import { Client as lre } from "@onr/chatfusion-api-client";
function MB(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in e)) {
          const o = Object.getOwnPropertyDescriptor(r, i);
          o && Object.defineProperty(e, i, o.get ? o : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var qa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Oi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function NB(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var kB = { exports: {} }, hw = {}, LB = { exports: {} }, mn = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jg = Symbol.for("react.element"), cre = Symbol.for("react.portal"), ure = Symbol.for("react.fragment"), fre = Symbol.for("react.strict_mode"), dre = Symbol.for("react.profiler"), pre = Symbol.for("react.provider"), hre = Symbol.for("react.context"), mre = Symbol.for("react.forward_ref"), gre = Symbol.for("react.suspense"), vre = Symbol.for("react.memo"), yre = Symbol.for("react.lazy"), qk = Symbol.iterator;
function bre(e) {
  return e === null || typeof e != "object" ? null : (e = qk && e[qk] || e["@@iterator"], typeof e == "function" ? e : null);
}
var DB = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, jB = Object.assign, FB = {};
function ah(e, t, n) {
  this.props = e, this.context = t, this.refs = FB, this.updater = n || DB;
}
ah.prototype.isReactComponent = {};
ah.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null)
    throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
ah.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function BB() {
}
BB.prototype = ah.prototype;
function nA(e, t, n) {
  this.props = e, this.context = t, this.refs = FB, this.updater = n || DB;
}
var rA = nA.prototype = new BB();
rA.constructor = nA;
jB(rA, ah.prototype);
rA.isPureReactComponent = !0;
var Yk = Array.isArray, zB = Object.prototype.hasOwnProperty, iA = { current: null }, UB = { key: !0, ref: !0, __self: !0, __source: !0 };
function HB(e, t, n) {
  var r, i = {}, o = null, a = null;
  if (t != null)
    for (r in t.ref !== void 0 && (a = t.ref), t.key !== void 0 && (o = "" + t.key), t)
      zB.call(t, r) && !UB.hasOwnProperty(r) && (i[r] = t[r]);
  var s = arguments.length - 2;
  if (s === 1)
    i.children = n;
  else if (1 < s) {
    for (var l = Array(s), c = 0; c < s; c++)
      l[c] = arguments[c + 2];
    i.children = l;
  }
  if (e && e.defaultProps)
    for (r in s = e.defaultProps, s)
      i[r] === void 0 && (i[r] = s[r]);
  return { $$typeof: Jg, type: e, key: o, ref: a, props: i, _owner: iA.current };
}
function wre(e, t) {
  return { $$typeof: Jg, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function oA(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Jg;
}
function Sre(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var Xk = /\/+/g;
function xE(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? Sre("" + e.key) : t.toString(36);
}
function V0(e, t, n, r, i) {
  var o = typeof e;
  (o === "undefined" || o === "boolean") && (e = null);
  var a = !1;
  if (e === null)
    a = !0;
  else
    switch (o) {
      case "string":
      case "number":
        a = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case Jg:
          case cre:
            a = !0;
        }
    }
  if (a)
    return a = e, i = i(a), e = r === "" ? "." + xE(a, 0) : r, Yk(i) ? (n = "", e != null && (n = e.replace(Xk, "$&/") + "/"), V0(i, t, n, "", function(c) {
      return c;
    })) : i != null && (oA(i) && (i = wre(i, n + (!i.key || a && a.key === i.key ? "" : ("" + i.key).replace(Xk, "$&/") + "/") + e)), t.push(i)), 1;
  if (a = 0, r = r === "" ? "." : r + ":", Yk(e))
    for (var s = 0; s < e.length; s++) {
      o = e[s];
      var l = r + xE(o, s);
      a += V0(o, t, n, l, i);
    }
  else if (l = bre(e), typeof l == "function")
    for (e = l.call(e), s = 0; !(o = e.next()).done; )
      o = o.value, l = r + xE(o, s++), a += V0(o, t, n, l, i);
  else if (o === "object")
    throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return a;
}
function jy(e, t, n) {
  if (e == null)
    return e;
  var r = [], i = 0;
  return V0(e, r, "", "", function(o) {
    return t.call(n, o, i++);
  }), r;
}
function xre(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
    }, function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1)
    return e._result.default;
  throw e._result;
}
var To = { current: null }, G0 = { transition: null }, Cre = { ReactCurrentDispatcher: To, ReactCurrentBatchConfig: G0, ReactCurrentOwner: iA };
mn.Children = { map: jy, forEach: function(e, t, n) {
  jy(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return jy(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return jy(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!oA(e))
    throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
mn.Component = ah;
mn.Fragment = ure;
mn.Profiler = dre;
mn.PureComponent = nA;
mn.StrictMode = fre;
mn.Suspense = gre;
mn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Cre;
mn.cloneElement = function(e, t, n) {
  if (e == null)
    throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var r = jB({}, e.props), i = e.key, o = e.ref, a = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (o = t.ref, a = iA.current), t.key !== void 0 && (i = "" + t.key), e.type && e.type.defaultProps)
      var s = e.type.defaultProps;
    for (l in t)
      zB.call(t, l) && !UB.hasOwnProperty(l) && (r[l] = t[l] === void 0 && s !== void 0 ? s[l] : t[l]);
  }
  var l = arguments.length - 2;
  if (l === 1)
    r.children = n;
  else if (1 < l) {
    s = Array(l);
    for (var c = 0; c < l; c++)
      s[c] = arguments[c + 2];
    r.children = s;
  }
  return { $$typeof: Jg, type: e.type, key: i, ref: o, props: r, _owner: a };
};
mn.createContext = function(e) {
  return e = { $$typeof: hre, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: pre, _context: e }, e.Consumer = e;
};
mn.createElement = HB;
mn.createFactory = function(e) {
  var t = HB.bind(null, e);
  return t.type = e, t;
};
mn.createRef = function() {
  return { current: null };
};
mn.forwardRef = function(e) {
  return { $$typeof: mre, render: e };
};
mn.isValidElement = oA;
mn.lazy = function(e) {
  return { $$typeof: yre, _payload: { _status: -1, _result: e }, _init: xre };
};
mn.memo = function(e, t) {
  return { $$typeof: vre, type: e, compare: t === void 0 ? null : t };
};
mn.startTransition = function(e) {
  var t = G0.transition;
  G0.transition = {};
  try {
    e();
  } finally {
    G0.transition = t;
  }
};
mn.unstable_act = function() {
  throw Error("act(...) is not supported in production builds of React.");
};
mn.useCallback = function(e, t) {
  return To.current.useCallback(e, t);
};
mn.useContext = function(e) {
  return To.current.useContext(e);
};
mn.useDebugValue = function() {
};
mn.useDeferredValue = function(e) {
  return To.current.useDeferredValue(e);
};
mn.useEffect = function(e, t) {
  return To.current.useEffect(e, t);
};
mn.useId = function() {
  return To.current.useId();
};
mn.useImperativeHandle = function(e, t, n) {
  return To.current.useImperativeHandle(e, t, n);
};
mn.useInsertionEffect = function(e, t) {
  return To.current.useInsertionEffect(e, t);
};
mn.useLayoutEffect = function(e, t) {
  return To.current.useLayoutEffect(e, t);
};
mn.useMemo = function(e, t) {
  return To.current.useMemo(e, t);
};
mn.useReducer = function(e, t, n) {
  return To.current.useReducer(e, t, n);
};
mn.useRef = function(e) {
  return To.current.useRef(e);
};
mn.useState = function(e) {
  return To.current.useState(e);
};
mn.useSyncExternalStore = function(e, t, n) {
  return To.current.useSyncExternalStore(e, t, n);
};
mn.useTransition = function() {
  return To.current.useTransition();
};
mn.version = "18.2.0";
LB.exports = mn;
var m = LB.exports;
const oe = /* @__PURE__ */ Oi(m), sh = /* @__PURE__ */ MB({
  __proto__: null,
  default: oe
}, [m]);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ere = m, $re = Symbol.for("react.element"), _re = Symbol.for("react.fragment"), Ore = Object.prototype.hasOwnProperty, Pre = Ere.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Tre = { key: !0, ref: !0, __self: !0, __source: !0 };
function WB(e, t, n) {
  var r, i = {}, o = null, a = null;
  n !== void 0 && (o = "" + n), t.key !== void 0 && (o = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t)
    Ore.call(t, r) && !Tre.hasOwnProperty(r) && (i[r] = t[r]);
  if (e && e.defaultProps)
    for (r in t = e.defaultProps, t)
      i[r] === void 0 && (i[r] = t[r]);
  return { $$typeof: $re, type: e, key: o, ref: a, props: i, _owner: Pre.current };
}
hw.Fragment = _re;
hw.jsx = WB;
hw.jsxs = WB;
kB.exports = hw;
var H = kB.exports, Ire = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, n = Symbol("test"), r = Object(n);
  if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
    return !1;
  var i = 42;
  t[n] = i;
  for (n in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(t);
  if (o.length !== 1 || o[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var a = Object.getOwnPropertyDescriptor(t, n);
    if (a.value !== i || a.enumerable !== !0)
      return !1;
  }
  return !0;
}, Qk = typeof Symbol < "u" && Symbol, Are = Ire, Rre = function() {
  return typeof Qk != "function" || typeof Symbol != "function" || typeof Qk("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Are();
}, Jk = {
  foo: {}
}, Mre = Object, Nre = function() {
  return { __proto__: Jk }.foo === Jk.foo && !({ __proto__: null } instanceof Mre);
}, kre = "Function.prototype.bind called on incompatible ", CE = Array.prototype.slice, Lre = Object.prototype.toString, Dre = "[object Function]", jre = function(t) {
  var n = this;
  if (typeof n != "function" || Lre.call(n) !== Dre)
    throw new TypeError(kre + n);
  for (var r = CE.call(arguments, 1), i, o = function() {
    if (this instanceof i) {
      var f = n.apply(
        this,
        r.concat(CE.call(arguments))
      );
      return Object(f) === f ? f : this;
    } else
      return n.apply(
        t,
        r.concat(CE.call(arguments))
      );
  }, a = Math.max(0, n.length - r.length), s = [], l = 0; l < a; l++)
    s.push("$" + l);
  if (i = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(o), n.prototype) {
    var c = function() {
    };
    c.prototype = n.prototype, i.prototype = new c(), c.prototype = null;
  }
  return i;
}, Fre = jre, Bre = Function.prototype.bind || Fre, zre = "Function.prototype.bind called on incompatible ", EE = Array.prototype.slice, Ure = Object.prototype.toString, Hre = "[object Function]", Wre = function(t) {
  var n = this;
  if (typeof n != "function" || Ure.call(n) !== Hre)
    throw new TypeError(zre + n);
  for (var r = EE.call(arguments, 1), i, o = function() {
    if (this instanceof i) {
      var f = n.apply(
        this,
        r.concat(EE.call(arguments))
      );
      return Object(f) === f ? f : this;
    } else
      return n.apply(
        t,
        r.concat(EE.call(arguments))
      );
  }, a = Math.max(0, n.length - r.length), s = [], l = 0; l < a; l++)
    s.push("$" + l);
  if (i = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(o), n.prototype) {
    var c = function() {
    };
    c.prototype = n.prototype, i.prototype = new c(), c.prototype = null;
  }
  return i;
}, Vre = Wre, Gre = Function.prototype.bind || Vre, Kre = Gre, qre = Kre.call(Function.call, Object.prototype.hasOwnProperty), pn, Ap = SyntaxError, VB = Function, fp = TypeError, $E = function(e) {
  try {
    return VB('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, $f = Object.getOwnPropertyDescriptor;
if ($f)
  try {
    $f({}, "");
  } catch {
    $f = null;
  }
var _E = function() {
  throw new fp();
}, Yre = $f ? function() {
  try {
    return arguments.callee, _E;
  } catch {
    try {
      return $f(arguments, "callee").get;
    } catch {
      return _E;
    }
  }
}() : _E, wd = Rre(), Xre = Nre(), Ci = Object.getPrototypeOf || (Xre ? function(e) {
  return e.__proto__;
} : null), Fd = {}, Qre = typeof Uint8Array > "u" || !Ci ? pn : Ci(Uint8Array), _f = {
  "%AggregateError%": typeof AggregateError > "u" ? pn : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? pn : ArrayBuffer,
  "%ArrayIteratorPrototype%": wd && Ci ? Ci([][Symbol.iterator]()) : pn,
  "%AsyncFromSyncIteratorPrototype%": pn,
  "%AsyncFunction%": Fd,
  "%AsyncGenerator%": Fd,
  "%AsyncGeneratorFunction%": Fd,
  "%AsyncIteratorPrototype%": Fd,
  "%Atomics%": typeof Atomics > "u" ? pn : Atomics,
  "%BigInt%": typeof BigInt > "u" ? pn : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? pn : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? pn : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? pn : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? pn : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? pn : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? pn : FinalizationRegistry,
  "%Function%": VB,
  "%GeneratorFunction%": Fd,
  "%Int8Array%": typeof Int8Array > "u" ? pn : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? pn : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? pn : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": wd && Ci ? Ci(Ci([][Symbol.iterator]())) : pn,
  "%JSON%": typeof JSON == "object" ? JSON : pn,
  "%Map%": typeof Map > "u" ? pn : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !wd || !Ci ? pn : Ci((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? pn : Promise,
  "%Proxy%": typeof Proxy > "u" ? pn : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? pn : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? pn : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !wd || !Ci ? pn : Ci((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? pn : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": wd && Ci ? Ci(""[Symbol.iterator]()) : pn,
  "%Symbol%": wd ? Symbol : pn,
  "%SyntaxError%": Ap,
  "%ThrowTypeError%": Yre,
  "%TypedArray%": Qre,
  "%TypeError%": fp,
  "%Uint8Array%": typeof Uint8Array > "u" ? pn : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? pn : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? pn : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? pn : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? pn : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? pn : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? pn : WeakSet
};
if (Ci)
  try {
    null.error;
  } catch (e) {
    var Jre = Ci(Ci(e));
    _f["%Error.prototype%"] = Jre;
  }
var Zre = function e(t) {
  var n;
  if (t === "%AsyncFunction%")
    n = $E("async function () {}");
  else if (t === "%GeneratorFunction%")
    n = $E("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    n = $E("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var r = e("%AsyncGeneratorFunction%");
    r && (n = r.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var i = e("%AsyncGenerator%");
    i && Ci && (n = Ci(i.prototype));
  }
  return _f[t] = n, n;
}, Zk = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Zg = Bre, Bb = qre, eie = Zg.call(Function.call, Array.prototype.concat), tie = Zg.call(Function.apply, Array.prototype.splice), eL = Zg.call(Function.call, String.prototype.replace), zb = Zg.call(Function.call, String.prototype.slice), nie = Zg.call(Function.call, RegExp.prototype.exec), rie = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, iie = /\\(\\)?/g, oie = function(t) {
  var n = zb(t, 0, 1), r = zb(t, -1);
  if (n === "%" && r !== "%")
    throw new Ap("invalid intrinsic syntax, expected closing `%`");
  if (r === "%" && n !== "%")
    throw new Ap("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return eL(t, rie, function(o, a, s, l) {
    i[i.length] = s ? eL(l, iie, "$1") : a || o;
  }), i;
}, aie = function(t, n) {
  var r = t, i;
  if (Bb(Zk, r) && (i = Zk[r], r = "%" + i[0] + "%"), Bb(_f, r)) {
    var o = _f[r];
    if (o === Fd && (o = Zre(r)), typeof o > "u" && !n)
      throw new fp("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: r,
      value: o
    };
  }
  throw new Ap("intrinsic " + t + " does not exist!");
}, aA = function(t, n) {
  if (typeof t != "string" || t.length === 0)
    throw new fp("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof n != "boolean")
    throw new fp('"allowMissing" argument must be a boolean');
  if (nie(/^%?[^%]*%?$/, t) === null)
    throw new Ap("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var r = oie(t), i = r.length > 0 ? r[0] : "", o = aie("%" + i + "%", n), a = o.name, s = o.value, l = !1, c = o.alias;
  c && (i = c[0], tie(r, eie([0, 1], c)));
  for (var f = 1, d = !0; f < r.length; f += 1) {
    var p = r[f], g = zb(p, 0, 1), v = zb(p, -1);
    if ((g === '"' || g === "'" || g === "`" || v === '"' || v === "'" || v === "`") && g !== v)
      throw new Ap("property names with quotes must have matching quotes");
    if ((p === "constructor" || !d) && (l = !0), i += "." + p, a = "%" + i + "%", Bb(_f, a))
      s = _f[a];
    else if (s != null) {
      if (!(p in s)) {
        if (!n)
          throw new fp("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if ($f && f + 1 >= r.length) {
        var y = $f(s, p);
        d = !!y, d && "get" in y && !("originalValue" in y.get) ? s = y.get : s = s[p];
      } else
        d = Bb(s, p), s = s[p];
      d && !l && (_f[a] = s);
    }
  }
  return s;
}, GB = { exports: {} }, sie = "Function.prototype.bind called on incompatible ", OE = Array.prototype.slice, lie = Object.prototype.toString, cie = "[object Function]", uie = function(t) {
  var n = this;
  if (typeof n != "function" || lie.call(n) !== cie)
    throw new TypeError(sie + n);
  for (var r = OE.call(arguments, 1), i, o = function() {
    if (this instanceof i) {
      var f = n.apply(
        this,
        r.concat(OE.call(arguments))
      );
      return Object(f) === f ? f : this;
    } else
      return n.apply(
        t,
        r.concat(OE.call(arguments))
      );
  }, a = Math.max(0, n.length - r.length), s = [], l = 0; l < a; l++)
    s.push("$" + l);
  if (i = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(o), n.prototype) {
    var c = function() {
    };
    c.prototype = n.prototype, i.prototype = new c(), c.prototype = null;
  }
  return i;
}, fie = uie, die = Function.prototype.bind || fie;
(function(e) {
  var t = die, n = aA, r = n("%Function.prototype.apply%"), i = n("%Function.prototype.call%"), o = n("%Reflect.apply%", !0) || t.call(i, r), a = n("%Object.getOwnPropertyDescriptor%", !0), s = n("%Object.defineProperty%", !0), l = n("%Math.max%");
  if (s)
    try {
      s({}, "a", { value: 1 });
    } catch {
      s = null;
    }
  e.exports = function(d) {
    var p = o(t, i, arguments);
    if (a && s) {
      var g = a(p, "length");
      g.configurable && s(
        p,
        "length",
        { value: 1 + l(0, d.length - (arguments.length - 1)) }
      );
    }
    return p;
  };
  var c = function() {
    return o(t, r, arguments);
  };
  s ? s(e.exports, "apply", { value: c }) : e.exports.apply = c;
})(GB);
var pie = GB.exports, KB = aA, qB = pie, hie = qB(KB("String.prototype.indexOf")), mie = function(t, n) {
  var r = KB(t, !!n);
  return typeof r == "function" && hie(t, ".prototype.") > -1 ? qB(r) : r;
};
const gie = {}, vie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gie
}, Symbol.toStringTag, { value: "Module" })), yie = /* @__PURE__ */ NB(vie);
var sA = typeof Map == "function" && Map.prototype, PE = Object.getOwnPropertyDescriptor && sA ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Ub = sA && PE && typeof PE.get == "function" ? PE.get : null, tL = sA && Map.prototype.forEach, lA = typeof Set == "function" && Set.prototype, TE = Object.getOwnPropertyDescriptor && lA ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, Hb = lA && TE && typeof TE.get == "function" ? TE.get : null, nL = lA && Set.prototype.forEach, bie = typeof WeakMap == "function" && WeakMap.prototype, Fm = bie ? WeakMap.prototype.has : null, wie = typeof WeakSet == "function" && WeakSet.prototype, Bm = wie ? WeakSet.prototype.has : null, Sie = typeof WeakRef == "function" && WeakRef.prototype, rL = Sie ? WeakRef.prototype.deref : null, xie = Boolean.prototype.valueOf, Cie = Object.prototype.toString, Eie = Function.prototype.toString, $ie = String.prototype.match, cA = String.prototype.slice, Jc = String.prototype.replace, _ie = String.prototype.toUpperCase, iL = String.prototype.toLowerCase, YB = RegExp.prototype.test, oL = Array.prototype.concat, ml = Array.prototype.join, Oie = Array.prototype.slice, aL = Math.floor, rO = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, IE = Object.getOwnPropertySymbols, iO = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Rp = typeof Symbol == "function" && typeof Symbol.iterator == "object", ho = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Rp || !0) ? Symbol.toStringTag : null, XB = Object.prototype.propertyIsEnumerable, sL = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function lL(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || YB.call(/e/, t))
    return t;
  var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var r = e < 0 ? -aL(-e) : aL(e);
    if (r !== e) {
      var i = String(r), o = cA.call(t, i.length + 1);
      return Jc.call(i, n, "$&_") + "." + Jc.call(Jc.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Jc.call(t, n, "$&_");
}
var oO = yie, cL = oO.custom, uL = JB(cL) ? cL : null, Pie = function e(t, n, r, i) {
  var o = n || {};
  if (Hc(o, "quoteStyle") && o.quoteStyle !== "single" && o.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (Hc(o, "maxStringLength") && (typeof o.maxStringLength == "number" ? o.maxStringLength < 0 && o.maxStringLength !== 1 / 0 : o.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var a = Hc(o, "customInspect") ? o.customInspect : !0;
  if (typeof a != "boolean" && a !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (Hc(o, "indent") && o.indent !== null && o.indent !== "	" && !(parseInt(o.indent, 10) === o.indent && o.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (Hc(o, "numericSeparator") && typeof o.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var s = o.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return e8(t, o);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var l = String(t);
    return s ? lL(t, l) : l;
  }
  if (typeof t == "bigint") {
    var c = String(t) + "n";
    return s ? lL(t, c) : c;
  }
  var f = typeof o.depth > "u" ? 5 : o.depth;
  if (typeof r > "u" && (r = 0), r >= f && f > 0 && typeof t == "object")
    return aO(t) ? "[Array]" : "[Object]";
  var d = Gie(o, r);
  if (typeof i > "u")
    i = [];
  else if (ZB(i, t) >= 0)
    return "[Circular]";
  function p(T, k, F) {
    if (k && (i = Oie.call(i), i.push(k)), F) {
      var W = {
        depth: o.depth
      };
      return Hc(o, "quoteStyle") && (W.quoteStyle = o.quoteStyle), e(T, W, r + 1, i);
    }
    return e(T, o, r + 1, i);
  }
  if (typeof t == "function" && !fL(t)) {
    var g = Die(t), v = Fy(t, p);
    return "[Function" + (g ? ": " + g : " (anonymous)") + "]" + (v.length > 0 ? " { " + ml.call(v, ", ") + " }" : "");
  }
  if (JB(t)) {
    var y = Rp ? Jc.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : iO.call(t);
    return typeof t == "object" && !Rp ? sm(y) : y;
  }
  if (Hie(t)) {
    for (var x = "<" + iL.call(String(t.nodeName)), b = t.attributes || [], w = 0; w < b.length; w++)
      x += " " + b[w].name + "=" + QB(Tie(b[w].value), "double", o);
    return x += ">", t.childNodes && t.childNodes.length && (x += "..."), x += "</" + iL.call(String(t.nodeName)) + ">", x;
  }
  if (aO(t)) {
    if (t.length === 0)
      return "[]";
    var S = Fy(t, p);
    return d && !Vie(S) ? "[" + sO(S, d) + "]" : "[ " + ml.call(S, ", ") + " ]";
  }
  if (Aie(t)) {
    var E = Fy(t, p);
    return !("cause" in Error.prototype) && "cause" in t && !XB.call(t, "cause") ? "{ [" + String(t) + "] " + ml.call(oL.call("[cause]: " + p(t.cause), E), ", ") + " }" : E.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + ml.call(E, ", ") + " }";
  }
  if (typeof t == "object" && a) {
    if (uL && typeof t[uL] == "function" && oO)
      return oO(t, { depth: f - r });
    if (a !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (jie(t)) {
    var O = [];
    return tL && tL.call(t, function(T, k) {
      O.push(p(k, t, !0) + " => " + p(T, t));
    }), dL("Map", Ub.call(t), O, d);
  }
  if (zie(t)) {
    var $ = [];
    return nL && nL.call(t, function(T) {
      $.push(p(T, t));
    }), dL("Set", Hb.call(t), $, d);
  }
  if (Fie(t))
    return AE("WeakMap");
  if (Uie(t))
    return AE("WeakSet");
  if (Bie(t))
    return AE("WeakRef");
  if (Mie(t))
    return sm(p(Number(t)));
  if (kie(t))
    return sm(p(rO.call(t)));
  if (Nie(t))
    return sm(xie.call(t));
  if (Rie(t))
    return sm(p(String(t)));
  if (!Iie(t) && !fL(t)) {
    var P = Fy(t, p), R = sL ? sL(t) === Object.prototype : t instanceof Object || t.constructor === Object, L = t instanceof Object ? "" : "null prototype", B = !R && ho && Object(t) === t && ho in t ? cA.call(Iu(t), 8, -1) : L ? "Object" : "", j = R || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", A = j + (B || L ? "[" + ml.call(oL.call([], B || [], L || []), ": ") + "] " : "");
    return P.length === 0 ? A + "{}" : d ? A + "{" + sO(P, d) + "}" : A + "{ " + ml.call(P, ", ") + " }";
  }
  return String(t);
};
function QB(e, t, n) {
  var r = (n.quoteStyle || t) === "double" ? '"' : "'";
  return r + e + r;
}
function Tie(e) {
  return Jc.call(String(e), /"/g, "&quot;");
}
function aO(e) {
  return Iu(e) === "[object Array]" && (!ho || !(typeof e == "object" && ho in e));
}
function Iie(e) {
  return Iu(e) === "[object Date]" && (!ho || !(typeof e == "object" && ho in e));
}
function fL(e) {
  return Iu(e) === "[object RegExp]" && (!ho || !(typeof e == "object" && ho in e));
}
function Aie(e) {
  return Iu(e) === "[object Error]" && (!ho || !(typeof e == "object" && ho in e));
}
function Rie(e) {
  return Iu(e) === "[object String]" && (!ho || !(typeof e == "object" && ho in e));
}
function Mie(e) {
  return Iu(e) === "[object Number]" && (!ho || !(typeof e == "object" && ho in e));
}
function Nie(e) {
  return Iu(e) === "[object Boolean]" && (!ho || !(typeof e == "object" && ho in e));
}
function JB(e) {
  if (Rp)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !iO)
    return !1;
  try {
    return iO.call(e), !0;
  } catch {
  }
  return !1;
}
function kie(e) {
  if (!e || typeof e != "object" || !rO)
    return !1;
  try {
    return rO.call(e), !0;
  } catch {
  }
  return !1;
}
var Lie = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function Hc(e, t) {
  return Lie.call(e, t);
}
function Iu(e) {
  return Cie.call(e);
}
function Die(e) {
  if (e.name)
    return e.name;
  var t = $ie.call(Eie.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function ZB(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var n = 0, r = e.length; n < r; n++)
    if (e[n] === t)
      return n;
  return -1;
}
function jie(e) {
  if (!Ub || !e || typeof e != "object")
    return !1;
  try {
    Ub.call(e);
    try {
      Hb.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function Fie(e) {
  if (!Fm || !e || typeof e != "object")
    return !1;
  try {
    Fm.call(e, Fm);
    try {
      Bm.call(e, Bm);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Bie(e) {
  if (!rL || !e || typeof e != "object")
    return !1;
  try {
    return rL.call(e), !0;
  } catch {
  }
  return !1;
}
function zie(e) {
  if (!Hb || !e || typeof e != "object")
    return !1;
  try {
    Hb.call(e);
    try {
      Ub.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function Uie(e) {
  if (!Bm || !e || typeof e != "object")
    return !1;
  try {
    Bm.call(e, Bm);
    try {
      Fm.call(e, Fm);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function Hie(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function e8(e, t) {
  if (e.length > t.maxStringLength) {
    var n = e.length - t.maxStringLength, r = "... " + n + " more character" + (n > 1 ? "s" : "");
    return e8(cA.call(e, 0, t.maxStringLength), t) + r;
  }
  var i = Jc.call(Jc.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Wie);
  return QB(i, "single", t);
}
function Wie(e) {
  var t = e.charCodeAt(0), n = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + _ie.call(t.toString(16));
}
function sm(e) {
  return "Object(" + e + ")";
}
function AE(e) {
  return e + " { ? }";
}
function dL(e, t, n, r) {
  var i = r ? sO(n, r) : ml.call(n, ", ");
  return e + " (" + t + ") {" + i + "}";
}
function Vie(e) {
  for (var t = 0; t < e.length; t++)
    if (ZB(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function Gie(e, t) {
  var n;
  if (e.indent === "	")
    n = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    n = ml.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: n,
    prev: ml.call(Array(t + 1), n)
  };
}
function sO(e, t) {
  if (e.length === 0)
    return "";
  var n = `
` + t.prev + t.base;
  return n + ml.call(e, "," + n) + `
` + t.prev;
}
function Fy(e, t) {
  var n = aO(e), r = [];
  if (n) {
    r.length = e.length;
    for (var i = 0; i < e.length; i++)
      r[i] = Hc(e, i) ? t(e[i], e) : "";
  }
  var o = typeof IE == "function" ? IE(e) : [], a;
  if (Rp) {
    a = {};
    for (var s = 0; s < o.length; s++)
      a["$" + o[s]] = o[s];
  }
  for (var l in e)
    Hc(e, l) && (n && String(Number(l)) === l && l < e.length || Rp && a["$" + l] instanceof Symbol || (YB.call(/[^\w$]/, l) ? r.push(t(l, e) + ": " + t(e[l], e)) : r.push(l + ": " + t(e[l], e))));
  if (typeof IE == "function")
    for (var c = 0; c < o.length; c++)
      XB.call(e, o[c]) && r.push("[" + t(o[c]) + "]: " + t(e[o[c]], e));
  return r;
}
var uA = aA, lh = mie, Kie = Pie, qie = uA("%TypeError%"), By = uA("%WeakMap%", !0), zy = uA("%Map%", !0), Yie = lh("WeakMap.prototype.get", !0), Xie = lh("WeakMap.prototype.set", !0), Qie = lh("WeakMap.prototype.has", !0), Jie = lh("Map.prototype.get", !0), Zie = lh("Map.prototype.set", !0), eoe = lh("Map.prototype.has", !0), fA = function(e, t) {
  for (var n = e, r; (r = n.next) !== null; n = r)
    if (r.key === t)
      return n.next = r.next, r.next = e.next, e.next = r, r;
}, toe = function(e, t) {
  var n = fA(e, t);
  return n && n.value;
}, noe = function(e, t, n) {
  var r = fA(e, t);
  r ? r.value = n : e.next = {
    // eslint-disable-line no-param-reassign
    key: t,
    next: e.next,
    value: n
  };
}, roe = function(e, t) {
  return !!fA(e, t);
}, ioe = function() {
  var t, n, r, i = {
    assert: function(o) {
      if (!i.has(o))
        throw new qie("Side channel does not contain " + Kie(o));
    },
    get: function(o) {
      if (By && o && (typeof o == "object" || typeof o == "function")) {
        if (t)
          return Yie(t, o);
      } else if (zy) {
        if (n)
          return Jie(n, o);
      } else if (r)
        return toe(r, o);
    },
    has: function(o) {
      if (By && o && (typeof o == "object" || typeof o == "function")) {
        if (t)
          return Qie(t, o);
      } else if (zy) {
        if (n)
          return eoe(n, o);
      } else if (r)
        return roe(r, o);
      return !1;
    },
    set: function(o, a) {
      By && o && (typeof o == "object" || typeof o == "function") ? (t || (t = new By()), Xie(t, o, a)) : zy ? (n || (n = new zy()), Zie(n, o, a)) : (r || (r = { key: {}, next: null }), noe(r, o, a));
    }
  };
  return i;
}, ooe = String.prototype.replace, aoe = /%20/g, RE = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, dA = {
  default: RE.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return ooe.call(e, aoe, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: RE.RFC1738,
  RFC3986: RE.RFC3986
}, soe = dA, ME = Object.prototype.hasOwnProperty, uf = Array.isArray, cl = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), loe = function(t) {
  for (; t.length > 1; ) {
    var n = t.pop(), r = n.obj[n.prop];
    if (uf(r)) {
      for (var i = [], o = 0; o < r.length; ++o)
        typeof r[o] < "u" && i.push(r[o]);
      n.obj[n.prop] = i;
    }
  }
}, t8 = function(t, n) {
  for (var r = n && n.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = 0; i < t.length; ++i)
    typeof t[i] < "u" && (r[i] = t[i]);
  return r;
}, coe = function e(t, n, r) {
  if (!n)
    return t;
  if (typeof n != "object") {
    if (uf(t))
      t.push(n);
    else if (t && typeof t == "object")
      (r && (r.plainObjects || r.allowPrototypes) || !ME.call(Object.prototype, n)) && (t[n] = !0);
    else
      return [t, n];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(n);
  var i = t;
  return uf(t) && !uf(n) && (i = t8(t, r)), uf(t) && uf(n) ? (n.forEach(function(o, a) {
    if (ME.call(t, a)) {
      var s = t[a];
      s && typeof s == "object" && o && typeof o == "object" ? t[a] = e(s, o, r) : t.push(o);
    } else
      t[a] = o;
  }), t) : Object.keys(n).reduce(function(o, a) {
    var s = n[a];
    return ME.call(o, a) ? o[a] = e(o[a], s, r) : o[a] = s, o;
  }, i);
}, uoe = function(t, n) {
  return Object.keys(n).reduce(function(r, i) {
    return r[i] = n[i], r;
  }, t);
}, foe = function(e, t, n) {
  var r = e.replace(/\+/g, " ");
  if (n === "iso-8859-1")
    return r.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(r);
  } catch {
    return r;
  }
}, doe = function(t, n, r, i, o) {
  if (t.length === 0)
    return t;
  var a = t;
  if (typeof t == "symbol" ? a = Symbol.prototype.toString.call(t) : typeof t != "string" && (a = String(t)), r === "iso-8859-1")
    return escape(a).replace(/%u[0-9a-f]{4}/gi, function(f) {
      return "%26%23" + parseInt(f.slice(2), 16) + "%3B";
    });
  for (var s = "", l = 0; l < a.length; ++l) {
    var c = a.charCodeAt(l);
    if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || o === soe.RFC1738 && (c === 40 || c === 41)) {
      s += a.charAt(l);
      continue;
    }
    if (c < 128) {
      s = s + cl[c];
      continue;
    }
    if (c < 2048) {
      s = s + (cl[192 | c >> 6] + cl[128 | c & 63]);
      continue;
    }
    if (c < 55296 || c >= 57344) {
      s = s + (cl[224 | c >> 12] + cl[128 | c >> 6 & 63] + cl[128 | c & 63]);
      continue;
    }
    l += 1, c = 65536 + ((c & 1023) << 10 | a.charCodeAt(l) & 1023), s += cl[240 | c >> 18] + cl[128 | c >> 12 & 63] + cl[128 | c >> 6 & 63] + cl[128 | c & 63];
  }
  return s;
}, poe = function(t) {
  for (var n = [{ obj: { o: t }, prop: "o" }], r = [], i = 0; i < n.length; ++i)
    for (var o = n[i], a = o.obj[o.prop], s = Object.keys(a), l = 0; l < s.length; ++l) {
      var c = s[l], f = a[c];
      typeof f == "object" && f !== null && r.indexOf(f) === -1 && (n.push({ obj: a, prop: c }), r.push(f));
    }
  return loe(n), t;
}, hoe = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, moe = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, goe = function(t, n) {
  return [].concat(t, n);
}, voe = function(t, n) {
  if (uf(t)) {
    for (var r = [], i = 0; i < t.length; i += 1)
      r.push(n(t[i]));
    return r;
  }
  return n(t);
}, n8 = {
  arrayToObject: t8,
  assign: uoe,
  combine: goe,
  compact: poe,
  decode: foe,
  encode: doe,
  isBuffer: moe,
  isRegExp: hoe,
  maybeMap: voe,
  merge: coe
}, r8 = ioe, K0 = n8, zm = dA, yoe = Object.prototype.hasOwnProperty, pL = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, n) {
    return t + "[" + n + "]";
  },
  repeat: function(t) {
    return t;
  }
}, nc = Array.isArray, boe = Array.prototype.push, i8 = function(e, t) {
  boe.apply(e, nc(t) ? t : [t]);
}, woe = Date.prototype.toISOString, hL = zm.default, ao = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: K0.encode,
  encodeValuesOnly: !1,
  format: hL,
  formatter: zm.formatters[hL],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return woe.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Soe = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, NE = {}, xoe = function e(t, n, r, i, o, a, s, l, c, f, d, p, g, v, y, x) {
  for (var b = t, w = x, S = 0, E = !1; (w = w.get(NE)) !== void 0 && !E; ) {
    var O = w.get(t);
    if (S += 1, typeof O < "u") {
      if (O === S)
        throw new RangeError("Cyclic object value");
      E = !0;
    }
    typeof w.get(NE) > "u" && (S = 0);
  }
  if (typeof l == "function" ? b = l(n, b) : b instanceof Date ? b = d(b) : r === "comma" && nc(b) && (b = K0.maybeMap(b, function(W) {
    return W instanceof Date ? d(W) : W;
  })), b === null) {
    if (o)
      return s && !v ? s(n, ao.encoder, y, "key", p) : n;
    b = "";
  }
  if (Soe(b) || K0.isBuffer(b)) {
    if (s) {
      var $ = v ? n : s(n, ao.encoder, y, "key", p);
      return [g($) + "=" + g(s(b, ao.encoder, y, "value", p))];
    }
    return [g(n) + "=" + g(String(b))];
  }
  var P = [];
  if (typeof b > "u")
    return P;
  var R;
  if (r === "comma" && nc(b))
    v && s && (b = K0.maybeMap(b, s)), R = [{ value: b.length > 0 ? b.join(",") || null : void 0 }];
  else if (nc(l))
    R = l;
  else {
    var L = Object.keys(b);
    R = c ? L.sort(c) : L;
  }
  for (var B = i && nc(b) && b.length === 1 ? n + "[]" : n, j = 0; j < R.length; ++j) {
    var A = R[j], T = typeof A == "object" && typeof A.value < "u" ? A.value : b[A];
    if (!(a && T === null)) {
      var k = nc(b) ? typeof r == "function" ? r(B, A) : B : B + (f ? "." + A : "[" + A + "]");
      x.set(t, S);
      var F = r8();
      F.set(NE, x), i8(P, e(
        T,
        k,
        r,
        i,
        o,
        a,
        r === "comma" && v && nc(b) ? null : s,
        l,
        c,
        f,
        d,
        p,
        g,
        v,
        y,
        F
      ));
    }
  }
  return P;
}, Coe = function(t) {
  if (!t)
    return ao;
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var n = t.charset || ao.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = zm.default;
  if (typeof t.format < "u") {
    if (!yoe.call(zm.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    r = t.format;
  }
  var i = zm.formatters[r], o = ao.filter;
  return (typeof t.filter == "function" || nc(t.filter)) && (o = t.filter), {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : ao.addQueryPrefix,
    allowDots: typeof t.allowDots > "u" ? ao.allowDots : !!t.allowDots,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : ao.charsetSentinel,
    delimiter: typeof t.delimiter > "u" ? ao.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : ao.encode,
    encoder: typeof t.encoder == "function" ? t.encoder : ao.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : ao.encodeValuesOnly,
    filter: o,
    format: r,
    formatter: i,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : ao.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : ao.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : ao.strictNullHandling
  };
}, Eoe = function(e, t) {
  var n = e, r = Coe(t), i, o;
  typeof r.filter == "function" ? (o = r.filter, n = o("", n)) : nc(r.filter) && (o = r.filter, i = o);
  var a = [];
  if (typeof n != "object" || n === null)
    return "";
  var s;
  t && t.arrayFormat in pL ? s = t.arrayFormat : t && "indices" in t ? s = t.indices ? "indices" : "repeat" : s = "indices";
  var l = pL[s];
  if (t && "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var c = l === "comma" && t && t.commaRoundTrip;
  i || (i = Object.keys(n)), r.sort && i.sort(r.sort);
  for (var f = r8(), d = 0; d < i.length; ++d) {
    var p = i[d];
    r.skipNulls && n[p] === null || i8(a, xoe(
      n[p],
      p,
      l,
      c,
      r.strictNullHandling,
      r.skipNulls,
      r.encode ? r.encoder : null,
      r.filter,
      r.sort,
      r.allowDots,
      r.serializeDate,
      r.format,
      r.formatter,
      r.encodeValuesOnly,
      r.charset,
      f
    ));
  }
  var g = a.join(r.delimiter), v = r.addQueryPrefix === !0 ? "?" : "";
  return r.charsetSentinel && (r.charset === "iso-8859-1" ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"), g.length > 0 ? v + g : "";
}, Mp = n8, lO = Object.prototype.hasOwnProperty, $oe = Array.isArray, xi = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: Mp.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, _oe = function(e) {
  return e.replace(/&#(\d+);/g, function(t, n) {
    return String.fromCharCode(parseInt(n, 10));
  });
}, o8 = function(e, t) {
  return e && typeof e == "string" && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, Ooe = "utf8=%26%2310003%3B", Poe = "utf8=%E2%9C%93", Toe = function(t, n) {
  var r = { __proto__: null }, i = n.ignoreQueryPrefix ? t.replace(/^\?/, "") : t, o = n.parameterLimit === 1 / 0 ? void 0 : n.parameterLimit, a = i.split(n.delimiter, o), s = -1, l, c = n.charset;
  if (n.charsetSentinel)
    for (l = 0; l < a.length; ++l)
      a[l].indexOf("utf8=") === 0 && (a[l] === Poe ? c = "utf-8" : a[l] === Ooe && (c = "iso-8859-1"), s = l, l = a.length);
  for (l = 0; l < a.length; ++l)
    if (l !== s) {
      var f = a[l], d = f.indexOf("]="), p = d === -1 ? f.indexOf("=") : d + 1, g, v;
      p === -1 ? (g = n.decoder(f, xi.decoder, c, "key"), v = n.strictNullHandling ? null : "") : (g = n.decoder(f.slice(0, p), xi.decoder, c, "key"), v = Mp.maybeMap(
        o8(f.slice(p + 1), n),
        function(y) {
          return n.decoder(y, xi.decoder, c, "value");
        }
      )), v && n.interpretNumericEntities && c === "iso-8859-1" && (v = _oe(v)), f.indexOf("[]=") > -1 && (v = $oe(v) ? [v] : v), lO.call(r, g) ? r[g] = Mp.combine(r[g], v) : r[g] = v;
    }
  return r;
}, Ioe = function(e, t, n, r) {
  for (var i = r ? t : o8(t, n), o = e.length - 1; o >= 0; --o) {
    var a, s = e[o];
    if (s === "[]" && n.parseArrays)
      a = [].concat(i);
    else {
      a = n.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = s.charAt(0) === "[" && s.charAt(s.length - 1) === "]" ? s.slice(1, -1) : s, c = parseInt(l, 10);
      !n.parseArrays && l === "" ? a = { 0: i } : !isNaN(c) && s !== l && String(c) === l && c >= 0 && n.parseArrays && c <= n.arrayLimit ? (a = [], a[c] = i) : l !== "__proto__" && (a[l] = i);
    }
    i = a;
  }
  return i;
}, Aoe = function(t, n, r, i) {
  if (t) {
    var o = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, a = /(\[[^[\]]*])/, s = /(\[[^[\]]*])/g, l = r.depth > 0 && a.exec(o), c = l ? o.slice(0, l.index) : o, f = [];
    if (c) {
      if (!r.plainObjects && lO.call(Object.prototype, c) && !r.allowPrototypes)
        return;
      f.push(c);
    }
    for (var d = 0; r.depth > 0 && (l = s.exec(o)) !== null && d < r.depth; ) {
      if (d += 1, !r.plainObjects && lO.call(Object.prototype, l[1].slice(1, -1)) && !r.allowPrototypes)
        return;
      f.push(l[1]);
    }
    return l && f.push("[" + o.slice(l.index) + "]"), Ioe(f, n, r, i);
  }
}, Roe = function(t) {
  if (!t)
    return xi;
  if (t.decoder !== null && t.decoder !== void 0 && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = typeof t.charset > "u" ? xi.charset : t.charset;
  return {
    allowDots: typeof t.allowDots > "u" ? xi.allowDots : !!t.allowDots,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : xi.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : xi.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : xi.arrayLimit,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : xi.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : xi.comma,
    decoder: typeof t.decoder == "function" ? t.decoder : xi.decoder,
    delimiter: typeof t.delimiter == "string" || Mp.isRegExp(t.delimiter) ? t.delimiter : xi.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : xi.depth,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : xi.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : xi.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : xi.plainObjects,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : xi.strictNullHandling
  };
}, Moe = function(e, t) {
  var n = Roe(t);
  if (e === "" || e === null || typeof e > "u")
    return n.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var r = typeof e == "string" ? Toe(e, n) : e, i = n.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = Object.keys(r), a = 0; a < o.length; ++a) {
    var s = o[a], l = Aoe(s, r[s], n, typeof e == "string");
    i = Mp.merge(i, l, n);
  }
  return n.allowSparse === !0 ? i : Mp.compact(i);
}, Noe = Eoe, koe = Moe, Loe = dA, Doe = {
  formats: Loe,
  parse: koe,
  stringify: Noe
};
const mL = /* @__PURE__ */ Oi(Doe);
var a8 = { exports: {} }, Pa = {}, s8 = { exports: {} }, l8 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  function t(G, X) {
    var D = G.length;
    G.push(X);
    e:
      for (; 0 < D; ) {
        var te = D - 1 >>> 1, ee = G[te];
        if (0 < i(ee, X))
          G[te] = X, G[D] = ee, D = te;
        else
          break e;
      }
  }
  function n(G) {
    return G.length === 0 ? null : G[0];
  }
  function r(G) {
    if (G.length === 0)
      return null;
    var X = G[0], D = G.pop();
    if (D !== X) {
      G[0] = D;
      e:
        for (var te = 0, ee = G.length, U = ee >>> 1; te < U; ) {
          var he = 2 * (te + 1) - 1, re = G[he], de = he + 1, we = G[de];
          if (0 > i(re, D))
            de < ee && 0 > i(we, re) ? (G[te] = we, G[de] = D, te = de) : (G[te] = re, G[he] = D, te = he);
          else if (de < ee && 0 > i(we, D))
            G[te] = we, G[de] = D, te = de;
          else
            break e;
        }
    }
    return X;
  }
  function i(G, X) {
    var D = G.sortIndex - X.sortIndex;
    return D !== 0 ? D : G.id - X.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var o = performance;
    e.unstable_now = function() {
      return o.now();
    };
  } else {
    var a = Date, s = a.now();
    e.unstable_now = function() {
      return a.now() - s;
    };
  }
  var l = [], c = [], f = 1, d = null, p = 3, g = !1, v = !1, y = !1, x = typeof setTimeout == "function" ? setTimeout : null, b = typeof clearTimeout == "function" ? clearTimeout : null, w = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function S(G) {
    for (var X = n(c); X !== null; ) {
      if (X.callback === null)
        r(c);
      else if (X.startTime <= G)
        r(c), X.sortIndex = X.expirationTime, t(l, X);
      else
        break;
      X = n(c);
    }
  }
  function E(G) {
    if (y = !1, S(G), !v)
      if (n(l) !== null)
        v = !0, W(O);
      else {
        var X = n(c);
        X !== null && V(E, X.startTime - G);
      }
  }
  function O(G, X) {
    v = !1, y && (y = !1, b(R), R = -1), g = !0;
    var D = p;
    try {
      for (S(X), d = n(l); d !== null && (!(d.expirationTime > X) || G && !j()); ) {
        var te = d.callback;
        if (typeof te == "function") {
          d.callback = null, p = d.priorityLevel;
          var ee = te(d.expirationTime <= X);
          X = e.unstable_now(), typeof ee == "function" ? d.callback = ee : d === n(l) && r(l), S(X);
        } else
          r(l);
        d = n(l);
      }
      if (d !== null)
        var U = !0;
      else {
        var he = n(c);
        he !== null && V(E, he.startTime - X), U = !1;
      }
      return U;
    } finally {
      d = null, p = D, g = !1;
    }
  }
  var $ = !1, P = null, R = -1, L = 5, B = -1;
  function j() {
    return !(e.unstable_now() - B < L);
  }
  function A() {
    if (P !== null) {
      var G = e.unstable_now();
      B = G;
      var X = !0;
      try {
        X = P(!0, G);
      } finally {
        X ? T() : ($ = !1, P = null);
      }
    } else
      $ = !1;
  }
  var T;
  if (typeof w == "function")
    T = function() {
      w(A);
    };
  else if (typeof MessageChannel < "u") {
    var k = new MessageChannel(), F = k.port2;
    k.port1.onmessage = A, T = function() {
      F.postMessage(null);
    };
  } else
    T = function() {
      x(A, 0);
    };
  function W(G) {
    P = G, $ || ($ = !0, T());
  }
  function V(G, X) {
    R = x(function() {
      G(e.unstable_now());
    }, X);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(G) {
    G.callback = null;
  }, e.unstable_continueExecution = function() {
    v || g || (v = !0, W(O));
  }, e.unstable_forceFrameRate = function(G) {
    0 > G || 125 < G ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : L = 0 < G ? Math.floor(1e3 / G) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return p;
  }, e.unstable_getFirstCallbackNode = function() {
    return n(l);
  }, e.unstable_next = function(G) {
    switch (p) {
      case 1:
      case 2:
      case 3:
        var X = 3;
        break;
      default:
        X = p;
    }
    var D = p;
    p = X;
    try {
      return G();
    } finally {
      p = D;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(G, X) {
    switch (G) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        G = 3;
    }
    var D = p;
    p = G;
    try {
      return X();
    } finally {
      p = D;
    }
  }, e.unstable_scheduleCallback = function(G, X, D) {
    var te = e.unstable_now();
    switch (typeof D == "object" && D !== null ? (D = D.delay, D = typeof D == "number" && 0 < D ? te + D : te) : D = te, G) {
      case 1:
        var ee = -1;
        break;
      case 2:
        ee = 250;
        break;
      case 5:
        ee = 1073741823;
        break;
      case 4:
        ee = 1e4;
        break;
      default:
        ee = 5e3;
    }
    return ee = D + ee, G = { id: f++, callback: X, priorityLevel: G, startTime: D, expirationTime: ee, sortIndex: -1 }, D > te ? (G.sortIndex = D, t(c, G), n(l) === null && G === n(c) && (y ? (b(R), R = -1) : y = !0, V(E, D - te))) : (G.sortIndex = ee, t(l, G), v || g || (v = !0, W(O))), G;
  }, e.unstable_shouldYield = j, e.unstable_wrapCallback = function(G) {
    var X = p;
    return function() {
      var D = p;
      p = X;
      try {
        return G.apply(this, arguments);
      } finally {
        p = D;
      }
    };
  };
})(l8);
s8.exports = l8;
var joe = s8.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c8 = m, $a = joe;
function Ve(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var u8 = /* @__PURE__ */ new Set(), cg = {};
function Xf(e, t) {
  Np(e, t), Np(e + "Capture", t);
}
function Np(e, t) {
  for (cg[e] = t, e = 0; e < t.length; e++)
    u8.add(t[e]);
}
var fc = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), cO = Object.prototype.hasOwnProperty, Foe = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, gL = {}, vL = {};
function Boe(e) {
  return cO.call(vL, e) ? !0 : cO.call(gL, e) ? !1 : Foe.test(e) ? vL[e] = !0 : (gL[e] = !0, !1);
}
function zoe(e, t, n, r) {
  if (n !== null && n.type === 0)
    return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function Uoe(e, t, n, r) {
  if (t === null || typeof t > "u" || zoe(e, t, n, r))
    return !0;
  if (r)
    return !1;
  if (n !== null)
    switch (n.type) {
      case 3:
        return !t;
      case 4:
        return t === !1;
      case 5:
        return isNaN(t);
      case 6:
        return isNaN(t) || 1 > t;
    }
  return !1;
}
function Io(e, t, n, r, i, o, a) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = a;
}
var Wi = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  Wi[e] = new Io(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  Wi[t] = new Io(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  Wi[e] = new Io(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  Wi[e] = new Io(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  Wi[e] = new Io(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  Wi[e] = new Io(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  Wi[e] = new Io(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  Wi[e] = new Io(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  Wi[e] = new Io(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var pA = /[\-:]([a-z])/g;
function hA(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    pA,
    hA
  );
  Wi[t] = new Io(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(pA, hA);
  Wi[t] = new Io(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(pA, hA);
  Wi[t] = new Io(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  Wi[e] = new Io(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
Wi.xlinkHref = new Io("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  Wi[e] = new Io(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function mA(e, t, n, r) {
  var i = Wi.hasOwnProperty(t) ? Wi[t] : null;
  (i !== null ? i.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (Uoe(t, n, i, r) && (n = null), r || i === null ? Boe(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : i.mustUseProperty ? e[i.propertyName] = n === null ? i.type === 3 ? !1 : "" : n : (t = i.attributeName, r = i.attributeNamespace, n === null ? e.removeAttribute(t) : (i = i.type, n = i === 3 || i === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var wc = c8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Uy = Symbol.for("react.element"), Ud = Symbol.for("react.portal"), Hd = Symbol.for("react.fragment"), gA = Symbol.for("react.strict_mode"), uO = Symbol.for("react.profiler"), f8 = Symbol.for("react.provider"), d8 = Symbol.for("react.context"), vA = Symbol.for("react.forward_ref"), fO = Symbol.for("react.suspense"), dO = Symbol.for("react.suspense_list"), yA = Symbol.for("react.memo"), Wc = Symbol.for("react.lazy"), p8 = Symbol.for("react.offscreen"), yL = Symbol.iterator;
function lm(e) {
  return e === null || typeof e != "object" ? null : (e = yL && e[yL] || e["@@iterator"], typeof e == "function" ? e : null);
}
var Lr = Object.assign, kE;
function Im(e) {
  if (kE === void 0)
    try {
      throw Error();
    } catch (n) {
      var t = n.stack.trim().match(/\n( *(at )?)/);
      kE = t && t[1] || "";
    }
  return `
` + kE + e;
}
var LE = !1;
function DE(e, t) {
  if (!e || LE)
    return "";
  LE = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t)
      if (t = function() {
        throw Error();
      }, Object.defineProperty(t.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(t, []);
        } catch (c) {
          var r = c;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (c) {
          r = c;
        }
        e.call(t.prototype);
      }
    else {
      try {
        throw Error();
      } catch (c) {
        r = c;
      }
      e();
    }
  } catch (c) {
    if (c && r && typeof c.stack == "string") {
      for (var i = c.stack.split(`
`), o = r.stack.split(`
`), a = i.length - 1, s = o.length - 1; 1 <= a && 0 <= s && i[a] !== o[s]; )
        s--;
      for (; 1 <= a && 0 <= s; a--, s--)
        if (i[a] !== o[s]) {
          if (a !== 1 || s !== 1)
            do
              if (a--, s--, 0 > s || i[a] !== o[s]) {
                var l = `
` + i[a].replace(" at new ", " at ");
                return e.displayName && l.includes("<anonymous>") && (l = l.replace("<anonymous>", e.displayName)), l;
              }
            while (1 <= a && 0 <= s);
          break;
        }
    }
  } finally {
    LE = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? Im(e) : "";
}
function Hoe(e) {
  switch (e.tag) {
    case 5:
      return Im(e.type);
    case 16:
      return Im("Lazy");
    case 13:
      return Im("Suspense");
    case 19:
      return Im("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = DE(e.type, !1), e;
    case 11:
      return e = DE(e.type.render, !1), e;
    case 1:
      return e = DE(e.type, !0), e;
    default:
      return "";
  }
}
function pO(e) {
  if (e == null)
    return null;
  if (typeof e == "function")
    return e.displayName || e.name || null;
  if (typeof e == "string")
    return e;
  switch (e) {
    case Hd:
      return "Fragment";
    case Ud:
      return "Portal";
    case uO:
      return "Profiler";
    case gA:
      return "StrictMode";
    case fO:
      return "Suspense";
    case dO:
      return "SuspenseList";
  }
  if (typeof e == "object")
    switch (e.$$typeof) {
      case d8:
        return (e.displayName || "Context") + ".Consumer";
      case f8:
        return (e._context.displayName || "Context") + ".Provider";
      case vA:
        var t = e.render;
        return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
      case yA:
        return t = e.displayName || null, t !== null ? t : pO(e.type) || "Memo";
      case Wc:
        t = e._payload, e = e._init;
        try {
          return pO(e(t));
        } catch {
        }
    }
  return null;
}
function Woe(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return pO(t);
    case 8:
      return t === gA ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
  }
  return null;
}
function Cu(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function h8(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function Voe(e) {
  var t = h8(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
    var i = n.get, o = n.set;
    return Object.defineProperty(e, t, { configurable: !0, get: function() {
      return i.call(this);
    }, set: function(a) {
      r = "" + a, o.call(this, a);
    } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
      return r;
    }, setValue: function(a) {
      r = "" + a;
    }, stopTracking: function() {
      e._valueTracker = null, delete e[t];
    } };
  }
}
function Hy(e) {
  e._valueTracker || (e._valueTracker = Voe(e));
}
function m8(e) {
  if (!e)
    return !1;
  var t = e._valueTracker;
  if (!t)
    return !0;
  var n = t.getValue(), r = "";
  return e && (r = h8(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function Wb(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function hO(e, t) {
  var n = t.checked;
  return Lr({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n ?? e._wrapperState.initialChecked });
}
function bL(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
  n = Cu(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
}
function g8(e, t) {
  t = t.checked, t != null && mA(e, "checked", t, !1);
}
function mO(e, t) {
  g8(e, t);
  var n = Cu(t.value), r = t.type;
  if (n != null)
    r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? gO(e, t.type, n) : t.hasOwnProperty("defaultValue") && gO(e, t.type, Cu(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function wL(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null))
      return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function gO(e, t, n) {
  (t !== "number" || Wb(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var Am = Array.isArray;
function dp(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var i = 0; i < n.length; i++)
      t["$" + n[i]] = !0;
    for (n = 0; n < e.length; n++)
      i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + Cu(n), t = null, i = 0; i < e.length; i++) {
      if (e[i].value === n) {
        e[i].selected = !0, r && (e[i].defaultSelected = !0);
        return;
      }
      t !== null || e[i].disabled || (t = e[i]);
    }
    t !== null && (t.selected = !0);
  }
}
function vO(e, t) {
  if (t.dangerouslySetInnerHTML != null)
    throw Error(Ve(91));
  return Lr({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
}
function SL(e, t) {
  var n = t.value;
  if (n == null) {
    if (n = t.children, t = t.defaultValue, n != null) {
      if (t != null)
        throw Error(Ve(92));
      if (Am(n)) {
        if (1 < n.length)
          throw Error(Ve(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ""), n = t;
  }
  e._wrapperState = { initialValue: Cu(n) };
}
function v8(e, t) {
  var n = Cu(t.value), r = Cu(t.defaultValue);
  n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function xL(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function y8(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function yO(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? y8(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var Wy, b8 = function(e) {
  return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, n, r, i) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(t, n, r, i);
    });
  } : e;
}(function(e, t) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e)
    e.innerHTML = t;
  else {
    for (Wy = Wy || document.createElement("div"), Wy.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Wy.firstChild; e.firstChild; )
      e.removeChild(e.firstChild);
    for (; t.firstChild; )
      e.appendChild(t.firstChild);
  }
});
function ug(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var Um = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, Goe = ["Webkit", "ms", "Moz", "O"];
Object.keys(Um).forEach(function(e) {
  Goe.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), Um[t] = Um[e];
  });
});
function w8(e, t, n) {
  return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || Um.hasOwnProperty(e) && Um[e] ? ("" + t).trim() : t + "px";
}
function S8(e, t) {
  e = e.style;
  for (var n in t)
    if (t.hasOwnProperty(n)) {
      var r = n.indexOf("--") === 0, i = w8(n, t[n], r);
      n === "float" && (n = "cssFloat"), r ? e.setProperty(n, i) : e[n] = i;
    }
}
var Koe = Lr({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function bO(e, t) {
  if (t) {
    if (Koe[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
      throw Error(Ve(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null)
        throw Error(Ve(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML))
        throw Error(Ve(61));
    }
    if (t.style != null && typeof t.style != "object")
      throw Error(Ve(62));
  }
}
function wO(e, t) {
  if (e.indexOf("-") === -1)
    return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var SO = null;
function bA(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var xO = null, pp = null, hp = null;
function CL(e) {
  if (e = nv(e)) {
    if (typeof xO != "function")
      throw Error(Ve(280));
    var t = e.stateNode;
    t && (t = bw(t), xO(e.stateNode, e.type, t));
  }
}
function x8(e) {
  pp ? hp ? hp.push(e) : hp = [e] : pp = e;
}
function C8() {
  if (pp) {
    var e = pp, t = hp;
    if (hp = pp = null, CL(e), t)
      for (e = 0; e < t.length; e++)
        CL(t[e]);
  }
}
function E8(e, t) {
  return e(t);
}
function $8() {
}
var jE = !1;
function _8(e, t, n) {
  if (jE)
    return e(t, n);
  jE = !0;
  try {
    return E8(e, t, n);
  } finally {
    jE = !1, (pp !== null || hp !== null) && ($8(), C8());
  }
}
function fg(e, t) {
  var n = e.stateNode;
  if (n === null)
    return null;
  var r = bw(n);
  if (r === null)
    return null;
  n = r[t];
  e:
    switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
        break e;
      default:
        e = !1;
    }
  if (e)
    return null;
  if (n && typeof n != "function")
    throw Error(Ve(231, t, typeof n));
  return n;
}
var CO = !1;
if (fc)
  try {
    var cm = {};
    Object.defineProperty(cm, "passive", { get: function() {
      CO = !0;
    } }), window.addEventListener("test", cm, cm), window.removeEventListener("test", cm, cm);
  } catch {
    CO = !1;
  }
function qoe(e, t, n, r, i, o, a, s, l) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (f) {
    this.onError(f);
  }
}
var Hm = !1, Vb = null, Gb = !1, EO = null, Yoe = { onError: function(e) {
  Hm = !0, Vb = e;
} };
function Xoe(e, t, n, r, i, o, a, s, l) {
  Hm = !1, Vb = null, qoe.apply(Yoe, arguments);
}
function Qoe(e, t, n, r, i, o, a, s, l) {
  if (Xoe.apply(this, arguments), Hm) {
    if (Hm) {
      var c = Vb;
      Hm = !1, Vb = null;
    } else
      throw Error(Ve(198));
    Gb || (Gb = !0, EO = c);
  }
}
function Qf(e) {
  var t = e, n = e;
  if (e.alternate)
    for (; t.return; )
      t = t.return;
  else {
    e = t;
    do
      t = e, t.flags & 4098 && (n = t.return), e = t.return;
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function O8(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null)
      return t.dehydrated;
  }
  return null;
}
function EL(e) {
  if (Qf(e) !== e)
    throw Error(Ve(188));
}
function Joe(e) {
  var t = e.alternate;
  if (!t) {
    if (t = Qf(e), t === null)
      throw Error(Ve(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t; ; ) {
    var i = n.return;
    if (i === null)
      break;
    var o = i.alternate;
    if (o === null) {
      if (r = i.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (i.child === o.child) {
      for (o = i.child; o; ) {
        if (o === n)
          return EL(i), e;
        if (o === r)
          return EL(i), t;
        o = o.sibling;
      }
      throw Error(Ve(188));
    }
    if (n.return !== r.return)
      n = i, r = o;
    else {
      for (var a = !1, s = i.child; s; ) {
        if (s === n) {
          a = !0, n = i, r = o;
          break;
        }
        if (s === r) {
          a = !0, r = i, n = o;
          break;
        }
        s = s.sibling;
      }
      if (!a) {
        for (s = o.child; s; ) {
          if (s === n) {
            a = !0, n = o, r = i;
            break;
          }
          if (s === r) {
            a = !0, r = o, n = i;
            break;
          }
          s = s.sibling;
        }
        if (!a)
          throw Error(Ve(189));
      }
    }
    if (n.alternate !== r)
      throw Error(Ve(190));
  }
  if (n.tag !== 3)
    throw Error(Ve(188));
  return n.stateNode.current === n ? e : t;
}
function P8(e) {
  return e = Joe(e), e !== null ? T8(e) : null;
}
function T8(e) {
  if (e.tag === 5 || e.tag === 6)
    return e;
  for (e = e.child; e !== null; ) {
    var t = T8(e);
    if (t !== null)
      return t;
    e = e.sibling;
  }
  return null;
}
var I8 = $a.unstable_scheduleCallback, $L = $a.unstable_cancelCallback, Zoe = $a.unstable_shouldYield, eae = $a.unstable_requestPaint, qr = $a.unstable_now, tae = $a.unstable_getCurrentPriorityLevel, wA = $a.unstable_ImmediatePriority, A8 = $a.unstable_UserBlockingPriority, Kb = $a.unstable_NormalPriority, nae = $a.unstable_LowPriority, R8 = $a.unstable_IdlePriority, mw = null, Ol = null;
function rae(e) {
  if (Ol && typeof Ol.onCommitFiberRoot == "function")
    try {
      Ol.onCommitFiberRoot(mw, e, void 0, (e.current.flags & 128) === 128);
    } catch {
    }
}
var Bs = Math.clz32 ? Math.clz32 : aae, iae = Math.log, oae = Math.LN2;
function aae(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (iae(e) / oae | 0) | 0;
}
var Vy = 64, Gy = 4194304;
function Rm(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function qb(e, t) {
  var n = e.pendingLanes;
  if (n === 0)
    return 0;
  var r = 0, i = e.suspendedLanes, o = e.pingedLanes, a = n & 268435455;
  if (a !== 0) {
    var s = a & ~i;
    s !== 0 ? r = Rm(s) : (o &= a, o !== 0 && (r = Rm(o)));
  } else
    a = n & ~i, a !== 0 ? r = Rm(a) : o !== 0 && (r = Rm(o));
  if (r === 0)
    return 0;
  if (t !== 0 && t !== r && !(t & i) && (i = r & -r, o = t & -t, i >= o || i === 16 && (o & 4194240) !== 0))
    return t;
  if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0)
    for (e = e.entanglements, t &= r; 0 < t; )
      n = 31 - Bs(t), i = 1 << n, r |= e[n], t &= ~i;
  return r;
}
function sae(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function lae(e, t) {
  for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
    var a = 31 - Bs(o), s = 1 << a, l = i[a];
    l === -1 ? (!(s & n) || s & r) && (i[a] = sae(s, t)) : l <= t && (e.expiredLanes |= s), o &= ~s;
  }
}
function $O(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function M8() {
  var e = Vy;
  return Vy <<= 1, !(Vy & 4194240) && (Vy = 64), e;
}
function FE(e) {
  for (var t = [], n = 0; 31 > n; n++)
    t.push(e);
  return t;
}
function ev(e, t, n) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - Bs(t), e[t] = n;
}
function cae(e, t) {
  var n = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var i = 31 - Bs(n), o = 1 << i;
    t[i] = 0, r[i] = -1, e[i] = -1, n &= ~o;
  }
}
function SA(e, t) {
  var n = e.entangledLanes |= t;
  for (e = e.entanglements; n; ) {
    var r = 31 - Bs(n), i = 1 << r;
    i & t | e[r] & t && (e[r] |= t), n &= ~i;
  }
}
var Fn = 0;
function N8(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var k8, xA, L8, D8, j8, _O = !1, Ky = [], du = null, pu = null, hu = null, dg = /* @__PURE__ */ new Map(), pg = /* @__PURE__ */ new Map(), Kc = [], uae = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function _L(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      du = null;
      break;
    case "dragenter":
    case "dragleave":
      pu = null;
      break;
    case "mouseover":
    case "mouseout":
      hu = null;
      break;
    case "pointerover":
    case "pointerout":
      dg.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      pg.delete(t.pointerId);
  }
}
function um(e, t, n, r, i, o) {
  return e === null || e.nativeEvent !== o ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: o, targetContainers: [i] }, t !== null && (t = nv(t), t !== null && xA(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
}
function fae(e, t, n, r, i) {
  switch (t) {
    case "focusin":
      return du = um(du, e, t, n, r, i), !0;
    case "dragenter":
      return pu = um(pu, e, t, n, r, i), !0;
    case "mouseover":
      return hu = um(hu, e, t, n, r, i), !0;
    case "pointerover":
      var o = i.pointerId;
      return dg.set(o, um(dg.get(o) || null, e, t, n, r, i)), !0;
    case "gotpointercapture":
      return o = i.pointerId, pg.set(o, um(pg.get(o) || null, e, t, n, r, i)), !0;
  }
  return !1;
}
function F8(e) {
  var t = gf(e.target);
  if (t !== null) {
    var n = Qf(t);
    if (n !== null) {
      if (t = n.tag, t === 13) {
        if (t = O8(n), t !== null) {
          e.blockedOn = t, j8(e.priority, function() {
            L8(n);
          });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function q0(e) {
  if (e.blockedOn !== null)
    return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = OO(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      SO = r, n.target.dispatchEvent(r), SO = null;
    } else
      return t = nv(n), t !== null && xA(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function OL(e, t, n) {
  q0(e) && n.delete(t);
}
function dae() {
  _O = !1, du !== null && q0(du) && (du = null), pu !== null && q0(pu) && (pu = null), hu !== null && q0(hu) && (hu = null), dg.forEach(OL), pg.forEach(OL);
}
function fm(e, t) {
  e.blockedOn === t && (e.blockedOn = null, _O || (_O = !0, $a.unstable_scheduleCallback($a.unstable_NormalPriority, dae)));
}
function hg(e) {
  function t(i) {
    return fm(i, e);
  }
  if (0 < Ky.length) {
    fm(Ky[0], e);
    for (var n = 1; n < Ky.length; n++) {
      var r = Ky[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (du !== null && fm(du, e), pu !== null && fm(pu, e), hu !== null && fm(hu, e), dg.forEach(t), pg.forEach(t), n = 0; n < Kc.length; n++)
    r = Kc[n], r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < Kc.length && (n = Kc[0], n.blockedOn === null); )
    F8(n), n.blockedOn === null && Kc.shift();
}
var mp = wc.ReactCurrentBatchConfig, Yb = !0;
function pae(e, t, n, r) {
  var i = Fn, o = mp.transition;
  mp.transition = null;
  try {
    Fn = 1, CA(e, t, n, r);
  } finally {
    Fn = i, mp.transition = o;
  }
}
function hae(e, t, n, r) {
  var i = Fn, o = mp.transition;
  mp.transition = null;
  try {
    Fn = 4, CA(e, t, n, r);
  } finally {
    Fn = i, mp.transition = o;
  }
}
function CA(e, t, n, r) {
  if (Yb) {
    var i = OO(e, t, n, r);
    if (i === null)
      YE(e, t, r, Xb, n), _L(e, r);
    else if (fae(i, e, t, n, r))
      r.stopPropagation();
    else if (_L(e, r), t & 4 && -1 < uae.indexOf(e)) {
      for (; i !== null; ) {
        var o = nv(i);
        if (o !== null && k8(o), o = OO(e, t, n, r), o === null && YE(e, t, r, Xb, n), o === i)
          break;
        i = o;
      }
      i !== null && r.stopPropagation();
    } else
      YE(e, t, r, null, n);
  }
}
var Xb = null;
function OO(e, t, n, r) {
  if (Xb = null, e = bA(r), e = gf(e), e !== null)
    if (t = Qf(e), t === null)
      e = null;
    else if (n = t.tag, n === 13) {
      if (e = O8(t), e !== null)
        return e;
      e = null;
    } else if (n === 3) {
      if (t.stateNode.current.memoizedState.isDehydrated)
        return t.tag === 3 ? t.stateNode.containerInfo : null;
      e = null;
    } else
      t !== e && (e = null);
  return Xb = e, null;
}
function B8(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (tae()) {
        case wA:
          return 1;
        case A8:
          return 4;
        case Kb:
        case nae:
          return 16;
        case R8:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var Zc = null, EA = null, Y0 = null;
function z8() {
  if (Y0)
    return Y0;
  var e, t = EA, n = t.length, r, i = "value" in Zc ? Zc.value : Zc.textContent, o = i.length;
  for (e = 0; e < n && t[e] === i[e]; e++)
    ;
  var a = n - e;
  for (r = 1; r <= a && t[n - r] === i[o - r]; r++)
    ;
  return Y0 = i.slice(e, 1 < r ? 1 - r : void 0);
}
function X0(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function qy() {
  return !0;
}
function PL() {
  return !1;
}
function Ta(e) {
  function t(n, r, i, o, a) {
    this._reactName = n, this._targetInst = i, this.type = r, this.nativeEvent = o, this.target = a, this.currentTarget = null;
    for (var s in e)
      e.hasOwnProperty(s) && (n = e[s], this[s] = n ? n(o) : o[s]);
    return this.isDefaultPrevented = (o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1) ? qy : PL, this.isPropagationStopped = PL, this;
  }
  return Lr(t.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var n = this.nativeEvent;
    n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = qy);
  }, stopPropagation: function() {
    var n = this.nativeEvent;
    n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = qy);
  }, persist: function() {
  }, isPersistent: qy }), t;
}
var ch = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, $A = Ta(ch), tv = Lr({}, ch, { view: 0, detail: 0 }), mae = Ta(tv), BE, zE, dm, gw = Lr({}, tv, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: _A, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== dm && (dm && e.type === "mousemove" ? (BE = e.screenX - dm.screenX, zE = e.screenY - dm.screenY) : zE = BE = 0, dm = e), BE);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : zE;
} }), TL = Ta(gw), gae = Lr({}, gw, { dataTransfer: 0 }), vae = Ta(gae), yae = Lr({}, tv, { relatedTarget: 0 }), UE = Ta(yae), bae = Lr({}, ch, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), wae = Ta(bae), Sae = Lr({}, ch, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} }), xae = Ta(Sae), Cae = Lr({}, ch, { data: 0 }), IL = Ta(Cae), Eae = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, $ae = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, _ae = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Oae(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = _ae[e]) ? !!t[e] : !1;
}
function _A() {
  return Oae;
}
var Pae = Lr({}, tv, { key: function(e) {
  if (e.key) {
    var t = Eae[e.key] || e.key;
    if (t !== "Unidentified")
      return t;
  }
  return e.type === "keypress" ? (e = X0(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? $ae[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: _A, charCode: function(e) {
  return e.type === "keypress" ? X0(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? X0(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} }), Tae = Ta(Pae), Iae = Lr({}, gw, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), AL = Ta(Iae), Aae = Lr({}, tv, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: _A }), Rae = Ta(Aae), Mae = Lr({}, ch, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Nae = Ta(Mae), kae = Lr({}, gw, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Lae = Ta(kae), Dae = [9, 13, 27, 32], OA = fc && "CompositionEvent" in window, Wm = null;
fc && "documentMode" in document && (Wm = document.documentMode);
var jae = fc && "TextEvent" in window && !Wm, U8 = fc && (!OA || Wm && 8 < Wm && 11 >= Wm), RL = " ", ML = !1;
function H8(e, t) {
  switch (e) {
    case "keyup":
      return Dae.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function W8(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var Wd = !1;
function Fae(e, t) {
  switch (e) {
    case "compositionend":
      return W8(t);
    case "keypress":
      return t.which !== 32 ? null : (ML = !0, RL);
    case "textInput":
      return e = t.data, e === RL && ML ? null : e;
    default:
      return null;
  }
}
function Bae(e, t) {
  if (Wd)
    return e === "compositionend" || !OA && H8(e, t) ? (e = z8(), Y0 = EA = Zc = null, Wd = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length)
          return t.char;
        if (t.which)
          return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return U8 && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var zae = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function NL(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!zae[e.type] : t === "textarea";
}
function V8(e, t, n, r) {
  x8(r), t = Qb(t, "onChange"), 0 < t.length && (n = new $A("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
}
var Vm = null, mg = null;
function Uae(e) {
  nz(e, 0);
}
function vw(e) {
  var t = Kd(e);
  if (m8(t))
    return e;
}
function Hae(e, t) {
  if (e === "change")
    return t;
}
var G8 = !1;
if (fc) {
  var HE;
  if (fc) {
    var WE = "oninput" in document;
    if (!WE) {
      var kL = document.createElement("div");
      kL.setAttribute("oninput", "return;"), WE = typeof kL.oninput == "function";
    }
    HE = WE;
  } else
    HE = !1;
  G8 = HE && (!document.documentMode || 9 < document.documentMode);
}
function LL() {
  Vm && (Vm.detachEvent("onpropertychange", K8), mg = Vm = null);
}
function K8(e) {
  if (e.propertyName === "value" && vw(mg)) {
    var t = [];
    V8(t, mg, e, bA(e)), _8(Uae, t);
  }
}
function Wae(e, t, n) {
  e === "focusin" ? (LL(), Vm = t, mg = n, Vm.attachEvent("onpropertychange", K8)) : e === "focusout" && LL();
}
function Vae(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown")
    return vw(mg);
}
function Gae(e, t) {
  if (e === "click")
    return vw(t);
}
function Kae(e, t) {
  if (e === "input" || e === "change")
    return vw(t);
}
function qae(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Ks = typeof Object.is == "function" ? Object.is : qae;
function gg(e, t) {
  if (Ks(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (r = 0; r < n.length; r++) {
    var i = n[r];
    if (!cO.call(t, i) || !Ks(e[i], t[i]))
      return !1;
  }
  return !0;
}
function DL(e) {
  for (; e && e.firstChild; )
    e = e.firstChild;
  return e;
}
function jL(e, t) {
  var n = DL(e);
  e = 0;
  for (var r; n; ) {
    if (n.nodeType === 3) {
      if (r = e + n.textContent.length, e <= t && r >= t)
        return { node: n, offset: t - e };
      e = r;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = DL(n);
  }
}
function q8(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? q8(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function Y8() {
  for (var e = window, t = Wb(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n)
      e = t.contentWindow;
    else
      break;
    t = Wb(e.document);
  }
  return t;
}
function PA(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function Yae(e) {
  var t = Y8(), n = e.focusedElem, r = e.selectionRange;
  if (t !== n && n && n.ownerDocument && q8(n.ownerDocument.documentElement, n)) {
    if (r !== null && PA(n)) {
      if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n)
        n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
      else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var i = n.textContent.length, o = Math.min(r.start, i);
        r = r.end === void 0 ? o : Math.min(r.end, i), !e.extend && o > r && (i = r, r = o, o = i), i = jL(n, o);
        var a = jL(
          n,
          r
        );
        i && a && (e.rangeCount !== 1 || e.anchorNode !== i.node || e.anchorOffset !== i.offset || e.focusNode !== a.node || e.focusOffset !== a.offset) && (t = t.createRange(), t.setStart(i.node, i.offset), e.removeAllRanges(), o > r ? (e.addRange(t), e.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; e = e.parentNode; )
      e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++)
      e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var Xae = fc && "documentMode" in document && 11 >= document.documentMode, Vd = null, PO = null, Gm = null, TO = !1;
function FL(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  TO || Vd == null || Vd !== Wb(r) || (r = Vd, "selectionStart" in r && PA(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), Gm && gg(Gm, r) || (Gm = r, r = Qb(PO, "onSelect"), 0 < r.length && (t = new $A("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = Vd)));
}
function Yy(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var Gd = { animationend: Yy("Animation", "AnimationEnd"), animationiteration: Yy("Animation", "AnimationIteration"), animationstart: Yy("Animation", "AnimationStart"), transitionend: Yy("Transition", "TransitionEnd") }, VE = {}, X8 = {};
fc && (X8 = document.createElement("div").style, "AnimationEvent" in window || (delete Gd.animationend.animation, delete Gd.animationiteration.animation, delete Gd.animationstart.animation), "TransitionEvent" in window || delete Gd.transitionend.transition);
function yw(e) {
  if (VE[e])
    return VE[e];
  if (!Gd[e])
    return e;
  var t = Gd[e], n;
  for (n in t)
    if (t.hasOwnProperty(n) && n in X8)
      return VE[e] = t[n];
  return e;
}
var Q8 = yw("animationend"), J8 = yw("animationiteration"), Z8 = yw("animationstart"), ez = yw("transitionend"), tz = /* @__PURE__ */ new Map(), BL = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function Au(e, t) {
  tz.set(e, t), Xf(t, [e]);
}
for (var GE = 0; GE < BL.length; GE++) {
  var KE = BL[GE], Qae = KE.toLowerCase(), Jae = KE[0].toUpperCase() + KE.slice(1);
  Au(Qae, "on" + Jae);
}
Au(Q8, "onAnimationEnd");
Au(J8, "onAnimationIteration");
Au(Z8, "onAnimationStart");
Au("dblclick", "onDoubleClick");
Au("focusin", "onFocus");
Au("focusout", "onBlur");
Au(ez, "onTransitionEnd");
Np("onMouseEnter", ["mouseout", "mouseover"]);
Np("onMouseLeave", ["mouseout", "mouseover"]);
Np("onPointerEnter", ["pointerout", "pointerover"]);
Np("onPointerLeave", ["pointerout", "pointerover"]);
Xf("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
Xf("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
Xf("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
Xf("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
Xf("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
Xf("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Mm = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Zae = new Set("cancel close invalid load scroll toggle".split(" ").concat(Mm));
function zL(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, Qoe(r, t, void 0, e), e.currentTarget = null;
}
function nz(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = r.event;
    r = r.listeners;
    e: {
      var o = void 0;
      if (t)
        for (var a = r.length - 1; 0 <= a; a--) {
          var s = r[a], l = s.instance, c = s.currentTarget;
          if (s = s.listener, l !== o && i.isPropagationStopped())
            break e;
          zL(i, s, c), o = l;
        }
      else
        for (a = 0; a < r.length; a++) {
          if (s = r[a], l = s.instance, c = s.currentTarget, s = s.listener, l !== o && i.isPropagationStopped())
            break e;
          zL(i, s, c), o = l;
        }
    }
  }
  if (Gb)
    throw e = EO, Gb = !1, EO = null, e;
}
function gr(e, t) {
  var n = t[NO];
  n === void 0 && (n = t[NO] = /* @__PURE__ */ new Set());
  var r = e + "__bubble";
  n.has(r) || (rz(t, e, 2, !1), n.add(r));
}
function qE(e, t, n) {
  var r = 0;
  t && (r |= 4), rz(n, e, r, t);
}
var Xy = "_reactListening" + Math.random().toString(36).slice(2);
function vg(e) {
  if (!e[Xy]) {
    e[Xy] = !0, u8.forEach(function(n) {
      n !== "selectionchange" && (Zae.has(n) || qE(n, !1, e), qE(n, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[Xy] || (t[Xy] = !0, qE("selectionchange", !1, t));
  }
}
function rz(e, t, n, r) {
  switch (B8(t)) {
    case 1:
      var i = pae;
      break;
    case 4:
      i = hae;
      break;
    default:
      i = CA;
  }
  n = i.bind(null, t, n, e), i = void 0, !CO || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: i }) : e.addEventListener(t, n, !0) : i !== void 0 ? e.addEventListener(t, n, { passive: i }) : e.addEventListener(t, n, !1);
}
function YE(e, t, n, r, i) {
  var o = r;
  if (!(t & 1) && !(t & 2) && r !== null)
    e:
      for (; ; ) {
        if (r === null)
          return;
        var a = r.tag;
        if (a === 3 || a === 4) {
          var s = r.stateNode.containerInfo;
          if (s === i || s.nodeType === 8 && s.parentNode === i)
            break;
          if (a === 4)
            for (a = r.return; a !== null; ) {
              var l = a.tag;
              if ((l === 3 || l === 4) && (l = a.stateNode.containerInfo, l === i || l.nodeType === 8 && l.parentNode === i))
                return;
              a = a.return;
            }
          for (; s !== null; ) {
            if (a = gf(s), a === null)
              return;
            if (l = a.tag, l === 5 || l === 6) {
              r = o = a;
              continue e;
            }
            s = s.parentNode;
          }
        }
        r = r.return;
      }
  _8(function() {
    var c = o, f = bA(n), d = [];
    e: {
      var p = tz.get(e);
      if (p !== void 0) {
        var g = $A, v = e;
        switch (e) {
          case "keypress":
            if (X0(n) === 0)
              break e;
          case "keydown":
          case "keyup":
            g = Tae;
            break;
          case "focusin":
            v = "focus", g = UE;
            break;
          case "focusout":
            v = "blur", g = UE;
            break;
          case "beforeblur":
          case "afterblur":
            g = UE;
            break;
          case "click":
            if (n.button === 2)
              break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            g = TL;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            g = vae;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            g = Rae;
            break;
          case Q8:
          case J8:
          case Z8:
            g = wae;
            break;
          case ez:
            g = Nae;
            break;
          case "scroll":
            g = mae;
            break;
          case "wheel":
            g = Lae;
            break;
          case "copy":
          case "cut":
          case "paste":
            g = xae;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            g = AL;
        }
        var y = (t & 4) !== 0, x = !y && e === "scroll", b = y ? p !== null ? p + "Capture" : null : p;
        y = [];
        for (var w = c, S; w !== null; ) {
          S = w;
          var E = S.stateNode;
          if (S.tag === 5 && E !== null && (S = E, b !== null && (E = fg(w, b), E != null && y.push(yg(w, E, S)))), x)
            break;
          w = w.return;
        }
        0 < y.length && (p = new g(p, v, null, n, f), d.push({ event: p, listeners: y }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (p = e === "mouseover" || e === "pointerover", g = e === "mouseout" || e === "pointerout", p && n !== SO && (v = n.relatedTarget || n.fromElement) && (gf(v) || v[dc]))
          break e;
        if ((g || p) && (p = f.window === f ? f : (p = f.ownerDocument) ? p.defaultView || p.parentWindow : window, g ? (v = n.relatedTarget || n.toElement, g = c, v = v ? gf(v) : null, v !== null && (x = Qf(v), v !== x || v.tag !== 5 && v.tag !== 6) && (v = null)) : (g = null, v = c), g !== v)) {
          if (y = TL, E = "onMouseLeave", b = "onMouseEnter", w = "mouse", (e === "pointerout" || e === "pointerover") && (y = AL, E = "onPointerLeave", b = "onPointerEnter", w = "pointer"), x = g == null ? p : Kd(g), S = v == null ? p : Kd(v), p = new y(E, w + "leave", g, n, f), p.target = x, p.relatedTarget = S, E = null, gf(f) === c && (y = new y(b, w + "enter", v, n, f), y.target = S, y.relatedTarget = x, E = y), x = E, g && v)
            t: {
              for (y = g, b = v, w = 0, S = y; S; S = Sd(S))
                w++;
              for (S = 0, E = b; E; E = Sd(E))
                S++;
              for (; 0 < w - S; )
                y = Sd(y), w--;
              for (; 0 < S - w; )
                b = Sd(b), S--;
              for (; w--; ) {
                if (y === b || b !== null && y === b.alternate)
                  break t;
                y = Sd(y), b = Sd(b);
              }
              y = null;
            }
          else
            y = null;
          g !== null && UL(d, p, g, y, !1), v !== null && x !== null && UL(d, x, v, y, !0);
        }
      }
      e: {
        if (p = c ? Kd(c) : window, g = p.nodeName && p.nodeName.toLowerCase(), g === "select" || g === "input" && p.type === "file")
          var O = Hae;
        else if (NL(p))
          if (G8)
            O = Kae;
          else {
            O = Vae;
            var $ = Wae;
          }
        else
          (g = p.nodeName) && g.toLowerCase() === "input" && (p.type === "checkbox" || p.type === "radio") && (O = Gae);
        if (O && (O = O(e, c))) {
          V8(d, O, n, f);
          break e;
        }
        $ && $(e, p, c), e === "focusout" && ($ = p._wrapperState) && $.controlled && p.type === "number" && gO(p, "number", p.value);
      }
      switch ($ = c ? Kd(c) : window, e) {
        case "focusin":
          (NL($) || $.contentEditable === "true") && (Vd = $, PO = c, Gm = null);
          break;
        case "focusout":
          Gm = PO = Vd = null;
          break;
        case "mousedown":
          TO = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          TO = !1, FL(d, n, f);
          break;
        case "selectionchange":
          if (Xae)
            break;
        case "keydown":
        case "keyup":
          FL(d, n, f);
      }
      var P;
      if (OA)
        e: {
          switch (e) {
            case "compositionstart":
              var R = "onCompositionStart";
              break e;
            case "compositionend":
              R = "onCompositionEnd";
              break e;
            case "compositionupdate":
              R = "onCompositionUpdate";
              break e;
          }
          R = void 0;
        }
      else
        Wd ? H8(e, n) && (R = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (R = "onCompositionStart");
      R && (U8 && n.locale !== "ko" && (Wd || R !== "onCompositionStart" ? R === "onCompositionEnd" && Wd && (P = z8()) : (Zc = f, EA = "value" in Zc ? Zc.value : Zc.textContent, Wd = !0)), $ = Qb(c, R), 0 < $.length && (R = new IL(R, e, null, n, f), d.push({ event: R, listeners: $ }), P ? R.data = P : (P = W8(n), P !== null && (R.data = P)))), (P = jae ? Fae(e, n) : Bae(e, n)) && (c = Qb(c, "onBeforeInput"), 0 < c.length && (f = new IL("onBeforeInput", "beforeinput", null, n, f), d.push({ event: f, listeners: c }), f.data = P));
    }
    nz(d, t);
  });
}
function yg(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function Qb(e, t) {
  for (var n = t + "Capture", r = []; e !== null; ) {
    var i = e, o = i.stateNode;
    i.tag === 5 && o !== null && (i = o, o = fg(e, n), o != null && r.unshift(yg(e, o, i)), o = fg(e, t), o != null && r.push(yg(e, o, i))), e = e.return;
  }
  return r;
}
function Sd(e) {
  if (e === null)
    return null;
  do
    e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function UL(e, t, n, r, i) {
  for (var o = t._reactName, a = []; n !== null && n !== r; ) {
    var s = n, l = s.alternate, c = s.stateNode;
    if (l !== null && l === r)
      break;
    s.tag === 5 && c !== null && (s = c, i ? (l = fg(n, o), l != null && a.unshift(yg(n, l, s))) : i || (l = fg(n, o), l != null && a.push(yg(n, l, s)))), n = n.return;
  }
  a.length !== 0 && e.push({ event: t, listeners: a });
}
var ese = /\r\n?/g, tse = /\u0000|\uFFFD/g;
function HL(e) {
  return (typeof e == "string" ? e : "" + e).replace(ese, `
`).replace(tse, "");
}
function Qy(e, t, n) {
  if (t = HL(t), HL(e) !== t && n)
    throw Error(Ve(425));
}
function Jb() {
}
var IO = null, AO = null;
function RO(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var MO = typeof setTimeout == "function" ? setTimeout : void 0, nse = typeof clearTimeout == "function" ? clearTimeout : void 0, WL = typeof Promise == "function" ? Promise : void 0, rse = typeof queueMicrotask == "function" ? queueMicrotask : typeof WL < "u" ? function(e) {
  return WL.resolve(null).then(e).catch(ise);
} : MO;
function ise(e) {
  setTimeout(function() {
    throw e;
  });
}
function XE(e, t) {
  var n = t, r = 0;
  do {
    var i = n.nextSibling;
    if (e.removeChild(n), i && i.nodeType === 8)
      if (n = i.data, n === "/$") {
        if (r === 0) {
          e.removeChild(i), hg(t);
          return;
        }
        r--;
      } else
        n !== "$" && n !== "$?" && n !== "$!" || r++;
    n = i;
  } while (n);
  hg(t);
}
function mu(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3)
      break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?")
        break;
      if (t === "/$")
        return null;
    }
  }
  return e;
}
function VL(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0)
          return e;
        t--;
      } else
        n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var uh = Math.random().toString(36).slice(2), bl = "__reactFiber$" + uh, bg = "__reactProps$" + uh, dc = "__reactContainer$" + uh, NO = "__reactEvents$" + uh, ose = "__reactListeners$" + uh, ase = "__reactHandles$" + uh;
function gf(e) {
  var t = e[bl];
  if (t)
    return t;
  for (var n = e.parentNode; n; ) {
    if (t = n[dc] || n[bl]) {
      if (n = t.alternate, t.child !== null || n !== null && n.child !== null)
        for (e = VL(e); e !== null; ) {
          if (n = e[bl])
            return n;
          e = VL(e);
        }
      return t;
    }
    e = n, n = e.parentNode;
  }
  return null;
}
function nv(e) {
  return e = e[bl] || e[dc], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function Kd(e) {
  if (e.tag === 5 || e.tag === 6)
    return e.stateNode;
  throw Error(Ve(33));
}
function bw(e) {
  return e[bg] || null;
}
var kO = [], qd = -1;
function Ru(e) {
  return { current: e };
}
function br(e) {
  0 > qd || (e.current = kO[qd], kO[qd] = null, qd--);
}
function cr(e, t) {
  qd++, kO[qd] = e.current, e.current = t;
}
var Eu = {}, mo = Ru(Eu), Ko = Ru(!1), Mf = Eu;
function kp(e, t) {
  var n = e.type.contextTypes;
  if (!n)
    return Eu;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
    return r.__reactInternalMemoizedMaskedChildContext;
  var i = {}, o;
  for (o in n)
    i[o] = t[o];
  return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i), i;
}
function qo(e) {
  return e = e.childContextTypes, e != null;
}
function Zb() {
  br(Ko), br(mo);
}
function GL(e, t, n) {
  if (mo.current !== Eu)
    throw Error(Ve(168));
  cr(mo, t), cr(Ko, n);
}
function iz(e, t, n) {
  var r = e.stateNode;
  if (t = t.childContextTypes, typeof r.getChildContext != "function")
    return n;
  r = r.getChildContext();
  for (var i in r)
    if (!(i in t))
      throw Error(Ve(108, Woe(e) || "Unknown", i));
  return Lr({}, n, r);
}
function e1(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Eu, Mf = mo.current, cr(mo, e), cr(Ko, Ko.current), !0;
}
function KL(e, t, n) {
  var r = e.stateNode;
  if (!r)
    throw Error(Ve(169));
  n ? (e = iz(e, t, Mf), r.__reactInternalMemoizedMergedChildContext = e, br(Ko), br(mo), cr(mo, e)) : br(Ko), cr(Ko, n);
}
var rc = null, ww = !1, QE = !1;
function oz(e) {
  rc === null ? rc = [e] : rc.push(e);
}
function sse(e) {
  ww = !0, oz(e);
}
function Mu() {
  if (!QE && rc !== null) {
    QE = !0;
    var e = 0, t = Fn;
    try {
      var n = rc;
      for (Fn = 1; e < n.length; e++) {
        var r = n[e];
        do
          r = r(!0);
        while (r !== null);
      }
      rc = null, ww = !1;
    } catch (i) {
      throw rc !== null && (rc = rc.slice(e + 1)), I8(wA, Mu), i;
    } finally {
      Fn = t, QE = !1;
    }
  }
  return null;
}
var Yd = [], Xd = 0, t1 = null, n1 = 0, Va = [], Ga = 0, Nf = null, ac = 1, sc = "";
function Qu(e, t) {
  Yd[Xd++] = n1, Yd[Xd++] = t1, t1 = e, n1 = t;
}
function az(e, t, n) {
  Va[Ga++] = ac, Va[Ga++] = sc, Va[Ga++] = Nf, Nf = e;
  var r = ac;
  e = sc;
  var i = 32 - Bs(r) - 1;
  r &= ~(1 << i), n += 1;
  var o = 32 - Bs(t) + i;
  if (30 < o) {
    var a = i - i % 5;
    o = (r & (1 << a) - 1).toString(32), r >>= a, i -= a, ac = 1 << 32 - Bs(t) + i | n << i | r, sc = o + e;
  } else
    ac = 1 << o | n << i | r, sc = e;
}
function TA(e) {
  e.return !== null && (Qu(e, 1), az(e, 1, 0));
}
function IA(e) {
  for (; e === t1; )
    t1 = Yd[--Xd], Yd[Xd] = null, n1 = Yd[--Xd], Yd[Xd] = null;
  for (; e === Nf; )
    Nf = Va[--Ga], Va[Ga] = null, sc = Va[--Ga], Va[Ga] = null, ac = Va[--Ga], Va[Ga] = null;
}
var Ea = null, wa = null, $r = !1, Ds = null;
function sz(e, t) {
  var n = Ya(5, null, null, 0);
  n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
}
function qL(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, Ea = e, wa = mu(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, Ea = e, wa = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (n = Nf !== null ? { id: ac, overflow: sc } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = Ya(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, Ea = e, wa = null, !0) : !1;
    default:
      return !1;
  }
}
function LO(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function DO(e) {
  if ($r) {
    var t = wa;
    if (t) {
      var n = t;
      if (!qL(e, t)) {
        if (LO(e))
          throw Error(Ve(418));
        t = mu(n.nextSibling);
        var r = Ea;
        t && qL(e, t) ? sz(r, n) : (e.flags = e.flags & -4097 | 2, $r = !1, Ea = e);
      }
    } else {
      if (LO(e))
        throw Error(Ve(418));
      e.flags = e.flags & -4097 | 2, $r = !1, Ea = e;
    }
  }
}
function YL(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; )
    e = e.return;
  Ea = e;
}
function Jy(e) {
  if (e !== Ea)
    return !1;
  if (!$r)
    return YL(e), $r = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !RO(e.type, e.memoizedProps)), t && (t = wa)) {
    if (LO(e))
      throw lz(), Error(Ve(418));
    for (; t; )
      sz(e, t), t = mu(t.nextSibling);
  }
  if (YL(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e)
      throw Error(Ve(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              wa = mu(e.nextSibling);
              break e;
            }
            t--;
          } else
            n !== "$" && n !== "$!" && n !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      wa = null;
    }
  } else
    wa = Ea ? mu(e.stateNode.nextSibling) : null;
  return !0;
}
function lz() {
  for (var e = wa; e; )
    e = mu(e.nextSibling);
}
function Lp() {
  wa = Ea = null, $r = !1;
}
function AA(e) {
  Ds === null ? Ds = [e] : Ds.push(e);
}
var lse = wc.ReactCurrentBatchConfig;
function Ts(e, t) {
  if (e && e.defaultProps) {
    t = Lr({}, t), e = e.defaultProps;
    for (var n in e)
      t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
var r1 = Ru(null), i1 = null, Qd = null, RA = null;
function MA() {
  RA = Qd = i1 = null;
}
function NA(e) {
  var t = r1.current;
  br(r1), e._currentValue = t;
}
function jO(e, t, n) {
  for (; e !== null; ) {
    var r = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n)
      break;
    e = e.return;
  }
}
function gp(e, t) {
  i1 = e, RA = Qd = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (Vo = !0), e.firstContext = null);
}
function ns(e) {
  var t = e._currentValue;
  if (RA !== e)
    if (e = { context: e, memoizedValue: t, next: null }, Qd === null) {
      if (i1 === null)
        throw Error(Ve(308));
      Qd = e, i1.dependencies = { lanes: 0, firstContext: e };
    } else
      Qd = Qd.next = e;
  return t;
}
var vf = null;
function kA(e) {
  vf === null ? vf = [e] : vf.push(e);
}
function cz(e, t, n, r) {
  var i = t.interleaved;
  return i === null ? (n.next = n, kA(t)) : (n.next = i.next, i.next = n), t.interleaved = n, pc(e, r);
}
function pc(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; )
    e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
  return n.tag === 3 ? n.stateNode : null;
}
var Vc = !1;
function LA(e) {
  e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function uz(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
}
function lc(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function gu(e, t, n) {
  var r = e.updateQueue;
  if (r === null)
    return null;
  if (r = r.shared, $n & 2) {
    var i = r.pending;
    return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, pc(e, n);
  }
  return i = r.interleaved, i === null ? (t.next = t, kA(r)) : (t.next = i.next, i.next = t), r.interleaved = t, pc(e, n);
}
function Q0(e, t, n) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, SA(e, n);
  }
}
function XL(e, t) {
  var n = e.updateQueue, r = e.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var i = null, o = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var a = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
        o === null ? i = o = a : o = o.next = a, n = n.next;
      } while (n !== null);
      o === null ? i = o = t : o = o.next = t;
    } else
      i = o = t;
    n = { baseState: r.baseState, firstBaseUpdate: i, lastBaseUpdate: o, shared: r.shared, effects: r.effects }, e.updateQueue = n;
    return;
  }
  e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function o1(e, t, n, r) {
  var i = e.updateQueue;
  Vc = !1;
  var o = i.firstBaseUpdate, a = i.lastBaseUpdate, s = i.shared.pending;
  if (s !== null) {
    i.shared.pending = null;
    var l = s, c = l.next;
    l.next = null, a === null ? o = c : a.next = c, a = l;
    var f = e.alternate;
    f !== null && (f = f.updateQueue, s = f.lastBaseUpdate, s !== a && (s === null ? f.firstBaseUpdate = c : s.next = c, f.lastBaseUpdate = l));
  }
  if (o !== null) {
    var d = i.baseState;
    a = 0, f = c = l = null, s = o;
    do {
      var p = s.lane, g = s.eventTime;
      if ((r & p) === p) {
        f !== null && (f = f.next = {
          eventTime: g,
          lane: 0,
          tag: s.tag,
          payload: s.payload,
          callback: s.callback,
          next: null
        });
        e: {
          var v = e, y = s;
          switch (p = t, g = n, y.tag) {
            case 1:
              if (v = y.payload, typeof v == "function") {
                d = v.call(g, d, p);
                break e;
              }
              d = v;
              break e;
            case 3:
              v.flags = v.flags & -65537 | 128;
            case 0:
              if (v = y.payload, p = typeof v == "function" ? v.call(g, d, p) : v, p == null)
                break e;
              d = Lr({}, d, p);
              break e;
            case 2:
              Vc = !0;
          }
        }
        s.callback !== null && s.lane !== 0 && (e.flags |= 64, p = i.effects, p === null ? i.effects = [s] : p.push(s));
      } else
        g = { eventTime: g, lane: p, tag: s.tag, payload: s.payload, callback: s.callback, next: null }, f === null ? (c = f = g, l = d) : f = f.next = g, a |= p;
      if (s = s.next, s === null) {
        if (s = i.shared.pending, s === null)
          break;
        p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
      }
    } while (!0);
    if (f === null && (l = d), i.baseState = l, i.firstBaseUpdate = c, i.lastBaseUpdate = f, t = i.shared.interleaved, t !== null) {
      i = t;
      do
        a |= i.lane, i = i.next;
      while (i !== t);
    } else
      o === null && (i.shared.lanes = 0);
    Lf |= a, e.lanes = a, e.memoizedState = d;
  }
}
function QL(e, t, n) {
  if (e = t.effects, t.effects = null, e !== null)
    for (t = 0; t < e.length; t++) {
      var r = e[t], i = r.callback;
      if (i !== null) {
        if (r.callback = null, r = n, typeof i != "function")
          throw Error(Ve(191, i));
        i.call(r);
      }
    }
}
var fz = new c8.Component().refs;
function FO(e, t, n, r) {
  t = e.memoizedState, n = n(r, t), n = n == null ? t : Lr({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var Sw = { isMounted: function(e) {
  return (e = e._reactInternals) ? Qf(e) === e : !1;
}, enqueueSetState: function(e, t, n) {
  e = e._reactInternals;
  var r = Oo(), i = yu(e), o = lc(r, i);
  o.payload = t, n != null && (o.callback = n), t = gu(e, o, i), t !== null && (zs(t, e, i, r), Q0(t, e, i));
}, enqueueReplaceState: function(e, t, n) {
  e = e._reactInternals;
  var r = Oo(), i = yu(e), o = lc(r, i);
  o.tag = 1, o.payload = t, n != null && (o.callback = n), t = gu(e, o, i), t !== null && (zs(t, e, i, r), Q0(t, e, i));
}, enqueueForceUpdate: function(e, t) {
  e = e._reactInternals;
  var n = Oo(), r = yu(e), i = lc(n, r);
  i.tag = 2, t != null && (i.callback = t), t = gu(e, i, r), t !== null && (zs(t, e, r, n), Q0(t, e, r));
} };
function JL(e, t, n, r, i, o, a) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, o, a) : t.prototype && t.prototype.isPureReactComponent ? !gg(n, r) || !gg(i, o) : !0;
}
function dz(e, t, n) {
  var r = !1, i = Eu, o = t.contextType;
  return typeof o == "object" && o !== null ? o = ns(o) : (i = qo(t) ? Mf : mo.current, r = t.contextTypes, o = (r = r != null) ? kp(e, i) : Eu), t = new t(n, o), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = Sw, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = o), t;
}
function ZL(e, t, n, r) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Sw.enqueueReplaceState(t, t.state, null);
}
function BO(e, t, n, r) {
  var i = e.stateNode;
  i.props = n, i.state = e.memoizedState, i.refs = fz, LA(e);
  var o = t.contextType;
  typeof o == "object" && o !== null ? i.context = ns(o) : (o = qo(t) ? Mf : mo.current, i.context = kp(e, o)), i.state = e.memoizedState, o = t.getDerivedStateFromProps, typeof o == "function" && (FO(e, t, o, n), i.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof i.getSnapshotBeforeUpdate == "function" || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (t = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), t !== i.state && Sw.enqueueReplaceState(i, i.state, null), o1(e, n, i, r), i.state = e.memoizedState), typeof i.componentDidMount == "function" && (e.flags |= 4194308);
}
function pm(e, t, n) {
  if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1)
          throw Error(Ve(309));
        var r = n.stateNode;
      }
      if (!r)
        throw Error(Ve(147, e));
      var i = r, o = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === o ? t.ref : (t = function(a) {
        var s = i.refs;
        s === fz && (s = i.refs = {}), a === null ? delete s[o] : s[o] = a;
      }, t._stringRef = o, t);
    }
    if (typeof e != "string")
      throw Error(Ve(284));
    if (!n._owner)
      throw Error(Ve(290, e));
  }
  return e;
}
function Zy(e, t) {
  throw e = Object.prototype.toString.call(t), Error(Ve(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function e3(e) {
  var t = e._init;
  return t(e._payload);
}
function pz(e) {
  function t(b, w) {
    if (e) {
      var S = b.deletions;
      S === null ? (b.deletions = [w], b.flags |= 16) : S.push(w);
    }
  }
  function n(b, w) {
    if (!e)
      return null;
    for (; w !== null; )
      t(b, w), w = w.sibling;
    return null;
  }
  function r(b, w) {
    for (b = /* @__PURE__ */ new Map(); w !== null; )
      w.key !== null ? b.set(w.key, w) : b.set(w.index, w), w = w.sibling;
    return b;
  }
  function i(b, w) {
    return b = bu(b, w), b.index = 0, b.sibling = null, b;
  }
  function o(b, w, S) {
    return b.index = S, e ? (S = b.alternate, S !== null ? (S = S.index, S < w ? (b.flags |= 2, w) : S) : (b.flags |= 2, w)) : (b.flags |= 1048576, w);
  }
  function a(b) {
    return e && b.alternate === null && (b.flags |= 2), b;
  }
  function s(b, w, S, E) {
    return w === null || w.tag !== 6 ? (w = i$(S, b.mode, E), w.return = b, w) : (w = i(w, S), w.return = b, w);
  }
  function l(b, w, S, E) {
    var O = S.type;
    return O === Hd ? f(b, w, S.props.children, E, S.key) : w !== null && (w.elementType === O || typeof O == "object" && O !== null && O.$$typeof === Wc && e3(O) === w.type) ? (E = i(w, S.props), E.ref = pm(b, w, S), E.return = b, E) : (E = rb(S.type, S.key, S.props, null, b.mode, E), E.ref = pm(b, w, S), E.return = b, E);
  }
  function c(b, w, S, E) {
    return w === null || w.tag !== 4 || w.stateNode.containerInfo !== S.containerInfo || w.stateNode.implementation !== S.implementation ? (w = o$(S, b.mode, E), w.return = b, w) : (w = i(w, S.children || []), w.return = b, w);
  }
  function f(b, w, S, E, O) {
    return w === null || w.tag !== 7 ? (w = Pf(S, b.mode, E, O), w.return = b, w) : (w = i(w, S), w.return = b, w);
  }
  function d(b, w, S) {
    if (typeof w == "string" && w !== "" || typeof w == "number")
      return w = i$("" + w, b.mode, S), w.return = b, w;
    if (typeof w == "object" && w !== null) {
      switch (w.$$typeof) {
        case Uy:
          return S = rb(w.type, w.key, w.props, null, b.mode, S), S.ref = pm(b, null, w), S.return = b, S;
        case Ud:
          return w = o$(w, b.mode, S), w.return = b, w;
        case Wc:
          var E = w._init;
          return d(b, E(w._payload), S);
      }
      if (Am(w) || lm(w))
        return w = Pf(w, b.mode, S, null), w.return = b, w;
      Zy(b, w);
    }
    return null;
  }
  function p(b, w, S, E) {
    var O = w !== null ? w.key : null;
    if (typeof S == "string" && S !== "" || typeof S == "number")
      return O !== null ? null : s(b, w, "" + S, E);
    if (typeof S == "object" && S !== null) {
      switch (S.$$typeof) {
        case Uy:
          return S.key === O ? l(b, w, S, E) : null;
        case Ud:
          return S.key === O ? c(b, w, S, E) : null;
        case Wc:
          return O = S._init, p(
            b,
            w,
            O(S._payload),
            E
          );
      }
      if (Am(S) || lm(S))
        return O !== null ? null : f(b, w, S, E, null);
      Zy(b, S);
    }
    return null;
  }
  function g(b, w, S, E, O) {
    if (typeof E == "string" && E !== "" || typeof E == "number")
      return b = b.get(S) || null, s(w, b, "" + E, O);
    if (typeof E == "object" && E !== null) {
      switch (E.$$typeof) {
        case Uy:
          return b = b.get(E.key === null ? S : E.key) || null, l(w, b, E, O);
        case Ud:
          return b = b.get(E.key === null ? S : E.key) || null, c(w, b, E, O);
        case Wc:
          var $ = E._init;
          return g(b, w, S, $(E._payload), O);
      }
      if (Am(E) || lm(E))
        return b = b.get(S) || null, f(w, b, E, O, null);
      Zy(w, E);
    }
    return null;
  }
  function v(b, w, S, E) {
    for (var O = null, $ = null, P = w, R = w = 0, L = null; P !== null && R < S.length; R++) {
      P.index > R ? (L = P, P = null) : L = P.sibling;
      var B = p(b, P, S[R], E);
      if (B === null) {
        P === null && (P = L);
        break;
      }
      e && P && B.alternate === null && t(b, P), w = o(B, w, R), $ === null ? O = B : $.sibling = B, $ = B, P = L;
    }
    if (R === S.length)
      return n(b, P), $r && Qu(b, R), O;
    if (P === null) {
      for (; R < S.length; R++)
        P = d(b, S[R], E), P !== null && (w = o(P, w, R), $ === null ? O = P : $.sibling = P, $ = P);
      return $r && Qu(b, R), O;
    }
    for (P = r(b, P); R < S.length; R++)
      L = g(P, b, R, S[R], E), L !== null && (e && L.alternate !== null && P.delete(L.key === null ? R : L.key), w = o(L, w, R), $ === null ? O = L : $.sibling = L, $ = L);
    return e && P.forEach(function(j) {
      return t(b, j);
    }), $r && Qu(b, R), O;
  }
  function y(b, w, S, E) {
    var O = lm(S);
    if (typeof O != "function")
      throw Error(Ve(150));
    if (S = O.call(S), S == null)
      throw Error(Ve(151));
    for (var $ = O = null, P = w, R = w = 0, L = null, B = S.next(); P !== null && !B.done; R++, B = S.next()) {
      P.index > R ? (L = P, P = null) : L = P.sibling;
      var j = p(b, P, B.value, E);
      if (j === null) {
        P === null && (P = L);
        break;
      }
      e && P && j.alternate === null && t(b, P), w = o(j, w, R), $ === null ? O = j : $.sibling = j, $ = j, P = L;
    }
    if (B.done)
      return n(
        b,
        P
      ), $r && Qu(b, R), O;
    if (P === null) {
      for (; !B.done; R++, B = S.next())
        B = d(b, B.value, E), B !== null && (w = o(B, w, R), $ === null ? O = B : $.sibling = B, $ = B);
      return $r && Qu(b, R), O;
    }
    for (P = r(b, P); !B.done; R++, B = S.next())
      B = g(P, b, R, B.value, E), B !== null && (e && B.alternate !== null && P.delete(B.key === null ? R : B.key), w = o(B, w, R), $ === null ? O = B : $.sibling = B, $ = B);
    return e && P.forEach(function(A) {
      return t(b, A);
    }), $r && Qu(b, R), O;
  }
  function x(b, w, S, E) {
    if (typeof S == "object" && S !== null && S.type === Hd && S.key === null && (S = S.props.children), typeof S == "object" && S !== null) {
      switch (S.$$typeof) {
        case Uy:
          e: {
            for (var O = S.key, $ = w; $ !== null; ) {
              if ($.key === O) {
                if (O = S.type, O === Hd) {
                  if ($.tag === 7) {
                    n(b, $.sibling), w = i($, S.props.children), w.return = b, b = w;
                    break e;
                  }
                } else if ($.elementType === O || typeof O == "object" && O !== null && O.$$typeof === Wc && e3(O) === $.type) {
                  n(b, $.sibling), w = i($, S.props), w.ref = pm(b, $, S), w.return = b, b = w;
                  break e;
                }
                n(b, $);
                break;
              } else
                t(b, $);
              $ = $.sibling;
            }
            S.type === Hd ? (w = Pf(S.props.children, b.mode, E, S.key), w.return = b, b = w) : (E = rb(S.type, S.key, S.props, null, b.mode, E), E.ref = pm(b, w, S), E.return = b, b = E);
          }
          return a(b);
        case Ud:
          e: {
            for ($ = S.key; w !== null; ) {
              if (w.key === $)
                if (w.tag === 4 && w.stateNode.containerInfo === S.containerInfo && w.stateNode.implementation === S.implementation) {
                  n(b, w.sibling), w = i(w, S.children || []), w.return = b, b = w;
                  break e;
                } else {
                  n(b, w);
                  break;
                }
              else
                t(b, w);
              w = w.sibling;
            }
            w = o$(S, b.mode, E), w.return = b, b = w;
          }
          return a(b);
        case Wc:
          return $ = S._init, x(b, w, $(S._payload), E);
      }
      if (Am(S))
        return v(b, w, S, E);
      if (lm(S))
        return y(b, w, S, E);
      Zy(b, S);
    }
    return typeof S == "string" && S !== "" || typeof S == "number" ? (S = "" + S, w !== null && w.tag === 6 ? (n(b, w.sibling), w = i(w, S), w.return = b, b = w) : (n(b, w), w = i$(S, b.mode, E), w.return = b, b = w), a(b)) : n(b, w);
  }
  return x;
}
var Dp = pz(!0), hz = pz(!1), rv = {}, Pl = Ru(rv), wg = Ru(rv), Sg = Ru(rv);
function yf(e) {
  if (e === rv)
    throw Error(Ve(174));
  return e;
}
function DA(e, t) {
  switch (cr(Sg, t), cr(wg, e), cr(Pl, rv), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : yO(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = yO(t, e);
  }
  br(Pl), cr(Pl, t);
}
function jp() {
  br(Pl), br(wg), br(Sg);
}
function mz(e) {
  yf(Sg.current);
  var t = yf(Pl.current), n = yO(t, e.type);
  t !== n && (cr(wg, e), cr(Pl, n));
}
function jA(e) {
  wg.current === e && (br(Pl), br(wg));
}
var Rr = Ru(0);
function a1(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!"))
        return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128)
        return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e)
      break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e)
        return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var JE = [];
function FA() {
  for (var e = 0; e < JE.length; e++)
    JE[e]._workInProgressVersionPrimary = null;
  JE.length = 0;
}
var J0 = wc.ReactCurrentDispatcher, ZE = wc.ReactCurrentBatchConfig, kf = 0, kr = null, di = null, Ei = null, s1 = !1, Km = !1, xg = 0, cse = 0;
function io() {
  throw Error(Ve(321));
}
function BA(e, t) {
  if (t === null)
    return !1;
  for (var n = 0; n < t.length && n < e.length; n++)
    if (!Ks(e[n], t[n]))
      return !1;
  return !0;
}
function zA(e, t, n, r, i, o) {
  if (kf = o, kr = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, J0.current = e === null || e.memoizedState === null ? pse : hse, e = n(r, i), Km) {
    o = 0;
    do {
      if (Km = !1, xg = 0, 25 <= o)
        throw Error(Ve(301));
      o += 1, Ei = di = null, t.updateQueue = null, J0.current = mse, e = n(r, i);
    } while (Km);
  }
  if (J0.current = l1, t = di !== null && di.next !== null, kf = 0, Ei = di = kr = null, s1 = !1, t)
    throw Error(Ve(300));
  return e;
}
function UA() {
  var e = xg !== 0;
  return xg = 0, e;
}
function dl() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return Ei === null ? kr.memoizedState = Ei = e : Ei = Ei.next = e, Ei;
}
function rs() {
  if (di === null) {
    var e = kr.alternate;
    e = e !== null ? e.memoizedState : null;
  } else
    e = di.next;
  var t = Ei === null ? kr.memoizedState : Ei.next;
  if (t !== null)
    Ei = t, di = e;
  else {
    if (e === null)
      throw Error(Ve(310));
    di = e, e = { memoizedState: di.memoizedState, baseState: di.baseState, baseQueue: di.baseQueue, queue: di.queue, next: null }, Ei === null ? kr.memoizedState = Ei = e : Ei = Ei.next = e;
  }
  return Ei;
}
function Cg(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function e$(e) {
  var t = rs(), n = t.queue;
  if (n === null)
    throw Error(Ve(311));
  n.lastRenderedReducer = e;
  var r = di, i = r.baseQueue, o = n.pending;
  if (o !== null) {
    if (i !== null) {
      var a = i.next;
      i.next = o.next, o.next = a;
    }
    r.baseQueue = i = o, n.pending = null;
  }
  if (i !== null) {
    o = i.next, r = r.baseState;
    var s = a = null, l = null, c = o;
    do {
      var f = c.lane;
      if ((kf & f) === f)
        l !== null && (l = l.next = { lane: 0, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }), r = c.hasEagerState ? c.eagerState : e(r, c.action);
      else {
        var d = {
          lane: f,
          action: c.action,
          hasEagerState: c.hasEagerState,
          eagerState: c.eagerState,
          next: null
        };
        l === null ? (s = l = d, a = r) : l = l.next = d, kr.lanes |= f, Lf |= f;
      }
      c = c.next;
    } while (c !== null && c !== o);
    l === null ? a = r : l.next = s, Ks(r, t.memoizedState) || (Vo = !0), t.memoizedState = r, t.baseState = a, t.baseQueue = l, n.lastRenderedState = r;
  }
  if (e = n.interleaved, e !== null) {
    i = e;
    do
      o = i.lane, kr.lanes |= o, Lf |= o, i = i.next;
    while (i !== e);
  } else
    i === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function t$(e) {
  var t = rs(), n = t.queue;
  if (n === null)
    throw Error(Ve(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch, i = n.pending, o = t.memoizedState;
  if (i !== null) {
    n.pending = null;
    var a = i = i.next;
    do
      o = e(o, a.action), a = a.next;
    while (a !== i);
    Ks(o, t.memoizedState) || (Vo = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
  }
  return [o, r];
}
function gz() {
}
function vz(e, t) {
  var n = kr, r = rs(), i = t(), o = !Ks(r.memoizedState, i);
  if (o && (r.memoizedState = i, Vo = !0), r = r.queue, HA(wz.bind(null, n, r, e), [e]), r.getSnapshot !== t || o || Ei !== null && Ei.memoizedState.tag & 1) {
    if (n.flags |= 2048, Eg(9, bz.bind(null, n, r, i, t), void 0, null), _i === null)
      throw Error(Ve(349));
    kf & 30 || yz(n, t, i);
  }
  return i;
}
function yz(e, t, n) {
  e.flags |= 16384, e = { getSnapshot: t, value: n }, t = kr.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, kr.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
}
function bz(e, t, n, r) {
  t.value = n, t.getSnapshot = r, Sz(t) && xz(e);
}
function wz(e, t, n) {
  return n(function() {
    Sz(t) && xz(e);
  });
}
function Sz(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Ks(e, n);
  } catch {
    return !0;
  }
}
function xz(e) {
  var t = pc(e, 1);
  t !== null && zs(t, e, 1, -1);
}
function t3(e) {
  var t = dl();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Cg, lastRenderedState: e }, t.queue = e, e = e.dispatch = dse.bind(null, kr, e), [t.memoizedState, e];
}
function Eg(e, t, n, r) {
  return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = kr.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, kr.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function Cz() {
  return rs().memoizedState;
}
function Z0(e, t, n, r) {
  var i = dl();
  kr.flags |= e, i.memoizedState = Eg(1 | t, n, void 0, r === void 0 ? null : r);
}
function xw(e, t, n, r) {
  var i = rs();
  r = r === void 0 ? null : r;
  var o = void 0;
  if (di !== null) {
    var a = di.memoizedState;
    if (o = a.destroy, r !== null && BA(r, a.deps)) {
      i.memoizedState = Eg(t, n, o, r);
      return;
    }
  }
  kr.flags |= e, i.memoizedState = Eg(1 | t, n, o, r);
}
function n3(e, t) {
  return Z0(8390656, 8, e, t);
}
function HA(e, t) {
  return xw(2048, 8, e, t);
}
function Ez(e, t) {
  return xw(4, 2, e, t);
}
function $z(e, t) {
  return xw(4, 4, e, t);
}
function _z(e, t) {
  if (typeof t == "function")
    return e = e(), t(e), function() {
      t(null);
    };
  if (t != null)
    return e = e(), t.current = e, function() {
      t.current = null;
    };
}
function Oz(e, t, n) {
  return n = n != null ? n.concat([e]) : null, xw(4, 4, _z.bind(null, t, e), n);
}
function WA() {
}
function Pz(e, t) {
  var n = rs();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && BA(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function Tz(e, t) {
  var n = rs();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && BA(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function Iz(e, t, n) {
  return kf & 21 ? (Ks(n, t) || (n = M8(), kr.lanes |= n, Lf |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, Vo = !0), e.memoizedState = n);
}
function use(e, t) {
  var n = Fn;
  Fn = n !== 0 && 4 > n ? n : 4, e(!0);
  var r = ZE.transition;
  ZE.transition = {};
  try {
    e(!1), t();
  } finally {
    Fn = n, ZE.transition = r;
  }
}
function Az() {
  return rs().memoizedState;
}
function fse(e, t, n) {
  var r = yu(e);
  if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, Rz(e))
    Mz(t, n);
  else if (n = cz(e, t, n, r), n !== null) {
    var i = Oo();
    zs(n, e, r, i), Nz(n, t, r);
  }
}
function dse(e, t, n) {
  var r = yu(e), i = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (Rz(e))
    Mz(t, i);
  else {
    var o = e.alternate;
    if (e.lanes === 0 && (o === null || o.lanes === 0) && (o = t.lastRenderedReducer, o !== null))
      try {
        var a = t.lastRenderedState, s = o(a, n);
        if (i.hasEagerState = !0, i.eagerState = s, Ks(s, a)) {
          var l = t.interleaved;
          l === null ? (i.next = i, kA(t)) : (i.next = l.next, l.next = i), t.interleaved = i;
          return;
        }
      } catch {
      } finally {
      }
    n = cz(e, t, i, r), n !== null && (i = Oo(), zs(n, e, r, i), Nz(n, t, r));
  }
}
function Rz(e) {
  var t = e.alternate;
  return e === kr || t !== null && t === kr;
}
function Mz(e, t) {
  Km = s1 = !0;
  var n = e.pending;
  n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function Nz(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, SA(e, n);
  }
}
var l1 = { readContext: ns, useCallback: io, useContext: io, useEffect: io, useImperativeHandle: io, useInsertionEffect: io, useLayoutEffect: io, useMemo: io, useReducer: io, useRef: io, useState: io, useDebugValue: io, useDeferredValue: io, useTransition: io, useMutableSource: io, useSyncExternalStore: io, useId: io, unstable_isNewReconciler: !1 }, pse = { readContext: ns, useCallback: function(e, t) {
  return dl().memoizedState = [e, t === void 0 ? null : t], e;
}, useContext: ns, useEffect: n3, useImperativeHandle: function(e, t, n) {
  return n = n != null ? n.concat([e]) : null, Z0(
    4194308,
    4,
    _z.bind(null, t, e),
    n
  );
}, useLayoutEffect: function(e, t) {
  return Z0(4194308, 4, e, t);
}, useInsertionEffect: function(e, t) {
  return Z0(4, 2, e, t);
}, useMemo: function(e, t) {
  var n = dl();
  return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
}, useReducer: function(e, t, n) {
  var r = dl();
  return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = fse.bind(null, kr, e), [r.memoizedState, e];
}, useRef: function(e) {
  var t = dl();
  return e = { current: e }, t.memoizedState = e;
}, useState: t3, useDebugValue: WA, useDeferredValue: function(e) {
  return dl().memoizedState = e;
}, useTransition: function() {
  var e = t3(!1), t = e[0];
  return e = use.bind(null, e[1]), dl().memoizedState = e, [t, e];
}, useMutableSource: function() {
}, useSyncExternalStore: function(e, t, n) {
  var r = kr, i = dl();
  if ($r) {
    if (n === void 0)
      throw Error(Ve(407));
    n = n();
  } else {
    if (n = t(), _i === null)
      throw Error(Ve(349));
    kf & 30 || yz(r, t, n);
  }
  i.memoizedState = n;
  var o = { value: n, getSnapshot: t };
  return i.queue = o, n3(wz.bind(
    null,
    r,
    o,
    e
  ), [e]), r.flags |= 2048, Eg(9, bz.bind(null, r, o, n, t), void 0, null), n;
}, useId: function() {
  var e = dl(), t = _i.identifierPrefix;
  if ($r) {
    var n = sc, r = ac;
    n = (r & ~(1 << 32 - Bs(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = xg++, 0 < n && (t += "H" + n.toString(32)), t += ":";
  } else
    n = cse++, t = ":" + t + "r" + n.toString(32) + ":";
  return e.memoizedState = t;
}, unstable_isNewReconciler: !1 }, hse = {
  readContext: ns,
  useCallback: Pz,
  useContext: ns,
  useEffect: HA,
  useImperativeHandle: Oz,
  useInsertionEffect: Ez,
  useLayoutEffect: $z,
  useMemo: Tz,
  useReducer: e$,
  useRef: Cz,
  useState: function() {
    return e$(Cg);
  },
  useDebugValue: WA,
  useDeferredValue: function(e) {
    var t = rs();
    return Iz(t, di.memoizedState, e);
  },
  useTransition: function() {
    var e = e$(Cg)[0], t = rs().memoizedState;
    return [e, t];
  },
  useMutableSource: gz,
  useSyncExternalStore: vz,
  useId: Az,
  unstable_isNewReconciler: !1
}, mse = { readContext: ns, useCallback: Pz, useContext: ns, useEffect: HA, useImperativeHandle: Oz, useInsertionEffect: Ez, useLayoutEffect: $z, useMemo: Tz, useReducer: t$, useRef: Cz, useState: function() {
  return t$(Cg);
}, useDebugValue: WA, useDeferredValue: function(e) {
  var t = rs();
  return di === null ? t.memoizedState = e : Iz(t, di.memoizedState, e);
}, useTransition: function() {
  var e = t$(Cg)[0], t = rs().memoizedState;
  return [e, t];
}, useMutableSource: gz, useSyncExternalStore: vz, useId: Az, unstable_isNewReconciler: !1 };
function Fp(e, t) {
  try {
    var n = "", r = t;
    do
      n += Hoe(r), r = r.return;
    while (r);
    var i = n;
  } catch (o) {
    i = `
Error generating stack: ` + o.message + `
` + o.stack;
  }
  return { value: e, source: t, stack: i, digest: null };
}
function n$(e, t, n) {
  return { value: e, source: null, stack: n ?? null, digest: t ?? null };
}
function zO(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function() {
      throw n;
    });
  }
}
var gse = typeof WeakMap == "function" ? WeakMap : Map;
function kz(e, t, n) {
  n = lc(-1, n), n.tag = 3, n.payload = { element: null };
  var r = t.value;
  return n.callback = function() {
    u1 || (u1 = !0, QO = r), zO(e, t);
  }, n;
}
function Lz(e, t, n) {
  n = lc(-1, n), n.tag = 3;
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var i = t.value;
    n.payload = function() {
      return r(i);
    }, n.callback = function() {
      zO(e, t);
    };
  }
  var o = e.stateNode;
  return o !== null && typeof o.componentDidCatch == "function" && (n.callback = function() {
    zO(e, t), typeof r != "function" && (vu === null ? vu = /* @__PURE__ */ new Set([this]) : vu.add(this));
    var a = t.stack;
    this.componentDidCatch(t.value, { componentStack: a !== null ? a : "" });
  }), n;
}
function r3(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new gse();
    var i = /* @__PURE__ */ new Set();
    r.set(t, i);
  } else
    i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
  i.has(n) || (i.add(n), e = Ise.bind(null, e, t, n), t.then(e, e));
}
function i3(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t)
      return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function o3(e, t, n, r, i) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = i, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = lc(-1, 1), t.tag = 2, gu(n, t, 1))), n.lanes |= 1), e);
}
var vse = wc.ReactCurrentOwner, Vo = !1;
function xo(e, t, n, r) {
  t.child = e === null ? hz(t, null, n, r) : Dp(t, e.child, n, r);
}
function a3(e, t, n, r, i) {
  n = n.render;
  var o = t.ref;
  return gp(t, i), r = zA(e, t, n, r, o, i), n = UA(), e !== null && !Vo ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, hc(e, t, i)) : ($r && n && TA(t), t.flags |= 1, xo(e, t, r, i), t.child);
}
function s3(e, t, n, r, i) {
  if (e === null) {
    var o = n.type;
    return typeof o == "function" && !JA(o) && o.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = o, Dz(e, t, o, r, i)) : (e = rb(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (o = e.child, !(e.lanes & i)) {
    var a = o.memoizedProps;
    if (n = n.compare, n = n !== null ? n : gg, n(a, r) && e.ref === t.ref)
      return hc(e, t, i);
  }
  return t.flags |= 1, e = bu(o, r), e.ref = t.ref, e.return = t, t.child = e;
}
function Dz(e, t, n, r, i) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (gg(o, r) && e.ref === t.ref)
      if (Vo = !1, t.pendingProps = r = o, (e.lanes & i) !== 0)
        e.flags & 131072 && (Vo = !0);
      else
        return t.lanes = e.lanes, hc(e, t, i);
  }
  return UO(e, t, n, r, i);
}
function jz(e, t, n) {
  var r = t.pendingProps, i = r.children, o = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden")
    if (!(t.mode & 1))
      t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, cr(Zd, va), va |= n;
    else {
      if (!(n & 1073741824))
        return e = o !== null ? o.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, cr(Zd, va), va |= e, null;
      t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = o !== null ? o.baseLanes : n, cr(Zd, va), va |= r;
    }
  else
    o !== null ? (r = o.baseLanes | n, t.memoizedState = null) : r = n, cr(Zd, va), va |= r;
  return xo(e, t, i, n), t.child;
}
function Fz(e, t) {
  var n = t.ref;
  (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function UO(e, t, n, r, i) {
  var o = qo(n) ? Mf : mo.current;
  return o = kp(t, o), gp(t, i), n = zA(e, t, n, r, o, i), r = UA(), e !== null && !Vo ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~i, hc(e, t, i)) : ($r && r && TA(t), t.flags |= 1, xo(e, t, n, i), t.child);
}
function l3(e, t, n, r, i) {
  if (qo(n)) {
    var o = !0;
    e1(t);
  } else
    o = !1;
  if (gp(t, i), t.stateNode === null)
    eb(e, t), dz(t, n, r), BO(t, n, r, i), r = !0;
  else if (e === null) {
    var a = t.stateNode, s = t.memoizedProps;
    a.props = s;
    var l = a.context, c = n.contextType;
    typeof c == "object" && c !== null ? c = ns(c) : (c = qo(n) ? Mf : mo.current, c = kp(t, c));
    var f = n.getDerivedStateFromProps, d = typeof f == "function" || typeof a.getSnapshotBeforeUpdate == "function";
    d || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s !== r || l !== c) && ZL(t, a, r, c), Vc = !1;
    var p = t.memoizedState;
    a.state = p, o1(t, r, a, i), l = t.memoizedState, s !== r || p !== l || Ko.current || Vc ? (typeof f == "function" && (FO(t, n, f, r), l = t.memoizedState), (s = Vc || JL(t, n, s, r, p, l, c)) ? (d || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = c, r = s) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
  } else {
    a = t.stateNode, uz(e, t), s = t.memoizedProps, c = t.type === t.elementType ? s : Ts(t.type, s), a.props = c, d = t.pendingProps, p = a.context, l = n.contextType, typeof l == "object" && l !== null ? l = ns(l) : (l = qo(n) ? Mf : mo.current, l = kp(t, l));
    var g = n.getDerivedStateFromProps;
    (f = typeof g == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s !== d || p !== l) && ZL(t, a, r, l), Vc = !1, p = t.memoizedState, a.state = p, o1(t, r, a, i);
    var v = t.memoizedState;
    s !== d || p !== v || Ko.current || Vc ? (typeof g == "function" && (FO(t, n, g, r), v = t.memoizedState), (c = Vc || JL(t, n, c, r, p, v, l) || !1) ? (f || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, v, l), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, v, l)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = v), a.props = r, a.state = v, a.context = l, r = c) : (typeof a.componentDidUpdate != "function" || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), r = !1);
  }
  return HO(e, t, n, r, o, i);
}
function HO(e, t, n, r, i, o) {
  Fz(e, t);
  var a = (t.flags & 128) !== 0;
  if (!r && !a)
    return i && KL(t, n, !1), hc(e, t, o);
  r = t.stateNode, vse.current = t;
  var s = a && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return t.flags |= 1, e !== null && a ? (t.child = Dp(t, e.child, null, o), t.child = Dp(t, null, s, o)) : xo(e, t, s, o), t.memoizedState = r.state, i && KL(t, n, !0), t.child;
}
function Bz(e) {
  var t = e.stateNode;
  t.pendingContext ? GL(e, t.pendingContext, t.pendingContext !== t.context) : t.context && GL(e, t.context, !1), DA(e, t.containerInfo);
}
function c3(e, t, n, r, i) {
  return Lp(), AA(i), t.flags |= 256, xo(e, t, n, r), t.child;
}
var WO = { dehydrated: null, treeContext: null, retryLane: 0 };
function VO(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function zz(e, t, n) {
  var r = t.pendingProps, i = Rr.current, o = !1, a = (t.flags & 128) !== 0, s;
  if ((s = a) || (s = e !== null && e.memoizedState === null ? !1 : (i & 2) !== 0), s ? (o = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (i |= 1), cr(Rr, i & 1), e === null)
    return DO(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (a = r.children, e = r.fallback, o ? (r = t.mode, o = t.child, a = { mode: "hidden", children: a }, !(r & 1) && o !== null ? (o.childLanes = 0, o.pendingProps = a) : o = $w(a, r, 0, null), e = Pf(e, r, n, null), o.return = t, e.return = t, o.sibling = e, t.child = o, t.child.memoizedState = VO(n), t.memoizedState = WO, e) : VA(t, a));
  if (i = e.memoizedState, i !== null && (s = i.dehydrated, s !== null))
    return yse(e, t, a, r, s, i, n);
  if (o) {
    o = r.fallback, a = t.mode, i = e.child, s = i.sibling;
    var l = { mode: "hidden", children: r.children };
    return !(a & 1) && t.child !== i ? (r = t.child, r.childLanes = 0, r.pendingProps = l, t.deletions = null) : (r = bu(i, l), r.subtreeFlags = i.subtreeFlags & 14680064), s !== null ? o = bu(s, o) : (o = Pf(o, a, n, null), o.flags |= 2), o.return = t, r.return = t, r.sibling = o, t.child = r, r = o, o = t.child, a = e.child.memoizedState, a = a === null ? VO(n) : { baseLanes: a.baseLanes | n, cachePool: null, transitions: a.transitions }, o.memoizedState = a, o.childLanes = e.childLanes & ~n, t.memoizedState = WO, r;
  }
  return o = e.child, e = o.sibling, r = bu(o, { mode: "visible", children: r.children }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function VA(e, t) {
  return t = $w({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
}
function e0(e, t, n, r) {
  return r !== null && AA(r), Dp(t, e.child, null, n), e = VA(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function yse(e, t, n, r, i, o, a) {
  if (n)
    return t.flags & 256 ? (t.flags &= -257, r = n$(Error(Ve(422))), e0(e, t, a, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (o = r.fallback, i = t.mode, r = $w({ mode: "visible", children: r.children }, i, 0, null), o = Pf(o, i, a, null), o.flags |= 2, r.return = t, o.return = t, r.sibling = o, t.child = r, t.mode & 1 && Dp(t, e.child, null, a), t.child.memoizedState = VO(a), t.memoizedState = WO, o);
  if (!(t.mode & 1))
    return e0(e, t, a, null);
  if (i.data === "$!") {
    if (r = i.nextSibling && i.nextSibling.dataset, r)
      var s = r.dgst;
    return r = s, o = Error(Ve(419)), r = n$(o, r, void 0), e0(e, t, a, r);
  }
  if (s = (a & e.childLanes) !== 0, Vo || s) {
    if (r = _i, r !== null) {
      switch (a & -a) {
        case 4:
          i = 2;
          break;
        case 16:
          i = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          i = 32;
          break;
        case 536870912:
          i = 268435456;
          break;
        default:
          i = 0;
      }
      i = i & (r.suspendedLanes | a) ? 0 : i, i !== 0 && i !== o.retryLane && (o.retryLane = i, pc(e, i), zs(r, e, i, -1));
    }
    return QA(), r = n$(Error(Ve(421))), e0(e, t, a, r);
  }
  return i.data === "$?" ? (t.flags |= 128, t.child = e.child, t = Ase.bind(null, e), i._reactRetry = t, null) : (e = o.treeContext, wa = mu(i.nextSibling), Ea = t, $r = !0, Ds = null, e !== null && (Va[Ga++] = ac, Va[Ga++] = sc, Va[Ga++] = Nf, ac = e.id, sc = e.overflow, Nf = t), t = VA(t, r.children), t.flags |= 4096, t);
}
function u3(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  r !== null && (r.lanes |= t), jO(e.return, t, n);
}
function r$(e, t, n, r, i) {
  var o = e.memoizedState;
  o === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: i } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i);
}
function Uz(e, t, n) {
  var r = t.pendingProps, i = r.revealOrder, o = r.tail;
  if (xo(e, t, r.children, n), r = Rr.current, r & 2)
    r = r & 1 | 2, t.flags |= 128;
  else {
    if (e !== null && e.flags & 128)
      e:
        for (e = t.child; e !== null; ) {
          if (e.tag === 13)
            e.memoizedState !== null && u3(e, n, t);
          else if (e.tag === 19)
            u3(e, n, t);
          else if (e.child !== null) {
            e.child.return = e, e = e.child;
            continue;
          }
          if (e === t)
            break e;
          for (; e.sibling === null; ) {
            if (e.return === null || e.return === t)
              break e;
            e = e.return;
          }
          e.sibling.return = e.return, e = e.sibling;
        }
    r &= 1;
  }
  if (cr(Rr, r), !(t.mode & 1))
    t.memoizedState = null;
  else
    switch (i) {
      case "forwards":
        for (n = t.child, i = null; n !== null; )
          e = n.alternate, e !== null && a1(e) === null && (i = n), n = n.sibling;
        n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), r$(t, !1, i, n, o);
        break;
      case "backwards":
        for (n = null, i = t.child, t.child = null; i !== null; ) {
          if (e = i.alternate, e !== null && a1(e) === null) {
            t.child = i;
            break;
          }
          e = i.sibling, i.sibling = n, n = i, i = e;
        }
        r$(t, !0, n, null, o);
        break;
      case "together":
        r$(t, !1, null, null, void 0);
        break;
      default:
        t.memoizedState = null;
    }
  return t.child;
}
function eb(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function hc(e, t, n) {
  if (e !== null && (t.dependencies = e.dependencies), Lf |= t.lanes, !(n & t.childLanes))
    return null;
  if (e !== null && t.child !== e.child)
    throw Error(Ve(153));
  if (t.child !== null) {
    for (e = t.child, n = bu(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; )
      e = e.sibling, n = n.sibling = bu(e, e.pendingProps), n.return = t;
    n.sibling = null;
  }
  return t.child;
}
function bse(e, t, n) {
  switch (t.tag) {
    case 3:
      Bz(t), Lp();
      break;
    case 5:
      mz(t);
      break;
    case 1:
      qo(t.type) && e1(t);
      break;
    case 4:
      DA(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context, i = t.memoizedProps.value;
      cr(r1, r._currentValue), r._currentValue = i;
      break;
    case 13:
      if (r = t.memoizedState, r !== null)
        return r.dehydrated !== null ? (cr(Rr, Rr.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? zz(e, t, n) : (cr(Rr, Rr.current & 1), e = hc(e, t, n), e !== null ? e.sibling : null);
      cr(Rr, Rr.current & 1);
      break;
    case 19:
      if (r = (n & t.childLanes) !== 0, e.flags & 128) {
        if (r)
          return Uz(e, t, n);
        t.flags |= 128;
      }
      if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), cr(Rr, Rr.current), r)
        break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, jz(e, t, n);
  }
  return hc(e, t, n);
}
var Hz, GO, Wz, Vz;
Hz = function(e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6)
      e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t)
      break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t)
        return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
};
GO = function() {
};
Wz = function(e, t, n, r) {
  var i = e.memoizedProps;
  if (i !== r) {
    e = t.stateNode, yf(Pl.current);
    var o = null;
    switch (n) {
      case "input":
        i = hO(e, i), r = hO(e, r), o = [];
        break;
      case "select":
        i = Lr({}, i, { value: void 0 }), r = Lr({}, r, { value: void 0 }), o = [];
        break;
      case "textarea":
        i = vO(e, i), r = vO(e, r), o = [];
        break;
      default:
        typeof i.onClick != "function" && typeof r.onClick == "function" && (e.onclick = Jb);
    }
    bO(n, r);
    var a;
    n = null;
    for (c in i)
      if (!r.hasOwnProperty(c) && i.hasOwnProperty(c) && i[c] != null)
        if (c === "style") {
          var s = i[c];
          for (a in s)
            s.hasOwnProperty(a) && (n || (n = {}), n[a] = "");
        } else
          c !== "dangerouslySetInnerHTML" && c !== "children" && c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && c !== "autoFocus" && (cg.hasOwnProperty(c) ? o || (o = []) : (o = o || []).push(c, null));
    for (c in r) {
      var l = r[c];
      if (s = i != null ? i[c] : void 0, r.hasOwnProperty(c) && l !== s && (l != null || s != null))
        if (c === "style")
          if (s) {
            for (a in s)
              !s.hasOwnProperty(a) || l && l.hasOwnProperty(a) || (n || (n = {}), n[a] = "");
            for (a in l)
              l.hasOwnProperty(a) && s[a] !== l[a] && (n || (n = {}), n[a] = l[a]);
          } else
            n || (o || (o = []), o.push(
              c,
              n
            )), n = l;
        else
          c === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, s = s ? s.__html : void 0, l != null && s !== l && (o = o || []).push(c, l)) : c === "children" ? typeof l != "string" && typeof l != "number" || (o = o || []).push(c, "" + l) : c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && (cg.hasOwnProperty(c) ? (l != null && c === "onScroll" && gr("scroll", e), o || s === l || (o = [])) : (o = o || []).push(c, l));
    }
    n && (o = o || []).push("style", n);
    var c = o;
    (t.updateQueue = c) && (t.flags |= 4);
  }
};
Vz = function(e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function hm(e, t) {
  if (!$r)
    switch (e.tailMode) {
      case "hidden":
        t = e.tail;
        for (var n = null; t !== null; )
          t.alternate !== null && (n = t), t = t.sibling;
        n === null ? e.tail = null : n.sibling = null;
        break;
      case "collapsed":
        n = e.tail;
        for (var r = null; n !== null; )
          n.alternate !== null && (r = n), n = n.sibling;
        r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
    }
}
function oo(e) {
  var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
  if (t)
    for (var i = e.child; i !== null; )
      n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 14680064, r |= i.flags & 14680064, i.return = e, i = i.sibling;
  else
    for (i = e.child; i !== null; )
      n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
  return e.subtreeFlags |= r, e.childLanes = n, t;
}
function wse(e, t, n) {
  var r = t.pendingProps;
  switch (IA(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return oo(t), null;
    case 1:
      return qo(t.type) && Zb(), oo(t), null;
    case 3:
      return r = t.stateNode, jp(), br(Ko), br(mo), FA(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (Jy(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Ds !== null && (eP(Ds), Ds = null))), GO(e, t), oo(t), null;
    case 5:
      jA(t);
      var i = yf(Sg.current);
      if (n = t.type, e !== null && t.stateNode != null)
        Wz(e, t, n, r, i), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
      else {
        if (!r) {
          if (t.stateNode === null)
            throw Error(Ve(166));
          return oo(t), null;
        }
        if (e = yf(Pl.current), Jy(t)) {
          r = t.stateNode, n = t.type;
          var o = t.memoizedProps;
          switch (r[bl] = t, r[bg] = o, e = (t.mode & 1) !== 0, n) {
            case "dialog":
              gr("cancel", r), gr("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              gr("load", r);
              break;
            case "video":
            case "audio":
              for (i = 0; i < Mm.length; i++)
                gr(Mm[i], r);
              break;
            case "source":
              gr("error", r);
              break;
            case "img":
            case "image":
            case "link":
              gr(
                "error",
                r
              ), gr("load", r);
              break;
            case "details":
              gr("toggle", r);
              break;
            case "input":
              bL(r, o), gr("invalid", r);
              break;
            case "select":
              r._wrapperState = { wasMultiple: !!o.multiple }, gr("invalid", r);
              break;
            case "textarea":
              SL(r, o), gr("invalid", r);
          }
          bO(n, o), i = null;
          for (var a in o)
            if (o.hasOwnProperty(a)) {
              var s = o[a];
              a === "children" ? typeof s == "string" ? r.textContent !== s && (o.suppressHydrationWarning !== !0 && Qy(r.textContent, s, e), i = ["children", s]) : typeof s == "number" && r.textContent !== "" + s && (o.suppressHydrationWarning !== !0 && Qy(
                r.textContent,
                s,
                e
              ), i = ["children", "" + s]) : cg.hasOwnProperty(a) && s != null && a === "onScroll" && gr("scroll", r);
            }
          switch (n) {
            case "input":
              Hy(r), wL(r, o, !0);
              break;
            case "textarea":
              Hy(r), xL(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof o.onClick == "function" && (r.onclick = Jb);
          }
          r = i, t.updateQueue = r, r !== null && (t.flags |= 4);
        } else {
          a = i.nodeType === 9 ? i : i.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = y8(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = a.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = a.createElement(n, { is: r.is }) : (e = a.createElement(n), n === "select" && (a = e, r.multiple ? a.multiple = !0 : r.size && (a.size = r.size))) : e = a.createElementNS(e, n), e[bl] = t, e[bg] = r, Hz(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (a = wO(n, r), n) {
              case "dialog":
                gr("cancel", e), gr("close", e), i = r;
                break;
              case "iframe":
              case "object":
              case "embed":
                gr("load", e), i = r;
                break;
              case "video":
              case "audio":
                for (i = 0; i < Mm.length; i++)
                  gr(Mm[i], e);
                i = r;
                break;
              case "source":
                gr("error", e), i = r;
                break;
              case "img":
              case "image":
              case "link":
                gr(
                  "error",
                  e
                ), gr("load", e), i = r;
                break;
              case "details":
                gr("toggle", e), i = r;
                break;
              case "input":
                bL(e, r), i = hO(e, r), gr("invalid", e);
                break;
              case "option":
                i = r;
                break;
              case "select":
                e._wrapperState = { wasMultiple: !!r.multiple }, i = Lr({}, r, { value: void 0 }), gr("invalid", e);
                break;
              case "textarea":
                SL(e, r), i = vO(e, r), gr("invalid", e);
                break;
              default:
                i = r;
            }
            bO(n, i), s = i;
            for (o in s)
              if (s.hasOwnProperty(o)) {
                var l = s[o];
                o === "style" ? S8(e, l) : o === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, l != null && b8(e, l)) : o === "children" ? typeof l == "string" ? (n !== "textarea" || l !== "") && ug(e, l) : typeof l == "number" && ug(e, "" + l) : o !== "suppressContentEditableWarning" && o !== "suppressHydrationWarning" && o !== "autoFocus" && (cg.hasOwnProperty(o) ? l != null && o === "onScroll" && gr("scroll", e) : l != null && mA(e, o, l, a));
              }
            switch (n) {
              case "input":
                Hy(e), wL(e, r, !1);
                break;
              case "textarea":
                Hy(e), xL(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + Cu(r.value));
                break;
              case "select":
                e.multiple = !!r.multiple, o = r.value, o != null ? dp(e, !!r.multiple, o, !1) : r.defaultValue != null && dp(
                  e,
                  !!r.multiple,
                  r.defaultValue,
                  !0
                );
                break;
              default:
                typeof i.onClick == "function" && (e.onclick = Jb);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return oo(t), null;
    case 6:
      if (e && t.stateNode != null)
        Vz(e, t, e.memoizedProps, r);
      else {
        if (typeof r != "string" && t.stateNode === null)
          throw Error(Ve(166));
        if (n = yf(Sg.current), yf(Pl.current), Jy(t)) {
          if (r = t.stateNode, n = t.memoizedProps, r[bl] = t, (o = r.nodeValue !== n) && (e = Ea, e !== null))
            switch (e.tag) {
              case 3:
                Qy(r.nodeValue, n, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 && Qy(r.nodeValue, n, (e.mode & 1) !== 0);
            }
          o && (t.flags |= 4);
        } else
          r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[bl] = t, t.stateNode = r;
      }
      return oo(t), null;
    case 13:
      if (br(Rr), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if ($r && wa !== null && t.mode & 1 && !(t.flags & 128))
          lz(), Lp(), t.flags |= 98560, o = !1;
        else if (o = Jy(t), r !== null && r.dehydrated !== null) {
          if (e === null) {
            if (!o)
              throw Error(Ve(318));
            if (o = t.memoizedState, o = o !== null ? o.dehydrated : null, !o)
              throw Error(Ve(317));
            o[bl] = t;
          } else
            Lp(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          oo(t), o = !1;
        } else
          Ds !== null && (eP(Ds), Ds = null), o = !0;
        if (!o)
          return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || Rr.current & 1 ? pi === 0 && (pi = 3) : QA())), t.updateQueue !== null && (t.flags |= 4), oo(t), null);
    case 4:
      return jp(), GO(e, t), e === null && vg(t.stateNode.containerInfo), oo(t), null;
    case 10:
      return NA(t.type._context), oo(t), null;
    case 17:
      return qo(t.type) && Zb(), oo(t), null;
    case 19:
      if (br(Rr), o = t.memoizedState, o === null)
        return oo(t), null;
      if (r = (t.flags & 128) !== 0, a = o.rendering, a === null)
        if (r)
          hm(o, !1);
        else {
          if (pi !== 0 || e !== null && e.flags & 128)
            for (e = t.child; e !== null; ) {
              if (a = a1(e), a !== null) {
                for (t.flags |= 128, hm(o, !1), r = a.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; )
                  o = n, e = r, o.flags &= 14680066, a = o.alternate, a === null ? (o.childLanes = 0, o.lanes = e, o.child = null, o.subtreeFlags = 0, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = a.childLanes, o.lanes = a.lanes, o.child = a.child, o.subtreeFlags = 0, o.deletions = null, o.memoizedProps = a.memoizedProps, o.memoizedState = a.memoizedState, o.updateQueue = a.updateQueue, o.type = a.type, e = a.dependencies, o.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
                return cr(Rr, Rr.current & 1 | 2), t.child;
              }
              e = e.sibling;
            }
          o.tail !== null && qr() > Bp && (t.flags |= 128, r = !0, hm(o, !1), t.lanes = 4194304);
        }
      else {
        if (!r)
          if (e = a1(a), e !== null) {
            if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), hm(o, !0), o.tail === null && o.tailMode === "hidden" && !a.alternate && !$r)
              return oo(t), null;
          } else
            2 * qr() - o.renderingStartTime > Bp && n !== 1073741824 && (t.flags |= 128, r = !0, hm(o, !1), t.lanes = 4194304);
        o.isBackwards ? (a.sibling = t.child, t.child = a) : (n = o.last, n !== null ? n.sibling = a : t.child = a, o.last = a);
      }
      return o.tail !== null ? (t = o.tail, o.rendering = t, o.tail = t.sibling, o.renderingStartTime = qr(), t.sibling = null, n = Rr.current, cr(Rr, r ? n & 1 | 2 : n & 1), t) : (oo(t), null);
    case 22:
    case 23:
      return XA(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? va & 1073741824 && (oo(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : oo(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(Ve(156, t.tag));
}
function Sse(e, t) {
  switch (IA(t), t.tag) {
    case 1:
      return qo(t.type) && Zb(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return jp(), br(Ko), br(mo), FA(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return jA(t), null;
    case 13:
      if (br(Rr), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null)
          throw Error(Ve(340));
        Lp();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return br(Rr), null;
    case 4:
      return jp(), null;
    case 10:
      return NA(t.type._context), null;
    case 22:
    case 23:
      return XA(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var t0 = !1, uo = !1, xse = typeof WeakSet == "function" ? WeakSet : Set, st = null;
function Jd(e, t) {
  var n = e.ref;
  if (n !== null)
    if (typeof n == "function")
      try {
        n(null);
      } catch (r) {
        zr(e, t, r);
      }
    else
      n.current = null;
}
function KO(e, t, n) {
  try {
    n();
  } catch (r) {
    zr(e, t, r);
  }
}
var f3 = !1;
function Cse(e, t) {
  if (IO = Yb, e = Y8(), PA(e)) {
    if ("selectionStart" in e)
      var n = { start: e.selectionStart, end: e.selectionEnd };
    else
      e: {
        n = (n = e.ownerDocument) && n.defaultView || window;
        var r = n.getSelection && n.getSelection();
        if (r && r.rangeCount !== 0) {
          n = r.anchorNode;
          var i = r.anchorOffset, o = r.focusNode;
          r = r.focusOffset;
          try {
            n.nodeType, o.nodeType;
          } catch {
            n = null;
            break e;
          }
          var a = 0, s = -1, l = -1, c = 0, f = 0, d = e, p = null;
          t:
            for (; ; ) {
              for (var g; d !== n || i !== 0 && d.nodeType !== 3 || (s = a + i), d !== o || r !== 0 && d.nodeType !== 3 || (l = a + r), d.nodeType === 3 && (a += d.nodeValue.length), (g = d.firstChild) !== null; )
                p = d, d = g;
              for (; ; ) {
                if (d === e)
                  break t;
                if (p === n && ++c === i && (s = a), p === o && ++f === r && (l = a), (g = d.nextSibling) !== null)
                  break;
                d = p, p = d.parentNode;
              }
              d = g;
            }
          n = s === -1 || l === -1 ? null : { start: s, end: l };
        } else
          n = null;
      }
    n = n || { start: 0, end: 0 };
  } else
    n = null;
  for (AO = { focusedElem: e, selectionRange: n }, Yb = !1, st = t; st !== null; )
    if (t = st, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null)
      e.return = t, st = e;
    else
      for (; st !== null; ) {
        t = st;
        try {
          var v = t.alternate;
          if (t.flags & 1024)
            switch (t.tag) {
              case 0:
              case 11:
              case 15:
                break;
              case 1:
                if (v !== null) {
                  var y = v.memoizedProps, x = v.memoizedState, b = t.stateNode, w = b.getSnapshotBeforeUpdate(t.elementType === t.type ? y : Ts(t.type, y), x);
                  b.__reactInternalSnapshotBeforeUpdate = w;
                }
                break;
              case 3:
                var S = t.stateNode.containerInfo;
                S.nodeType === 1 ? S.textContent = "" : S.nodeType === 9 && S.documentElement && S.removeChild(S.documentElement);
                break;
              case 5:
              case 6:
              case 4:
              case 17:
                break;
              default:
                throw Error(Ve(163));
            }
        } catch (E) {
          zr(t, t.return, E);
        }
        if (e = t.sibling, e !== null) {
          e.return = t.return, st = e;
          break;
        }
        st = t.return;
      }
  return v = f3, f3 = !1, v;
}
function qm(e, t, n) {
  var r = t.updateQueue;
  if (r = r !== null ? r.lastEffect : null, r !== null) {
    var i = r = r.next;
    do {
      if ((i.tag & e) === e) {
        var o = i.destroy;
        i.destroy = void 0, o !== void 0 && KO(t, n, o);
      }
      i = i.next;
    } while (i !== r);
  }
}
function Cw(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var n = t = t.next;
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function qO(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function Gz(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, Gz(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[bl], delete t[bg], delete t[NO], delete t[ose], delete t[ase])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function Kz(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function d3(e) {
  e:
    for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || Kz(e.return))
          return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.flags & 2 || e.child === null || e.tag === 4)
          continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2))
        return e.stateNode;
    }
}
function YO(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6)
    e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Jb));
  else if (r !== 4 && (e = e.child, e !== null))
    for (YO(e, t, n), e = e.sibling; e !== null; )
      YO(e, t, n), e = e.sibling;
}
function XO(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6)
    e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (r !== 4 && (e = e.child, e !== null))
    for (XO(e, t, n), e = e.sibling; e !== null; )
      XO(e, t, n), e = e.sibling;
}
var Li = null, Rs = !1;
function kc(e, t, n) {
  for (n = n.child; n !== null; )
    qz(e, t, n), n = n.sibling;
}
function qz(e, t, n) {
  if (Ol && typeof Ol.onCommitFiberUnmount == "function")
    try {
      Ol.onCommitFiberUnmount(mw, n);
    } catch {
    }
  switch (n.tag) {
    case 5:
      uo || Jd(n, t);
    case 6:
      var r = Li, i = Rs;
      Li = null, kc(e, t, n), Li = r, Rs = i, Li !== null && (Rs ? (e = Li, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : Li.removeChild(n.stateNode));
      break;
    case 18:
      Li !== null && (Rs ? (e = Li, n = n.stateNode, e.nodeType === 8 ? XE(e.parentNode, n) : e.nodeType === 1 && XE(e, n), hg(e)) : XE(Li, n.stateNode));
      break;
    case 4:
      r = Li, i = Rs, Li = n.stateNode.containerInfo, Rs = !0, kc(e, t, n), Li = r, Rs = i;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!uo && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
        i = r = r.next;
        do {
          var o = i, a = o.destroy;
          o = o.tag, a !== void 0 && (o & 2 || o & 4) && KO(n, t, a), i = i.next;
        } while (i !== r);
      }
      kc(e, t, n);
      break;
    case 1:
      if (!uo && (Jd(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function"))
        try {
          r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
        } catch (s) {
          zr(n, t, s);
        }
      kc(e, t, n);
      break;
    case 21:
      kc(e, t, n);
      break;
    case 22:
      n.mode & 1 ? (uo = (r = uo) || n.memoizedState !== null, kc(e, t, n), uo = r) : kc(e, t, n);
      break;
    default:
      kc(e, t, n);
  }
}
function p3(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new xse()), t.forEach(function(r) {
      var i = Rse.bind(null, e, r);
      n.has(r) || (n.add(r), r.then(i, i));
    });
  }
}
function $s(e, t) {
  var n = t.deletions;
  if (n !== null)
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      try {
        var o = e, a = t, s = a;
        e:
          for (; s !== null; ) {
            switch (s.tag) {
              case 5:
                Li = s.stateNode, Rs = !1;
                break e;
              case 3:
                Li = s.stateNode.containerInfo, Rs = !0;
                break e;
              case 4:
                Li = s.stateNode.containerInfo, Rs = !0;
                break e;
            }
            s = s.return;
          }
        if (Li === null)
          throw Error(Ve(160));
        qz(o, a, i), Li = null, Rs = !1;
        var l = i.alternate;
        l !== null && (l.return = null), i.return = null;
      } catch (c) {
        zr(i, t, c);
      }
    }
  if (t.subtreeFlags & 12854)
    for (t = t.child; t !== null; )
      Yz(t, e), t = t.sibling;
}
function Yz(e, t) {
  var n = e.alternate, r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if ($s(t, e), ul(e), r & 4) {
        try {
          qm(3, e, e.return), Cw(3, e);
        } catch (y) {
          zr(e, e.return, y);
        }
        try {
          qm(5, e, e.return);
        } catch (y) {
          zr(e, e.return, y);
        }
      }
      break;
    case 1:
      $s(t, e), ul(e), r & 512 && n !== null && Jd(n, n.return);
      break;
    case 5:
      if ($s(t, e), ul(e), r & 512 && n !== null && Jd(n, n.return), e.flags & 32) {
        var i = e.stateNode;
        try {
          ug(i, "");
        } catch (y) {
          zr(e, e.return, y);
        }
      }
      if (r & 4 && (i = e.stateNode, i != null)) {
        var o = e.memoizedProps, a = n !== null ? n.memoizedProps : o, s = e.type, l = e.updateQueue;
        if (e.updateQueue = null, l !== null)
          try {
            s === "input" && o.type === "radio" && o.name != null && g8(i, o), wO(s, a);
            var c = wO(s, o);
            for (a = 0; a < l.length; a += 2) {
              var f = l[a], d = l[a + 1];
              f === "style" ? S8(i, d) : f === "dangerouslySetInnerHTML" ? b8(i, d) : f === "children" ? ug(i, d) : mA(i, f, d, c);
            }
            switch (s) {
              case "input":
                mO(i, o);
                break;
              case "textarea":
                v8(i, o);
                break;
              case "select":
                var p = i._wrapperState.wasMultiple;
                i._wrapperState.wasMultiple = !!o.multiple;
                var g = o.value;
                g != null ? dp(i, !!o.multiple, g, !1) : p !== !!o.multiple && (o.defaultValue != null ? dp(
                  i,
                  !!o.multiple,
                  o.defaultValue,
                  !0
                ) : dp(i, !!o.multiple, o.multiple ? [] : "", !1));
            }
            i[bg] = o;
          } catch (y) {
            zr(e, e.return, y);
          }
      }
      break;
    case 6:
      if ($s(t, e), ul(e), r & 4) {
        if (e.stateNode === null)
          throw Error(Ve(162));
        i = e.stateNode, o = e.memoizedProps;
        try {
          i.nodeValue = o;
        } catch (y) {
          zr(e, e.return, y);
        }
      }
      break;
    case 3:
      if ($s(t, e), ul(e), r & 4 && n !== null && n.memoizedState.isDehydrated)
        try {
          hg(t.containerInfo);
        } catch (y) {
          zr(e, e.return, y);
        }
      break;
    case 4:
      $s(t, e), ul(e);
      break;
    case 13:
      $s(t, e), ul(e), i = e.child, i.flags & 8192 && (o = i.memoizedState !== null, i.stateNode.isHidden = o, !o || i.alternate !== null && i.alternate.memoizedState !== null || (qA = qr())), r & 4 && p3(e);
      break;
    case 22:
      if (f = n !== null && n.memoizedState !== null, e.mode & 1 ? (uo = (c = uo) || f, $s(t, e), uo = c) : $s(t, e), ul(e), r & 8192) {
        if (c = e.memoizedState !== null, (e.stateNode.isHidden = c) && !f && e.mode & 1)
          for (st = e, f = e.child; f !== null; ) {
            for (d = st = f; st !== null; ) {
              switch (p = st, g = p.child, p.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  qm(4, p, p.return);
                  break;
                case 1:
                  Jd(p, p.return);
                  var v = p.stateNode;
                  if (typeof v.componentWillUnmount == "function") {
                    r = p, n = p.return;
                    try {
                      t = r, v.props = t.memoizedProps, v.state = t.memoizedState, v.componentWillUnmount();
                    } catch (y) {
                      zr(r, n, y);
                    }
                  }
                  break;
                case 5:
                  Jd(p, p.return);
                  break;
                case 22:
                  if (p.memoizedState !== null) {
                    m3(d);
                    continue;
                  }
              }
              g !== null ? (g.return = p, st = g) : m3(d);
            }
            f = f.sibling;
          }
        e:
          for (f = null, d = e; ; ) {
            if (d.tag === 5) {
              if (f === null) {
                f = d;
                try {
                  i = d.stateNode, c ? (o = i.style, typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none") : (s = d.stateNode, l = d.memoizedProps.style, a = l != null && l.hasOwnProperty("display") ? l.display : null, s.style.display = w8("display", a));
                } catch (y) {
                  zr(e, e.return, y);
                }
              }
            } else if (d.tag === 6) {
              if (f === null)
                try {
                  d.stateNode.nodeValue = c ? "" : d.memoizedProps;
                } catch (y) {
                  zr(e, e.return, y);
                }
            } else if ((d.tag !== 22 && d.tag !== 23 || d.memoizedState === null || d === e) && d.child !== null) {
              d.child.return = d, d = d.child;
              continue;
            }
            if (d === e)
              break e;
            for (; d.sibling === null; ) {
              if (d.return === null || d.return === e)
                break e;
              f === d && (f = null), d = d.return;
            }
            f === d && (f = null), d.sibling.return = d.return, d = d.sibling;
          }
      }
      break;
    case 19:
      $s(t, e), ul(e), r & 4 && p3(e);
      break;
    case 21:
      break;
    default:
      $s(
        t,
        e
      ), ul(e);
  }
}
function ul(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (Kz(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(Ve(160));
      }
      switch (r.tag) {
        case 5:
          var i = r.stateNode;
          r.flags & 32 && (ug(i, ""), r.flags &= -33);
          var o = d3(e);
          XO(e, o, i);
          break;
        case 3:
        case 4:
          var a = r.stateNode.containerInfo, s = d3(e);
          YO(e, s, a);
          break;
        default:
          throw Error(Ve(161));
      }
    } catch (l) {
      zr(e, e.return, l);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function Ese(e, t, n) {
  st = e, Xz(e);
}
function Xz(e, t, n) {
  for (var r = (e.mode & 1) !== 0; st !== null; ) {
    var i = st, o = i.child;
    if (i.tag === 22 && r) {
      var a = i.memoizedState !== null || t0;
      if (!a) {
        var s = i.alternate, l = s !== null && s.memoizedState !== null || uo;
        s = t0;
        var c = uo;
        if (t0 = a, (uo = l) && !c)
          for (st = i; st !== null; )
            a = st, l = a.child, a.tag === 22 && a.memoizedState !== null ? g3(i) : l !== null ? (l.return = a, st = l) : g3(i);
        for (; o !== null; )
          st = o, Xz(o), o = o.sibling;
        st = i, t0 = s, uo = c;
      }
      h3(e);
    } else
      i.subtreeFlags & 8772 && o !== null ? (o.return = i, st = o) : h3(e);
  }
}
function h3(e) {
  for (; st !== null; ) {
    var t = st;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772)
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              uo || Cw(5, t);
              break;
            case 1:
              var r = t.stateNode;
              if (t.flags & 4 && !uo)
                if (n === null)
                  r.componentDidMount();
                else {
                  var i = t.elementType === t.type ? n.memoizedProps : Ts(t.type, n.memoizedProps);
                  r.componentDidUpdate(i, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
                }
              var o = t.updateQueue;
              o !== null && QL(t, o, r);
              break;
            case 3:
              var a = t.updateQueue;
              if (a !== null) {
                if (n = null, t.child !== null)
                  switch (t.child.tag) {
                    case 5:
                      n = t.child.stateNode;
                      break;
                    case 1:
                      n = t.child.stateNode;
                  }
                QL(t, a, n);
              }
              break;
            case 5:
              var s = t.stateNode;
              if (n === null && t.flags & 4) {
                n = s;
                var l = t.memoizedProps;
                switch (t.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    l.autoFocus && n.focus();
                    break;
                  case "img":
                    l.src && (n.src = l.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (t.memoizedState === null) {
                var c = t.alternate;
                if (c !== null) {
                  var f = c.memoizedState;
                  if (f !== null) {
                    var d = f.dehydrated;
                    d !== null && hg(d);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(Ve(163));
          }
        uo || t.flags & 512 && qO(t);
      } catch (p) {
        zr(t, t.return, p);
      }
    }
    if (t === e) {
      st = null;
      break;
    }
    if (n = t.sibling, n !== null) {
      n.return = t.return, st = n;
      break;
    }
    st = t.return;
  }
}
function m3(e) {
  for (; st !== null; ) {
    var t = st;
    if (t === e) {
      st = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      n.return = t.return, st = n;
      break;
    }
    st = t.return;
  }
}
function g3(e) {
  for (; st !== null; ) {
    var t = st;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            Cw(4, t);
          } catch (l) {
            zr(t, n, l);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var i = t.return;
            try {
              r.componentDidMount();
            } catch (l) {
              zr(t, i, l);
            }
          }
          var o = t.return;
          try {
            qO(t);
          } catch (l) {
            zr(t, o, l);
          }
          break;
        case 5:
          var a = t.return;
          try {
            qO(t);
          } catch (l) {
            zr(t, a, l);
          }
      }
    } catch (l) {
      zr(t, t.return, l);
    }
    if (t === e) {
      st = null;
      break;
    }
    var s = t.sibling;
    if (s !== null) {
      s.return = t.return, st = s;
      break;
    }
    st = t.return;
  }
}
var $se = Math.ceil, c1 = wc.ReactCurrentDispatcher, GA = wc.ReactCurrentOwner, Xa = wc.ReactCurrentBatchConfig, $n = 0, _i = null, ni = null, Ui = 0, va = 0, Zd = Ru(0), pi = 0, $g = null, Lf = 0, Ew = 0, KA = 0, Ym = null, Uo = null, qA = 0, Bp = 1 / 0, ec = null, u1 = !1, QO = null, vu = null, n0 = !1, eu = null, f1 = 0, Xm = 0, JO = null, tb = -1, nb = 0;
function Oo() {
  return $n & 6 ? qr() : tb !== -1 ? tb : tb = qr();
}
function yu(e) {
  return e.mode & 1 ? $n & 2 && Ui !== 0 ? Ui & -Ui : lse.transition !== null ? (nb === 0 && (nb = M8()), nb) : (e = Fn, e !== 0 || (e = window.event, e = e === void 0 ? 16 : B8(e.type)), e) : 1;
}
function zs(e, t, n, r) {
  if (50 < Xm)
    throw Xm = 0, JO = null, Error(Ve(185));
  ev(e, n, r), (!($n & 2) || e !== _i) && (e === _i && (!($n & 2) && (Ew |= n), pi === 4 && qc(e, Ui)), Yo(e, r), n === 1 && $n === 0 && !(t.mode & 1) && (Bp = qr() + 500, ww && Mu()));
}
function Yo(e, t) {
  var n = e.callbackNode;
  lae(e, t);
  var r = qb(e, e === _i ? Ui : 0);
  if (r === 0)
    n !== null && $L(n), e.callbackNode = null, e.callbackPriority = 0;
  else if (t = r & -r, e.callbackPriority !== t) {
    if (n != null && $L(n), t === 1)
      e.tag === 0 ? sse(v3.bind(null, e)) : oz(v3.bind(null, e)), rse(function() {
        !($n & 6) && Mu();
      }), n = null;
    else {
      switch (N8(r)) {
        case 1:
          n = wA;
          break;
        case 4:
          n = A8;
          break;
        case 16:
          n = Kb;
          break;
        case 536870912:
          n = R8;
          break;
        default:
          n = Kb;
      }
      n = iU(n, Qz.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = n;
  }
}
function Qz(e, t) {
  if (tb = -1, nb = 0, $n & 6)
    throw Error(Ve(327));
  var n = e.callbackNode;
  if (vp() && e.callbackNode !== n)
    return null;
  var r = qb(e, e === _i ? Ui : 0);
  if (r === 0)
    return null;
  if (r & 30 || r & e.expiredLanes || t)
    t = d1(e, r);
  else {
    t = r;
    var i = $n;
    $n |= 2;
    var o = Zz();
    (_i !== e || Ui !== t) && (ec = null, Bp = qr() + 500, Of(e, t));
    do
      try {
        Pse();
        break;
      } catch (s) {
        Jz(e, s);
      }
    while (!0);
    MA(), c1.current = o, $n = i, ni !== null ? t = 0 : (_i = null, Ui = 0, t = pi);
  }
  if (t !== 0) {
    if (t === 2 && (i = $O(e), i !== 0 && (r = i, t = ZO(e, i))), t === 1)
      throw n = $g, Of(e, 0), qc(e, r), Yo(e, qr()), n;
    if (t === 6)
      qc(e, r);
    else {
      if (i = e.current.alternate, !(r & 30) && !_se(i) && (t = d1(e, r), t === 2 && (o = $O(e), o !== 0 && (r = o, t = ZO(e, o))), t === 1))
        throw n = $g, Of(e, 0), qc(e, r), Yo(e, qr()), n;
      switch (e.finishedWork = i, e.finishedLanes = r, t) {
        case 0:
        case 1:
          throw Error(Ve(345));
        case 2:
          Ju(e, Uo, ec);
          break;
        case 3:
          if (qc(e, r), (r & 130023424) === r && (t = qA + 500 - qr(), 10 < t)) {
            if (qb(e, 0) !== 0)
              break;
            if (i = e.suspendedLanes, (i & r) !== r) {
              Oo(), e.pingedLanes |= e.suspendedLanes & i;
              break;
            }
            e.timeoutHandle = MO(Ju.bind(null, e, Uo, ec), t);
            break;
          }
          Ju(e, Uo, ec);
          break;
        case 4:
          if (qc(e, r), (r & 4194240) === r)
            break;
          for (t = e.eventTimes, i = -1; 0 < r; ) {
            var a = 31 - Bs(r);
            o = 1 << a, a = t[a], a > i && (i = a), r &= ~o;
          }
          if (r = i, r = qr() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * $se(r / 1960)) - r, 10 < r) {
            e.timeoutHandle = MO(Ju.bind(null, e, Uo, ec), r);
            break;
          }
          Ju(e, Uo, ec);
          break;
        case 5:
          Ju(e, Uo, ec);
          break;
        default:
          throw Error(Ve(329));
      }
    }
  }
  return Yo(e, qr()), e.callbackNode === n ? Qz.bind(null, e) : null;
}
function ZO(e, t) {
  var n = Ym;
  return e.current.memoizedState.isDehydrated && (Of(e, t).flags |= 256), e = d1(e, t), e !== 2 && (t = Uo, Uo = n, t !== null && eP(t)), e;
}
function eP(e) {
  Uo === null ? Uo = e : Uo.push.apply(Uo, e);
}
function _se(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && (n = n.stores, n !== null))
        for (var r = 0; r < n.length; r++) {
          var i = n[r], o = i.getSnapshot;
          i = i.value;
          try {
            if (!Ks(o(), i))
              return !1;
          } catch {
            return !1;
          }
        }
    }
    if (n = t.child, t.subtreeFlags & 16384 && n !== null)
      n.return = t, t = n;
    else {
      if (t === e)
        break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e)
          return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function qc(e, t) {
  for (t &= ~KA, t &= ~Ew, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - Bs(t), r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function v3(e) {
  if ($n & 6)
    throw Error(Ve(327));
  vp();
  var t = qb(e, 0);
  if (!(t & 1))
    return Yo(e, qr()), null;
  var n = d1(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = $O(e);
    r !== 0 && (t = r, n = ZO(e, r));
  }
  if (n === 1)
    throw n = $g, Of(e, 0), qc(e, t), Yo(e, qr()), n;
  if (n === 6)
    throw Error(Ve(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, Ju(e, Uo, ec), Yo(e, qr()), null;
}
function YA(e, t) {
  var n = $n;
  $n |= 1;
  try {
    return e(t);
  } finally {
    $n = n, $n === 0 && (Bp = qr() + 500, ww && Mu());
  }
}
function Df(e) {
  eu !== null && eu.tag === 0 && !($n & 6) && vp();
  var t = $n;
  $n |= 1;
  var n = Xa.transition, r = Fn;
  try {
    if (Xa.transition = null, Fn = 1, e)
      return e();
  } finally {
    Fn = r, Xa.transition = n, $n = t, !($n & 6) && Mu();
  }
}
function XA() {
  va = Zd.current, br(Zd);
}
function Of(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (n !== -1 && (e.timeoutHandle = -1, nse(n)), ni !== null)
    for (n = ni.return; n !== null; ) {
      var r = n;
      switch (IA(r), r.tag) {
        case 1:
          r = r.type.childContextTypes, r != null && Zb();
          break;
        case 3:
          jp(), br(Ko), br(mo), FA();
          break;
        case 5:
          jA(r);
          break;
        case 4:
          jp();
          break;
        case 13:
          br(Rr);
          break;
        case 19:
          br(Rr);
          break;
        case 10:
          NA(r.type._context);
          break;
        case 22:
        case 23:
          XA();
      }
      n = n.return;
    }
  if (_i = e, ni = e = bu(e.current, null), Ui = va = t, pi = 0, $g = null, KA = Ew = Lf = 0, Uo = Ym = null, vf !== null) {
    for (t = 0; t < vf.length; t++)
      if (n = vf[t], r = n.interleaved, r !== null) {
        n.interleaved = null;
        var i = r.next, o = n.pending;
        if (o !== null) {
          var a = o.next;
          o.next = i, r.next = a;
        }
        n.pending = r;
      }
    vf = null;
  }
  return e;
}
function Jz(e, t) {
  do {
    var n = ni;
    try {
      if (MA(), J0.current = l1, s1) {
        for (var r = kr.memoizedState; r !== null; ) {
          var i = r.queue;
          i !== null && (i.pending = null), r = r.next;
        }
        s1 = !1;
      }
      if (kf = 0, Ei = di = kr = null, Km = !1, xg = 0, GA.current = null, n === null || n.return === null) {
        pi = 1, $g = t, ni = null;
        break;
      }
      e: {
        var o = e, a = n.return, s = n, l = t;
        if (t = Ui, s.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
          var c = l, f = s, d = f.tag;
          if (!(f.mode & 1) && (d === 0 || d === 11 || d === 15)) {
            var p = f.alternate;
            p ? (f.updateQueue = p.updateQueue, f.memoizedState = p.memoizedState, f.lanes = p.lanes) : (f.updateQueue = null, f.memoizedState = null);
          }
          var g = i3(a);
          if (g !== null) {
            g.flags &= -257, o3(g, a, s, o, t), g.mode & 1 && r3(o, c, t), t = g, l = c;
            var v = t.updateQueue;
            if (v === null) {
              var y = /* @__PURE__ */ new Set();
              y.add(l), t.updateQueue = y;
            } else
              v.add(l);
            break e;
          } else {
            if (!(t & 1)) {
              r3(o, c, t), QA();
              break e;
            }
            l = Error(Ve(426));
          }
        } else if ($r && s.mode & 1) {
          var x = i3(a);
          if (x !== null) {
            !(x.flags & 65536) && (x.flags |= 256), o3(x, a, s, o, t), AA(Fp(l, s));
            break e;
          }
        }
        o = l = Fp(l, s), pi !== 4 && (pi = 2), Ym === null ? Ym = [o] : Ym.push(o), o = a;
        do {
          switch (o.tag) {
            case 3:
              o.flags |= 65536, t &= -t, o.lanes |= t;
              var b = kz(o, l, t);
              XL(o, b);
              break e;
            case 1:
              s = l;
              var w = o.type, S = o.stateNode;
              if (!(o.flags & 128) && (typeof w.getDerivedStateFromError == "function" || S !== null && typeof S.componentDidCatch == "function" && (vu === null || !vu.has(S)))) {
                o.flags |= 65536, t &= -t, o.lanes |= t;
                var E = Lz(o, s, t);
                XL(o, E);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      tU(n);
    } catch (O) {
      t = O, ni === n && n !== null && (ni = n = n.return);
      continue;
    }
    break;
  } while (!0);
}
function Zz() {
  var e = c1.current;
  return c1.current = l1, e === null ? l1 : e;
}
function QA() {
  (pi === 0 || pi === 3 || pi === 2) && (pi = 4), _i === null || !(Lf & 268435455) && !(Ew & 268435455) || qc(_i, Ui);
}
function d1(e, t) {
  var n = $n;
  $n |= 2;
  var r = Zz();
  (_i !== e || Ui !== t) && (ec = null, Of(e, t));
  do
    try {
      Ose();
      break;
    } catch (i) {
      Jz(e, i);
    }
  while (!0);
  if (MA(), $n = n, c1.current = r, ni !== null)
    throw Error(Ve(261));
  return _i = null, Ui = 0, pi;
}
function Ose() {
  for (; ni !== null; )
    eU(ni);
}
function Pse() {
  for (; ni !== null && !Zoe(); )
    eU(ni);
}
function eU(e) {
  var t = rU(e.alternate, e, va);
  e.memoizedProps = e.pendingProps, t === null ? tU(e) : ni = t, GA.current = null;
}
function tU(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (n = Sse(n, t), n !== null) {
        n.flags &= 32767, ni = n;
        return;
      }
      if (e !== null)
        e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      else {
        pi = 6, ni = null;
        return;
      }
    } else if (n = wse(n, t, va), n !== null) {
      ni = n;
      return;
    }
    if (t = t.sibling, t !== null) {
      ni = t;
      return;
    }
    ni = t = e;
  } while (t !== null);
  pi === 0 && (pi = 5);
}
function Ju(e, t, n) {
  var r = Fn, i = Xa.transition;
  try {
    Xa.transition = null, Fn = 1, Tse(e, t, n, r);
  } finally {
    Xa.transition = i, Fn = r;
  }
  return null;
}
function Tse(e, t, n, r) {
  do
    vp();
  while (eu !== null);
  if ($n & 6)
    throw Error(Ve(327));
  n = e.finishedWork;
  var i = e.finishedLanes;
  if (n === null)
    return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current)
    throw Error(Ve(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var o = n.lanes | n.childLanes;
  if (cae(e, o), e === _i && (ni = _i = null, Ui = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || n0 || (n0 = !0, iU(Kb, function() {
    return vp(), null;
  })), o = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || o) {
    o = Xa.transition, Xa.transition = null;
    var a = Fn;
    Fn = 1;
    var s = $n;
    $n |= 4, GA.current = null, Cse(e, n), Yz(n, e), Yae(AO), Yb = !!IO, AO = IO = null, e.current = n, Ese(n), eae(), $n = s, Fn = a, Xa.transition = o;
  } else
    e.current = n;
  if (n0 && (n0 = !1, eu = e, f1 = i), o = e.pendingLanes, o === 0 && (vu = null), rae(n.stateNode), Yo(e, qr()), t !== null)
    for (r = e.onRecoverableError, n = 0; n < t.length; n++)
      i = t[n], r(i.value, { componentStack: i.stack, digest: i.digest });
  if (u1)
    throw u1 = !1, e = QO, QO = null, e;
  return f1 & 1 && e.tag !== 0 && vp(), o = e.pendingLanes, o & 1 ? e === JO ? Xm++ : (Xm = 0, JO = e) : Xm = 0, Mu(), null;
}
function vp() {
  if (eu !== null) {
    var e = N8(f1), t = Xa.transition, n = Fn;
    try {
      if (Xa.transition = null, Fn = 16 > e ? 16 : e, eu === null)
        var r = !1;
      else {
        if (e = eu, eu = null, f1 = 0, $n & 6)
          throw Error(Ve(331));
        var i = $n;
        for ($n |= 4, st = e.current; st !== null; ) {
          var o = st, a = o.child;
          if (st.flags & 16) {
            var s = o.deletions;
            if (s !== null) {
              for (var l = 0; l < s.length; l++) {
                var c = s[l];
                for (st = c; st !== null; ) {
                  var f = st;
                  switch (f.tag) {
                    case 0:
                    case 11:
                    case 15:
                      qm(8, f, o);
                  }
                  var d = f.child;
                  if (d !== null)
                    d.return = f, st = d;
                  else
                    for (; st !== null; ) {
                      f = st;
                      var p = f.sibling, g = f.return;
                      if (Gz(f), f === c) {
                        st = null;
                        break;
                      }
                      if (p !== null) {
                        p.return = g, st = p;
                        break;
                      }
                      st = g;
                    }
                }
              }
              var v = o.alternate;
              if (v !== null) {
                var y = v.child;
                if (y !== null) {
                  v.child = null;
                  do {
                    var x = y.sibling;
                    y.sibling = null, y = x;
                  } while (y !== null);
                }
              }
              st = o;
            }
          }
          if (o.subtreeFlags & 2064 && a !== null)
            a.return = o, st = a;
          else
            e:
              for (; st !== null; ) {
                if (o = st, o.flags & 2048)
                  switch (o.tag) {
                    case 0:
                    case 11:
                    case 15:
                      qm(9, o, o.return);
                  }
                var b = o.sibling;
                if (b !== null) {
                  b.return = o.return, st = b;
                  break e;
                }
                st = o.return;
              }
        }
        var w = e.current;
        for (st = w; st !== null; ) {
          a = st;
          var S = a.child;
          if (a.subtreeFlags & 2064 && S !== null)
            S.return = a, st = S;
          else
            e:
              for (a = w; st !== null; ) {
                if (s = st, s.flags & 2048)
                  try {
                    switch (s.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Cw(9, s);
                    }
                  } catch (O) {
                    zr(s, s.return, O);
                  }
                if (s === a) {
                  st = null;
                  break e;
                }
                var E = s.sibling;
                if (E !== null) {
                  E.return = s.return, st = E;
                  break e;
                }
                st = s.return;
              }
        }
        if ($n = i, Mu(), Ol && typeof Ol.onPostCommitFiberRoot == "function")
          try {
            Ol.onPostCommitFiberRoot(mw, e);
          } catch {
          }
        r = !0;
      }
      return r;
    } finally {
      Fn = n, Xa.transition = t;
    }
  }
  return !1;
}
function y3(e, t, n) {
  t = Fp(n, t), t = kz(e, t, 1), e = gu(e, t, 1), t = Oo(), e !== null && (ev(e, 1, t), Yo(e, t));
}
function zr(e, t, n) {
  if (e.tag === 3)
    y3(e, e, n);
  else
    for (; t !== null; ) {
      if (t.tag === 3) {
        y3(t, e, n);
        break;
      } else if (t.tag === 1) {
        var r = t.stateNode;
        if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (vu === null || !vu.has(r))) {
          e = Fp(n, e), e = Lz(t, e, 1), t = gu(t, e, 1), e = Oo(), t !== null && (ev(t, 1, e), Yo(t, e));
          break;
        }
      }
      t = t.return;
    }
}
function Ise(e, t, n) {
  var r = e.pingCache;
  r !== null && r.delete(t), t = Oo(), e.pingedLanes |= e.suspendedLanes & n, _i === e && (Ui & n) === n && (pi === 4 || pi === 3 && (Ui & 130023424) === Ui && 500 > qr() - qA ? Of(e, 0) : KA |= n), Yo(e, t);
}
function nU(e, t) {
  t === 0 && (e.mode & 1 ? (t = Gy, Gy <<= 1, !(Gy & 130023424) && (Gy = 4194304)) : t = 1);
  var n = Oo();
  e = pc(e, t), e !== null && (ev(e, t, n), Yo(e, n));
}
function Ase(e) {
  var t = e.memoizedState, n = 0;
  t !== null && (n = t.retryLane), nU(e, n);
}
function Rse(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode, i = e.memoizedState;
      i !== null && (n = i.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(Ve(314));
  }
  r !== null && r.delete(t), nU(e, n);
}
var rU;
rU = function(e, t, n) {
  if (e !== null)
    if (e.memoizedProps !== t.pendingProps || Ko.current)
      Vo = !0;
    else {
      if (!(e.lanes & n) && !(t.flags & 128))
        return Vo = !1, bse(e, t, n);
      Vo = !!(e.flags & 131072);
    }
  else
    Vo = !1, $r && t.flags & 1048576 && az(t, n1, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var r = t.type;
      eb(e, t), e = t.pendingProps;
      var i = kp(t, mo.current);
      gp(t, n), i = zA(null, t, r, e, i, n);
      var o = UA();
      return t.flags |= 1, typeof i == "object" && i !== null && typeof i.render == "function" && i.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, qo(r) ? (o = !0, e1(t)) : o = !1, t.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, LA(t), i.updater = Sw, t.stateNode = i, i._reactInternals = t, BO(t, r, e, n), t = HO(null, t, r, !0, o, n)) : (t.tag = 0, $r && o && TA(t), xo(null, t, i, n), t = t.child), t;
    case 16:
      r = t.elementType;
      e: {
        switch (eb(e, t), e = t.pendingProps, i = r._init, r = i(r._payload), t.type = r, i = t.tag = Nse(r), e = Ts(r, e), i) {
          case 0:
            t = UO(null, t, r, e, n);
            break e;
          case 1:
            t = l3(null, t, r, e, n);
            break e;
          case 11:
            t = a3(null, t, r, e, n);
            break e;
          case 14:
            t = s3(null, t, r, Ts(r.type, e), n);
            break e;
        }
        throw Error(Ve(
          306,
          r,
          ""
        ));
      }
      return t;
    case 0:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ts(r, i), UO(e, t, r, i, n);
    case 1:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ts(r, i), l3(e, t, r, i, n);
    case 3:
      e: {
        if (Bz(t), e === null)
          throw Error(Ve(387));
        r = t.pendingProps, o = t.memoizedState, i = o.element, uz(e, t), o1(t, r, null, n);
        var a = t.memoizedState;
        if (r = a.element, o.isDehydrated)
          if (o = { element: r, isDehydrated: !1, cache: a.cache, pendingSuspenseBoundaries: a.pendingSuspenseBoundaries, transitions: a.transitions }, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
            i = Fp(Error(Ve(423)), t), t = c3(e, t, r, n, i);
            break e;
          } else if (r !== i) {
            i = Fp(Error(Ve(424)), t), t = c3(e, t, r, n, i);
            break e;
          } else
            for (wa = mu(t.stateNode.containerInfo.firstChild), Ea = t, $r = !0, Ds = null, n = hz(t, null, r, n), t.child = n; n; )
              n.flags = n.flags & -3 | 4096, n = n.sibling;
        else {
          if (Lp(), r === i) {
            t = hc(e, t, n);
            break e;
          }
          xo(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return mz(t), e === null && DO(t), r = t.type, i = t.pendingProps, o = e !== null ? e.memoizedProps : null, a = i.children, RO(r, i) ? a = null : o !== null && RO(r, o) && (t.flags |= 32), Fz(e, t), xo(e, t, a, n), t.child;
    case 6:
      return e === null && DO(t), null;
    case 13:
      return zz(e, t, n);
    case 4:
      return DA(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Dp(t, null, r, n) : xo(e, t, r, n), t.child;
    case 11:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ts(r, i), a3(e, t, r, i, n);
    case 7:
      return xo(e, t, t.pendingProps, n), t.child;
    case 8:
      return xo(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return xo(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (r = t.type._context, i = t.pendingProps, o = t.memoizedProps, a = i.value, cr(r1, r._currentValue), r._currentValue = a, o !== null)
          if (Ks(o.value, a)) {
            if (o.children === i.children && !Ko.current) {
              t = hc(e, t, n);
              break e;
            }
          } else
            for (o = t.child, o !== null && (o.return = t); o !== null; ) {
              var s = o.dependencies;
              if (s !== null) {
                a = o.child;
                for (var l = s.firstContext; l !== null; ) {
                  if (l.context === r) {
                    if (o.tag === 1) {
                      l = lc(-1, n & -n), l.tag = 2;
                      var c = o.updateQueue;
                      if (c !== null) {
                        c = c.shared;
                        var f = c.pending;
                        f === null ? l.next = l : (l.next = f.next, f.next = l), c.pending = l;
                      }
                    }
                    o.lanes |= n, l = o.alternate, l !== null && (l.lanes |= n), jO(
                      o.return,
                      n,
                      t
                    ), s.lanes |= n;
                    break;
                  }
                  l = l.next;
                }
              } else if (o.tag === 10)
                a = o.type === t.type ? null : o.child;
              else if (o.tag === 18) {
                if (a = o.return, a === null)
                  throw Error(Ve(341));
                a.lanes |= n, s = a.alternate, s !== null && (s.lanes |= n), jO(a, n, t), a = o.sibling;
              } else
                a = o.child;
              if (a !== null)
                a.return = o;
              else
                for (a = o; a !== null; ) {
                  if (a === t) {
                    a = null;
                    break;
                  }
                  if (o = a.sibling, o !== null) {
                    o.return = a.return, a = o;
                    break;
                  }
                  a = a.return;
                }
              o = a;
            }
        xo(e, t, i.children, n), t = t.child;
      }
      return t;
    case 9:
      return i = t.type, r = t.pendingProps.children, gp(t, n), i = ns(i), r = r(i), t.flags |= 1, xo(e, t, r, n), t.child;
    case 14:
      return r = t.type, i = Ts(r, t.pendingProps), i = Ts(r.type, i), s3(e, t, r, i, n);
    case 15:
      return Dz(e, t, t.type, t.pendingProps, n);
    case 17:
      return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Ts(r, i), eb(e, t), t.tag = 1, qo(r) ? (e = !0, e1(t)) : e = !1, gp(t, n), dz(t, r, i), BO(t, r, i, n), HO(null, t, r, !0, e, n);
    case 19:
      return Uz(e, t, n);
    case 22:
      return jz(e, t, n);
  }
  throw Error(Ve(156, t.tag));
};
function iU(e, t) {
  return I8(e, t);
}
function Mse(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function Ya(e, t, n, r) {
  return new Mse(e, t, n, r);
}
function JA(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function Nse(e) {
  if (typeof e == "function")
    return JA(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === vA)
      return 11;
    if (e === yA)
      return 14;
  }
  return 2;
}
function bu(e, t) {
  var n = e.alternate;
  return n === null ? (n = Ya(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function rb(e, t, n, r, i, o) {
  var a = 2;
  if (r = e, typeof e == "function")
    JA(e) && (a = 1);
  else if (typeof e == "string")
    a = 5;
  else
    e:
      switch (e) {
        case Hd:
          return Pf(n.children, i, o, t);
        case gA:
          a = 8, i |= 8;
          break;
        case uO:
          return e = Ya(12, n, t, i | 2), e.elementType = uO, e.lanes = o, e;
        case fO:
          return e = Ya(13, n, t, i), e.elementType = fO, e.lanes = o, e;
        case dO:
          return e = Ya(19, n, t, i), e.elementType = dO, e.lanes = o, e;
        case p8:
          return $w(n, i, o, t);
        default:
          if (typeof e == "object" && e !== null)
            switch (e.$$typeof) {
              case f8:
                a = 10;
                break e;
              case d8:
                a = 9;
                break e;
              case vA:
                a = 11;
                break e;
              case yA:
                a = 14;
                break e;
              case Wc:
                a = 16, r = null;
                break e;
            }
          throw Error(Ve(130, e == null ? e : typeof e, ""));
      }
  return t = Ya(a, n, t, i), t.elementType = e, t.type = r, t.lanes = o, t;
}
function Pf(e, t, n, r) {
  return e = Ya(7, e, r, t), e.lanes = n, e;
}
function $w(e, t, n, r) {
  return e = Ya(22, e, r, t), e.elementType = p8, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
}
function i$(e, t, n) {
  return e = Ya(6, e, null, t), e.lanes = n, e;
}
function o$(e, t, n) {
  return t = Ya(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
}
function kse(e, t, n, r, i) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = FE(0), this.expirationTimes = FE(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = FE(0), this.identifierPrefix = r, this.onRecoverableError = i, this.mutableSourceEagerHydrationData = null;
}
function ZA(e, t, n, r, i, o, a, s, l) {
  return e = new kse(e, t, n, s, l), t === 1 ? (t = 1, o === !0 && (t |= 8)) : t = 0, o = Ya(3, null, null, t), e.current = o, o.stateNode = e, o.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, LA(o), e;
}
function Lse(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: Ud, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
}
function oU(e) {
  if (!e)
    return Eu;
  e = e._reactInternals;
  e: {
    if (Qf(e) !== e || e.tag !== 1)
      throw Error(Ve(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (qo(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(Ve(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (qo(n))
      return iz(e, n, t);
  }
  return t;
}
function aU(e, t, n, r, i, o, a, s, l) {
  return e = ZA(n, r, !0, e, i, o, a, s, l), e.context = oU(null), n = e.current, r = Oo(), i = yu(n), o = lc(r, i), o.callback = t ?? null, gu(n, o, i), e.current.lanes = i, ev(e, i, r), Yo(e, r), e;
}
function _w(e, t, n, r) {
  var i = t.current, o = Oo(), a = yu(i);
  return n = oU(n), t.context === null ? t.context = n : t.pendingContext = n, t = lc(o, a), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = gu(i, t, a), e !== null && (zs(e, i, a, o), Q0(e, i, a)), a;
}
function p1(e) {
  if (e = e.current, !e.child)
    return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function b3(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function eR(e, t) {
  b3(e, t), (e = e.alternate) && b3(e, t);
}
function Dse() {
  return null;
}
var sU = typeof reportError == "function" ? reportError : function(e) {
  console.error(e);
};
function tR(e) {
  this._internalRoot = e;
}
Ow.prototype.render = tR.prototype.render = function(e) {
  var t = this._internalRoot;
  if (t === null)
    throw Error(Ve(409));
  _w(e, t, null, null);
};
Ow.prototype.unmount = tR.prototype.unmount = function() {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    Df(function() {
      _w(null, e, null, null);
    }), t[dc] = null;
  }
};
function Ow(e) {
  this._internalRoot = e;
}
Ow.prototype.unstable_scheduleHydration = function(e) {
  if (e) {
    var t = D8();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < Kc.length && t !== 0 && t < Kc[n].priority; n++)
      ;
    Kc.splice(n, 0, e), n === 0 && F8(e);
  }
};
function nR(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function Pw(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function w3() {
}
function jse(e, t, n, r, i) {
  if (i) {
    if (typeof r == "function") {
      var o = r;
      r = function() {
        var c = p1(a);
        o.call(c);
      };
    }
    var a = aU(t, r, e, 0, null, !1, !1, "", w3);
    return e._reactRootContainer = a, e[dc] = a.current, vg(e.nodeType === 8 ? e.parentNode : e), Df(), a;
  }
  for (; i = e.lastChild; )
    e.removeChild(i);
  if (typeof r == "function") {
    var s = r;
    r = function() {
      var c = p1(l);
      s.call(c);
    };
  }
  var l = ZA(e, 0, !1, null, null, !1, !1, "", w3);
  return e._reactRootContainer = l, e[dc] = l.current, vg(e.nodeType === 8 ? e.parentNode : e), Df(function() {
    _w(t, l, n, r);
  }), l;
}
function Tw(e, t, n, r, i) {
  var o = n._reactRootContainer;
  if (o) {
    var a = o;
    if (typeof i == "function") {
      var s = i;
      i = function() {
        var l = p1(a);
        s.call(l);
      };
    }
    _w(t, a, e, i);
  } else
    a = jse(n, t, e, i, r);
  return p1(a);
}
k8 = function(e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = Rm(t.pendingLanes);
        n !== 0 && (SA(t, n | 1), Yo(t, qr()), !($n & 6) && (Bp = qr() + 500, Mu()));
      }
      break;
    case 13:
      Df(function() {
        var r = pc(e, 1);
        if (r !== null) {
          var i = Oo();
          zs(r, e, 1, i);
        }
      }), eR(e, 1);
  }
};
xA = function(e) {
  if (e.tag === 13) {
    var t = pc(e, 134217728);
    if (t !== null) {
      var n = Oo();
      zs(t, e, 134217728, n);
    }
    eR(e, 134217728);
  }
};
L8 = function(e) {
  if (e.tag === 13) {
    var t = yu(e), n = pc(e, t);
    if (n !== null) {
      var r = Oo();
      zs(n, e, t, r);
    }
    eR(e, t);
  }
};
D8 = function() {
  return Fn;
};
j8 = function(e, t) {
  var n = Fn;
  try {
    return Fn = e, t();
  } finally {
    Fn = n;
  }
};
xO = function(e, t, n) {
  switch (t) {
    case "input":
      if (mO(e, n), t = n.name, n.type === "radio" && t != null) {
        for (n = e; n.parentNode; )
          n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var i = bw(r);
            if (!i)
              throw Error(Ve(90));
            m8(r), mO(r, i);
          }
        }
      }
      break;
    case "textarea":
      v8(e, n);
      break;
    case "select":
      t = n.value, t != null && dp(e, !!n.multiple, t, !1);
  }
};
E8 = YA;
$8 = Df;
var Fse = { usingClientEntryPoint: !1, Events: [nv, Kd, bw, x8, C8, YA] }, mm = { findFiberByHostInstance: gf, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, Bse = { bundleType: mm.bundleType, version: mm.version, rendererPackageName: mm.rendererPackageName, rendererConfig: mm.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: wc.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = P8(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: mm.findFiberByHostInstance || Dse, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var r0 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!r0.isDisabled && r0.supportsFiber)
    try {
      mw = r0.inject(Bse), Ol = r0;
    } catch {
    }
}
Pa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Fse;
Pa.createPortal = function(e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!nR(t))
    throw Error(Ve(200));
  return Lse(e, t, null, n);
};
Pa.createRoot = function(e, t) {
  if (!nR(e))
    throw Error(Ve(299));
  var n = !1, r = "", i = sU;
  return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (i = t.onRecoverableError)), t = ZA(e, 1, !1, null, null, n, !1, r, i), e[dc] = t.current, vg(e.nodeType === 8 ? e.parentNode : e), new tR(t);
};
Pa.findDOMNode = function(e) {
  if (e == null)
    return null;
  if (e.nodeType === 1)
    return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function" ? Error(Ve(188)) : (e = Object.keys(e).join(","), Error(Ve(268, e)));
  return e = P8(t), e = e === null ? null : e.stateNode, e;
};
Pa.flushSync = function(e) {
  return Df(e);
};
Pa.hydrate = function(e, t, n) {
  if (!Pw(t))
    throw Error(Ve(200));
  return Tw(null, e, t, !0, n);
};
Pa.hydrateRoot = function(e, t, n) {
  if (!nR(e))
    throw Error(Ve(405));
  var r = n != null && n.hydratedSources || null, i = !1, o = "", a = sU;
  if (n != null && (n.unstable_strictMode === !0 && (i = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onRecoverableError !== void 0 && (a = n.onRecoverableError)), t = aU(t, null, e, 1, n ?? null, i, !1, o, a), e[dc] = t.current, vg(e), r)
    for (e = 0; e < r.length; e++)
      n = r[e], i = n._getVersion, i = i(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, i] : t.mutableSourceEagerHydrationData.push(
        n,
        i
      );
  return new Ow(t);
};
Pa.render = function(e, t, n) {
  if (!Pw(t))
    throw Error(Ve(200));
  return Tw(null, e, t, !1, n);
};
Pa.unmountComponentAtNode = function(e) {
  if (!Pw(e))
    throw Error(Ve(40));
  return e._reactRootContainer ? (Df(function() {
    Tw(null, null, e, !1, function() {
      e._reactRootContainer = null, e[dc] = null;
    });
  }), !0) : !1;
};
Pa.unstable_batchedUpdates = YA;
Pa.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
  if (!Pw(n))
    throw Error(Ve(200));
  if (e == null || e._reactInternals === void 0)
    throw Error(Ve(38));
  return Tw(e, t, n, !1, r);
};
Pa.version = "18.2.0-next-9e3b772b8-20220608";
function lU() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(lU);
    } catch (e) {
      console.error(e);
    }
}
lU(), a8.exports = Pa;
var js = a8.exports;
const fh = /* @__PURE__ */ Oi(js), zse = /* @__PURE__ */ MB({
  __proto__: null,
  default: fh
}, [js]), Use = ({ scrollTop: e, clientHeight: t, scrollHeight: n }) => Math.abs(e + t - n) < 1, cU = (e, t) => {
  const n = m.useRef(null), r = e || n, [i, o] = m.useState(!1);
  m.useEffect(() => {
    if (!r.current)
      return;
    const c = (f) => {
      const d = f.target;
      o(Use(d));
    };
    return r.current.addEventListener("scroll", c), r.current.clientHeight === r.current.scrollHeight && o(!0), () => {
      r.current && r.current.removeEventListener("scroll", c);
    };
  }, [r.current]);
  const a = () => {
    !r.current || !r.current.scrollTo || r.current.scrollTo({
      top: 0,
      behavior: "auto"
    });
  }, s = m.useCallback(() => {
    !r.current || !r.current.scrollTo || (r.current.scrollTo({
      top: r.current.scrollHeight - r.current.clientHeight,
      behavior: "auto"
    }), o(!0));
  }, [r]), l = m.useCallback(
    (c) => {
      !(t != null && t.current) || !r.current || (r.current.scrollTo({
        top: t.current.offsetTop - 5,
        behavior: "smooth",
        ...c
      }), o(!0));
    },
    [t, r]
  );
  return {
    nodeRef: r,
    scrollHeight: r.current ? r.current.scrollHeight : 0,
    wasBottom: i,
    scrollToTop: a,
    scrollToBottom: s,
    scrollToLastMessage: l
  };
};
var wu = /* @__PURE__ */ ((e) => (e.ONGOING = "ongoing", e.REPLYING = "replying", e.CLOSE = "close", e))(wu || {}), fi = /* @__PURE__ */ ((e) => (e.RECEIVED = "received", e.SENT = "sent", e))(fi || {}), $u = /* @__PURE__ */ ((e) => (e.Message = "message", e.RelatedQuestion = "related_question", e.StarterQuestion = "starter_question", e.CallToAction = "call_to_action", e))($u || {});
function Fs(e) {
  for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function(i) {
    return "'" + i + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function _u(e) {
  return !!e && !!e[Cr];
}
function mc(e) {
  var t;
  return !!e && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var i = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return i === Object || typeof i == "function" && Function.toString.call(i) === Xse;
  }(e) || Array.isArray(e) || !!e[O3] || !!(!((t = e.constructor) === null || t === void 0) && t[O3]) || rR(e) || iR(e));
}
function jf(e, t, n) {
  n === void 0 && (n = !1), dh(e) === 0 ? (n ? Object.keys : bp)(e).forEach(function(r) {
    n && typeof r == "symbol" || t(r, e[r], e);
  }) : e.forEach(function(r, i) {
    return t(i, r, e);
  });
}
function dh(e) {
  var t = e[Cr];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : rR(e) ? 2 : iR(e) ? 3 : 0;
}
function yp(e, t) {
  return dh(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Hse(e, t) {
  return dh(e) === 2 ? e.get(t) : e[t];
}
function uU(e, t, n) {
  var r = dh(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function fU(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function rR(e) {
  return qse && e instanceof Map;
}
function iR(e) {
  return Yse && e instanceof Set;
}
function Zu(e) {
  return e.o || e.t;
}
function oR(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = hU(e);
  delete t[Cr];
  for (var n = bp(t), r = 0; r < n.length; r++) {
    var i = n[r], o = t[i];
    o.writable === !1 && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = { configurable: !0, writable: !0, enumerable: o.enumerable, value: e[i] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function aR(e, t) {
  return t === void 0 && (t = !1), sR(e) || _u(e) || !mc(e) || (dh(e) > 1 && (e.set = e.add = e.clear = e.delete = Wse), Object.freeze(e), t && jf(e, function(n, r) {
    return aR(r, !0);
  }, !0)), e;
}
function Wse() {
  Fs(2);
}
function sR(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function Tl(e) {
  var t = iP[e];
  return t || Fs(18, e), t;
}
function Vse(e, t) {
  iP[e] || (iP[e] = t);
}
function tP() {
  return _g;
}
function a$(e, t) {
  t && (Tl("Patches"), e.u = [], e.s = [], e.v = t);
}
function h1(e) {
  nP(e), e.p.forEach(Gse), e.p = null;
}
function nP(e) {
  e === _g && (_g = e.l);
}
function S3(e) {
  return _g = { p: [], l: _g, h: e, m: !0, _: 0 };
}
function Gse(e) {
  var t = e[Cr];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function s$(e, t) {
  t._ = t.p.length;
  var n = t.p[0], r = e !== void 0 && e !== n;
  return t.h.O || Tl("ES5").S(t, e, r), r ? (n[Cr].P && (h1(t), Fs(4)), mc(e) && (e = m1(t, e), t.l || g1(t, e)), t.u && Tl("Patches").M(n[Cr].t, e, t.u, t.s)) : e = m1(t, n, []), h1(t), t.u && t.v(t.u, t.s), e !== pU ? e : void 0;
}
function m1(e, t, n) {
  if (sR(t))
    return t;
  var r = t[Cr];
  if (!r)
    return jf(t, function(s, l) {
      return x3(e, r, t, s, l, n);
    }, !0), t;
  if (r.A !== e)
    return t;
  if (!r.P)
    return g1(e, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var i = r.i === 4 || r.i === 5 ? r.o = oR(r.k) : r.o, o = i, a = !1;
    r.i === 3 && (o = new Set(i), i.clear(), a = !0), jf(o, function(s, l) {
      return x3(e, r, i, s, l, n, a);
    }), g1(e, i, !1), n && e.u && Tl("Patches").N(r, n, e.u, e.s);
  }
  return r.o;
}
function x3(e, t, n, r, i, o, a) {
  if (_u(i)) {
    var s = m1(e, i, o && t && t.i !== 3 && !yp(t.R, r) ? o.concat(r) : void 0);
    if (uU(n, r, s), !_u(s))
      return;
    e.m = !1;
  } else
    a && n.add(i);
  if (mc(i) && !sR(i)) {
    if (!e.h.D && e._ < 1)
      return;
    m1(e, i), t && t.A.l || g1(e, i);
  }
}
function g1(e, t, n) {
  n === void 0 && (n = !1), !e.l && e.h.D && e.m && aR(t, n);
}
function l$(e, t) {
  var n = e[Cr];
  return (n ? Zu(n) : e)[t];
}
function C3(e, t) {
  if (t in e)
    for (var n = Object.getPrototypeOf(e); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function Yc(e) {
  e.P || (e.P = !0, e.l && Yc(e.l));
}
function c$(e) {
  e.o || (e.o = oR(e.t));
}
function rP(e, t, n) {
  var r = rR(t) ? Tl("MapSet").F(t, n) : iR(t) ? Tl("MapSet").T(t, n) : e.O ? function(i, o) {
    var a = Array.isArray(i), s = { i: a ? 1 : 0, A: o ? o.A : tP(), P: !1, I: !1, R: {}, l: o, t: i, k: null, o: null, j: null, C: !1 }, l = s, c = Og;
    a && (l = [s], c = Nm);
    var f = Proxy.revocable(l, c), d = f.revoke, p = f.proxy;
    return s.k = p, s.j = d, p;
  }(t, n) : Tl("ES5").J(t, n);
  return (n ? n.A : tP()).p.push(r), r;
}
function dU(e) {
  return _u(e) || Fs(22, e), function t(n) {
    if (!mc(n))
      return n;
    var r, i = n[Cr], o = dh(n);
    if (i) {
      if (!i.P && (i.i < 4 || !Tl("ES5").K(i)))
        return i.t;
      i.I = !0, r = E3(n, o), i.I = !1;
    } else
      r = E3(n, o);
    return jf(r, function(a, s) {
      i && Hse(i.t, a) === s || uU(r, a, t(s));
    }), o === 3 ? new Set(r) : r;
  }(e);
}
function E3(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return oR(e);
}
function Kse() {
  function e(o, a) {
    var s = i[o];
    return s ? s.enumerable = a : i[o] = s = { configurable: !0, enumerable: a, get: function() {
      var l = this[Cr];
      return Og.get(l, o);
    }, set: function(l) {
      var c = this[Cr];
      Og.set(c, o, l);
    } }, s;
  }
  function t(o) {
    for (var a = o.length - 1; a >= 0; a--) {
      var s = o[a][Cr];
      if (!s.P)
        switch (s.i) {
          case 5:
            r(s) && Yc(s);
            break;
          case 4:
            n(s) && Yc(s);
        }
    }
  }
  function n(o) {
    for (var a = o.t, s = o.k, l = bp(s), c = l.length - 1; c >= 0; c--) {
      var f = l[c];
      if (f !== Cr) {
        var d = a[f];
        if (d === void 0 && !yp(a, f))
          return !0;
        var p = s[f], g = p && p[Cr];
        if (g ? g.t !== d : !fU(p, d))
          return !0;
      }
    }
    var v = !!a[Cr];
    return l.length !== bp(a).length + (v ? 0 : 1);
  }
  function r(o) {
    var a = o.k;
    if (a.length !== o.t.length)
      return !0;
    var s = Object.getOwnPropertyDescriptor(a, a.length - 1);
    if (s && !s.get)
      return !0;
    for (var l = 0; l < a.length; l++)
      if (!a.hasOwnProperty(l))
        return !0;
    return !1;
  }
  var i = {};
  Vse("ES5", { J: function(o, a) {
    var s = Array.isArray(o), l = function(f, d) {
      if (f) {
        for (var p = Array(d.length), g = 0; g < d.length; g++)
          Object.defineProperty(p, "" + g, e(g, !0));
        return p;
      }
      var v = hU(d);
      delete v[Cr];
      for (var y = bp(v), x = 0; x < y.length; x++) {
        var b = y[x];
        v[b] = e(b, f || !!v[b].enumerable);
      }
      return Object.create(Object.getPrototypeOf(d), v);
    }(s, o), c = { i: s ? 5 : 4, A: a ? a.A : tP(), P: !1, I: !1, R: {}, l: a, t: o, k: l, o: null, g: !1, C: !1 };
    return Object.defineProperty(l, Cr, { value: c, writable: !0 }), l;
  }, S: function(o, a, s) {
    s ? _u(a) && a[Cr].A === o && t(o.p) : (o.u && function l(c) {
      if (c && typeof c == "object") {
        var f = c[Cr];
        if (f) {
          var d = f.t, p = f.k, g = f.R, v = f.i;
          if (v === 4)
            jf(p, function(S) {
              S !== Cr && (d[S] !== void 0 || yp(d, S) ? g[S] || l(p[S]) : (g[S] = !0, Yc(f)));
            }), jf(d, function(S) {
              p[S] !== void 0 || yp(p, S) || (g[S] = !1, Yc(f));
            });
          else if (v === 5) {
            if (r(f) && (Yc(f), g.length = !0), p.length < d.length)
              for (var y = p.length; y < d.length; y++)
                g[y] = !1;
            else
              for (var x = d.length; x < p.length; x++)
                g[x] = !0;
            for (var b = Math.min(p.length, d.length), w = 0; w < b; w++)
              p.hasOwnProperty(w) || (g[w] = !0), g[w] === void 0 && l(p[w]);
          }
        }
      }
    }(o.p[0]), t(o.p));
  }, K: function(o) {
    return o.i === 4 ? n(o) : r(o);
  } });
}
var $3, _g, lR = typeof Symbol < "u" && typeof Symbol("x") == "symbol", qse = typeof Map < "u", Yse = typeof Set < "u", _3 = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", pU = lR ? Symbol.for("immer-nothing") : (($3 = {})["immer-nothing"] = !0, $3), O3 = lR ? Symbol.for("immer-draftable") : "__$immer_draftable", Cr = lR ? Symbol.for("immer-state") : "__$immer_state", Xse = "" + Object.prototype.constructor, bp = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, hU = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return bp(e).forEach(function(n) {
    t[n] = Object.getOwnPropertyDescriptor(e, n);
  }), t;
}, iP = {}, Og = { get: function(e, t) {
  if (t === Cr)
    return e;
  var n = Zu(e);
  if (!yp(n, t))
    return function(i, o, a) {
      var s, l = C3(o, a);
      return l ? "value" in l ? l.value : (s = l.get) === null || s === void 0 ? void 0 : s.call(i.k) : void 0;
    }(e, n, t);
  var r = n[t];
  return e.I || !mc(r) ? r : r === l$(e.t, t) ? (c$(e), e.o[t] = rP(e.A.h, r, e)) : r;
}, has: function(e, t) {
  return t in Zu(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(Zu(e));
}, set: function(e, t, n) {
  var r = C3(Zu(e), t);
  if (r != null && r.set)
    return r.set.call(e.k, n), !0;
  if (!e.P) {
    var i = l$(Zu(e), t), o = i == null ? void 0 : i[Cr];
    if (o && o.t === n)
      return e.o[t] = n, e.R[t] = !1, !0;
    if (fU(n, i) && (n !== void 0 || yp(e.t, t)))
      return !0;
    c$(e), Yc(e);
  }
  return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return l$(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, c$(e), Yc(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var n = Zu(e), r = Reflect.getOwnPropertyDescriptor(n, t);
  return r && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: r.enumerable, value: n[t] };
}, defineProperty: function() {
  Fs(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  Fs(12);
} }, Nm = {};
jf(Og, function(e, t) {
  Nm[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), Nm.deleteProperty = function(e, t) {
  return Nm.set.call(this, e, t, void 0);
}, Nm.set = function(e, t, n) {
  return Og.set.call(this, e[0], t, n, e[0]);
};
var Qse = function() {
  function e(n) {
    var r = this;
    this.O = _3, this.D = !0, this.produce = function(i, o, a) {
      if (typeof i == "function" && typeof o != "function") {
        var s = o;
        o = i;
        var l = r;
        return function(y) {
          var x = this;
          y === void 0 && (y = s);
          for (var b = arguments.length, w = Array(b > 1 ? b - 1 : 0), S = 1; S < b; S++)
            w[S - 1] = arguments[S];
          return l.produce(y, function(E) {
            var O;
            return (O = o).call.apply(O, [x, E].concat(w));
          });
        };
      }
      var c;
      if (typeof o != "function" && Fs(6), a !== void 0 && typeof a != "function" && Fs(7), mc(i)) {
        var f = S3(r), d = rP(r, i, void 0), p = !0;
        try {
          c = o(d), p = !1;
        } finally {
          p ? h1(f) : nP(f);
        }
        return typeof Promise < "u" && c instanceof Promise ? c.then(function(y) {
          return a$(f, a), s$(y, f);
        }, function(y) {
          throw h1(f), y;
        }) : (a$(f, a), s$(c, f));
      }
      if (!i || typeof i != "object") {
        if ((c = o(i)) === void 0 && (c = i), c === pU && (c = void 0), r.D && aR(c, !0), a) {
          var g = [], v = [];
          Tl("Patches").M(i, c, g, v), a(g, v);
        }
        return c;
      }
      Fs(21, i);
    }, this.produceWithPatches = function(i, o) {
      if (typeof i == "function")
        return function(c) {
          for (var f = arguments.length, d = Array(f > 1 ? f - 1 : 0), p = 1; p < f; p++)
            d[p - 1] = arguments[p];
          return r.produceWithPatches(c, function(g) {
            return i.apply(void 0, [g].concat(d));
          });
        };
      var a, s, l = r.produce(i, o, function(c, f) {
        a = c, s = f;
      });
      return typeof Promise < "u" && l instanceof Promise ? l.then(function(c) {
        return [c, a, s];
      }) : [l, a, s];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(n) {
    mc(n) || Fs(8), _u(n) && (n = dU(n));
    var r = S3(this), i = rP(this, n, void 0);
    return i[Cr].C = !0, nP(r), i;
  }, t.finishDraft = function(n, r) {
    var i = n && n[Cr], o = i.A;
    return a$(o, r), s$(void 0, o);
  }, t.setAutoFreeze = function(n) {
    this.D = n;
  }, t.setUseProxies = function(n) {
    n && !_3 && Fs(20), this.O = n;
  }, t.applyPatches = function(n, r) {
    var i;
    for (i = r.length - 1; i >= 0; i--) {
      var o = r[i];
      if (o.path.length === 0 && o.op === "replace") {
        n = o.value;
        break;
      }
    }
    i > -1 && (r = r.slice(i + 1));
    var a = Tl("Patches").$;
    return _u(n) ? a(n, r) : this.produce(n, function(s) {
      return a(s, r);
    });
  }, e;
}(), _a = new Qse(), mU = _a.produce;
_a.produceWithPatches.bind(_a);
_a.setAutoFreeze.bind(_a);
_a.setUseProxies.bind(_a);
_a.applyPatches.bind(_a);
_a.createDraft.bind(_a);
_a.finishDraft.bind(_a);
function nn(e) {
  "@babel/helpers - typeof";
  return nn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nn(e);
}
function Jse(e, t) {
  if (nn(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (nn(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gU(e) {
  var t = Jse(e, "string");
  return nn(t) === "symbol" ? t : String(t);
}
function ce(e, t, n) {
  return t = gU(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function P3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ye(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? P3(Object(n), !0).forEach(function(r) {
      ce(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function so(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var T3 = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), u$ = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, v1 = {
  INIT: "@@redux/INIT" + u$(),
  REPLACE: "@@redux/REPLACE" + u$(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + u$();
  }
};
function Zse(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function cR(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(so(0));
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(so(1));
    return n(cR)(e, t);
  }
  if (typeof e != "function")
    throw new Error(so(2));
  var i = e, o = t, a = [], s = a, l = !1;
  function c() {
    s === a && (s = a.slice());
  }
  function f() {
    if (l)
      throw new Error(so(3));
    return o;
  }
  function d(y) {
    if (typeof y != "function")
      throw new Error(so(4));
    if (l)
      throw new Error(so(5));
    var x = !0;
    return c(), s.push(y), function() {
      if (x) {
        if (l)
          throw new Error(so(6));
        x = !1, c();
        var w = s.indexOf(y);
        s.splice(w, 1), a = null;
      }
    };
  }
  function p(y) {
    if (!Zse(y))
      throw new Error(so(7));
    if (typeof y.type > "u")
      throw new Error(so(8));
    if (l)
      throw new Error(so(9));
    try {
      l = !0, o = i(o, y);
    } finally {
      l = !1;
    }
    for (var x = a = s, b = 0; b < x.length; b++) {
      var w = x[b];
      w();
    }
    return y;
  }
  function g(y) {
    if (typeof y != "function")
      throw new Error(so(10));
    i = y, p({
      type: v1.REPLACE
    });
  }
  function v() {
    var y, x = d;
    return y = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(w) {
        if (typeof w != "object" || w === null)
          throw new Error(so(11));
        function S() {
          w.next && w.next(f());
        }
        S();
        var E = x(S);
        return {
          unsubscribe: E
        };
      }
    }, y[T3] = function() {
      return this;
    }, y;
  }
  return p({
    type: v1.INIT
  }), r = {
    dispatch: p,
    subscribe: d,
    getState: f,
    replaceReducer: g
  }, r[T3] = v, r;
}
function ele(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], r = n(void 0, {
      type: v1.INIT
    });
    if (typeof r > "u")
      throw new Error(so(12));
    if (typeof n(void 0, {
      type: v1.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(so(13));
  });
}
function uR(e) {
  for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
    var i = t[r];
    typeof e[i] == "function" && (n[i] = e[i]);
  }
  var o = Object.keys(n), a;
  try {
    ele(n);
  } catch (s) {
    a = s;
  }
  return function(l, c) {
    if (l === void 0 && (l = {}), a)
      throw a;
    for (var f = !1, d = {}, p = 0; p < o.length; p++) {
      var g = o[p], v = n[g], y = l[g], x = v(y, c);
      if (typeof x > "u")
        throw c && c.type, new Error(so(14));
      d[g] = x, f = f || x !== y;
    }
    return f = f || o.length !== Object.keys(l).length, f ? d : l;
  };
}
function y1() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, i) {
    return function() {
      return r(i.apply(void 0, arguments));
    };
  });
}
function tle() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var i = r.apply(void 0, arguments), o = function() {
        throw new Error(so(15));
      }, a = {
        getState: i.getState,
        dispatch: function() {
          return o.apply(void 0, arguments);
        }
      }, s = t.map(function(l) {
        return l(a);
      });
      return o = y1.apply(void 0, s)(i.dispatch), ye(ye({}, i), {}, {
        dispatch: o
      });
    };
  };
}
function vU(e) {
  var t = function(r) {
    var i = r.dispatch, o = r.getState;
    return function(a) {
      return function(s) {
        return typeof s == "function" ? s(i, o, e) : a(s);
      };
    };
  };
  return t;
}
var yU = vU();
yU.withExtraArgument = vU;
const I3 = yU;
var bU = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), nle = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(f) {
      return l([c, f]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = c;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(c);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (f) {
        c = [6, f], i = 0;
      } finally {
        r = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, zp = function(e, t) {
  for (var n = 0, r = t.length, i = e.length; n < r; n++, i++)
    e[i] = t[n];
  return e;
}, rle = Object.defineProperty, ile = Object.defineProperties, ole = Object.getOwnPropertyDescriptors, A3 = Object.getOwnPropertySymbols, ale = Object.prototype.hasOwnProperty, sle = Object.prototype.propertyIsEnumerable, R3 = function(e, t, n) {
  return t in e ? rle(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
}, Su = function(e, t) {
  for (var n in t || (t = {}))
    ale.call(t, n) && R3(e, n, t[n]);
  if (A3)
    for (var r = 0, i = A3(t); r < i.length; r++) {
      var n = i[r];
      sle.call(t, n) && R3(e, n, t[n]);
    }
  return e;
}, f$ = function(e, t) {
  return ile(e, ole(t));
}, lle = function(e, t, n) {
  return new Promise(function(r, i) {
    var o = function(l) {
      try {
        s(n.next(l));
      } catch (c) {
        i(c);
      }
    }, a = function(l) {
      try {
        s(n.throw(l));
      } catch (c) {
        i(c);
      }
    }, s = function(l) {
      return l.done ? r(l.value) : Promise.resolve(l.value).then(o, a);
    };
    s((n = n.apply(e, t)).next());
  });
}, cle = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? y1 : y1.apply(null, arguments);
};
function ule(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
var fle = (
  /** @class */
  function(e) {
    bU(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var i = e.apply(this, n) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, zp([void 0], n[0].concat(this))))() : new (t.bind.apply(t, zp([void 0], n.concat(this))))();
    }, t;
  }(Array)
), dle = (
  /** @class */
  function(e) {
    bU(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var i = e.apply(this, n) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, zp([void 0], n[0].concat(this))))() : new (t.bind.apply(t, zp([void 0], n.concat(this))))();
    }, t;
  }(Array)
);
function oP(e) {
  return mc(e) ? mU(e, function() {
  }) : e;
}
function ple(e) {
  return typeof e == "boolean";
}
function hle() {
  return function(t) {
    return mle(t);
  };
}
function mle(e) {
  e === void 0 && (e = {});
  var t = e.thunk, n = t === void 0 ? !0 : t;
  e.immutableCheck, e.serializableCheck;
  var r = new fle();
  return n && (ple(n) ? r.push(I3) : r.push(I3.withExtraArgument(n.extraArgument))), r;
}
var gle = !0;
function wU(e) {
  var t = hle(), n = e || {}, r = n.reducer, i = r === void 0 ? void 0 : r, o = n.middleware, a = o === void 0 ? t() : o, s = n.devTools, l = s === void 0 ? !0 : s, c = n.preloadedState, f = c === void 0 ? void 0 : c, d = n.enhancers, p = d === void 0 ? void 0 : d, g;
  if (typeof i == "function")
    g = i;
  else if (ule(i))
    g = uR(i);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var v = a;
  typeof v == "function" && (v = v(t));
  var y = tle.apply(void 0, v), x = y1;
  l && (x = cle(Su({
    trace: !gle
  }, typeof l == "object" && l)));
  var b = new dle(y), w = b;
  Array.isArray(p) ? w = zp([y], p) : typeof p == "function" && (w = p(b));
  var S = x.apply(void 0, w);
  return cR(g, f, S);
}
function Po(e, t) {
  function n() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    if (t) {
      var o = t.apply(void 0, r);
      if (!o)
        throw new Error("prepareAction did not return an object");
      return Su(Su({
        type: e,
        payload: o.payload
      }, "meta" in o && { meta: o.meta }), "error" in o && { error: o.error });
    }
    return { type: e, payload: r[0] };
  }
  return n.toString = function() {
    return "" + e;
  }, n.type = e, n.match = function(r) {
    return r.type === e;
  }, n;
}
function SU(e) {
  var t = {}, n = [], r, i = {
    addCase: function(o, a) {
      var s = typeof o == "string" ? o : o.type;
      if (s in t)
        throw new Error("addCase cannot be called with two reducers for the same action type");
      return t[s] = a, i;
    },
    addMatcher: function(o, a) {
      return n.push({ matcher: o, reducer: a }), i;
    },
    addDefaultCase: function(o) {
      return r = o, i;
    }
  };
  return e(i), [t, n, r];
}
function vle(e) {
  return typeof e == "function";
}
function yle(e, t, n, r) {
  n === void 0 && (n = []);
  var i = typeof t == "function" ? SU(t) : [t, n, r], o = i[0], a = i[1], s = i[2], l;
  if (vle(e))
    l = function() {
      return oP(e());
    };
  else {
    var c = oP(e);
    l = function() {
      return c;
    };
  }
  function f(d, p) {
    d === void 0 && (d = l());
    var g = zp([
      o[p.type]
    ], a.filter(function(v) {
      var y = v.matcher;
      return y(p);
    }).map(function(v) {
      var y = v.reducer;
      return y;
    }));
    return g.filter(function(v) {
      return !!v;
    }).length === 0 && (g = [s]), g.reduce(function(v, y) {
      if (y)
        if (_u(v)) {
          var x = v, b = y(x, p);
          return b === void 0 ? v : b;
        } else {
          if (mc(v))
            return mU(v, function(w) {
              return y(w, p);
            });
          var b = y(v, p);
          if (b === void 0) {
            if (v === null)
              return v;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return b;
        }
      return v;
    }, d);
  }
  return f.getInitialState = l, f;
}
function ble(e, t) {
  return e + "/" + t;
}
function Iw(e) {
  var t = e.name;
  if (!t)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u";
  var n = typeof e.initialState == "function" ? e.initialState : oP(e.initialState), r = e.reducers || {}, i = Object.keys(r), o = {}, a = {}, s = {};
  i.forEach(function(f) {
    var d = r[f], p = ble(t, f), g, v;
    "reducer" in d ? (g = d.reducer, v = d.prepare) : g = d, o[f] = g, a[p] = g, s[f] = v ? Po(p, v) : Po(p);
  });
  function l() {
    var f = typeof e.extraReducers == "function" ? SU(e.extraReducers) : [e.extraReducers], d = f[0], p = d === void 0 ? {} : d, g = f[1], v = g === void 0 ? [] : g, y = f[2], x = y === void 0 ? void 0 : y, b = Su(Su({}, p), a);
    return yle(n, function(w) {
      for (var S in b)
        w.addCase(S, b[S]);
      for (var E = 0, O = v; E < O.length; E++) {
        var $ = O[E];
        w.addMatcher($.matcher, $.reducer);
      }
      x && w.addDefaultCase(x);
    });
  }
  var c;
  return {
    name: t,
    reducer: function(f, d) {
      return c || (c = l()), c(f, d);
    },
    actions: s,
    caseReducers: o,
    getInitialState: function() {
      return c || (c = l()), c.getInitialState();
    }
  };
}
var wle = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Sle = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", n = e; n--; )
    t += wle[Math.random() * 64 | 0];
  return t;
}, xle = [
  "name",
  "message",
  "stack",
  "code"
], d$ = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), M3 = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), Cle = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, n = 0, r = xle; n < r.length; n++) {
      var i = r[n];
      typeof e[i] == "string" && (t[i] = e[i]);
    }
    return t;
  }
  return { message: String(e) };
}, Nu = function() {
  function e(t, n, r) {
    var i = Po(t + "/fulfilled", function(c, f, d, p) {
      return {
        payload: c,
        meta: f$(Su({}, p || {}), {
          arg: d,
          requestId: f,
          requestStatus: "fulfilled"
        })
      };
    }), o = Po(t + "/pending", function(c, f, d) {
      return {
        payload: void 0,
        meta: f$(Su({}, d || {}), {
          arg: f,
          requestId: c,
          requestStatus: "pending"
        })
      };
    }), a = Po(t + "/rejected", function(c, f, d, p, g) {
      return {
        payload: p,
        error: (r && r.serializeError || Cle)(c || "Rejected"),
        meta: f$(Su({}, g || {}), {
          arg: d,
          requestId: f,
          rejectedWithValue: !!p,
          requestStatus: "rejected",
          aborted: (c == null ? void 0 : c.name) === "AbortError",
          condition: (c == null ? void 0 : c.name) === "ConditionError"
        })
      };
    }), s = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function c() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return c.prototype.abort = function() {
        }, c;
      }()
    );
    function l(c) {
      return function(f, d, p) {
        var g = r != null && r.idGenerator ? r.idGenerator(c) : Sle(), v = new s(), y;
        function x(w) {
          y = w, v.abort();
        }
        var b = function() {
          return lle(this, null, function() {
            var w, S, E, O, $, P, R;
            return nle(this, function(L) {
              switch (L.label) {
                case 0:
                  return L.trys.push([0, 4, , 5]), O = (w = r == null ? void 0 : r.condition) == null ? void 0 : w.call(r, c, { getState: d, extra: p }), $le(O) ? [4, O] : [3, 2];
                case 1:
                  O = L.sent(), L.label = 2;
                case 2:
                  if (O === !1 || v.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return $ = new Promise(function(B, j) {
                    return v.signal.addEventListener("abort", function() {
                      return j({
                        name: "AbortError",
                        message: y || "Aborted"
                      });
                    });
                  }), f(o(g, c, (S = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : S.call(r, { requestId: g, arg: c }, { getState: d, extra: p }))), [4, Promise.race([
                    $,
                    Promise.resolve(n(c, {
                      dispatch: f,
                      getState: d,
                      extra: p,
                      requestId: g,
                      signal: v.signal,
                      abort: x,
                      rejectWithValue: function(B, j) {
                        return new d$(B, j);
                      },
                      fulfillWithValue: function(B, j) {
                        return new M3(B, j);
                      }
                    })).then(function(B) {
                      if (B instanceof d$)
                        throw B;
                      return B instanceof M3 ? i(B.payload, g, c, B.meta) : i(B, g, c);
                    })
                  ])];
                case 3:
                  return E = L.sent(), [3, 5];
                case 4:
                  return P = L.sent(), E = P instanceof d$ ? a(null, g, c, P.payload, P.meta) : a(P, g, c), [3, 5];
                case 5:
                  return R = r && !r.dispatchConditionRejection && a.match(E) && E.meta.condition, R || f(E), [2, E];
              }
            });
          });
        }();
        return Object.assign(b, {
          abort: x,
          requestId: g,
          arg: c,
          unwrap: function() {
            return b.then(Ele);
          }
        });
      };
    }
    return Object.assign(l, {
      pending: o,
      rejected: a,
      fulfilled: i,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
}();
function Ele(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function $le(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var fR = "listenerMiddleware";
Po(fR + "/add");
Po(fR + "/removeAll");
Po(fR + "/remove");
var N3;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
Kse();
const ib = Po("app/wbChatThemeUpdated"), Aw = Po(
  "app/receiveMessageReplied"
), xU = Po(
  "app/receiveStreamingMessage"
), dR = Po(
  "app/receiveStreamingMessageDone"
), CU = Po(
  "app/receiveMessageRepliedAndStreamingDone"
), ep = Po("app/pusherConnectChange");
class ii {
  constructor(t) {
    this.featureName = t;
  }
  isFeatureEnabled() {
    return ("SEND_LEAD_CREATED_EVENT_FEATURE,EVENT_LOG_IMPRESSION,INDEPENDENT_LAUNCHER,MULTIPLE_BOT_STORE,CREATE_CONVERSATION_WITH_SAME_UUID,CONVERSATION_WITH_EACH_PAGE,ANSWER_RATING,STORE_USER_BEHAVIOR_DATA,USER_ACTION_BOX,WEBCHAT_PURE_SCRIPT,CHAT_BUBBLE_NEW_PLACEMENT,CHAT_BUBBLE_NEW_PLACEMENT_2,USE_API_CLIENT,INVITATION_MODAL,CHAT_BUBBLE_SUPPORT_GIF,SITE_COMPANION_LOADING_ANIMATION,STREAMING_MESSAGE,RELATED_QUESTION_API,SITE_COMPANION_LOADING_ANIMATION_2".split(",").map((n) => n.trim()) ?? []).includes(this.featureName);
  }
}
class _le extends Error {
  constructor(t = "Invalid command") {
    super(t), this.name = "InvalidCommandError";
  }
}
class EU {
  constructor() {
  }
  async perform(t) {
    if (!await (t == null ? void 0 : t.validate()))
      throw new _le("The provided command is invalid");
    return this.action(t);
  }
}
var $U = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = t.type, this.name = t.name, this.target = t.target, this.propertyName = t.propertyName, this.constraints = t == null ? void 0 : t.constraints, this.constraintCls = t.constraintCls, this.validationTypeOptions = t.validationTypeOptions, t.validationOptions && (this.message = t.validationOptions.message, this.groups = t.validationOptions.groups, this.always = t.validationOptions.always, this.each = t.validationOptions.each, this.context = t.validationOptions.context);
    }
    return e;
  }()
), Ole = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.transform = function(t) {
      var n = [];
      return Object.keys(t.properties).forEach(function(r) {
        t.properties[r].forEach(function(i) {
          var o = {
            message: i.message,
            groups: i.groups,
            always: i.always,
            each: i.each
          }, a = {
            type: i.type,
            name: i.name,
            target: t.name,
            propertyName: r,
            constraints: i.constraints,
            validationTypeOptions: i.options,
            validationOptions: o
          };
          n.push(new $U(a));
        });
      }), n;
    }, e;
  }()
);
function Ple(e) {
  return e instanceof Map ? Array.from(e.values()) : Array.isArray(e) ? e : Array.from(e);
}
function Tle() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function p$(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var Ile = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, k3 = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Ale = function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, _U = (
  /** @class */
  function() {
    function e() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(e.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addValidationSchema = function(t) {
      var n = this, r = new Ole().transform(t);
      r.forEach(function(i) {
        return n.addValidationMetadata(i);
      });
    }, e.prototype.addValidationMetadata = function(t) {
      var n = this.validationMetadatas.get(t.target);
      n ? n.push(t) : this.validationMetadatas.set(t.target, [t]);
    }, e.prototype.addConstraintMetadata = function(t) {
      var n = this.constraintMetadatas.get(t.target);
      n ? n.push(t) : this.constraintMetadatas.set(t.target, [t]);
    }, e.prototype.groupByPropertyName = function(t) {
      var n = {};
      return t.forEach(function(r) {
        n[r.propertyName] || (n[r.propertyName] = []), n[r.propertyName].push(r);
      }), n;
    }, e.prototype.getTargetValidationMetadatas = function(t, n, r, i, o) {
      var a, s, l = function(E) {
        return typeof E.always < "u" ? E.always : E.groups && E.groups.length ? !1 : r;
      }, c = function(E) {
        return !!(i && (!o || !o.length) && E.groups && E.groups.length);
      }, f = this.validationMetadatas.get(t) || [], d = f.filter(function(E) {
        return E.target !== t && E.target !== n ? !1 : l(E) ? !0 : c(E) ? !1 : o && o.length > 0 ? E.groups && !!E.groups.find(function(O) {
          return o.indexOf(O) !== -1;
        }) : !0;
      }), p = [];
      try {
        for (var g = Ile(this.validationMetadatas.entries()), v = g.next(); !v.done; v = g.next()) {
          var y = k3(v.value, 2), x = y[0], b = y[1];
          t.prototype instanceof x && p.push.apply(p, Ale([], k3(b), !1));
        }
      } catch (E) {
        a = { error: E };
      } finally {
        try {
          v && !v.done && (s = g.return) && s.call(g);
        } finally {
          if (a)
            throw a.error;
        }
      }
      var w = p.filter(function(E) {
        return typeof E.target == "string" || E.target === t || E.target instanceof Function && !(t.prototype instanceof E.target) ? !1 : l(E) ? !0 : c(E) ? !1 : o && o.length > 0 ? E.groups && !!E.groups.find(function(O) {
          return o.indexOf(O) !== -1;
        }) : !0;
      }), S = w.filter(function(E) {
        return !d.find(function(O) {
          return O.propertyName === E.propertyName && O.type === E.type;
        });
      });
      return d.concat(S);
    }, e.prototype.getTargetValidatorConstraints = function(t) {
      return this.constraintMetadatas.get(t) || [];
    }, e;
  }()
);
function aP() {
  var e = Tle();
  return e.classValidatorMetadataStorage || (e.classValidatorMetadataStorage = new _U()), e.classValidatorMetadataStorage;
}
var L3 = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.toString = function(t, n, r, i) {
      var o = this;
      t === void 0 && (t = !1), n === void 0 && (n = !1), r === void 0 && (r = ""), i === void 0 && (i = !1);
      var a = t ? "\x1B[1m" : "", s = t ? "\x1B[22m" : "", l = function() {
        var d;
        return (i ? Object.values : Object.keys)((d = o.constraints) !== null && d !== void 0 ? d : {}).join(", ");
      }, c = function(d) {
        return " - property ".concat(a).concat(r).concat(d).concat(s, " has failed the following constraints: ").concat(a).concat(l()).concat(s, ` 
`);
      };
      if (n) {
        var f = Number.isInteger(+this.property) ? "[".concat(this.property, "]") : "".concat(r ? "." : "").concat(this.property);
        return this.constraints ? c(f) : this.children ? this.children.map(function(d) {
          return d.toString(t, !0, "".concat(r).concat(f), i);
        }).join("") : "";
      } else
        return "An instance of ".concat(a).concat(this.target ? this.target.constructor.name : "an object").concat(s, ` has failed the validation:
`) + (this.constraints ? c(this.property) : "") + (this.children ? this.children.map(function(d) {
          return d.toString(t, !0, o.property, i);
        }).join("") : "");
    }, e;
  }()
), ma = (
  /** @class */
  function() {
    function e() {
    }
    return e.isValid = function(t) {
      var n = this;
      return t !== "isValid" && t !== "getMessage" && Object.keys(this).map(function(r) {
        return n[r];
      }).indexOf(t) !== -1;
    }, e.CUSTOM_VALIDATION = "customValidation", e.NESTED_VALIDATION = "nestedValidation", e.PROMISE_VALIDATION = "promiseValidation", e.CONDITIONAL_VALIDATION = "conditionalValidation", e.WHITELIST = "whitelistValidation", e.IS_DEFINED = "isDefined", e;
  }()
);
function Rle(e) {
  return Array.isArray(e) ? e.join(", ") : (typeof e == "symbol" && (e = e.description), "".concat(e));
}
var Mle = (
  /** @class */
  function() {
    function e() {
    }
    return e.replaceMessageSpecialTokens = function(t, n) {
      var r;
      return t instanceof Function ? r = t(n) : typeof t == "string" && (r = t), r && Array.isArray(n.constraints) && n.constraints.forEach(function(i, o) {
        r = r.replace(new RegExp("\\$constraint".concat(o + 1), "g"), Rle(i));
      }), r && n.value !== void 0 && n.value !== null && ["string", "boolean", "number"].includes(typeof n.value) && (r = r.replace(/\$value/g, n.value)), r && (r = r.replace(/\$property/g, n.property)), r && (r = r.replace(/\$target/g, n.targetName)), r;
    }, e;
  }()
), gm = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, D3 = (
  /** @class */
  function() {
    function e(t, n) {
      this.validator = t, this.validatorOptions = n, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = aP();
    }
    return e.prototype.execute = function(t, n, r) {
      var i = this, o, a;
      !this.metadataStorage.hasValidationMetaData && ((o = this.validatorOptions) === null || o === void 0 ? void 0 : o.enableDebugMessages) === !0 && console.warn(`No validation metadata found. No validation will be  performed. There are multiple possible reasons:
  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.
  - This validation runs before any file with validation decorator was parsed by NodeJS.`);
      var s = this.validatorOptions ? this.validatorOptions.groups : void 0, l = this.validatorOptions && this.validatorOptions.strictGroups || !1, c = this.validatorOptions && this.validatorOptions.always || !1, f = ((a = this.validatorOptions) === null || a === void 0 ? void 0 : a.forbidUnknownValues) === void 0 || this.validatorOptions.forbidUnknownValues !== !1, d = this.metadataStorage.getTargetValidationMetadatas(t.constructor, n, c, l, s), p = this.metadataStorage.groupByPropertyName(d);
      if (this.validatorOptions && f && !d.length) {
        var g = new L3();
        (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (g.target = t), g.value = void 0, g.property = void 0, g.children = [], g.constraints = { unknownValue: "an unknown value was passed to the validate function" }, r.push(g);
        return;
      }
      this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(t, p, r), Object.keys(p).forEach(function(v) {
        var y = t[v], x = p[v].filter(function(w) {
          return w.type === ma.IS_DEFINED;
        }), b = p[v].filter(function(w) {
          return w.type !== ma.IS_DEFINED && w.type !== ma.WHITELIST;
        });
        y instanceof Promise && b.find(function(w) {
          return w.type === ma.PROMISE_VALIDATION;
        }) ? i.awaitingPromises.push(y.then(function(w) {
          i.performValidations(t, w, v, x, b, r);
        })) : i.performValidations(t, y, v, x, b, r);
      });
    }, e.prototype.whitelist = function(t, n, r) {
      var i = this, o = [];
      Object.keys(t).forEach(function(a) {
        (!n[a] || n[a].length === 0) && o.push(a);
      }), o.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? o.forEach(function(a) {
        var s, l = i.generateValidationError(t, t[a], a);
        l.constraints = (s = {}, s[ma.WHITELIST] = "property ".concat(a, " should not exist"), s), l.children = void 0, r.push(l);
      }) : o.forEach(function(a) {
        return delete t[a];
      }));
    }, e.prototype.stripEmptyErrors = function(t) {
      var n = this;
      return t.filter(function(r) {
        if (r.children && (r.children = n.stripEmptyErrors(r.children)), Object.keys(r.constraints).length === 0) {
          if (r.children.length === 0)
            return !1;
          delete r.constraints;
        }
        return !0;
      });
    }, e.prototype.performValidations = function(t, n, r, i, o, a) {
      var s = o.filter(function(p) {
        return p.type === ma.CUSTOM_VALIDATION;
      }), l = o.filter(function(p) {
        return p.type === ma.NESTED_VALIDATION;
      }), c = o.filter(function(p) {
        return p.type === ma.CONDITIONAL_VALIDATION;
      }), f = this.generateValidationError(t, n, r);
      a.push(f);
      var d = this.conditionalValidations(t, n, c);
      d && (this.customValidations(t, n, i, f), this.mapContexts(t, n, i, f), !(n === void 0 && this.validatorOptions && this.validatorOptions.skipUndefinedProperties === !0) && (n === null && this.validatorOptions && this.validatorOptions.skipNullProperties === !0 || n == null && this.validatorOptions && this.validatorOptions.skipMissingProperties === !0 || (this.customValidations(t, n, s, f), this.nestedValidations(n, l, f), this.mapContexts(t, n, o, f), this.mapContexts(t, n, s, f))));
    }, e.prototype.generateValidationError = function(t, n, r) {
      var i = new L3();
      return (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (i.target = t), (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.value === void 0 || this.validatorOptions.validationError.value === !0) && (i.value = n), i.property = r, i.children = [], i.constraints = {}, i;
    }, e.prototype.conditionalValidations = function(t, n, r) {
      return r.map(function(i) {
        return i.constraints[0](t, n);
      }).reduce(function(i, o) {
        return i && o;
      }, !0);
    }, e.prototype.customValidations = function(t, n, r, i) {
      var o = this;
      r.forEach(function(a) {
        o.metadataStorage.getTargetValidatorConstraints(a.constraintCls).forEach(function(s) {
          if (!(s.async && o.ignoreAsyncValidations) && !(o.validatorOptions && o.validatorOptions.stopAtFirstError && Object.keys(i.constraints || {}).length > 0)) {
            var l = {
              targetName: t.constructor ? t.constructor.name : void 0,
              property: a.propertyName,
              object: t,
              value: n,
              constraints: a.constraints
            };
            if (!a.each || !(Array.isArray(n) || n instanceof Set || n instanceof Map)) {
              var c = s.instance.validate(n, l);
              if (p$(c)) {
                var f = c.then(function(O) {
                  if (!O) {
                    var $ = gm(o.createValidationError(t, n, a, s), 2), P = $[0], R = $[1];
                    i.constraints[P] = R, a.context && (i.contexts || (i.contexts = {}), i.contexts[P] = Object.assign(i.contexts[P] || {}, a.context));
                  }
                });
                o.awaitingPromises.push(f);
              } else if (!c) {
                var d = gm(o.createValidationError(t, n, a, s), 2), p = d[0], g = d[1];
                i.constraints[p] = g;
              }
              return;
            }
            var v = Ple(n), y = v.map(function(O) {
              return s.instance.validate(O, l);
            }), x = y.some(function(O) {
              return p$(O);
            });
            if (x) {
              var b = y.map(function(O) {
                return p$(O) ? O : Promise.resolve(O);
              }), w = Promise.all(b).then(function(O) {
                var $ = O.every(function(B) {
                  return B;
                });
                if (!$) {
                  var P = gm(o.createValidationError(t, n, a, s), 2), R = P[0], L = P[1];
                  i.constraints[R] = L, a.context && (i.contexts || (i.contexts = {}), i.contexts[R] = Object.assign(i.contexts[R] || {}, a.context));
                }
              });
              o.awaitingPromises.push(w);
              return;
            }
            var S = y.every(function(O) {
              return O;
            });
            if (!S) {
              var E = gm(o.createValidationError(t, n, a, s), 2), p = E[0], g = E[1];
              i.constraints[p] = g;
            }
          }
        });
      });
    }, e.prototype.nestedValidations = function(t, n, r) {
      var i = this;
      t !== void 0 && n.forEach(function(o) {
        if (!(o.type !== ma.NESTED_VALIDATION && o.type !== ma.PROMISE_VALIDATION) && !(i.validatorOptions && i.validatorOptions.stopAtFirstError && Object.keys(r.constraints || {}).length > 0))
          if (Array.isArray(t) || t instanceof Set || t instanceof Map) {
            var a = t instanceof Set ? Array.from(t) : t;
            a.forEach(function(d, p) {
              i.performValidations(t, d, p.toString(), [], n, r.children);
            });
          } else if (t instanceof Object) {
            var s = typeof o.target == "string" ? o.target : o.target.name;
            i.execute(t, s, r.children);
          } else {
            var l = gm(i.createValidationError(o.target, t, o), 2), c = l[0], f = l[1];
            r.constraints[c] = f;
          }
      });
    }, e.prototype.mapContexts = function(t, n, r, i) {
      var o = this;
      return r.forEach(function(a) {
        if (a.context) {
          var s = void 0;
          if (a.type === ma.CUSTOM_VALIDATION) {
            var l = o.metadataStorage.getTargetValidatorConstraints(a.constraintCls);
            s = l[0];
          }
          var c = o.getConstraintType(a, s);
          i.constraints[c] && (i.contexts || (i.contexts = {}), i.contexts[c] = Object.assign(i.contexts[c] || {}, a.context));
        }
      });
    }, e.prototype.createValidationError = function(t, n, r, i) {
      var o = t.constructor ? t.constructor.name : void 0, a = this.getConstraintType(r, i), s = {
        targetName: o,
        property: r.propertyName,
        object: t,
        value: n,
        constraints: r.constraints
      }, l = r.message || "";
      !r.message && (!this.validatorOptions || this.validatorOptions && !this.validatorOptions.dismissDefaultMessages) && i && i.instance.defaultMessage instanceof Function && (l = i.instance.defaultMessage(s));
      var c = Mle.replaceMessageSpecialTokens(l, s);
      return [a, c];
    }, e.prototype.getConstraintType = function(t, n) {
      var r = n && n.name ? n.name : t.type;
      return r;
    }, e;
  }()
), Nle = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(f) {
      try {
        c(r.next(f));
      } catch (d) {
        a(d);
      }
    }
    function l(f) {
      try {
        c(r.throw(f));
      } catch (d) {
        a(d);
      }
    }
    function c(f) {
      f.done ? o(f.value) : i(f.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, kle = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(f) {
      return l([c, f]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = c;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(c);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (f) {
        c = [6, f], i = 0;
      } finally {
        r = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, j3 = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.validate = function(t, n, r) {
      return this.coreValidate(t, n, r);
    }, e.prototype.validateOrReject = function(t, n, r) {
      return Nle(this, void 0, void 0, function() {
        var i;
        return kle(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.coreValidate(t, n, r)];
            case 1:
              return i = o.sent(), i.length ? [2, Promise.reject(i)] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.validateSync = function(t, n, r) {
      var i = typeof t == "string" ? n : t, o = typeof t == "string" ? r : n, a = typeof t == "string" ? t : void 0, s = new D3(this, o);
      s.ignoreAsyncValidations = !0;
      var l = [];
      return s.execute(i, a, l), s.stripEmptyErrors(l);
    }, e.prototype.coreValidate = function(t, n, r) {
      var i = typeof t == "string" ? n : t, o = typeof t == "string" ? r : n, a = typeof t == "string" ? t : void 0, s = new D3(this, o), l = [];
      return s.execute(i, a, l), Promise.all(s.awaitingPromises).then(function() {
        return s.stripEmptyErrors(l);
      });
    }, e;
  }()
), Lle = new /** @class */
(function() {
  function e() {
    this.instances = [];
  }
  return e.prototype.get = function(t) {
    var n = this.instances.find(function(r) {
      return r.type === t;
    });
    return n || (n = { type: t, object: new t() }, this.instances.push(n)), n.object;
  }, e;
}())();
function b1(e) {
  return Lle.get(e);
}
var Dle = (
  /** @class */
  function() {
    function e(t, n, r) {
      r === void 0 && (r = !1), this.target = t, this.name = n, this.async = r;
    }
    return Object.defineProperty(e.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return b1(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
function jle(e) {
  var t;
  if (e.validator instanceof Function) {
    t = e.validator;
    var n = b1(_U).getTargetValidatorConstraints(e.validator);
    if (n.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(e.target.name, ":").concat(e.propertyName);
  } else {
    var r = e.validator;
    t = /** @class */
    function() {
      function o() {
      }
      return o.prototype.validate = function(a, s) {
        return r.validate(a, s);
      }, o.prototype.defaultMessage = function(a) {
        return r.defaultMessage ? r.defaultMessage(a) : "";
      }, o;
    }(), aP().addConstraintMetadata(new Dle(t, e.name, e.async));
  }
  var i = {
    type: e.name && ma.isValid(e.name) ? e.name : ma.CUSTOM_VALIDATION,
    name: e.name,
    target: e.target,
    propertyName: e.propertyName,
    validationOptions: e.options,
    constraintCls: t,
    constraints: e.constraints
  };
  aP().addValidationMetadata(new $U(i));
}
function Rw(e, t) {
  return function(n) {
    var r = t && t.each ? "each value in " : "";
    return e(r, n);
  };
}
function Mw(e, t) {
  return function(n, r) {
    jle({
      name: e.name,
      target: n.constructor,
      propertyName: r,
      options: t,
      constraints: e.constraints,
      validator: e.validator
    });
  };
}
var Fle = "isNotEmpty";
function Ble(e) {
  return e !== "" && e !== null && e !== void 0;
}
function iv(e) {
  return Mw({
    name: Fle,
    validator: {
      validate: function(t, n) {
        return Ble(t);
      },
      defaultMessage: Rw(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var zle = "isBoolean";
function Ule(e) {
  return e instanceof Boolean || typeof e == "boolean";
}
function Hle(e) {
  return Mw({
    name: zle,
    validator: {
      validate: function(t, n) {
        return Ule(t);
      },
      defaultMessage: Rw(function(t) {
        return t + "$property must be a boolean value";
      }, e)
    }
  }, e);
}
var Wle = "isNumber";
function Vle(e, t) {
  if (t === void 0 && (t = {}), typeof e != "number")
    return !1;
  if (e === 1 / 0 || e === -1 / 0)
    return !!t.allowInfinity;
  if (Number.isNaN(e))
    return !!t.allowNaN;
  if (t.maxDecimalPlaces !== void 0) {
    var n = 0;
    if (e % 1 !== 0 && (n = e.toString().split(".")[1].length), n > t.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(e);
}
function ov(e, t) {
  return e === void 0 && (e = {}), Mw({
    name: Wle,
    constraints: [e],
    validator: {
      validate: function(n, r) {
        return Vle(n, r == null ? void 0 : r.constraints[0]);
      },
      defaultMessage: Rw(function(n) {
        return n + "$property must be a number conforming to the specified constraints";
      }, t)
    }
  }, t);
}
var Gle = "isString";
function Kle(e) {
  return e instanceof String || typeof e == "string";
}
function qle(e) {
  return Mw({
    name: Gle,
    validator: {
      validate: function(t, n) {
        return Kle(t);
      },
      defaultMessage: Rw(function(t) {
        return t + "$property must be a string";
      }, e)
    }
  }, e);
}
function Yle(e, t, n) {
  return typeof e == "string" ? b1(j3).validate(e, t, n) : b1(j3).validate(e, t);
}
class OU {
  async validate() {
    return !((await Yle(this)).length > 0);
  }
}
var Xle = Object.defineProperty, Qle = Object.getOwnPropertyDescriptor, Jle = (e, t, n, r) => {
  for (var i = r > 1 ? void 0 : r ? Qle(t, n) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (i = (r ? a(t, n, i) : a(i)) || i);
  return r && i && Xle(t, n, i), i;
};
class PU extends OU {
  constructor(t) {
    super(), this.name = t.name;
  }
}
Jle([
  qle()
], PU.prototype, "name", 2);
var Zle = Object.defineProperty, ece = Object.getOwnPropertyDescriptor, ph = (e, t, n, r) => {
  for (var i = r > 1 ? void 0 : r ? ece(t, n) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (i = (r ? a(t, n, i) : a(i)) || i);
  return r && i && Zle(t, n, i), i;
};
class Jf extends OU {
  constructor(t, n = {}) {
    var i, o;
    super();
    const r = (n == null ? void 0 : n.isShownUserActionBox) && ((i = t.userActionBox) == null ? void 0 : i.display);
    this.footerHeight = t.footer.height, this.headerHeight = t.header.height, this.disclaimerHeight = t.disclaimers.height, this.sendMsgBoxHeight = t.conversation.sendMsgBox.height, this.showDisclaimers = (t.disclaimers.display ?? !0) && !!n.hasDisclaimers, this.userActionBoxContainerHeight = r && ((o = t.userActionBox) == null ? void 0 : o.height) || 0;
  }
}
ph([
  iv(),
  ov()
], Jf.prototype, "footerHeight", 2);
ph([
  iv(),
  ov()
], Jf.prototype, "headerHeight", 2);
ph([
  iv(),
  ov()
], Jf.prototype, "disclaimerHeight", 2);
ph([
  iv(),
  ov()
], Jf.prototype, "sendMsgBoxHeight", 2);
ph([
  Hle()
], Jf.prototype, "showDisclaimers", 2);
ph([
  iv(),
  ov()
], Jf.prototype, "userActionBoxContainerHeight", 2);
class tce extends EU {
  constructor(t) {
    super(), this.service = t;
  }
  async action(t) {
    const { name: n } = t, r = await this.service.getTheme(n);
    return Promise.resolve((r == null ? void 0 : r.config) ?? null);
  }
}
class nce extends EU {
  async action(t) {
    const {
      footerHeight: n,
      headerHeight: r,
      sendMsgBoxHeight: i,
      disclaimerHeight: o,
      showDisclaimers: a,
      userActionBoxContainerHeight: s
      // Note: only in site-companion bot
    } = t, l = a ? o : 0, c = {
      header: `${r}px`,
      body: `calc(100% - ${r}px)`,
      footer: `${n}px`,
      conversation: `calc(100% - ${i + l + n + s}px)`,
      sendMsgBox: i ? `${i}px` : "50px"
    };
    return Promise.resolve(c);
  }
}
var TU = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (o = i(o, r(s)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var a = "";
      for (var s in o)
        t.call(o, s) && o[s] && (a = i(a, s));
      return a;
    }
    function i(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(TU);
var rce = TU.exports;
const Ue = /* @__PURE__ */ Oi(rce);
function sP() {
  return sP = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sP.apply(this, arguments);
}
var IU = { exports: {} }, Bn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pR = Symbol.for("react.element"), hR = Symbol.for("react.portal"), Nw = Symbol.for("react.fragment"), kw = Symbol.for("react.strict_mode"), Lw = Symbol.for("react.profiler"), Dw = Symbol.for("react.provider"), jw = Symbol.for("react.context"), ice = Symbol.for("react.server_context"), Fw = Symbol.for("react.forward_ref"), Bw = Symbol.for("react.suspense"), zw = Symbol.for("react.suspense_list"), Uw = Symbol.for("react.memo"), Hw = Symbol.for("react.lazy"), oce = Symbol.for("react.offscreen"), AU;
AU = Symbol.for("react.module.reference");
function us(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case pR:
        switch (e = e.type, e) {
          case Nw:
          case Lw:
          case kw:
          case Bw:
          case zw:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case ice:
              case jw:
              case Fw:
              case Hw:
              case Uw:
              case Dw:
                return e;
              default:
                return t;
            }
        }
      case hR:
        return t;
    }
  }
}
Bn.ContextConsumer = jw;
Bn.ContextProvider = Dw;
Bn.Element = pR;
Bn.ForwardRef = Fw;
Bn.Fragment = Nw;
Bn.Lazy = Hw;
Bn.Memo = Uw;
Bn.Portal = hR;
Bn.Profiler = Lw;
Bn.StrictMode = kw;
Bn.Suspense = Bw;
Bn.SuspenseList = zw;
Bn.isAsyncMode = function() {
  return !1;
};
Bn.isConcurrentMode = function() {
  return !1;
};
Bn.isContextConsumer = function(e) {
  return us(e) === jw;
};
Bn.isContextProvider = function(e) {
  return us(e) === Dw;
};
Bn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === pR;
};
Bn.isForwardRef = function(e) {
  return us(e) === Fw;
};
Bn.isFragment = function(e) {
  return us(e) === Nw;
};
Bn.isLazy = function(e) {
  return us(e) === Hw;
};
Bn.isMemo = function(e) {
  return us(e) === Uw;
};
Bn.isPortal = function(e) {
  return us(e) === hR;
};
Bn.isProfiler = function(e) {
  return us(e) === Lw;
};
Bn.isStrictMode = function(e) {
  return us(e) === kw;
};
Bn.isSuspense = function(e) {
  return us(e) === Bw;
};
Bn.isSuspenseList = function(e) {
  return us(e) === zw;
};
Bn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Nw || e === Lw || e === kw || e === Bw || e === zw || e === oce || typeof e == "object" && e !== null && (e.$$typeof === Hw || e.$$typeof === Uw || e.$$typeof === Dw || e.$$typeof === jw || e.$$typeof === Fw || e.$$typeof === AU || e.getModuleId !== void 0);
};
Bn.typeOf = us;
IU.exports = Bn;
var wp = IU.exports;
function lP(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return oe.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(lP(r)) : wp.isFragment(r) && r.props ? n = n.concat(lP(r.props.children, t)) : n.push(r));
  }), n;
}
function Ou(e) {
  "@babel/helpers - typeof";
  return Ou = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ou(e);
}
function ace(e, t) {
  if (Ou(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ou(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function RU(e) {
  var t = ace(e, "string");
  return Ou(t) === "symbol" ? t : String(t);
}
function sce(e, t, n) {
  return t = RU(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function F3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function B3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F3(Object(n), !0).forEach(function(r) {
      sce(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : F3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function lce(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function h$(e) {
  return lce(e) ? e : e instanceof oe.Component ? fh.findDOMNode(e) : null;
}
function cce(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function uce(e, t) {
  typeof e == "function" ? e(t) : Ou(e) === "object" && e && "current" in e && (e.current = t);
}
function fce() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      uce(o, i);
    });
  };
}
function dce() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return cce(function() {
    return fce.apply(void 0, t);
  }, t, function(r, i) {
    return r.length !== i.length || r.every(function(o, a) {
      return o !== i[a];
    });
  });
}
function pce(e) {
  var t, n, r = wp.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
var cP = /* @__PURE__ */ m.createContext(null);
function hce(e) {
  var t = e.children, n = e.onBatchResize, r = m.useRef(0), i = m.useRef([]), o = m.useContext(cP), a = m.useCallback(function(s, l, c) {
    r.current += 1;
    var f = r.current;
    i.current.push({
      size: s,
      element: l,
      data: c
    }), Promise.resolve().then(function() {
      f === r.current && (n == null || n(i.current), i.current = []);
    }), o == null || o(s, l, c);
  }, [n, o]);
  return /* @__PURE__ */ m.createElement(cP.Provider, {
    value: a
  }, t);
}
var MU = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(i, o) {
      return i[0] === n ? (r = o, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), i = this.__entries__[r];
        return i && i[1];
      }, t.prototype.set = function(n, r) {
        var i = e(this.__entries__, n);
        ~i ? this.__entries__[i][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, i = e(r, n);
        ~i && r.splice(i, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var i = 0, o = this.__entries__; i < o.length; i++) {
          var a = o[i];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), uP = typeof window < "u" && typeof document < "u" && window.document === document, w1 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), mce = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(w1) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), gce = 2;
function vce(e, t) {
  var n = !1, r = !1, i = 0;
  function o() {
    n && (n = !1, e()), r && s();
  }
  function a() {
    mce(o);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - i < gce)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    i = l;
  }
  return s;
}
var yce = 20, bce = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], wce = typeof MutationObserver < "u", Sce = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = vce(this.refresh.bind(this), yce);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !uP || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), wce ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !uP || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, i = bce.some(function(o) {
        return !!~r.indexOf(o);
      });
      i && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), NU = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var i = r[n];
    Object.defineProperty(e, i, {
      value: t[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Up = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || w1;
}, kU = Ww(0, 0, 0, 0);
function S1(e) {
  return parseFloat(e) || 0;
}
function z3(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, i) {
    var o = e["border-" + i + "-width"];
    return r + S1(o);
  }, 0);
}
function xce(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, i = t; r < i.length; r++) {
    var o = i[r], a = e["padding-" + o];
    n[o] = S1(a);
  }
  return n;
}
function Cce(e) {
  var t = e.getBBox();
  return Ww(0, 0, t.width, t.height);
}
function Ece(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return kU;
  var r = Up(e).getComputedStyle(e), i = xce(r), o = i.left + i.right, a = i.top + i.bottom, s = S1(r.width), l = S1(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + o) !== t && (s -= z3(r, "left", "right") + o), Math.round(l + a) !== n && (l -= z3(r, "top", "bottom") + a)), !_ce(e)) {
    var c = Math.round(s + o) - t, f = Math.round(l + a) - n;
    Math.abs(c) !== 1 && (s -= c), Math.abs(f) !== 1 && (l -= f);
  }
  return Ww(i.left, i.top, s, l);
}
var $ce = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Up(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Up(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function _ce(e) {
  return e === Up(e).document.documentElement;
}
function Oce(e) {
  return uP ? $ce(e) ? Cce(e) : Ece(e) : kU;
}
function Pce(e) {
  var t = e.x, n = e.y, r = e.width, i = e.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, a = Object.create(o.prototype);
  return NU(a, {
    x: t,
    y: n,
    width: r,
    height: i,
    top: n,
    right: t + r,
    bottom: i + n,
    left: t
  }), a;
}
function Ww(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var Tce = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Ww(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Oce(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), Ice = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = Pce(n);
      NU(this, { target: t, contentRect: r });
    }
    return e;
  }()
), Ace = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new MU(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Up(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new Tce(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Up(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new Ice(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), LU = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MU(), DU = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = Sce.getInstance(), r = new Ace(t, n, this);
      LU.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  DU.prototype[e] = function() {
    var t;
    return (t = LU.get(this))[e].apply(t, arguments);
  };
});
var jU = function() {
  return typeof w1.ResizeObserver < "u" ? w1.ResizeObserver : DU;
}(), tu = /* @__PURE__ */ new Map();
function Rce(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = tu.get(r)) === null || n === void 0 || n.forEach(function(i) {
      return i(r);
    });
  });
}
var FU = new jU(Rce);
function Mce(e, t) {
  tu.has(e) || (tu.set(e, /* @__PURE__ */ new Set()), FU.observe(e)), tu.get(e).add(t);
}
function Nce(e, t) {
  tu.has(e) && (tu.get(e).delete(t), tu.get(e).size || (FU.unobserve(e), tu.delete(e)));
}
function kce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function U3(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, RU(r.key), r);
  }
}
function Lce(e, t, n) {
  return t && U3(e.prototype, t), n && U3(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function fP(e, t) {
  return fP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, fP(e, t);
}
function Dce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && fP(e, t);
}
function x1(e) {
  return x1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, x1(e);
}
function jce() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Fce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Bce(e, t) {
  if (t && (Ou(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fce(e);
}
function zce(e) {
  var t = jce();
  return function() {
    var r = x1(e), i;
    if (t) {
      var o = x1(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return Bce(this, i);
  };
}
var Uce = /* @__PURE__ */ function(e) {
  Dce(n, e);
  var t = zce(n);
  function n() {
    return kce(this, n), t.apply(this, arguments);
  }
  return Lce(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(m.Component);
function Hce(e, t) {
  var n = e.children, r = e.disabled, i = m.useRef(null), o = m.useRef(null), a = m.useContext(cP), s = typeof n == "function", l = s ? n(i) : n, c = m.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), f = !s && /* @__PURE__ */ m.isValidElement(l) && pce(l), d = f ? l.ref : null, p = dce(d, i), g = function() {
    var b;
    return h$(i.current) || // Support `nativeElement` format
    (i.current && Ou(i.current) === "object" ? h$((b = i.current) === null || b === void 0 ? void 0 : b.nativeElement) : null) || h$(o.current);
  };
  m.useImperativeHandle(t, function() {
    return g();
  });
  var v = m.useRef(e);
  v.current = e;
  var y = m.useCallback(function(x) {
    var b = v.current, w = b.onResize, S = b.data, E = x.getBoundingClientRect(), O = E.width, $ = E.height, P = x.offsetWidth, R = x.offsetHeight, L = Math.floor(O), B = Math.floor($);
    if (c.current.width !== L || c.current.height !== B || c.current.offsetWidth !== P || c.current.offsetHeight !== R) {
      var j = {
        width: L,
        height: B,
        offsetWidth: P,
        offsetHeight: R
      };
      c.current = j;
      var A = P === Math.round(O) ? O : P, T = R === Math.round($) ? $ : R, k = B3(B3({}, j), {}, {
        offsetWidth: A,
        offsetHeight: T
      });
      a == null || a(k, x, S), w && Promise.resolve().then(function() {
        w(k, x);
      });
    }
  }, []);
  return m.useEffect(function() {
    var x = g();
    return x && !r && Mce(x, y), function() {
      return Nce(x, y);
    };
  }, [i.current, r]), /* @__PURE__ */ m.createElement(Uce, {
    ref: o
  }, f ? /* @__PURE__ */ m.cloneElement(l, {
    ref: p
  }) : l);
}
var Wce = /* @__PURE__ */ m.forwardRef(Hce), Vce = "rc-observer-key";
function Gce(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : lP(n);
  return r.map(function(i, o) {
    var a = (i == null ? void 0 : i.key) || "".concat(Vce, "-").concat(o);
    return /* @__PURE__ */ m.createElement(Wce, sP({}, e, {
      key: a,
      ref: o === 0 ? t : void 0
    }), i);
  });
}
var mR = /* @__PURE__ */ m.forwardRef(Gce);
mR.Collection = hce;
function is(e) {
  "@babel/helpers - typeof";
  return is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, is(e);
}
function Kce(e, t) {
  if (is(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (is(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qce(e) {
  var t = Kce(e, "string");
  return is(t) === "symbol" ? t : String(t);
}
function Yce(e, t, n) {
  return t = qce(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function H3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? H3(Object(n), !0).forEach(function(r) {
      Yce(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function os(e, t) {
  var n = Hp({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function dP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Xce(e) {
  if (Array.isArray(e))
    return dP(e);
}
function Qce(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Jce(e, t) {
  if (e) {
    if (typeof e == "string")
      return dP(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return dP(e, t);
  }
}
function Zce() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qa(e) {
  return Xce(e) || Qce(e) || Jce(e) || Zce();
}
var BU = function(t) {
  return +setTimeout(t, 16);
}, zU = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (BU = function(t) {
  return window.requestAnimationFrame(t);
}, zU = function(t) {
  return window.cancelAnimationFrame(t);
});
var W3 = 0, gR = /* @__PURE__ */ new Map();
function UU(e) {
  gR.delete(e);
}
var Pg = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  W3 += 1;
  var r = W3;
  function i(o) {
    if (o === 0)
      UU(r), t();
    else {
      var a = BU(function() {
        i(o - 1);
      });
      gR.set(r, a);
    }
  }
  return i(n), r;
};
Pg.cancel = function(e) {
  var t = gR.get(e);
  return UU(e), zU(t);
};
function HU(e) {
  if (Array.isArray(e))
    return e;
}
function eue(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function pP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function vR(e, t) {
  if (e) {
    if (typeof e == "string")
      return pP(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return pP(e, t);
  }
}
function WU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ke(e, t) {
  return HU(e) || eue(e, t) || vR(e, t) || WU();
}
function tue(e) {
  if (Array.isArray(e))
    return pP(e);
}
function VU(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function nue() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rt(e) {
  return tue(e) || VU(e) || vR(e) || nue();
}
function C1(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function hh() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function rue(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var V3 = "data-rc-order", G3 = "data-rc-priority", iue = "rc-util-key", hP = /* @__PURE__ */ new Map();
function GU() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : iue;
}
function Vw(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function oue(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function KU(e) {
  return Array.from((hP.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function qU(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!hh())
    return null;
  var n = t.csp, r = t.prepend, i = t.priority, o = i === void 0 ? 0 : i, a = oue(r), s = a === "prependQueue", l = document.createElement("style");
  l.setAttribute(V3, a), s && o && l.setAttribute(G3, "".concat(o)), n != null && n.nonce && (l.nonce = n == null ? void 0 : n.nonce), l.innerHTML = e;
  var c = Vw(t), f = c.firstChild;
  if (r) {
    if (s) {
      var d = KU(c).filter(function(p) {
        if (!["prepend", "prependQueue"].includes(p.getAttribute(V3)))
          return !1;
        var g = Number(p.getAttribute(G3) || 0);
        return o >= g;
      });
      if (d.length)
        return c.insertBefore(l, d[d.length - 1].nextSibling), l;
    }
    c.insertBefore(l, f);
  } else
    c.appendChild(l);
  return l;
}
function YU(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Vw(t);
  return KU(n).find(function(r) {
    return r.getAttribute(GU(t)) === e;
  });
}
function yR(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = YU(e, t);
  if (n) {
    var r = Vw(t);
    r.removeChild(n);
  }
}
function aue(e, t) {
  var n = hP.get(e);
  if (!n || !rue(document, n)) {
    var r = qU("", t), i = r.parentNode;
    hP.set(e, i), e.removeChild(r);
  }
}
function Tg(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Vw(n);
  aue(r, n);
  var i = YU(t, n);
  if (i) {
    var o, a;
    if ((o = n.csp) !== null && o !== void 0 && o.nonce && i.nonce !== ((a = n.csp) === null || a === void 0 ? void 0 : a.nonce)) {
      var s;
      i.nonce = (s = n.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return i.innerHTML !== e && (i.innerHTML = e), i;
  }
  var l = qU(e, n);
  return l.setAttribute(GU(n), t), l;
}
function sue(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function _n(e, t) {
  if (e == null)
    return {};
  var n = sue(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Js(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function K3(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, gU(r.key), r);
  }
}
function Zs(e, t, n) {
  return t && K3(e.prototype, t), n && K3(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var lue = "%";
function mP(e) {
  return e.join(lue);
}
var cue = /* @__PURE__ */ function() {
  function e(t) {
    Js(this, e), ce(this, "instanceId", void 0), ce(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return Zs(e, [{
    key: "get",
    value: function(n) {
      return this.opGet(mP(n));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(n) {
      return this.cache.get(n) || null;
    }
  }, {
    key: "update",
    value: function(n, r) {
      return this.opUpdate(mP(n), r);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(n, r) {
      var i = this.cache.get(n), o = r(i);
      o === null ? this.cache.delete(n) : this.cache.set(n, o);
    }
  }]), e;
}(), Wp = "data-token-hash", Us = "data-css-hash", nu = "__cssinjs_instance__";
function uue() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(Us, "]")) || [], n = document.head.firstChild;
    Array.from(t).forEach(function(i) {
      i[nu] = i[nu] || e, i[nu] === e && document.head.insertBefore(i, n);
    });
    var r = {};
    Array.from(document.querySelectorAll("style[".concat(Us, "]"))).forEach(function(i) {
      var o = i.getAttribute(Us);
      if (r[o]) {
        if (i[nu] === e) {
          var a;
          (a = i.parentNode) === null || a === void 0 || a.removeChild(i);
        }
      } else
        r[o] = !0;
    });
  }
  return new cue(e);
}
var Gw = /* @__PURE__ */ m.createContext({
  hashPriority: "low",
  cache: uue(),
  defaultCache: !0
});
function fue(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var bR = /* @__PURE__ */ function() {
  function e() {
    Js(this, e), ce(this, "cache", void 0), ce(this, "keys", void 0), ce(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return Zs(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(n) {
      var r, i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = {
        map: this.cache
      };
      return n.forEach(function(s) {
        if (!a)
          a = void 0;
        else {
          var l;
          a = (l = a) === null || l === void 0 || (l = l.map) === null || l === void 0 ? void 0 : l.get(s);
        }
      }), (r = a) !== null && r !== void 0 && r.value && o && (a.value[1] = this.cacheCallTimes++), (i = a) === null || i === void 0 ? void 0 : i.value;
    }
  }, {
    key: "get",
    value: function(n) {
      var r;
      return (r = this.internalGet(n, !0)) === null || r === void 0 ? void 0 : r[0];
    }
  }, {
    key: "has",
    value: function(n) {
      return !!this.internalGet(n);
    }
  }, {
    key: "set",
    value: function(n, r) {
      var i = this;
      if (!this.has(n)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var o = this.keys.reduce(function(c, f) {
            var d = ke(c, 2), p = d[1];
            return i.internalGet(f)[1] < p ? [f, i.internalGet(f)[1]] : c;
          }, [this.keys[0], this.cacheCallTimes]), a = ke(o, 1), s = a[0];
          this.delete(s);
        }
        this.keys.push(n);
      }
      var l = this.cache;
      n.forEach(function(c, f) {
        if (f === n.length - 1)
          l.set(c, {
            value: [r, i.cacheCallTimes++]
          });
        else {
          var d = l.get(c);
          d ? d.map || (d.map = /* @__PURE__ */ new Map()) : l.set(c, {
            map: /* @__PURE__ */ new Map()
          }), l = l.get(c).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(n, r) {
      var i = n.get(r[0]);
      if (r.length === 1) {
        var o;
        return i.map ? n.set(r[0], {
          map: i.map
        }) : n.delete(r[0]), (o = i.value) === null || o === void 0 ? void 0 : o[0];
      }
      var a = this.deleteByPath(i.map, r.slice(1));
      return (!i.map || i.map.size === 0) && !i.value && n.delete(r[0]), a;
    }
  }, {
    key: "delete",
    value: function(n) {
      if (this.has(n))
        return this.keys = this.keys.filter(function(r) {
          return !fue(r, n);
        }), this.deleteByPath(this.cache, n);
    }
  }]), e;
}();
ce(bR, "MAX_CACHE_SIZE", 20);
ce(bR, "MAX_CACHE_OFFSET", 5);
var q3 = 0, XU = /* @__PURE__ */ function() {
  function e(t) {
    Js(this, e), ce(this, "derivatives", void 0), ce(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = q3, t.length === 0 && (t.length > 0, void 0), q3 += 1;
  }
  return Zs(e, [{
    key: "getDerivativeToken",
    value: function(n) {
      return this.derivatives.reduce(function(r, i) {
        return i(n, r);
      }, void 0);
    }
  }]), e;
}(), m$ = new bR();
function gP(e) {
  var t = Array.isArray(e) ? e : [e];
  return m$.has(t) || m$.set(t, new XU(t)), m$.get(t);
}
var due = /* @__PURE__ */ new WeakMap(), g$ = {};
function pue(e, t) {
  for (var n = due, r = 0; r < t.length; r += 1) {
    var i = t[r];
    n.has(i) || n.set(i, /* @__PURE__ */ new WeakMap()), n = n.get(i);
  }
  return n.has(g$) || n.set(g$, e()), n.get(g$);
}
var Y3 = /* @__PURE__ */ new WeakMap();
function Qm(e) {
  var t = Y3.get(e) || "";
  return t || (Object.keys(e).forEach(function(n) {
    var r = e[n];
    t += n, r instanceof XU ? t += r.id : r && nn(r) === "object" ? t += Qm(r) : t += r;
  }), Y3.set(e, t)), t;
}
function X3(e, t) {
  return C1("".concat(t, "_").concat(Qm(e)));
}
var Jm = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, ""), QU = "_bAmBoO_";
function hue(e, t, n) {
  if (hh()) {
    var r, i;
    Tg(e, Jm);
    var o = document.createElement("div");
    o.style.position = "fixed", o.style.left = "0", o.style.top = "0", t == null || t(o), document.body.appendChild(o);
    var a = n ? n(o) : (r = getComputedStyle(o).content) === null || r === void 0 ? void 0 : r.includes(QU);
    return (i = o.parentNode) === null || i === void 0 || i.removeChild(o), yR(Jm), a;
  }
  return !1;
}
var v$ = void 0;
function mue() {
  return v$ === void 0 && (v$ = hue("@layer ".concat(Jm, " { .").concat(Jm, ' { content: "').concat(QU, '"!important; } }'), function(e) {
    e.className = Jm;
  })), v$;
}
var vP = hh();
function ge(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function E1(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var o = ye(ye({}, r), {}, ce(ce({}, Wp, t), Us, n)), a = Object.keys(o).map(function(s) {
    var l = o[s];
    return l ? "".concat(s, '="').concat(l, '"') : null;
  }).filter(function(s) {
    return s;
  }).join(" ");
  return "<style ".concat(a, ">").concat(e, "</style>");
}
var JU = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(n ? "".concat(n, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, gue = function(t, n, r) {
  return Object.keys(t).length ? ".".concat(n).concat(r != null && r.scope ? ".".concat(r.scope) : "", "{").concat(Object.entries(t).map(function(i) {
    var o = ke(i, 2), a = o[0], s = o[1];
    return "".concat(a, ":").concat(s, ";");
  }).join(""), "}") : "";
}, ZU = function(t, n, r) {
  var i = {}, o = {};
  return Object.entries(t).forEach(function(a) {
    var s, l, c = ke(a, 2), f = c[0], d = c[1];
    if (r != null && (s = r.preserve) !== null && s !== void 0 && s[f])
      o[f] = d;
    else if ((typeof d == "string" || typeof d == "number") && !(r != null && (l = r.ignore) !== null && l !== void 0 && l[f])) {
      var p, g = JU(f, r == null ? void 0 : r.prefix);
      i[g] = typeof d == "number" && !(r != null && (p = r.unitless) !== null && p !== void 0 && p[f]) ? "".concat(d, "px") : String(d), o[f] = "var(".concat(g, ")");
    }
  }), [o, gue(i, n, {
    scope: r == null ? void 0 : r.scope
  })];
}, Q3 = hh() ? m.useLayoutEffect : m.useEffect, vue = function(t, n) {
  var r = m.useRef(!0);
  Q3(function() {
    return t(r.current);
  }, n), Q3(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, yue = ye({}, sh), J3 = yue.useInsertionEffect, bue = function(t, n, r) {
  m.useMemo(t, r), vue(function() {
    return n(!0);
  }, r);
}, wue = J3 ? function(e, t, n) {
  return J3(function() {
    return e(), t();
  }, n);
} : bue, Sue = ye({}, sh), xue = Sue.useInsertionEffect, Cue = function(t) {
  var n = [], r = !1;
  function i(o) {
    r || n.push(o);
  }
  return m.useEffect(function() {
    return r = !1, function() {
      r = !0, n.length && n.forEach(function(o) {
        return o();
      });
    };
  }, t), i;
}, Eue = function() {
  return function(t) {
    t();
  };
}, $ue = typeof xue < "u" ? Cue : Eue;
function wR(e, t, n, r, i) {
  var o = m.useContext(Gw), a = o.cache, s = [e].concat(Rt(t)), l = mP(s), c = $ue([l]), f = function(v) {
    a.opUpdate(l, function(y) {
      var x = y || [void 0, void 0], b = ke(x, 2), w = b[0], S = w === void 0 ? 0 : w, E = b[1], O = E, $ = O || n(), P = [S, $];
      return v ? v(P) : P;
    });
  };
  m.useMemo(
    function() {
      f();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [l]
    /* eslint-enable */
  );
  var d = a.opGet(l), p = d[1];
  return wue(function() {
    i == null || i(p);
  }, function(g) {
    return f(function(v) {
      var y = ke(v, 2), x = y[0], b = y[1];
      return g && x === 0 && (i == null || i(p)), [x + 1, b];
    }), function() {
      a.opUpdate(l, function(v) {
        var y = v || [], x = ke(y, 2), b = x[0], w = b === void 0 ? 0 : b, S = x[1], E = w - 1;
        return E === 0 ? (c(function() {
          (g || !a.opGet(l)) && (r == null || r(S, !1));
        }), null) : [w - 1, S];
      });
    };
  }, [l]), p;
}
var _ue = {}, Oue = "css", ff = /* @__PURE__ */ new Map();
function Pue(e) {
  ff.set(e, (ff.get(e) || 0) + 1);
}
function Tue(e, t) {
  if (typeof document < "u") {
    var n = document.querySelectorAll("style[".concat(Wp, '="').concat(e, '"]'));
    n.forEach(function(r) {
      if (r[nu] === t) {
        var i;
        (i = r.parentNode) === null || i === void 0 || i.removeChild(r);
      }
    });
  }
}
var Iue = 0;
function Aue(e, t) {
  ff.set(e, (ff.get(e) || 0) - 1);
  var n = Array.from(ff.keys()), r = n.filter(function(i) {
    var o = ff.get(i) || 0;
    return o <= 0;
  });
  n.length - r.length > Iue && r.forEach(function(i) {
    Tue(i, t), ff.delete(i);
  });
}
var Rue = function(t, n, r, i) {
  var o = r.getDerivativeToken(t), a = ye(ye({}, o), n);
  return i && (a = i(a)), a;
}, eH = "token";
function Mue(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = m.useContext(Gw), i = r.cache.instanceId, o = r.container, a = n.salt, s = a === void 0 ? "" : a, l = n.override, c = l === void 0 ? _ue : l, f = n.formatToken, d = n.getComputedToken, p = n.cssVar, g = pue(function() {
    return Object.assign.apply(Object, [{}].concat(Rt(t)));
  }, t), v = Qm(g), y = Qm(c), x = p ? Qm(p) : "", b = wR(eH, [s, e.id, v, y, x], function() {
    var w, S = d ? d(g, c, e) : Rue(g, c, e, f), E = ye({}, S), O = "";
    if (p) {
      var $ = ZU(S, p.key, {
        prefix: p.prefix,
        ignore: p.ignore,
        unitless: p.unitless,
        preserve: p.preserve
      }), P = ke($, 2);
      S = P[0], O = P[1];
    }
    var R = X3(S, s);
    S._tokenKey = R, E._tokenKey = X3(E, s);
    var L = (w = p == null ? void 0 : p.key) !== null && w !== void 0 ? w : R;
    S._themeKey = L, Pue(L);
    var B = "".concat(Oue, "-").concat(C1(R));
    return S._hashId = B, [S, B, E, O, (p == null ? void 0 : p.key) || ""];
  }, function(w) {
    Aue(w[0]._themeKey, i);
  }, function(w) {
    var S = ke(w, 4), E = S[0], O = S[3];
    if (p && O) {
      var $ = Tg(O, C1("css-variables-".concat(E._themeKey)), {
        mark: Us,
        prepend: "queue",
        attachTo: o,
        priority: -999
      });
      $[nu] = i, $.setAttribute(Wp, E._themeKey);
    }
  });
  return b;
}
var Nue = function(t, n, r) {
  var i = ke(t, 5), o = i[2], a = i[3], s = i[4], l = r || {}, c = l.plain;
  if (!a)
    return null;
  var f = o._tokenKey, d = -999, p = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, g = E1(a, s, f, p, c);
  return [d, f, g];
};
function jt() {
  return jt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jt.apply(this, arguments);
}
var kue = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, tH = "comm", nH = "rule", rH = "decl", Lue = "@import", Due = "@keyframes", jue = "@layer", Fue = Math.abs, SR = String.fromCharCode;
function iH(e) {
  return e.trim();
}
function ob(e, t, n) {
  return e.replace(t, n);
}
function Bue(e, t) {
  return e.indexOf(t);
}
function Ig(e, t) {
  return e.charCodeAt(t) | 0;
}
function Ag(e, t, n) {
  return e.slice(t, n);
}
function Gc(e) {
  return e.length;
}
function oH(e) {
  return e.length;
}
function i0(e, t) {
  return t.push(e), e;
}
var Kw = 1, Vp = 1, aH = 0, as = 0, ei = 0, mh = "";
function xR(e, t, n, r, i, o, a) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: Kw, column: Vp, length: a, return: "" };
}
function zue() {
  return ei;
}
function Uue() {
  return ei = as > 0 ? Ig(mh, --as) : 0, Vp--, ei === 10 && (Vp = 1, Kw--), ei;
}
function Hs() {
  return ei = as < aH ? Ig(mh, as++) : 0, Vp++, ei === 10 && (Vp = 1, Kw++), ei;
}
function Tf() {
  return Ig(mh, as);
}
function ab() {
  return as;
}
function qw(e, t) {
  return Ag(mh, e, t);
}
function yP(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Hue(e) {
  return Kw = Vp = 1, aH = Gc(mh = e), as = 0, [];
}
function Wue(e) {
  return mh = "", e;
}
function y$(e) {
  return iH(qw(as - 1, bP(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Vue(e) {
  for (; (ei = Tf()) && ei < 33; )
    Hs();
  return yP(e) > 2 || yP(ei) > 3 ? "" : " ";
}
function Gue(e, t) {
  for (; --t && Hs() && !(ei < 48 || ei > 102 || ei > 57 && ei < 65 || ei > 70 && ei < 97); )
    ;
  return qw(e, ab() + (t < 6 && Tf() == 32 && Hs() == 32));
}
function bP(e) {
  for (; Hs(); )
    switch (ei) {
      case e:
        return as;
      case 34:
      case 39:
        e !== 34 && e !== 39 && bP(ei);
        break;
      case 40:
        e === 41 && bP(e);
        break;
      case 92:
        Hs();
        break;
    }
  return as;
}
function Kue(e, t) {
  for (; Hs() && e + ei !== 57; )
    if (e + ei === 84 && Tf() === 47)
      break;
  return "/*" + qw(t, as - 1) + "*" + SR(e === 47 ? e : Hs());
}
function que(e) {
  for (; !yP(Tf()); )
    Hs();
  return qw(e, as);
}
function Yue(e) {
  return Wue(sb("", null, null, null, [""], e = Hue(e), 0, [0], e));
}
function sb(e, t, n, r, i, o, a, s, l) {
  for (var c = 0, f = 0, d = a, p = 0, g = 0, v = 0, y = 1, x = 1, b = 1, w = 0, S = "", E = i, O = o, $ = r, P = S; x; )
    switch (v = w, w = Hs()) {
      case 40:
        if (v != 108 && Ig(P, d - 1) == 58) {
          Bue(P += ob(y$(w), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += y$(w);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += Vue(v);
        break;
      case 92:
        P += Gue(ab() - 1, 7);
        continue;
      case 47:
        switch (Tf()) {
          case 42:
          case 47:
            i0(Xue(Kue(Hs(), ab()), t, n), l);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * y:
        s[c++] = Gc(P) * b;
      case 125 * y:
      case 59:
      case 0:
        switch (w) {
          case 0:
          case 125:
            x = 0;
          case 59 + f:
            b == -1 && (P = ob(P, /\f/g, "")), g > 0 && Gc(P) - d && i0(g > 32 ? e4(P + ";", r, n, d - 1) : e4(ob(P, " ", "") + ";", r, n, d - 2), l);
            break;
          case 59:
            P += ";";
          default:
            if (i0($ = Z3(P, t, n, c, f, i, s, S, E = [], O = [], d), o), w === 123)
              if (f === 0)
                sb(P, t, $, $, E, o, d, s, O);
              else
                switch (p === 99 && Ig(P, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    sb(e, $, $, r && i0(Z3(e, $, $, 0, 0, i, s, S, i, E = [], d), O), i, O, d, s, r ? E : O);
                    break;
                  default:
                    sb(P, $, $, $, [""], O, 0, s, O);
                }
        }
        c = f = g = 0, y = b = 1, S = P = "", d = a;
        break;
      case 58:
        d = 1 + Gc(P), g = v;
      default:
        if (y < 1) {
          if (w == 123)
            --y;
          else if (w == 125 && y++ == 0 && Uue() == 125)
            continue;
        }
        switch (P += SR(w), w * y) {
          case 38:
            b = f > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            s[c++] = (Gc(P) - 1) * b, b = 1;
            break;
          case 64:
            Tf() === 45 && (P += y$(Hs())), p = Tf(), f = d = Gc(S = P += que(ab())), w++;
            break;
          case 45:
            v === 45 && Gc(P) == 2 && (y = 0);
        }
    }
  return o;
}
function Z3(e, t, n, r, i, o, a, s, l, c, f) {
  for (var d = i - 1, p = i === 0 ? o : [""], g = oH(p), v = 0, y = 0, x = 0; v < r; ++v)
    for (var b = 0, w = Ag(e, d + 1, d = Fue(y = a[v])), S = e; b < g; ++b)
      (S = iH(y > 0 ? p[b] + " " + w : ob(w, /&\f/g, p[b]))) && (l[x++] = S);
  return xR(e, t, n, i === 0 ? nH : s, l, c, f);
}
function Xue(e, t, n) {
  return xR(e, t, n, tH, SR(zue()), Ag(e, 2, -2), 0);
}
function e4(e, t, n, r) {
  return xR(e, t, n, rH, Ag(e, 0, r), Ag(e, r + 1, -1), r);
}
function wP(e, t) {
  for (var n = "", r = oH(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function Que(e, t, n, r) {
  switch (e.type) {
    case jue:
      if (e.children.length)
        break;
    case Lue:
    case rH:
      return e.return = e.return || e.value;
    case tH:
      return "";
    case Due:
      return e.return = e.value + "{" + wP(e.children, r) + "}";
    case nH:
      e.value = e.props.join(",");
  }
  return Gc(n = wP(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
var t4 = "data-ant-cssinjs-cache-path", sH = "_FILE_STYLE__", If, lH = !0;
function Jue() {
  if (!If && (If = {}, hh())) {
    var e = document.createElement("div");
    e.className = t4, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(i) {
      var o = i.split(":"), a = ke(o, 2), s = a[0], l = a[1];
      If[s] = l;
    });
    var n = document.querySelector("style[".concat(t4, "]"));
    if (n) {
      var r;
      lH = !1, (r = n.parentNode) === null || r === void 0 || r.removeChild(n);
    }
    document.body.removeChild(e);
  }
}
function Zue(e) {
  return Jue(), !!If[e];
}
function efe(e) {
  var t = If[e], n = null;
  if (t && hh())
    if (lH)
      n = sH;
    else {
      var r = document.querySelector("style[".concat(Us, '="').concat(If[e], '"]'));
      r ? n = r.innerHTML : delete If[e];
    }
  return [n, t];
}
var tfe = "_skip_check_", cH = "_multi_value_";
function SP(e) {
  var t = wP(Yue(e), Que);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function nfe(e) {
  return nn(e) === "object" && e && (tfe in e || cH in e);
}
function rfe(e, t, n) {
  if (!t)
    return e;
  var r = ".".concat(t), i = n === "low" ? ":where(".concat(r, ")") : r, o = e.split(",").map(function(a) {
    var s, l = a.trim().split(/\s+/), c = l[0] || "", f = ((s = c.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return c = "".concat(f).concat(i).concat(c.slice(f.length)), [c].concat(Rt(l.slice(1))).join(" ");
  });
  return o.join(",");
}
var ife = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, i = r.root, o = r.injectHash, a = r.parentSelectors, s = n.hashId, l = n.layer;
  n.path;
  var c = n.hashPriority, f = n.transformers, d = f === void 0 ? [] : f;
  n.linters;
  var p = "", g = {};
  function v(S) {
    var E = S.getName(s);
    if (!g[E]) {
      var O = e(S.style, n, {
        root: !1,
        parentSelectors: a
      }), $ = ke(O, 1), P = $[0];
      g[E] = "@keyframes ".concat(S.getName(s)).concat(P);
    }
  }
  function y(S) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return S.forEach(function(O) {
      Array.isArray(O) ? y(O, E) : O && E.push(O);
    }), E;
  }
  var x = y(Array.isArray(t) ? t : [t]);
  if (x.forEach(function(S) {
    var E = typeof S == "string" && !i ? {} : S;
    if (typeof E == "string")
      p += "".concat(E, `
`);
    else if (E._keyframe)
      v(E);
    else {
      var O = d.reduce(function($, P) {
        var R;
        return (P == null || (R = P.visit) === null || R === void 0 ? void 0 : R.call(P, $)) || $;
      }, E);
      Object.keys(O).forEach(function($) {
        var P = O[$];
        if (nn(P) === "object" && P && ($ !== "animationName" || !P._keyframe) && !nfe(P)) {
          var R = !1, L = $.trim(), B = !1;
          (i || o) && s ? L.startsWith("@") ? R = !0 : L = rfe($, s, c) : i && !s && (L === "&" || L === "") && (L = "", B = !0);
          var j = e(P, n, {
            root: B,
            injectHash: R,
            parentSelectors: [].concat(Rt(a), [L])
          }), A = ke(j, 2), T = A[0], k = A[1];
          g = ye(ye({}, g), k), p += "".concat(L).concat(T);
        } else {
          let V = function(G, X) {
            var D = G.replace(/[A-Z]/g, function(ee) {
              return "-".concat(ee.toLowerCase());
            }), te = X;
            !kue[G] && typeof te == "number" && te !== 0 && (te = "".concat(te, "px")), G === "animationName" && X !== null && X !== void 0 && X._keyframe && (v(X), te = X.getName(s)), p += "".concat(D, ":").concat(te, ";");
          };
          var F, W = (F = P == null ? void 0 : P.value) !== null && F !== void 0 ? F : P;
          nn(P) === "object" && P !== null && P !== void 0 && P[cH] && Array.isArray(W) ? W.forEach(function(G) {
            V($, G);
          }) : V($, W);
        }
      });
    }
  }), !i)
    p = "{".concat(p, "}");
  else if (l && mue()) {
    var b = l.split(","), w = b[b.length - 1].trim();
    p = "@layer ".concat(w, " {").concat(p, "}"), b.length > 1 && (p = "@layer ".concat(l, "{%%%:%}").concat(p));
  }
  return [p, g];
};
function uH(e, t) {
  return C1("".concat(e.join("%")).concat(t));
}
function ofe() {
  return null;
}
var fH = "style";
function xP(e, t) {
  var n = e.token, r = e.path, i = e.hashId, o = e.layer, a = e.nonce, s = e.clientOnly, l = e.order, c = l === void 0 ? 0 : l, f = m.useContext(Gw), d = f.autoClear;
  f.mock;
  var p = f.defaultCache, g = f.hashPriority, v = f.container, y = f.ssrInline, x = f.transformers, b = f.linters, w = f.cache, S = n._tokenKey, E = [S].concat(Rt(r)), O = vP, $ = wR(
    fH,
    E,
    // Create cache if needed
    function() {
      var j = E.join("|");
      if (Zue(j)) {
        var A = efe(j), T = ke(A, 2), k = T[0], F = T[1];
        if (k)
          return [k, S, F, {}, s, c];
      }
      var W = t(), V = ife(W, {
        hashId: i,
        hashPriority: g,
        layer: o,
        path: r.join("-"),
        transformers: x,
        linters: b
      }), G = ke(V, 2), X = G[0], D = G[1], te = SP(X), ee = uH(E, te);
      return [te, S, ee, D, s, c];
    },
    // Remove cache if no need
    function(j, A) {
      var T = ke(j, 3), k = T[2];
      (A || d) && vP && yR(k, {
        mark: Us
      });
    },
    // Effect: Inject style here
    function(j) {
      var A = ke(j, 4), T = A[0];
      A[1];
      var k = A[2], F = A[3];
      if (O && T !== sH) {
        var W = {
          mark: Us,
          prepend: "queue",
          attachTo: v,
          priority: c
        }, V = typeof a == "function" ? a() : a;
        V && (W.csp = {
          nonce: V
        });
        var G = Tg(T, k, W);
        G[nu] = w.instanceId, G.setAttribute(Wp, S), Object.keys(F).forEach(function(X) {
          Tg(SP(F[X]), "_effect-".concat(X), W);
        });
      }
    }
  ), P = ke($, 3), R = P[0], L = P[1], B = P[2];
  return function(j) {
    var A;
    return !y || O || !p ? A = /* @__PURE__ */ m.createElement(ofe, null) : A = /* @__PURE__ */ m.createElement("style", jt({}, ce(ce({}, Wp, L), Us, B), {
      dangerouslySetInnerHTML: {
        __html: R
      }
    })), /* @__PURE__ */ m.createElement(m.Fragment, null, A, j);
  };
}
var afe = function(t, n, r) {
  var i = ke(t, 6), o = i[0], a = i[1], s = i[2], l = i[3], c = i[4], f = i[5], d = r || {}, p = d.plain;
  if (c)
    return null;
  var g = o, v = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(f)
  };
  return g = E1(o, a, s, v, p), l && Object.keys(l).forEach(function(y) {
    if (!n[y]) {
      n[y] = !0;
      var x = SP(l[y]);
      g += E1(x, a, "_effect-".concat(y), v, p);
    }
  }), [f, s, g];
}, dH = "cssVar", sfe = function(t, n) {
  var r = t.key, i = t.prefix, o = t.unitless, a = t.ignore, s = t.token, l = t.scope, c = l === void 0 ? "" : l, f = m.useContext(Gw), d = f.cache.instanceId, p = f.container, g = s._tokenKey, v = [].concat(Rt(t.path), [r, c, g]), y = wR(dH, v, function() {
    var x = n(), b = ZU(x, r, {
      prefix: i,
      unitless: o,
      ignore: a,
      scope: c
    }), w = ke(b, 2), S = w[0], E = w[1], O = uH(v, E);
    return [S, E, O, r];
  }, function(x) {
    var b = ke(x, 3), w = b[2];
    vP && yR(w, {
      mark: Us
    });
  }, function(x) {
    var b = ke(x, 3), w = b[1], S = b[2];
    if (w) {
      var E = Tg(w, S, {
        mark: Us,
        prepend: "queue",
        attachTo: p,
        priority: -999
      });
      E[nu] = d, E.setAttribute(Wp, r);
    }
  });
  return y;
}, lfe = function(t, n, r) {
  var i = ke(t, 4), o = i[1], a = i[2], s = i[3], l = r || {}, c = l.plain;
  if (!o)
    return null;
  var f = -999, d = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(f)
  }, p = E1(o, s, a, d, c);
  return [f, a, p];
};
ce(ce(ce({}, fH, afe), eH, Nue), dH, lfe);
var Tn = /* @__PURE__ */ function() {
  function e(t, n) {
    Js(this, e), ce(this, "name", void 0), ce(this, "style", void 0), ce(this, "_keyframe", !0), this.name = t, this.style = n;
  }
  return Zs(e, [{
    key: "getName",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return n ? "".concat(n, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function xd(e) {
  return e.notSplit = !0, e;
}
xd(["borderTop", "borderBottom"]), xd(["borderTop"]), xd(["borderBottom"]), xd(["borderLeft", "borderRight"]), xd(["borderLeft"]), xd(["borderRight"]);
var cfe = /* @__PURE__ */ m.createContext({});
const CR = cfe;
function pH(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function CP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ufe(e) {
  if (Array.isArray(e))
    return CP(e);
}
function hH(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ER(e, t) {
  if (e) {
    if (typeof e == "string")
      return CP(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return CP(e, t);
  }
}
function ffe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mH(e) {
  return ufe(e) || hH(e) || ER(e) || ffe();
}
function gH(e) {
  if (Array.isArray(e))
    return e;
}
function vH() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dfe(e) {
  return gH(e) || hH(e) || ER(e) || vH();
}
function EP(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function yH(e, t, n, r) {
  if (!t.length)
    return n;
  var i = dfe(t), o = i[0], a = i.slice(1), s;
  return !e && typeof o == "number" ? s = [] : Array.isArray(e) ? s = mH(e) : s = Hp({}, e), r && n === void 0 && a.length === 1 ? delete s[o][a[0]] : s[o] = yH(s[o], a, n, r), s;
}
function b$(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !EP(e, t.slice(0, -1)) ? e : yH(e, t, n, r);
}
function pfe(e) {
  return is(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function n4(e) {
  return Array.isArray(e) ? [] : {};
}
var hfe = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function mfe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = n4(t[0]);
  return t.forEach(function(i) {
    function o(a, s) {
      var l = new Set(s), c = EP(i, a), f = Array.isArray(c);
      if (f || pfe(c)) {
        if (!l.has(c)) {
          l.add(c);
          var d = EP(r, a);
          f ? r = b$(r, a, []) : (!d || is(d) !== "object") && (r = b$(r, a, n4(c))), hfe(c).forEach(function(p) {
            o([].concat(mH(a), [p]), l);
          });
        }
      } else
        r = b$(r, a, c);
    }
    o([]);
  }), r;
}
var $P = {}, gfe = function(t) {
};
function vfe(e, t) {
}
function yfe(e, t) {
}
function bfe() {
  $P = {};
}
function bH(e, t, n) {
  !t && !$P[n] && (e(!1, n), $P[n] = !0);
}
function Yw(e, t) {
  bH(vfe, e, t);
}
function wfe(e, t) {
  bH(yfe, e, t);
}
Yw.preMessage = gfe;
Yw.resetWarned = bfe;
Yw.noteOnce = wfe;
function Sfe() {
}
const xfe = /* @__PURE__ */ m.createContext({}), wH = () => {
  const e = () => {
  };
  return e.deprecated = Sfe, e;
}, Cfe = /* @__PURE__ */ m.createContext(void 0);
var Efe = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, $fe = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
const _fe = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, SH = _fe, Ofe = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, $fe),
  timePickerLocale: Object.assign({}, SH)
}, r4 = Ofe, ca = "${label} is not a valid ${type}", Pfe = {
  locale: "en",
  Pagination: Efe,
  DatePicker: r4,
  TimePicker: SH,
  Calendar: r4,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: ca,
        method: ca,
        array: ca,
        object: ca,
        number: ca,
        date: ca,
        boolean: ca,
        integer: ca,
        float: ca,
        regexp: ca,
        email: ca,
        url: ca,
        hex: ca
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
}, Ff = Pfe;
let lb = Object.assign({}, Ff.Modal), cb = [];
const i4 = () => cb.reduce((e, t) => Object.assign(Object.assign({}, e), t), Ff.Modal);
function Tfe(e) {
  if (e) {
    const t = Object.assign({}, e);
    return cb.push(t), lb = i4(), () => {
      cb = cb.filter((n) => n !== t), lb = i4();
    };
  }
  lb = Object.assign({}, Ff.Modal);
}
function xH() {
  return lb;
}
const Ife = /* @__PURE__ */ m.createContext(void 0), $R = Ife, Afe = (e, t) => {
  const n = m.useContext($R), r = m.useMemo(() => {
    var o;
    const a = t || Ff[e], s = (o = n == null ? void 0 : n[e]) !== null && o !== void 0 ? o : {};
    return Object.assign(Object.assign({}, typeof a == "function" ? a() : a), s || {});
  }, [e, t, n]), i = m.useMemo(() => {
    const o = n == null ? void 0 : n.locale;
    return n != null && n.exist && !o ? Ff.locale : o;
  }, [n]);
  return [r, i];
}, Xw = Afe, Rfe = "internalMark", Mfe = (e) => {
  const {
    locale: t = {},
    children: n,
    _ANT_MARK__: r
  } = e;
  m.useEffect(() => Tfe(t && t.Modal), [t]);
  const i = m.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ m.createElement($R.Provider, {
    value: i
  }, n);
}, Nfe = Mfe;
function Hi(e, t) {
  kfe(e) && (e = "100%");
  var n = Lfe(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function o0(e) {
  return Math.min(1, Math.max(0, e));
}
function kfe(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Lfe(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function CH(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function a0(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function bf(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Dfe(e, t, n) {
  return {
    r: Hi(e, 255) * 255,
    g: Hi(t, 255) * 255,
    b: Hi(n, 255) * 255
  };
}
function o4(e, t, n) {
  e = Hi(e, 255), t = Hi(t, 255), n = Hi(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = 0, s = (r + i) / 2;
  if (r === i)
    a = 0, o = 0;
  else {
    var l = r - i;
    switch (a = s > 0.5 ? l / (2 - r - i) : l / (r + i), r) {
      case e:
        o = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / l + 2;
        break;
      case n:
        o = (e - t) / l + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: a, l: s };
}
function w$(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function jfe(e, t, n) {
  var r, i, o;
  if (e = Hi(e, 360), t = Hi(t, 100), n = Hi(n, 100), t === 0)
    i = n, o = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - a;
    r = w$(s, a, e + 1 / 3), i = w$(s, a, e), o = w$(s, a, e - 1 / 3);
  }
  return { r: r * 255, g: i * 255, b: o * 255 };
}
function _P(e, t, n) {
  e = Hi(e, 255), t = Hi(t, 255), n = Hi(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = r, s = r - i, l = r === 0 ? 0 : s / r;
  if (r === i)
    o = 0;
  else {
    switch (r) {
      case e:
        o = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / s + 2;
        break;
      case n:
        o = (e - t) / s + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: l, v: a };
}
function Ffe(e, t, n) {
  e = Hi(e, 360) * 6, t = Hi(t, 100), n = Hi(n, 100);
  var r = Math.floor(e), i = e - r, o = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), l = r % 6, c = [n, a, o, o, s, n][l], f = [s, n, n, a, o, o][l], d = [o, o, s, n, n, a][l];
  return { r: c * 255, g: f * 255, b: d * 255 };
}
function OP(e, t, n, r) {
  var i = [
    bf(Math.round(e).toString(16)),
    bf(Math.round(t).toString(16)),
    bf(Math.round(n).toString(16))
  ];
  return r && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function Bfe(e, t, n, r, i) {
  var o = [
    bf(Math.round(e).toString(16)),
    bf(Math.round(t).toString(16)),
    bf(Math.round(n).toString(16)),
    bf(zfe(r))
  ];
  return i && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) && o[3].startsWith(o[3].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function zfe(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function a4(e) {
  return fa(e) / 255;
}
function fa(e) {
  return parseInt(e, 16);
}
function Ufe(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var PP = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Bd(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof e == "string" && (e = Vfe(e)), typeof e == "object" && (ql(e.r) && ql(e.g) && ql(e.b) ? (t = Dfe(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : ql(e.h) && ql(e.s) && ql(e.v) ? (r = a0(e.s), i = a0(e.v), t = Ffe(e.h, r, i), a = !0, s = "hsv") : ql(e.h) && ql(e.s) && ql(e.l) && (r = a0(e.s), o = a0(e.l), t = jfe(e.h, r, o), a = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = CH(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var Hfe = "[-\\+]?\\d+%?", Wfe = "[-\\+]?\\d*\\.\\d+%?", ru = "(?:".concat(Wfe, ")|(?:").concat(Hfe, ")"), S$ = "[\\s|\\(]+(".concat(ru, ")[,|\\s]+(").concat(ru, ")[,|\\s]+(").concat(ru, ")\\s*\\)?"), x$ = "[\\s|\\(]+(".concat(ru, ")[,|\\s]+(").concat(ru, ")[,|\\s]+(").concat(ru, ")[,|\\s]+(").concat(ru, ")\\s*\\)?"), _s = {
  CSS_UNIT: new RegExp(ru),
  rgb: new RegExp("rgb" + S$),
  rgba: new RegExp("rgba" + x$),
  hsl: new RegExp("hsl" + S$),
  hsla: new RegExp("hsla" + x$),
  hsv: new RegExp("hsv" + S$),
  hsva: new RegExp("hsva" + x$),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Vfe(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (PP[e])
    e = PP[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = _s.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = _s.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = _s.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = _s.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = _s.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = _s.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = _s.hex8.exec(e), n ? {
    r: fa(n[1]),
    g: fa(n[2]),
    b: fa(n[3]),
    a: a4(n[4]),
    format: t ? "name" : "hex8"
  } : (n = _s.hex6.exec(e), n ? {
    r: fa(n[1]),
    g: fa(n[2]),
    b: fa(n[3]),
    format: t ? "name" : "hex"
  } : (n = _s.hex4.exec(e), n ? {
    r: fa(n[1] + n[1]),
    g: fa(n[2] + n[2]),
    b: fa(n[3] + n[3]),
    a: a4(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = _s.hex3.exec(e), n ? {
    r: fa(n[1] + n[1]),
    g: fa(n[2] + n[2]),
    b: fa(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function ql(e) {
  return !!_s.CSS_UNIT.exec(String(e));
}
var Go = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = Ufe(t)), this.originalInput = t;
      var i = Bd(t);
      this.originalInput = t, this.r = i.r, this.g = i.g, this.b = i.b, this.a = i.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : i.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = i.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, i, o = t.r / 255, a = t.g / 255, s = t.b / 255;
      return o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? i = s / 12.92 : i = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * i;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = CH(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = _P(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = _P(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = o4(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = o4(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), OP(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), Bfe(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(Hi(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(Hi(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + OP(this.r, this.g, this.b, !1), n = 0, r = Object.entries(PP); n < r.length; n++) {
        var i = r[n], o = i[0], a = i[1];
        if (t === a)
          return o;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, i = this.a < 1 && this.a >= 0, o = !n && i && (t.startsWith("hex") || t === "name");
      return o ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = o0(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = o0(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = o0(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = o0(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), i = new e(t).toRgb(), o = n / 100, a = {
        r: (i.r - r.r) * o + r.r,
        g: (i.g - r.g) * o + r.g,
        b: (i.b - r.b) * o + r.b,
        a: (i.a - r.a) * o + r.a
      };
      return new e(a);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), i = 360 / n, o = [this];
      for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + i) % 360, o.push(new e(r));
      return o;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / t; t--; )
        a.push(new e({ h: r, s: i, v: o })), o = (o + s) % 1;
      return a;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), i = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / i,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / i,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / i,
        a: i
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, i = [this], o = 360 / t, a = 1; a < t; a++)
        i.push(new e({ h: (r + a * o) % 360, s: n.s, l: n.l }));
      return i;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
), s0 = 2, s4 = 0.16, Gfe = 0.05, Kfe = 0.05, qfe = 0.15, EH = 5, $H = 4, Yfe = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function l4(e) {
  var t = e.r, n = e.g, r = e.b, i = _P(t, n, r);
  return {
    h: i.h * 360,
    s: i.s,
    v: i.v
  };
}
function l0(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(OP(t, n, r, !1));
}
function Xfe(e, t, n) {
  var r = n / 100, i = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return i;
}
function c4(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - s0 * t : Math.round(e.h) + s0 * t : r = n ? Math.round(e.h) + s0 * t : Math.round(e.h) - s0 * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function u4(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - s4 * t : t === $H ? r = e.s + s4 : r = e.s + Gfe * t, r > 1 && (r = 1), n && t === EH && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function f4(e, t, n) {
  var r;
  return n ? r = e.v + Kfe * t : r = e.v - qfe * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function Gp(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = Bd(e), i = EH; i > 0; i -= 1) {
    var o = l4(r), a = l0(Bd({
      h: c4(o, i, !0),
      s: u4(o, i, !0),
      v: f4(o, i, !0)
    }));
    n.push(a);
  }
  n.push(l0(r));
  for (var s = 1; s <= $H; s += 1) {
    var l = l4(r), c = l0(Bd({
      h: c4(l, s),
      s: u4(l, s),
      v: f4(l, s)
    }));
    n.push(c);
  }
  return t.theme === "dark" ? Yfe.map(function(f) {
    var d = f.index, p = f.opacity, g = l0(Xfe(Bd(t.backgroundColor || "#141414"), Bd(n[d]), p * 100));
    return g;
  }) : n;
}
var C$ = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, ub = {}, E$ = {};
Object.keys(C$).forEach(function(e) {
  ub[e] = Gp(C$[e]), ub[e].primary = ub[e][5], E$[e] = Gp(C$[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), E$[e].primary = E$[e][5];
});
var Qfe = ub.gold;
const Jfe = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
}, Zfe = Jfe;
function ede(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
const _H = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, tde = Object.assign(Object.assign({}, _H), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), Rg = tde;
function nde(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: i,
    colorWarning: o,
    colorError: a,
    colorInfo: s,
    colorPrimary: l,
    colorBgBase: c,
    colorTextBase: f
  } = e, d = n(l), p = n(i), g = n(o), v = n(a), y = n(s), x = r(c, f), b = e.colorLink || e.colorInfo, w = n(b);
  return Object.assign(Object.assign({}, x), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: p[1],
    colorSuccessBgHover: p[2],
    colorSuccessBorder: p[3],
    colorSuccessBorderHover: p[4],
    colorSuccessHover: p[4],
    colorSuccess: p[6],
    colorSuccessActive: p[7],
    colorSuccessTextHover: p[8],
    colorSuccessText: p[9],
    colorSuccessTextActive: p[10],
    colorErrorBg: v[1],
    colorErrorBgHover: v[2],
    colorErrorBorder: v[3],
    colorErrorBorderHover: v[4],
    colorErrorHover: v[5],
    colorError: v[6],
    colorErrorActive: v[7],
    colorErrorTextHover: v[8],
    colorErrorText: v[9],
    colorErrorTextActive: v[10],
    colorWarningBg: g[1],
    colorWarningBgHover: g[2],
    colorWarningBorder: g[3],
    colorWarningBorderHover: g[4],
    colorWarningHover: g[4],
    colorWarning: g[6],
    colorWarningActive: g[7],
    colorWarningTextHover: g[8],
    colorWarningText: g[9],
    colorWarningTextActive: g[10],
    colorInfoBg: y[1],
    colorInfoBgHover: y[2],
    colorInfoBorder: y[3],
    colorInfoBorderHover: y[4],
    colorInfoHover: y[4],
    colorInfo: y[6],
    colorInfoActive: y[7],
    colorInfoTextHover: y[8],
    colorInfoText: y[9],
    colorInfoTextActive: y[10],
    colorLinkHover: w[4],
    colorLink: w[6],
    colorLinkActive: w[7],
    colorBgMask: new Go("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const rde = (e) => {
  let t = e, n = e, r = e, i = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? i = 4 : e >= 8 && (i = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: i
  };
}, ide = rde;
function ode(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: i
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: i + 1
  }, ide(r));
}
const Yl = (e, t) => new Go(e).setAlpha(t).toRgbString(), vm = (e, t) => new Go(e).darken(t).toHexString(), ade = (e) => {
  const t = Gp(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, sde = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: Yl(r, 0.88),
    colorTextSecondary: Yl(r, 0.65),
    colorTextTertiary: Yl(r, 0.45),
    colorTextQuaternary: Yl(r, 0.25),
    colorFill: Yl(r, 0.15),
    colorFillSecondary: Yl(r, 0.06),
    colorFillTertiary: Yl(r, 0.04),
    colorFillQuaternary: Yl(r, 0.02),
    colorBgLayout: vm(n, 4),
    colorBgContainer: vm(n, 0),
    colorBgElevated: vm(n, 0),
    colorBgSpotlight: Yl(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: vm(n, 15),
    colorBorderSecondary: vm(n, 6)
  };
};
function fb(e) {
  return (e + 8) / e;
}
function lde(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const i = r - 1, o = e * Math.pow(2.71828, i / 5), a = r > 1 ? Math.floor(o) : Math.ceil(o);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: fb(n)
  }));
}
const cde = (e) => {
  const t = lde(e), n = t.map((f) => f.size), r = t.map((f) => f.lineHeight), i = n[1], o = n[0], a = n[2], s = r[1], l = r[0], c = r[2];
  return {
    fontSizeSM: o,
    fontSize: i,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: c,
    lineHeightSM: l,
    fontHeight: Math.round(s * i),
    fontHeightLG: Math.round(c * a),
    fontHeightSM: Math.round(l * o),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
}, ude = cde;
function fde(e) {
  const t = Object.keys(_H).map((n) => {
    const r = Gp(e[n]);
    return new Array(10).fill(1).reduce((i, o, a) => (i[`${n}-${a + 1}`] = r[a], i[`${n}${a + 1}`] = r[a], i), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), nde(e, {
    generateColorPalettes: ade,
    generateNeutralColorPalettes: sde
  })), ude(e.fontSize)), ede(e)), Zfe(e)), ode(e));
}
const OH = gP(fde), TP = {
  token: Rg,
  override: {
    override: Rg
  },
  hashed: !0
}, PH = /* @__PURE__ */ oe.createContext(TP), _R = "anticon", dde = (e, t) => t || (e ? `ant-${e}` : "ant"), Mt = /* @__PURE__ */ m.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: dde,
  iconPrefixCls: _R
});
function av() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function pde(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var d4 = "data-rc-order", p4 = "data-rc-priority", hde = "rc-util-key", IP = /* @__PURE__ */ new Map();
function TH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : hde;
}
function OR(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function mde(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function PR(e) {
  return Array.from((IP.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function IH(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!av())
    return null;
  var n = t.csp, r = t.prepend, i = t.priority, o = i === void 0 ? 0 : i, a = mde(r), s = a === "prependQueue", l = document.createElement("style");
  l.setAttribute(d4, a), s && o && l.setAttribute(p4, "".concat(o)), n != null && n.nonce && (l.nonce = n == null ? void 0 : n.nonce), l.innerHTML = e;
  var c = OR(t), f = c.firstChild;
  if (r) {
    if (s) {
      var d = (t.styles || PR(c)).filter(function(p) {
        if (!["prepend", "prependQueue"].includes(p.getAttribute(d4)))
          return !1;
        var g = Number(p.getAttribute(p4) || 0);
        return o >= g;
      });
      if (d.length)
        return c.insertBefore(l, d[d.length - 1].nextSibling), l;
    }
    c.insertBefore(l, f);
  } else
    c.appendChild(l);
  return l;
}
function gde(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = OR(t);
  return (t.styles || PR(n)).find(function(r) {
    return r.getAttribute(TH(t)) === e;
  });
}
function vde(e, t) {
  var n = IP.get(e);
  if (!n || !pde(document, n)) {
    var r = IH("", t), i = r.parentNode;
    IP.set(e, i), e.removeChild(r);
  }
}
function yde(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = OR(n), i = PR(r), o = Hp(Hp({}, n), {}, {
    styles: i
  });
  vde(r, o);
  var a = gde(t, o);
  if (a) {
    var s, l;
    if ((s = o.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((l = o.csp) === null || l === void 0 ? void 0 : l.nonce)) {
      var c;
      a.nonce = (c = o.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var f = IH(e, o);
  return f.setAttribute(TH(o), t), f;
}
const bde = `-ant-${Date.now()}-${Math.random()}`;
function wde(e, t) {
  const n = {}, r = (a, s) => {
    let l = a.clone();
    return l = (s == null ? void 0 : s(l)) || l, l.toRgbString();
  }, i = (a, s) => {
    const l = new Go(a), c = Gp(l.toRgbString());
    n[`${s}-color`] = r(l), n[`${s}-color-disabled`] = c[1], n[`${s}-color-hover`] = c[4], n[`${s}-color-active`] = c[6], n[`${s}-color-outline`] = l.clone().setAlpha(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = c[0], n[`${s}-color-deprecated-border`] = c[2];
  };
  if (t.primaryColor) {
    i(t.primaryColor, "primary");
    const a = new Go(t.primaryColor), s = Gp(a.toRgbString());
    s.forEach((c, f) => {
      n[`primary-${f + 1}`] = c;
    }), n["primary-color-deprecated-l-35"] = r(a, (c) => c.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (c) => c.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (c) => c.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (c) => c.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (c) => c.setAlpha(c.getAlpha() * 0.12));
    const l = new Go(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(l, (c) => c.setAlpha(c.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(l, (c) => c.darken(2));
  }
  return t.successColor && i(t.successColor, "success"), t.warningColor && i(t.warningColor, "warning"), t.errorColor && i(t.errorColor, "error"), t.infoColor && i(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function Sde(e, t) {
  const n = wde(e, t);
  av() && yde(n, `${bde}-dynamic-theme`);
}
const AP = /* @__PURE__ */ m.createContext(!1), AH = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = m.useContext(AP);
  return /* @__PURE__ */ m.createElement(AP.Provider, {
    value: n ?? r
  }, t);
}, sv = AP, RP = /* @__PURE__ */ m.createContext(void 0), xde = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = m.useContext(RP);
  return /* @__PURE__ */ m.createElement(RP.Provider, {
    value: n || r
  }, t);
}, Qw = RP;
function Cde() {
  const e = m.useContext(sv), t = m.useContext(Qw);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
function Ede(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = r.has(o);
    if (Yw(!l, "Warning: There may be circular references"), l)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var c = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var f = 0; f < o.length; f++)
        if (!i(o[f], a[f], c))
          return !1;
      return !0;
    }
    if (o && a && is(o) === "object" && is(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(p) {
        return i(o[p], a[p], c);
      });
    }
    return !1;
  }
  return i(e, t);
}
const Mg = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], $de = "5.15.4";
function $$(e) {
  return e >= 0 && e <= 255;
}
function c0(e, t) {
  const {
    r: n,
    g: r,
    b: i,
    a: o
  } = new Go(e).toRgb();
  if (o < 1)
    return e;
  const {
    r: a,
    g: s,
    b: l
  } = new Go(t).toRgb();
  for (let c = 0.01; c <= 1; c += 0.01) {
    const f = Math.round((n - a * (1 - c)) / c), d = Math.round((r - s * (1 - c)) / c), p = Math.round((i - l * (1 - c)) / c);
    if ($$(f) && $$(d) && $$(p))
      return new Go({
        r: f,
        g: d,
        b: p,
        a: Math.round(c * 100) / 100
      }).toRgbString();
  }
  return new Go({
    r: n,
    g: r,
    b: i,
    a: 1
  }).toRgbString();
}
var _de = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function RH(e) {
  const {
    override: t
  } = e, n = _de(e, ["override"]), r = Object.assign({}, t);
  Object.keys(Rg).forEach((p) => {
    delete r[p];
  });
  const i = Object.assign(Object.assign({}, n), r), o = 480, a = 576, s = 768, l = 992, c = 1200, f = 1600;
  if (i.motion === !1) {
    const p = "0s";
    i.motionDurationFast = p, i.motionDurationMid = p, i.motionDurationSlow = p;
  }
  return Object.assign(Object.assign(Object.assign({}, i), {
    // ============== Background ============== //
    colorFillContent: i.colorFillSecondary,
    colorFillContentHover: i.colorFill,
    colorFillAlter: i.colorFillQuaternary,
    colorBgContainerDisabled: i.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: i.colorBgContainer,
    colorSplit: c0(i.colorBorderSecondary, i.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: i.colorTextQuaternary,
    colorTextDisabled: i.colorTextQuaternary,
    colorTextHeading: i.colorText,
    colorTextLabel: i.colorTextSecondary,
    colorTextDescription: i.colorTextTertiary,
    colorTextLightSolid: i.colorWhite,
    colorHighlight: i.colorError,
    colorBgTextHover: i.colorFillSecondary,
    colorBgTextActive: i.colorFill,
    colorIcon: i.colorTextTertiary,
    colorIconHover: i.colorText,
    colorErrorOutline: c0(i.colorErrorBg, i.colorBgContainer),
    colorWarningOutline: c0(i.colorWarningBg, i.colorBgContainer),
    // Font
    fontSizeIcon: i.fontSizeSM,
    // Line
    lineWidthFocus: i.lineWidth * 4,
    // Control
    lineWidth: i.lineWidth,
    controlOutlineWidth: i.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: i.controlHeight / 2,
    controlItemBgHover: i.colorFillTertiary,
    controlItemBgActive: i.colorPrimaryBg,
    controlItemBgActiveHover: i.colorPrimaryBgHover,
    controlItemBgActiveDisabled: i.colorFill,
    controlTmpOutline: i.colorFillQuaternary,
    controlOutline: c0(i.colorPrimaryBg, i.colorBgContainer),
    lineType: i.lineType,
    borderRadius: i.borderRadius,
    borderRadiusXS: i.borderRadiusXS,
    borderRadiusSM: i.borderRadiusSM,
    borderRadiusLG: i.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: i.sizeXXS,
    paddingXS: i.sizeXS,
    paddingSM: i.sizeSM,
    padding: i.size,
    paddingMD: i.sizeMD,
    paddingLG: i.sizeLG,
    paddingXL: i.sizeXL,
    paddingContentHorizontalLG: i.sizeLG,
    paddingContentVerticalLG: i.sizeMS,
    paddingContentHorizontal: i.sizeMS,
    paddingContentVertical: i.sizeSM,
    paddingContentHorizontalSM: i.size,
    paddingContentVerticalSM: i.sizeXS,
    marginXXS: i.sizeXXS,
    marginXS: i.sizeXS,
    marginSM: i.sizeSM,
    margin: i.size,
    marginMD: i.sizeMD,
    marginLG: i.sizeLG,
    marginXL: i.sizeXL,
    marginXXL: i.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: o,
    screenXSMin: o,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: c - 1,
    screenXL: c,
    screenXLMin: c,
    screenXLMax: f - 1,
    screenXXL: f,
    screenXXLMin: f,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new Go("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new Go("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new Go("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var h4 = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const MH = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0
}, NH = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, Ode = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, kH = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: i
  } = t, o = h4(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: i
  });
  return a = RH(a), o && Object.entries(o).forEach((s) => {
    let [l, c] = s;
    const {
      theme: f
    } = c, d = h4(c, ["theme"]);
    let p = d;
    f && (p = kH(Object.assign(Object.assign({}, a), d), {
      override: d
    }, f)), a[l] = p;
  }), a;
};
function ss() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: i
  } = oe.useContext(PH), o = `${$de}-${t || ""}`, a = n || OH, [s, l, c] = Mue(a, [Rg, e], {
    salt: o,
    override: r,
    getComputedToken: kH,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: RH,
    cssVar: i && {
      prefix: i.prefix,
      key: i.key,
      unitless: MH,
      ignore: NH,
      preserve: Ode
    }
  });
  return [a, c, t ? l : "", s, i];
}
function $1(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function Pde(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function MP(e, t) {
  return gH(e) || Pde(e, t) || ER(e, t) || vH();
}
var m4 = av() ? m.useLayoutEffect : m.useEffect, Sp = function(t, n) {
  var r = m.useRef(!0);
  m4(function() {
    return t(r.current);
  }, n), m4(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, g4 = function(t, n) {
  Sp(function(r) {
    if (!r)
      return t();
  }, n);
};
function NP(e) {
  var t = m.useRef(!1), n = m.useState(e), r = MP(n, 2), i = r[0], o = r[1];
  m.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || o(s);
  }
  return [i, a];
}
function _$(e) {
  return e !== void 0;
}
function TR(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = NP(function() {
    return _$(i) ? i : _$(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = MP(s, 2), c = l[0], f = l[1], d = i !== void 0 ? i : c, p = a ? a(d) : d, g = $1(o), v = NP([d]), y = MP(v, 2), x = y[0], b = y[1];
  g4(function() {
    var S = x[0];
    c !== S && g(c, S);
  }, [x]), g4(function() {
    _$(i) || f(i);
  }, [i]);
  var w = $1(function(S, E) {
    f(S, E), b([d], E);
  });
  return [p, w];
}
function Tde(e, t) {
  typeof e == "function" ? e(t) : is(e) === "object" && e && "current" in e && (e.current = t);
}
function Sc() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      Tde(o, i);
    });
  };
}
function Ide(e) {
  var t, n, r = wp.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) && r.$$typeof !== wp.ForwardRef || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render) && e.$$typeof !== wp.ForwardRef);
}
const LH = (e) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${e.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
}), IR = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, Vi = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, DH = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), gh = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), Ade = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active,\n  &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), Rde = (e, t, n) => {
  const {
    fontFamily: r,
    fontSize: i
  } = e, o = `[class^="${t}"], [class*=" ${t}"]`;
  return {
    [n ? `.${n}` : o]: {
      fontFamily: r,
      fontSize: i,
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      },
      [o]: {
        boxSizing: "border-box",
        "&::before, &::after": {
          boxSizing: "border-box"
        }
      }
    }
  };
}, AR = (e) => ({
  outline: `${ge(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), Jw = (e) => ({
  "&:focus-visible": Object.assign({}, AR(e))
});
function RR(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Kp(e) {
  "@babel/helpers - typeof";
  return Kp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kp(e);
}
function Mde(e, t) {
  if (Kp(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Kp(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Nde(e) {
  var t = Mde(e, "string");
  return Kp(t) == "symbol" ? t : t + "";
}
function v4(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Nde(r.key), r);
  }
}
function MR(e, t, n) {
  return t && v4(e.prototype, t), n && v4(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _1(e) {
  return _1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _1(e);
}
function jH() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jH = function() {
    return !!e;
  })();
}
function kde(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Lde(e, t) {
  if (t && (Kp(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return kde(e);
}
function FH(e, t, n) {
  return t = _1(t), Lde(e, jH() ? Reflect.construct(t, n || [], _1(e).constructor) : t.apply(e, n));
}
function kP(e, t) {
  return kP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, kP(e, t);
}
function BH(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && kP(e, t);
}
let Dde = /* @__PURE__ */ MR(function e() {
  RR(this, e);
});
const zH = Dde;
let jde = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return RR(this, t), r = FH(this, t), r.result = 0, n instanceof t ? r.result = n.result : typeof n == "number" && (r.result = n), r;
  }
  return BH(t, e), MR(t, [{
    key: "add",
    value: function(r) {
      return r instanceof t ? this.result += r.result : typeof r == "number" && (this.result += r), this;
    }
  }, {
    key: "sub",
    value: function(r) {
      return r instanceof t ? this.result -= r.result : typeof r == "number" && (this.result -= r), this;
    }
  }, {
    key: "mul",
    value: function(r) {
      return r instanceof t ? this.result *= r.result : typeof r == "number" && (this.result *= r), this;
    }
  }, {
    key: "div",
    value: function(r) {
      return r instanceof t ? this.result /= r.result : typeof r == "number" && (this.result /= r), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]);
}(zH);
const UH = "CALC_UNIT";
function O$(e) {
  return typeof e == "number" ? `${e}${UH}` : e;
}
let Fde = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return RR(this, t), r = FH(this, t), r.result = "", n instanceof t ? r.result = `(${n.result})` : typeof n == "number" ? r.result = O$(n) : typeof n == "string" && (r.result = n), r;
  }
  return BH(t, e), MR(t, [{
    key: "add",
    value: function(r) {
      return r instanceof t ? this.result = `${this.result} + ${r.getResult()}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} + ${O$(r)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(r) {
      return r instanceof t ? this.result = `${this.result} - ${r.getResult()}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} - ${O$(r)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(r) {
      return this.lowPriority && (this.result = `(${this.result})`), r instanceof t ? this.result = `${this.result} * ${r.getResult(!0)}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} * ${r}`), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(r) {
      return this.lowPriority && (this.result = `(${this.result})`), r instanceof t ? this.result = `${this.result} / ${r.getResult(!0)}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} / ${r}`), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(r) {
      return this.lowPriority || r ? `(${this.result})` : this.result;
    }
  }, {
    key: "equal",
    value: function(r) {
      const {
        unit: i = !0
      } = r || {}, o = new RegExp(`${UH}`, "g");
      return this.result = this.result.replace(o, i ? "px" : ""), typeof this.lowPriority < "u" ? `calc(${this.result})` : this.result;
    }
  }]);
}(zH);
const Bde = (e) => {
  const t = e === "css" ? Fde : jde;
  return (n) => new t(n);
}, zde = Bde;
function Ude(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return `max(${n.map((i) => ge(i)).join(",")})`;
    },
    min: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return `min(${n.map((i) => ge(i)).join(",")})`;
    }
  };
}
const HH = typeof CSSINJS_STATISTIC < "u";
let LP = !0;
function _r() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!HH)
    return Object.assign.apply(Object, [{}].concat(t));
  LP = !1;
  const r = {};
  return t.forEach((i) => {
    Object.keys(i).forEach((a) => {
      Object.defineProperty(r, a, {
        configurable: !0,
        enumerable: !0,
        get: () => i[a]
      });
    });
  }), LP = !0, r;
}
const y4 = {};
function Hde() {
}
const Wde = (e) => {
  let t, n = e, r = Hde;
  return HH && typeof Proxy < "u" && (t = /* @__PURE__ */ new Set(), n = new Proxy(e, {
    get(i, o) {
      return LP && t.add(o), i[o];
    }
  }), r = (i, o) => {
    var a;
    y4[i] = {
      global: Array.from(t),
      component: Object.assign(Object.assign({}, (a = y4[i]) === null || a === void 0 ? void 0 : a.component), o)
    };
  }), {
    token: n,
    keys: t,
    flush: r
  };
}, Vde = (e, t) => {
  const [n, r] = ss();
  return xP({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, DH()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, WH = Vde, VH = (e, t, n) => {
  var r;
  return typeof n == "function" ? n(_r(t, (r = t[e]) !== null && r !== void 0 ? r : {})) : n ?? {};
}, GH = (e, t, n, r) => {
  const i = Object.assign({}, t[e]);
  if (r != null && r.deprecatedTokens) {
    const {
      deprecatedTokens: a
    } = r;
    a.forEach((s) => {
      let [l, c] = s;
      var f;
      (i != null && i[l] || i != null && i[c]) && ((f = i[c]) !== null && f !== void 0 || (i[c] = i == null ? void 0 : i[l]));
    });
  }
  const o = Object.assign(Object.assign({}, n), i);
  return Object.keys(o).forEach((a) => {
    o[a] === t[a] && delete o[a];
  }), o;
}, Gde = (e, t) => `${[t, e.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function NR(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const i = Array.isArray(e) ? e : [e, e], [o] = i, a = i.join("-");
  return function(s) {
    let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
    const [c, f, d, p, g] = ss(), {
      getPrefixCls: v,
      iconPrefixCls: y,
      csp: x
    } = m.useContext(Mt), b = v(), w = g ? "css" : "js", S = zde(w), {
      max: E,
      min: O
    } = Ude(w), $ = {
      theme: c,
      token: p,
      hashId: d,
      nonce: () => x == null ? void 0 : x.nonce,
      clientOnly: r.clientOnly,
      // antd is always at top of styles
      order: r.order || -999
    };
    return xP(Object.assign(Object.assign({}, $), {
      clientOnly: !1,
      path: ["Shared", b]
    }), () => [{
      // Link
      "&": Ade(p)
    }]), WH(y, x), [xP(Object.assign(Object.assign({}, $), {
      path: [a, s, y]
    }), () => {
      if (r.injectStyle === !1)
        return [];
      const {
        token: R,
        flush: L
      } = Wde(p), B = VH(o, f, n), j = `.${s}`, A = GH(o, f, B, {
        deprecatedTokens: r.deprecatedTokens
      });
      g && Object.keys(B).forEach((F) => {
        B[F] = `var(${JU(F, Gde(o, g.prefix))})`;
      });
      const T = _r(R, {
        componentCls: j,
        prefixCls: s,
        iconCls: `.${y}`,
        antCls: `.${b}`,
        calc: S,
        max: E,
        min: O
      }, g ? B : A), k = t(T, {
        hashId: d,
        prefixCls: s,
        rootPrefixCls: b,
        iconPrefixCls: y
      });
      return L(o, A), [r.resetStyle === !1 ? null : Rde(T, s, l), k];
    }), d];
  };
}
const Zw = (e, t, n, r) => {
  const i = NR(e, t, n, Object.assign({
    resetStyle: !1,
    // Sub Style should default after root one
    order: -998
  }, r));
  return (a) => {
    let {
      prefixCls: s,
      rootCls: l = s
    } = a;
    return i(s, l), null;
  };
}, Kde = (e, t, n) => {
  function r(c) {
    return `${e}${c.slice(0, 1).toUpperCase()}${c.slice(1)}`;
  }
  const {
    unitless: i = {},
    injectStyle: o = !0
  } = n ?? {}, a = {
    [r("zIndexPopup")]: !0
  };
  Object.keys(i).forEach((c) => {
    a[r(c)] = i[c];
  });
  const s = (c) => {
    let {
      rootCls: f,
      cssVar: d
    } = c;
    const [, p] = ss();
    return sfe({
      path: [e],
      prefix: d.prefix,
      key: d == null ? void 0 : d.key,
      unitless: Object.assign(Object.assign({}, MH), a),
      ignore: NH,
      token: p,
      scope: f
    }, () => {
      const g = VH(e, p, t), v = GH(e, p, g, {
        deprecatedTokens: n == null ? void 0 : n.deprecatedTokens
      });
      return Object.keys(g).forEach((y) => {
        v[r(y)] = v[y], delete v[y];
      }), v;
    }), null;
  };
  return (c) => {
    const [, , , , f] = ss();
    return [(d) => o && f ? /* @__PURE__ */ oe.createElement(oe.Fragment, null, /* @__PURE__ */ oe.createElement(s, {
      rootCls: c,
      cssVar: f,
      component: e
    }), d) : d, f == null ? void 0 : f.key];
  };
}, Pi = (e, t, n, r) => {
  const i = NR(e, t, n, r), o = Kde(Array.isArray(e) ? e[0] : e, n, r);
  return function(a) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : a;
    const [, l] = i(a, s), [c, f] = o(s);
    return [c, l, f];
  };
};
function eS(e, t) {
  return Mg.reduce((n, r) => {
    const i = e[`${r}1`], o = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: i,
      lightBorderColor: o,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
const qde = Object.assign({}, sh), {
  useId: b4
} = qde, Yde = () => "", Xde = typeof b4 > "u" ? Yde : b4, Qde = Xde;
function Jde(e, t, n) {
  var r;
  wH();
  const i = e || {}, o = i.inherit === !1 || !t ? Object.assign(Object.assign({}, TP), {
    hashed: (r = t == null ? void 0 : t.hashed) !== null && r !== void 0 ? r : TP.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, a = Qde();
  return pH(() => {
    var s, l;
    if (!e)
      return t;
    const c = Object.assign({}, o.components);
    Object.keys(e.components || {}).forEach((p) => {
      c[p] = Object.assign(Object.assign({}, c[p]), e.components[p]);
    });
    const f = `css-var-${a.replace(/:/g, "")}`, d = ((s = i.cssVar) !== null && s !== void 0 ? s : o.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: n == null ? void 0 : n.prefixCls
    }, typeof o.cssVar == "object" ? o.cssVar : {}), typeof i.cssVar == "object" ? i.cssVar : {}), {
      key: typeof i.cssVar == "object" && ((l = i.cssVar) === null || l === void 0 ? void 0 : l.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, o), i), {
      token: Object.assign(Object.assign({}, o.token), i.token),
      components: c,
      cssVar: d
    });
  }, [i, o], (s, l) => s.some((c, f) => {
    const d = l[f];
    return !Ede(c, d, !0);
  }));
}
function Il(e) {
  "@babel/helpers - typeof";
  return Il = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Il(e);
}
function Zde(e, t) {
  if (Il(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Il(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function KH(e) {
  var t = Zde(e, "string");
  return Il(t) === "symbol" ? t : String(t);
}
function Co(e, t, n) {
  return t = KH(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function w4(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w4(Object(n), !0).forEach(function(r) {
      Co(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w4(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function epe(e) {
  if (Array.isArray(e))
    return e;
}
function tpe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function S4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function npe(e, t) {
  if (e) {
    if (typeof e == "string")
      return S4(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return S4(e, t);
  }
}
function rpe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ic(e, t) {
  return epe(e) || tpe(e, t) || npe(e, t) || rpe();
}
var qH = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var l in o)
              t.call(o, l) && o[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(qH);
var ipe = qH.exports;
const ope = /* @__PURE__ */ Oi(ipe);
function ape(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function spe(e) {
  return ape(e) ? e : e instanceof oe.Component ? fh.findDOMNode(e) : null;
}
var YH = { exports: {} }, zn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ti = typeof Symbol == "function" && Symbol.for, kR = Ti ? Symbol.for("react.element") : 60103, LR = Ti ? Symbol.for("react.portal") : 60106, tS = Ti ? Symbol.for("react.fragment") : 60107, nS = Ti ? Symbol.for("react.strict_mode") : 60108, rS = Ti ? Symbol.for("react.profiler") : 60114, iS = Ti ? Symbol.for("react.provider") : 60109, oS = Ti ? Symbol.for("react.context") : 60110, DR = Ti ? Symbol.for("react.async_mode") : 60111, aS = Ti ? Symbol.for("react.concurrent_mode") : 60111, sS = Ti ? Symbol.for("react.forward_ref") : 60112, lS = Ti ? Symbol.for("react.suspense") : 60113, lpe = Ti ? Symbol.for("react.suspense_list") : 60120, cS = Ti ? Symbol.for("react.memo") : 60115, uS = Ti ? Symbol.for("react.lazy") : 60116, cpe = Ti ? Symbol.for("react.block") : 60121, upe = Ti ? Symbol.for("react.fundamental") : 60117, fpe = Ti ? Symbol.for("react.responder") : 60118, dpe = Ti ? Symbol.for("react.scope") : 60119;
function Ia(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case kR:
        switch (e = e.type, e) {
          case DR:
          case aS:
          case tS:
          case rS:
          case nS:
          case lS:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case oS:
              case sS:
              case uS:
              case cS:
              case iS:
                return e;
              default:
                return t;
            }
        }
      case LR:
        return t;
    }
  }
}
function XH(e) {
  return Ia(e) === aS;
}
zn.AsyncMode = DR;
zn.ConcurrentMode = aS;
zn.ContextConsumer = oS;
zn.ContextProvider = iS;
zn.Element = kR;
zn.ForwardRef = sS;
zn.Fragment = tS;
zn.Lazy = uS;
zn.Memo = cS;
zn.Portal = LR;
zn.Profiler = rS;
zn.StrictMode = nS;
zn.Suspense = lS;
zn.isAsyncMode = function(e) {
  return XH(e) || Ia(e) === DR;
};
zn.isConcurrentMode = XH;
zn.isContextConsumer = function(e) {
  return Ia(e) === oS;
};
zn.isContextProvider = function(e) {
  return Ia(e) === iS;
};
zn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === kR;
};
zn.isForwardRef = function(e) {
  return Ia(e) === sS;
};
zn.isFragment = function(e) {
  return Ia(e) === tS;
};
zn.isLazy = function(e) {
  return Ia(e) === uS;
};
zn.isMemo = function(e) {
  return Ia(e) === cS;
};
zn.isPortal = function(e) {
  return Ia(e) === LR;
};
zn.isProfiler = function(e) {
  return Ia(e) === rS;
};
zn.isStrictMode = function(e) {
  return Ia(e) === nS;
};
zn.isSuspense = function(e) {
  return Ia(e) === lS;
};
zn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === tS || e === aS || e === rS || e === nS || e === lS || e === lpe || typeof e == "object" && e !== null && (e.$$typeof === uS || e.$$typeof === cS || e.$$typeof === iS || e.$$typeof === oS || e.$$typeof === sS || e.$$typeof === upe || e.$$typeof === fpe || e.$$typeof === dpe || e.$$typeof === cpe);
};
zn.typeOf = Ia;
YH.exports = zn;
var ppe = YH.exports;
function hpe(e, t) {
  typeof e == "function" ? e(t) : Il(e) === "object" && e && "current" in e && (e.current = t);
}
function mpe(e) {
  var t, n, r = ppe.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
function gpe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function DP(e, t) {
  if (e == null)
    return {};
  var n = gpe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var vpe = ["children"], QH = /* @__PURE__ */ m.createContext({});
function ype(e) {
  var t = e.children, n = DP(e, vpe);
  return /* @__PURE__ */ m.createElement(QH.Provider, {
    value: n
  }, t);
}
function JH(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x4(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, KH(r.key), r);
  }
}
function ZH(e, t, n) {
  return t && x4(e.prototype, t), n && x4(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function jP(e, t) {
  return jP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, jP(e, t);
}
function e9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && jP(e, t);
}
function O1(e) {
  return O1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, O1(e);
}
function bpe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function FP(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wpe(e, t) {
  if (t && (Il(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return FP(e);
}
function t9(e) {
  var t = bpe();
  return function() {
    var r = O1(e), i;
    if (t) {
      var o = O1(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return wpe(this, i);
  };
}
var Spe = /* @__PURE__ */ function(e) {
  e9(n, e);
  var t = t9(n);
  function n() {
    return JH(this, n), t.apply(this, arguments);
  }
  return ZH(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(m.Component);
function db(e) {
  var t = m.useRef(!1), n = m.useState(e), r = ic(n, 2), i = r[0], o = r[1];
  m.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || o(s);
  }
  return [i, a];
}
var ef = "none", u0 = "appear", f0 = "enter", d0 = "leave", C4 = "none", Ms = "prepare", tp = "start", np = "active", jR = "end", n9 = "prepared";
function FR() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function E4(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function xpe(e, t) {
  var n = {
    animationend: E4("Animation", "AnimationEnd"),
    transitionend: E4("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var Cpe = xpe(FR(), typeof window < "u" ? window : {}), r9 = {};
if (FR()) {
  var Epe = document.createElement("div");
  r9 = Epe.style;
}
var p0 = {};
function i9(e) {
  if (p0[e])
    return p0[e];
  var t = Cpe[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(t, o) && o in r9)
        return p0[e] = t[o], p0[e];
    }
  return "";
}
var o9 = i9("animationend"), a9 = i9("transitionend"), s9 = !!(o9 && a9), $4 = o9 || "animationend", _4 = a9 || "transitionend";
function O4(e, t) {
  if (!e)
    return null;
  if (Il(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const $pe = function(e) {
  var t = m.useRef(), n = m.useRef(e);
  n.current = e;
  var r = m.useCallback(function(a) {
    n.current(a);
  }, []);
  function i(a) {
    a && (a.removeEventListener(_4, r), a.removeEventListener($4, r));
  }
  function o(a) {
    t.current && t.current !== a && i(t.current), a && a !== t.current && (a.addEventListener(_4, r), a.addEventListener($4, r), t.current = a);
  }
  return m.useEffect(function() {
    return function() {
      i(t.current);
    };
  }, []), [o, i];
};
var l9 = FR() ? m.useLayoutEffect : m.useEffect, c9 = function(t) {
  return +setTimeout(t, 16);
}, u9 = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (c9 = function(t) {
  return window.requestAnimationFrame(t);
}, u9 = function(t) {
  return window.cancelAnimationFrame(t);
});
var P4 = 0, BR = /* @__PURE__ */ new Map();
function f9(e) {
  BR.delete(e);
}
var BP = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  P4 += 1;
  var r = P4;
  function i(o) {
    if (o === 0)
      f9(r), t();
    else {
      var a = c9(function() {
        i(o - 1);
      });
      BR.set(r, a);
    }
  }
  return i(n), r;
};
BP.cancel = function(e) {
  var t = BR.get(e);
  return f9(t), u9(t);
};
const _pe = function() {
  var e = m.useRef(null);
  function t() {
    BP.cancel(e.current);
  }
  function n(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var o = BP(function() {
      i <= 1 ? r({
        isCanceled: function() {
          return o !== e.current;
        }
      }) : n(r, i - 1);
    });
    e.current = o;
  }
  return m.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var Ope = [Ms, tp, np, jR], Ppe = [Ms, n9], d9 = !1, Tpe = !0;
function p9(e) {
  return e === np || e === jR;
}
const Ipe = function(e, t, n) {
  var r = db(C4), i = ic(r, 2), o = i[0], a = i[1], s = _pe(), l = ic(s, 2), c = l[0], f = l[1];
  function d() {
    a(Ms, !0);
  }
  var p = t ? Ppe : Ope;
  return l9(function() {
    if (o !== C4 && o !== jR) {
      var g = p.indexOf(o), v = p[g + 1], y = n(o);
      y === d9 ? a(v, !0) : v && c(function(x) {
        function b() {
          x.isCanceled() || a(v, !0);
        }
        y === !0 ? b() : Promise.resolve(y).then(b);
      });
    }
  }, [e, o]), m.useEffect(function() {
    return function() {
      f();
    };
  }, []), [d, o];
};
function Ape(e, t, n, r) {
  var i = r.motionEnter, o = i === void 0 ? !0 : i, a = r.motionAppear, s = a === void 0 ? !0 : a, l = r.motionLeave, c = l === void 0 ? !0 : l, f = r.motionDeadline, d = r.motionLeaveImmediately, p = r.onAppearPrepare, g = r.onEnterPrepare, v = r.onLeavePrepare, y = r.onAppearStart, x = r.onEnterStart, b = r.onLeaveStart, w = r.onAppearActive, S = r.onEnterActive, E = r.onLeaveActive, O = r.onAppearEnd, $ = r.onEnterEnd, P = r.onLeaveEnd, R = r.onVisibleChanged, L = db(), B = ic(L, 2), j = B[0], A = B[1], T = db(ef), k = ic(T, 2), F = k[0], W = k[1], V = db(null), G = ic(V, 2), X = G[0], D = G[1], te = m.useRef(!1), ee = m.useRef(null);
  function U() {
    return n();
  }
  var he = m.useRef(!1);
  function re() {
    W(ef, !0), D(null, !0);
  }
  function de(ie) {
    var fe = U();
    if (!(ie && !ie.deadline && ie.target !== fe)) {
      var be = he.current, Te;
      F === u0 && be ? Te = O == null ? void 0 : O(fe, ie) : F === f0 && be ? Te = $ == null ? void 0 : $(fe, ie) : F === d0 && be && (Te = P == null ? void 0 : P(fe, ie)), F !== ef && be && Te !== !1 && re();
    }
  }
  var we = $pe(de), ue = ic(we, 1), me = ue[0], Se = function(fe) {
    var be, Te, Le;
    switch (fe) {
      case u0:
        return be = {}, Co(be, Ms, p), Co(be, tp, y), Co(be, np, w), be;
      case f0:
        return Te = {}, Co(Te, Ms, g), Co(Te, tp, x), Co(Te, np, S), Te;
      case d0:
        return Le = {}, Co(Le, Ms, v), Co(Le, tp, b), Co(Le, np, E), Le;
      default:
        return {};
    }
  }, _e = m.useMemo(function() {
    return Se(F);
  }, [F]), Ge = Ipe(F, !e, function(ie) {
    if (ie === Ms) {
      var fe = _e[Ms];
      return fe ? fe(U()) : d9;
    }
    if (Me in _e) {
      var be;
      D(((be = _e[Me]) === null || be === void 0 ? void 0 : be.call(_e, U(), null)) || null);
    }
    return Me === np && (me(U()), f > 0 && (clearTimeout(ee.current), ee.current = setTimeout(function() {
      de({
        deadline: !0
      });
    }, f))), Me === n9 && re(), Tpe;
  }), Fe = ic(Ge, 2), Ae = Fe[0], Me = Fe[1], et = p9(Me);
  he.current = et, l9(function() {
    A(t);
    var ie = te.current;
    te.current = !0;
    var fe;
    !ie && t && s && (fe = u0), ie && t && o && (fe = f0), (ie && !t && c || !ie && d && !t && c) && (fe = d0);
    var be = Se(fe);
    fe && (e || be[Ms]) ? (W(fe), Ae()) : W(ef);
  }, [t]), m.useEffect(function() {
    // Cancel appear
    (F === u0 && !s || // Cancel enter
    F === f0 && !o || // Cancel leave
    F === d0 && !c) && W(ef);
  }, [s, o, c]), m.useEffect(function() {
    return function() {
      te.current = !1, clearTimeout(ee.current);
    };
  }, []);
  var De = m.useRef(!1);
  m.useEffect(function() {
    j && (De.current = !0), j !== void 0 && F === ef && ((De.current || j) && (R == null || R(j)), De.current = !0);
  }, [j, F]);
  var je = X;
  return _e[Ms] && Me === tp && (je = Er({
    transition: "none"
  }, je)), [F, Me, je, j ?? t];
}
function Rpe(e) {
  var t = e;
  Il(e) === "object" && (t = e.transitionSupport);
  function n(i, o) {
    return !!(i.motionName && t && o !== !1);
  }
  var r = /* @__PURE__ */ m.forwardRef(function(i, o) {
    var a = i.visible, s = a === void 0 ? !0 : a, l = i.removeOnLeave, c = l === void 0 ? !0 : l, f = i.forceRender, d = i.children, p = i.motionName, g = i.leavedClassName, v = i.eventProps, y = m.useContext(QH), x = y.motion, b = n(i, x), w = m.useRef(), S = m.useRef();
    function E() {
      try {
        return w.current instanceof HTMLElement ? w.current : spe(S.current);
      } catch {
        return null;
      }
    }
    var O = Ape(b, s, E, i), $ = ic(O, 4), P = $[0], R = $[1], L = $[2], B = $[3], j = m.useRef(B);
    B && (j.current = !0);
    var A = m.useCallback(function(D) {
      w.current = D, hpe(o, D);
    }, [o]), T, k = Er(Er({}, v), {}, {
      visible: s
    });
    if (!d)
      T = null;
    else if (P === ef)
      B ? T = d(Er({}, k), A) : !c && j.current && g ? T = d(Er(Er({}, k), {}, {
        className: g
      }), A) : f || !c && !g ? T = d(Er(Er({}, k), {}, {
        style: {
          display: "none"
        }
      }), A) : T = null;
    else {
      var F, W;
      R === Ms ? W = "prepare" : p9(R) ? W = "active" : R === tp && (W = "start");
      var V = O4(p, "".concat(P, "-").concat(W));
      T = d(Er(Er({}, k), {}, {
        className: ope(O4(p, P), (F = {}, Co(F, V, V && W), Co(F, p, typeof p == "string"), F)),
        style: L
      }), A);
    }
    if (/* @__PURE__ */ m.isValidElement(T) && mpe(T)) {
      var G = T, X = G.ref;
      X || (T = /* @__PURE__ */ m.cloneElement(T, {
        ref: A
      }));
    }
    return /* @__PURE__ */ m.createElement(Spe, {
      ref: S
    }, T);
  });
  return r.displayName = "CSSMotion", r;
}
const fS = Rpe(s9);
function zP() {
  return zP = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zP.apply(this, arguments);
}
var UP = "add", HP = "keep", WP = "remove", P$ = "removed";
function Mpe(e) {
  var t;
  return e && Il(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, Er(Er({}, t), {}, {
    key: String(t.key)
  });
}
function VP() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(Mpe);
}
function Npe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, i = t.length, o = VP(e), a = VP(t);
  o.forEach(function(c) {
    for (var f = !1, d = r; d < i; d += 1) {
      var p = a[d];
      if (p.key === c.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(g) {
          return Er(Er({}, g), {}, {
            status: UP
          });
        })), r = d), n.push(Er(Er({}, p), {}, {
          status: HP
        })), r += 1, f = !0;
        break;
      }
    }
    f || n.push(Er(Er({}, c), {}, {
      status: WP
    }));
  }), r < i && (n = n.concat(a.slice(r).map(function(c) {
    return Er(Er({}, c), {}, {
      status: UP
    });
  })));
  var s = {};
  n.forEach(function(c) {
    var f = c.key;
    s[f] = (s[f] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(c) {
    return s[c] > 1;
  });
  return l.forEach(function(c) {
    n = n.filter(function(f) {
      var d = f.key, p = f.status;
      return d !== c || p !== WP;
    }), n.forEach(function(f) {
      f.key === c && (f.status = HP);
    });
  }), n;
}
var kpe = ["component", "children", "onVisibleChanged", "onAllRemoved"], Lpe = ["status"], Dpe = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function jpe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fS, n = /* @__PURE__ */ function(r) {
    e9(o, r);
    var i = t9(o);
    function o() {
      var a;
      JH(this, o);
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      return a = i.call.apply(i, [this].concat(l)), Co(FP(a), "state", {
        keyEntities: []
      }), Co(FP(a), "removeKey", function(f) {
        var d = a.state.keyEntities, p = d.map(function(g) {
          return g.key !== f ? g : Er(Er({}, g), {}, {
            status: P$
          });
        });
        return a.setState({
          keyEntities: p
        }), p.filter(function(g) {
          var v = g.status;
          return v !== P$;
        }).length;
      }), a;
    }
    return ZH(o, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, c = this.props, f = c.component, d = c.children, p = c.onVisibleChanged, g = c.onAllRemoved, v = DP(c, kpe), y = f || m.Fragment, x = {};
        return Dpe.forEach(function(b) {
          x[b] = v[b], delete v[b];
        }), delete v.keys, /* @__PURE__ */ m.createElement(y, v, l.map(function(b, w) {
          var S = b.status, E = DP(b, Lpe), O = S === UP || S === HP;
          return /* @__PURE__ */ m.createElement(t, zP({}, x, {
            key: E.key,
            visible: O,
            eventProps: E,
            onVisibleChanged: function(P) {
              if (p == null || p(P, {
                key: E.key
              }), !P) {
                var R = s.removeKey(E.key);
                R === 0 && g && g();
              }
            }
          }), function($, P) {
            return d(Er(Er({}, $), {}, {
              index: w
            }), P);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var c = s.keys, f = l.keyEntities, d = VP(c), p = Npe(f, d);
        return {
          keyEntities: p.filter(function(g) {
            var v = f.find(function(y) {
              var x = y.key;
              return g.key === x;
            });
            return !(v && v.status === P$ && g.status === WP);
          })
        };
      }
    }]), o;
  }(m.Component);
  return Co(n, "defaultProps", {
    component: "div"
  }), n;
}
jpe(s9);
function Fpe(e) {
  const {
    children: t
  } = e, [, n] = ss(), {
    motion: r
  } = n, i = m.useRef(!1);
  return i.current = i.current || r === !1, i.current ? /* @__PURE__ */ m.createElement(ype, {
    motion: r
  }, t) : t;
}
const Bpe = () => null;
var zpe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Upe = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"], Hpe = "ant";
let P1, h9, m9, g9;
function pb() {
  return P1 || Hpe;
}
function Wpe() {
  return h9 || _R;
}
function Vpe(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const Gpe = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: n,
    theme: r,
    holderRender: i
  } = e;
  t !== void 0 && (P1 = t), n !== void 0 && (h9 = n), "holderRender" in e && (g9 = i), r && (Vpe(r) ? Sde(pb(), r) : m9 = r);
}, Kpe = () => ({
  getPrefixCls: (e, t) => t || (e ? `${pb()}-${e}` : pb()),
  getIconPrefixCls: Wpe,
  getRootPrefixCls: () => P1 || pb(),
  getTheme: () => m9,
  holderRender: g9
}), qpe = (e) => {
  const {
    children: t,
    csp: n,
    autoInsertSpaceInButton: r,
    alert: i,
    anchor: o,
    form: a,
    locale: s,
    componentSize: l,
    direction: c,
    space: f,
    virtual: d,
    dropdownMatchSelectWidth: p,
    popupMatchSelectWidth: g,
    popupOverflow: v,
    legacyLocale: y,
    parentContext: x,
    iconPrefixCls: b,
    theme: w,
    componentDisabled: S,
    segmented: E,
    statistic: O,
    spin: $,
    calendar: P,
    carousel: R,
    cascader: L,
    collapse: B,
    typography: j,
    checkbox: A,
    descriptions: T,
    divider: k,
    drawer: F,
    skeleton: W,
    steps: V,
    image: G,
    layout: X,
    list: D,
    mentions: te,
    modal: ee,
    progress: U,
    result: he,
    slider: re,
    breadcrumb: de,
    menu: we,
    pagination: ue,
    input: me,
    textArea: Se,
    empty: _e,
    badge: Ge,
    radio: Fe,
    rate: Ae,
    switch: Me,
    transfer: et,
    avatar: De,
    message: je,
    tag: ie,
    table: fe,
    card: be,
    tabs: Te,
    timeline: Le,
    timePicker: ct,
    upload: Z,
    notification: se,
    tree: Ce,
    colorPicker: Pe,
    datePicker: Ee,
    rangePicker: We,
    flex: ze,
    wave: Ye,
    dropdown: xt,
    warning: Lt,
    tour: mt
  } = e, St = m.useCallback((Xe, it) => {
    const {
      prefixCls: _t
    } = e;
    if (it)
      return it;
    const Yt = _t || x.getPrefixCls("");
    return Xe ? `${Yt}-${Xe}` : Yt;
  }, [x.getPrefixCls, e.prefixCls]), Et = b || x.iconPrefixCls || _R, Je = n || x.csp;
  WH(Et, Je);
  const Ze = Jde(w, x.theme, {
    prefixCls: St("")
  }), ut = {
    csp: Je,
    autoInsertSpaceInButton: r,
    alert: i,
    anchor: o,
    locale: s || y,
    direction: c,
    space: f,
    virtual: d,
    popupMatchSelectWidth: g ?? p,
    popupOverflow: v,
    getPrefixCls: St,
    iconPrefixCls: Et,
    theme: Ze,
    segmented: E,
    statistic: O,
    spin: $,
    calendar: P,
    carousel: R,
    cascader: L,
    collapse: B,
    typography: j,
    checkbox: A,
    descriptions: T,
    divider: k,
    drawer: F,
    skeleton: W,
    steps: V,
    image: G,
    input: me,
    textArea: Se,
    layout: X,
    list: D,
    mentions: te,
    modal: ee,
    progress: U,
    result: he,
    slider: re,
    breadcrumb: de,
    menu: we,
    pagination: ue,
    empty: _e,
    badge: Ge,
    radio: Fe,
    rate: Ae,
    switch: Me,
    transfer: et,
    avatar: De,
    message: je,
    tag: ie,
    table: fe,
    card: be,
    tabs: Te,
    timeline: Le,
    timePicker: ct,
    upload: Z,
    notification: se,
    tree: Ce,
    colorPicker: Pe,
    datePicker: Ee,
    rangePicker: We,
    flex: ze,
    wave: Ye,
    dropdown: xt,
    warning: Lt,
    tour: mt
  }, cn = Object.assign({}, x);
  Object.keys(ut).forEach((Xe) => {
    ut[Xe] !== void 0 && (cn[Xe] = ut[Xe]);
  }), Upe.forEach((Xe) => {
    const it = e[Xe];
    it && (cn[Xe] = it);
  });
  const un = pH(() => cn, cn, (Xe, it) => {
    const _t = Object.keys(Xe), Yt = Object.keys(it);
    return _t.length !== Yt.length || _t.some((gn) => Xe[gn] !== it[gn]);
  }), bn = m.useMemo(() => ({
    prefixCls: Et,
    csp: Je
  }), [Et, Je]);
  let tt = /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Bpe, {
    dropdownMatchSelectWidth: p
  }), t);
  const Qe = m.useMemo(() => {
    var Xe, it, _t, Yt;
    return mfe(((Xe = Ff.Form) === null || Xe === void 0 ? void 0 : Xe.defaultValidateMessages) || {}, ((_t = (it = un.locale) === null || it === void 0 ? void 0 : it.Form) === null || _t === void 0 ? void 0 : _t.defaultValidateMessages) || {}, ((Yt = un.form) === null || Yt === void 0 ? void 0 : Yt.validateMessages) || {}, (a == null ? void 0 : a.validateMessages) || {});
  }, [un, a == null ? void 0 : a.validateMessages]);
  Object.keys(Qe).length > 0 && (tt = /* @__PURE__ */ m.createElement(Cfe.Provider, {
    value: Qe
  }, tt)), s && (tt = /* @__PURE__ */ m.createElement(Nfe, {
    locale: s,
    _ANT_MARK__: Rfe
  }, tt)), (Et || Je) && (tt = /* @__PURE__ */ m.createElement(CR.Provider, {
    value: bn
  }, tt)), l && (tt = /* @__PURE__ */ m.createElement(xde, {
    size: l
  }, tt)), tt = /* @__PURE__ */ m.createElement(Fpe, null, tt);
  const rn = m.useMemo(() => {
    const Xe = Ze || {}, {
      algorithm: it,
      token: _t,
      components: Yt,
      cssVar: gn
    } = Xe, Zt = zpe(Xe, ["algorithm", "token", "components", "cssVar"]), dr = it && (!Array.isArray(it) || it.length > 0) ? gP(it) : OH, pr = {};
    Object.entries(Yt || {}).forEach((Mn) => {
      let [Hr, Nn] = Mn;
      const bt = Object.assign({}, Nn);
      "algorithm" in bt && (bt.algorithm === !0 ? bt.theme = dr : (Array.isArray(bt.algorithm) || typeof bt.algorithm == "function") && (bt.theme = gP(bt.algorithm)), delete bt.algorithm), pr[Hr] = bt;
    });
    const Gn = Object.assign(Object.assign({}, Rg), _t);
    return Object.assign(Object.assign({}, Zt), {
      theme: dr,
      token: Gn,
      components: pr,
      override: Object.assign({
        override: Gn
      }, pr),
      cssVar: gn
    });
  }, [Ze]);
  return w && (tt = /* @__PURE__ */ m.createElement(PH.Provider, {
    value: rn
  }, tt)), un.warning && (tt = /* @__PURE__ */ m.createElement(xfe.Provider, {
    value: un.warning
  }, tt)), S !== void 0 && (tt = /* @__PURE__ */ m.createElement(AH, {
    disabled: S
  }, tt)), /* @__PURE__ */ m.createElement(Mt.Provider, {
    value: un
  }, tt);
}, vh = (e) => {
  const t = m.useContext(Mt), n = m.useContext($R);
  return /* @__PURE__ */ m.createElement(qpe, Object.assign({
    parentContext: t,
    legacyLocale: n
  }, e));
};
vh.ConfigContext = Mt;
vh.SizeContext = Qw;
vh.config = Gpe;
vh.useConfig = Cde;
Object.defineProperty(vh, "SizeContext", {
  get: () => Qw
});
const dS = vh;
function ri() {
  return ri = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ri.apply(this, arguments);
}
var Ype = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const Xpe = Ype;
function Qpe(e) {
  if (Array.isArray(e))
    return e;
}
function Jpe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function T4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Zpe(e, t) {
  if (e) {
    if (typeof e == "string")
      return T4(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return T4(e, t);
  }
}
function ehe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v9(e, t) {
  return Qpe(e) || Jpe(e, t) || Zpe(e, t) || ehe();
}
function Bf(e) {
  "@babel/helpers - typeof";
  return Bf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bf(e);
}
function the(e, t) {
  if (Bf(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Bf(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function nhe(e) {
  var t = the(e, "string");
  return Bf(t) === "symbol" ? t : String(t);
}
function GP(e, t, n) {
  return t = nhe(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function rhe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function y9(e, t) {
  if (e == null)
    return {};
  var n = rhe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var b9 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var l in o)
              t.call(o, l) && o[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(b9);
var ihe = b9.exports;
const ohe = /* @__PURE__ */ Oi(ihe);
function Ja(e, t) {
  ahe(e) && (e = "100%");
  var n = she(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function ahe(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function she(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function lhe(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function h0(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function T$(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function che(e, t, n) {
  return {
    r: Ja(e, 255) * 255,
    g: Ja(t, 255) * 255,
    b: Ja(n, 255) * 255
  };
}
function I$(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function uhe(e, t, n) {
  var r, i, o;
  if (e = Ja(e, 360), t = Ja(t, 100), n = Ja(n, 100), t === 0)
    i = n, o = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - a;
    r = I$(s, a, e + 1 / 3), i = I$(s, a, e), o = I$(s, a, e - 1 / 3);
  }
  return { r: r * 255, g: i * 255, b: o * 255 };
}
function fhe(e, t, n) {
  e = Ja(e, 255), t = Ja(t, 255), n = Ja(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = r, s = r - i, l = r === 0 ? 0 : s / r;
  if (r === i)
    o = 0;
  else {
    switch (r) {
      case e:
        o = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / s + 2;
        break;
      case n:
        o = (e - t) / s + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: l, v: a };
}
function dhe(e, t, n) {
  e = Ja(e, 360) * 6, t = Ja(t, 100), n = Ja(n, 100);
  var r = Math.floor(e), i = e - r, o = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), l = r % 6, c = [n, a, o, o, s, n][l], f = [s, n, n, a, o, o][l], d = [o, o, s, n, n, a][l];
  return { r: c * 255, g: f * 255, b: d * 255 };
}
function phe(e, t, n, r) {
  var i = [
    T$(Math.round(e).toString(16)),
    T$(Math.round(t).toString(16)),
    T$(Math.round(n).toString(16))
  ];
  return r && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function I4(e) {
  return da(e) / 255;
}
function da(e) {
  return parseInt(e, 16);
}
var A4 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function ym(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof e == "string" && (e = ghe(e)), typeof e == "object" && (Xl(e.r) && Xl(e.g) && Xl(e.b) ? (t = che(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Xl(e.h) && Xl(e.s) && Xl(e.v) ? (r = h0(e.s), i = h0(e.v), t = dhe(e.h, r, i), a = !0, s = "hsv") : Xl(e.h) && Xl(e.s) && Xl(e.l) && (r = h0(e.s), o = h0(e.l), t = uhe(e.h, r, o), a = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = lhe(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var hhe = "[-\\+]?\\d+%?", mhe = "[-\\+]?\\d*\\.\\d+%?", iu = "(?:".concat(mhe, ")|(?:").concat(hhe, ")"), A$ = "[\\s|\\(]+(".concat(iu, ")[,|\\s]+(").concat(iu, ")[,|\\s]+(").concat(iu, ")\\s*\\)?"), R$ = "[\\s|\\(]+(".concat(iu, ")[,|\\s]+(").concat(iu, ")[,|\\s]+(").concat(iu, ")[,|\\s]+(").concat(iu, ")\\s*\\)?"), Os = {
  CSS_UNIT: new RegExp(iu),
  rgb: new RegExp("rgb" + A$),
  rgba: new RegExp("rgba" + R$),
  hsl: new RegExp("hsl" + A$),
  hsla: new RegExp("hsla" + R$),
  hsv: new RegExp("hsv" + A$),
  hsva: new RegExp("hsva" + R$),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function ghe(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (A4[e])
    e = A4[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = Os.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = Os.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = Os.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = Os.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = Os.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = Os.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = Os.hex8.exec(e), n ? {
    r: da(n[1]),
    g: da(n[2]),
    b: da(n[3]),
    a: I4(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Os.hex6.exec(e), n ? {
    r: da(n[1]),
    g: da(n[2]),
    b: da(n[3]),
    format: t ? "name" : "hex"
  } : (n = Os.hex4.exec(e), n ? {
    r: da(n[1] + n[1]),
    g: da(n[2] + n[2]),
    b: da(n[3] + n[3]),
    a: I4(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Os.hex3.exec(e), n ? {
    r: da(n[1] + n[1]),
    g: da(n[2] + n[2]),
    b: da(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Xl(e) {
  return !!Os.CSS_UNIT.exec(String(e));
}
var m0 = 2, R4 = 0.16, vhe = 0.05, yhe = 0.05, bhe = 0.15, w9 = 5, S9 = 4, whe = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function M4(e) {
  var t = e.r, n = e.g, r = e.b, i = fhe(t, n, r);
  return {
    h: i.h * 360,
    s: i.s,
    v: i.v
  };
}
function g0(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(phe(t, n, r, !1));
}
function She(e, t, n) {
  var r = n / 100, i = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return i;
}
function N4(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - m0 * t : Math.round(e.h) + m0 * t : r = n ? Math.round(e.h) + m0 * t : Math.round(e.h) - m0 * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function k4(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - R4 * t : t === S9 ? r = e.s + R4 : r = e.s + vhe * t, r > 1 && (r = 1), n && t === w9 && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function L4(e, t, n) {
  var r;
  return n ? r = e.v + yhe * t : r = e.v - bhe * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function KP(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = ym(e), i = w9; i > 0; i -= 1) {
    var o = M4(r), a = g0(ym({
      h: N4(o, i, !0),
      s: k4(o, i, !0),
      v: L4(o, i, !0)
    }));
    n.push(a);
  }
  n.push(g0(r));
  for (var s = 1; s <= S9; s += 1) {
    var l = M4(r), c = g0(ym({
      h: N4(l, s),
      s: k4(l, s),
      v: L4(l, s)
    }));
    n.push(c);
  }
  return t.theme === "dark" ? whe.map(function(f) {
    var d = f.index, p = f.opacity, g = g0(She(ym(t.backgroundColor || "#141414"), ym(n[d]), p * 100));
    return g;
  }) : n;
}
var M$ = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, hb = {}, N$ = {};
Object.keys(M$).forEach(function(e) {
  hb[e] = KP(M$[e]), hb[e].primary = hb[e][5], N$[e] = KP(M$[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), N$[e].primary = N$[e][5];
});
var xhe = hb.blue;
function D4(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ou(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D4(Object(n), !0).forEach(function(r) {
      GP(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D4(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Che() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Ehe(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var j4 = "data-rc-order", $he = "rc-util-key", qP = /* @__PURE__ */ new Map();
function x9() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : $he;
}
function zR(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function _he(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function C9(e) {
  return Array.from((qP.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function E9(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Che())
    return null;
  var n = t.csp, r = t.prepend, i = document.createElement("style");
  i.setAttribute(j4, _he(r)), n != null && n.nonce && (i.nonce = n == null ? void 0 : n.nonce), i.innerHTML = e;
  var o = zR(t), a = o.firstChild;
  if (r) {
    if (r === "queue") {
      var s = C9(o).filter(function(l) {
        return ["prepend", "prependQueue"].includes(l.getAttribute(j4));
      });
      if (s.length)
        return o.insertBefore(i, s[s.length - 1].nextSibling), i;
    }
    o.insertBefore(i, a);
  } else
    o.appendChild(i);
  return i;
}
function Ohe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = zR(t);
  return C9(n).find(function(r) {
    return r.getAttribute(x9(t)) === e;
  });
}
function Phe(e, t) {
  var n = qP.get(e);
  if (!n || !Ehe(document, n)) {
    var r = E9("", t), i = r.parentNode;
    qP.set(e, i), e.removeChild(r);
  }
}
function The(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = zR(n);
  Phe(r, n);
  var i = Ohe(t, n);
  if (i) {
    var o, a;
    if ((o = n.csp) !== null && o !== void 0 && o.nonce && i.nonce !== ((a = n.csp) === null || a === void 0 ? void 0 : a.nonce)) {
      var s;
      i.nonce = (s = n.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return i.innerHTML !== e && (i.innerHTML = e), i;
  }
  var l = E9(e, n);
  return l.setAttribute(x9(n), t), l;
}
function $9(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function Ihe(e) {
  return $9(e) !== (e == null ? void 0 : e.ownerDocument);
}
function Ahe(e) {
  return Ihe(e) ? $9(e) : null;
}
var YP = {}, Rhe = function(t) {
};
function Mhe(e, t) {
}
function Nhe(e, t) {
}
function khe() {
  YP = {};
}
function _9(e, t, n) {
  !t && !YP[n] && (e(!1, n), YP[n] = !0);
}
function pS(e, t) {
  _9(Mhe, e, t);
}
function Lhe(e, t) {
  _9(Nhe, e, t);
}
pS.preMessage = Rhe;
pS.resetWarned = khe;
pS.noteOnce = Lhe;
function Dhe(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function jhe(e, t) {
  pS(e, "[@ant-design/icons] ".concat(t));
}
function F4(e) {
  return Bf(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Bf(e.icon) === "object" || typeof e.icon == "function");
}
function B4() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[Dhe(n)] = r;
    }
    return t;
  }, {});
}
function XP(e, t, n) {
  return n ? /* @__PURE__ */ oe.createElement(e.tag, ou(ou({
    key: t
  }, B4(e.attrs)), n), (e.children || []).map(function(r, i) {
    return XP(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ oe.createElement(e.tag, ou({
    key: t
  }, B4(e.attrs)), (e.children || []).map(function(r, i) {
    return XP(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  }));
}
function O9(e) {
  return KP(e)[0];
}
function P9(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var Fhe = `
.anticon {
  display: inline-flex;
  alignItems: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Bhe = function(t) {
  var n = m.useContext(CR), r = n.csp, i = n.prefixCls, o = Fhe;
  i && (o = o.replace(/anticon/g, i)), m.useEffect(function() {
    var a = t.current, s = Ahe(a);
    The(o, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: s
    });
  }, []);
}, zhe = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], Zm = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Uhe(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  Zm.primaryColor = t, Zm.secondaryColor = n || O9(t), Zm.calculated = !!n;
}
function Hhe() {
  return ou({}, Zm);
}
var hS = function(t) {
  var n = t.icon, r = t.className, i = t.onClick, o = t.style, a = t.primaryColor, s = t.secondaryColor, l = y9(t, zhe), c = m.useRef(), f = Zm;
  if (a && (f = {
    primaryColor: a,
    secondaryColor: s || O9(a)
  }), Bhe(c), jhe(F4(n), "icon should be icon definiton, but got ".concat(n)), !F4(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = ou(ou({}, d), {}, {
    icon: d.icon(f.primaryColor, f.secondaryColor)
  })), XP(d.icon, "svg-".concat(d.name), ou(ou({
    className: r,
    onClick: i,
    style: o,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: c
  }));
};
hS.displayName = "IconReact";
hS.getTwoToneColors = Hhe;
hS.setTwoToneColors = Uhe;
const UR = hS;
function T9(e) {
  var t = P9(e), n = v9(t, 2), r = n[0], i = n[1];
  return UR.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function Whe() {
  var e = UR.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var Vhe = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
T9(xhe.primary);
var mS = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, i = e.spin, o = e.rotate, a = e.tabIndex, s = e.onClick, l = e.twoToneColor, c = y9(e, Vhe), f = m.useContext(CR), d = f.prefixCls, p = d === void 0 ? "anticon" : d, g = f.rootClassName, v = ohe(g, p, GP(GP({}, "".concat(p, "-").concat(r.name), !!r.name), "".concat(p, "-spin"), !!i || r.name === "loading"), n), y = a;
  y === void 0 && s && (y = -1);
  var x = o ? {
    msTransform: "rotate(".concat(o, "deg)"),
    transform: "rotate(".concat(o, "deg)")
  } : void 0, b = P9(l), w = v9(b, 2), S = w[0], E = w[1];
  return /* @__PURE__ */ m.createElement("span", ri({
    role: "img",
    "aria-label": r.name
  }, c, {
    ref: t,
    tabIndex: y,
    onClick: s,
    className: v
  }), /* @__PURE__ */ m.createElement(UR, {
    icon: r,
    primaryColor: S,
    secondaryColor: E,
    style: x
  }));
});
mS.displayName = "AntdIcon";
mS.getTwoToneColor = Whe;
mS.setTwoToneColor = T9;
const Gi = mS;
var Ghe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: Xpe
  }));
}, Khe = /* @__PURE__ */ m.forwardRef(Ghe);
const qhe = Khe;
var Yhe = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const Xhe = Yhe;
var Qhe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: Xhe
  }));
}, Jhe = /* @__PURE__ */ m.forwardRef(Qhe);
const I9 = Jhe;
var Zhe = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const A9 = Zhe;
var eme = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: A9
  }));
}, tme = /* @__PURE__ */ m.forwardRef(eme);
const lv = tme;
var nme = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const rme = nme;
var ime = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: rme
  }));
}, ome = /* @__PURE__ */ m.forwardRef(ime);
const ame = ome;
var sme = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const lme = sme;
var cme = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: lme
  }));
}, ume = /* @__PURE__ */ m.forwardRef(cme);
const fme = ume;
var dme = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, pme = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, hme = "".concat(dme, " ").concat(pme).split(/[\s\n]+/), mme = "aria-", gme = "data-";
function z4(e, t) {
  return e.indexOf(t) === 0;
}
function R9(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = Hp({}, t);
  var r = {};
  return Object.keys(e).forEach(function(i) {
    // Aria
    (n.aria && (i === "role" || z4(i, mme)) || // Data
    n.data && z4(i, gme) || // Attr
    n.attr && hme.includes(i)) && (r[i] = e[i]);
  }), r;
}
function M9(e) {
  return e && /* @__PURE__ */ oe.isValidElement(e) && e.type === oe.Fragment;
}
const vme = (e, t, n) => /* @__PURE__ */ oe.isValidElement(e) ? /* @__PURE__ */ oe.cloneElement(e, typeof n == "function" ? n(e.props || {}) : n) : t;
function Oa(e, t) {
  return vme(e, e, t);
}
const yme = (e) => {
  const [, , , , t] = ss();
  return t ? `${e}-css-var` : "";
}, xc = yme;
var N9 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var l in o)
              t.call(o, l) && o[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(N9);
var bme = N9.exports;
const ft = /* @__PURE__ */ Oi(bme);
function wme(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function QP(e) {
  return wme(e) ? e : e instanceof oe.Component ? fh.findDOMNode(e) : null;
}
var k9 = { exports: {} }, Un = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ii = typeof Symbol == "function" && Symbol.for, HR = Ii ? Symbol.for("react.element") : 60103, WR = Ii ? Symbol.for("react.portal") : 60106, gS = Ii ? Symbol.for("react.fragment") : 60107, vS = Ii ? Symbol.for("react.strict_mode") : 60108, yS = Ii ? Symbol.for("react.profiler") : 60114, bS = Ii ? Symbol.for("react.provider") : 60109, wS = Ii ? Symbol.for("react.context") : 60110, VR = Ii ? Symbol.for("react.async_mode") : 60111, SS = Ii ? Symbol.for("react.concurrent_mode") : 60111, xS = Ii ? Symbol.for("react.forward_ref") : 60112, CS = Ii ? Symbol.for("react.suspense") : 60113, Sme = Ii ? Symbol.for("react.suspense_list") : 60120, ES = Ii ? Symbol.for("react.memo") : 60115, $S = Ii ? Symbol.for("react.lazy") : 60116, xme = Ii ? Symbol.for("react.block") : 60121, Cme = Ii ? Symbol.for("react.fundamental") : 60117, Eme = Ii ? Symbol.for("react.responder") : 60118, $me = Ii ? Symbol.for("react.scope") : 60119;
function Aa(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case HR:
        switch (e = e.type, e) {
          case VR:
          case SS:
          case gS:
          case yS:
          case vS:
          case CS:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case wS:
              case xS:
              case $S:
              case ES:
              case bS:
                return e;
              default:
                return t;
            }
        }
      case WR:
        return t;
    }
  }
}
function L9(e) {
  return Aa(e) === SS;
}
Un.AsyncMode = VR;
Un.ConcurrentMode = SS;
Un.ContextConsumer = wS;
Un.ContextProvider = bS;
Un.Element = HR;
Un.ForwardRef = xS;
Un.Fragment = gS;
Un.Lazy = $S;
Un.Memo = ES;
Un.Portal = WR;
Un.Profiler = yS;
Un.StrictMode = vS;
Un.Suspense = CS;
Un.isAsyncMode = function(e) {
  return L9(e) || Aa(e) === VR;
};
Un.isConcurrentMode = L9;
Un.isContextConsumer = function(e) {
  return Aa(e) === wS;
};
Un.isContextProvider = function(e) {
  return Aa(e) === bS;
};
Un.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === HR;
};
Un.isForwardRef = function(e) {
  return Aa(e) === xS;
};
Un.isFragment = function(e) {
  return Aa(e) === gS;
};
Un.isLazy = function(e) {
  return Aa(e) === $S;
};
Un.isMemo = function(e) {
  return Aa(e) === ES;
};
Un.isPortal = function(e) {
  return Aa(e) === WR;
};
Un.isProfiler = function(e) {
  return Aa(e) === yS;
};
Un.isStrictMode = function(e) {
  return Aa(e) === vS;
};
Un.isSuspense = function(e) {
  return Aa(e) === CS;
};
Un.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === gS || e === SS || e === yS || e === vS || e === CS || e === Sme || typeof e == "object" && e !== null && (e.$$typeof === $S || e.$$typeof === ES || e.$$typeof === bS || e.$$typeof === wS || e.$$typeof === xS || e.$$typeof === Cme || e.$$typeof === Eme || e.$$typeof === $me || e.$$typeof === xme);
};
Un.typeOf = Aa;
k9.exports = Un;
var yh = k9.exports;
function _me(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function D9(e, t) {
  typeof e == "function" ? e(t) : nn(e) === "object" && e && "current" in e && (e.current = t);
}
function j9() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      D9(o, i);
    });
  };
}
function F9() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return _me(function() {
    return j9.apply(void 0, t);
  }, t, function(r, i) {
    return r.length === i.length && r.every(function(o, a) {
      return o === i[a];
    });
  });
}
function GR(e) {
  var t, n, r = yh.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
function JP(e, t) {
  return JP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, JP(e, t);
}
function cv(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && JP(e, t);
}
function T1(e) {
  return T1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, T1(e);
}
function Ome() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Cn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Pme(e, t) {
  if (t && (nn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Cn(e);
}
function uv(e) {
  var t = Ome();
  return function() {
    var r = T1(e), i;
    if (t) {
      var o = T1(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return Pme(this, i);
  };
}
function xp(e) {
  var t = m.useRef(!1), n = m.useState(e), r = ke(n, 2), i = r[0], o = r[1];
  m.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || o(s);
  }
  return [i, a];
}
function gc() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var B9 = function(t) {
  return +setTimeout(t, 16);
}, z9 = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (B9 = function(t) {
  return window.requestAnimationFrame(t);
}, z9 = function(t) {
  return window.cancelAnimationFrame(t);
});
var U4 = 0, KR = /* @__PURE__ */ new Map();
function U9(e) {
  KR.delete(e);
}
var qp = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  U4 += 1;
  var r = U4;
  function i(o) {
    if (o === 0)
      U9(r), t();
    else {
      var a = B9(function() {
        i(o - 1);
      });
      KR.set(r, a);
    }
  }
  return i(n), r;
};
qp.cancel = function(e) {
  var t = KR.get(e);
  return U9(t), z9(t);
};
var Tt = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Tt.F1 && n <= Tt.F12)
      return !1;
    switch (n) {
      case Tt.ALT:
      case Tt.CAPS_LOCK:
      case Tt.CONTEXT_MENU:
      case Tt.CTRL:
      case Tt.DOWN:
      case Tt.END:
      case Tt.ESC:
      case Tt.HOME:
      case Tt.INSERT:
      case Tt.LEFT:
      case Tt.MAC_FF_META:
      case Tt.META:
      case Tt.NUMLOCK:
      case Tt.NUM_CENTER:
      case Tt.PAGE_DOWN:
      case Tt.PAGE_UP:
      case Tt.PAUSE:
      case Tt.PRINT_SCREEN:
      case Tt.RIGHT:
      case Tt.SHIFT:
      case Tt.UP:
      case Tt.WIN_KEY:
      case Tt.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Tt.ZERO && t <= Tt.NINE || t >= Tt.NUM_ZERO && t <= Tt.NUM_MULTIPLY || t >= Tt.A && t <= Tt.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Tt.SPACE:
      case Tt.QUESTION_MARK:
      case Tt.NUM_PLUS:
      case Tt.NUM_MINUS:
      case Tt.NUM_PERIOD:
      case Tt.NUM_DIVISION:
      case Tt.SEMICOLON:
      case Tt.DASH:
      case Tt.EQUALS:
      case Tt.COMMA:
      case Tt.PERIOD:
      case Tt.SLASH:
      case Tt.APOSTROPHE:
      case Tt.SINGLE_QUOTE:
      case Tt.OPEN_SQUARE_BRACKET:
      case Tt.BACKSLASH:
      case Tt.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, Tme = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const H9 = Tme;
var Ime = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: H9
  }));
}, Ame = /* @__PURE__ */ m.forwardRef(Ime);
const Rme = Ame, Mme = /* @__PURE__ */ oe.createContext(void 0), qR = Mme, tf = 100, Nme = 10, W9 = tf * Nme, V9 = {
  Modal: tf,
  Drawer: tf,
  Popover: tf,
  Popconfirm: tf,
  Tooltip: tf,
  Tour: tf
}, kme = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function Lme(e) {
  return e in V9;
}
function G9(e, t) {
  const [, n] = ss(), r = oe.useContext(qR), i = Lme(e);
  if (t !== void 0)
    return [t, t];
  let o = r ?? 0;
  return i ? (o += // Use preset token zIndex by default but not stack when has parent container
  (r ? 0 : n.zIndexPopupBase) + // Container offset
  V9[e], o = Math.min(o, n.zIndexPopupBase + W9)) : o += kme[e], [r === void 0 ? t : o, o];
}
function Dme() {
  const [e, t] = m.useState([]), n = m.useCallback((r) => (t((i) => [].concat(Qa(i), [r])), () => {
    t((i) => i.filter((o) => o !== r));
  }), []);
  return [e, n];
}
function Ng() {
  Ng = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = Object.defineProperty || function(A, T, k) {
    A[T] = k.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, o = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
  function l(A, T, k) {
    return Object.defineProperty(A, T, {
      value: k,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), A[T];
  }
  try {
    l({}, "");
  } catch {
    l = function(k, F, W) {
      return k[F] = W;
    };
  }
  function c(A, T, k, F) {
    var W = T && T.prototype instanceof p ? T : p, V = Object.create(W.prototype), G = new L(F || []);
    return r(V, "_invoke", {
      value: O(A, k, G)
    }), V;
  }
  function f(A, T, k) {
    try {
      return {
        type: "normal",
        arg: A.call(T, k)
      };
    } catch (F) {
      return {
        type: "throw",
        arg: F
      };
    }
  }
  e.wrap = c;
  var d = {};
  function p() {
  }
  function g() {
  }
  function v() {
  }
  var y = {};
  l(y, o, function() {
    return this;
  });
  var x = Object.getPrototypeOf, b = x && x(x(B([])));
  b && b !== t && n.call(b, o) && (y = b);
  var w = v.prototype = p.prototype = Object.create(y);
  function S(A) {
    ["next", "throw", "return"].forEach(function(T) {
      l(A, T, function(k) {
        return this._invoke(T, k);
      });
    });
  }
  function E(A, T) {
    function k(W, V, G, X) {
      var D = f(A[W], A, V);
      if (D.type !== "throw") {
        var te = D.arg, ee = te.value;
        return ee && is(ee) == "object" && n.call(ee, "__await") ? T.resolve(ee.__await).then(function(U) {
          k("next", U, G, X);
        }, function(U) {
          k("throw", U, G, X);
        }) : T.resolve(ee).then(function(U) {
          te.value = U, G(te);
        }, function(U) {
          return k("throw", U, G, X);
        });
      }
      X(D.arg);
    }
    var F;
    r(this, "_invoke", {
      value: function(V, G) {
        function X() {
          return new T(function(D, te) {
            k(V, G, D, te);
          });
        }
        return F = F ? F.then(X, X) : X();
      }
    });
  }
  function O(A, T, k) {
    var F = "suspendedStart";
    return function(W, V) {
      if (F === "executing")
        throw new Error("Generator is already running");
      if (F === "completed") {
        if (W === "throw")
          throw V;
        return j();
      }
      for (k.method = W, k.arg = V; ; ) {
        var G = k.delegate;
        if (G) {
          var X = $(G, k);
          if (X) {
            if (X === d)
              continue;
            return X;
          }
        }
        if (k.method === "next")
          k.sent = k._sent = k.arg;
        else if (k.method === "throw") {
          if (F === "suspendedStart")
            throw F = "completed", k.arg;
          k.dispatchException(k.arg);
        } else
          k.method === "return" && k.abrupt("return", k.arg);
        F = "executing";
        var D = f(A, T, k);
        if (D.type === "normal") {
          if (F = k.done ? "completed" : "suspendedYield", D.arg === d)
            continue;
          return {
            value: D.arg,
            done: k.done
          };
        }
        D.type === "throw" && (F = "completed", k.method = "throw", k.arg = D.arg);
      }
    };
  }
  function $(A, T) {
    var k = T.method, F = A.iterator[k];
    if (F === void 0)
      return T.delegate = null, k === "throw" && A.iterator.return && (T.method = "return", T.arg = void 0, $(A, T), T.method === "throw") || k !== "return" && (T.method = "throw", T.arg = new TypeError("The iterator does not provide a '" + k + "' method")), d;
    var W = f(F, A.iterator, T.arg);
    if (W.type === "throw")
      return T.method = "throw", T.arg = W.arg, T.delegate = null, d;
    var V = W.arg;
    return V ? V.done ? (T[A.resultName] = V.value, T.next = A.nextLoc, T.method !== "return" && (T.method = "next", T.arg = void 0), T.delegate = null, d) : V : (T.method = "throw", T.arg = new TypeError("iterator result is not an object"), T.delegate = null, d);
  }
  function P(A) {
    var T = {
      tryLoc: A[0]
    };
    1 in A && (T.catchLoc = A[1]), 2 in A && (T.finallyLoc = A[2], T.afterLoc = A[3]), this.tryEntries.push(T);
  }
  function R(A) {
    var T = A.completion || {};
    T.type = "normal", delete T.arg, A.completion = T;
  }
  function L(A) {
    this.tryEntries = [{
      tryLoc: "root"
    }], A.forEach(P, this), this.reset(!0);
  }
  function B(A) {
    if (A) {
      var T = A[o];
      if (T)
        return T.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var k = -1, F = function W() {
          for (; ++k < A.length; )
            if (n.call(A, k))
              return W.value = A[k], W.done = !1, W;
          return W.value = void 0, W.done = !0, W;
        };
        return F.next = F;
      }
    }
    return {
      next: j
    };
  }
  function j() {
    return {
      value: void 0,
      done: !0
    };
  }
  return g.prototype = v, r(w, "constructor", {
    value: v,
    configurable: !0
  }), r(v, "constructor", {
    value: g,
    configurable: !0
  }), g.displayName = l(v, s, "GeneratorFunction"), e.isGeneratorFunction = function(A) {
    var T = typeof A == "function" && A.constructor;
    return !!T && (T === g || (T.displayName || T.name) === "GeneratorFunction");
  }, e.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, v) : (A.__proto__ = v, l(A, s, "GeneratorFunction")), A.prototype = Object.create(w), A;
  }, e.awrap = function(A) {
    return {
      __await: A
    };
  }, S(E.prototype), l(E.prototype, a, function() {
    return this;
  }), e.AsyncIterator = E, e.async = function(A, T, k, F, W) {
    W === void 0 && (W = Promise);
    var V = new E(c(A, T, k, F), W);
    return e.isGeneratorFunction(T) ? V : V.next().then(function(G) {
      return G.done ? G.value : V.next();
    });
  }, S(w), l(w, s, "Generator"), l(w, o, function() {
    return this;
  }), l(w, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(A) {
    var T = Object(A), k = [];
    for (var F in T)
      k.push(F);
    return k.reverse(), function W() {
      for (; k.length; ) {
        var V = k.pop();
        if (V in T)
          return W.value = V, W.done = !1, W;
      }
      return W.done = !0, W;
    };
  }, e.values = B, L.prototype = {
    constructor: L,
    reset: function(T) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(R), !T)
        for (var k in this)
          k.charAt(0) === "t" && n.call(this, k) && !isNaN(+k.slice(1)) && (this[k] = void 0);
    },
    stop: function() {
      this.done = !0;
      var T = this.tryEntries[0].completion;
      if (T.type === "throw")
        throw T.arg;
      return this.rval;
    },
    dispatchException: function(T) {
      if (this.done)
        throw T;
      var k = this;
      function F(te, ee) {
        return G.type = "throw", G.arg = T, k.next = te, ee && (k.method = "next", k.arg = void 0), !!ee;
      }
      for (var W = this.tryEntries.length - 1; W >= 0; --W) {
        var V = this.tryEntries[W], G = V.completion;
        if (V.tryLoc === "root")
          return F("end");
        if (V.tryLoc <= this.prev) {
          var X = n.call(V, "catchLoc"), D = n.call(V, "finallyLoc");
          if (X && D) {
            if (this.prev < V.catchLoc)
              return F(V.catchLoc, !0);
            if (this.prev < V.finallyLoc)
              return F(V.finallyLoc);
          } else if (X) {
            if (this.prev < V.catchLoc)
              return F(V.catchLoc, !0);
          } else {
            if (!D)
              throw new Error("try statement without catch or finally");
            if (this.prev < V.finallyLoc)
              return F(V.finallyLoc);
          }
        }
      }
    },
    abrupt: function(T, k) {
      for (var F = this.tryEntries.length - 1; F >= 0; --F) {
        var W = this.tryEntries[F];
        if (W.tryLoc <= this.prev && n.call(W, "finallyLoc") && this.prev < W.finallyLoc) {
          var V = W;
          break;
        }
      }
      V && (T === "break" || T === "continue") && V.tryLoc <= k && k <= V.finallyLoc && (V = null);
      var G = V ? V.completion : {};
      return G.type = T, G.arg = k, V ? (this.method = "next", this.next = V.finallyLoc, d) : this.complete(G);
    },
    complete: function(T, k) {
      if (T.type === "throw")
        throw T.arg;
      return T.type === "break" || T.type === "continue" ? this.next = T.arg : T.type === "return" ? (this.rval = this.arg = T.arg, this.method = "return", this.next = "end") : T.type === "normal" && k && (this.next = k), d;
    },
    finish: function(T) {
      for (var k = this.tryEntries.length - 1; k >= 0; --k) {
        var F = this.tryEntries[k];
        if (F.finallyLoc === T)
          return this.complete(F.completion, F.afterLoc), R(F), d;
      }
    },
    catch: function(T) {
      for (var k = this.tryEntries.length - 1; k >= 0; --k) {
        var F = this.tryEntries[k];
        if (F.tryLoc === T) {
          var W = F.completion;
          if (W.type === "throw") {
            var V = W.arg;
            R(F);
          }
          return V;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(T, k, F) {
      return this.delegate = {
        iterator: B(T),
        resultName: k,
        nextLoc: F
      }, this.method === "next" && (this.arg = void 0), d;
    }
  }, e;
}
function H4(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a), l = s.value;
  } catch (c) {
    n(c);
    return;
  }
  s.done ? t(l) : Promise.resolve(l).then(r, i);
}
function K9(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(l) {
        H4(o, r, i, a, s, "next", l);
      }
      function s(l) {
        H4(o, r, i, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
var fv = Hp({}, zse), jme = fv.version, Fme = fv.render, Bme = fv.unmountComponentAtNode, _S;
try {
  var zme = Number((jme || "").split(".")[0]);
  zme >= 18 && (_S = fv.createRoot);
} catch {
}
function W4(e) {
  var t = fv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && is(t) === "object" && (t.usingClientEntryPoint = e);
}
var I1 = "__rc_react_root__";
function Ume(e, t) {
  W4(!0);
  var n = t[I1] || _S(t);
  W4(!1), n.render(e), t[I1] = n;
}
function Hme(e, t) {
  Fme(e, t);
}
function q9(e, t) {
  if (_S) {
    Ume(e, t);
    return;
  }
  Hme(e, t);
}
function Wme(e) {
  return ZP.apply(this, arguments);
}
function ZP() {
  return ZP = K9(/* @__PURE__ */ Ng().mark(function e(t) {
    return Ng().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var i;
              (i = t[I1]) === null || i === void 0 || i.unmount(), delete t[I1];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), ZP.apply(this, arguments);
}
function Vme(e) {
  Bme(e);
}
function Y9(e) {
  return eT.apply(this, arguments);
}
function eT() {
  return eT = K9(/* @__PURE__ */ Ng().mark(function e(t) {
    return Ng().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (_S === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", Wme(t));
          case 2:
            Vme(t);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), eT.apply(this, arguments);
}
const k$ = () => ({
  height: 0,
  opacity: 0
}), V4 = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, Gme = (e) => ({
  height: e ? e.offsetHeight : 0
}), L$ = (e, t) => (t == null ? void 0 : t.deadline) === !0 || t.propertyName === "height", Kme = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: k$,
    onEnterStart: k$,
    onAppearActive: V4,
    onEnterActive: V4,
    onLeaveStart: Gme,
    onLeaveActive: k$,
    onAppearEnd: L$,
    onEnterEnd: L$,
    onLeaveEnd: L$,
    motionDeadline: 500
  };
}, zf = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, qme = Kme, Yme = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), o = i.width, a = i.height;
      if (o || a)
        return !0;
    }
  }
  return !1;
}, Xme = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow 0.3s ${e.motionEaseInOut}`, `opacity 0.35s ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, Qme = NR("Wave", (e) => [Xme(e)]);
function Jme(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function D$(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && Jme(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function Zme(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return D$(t) ? t : D$(n) ? n : D$(r) ? r : null;
}
const YR = "ant-wave-target";
function j$(e) {
  return Number.isNaN(e) ? 0 : e;
}
const ege = (e) => {
  const {
    className: t,
    target: n,
    component: r
  } = e, i = m.useRef(null), [o, a] = m.useState(null), [s, l] = m.useState([]), [c, f] = m.useState(0), [d, p] = m.useState(0), [g, v] = m.useState(0), [y, x] = m.useState(0), [b, w] = m.useState(!1), S = {
    left: c,
    top: d,
    width: g,
    height: y,
    borderRadius: s.map(($) => `${$}px`).join(" ")
  };
  o && (S["--wave-color"] = o);
  function E() {
    const $ = getComputedStyle(n);
    a(Zme(n));
    const P = $.position === "static", {
      borderLeftWidth: R,
      borderTopWidth: L
    } = $;
    f(P ? n.offsetLeft : j$(-parseFloat(R))), p(P ? n.offsetTop : j$(-parseFloat(L))), v(n.offsetWidth), x(n.offsetHeight);
    const {
      borderTopLeftRadius: B,
      borderTopRightRadius: j,
      borderBottomLeftRadius: A,
      borderBottomRightRadius: T
    } = $;
    l([B, j, T, A].map((k) => j$(parseFloat(k))));
  }
  if (m.useEffect(() => {
    if (n) {
      const $ = Pg(() => {
        E(), w(!0);
      });
      let P;
      return typeof ResizeObserver < "u" && (P = new ResizeObserver(E), P.observe(n)), () => {
        Pg.cancel($), P == null || P.disconnect();
      };
    }
  }, []), !b)
    return null;
  const O = (r === "Checkbox" || r === "Radio") && (n == null ? void 0 : n.classList.contains(YR));
  return /* @__PURE__ */ m.createElement(fS, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: ($, P) => {
      var R;
      if (P.deadline || P.propertyName === "opacity") {
        const L = (R = i.current) === null || R === void 0 ? void 0 : R.parentElement;
        Y9(L).then(() => {
          L == null || L.remove();
        });
      }
      return !1;
    }
  }, ($) => {
    let {
      className: P
    } = $;
    return /* @__PURE__ */ m.createElement("div", {
      ref: i,
      className: Ue(t, {
        "wave-quick": O
      }, P),
      style: S
    });
  });
}, tge = (e, t) => {
  var n;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((n = e.querySelector("input")) === null || n === void 0) && n.checked))
    return;
  const i = document.createElement("div");
  i.style.position = "absolute", i.style.left = "0px", i.style.top = "0px", e == null || e.insertBefore(i, e == null ? void 0 : e.firstChild), q9(/* @__PURE__ */ m.createElement(ege, Object.assign({}, t, {
    target: e
  })), i);
}, nge = tge;
function rge(e, t, n) {
  const {
    wave: r
  } = m.useContext(Mt), [, i, o] = ss(), a = $1((c) => {
    const f = e.current;
    if (r != null && r.disabled || !f)
      return;
    const d = f.querySelector(`.${YR}`) || f, {
      showEffect: p
    } = r || {};
    (p || nge)(d, {
      className: t,
      token: i,
      component: n,
      event: c,
      hashId: o
    });
  }), s = m.useRef();
  return (c) => {
    Pg.cancel(s.current), s.current = Pg(() => {
      a(c);
    });
  };
}
const ige = (e) => {
  const {
    children: t,
    disabled: n,
    component: r
  } = e, {
    getPrefixCls: i
  } = m.useContext(Mt), o = m.useRef(null), a = i("wave"), [, s] = Qme(a), l = rge(o, Ue(a, s), r);
  if (oe.useEffect(() => {
    const f = o.current;
    if (!f || f.nodeType !== 1 || n)
      return;
    const d = (p) => {
      !Yme(p.target) || // No need wave
      !f.getAttribute || f.getAttribute("disabled") || f.disabled || f.className.includes("disabled") || f.className.includes("-leave") || l(p);
    };
    return f.addEventListener("click", d, !0), () => {
      f.removeEventListener("click", d, !0);
    };
  }, [n]), !/* @__PURE__ */ oe.isValidElement(t))
    return t ?? null;
  const c = Ide(t) ? Sc(t.ref, o) : o;
  return Oa(t, {
    ref: c
  });
}, XR = ige, oge = (e) => {
  const t = oe.useContext(Qw);
  return oe.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, Rl = oge;
function vc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return oe.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(vc(r)) : wp.isFragment(r) && r.props ? n = n.concat(vc(r.props.children, t)) : n.push(r));
  }), n;
}
const age = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, sge = age, lge = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${t}-item > ${n}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, cge = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, X9 = Pi("Space", (e) => {
  const t = _r(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [lge(t), cge(t), sge(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var Q9 = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const OS = /* @__PURE__ */ m.createContext(null), QR = (e, t) => {
  const n = m.useContext(OS), r = m.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: i,
      isFirstItem: o,
      isLastItem: a
    } = n, s = i === "vertical" ? "-vertical-" : "-";
    return Ue(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: o,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
}, A1 = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ m.createElement(OS.Provider, {
    value: null
  }, t);
}, uge = (e) => {
  var {
    children: t
  } = e, n = Q9(e, ["children"]);
  return /* @__PURE__ */ m.createElement(OS.Provider, {
    value: n
  }, t);
}, fge = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = m.useContext(Mt), {
    size: r,
    direction: i,
    block: o,
    prefixCls: a,
    className: s,
    rootClassName: l,
    children: c
  } = e, f = Q9(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), d = Rl((S) => r ?? S), p = t("space-compact", a), [g, v] = X9(p), y = Ue(p, v, {
    [`${p}-rtl`]: n === "rtl",
    [`${p}-block`]: o,
    [`${p}-vertical`]: i === "vertical"
  }, s, l), x = m.useContext(OS), b = vc(c), w = m.useMemo(() => b.map((S, E) => {
    const O = S && S.key || `${p}-item-${E}`;
    return /* @__PURE__ */ m.createElement(uge, {
      key: O,
      compactSize: d,
      compactDirection: i,
      isFirstItem: E === 0 && (!x || (x == null ? void 0 : x.isFirstItem)),
      isLastItem: E === b.length - 1 && (!x || (x == null ? void 0 : x.isLastItem))
    }, S);
  }), [r, b, x]);
  return b.length === 0 ? null : g(/* @__PURE__ */ m.createElement("div", Object.assign({
    className: y
  }, f), w));
};
var dge = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const J9 = /* @__PURE__ */ m.createContext(void 0), pge = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = m.useContext(Mt), {
    prefixCls: r,
    size: i,
    className: o
  } = e, a = dge(e, ["prefixCls", "size", "className"]), s = t("btn-group", r), [, , l] = ss();
  let c = "";
  switch (i) {
    case "large":
      c = "lg";
      break;
    case "small":
      c = "sm";
      break;
  }
  const f = Ue(s, {
    [`${s}-${c}`]: c,
    [`${s}-rtl`]: n === "rtl"
  }, o, l);
  return /* @__PURE__ */ m.createElement(J9.Provider, {
    value: i
  }, /* @__PURE__ */ m.createElement("div", Object.assign({}, a, {
    className: f
  })));
}, hge = pge, G4 = /^[\u4e00-\u9fa5]{2}$/, tT = G4.test.bind(G4);
function Z9(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
function K4(e) {
  return typeof e == "string";
}
function F$(e) {
  return e === "text" || e === "link";
}
function mge(e, t) {
  if (e == null)
    return;
  const n = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && K4(e.type) && tT(e.props.children) ? Oa(e, {
    children: e.props.children.split("").join(n)
  }) : K4(e) ? tT(e) ? /* @__PURE__ */ oe.createElement("span", null, e.split("").join(n)) : /* @__PURE__ */ oe.createElement("span", null, e) : M9(e) ? /* @__PURE__ */ oe.createElement("span", null, e) : e;
}
function gge(e, t) {
  let n = !1;
  const r = [];
  return oe.Children.forEach(e, (i) => {
    const o = typeof i, a = o === "string" || o === "number";
    if (n && a) {
      const s = r.length - 1, l = r[s];
      r[s] = `${l}${i}`;
    } else
      r.push(i);
    n = a;
  }), oe.Children.map(r, (i) => mge(i, t));
}
const vge = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    className: n,
    style: r,
    children: i,
    prefixCls: o
  } = e, a = Ue(`${o}-icon`, n);
  return /* @__PURE__ */ oe.createElement("span", {
    ref: t,
    className: a,
    style: r
  }, i);
}), eW = vge, q4 = /* @__PURE__ */ m.forwardRef((e, t) => {
  let {
    prefixCls: n,
    className: r,
    style: i,
    iconClassName: o
  } = e;
  const a = Ue(`${n}-loading-icon`, r);
  return /* @__PURE__ */ oe.createElement(eW, {
    prefixCls: n,
    className: a,
    style: i,
    ref: t
  }, /* @__PURE__ */ oe.createElement(Rme, {
    className: o
  }));
}), B$ = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), z$ = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), yge = (e) => {
  const {
    prefixCls: t,
    loading: n,
    existIcon: r,
    className: i,
    style: o
  } = e, a = !!n;
  return r ? /* @__PURE__ */ oe.createElement(q4, {
    prefixCls: t,
    className: i,
    style: o
  }) : /* @__PURE__ */ oe.createElement(fS, {
    visible: a,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: a,
    removeOnLeave: !0,
    onAppearStart: B$,
    onAppearActive: z$,
    onEnterStart: B$,
    onEnterActive: z$,
    onLeaveStart: z$,
    onLeaveActive: B$
  }, (s, l) => {
    let {
      className: c,
      style: f
    } = s;
    return /* @__PURE__ */ oe.createElement(q4, {
      prefixCls: t,
      className: i,
      style: Object.assign(Object.assign({}, o), f),
      ref: l,
      iconClassName: c
    });
  });
}, bge = yge, Y4 = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), wge = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    groupBorderColor: i,
    colorErrorHover: o
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover,\n          &:focus,\n          &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      Y4(`${t}-primary`, i),
      Y4(`${t}-danger`, o)
    ]
  };
}, Sge = wge, tW = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: n,
    paddingBlock: r
  } = e;
  return _r(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: r,
    buttonIconOnlyFontSize: n
  });
}, nW = (e) => {
  var t, n, r, i, o, a;
  const s = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, l = (n = e.contentFontSizeSM) !== null && n !== void 0 ? n : e.fontSize, c = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, f = (i = e.contentLineHeight) !== null && i !== void 0 ? i : fb(s), d = (o = e.contentLineHeightSM) !== null && o !== void 0 ? o : fb(l), p = (a = e.contentLineHeightLG) !== null && a !== void 0 ? a : fb(c);
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: e.colorBgTextHover,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    contentFontSize: s,
    contentFontSizeSM: l,
    contentFontSizeLG: c,
    contentLineHeight: f,
    contentLineHeightSM: d,
    contentLineHeightLG: p,
    paddingBlock: Math.max((e.controlHeight - s * f) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - l * d) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - c * p) / 2 - e.lineWidth, 0)
  };
}, xge = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontWeight: r
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-block",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${ge(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 0
      },
      // Leave a space between icon and text.
      [`> ${n} + span, > span + ${n}`]: {
        marginInlineStart: e.marginXS
      },
      [`&:not(${t}-icon-only) > ${t}-icon`]: {
        [`&${t}-loading-icon, &:not(:last-child)`]: {
          marginInlineEnd: e.marginXS
        }
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, Jw(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${n})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // make `btn-icon-only` not too narrow
      [`&-icon-only${t}-compact-item`]: {
        flex: "none"
      }
    }
  };
}, yc = (e, t, n) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": n
  }
}), Cge = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), Ege = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), $ge = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), kg = (e, t, n, r, i, o, a, s) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: n || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, yc(e, Object.assign({
    background: t
  }, a), Object.assign({
    background: t
  }, s))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: i || void 0,
      borderColor: o || void 0
    }
  })
}), JR = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, $ge(e))
}), rW = (e) => Object.assign({}, JR(e)), R1 = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), iW = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, rW(e)), {
  background: e.defaultBg,
  borderColor: e.defaultBorderColor,
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}), yc(e.componentCls, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), kg(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: e.colorError,
    borderColor: e.colorError
  }, yc(e.componentCls, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorBorderHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), kg(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder)), JR(e))
}), _ge = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, rW(e)), {
  color: e.primaryColor,
  background: e.colorPrimary,
  boxShadow: e.primaryShadow
}), yc(e.componentCls, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryHover
}, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryActive
})), kg(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: e.colorError,
    boxShadow: e.dangerShadow,
    color: e.dangerColor
  }, yc(e.componentCls, {
    background: e.colorErrorHover
  }, {
    background: e.colorErrorActive
  })), kg(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), JR(e))
}), Oge = (e) => Object.assign(Object.assign({}, iW(e)), {
  borderStyle: "dashed"
}), Pge = (e) => Object.assign(Object.assign(Object.assign({
  color: e.colorLink
}, yc(e.componentCls, {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), R1(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, yc(e.componentCls, {
    color: e.colorErrorHover
  }, {
    color: e.colorErrorActive
  })), R1(e))
}), Tge = (e) => Object.assign(Object.assign(Object.assign({}, yc(e.componentCls, {
  color: e.colorText,
  background: e.textHoverBg
}, {
  color: e.colorText,
  background: e.colorBgTextActive
})), R1(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, R1(e)), yc(e.componentCls, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }))
}), Ige = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-default`]: iW(e),
    [`${t}-primary`]: _ge(e),
    [`${t}-dashed`]: Oge(e),
    [`${t}-link`]: Pge(e),
    [`${t}-text`]: Tge(e),
    [`${t}-ghost`]: kg(e.componentCls, e.ghostBg, e.colorBgContainer, e.colorBgContainer, e.colorTextDisabled, e.colorBorder)
  };
}, ZR = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    controlHeight: r,
    fontSize: i,
    lineHeight: o,
    borderRadius: a,
    buttonPaddingHorizontal: s,
    iconCls: l,
    buttonPaddingVertical: c
  } = e, f = `${n}-icon-only`;
  return [
    {
      [`${t}`]: {
        fontSize: i,
        lineHeight: o,
        height: r,
        padding: `${ge(c)} ${ge(s)}`,
        borderRadius: a,
        [`&${f}`]: {
          width: r,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
          [`&${n}-round`]: {
            width: "auto"
          },
          [l]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${n}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${n}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: Cge(e)
    },
    {
      [`${n}${n}-round${t}`]: Ege(e)
    }
  ];
}, Age = (e) => {
  const t = _r(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return ZR(t, e.componentCls);
}, Rge = (e) => {
  const t = _r(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return ZR(t, `${e.componentCls}-sm`);
}, Mge = (e) => {
  const t = _r(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return ZR(t, `${e.componentCls}-lg`);
}, Nge = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, kge = Pi("Button", (e) => {
  const t = tW(e);
  return [
    // Shared
    xge(t),
    // Size
    Age(t),
    Rge(t),
    Mge(t),
    // Block
    Nge(t),
    // Group (type, ghost, danger, loading)
    Ige(t),
    // Button Group
    Sge(t)
  ];
}, nW, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function Lge(e, t, n) {
  const {
    focusElCls: r,
    focus: i,
    borderElCls: o
  } = n, a = o ? "> *" : "", s = ["hover", i ? "focus" : null, "active"].filter(Boolean).map((l) => `&:${l} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function Dge(e, t, n) {
  const {
    borderElCls: r
  } = n, i = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${i}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function oW(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, Lge(e, r, t)), Dge(n, r, t))
  };
}
function jge(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function Fge(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function Bge(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, jge(e, t)), Fge(e.componentCls, t))
  };
}
const zge = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: n(e.lineWidth).mul(-1).equal(),
            insetInlineStart: n(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${ge(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: n(e.lineWidth).mul(-1).equal(),
              insetInlineStart: n(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${ge(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, Uge = Zw(["Button", "compact"], (e) => {
  const t = tW(e);
  return [
    // Space Compact
    oW(t),
    Bge(t),
    zge(t)
  ];
}, nW);
var Hge = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Wge(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const Vge = (e, t) => {
  var n, r;
  const {
    loading: i = !1,
    prefixCls: o,
    type: a,
    danger: s,
    shape: l = "default",
    size: c,
    styles: f,
    disabled: d,
    className: p,
    rootClassName: g,
    children: v,
    icon: y,
    ghost: x = !1,
    block: b = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: w = "button",
    classNames: S,
    style: E = {}
  } = e, O = Hge(e, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "ghost", "block", "htmlType", "classNames", "style"]), $ = a || "default", {
    getPrefixCls: P,
    autoInsertSpaceInButton: R,
    direction: L,
    button: B
  } = m.useContext(Mt), j = P("btn", o), [A, T, k] = kge(j), F = m.useContext(sv), W = d ?? F, V = m.useContext(J9), G = m.useMemo(() => Wge(i), [i]), [X, D] = m.useState(G.loading), [te, ee] = m.useState(!1), he = Sc(t, /* @__PURE__ */ m.createRef()), re = m.Children.count(v) === 1 && !y && !F$($);
  m.useEffect(() => {
    let Te = null;
    G.delay > 0 ? Te = setTimeout(() => {
      Te = null, D(!0);
    }, G.delay) : D(G.loading);
    function Le() {
      Te && (clearTimeout(Te), Te = null);
    }
    return Le;
  }, [G]), m.useEffect(() => {
    if (!he || !he.current || R === !1)
      return;
    const Te = he.current.textContent;
    re && tT(Te) ? te || ee(!0) : te && ee(!1);
  }, [he]);
  const de = (Te) => {
    const {
      onClick: Le
    } = e;
    if (X || W) {
      Te.preventDefault();
      return;
    }
    Le == null || Le(Te);
  }, we = R !== !1, {
    compactSize: ue,
    compactItemClassnames: me
  } = QR(j, L), Se = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, _e = Rl((Te) => {
    var Le, ct;
    return (ct = (Le = c ?? ue) !== null && Le !== void 0 ? Le : V) !== null && ct !== void 0 ? ct : Te;
  }), Ge = _e && Se[_e] || "", Fe = X ? "loading" : y, Ae = os(O, ["navigate"]), Me = Ue(j, T, k, {
    [`${j}-${l}`]: l !== "default" && l,
    [`${j}-${$}`]: $,
    [`${j}-${Ge}`]: Ge,
    [`${j}-icon-only`]: !v && v !== 0 && !!Fe,
    [`${j}-background-ghost`]: x && !F$($),
    [`${j}-loading`]: X,
    [`${j}-two-chinese-chars`]: te && we && !X,
    [`${j}-block`]: b,
    [`${j}-dangerous`]: !!s,
    [`${j}-rtl`]: L === "rtl"
  }, me, p, g, B == null ? void 0 : B.className), et = Object.assign(Object.assign({}, B == null ? void 0 : B.style), E), De = Ue(S == null ? void 0 : S.icon, (n = B == null ? void 0 : B.classNames) === null || n === void 0 ? void 0 : n.icon), je = Object.assign(Object.assign({}, (f == null ? void 0 : f.icon) || {}), ((r = B == null ? void 0 : B.styles) === null || r === void 0 ? void 0 : r.icon) || {}), ie = y && !X ? /* @__PURE__ */ oe.createElement(eW, {
    prefixCls: j,
    className: De,
    style: je
  }, y) : /* @__PURE__ */ oe.createElement(bge, {
    existIcon: !!y,
    prefixCls: j,
    loading: !!X
  }), fe = v || v === 0 ? gge(v, re && we) : null;
  if (Ae.href !== void 0)
    return A(/* @__PURE__ */ oe.createElement("a", Object.assign({}, Ae, {
      className: Ue(Me, {
        [`${j}-disabled`]: W
      }),
      href: W ? void 0 : Ae.href,
      style: et,
      onClick: de,
      ref: he,
      tabIndex: W ? -1 : 0
    }), ie, fe));
  let be = /* @__PURE__ */ oe.createElement("button", Object.assign({}, O, {
    type: w,
    className: Me,
    style: et,
    onClick: de,
    disabled: W,
    ref: he
  }), ie, fe, !!me && /* @__PURE__ */ oe.createElement(Uge, {
    key: "compact",
    prefixCls: j
  }));
  return F$($) || (be = /* @__PURE__ */ oe.createElement(XR, {
    component: "Button",
    disabled: !!X
  }, be)), A(be);
}, e2 = /* @__PURE__ */ m.forwardRef(Vge);
e2.Group = hge;
e2.__ANT_BUTTON = !0;
const zi = e2;
function X4(e) {
  return !!(e && e.then);
}
const Gge = (e) => {
  const {
    type: t,
    children: n,
    prefixCls: r,
    buttonProps: i,
    close: o,
    autoFocus: a,
    emitEvent: s,
    isSilent: l,
    quitOnNullishReturnValue: c,
    actionFn: f
  } = e, d = m.useRef(!1), p = m.useRef(null), [g, v] = NP(!1), y = function() {
    o == null || o.apply(void 0, arguments);
  };
  m.useEffect(() => {
    let w = null;
    return a && (w = setTimeout(() => {
      var S;
      (S = p.current) === null || S === void 0 || S.focus();
    })), () => {
      w && clearTimeout(w);
    };
  }, []);
  const x = (w) => {
    X4(w) && (v(!0), w.then(function() {
      v(!1, !0), y.apply(void 0, arguments), d.current = !1;
    }, (S) => {
      if (v(!1, !0), d.current = !1, !(l != null && l()))
        return Promise.reject(S);
    }));
  }, b = (w) => {
    if (d.current)
      return;
    if (d.current = !0, !f) {
      y();
      return;
    }
    let S;
    if (s) {
      if (S = f(w), c && !X4(S)) {
        d.current = !1, y(w);
        return;
      }
    } else if (f.length)
      S = f(o), d.current = !1;
    else if (S = f(), !S) {
      y();
      return;
    }
    x(S);
  };
  return /* @__PURE__ */ m.createElement(zi, Object.assign({}, Z9(t), {
    onClick: b,
    loading: g,
    prefixCls: r
  }, i, {
    ref: p
  }), n);
}, aW = Gge, dv = /* @__PURE__ */ oe.createContext({}), {
  Provider: sW
} = dv, Kge = () => {
  const {
    autoFocusButton: e,
    cancelButtonProps: t,
    cancelTextLocale: n,
    isSilent: r,
    mergedOkCancel: i,
    rootPrefixCls: o,
    close: a,
    onCancel: s,
    onConfirm: l
  } = m.useContext(dv);
  return i ? /* @__PURE__ */ oe.createElement(aW, {
    isSilent: r,
    actionFn: s,
    close: function() {
      a == null || a.apply(void 0, arguments), l == null || l(!1);
    },
    autoFocus: e === "cancel",
    buttonProps: t,
    prefixCls: `${o}-btn`
  }, n) : null;
}, Q4 = Kge, qge = () => {
  const {
    autoFocusButton: e,
    close: t,
    isSilent: n,
    okButtonProps: r,
    rootPrefixCls: i,
    okTextLocale: o,
    okType: a,
    onConfirm: s,
    onOk: l
  } = m.useContext(dv);
  return /* @__PURE__ */ oe.createElement(aW, {
    isSilent: n,
    type: a || "primary",
    actionFn: l,
    close: function() {
      t == null || t.apply(void 0, arguments), s == null || s(!0);
    },
    autoFocus: e === "ok",
    buttonProps: r,
    prefixCls: `${i}-btn`
  }, o);
}, J4 = qge;
var lW = /* @__PURE__ */ m.createContext(null), Pu = gc() ? m.useLayoutEffect : m.useEffect, Z4 = function(t, n) {
  var r = m.useRef(!0);
  Pu(function() {
    if (!r.current)
      return t();
  }, n), Pu(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, eD = [];
function Yge(e, t) {
  var n = m.useState(function() {
    if (!gc())
      return null;
    var v = document.createElement("div");
    return v;
  }), r = ke(n, 1), i = r[0], o = m.useRef(!1), a = m.useContext(lW), s = m.useState(eD), l = ke(s, 2), c = l[0], f = l[1], d = a || (o.current ? void 0 : function(v) {
    f(function(y) {
      var x = [v].concat(Rt(y));
      return x;
    });
  });
  function p() {
    i.parentElement || document.body.appendChild(i), o.current = !0;
  }
  function g() {
    var v;
    (v = i.parentElement) === null || v === void 0 || v.removeChild(i), o.current = !1;
  }
  return Pu(function() {
    return e ? a ? a(p) : p() : g(), g;
  }, [e]), Pu(function() {
    c.length && (c.forEach(function(v) {
      return v();
    }), f(eD));
  }, [c]), [i, d];
}
function nT(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var tD = "data-rc-order", Xge = "rc-util-key", rT = /* @__PURE__ */ new Map();
function cW() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : Xge;
}
function PS(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function Qge(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function uW(e) {
  return Array.from((rT.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function fW(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!gc())
    return null;
  var n = t.csp, r = t.prepend, i = document.createElement("style");
  i.setAttribute(tD, Qge(r)), n != null && n.nonce && (i.nonce = n == null ? void 0 : n.nonce), i.innerHTML = e;
  var o = PS(t), a = o.firstChild;
  if (r) {
    if (r === "queue") {
      var s = uW(o).filter(function(l) {
        return ["prepend", "prependQueue"].includes(l.getAttribute(tD));
      });
      if (s.length)
        return o.insertBefore(i, s[s.length - 1].nextSibling), i;
    }
    o.insertBefore(i, a);
  } else
    o.appendChild(i);
  return i;
}
function dW(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = PS(t);
  return uW(n).find(function(r) {
    return r.getAttribute(cW(t)) === e;
  });
}
function nD(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = dW(e, t);
  if (n) {
    var r = PS(t);
    r.removeChild(n);
  }
}
function Jge(e, t) {
  var n = rT.get(e);
  if (!n || !nT(document, n)) {
    var r = fW("", t), i = r.parentNode;
    rT.set(e, i), e.removeChild(r);
  }
}
function Zge(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = PS(n);
  Jge(r, n);
  var i = dW(t, n);
  if (i) {
    var o, a;
    if ((o = n.csp) !== null && o !== void 0 && o.nonce && i.nonce !== ((a = n.csp) === null || a === void 0 ? void 0 : a.nonce)) {
      var s;
      i.nonce = (s = n.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return i.innerHTML !== e && (i.innerHTML = e), i;
  }
  var l = fW(e, n);
  return l.setAttribute(cW(n), t), l;
}
var U$;
function eve(e) {
  if (typeof document > "u")
    return 0;
  if (e || U$ === void 0) {
    var t = document.createElement("div");
    t.style.width = "100%", t.style.height = "200px";
    var n = document.createElement("div"), r = n.style;
    r.position = "absolute", r.top = "0", r.left = "0", r.pointerEvents = "none", r.visibility = "hidden", r.width = "200px", r.height = "150px", r.overflow = "hidden", n.appendChild(t), document.body.appendChild(n);
    var i = t.offsetWidth;
    n.style.overflow = "scroll";
    var o = t.offsetWidth;
    i === o && (o = n.clientWidth), document.body.removeChild(n), U$ = i - o;
  }
  return U$;
}
function tve() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var nve = "rc-util-locker-".concat(Date.now()), rD = 0;
function rve(e) {
  var t = !!e, n = m.useState(function() {
    return rD += 1, "".concat(nve, "_").concat(rD);
  }), r = ke(n, 1), i = r[0];
  Pu(function() {
    if (t) {
      var o = eve(), a = tve();
      Zge(`
html body {
  overflow-y: hidden;
  `.concat(a ? "width: calc(100% - ".concat(o, "px);") : "", `
}`), i);
    } else
      nD(i);
    return function() {
      nD(i);
    };
  }, [t, i]);
}
var iD = !1;
function ive(e) {
  return typeof e == "boolean" && (iD = e), iD;
}
var oD = function(t) {
  return t === !1 ? !1 : !gc() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, pv = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, i = e.getContainer;
  e.debug;
  var o = e.autoDestroy, a = o === void 0 ? !0 : o, s = e.children, l = m.useState(n), c = ke(l, 2), f = c[0], d = c[1], p = f || n;
  m.useEffect(function() {
    (a || n) && d(n);
  }, [n, a]);
  var g = m.useState(function() {
    return oD(i);
  }), v = ke(g, 2), y = v[0], x = v[1];
  m.useEffect(function() {
    var j = oD(i);
    x(j ?? null);
  });
  var b = Yge(p && !y), w = ke(b, 2), S = w[0], E = w[1], O = y ?? S;
  rve(r && n && gc() && (O === S || O === document.body));
  var $ = null;
  if (s && GR(s) && t) {
    var P = s;
    $ = P.ref;
  }
  var R = F9($, t);
  if (!p || !gc() || y === void 0)
    return null;
  var L = O === !1 || ive(), B = s;
  return t && (B = /* @__PURE__ */ m.cloneElement(s, {
    ref: R
  })), /* @__PURE__ */ m.createElement(lW.Provider, {
    value: E
  }, L ? B : /* @__PURE__ */ js.createPortal(B, O));
}), pW = /* @__PURE__ */ m.createContext({});
function ove() {
  var e = ye({}, sh);
  return e.useId;
}
var aD = 0;
function ave(e) {
  var t = m.useState("ssr-id"), n = ke(t, 2), r = n[0], i = n[1], o = ove(), a = o == null ? void 0 : o();
  return m.useEffect(function() {
    if (!o) {
      var s = aD;
      aD += 1, i("rc_unique_".concat(s));
    }
  }, []), e || a || r;
}
var sve = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, lve = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, cve = "".concat(sve, " ").concat(lve).split(/[\s\n]+/), uve = "aria-", fve = "data-";
function sD(e, t) {
  return e.indexOf(t) === 0;
}
function hW(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = ye({}, t);
  var r = {};
  return Object.keys(e).forEach(function(i) {
    // Aria
    (n.aria && (i === "role" || sD(i, uve)) || // Data
    n.data && sD(i, fve) || // Attr
    n.attr && cve.includes(i)) && (r[i] = e[i]);
  }), r;
}
function lD(e, t, n) {
  var r = t;
  return !r && n && (r = "".concat(e, "-").concat(n)), r;
}
function cD(e, t) {
  var n = e["page".concat(t ? "Y" : "X", "Offset")], r = "scroll".concat(t ? "Top" : "Left");
  if (typeof n != "number") {
    var i = e.document;
    n = i.documentElement[r], typeof n != "number" && (n = i.body[r]);
  }
  return n;
}
function dve(e) {
  var t = e.getBoundingClientRect(), n = {
    left: t.left,
    top: t.top
  }, r = e.ownerDocument, i = r.defaultView || r.parentWindow;
  return n.left += cD(i), n.top += cD(i, !0), n;
}
var pve = /* @__PURE__ */ m.createContext({}), hve = /* @__PURE__ */ function(e) {
  cv(n, e);
  var t = uv(n);
  function n() {
    return Js(this, n), t.apply(this, arguments);
  }
  return Zs(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(m.Component), nf = "none", v0 = "appear", y0 = "enter", b0 = "leave", uD = "none", Ns = "prepare", rp = "start", ip = "active", t2 = "end", mW = "prepared";
function fD(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function mve(e, t) {
  var n = {
    animationend: fD("Animation", "AnimationEnd"),
    transitionend: fD("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var gve = mve(gc(), typeof window < "u" ? window : {}), gW = {};
if (gc()) {
  var vve = document.createElement("div");
  gW = vve.style;
}
var w0 = {};
function vW(e) {
  if (w0[e])
    return w0[e];
  var t = gve[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(t, o) && o in gW)
        return w0[e] = t[o], w0[e];
    }
  return "";
}
var yW = vW("animationend"), bW = vW("transitionend"), wW = !!(yW && bW), dD = yW || "animationend", pD = bW || "transitionend";
function hD(e, t) {
  if (!e)
    return null;
  if (nn(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const yve = function(e) {
  var t = m.useRef(), n = m.useRef(e);
  n.current = e;
  var r = m.useCallback(function(a) {
    n.current(a);
  }, []);
  function i(a) {
    a && (a.removeEventListener(pD, r), a.removeEventListener(dD, r));
  }
  function o(a) {
    t.current && t.current !== a && i(t.current), a && a !== t.current && (a.addEventListener(pD, r), a.addEventListener(dD, r), t.current = a);
  }
  return m.useEffect(function() {
    return function() {
      i(t.current);
    };
  }, []), [o, i];
};
var SW = gc() ? m.useLayoutEffect : m.useEffect;
const bve = function() {
  var e = m.useRef(null);
  function t() {
    qp.cancel(e.current);
  }
  function n(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var o = qp(function() {
      i <= 1 ? r({
        isCanceled: function() {
          return o !== e.current;
        }
      }) : n(r, i - 1);
    });
    e.current = o;
  }
  return m.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var wve = [Ns, rp, ip, t2], Sve = [Ns, mW], xW = !1, xve = !0;
function CW(e) {
  return e === ip || e === t2;
}
const Cve = function(e, t, n) {
  var r = xp(uD), i = ke(r, 2), o = i[0], a = i[1], s = bve(), l = ke(s, 2), c = l[0], f = l[1];
  function d() {
    a(Ns, !0);
  }
  var p = t ? Sve : wve;
  return SW(function() {
    if (o !== uD && o !== t2) {
      var g = p.indexOf(o), v = p[g + 1], y = n(o);
      y === xW ? a(v, !0) : v && c(function(x) {
        function b() {
          x.isCanceled() || a(v, !0);
        }
        y === !0 ? b() : Promise.resolve(y).then(b);
      });
    }
  }, [e, o]), m.useEffect(function() {
    return function() {
      f();
    };
  }, []), [d, o];
};
function Eve(e, t, n, r) {
  var i = r.motionEnter, o = i === void 0 ? !0 : i, a = r.motionAppear, s = a === void 0 ? !0 : a, l = r.motionLeave, c = l === void 0 ? !0 : l, f = r.motionDeadline, d = r.motionLeaveImmediately, p = r.onAppearPrepare, g = r.onEnterPrepare, v = r.onLeavePrepare, y = r.onAppearStart, x = r.onEnterStart, b = r.onLeaveStart, w = r.onAppearActive, S = r.onEnterActive, E = r.onLeaveActive, O = r.onAppearEnd, $ = r.onEnterEnd, P = r.onLeaveEnd, R = r.onVisibleChanged, L = xp(), B = ke(L, 2), j = B[0], A = B[1], T = xp(nf), k = ke(T, 2), F = k[0], W = k[1], V = xp(null), G = ke(V, 2), X = G[0], D = G[1], te = m.useRef(!1), ee = m.useRef(null);
  function U() {
    return n();
  }
  var he = m.useRef(!1);
  function re() {
    W(nf, !0), D(null, !0);
  }
  function de(ie) {
    var fe = U();
    if (!(ie && !ie.deadline && ie.target !== fe)) {
      var be = he.current, Te;
      F === v0 && be ? Te = O == null ? void 0 : O(fe, ie) : F === y0 && be ? Te = $ == null ? void 0 : $(fe, ie) : F === b0 && be && (Te = P == null ? void 0 : P(fe, ie)), F !== nf && be && Te !== !1 && re();
    }
  }
  var we = yve(de), ue = ke(we, 1), me = ue[0], Se = function(fe) {
    var be, Te, Le;
    switch (fe) {
      case v0:
        return be = {}, ce(be, Ns, p), ce(be, rp, y), ce(be, ip, w), be;
      case y0:
        return Te = {}, ce(Te, Ns, g), ce(Te, rp, x), ce(Te, ip, S), Te;
      case b0:
        return Le = {}, ce(Le, Ns, v), ce(Le, rp, b), ce(Le, ip, E), Le;
      default:
        return {};
    }
  }, _e = m.useMemo(function() {
    return Se(F);
  }, [F]), Ge = Cve(F, !e, function(ie) {
    if (ie === Ns) {
      var fe = _e[Ns];
      return fe ? fe(U()) : xW;
    }
    if (Me in _e) {
      var be;
      D(((be = _e[Me]) === null || be === void 0 ? void 0 : be.call(_e, U(), null)) || null);
    }
    return Me === ip && (me(U()), f > 0 && (clearTimeout(ee.current), ee.current = setTimeout(function() {
      de({
        deadline: !0
      });
    }, f))), Me === mW && re(), xve;
  }), Fe = ke(Ge, 2), Ae = Fe[0], Me = Fe[1], et = CW(Me);
  he.current = et, SW(function() {
    A(t);
    var ie = te.current;
    te.current = !0;
    var fe;
    !ie && t && s && (fe = v0), ie && t && o && (fe = y0), (ie && !t && c || !ie && d && !t && c) && (fe = b0);
    var be = Se(fe);
    fe && (e || be[Ns]) ? (W(fe), Ae()) : W(nf);
  }, [t]), m.useEffect(function() {
    // Cancel appear
    (F === v0 && !s || // Cancel enter
    F === y0 && !o || // Cancel leave
    F === b0 && !c) && W(nf);
  }, [s, o, c]), m.useEffect(function() {
    return function() {
      te.current = !1, clearTimeout(ee.current);
    };
  }, []);
  var De = m.useRef(!1);
  m.useEffect(function() {
    j && (De.current = !0), j !== void 0 && F === nf && ((De.current || j) && (R == null || R(j)), De.current = !0);
  }, [j, F]);
  var je = X;
  return _e[Ns] && Me === rp && (je = ye({
    transition: "none"
  }, je)), [F, Me, je, j ?? t];
}
function $ve(e) {
  var t = e;
  nn(e) === "object" && (t = e.transitionSupport);
  function n(i, o) {
    return !!(i.motionName && t && o !== !1);
  }
  var r = /* @__PURE__ */ m.forwardRef(function(i, o) {
    var a = i.visible, s = a === void 0 ? !0 : a, l = i.removeOnLeave, c = l === void 0 ? !0 : l, f = i.forceRender, d = i.children, p = i.motionName, g = i.leavedClassName, v = i.eventProps, y = m.useContext(pve), x = y.motion, b = n(i, x), w = m.useRef(), S = m.useRef();
    function E() {
      try {
        return w.current instanceof HTMLElement ? w.current : QP(S.current);
      } catch {
        return null;
      }
    }
    var O = Eve(b, s, E, i), $ = ke(O, 4), P = $[0], R = $[1], L = $[2], B = $[3], j = m.useRef(B);
    B && (j.current = !0);
    var A = m.useCallback(function(D) {
      w.current = D, D9(o, D);
    }, [o]), T, k = ye(ye({}, v), {}, {
      visible: s
    });
    if (!d)
      T = null;
    else if (P === nf)
      B ? T = d(ye({}, k), A) : !c && j.current && g ? T = d(ye(ye({}, k), {}, {
        className: g
      }), A) : f || !c && !g ? T = d(ye(ye({}, k), {}, {
        style: {
          display: "none"
        }
      }), A) : T = null;
    else {
      var F, W;
      R === Ns ? W = "prepare" : CW(R) ? W = "active" : R === rp && (W = "start");
      var V = hD(p, "".concat(P, "-").concat(W));
      T = d(ye(ye({}, k), {}, {
        className: ft(hD(p, P), (F = {}, ce(F, V, V && W), ce(F, p, typeof p == "string"), F)),
        style: L
      }), A);
    }
    if (/* @__PURE__ */ m.isValidElement(T) && GR(T)) {
      var G = T, X = G.ref;
      X || (T = /* @__PURE__ */ m.cloneElement(T, {
        ref: A
      }));
    }
    return /* @__PURE__ */ m.createElement(hve, {
      ref: S
    }, T);
  });
  return r.displayName = "CSSMotion", r;
}
const Cc = $ve(wW);
var iT = "add", oT = "keep", aT = "remove", H$ = "removed";
function _ve(e) {
  var t;
  return e && nn(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, ye(ye({}, t), {}, {
    key: String(t.key)
  });
}
function sT() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(_ve);
}
function Ove() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, i = t.length, o = sT(e), a = sT(t);
  o.forEach(function(c) {
    for (var f = !1, d = r; d < i; d += 1) {
      var p = a[d];
      if (p.key === c.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(g) {
          return ye(ye({}, g), {}, {
            status: iT
          });
        })), r = d), n.push(ye(ye({}, p), {}, {
          status: oT
        })), r += 1, f = !0;
        break;
      }
    }
    f || n.push(ye(ye({}, c), {}, {
      status: aT
    }));
  }), r < i && (n = n.concat(a.slice(r).map(function(c) {
    return ye(ye({}, c), {}, {
      status: iT
    });
  })));
  var s = {};
  n.forEach(function(c) {
    var f = c.key;
    s[f] = (s[f] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(c) {
    return s[c] > 1;
  });
  return l.forEach(function(c) {
    n = n.filter(function(f) {
      var d = f.key, p = f.status;
      return d !== c || p !== aT;
    }), n.forEach(function(f) {
      f.key === c && (f.status = oT);
    });
  }), n;
}
var Pve = ["component", "children", "onVisibleChanged", "onAllRemoved"], Tve = ["status"], Ive = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function Ave(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Cc, n = /* @__PURE__ */ function(r) {
    cv(o, r);
    var i = uv(o);
    function o() {
      var a;
      Js(this, o);
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      return a = i.call.apply(i, [this].concat(l)), ce(Cn(a), "state", {
        keyEntities: []
      }), ce(Cn(a), "removeKey", function(f) {
        var d = a.state.keyEntities, p = d.map(function(g) {
          return g.key !== f ? g : ye(ye({}, g), {}, {
            status: H$
          });
        });
        return a.setState({
          keyEntities: p
        }), p.filter(function(g) {
          var v = g.status;
          return v !== H$;
        }).length;
      }), a;
    }
    return Zs(o, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, c = this.props, f = c.component, d = c.children, p = c.onVisibleChanged, g = c.onAllRemoved, v = _n(c, Pve), y = f || m.Fragment, x = {};
        return Ive.forEach(function(b) {
          x[b] = v[b], delete v[b];
        }), delete v.keys, /* @__PURE__ */ m.createElement(y, v, l.map(function(b) {
          var w = b.status, S = _n(b, Tve), E = w === iT || w === oT;
          return /* @__PURE__ */ m.createElement(t, jt({}, x, {
            key: S.key,
            visible: E,
            eventProps: S,
            onVisibleChanged: function($) {
              if (p == null || p($, {
                key: S.key
              }), !$) {
                var P = s.removeKey(S.key);
                P === 0 && g && g();
              }
            }
          }), d);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var c = s.keys, f = l.keyEntities, d = sT(c), p = Ove(f, d);
        return {
          keyEntities: p.filter(function(g) {
            var v = f.find(function(y) {
              var x = y.key;
              return g.key === x;
            });
            return !(v && v.status === H$ && g.status === aT);
          })
        };
      }
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
    }]), o;
  }(m.Component);
  return ce(n, "defaultProps", {
    component: "div"
  }), n;
}
Ave(wW);
const Rve = /* @__PURE__ */ m.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  var n = t.shouldUpdate;
  return !n;
});
var mD = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, Mve = {
  outline: "none"
}, EW = /* @__PURE__ */ oe.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.className, i = e.style, o = e.title, a = e.ariaId, s = e.footer, l = e.closable, c = e.closeIcon, f = e.onClose, d = e.children, p = e.bodyStyle, g = e.bodyProps, v = e.modalRender, y = e.onMouseDown, x = e.onMouseUp, b = e.holderRef, w = e.visible, S = e.forceRender, E = e.width, O = e.height, $ = e.classNames, P = e.styles, R = oe.useContext(pW), L = R.panel, B = F9(b, L), j = m.useRef(), A = m.useRef(), T = m.useRef();
  oe.useImperativeHandle(t, function() {
    return {
      focus: function() {
        var ee;
        (ee = T.current) === null || ee === void 0 || ee.focus();
      },
      changeActive: function(ee) {
        var U = document, he = U.activeElement;
        ee && he === A.current ? j.current.focus() : !ee && he === j.current && A.current.focus();
      }
    };
  });
  var k = {};
  E !== void 0 && (k.width = E), O !== void 0 && (k.height = O);
  var F;
  s && (F = /* @__PURE__ */ oe.createElement("div", {
    className: ft("".concat(n, "-footer"), $ == null ? void 0 : $.footer),
    style: ye({}, P == null ? void 0 : P.footer)
  }, s));
  var W;
  o && (W = /* @__PURE__ */ oe.createElement("div", {
    className: ft("".concat(n, "-header"), $ == null ? void 0 : $.header),
    style: ye({}, P == null ? void 0 : P.header)
  }, /* @__PURE__ */ oe.createElement("div", {
    className: "".concat(n, "-title"),
    id: a
  }, o)));
  var V = m.useMemo(function() {
    return nn(l) === "object" && l !== null ? l : l ? {
      closeIcon: c ?? /* @__PURE__ */ oe.createElement("span", {
        className: "".concat(n, "-close-x")
      })
    } : {};
  }, [l, c]), G = hW(V, !0), X;
  l && (X = /* @__PURE__ */ oe.createElement("button", jt({
    type: "button",
    onClick: f,
    "aria-label": "Close"
  }, G, {
    className: "".concat(n, "-close")
  }), V.closeIcon));
  var D = /* @__PURE__ */ oe.createElement("div", {
    className: ft("".concat(n, "-content"), $ == null ? void 0 : $.content),
    style: P == null ? void 0 : P.content
  }, X, W, /* @__PURE__ */ oe.createElement("div", jt({
    className: ft("".concat(n, "-body"), $ == null ? void 0 : $.body),
    style: ye(ye({}, p), P == null ? void 0 : P.body)
  }, g), d), F);
  return /* @__PURE__ */ oe.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": o ? a : null,
    "aria-modal": "true",
    ref: B,
    style: ye(ye({}, i), k),
    className: ft(n, r),
    onMouseDown: y,
    onMouseUp: x
  }, /* @__PURE__ */ oe.createElement("div", {
    tabIndex: 0,
    ref: j,
    style: mD,
    "aria-hidden": "true"
  }), /* @__PURE__ */ oe.createElement("div", {
    ref: T,
    tabIndex: -1,
    style: Mve
  }, /* @__PURE__ */ oe.createElement(Rve, {
    shouldUpdate: w || S
  }, v ? v(D) : D)), /* @__PURE__ */ oe.createElement("div", {
    tabIndex: 0,
    ref: A,
    style: mD,
    "aria-hidden": "true"
  }));
}), $W = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.title, i = e.style, o = e.className, a = e.visible, s = e.forceRender, l = e.destroyOnClose, c = e.motionName, f = e.ariaId, d = e.onVisibleChanged, p = e.mousePosition, g = m.useRef(), v = m.useState(), y = ke(v, 2), x = y[0], b = y[1], w = {};
  x && (w.transformOrigin = x);
  function S() {
    var E = dve(g.current);
    b(p ? "".concat(p.x - E.left, "px ").concat(p.y - E.top, "px") : "");
  }
  return /* @__PURE__ */ m.createElement(Cc, {
    visible: a,
    onVisibleChanged: d,
    onAppearPrepare: S,
    onEnterPrepare: S,
    forceRender: s,
    motionName: c,
    removeOnLeave: l,
    ref: g
  }, function(E, O) {
    var $ = E.className, P = E.style;
    return /* @__PURE__ */ m.createElement(EW, jt({}, e, {
      ref: t,
      title: r,
      ariaId: f,
      prefixCls: n,
      holderRef: O,
      style: ye(ye(ye({}, P), i), w),
      className: ft(o, $)
    }));
  });
});
$W.displayName = "Content";
function Nve(e) {
  var t = e.prefixCls, n = e.style, r = e.visible, i = e.maskProps, o = e.motionName, a = e.className;
  return /* @__PURE__ */ m.createElement(Cc, {
    key: "mask",
    visible: r,
    motionName: o,
    leavedClassName: "".concat(t, "-mask-hidden")
  }, function(s, l) {
    var c = s.className, f = s.style;
    return /* @__PURE__ */ m.createElement("div", jt({
      ref: l,
      style: ye(ye({}, f), n),
      className: ft("".concat(t, "-mask"), c, a)
    }, i));
  });
}
function kve(e) {
  var t = e.prefixCls, n = t === void 0 ? "rc-dialog" : t, r = e.zIndex, i = e.visible, o = i === void 0 ? !1 : i, a = e.keyboard, s = a === void 0 ? !0 : a, l = e.focusTriggerAfterClose, c = l === void 0 ? !0 : l, f = e.wrapStyle, d = e.wrapClassName, p = e.wrapProps, g = e.onClose, v = e.afterOpenChange, y = e.afterClose, x = e.transitionName, b = e.animation, w = e.closable, S = w === void 0 ? !0 : w, E = e.mask, O = E === void 0 ? !0 : E, $ = e.maskTransitionName, P = e.maskAnimation, R = e.maskClosable, L = R === void 0 ? !0 : R, B = e.maskStyle, j = e.maskProps, A = e.rootClassName, T = e.classNames, k = e.styles, F = m.useRef(), W = m.useRef(), V = m.useRef(), G = m.useState(o), X = ke(G, 2), D = X[0], te = X[1], ee = ave();
  function U() {
    nT(W.current, document.activeElement) || (F.current = document.activeElement);
  }
  function he() {
    if (!nT(W.current, document.activeElement)) {
      var Fe;
      (Fe = V.current) === null || Fe === void 0 || Fe.focus();
    }
  }
  function re(Fe) {
    if (Fe)
      he();
    else {
      if (te(!1), O && F.current && c) {
        try {
          F.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        F.current = null;
      }
      D && (y == null || y());
    }
    v == null || v(Fe);
  }
  function de(Fe) {
    g == null || g(Fe);
  }
  var we = m.useRef(!1), ue = m.useRef(), me = function() {
    clearTimeout(ue.current), we.current = !0;
  }, Se = function() {
    ue.current = setTimeout(function() {
      we.current = !1;
    });
  }, _e = null;
  L && (_e = function(Ae) {
    we.current ? we.current = !1 : W.current === Ae.target && de(Ae);
  });
  function Ge(Fe) {
    if (s && Fe.keyCode === Tt.ESC) {
      Fe.stopPropagation(), de(Fe);
      return;
    }
    o && Fe.keyCode === Tt.TAB && V.current.changeActive(!Fe.shiftKey);
  }
  return m.useEffect(function() {
    o && (te(!0), U());
  }, [o]), m.useEffect(function() {
    return function() {
      clearTimeout(ue.current);
    };
  }, []), /* @__PURE__ */ m.createElement("div", jt({
    className: ft("".concat(n, "-root"), A)
  }, hW(e, {
    data: !0
  })), /* @__PURE__ */ m.createElement(Nve, {
    prefixCls: n,
    visible: O && o,
    motionName: lD(n, $, P),
    style: ye(ye({
      zIndex: r
    }, B), k == null ? void 0 : k.mask),
    maskProps: j,
    className: T == null ? void 0 : T.mask
  }), /* @__PURE__ */ m.createElement("div", jt({
    tabIndex: -1,
    onKeyDown: Ge,
    className: ft("".concat(n, "-wrap"), d, T == null ? void 0 : T.wrapper),
    ref: W,
    onClick: _e,
    style: ye(ye(ye({
      zIndex: r
    }, f), k == null ? void 0 : k.wrapper), {}, {
      display: D ? null : "none"
    })
  }, p), /* @__PURE__ */ m.createElement($W, jt({}, e, {
    onMouseDown: me,
    onMouseUp: Se,
    ref: V,
    closable: S,
    ariaId: ee,
    prefixCls: n,
    visible: o && D,
    onClose: de,
    onVisibleChanged: re,
    motionName: lD(n, x, b)
  }))));
}
var _W = function(t) {
  var n = t.visible, r = t.getContainer, i = t.forceRender, o = t.destroyOnClose, a = o === void 0 ? !1 : o, s = t.afterClose, l = t.panelRef, c = m.useState(n), f = ke(c, 2), d = f[0], p = f[1], g = m.useMemo(function() {
    return {
      panel: l
    };
  }, [l]);
  return m.useEffect(function() {
    n && p(!0);
  }, [n]), !i && a && !d ? null : /* @__PURE__ */ m.createElement(pW.Provider, {
    value: g
  }, /* @__PURE__ */ m.createElement(pv, {
    open: n || i || d,
    autoDestroy: !1,
    getContainer: r,
    autoLock: n || d
  }, /* @__PURE__ */ m.createElement(kve, jt({}, t, {
    destroyOnClose: a,
    afterClose: function() {
      s == null || s(), p(!1);
    }
  }))));
};
_W.displayName = "Dialog";
var Lve = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Dve(e, t, n) {
  return typeof e == "boolean" ? e : typeof e == "object" ? !0 : t === void 0 ? !!n : t !== !1 && t !== null;
}
function OW(e) {
  let {
    closable: t,
    closeIcon: n,
    customCloseIconRender: r,
    defaultCloseIcon: i = /* @__PURE__ */ oe.createElement(lv, null),
    defaultClosable: o = !1
  } = e;
  if (!Dve(t, n, o))
    return [!1, null];
  const s = typeof t == "object" ? t : {}, {
    closeIcon: l
  } = s, c = Lve(s, ["closeIcon"]), f = typeof t == "object" && l !== void 0 ? l : typeof n == "boolean" || n === void 0 || n === null ? i : n, d = R9(c, !0), p = r ? r(f) : f;
  return [!0, /* @__PURE__ */ oe.isValidElement(p) ? /* @__PURE__ */ oe.cloneElement(p, d) : /* @__PURE__ */ oe.createElement("span", Object.assign({}, d), p)];
}
var PW = function(t) {
  if (av() && window.document.documentElement) {
    var n = Array.isArray(t) ? t : [t], r = window.document.documentElement;
    return n.some(function(i) {
      return i in r.style;
    });
  }
  return !1;
}, jve = function(t, n) {
  if (!PW(t))
    return !1;
  var r = document.createElement("div"), i = r.style[t];
  return r.style[t] = n, r.style[t] !== i;
};
function gD(e, t) {
  return !Array.isArray(e) && t !== void 0 ? jve(e, t) : PW(e);
}
const Fve = () => av() && window.document.documentElement;
function qs() {
  qs = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = Object.defineProperty || function(A, T, k) {
    A[T] = k.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, o = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
  function l(A, T, k) {
    return Object.defineProperty(A, T, {
      value: k,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), A[T];
  }
  try {
    l({}, "");
  } catch {
    l = function(k, F, W) {
      return k[F] = W;
    };
  }
  function c(A, T, k, F) {
    var W = T && T.prototype instanceof p ? T : p, V = Object.create(W.prototype), G = new L(F || []);
    return r(V, "_invoke", {
      value: O(A, k, G)
    }), V;
  }
  function f(A, T, k) {
    try {
      return {
        type: "normal",
        arg: A.call(T, k)
      };
    } catch (F) {
      return {
        type: "throw",
        arg: F
      };
    }
  }
  e.wrap = c;
  var d = {};
  function p() {
  }
  function g() {
  }
  function v() {
  }
  var y = {};
  l(y, o, function() {
    return this;
  });
  var x = Object.getPrototypeOf, b = x && x(x(B([])));
  b && b !== t && n.call(b, o) && (y = b);
  var w = v.prototype = p.prototype = Object.create(y);
  function S(A) {
    ["next", "throw", "return"].forEach(function(T) {
      l(A, T, function(k) {
        return this._invoke(T, k);
      });
    });
  }
  function E(A, T) {
    function k(W, V, G, X) {
      var D = f(A[W], A, V);
      if (D.type !== "throw") {
        var te = D.arg, ee = te.value;
        return ee && nn(ee) == "object" && n.call(ee, "__await") ? T.resolve(ee.__await).then(function(U) {
          k("next", U, G, X);
        }, function(U) {
          k("throw", U, G, X);
        }) : T.resolve(ee).then(function(U) {
          te.value = U, G(te);
        }, function(U) {
          return k("throw", U, G, X);
        });
      }
      X(D.arg);
    }
    var F;
    r(this, "_invoke", {
      value: function(V, G) {
        function X() {
          return new T(function(D, te) {
            k(V, G, D, te);
          });
        }
        return F = F ? F.then(X, X) : X();
      }
    });
  }
  function O(A, T, k) {
    var F = "suspendedStart";
    return function(W, V) {
      if (F === "executing")
        throw new Error("Generator is already running");
      if (F === "completed") {
        if (W === "throw")
          throw V;
        return j();
      }
      for (k.method = W, k.arg = V; ; ) {
        var G = k.delegate;
        if (G) {
          var X = $(G, k);
          if (X) {
            if (X === d)
              continue;
            return X;
          }
        }
        if (k.method === "next")
          k.sent = k._sent = k.arg;
        else if (k.method === "throw") {
          if (F === "suspendedStart")
            throw F = "completed", k.arg;
          k.dispatchException(k.arg);
        } else
          k.method === "return" && k.abrupt("return", k.arg);
        F = "executing";
        var D = f(A, T, k);
        if (D.type === "normal") {
          if (F = k.done ? "completed" : "suspendedYield", D.arg === d)
            continue;
          return {
            value: D.arg,
            done: k.done
          };
        }
        D.type === "throw" && (F = "completed", k.method = "throw", k.arg = D.arg);
      }
    };
  }
  function $(A, T) {
    var k = T.method, F = A.iterator[k];
    if (F === void 0)
      return T.delegate = null, k === "throw" && A.iterator.return && (T.method = "return", T.arg = void 0, $(A, T), T.method === "throw") || k !== "return" && (T.method = "throw", T.arg = new TypeError("The iterator does not provide a '" + k + "' method")), d;
    var W = f(F, A.iterator, T.arg);
    if (W.type === "throw")
      return T.method = "throw", T.arg = W.arg, T.delegate = null, d;
    var V = W.arg;
    return V ? V.done ? (T[A.resultName] = V.value, T.next = A.nextLoc, T.method !== "return" && (T.method = "next", T.arg = void 0), T.delegate = null, d) : V : (T.method = "throw", T.arg = new TypeError("iterator result is not an object"), T.delegate = null, d);
  }
  function P(A) {
    var T = {
      tryLoc: A[0]
    };
    1 in A && (T.catchLoc = A[1]), 2 in A && (T.finallyLoc = A[2], T.afterLoc = A[3]), this.tryEntries.push(T);
  }
  function R(A) {
    var T = A.completion || {};
    T.type = "normal", delete T.arg, A.completion = T;
  }
  function L(A) {
    this.tryEntries = [{
      tryLoc: "root"
    }], A.forEach(P, this), this.reset(!0);
  }
  function B(A) {
    if (A) {
      var T = A[o];
      if (T)
        return T.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var k = -1, F = function W() {
          for (; ++k < A.length; )
            if (n.call(A, k))
              return W.value = A[k], W.done = !1, W;
          return W.value = void 0, W.done = !0, W;
        };
        return F.next = F;
      }
    }
    return {
      next: j
    };
  }
  function j() {
    return {
      value: void 0,
      done: !0
    };
  }
  return g.prototype = v, r(w, "constructor", {
    value: v,
    configurable: !0
  }), r(v, "constructor", {
    value: g,
    configurable: !0
  }), g.displayName = l(v, s, "GeneratorFunction"), e.isGeneratorFunction = function(A) {
    var T = typeof A == "function" && A.constructor;
    return !!T && (T === g || (T.displayName || T.name) === "GeneratorFunction");
  }, e.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, v) : (A.__proto__ = v, l(A, s, "GeneratorFunction")), A.prototype = Object.create(w), A;
  }, e.awrap = function(A) {
    return {
      __await: A
    };
  }, S(E.prototype), l(E.prototype, a, function() {
    return this;
  }), e.AsyncIterator = E, e.async = function(A, T, k, F, W) {
    W === void 0 && (W = Promise);
    var V = new E(c(A, T, k, F), W);
    return e.isGeneratorFunction(T) ? V : V.next().then(function(G) {
      return G.done ? G.value : V.next();
    });
  }, S(w), l(w, s, "Generator"), l(w, o, function() {
    return this;
  }), l(w, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(A) {
    var T = Object(A), k = [];
    for (var F in T)
      k.push(F);
    return k.reverse(), function W() {
      for (; k.length; ) {
        var V = k.pop();
        if (V in T)
          return W.value = V, W.done = !1, W;
      }
      return W.done = !0, W;
    };
  }, e.values = B, L.prototype = {
    constructor: L,
    reset: function(T) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(R), !T)
        for (var k in this)
          k.charAt(0) === "t" && n.call(this, k) && !isNaN(+k.slice(1)) && (this[k] = void 0);
    },
    stop: function() {
      this.done = !0;
      var T = this.tryEntries[0].completion;
      if (T.type === "throw")
        throw T.arg;
      return this.rval;
    },
    dispatchException: function(T) {
      if (this.done)
        throw T;
      var k = this;
      function F(te, ee) {
        return G.type = "throw", G.arg = T, k.next = te, ee && (k.method = "next", k.arg = void 0), !!ee;
      }
      for (var W = this.tryEntries.length - 1; W >= 0; --W) {
        var V = this.tryEntries[W], G = V.completion;
        if (V.tryLoc === "root")
          return F("end");
        if (V.tryLoc <= this.prev) {
          var X = n.call(V, "catchLoc"), D = n.call(V, "finallyLoc");
          if (X && D) {
            if (this.prev < V.catchLoc)
              return F(V.catchLoc, !0);
            if (this.prev < V.finallyLoc)
              return F(V.finallyLoc);
          } else if (X) {
            if (this.prev < V.catchLoc)
              return F(V.catchLoc, !0);
          } else {
            if (!D)
              throw new Error("try statement without catch or finally");
            if (this.prev < V.finallyLoc)
              return F(V.finallyLoc);
          }
        }
      }
    },
    abrupt: function(T, k) {
      for (var F = this.tryEntries.length - 1; F >= 0; --F) {
        var W = this.tryEntries[F];
        if (W.tryLoc <= this.prev && n.call(W, "finallyLoc") && this.prev < W.finallyLoc) {
          var V = W;
          break;
        }
      }
      V && (T === "break" || T === "continue") && V.tryLoc <= k && k <= V.finallyLoc && (V = null);
      var G = V ? V.completion : {};
      return G.type = T, G.arg = k, V ? (this.method = "next", this.next = V.finallyLoc, d) : this.complete(G);
    },
    complete: function(T, k) {
      if (T.type === "throw")
        throw T.arg;
      return T.type === "break" || T.type === "continue" ? this.next = T.arg : T.type === "return" ? (this.rval = this.arg = T.arg, this.method = "return", this.next = "end") : T.type === "normal" && k && (this.next = k), d;
    },
    finish: function(T) {
      for (var k = this.tryEntries.length - 1; k >= 0; --k) {
        var F = this.tryEntries[k];
        if (F.finallyLoc === T)
          return this.complete(F.completion, F.afterLoc), R(F), d;
      }
    },
    catch: function(T) {
      for (var k = this.tryEntries.length - 1; k >= 0; --k) {
        var F = this.tryEntries[k];
        if (F.tryLoc === T) {
          var W = F.completion;
          if (W.type === "throw") {
            var V = W.arg;
            R(F);
          }
          return V;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(T, k, F) {
      return this.delegate = {
        iterator: B(T),
        resultName: k,
        nextLoc: F
      }, this.method === "next" && (this.arg = void 0), d;
    }
  }, e;
}
function vD(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a), l = s.value;
  } catch (c) {
    n(c);
    return;
  }
  s.done ? t(l) : Promise.resolve(l).then(r, i);
}
function hv(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(l) {
        vD(o, r, i, a, s, "next", l);
      }
      function s(l) {
        vD(o, r, i, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
function lT(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return oe.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(lT(r)) : yh.isFragment(r) && r.props ? n = n.concat(lT(r.props.children, t)) : n.push(r));
  }), n;
}
var cT = {}, Bve = function(t) {
};
function zve(e, t) {
}
function Uve(e, t) {
}
function Hve() {
  cT = {};
}
function TW(e, t, n) {
  !t && !cT[n] && (e(!1, n), cT[n] = !0);
}
function Za(e, t) {
  TW(zve, e, t);
}
function Wve(e, t) {
  TW(Uve, e, t);
}
Za.preMessage = Bve;
Za.resetWarned = Hve;
Za.noteOnce = Wve;
function Vve(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = r.has(o);
    if (Za(!l, "Warning: There may be circular references"), l)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var c = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var f = 0; f < o.length; f++)
        if (!i(o[f], a[f], c))
          return !1;
      return !0;
    }
    if (o && a && nn(o) === "object" && nn(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(p) {
        return i(o[p], a[p], c);
      });
    }
    return !1;
  }
  return i(e, t);
}
var wf = "RC_FORM_INTERNAL_HOOKS", Yn = function() {
  Za(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Yp = /* @__PURE__ */ m.createContext({
  getFieldValue: Yn,
  getFieldsValue: Yn,
  getFieldError: Yn,
  getFieldWarning: Yn,
  getFieldsError: Yn,
  isFieldsTouched: Yn,
  isFieldTouched: Yn,
  isFieldValidating: Yn,
  isFieldsValidating: Yn,
  resetFields: Yn,
  setFields: Yn,
  setFieldValue: Yn,
  setFieldsValue: Yn,
  validateFields: Yn,
  submit: Yn,
  getInternalHooks: function() {
    return Yn(), {
      dispatch: Yn,
      initEntityValue: Yn,
      registerField: Yn,
      useSubscribe: Yn,
      setInitialValues: Yn,
      destroyForm: Yn,
      setCallbacks: Yn,
      registerWatch: Yn,
      getFields: Yn,
      setValidateMessages: Yn,
      setPreserve: Yn,
      getInitialValue: Yn
    };
  }
}), M1 = /* @__PURE__ */ m.createContext(null);
function uT(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Gve(e) {
  return e && !!e._init;
}
function Sf() {
  return Sf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sf.apply(this, arguments);
}
function Kve(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Lg(e, t);
}
function fT(e) {
  return fT = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, fT(e);
}
function Lg(e, t) {
  return Lg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Lg(e, t);
}
function qve() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function mb(e, t, n) {
  return qve() ? mb = Reflect.construct.bind() : mb = function(i, o, a) {
    var s = [null];
    s.push.apply(s, o);
    var l = Function.bind.apply(i, s), c = new l();
    return a && Lg(c, a.prototype), c;
  }, mb.apply(null, arguments);
}
function Yve(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function dT(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return dT = function(r) {
    if (r === null || !Yve(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, i);
    }
    function i() {
      return mb(r, arguments, fT(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Lg(i, r);
  }, dT(e);
}
var Xve = /%[sdj%]/g, Qve = function() {
};
typeof process < "u" && process.env;
function pT(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function Sa(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var i = 0, o = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var a = e.replace(Xve, function(s) {
      if (s === "%%")
        return "%";
      if (i >= o)
        return s;
      switch (s) {
        case "%s":
          return String(n[i++]);
        case "%d":
          return Number(n[i++]);
        case "%j":
          try {
            return JSON.stringify(n[i++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return e;
}
function Jve(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function hi(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || Jve(t) && typeof e == "string" && !e);
}
function Zve(e, t, n) {
  var r = [], i = 0, o = e.length;
  function a(s) {
    r.push.apply(r, s || []), i++, i === o && n(r);
  }
  e.forEach(function(s) {
    t(s, a);
  });
}
function yD(e, t, n) {
  var r = 0, i = e.length;
  function o(a) {
    if (a && a.length) {
      n(a);
      return;
    }
    var s = r;
    r = r + 1, s < i ? t(e[s], o) : n([]);
  }
  o([]);
}
function eye(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, e[n] || []);
  }), t;
}
var bD = /* @__PURE__ */ function(e) {
  Kve(t, e);
  function t(n, r) {
    var i;
    return i = e.call(this, "Async Validation Error") || this, i.errors = n, i.fields = r, i;
  }
  return t;
}(/* @__PURE__ */ dT(Error));
function tye(e, t, n, r, i) {
  if (t.first) {
    var o = new Promise(function(p, g) {
      var v = function(b) {
        return r(b), b.length ? g(new bD(b, pT(b))) : p(i);
      }, y = eye(e);
      yD(y, n, v);
    });
    return o.catch(function(p) {
      return p;
    }), o;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, c = 0, f = [], d = new Promise(function(p, g) {
    var v = function(x) {
      if (f.push.apply(f, x), c++, c === l)
        return r(f), f.length ? g(new bD(f, pT(f))) : p(i);
    };
    s.length || (r(f), p(i)), s.forEach(function(y) {
      var x = e[y];
      a.indexOf(y) !== -1 ? yD(x, n, v) : Zve(x, n, v);
    });
  });
  return d.catch(function(p) {
    return p;
  }), d;
}
function nye(e) {
  return !!(e && e.message !== void 0);
}
function rye(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function wD(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = rye(t, e.fullFields) : r = t[n.field || e.fullField], nye(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function SD(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        typeof r == "object" && typeof e[n] == "object" ? e[n] = Sf({}, e[n], r) : e[n] = r;
      }
  }
  return e;
}
var IW = function(t, n, r, i, o, a) {
  t.required && (!r.hasOwnProperty(t.field) || hi(n, a || t.type)) && i.push(Sa(o.messages.required, t.fullField));
}, iye = function(t, n, r, i, o) {
  (/^\s+$/.test(n) || n === "") && i.push(Sa(o.messages.whitespace, t.fullField));
}, S0, oye = function() {
  if (S0)
    return S0;
  var e = "[a-fA-F\\d:]", t = function(E) {
    return E && E.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", i = (`
(?:
(?:` + r + ":){7}(?:" + r + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + r + ":){6}(?:" + n + "|:" + r + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + r + ":){5}(?::" + n + "|(?::" + r + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + r + ":){4}(?:(?::" + r + "){0,1}:" + n + "|(?::" + r + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + r + ":){3}(?:(?::" + r + "){0,2}:" + n + "|(?::" + r + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + r + ":){2}(?:(?::" + r + "){0,3}:" + n + "|(?::" + r + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + r + ":){1}(?:(?::" + r + "){0,4}:" + n + "|(?::" + r + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + r + "){0,5}:" + n + "|(?::" + r + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), o = new RegExp("(?:^" + n + "$)|(?:^" + i + "$)"), a = new RegExp("^" + n + "$"), s = new RegExp("^" + i + "$"), l = function(E) {
    return E && E.exact ? o : new RegExp("(?:" + t(E) + n + t(E) + ")|(?:" + t(E) + i + t(E) + ")", "g");
  };
  l.v4 = function(S) {
    return S && S.exact ? a : new RegExp("" + t(S) + n + t(S), "g");
  }, l.v6 = function(S) {
    return S && S.exact ? s : new RegExp("" + t(S) + i + t(S), "g");
  };
  var c = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", d = l.v4().source, p = l.v6().source, g = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", v = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", y = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", x = "(?::\\d{2,5})?", b = '(?:[/?#][^\\s"]*)?', w = "(?:" + c + "|www\\.)" + f + "(?:localhost|" + d + "|" + p + "|" + g + v + y + ")" + x + b;
  return S0 = new RegExp("(?:^" + w + "$)", "i"), S0;
}, xD = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, km = {
  integer: function(t) {
    return km.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return km.number(t) && !km.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !km.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(xD.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(oye());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(xD.hex);
  }
}, aye = function(t, n, r, i, o) {
  if (t.required && n === void 0) {
    IW(t, n, r, i, o);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  a.indexOf(s) > -1 ? km[s](n) || i.push(Sa(o.messages.types[s], t.fullField, t.type)) : s && typeof n !== t.type && i.push(Sa(o.messages.types[s], t.fullField, t.type));
}, sye = function(t, n, r, i, o) {
  var a = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", c = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, f = n, d = null, p = typeof n == "number", g = typeof n == "string", v = Array.isArray(n);
  if (p ? d = "number" : g ? d = "string" : v && (d = "array"), !d)
    return !1;
  v && (f = n.length), g && (f = n.replace(c, "_").length), a ? f !== t.len && i.push(Sa(o.messages[d].len, t.fullField, t.len)) : s && !l && f < t.min ? i.push(Sa(o.messages[d].min, t.fullField, t.min)) : l && !s && f > t.max ? i.push(Sa(o.messages[d].max, t.fullField, t.max)) : s && l && (f < t.min || f > t.max) && i.push(Sa(o.messages[d].range, t.fullField, t.min, t.max));
}, Cd = "enum", lye = function(t, n, r, i, o) {
  t[Cd] = Array.isArray(t[Cd]) ? t[Cd] : [], t[Cd].indexOf(n) === -1 && i.push(Sa(o.messages[Cd], t.fullField, t[Cd].join(", ")));
}, cye = function(t, n, r, i, o) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || i.push(Sa(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(n) || i.push(Sa(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, hn = {
  required: IW,
  whitespace: iye,
  type: aye,
  range: sye,
  enum: lye,
  pattern: cye
}, uye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n, "string") && !t.required)
      return r();
    hn.required(t, n, i, a, o, "string"), hi(n, "string") || (hn.type(t, n, i, a, o), hn.range(t, n, i, a, o), hn.pattern(t, n, i, a, o), t.whitespace === !0 && hn.whitespace(t, n, i, a, o));
  }
  r(a);
}, fye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), n !== void 0 && hn.type(t, n, i, a, o);
  }
  r(a);
}, dye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), n !== void 0 && (hn.type(t, n, i, a, o), hn.range(t, n, i, a, o));
  }
  r(a);
}, pye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), n !== void 0 && hn.type(t, n, i, a, o);
  }
  r(a);
}, hye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), hi(n) || hn.type(t, n, i, a, o);
  }
  r(a);
}, mye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), n !== void 0 && (hn.type(t, n, i, a, o), hn.range(t, n, i, a, o));
  }
  r(a);
}, gye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), n !== void 0 && (hn.type(t, n, i, a, o), hn.range(t, n, i, a, o));
  }
  r(a);
}, vye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    hn.required(t, n, i, a, o, "array"), n != null && (hn.type(t, n, i, a, o), hn.range(t, n, i, a, o));
  }
  r(a);
}, yye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), n !== void 0 && hn.type(t, n, i, a, o);
  }
  r(a);
}, bye = "enum", wye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o), n !== void 0 && hn[bye](t, n, i, a, o);
  }
  r(a);
}, Sye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n, "string") && !t.required)
      return r();
    hn.required(t, n, i, a, o), hi(n, "string") || hn.pattern(t, n, i, a, o);
  }
  r(a);
}, xye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n, "date") && !t.required)
      return r();
    if (hn.required(t, n, i, a, o), !hi(n, "date")) {
      var l;
      n instanceof Date ? l = n : l = new Date(n), hn.type(t, l, i, a, o), l && hn.range(t, l.getTime(), i, a, o);
    }
  }
  r(a);
}, Cye = function(t, n, r, i, o) {
  var a = [], s = Array.isArray(n) ? "array" : typeof n;
  hn.required(t, n, i, a, o, s), r(a);
}, W$ = function(t, n, r, i, o) {
  var a = t.type, s = [], l = t.required || !t.required && i.hasOwnProperty(t.field);
  if (l) {
    if (hi(n, a) && !t.required)
      return r();
    hn.required(t, n, i, s, o, a), hi(n, a) || hn.type(t, n, i, s, o);
  }
  r(s);
}, Eye = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (hi(n) && !t.required)
      return r();
    hn.required(t, n, i, a, o);
  }
  r(a);
}, eg = {
  string: uye,
  method: fye,
  number: dye,
  boolean: pye,
  regexp: hye,
  integer: mye,
  float: gye,
  array: vye,
  object: yye,
  enum: wye,
  pattern: Sye,
  date: xye,
  url: W$,
  hex: W$,
  email: W$,
  required: Cye,
  any: Eye
};
function hT() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var mT = hT(), mv = /* @__PURE__ */ function() {
  function e(n) {
    this.rules = null, this._messages = mT, this.define(n);
  }
  var t = e.prototype;
  return t.define = function(r) {
    var i = this;
    if (!r)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof r != "object" || Array.isArray(r))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(r).forEach(function(o) {
      var a = r[o];
      i.rules[o] = Array.isArray(a) ? a : [a];
    });
  }, t.messages = function(r) {
    return r && (this._messages = SD(hT(), r)), this._messages;
  }, t.validate = function(r, i, o) {
    var a = this;
    i === void 0 && (i = {}), o === void 0 && (o = function() {
    });
    var s = r, l = i, c = o;
    if (typeof l == "function" && (c = l, l = {}), !this.rules || Object.keys(this.rules).length === 0)
      return c && c(null, s), Promise.resolve(s);
    function f(y) {
      var x = [], b = {};
      function w(E) {
        if (Array.isArray(E)) {
          var O;
          x = (O = x).concat.apply(O, E);
        } else
          x.push(E);
      }
      for (var S = 0; S < y.length; S++)
        w(y[S]);
      x.length ? (b = pT(x), c(x, b)) : c(null, s);
    }
    if (l.messages) {
      var d = this.messages();
      d === mT && (d = hT()), SD(d, l.messages), l.messages = d;
    } else
      l.messages = this.messages();
    var p = {}, g = l.keys || Object.keys(this.rules);
    g.forEach(function(y) {
      var x = a.rules[y], b = s[y];
      x.forEach(function(w) {
        var S = w;
        typeof S.transform == "function" && (s === r && (s = Sf({}, s)), b = s[y] = S.transform(b)), typeof S == "function" ? S = {
          validator: S
        } : S = Sf({}, S), S.validator = a.getValidationMethod(S), S.validator && (S.field = y, S.fullField = S.fullField || y, S.type = a.getType(S), p[y] = p[y] || [], p[y].push({
          rule: S,
          value: b,
          source: s,
          field: y
        }));
      });
    });
    var v = {};
    return tye(p, l, function(y, x) {
      var b = y.rule, w = (b.type === "object" || b.type === "array") && (typeof b.fields == "object" || typeof b.defaultField == "object");
      w = w && (b.required || !b.required && y.value), b.field = y.field;
      function S($, P) {
        return Sf({}, P, {
          fullField: b.fullField + "." + $,
          fullFields: b.fullFields ? [].concat(b.fullFields, [$]) : [$]
        });
      }
      function E($) {
        $ === void 0 && ($ = []);
        var P = Array.isArray($) ? $ : [$];
        !l.suppressWarning && P.length && e.warning("async-validator:", P), P.length && b.message !== void 0 && (P = [].concat(b.message));
        var R = P.map(wD(b, s));
        if (l.first && R.length)
          return v[b.field] = 1, x(R);
        if (!w)
          x(R);
        else {
          if (b.required && !y.value)
            return b.message !== void 0 ? R = [].concat(b.message).map(wD(b, s)) : l.error && (R = [l.error(b, Sa(l.messages.required, b.field))]), x(R);
          var L = {};
          b.defaultField && Object.keys(y.value).map(function(A) {
            L[A] = b.defaultField;
          }), L = Sf({}, L, y.rule.fields);
          var B = {};
          Object.keys(L).forEach(function(A) {
            var T = L[A], k = Array.isArray(T) ? T : [T];
            B[A] = k.map(S.bind(null, A));
          });
          var j = new e(B);
          j.messages(l.messages), y.rule.options && (y.rule.options.messages = l.messages, y.rule.options.error = l.error), j.validate(y.value, y.rule.options || l, function(A) {
            var T = [];
            R && R.length && T.push.apply(T, R), A && A.length && T.push.apply(T, A), x(T.length ? T : null);
          });
        }
      }
      var O;
      if (b.asyncValidator)
        O = b.asyncValidator(b, y.value, E, y.source, l);
      else if (b.validator) {
        try {
          O = b.validator(b, y.value, E, y.source, l);
        } catch ($) {
          console.error == null || console.error($), l.suppressValidatorError || setTimeout(function() {
            throw $;
          }, 0), E($.message);
        }
        O === !0 ? E() : O === !1 ? E(typeof b.message == "function" ? b.message(b.fullField || b.field) : b.message || (b.fullField || b.field) + " fails") : O instanceof Array ? E(O) : O instanceof Error && E(O.message);
      }
      O && O.then && O.then(function() {
        return E();
      }, function($) {
        return E($);
      });
    }, function(y) {
      f(y);
    }, s);
  }, t.getType = function(r) {
    if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !eg.hasOwnProperty(r.type))
      throw new Error(Sa("Unknown rule type %s", r.type));
    return r.type || "string";
  }, t.getValidationMethod = function(r) {
    if (typeof r.validator == "function")
      return r.validator;
    var i = Object.keys(r), o = i.indexOf("message");
    return o !== -1 && i.splice(o, 1), i.length === 1 && i[0] === "required" ? eg.required : eg[this.getType(r)] || void 0;
  }, e;
}();
mv.register = function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  eg[t] = n;
};
mv.warning = Qve;
mv.messages = mT;
mv.validators = eg;
var ua = "'${name}' is not a valid ${type}", AW = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: ua,
    method: ua,
    array: ua,
    object: ua,
    number: ua,
    date: ua,
    boolean: ua,
    integer: ua,
    float: ua,
    regexp: ua,
    email: ua,
    url: ua,
    hex: ua
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
function $ye(e) {
  return HU(e) || VU(e) || vR(e) || WU();
}
function xl(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function RW(e, t, n, r) {
  if (!t.length)
    return n;
  var i = $ye(t), o = i[0], a = i.slice(1), s;
  return !e && typeof o == "number" ? s = [] : Array.isArray(e) ? s = Rt(e) : s = ye({}, e), r && n === void 0 && a.length === 1 ? delete s[o][a[0]] : s[o] = RW(s[o], a, n, r), s;
}
function ks(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !xl(e, t.slice(0, -1)) ? e : RW(e, t, n, r);
}
function _ye(e) {
  return nn(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function CD(e) {
  return Array.isArray(e) ? [] : {};
}
function Lm() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = CD(t[0]);
  return t.forEach(function(i) {
    function o(a, s) {
      var l = new Set(s), c = xl(i, a), f = Array.isArray(c);
      if (f || _ye(c)) {
        if (!l.has(c)) {
          l.add(c);
          var d = xl(r, a);
          f ? r = ks(r, a, []) : (!d || nn(d) !== "object") && (r = ks(r, a, CD(c))), Object.keys(c).forEach(function(p) {
            o([].concat(Rt(a), [p]), l);
          });
        }
      } else
        r = ks(r, a, c);
    }
    o([]);
  }), r;
}
var ED = mv;
function Oye(e, t) {
  return e.replace(/\$\{\w+\}/g, function(n) {
    var r = n.slice(2, -1);
    return t[r];
  });
}
var $D = "CODE_LOGIC_ERROR";
function gT(e, t, n, r, i) {
  return vT.apply(this, arguments);
}
function vT() {
  return vT = hv(/* @__PURE__ */ qs().mark(function e(t, n, r, i, o) {
    var a, s, l, c, f, d, p, g, v;
    return qs().wrap(function(x) {
      for (; ; )
        switch (x.prev = x.next) {
          case 0:
            return a = ye({}, r), delete a.ruleIndex, ED.warning = function() {
            }, a.validator && (s = a.validator, a.validator = function() {
              try {
                return s.apply(void 0, arguments);
              } catch (b) {
                return console.error(b), Promise.reject($D);
              }
            }), l = null, a && a.type === "array" && a.defaultField && (l = a.defaultField, delete a.defaultField), c = new ED(ce({}, t, [a])), f = Lm(AW, i.validateMessages), c.messages(f), d = [], x.prev = 10, x.next = 13, Promise.resolve(c.validate(ce({}, t, n), ye({}, i)));
          case 13:
            x.next = 18;
            break;
          case 15:
            x.prev = 15, x.t0 = x.catch(10), x.t0.errors && (d = x.t0.errors.map(function(b, w) {
              var S = b.message, E = S === $D ? f.default : S;
              return /* @__PURE__ */ m.isValidElement(E) ? (
                // Wrap ReactNode with `key`
                m.cloneElement(E, {
                  key: "error_".concat(w)
                })
              ) : E;
            }));
          case 18:
            if (!(!d.length && l)) {
              x.next = 23;
              break;
            }
            return x.next = 21, Promise.all(n.map(function(b, w) {
              return gT("".concat(t, ".").concat(w), b, l, i, o);
            }));
          case 21:
            return p = x.sent, x.abrupt("return", p.reduce(function(b, w) {
              return [].concat(Rt(b), Rt(w));
            }, []));
          case 23:
            return g = ye(ye({}, r), {}, {
              name: t,
              enum: (r.enum || []).join(", ")
            }, o), v = d.map(function(b) {
              return typeof b == "string" ? Oye(b, g) : b;
            }), x.abrupt("return", v);
          case 26:
          case "end":
            return x.stop();
        }
    }, e, null, [[10, 15]]);
  })), vT.apply(this, arguments);
}
function Pye(e, t, n, r, i, o) {
  var a = e.join("."), s = n.map(function(f, d) {
    var p = f.validator, g = ye(ye({}, f), {}, {
      ruleIndex: d
    });
    return p && (g.validator = function(v, y, x) {
      var b = !1, w = function() {
        for (var O = arguments.length, $ = new Array(O), P = 0; P < O; P++)
          $[P] = arguments[P];
        Promise.resolve().then(function() {
          Za(!b, "Your validator function has already return a promise. `callback` will be ignored."), b || x.apply(void 0, $);
        });
      }, S = p(v, y, w);
      b = S && typeof S.then == "function" && typeof S.catch == "function", Za(b, "`callback` is deprecated. Please return a promise instead."), b && S.then(function() {
        x();
      }).catch(function(E) {
        x(E || " ");
      });
    }), g;
  }).sort(function(f, d) {
    var p = f.warningOnly, g = f.ruleIndex, v = d.warningOnly, y = d.ruleIndex;
    return !!p == !!v ? g - y : p ? 1 : -1;
  }), l;
  if (i === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var f = hv(/* @__PURE__ */ qs().mark(function d(p, g) {
        var v, y, x;
        return qs().wrap(function(w) {
          for (; ; )
            switch (w.prev = w.next) {
              case 0:
                v = 0;
              case 1:
                if (!(v < s.length)) {
                  w.next = 12;
                  break;
                }
                return y = s[v], w.next = 5, gT(a, t, y, r, o);
              case 5:
                if (x = w.sent, !x.length) {
                  w.next = 9;
                  break;
                }
                return g([{
                  errors: x,
                  rule: y
                }]), w.abrupt("return");
              case 9:
                v += 1, w.next = 1;
                break;
              case 12:
                p([]);
              case 13:
              case "end":
                return w.stop();
            }
        }, d);
      }));
      return function(d, p) {
        return f.apply(this, arguments);
      };
    }());
  else {
    var c = s.map(function(f) {
      return gT(a, t, f, r, o).then(function(d) {
        return {
          errors: d,
          rule: f
        };
      });
    });
    l = (i ? Iye(c) : Tye(c)).then(function(f) {
      return Promise.reject(f);
    });
  }
  return l.catch(function(f) {
    return f;
  }), l;
}
function Tye(e) {
  return yT.apply(this, arguments);
}
function yT() {
  return yT = hv(/* @__PURE__ */ qs().mark(function e(t) {
    return qs().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(t).then(function(i) {
              var o, a = (o = []).concat.apply(o, Rt(i));
              return a;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), yT.apply(this, arguments);
}
function Iye(e) {
  return bT.apply(this, arguments);
}
function bT() {
  return bT = hv(/* @__PURE__ */ qs().mark(function e(t) {
    var n;
    return qs().wrap(function(i) {
      for (; ; )
        switch (i.prev = i.next) {
          case 0:
            return n = 0, i.abrupt("return", new Promise(function(o) {
              t.forEach(function(a) {
                a.then(function(s) {
                  s.errors.length && o([s]), n += 1, n === t.length && o([]);
                });
              });
            }));
          case 2:
          case "end":
            return i.stop();
        }
    }, e);
  })), bT.apply(this, arguments);
}
function Kr(e) {
  return uT(e);
}
function _D(e, t) {
  var n = {};
  return t.forEach(function(r) {
    var i = xl(e, r);
    n = ks(n, r, i);
  }), n;
}
function Cp(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(r) {
    return MW(t, r, n);
  });
}
function MW(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !n && e.length !== t.length ? !1 : t.every(function(r, i) {
    return e[i] === r;
  });
}
function Aye(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || nn(e) !== "object" || nn(t) !== "object")
    return !1;
  var n = Object.keys(e), r = Object.keys(t), i = new Set([].concat(n, r));
  return Rt(i).every(function(o) {
    var a = e[o], s = t[o];
    return typeof a == "function" && typeof s == "function" ? !0 : a === s;
  });
}
function Rye(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && nn(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function OD(e, t, n) {
  var r = e.length;
  if (t < 0 || t >= r || n < 0 || n >= r)
    return e;
  var i = e[t], o = t - n;
  return o > 0 ? [].concat(Rt(e.slice(0, n)), [i], Rt(e.slice(n, t)), Rt(e.slice(t + 1, r))) : o < 0 ? [].concat(Rt(e.slice(0, t)), Rt(e.slice(t + 1, n + 1)), [i], Rt(e.slice(n + 1, r))) : e;
}
var Mye = ["name"], Ua = [];
function PD(e, t, n, r, i, o) {
  return typeof e == "function" ? e(t, n, "source" in o ? {
    source: o.source
  } : {}) : r !== i;
}
var n2 = /* @__PURE__ */ function(e) {
  cv(n, e);
  var t = uv(n);
  function n(r) {
    var i;
    if (Js(this, n), i = t.call(this, r), ce(Cn(i), "state", {
      resetCount: 0
    }), ce(Cn(i), "cancelRegisterFunc", null), ce(Cn(i), "mounted", !1), ce(Cn(i), "touched", !1), ce(Cn(i), "dirty", !1), ce(Cn(i), "validatePromise", void 0), ce(Cn(i), "prevValidating", void 0), ce(Cn(i), "errors", Ua), ce(Cn(i), "warnings", Ua), ce(Cn(i), "cancelRegister", function() {
      var l = i.props, c = l.preserve, f = l.isListField, d = l.name;
      i.cancelRegisterFunc && i.cancelRegisterFunc(f, c, Kr(d)), i.cancelRegisterFunc = null;
    }), ce(Cn(i), "getNamePath", function() {
      var l = i.props, c = l.name, f = l.fieldContext, d = f.prefixName, p = d === void 0 ? [] : d;
      return c !== void 0 ? [].concat(Rt(p), Rt(c)) : [];
    }), ce(Cn(i), "getRules", function() {
      var l = i.props, c = l.rules, f = c === void 0 ? [] : c, d = l.fieldContext;
      return f.map(function(p) {
        return typeof p == "function" ? p(d) : p;
      });
    }), ce(Cn(i), "refresh", function() {
      i.mounted && i.setState(function(l) {
        var c = l.resetCount;
        return {
          resetCount: c + 1
        };
      });
    }), ce(Cn(i), "metaCache", null), ce(Cn(i), "triggerMetaEvent", function(l) {
      var c = i.props.onMetaChange;
      if (c) {
        var f = ye(ye({}, i.getMeta()), {}, {
          destroy: l
        });
        Vve(i.metaCache, f) || c(f), i.metaCache = f;
      } else
        i.metaCache = null;
    }), ce(Cn(i), "onStoreChange", function(l, c, f) {
      var d = i.props, p = d.shouldUpdate, g = d.dependencies, v = g === void 0 ? [] : g, y = d.onReset, x = f.store, b = i.getNamePath(), w = i.getValue(l), S = i.getValue(x), E = c && Cp(c, b);
      switch (f.type === "valueUpdate" && f.source === "external" && w !== S && (i.touched = !0, i.dirty = !0, i.validatePromise = null, i.errors = Ua, i.warnings = Ua, i.triggerMetaEvent()), f.type) {
        case "reset":
          if (!c || E) {
            i.touched = !1, i.dirty = !1, i.validatePromise = void 0, i.errors = Ua, i.warnings = Ua, i.triggerMetaEvent(), y == null || y(), i.refresh();
            return;
          }
          break;
        case "remove": {
          if (p) {
            i.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var O = f.data;
          if (E) {
            "touched" in O && (i.touched = O.touched), "validating" in O && !("originRCField" in O) && (i.validatePromise = O.validating ? Promise.resolve([]) : null), "errors" in O && (i.errors = O.errors || Ua), "warnings" in O && (i.warnings = O.warnings || Ua), i.dirty = !0, i.triggerMetaEvent(), i.reRender();
            return;
          } else if ("value" in O && Cp(c, b, !0)) {
            i.reRender();
            return;
          }
          if (p && !b.length && PD(p, l, x, w, S, f)) {
            i.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var $ = v.map(Kr);
          if ($.some(function(P) {
            return Cp(f.relatedFields, P);
          })) {
            i.reRender();
            return;
          }
          break;
        }
        default:
          if (E || (!v.length || b.length || p) && PD(p, l, x, w, S, f)) {
            i.reRender();
            return;
          }
          break;
      }
      p === !0 && i.reRender();
    }), ce(Cn(i), "validateRules", function(l) {
      var c = i.getNamePath(), f = i.getValue(), d = l || {}, p = d.triggerName, g = d.validateOnly, v = g === void 0 ? !1 : g, y = Promise.resolve().then(/* @__PURE__ */ hv(/* @__PURE__ */ qs().mark(function x() {
        var b, w, S, E, O, $, P;
        return qs().wrap(function(L) {
          for (; ; )
            switch (L.prev = L.next) {
              case 0:
                if (i.mounted) {
                  L.next = 2;
                  break;
                }
                return L.abrupt("return", []);
              case 2:
                if (b = i.props, w = b.validateFirst, S = w === void 0 ? !1 : w, E = b.messageVariables, O = b.validateDebounce, $ = i.getRules(), p && ($ = $.filter(function(B) {
                  return B;
                }).filter(function(B) {
                  var j = B.validateTrigger;
                  if (!j)
                    return !0;
                  var A = uT(j);
                  return A.includes(p);
                })), !(O && p)) {
                  L.next = 10;
                  break;
                }
                return L.next = 8, new Promise(function(B) {
                  setTimeout(B, O);
                });
              case 8:
                if (i.validatePromise === y) {
                  L.next = 10;
                  break;
                }
                return L.abrupt("return", []);
              case 10:
                return P = Pye(c, f, $, l, S, E), P.catch(function(B) {
                  return B;
                }).then(function() {
                  var B = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ua;
                  if (i.validatePromise === y) {
                    var j;
                    i.validatePromise = null;
                    var A = [], T = [];
                    (j = B.forEach) === null || j === void 0 || j.call(B, function(k) {
                      var F = k.rule.warningOnly, W = k.errors, V = W === void 0 ? Ua : W;
                      F ? T.push.apply(T, Rt(V)) : A.push.apply(A, Rt(V));
                    }), i.errors = A, i.warnings = T, i.triggerMetaEvent(), i.reRender();
                  }
                }), L.abrupt("return", P);
              case 13:
              case "end":
                return L.stop();
            }
        }, x);
      })));
      return v || (i.validatePromise = y, i.dirty = !0, i.errors = Ua, i.warnings = Ua, i.triggerMetaEvent(), i.reRender()), y;
    }), ce(Cn(i), "isFieldValidating", function() {
      return !!i.validatePromise;
    }), ce(Cn(i), "isFieldTouched", function() {
      return i.touched;
    }), ce(Cn(i), "isFieldDirty", function() {
      if (i.dirty || i.props.initialValue !== void 0)
        return !0;
      var l = i.props.fieldContext, c = l.getInternalHooks(wf), f = c.getInitialValue;
      return f(i.getNamePath()) !== void 0;
    }), ce(Cn(i), "getErrors", function() {
      return i.errors;
    }), ce(Cn(i), "getWarnings", function() {
      return i.warnings;
    }), ce(Cn(i), "isListField", function() {
      return i.props.isListField;
    }), ce(Cn(i), "isList", function() {
      return i.props.isList;
    }), ce(Cn(i), "isPreserve", function() {
      return i.props.preserve;
    }), ce(Cn(i), "getMeta", function() {
      i.prevValidating = i.isFieldValidating();
      var l = {
        touched: i.isFieldTouched(),
        validating: i.prevValidating,
        errors: i.errors,
        warnings: i.warnings,
        name: i.getNamePath(),
        validated: i.validatePromise === null
      };
      return l;
    }), ce(Cn(i), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var c = i.getMeta();
        return ye(ye({}, i.getOnlyChild(l(i.getControlled(), c, i.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var f = lT(l);
      return f.length !== 1 || !/* @__PURE__ */ m.isValidElement(f[0]) ? {
        child: f,
        isFunction: !1
      } : {
        child: f[0],
        isFunction: !1
      };
    }), ce(Cn(i), "getValue", function(l) {
      var c = i.props.fieldContext.getFieldsValue, f = i.getNamePath();
      return xl(l || c(!0), f);
    }), ce(Cn(i), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = i.props, f = c.trigger, d = c.validateTrigger, p = c.getValueFromEvent, g = c.normalize, v = c.valuePropName, y = c.getValueProps, x = c.fieldContext, b = d !== void 0 ? d : x.validateTrigger, w = i.getNamePath(), S = x.getInternalHooks, E = x.getFieldsValue, O = S(wf), $ = O.dispatch, P = i.getValue(), R = y || function(T) {
        return ce({}, v, T);
      }, L = l[f], B = R(P), j = ye(ye({}, l), B);
      j[f] = function() {
        i.touched = !0, i.dirty = !0, i.triggerMetaEvent();
        for (var T, k = arguments.length, F = new Array(k), W = 0; W < k; W++)
          F[W] = arguments[W];
        p ? T = p.apply(void 0, F) : T = Rye.apply(void 0, [v].concat(F)), g && (T = g(T, P, E(!0))), $({
          type: "updateValue",
          namePath: w,
          value: T
        }), L && L.apply(void 0, F);
      };
      var A = uT(b || []);
      return A.forEach(function(T) {
        var k = j[T];
        j[T] = function() {
          k && k.apply(void 0, arguments);
          var F = i.props.rules;
          F && F.length && $({
            type: "validateField",
            namePath: w,
            triggerName: T
          });
        };
      }), j;
    }), r.fieldContext) {
      var o = r.fieldContext.getInternalHooks, a = o(wf), s = a.initEntityValue;
      s(Cn(i));
    }
    return i;
  }
  return Zs(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.shouldUpdate, a = i.fieldContext;
      if (this.mounted = !0, a) {
        var s = a.getInternalHooks, l = s(wf), c = l.registerField;
        this.cancelRegisterFunc = c(this);
      }
      o === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var i = this.state.resetCount, o = this.props.children, a = this.getOnlyChild(o), s = a.child, l = a.isFunction, c;
      return l ? c = s : /* @__PURE__ */ m.isValidElement(s) ? c = /* @__PURE__ */ m.cloneElement(s, this.getControlled(s.props)) : (Za(!s, "`children` of Field is not validate ReactElement."), c = s), /* @__PURE__ */ m.createElement(m.Fragment, {
        key: i
      }, c);
    }
  }]), n;
}(m.Component);
ce(n2, "contextType", Yp);
ce(n2, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function NW(e) {
  var t = e.name, n = _n(e, Mye), r = m.useContext(Yp), i = m.useContext(M1), o = t !== void 0 ? Kr(t) : void 0, a = "keep";
  return n.isListField || (a = "_".concat((o || []).join("_"))), /* @__PURE__ */ m.createElement(n2, jt({
    key: a,
    name: o,
    isListField: !!i
  }, n, {
    fieldContext: r
  }));
}
function Nye(e) {
  var t = e.name, n = e.initialValue, r = e.children, i = e.rules, o = e.validateTrigger, a = e.isListField, s = m.useContext(Yp), l = m.useContext(M1), c = m.useRef({
    keys: [],
    id: 0
  }), f = c.current, d = m.useMemo(function() {
    var y = Kr(s.prefixName) || [];
    return [].concat(Rt(y), Rt(Kr(t)));
  }, [s.prefixName, t]), p = m.useMemo(function() {
    return ye(ye({}, s), {}, {
      prefixName: d
    });
  }, [s, d]), g = m.useMemo(function() {
    return {
      getKey: function(x) {
        var b = d.length, w = x[b];
        return [f.keys[w], x.slice(b + 1)];
      }
    };
  }, [d]);
  if (typeof r != "function")
    return Za(!1, "Form.List only accepts function as children."), null;
  var v = function(x, b, w) {
    var S = w.source;
    return S === "internal" ? !1 : x !== b;
  };
  return /* @__PURE__ */ m.createElement(M1.Provider, {
    value: g
  }, /* @__PURE__ */ m.createElement(Yp.Provider, {
    value: p
  }, /* @__PURE__ */ m.createElement(NW, {
    name: [],
    shouldUpdate: v,
    rules: i,
    validateTrigger: o,
    initialValue: n,
    isList: !0,
    isListField: a ?? !!l
  }, function(y, x) {
    var b = y.value, w = b === void 0 ? [] : b, S = y.onChange, E = s.getFieldValue, O = function() {
      var L = E(d || []);
      return L || [];
    }, $ = {
      add: function(L, B) {
        var j = O();
        B >= 0 && B <= j.length ? (f.keys = [].concat(Rt(f.keys.slice(0, B)), [f.id], Rt(f.keys.slice(B))), S([].concat(Rt(j.slice(0, B)), [L], Rt(j.slice(B))))) : (f.keys = [].concat(Rt(f.keys), [f.id]), S([].concat(Rt(j), [L]))), f.id += 1;
      },
      remove: function(L) {
        var B = O(), j = new Set(Array.isArray(L) ? L : [L]);
        j.size <= 0 || (f.keys = f.keys.filter(function(A, T) {
          return !j.has(T);
        }), S(B.filter(function(A, T) {
          return !j.has(T);
        })));
      },
      move: function(L, B) {
        if (L !== B) {
          var j = O();
          L < 0 || L >= j.length || B < 0 || B >= j.length || (f.keys = OD(f.keys, L, B), S(OD(j, L, B)));
        }
      }
    }, P = w || [];
    return Array.isArray(P) || (P = []), r(P.map(function(R, L) {
      var B = f.keys[L];
      return B === void 0 && (f.keys[L] = f.id, B = f.keys[L], f.id += 1), {
        name: L,
        key: B,
        isListField: !0
      };
    }), $, x);
  })));
}
function kye(e) {
  var t = !1, n = e.length, r = [];
  return e.length ? new Promise(function(i, o) {
    e.forEach(function(a, s) {
      a.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        n -= 1, r[s] = l, !(n > 0) && (t && o(r), i(r));
      });
    });
  }) : Promise.resolve([]);
}
var kW = "__@field_split__";
function V$(e) {
  return e.map(function(t) {
    return "".concat(nn(t), ":").concat(t);
  }).join(kW);
}
var Ed = /* @__PURE__ */ function() {
  function e() {
    Js(this, e), ce(this, "kvs", /* @__PURE__ */ new Map());
  }
  return Zs(e, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(V$(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(V$(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var i = this.get(n), o = r(i);
      o ? this.set(n, o) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(V$(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return Rt(this.kvs.entries()).map(function(r) {
        var i = ke(r, 2), o = i[0], a = i[1], s = o.split(kW);
        return n({
          key: s.map(function(l) {
            var c = l.match(/^([^:]*):(.*)$/), f = ke(c, 3), d = f[1], p = f[2];
            return d === "number" ? Number(p) : p;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var i = r.key, o = r.value;
        return n[i.join(".")] = o, null;
      }), n;
    }
  }]), e;
}(), Lye = ["name"], Dye = /* @__PURE__ */ Zs(function e(t) {
  var n = this;
  Js(this, e), ce(this, "formHooked", !1), ce(this, "forceRootUpdate", void 0), ce(this, "subscribable", !0), ce(this, "store", {}), ce(this, "fieldEntities", []), ce(this, "initialValues", {}), ce(this, "callbacks", {}), ce(this, "validateMessages", null), ce(this, "preserve", null), ce(this, "lastValidatePromise", null), ce(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), ce(this, "getInternalHooks", function(r) {
    return r === wf ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (Za(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), ce(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), ce(this, "prevWithoutPreserves", null), ce(this, "setInitialValues", function(r, i) {
    if (n.initialValues = r || {}, i) {
      var o, a = Lm(r, n.store);
      (o = n.prevWithoutPreserves) === null || o === void 0 || o.map(function(s) {
        var l = s.key;
        a = ks(a, l, xl(r, l));
      }), n.prevWithoutPreserves = null, n.updateStore(a);
    }
  }), ce(this, "destroyForm", function() {
    var r = new Ed();
    n.getFieldEntities(!0).forEach(function(i) {
      n.isMergedPreserve(i.isPreserve()) || r.set(i.getNamePath(), !0);
    }), n.prevWithoutPreserves = r;
  }), ce(this, "getInitialValue", function(r) {
    var i = xl(n.initialValues, r);
    return r.length ? Lm(i) : i;
  }), ce(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), ce(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), ce(this, "setPreserve", function(r) {
    n.preserve = r;
  }), ce(this, "watchList", []), ce(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(i) {
        return i !== r;
      });
    };
  }), ce(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var i = n.getFieldsValue(), o = n.getFieldsValue(!0);
      n.watchList.forEach(function(a) {
        a(i, o, r);
      });
    }
  }), ce(this, "timeoutId", null), ce(this, "warningUnhooked", function() {
  }), ce(this, "updateStore", function(r) {
    n.store = r;
  }), ce(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(i) {
      return i.getNamePath().length;
    }) : n.fieldEntities;
  }), ce(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, i = new Ed();
    return n.getFieldEntities(r).forEach(function(o) {
      var a = o.getNamePath();
      i.set(a, o);
    }), i;
  }), ce(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var i = n.getFieldsMap(!0);
    return r.map(function(o) {
      var a = Kr(o);
      return i.get(a) || {
        INVALIDATE_NAME_PATH: Kr(o)
      };
    });
  }), ce(this, "getFieldsValue", function(r, i) {
    n.warningUnhooked();
    var o, a, s;
    if (r === !0 || Array.isArray(r) ? (o = r, a = i) : r && nn(r) === "object" && (s = r.strict, a = r.filter), o === !0 && !a)
      return n.store;
    var l = n.getFieldEntitiesForNamePathList(Array.isArray(o) ? o : null), c = [];
    return l.forEach(function(f) {
      var d, p, g = "INVALIDATE_NAME_PATH" in f ? f.INVALIDATE_NAME_PATH : f.getNamePath();
      if (s) {
        var v, y;
        if ((v = (y = f).isList) !== null && v !== void 0 && v.call(y))
          return;
      } else if (!o && (d = (p = f).isListField) !== null && d !== void 0 && d.call(p))
        return;
      if (!a)
        c.push(g);
      else {
        var x = "getMeta" in f ? f.getMeta() : null;
        a(x) && c.push(g);
      }
    }), _D(n.store, c.map(Kr));
  }), ce(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var i = Kr(r);
    return xl(n.store, i);
  }), ce(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntitiesForNamePathList(r);
    return i.map(function(o, a) {
      return o && !("INVALIDATE_NAME_PATH" in o) ? {
        name: o.getNamePath(),
        errors: o.getErrors(),
        warnings: o.getWarnings()
      } : {
        name: Kr(r[a]),
        errors: [],
        warnings: []
      };
    });
  }), ce(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var i = Kr(r), o = n.getFieldsError([i])[0];
    return o.errors;
  }), ce(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var i = Kr(r), o = n.getFieldsError([i])[0];
    return o.warnings;
  }), ce(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i[0], s = i[1], l, c = !1;
    i.length === 0 ? l = null : i.length === 1 ? Array.isArray(a) ? (l = a.map(Kr), c = !1) : (l = null, c = a) : (l = a.map(Kr), c = s);
    var f = n.getFieldEntities(!0), d = function(x) {
      return x.isFieldTouched();
    };
    if (!l)
      return c ? f.every(function(y) {
        return d(y) || y.isList();
      }) : f.some(d);
    var p = new Ed();
    l.forEach(function(y) {
      p.set(y, []);
    }), f.forEach(function(y) {
      var x = y.getNamePath();
      l.forEach(function(b) {
        b.every(function(w, S) {
          return x[S] === w;
        }) && p.update(b, function(w) {
          return [].concat(Rt(w), [y]);
        });
      });
    });
    var g = function(x) {
      return x.some(d);
    }, v = p.map(function(y) {
      var x = y.value;
      return x;
    });
    return c ? v.every(g) : v.some(g);
  }), ce(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), ce(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntities();
    if (!r)
      return i.some(function(a) {
        return a.isFieldValidating();
      });
    var o = r.map(Kr);
    return i.some(function(a) {
      var s = a.getNamePath();
      return Cp(o, s) && a.isFieldValidating();
    });
  }), ce(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), ce(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = new Ed(), o = n.getFieldEntities(!0);
    o.forEach(function(l) {
      var c = l.props.initialValue, f = l.getNamePath();
      if (c !== void 0) {
        var d = i.get(f) || /* @__PURE__ */ new Set();
        d.add({
          entity: l,
          value: c
        }), i.set(f, d);
      }
    });
    var a = function(c) {
      c.forEach(function(f) {
        var d = f.props.initialValue;
        if (d !== void 0) {
          var p = f.getNamePath(), g = n.getInitialValue(p);
          if (g !== void 0)
            Za(!1, "Form already set 'initialValues' with path '".concat(p.join("."), "'. Field can not overwrite it."));
          else {
            var v = i.get(p);
            if (v && v.size > 1)
              Za(!1, "Multiple Field with path '".concat(p.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (v) {
              var y = n.getFieldValue(p), x = f.isListField();
              !x && (!r.skipExist || y === void 0) && n.updateStore(ks(n.store, p, Rt(v)[0].value));
            }
          }
        }
      });
    }, s;
    r.entities ? s = r.entities : r.namePathList ? (s = [], r.namePathList.forEach(function(l) {
      var c = i.get(l);
      if (c) {
        var f;
        (f = s).push.apply(f, Rt(Rt(c).map(function(d) {
          return d.entity;
        })));
      }
    })) : s = o, a(s);
  }), ce(this, "resetFields", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (!r) {
      n.updateStore(Lm(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(i, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var o = r.map(Kr);
    o.forEach(function(a) {
      var s = n.getInitialValue(a);
      n.updateStore(ks(n.store, a, s));
    }), n.resetWithFieldInitialValue({
      namePathList: o
    }), n.notifyObservers(i, o, {
      type: "reset"
    }), n.notifyWatch(o);
  }), ce(this, "setFields", function(r) {
    n.warningUnhooked();
    var i = n.store, o = [];
    r.forEach(function(a) {
      var s = a.name, l = _n(a, Lye), c = Kr(s);
      o.push(c), "value" in l && n.updateStore(ks(n.store, c, l.value)), n.notifyObservers(i, [c], {
        type: "setField",
        data: a
      });
    }), n.notifyWatch(o);
  }), ce(this, "getFields", function() {
    var r = n.getFieldEntities(!0), i = r.map(function(o) {
      var a = o.getNamePath(), s = o.getMeta(), l = ye(ye({}, s), {}, {
        name: a,
        value: n.getFieldValue(a)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return i;
  }), ce(this, "initEntityValue", function(r) {
    var i = r.props.initialValue;
    if (i !== void 0) {
      var o = r.getNamePath(), a = xl(n.store, o);
      a === void 0 && n.updateStore(ks(n.store, o, i));
    }
  }), ce(this, "isMergedPreserve", function(r) {
    var i = r !== void 0 ? r : n.preserve;
    return i ?? !0;
  }), ce(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var i = r.getNamePath();
    if (n.notifyWatch([i]), r.props.initialValue !== void 0) {
      var o = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(o, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, s) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(d) {
        return d !== r;
      }), !n.isMergedPreserve(s) && (!a || l.length > 1)) {
        var c = a ? void 0 : n.getInitialValue(i);
        if (i.length && n.getFieldValue(i) !== c && n.fieldEntities.every(function(d) {
          return (
            // Only reset when no namePath exist
            !MW(d.getNamePath(), i)
          );
        })) {
          var f = n.store;
          n.updateStore(ks(f, i, c, !0)), n.notifyObservers(f, [i], {
            type: "remove"
          }), n.triggerDependenciesUpdate(f, i);
        }
      }
      n.notifyWatch([i]);
    };
  }), ce(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var i = r.namePath, o = r.value;
        n.updateValue(i, o);
        break;
      }
      case "validateField": {
        var a = r.namePath, s = r.triggerName;
        n.validateFields([a], {
          triggerName: s
        });
        break;
      }
    }
  }), ce(this, "notifyObservers", function(r, i, o) {
    if (n.subscribable) {
      var a = ye(ye({}, o), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(s) {
        var l = s.onStoreChange;
        l(r, i, a);
      });
    } else
      n.forceRootUpdate();
  }), ce(this, "triggerDependenciesUpdate", function(r, i) {
    var o = n.getDependencyChildrenFields(i);
    return o.length && n.validateFields(o), n.notifyObservers(r, o, {
      type: "dependenciesUpdate",
      relatedFields: [i].concat(Rt(o))
    }), o;
  }), ce(this, "updateValue", function(r, i) {
    var o = Kr(r), a = n.store;
    n.updateStore(ks(n.store, o, i)), n.notifyObservers(a, [o], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([o]);
    var s = n.triggerDependenciesUpdate(a, o), l = n.callbacks.onValuesChange;
    if (l) {
      var c = _D(n.store, [o]);
      l(c, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([o].concat(Rt(s)));
  }), ce(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (r) {
      var o = Lm(n.store, r);
      n.updateStore(o);
    }
    n.notifyObservers(i, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), ce(this, "setFieldValue", function(r, i) {
    n.setFields([{
      name: r,
      value: i
    }]);
  }), ce(this, "getDependencyChildrenFields", function(r) {
    var i = /* @__PURE__ */ new Set(), o = [], a = new Ed();
    n.getFieldEntities().forEach(function(l) {
      var c = l.props.dependencies;
      (c || []).forEach(function(f) {
        var d = Kr(f);
        a.update(d, function() {
          var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return p.add(l), p;
        });
      });
    });
    var s = function l(c) {
      var f = a.get(c) || /* @__PURE__ */ new Set();
      f.forEach(function(d) {
        if (!i.has(d)) {
          i.add(d);
          var p = d.getNamePath();
          d.isFieldDirty() && p.length && (o.push(p), l(p));
        }
      });
    };
    return s(r), o;
  }), ce(this, "triggerOnFieldsChange", function(r, i) {
    var o = n.callbacks.onFieldsChange;
    if (o) {
      var a = n.getFields();
      if (i) {
        var s = new Ed();
        i.forEach(function(c) {
          var f = c.name, d = c.errors;
          s.set(f, d);
        }), a.forEach(function(c) {
          c.errors = s.get(c.name) || c.errors;
        });
      }
      var l = a.filter(function(c) {
        var f = c.name;
        return Cp(r, f);
      });
      l.length && o(l, a);
    }
  }), ce(this, "validateFields", function(r, i) {
    n.warningUnhooked();
    var o, a;
    Array.isArray(r) || typeof r == "string" || typeof i == "string" ? (o = r, a = i) : a = r;
    var s = !!o, l = s ? o.map(Kr) : [], c = [], f = String(Date.now()), d = /* @__PURE__ */ new Set(), p = a || {}, g = p.recursive, v = p.dirty;
    n.getFieldEntities(!0).forEach(function(w) {
      if (s || l.push(w.getNamePath()), !(!w.props.rules || !w.props.rules.length) && !(v && !w.isFieldDirty())) {
        var S = w.getNamePath();
        if (d.add(S.join(f)), !s || Cp(l, S, g)) {
          var E = w.validateRules(ye({
            validateMessages: ye(ye({}, AW), n.validateMessages)
          }, a));
          c.push(E.then(function() {
            return {
              name: S,
              errors: [],
              warnings: []
            };
          }).catch(function(O) {
            var $, P = [], R = [];
            return ($ = O.forEach) === null || $ === void 0 || $.call(O, function(L) {
              var B = L.rule.warningOnly, j = L.errors;
              B ? R.push.apply(R, Rt(j)) : P.push.apply(P, Rt(j));
            }), P.length ? Promise.reject({
              name: S,
              errors: P,
              warnings: R
            }) : {
              name: S,
              errors: P,
              warnings: R
            };
          }));
        }
      }
    });
    var y = kye(c);
    n.lastValidatePromise = y, y.catch(function(w) {
      return w;
    }).then(function(w) {
      var S = w.map(function(E) {
        var O = E.name;
        return O;
      });
      n.notifyObservers(n.store, S, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(S, w);
    });
    var x = y.then(function() {
      return n.lastValidatePromise === y ? Promise.resolve(n.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(w) {
      var S = w.filter(function(E) {
        return E && E.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(l),
        errorFields: S,
        outOfDate: n.lastValidatePromise !== y
      });
    });
    x.catch(function(w) {
      return w;
    });
    var b = l.filter(function(w) {
      return d.has(w.join(f));
    });
    return n.triggerOnFieldsChange(b), x;
  }), ce(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var i = n.callbacks.onFinish;
      if (i)
        try {
          i(r);
        } catch (o) {
          console.error(o);
        }
    }).catch(function(r) {
      var i = n.callbacks.onFinishFailed;
      i && i(r);
    });
  }), this.forceRootUpdate = t;
});
function LW(e) {
  var t = m.useRef(), n = m.useState({}), r = ke(n, 2), i = r[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var o = function() {
        i({});
      }, a = new Dye(o);
      t.current = a.getForm();
    }
  return [t.current];
}
var wT = /* @__PURE__ */ m.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), jye = function(t) {
  var n = t.validateMessages, r = t.onFormChange, i = t.onFormFinish, o = t.children, a = m.useContext(wT), s = m.useRef({});
  return /* @__PURE__ */ m.createElement(wT.Provider, {
    value: ye(ye({}, a), {}, {
      validateMessages: ye(ye({}, a.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(c, f) {
        r && r(c, {
          changedFields: f,
          forms: s.current
        }), a.triggerFormChange(c, f);
      },
      triggerFormFinish: function(c, f) {
        i && i(c, {
          values: f,
          forms: s.current
        }), a.triggerFormFinish(c, f);
      },
      registerForm: function(c, f) {
        c && (s.current = ye(ye({}, s.current), {}, ce({}, c, f))), a.registerForm(c, f);
      },
      unregisterForm: function(c) {
        var f = ye({}, s.current);
        delete f[c], s.current = f, a.unregisterForm(c);
      }
    })
  }, o);
}, Fye = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"], Bye = function(t, n) {
  var r = t.name, i = t.initialValues, o = t.fields, a = t.form, s = t.preserve, l = t.children, c = t.component, f = c === void 0 ? "form" : c, d = t.validateMessages, p = t.validateTrigger, g = p === void 0 ? "onChange" : p, v = t.onValuesChange, y = t.onFieldsChange, x = t.onFinish, b = t.onFinishFailed, w = _n(t, Fye), S = m.useContext(wT), E = LW(a), O = ke(E, 1), $ = O[0], P = $.getInternalHooks(wf), R = P.useSubscribe, L = P.setInitialValues, B = P.setCallbacks, j = P.setValidateMessages, A = P.setPreserve, T = P.destroyForm;
  m.useImperativeHandle(n, function() {
    return $;
  }), m.useEffect(function() {
    return S.registerForm(r, $), function() {
      S.unregisterForm(r);
    };
  }, [S, $, r]), j(ye(ye({}, S.validateMessages), d)), B({
    onValuesChange: v,
    onFieldsChange: function(ee) {
      if (S.triggerFormChange(r, ee), y) {
        for (var U = arguments.length, he = new Array(U > 1 ? U - 1 : 0), re = 1; re < U; re++)
          he[re - 1] = arguments[re];
        y.apply(void 0, [ee].concat(he));
      }
    },
    onFinish: function(ee) {
      S.triggerFormFinish(r, ee), x && x(ee);
    },
    onFinishFailed: b
  }), A(s);
  var k = m.useRef(null);
  L(i, !k.current), k.current || (k.current = !0), m.useEffect(
    function() {
      return T;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var F, W = typeof l == "function";
  if (W) {
    var V = $.getFieldsValue(!0);
    F = l(V, $);
  } else
    F = l;
  R(!W);
  var G = m.useRef();
  m.useEffect(function() {
    Aye(G.current || [], o || []) || $.setFields(o || []), G.current = o;
  }, [o, $]);
  var X = m.useMemo(function() {
    return ye(ye({}, $), {}, {
      validateTrigger: g
    });
  }, [$, g]), D = /* @__PURE__ */ m.createElement(M1.Provider, {
    value: null
  }, /* @__PURE__ */ m.createElement(Yp.Provider, {
    value: X
  }, F));
  return f === !1 ? D : /* @__PURE__ */ m.createElement(f, jt({}, w, {
    onSubmit: function(ee) {
      ee.preventDefault(), ee.stopPropagation(), $.submit();
    },
    onReset: function(ee) {
      var U;
      ee.preventDefault(), $.resetFields(), (U = w.onReset) === null || U === void 0 || U.call(w, ee);
    }
  }), D);
};
function TD(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
function zye() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], i = t[1], o = i === void 0 ? {} : i, a = Gve(o) ? {
    form: o
  } : o, s = a.form, l = m.useState(), c = ke(l, 2), f = c[0], d = c[1], p = m.useMemo(function() {
    return TD(f);
  }, [f]), g = m.useRef(p);
  g.current = p;
  var v = m.useContext(Yp), y = s || v, x = y && y._init, b = Kr(r), w = m.useRef(b);
  return w.current = b, m.useEffect(
    function() {
      if (x) {
        var S = y.getFieldsValue, E = y.getInternalHooks, O = E(wf), $ = O.registerWatch, P = function(j, A) {
          var T = a.preserve ? A : j;
          return typeof r == "function" ? r(T) : xl(T, w.current);
        }, R = $(function(B, j) {
          var A = P(B, j), T = TD(A);
          g.current !== T && (g.current = T, d(A));
        }), L = P(S(), S(!0));
        return f !== L && d(L), R;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [x]
  ), f;
}
var Uye = /* @__PURE__ */ m.forwardRef(Bye), gv = Uye;
gv.FormProvider = jye;
gv.Field = NW;
gv.List = Nye;
gv.useForm = LW;
gv.useWatch = zye;
const Uf = /* @__PURE__ */ m.createContext({}), ST = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const i = m.useContext(Uf), o = m.useMemo(() => {
    const a = Object.assign({}, i);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, i]);
  return /* @__PURE__ */ m.createElement(Uf.Provider, {
    value: o
  }, t);
}, Hye = /* @__PURE__ */ m.createContext(void 0);
function ID() {
}
const Wye = /* @__PURE__ */ m.createContext({
  add: ID,
  remove: ID
});
function Vye(e) {
  const t = m.useContext(Wye), n = m.useRef();
  return $1((i) => {
    if (i) {
      const o = e ? i.querySelector(e) : i;
      t.add(o), n.current = o;
    } else
      t.remove(n.current);
  });
}
const Gye = () => {
  const {
    cancelButtonProps: e,
    cancelTextLocale: t,
    onCancel: n
  } = m.useContext(dv);
  return /* @__PURE__ */ oe.createElement(zi, Object.assign({
    onClick: n
  }, e), t);
}, AD = Gye, Kye = () => {
  const {
    confirmLoading: e,
    okButtonProps: t,
    okType: n,
    okTextLocale: r,
    onOk: i
  } = m.useContext(dv);
  return /* @__PURE__ */ oe.createElement(zi, Object.assign({}, Z9(n), {
    loading: e,
    onClick: i
  }, t), r);
}, RD = Kye;
function DW(e, t) {
  return /* @__PURE__ */ oe.createElement("span", {
    className: `${e}-close-x`
  }, t || /* @__PURE__ */ oe.createElement(lv, {
    className: `${e}-close-icon`
  }));
}
const jW = (e) => {
  const {
    okText: t,
    okType: n = "primary",
    cancelText: r,
    confirmLoading: i,
    onOk: o,
    onCancel: a,
    okButtonProps: s,
    cancelButtonProps: l,
    footer: c
  } = e, [f] = Xw("Modal", xH()), d = t || (f == null ? void 0 : f.okText), p = r || (f == null ? void 0 : f.cancelText), g = {
    confirmLoading: i,
    okButtonProps: s,
    cancelButtonProps: l,
    okTextLocale: d,
    cancelTextLocale: p,
    okType: n,
    onOk: o,
    onCancel: a
  }, v = oe.useMemo(() => g, Qa(Object.values(g)));
  let y;
  return typeof c == "function" || typeof c > "u" ? (y = /* @__PURE__ */ oe.createElement(oe.Fragment, null, /* @__PURE__ */ oe.createElement(AD, null), /* @__PURE__ */ oe.createElement(RD, null)), typeof c == "function" && (y = c(y, {
    OkBtn: RD,
    CancelBtn: AD
  })), y = /* @__PURE__ */ oe.createElement(sW, {
    value: v
  }, y)) : y = c, /* @__PURE__ */ oe.createElement(AH, {
    disabled: !1
  }, y);
}, qye = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), Yye = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), r2 = function(e, t, n, r) {
  const o = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${o}${e}-enter,
      ${o}${e}-appear
    `]: Object.assign(Object.assign({}, qye(r)), {
      animationPlayState: "paused"
    }),
    [`${o}${e}-leave`]: Object.assign(Object.assign({}, Yye(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${o}${e}-enter${e}-enter-active,
      ${o}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${o}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, Xye = new Tn("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), Qye = new Tn("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), Jye = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: n
  } = e, r = `${n}-fade`, i = t ? "&" : "";
  return [r2(r, Xye, Qye, e.motionDurationMid, t), {
    [`
        ${i}${r}-enter,
        ${i}${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${i}${r}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, Zye = new Tn("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), e0e = new Tn("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), t0e = new Tn("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), n0e = new Tn("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), r0e = new Tn("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), i0e = new Tn("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), o0e = new Tn("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), a0e = new Tn("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), s0e = {
  "slide-up": {
    inKeyframes: Zye,
    outKeyframes: e0e
  },
  "slide-down": {
    inKeyframes: t0e,
    outKeyframes: n0e
  },
  "slide-left": {
    inKeyframes: r0e,
    outKeyframes: i0e
  },
  "slide-right": {
    inKeyframes: o0e,
    outKeyframes: a0e
  }
}, MD = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = s0e[t];
  return [r2(r, i, o, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, l0e = new Tn("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), c0e = new Tn("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), ND = new Tn("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), kD = new Tn("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), u0e = new Tn("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), f0e = new Tn("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), d0e = new Tn("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), p0e = new Tn("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), h0e = new Tn("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), m0e = new Tn("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), g0e = new Tn("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), v0e = new Tn("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), y0e = {
  zoom: {
    inKeyframes: l0e,
    outKeyframes: c0e
  },
  "zoom-big": {
    inKeyframes: ND,
    outKeyframes: kD
  },
  "zoom-big-fast": {
    inKeyframes: ND,
    outKeyframes: kD
  },
  "zoom-left": {
    inKeyframes: d0e,
    outKeyframes: p0e
  },
  "zoom-right": {
    inKeyframes: h0e,
    outKeyframes: m0e
  },
  "zoom-up": {
    inKeyframes: u0e,
    outKeyframes: f0e
  },
  "zoom-down": {
    inKeyframes: g0e,
    outKeyframes: v0e
  }
}, i2 = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = y0e[t];
  return [r2(r, i, o, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, b0e = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), w0e = b0e;
function LD(e) {
  return {
    position: e,
    inset: 0
  };
}
const S0e = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return [{
    [`${t}-root`]: {
      [`${t}${n}-zoom-enter, ${t}${n}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: e.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${t}${n}-zoom-leave ${t}-content`]: {
        pointerEvents: "none"
      },
      [`${t}-mask`]: Object.assign(Object.assign({}, LD("fixed")), {
        zIndex: e.zIndexPopupBase,
        height: "100%",
        backgroundColor: e.colorBgMask,
        pointerEvents: "none",
        [`${t}-hidden`]: {
          display: "none"
        }
      }),
      [`${t}-wrap`]: Object.assign(Object.assign({}, LD("fixed")), {
        zIndex: e.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${t}-root`]: Jye(e)
  }];
}, x0e = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    // ======================== Root =========================
    {
      [`${t}-root`]: {
        [`${t}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${t}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [t]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${e.screenSMMax}px)`]: {
          [t]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${ge(e.marginXS)} auto`
          },
          [`${t}-centered`]: {
            [t]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [t]: Object.assign(Object.assign({}, Vi(e)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${ge(e.calc(e.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: e.paddingLG,
        [`${t}-title`]: {
          margin: 0,
          color: e.titleColor,
          fontWeight: e.fontWeightStrong,
          fontSize: e.titleFontSize,
          lineHeight: e.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${t}-content`]: {
          position: "relative",
          backgroundColor: e.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: e.borderRadiusLG,
          boxShadow: e.boxShadow,
          pointerEvents: "auto",
          padding: e.contentPadding
        },
        [`${t}-close`]: Object.assign({
          position: "absolute",
          top: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          zIndex: e.calc(e.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: e.modalCloseIconColor,
          fontWeight: e.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: e.borderRadiusSM,
          width: e.modalCloseBtnSize,
          height: e.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${e.motionDurationMid}, background-color ${e.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: e.fontSizeLG,
            fontStyle: "normal",
            lineHeight: `${ge(e.modalCloseBtnSize)}`,
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:hover": {
            color: e.modalCloseIconHoverColor,
            backgroundColor: e.colorBgTextHover,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: e.colorBgTextActive
          }
        }, Jw(e)),
        [`${t}-header`]: {
          color: e.colorText,
          background: e.headerBg,
          borderRadius: `${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)} 0 0`,
          marginBottom: e.headerMarginBottom,
          padding: e.headerPadding,
          borderBottom: e.headerBorderBottom
        },
        [`${t}-body`]: {
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          wordWrap: "break-word",
          padding: e.bodyPadding
        },
        [`${t}-footer`]: {
          textAlign: "end",
          background: e.footerBg,
          marginTop: e.footerMarginTop,
          padding: e.footerPadding,
          borderTop: e.footerBorderTop,
          borderRadius: e.footerBorderRadius,
          [`> ${e.antCls}-btn + ${e.antCls}-btn`]: {
            marginInlineStart: e.marginXS
          }
        },
        [`${t}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${t}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${t}-content,
          ${t}-body,
          ${t}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${t}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, C0e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-root`]: {
      [`${t}-wrap-rtl`]: {
        direction: "rtl",
        [`${t}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, FW = (e) => {
  const t = e.padding, n = e.fontSizeHeading5, r = e.lineHeightHeading5;
  return _r(e, {
    modalHeaderHeight: e.calc(e.calc(r).mul(n).equal()).add(e.calc(t).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: e.colorSplit,
    modalFooterBorderStyle: e.lineType,
    modalFooterBorderWidth: e.lineWidth,
    modalCloseIconColor: e.colorIcon,
    modalCloseIconHoverColor: e.colorIconHover,
    modalCloseBtnSize: e.controlHeight,
    modalConfirmIconSize: e.fontHeight,
    modalTitleHeight: e.calc(e.titleFontSize).mul(e.titleLineHeight).equal()
  });
}, BW = (e) => ({
  footerBg: "transparent",
  headerBg: e.colorBgElevated,
  titleLineHeight: e.lineHeightHeading5,
  titleFontSize: e.fontSizeHeading5,
  contentBg: e.colorBgElevated,
  titleColor: e.colorTextHeading,
  // internal
  contentPadding: e.wireframe ? 0 : `${ge(e.paddingMD)} ${ge(e.paddingContentHorizontalLG)}`,
  headerPadding: e.wireframe ? `${ge(e.padding)} ${ge(e.paddingLG)}` : 0,
  headerBorderBottom: e.wireframe ? `${ge(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  headerMarginBottom: e.wireframe ? 0 : e.marginXS,
  bodyPadding: e.wireframe ? e.paddingLG : 0,
  footerPadding: e.wireframe ? `${ge(e.paddingXS)} ${ge(e.padding)}` : 0,
  footerBorderTop: e.wireframe ? `${ge(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  footerBorderRadius: e.wireframe ? `0 0 ${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)}` : 0,
  footerMarginTop: e.wireframe ? 0 : e.marginSM,
  confirmBodyPadding: e.wireframe ? `${ge(e.padding * 2)} ${ge(e.padding * 2)} ${ge(e.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: e.wireframe ? e.margin : e.marginSM,
  confirmBtnsMarginTop: e.wireframe ? e.marginLG : e.marginSM
}), zW = Pi("Modal", (e) => {
  const t = FW(e);
  return [x0e(t), C0e(t), S0e(t), i2(t, "zoom")];
}, BW, {
  unitless: {
    titleLineHeight: !0
  }
});
var E0e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
let xT;
const $0e = (e) => {
  xT = {
    x: e.pageX,
    y: e.pageY
  }, setTimeout(() => {
    xT = null;
  }, 100);
};
Fve() && document.documentElement.addEventListener("click", $0e, !0);
const _0e = (e) => {
  var t;
  const {
    getPopupContainer: n,
    getPrefixCls: r,
    direction: i,
    modal: o
  } = m.useContext(Mt), a = (ee) => {
    const {
      onCancel: U
    } = e;
    U == null || U(ee);
  }, s = (ee) => {
    const {
      onOk: U
    } = e;
    U == null || U(ee);
  }, {
    prefixCls: l,
    className: c,
    rootClassName: f,
    open: d,
    wrapClassName: p,
    centered: g,
    getContainer: v,
    closeIcon: y,
    closable: x,
    focusTriggerAfterClose: b = !0,
    style: w,
    // Deprecated
    visible: S,
    width: E = 520,
    footer: O,
    classNames: $,
    styles: P
  } = e, R = E0e(e, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "closeIcon", "closable", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles"]), L = r("modal", l), B = r(), j = xc(L), [A, T, k] = zW(L, j), F = Ue(p, {
    [`${L}-centered`]: !!g,
    [`${L}-wrap-rtl`]: i === "rtl"
  }), W = O !== null && /* @__PURE__ */ m.createElement(jW, Object.assign({}, e, {
    onOk: s,
    onCancel: a
  })), [V, G] = OW({
    closable: x,
    closeIcon: typeof y < "u" ? y : o == null ? void 0 : o.closeIcon,
    customCloseIconRender: (ee) => DW(L, ee),
    defaultCloseIcon: /* @__PURE__ */ m.createElement(lv, {
      className: `${L}-close-icon`
    }),
    defaultClosable: !0
  }), X = Vye(`.${L}-content`), [D, te] = G9("Modal", R.zIndex);
  return A(/* @__PURE__ */ m.createElement(A1, null, /* @__PURE__ */ m.createElement(ST, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ m.createElement(qR.Provider, {
    value: te
  }, /* @__PURE__ */ m.createElement(_W, Object.assign({
    width: E
  }, R, {
    zIndex: D,
    getContainer: v === void 0 ? n : v,
    prefixCls: L,
    rootClassName: Ue(T, f, k, j),
    footer: W,
    visible: d ?? S,
    mousePosition: (t = R.mousePosition) !== null && t !== void 0 ? t : xT,
    onClose: a,
    closable: V,
    closeIcon: G,
    focusTriggerAfterClose: b,
    transitionName: zf(B, "zoom", e.transitionName),
    maskTransitionName: zf(B, "fade", e.maskTransitionName),
    className: Ue(T, c, o == null ? void 0 : o.className),
    style: Object.assign(Object.assign({}, o == null ? void 0 : o.style), w),
    classNames: Object.assign(Object.assign(Object.assign({}, o == null ? void 0 : o.classNames), $), {
      wrapper: Ue(F, $ == null ? void 0 : $.wrapper)
    }),
    styles: Object.assign(Object.assign({}, o == null ? void 0 : o.styles), P),
    panelRef: X
  }))))));
}, UW = _0e, O0e = (e) => {
  const {
    componentCls: t,
    titleFontSize: n,
    titleLineHeight: r,
    modalConfirmIconSize: i,
    fontSize: o,
    lineHeight: a,
    modalTitleHeight: s,
    fontHeight: l,
    confirmBodyPadding: c
  } = e, f = `${t}-confirm`;
  return {
    [f]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${e.antCls}-modal-header`]: {
        display: "none"
      },
      [`${f}-body-wrapper`]: Object.assign({}, gh()),
      [`&${t} ${t}-body`]: {
        padding: c
      },
      // ====================== Body ======================
      [`${f}-body`]: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${e.iconCls}`]: {
          flex: "none",
          fontSize: i,
          marginInlineEnd: e.confirmIconMarginInlineEnd,
          marginTop: e.calc(e.calc(l).sub(i).equal()).div(2).equal()
        },
        [`&-has-title > ${e.iconCls}`]: {
          marginTop: e.calc(e.calc(s).sub(i).equal()).div(2).equal()
        }
      },
      [`${f}-paragraph`]: {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: e.marginXS,
        maxWidth: `calc(100% - ${ge(e.calc(e.modalConfirmIconSize).add(e.marginSM).equal())})`
      },
      [`${f}-title`]: {
        color: e.colorTextHeading,
        fontWeight: e.fontWeightStrong,
        fontSize: n,
        lineHeight: r
      },
      [`${f}-content`]: {
        color: e.colorText,
        fontSize: o,
        lineHeight: a
      },
      // ===================== Footer =====================
      [`${f}-btns`]: {
        textAlign: "end",
        marginTop: e.confirmBtnsMarginTop,
        [`${e.antCls}-btn + ${e.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: e.marginXS
        }
      }
    },
    [`${f}-error ${f}-body > ${e.iconCls}`]: {
      color: e.colorError
    },
    [`${f}-warning ${f}-body > ${e.iconCls},
        ${f}-confirm ${f}-body > ${e.iconCls}`]: {
      color: e.colorWarning
    },
    [`${f}-info ${f}-body > ${e.iconCls}`]: {
      color: e.colorInfo
    },
    [`${f}-success ${f}-body > ${e.iconCls}`]: {
      color: e.colorSuccess
    }
  };
}, P0e = Zw(["Modal", "confirm"], (e) => {
  const t = FW(e);
  return [O0e(t)];
}, BW, {
  // confirm is weak than modal since no conflict here
  order: -1e3
});
var T0e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function HW(e) {
  const {
    prefixCls: t,
    icon: n,
    okText: r,
    cancelText: i,
    confirmPrefixCls: o,
    type: a,
    okCancel: s,
    footer: l,
    // Legacy for static function usage
    locale: c
  } = e, f = T0e(e, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  let d = n;
  if (!n && n !== null)
    switch (a) {
      case "info":
        d = /* @__PURE__ */ m.createElement(fme, null);
        break;
      case "success":
        d = /* @__PURE__ */ m.createElement(qhe, null);
        break;
      case "error":
        d = /* @__PURE__ */ m.createElement(I9, null);
        break;
      default:
        d = /* @__PURE__ */ m.createElement(ame, null);
    }
  const p = s ?? a === "confirm", g = e.autoFocusButton === null ? !1 : e.autoFocusButton || "ok", [v] = Xw("Modal"), y = c || v, x = r || (p ? y == null ? void 0 : y.okText : y == null ? void 0 : y.justOkText), b = i || (y == null ? void 0 : y.cancelText), w = Object.assign({
    autoFocusButton: g,
    cancelTextLocale: b,
    okTextLocale: x,
    mergedOkCancel: p
  }, f), S = m.useMemo(() => w, Qa(Object.values(w))), E = /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Q4, null), /* @__PURE__ */ m.createElement(J4, null)), O = e.title !== void 0 && e.title !== null, $ = `${o}-body`;
  return /* @__PURE__ */ m.createElement("div", {
    className: `${o}-body-wrapper`
  }, /* @__PURE__ */ m.createElement("div", {
    className: Ue($, {
      [`${$}-has-title`]: O
    })
  }, d, /* @__PURE__ */ m.createElement("div", {
    className: `${o}-paragraph`
  }, O && /* @__PURE__ */ m.createElement("span", {
    className: `${o}-title`
  }, e.title), /* @__PURE__ */ m.createElement("div", {
    className: `${o}-content`
  }, e.content))), l === void 0 || typeof l == "function" ? /* @__PURE__ */ m.createElement(sW, {
    value: S
  }, /* @__PURE__ */ m.createElement("div", {
    className: `${o}-btns`
  }, typeof l == "function" ? l(E, {
    OkBtn: J4,
    CancelBtn: Q4
  }) : E)) : l, /* @__PURE__ */ m.createElement(P0e, {
    prefixCls: t
  }));
}
const I0e = (e) => {
  const {
    close: t,
    zIndex: n,
    afterClose: r,
    open: i,
    keyboard: o,
    centered: a,
    getContainer: s,
    maskStyle: l,
    direction: c,
    prefixCls: f,
    wrapClassName: d,
    rootPrefixCls: p,
    bodyStyle: g,
    closable: v = !1,
    closeIcon: y,
    modalRender: x,
    focusTriggerAfterClose: b,
    onConfirm: w,
    styles: S
  } = e, E = `${f}-confirm`, O = e.width || 416, $ = e.style || {}, P = e.mask === void 0 ? !0 : e.mask, R = e.maskClosable === void 0 ? !1 : e.maskClosable, L = Ue(E, `${E}-${e.type}`, {
    [`${E}-rtl`]: c === "rtl"
  }, e.className), [, B] = ss(), j = m.useMemo(() => n !== void 0 ? n : B.zIndexPopupBase + W9, [n, B]);
  return /* @__PURE__ */ m.createElement(UW, {
    prefixCls: f,
    className: L,
    wrapClassName: Ue({
      [`${E}-centered`]: !!e.centered
    }, d),
    onCancel: () => {
      t == null || t({
        triggerCancel: !0
      }), w == null || w(!1);
    },
    open: i,
    title: "",
    footer: null,
    transitionName: zf(p || "", "zoom", e.transitionName),
    maskTransitionName: zf(p || "", "fade", e.maskTransitionName),
    mask: P,
    maskClosable: R,
    style: $,
    styles: Object.assign({
      body: g,
      mask: l
    }, S),
    width: O,
    zIndex: j,
    afterClose: r,
    keyboard: o,
    centered: a,
    getContainer: s,
    closable: v,
    closeIcon: y,
    modalRender: x,
    focusTriggerAfterClose: b
  }, /* @__PURE__ */ m.createElement(HW, Object.assign({}, e, {
    confirmPrefixCls: E
  })));
}, WW = (e) => {
  const {
    rootPrefixCls: t,
    iconPrefixCls: n,
    direction: r,
    theme: i
  } = e;
  return /* @__PURE__ */ m.createElement(dS, {
    prefixCls: t,
    iconPrefixCls: n,
    direction: r,
    theme: i
  }, /* @__PURE__ */ m.createElement(I0e, Object.assign({}, e)));
}, A0e = [], xf = A0e;
let VW = "";
function GW() {
  return VW;
}
const R0e = (e) => {
  var t, n;
  const {
    prefixCls: r,
    getContainer: i,
    direction: o
  } = e, a = xH(), s = m.useContext(Mt), l = GW() || s.getPrefixCls(), c = r || `${l}-modal`;
  let f = i;
  return f === !1 && (f = void 0), /* @__PURE__ */ oe.createElement(WW, Object.assign({}, e, {
    rootPrefixCls: l,
    prefixCls: c,
    iconPrefixCls: s.iconPrefixCls,
    theme: s.theme,
    direction: o ?? s.direction,
    locale: (n = (t = s.locale) === null || t === void 0 ? void 0 : t.Modal) !== null && n !== void 0 ? n : a,
    getContainer: f
  }));
};
function vv(e) {
  const t = Kpe(), n = document.createDocumentFragment();
  let r = Object.assign(Object.assign({}, e), {
    close: s,
    open: !0
  }), i;
  function o() {
    for (var c = arguments.length, f = new Array(c), d = 0; d < c; d++)
      f[d] = arguments[d];
    const p = f.some((g) => g && g.triggerCancel);
    e.onCancel && p && e.onCancel.apply(e, [() => {
    }].concat(Qa(f.slice(1))));
    for (let g = 0; g < xf.length; g++)
      if (xf[g] === s) {
        xf.splice(g, 1);
        break;
      }
    Y9(n);
  }
  function a(c) {
    clearTimeout(i), i = setTimeout(() => {
      const f = t.getPrefixCls(void 0, GW()), d = t.getIconPrefixCls(), p = t.getTheme(), g = /* @__PURE__ */ oe.createElement(R0e, Object.assign({}, c));
      q9(/* @__PURE__ */ oe.createElement(dS, {
        prefixCls: f,
        iconPrefixCls: d,
        theme: p
      }, t.holderRender ? t.holderRender(g) : g), n);
    });
  }
  function s() {
    for (var c = arguments.length, f = new Array(c), d = 0; d < c; d++)
      f[d] = arguments[d];
    r = Object.assign(Object.assign({}, r), {
      open: !1,
      afterClose: () => {
        typeof e.afterClose == "function" && e.afterClose(), o.apply(this, f);
      }
    }), r.visible && delete r.visible, a(r);
  }
  function l(c) {
    typeof c == "function" ? r = c(r) : r = Object.assign(Object.assign({}, r), c), a(r);
  }
  return a(r), xf.push(s), {
    destroy: s,
    update: l
  };
}
function KW(e) {
  return Object.assign(Object.assign({}, e), {
    type: "warning"
  });
}
function qW(e) {
  return Object.assign(Object.assign({}, e), {
    type: "info"
  });
}
function YW(e) {
  return Object.assign(Object.assign({}, e), {
    type: "success"
  });
}
function XW(e) {
  return Object.assign(Object.assign({}, e), {
    type: "error"
  });
}
function QW(e) {
  return Object.assign(Object.assign({}, e), {
    type: "confirm"
  });
}
function M0e(e) {
  let {
    rootPrefixCls: t
  } = e;
  VW = t;
}
var N0e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const k0e = (e, t) => {
  var n, {
    afterClose: r,
    config: i
  } = e, o = N0e(e, ["afterClose", "config"]);
  const [a, s] = m.useState(!0), [l, c] = m.useState(i), {
    direction: f,
    getPrefixCls: d
  } = m.useContext(Mt), p = d("modal"), g = d(), v = () => {
    var w;
    r(), (w = l.afterClose) === null || w === void 0 || w.call(l);
  }, y = function() {
    s(!1);
    for (var w = arguments.length, S = new Array(w), E = 0; E < w; E++)
      S[E] = arguments[E];
    const O = S.some(($) => $ && $.triggerCancel);
    l.onCancel && O && l.onCancel.apply(l, [() => {
    }].concat(Qa(S.slice(1))));
  };
  m.useImperativeHandle(t, () => ({
    destroy: y,
    update: (w) => {
      c((S) => Object.assign(Object.assign({}, S), w));
    }
  }));
  const x = (n = l.okCancel) !== null && n !== void 0 ? n : l.type === "confirm", [b] = Xw("Modal", Ff.Modal);
  return /* @__PURE__ */ m.createElement(WW, Object.assign({
    prefixCls: p,
    rootPrefixCls: g
  }, l, {
    close: y,
    open: a,
    afterClose: v,
    okText: l.okText || (x ? b == null ? void 0 : b.okText : b == null ? void 0 : b.justOkText),
    direction: l.direction || f,
    cancelText: l.cancelText || (b == null ? void 0 : b.cancelText)
  }, o));
}, L0e = /* @__PURE__ */ m.forwardRef(k0e);
let DD = 0;
const D0e = /* @__PURE__ */ m.memo(/* @__PURE__ */ m.forwardRef((e, t) => {
  const [n, r] = Dme();
  return m.useImperativeHandle(t, () => ({
    patchElement: r
  }), []), /* @__PURE__ */ m.createElement(m.Fragment, null, n);
}));
function j0e() {
  const e = m.useRef(null), [t, n] = m.useState([]);
  m.useEffect(() => {
    t.length && (Qa(t).forEach((a) => {
      a();
    }), n([]));
  }, [t]);
  const r = m.useCallback((o) => function(s) {
    var l;
    DD += 1;
    const c = /* @__PURE__ */ m.createRef();
    let f;
    const d = new Promise((x) => {
      f = x;
    });
    let p = !1, g;
    const v = /* @__PURE__ */ m.createElement(L0e, {
      key: `modal-${DD}`,
      config: o(s),
      ref: c,
      afterClose: () => {
        g == null || g();
      },
      isSilent: () => p,
      onConfirm: (x) => {
        f(x);
      }
    });
    return g = (l = e.current) === null || l === void 0 ? void 0 : l.patchElement(v), g && xf.push(g), {
      destroy: () => {
        function x() {
          var b;
          (b = c.current) === null || b === void 0 || b.destroy();
        }
        c.current ? x() : n((b) => [].concat(Qa(b), [x]));
      },
      update: (x) => {
        function b() {
          var w;
          (w = c.current) === null || w === void 0 || w.update(x);
        }
        c.current ? b() : n((w) => [].concat(Qa(w), [b]));
      },
      then: (x) => (p = !0, d.then(x))
    };
  }, []);
  return [m.useMemo(() => ({
    info: r(qW),
    success: r(YW),
    error: r(XW),
    warning: r(KW),
    confirm: r(QW)
  }), []), /* @__PURE__ */ m.createElement(D0e, {
    key: "modal-holder",
    ref: e
  })];
}
function F0e(e) {
  return (t) => /* @__PURE__ */ m.createElement(dS, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ m.createElement(e, Object.assign({}, t)));
}
function CT(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return oe.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(CT(r)) : yh.isFragment(r) && r.props ? n = n.concat(CT(r.props.children, t)) : n.push(r));
  }), n;
}
var au = /* @__PURE__ */ new Map();
function B0e(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = au.get(r)) === null || n === void 0 || n.forEach(function(i) {
      return i(r);
    });
  });
}
var JW = new jU(B0e);
function z0e(e, t) {
  au.has(e) || (au.set(e, /* @__PURE__ */ new Set()), JW.observe(e)), au.get(e).add(t);
}
function U0e(e, t) {
  au.has(e) && (au.get(e).delete(t), au.get(e).size || (JW.unobserve(e), au.delete(e)));
}
var H0e = /* @__PURE__ */ function(e) {
  cv(n, e);
  var t = uv(n);
  function n() {
    return Js(this, n), t.apply(this, arguments);
  }
  return Zs(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(m.Component), ET = /* @__PURE__ */ m.createContext(null);
function W0e(e) {
  var t = e.children, n = e.onBatchResize, r = m.useRef(0), i = m.useRef([]), o = m.useContext(ET), a = m.useCallback(function(s, l, c) {
    r.current += 1;
    var f = r.current;
    i.current.push({
      size: s,
      element: l,
      data: c
    }), Promise.resolve().then(function() {
      f === r.current && (n == null || n(i.current), i.current = []);
    }), o == null || o(s, l, c);
  }, [n, o]);
  return /* @__PURE__ */ m.createElement(ET.Provider, {
    value: a
  }, t);
}
function V0e(e, t) {
  var n = e.children, r = e.disabled, i = m.useRef(null), o = m.useRef(null), a = m.useContext(ET), s = typeof n == "function", l = s ? n(i) : n, c = m.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), f = !s && /* @__PURE__ */ m.isValidElement(l) && GR(l), d = f ? l.ref : null, p = m.useMemo(function() {
    return j9(d, i);
  }, [d, i]), g = function() {
    return QP(i.current) || QP(o.current);
  };
  m.useImperativeHandle(t, function() {
    return g();
  });
  var v = m.useRef(e);
  v.current = e;
  var y = m.useCallback(function(x) {
    var b = v.current, w = b.onResize, S = b.data, E = x.getBoundingClientRect(), O = E.width, $ = E.height, P = x.offsetWidth, R = x.offsetHeight, L = Math.floor(O), B = Math.floor($);
    if (c.current.width !== L || c.current.height !== B || c.current.offsetWidth !== P || c.current.offsetHeight !== R) {
      var j = {
        width: L,
        height: B,
        offsetWidth: P,
        offsetHeight: R
      };
      c.current = j;
      var A = P === Math.round(O) ? O : P, T = R === Math.round($) ? $ : R, k = ye(ye({}, j), {}, {
        offsetWidth: A,
        offsetHeight: T
      });
      a == null || a(k, x, S), w && Promise.resolve().then(function() {
        w(k, x);
      });
    }
  }, []);
  return m.useEffect(function() {
    var x = g();
    return x && !r && z0e(x, y), function() {
      return U0e(x, y);
    };
  }, [i.current, r]), /* @__PURE__ */ m.createElement(H0e, {
    ref: o
  }, f ? /* @__PURE__ */ m.cloneElement(l, {
    ref: p
  }) : l);
}
var G0e = /* @__PURE__ */ m.forwardRef(V0e), K0e = "rc-observer-key";
function q0e(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : CT(n);
  return r.map(function(i, o) {
    var a = (i == null ? void 0 : i.key) || "".concat(K0e, "-").concat(o);
    return /* @__PURE__ */ m.createElement(G0e, jt({}, e, {
      key: a,
      ref: o === 0 ? t : void 0
    }), i);
  });
}
var Ws = /* @__PURE__ */ m.forwardRef(q0e);
Ws.Collection = W0e;
var Y0e = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], $d = void 0;
function X0e(e, t) {
  var n = e.prefixCls, r = e.invalidate, i = e.item, o = e.renderItem, a = e.responsive, s = e.responsiveDisabled, l = e.registerSize, c = e.itemKey, f = e.className, d = e.style, p = e.children, g = e.display, v = e.order, y = e.component, x = y === void 0 ? "div" : y, b = _n(e, Y0e), w = a && !g;
  function S(R) {
    l(c, R);
  }
  m.useEffect(function() {
    return function() {
      S(null);
    };
  }, []);
  var E = o && i !== $d ? o(i) : p, O;
  r || (O = {
    opacity: w ? 0 : 1,
    height: w ? 0 : $d,
    overflowY: w ? "hidden" : $d,
    order: a ? v : $d,
    pointerEvents: w ? "none" : $d,
    position: w ? "absolute" : $d
  });
  var $ = {};
  w && ($["aria-hidden"] = !0);
  var P = /* @__PURE__ */ m.createElement(x, jt({
    className: ft(!r && n, f),
    style: ye(ye({}, O), d)
  }, $, b, {
    ref: t
  }), E);
  return a && (P = /* @__PURE__ */ m.createElement(Ws, {
    onResize: function(L) {
      var B = L.offsetWidth;
      S(B);
    },
    disabled: s
  }, P)), P;
}
var tg = /* @__PURE__ */ m.forwardRef(X0e);
tg.displayName = "Item";
function $T(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function Q0e(e) {
  if (typeof MessageChannel > "u")
    qp(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function J0e() {
  var e = m.useRef(null), t = function(r) {
    e.current || (e.current = [], Q0e(function() {
      js.unstable_batchedUpdates(function() {
        e.current.forEach(function(i) {
          i();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return t;
}
function bm(e, t) {
  var n = m.useState(t), r = ke(n, 2), i = r[0], o = r[1], a = $T(function(s) {
    e(function() {
      o(s);
    });
  });
  return [i, a];
}
var N1 = /* @__PURE__ */ oe.createContext(null), Z0e = ["component"], ebe = ["className"], tbe = ["className"], nbe = function(t, n) {
  var r = m.useContext(N1);
  if (!r) {
    var i = t.component, o = i === void 0 ? "div" : i, a = _n(t, Z0e);
    return /* @__PURE__ */ m.createElement(o, jt({}, a, {
      ref: n
    }));
  }
  var s = r.className, l = _n(r, ebe), c = t.className, f = _n(t, tbe);
  return /* @__PURE__ */ m.createElement(N1.Provider, {
    value: null
  }, /* @__PURE__ */ m.createElement(tg, jt({
    ref: n,
    className: ft(s, c)
  }, l, f)));
}, ZW = /* @__PURE__ */ m.forwardRef(nbe);
ZW.displayName = "RawItem";
var rbe = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], e7 = "responsive", t7 = "invalidate";
function ibe(e) {
  return "+ ".concat(e.length, " ...");
}
function obe(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-overflow" : n, i = e.data, o = i === void 0 ? [] : i, a = e.renderItem, s = e.renderRawItem, l = e.itemKey, c = e.itemWidth, f = c === void 0 ? 10 : c, d = e.ssr, p = e.style, g = e.className, v = e.maxCount, y = e.renderRest, x = e.renderRawRest, b = e.suffix, w = e.component, S = w === void 0 ? "div" : w, E = e.itemComponent, O = e.onVisibleChange, $ = _n(e, rbe), P = d === "full", R = J0e(), L = bm(R, null), B = ke(L, 2), j = B[0], A = B[1], T = j || 0, k = bm(R, /* @__PURE__ */ new Map()), F = ke(k, 2), W = F[0], V = F[1], G = bm(R, 0), X = ke(G, 2), D = X[0], te = X[1], ee = bm(R, 0), U = ke(ee, 2), he = U[0], re = U[1], de = bm(R, 0), we = ke(de, 2), ue = we[0], me = we[1], Se = m.useState(null), _e = ke(Se, 2), Ge = _e[0], Fe = _e[1], Ae = m.useState(null), Me = ke(Ae, 2), et = Me[0], De = Me[1], je = m.useMemo(function() {
    return et === null && P ? Number.MAX_SAFE_INTEGER : et || 0;
  }, [et, j]), ie = m.useState(!1), fe = ke(ie, 2), be = fe[0], Te = fe[1], Le = "".concat(r, "-item"), ct = Math.max(D, he), Z = v === e7, se = o.length && Z, Ce = v === t7, Pe = se || typeof v == "number" && o.length > v, Ee = m.useMemo(function() {
    var Xe = o;
    return se ? j === null && P ? Xe = o : Xe = o.slice(0, Math.min(o.length, T / f)) : typeof v == "number" && (Xe = o.slice(0, v)), Xe;
  }, [o, f, j, v, se]), We = m.useMemo(function() {
    return se ? o.slice(je + 1) : o.slice(Ee.length);
  }, [o, Ee, se, je]), ze = m.useCallback(function(Xe, it) {
    var _t;
    return typeof l == "function" ? l(Xe) : (_t = l && (Xe == null ? void 0 : Xe[l])) !== null && _t !== void 0 ? _t : it;
  }, [l]), Ye = m.useCallback(a || function(Xe) {
    return Xe;
  }, [a]);
  function xt(Xe, it, _t) {
    et === Xe && (it === void 0 || it === Ge) || (De(Xe), _t || (Te(Xe < o.length - 1), O == null || O(Xe)), it !== void 0 && Fe(it));
  }
  function Lt(Xe, it) {
    A(it.clientWidth);
  }
  function mt(Xe, it) {
    V(function(_t) {
      var Yt = new Map(_t);
      return it === null ? Yt.delete(Xe) : Yt.set(Xe, it), Yt;
    });
  }
  function St(Xe, it) {
    re(it), te(he);
  }
  function Et(Xe, it) {
    me(it);
  }
  function Je(Xe) {
    return W.get(ze(Ee[Xe], Xe));
  }
  Pu(function() {
    if (T && typeof ct == "number" && Ee) {
      var Xe = ue, it = Ee.length, _t = it - 1;
      if (!it) {
        xt(0, null);
        return;
      }
      for (var Yt = 0; Yt < it; Yt += 1) {
        var gn = Je(Yt);
        if (P && (gn = gn || 0), gn === void 0) {
          xt(Yt - 1, void 0, !0);
          break;
        }
        if (Xe += gn, // Only one means `totalWidth` is the final width
        _t === 0 && Xe <= T || // Last two width will be the final width
        Yt === _t - 1 && Xe + Je(_t) <= T) {
          xt(_t, null);
          break;
        } else if (Xe + ct > T) {
          xt(Yt - 1, Xe - gn - ue + he);
          break;
        }
      }
      b && Je(0) + ue > T && Fe(null);
    }
  }, [T, W, he, ue, ze, Ee]);
  var Ze = be && !!We.length, ut = {};
  Ge !== null && se && (ut = {
    position: "absolute",
    left: Ge,
    top: 0
  });
  var cn = {
    prefixCls: Le,
    responsive: se,
    component: E,
    invalidate: Ce
  }, un = s ? function(Xe, it) {
    var _t = ze(Xe, it);
    return /* @__PURE__ */ m.createElement(N1.Provider, {
      key: _t,
      value: ye(ye({}, cn), {}, {
        order: it,
        item: Xe,
        itemKey: _t,
        registerSize: mt,
        display: it <= je
      })
    }, s(Xe, it));
  } : function(Xe, it) {
    var _t = ze(Xe, it);
    return /* @__PURE__ */ m.createElement(tg, jt({}, cn, {
      order: it,
      key: _t,
      item: Xe,
      renderItem: Ye,
      itemKey: _t,
      registerSize: mt,
      display: it <= je
    }));
  }, bn, tt = {
    order: Ze ? je : Number.MAX_SAFE_INTEGER,
    className: "".concat(Le, "-rest"),
    registerSize: St,
    display: Ze
  };
  if (x)
    x && (bn = /* @__PURE__ */ m.createElement(N1.Provider, {
      value: ye(ye({}, cn), tt)
    }, x(We)));
  else {
    var Qe = y || ibe;
    bn = /* @__PURE__ */ m.createElement(tg, jt({}, cn, tt), typeof Qe == "function" ? Qe(We) : Qe);
  }
  var rn = /* @__PURE__ */ m.createElement(S, jt({
    className: ft(!Ce && r, g),
    style: p,
    ref: t
  }, $), Ee.map(un), Pe ? bn : null, b && /* @__PURE__ */ m.createElement(tg, jt({}, cn, {
    responsive: Z,
    responsiveDisabled: !se,
    order: je,
    className: "".concat(Le, "-suffix"),
    registerSize: Et,
    display: !0,
    style: ut
  }), b));
  return Z && (rn = /* @__PURE__ */ m.createElement(Ws, {
    onResize: Lt,
    disabled: !se
  }, rn)), rn;
}
var cc = /* @__PURE__ */ m.forwardRef(obe);
cc.displayName = "Overflow";
cc.Item = ZW;
cc.RESPONSIVE = e7;
cc.INVALIDATE = t7;
function _T(e, t, n) {
  return Ue({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const n7 = (e, t) => t || e, abe = ["outlined", "borderless", "filled"], sbe = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  const n = m.useContext(Hye);
  let r;
  typeof e < "u" ? r = e : t === !1 ? r = "borderless" : r = n ?? "outlined";
  const i = abe.includes(r);
  return [r, i];
}, r7 = sbe;
var lbe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const cbe = lbe;
var ube = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: cbe
  }));
}, fbe = /* @__PURE__ */ m.forwardRef(ube);
const dbe = fbe;
var pbe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const hbe = pbe;
var mbe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const i7 = mbe;
var gbe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: i7
  }));
}, vbe = /* @__PURE__ */ m.forwardRef(gbe);
const ybe = vbe, o7 = ["xxl", "xl", "lg", "md", "sm", "xs"], bbe = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`
}), wbe = (e) => {
  const t = e, n = [].concat(o7).reverse();
  return n.forEach((r, i) => {
    const o = r.toUpperCase(), a = `screen${o}Min`, s = `screen${o}`;
    if (!(t[a] <= t[s]))
      throw new Error(`${a}<=${s} fails : !(${t[a]}<=${t[s]})`);
    if (i < n.length - 1) {
      const l = `screen${o}Max`;
      if (!(t[s] <= t[l]))
        throw new Error(`${s}<=${l} fails : !(${t[s]}<=${t[l]})`);
      const f = `screen${n[i + 1].toUpperCase()}Min`;
      if (!(t[l] <= t[f]))
        throw new Error(`${l}<=${f} fails : !(${t[l]}<=${t[f]})`);
    }
  }), e;
};
function Sbe() {
  const [, e] = ss(), t = bbe(wbe(e));
  return oe.useMemo(() => {
    const n = /* @__PURE__ */ new Map();
    let r = -1, i = {};
    return {
      matchHandlers: {},
      dispatch(o) {
        return i = o, n.forEach((a) => a(i)), n.size >= 1;
      },
      subscribe(o) {
        return n.size || this.register(), r += 1, n.set(r, o), o(i), r;
      },
      unsubscribe(o) {
        n.delete(o), n.size || this.unregister();
      },
      unregister() {
        Object.keys(t).forEach((o) => {
          const a = t[o], s = this.matchHandlers[a];
          s == null || s.mql.removeListener(s == null ? void 0 : s.listener);
        }), n.clear();
      },
      register() {
        Object.keys(t).forEach((o) => {
          const a = t[o], s = (c) => {
            let {
              matches: f
            } = c;
            this.dispatch(Object.assign(Object.assign({}, i), {
              [o]: f
            }));
          }, l = window.matchMedia(a);
          l.addListener(s), this.matchHandlers[a] = {
            mql: l,
            listener: s
          }, s(l);
        });
      },
      responsiveMap: t
    };
  }, [e]);
}
function xbe() {
  const [, e] = m.useReducer((t) => t + 1, 0);
  return e;
}
function Cbe() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  const t = m.useRef({}), n = xbe(), r = Sbe();
  return Sp(() => {
    const i = r.subscribe((o) => {
      t.current = o, e && n();
    });
    return () => r.unsubscribe(i);
  }, []), t.current;
}
const Ebe = /* @__PURE__ */ m.createContext({}), OT = Ebe, $be = (e) => {
  const {
    antCls: t,
    componentCls: n,
    iconCls: r,
    avatarBg: i,
    avatarColor: o,
    containerSize: a,
    containerSizeLG: s,
    containerSizeSM: l,
    textFontSize: c,
    textFontSizeLG: f,
    textFontSizeSM: d,
    borderRadius: p,
    borderRadiusLG: g,
    borderRadiusSM: v,
    lineWidth: y,
    lineType: x
  } = e, b = (w, S, E) => ({
    width: w,
    height: w,
    borderRadius: "50%",
    [`&${n}-square`]: {
      borderRadius: E
    },
    [`&${n}-icon`]: {
      fontSize: S,
      [`> ${r}`]: {
        margin: 0
      }
    }
  });
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign({}, Vi(e)), {
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      color: o,
      whiteSpace: "nowrap",
      textAlign: "center",
      verticalAlign: "middle",
      background: i,
      border: `${ge(y)} ${x} transparent`,
      "&-image": {
        background: "transparent"
      },
      [`${t}-image-img`]: {
        display: "block"
      }
    }), b(a, c, p)), {
      "&-lg": Object.assign({}, b(s, f, g)),
      "&-sm": Object.assign({}, b(l, d, v)),
      "> img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    })
  };
}, _be = (e) => {
  const {
    componentCls: t,
    groupBorderColor: n,
    groupOverlapping: r,
    groupSpace: i
  } = e;
  return {
    [`${t}-group`]: {
      display: "inline-flex",
      [`${t}`]: {
        borderColor: n
      },
      "> *:not(:first-child)": {
        marginInlineStart: r
      }
    },
    [`${t}-group-popover`]: {
      [`${t} + ${t}`]: {
        marginInlineStart: i
      }
    }
  };
}, Obe = (e) => {
  const {
    controlHeight: t,
    controlHeightLG: n,
    controlHeightSM: r,
    fontSize: i,
    fontSizeLG: o,
    fontSizeXL: a,
    fontSizeHeading3: s,
    marginXS: l,
    marginXXS: c,
    colorBorderBg: f
  } = e;
  return {
    containerSize: t,
    containerSizeLG: n,
    containerSizeSM: r,
    textFontSize: Math.round((o + a) / 2),
    textFontSizeLG: s,
    textFontSizeSM: i,
    groupSpace: c,
    groupOverlapping: -l,
    groupBorderColor: f
  };
}, a7 = Pi("Avatar", (e) => {
  const {
    colorTextLightSolid: t,
    colorTextPlaceholder: n
  } = e, r = _r(e, {
    avatarBg: n,
    avatarColor: t
  });
  return [$be(r), _be(r)];
}, Obe);
var Pbe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Tbe = (e, t) => {
  const [n, r] = m.useState(1), [i, o] = m.useState(!1), [a, s] = m.useState(!0), l = m.useRef(null), c = m.useRef(null), f = Sc(t, l), {
    getPrefixCls: d,
    avatar: p
  } = m.useContext(Mt), g = m.useContext(OT), v = () => {
    if (!c.current || !l.current)
      return;
    const ue = c.current.offsetWidth, me = l.current.offsetWidth;
    if (ue !== 0 && me !== 0) {
      const {
        gap: Se = 4
      } = e;
      Se * 2 < me && r(me - Se * 2 < ue ? (me - Se * 2) / ue : 1);
    }
  };
  m.useEffect(() => {
    o(!0);
  }, []), m.useEffect(() => {
    s(!0), r(1);
  }, [e.src]), m.useEffect(v, [e.gap]);
  const y = () => {
    const {
      onError: ue
    } = e;
    (ue == null ? void 0 : ue()) !== !1 && s(!1);
  }, {
    prefixCls: x,
    shape: b,
    size: w,
    src: S,
    srcSet: E,
    icon: O,
    className: $,
    rootClassName: P,
    alt: R,
    draggable: L,
    children: B,
    crossOrigin: j
  } = e, A = Pbe(e, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "rootClassName", "alt", "draggable", "children", "crossOrigin"]), T = Rl((ue) => {
    var me, Se;
    return (Se = (me = w ?? (g == null ? void 0 : g.size)) !== null && me !== void 0 ? me : ue) !== null && Se !== void 0 ? Se : "default";
  }), k = Object.keys(typeof T == "object" ? T || {} : {}).some((ue) => ["xs", "sm", "md", "lg", "xl", "xxl"].includes(ue)), F = Cbe(k), W = m.useMemo(() => {
    if (typeof T != "object")
      return {};
    const ue = o7.find((Se) => F[Se]), me = T[ue];
    return me ? {
      width: me,
      height: me,
      fontSize: me && (O || B) ? me / 2 : 18
    } : {};
  }, [F, T]), V = d("avatar", x), G = xc(V), [X, D, te] = a7(V, G), ee = Ue({
    [`${V}-lg`]: T === "large",
    [`${V}-sm`]: T === "small"
  }), U = /* @__PURE__ */ m.isValidElement(S), he = b || (g == null ? void 0 : g.shape) || "circle", re = Ue(V, ee, p == null ? void 0 : p.className, `${V}-${he}`, {
    [`${V}-image`]: U || S && a,
    [`${V}-icon`]: !!O
  }, te, G, $, P, D), de = typeof T == "number" ? {
    width: T,
    height: T,
    fontSize: O ? T / 2 : 18
  } : {};
  let we;
  if (typeof S == "string" && a)
    we = /* @__PURE__ */ m.createElement("img", {
      src: S,
      draggable: L,
      srcSet: E,
      onError: y,
      alt: R,
      crossOrigin: j
    });
  else if (U)
    we = S;
  else if (O)
    we = O;
  else if (i || n !== 1) {
    const ue = `scale(${n})`, me = {
      msTransform: ue,
      WebkitTransform: ue,
      transform: ue
    };
    we = /* @__PURE__ */ m.createElement(mR, {
      onResize: v
    }, /* @__PURE__ */ m.createElement("span", {
      className: `${V}-string`,
      ref: c,
      style: Object.assign({}, me)
    }, B));
  } else
    we = /* @__PURE__ */ m.createElement("span", {
      className: `${V}-string`,
      style: {
        opacity: 0
      },
      ref: c
    }, B);
  return delete A.onError, delete A.gap, X(/* @__PURE__ */ m.createElement("span", Object.assign({}, A, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, de), W), p == null ? void 0 : p.style), A.style),
    className: re,
    ref: f
  }), we));
}, Ibe = /* @__PURE__ */ m.forwardRef(Tbe), s7 = Ibe, k1 = (e) => e ? typeof e == "function" ? e() : e : null;
function o2(e) {
  var t = e.children, n = e.prefixCls, r = e.id, i = e.overlayInnerStyle, o = e.className, a = e.style;
  return /* @__PURE__ */ m.createElement("div", {
    className: ft("".concat(n, "-content"), o),
    style: a
  }, /* @__PURE__ */ m.createElement("div", {
    className: "".concat(n, "-inner"),
    id: r,
    role: "tooltip",
    style: i
  }, typeof t == "function" ? t() : t));
}
function Dg(e) {
  "@babel/helpers - typeof";
  return Dg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dg(e);
}
function Abe(e, t) {
  if (Dg(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Dg(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rbe(e) {
  var t = Abe(e, "string");
  return Dg(t) === "symbol" ? t : String(t);
}
function Mbe(e, t, n) {
  return t = Rbe(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function jD(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Eo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jD(Object(n), !0).forEach(function(r) {
      Mbe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jD(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Nbe(e) {
  if (Array.isArray(e))
    return e;
}
function kbe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function PT(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function l7(e, t) {
  if (e) {
    if (typeof e == "string")
      return PT(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return PT(e, t);
  }
}
function Lbe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Di(e, t) {
  return Nbe(e) || kbe(e, t) || l7(e, t) || Lbe();
}
function Dbe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function jbe(e, t) {
  if (e == null)
    return {};
  var n = Dbe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function TT(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function c7(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function Fbe(e) {
  return c7(e) instanceof ShadowRoot;
}
function IT(e) {
  return Fbe(e) ? c7(e) : null;
}
function rf(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function Bbe() {
  var e = ye({}, sh);
  return e.useId;
}
var FD = 0, BD = Bbe();
const zbe = BD ? (
  // Use React `useId`
  function(t) {
    var n = BD();
    return t || n;
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = m.useState("ssr-id"), r = ke(n, 2), i = r[0], o = r[1];
    return m.useEffect(function() {
      var a = FD;
      FD += 1, o("rc_unique_".concat(a));
    }, []), t || i;
  }
);
function Ube() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var zD = Ube() ? m.useLayoutEffect : m.useEffect, gl = function(t, n) {
  var r = m.useRef(!0);
  zD(function() {
    return t(r.current);
  }, n), zD(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
};
const Hbe = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
function L1() {
  return L1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, L1.apply(this, arguments);
}
var u7 = { exports: {} }, Hn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a2 = Symbol.for("react.element"), s2 = Symbol.for("react.portal"), TS = Symbol.for("react.fragment"), IS = Symbol.for("react.strict_mode"), AS = Symbol.for("react.profiler"), RS = Symbol.for("react.provider"), MS = Symbol.for("react.context"), Wbe = Symbol.for("react.server_context"), NS = Symbol.for("react.forward_ref"), kS = Symbol.for("react.suspense"), LS = Symbol.for("react.suspense_list"), DS = Symbol.for("react.memo"), jS = Symbol.for("react.lazy"), Vbe = Symbol.for("react.offscreen"), f7;
f7 = Symbol.for("react.module.reference");
function fs(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case a2:
        switch (e = e.type, e) {
          case TS:
          case AS:
          case IS:
          case kS:
          case LS:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Wbe:
              case MS:
              case NS:
              case jS:
              case DS:
              case RS:
                return e;
              default:
                return t;
            }
        }
      case s2:
        return t;
    }
  }
}
Hn.ContextConsumer = MS;
Hn.ContextProvider = RS;
Hn.Element = a2;
Hn.ForwardRef = NS;
Hn.Fragment = TS;
Hn.Lazy = jS;
Hn.Memo = DS;
Hn.Portal = s2;
Hn.Profiler = AS;
Hn.StrictMode = IS;
Hn.Suspense = kS;
Hn.SuspenseList = LS;
Hn.isAsyncMode = function() {
  return !1;
};
Hn.isConcurrentMode = function() {
  return !1;
};
Hn.isContextConsumer = function(e) {
  return fs(e) === MS;
};
Hn.isContextProvider = function(e) {
  return fs(e) === RS;
};
Hn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === a2;
};
Hn.isForwardRef = function(e) {
  return fs(e) === NS;
};
Hn.isFragment = function(e) {
  return fs(e) === TS;
};
Hn.isLazy = function(e) {
  return fs(e) === jS;
};
Hn.isMemo = function(e) {
  return fs(e) === DS;
};
Hn.isPortal = function(e) {
  return fs(e) === s2;
};
Hn.isProfiler = function(e) {
  return fs(e) === AS;
};
Hn.isStrictMode = function(e) {
  return fs(e) === IS;
};
Hn.isSuspense = function(e) {
  return fs(e) === kS;
};
Hn.isSuspenseList = function(e) {
  return fs(e) === LS;
};
Hn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === TS || e === AS || e === IS || e === kS || e === LS || e === Vbe || typeof e == "object" && e !== null && (e.$$typeof === jS || e.$$typeof === DS || e.$$typeof === RS || e.$$typeof === MS || e.$$typeof === NS || e.$$typeof === f7 || e.getModuleId !== void 0);
};
Hn.typeOf = fs;
u7.exports = Hn;
var Gbe = u7.exports;
function Kbe(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function d7(e, t) {
  typeof e == "function" ? e(t) : nn(e) === "object" && e && "current" in e && (e.current = t);
}
function p7() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      d7(o, i);
    });
  };
}
function qbe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Kbe(function() {
    return p7.apply(void 0, t);
  }, t, function(r, i) {
    return r.length !== i.length || r.every(function(o, a) {
      return o !== i[a];
    });
  });
}
function Ybe(e) {
  var t, n, r = Gbe.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
function Xbe(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, i = e.arrowPos, o = r || {}, a = o.className, s = o.content, l = i.x, c = l === void 0 ? 0 : l, f = i.y, d = f === void 0 ? 0 : f, p = m.useRef();
  if (!n || !n.points)
    return null;
  var g = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var v = n.points[0], y = n.points[1], x = v[0], b = v[1], w = y[0], S = y[1];
    x === w || !["t", "b"].includes(x) ? g.top = d : x === "t" ? g.top = 0 : g.bottom = 0, b === S || !["l", "r"].includes(b) ? g.left = c : b === "l" ? g.left = 0 : g.right = 0;
  }
  return /* @__PURE__ */ m.createElement("div", {
    ref: p,
    className: ft("".concat(t, "-arrow"), a),
    style: g
  }, s);
}
function Qbe(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, i = e.mask, o = e.motion;
  return i ? /* @__PURE__ */ m.createElement(Cc, L1({}, o, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ m.createElement("div", {
      style: {
        zIndex: r
      },
      className: ft("".concat(t, "-mask"), s)
    });
  }) : null;
}
var Jbe = /* @__PURE__ */ m.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
}), Zbe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, i = e.prefixCls, o = e.style, a = e.target, s = e.onVisibleChanged, l = e.open, c = e.keepDom, f = e.fresh, d = e.onClick, p = e.mask, g = e.arrow, v = e.arrowPos, y = e.align, x = e.motion, b = e.maskMotion, w = e.forceRender, S = e.getPopupContainer, E = e.autoDestroy, O = e.portal, $ = e.zIndex, P = e.onMouseEnter, R = e.onMouseLeave, L = e.onPointerEnter, B = e.ready, j = e.offsetX, A = e.offsetY, T = e.offsetR, k = e.offsetB, F = e.onAlign, W = e.onPrepare, V = e.stretch, G = e.targetWidth, X = e.targetHeight, D = typeof n == "function" ? n() : n, te = l || c, ee = (S == null ? void 0 : S.length) > 0, U = m.useState(!S || !ee), he = Di(U, 2), re = he[0], de = he[1];
  if (gl(function() {
    !re && ee && a && de(!0);
  }, [re, ee, a]), !re)
    return null;
  var we = "auto", ue = {
    left: "-1000vw",
    top: "-1000vh",
    right: we,
    bottom: we
  };
  if (B || !l) {
    var me, Se = y.points, _e = y.dynamicInset || ((me = y._experimental) === null || me === void 0 ? void 0 : me.dynamicInset), Ge = _e && Se[0][1] === "r", Fe = _e && Se[0][0] === "b";
    Ge ? (ue.right = T, ue.left = we) : (ue.left = j, ue.right = we), Fe ? (ue.bottom = k, ue.top = we) : (ue.top = A, ue.bottom = we);
  }
  var Ae = {};
  return V && (V.includes("height") && X ? Ae.height = X : V.includes("minHeight") && X && (Ae.minHeight = X), V.includes("width") && G ? Ae.width = G : V.includes("minWidth") && G && (Ae.minWidth = G)), l || (Ae.pointerEvents = "none"), /* @__PURE__ */ m.createElement(O, {
    open: w || te,
    getContainer: S && function() {
      return S(a);
    },
    autoDestroy: E
  }, /* @__PURE__ */ m.createElement(Qbe, {
    prefixCls: i,
    open: l,
    zIndex: $,
    mask: p,
    motion: b
  }), /* @__PURE__ */ m.createElement(Ws, {
    onResize: F,
    disabled: !l
  }, function(Me) {
    return /* @__PURE__ */ m.createElement(Cc, L1({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: w,
      leavedClassName: "".concat(i, "-hidden")
    }, x, {
      onAppearPrepare: W,
      onEnterPrepare: W,
      visible: l,
      onVisibleChanged: function(De) {
        var je;
        x == null || (je = x.onVisibleChanged) === null || je === void 0 || je.call(x, De), s(De);
      }
    }), function(et, De) {
      var je = et.className, ie = et.style, fe = ft(i, je, r);
      return /* @__PURE__ */ m.createElement("div", {
        ref: p7(Me, t, De),
        className: fe,
        style: Eo(Eo(Eo(Eo({
          "--arrow-x": "".concat(v.x || 0, "px"),
          "--arrow-y": "".concat(v.y || 0, "px")
        }, ue), Ae), ie), {}, {
          boxSizing: "border-box",
          zIndex: $
        }, o),
        onMouseEnter: P,
        onMouseLeave: R,
        onPointerEnter: L,
        onClick: d
      }, g && /* @__PURE__ */ m.createElement(Xbe, {
        prefixCls: i,
        arrow: g,
        arrowPos: v,
        align: y
      }), /* @__PURE__ */ m.createElement(Jbe, {
        cache: !l && !f
      }, D));
    });
  }));
}), e1e = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, i = Ybe(n), o = m.useCallback(function(s) {
    d7(t, r ? r(s) : s);
  }, [r]), a = qbe(o, n.ref);
  return i ? /* @__PURE__ */ m.cloneElement(n, {
    ref: a
  }) : n;
}), UD = /* @__PURE__ */ m.createContext(null);
function HD(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function t1e(e, t, n, r) {
  return m.useMemo(function() {
    var i = HD(n ?? t), o = HD(r ?? t), a = new Set(i), s = new Set(o);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
const n1e = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), o = i.width, a = i.height;
      if (o || a)
        return !0;
    }
  }
  return !1;
};
function r1e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function i1e(e, t, n, r) {
  for (var i = n.points, o = Object.keys(e), a = 0; a < o.length; a += 1) {
    var s, l = o[a];
    if (r1e((s = e[l]) === null || s === void 0 ? void 0 : s.points, i, r))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function WD(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function yv(e) {
  return e.ownerDocument.defaultView;
}
function AT(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var i = yv(n).getComputedStyle(n), o = i.overflowX, a = i.overflowY, s = i.overflow;
    [o, a, s].some(function(l) {
      return r.includes(l);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function jg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function wm(e) {
  return jg(parseFloat(e), 0);
}
function VD(e, t) {
  var n = Eo({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var i = yv(r).getComputedStyle(r), o = i.overflow, a = i.overflowClipMargin, s = i.borderTopWidth, l = i.borderBottomWidth, c = i.borderLeftWidth, f = i.borderRightWidth, d = r.getBoundingClientRect(), p = r.offsetHeight, g = r.clientHeight, v = r.offsetWidth, y = r.clientWidth, x = wm(s), b = wm(l), w = wm(c), S = wm(f), E = jg(Math.round(d.width / v * 1e3) / 1e3), O = jg(Math.round(d.height / p * 1e3) / 1e3), $ = (v - y - w - S) * E, P = (p - g - x - b) * O, R = x * O, L = b * O, B = w * E, j = S * E, A = 0, T = 0;
      if (o === "clip") {
        var k = wm(a);
        A = k * E, T = k * O;
      }
      var F = d.x + B - A, W = d.y + R - T, V = F + d.width + 2 * A - B - j - $, G = W + d.height + 2 * T - R - L - P;
      n.left = Math.max(n.left, F), n.top = Math.max(n.top, W), n.right = Math.min(n.right, V), n.bottom = Math.min(n.bottom, G);
    }
  }), n;
}
function GD(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function KD(e, t) {
  var n = t || [], r = Di(n, 2), i = r[0], o = r[1];
  return [GD(e.width, i), GD(e.height, o)];
}
function qD() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function _d(e, t) {
  var n = t[0], r = t[1], i, o;
  return n === "t" ? o = e.y : n === "b" ? o = e.y + e.height : o = e.y + e.height / 2, r === "l" ? i = e.x : r === "r" ? i = e.x + e.width : i = e.x + e.width / 2, {
    x: i,
    y: o
  };
}
function Lc(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, i) {
    return i === t ? n[r] || "c" : r;
  }).join("");
}
function o1e(e, t, n, r, i, o, a) {
  var s = m.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: i[r] || {}
  }), l = Di(s, 2), c = l[0], f = l[1], d = m.useRef(0), p = m.useMemo(function() {
    return t ? AT(t) : [];
  }, [t]), g = m.useRef({}), v = function() {
    g.current = {};
  };
  e || v();
  var y = rf(function() {
    if (t && n && e) {
      let wn = function(ir, mr) {
        var bi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fe, wi = D.x + ir, Zi = D.y + mr, eo = wi + me, Mo = Zi + ue, ys = Math.max(wi, bi.left), Na = Math.max(Zi, bi.top), ka = Math.min(eo, bi.right), bs = Math.min(Mo, bi.bottom);
        return Math.max(0, (ka - ys) * (bs - Na));
      }, Ro = function() {
        Nn = D.y + Qe, bt = Nn + ue, ht = D.x + tt, Ht = ht + me;
      };
      var w, S, E = t, O = E.ownerDocument, $ = yv(E), P = $.getComputedStyle(E), R = P.width, L = P.height, B = P.position, j = E.style.left, A = E.style.top, T = E.style.right, k = E.style.bottom, F = E.style.overflow, W = Eo(Eo({}, i[r]), o), V = O.createElement("div");
      (w = E.parentElement) === null || w === void 0 || w.appendChild(V), V.style.left = "".concat(E.offsetLeft, "px"), V.style.top = "".concat(E.offsetTop, "px"), V.style.position = B, V.style.height = "".concat(E.offsetHeight, "px"), V.style.width = "".concat(E.offsetWidth, "px"), E.style.left = "0", E.style.top = "0", E.style.right = "auto", E.style.bottom = "auto", E.style.overflow = "hidden";
      var G;
      if (Array.isArray(n))
        G = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var X = n.getBoundingClientRect();
        G = {
          x: X.x,
          y: X.y,
          width: X.width,
          height: X.height
        };
      }
      var D = E.getBoundingClientRect(), te = O.documentElement, ee = te.clientWidth, U = te.clientHeight, he = te.scrollWidth, re = te.scrollHeight, de = te.scrollTop, we = te.scrollLeft, ue = D.height, me = D.width, Se = G.height, _e = G.width, Ge = {
        left: 0,
        top: 0,
        right: ee,
        bottom: U
      }, Fe = {
        left: -we,
        top: -de,
        right: he - we,
        bottom: re - de
      }, Ae = W.htmlRegion, Me = "visible", et = "visibleFirst";
      Ae !== "scroll" && Ae !== et && (Ae = Me);
      var De = Ae === et, je = VD(Fe, p), ie = VD(Ge, p), fe = Ae === Me ? ie : je, be = De ? ie : fe;
      E.style.left = "auto", E.style.top = "auto", E.style.right = "0", E.style.bottom = "0";
      var Te = E.getBoundingClientRect();
      E.style.left = j, E.style.top = A, E.style.right = T, E.style.bottom = k, E.style.overflow = F, (S = E.parentElement) === null || S === void 0 || S.removeChild(V);
      var Le = jg(Math.round(me / parseFloat(R) * 1e3) / 1e3), ct = jg(Math.round(ue / parseFloat(L) * 1e3) / 1e3);
      if (Le === 0 || ct === 0 || TT(n) && !n1e(n))
        return;
      var Z = W.offset, se = W.targetOffset, Ce = KD(D, Z), Pe = Di(Ce, 2), Ee = Pe[0], We = Pe[1], ze = KD(G, se), Ye = Di(ze, 2), xt = Ye[0], Lt = Ye[1];
      G.x -= xt, G.y -= Lt;
      var mt = W.points || [], St = Di(mt, 2), Et = St[0], Je = St[1], Ze = qD(Je), ut = qD(Et), cn = _d(G, Ze), un = _d(D, ut), bn = Eo({}, W), tt = cn.x - un.x + Ee, Qe = cn.y - un.y + We, rn = wn(tt, Qe), Xe = wn(tt, Qe, ie), it = _d(G, ["t", "l"]), _t = _d(D, ["t", "l"]), Yt = _d(G, ["b", "r"]), gn = _d(D, ["b", "r"]), Zt = W.overflow || {}, dr = Zt.adjustX, pr = Zt.adjustY, Gn = Zt.shiftX, Mn = Zt.shiftY, Hr = function(mr) {
        return typeof mr == "boolean" ? mr : mr >= 0;
      }, Nn, bt, ht, Ht;
      Ro();
      var Sn = Hr(pr), hr = ut[0] === Ze[0];
      if (Sn && ut[0] === "t" && (bt > be.bottom || g.current.bt)) {
        var In = Qe;
        hr ? In -= ue - Se : In = it.y - gn.y - We;
        var Kn = wn(tt, In), vi = wn(tt, In, ie);
        // Of course use larger one
        Kn > rn || Kn === rn && (!De || // Choose recommend one
        vi >= Xe) ? (g.current.bt = !0, Qe = In, We = -We, bn.points = [Lc(ut, 0), Lc(Ze, 0)]) : g.current.bt = !1;
      }
      if (Sn && ut[0] === "b" && (Nn < be.top || g.current.tb)) {
        var Vt = Qe;
        hr ? Vt += ue - Se : Vt = Yt.y - _t.y - We;
        var Sr = wn(tt, Vt), Xr = wn(tt, Vt, ie);
        // Of course use larger one
        Sr > rn || Sr === rn && (!De || // Choose recommend one
        Xr >= Xe) ? (g.current.tb = !0, Qe = Vt, We = -We, bn.points = [Lc(ut, 0), Lc(Ze, 0)]) : g.current.tb = !1;
      }
      var Ri = Hr(dr), Dr = ut[1] === Ze[1];
      if (Ri && ut[1] === "l" && (Ht > be.right || g.current.rl)) {
        var Or = tt;
        Dr ? Or -= me - _e : Or = it.x - gn.x - Ee;
        var qi = wn(Or, Qe), Yi = wn(Or, Qe, ie);
        // Of course use larger one
        qi > rn || qi === rn && (!De || // Choose recommend one
        Yi >= Xe) ? (g.current.rl = !0, tt = Or, Ee = -Ee, bn.points = [Lc(ut, 1), Lc(Ze, 1)]) : g.current.rl = !1;
      }
      if (Ri && ut[1] === "r" && (ht < be.left || g.current.lr)) {
        var jr = tt;
        Dr ? jr += me - _e : jr = Yt.x - _t.x - Ee;
        var Xi = wn(jr, Qe), qn = wn(jr, Qe, ie);
        // Of course use larger one
        Xi > rn || Xi === rn && (!De || // Choose recommend one
        qn >= Xe) ? (g.current.lr = !0, tt = jr, Ee = -Ee, bn.points = [Lc(ut, 1), Lc(Ze, 1)]) : g.current.lr = !1;
      }
      Ro();
      var Qn = Gn === !0 ? 0 : Gn;
      typeof Qn == "number" && (ht < ie.left && (tt -= ht - ie.left - Ee, G.x + _e < ie.left + Qn && (tt += G.x - ie.left + _e - Qn)), Ht > ie.right && (tt -= Ht - ie.right - Ee, G.x > ie.right - Qn && (tt += G.x - ie.right + Qn)));
      var Jn = Mn === !0 ? 0 : Mn;
      typeof Jn == "number" && (Nn < ie.top && (Qe -= Nn - ie.top - We, G.y + Se < ie.top + Jn && (Qe += G.y - ie.top + Se - Jn)), bt > ie.bottom && (Qe -= bt - ie.bottom - We, G.y > ie.bottom - Jn && (Qe += G.y - ie.bottom + Jn)));
      var Wr = D.x + tt, oi = Wr + me, nr = D.y + Qe, Qi = nr + ue, Kt = G.x, wt = Kt + _e, an = G.y, rr = an + Se, kn = Math.max(Wr, Kt), Fr = Math.min(oi, wt), ai = (kn + Fr) / 2, Ao = ai - Wr, si = Math.max(nr, an), yi = Math.min(Qi, rr), Mi = (si + yi) / 2, Ji = Mi - nr;
      a == null || a(t, bn);
      var Ni = Te.right - D.x - (tt + D.width), ta = Te.bottom - D.y - (Qe + D.height);
      f({
        ready: !0,
        offsetX: tt / Le,
        offsetY: Qe / ct,
        offsetR: Ni / Le,
        offsetB: ta / ct,
        arrowX: Ao / Le,
        arrowY: Ji / ct,
        scaleX: Le,
        scaleY: ct,
        align: bn
      });
    }
  }), x = function() {
    d.current += 1;
    var S = d.current;
    Promise.resolve().then(function() {
      d.current === S && y();
    });
  }, b = function() {
    f(function(S) {
      return Eo(Eo({}, S), {}, {
        ready: !1
      });
    });
  };
  return gl(b, [r]), gl(function() {
    e || b();
  }, [e]), [c.ready, c.offsetX, c.offsetY, c.offsetR, c.offsetB, c.arrowX, c.arrowY, c.scaleX, c.scaleY, c.align, x];
}
function a1e(e) {
  if (Array.isArray(e))
    return PT(e);
}
function s1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function l1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YD(e) {
  return a1e(e) || s1e(e) || l7(e) || l1e();
}
function c1e(e, t, n, r, i) {
  gl(function() {
    if (e && t && n) {
      let d = function() {
        r(), i();
      };
      var o = t, a = n, s = AT(o), l = AT(a), c = yv(a), f = new Set([c].concat(YD(s), YD(l)));
      return f.forEach(function(p) {
        p.addEventListener("scroll", d, {
          passive: !0
        });
      }), c.addEventListener("resize", d, {
        passive: !0
      }), r(), function() {
        f.forEach(function(p) {
          p.removeEventListener("scroll", d), c.removeEventListener("resize", d);
        });
      };
    }
  }, [e, t, n]);
}
function u1e(e, t, n, r, i, o, a, s) {
  var l = m.useRef(e);
  l.current = e, m.useEffect(function() {
    if (t && r && (!i || o)) {
      var c = function(g) {
        var v = g.target;
        l.current && !a(v) && s(!1);
      }, f = yv(r);
      f.addEventListener("mousedown", c, !0), f.addEventListener("contextmenu", c, !0);
      var d = IT(n);
      return d && (d.addEventListener("mousedown", c, !0), d.addEventListener("contextmenu", c, !0)), function() {
        f.removeEventListener("mousedown", c, !0), f.removeEventListener("contextmenu", c, !0), d && (d.removeEventListener("mousedown", c, !0), d.removeEventListener("contextmenu", c, !0));
      };
    }
  }, [t, n, r, i, o]);
}
var f1e = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function d1e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pv, t = /* @__PURE__ */ m.forwardRef(function(n, r) {
    var i = n.prefixCls, o = i === void 0 ? "rc-trigger-popup" : i, a = n.children, s = n.action, l = s === void 0 ? "hover" : s, c = n.showAction, f = n.hideAction, d = n.popupVisible, p = n.defaultPopupVisible, g = n.onPopupVisibleChange, v = n.afterPopupVisibleChange, y = n.mouseEnterDelay, x = n.mouseLeaveDelay, b = x === void 0 ? 0.1 : x, w = n.focusDelay, S = n.blurDelay, E = n.mask, O = n.maskClosable, $ = O === void 0 ? !0 : O, P = n.getPopupContainer, R = n.forceRender, L = n.autoDestroy, B = n.destroyPopupOnHide, j = n.popup, A = n.popupClassName, T = n.popupStyle, k = n.popupPlacement, F = n.builtinPlacements, W = F === void 0 ? {} : F, V = n.popupAlign, G = n.zIndex, X = n.stretch, D = n.getPopupClassNameFromAlign, te = n.fresh, ee = n.alignPoint, U = n.onPopupClick, he = n.onPopupAlign, re = n.arrow, de = n.popupMotion, we = n.maskMotion, ue = n.popupTransitionName, me = n.popupAnimation, Se = n.maskTransitionName, _e = n.maskAnimation, Ge = n.className, Fe = n.getTriggerDOMNode, Ae = jbe(n, f1e), Me = L || B || !1, et = m.useState(!1), De = Di(et, 2), je = De[0], ie = De[1];
    gl(function() {
      ie(Hbe());
    }, []);
    var fe = m.useRef({}), be = m.useContext(UD), Te = m.useMemo(function() {
      return {
        registerSubPopup: function(He, Nt) {
          fe.current[He] = Nt, be == null || be.registerSubPopup(He, Nt);
        }
      };
    }, [be]), Le = zbe(), ct = m.useState(null), Z = Di(ct, 2), se = Z[0], Ce = Z[1], Pe = rf(function(xe) {
      TT(xe) && se !== xe && Ce(xe), be == null || be.registerSubPopup(Le, xe);
    }), Ee = m.useState(null), We = Di(Ee, 2), ze = We[0], Ye = We[1], xt = m.useRef(null), Lt = rf(function(xe) {
      TT(xe) && ze !== xe && (Ye(xe), xt.current = xe);
    }), mt = m.Children.only(a), St = (mt == null ? void 0 : mt.props) || {}, Et = {}, Je = rf(function(xe) {
      var He, Nt, Wt = ze;
      return (Wt == null ? void 0 : Wt.contains(xe)) || ((He = IT(Wt)) === null || He === void 0 ? void 0 : He.host) === xe || xe === Wt || (se == null ? void 0 : se.contains(xe)) || ((Nt = IT(se)) === null || Nt === void 0 ? void 0 : Nt.host) === xe || xe === se || Object.values(fe.current).some(function(kt) {
        return (kt == null ? void 0 : kt.contains(xe)) || xe === kt;
      });
    }), Ze = WD(o, de, me, ue), ut = WD(o, we, _e, Se), cn = m.useState(p || !1), un = Di(cn, 2), bn = un[0], tt = un[1], Qe = d ?? bn, rn = rf(function(xe) {
      d === void 0 && tt(xe);
    });
    gl(function() {
      tt(d || !1);
    }, [d]);
    var Xe = m.useRef(Qe);
    Xe.current = Qe;
    var it = m.useRef([]);
    it.current = [];
    var _t = rf(function(xe) {
      var He;
      rn(xe), ((He = it.current[it.current.length - 1]) !== null && He !== void 0 ? He : Qe) !== xe && (it.current.push(xe), g == null || g(xe));
    }), Yt = m.useRef(), gn = function() {
      clearTimeout(Yt.current);
    }, Zt = function(He) {
      var Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      gn(), Nt === 0 ? _t(He) : Yt.current = setTimeout(function() {
        _t(He);
      }, Nt * 1e3);
    };
    m.useEffect(function() {
      return gn;
    }, []);
    var dr = m.useState(!1), pr = Di(dr, 2), Gn = pr[0], Mn = pr[1];
    gl(function(xe) {
      (!xe || Qe) && Mn(!0);
    }, [Qe]);
    var Hr = m.useState(null), Nn = Di(Hr, 2), bt = Nn[0], ht = Nn[1], Ht = m.useState([0, 0]), Sn = Di(Ht, 2), hr = Sn[0], In = Sn[1], Kn = function(He) {
      In([He.clientX, He.clientY]);
    }, vi = o1e(Qe, se, ee ? hr : ze, k, W, V, he), Vt = Di(vi, 11), Sr = Vt[0], Xr = Vt[1], Ri = Vt[2], Dr = Vt[3], Or = Vt[4], qi = Vt[5], Yi = Vt[6], jr = Vt[7], Xi = Vt[8], qn = Vt[9], Qn = Vt[10], Jn = t1e(je, l, c, f), Wr = Di(Jn, 2), oi = Wr[0], nr = Wr[1], Qi = oi.has("click"), Kt = nr.has("click") || nr.has("contextMenu"), wt = rf(function() {
      Gn || Qn();
    }), an = function() {
      Xe.current && ee && Kt && Zt(!1);
    };
    c1e(Qe, ze, se, wt, an), gl(function() {
      wt();
    }, [hr, k]), gl(function() {
      Qe && !(W != null && W[k]) && wt();
    }, [JSON.stringify(V)]);
    var rr = m.useMemo(function() {
      var xe = i1e(W, o, qn, ee);
      return ft(xe, D == null ? void 0 : D(qn));
    }, [qn, D, W, o, ee]);
    m.useImperativeHandle(r, function() {
      return {
        nativeElement: xt.current,
        forceAlign: wt
      };
    });
    var kn = m.useState(0), Fr = Di(kn, 2), ai = Fr[0], Ao = Fr[1], si = m.useState(0), yi = Di(si, 2), Mi = yi[0], Ji = yi[1], Ni = function() {
      if (X && ze) {
        var He = ze.getBoundingClientRect();
        Ao(He.width), Ji(He.height);
      }
    }, ta = function() {
      Ni(), wt();
    }, wn = function(He) {
      Mn(!1), Qn(), v == null || v(He);
    }, Ro = function() {
      return new Promise(function(He) {
        Ni(), ht(function() {
          return He;
        });
      });
    };
    gl(function() {
      bt && (Qn(), bt(), ht(null));
    }, [bt]);
    function ir(xe, He, Nt, Wt) {
      Et[xe] = function(kt) {
        var na;
        Wt == null || Wt(kt), Zt(He, Nt);
        for (var ws = arguments.length, il = new Array(ws > 1 ? ws - 1 : 0), ra = 1; ra < ws; ra++)
          il[ra - 1] = arguments[ra];
        (na = St[xe]) === null || na === void 0 || na.call.apply(na, [St, kt].concat(il));
      };
    }
    (Qi || Kt) && (Et.onClick = function(xe) {
      var He;
      Xe.current && Kt ? Zt(!1) : !Xe.current && Qi && (Kn(xe), Zt(!0));
      for (var Nt = arguments.length, Wt = new Array(Nt > 1 ? Nt - 1 : 0), kt = 1; kt < Nt; kt++)
        Wt[kt - 1] = arguments[kt];
      (He = St.onClick) === null || He === void 0 || He.call.apply(He, [St, xe].concat(Wt));
    }), u1e(Qe, Kt, ze, se, E, $, Je, Zt);
    var mr = oi.has("hover"), bi = nr.has("hover"), wi, Zi;
    mr && (ir("onMouseEnter", !0, y, function(xe) {
      Kn(xe);
    }), ir("onPointerEnter", !0, y, function(xe) {
      Kn(xe);
    }), wi = function(He) {
      (Qe || Gn) && se !== null && se !== void 0 && se.contains(He.target) && Zt(!0, y);
    }, ee && (Et.onMouseMove = function(xe) {
      var He;
      (He = St.onMouseMove) === null || He === void 0 || He.call(St, xe);
    })), bi && (ir("onMouseLeave", !1, b), ir("onPointerLeave", !1, b), Zi = function() {
      Zt(!1, b);
    }), oi.has("focus") && ir("onFocus", !0, w), nr.has("focus") && ir("onBlur", !1, S), oi.has("contextMenu") && (Et.onContextMenu = function(xe) {
      var He;
      Xe.current && nr.has("contextMenu") ? Zt(!1) : (Kn(xe), Zt(!0)), xe.preventDefault();
      for (var Nt = arguments.length, Wt = new Array(Nt > 1 ? Nt - 1 : 0), kt = 1; kt < Nt; kt++)
        Wt[kt - 1] = arguments[kt];
      (He = St.onContextMenu) === null || He === void 0 || He.call.apply(He, [St, xe].concat(Wt));
    }), Ge && (Et.className = ft(St.className, Ge));
    var eo = Eo(Eo({}, St), Et), Mo = {}, ys = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    ys.forEach(function(xe) {
      Ae[xe] && (Mo[xe] = function() {
        for (var He, Nt = arguments.length, Wt = new Array(Nt), kt = 0; kt < Nt; kt++)
          Wt[kt] = arguments[kt];
        (He = eo[xe]) === null || He === void 0 || He.call.apply(He, [eo].concat(Wt)), Ae[xe].apply(Ae, Wt);
      });
    });
    var Na = /* @__PURE__ */ m.cloneElement(mt, Eo(Eo({}, eo), Mo)), ka = {
      x: qi,
      y: Yi
    }, bs = re ? Eo({}, re !== !0 ? re : {}) : null;
    return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Ws, {
      disabled: !Qe,
      ref: Lt,
      onResize: ta
    }, /* @__PURE__ */ m.createElement(e1e, {
      getTriggerDOMNode: Fe
    }, Na)), /* @__PURE__ */ m.createElement(UD.Provider, {
      value: Te
    }, /* @__PURE__ */ m.createElement(Zbe, {
      portal: e,
      ref: Pe,
      prefixCls: o,
      popup: j,
      className: ft(A, rr),
      style: T,
      target: ze,
      onMouseEnter: wi,
      onMouseLeave: Zi,
      onPointerEnter: wi,
      zIndex: G,
      open: Qe,
      keepDom: Gn,
      fresh: te,
      onClick: U,
      mask: E,
      motion: Ze,
      maskMotion: ut,
      onVisibleChanged: wn,
      onPrepare: Ro,
      forceRender: R,
      autoDestroy: Me,
      getPopupContainer: P,
      align: qn,
      arrow: bs,
      arrowPos: ka,
      ready: Sr,
      offsetX: Xr,
      offsetY: Ri,
      offsetR: Dr,
      offsetB: Or,
      onAlign: wt,
      stretch: X,
      targetWidth: ai / jr,
      targetHeight: Mi / Xi
    })));
  });
  return t;
}
const p1e = d1e(pv);
var Od = {
  shiftX: 64,
  adjustY: 1
}, Pd = {
  adjustX: 1,
  shiftY: !0
}, Ha = [0, 0], h1e = {
  left: {
    points: ["cr", "cl"],
    overflow: Pd,
    offset: [-4, 0],
    targetOffset: Ha
  },
  right: {
    points: ["cl", "cr"],
    overflow: Pd,
    offset: [4, 0],
    targetOffset: Ha
  },
  top: {
    points: ["bc", "tc"],
    overflow: Od,
    offset: [0, -4],
    targetOffset: Ha
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Od,
    offset: [0, 4],
    targetOffset: Ha
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: Od,
    offset: [0, -4],
    targetOffset: Ha
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Pd,
    offset: [-4, 0],
    targetOffset: Ha
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Od,
    offset: [0, -4],
    targetOffset: Ha
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Pd,
    offset: [4, 0],
    targetOffset: Ha
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Od,
    offset: [0, 4],
    targetOffset: Ha
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Pd,
    offset: [4, 0],
    targetOffset: Ha
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Od,
    offset: [0, 4],
    targetOffset: Ha
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Pd,
    offset: [-4, 0],
    targetOffset: Ha
  }
}, m1e = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], g1e = function(t, n) {
  var r = t.overlayClassName, i = t.trigger, o = i === void 0 ? ["hover"] : i, a = t.mouseEnterDelay, s = a === void 0 ? 0 : a, l = t.mouseLeaveDelay, c = l === void 0 ? 0.1 : l, f = t.overlayStyle, d = t.prefixCls, p = d === void 0 ? "rc-tooltip" : d, g = t.children, v = t.onVisibleChange, y = t.afterVisibleChange, x = t.transitionName, b = t.animation, w = t.motion, S = t.placement, E = S === void 0 ? "right" : S, O = t.align, $ = O === void 0 ? {} : O, P = t.destroyTooltipOnHide, R = P === void 0 ? !1 : P, L = t.defaultVisible, B = t.getTooltipContainer, j = t.overlayInnerStyle;
  t.arrowContent;
  var A = t.overlay, T = t.id, k = t.showArrow, F = k === void 0 ? !0 : k, W = _n(t, m1e), V = m.useRef(null);
  m.useImperativeHandle(n, function() {
    return V.current;
  });
  var G = ye({}, W);
  "visible" in t && (G.popupVisible = t.visible);
  var X = function() {
    return /* @__PURE__ */ m.createElement(o2, {
      key: "content",
      prefixCls: p,
      id: T,
      overlayInnerStyle: j
    }, A);
  };
  return /* @__PURE__ */ m.createElement(p1e, jt({
    popupClassName: r,
    prefixCls: p,
    popup: X,
    action: o,
    builtinPlacements: h1e,
    popupPlacement: E,
    ref: V,
    popupAlign: $,
    getPopupContainer: B,
    onPopupVisibleChange: v,
    afterPopupVisibleChange: y,
    popupTransitionName: x,
    popupAnimation: b,
    popupMotion: w,
    defaultPopupVisible: L,
    autoDestroy: R,
    mouseLeaveDelay: c,
    popupStyle: f,
    mouseEnterDelay: s,
    arrow: F
  }, G), g);
};
const v1e = /* @__PURE__ */ m.forwardRef(g1e);
function h7(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: n,
    borderRadiusOuter: r
  } = e, i = t / 2, o = 0, a = i, s = r * 1 / Math.sqrt(2), l = i - r * (1 - 1 / Math.sqrt(2)), c = i - n * (1 / Math.sqrt(2)), f = r * (Math.sqrt(2) - 1) + n * (1 / Math.sqrt(2)), d = 2 * i - c, p = f, g = 2 * i - s, v = l, y = 2 * i - o, x = a, b = i * Math.sqrt(2) + r * (Math.sqrt(2) - 2), w = r * (Math.sqrt(2) - 1), S = `polygon(${w}px 100%, 50% ${w}px, ${2 * i - w}px 100%, ${w}px 100%)`, E = `path('M ${o} ${a} A ${r} ${r} 0 0 0 ${s} ${l} L ${c} ${f} A ${n} ${n} 0 0 1 ${d} ${p} L ${g} ${v} A ${r} ${r} 0 0 0 ${y} ${x} Z')`;
  return {
    arrowShadowWidth: b,
    arrowPath: E,
    arrowPolygon: S
  };
}
const y1e = (e, t, n) => {
  const {
    sizePopupArrow: r,
    arrowPolygon: i,
    arrowPath: o,
    arrowShadowWidth: a,
    borderRadiusXS: s,
    calc: l
  } = e;
  return {
    pointerEvents: "none",
    width: r,
    height: r,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: r,
      height: l(r).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [i, o]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: a,
      height: a,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${ge(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: n,
      zIndex: 0,
      background: "transparent"
    }
  };
}, m7 = 8;
function l2(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: n
  } = e, r = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: r,
    arrowOffsetVertical: n ? m7 : r
  };
}
function x0(e, t) {
  return e ? t : {};
}
function g7(e, t, n) {
  const {
    componentCls: r,
    boxShadowPopoverArrow: i,
    arrowOffsetVertical: o,
    arrowOffsetHorizontal: a
  } = e, {
    arrowDistance: s = 0,
    arrowPlacement: l = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = n || {};
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${r}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, y1e(e, t, i)), {
        "&:before": {
          background: t
        }
      })]
    }, x0(!!l.top, {
      [[`&-placement-top > ${r}-arrow`, `&-placement-topLeft > ${r}-arrow`, `&-placement-topRight > ${r}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: a
        }
      },
      [`&-placement-topRight > ${r}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: a
        }
      }
    })), x0(!!l.bottom, {
      [[`&-placement-bottom > ${r}-arrow`, `&-placement-bottomLeft > ${r}-arrow`, `&-placement-bottomRight > ${r}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: a
        }
      },
      [`&-placement-bottomRight > ${r}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: a
        }
      }
    })), x0(!!l.left, {
      [[`&-placement-left > ${r}-arrow`, `&-placement-leftTop > ${r}-arrow`, `&-placement-leftBottom > ${r}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${r}-arrow`]: {
        top: o
      },
      [`&-placement-leftBottom > ${r}-arrow`]: {
        bottom: o
      }
    })), x0(!!l.right, {
      [[`&-placement-right > ${r}-arrow`, `&-placement-rightTop > ${r}-arrow`, `&-placement-rightBottom > ${r}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${r}-arrow`]: {
        top: o
      },
      [`&-placement-rightBottom > ${r}-arrow`]: {
        bottom: o
      }
    }))
  };
}
function b1e(e, t, n, r) {
  if (r === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const i = r && typeof r == "object" ? r : {}, o = {};
  switch (e) {
    case "top":
    case "bottom":
      o.shiftX = t.arrowOffsetHorizontal * 2 + n, o.shiftY = !0, o.adjustY = !0;
      break;
    case "left":
    case "right":
      o.shiftY = t.arrowOffsetVertical * 2 + n, o.shiftX = !0, o.adjustX = !0;
      break;
  }
  const a = Object.assign(Object.assign({}, o), i);
  return a.shiftX || (a.adjustX = !0), a.shiftY || (a.adjustY = !0), a;
}
const XD = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, w1e = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, S1e = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function x1e(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: n,
    arrowPointAtCenter: r,
    offset: i,
    borderRadius: o,
    visibleFirst: a
  } = e, s = t / 2, l = {};
  return Object.keys(XD).forEach((c) => {
    const f = r && w1e[c] || XD[c], d = Object.assign(Object.assign({}, f), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (l[c] = d, S1e.has(c) && (d.autoArrow = !1), c) {
      case "top":
      case "topLeft":
      case "topRight":
        d.offset[1] = -s - i;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        d.offset[1] = s + i;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        d.offset[0] = -s - i;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        d.offset[0] = s + i;
        break;
    }
    const p = l2({
      contentRadius: o,
      limitVerticalRadius: !0
    });
    if (r)
      switch (c) {
        case "topLeft":
        case "bottomLeft":
          d.offset[0] = -p.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          d.offset[0] = p.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          d.offset[1] = -p.arrowOffsetHorizontal - s;
          break;
        case "leftBottom":
        case "rightBottom":
          d.offset[1] = p.arrowOffsetHorizontal + s;
          break;
      }
    d.overflow = b1e(c, p, t, n), a && (d.htmlRegion = "visibleFirst");
  }), l;
}
const C1e = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: n,
    tooltipColor: r,
    tooltipBg: i,
    tooltipBorderRadius: o,
    zIndexPopup: a,
    controlHeight: s,
    boxShadowSecondary: l,
    paddingSM: c,
    paddingXS: f
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Vi(e)), {
        position: "absolute",
        zIndex: a,
        display: "block",
        width: "max-content",
        maxWidth: n,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": i,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: s,
          minHeight: s,
          padding: `${ge(e.calc(c).div(2).equal())} ${ge(f)}`,
          color: r,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: i,
          borderRadius: o,
          boxShadow: l,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(o, m7)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), eS(e, (d, p) => {
        let {
          darkColor: g
        } = p;
        return {
          [`&${t}-${d}`]: {
            [`${t}-inner`]: {
              backgroundColor: g
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": g
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    g7(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, E1e = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, l2({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), h7(_r(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), v7 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Pi("Tooltip", (r) => {
    const {
      borderRadius: i,
      colorTextLightSolid: o,
      colorBgSpotlight: a
    } = r, s = _r(r, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: o,
      tooltipBorderRadius: i,
      tooltipBg: a
    });
    return [C1e(s), i2(r, "zoom-big-fast")];
  }, E1e, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, $1e = Mg.map((e) => `${e}-inverse`), _1e = ["success", "processing", "error", "default", "warning"];
function FS(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(Qa($1e), Qa(Mg)).includes(e) : Mg.includes(e);
}
function O1e(e) {
  return _1e.includes(e);
}
function y7(e, t) {
  const n = FS(t), r = Ue({
    [`${e}-${t}`]: t && n
  }), i = {}, o = {};
  return t && !n && (i.background = t, o["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: i,
    arrowStyle: o
  };
}
const P1e = (e) => {
  const {
    prefixCls: t,
    className: n,
    placement: r = "top",
    title: i,
    color: o,
    overlayInnerStyle: a
  } = e, {
    getPrefixCls: s
  } = m.useContext(Mt), l = s("tooltip", t), [c, f, d] = v7(l), p = y7(l, o), g = p.arrowStyle, v = Object.assign(Object.assign({}, a), p.overlayStyle), y = Ue(f, d, l, `${l}-pure`, `${l}-placement-${r}`, n, p.className);
  return c(/* @__PURE__ */ m.createElement("div", {
    className: y,
    style: g
  }, /* @__PURE__ */ m.createElement("div", {
    className: `${l}-arrow`
  }), /* @__PURE__ */ m.createElement(o2, Object.assign({}, e, {
    className: f,
    prefixCls: l,
    overlayInnerStyle: v
  }), i)));
}, T1e = P1e;
var I1e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const b7 = /* @__PURE__ */ m.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    openClassName: o,
    getTooltipContainer: a,
    overlayClassName: s,
    color: l,
    overlayInnerStyle: c,
    children: f,
    afterOpenChange: d,
    afterVisibleChange: p,
    destroyTooltipOnHide: g,
    arrow: v = !0,
    title: y,
    overlay: x,
    builtinPlacements: b,
    arrowPointAtCenter: w = !1,
    autoAdjustOverflow: S = !0
  } = e, E = !!v, [, O] = ss(), {
    getPopupContainer: $,
    getPrefixCls: P,
    direction: R
  } = m.useContext(Mt), L = wH(), B = m.useRef(null), j = () => {
    var Le;
    (Le = B.current) === null || Le === void 0 || Le.forceAlign();
  };
  m.useImperativeHandle(t, () => ({
    forceAlign: j,
    forcePopupAlign: () => {
      L.deprecated(!1, "forcePopupAlign", "forceAlign"), j();
    }
  }));
  const [A, T] = TR(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), k = !y && !x && y !== 0, F = (Le) => {
    var ct, Z;
    T(k ? !1 : Le), k || ((ct = e.onOpenChange) === null || ct === void 0 || ct.call(e, Le), (Z = e.onVisibleChange) === null || Z === void 0 || Z.call(e, Le));
  }, W = m.useMemo(() => {
    var Le, ct;
    let Z = w;
    return typeof v == "object" && (Z = (ct = (Le = v.pointAtCenter) !== null && Le !== void 0 ? Le : v.arrowPointAtCenter) !== null && ct !== void 0 ? ct : w), b || x1e({
      arrowPointAtCenter: Z,
      autoAdjustOverflow: S,
      arrowWidth: E ? O.sizePopupArrow : 0,
      borderRadius: O.borderRadius,
      offset: O.marginXXS,
      visibleFirst: !0
    });
  }, [w, v, b, O]), V = m.useMemo(() => y === 0 ? y : x || y || "", [x, y]), G = /* @__PURE__ */ m.createElement(A1, null, typeof V == "function" ? V() : V), {
    getPopupContainer: X,
    placement: D = "top",
    mouseEnterDelay: te = 0.1,
    mouseLeaveDelay: ee = 0.1,
    overlayStyle: U,
    rootClassName: he
  } = e, re = I1e(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), de = P("tooltip", i), we = P(), ue = e["data-popover-inject"];
  let me = A;
  !("open" in e) && !("visible" in e) && k && (me = !1);
  const Se = /* @__PURE__ */ m.isValidElement(f) && !M9(f) ? f : /* @__PURE__ */ m.createElement("span", null, f), _e = Se.props, Ge = !_e.className || typeof _e.className == "string" ? Ue(_e.className, o || `${de}-open`) : _e.className, [Fe, Ae, Me] = v7(de, !ue), et = y7(de, l), De = et.arrowStyle, je = Object.assign(Object.assign({}, c), et.overlayStyle), ie = Ue(s, {
    [`${de}-rtl`]: R === "rtl"
  }, et.className, he, Ae, Me), [fe, be] = G9("Tooltip", re.zIndex), Te = /* @__PURE__ */ m.createElement(v1e, Object.assign({}, re, {
    zIndex: fe,
    showArrow: E,
    placement: D,
    mouseEnterDelay: te,
    mouseLeaveDelay: ee,
    prefixCls: de,
    overlayClassName: ie,
    overlayStyle: Object.assign(Object.assign({}, De), U),
    getTooltipContainer: X || a || $,
    ref: B,
    builtinPlacements: W,
    overlay: G,
    visible: me,
    onVisibleChange: F,
    afterVisibleChange: d ?? p,
    overlayInnerStyle: je,
    arrowContent: /* @__PURE__ */ m.createElement("span", {
      className: `${de}-arrow-content`
    }),
    motion: {
      motionName: zf(we, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!g
  }), me ? Oa(Se, {
    className: Ge
  }) : Se);
  return Fe(/* @__PURE__ */ m.createElement(qR.Provider, {
    value: be
  }, Te));
});
b7._InternalPanelDoNotUseOrYouWillBeFired = T1e;
const BS = b7, A1e = (e) => {
  const {
    componentCls: t,
    popoverColor: n,
    titleMinWidth: r,
    fontWeightStrong: i,
    innerPadding: o,
    boxShadowSecondary: a,
    colorTextHeading: s,
    borderRadiusLG: l,
    zIndexPopup: c,
    titleMarginBottom: f,
    colorBgElevated: d,
    popoverBg: p,
    titleBorderBottom: g,
    innerContentPadding: v,
    titlePadding: y
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Vi(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: c,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "--antd-arrow-background-color": d,
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${t}-content`]: {
          position: "relative"
        },
        [`${t}-inner`]: {
          backgroundColor: p,
          backgroundClip: "padding-box",
          borderRadius: l,
          boxShadow: a,
          padding: o
        },
        [`${t}-title`]: {
          minWidth: r,
          marginBottom: f,
          color: s,
          fontWeight: i,
          borderBottom: g,
          padding: y
        },
        [`${t}-inner-content`]: {
          color: n,
          padding: v
        }
      })
    },
    // Arrow Style
    g7(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${t}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, R1e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Mg.map((n) => {
      const r = e[`${n}6`];
      return {
        [`&${t}-${n}`]: {
          "--antd-arrow-background-color": r,
          [`${t}-inner`]: {
            backgroundColor: r
          },
          [`${t}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, M1e = (e) => {
  const {
    lineWidth: t,
    controlHeight: n,
    fontHeight: r,
    padding: i,
    wireframe: o,
    zIndexPopupBase: a,
    borderRadiusLG: s,
    marginXS: l,
    lineType: c,
    colorSplit: f,
    paddingSM: d
  } = e, p = n - r, g = p / 2, v = p / 2 - t, y = i;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: a + 30
  }, h7(e)), l2({
    contentRadius: s,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: o ? 0 : 12,
    titleMarginBottom: o ? 0 : l,
    titlePadding: o ? `${g}px ${y}px ${v}px` : 0,
    titleBorderBottom: o ? `${t}px ${c} ${f}` : "none",
    innerContentPadding: o ? `${d}px ${y}px` : 0
  });
}, w7 = Pi("Popover", (e) => {
  const {
    colorBgElevated: t,
    colorText: n
  } = e, r = _r(e, {
    popoverBg: t,
    popoverColor: n
  });
  return [A1e(r), R1e(r), i2(r, "zoom-big")];
}, M1e, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var N1e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const k1e = (e, t, n) => !t && !n ? null : /* @__PURE__ */ m.createElement(m.Fragment, null, t && /* @__PURE__ */ m.createElement("div", {
  className: `${e}-title`
}, k1(t)), /* @__PURE__ */ m.createElement("div", {
  className: `${e}-inner-content`
}, k1(n))), L1e = (e) => {
  const {
    hashId: t,
    prefixCls: n,
    className: r,
    style: i,
    placement: o = "top",
    title: a,
    content: s,
    children: l
  } = e;
  return /* @__PURE__ */ m.createElement("div", {
    className: Ue(t, n, `${n}-pure`, `${n}-placement-${o}`, r),
    style: i
  }, /* @__PURE__ */ m.createElement("div", {
    className: `${n}-arrow`
  }), /* @__PURE__ */ m.createElement(o2, Object.assign({}, e, {
    className: t,
    prefixCls: n
  }), l || k1e(n, a, s)));
}, D1e = (e) => {
  const {
    prefixCls: t,
    className: n
  } = e, r = N1e(e, ["prefixCls", "className"]), {
    getPrefixCls: i
  } = m.useContext(Mt), o = i("popover", t), [a, s, l] = w7(o);
  return a(/* @__PURE__ */ m.createElement(L1e, Object.assign({}, r, {
    prefixCls: o,
    hashId: s,
    className: Ue(n, l)
  })));
}, j1e = D1e;
var F1e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const B1e = (e) => {
  let {
    title: t,
    content: n,
    prefixCls: r
  } = e;
  return /* @__PURE__ */ m.createElement(m.Fragment, null, t && /* @__PURE__ */ m.createElement("div", {
    className: `${r}-title`
  }, k1(t)), /* @__PURE__ */ m.createElement("div", {
    className: `${r}-inner-content`
  }, k1(n)));
}, S7 = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    prefixCls: n,
    title: r,
    content: i,
    overlayClassName: o,
    placement: a = "top",
    trigger: s = "hover",
    mouseEnterDelay: l = 0.1,
    mouseLeaveDelay: c = 0.1,
    overlayStyle: f = {}
  } = e, d = F1e(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle"]), {
    getPrefixCls: p
  } = m.useContext(Mt), g = p("popover", n), [v, y, x] = w7(g), b = p(), w = Ue(o, y, x);
  return v(/* @__PURE__ */ m.createElement(BS, Object.assign({
    placement: a,
    trigger: s,
    mouseEnterDelay: l,
    mouseLeaveDelay: c,
    overlayStyle: f
  }, d, {
    prefixCls: g,
    overlayClassName: w,
    ref: t,
    overlay: r || i ? /* @__PURE__ */ m.createElement(B1e, {
      prefixCls: g,
      title: r,
      content: i
    }) : null,
    transitionName: zf(b, "zoom-big", d.transitionName),
    "data-popover-inject": !0
  })));
});
S7._InternalPanelDoNotUseOrYouWillBeFired = j1e;
const z1e = S7, QD = (e) => {
  const {
    size: t,
    shape: n
  } = m.useContext(OT), r = m.useMemo(() => ({
    size: e.size || t,
    shape: e.shape || n
  }), [e.size, e.shape, t, n]);
  return /* @__PURE__ */ m.createElement(OT.Provider, {
    value: r
  }, e.children);
}, U1e = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = m.useContext(Mt), {
    prefixCls: r,
    className: i,
    rootClassName: o,
    style: a,
    maxCount: s,
    maxStyle: l,
    size: c,
    shape: f,
    maxPopoverPlacement: d = "top",
    maxPopoverTrigger: p = "hover",
    children: g
  } = e, v = t("avatar", r), y = `${v}-group`, x = xc(v), [b, w, S] = a7(v, x), E = Ue(y, {
    [`${y}-rtl`]: n === "rtl"
  }, S, x, i, o, w), O = vc(g).map((P, R) => Oa(P, {
    key: `avatar-key-${R}`
  })), $ = O.length;
  if (s && s < $) {
    const P = O.slice(0, s), R = O.slice(s, $);
    return P.push(/* @__PURE__ */ m.createElement(z1e, {
      key: "avatar-popover-key",
      content: R,
      trigger: p,
      placement: d,
      overlayClassName: `${y}-popover`,
      destroyTooltipOnHide: !0
    }, /* @__PURE__ */ m.createElement(s7, {
      style: l
    }, `+${$ - s}`))), b(/* @__PURE__ */ m.createElement(QD, {
      shape: f,
      size: c
    }, /* @__PURE__ */ m.createElement("div", {
      className: E,
      style: a
    }, P)));
  }
  return b(/* @__PURE__ */ m.createElement(QD, {
    shape: f,
    size: c
  }, /* @__PURE__ */ m.createElement("div", {
    className: E,
    style: a
  }, O)));
}, H1e = U1e, x7 = s7;
x7.Group = H1e;
const JD = x7, W1e = new Tn("antStatusProcessing", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0.5
  },
  "100%": {
    transform: "scale(2.4)",
    opacity: 0
  }
}), V1e = new Tn("antZoomBadgeIn", {
  "0%": {
    transform: "scale(0) translate(50%, -50%)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1) translate(50%, -50%)"
  }
}), G1e = new Tn("antZoomBadgeOut", {
  "0%": {
    transform: "scale(1) translate(50%, -50%)"
  },
  "100%": {
    transform: "scale(0) translate(50%, -50%)",
    opacity: 0
  }
}), K1e = new Tn("antNoWrapperZoomBadgeIn", {
  "0%": {
    transform: "scale(0)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)"
  }
}), q1e = new Tn("antNoWrapperZoomBadgeOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0)",
    opacity: 0
  }
}), Y1e = new Tn("antBadgeLoadingCircle", {
  "0%": {
    transformOrigin: "50%"
  },
  "100%": {
    transform: "translate(50%, -50%) rotate(360deg)",
    transformOrigin: "50%"
  }
}), X1e = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    antCls: r,
    badgeShadowSize: i,
    motionDurationSlow: o,
    textFontSize: a,
    textFontSizeSM: s,
    statusSize: l,
    dotSize: c,
    textFontWeight: f,
    indicatorHeight: d,
    indicatorHeightSM: p,
    marginXS: g,
    calc: v
  } = e, y = `${r}-scroll-number`, x = eS(e, (b, w) => {
    let {
      darkColor: S
    } = w;
    return {
      [`&${t} ${t}-color-${b}`]: {
        background: S,
        [`&:not(${t}-count)`]: {
          color: S
        }
      }
    };
  });
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Vi(e)), {
      position: "relative",
      display: "inline-block",
      width: "fit-content",
      lineHeight: 1,
      [`${t}-count`]: {
        zIndex: e.indicatorZIndex,
        minWidth: d,
        height: d,
        color: e.badgeTextColor,
        fontWeight: f,
        fontSize: a,
        lineHeight: ge(d),
        whiteSpace: "nowrap",
        textAlign: "center",
        background: e.badgeColor,
        borderRadius: v(d).div(2).equal(),
        boxShadow: `0 0 0 ${ge(i)} ${e.badgeShadowColor}`,
        transition: `background ${e.motionDurationMid}`,
        a: {
          color: e.badgeTextColor
        },
        "a:hover": {
          color: e.badgeTextColor
        },
        "a:hover &": {
          background: e.badgeColorHover
        }
      },
      [`${t}-count-sm`]: {
        minWidth: p,
        height: p,
        fontSize: s,
        lineHeight: ge(p),
        borderRadius: v(p).div(2).equal()
      },
      [`${t}-multiple-words`]: {
        padding: `0 ${ge(e.paddingXS)}`,
        bdi: {
          unicodeBidi: "plaintext"
        }
      },
      [`${t}-dot`]: {
        zIndex: e.indicatorZIndex,
        width: c,
        minWidth: c,
        height: c,
        background: e.badgeColor,
        borderRadius: "100%",
        boxShadow: `0 0 0 ${ge(i)} ${e.badgeShadowColor}`
      },
      [`${t}-dot${y}`]: {
        transition: `background ${o}`
      },
      [`${t}-count, ${t}-dot, ${y}-custom-component`]: {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        transform: "translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&${n}-spin`]: {
          animationName: Y1e,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        }
      },
      [`&${t}-status`]: {
        lineHeight: "inherit",
        verticalAlign: "baseline",
        [`${t}-status-dot`]: {
          position: "relative",
          top: -1,
          // Magic number, but seems better experience
          display: "inline-block",
          width: l,
          height: l,
          verticalAlign: "middle",
          borderRadius: "50%"
        },
        [`${t}-status-success`]: {
          backgroundColor: e.colorSuccess
        },
        [`${t}-status-processing`]: {
          overflow: "visible",
          color: e.colorPrimary,
          backgroundColor: e.colorPrimary,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineStart: 0,
            width: "100%",
            height: "100%",
            borderWidth: i,
            borderStyle: "solid",
            borderColor: "inherit",
            borderRadius: "50%",
            animationName: W1e,
            animationDuration: e.badgeProcessingDuration,
            animationIterationCount: "infinite",
            animationTimingFunction: "ease-in-out",
            content: '""'
          }
        },
        [`${t}-status-default`]: {
          backgroundColor: e.colorTextPlaceholder
        },
        [`${t}-status-error`]: {
          backgroundColor: e.colorError
        },
        [`${t}-status-warning`]: {
          backgroundColor: e.colorWarning
        },
        [`${t}-status-text`]: {
          marginInlineStart: g,
          color: e.colorText,
          fontSize: e.fontSize
        }
      }
    }), x), {
      [`${t}-zoom-appear, ${t}-zoom-enter`]: {
        animationName: V1e,
        animationDuration: e.motionDurationSlow,
        animationTimingFunction: e.motionEaseOutBack,
        animationFillMode: "both"
      },
      [`${t}-zoom-leave`]: {
        animationName: G1e,
        animationDuration: e.motionDurationSlow,
        animationTimingFunction: e.motionEaseOutBack,
        animationFillMode: "both"
      },
      [`&${t}-not-a-wrapper`]: {
        [`${t}-zoom-appear, ${t}-zoom-enter`]: {
          animationName: K1e,
          animationDuration: e.motionDurationSlow,
          animationTimingFunction: e.motionEaseOutBack
        },
        [`${t}-zoom-leave`]: {
          animationName: q1e,
          animationDuration: e.motionDurationSlow,
          animationTimingFunction: e.motionEaseOutBack
        },
        [`&:not(${t}-status)`]: {
          verticalAlign: "middle"
        },
        [`${y}-custom-component, ${t}-count`]: {
          transform: "none"
        },
        [`${y}-custom-component, ${y}`]: {
          position: "relative",
          top: "auto",
          display: "block",
          transformOrigin: "50% 50%"
        }
      },
      [`${y}`]: {
        overflow: "hidden",
        [`${y}-only`]: {
          position: "relative",
          display: "inline-block",
          height: d,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseOutBack}`,
          WebkitTransformStyle: "preserve-3d",
          WebkitBackfaceVisibility: "hidden",
          [`> p${y}-only-unit`]: {
            height: d,
            margin: 0,
            WebkitTransformStyle: "preserve-3d",
            WebkitBackfaceVisibility: "hidden"
          }
        },
        [`${y}-symbol`]: {
          verticalAlign: "top"
        }
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl",
        [`${t}-count, ${t}-dot, ${y}-custom-component`]: {
          transform: "translate(-50%, -50%)"
        }
      }
    })
  };
}, C7 = (e) => {
  const {
    fontHeight: t,
    lineWidth: n,
    marginXS: r,
    colorBorderBg: i
  } = e, o = t, a = n, s = e.colorBgContainer, l = e.colorError, c = e.colorErrorHover;
  return _r(e, {
    badgeFontHeight: o,
    badgeShadowSize: a,
    badgeTextColor: s,
    badgeColor: l,
    badgeColorHover: c,
    badgeShadowColor: i,
    badgeProcessingDuration: "1.2s",
    badgeRibbonOffset: r,
    // Follow token just by Design. Not related with token
    badgeRibbonCornerTransform: "scaleY(0.75)",
    badgeRibbonCornerFilter: "brightness(75%)"
  });
}, E7 = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    fontSizeSM: r,
    lineWidth: i
  } = e;
  return {
    indicatorZIndex: "auto",
    indicatorHeight: Math.round(t * n) - 2 * i,
    indicatorHeightSM: t,
    dotSize: r / 2,
    textFontSize: r,
    textFontSizeSM: r,
    textFontWeight: "normal",
    statusSize: r / 2
  };
}, Q1e = Pi("Badge", (e) => {
  const t = C7(e);
  return X1e(t);
}, E7), J1e = (e) => {
  const {
    antCls: t,
    badgeFontHeight: n,
    marginXS: r,
    badgeRibbonOffset: i,
    calc: o
  } = e, a = `${t}-ribbon`, s = `${t}-ribbon-wrapper`, l = eS(e, (c, f) => {
    let {
      darkColor: d
    } = f;
    return {
      [`&${a}-color-${c}`]: {
        background: d,
        color: d
      }
    };
  });
  return {
    [`${s}`]: {
      position: "relative"
    },
    [`${a}`]: Object.assign(Object.assign(Object.assign(Object.assign({}, Vi(e)), {
      position: "absolute",
      top: r,
      padding: `0 ${ge(e.paddingXS)}`,
      color: e.colorPrimary,
      lineHeight: ge(n),
      whiteSpace: "nowrap",
      backgroundColor: e.colorPrimary,
      borderRadius: e.borderRadiusSM,
      [`${a}-text`]: {
        color: e.colorTextLightSolid
      },
      [`${a}-corner`]: {
        position: "absolute",
        top: "100%",
        width: i,
        height: i,
        color: "currentcolor",
        border: `${ge(o(i).div(2).equal())} solid`,
        transform: e.badgeRibbonCornerTransform,
        transformOrigin: "top",
        filter: e.badgeRibbonCornerFilter
      }
    }), l), {
      [`&${a}-placement-end`]: {
        insetInlineEnd: o(i).mul(-1).equal(),
        borderEndEndRadius: 0,
        [`${a}-corner`]: {
          insetInlineEnd: 0,
          borderInlineEndColor: "transparent",
          borderBlockEndColor: "transparent"
        }
      },
      [`&${a}-placement-start`]: {
        insetInlineStart: o(i).mul(-1).equal(),
        borderEndStartRadius: 0,
        [`${a}-corner`]: {
          insetInlineStart: 0,
          borderBlockEndColor: "transparent",
          borderInlineStartColor: "transparent"
        }
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, Z1e = Pi(["Badge", "Ribbon"], (e) => {
  const t = C7(e);
  return J1e(t);
}, E7), ewe = (e) => {
  const {
    className: t,
    prefixCls: n,
    style: r,
    color: i,
    children: o,
    text: a,
    placement: s = "end",
    rootClassName: l
  } = e, {
    getPrefixCls: c,
    direction: f
  } = m.useContext(Mt), d = c("ribbon", n), p = `${d}-wrapper`, [g, v, y] = Z1e(d, p), x = FS(i, !1), b = Ue(d, `${d}-placement-${s}`, {
    [`${d}-rtl`]: f === "rtl",
    [`${d}-color-${i}`]: x
  }, t), w = {}, S = {};
  return i && !x && (w.background = i, S.color = i), g(/* @__PURE__ */ m.createElement("div", {
    className: Ue(p, l, v, y)
  }, o, /* @__PURE__ */ m.createElement("div", {
    className: Ue(b, v),
    style: Object.assign(Object.assign({}, w), r)
  }, /* @__PURE__ */ m.createElement("span", {
    className: `${d}-text`
  }, a), /* @__PURE__ */ m.createElement("div", {
    className: `${d}-corner`,
    style: S
  }))));
}, twe = ewe;
function ZD(e) {
  let {
    prefixCls: t,
    value: n,
    current: r,
    offset: i = 0
  } = e, o;
  return i && (o = {
    position: "absolute",
    top: `${i}00%`,
    left: 0
  }), /* @__PURE__ */ m.createElement("span", {
    style: o,
    className: Ue(`${t}-only-unit`, {
      current: r
    })
  }, n);
}
function nwe(e, t, n) {
  let r = e, i = 0;
  for (; (r + 10) % 10 !== t; )
    r += n, i += n;
  return i;
}
function rwe(e) {
  const {
    prefixCls: t,
    count: n,
    value: r
  } = e, i = Number(r), o = Math.abs(n), [a, s] = m.useState(i), [l, c] = m.useState(o), f = () => {
    s(i), c(o);
  };
  m.useEffect(() => {
    const g = setTimeout(() => {
      f();
    }, 1e3);
    return () => {
      clearTimeout(g);
    };
  }, [i]);
  let d, p;
  if (a === i || Number.isNaN(i) || Number.isNaN(a))
    d = [/* @__PURE__ */ m.createElement(ZD, Object.assign({}, e, {
      key: i,
      current: !0
    }))], p = {
      transition: "none"
    };
  else {
    d = [];
    const g = i + 10, v = [];
    for (let b = i; b <= g; b += 1)
      v.push(b);
    const y = v.findIndex((b) => b % 10 === a);
    d = v.map((b, w) => {
      const S = b % 10;
      return /* @__PURE__ */ m.createElement(ZD, Object.assign({}, e, {
        key: b,
        value: S,
        offset: w - y,
        current: w === y
      }));
    });
    const x = l < o ? 1 : -1;
    p = {
      transform: `translateY(${-nwe(a, i, x)}00%)`
    };
  }
  return /* @__PURE__ */ m.createElement("span", {
    className: `${t}-only`,
    style: p,
    onTransitionEnd: f
  }, d);
}
var iwe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const owe = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    prefixCls: n,
    count: r,
    className: i,
    motionClassName: o,
    style: a,
    title: s,
    show: l,
    component: c = "sup",
    children: f
  } = e, d = iwe(e, ["prefixCls", "count", "className", "motionClassName", "style", "title", "show", "component", "children"]), {
    getPrefixCls: p
  } = m.useContext(Mt), g = p("scroll-number", n), v = Object.assign(Object.assign({}, d), {
    "data-show": l,
    style: a,
    className: Ue(g, i, o),
    title: s
  });
  let y = r;
  if (r && Number(r) % 1 === 0) {
    const x = String(r).split("");
    y = /* @__PURE__ */ m.createElement("bdi", null, x.map((b, w) => /* @__PURE__ */ m.createElement(rwe, {
      prefixCls: g,
      count: Number(r),
      value: b,
      // eslint-disable-next-line react/no-array-index-key
      key: x.length - w
    })));
  }
  return a && a.borderColor && (v.style = Object.assign(Object.assign({}, a), {
    boxShadow: `0 0 0 1px ${a.borderColor} inset`
  })), f ? Oa(f, (x) => ({
    className: Ue(`${g}-custom-component`, x == null ? void 0 : x.className, o)
  })) : /* @__PURE__ */ m.createElement(c, Object.assign({}, v, {
    ref: t
  }), y);
}), awe = owe;
var swe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const lwe = (e, t) => {
  var n, r, i, o, a;
  const {
    prefixCls: s,
    scrollNumberPrefixCls: l,
    children: c,
    status: f,
    text: d,
    color: p,
    count: g = null,
    overflowCount: v = 99,
    dot: y = !1,
    size: x = "default",
    title: b,
    offset: w,
    style: S,
    className: E,
    rootClassName: O,
    classNames: $,
    styles: P,
    showZero: R = !1
  } = e, L = swe(e, ["prefixCls", "scrollNumberPrefixCls", "children", "status", "text", "color", "count", "overflowCount", "dot", "size", "title", "offset", "style", "className", "rootClassName", "classNames", "styles", "showZero"]), {
    getPrefixCls: B,
    direction: j,
    badge: A
  } = m.useContext(Mt), T = B("badge", s), [k, F, W] = Q1e(T), V = g > v ? `${v}+` : g, G = V === "0" || V === 0, X = g === null || G && !R, D = (f != null || p != null) && X, te = y && !G, ee = te ? "" : V, U = m.useMemo(() => (ee == null || ee === "" || G && !R) && !te, [ee, G, R, te]), he = m.useRef(g);
  U || (he.current = g);
  const re = he.current, de = m.useRef(ee);
  U || (de.current = ee);
  const we = de.current, ue = m.useRef(te);
  U || (ue.current = te);
  const me = m.useMemo(() => {
    if (!w)
      return Object.assign(Object.assign({}, A == null ? void 0 : A.style), S);
    const De = {
      marginTop: w[1]
    };
    return j === "rtl" ? De.left = parseInt(w[0], 10) : De.right = -parseInt(w[0], 10), Object.assign(Object.assign(Object.assign({}, De), A == null ? void 0 : A.style), S);
  }, [j, w, S, A == null ? void 0 : A.style]), Se = b ?? (typeof re == "string" || typeof re == "number" ? re : void 0), _e = U || !d ? null : /* @__PURE__ */ m.createElement("span", {
    className: `${T}-status-text`
  }, d), Ge = !re || typeof re != "object" ? void 0 : Oa(re, (De) => ({
    style: Object.assign(Object.assign({}, me), De.style)
  })), Fe = FS(p, !1), Ae = Ue($ == null ? void 0 : $.indicator, (n = A == null ? void 0 : A.classNames) === null || n === void 0 ? void 0 : n.indicator, {
    [`${T}-status-dot`]: D,
    [`${T}-status-${f}`]: !!f,
    [`${T}-color-${p}`]: Fe
  }), Me = {};
  p && !Fe && (Me.color = p, Me.background = p);
  const et = Ue(T, {
    [`${T}-status`]: D,
    [`${T}-not-a-wrapper`]: !c,
    [`${T}-rtl`]: j === "rtl"
  }, E, O, A == null ? void 0 : A.className, (r = A == null ? void 0 : A.classNames) === null || r === void 0 ? void 0 : r.root, $ == null ? void 0 : $.root, F, W);
  if (!c && D) {
    const De = me.color;
    return k(/* @__PURE__ */ m.createElement("span", Object.assign({}, L, {
      className: et,
      style: Object.assign(Object.assign(Object.assign({}, P == null ? void 0 : P.root), (i = A == null ? void 0 : A.styles) === null || i === void 0 ? void 0 : i.root), me)
    }), /* @__PURE__ */ m.createElement("span", {
      className: Ae,
      style: Object.assign(Object.assign(Object.assign({}, P == null ? void 0 : P.indicator), (o = A == null ? void 0 : A.styles) === null || o === void 0 ? void 0 : o.indicator), Me)
    }), d && /* @__PURE__ */ m.createElement("span", {
      style: {
        color: De
      },
      className: `${T}-status-text`
    }, d)));
  }
  return k(/* @__PURE__ */ m.createElement("span", Object.assign({
    ref: t
  }, L, {
    className: et,
    style: Object.assign(Object.assign({}, (a = A == null ? void 0 : A.styles) === null || a === void 0 ? void 0 : a.root), P == null ? void 0 : P.root)
  }), c, /* @__PURE__ */ m.createElement(fS, {
    visible: !U,
    motionName: `${T}-zoom`,
    motionAppear: !1,
    motionDeadline: 1e3
  }, (De) => {
    let {
      className: je,
      ref: ie
    } = De;
    var fe, be;
    const Te = B("scroll-number", l), Le = ue.current, ct = Ue($ == null ? void 0 : $.indicator, (fe = A == null ? void 0 : A.classNames) === null || fe === void 0 ? void 0 : fe.indicator, {
      [`${T}-dot`]: Le,
      [`${T}-count`]: !Le,
      [`${T}-count-sm`]: x === "small",
      [`${T}-multiple-words`]: !Le && we && we.toString().length > 1,
      [`${T}-status-${f}`]: !!f,
      [`${T}-color-${p}`]: Fe
    });
    let Z = Object.assign(Object.assign(Object.assign({}, P == null ? void 0 : P.indicator), (be = A == null ? void 0 : A.styles) === null || be === void 0 ? void 0 : be.indicator), me);
    return p && !Fe && (Z = Z || {}, Z.background = p), /* @__PURE__ */ m.createElement(awe, {
      prefixCls: Te,
      show: !U,
      motionClassName: je,
      className: ct,
      count: we,
      title: Se,
      style: Z,
      key: "scrollNumber",
      ref: ie
    }, Ge);
  }), _e));
}, $7 = /* @__PURE__ */ m.forwardRef(lwe);
$7.Ribbon = twe;
const _7 = $7;
var cwe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const uwe = cwe;
var fwe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: uwe
  }));
}, dwe = /* @__PURE__ */ m.forwardRef(fwe);
const pwe = dwe;
var hwe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" };
const mwe = hwe;
var gwe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: mwe
  }));
}, vwe = /* @__PURE__ */ m.forwardRef(gwe);
const ywe = vwe, O7 = /* @__PURE__ */ m.createContext(null), bwe = O7.Provider, P7 = /* @__PURE__ */ m.createContext(null), wwe = P7.Provider;
function G$(e) {
  return e !== void 0;
}
function c2(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = xp(function() {
    return G$(i) ? i : G$(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = ke(s, 2), c = l[0], f = l[1], d = i !== void 0 ? i : c, p = a ? a(d) : d, g = $T(o), v = xp([d]), y = ke(v, 2), x = y[0], b = y[1];
  Z4(function() {
    var S = x[0];
    c !== S && g(c, S);
  }, [x]), Z4(function() {
    G$(i) || f(i);
  }, [i]);
  var w = $T(function(S, E) {
    f(S, E), b([d], E);
  });
  return [p, w];
}
var Swe = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], xwe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-checkbox" : n, i = e.className, o = e.style, a = e.checked, s = e.disabled, l = e.defaultChecked, c = l === void 0 ? !1 : l, f = e.type, d = f === void 0 ? "checkbox" : f, p = e.title, g = e.onChange, v = _n(e, Swe), y = m.useRef(null), x = c2(c, {
    value: a
  }), b = ke(x, 2), w = b[0], S = b[1];
  m.useImperativeHandle(t, function() {
    return {
      focus: function(P) {
        var R;
        (R = y.current) === null || R === void 0 || R.focus(P);
      },
      blur: function() {
        var P;
        (P = y.current) === null || P === void 0 || P.blur();
      },
      input: y.current
    };
  });
  var E = ft(r, i, ce(ce({}, "".concat(r, "-checked"), w), "".concat(r, "-disabled"), s)), O = function(P) {
    s || ("checked" in e || S(P.target.checked), g == null || g({
      target: ye(ye({}, e), {}, {
        type: d,
        checked: P.target.checked
      }),
      stopPropagation: function() {
        P.stopPropagation();
      },
      preventDefault: function() {
        P.preventDefault();
      },
      nativeEvent: P.nativeEvent
    }));
  };
  return /* @__PURE__ */ m.createElement("span", {
    className: E,
    title: p,
    style: o
  }, /* @__PURE__ */ m.createElement("input", jt({}, v, {
    className: "".concat(r, "-input"),
    ref: y,
    onChange: O,
    disabled: s,
    checked: !!w,
    type: d
  })), /* @__PURE__ */ m.createElement("span", {
    className: "".concat(r, "-inner")
  }));
});
const Cwe = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-group`;
  return {
    [r]: Object.assign(Object.assign({}, Vi(e)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${r}-rtl`]: {
        direction: "rtl"
      },
      [`${n}-badge ${n}-badge-count`]: {
        zIndex: 1
      },
      [`> ${n}-badge:not(:first-child) > ${n}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, Ewe = (e) => {
  const {
    componentCls: t,
    wrapperMarginInlineEnd: n,
    colorPrimary: r,
    radioSize: i,
    motionDurationSlow: o,
    motionDurationMid: a,
    motionEaseInOutCirc: s,
    colorBgContainer: l,
    colorBorder: c,
    lineWidth: f,
    colorBgContainerDisabled: d,
    colorTextDisabled: p,
    paddingXS: g,
    dotColorDisabled: v,
    lineType: y,
    radioColor: x,
    radioBgColor: b,
    calc: w
  } = e, S = `${t}-inner`, E = 4, O = w(i).sub(w(E).mul(2)), $ = w(1).mul(i).equal();
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, Vi(e)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: n,
      cursor: "pointer",
      // RTL
      [`&${t}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: e.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      // hashId 在 wrapper 上，只能铺平
      [`${t}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${ge(f)} ${y} ${r}`,
        borderRadius: "50%",
        visibility: "hidden",
        opacity: 0,
        content: '""'
      },
      [t]: Object.assign(Object.assign({}, Vi(e)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${t}-wrapper:hover &,
        &:hover ${S}`]: {
        borderColor: r
      },
      [`${t}-input:focus-visible + ${S}`]: Object.assign({}, AR(e)),
      [`${t}:hover::after, ${t}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${t}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: $,
          height: $,
          marginBlockStart: w(1).mul(i).div(-2).equal(),
          marginInlineStart: w(1).mul(i).div(-2).equal(),
          backgroundColor: x,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: $,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${o} ${s}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: $,
        height: $,
        backgroundColor: l,
        borderColor: c,
        borderStyle: "solid",
        borderWidth: f,
        borderRadius: "50%",
        transition: `all ${a}`
      },
      [`${t}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${t}-checked`]: {
        [S]: {
          borderColor: r,
          backgroundColor: b,
          "&::after": {
            transform: `scale(${e.calc(e.dotSize).div(i).equal()})`,
            opacity: 1,
            transition: `all ${o} ${s}`
          }
        }
      },
      [`${t}-disabled`]: {
        cursor: "not-allowed",
        [S]: {
          backgroundColor: d,
          borderColor: c,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: v
          }
        },
        [`${t}-input`]: {
          cursor: "not-allowed"
        },
        [`${t}-disabled + span`]: {
          color: p,
          cursor: "not-allowed"
        },
        [`&${t}-checked`]: {
          [S]: {
            "&::after": {
              transform: `scale(${w(O).div(i).equal({
                unit: !1
              })})`
            }
          }
        }
      },
      [`span${t} + *`]: {
        paddingInlineStart: g,
        paddingInlineEnd: g
      }
    })
  };
}, $we = (e) => {
  const {
    buttonColor: t,
    controlHeight: n,
    componentCls: r,
    lineWidth: i,
    lineType: o,
    colorBorder: a,
    motionDurationSlow: s,
    motionDurationMid: l,
    buttonPaddingInline: c,
    fontSize: f,
    buttonBg: d,
    fontSizeLG: p,
    controlHeightLG: g,
    controlHeightSM: v,
    paddingXS: y,
    borderRadius: x,
    borderRadiusSM: b,
    borderRadiusLG: w,
    buttonCheckedBg: S,
    buttonSolidCheckedColor: E,
    colorTextDisabled: O,
    colorBgContainerDisabled: $,
    buttonCheckedBgDisabled: P,
    buttonCheckedColorDisabled: R,
    colorPrimary: L,
    colorPrimaryHover: B,
    colorPrimaryActive: j,
    buttonSolidCheckedBg: A,
    buttonSolidCheckedHoverBg: T,
    buttonSolidCheckedActiveBg: k,
    calc: F
  } = e;
  return {
    [`${r}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: n,
      margin: 0,
      paddingInline: c,
      paddingBlock: 0,
      color: t,
      fontSize: f,
      lineHeight: ge(F(n).sub(F(i).mul(2)).equal()),
      background: d,
      border: `${ge(i)} ${o} ${a}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: F(i).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: i,
      cursor: "pointer",
      transition: [`color ${l}`, `background ${l}`, `box-shadow ${l}`].join(","),
      a: {
        color: t
      },
      [`> ${r}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:first-child)": {
        "&::before": {
          position: "absolute",
          insetBlockStart: F(i).mul(-1).equal(),
          insetInlineStart: F(i).mul(-1).equal(),
          display: "block",
          boxSizing: "content-box",
          width: 1,
          height: "100%",
          paddingBlock: i,
          paddingInline: 0,
          backgroundColor: a,
          transition: `background-color ${s}`,
          content: '""'
        }
      },
      "&:first-child": {
        borderInlineStart: `${ge(i)} ${o} ${a}`,
        borderStartStartRadius: x,
        borderEndStartRadius: x
      },
      "&:last-child": {
        borderStartEndRadius: x,
        borderEndEndRadius: x
      },
      "&:first-child:last-child": {
        borderRadius: x
      },
      [`${r}-group-large &`]: {
        height: g,
        fontSize: p,
        lineHeight: ge(F(g).sub(F(i).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: w,
          borderEndStartRadius: w
        },
        "&:last-child": {
          borderStartEndRadius: w,
          borderEndEndRadius: w
        }
      },
      [`${r}-group-small &`]: {
        height: v,
        paddingInline: F(y).sub(i).equal(),
        paddingBlock: 0,
        lineHeight: ge(F(v).sub(F(i).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: b,
          borderEndStartRadius: b
        },
        "&:last-child": {
          borderStartEndRadius: b,
          borderEndEndRadius: b
        }
      },
      "&:hover": {
        position: "relative",
        color: L
      },
      "&:has(:focus-visible)": Object.assign({}, AR(e)),
      [`${r}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${r}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: L,
        background: S,
        borderColor: L,
        "&::before": {
          backgroundColor: L
        },
        "&:first-child": {
          borderColor: L
        },
        "&:hover": {
          color: B,
          borderColor: B,
          "&::before": {
            backgroundColor: B
          }
        },
        "&:active": {
          color: j,
          borderColor: j,
          "&::before": {
            backgroundColor: j
          }
        }
      },
      [`${r}-group-solid &-checked:not(${r}-button-wrapper-disabled)`]: {
        color: E,
        background: A,
        borderColor: A,
        "&:hover": {
          color: E,
          background: T,
          borderColor: T
        },
        "&:active": {
          color: E,
          background: k,
          borderColor: k
        }
      },
      "&-disabled": {
        color: O,
        backgroundColor: $,
        borderColor: a,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: O,
          backgroundColor: $,
          borderColor: a
        }
      },
      [`&-disabled${r}-button-wrapper-checked`]: {
        color: R,
        backgroundColor: P,
        borderColor: a,
        boxShadow: "none"
      }
    }
  };
}, _we = (e) => {
  const {
    wireframe: t,
    padding: n,
    marginXS: r,
    lineWidth: i,
    fontSizeLG: o,
    colorText: a,
    colorBgContainer: s,
    colorTextDisabled: l,
    controlItemBgActiveDisabled: c,
    colorTextLightSolid: f,
    colorPrimary: d,
    colorPrimaryHover: p,
    colorPrimaryActive: g,
    colorWhite: v
  } = e, y = 4, x = o, b = t ? x - y * 2 : x - (y + i) * 2;
  return {
    // Radio
    radioSize: x,
    dotSize: b,
    dotColorDisabled: l,
    // Radio buttons
    buttonSolidCheckedColor: f,
    buttonSolidCheckedBg: d,
    buttonSolidCheckedHoverBg: p,
    buttonSolidCheckedActiveBg: g,
    buttonBg: s,
    buttonCheckedBg: s,
    buttonColor: a,
    buttonCheckedBgDisabled: c,
    buttonCheckedColorDisabled: l,
    buttonPaddingInline: n - i,
    wrapperMarginInlineEnd: r,
    // internal
    radioColor: t ? d : v,
    radioBgColor: t ? s : d
  };
}, T7 = Pi("Radio", (e) => {
  const {
    controlOutline: t,
    controlOutlineWidth: n
  } = e, r = `0 0 0 ${ge(n)} ${t}`, o = _r(e, {
    radioFocusShadow: r,
    radioButtonFocusShadow: r
  });
  return [Cwe(o), Ewe(o), $we(o)];
}, _we, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var Owe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Pwe = (e, t) => {
  var n, r;
  const i = m.useContext(O7), o = m.useContext(P7), {
    getPrefixCls: a,
    direction: s,
    radio: l
  } = m.useContext(Mt), c = m.useRef(null), f = Sc(t, c), {
    isFormItemInput: d
  } = m.useContext(Uf), p = (k) => {
    var F, W;
    (F = e.onChange) === null || F === void 0 || F.call(e, k), (W = i == null ? void 0 : i.onChange) === null || W === void 0 || W.call(i, k);
  }, {
    prefixCls: g,
    className: v,
    rootClassName: y,
    children: x,
    style: b,
    title: w
  } = e, S = Owe(e, ["prefixCls", "className", "rootClassName", "children", "style", "title"]), E = a("radio", g), O = ((i == null ? void 0 : i.optionType) || o) === "button", $ = O ? `${E}-button` : E, P = xc(E), [R, L, B] = T7(E, P), j = Object.assign({}, S), A = m.useContext(sv);
  i && (j.name = i.name, j.onChange = p, j.checked = e.value === i.value, j.disabled = (n = j.disabled) !== null && n !== void 0 ? n : i.disabled), j.disabled = (r = j.disabled) !== null && r !== void 0 ? r : A;
  const T = Ue(`${$}-wrapper`, {
    [`${$}-wrapper-checked`]: j.checked,
    [`${$}-wrapper-disabled`]: j.disabled,
    [`${$}-wrapper-rtl`]: s === "rtl",
    [`${$}-wrapper-in-form-item`]: d
  }, l == null ? void 0 : l.className, v, y, L, B, P);
  return R(/* @__PURE__ */ m.createElement(XR, {
    component: "Radio",
    disabled: j.disabled
  }, /* @__PURE__ */ m.createElement("label", {
    className: T,
    style: Object.assign(Object.assign({}, l == null ? void 0 : l.style), b),
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    title: w
  }, /* @__PURE__ */ m.createElement(xwe, Object.assign({}, j, {
    className: Ue(j.className, !O && YR),
    type: "radio",
    prefixCls: $,
    ref: f
  })), x !== void 0 ? /* @__PURE__ */ m.createElement("span", null, x) : null)));
}, Twe = /* @__PURE__ */ m.forwardRef(Pwe), D1 = Twe, Iwe = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r
  } = m.useContext(Mt), [i, o] = TR(e.defaultValue, {
    value: e.value
  }), a = (k) => {
    const F = i, W = k.target.value;
    "value" in e || o(W);
    const {
      onChange: V
    } = e;
    V && W !== F && V(k);
  }, {
    prefixCls: s,
    className: l,
    rootClassName: c,
    options: f,
    buttonStyle: d = "outline",
    disabled: p,
    children: g,
    size: v,
    style: y,
    id: x,
    onMouseEnter: b,
    onMouseLeave: w,
    onFocus: S,
    onBlur: E
  } = e, O = n("radio", s), $ = `${O}-group`, P = xc(O), [R, L, B] = T7(O, P);
  let j = g;
  f && f.length > 0 && (j = f.map((k) => typeof k == "string" || typeof k == "number" ? /* @__PURE__ */ m.createElement(D1, {
    key: k.toString(),
    prefixCls: O,
    disabled: p,
    value: k,
    checked: i === k
  }, k) : /* @__PURE__ */ m.createElement(D1, {
    key: `radio-group-value-options-${k.value}`,
    prefixCls: O,
    disabled: k.disabled || p,
    value: k.value,
    checked: i === k.value,
    title: k.title,
    style: k.style,
    id: k.id,
    required: k.required
  }, k.label)));
  const A = Rl(v), T = Ue($, `${$}-${d}`, {
    [`${$}-${A}`]: A,
    [`${$}-rtl`]: r === "rtl"
  }, l, c, L, B, P);
  return R(/* @__PURE__ */ m.createElement("div", Object.assign({}, R9(e, {
    aria: !0,
    data: !0
  }), {
    className: T,
    style: y,
    onMouseEnter: b,
    onMouseLeave: w,
    onFocus: S,
    onBlur: E,
    id: x,
    ref: t
  }), /* @__PURE__ */ m.createElement(bwe, {
    value: {
      onChange: a,
      value: i,
      disabled: e.disabled,
      name: e.name,
      optionType: e.optionType
    }
  }, j)));
}), Awe = /* @__PURE__ */ m.memo(Iwe);
var Rwe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Mwe = (e, t) => {
  const {
    getPrefixCls: n
  } = m.useContext(Mt), {
    prefixCls: r
  } = e, i = Rwe(e, ["prefixCls"]), o = n("radio", r);
  return /* @__PURE__ */ m.createElement(wwe, {
    value: "button"
  }, /* @__PURE__ */ m.createElement(D1, Object.assign({
    prefixCls: o
  }, i, {
    type: "radio",
    ref: t
  })));
}, Nwe = /* @__PURE__ */ m.forwardRef(Mwe), zS = D1;
zS.Button = Nwe;
zS.Group = Awe;
zS.__ANT_RADIO = !0;
const ej = zS;
function kwe(e) {
  return _r(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const Lwe = (e) => {
  const {
    controlHeight: t,
    fontSize: n,
    lineHeight: r,
    lineWidth: i,
    controlHeightSM: o,
    controlHeightLG: a,
    fontSizeLG: s,
    lineHeightLG: l,
    paddingSM: c,
    controlPaddingHorizontalSM: f,
    controlPaddingHorizontal: d,
    colorFillAlter: p,
    colorPrimaryHover: g,
    colorPrimary: v,
    controlOutlineWidth: y,
    controlOutline: x,
    colorErrorOutline: b,
    colorWarningOutline: w,
    colorBgContainer: S
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockSM: Math.max(Math.round((o - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockLG: Math.ceil((a - s * l) / 2 * 10) / 10 - i,
    paddingInline: c - i,
    paddingInlineSM: f - i,
    paddingInlineLG: d - i,
    addonBg: p,
    activeBorderColor: v,
    hoverBorderColor: g,
    activeShadow: `0 0 0 ${y}px ${x}`,
    errorActiveShadow: `0 0 0 ${y}px ${b}`,
    warningActiveShadow: `0 0 0 ${y}px ${w}`,
    hoverBg: S,
    activeBg: S,
    inputFontSize: n,
    inputFontSizeLG: s,
    inputFontSizeSM: n
  };
}, Dwe = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), u2 = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, Dwe(_r(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), I7 = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), tj = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, I7(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), jwe = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, I7(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, u2(e))
  }), tj(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), tj(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), nj = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), Fwe = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, nj(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), nj(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, u2(e))
    }
  })
}), Bwe = (e, t) => ({
  "&-borderless": Object.assign({
    background: "transparent",
    border: "none",
    "&:focus, &:focus-within": {
      outline: "none"
    },
    [`&${e.componentCls}-disabled, &[disabled]`]: {
      color: e.colorTextDisabled
    }
  }, t)
}), A7 = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t == null ? void 0 : t.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), rj = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, A7(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), zwe = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, A7(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, u2(e))
  }), rj(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), rj(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), ij = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), Uwe = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${ge(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${ge(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, ij(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), ij(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), Hwe = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), R7 = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: n,
    borderRadiusLG: r,
    paddingInlineLG: i
  } = e;
  return {
    padding: `${ge(t)} ${ge(i)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: n,
    borderRadius: r
  };
}, M7 = (e) => ({
  padding: `${ge(e.paddingBlockSM)} ${ge(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), N7 = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${ge(e.paddingBlock)} ${ge(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, Hwe(e.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, R7(e)),
  "&-sm": Object.assign({}, M7(e)),
  // RTL
  "&-rtl": {
    direction: "rtl"
  },
  "&-textarea-rtl": {
    direction: "rtl"
  }
}), Wwe = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, R7(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, M7(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${ge(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${n}-select`]: {
          margin: `${ge(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${ge(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${n}-select-single:not(${n}-select-customize-input):not(${n}-pagination-size-changer)`]: {
            [`${n}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${ge(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${n}-select-selector`]: {
              color: e.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${n}-cascader-picker`]: {
          margin: `-9px ${ge(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${n}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [`${t}`]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, gh()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover": {
            zIndex: 1
          },
          "&:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${n}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${t}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${n}-select > ${n}-select-selector,
      & > ${n}-select-auto-complete ${t},
      & > ${n}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover": {
          zIndex: 1
        },
        "&:focus": {
          zIndex: 1
        }
      },
      [`& > ${n}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${n}-select > ${n}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${n}-select:first-child > ${n}-select-selector,
      & > ${n}-select-auto-complete:first-child ${t},
      & > ${n}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${n}-select:last-child > ${n}-select-selector,
      & > ${n}-cascader-picker:last-child ${t},
      & > ${n}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${n}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, Vwe = (e) => {
  const {
    componentCls: t,
    controlHeightSM: n,
    lineWidth: r,
    calc: i
  } = e, o = 16, a = i(n).sub(i(r).mul(2)).sub(o).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Vi(e)), N7(e)), jwe(e)), zwe(e)), Bwe(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: n,
          paddingTop: a,
          paddingBottom: a
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, Gwe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${ge(e.inputAffixPadding)}`
      }
    }
  };
}, Kwe = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: n,
    colorTextDescription: r,
    motionDurationSlow: i,
    colorIcon: o,
    colorIconHover: a,
    iconCls: s
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign(Object.assign(Object.assign({}, N7(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: r
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: n
        },
        "&-suffix": {
          marginInlineStart: n
        }
      }
    }), Gwe(e)), {
      // password
      [`${s}${t}-password-icon`]: {
        color: o,
        cursor: "pointer",
        transition: `all ${i}`,
        "&:hover": {
          color: a
        }
      }
    })
  };
}, qwe = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: n,
    borderRadiusSM: r
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, Vi(e)), Wwe(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: n,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: r
          }
        }
      }, Fwe(e)), Uwe(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      })
    })
  };
}, Ywe = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-search`;
  return {
    [r]: {
      [`${t}`]: {
        "&:hover, &:focus": {
          borderColor: e.colorPrimaryHover,
          [`+ ${t}-group-addon ${r}-button:not(${n}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal({
          unit: !1
        })
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${r}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: e.borderRadius,
            borderEndEndRadius: e.borderRadius,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${r}-button:not(${n}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${n}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${r}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${r}-button`]: {
        height: e.controlHeightLG
      },
      [`&-small ${r}-button`]: {
        height: e.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover,&:focus,&:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, Xwe = (e) => {
  const {
    componentCls: t,
    paddingLG: n
  } = e, r = `${t}-textarea`;
  return {
    [r]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        [`${t}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      "&-allow-clear": {
        [`> ${t}`]: {
          paddingInlineEnd: n
        }
      },
      [`&-affix-wrapper${r}-has-feedback`]: {
        [`${t}`]: {
          paddingInlineEnd: n
        }
      },
      [`&-affix-wrapper${t}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${t}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${t}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${t}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingXS,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${r}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      }
    }
  };
}, Qwe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, f2 = Pi("Input", (e) => {
  const t = _r(e, kwe(e));
  return [
    Vwe(t),
    Xwe(t),
    Kwe(t),
    qwe(t),
    Ywe(t),
    Qwe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    oW(t)
  ];
}, Lwe), Jwe = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    size: i,
    shape: o
  } = e, a = Ue({
    [`${t}-lg`]: i === "large",
    [`${t}-sm`]: i === "small"
  }), s = Ue({
    [`${t}-circle`]: o === "circle",
    [`${t}-square`]: o === "square",
    [`${t}-round`]: o === "round"
  }), l = m.useMemo(() => typeof i == "number" ? {
    width: i,
    height: i,
    lineHeight: `${i}px`
  } : {}, [i]);
  return /* @__PURE__ */ m.createElement("span", {
    className: Ue(t, a, s, n),
    style: Object.assign(Object.assign({}, l), r)
  });
}, US = Jwe, Zwe = new Tn("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), HS = (e) => ({
  height: e,
  lineHeight: ge(e)
}), Ep = (e) => Object.assign({
  width: e
}, HS(e)), eSe = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: Zwe,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), K$ = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, HS(e)), tSe = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: n,
    controlHeight: r,
    controlHeightLG: i,
    controlHeightSM: o
  } = e;
  return {
    [`${t}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: n
    }, Ep(r)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, Ep(i)),
    [`${t}${t}-sm`]: Object.assign({}, Ep(o))
  };
}, nSe = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: n,
    skeletonInputCls: r,
    controlHeightLG: i,
    controlHeightSM: o,
    gradientFromColor: a,
    calc: s
  } = e;
  return {
    [`${r}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: n
    }, K$(t, s)),
    [`${r}-lg`]: Object.assign({}, K$(i, s)),
    [`${r}-sm`]: Object.assign({}, K$(o, s))
  };
}, oj = (e) => Object.assign({
  width: e
}, HS(e)), rSe = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: n,
    gradientFromColor: r,
    borderRadiusSM: i,
    calc: o
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "top",
      background: r,
      borderRadius: i
    }, oj(o(n).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, oj(n)), {
        maxWidth: o(n).mul(4).equal(),
        maxHeight: o(n).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, q$ = (e, t, n) => {
  const {
    skeletonButtonCls: r
  } = e;
  return {
    [`${n}${r}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${n}${r}-round`]: {
      borderRadius: t
    }
  };
}, Y$ = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, HS(e)), iSe = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: n,
    controlHeight: r,
    controlHeightLG: i,
    controlHeightSM: o,
    gradientFromColor: a,
    calc: s
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [`${n}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: t,
      width: s(r).mul(2).equal(),
      minWidth: s(r).mul(2).equal()
    }, Y$(r, s))
  }, q$(e, r, n)), {
    [`${n}-lg`]: Object.assign({}, Y$(i, s))
  }), q$(e, i, `${n}-lg`)), {
    [`${n}-sm`]: Object.assign({}, Y$(o, s))
  }), q$(e, o, `${n}-sm`));
}, oSe = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: n,
    skeletonTitleCls: r,
    skeletonParagraphCls: i,
    skeletonButtonCls: o,
    skeletonInputCls: a,
    skeletonImageCls: s,
    controlHeight: l,
    controlHeightLG: c,
    controlHeightSM: f,
    gradientFromColor: d,
    padding: p,
    marginSM: g,
    borderRadius: v,
    titleHeight: y,
    blockRadius: x,
    paragraphLiHeight: b,
    controlHeightXS: w,
    paragraphMarginTop: S
  } = e;
  return {
    [`${t}`]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: p,
        verticalAlign: "top",
        // Avatar
        [`${n}`]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: d
        }, Ep(l)),
        [`${n}-circle`]: {
          borderRadius: "50%"
        },
        [`${n}-lg`]: Object.assign({}, Ep(c)),
        [`${n}-sm`]: Object.assign({}, Ep(f))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [`${r}`]: {
          width: "100%",
          height: y,
          background: d,
          borderRadius: x,
          [`+ ${i}`]: {
            marginBlockStart: f
          }
        },
        // paragraph
        [`${i}`]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: b,
            listStyle: "none",
            background: d,
            borderRadius: x,
            "+ li": {
              marginBlockStart: w
            }
          }
        },
        [`${i}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${r}, ${i} > li`]: {
          borderRadius: v
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [`${r}`]: {
        marginBlockStart: g,
        [`+ ${i}`]: {
          marginBlockStart: S
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, iSe(e)), tSe(e)), nSe(e)), rSe(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [`${o}`]: {
        width: "100%"
      },
      [`${a}`]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${r},
        ${i} > li,
        ${n},
        ${o},
        ${a},
        ${s}
      `]: Object.assign({}, eSe(e))
    }
  };
}, aSe = (e) => {
  const {
    colorFillContent: t,
    colorFill: n
  } = e, r = t, i = n;
  return {
    color: r,
    colorGradientEnd: i,
    gradientFromColor: r,
    gradientToColor: i,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, bh = Pi("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: n
  } = e, r = _r(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: n(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [oSe(r)];
}, aSe, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), sSe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    shape: o = "circle",
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = m.useContext(Mt), l = s("skeleton", t), [c, f, d] = bh(l), p = os(e, ["prefixCls", "className"]), g = Ue(l, `${l}-element`, {
    [`${l}-active`]: i
  }, n, r, f, d);
  return c(/* @__PURE__ */ m.createElement("div", {
    className: g
  }, /* @__PURE__ */ m.createElement(US, Object.assign({
    prefixCls: `${l}-avatar`,
    shape: o,
    size: a
  }, p))));
}, lSe = sSe, cSe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    block: o = !1,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = m.useContext(Mt), l = s("skeleton", t), [c, f, d] = bh(l), p = os(e, ["prefixCls"]), g = Ue(l, `${l}-element`, {
    [`${l}-active`]: i,
    [`${l}-block`]: o
  }, n, r, f, d);
  return c(/* @__PURE__ */ m.createElement("div", {
    className: g
  }, /* @__PURE__ */ m.createElement(US, Object.assign({
    prefixCls: `${l}-button`,
    size: a
  }, p))));
}, uSe = cSe, fSe = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", dSe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: i,
    active: o
  } = e, {
    getPrefixCls: a
  } = m.useContext(Mt), s = a("skeleton", t), [l, c, f] = bh(s), d = Ue(s, `${s}-element`, {
    [`${s}-active`]: o
  }, n, r, c, f);
  return l(/* @__PURE__ */ m.createElement("div", {
    className: d
  }, /* @__PURE__ */ m.createElement("div", {
    className: Ue(`${s}-image`, n),
    style: i
  }, /* @__PURE__ */ m.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${s}-image-svg`
  }, /* @__PURE__ */ m.createElement("path", {
    d: fSe,
    className: `${s}-image-path`
  })))));
}, pSe = dSe, hSe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    block: o,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = m.useContext(Mt), l = s("skeleton", t), [c, f, d] = bh(l), p = os(e, ["prefixCls"]), g = Ue(l, `${l}-element`, {
    [`${l}-active`]: i,
    [`${l}-block`]: o
  }, n, r, f, d);
  return c(/* @__PURE__ */ m.createElement("div", {
    className: g
  }, /* @__PURE__ */ m.createElement(US, Object.assign({
    prefixCls: `${l}-input`,
    size: a
  }, p))));
}, mSe = hSe;
var gSe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "dot-chart", theme: "outlined" };
const vSe = gSe;
var ySe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: vSe
  }));
}, bSe = /* @__PURE__ */ m.forwardRef(ySe);
const wSe = bSe, SSe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: i,
    active: o,
    children: a
  } = e, {
    getPrefixCls: s
  } = m.useContext(Mt), l = s("skeleton", t), [c, f, d] = bh(l), p = Ue(l, `${l}-element`, {
    [`${l}-active`]: o
  }, f, n, r, d), g = a ?? /* @__PURE__ */ m.createElement(wSe, null);
  return c(/* @__PURE__ */ m.createElement("div", {
    className: p
  }, /* @__PURE__ */ m.createElement("div", {
    className: Ue(`${l}-image`, n),
    style: i
  }, g)));
}, xSe = SSe, CSe = (e, t) => {
  const {
    width: n,
    rows: r = 2
  } = t;
  if (Array.isArray(n))
    return n[e];
  if (r - 1 === e)
    return n;
}, ESe = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    rows: i
  } = e, o = Qa(Array(i)).map((a, s) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ m.createElement("li", {
      key: s,
      style: {
        width: CSe(s, e)
      }
    })
  ));
  return /* @__PURE__ */ m.createElement("ul", {
    className: Ue(t, n),
    style: r
  }, o);
}, $Se = ESe, _Se = (e) => {
  let {
    prefixCls: t,
    className: n,
    width: r,
    style: i
  } = e;
  return /* @__PURE__ */ m.createElement("h3", {
    className: Ue(t, n),
    style: Object.assign({
      width: r
    }, i)
  });
}, OSe = _Se;
function X$(e) {
  return e && typeof e == "object" ? e : {};
}
function PSe(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function TSe(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function ISe(e, t) {
  const n = {};
  return (!e || !t) && (n.width = "61%"), !e && t ? n.rows = 3 : n.rows = 2, n;
}
const wh = (e) => {
  const {
    prefixCls: t,
    loading: n,
    className: r,
    rootClassName: i,
    style: o,
    children: a,
    avatar: s = !1,
    title: l = !0,
    paragraph: c = !0,
    active: f,
    round: d
  } = e, {
    getPrefixCls: p,
    direction: g,
    skeleton: v
  } = m.useContext(Mt), y = p("skeleton", t), [x, b, w] = bh(y);
  if (n || !("loading" in e)) {
    const S = !!s, E = !!l, O = !!c;
    let $;
    if (S) {
      const L = Object.assign(Object.assign({
        prefixCls: `${y}-avatar`
      }, PSe(E, O)), X$(s));
      $ = /* @__PURE__ */ m.createElement("div", {
        className: `${y}-header`
      }, /* @__PURE__ */ m.createElement(US, Object.assign({}, L)));
    }
    let P;
    if (E || O) {
      let L;
      if (E) {
        const j = Object.assign(Object.assign({
          prefixCls: `${y}-title`
        }, TSe(S, O)), X$(l));
        L = /* @__PURE__ */ m.createElement(OSe, Object.assign({}, j));
      }
      let B;
      if (O) {
        const j = Object.assign(Object.assign({
          prefixCls: `${y}-paragraph`
        }, ISe(S, E)), X$(c));
        B = /* @__PURE__ */ m.createElement($Se, Object.assign({}, j));
      }
      P = /* @__PURE__ */ m.createElement("div", {
        className: `${y}-content`
      }, L, B);
    }
    const R = Ue(y, {
      [`${y}-with-avatar`]: S,
      [`${y}-active`]: f,
      [`${y}-rtl`]: g === "rtl",
      [`${y}-round`]: d
    }, v == null ? void 0 : v.className, r, i, b, w);
    return x(/* @__PURE__ */ m.createElement("div", {
      className: R,
      style: Object.assign(Object.assign({}, v == null ? void 0 : v.style), o)
    }, $, P));
  }
  return a ?? null;
};
wh.Button = uSe;
wh.Avatar = lSe;
wh.Input = mSe;
wh.Image = pSe;
wh.Node = xSe;
const Bo = wh;
var ASe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
const RSe = ASe;
var MSe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: RSe
  }));
}, NSe = /* @__PURE__ */ m.forwardRef(MSe);
const kSe = NSe;
function RT(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function LSe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var aj = LSe() ? m.useLayoutEffect : m.useEffect, DSe = function(t, n) {
  var r = m.useRef(!0);
  aj(function() {
    return t(r.current);
  }, n), aj(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, MT = function(t, n) {
  DSe(function(r) {
    if (!r)
      return t();
  }, n);
};
function sj(e) {
  var t = m.useRef(!1), n = m.useState(e), r = ke(n, 2), i = r[0], o = r[1];
  m.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || o(s);
  }
  return [i, a];
}
function Q$(e) {
  return e !== void 0;
}
function lj(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = sj(function() {
    return Q$(i) ? i : Q$(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = ke(s, 2), c = l[0], f = l[1], d = i !== void 0 ? i : c, p = a ? a(d) : d, g = RT(o), v = sj([d]), y = ke(v, 2), x = y[0], b = y[1];
  MT(function() {
    var S = x[0];
    c !== S && g(c, S);
  }, [x]), MT(function() {
    Q$(i) || f(i);
  }, [i]);
  var w = RT(function(S, E) {
    f(S, E), b([d], E);
  });
  return [p, w];
}
const jSe = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
}, WS = /* @__PURE__ */ m.createContext(null);
function FSe(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function BSe(e, t) {
  typeof e == "function" ? e(t) : nn(e) === "object" && e && "current" in e && (e.current = t);
}
function zSe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      BSe(o, i);
    });
  };
}
function USe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return FSe(function() {
    return zSe.apply(void 0, t);
  }, t, function(r, i) {
    return r.length === i.length && r.every(function(o, a) {
      return o === i[a];
    });
  });
}
var k7 = function(t) {
  return +setTimeout(t, 16);
}, L7 = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (k7 = function(t) {
  return window.requestAnimationFrame(t);
}, L7 = function(t) {
  return window.cancelAnimationFrame(t);
});
var cj = 0, d2 = /* @__PURE__ */ new Map();
function D7(e) {
  d2.delete(e);
}
var NT = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  cj += 1;
  var r = cj;
  function i(o) {
    if (o === 0)
      D7(r), t();
    else {
      var a = k7(function() {
        i(o - 1);
      });
      d2.set(r, a);
    }
  }
  return i(n), r;
};
NT.cancel = function(e) {
  var t = d2.get(e);
  return D7(t), L7(t);
};
var HSe = function(t) {
  var n = t.activeTabOffset, r = t.horizontal, i = t.rtl, o = t.indicator, a = o === void 0 ? {} : o, s = a.size, l = a.align, c = l === void 0 ? "center" : l, f = m.useState(), d = ke(f, 2), p = d[0], g = d[1], v = m.useRef(), y = oe.useCallback(function(b) {
    return typeof s == "function" ? s(b) : typeof s == "number" ? s : b;
  }, [s]);
  function x() {
    NT.cancel(v.current);
  }
  return m.useEffect(function() {
    var b = {};
    if (n)
      if (r) {
        b.width = y(n.width);
        var w = i ? "right" : "left";
        c === "start" && (b[w] = n[w]), c === "center" && (b[w] = n[w] + n.width / 2, b.transform = i ? "translateX(50%)" : "translateX(-50%)"), c === "end" && (b[w] = n[w] + n.width, b.transform = "translateX(-100%)");
      } else
        b.height = y(n.height), c === "start" && (b.top = n.top), c === "center" && (b.top = n.top + n.height / 2, b.transform = "translateY(-50%)"), c === "end" && (b.top = n.top + n.height, b.transform = "translateY(-100%)");
    return x(), v.current = NT(function() {
      g(b);
    }), x;
  }, [n, r, i, c, y]), {
    style: p
  };
}, uj = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function WSe(e, t, n) {
  return m.useMemo(function() {
    for (var r, i = /* @__PURE__ */ new Map(), o = t.get((r = e[0]) === null || r === void 0 ? void 0 : r.key) || uj, a = o.left + o.width, s = 0; s < e.length; s += 1) {
      var l = e[s].key, c = t.get(l);
      if (!c) {
        var f;
        c = t.get((f = e[s - 1]) === null || f === void 0 ? void 0 : f.key) || uj;
      }
      var d = i.get(l) || ye({}, c);
      d.right = a - d.left - d.width, i.set(l, d);
    }
    return i;
  }, [e.map(function(r) {
    return r.key;
  }).join("_"), t, n]);
}
function fj(e, t) {
  var n = m.useRef(e), r = m.useState({}), i = ke(r, 2), o = i[1];
  function a(s) {
    var l = typeof s == "function" ? s(n.current) : s;
    l !== n.current && t(l, n.current), n.current = l, o({});
  }
  return [n.current, a];
}
var VSe = 0.1, dj = 0.01, gb = 20, pj = Math.pow(0.995, gb);
function GSe(e, t) {
  var n = m.useState(), r = ke(n, 2), i = r[0], o = r[1], a = m.useState(0), s = ke(a, 2), l = s[0], c = s[1], f = m.useState(0), d = ke(f, 2), p = d[0], g = d[1], v = m.useState(), y = ke(v, 2), x = y[0], b = y[1], w = m.useRef();
  function S(L) {
    var B = L.touches[0], j = B.screenX, A = B.screenY;
    o({
      x: j,
      y: A
    }), window.clearInterval(w.current);
  }
  function E(L) {
    if (i) {
      L.preventDefault();
      var B = L.touches[0], j = B.screenX, A = B.screenY;
      o({
        x: j,
        y: A
      });
      var T = j - i.x, k = A - i.y;
      t(T, k);
      var F = Date.now();
      c(F), g(F - l), b({
        x: T,
        y: k
      });
    }
  }
  function O() {
    if (i && (o(null), b(null), x)) {
      var L = x.x / p, B = x.y / p, j = Math.abs(L), A = Math.abs(B);
      if (Math.max(j, A) < VSe)
        return;
      var T = L, k = B;
      w.current = window.setInterval(function() {
        if (Math.abs(T) < dj && Math.abs(k) < dj) {
          window.clearInterval(w.current);
          return;
        }
        T *= pj, k *= pj, t(T * gb, k * gb);
      }, gb);
    }
  }
  var $ = m.useRef();
  function P(L) {
    var B = L.deltaX, j = L.deltaY, A = 0, T = Math.abs(B), k = Math.abs(j);
    T === k ? A = $.current === "x" ? B : j : T > k ? (A = B, $.current = "x") : (A = j, $.current = "y"), t(-A, -A) && L.preventDefault();
  }
  var R = m.useRef(null);
  R.current = {
    onTouchStart: S,
    onTouchMove: E,
    onTouchEnd: O,
    onWheel: P
  }, m.useEffect(function() {
    function L(T) {
      R.current.onTouchStart(T);
    }
    function B(T) {
      R.current.onTouchMove(T);
    }
    function j(T) {
      R.current.onTouchEnd(T);
    }
    function A(T) {
      R.current.onWheel(T);
    }
    return document.addEventListener("touchmove", B, {
      passive: !1
    }), document.addEventListener("touchend", j, {
      passive: !1
    }), e.current.addEventListener("touchstart", L, {
      passive: !1
    }), e.current.addEventListener("wheel", A), function() {
      document.removeEventListener("touchmove", B), document.removeEventListener("touchend", j);
    };
  }, []);
}
function j7(e) {
  var t = m.useState(0), n = ke(t, 2), r = n[0], i = n[1], o = m.useRef(0), a = m.useRef();
  return a.current = e, MT(function() {
    var s;
    (s = a.current) === null || s === void 0 || s.call(a);
  }, [r]), function() {
    o.current === r && (o.current += 1, i(o.current));
  };
}
function KSe(e) {
  var t = m.useRef([]), n = m.useState({}), r = ke(n, 2), i = r[1], o = m.useRef(typeof e == "function" ? e() : e), a = j7(function() {
    var l = o.current;
    t.current.forEach(function(c) {
      l = c(l);
    }), t.current = [], o.current = l, i({});
  });
  function s(l) {
    t.current.push(l), a();
  }
  return [o.current, s];
}
var hj = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function qSe(e, t, n, r, i, o, a) {
  var s = a.tabs, l = a.tabPosition, c = a.rtl, f, d, p;
  return ["top", "bottom"].includes(l) ? (f = "width", d = c ? "right" : "left", p = Math.abs(n)) : (f = "height", d = "top", p = -n), m.useMemo(function() {
    if (!s.length)
      return [0, 0];
    for (var g = s.length, v = g, y = 0; y < g; y += 1) {
      var x = e.get(s[y].key) || hj;
      if (x[d] + x[f] > p + t) {
        v = y - 1;
        break;
      }
    }
    for (var b = 0, w = g - 1; w >= 0; w -= 1) {
      var S = e.get(s[w].key) || hj;
      if (S[d] < p) {
        b = w + 1;
        break;
      }
    }
    return b >= v ? [0, 0] : [b, v];
  }, [e, t, r, i, o, p, l, s.map(function(g) {
    return g.key;
  }).join("_"), c]);
}
function mj(e) {
  var t;
  return e instanceof Map ? (t = {}, e.forEach(function(n, r) {
    t[r] = n;
  })) : t = e, JSON.stringify(t);
}
var YSe = "TABS_DQ";
function F7(e) {
  return String(e).replace(/"/g, YSe);
}
function B7(e, t, n, r) {
  return (
    // Only editable tabs can be removed
    !(!n || // Tabs cannot be removed when disabled
    r || // closable is false
    e === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    e === void 0 && (t === !1 || t === null))
  );
}
var z7 = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.editable, i = e.locale, o = e.style;
  return !r || r.showAdd === !1 ? null : /* @__PURE__ */ m.createElement("button", {
    ref: t,
    type: "button",
    className: "".concat(n, "-nav-add"),
    style: o,
    "aria-label": (i == null ? void 0 : i.addAriaLabel) || "Add tab",
    onClick: function(s) {
      r.onEdit("add", {
        event: s
      });
    }
  }, r.addIcon || "+");
}), gj = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.position, r = e.prefixCls, i = e.extra;
  if (!i)
    return null;
  var o, a = {};
  return nn(i) === "object" && !/* @__PURE__ */ m.isValidElement(i) ? a = i : a.right = i, n === "right" && (o = a.right), n === "left" && (o = a.left), o ? /* @__PURE__ */ m.createElement("div", {
    className: "".concat(r, "-extra-content"),
    ref: t
  }, o) : null;
});
function Fg(e) {
  "@babel/helpers - typeof";
  return Fg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fg(e);
}
function XSe(e, t) {
  if (Fg(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Fg(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function QSe(e) {
  var t = XSe(e, "string");
  return Fg(t) === "symbol" ? t : String(t);
}
function JSe(e, t, n) {
  return t = QSe(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function vj(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $o(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vj(Object(n), !0).forEach(function(r) {
      JSe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vj(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ZSe(e) {
  if (Array.isArray(e))
    return e;
}
function exe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function kT(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function U7(e, t) {
  if (e) {
    if (typeof e == "string")
      return kT(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return kT(e, t);
  }
}
function txe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ji(e, t) {
  return ZSe(e) || exe(e, t) || U7(e, t) || txe();
}
function nxe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function rxe(e, t) {
  if (e == null)
    return {};
  var n = nxe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function LT(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function H7(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function ixe(e) {
  return H7(e) instanceof ShadowRoot;
}
function DT(e) {
  return ixe(e) ? H7(e) : null;
}
function of(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function oxe(e) {
  if (Array.isArray(e))
    return e;
}
function axe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function yj(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function sxe(e, t) {
  if (e) {
    if (typeof e == "string")
      return yj(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return yj(e, t);
  }
}
function lxe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cxe(e, t) {
  return oxe(e) || axe(e, t) || sxe(e, t) || lxe();
}
function Xp(e) {
  "@babel/helpers - typeof";
  return Xp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xp(e);
}
function uxe(e, t) {
  if (Xp(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Xp(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fxe(e) {
  var t = uxe(e, "string");
  return Xp(t) === "symbol" ? t : String(t);
}
function dxe(e, t, n) {
  return t = fxe(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function bj(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pxe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bj(Object(n), !0).forEach(function(r) {
      dxe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bj(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hxe() {
  var e = pxe({}, sh);
  return e.useId;
}
var wj = 0, Sj = hxe();
const mxe = Sj ? (
  // Use React `useId`
  function(t) {
    var n = Sj();
    return t || n;
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = m.useState("ssr-id"), r = cxe(n, 2), i = r[0], o = r[1];
    return m.useEffect(function() {
      var a = wj;
      wj += 1, o("rc_unique_".concat(a));
    }, []), t || i;
  }
);
function gxe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var xj = gxe() ? m.useLayoutEffect : m.useEffect, vl = function(t, n) {
  var r = m.useRef(!0);
  xj(function() {
    return t(r.current);
  }, n), xj(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
};
const vxe = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
function j1() {
  return j1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, j1.apply(this, arguments);
}
var W7 = { exports: {} }, Wn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p2 = Symbol.for("react.element"), h2 = Symbol.for("react.portal"), VS = Symbol.for("react.fragment"), GS = Symbol.for("react.strict_mode"), KS = Symbol.for("react.profiler"), qS = Symbol.for("react.provider"), YS = Symbol.for("react.context"), yxe = Symbol.for("react.server_context"), XS = Symbol.for("react.forward_ref"), QS = Symbol.for("react.suspense"), JS = Symbol.for("react.suspense_list"), ZS = Symbol.for("react.memo"), ex = Symbol.for("react.lazy"), bxe = Symbol.for("react.offscreen"), V7;
V7 = Symbol.for("react.module.reference");
function ds(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case p2:
        switch (e = e.type, e) {
          case VS:
          case KS:
          case GS:
          case QS:
          case JS:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case yxe:
              case YS:
              case XS:
              case ex:
              case ZS:
              case qS:
                return e;
              default:
                return t;
            }
        }
      case h2:
        return t;
    }
  }
}
Wn.ContextConsumer = YS;
Wn.ContextProvider = qS;
Wn.Element = p2;
Wn.ForwardRef = XS;
Wn.Fragment = VS;
Wn.Lazy = ex;
Wn.Memo = ZS;
Wn.Portal = h2;
Wn.Profiler = KS;
Wn.StrictMode = GS;
Wn.Suspense = QS;
Wn.SuspenseList = JS;
Wn.isAsyncMode = function() {
  return !1;
};
Wn.isConcurrentMode = function() {
  return !1;
};
Wn.isContextConsumer = function(e) {
  return ds(e) === YS;
};
Wn.isContextProvider = function(e) {
  return ds(e) === qS;
};
Wn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === p2;
};
Wn.isForwardRef = function(e) {
  return ds(e) === XS;
};
Wn.isFragment = function(e) {
  return ds(e) === VS;
};
Wn.isLazy = function(e) {
  return ds(e) === ex;
};
Wn.isMemo = function(e) {
  return ds(e) === ZS;
};
Wn.isPortal = function(e) {
  return ds(e) === h2;
};
Wn.isProfiler = function(e) {
  return ds(e) === KS;
};
Wn.isStrictMode = function(e) {
  return ds(e) === GS;
};
Wn.isSuspense = function(e) {
  return ds(e) === QS;
};
Wn.isSuspenseList = function(e) {
  return ds(e) === JS;
};
Wn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === VS || e === KS || e === GS || e === QS || e === JS || e === bxe || typeof e == "object" && e !== null && (e.$$typeof === ex || e.$$typeof === ZS || e.$$typeof === qS || e.$$typeof === YS || e.$$typeof === XS || e.$$typeof === V7 || e.getModuleId !== void 0);
};
Wn.typeOf = ds;
W7.exports = Wn;
var wxe = W7.exports;
function Sxe(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function G7(e, t) {
  typeof e == "function" ? e(t) : Xp(e) === "object" && e && "current" in e && (e.current = t);
}
function K7() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      G7(o, i);
    });
  };
}
function xxe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Sxe(function() {
    return K7.apply(void 0, t);
  }, t, function(r, i) {
    return r.length !== i.length || r.every(function(o, a) {
      return o !== i[a];
    });
  });
}
function Cxe(e) {
  var t, n, r = wxe.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
function Exe(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, i = e.arrowPos, o = r || {}, a = o.className, s = o.content, l = i.x, c = l === void 0 ? 0 : l, f = i.y, d = f === void 0 ? 0 : f, p = m.useRef();
  if (!n || !n.points)
    return null;
  var g = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var v = n.points[0], y = n.points[1], x = v[0], b = v[1], w = y[0], S = y[1];
    x === w || !["t", "b"].includes(x) ? g.top = d : x === "t" ? g.top = 0 : g.bottom = 0, b === S || !["l", "r"].includes(b) ? g.left = c : b === "l" ? g.left = 0 : g.right = 0;
  }
  return /* @__PURE__ */ m.createElement("div", {
    ref: p,
    className: ft("".concat(t, "-arrow"), a),
    style: g
  }, s);
}
function $xe(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, i = e.mask, o = e.motion;
  return i ? /* @__PURE__ */ m.createElement(Cc, j1({}, o, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ m.createElement("div", {
      style: {
        zIndex: r
      },
      className: ft("".concat(t, "-mask"), s)
    });
  }) : null;
}
var _xe = /* @__PURE__ */ m.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
}), Oxe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, i = e.prefixCls, o = e.style, a = e.target, s = e.onVisibleChanged, l = e.open, c = e.keepDom, f = e.fresh, d = e.onClick, p = e.mask, g = e.arrow, v = e.arrowPos, y = e.align, x = e.motion, b = e.maskMotion, w = e.forceRender, S = e.getPopupContainer, E = e.autoDestroy, O = e.portal, $ = e.zIndex, P = e.onMouseEnter, R = e.onMouseLeave, L = e.onPointerEnter, B = e.ready, j = e.offsetX, A = e.offsetY, T = e.offsetR, k = e.offsetB, F = e.onAlign, W = e.onPrepare, V = e.stretch, G = e.targetWidth, X = e.targetHeight, D = typeof n == "function" ? n() : n, te = l || c, ee = (S == null ? void 0 : S.length) > 0, U = m.useState(!S || !ee), he = ji(U, 2), re = he[0], de = he[1];
  if (vl(function() {
    !re && ee && a && de(!0);
  }, [re, ee, a]), !re)
    return null;
  var we = "auto", ue = {
    left: "-1000vw",
    top: "-1000vh",
    right: we,
    bottom: we
  };
  if (B || !l) {
    var me, Se = y.points, _e = y.dynamicInset || ((me = y._experimental) === null || me === void 0 ? void 0 : me.dynamicInset), Ge = _e && Se[0][1] === "r", Fe = _e && Se[0][0] === "b";
    Ge ? (ue.right = T, ue.left = we) : (ue.left = j, ue.right = we), Fe ? (ue.bottom = k, ue.top = we) : (ue.top = A, ue.bottom = we);
  }
  var Ae = {};
  return V && (V.includes("height") && X ? Ae.height = X : V.includes("minHeight") && X && (Ae.minHeight = X), V.includes("width") && G ? Ae.width = G : V.includes("minWidth") && G && (Ae.minWidth = G)), l || (Ae.pointerEvents = "none"), /* @__PURE__ */ m.createElement(O, {
    open: w || te,
    getContainer: S && function() {
      return S(a);
    },
    autoDestroy: E
  }, /* @__PURE__ */ m.createElement($xe, {
    prefixCls: i,
    open: l,
    zIndex: $,
    mask: p,
    motion: b
  }), /* @__PURE__ */ m.createElement(Ws, {
    onResize: F,
    disabled: !l
  }, function(Me) {
    return /* @__PURE__ */ m.createElement(Cc, j1({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: w,
      leavedClassName: "".concat(i, "-hidden")
    }, x, {
      onAppearPrepare: W,
      onEnterPrepare: W,
      visible: l,
      onVisibleChanged: function(De) {
        var je;
        x == null || (je = x.onVisibleChanged) === null || je === void 0 || je.call(x, De), s(De);
      }
    }), function(et, De) {
      var je = et.className, ie = et.style, fe = ft(i, je, r);
      return /* @__PURE__ */ m.createElement("div", {
        ref: K7(Me, t, De),
        className: fe,
        style: $o($o($o($o({
          "--arrow-x": "".concat(v.x || 0, "px"),
          "--arrow-y": "".concat(v.y || 0, "px")
        }, ue), Ae), ie), {}, {
          boxSizing: "border-box",
          zIndex: $
        }, o),
        onMouseEnter: P,
        onMouseLeave: R,
        onPointerEnter: L,
        onClick: d
      }, g && /* @__PURE__ */ m.createElement(Exe, {
        prefixCls: i,
        arrow: g,
        arrowPos: v,
        align: y
      }), /* @__PURE__ */ m.createElement(_xe, {
        cache: !l && !f
      }, D));
    });
  }));
}), Pxe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, i = Cxe(n), o = m.useCallback(function(s) {
    G7(t, r ? r(s) : s);
  }, [r]), a = xxe(o, n.ref);
  return i ? /* @__PURE__ */ m.cloneElement(n, {
    ref: a
  }) : n;
}), Cj = /* @__PURE__ */ m.createContext(null);
function Ej(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function Txe(e, t, n, r) {
  return m.useMemo(function() {
    var i = Ej(n ?? t), o = Ej(r ?? t), a = new Set(i), s = new Set(o);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
const Ixe = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), o = i.width, a = i.height;
      if (o || a)
        return !0;
    }
  }
  return !1;
};
function Axe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function Rxe(e, t, n, r) {
  for (var i = n.points, o = Object.keys(e), a = 0; a < o.length; a += 1) {
    var s, l = o[a];
    if (Axe((s = e[l]) === null || s === void 0 ? void 0 : s.points, i, r))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function $j(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function bv(e) {
  return e.ownerDocument.defaultView;
}
function jT(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var i = bv(n).getComputedStyle(n), o = i.overflowX, a = i.overflowY, s = i.overflow;
    [o, a, s].some(function(l) {
      return r.includes(l);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function Bg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Sm(e) {
  return Bg(parseFloat(e), 0);
}
function _j(e, t) {
  var n = $o({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var i = bv(r).getComputedStyle(r), o = i.overflow, a = i.overflowClipMargin, s = i.borderTopWidth, l = i.borderBottomWidth, c = i.borderLeftWidth, f = i.borderRightWidth, d = r.getBoundingClientRect(), p = r.offsetHeight, g = r.clientHeight, v = r.offsetWidth, y = r.clientWidth, x = Sm(s), b = Sm(l), w = Sm(c), S = Sm(f), E = Bg(Math.round(d.width / v * 1e3) / 1e3), O = Bg(Math.round(d.height / p * 1e3) / 1e3), $ = (v - y - w - S) * E, P = (p - g - x - b) * O, R = x * O, L = b * O, B = w * E, j = S * E, A = 0, T = 0;
      if (o === "clip") {
        var k = Sm(a);
        A = k * E, T = k * O;
      }
      var F = d.x + B - A, W = d.y + R - T, V = F + d.width + 2 * A - B - j - $, G = W + d.height + 2 * T - R - L - P;
      n.left = Math.max(n.left, F), n.top = Math.max(n.top, W), n.right = Math.min(n.right, V), n.bottom = Math.min(n.bottom, G);
    }
  }), n;
}
function Oj(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function Pj(e, t) {
  var n = t || [], r = ji(n, 2), i = r[0], o = r[1];
  return [Oj(e.width, i), Oj(e.height, o)];
}
function Tj() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function Td(e, t) {
  var n = t[0], r = t[1], i, o;
  return n === "t" ? o = e.y : n === "b" ? o = e.y + e.height : o = e.y + e.height / 2, r === "l" ? i = e.x : r === "r" ? i = e.x + e.width : i = e.x + e.width / 2, {
    x: i,
    y: o
  };
}
function Dc(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, i) {
    return i === t ? n[r] || "c" : r;
  }).join("");
}
function Mxe(e, t, n, r, i, o, a) {
  var s = m.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: i[r] || {}
  }), l = ji(s, 2), c = l[0], f = l[1], d = m.useRef(0), p = m.useMemo(function() {
    return t ? jT(t) : [];
  }, [t]), g = m.useRef({}), v = function() {
    g.current = {};
  };
  e || v();
  var y = of(function() {
    if (t && n && e) {
      let wn = function(ir, mr) {
        var bi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fe, wi = D.x + ir, Zi = D.y + mr, eo = wi + me, Mo = Zi + ue, ys = Math.max(wi, bi.left), Na = Math.max(Zi, bi.top), ka = Math.min(eo, bi.right), bs = Math.min(Mo, bi.bottom);
        return Math.max(0, (ka - ys) * (bs - Na));
      }, Ro = function() {
        Nn = D.y + Qe, bt = Nn + ue, ht = D.x + tt, Ht = ht + me;
      };
      var w, S, E = t, O = E.ownerDocument, $ = bv(E), P = $.getComputedStyle(E), R = P.width, L = P.height, B = P.position, j = E.style.left, A = E.style.top, T = E.style.right, k = E.style.bottom, F = E.style.overflow, W = $o($o({}, i[r]), o), V = O.createElement("div");
      (w = E.parentElement) === null || w === void 0 || w.appendChild(V), V.style.left = "".concat(E.offsetLeft, "px"), V.style.top = "".concat(E.offsetTop, "px"), V.style.position = B, V.style.height = "".concat(E.offsetHeight, "px"), V.style.width = "".concat(E.offsetWidth, "px"), E.style.left = "0", E.style.top = "0", E.style.right = "auto", E.style.bottom = "auto", E.style.overflow = "hidden";
      var G;
      if (Array.isArray(n))
        G = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var X = n.getBoundingClientRect();
        G = {
          x: X.x,
          y: X.y,
          width: X.width,
          height: X.height
        };
      }
      var D = E.getBoundingClientRect(), te = O.documentElement, ee = te.clientWidth, U = te.clientHeight, he = te.scrollWidth, re = te.scrollHeight, de = te.scrollTop, we = te.scrollLeft, ue = D.height, me = D.width, Se = G.height, _e = G.width, Ge = {
        left: 0,
        top: 0,
        right: ee,
        bottom: U
      }, Fe = {
        left: -we,
        top: -de,
        right: he - we,
        bottom: re - de
      }, Ae = W.htmlRegion, Me = "visible", et = "visibleFirst";
      Ae !== "scroll" && Ae !== et && (Ae = Me);
      var De = Ae === et, je = _j(Fe, p), ie = _j(Ge, p), fe = Ae === Me ? ie : je, be = De ? ie : fe;
      E.style.left = "auto", E.style.top = "auto", E.style.right = "0", E.style.bottom = "0";
      var Te = E.getBoundingClientRect();
      E.style.left = j, E.style.top = A, E.style.right = T, E.style.bottom = k, E.style.overflow = F, (S = E.parentElement) === null || S === void 0 || S.removeChild(V);
      var Le = Bg(Math.round(me / parseFloat(R) * 1e3) / 1e3), ct = Bg(Math.round(ue / parseFloat(L) * 1e3) / 1e3);
      if (Le === 0 || ct === 0 || LT(n) && !Ixe(n))
        return;
      var Z = W.offset, se = W.targetOffset, Ce = Pj(D, Z), Pe = ji(Ce, 2), Ee = Pe[0], We = Pe[1], ze = Pj(G, se), Ye = ji(ze, 2), xt = Ye[0], Lt = Ye[1];
      G.x -= xt, G.y -= Lt;
      var mt = W.points || [], St = ji(mt, 2), Et = St[0], Je = St[1], Ze = Tj(Je), ut = Tj(Et), cn = Td(G, Ze), un = Td(D, ut), bn = $o({}, W), tt = cn.x - un.x + Ee, Qe = cn.y - un.y + We, rn = wn(tt, Qe), Xe = wn(tt, Qe, ie), it = Td(G, ["t", "l"]), _t = Td(D, ["t", "l"]), Yt = Td(G, ["b", "r"]), gn = Td(D, ["b", "r"]), Zt = W.overflow || {}, dr = Zt.adjustX, pr = Zt.adjustY, Gn = Zt.shiftX, Mn = Zt.shiftY, Hr = function(mr) {
        return typeof mr == "boolean" ? mr : mr >= 0;
      }, Nn, bt, ht, Ht;
      Ro();
      var Sn = Hr(pr), hr = ut[0] === Ze[0];
      if (Sn && ut[0] === "t" && (bt > be.bottom || g.current.bt)) {
        var In = Qe;
        hr ? In -= ue - Se : In = it.y - gn.y - We;
        var Kn = wn(tt, In), vi = wn(tt, In, ie);
        // Of course use larger one
        Kn > rn || Kn === rn && (!De || // Choose recommend one
        vi >= Xe) ? (g.current.bt = !0, Qe = In, We = -We, bn.points = [Dc(ut, 0), Dc(Ze, 0)]) : g.current.bt = !1;
      }
      if (Sn && ut[0] === "b" && (Nn < be.top || g.current.tb)) {
        var Vt = Qe;
        hr ? Vt += ue - Se : Vt = Yt.y - _t.y - We;
        var Sr = wn(tt, Vt), Xr = wn(tt, Vt, ie);
        // Of course use larger one
        Sr > rn || Sr === rn && (!De || // Choose recommend one
        Xr >= Xe) ? (g.current.tb = !0, Qe = Vt, We = -We, bn.points = [Dc(ut, 0), Dc(Ze, 0)]) : g.current.tb = !1;
      }
      var Ri = Hr(dr), Dr = ut[1] === Ze[1];
      if (Ri && ut[1] === "l" && (Ht > be.right || g.current.rl)) {
        var Or = tt;
        Dr ? Or -= me - _e : Or = it.x - gn.x - Ee;
        var qi = wn(Or, Qe), Yi = wn(Or, Qe, ie);
        // Of course use larger one
        qi > rn || qi === rn && (!De || // Choose recommend one
        Yi >= Xe) ? (g.current.rl = !0, tt = Or, Ee = -Ee, bn.points = [Dc(ut, 1), Dc(Ze, 1)]) : g.current.rl = !1;
      }
      if (Ri && ut[1] === "r" && (ht < be.left || g.current.lr)) {
        var jr = tt;
        Dr ? jr += me - _e : jr = Yt.x - _t.x - Ee;
        var Xi = wn(jr, Qe), qn = wn(jr, Qe, ie);
        // Of course use larger one
        Xi > rn || Xi === rn && (!De || // Choose recommend one
        qn >= Xe) ? (g.current.lr = !0, tt = jr, Ee = -Ee, bn.points = [Dc(ut, 1), Dc(Ze, 1)]) : g.current.lr = !1;
      }
      Ro();
      var Qn = Gn === !0 ? 0 : Gn;
      typeof Qn == "number" && (ht < ie.left && (tt -= ht - ie.left - Ee, G.x + _e < ie.left + Qn && (tt += G.x - ie.left + _e - Qn)), Ht > ie.right && (tt -= Ht - ie.right - Ee, G.x > ie.right - Qn && (tt += G.x - ie.right + Qn)));
      var Jn = Mn === !0 ? 0 : Mn;
      typeof Jn == "number" && (Nn < ie.top && (Qe -= Nn - ie.top - We, G.y + Se < ie.top + Jn && (Qe += G.y - ie.top + Se - Jn)), bt > ie.bottom && (Qe -= bt - ie.bottom - We, G.y > ie.bottom - Jn && (Qe += G.y - ie.bottom + Jn)));
      var Wr = D.x + tt, oi = Wr + me, nr = D.y + Qe, Qi = nr + ue, Kt = G.x, wt = Kt + _e, an = G.y, rr = an + Se, kn = Math.max(Wr, Kt), Fr = Math.min(oi, wt), ai = (kn + Fr) / 2, Ao = ai - Wr, si = Math.max(nr, an), yi = Math.min(Qi, rr), Mi = (si + yi) / 2, Ji = Mi - nr;
      a == null || a(t, bn);
      var Ni = Te.right - D.x - (tt + D.width), ta = Te.bottom - D.y - (Qe + D.height);
      f({
        ready: !0,
        offsetX: tt / Le,
        offsetY: Qe / ct,
        offsetR: Ni / Le,
        offsetB: ta / ct,
        arrowX: Ao / Le,
        arrowY: Ji / ct,
        scaleX: Le,
        scaleY: ct,
        align: bn
      });
    }
  }), x = function() {
    d.current += 1;
    var S = d.current;
    Promise.resolve().then(function() {
      d.current === S && y();
    });
  }, b = function() {
    f(function(S) {
      return $o($o({}, S), {}, {
        ready: !1
      });
    });
  };
  return vl(b, [r]), vl(function() {
    e || b();
  }, [e]), [c.ready, c.offsetX, c.offsetY, c.offsetR, c.offsetB, c.arrowX, c.arrowY, c.scaleX, c.scaleY, c.align, x];
}
function Nxe(e) {
  if (Array.isArray(e))
    return kT(e);
}
function kxe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Lxe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ij(e) {
  return Nxe(e) || kxe(e) || U7(e) || Lxe();
}
function Dxe(e, t, n, r, i) {
  vl(function() {
    if (e && t && n) {
      let d = function() {
        r(), i();
      };
      var o = t, a = n, s = jT(o), l = jT(a), c = bv(a), f = new Set([c].concat(Ij(s), Ij(l)));
      return f.forEach(function(p) {
        p.addEventListener("scroll", d, {
          passive: !0
        });
      }), c.addEventListener("resize", d, {
        passive: !0
      }), r(), function() {
        f.forEach(function(p) {
          p.removeEventListener("scroll", d), c.removeEventListener("resize", d);
        });
      };
    }
  }, [e, t, n]);
}
function jxe(e, t, n, r, i, o, a, s) {
  var l = m.useRef(e);
  l.current = e, m.useEffect(function() {
    if (t && r && (!i || o)) {
      var c = function(g) {
        var v = g.target;
        l.current && !a(v) && s(!1);
      }, f = bv(r);
      f.addEventListener("mousedown", c, !0), f.addEventListener("contextmenu", c, !0);
      var d = DT(n);
      return d && (d.addEventListener("mousedown", c, !0), d.addEventListener("contextmenu", c, !0)), function() {
        f.removeEventListener("mousedown", c, !0), f.removeEventListener("contextmenu", c, !0), d && (d.removeEventListener("mousedown", c, !0), d.removeEventListener("contextmenu", c, !0));
      };
    }
  }, [t, n, r, i, o]);
}
var Fxe = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function Bxe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pv, t = /* @__PURE__ */ m.forwardRef(function(n, r) {
    var i = n.prefixCls, o = i === void 0 ? "rc-trigger-popup" : i, a = n.children, s = n.action, l = s === void 0 ? "hover" : s, c = n.showAction, f = n.hideAction, d = n.popupVisible, p = n.defaultPopupVisible, g = n.onPopupVisibleChange, v = n.afterPopupVisibleChange, y = n.mouseEnterDelay, x = n.mouseLeaveDelay, b = x === void 0 ? 0.1 : x, w = n.focusDelay, S = n.blurDelay, E = n.mask, O = n.maskClosable, $ = O === void 0 ? !0 : O, P = n.getPopupContainer, R = n.forceRender, L = n.autoDestroy, B = n.destroyPopupOnHide, j = n.popup, A = n.popupClassName, T = n.popupStyle, k = n.popupPlacement, F = n.builtinPlacements, W = F === void 0 ? {} : F, V = n.popupAlign, G = n.zIndex, X = n.stretch, D = n.getPopupClassNameFromAlign, te = n.fresh, ee = n.alignPoint, U = n.onPopupClick, he = n.onPopupAlign, re = n.arrow, de = n.popupMotion, we = n.maskMotion, ue = n.popupTransitionName, me = n.popupAnimation, Se = n.maskTransitionName, _e = n.maskAnimation, Ge = n.className, Fe = n.getTriggerDOMNode, Ae = rxe(n, Fxe), Me = L || B || !1, et = m.useState(!1), De = ji(et, 2), je = De[0], ie = De[1];
    vl(function() {
      ie(vxe());
    }, []);
    var fe = m.useRef({}), be = m.useContext(Cj), Te = m.useMemo(function() {
      return {
        registerSubPopup: function(He, Nt) {
          fe.current[He] = Nt, be == null || be.registerSubPopup(He, Nt);
        }
      };
    }, [be]), Le = mxe(), ct = m.useState(null), Z = ji(ct, 2), se = Z[0], Ce = Z[1], Pe = of(function(xe) {
      LT(xe) && se !== xe && Ce(xe), be == null || be.registerSubPopup(Le, xe);
    }), Ee = m.useState(null), We = ji(Ee, 2), ze = We[0], Ye = We[1], xt = m.useRef(null), Lt = of(function(xe) {
      LT(xe) && ze !== xe && (Ye(xe), xt.current = xe);
    }), mt = m.Children.only(a), St = (mt == null ? void 0 : mt.props) || {}, Et = {}, Je = of(function(xe) {
      var He, Nt, Wt = ze;
      return (Wt == null ? void 0 : Wt.contains(xe)) || ((He = DT(Wt)) === null || He === void 0 ? void 0 : He.host) === xe || xe === Wt || (se == null ? void 0 : se.contains(xe)) || ((Nt = DT(se)) === null || Nt === void 0 ? void 0 : Nt.host) === xe || xe === se || Object.values(fe.current).some(function(kt) {
        return (kt == null ? void 0 : kt.contains(xe)) || xe === kt;
      });
    }), Ze = $j(o, de, me, ue), ut = $j(o, we, _e, Se), cn = m.useState(p || !1), un = ji(cn, 2), bn = un[0], tt = un[1], Qe = d ?? bn, rn = of(function(xe) {
      d === void 0 && tt(xe);
    });
    vl(function() {
      tt(d || !1);
    }, [d]);
    var Xe = m.useRef(Qe);
    Xe.current = Qe;
    var it = m.useRef([]);
    it.current = [];
    var _t = of(function(xe) {
      var He;
      rn(xe), ((He = it.current[it.current.length - 1]) !== null && He !== void 0 ? He : Qe) !== xe && (it.current.push(xe), g == null || g(xe));
    }), Yt = m.useRef(), gn = function() {
      clearTimeout(Yt.current);
    }, Zt = function(He) {
      var Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      gn(), Nt === 0 ? _t(He) : Yt.current = setTimeout(function() {
        _t(He);
      }, Nt * 1e3);
    };
    m.useEffect(function() {
      return gn;
    }, []);
    var dr = m.useState(!1), pr = ji(dr, 2), Gn = pr[0], Mn = pr[1];
    vl(function(xe) {
      (!xe || Qe) && Mn(!0);
    }, [Qe]);
    var Hr = m.useState(null), Nn = ji(Hr, 2), bt = Nn[0], ht = Nn[1], Ht = m.useState([0, 0]), Sn = ji(Ht, 2), hr = Sn[0], In = Sn[1], Kn = function(He) {
      In([He.clientX, He.clientY]);
    }, vi = Mxe(Qe, se, ee ? hr : ze, k, W, V, he), Vt = ji(vi, 11), Sr = Vt[0], Xr = Vt[1], Ri = Vt[2], Dr = Vt[3], Or = Vt[4], qi = Vt[5], Yi = Vt[6], jr = Vt[7], Xi = Vt[8], qn = Vt[9], Qn = Vt[10], Jn = Txe(je, l, c, f), Wr = ji(Jn, 2), oi = Wr[0], nr = Wr[1], Qi = oi.has("click"), Kt = nr.has("click") || nr.has("contextMenu"), wt = of(function() {
      Gn || Qn();
    }), an = function() {
      Xe.current && ee && Kt && Zt(!1);
    };
    Dxe(Qe, ze, se, wt, an), vl(function() {
      wt();
    }, [hr, k]), vl(function() {
      Qe && !(W != null && W[k]) && wt();
    }, [JSON.stringify(V)]);
    var rr = m.useMemo(function() {
      var xe = Rxe(W, o, qn, ee);
      return ft(xe, D == null ? void 0 : D(qn));
    }, [qn, D, W, o, ee]);
    m.useImperativeHandle(r, function() {
      return {
        nativeElement: xt.current,
        forceAlign: wt
      };
    });
    var kn = m.useState(0), Fr = ji(kn, 2), ai = Fr[0], Ao = Fr[1], si = m.useState(0), yi = ji(si, 2), Mi = yi[0], Ji = yi[1], Ni = function() {
      if (X && ze) {
        var He = ze.getBoundingClientRect();
        Ao(He.width), Ji(He.height);
      }
    }, ta = function() {
      Ni(), wt();
    }, wn = function(He) {
      Mn(!1), Qn(), v == null || v(He);
    }, Ro = function() {
      return new Promise(function(He) {
        Ni(), ht(function() {
          return He;
        });
      });
    };
    vl(function() {
      bt && (Qn(), bt(), ht(null));
    }, [bt]);
    function ir(xe, He, Nt, Wt) {
      Et[xe] = function(kt) {
        var na;
        Wt == null || Wt(kt), Zt(He, Nt);
        for (var ws = arguments.length, il = new Array(ws > 1 ? ws - 1 : 0), ra = 1; ra < ws; ra++)
          il[ra - 1] = arguments[ra];
        (na = St[xe]) === null || na === void 0 || na.call.apply(na, [St, kt].concat(il));
      };
    }
    (Qi || Kt) && (Et.onClick = function(xe) {
      var He;
      Xe.current && Kt ? Zt(!1) : !Xe.current && Qi && (Kn(xe), Zt(!0));
      for (var Nt = arguments.length, Wt = new Array(Nt > 1 ? Nt - 1 : 0), kt = 1; kt < Nt; kt++)
        Wt[kt - 1] = arguments[kt];
      (He = St.onClick) === null || He === void 0 || He.call.apply(He, [St, xe].concat(Wt));
    }), jxe(Qe, Kt, ze, se, E, $, Je, Zt);
    var mr = oi.has("hover"), bi = nr.has("hover"), wi, Zi;
    mr && (ir("onMouseEnter", !0, y, function(xe) {
      Kn(xe);
    }), ir("onPointerEnter", !0, y, function(xe) {
      Kn(xe);
    }), wi = function(He) {
      (Qe || Gn) && se !== null && se !== void 0 && se.contains(He.target) && Zt(!0, y);
    }, ee && (Et.onMouseMove = function(xe) {
      var He;
      (He = St.onMouseMove) === null || He === void 0 || He.call(St, xe);
    })), bi && (ir("onMouseLeave", !1, b), ir("onPointerLeave", !1, b), Zi = function() {
      Zt(!1, b);
    }), oi.has("focus") && ir("onFocus", !0, w), nr.has("focus") && ir("onBlur", !1, S), oi.has("contextMenu") && (Et.onContextMenu = function(xe) {
      var He;
      Xe.current && nr.has("contextMenu") ? Zt(!1) : (Kn(xe), Zt(!0)), xe.preventDefault();
      for (var Nt = arguments.length, Wt = new Array(Nt > 1 ? Nt - 1 : 0), kt = 1; kt < Nt; kt++)
        Wt[kt - 1] = arguments[kt];
      (He = St.onContextMenu) === null || He === void 0 || He.call.apply(He, [St, xe].concat(Wt));
    }), Ge && (Et.className = ft(St.className, Ge));
    var eo = $o($o({}, St), Et), Mo = {}, ys = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    ys.forEach(function(xe) {
      Ae[xe] && (Mo[xe] = function() {
        for (var He, Nt = arguments.length, Wt = new Array(Nt), kt = 0; kt < Nt; kt++)
          Wt[kt] = arguments[kt];
        (He = eo[xe]) === null || He === void 0 || He.call.apply(He, [eo].concat(Wt)), Ae[xe].apply(Ae, Wt);
      });
    });
    var Na = /* @__PURE__ */ m.cloneElement(mt, $o($o({}, eo), Mo)), ka = {
      x: qi,
      y: Yi
    }, bs = re ? $o({}, re !== !0 ? re : {}) : null;
    return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Ws, {
      disabled: !Qe,
      ref: Lt,
      onResize: ta
    }, /* @__PURE__ */ m.createElement(Pxe, {
      getTriggerDOMNode: Fe
    }, Na)), /* @__PURE__ */ m.createElement(Cj.Provider, {
      value: Te
    }, /* @__PURE__ */ m.createElement(Oxe, {
      portal: e,
      ref: Pe,
      prefixCls: o,
      popup: j,
      className: ft(A, rr),
      style: T,
      target: ze,
      onMouseEnter: wi,
      onMouseLeave: Zi,
      onPointerEnter: wi,
      zIndex: G,
      open: Qe,
      keepDom: Gn,
      fresh: te,
      onClick: U,
      mask: E,
      motion: Ze,
      maskMotion: ut,
      onVisibleChanged: wn,
      onPrepare: Ro,
      forceRender: R,
      autoDestroy: Me,
      getPopupContainer: P,
      align: qn,
      arrow: bs,
      arrowPos: ka,
      ready: Sr,
      offsetX: Xr,
      offsetY: Ri,
      offsetR: Dr,
      offsetB: Or,
      onAlign: wt,
      stretch: X,
      targetWidth: ai / jr,
      targetHeight: Mi / Xi
    })));
  });
  return t;
}
const q7 = Bxe(pv);
function zxe(e, t) {
  typeof e == "function" ? e(t) : nn(e) === "object" && e && "current" in e && (e.current = t);
}
function Y7() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      zxe(o, i);
    });
  };
}
function X7(e) {
  var t, n, r = yh.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
var It = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= It.F1 && n <= It.F12)
      return !1;
    switch (n) {
      case It.ALT:
      case It.CAPS_LOCK:
      case It.CONTEXT_MENU:
      case It.CTRL:
      case It.DOWN:
      case It.END:
      case It.ESC:
      case It.HOME:
      case It.INSERT:
      case It.LEFT:
      case It.MAC_FF_META:
      case It.META:
      case It.NUMLOCK:
      case It.NUM_CENTER:
      case It.PAGE_DOWN:
      case It.PAGE_UP:
      case It.PAUSE:
      case It.PRINT_SCREEN:
      case It.RIGHT:
      case It.SHIFT:
      case It.UP:
      case It.WIN_KEY:
      case It.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= It.ZERO && t <= It.NINE || t >= It.NUM_ZERO && t <= It.NUM_MULTIPLY || t >= It.A && t <= It.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case It.SPACE:
      case It.QUESTION_MARK:
      case It.NUM_PLUS:
      case It.NUM_MINUS:
      case It.NUM_PERIOD:
      case It.NUM_DIVISION:
      case It.SEMICOLON:
      case It.DASH:
      case It.EQUALS:
      case It.COMMA:
      case It.PERIOD:
      case It.SLASH:
      case It.APOSTROPHE:
      case It.SINGLE_QUOTE:
      case It.OPEN_SQUARE_BRACKET:
      case It.BACKSLASH:
      case It.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, Q7 = function(t) {
  return +setTimeout(t, 16);
}, J7 = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (Q7 = function(t) {
  return window.requestAnimationFrame(t);
}, J7 = function(t) {
  return window.cancelAnimationFrame(t);
});
var Aj = 0, m2 = /* @__PURE__ */ new Map();
function Z7(e) {
  m2.delete(e);
}
var eV = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Aj += 1;
  var r = Aj;
  function i(o) {
    if (o === 0)
      Z7(r), t();
    else {
      var a = Q7(function() {
        i(o - 1);
      });
      m2.set(r, a);
    }
  }
  return i(n), r;
};
eV.cancel = function(e) {
  var t = m2.get(e);
  return Z7(t), J7(t);
};
var Uxe = It.ESC, Hxe = It.TAB;
function Wxe(e) {
  var t = e.visible, n = e.triggerRef, r = e.onVisibleChange, i = e.autoFocus, o = e.overlayRef, a = m.useRef(!1), s = function() {
    if (t) {
      var d, p;
      (d = n.current) === null || d === void 0 || (p = d.focus) === null || p === void 0 || p.call(d), r == null || r(!1);
    }
  }, l = function() {
    var d;
    return (d = o.current) !== null && d !== void 0 && d.focus ? (o.current.focus(), a.current = !0, !0) : !1;
  }, c = function(d) {
    switch (d.keyCode) {
      case Uxe:
        s();
        break;
      case Hxe: {
        var p = !1;
        a.current || (p = l()), p ? d.preventDefault() : s();
        break;
      }
    }
  };
  m.useEffect(function() {
    return t ? (window.addEventListener("keydown", c), i && eV(l, 3), function() {
      window.removeEventListener("keydown", c), a.current = !1;
    }) : function() {
      a.current = !1;
    };
  }, [t]);
}
var Vxe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.overlay, r = e.arrow, i = e.prefixCls, o = m.useMemo(function() {
    var s;
    return typeof n == "function" ? s = n() : s = n, s;
  }, [n]), a = Y7(t, o == null ? void 0 : o.ref);
  return /* @__PURE__ */ oe.createElement(oe.Fragment, null, r && /* @__PURE__ */ oe.createElement("div", {
    className: "".concat(i, "-arrow")
  }), /* @__PURE__ */ oe.cloneElement(o, {
    ref: X7(o) ? a : void 0
  }));
}), Id = {
  adjustX: 1,
  adjustY: 1
}, Ad = [0, 0], Gxe = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Id,
    offset: [0, -4],
    targetOffset: Ad
  },
  top: {
    points: ["bc", "tc"],
    overflow: Id,
    offset: [0, -4],
    targetOffset: Ad
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Id,
    offset: [0, -4],
    targetOffset: Ad
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Id,
    offset: [0, 4],
    targetOffset: Ad
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Id,
    offset: [0, 4],
    targetOffset: Ad
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Id,
    offset: [0, 4],
    targetOffset: Ad
  }
}, Kxe = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function qxe(e, t) {
  var n, r = e.arrow, i = r === void 0 ? !1 : r, o = e.prefixCls, a = o === void 0 ? "rc-dropdown" : o, s = e.transitionName, l = e.animation, c = e.align, f = e.placement, d = f === void 0 ? "bottomLeft" : f, p = e.placements, g = p === void 0 ? Gxe : p, v = e.getPopupContainer, y = e.showAction, x = e.hideAction, b = e.overlayClassName, w = e.overlayStyle, S = e.visible, E = e.trigger, O = E === void 0 ? ["hover"] : E, $ = e.autoFocus, P = e.overlay, R = e.children, L = e.onVisibleChange, B = _n(e, Kxe), j = oe.useState(), A = ke(j, 2), T = A[0], k = A[1], F = "visible" in e ? S : T, W = oe.useRef(null), V = oe.useRef(null), G = oe.useRef(null);
  oe.useImperativeHandle(t, function() {
    return W.current;
  });
  var X = function(ue) {
    k(ue), L == null || L(ue);
  };
  Wxe({
    visible: F,
    triggerRef: G,
    onVisibleChange: X,
    autoFocus: $,
    overlayRef: V
  });
  var D = function(ue) {
    var me = e.onOverlayClick;
    k(!1), me && me(ue);
  }, te = function() {
    return /* @__PURE__ */ oe.createElement(Vxe, {
      ref: V,
      overlay: P,
      prefixCls: a,
      arrow: i
    });
  }, ee = function() {
    return typeof P == "function" ? te : te();
  }, U = function() {
    var ue = e.minOverlayWidthMatchTrigger, me = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? ue : !me;
  }, he = function() {
    var ue = e.openClassName;
    return ue !== void 0 ? ue : "".concat(a, "-open");
  }, re = /* @__PURE__ */ oe.cloneElement(R, {
    className: ft((n = R.props) === null || n === void 0 ? void 0 : n.className, F && he()),
    ref: X7(R) ? Y7(G, R.ref) : void 0
  }), de = x;
  return !de && O.indexOf("contextMenu") !== -1 && (de = ["click"]), /* @__PURE__ */ oe.createElement(q7, jt({
    builtinPlacements: g
  }, B, {
    prefixCls: a,
    ref: W,
    popupClassName: ft(b, ce({}, "".concat(a, "-show-arrow"), i)),
    popupStyle: w,
    action: O,
    showAction: y,
    hideAction: de,
    popupPlacement: d,
    popupAlign: c,
    popupTransitionName: s,
    popupAnimation: l,
    popupVisible: F,
    stretch: U() ? "minWidth" : "",
    popup: ee(),
    onPopupVisibleChange: X,
    onPopupClick: D,
    getPopupContainer: v
  }), re);
}
const Yxe = /* @__PURE__ */ oe.forwardRef(qxe);
function Rj(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function Xxe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Mj = Xxe() ? m.useLayoutEffect : m.useEffect, Nj = function(t, n) {
  var r = m.useRef(!0);
  Mj(function() {
    if (!r.current)
      return t();
  }, n), Mj(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
};
function kj(e) {
  var t = m.useRef(!1), n = m.useState(e), r = ke(n, 2), i = r[0], o = r[1];
  m.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || o(s);
  }
  return [i, a];
}
function J$(e) {
  return e !== void 0;
}
function vb(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = kj(function() {
    return J$(i) ? i : J$(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = ke(s, 2), c = l[0], f = l[1], d = i !== void 0 ? i : c, p = a ? a(d) : d, g = Rj(o), v = kj([d]), y = ke(v, 2), x = y[0], b = y[1];
  Nj(function() {
    var S = x[0];
    c !== S && g(c, S);
  }, [x]), Nj(function() {
    J$(i) || f(i);
  }, [i]);
  var w = Rj(function(S, E) {
    f(S, E), b([d], E);
  });
  return [p, w];
}
var FT = {}, Qxe = function(t) {
};
function Jxe(e, t) {
}
function Zxe(e, t) {
}
function eCe() {
  FT = {};
}
function tV(e, t, n) {
  !t && !FT[n] && (e(!1, n), FT[n] = !0);
}
function Sh(e, t) {
  tV(Jxe, e, t);
}
function tCe(e, t) {
  tV(Zxe, e, t);
}
Sh.preMessage = Qxe;
Sh.resetWarned = eCe;
Sh.noteOnce = tCe;
function nV(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = r.has(o);
    if (Sh(!l, "Warning: There may be circular references"), l)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var c = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var f = 0; f < o.length; f++)
        if (!i(o[f], a[f], c))
          return !1;
      return !0;
    }
    if (o && a && nn(o) === "object" && nn(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(p) {
        return i(o[p], a[p], c);
      });
    }
    return !1;
  }
  return i(e, t);
}
var rV = /* @__PURE__ */ m.createContext(null);
function iV(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function oV(e) {
  var t = m.useContext(rV);
  return iV(t, e);
}
function aV(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var nCe = ["children", "locked"], Ys = /* @__PURE__ */ m.createContext(null);
function rCe(e, t) {
  var n = ye({}, e);
  return Object.keys(t).forEach(function(r) {
    var i = t[r];
    i !== void 0 && (n[r] = i);
  }), n;
}
function zg(e) {
  var t = e.children, n = e.locked, r = _n(e, nCe), i = m.useContext(Ys), o = aV(function() {
    return rCe(i, r);
  }, [i, r], function(a, s) {
    return !n && (a[0] !== s[0] || !nV(a[1], s[1], !0));
  });
  return /* @__PURE__ */ m.createElement(Ys.Provider, {
    value: o
  }, t);
}
var iCe = [], sV = /* @__PURE__ */ m.createContext(null);
function tx() {
  return m.useContext(sV);
}
var lV = /* @__PURE__ */ m.createContext(iCe);
function wv(e) {
  var t = m.useContext(lV);
  return m.useMemo(function() {
    return e !== void 0 ? [].concat(Rt(t), [e]) : t;
  }, [t, e]);
}
var cV = /* @__PURE__ */ m.createContext(null), g2 = /* @__PURE__ */ m.createContext({});
const oCe = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), o = i.width, a = i.height;
      if (o || a)
        return !0;
    }
  }
  return !1;
};
function Lj(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (oCe(e)) {
    var n = e.nodeName.toLowerCase(), r = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(n) || // Editable element
      e.isContentEditable || // Anchor with href element
      n === "a" && !!e.getAttribute("href")
    ), i = e.getAttribute("tabindex"), o = Number(i), a = null;
    return i && !Number.isNaN(o) ? a = o : r && a === null && (a = 0), r && e.disabled && (a = null), a !== null && (a >= 0 || t && a < 0);
  }
  return !1;
}
function aCe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = Rt(e.querySelectorAll("*")).filter(function(r) {
    return Lj(r, t);
  });
  return Lj(e, t) && n.unshift(e), n;
}
var vt = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= vt.F1 && n <= vt.F12)
      return !1;
    switch (n) {
      case vt.ALT:
      case vt.CAPS_LOCK:
      case vt.CONTEXT_MENU:
      case vt.CTRL:
      case vt.DOWN:
      case vt.END:
      case vt.ESC:
      case vt.HOME:
      case vt.INSERT:
      case vt.LEFT:
      case vt.MAC_FF_META:
      case vt.META:
      case vt.NUMLOCK:
      case vt.NUM_CENTER:
      case vt.PAGE_DOWN:
      case vt.PAGE_UP:
      case vt.PAUSE:
      case vt.PRINT_SCREEN:
      case vt.RIGHT:
      case vt.SHIFT:
      case vt.UP:
      case vt.WIN_KEY:
      case vt.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= vt.ZERO && t <= vt.NINE || t >= vt.NUM_ZERO && t <= vt.NUM_MULTIPLY || t >= vt.A && t <= vt.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case vt.SPACE:
      case vt.QUESTION_MARK:
      case vt.NUM_PLUS:
      case vt.NUM_MINUS:
      case vt.NUM_PERIOD:
      case vt.NUM_DIVISION:
      case vt.SEMICOLON:
      case vt.DASH:
      case vt.EQUALS:
      case vt.COMMA:
      case vt.PERIOD:
      case vt.SLASH:
      case vt.APOSTROPHE:
      case vt.SINGLE_QUOTE:
      case vt.OPEN_SQUARE_BRACKET:
      case vt.BACKSLASH:
      case vt.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, uV = function(t) {
  return +setTimeout(t, 16);
}, fV = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (uV = function(t) {
  return window.requestAnimationFrame(t);
}, fV = function(t) {
  return window.cancelAnimationFrame(t);
});
var Dj = 0, v2 = /* @__PURE__ */ new Map();
function dV(e) {
  v2.delete(e);
}
var $p = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Dj += 1;
  var r = Dj;
  function i(o) {
    if (o === 0)
      dV(r), t();
    else {
      var a = uV(function() {
        i(o - 1);
      });
      v2.set(r, a);
    }
  }
  return i(n), r;
};
$p.cancel = function(e) {
  var t = v2.get(e);
  return dV(t), fV(t);
};
var BT = vt.LEFT, zT = vt.RIGHT, UT = vt.UP, yb = vt.DOWN, bb = vt.ENTER, pV = vt.ESC, xm = vt.HOME, Cm = vt.END, jj = [UT, yb, BT, zT];
function sCe(e, t, n, r) {
  var i, o = "prev", a = "next", s = "children", l = "parent";
  if (e === "inline" && r === bb)
    return {
      inlineTrigger: !0
    };
  var c = ce(ce({}, UT, o), yb, a), f = ce(ce(ce(ce({}, BT, n ? a : o), zT, n ? o : a), yb, s), bb, s), d = ce(ce(ce(ce(ce(ce({}, UT, o), yb, a), bb, s), pV, l), BT, n ? s : l), zT, n ? l : s), p = {
    inline: c,
    horizontal: f,
    vertical: d,
    inlineSub: c,
    horizontalSub: d,
    verticalSub: d
  }, g = (i = p["".concat(e).concat(t ? "" : "Sub")]) === null || i === void 0 ? void 0 : i[r];
  switch (g) {
    case o:
      return {
        offset: -1,
        sibling: !0
      };
    case a:
      return {
        offset: 1,
        sibling: !0
      };
    case l:
      return {
        offset: -1,
        sibling: !1
      };
    case s:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function lCe(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function cCe(e, t) {
  for (var n = e || document.activeElement; n; ) {
    if (t.has(n))
      return n;
    n = n.parentElement;
  }
  return null;
}
function y2(e, t) {
  var n = aCe(e, !0);
  return n.filter(function(r) {
    return t.has(r);
  });
}
function Fj(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var i = y2(e, t), o = i.length, a = i.findIndex(function(s) {
    return n === s;
  });
  return r < 0 ? a === -1 ? a = o - 1 : a -= 1 : r > 0 && (a += 1), a = (a + o) % o, i[a];
}
var HT = function(t, n) {
  var r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  return t.forEach(function(a) {
    var s = document.querySelector("[data-menu-id='".concat(iV(n, a), "']"));
    s && (r.add(s), o.set(s, a), i.set(a, s));
  }), {
    elements: r,
    key2element: i,
    element2key: o
  };
};
function uCe(e, t, n, r, i, o, a, s, l, c) {
  var f = m.useRef(), d = m.useRef();
  d.current = t;
  var p = function() {
    $p.cancel(f.current);
  };
  return m.useEffect(function() {
    return function() {
      p();
    };
  }, []), function(g) {
    var v = g.which;
    if ([].concat(jj, [bb, pV, xm, Cm]).includes(v)) {
      var y = o(), x = HT(y, r), b = x, w = b.elements, S = b.key2element, E = b.element2key, O = S.get(t), $ = cCe(O, w), P = E.get($), R = sCe(e, a(P, !0).length === 1, n, v);
      if (!R && v !== xm && v !== Cm)
        return;
      (jj.includes(v) || [xm, Cm].includes(v)) && g.preventDefault();
      var L = function(V) {
        if (V) {
          var G = V, X = V.querySelector("a");
          X != null && X.getAttribute("href") && (G = X);
          var D = E.get(V);
          s(D), p(), f.current = $p(function() {
            d.current === D && G.focus();
          });
        }
      };
      if ([xm, Cm].includes(v) || R.sibling || !$) {
        var B;
        !$ || e === "inline" ? B = i.current : B = lCe($);
        var j, A = y2(B, w);
        v === xm ? j = A[0] : v === Cm ? j = A[A.length - 1] : j = Fj(B, w, $, R.offset), L(j);
      } else if (R.inlineTrigger)
        l(P);
      else if (R.offset > 0)
        l(P, !0), p(), f.current = $p(function() {
          x = HT(y, r);
          var W = $.getAttribute("aria-controls"), V = document.getElementById(W), G = Fj(V, x.elements);
          L(G);
        }, 5);
      else if (R.offset < 0) {
        var T = a(P, !0), k = T[T.length - 2], F = S.get(k);
        l(k, !1), L(F);
      }
    }
    c == null || c(g);
  };
}
function fCe(e) {
  Promise.resolve().then(e);
}
var b2 = "__RC_UTIL_PATH_SPLIT__", Bj = function(t) {
  return t.join(b2);
}, dCe = function(t) {
  return t.split(b2);
}, WT = "rc-menu-more";
function pCe() {
  var e = m.useState({}), t = ke(e, 2), n = t[1], r = m.useRef(/* @__PURE__ */ new Map()), i = m.useRef(/* @__PURE__ */ new Map()), o = m.useState([]), a = ke(o, 2), s = a[0], l = a[1], c = m.useRef(0), f = m.useRef(!1), d = function() {
    f.current || n({});
  }, p = m.useCallback(function(S, E) {
    var O = Bj(E);
    i.current.set(O, S), r.current.set(S, O), c.current += 1;
    var $ = c.current;
    fCe(function() {
      $ === c.current && d();
    });
  }, []), g = m.useCallback(function(S, E) {
    var O = Bj(E);
    i.current.delete(O), r.current.delete(S);
  }, []), v = m.useCallback(function(S) {
    l(S);
  }, []), y = m.useCallback(function(S, E) {
    var O = r.current.get(S) || "", $ = dCe(O);
    return E && s.includes($[0]) && $.unshift(WT), $;
  }, [s]), x = m.useCallback(function(S, E) {
    return S.some(function(O) {
      var $ = y(O, !0);
      return $.includes(E);
    });
  }, [y]), b = function() {
    var E = Rt(r.current.keys());
    return s.length && E.push(WT), E;
  }, w = m.useCallback(function(S) {
    var E = "".concat(r.current.get(S)).concat(b2), O = /* @__PURE__ */ new Set();
    return Rt(i.current.keys()).forEach(function($) {
      $.startsWith(E) && O.add(i.current.get($));
    }), O;
  }, []);
  return m.useEffect(function() {
    return function() {
      f.current = !0;
    };
  }, []), {
    // Register
    registerPath: p,
    unregisterPath: g,
    refreshOverflowKeys: v,
    // Util
    isSubPathKey: x,
    getKeyPath: y,
    getKeys: b,
    getSubPathKeys: w
  };
}
function Dm(e) {
  var t = m.useRef(e);
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return e ? n : void 0;
}
var hCe = Math.random().toFixed(5).toString().slice(2), zj = 0;
function mCe(e) {
  var t = vb(e, {
    value: e
  }), n = ke(t, 2), r = n[0], i = n[1];
  return m.useEffect(function() {
    zj += 1;
    var o = "".concat(hCe, "-").concat(zj);
    i("rc-menu-uuid-".concat(o));
  }, []), r;
}
function hV(e, t) {
  var n = ye({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function gCe(e, t) {
  typeof e == "function" ? e(t) : nn(e) === "object" && e && "current" in e && (e.current = t);
}
function vCe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      gCe(o, i);
    });
  };
}
function yCe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return aV(function() {
    return vCe.apply(void 0, t);
  }, t, function(r, i) {
    return r.length === i.length && r.every(function(o, a) {
      return o === i[a];
    });
  });
}
function mV(e, t, n, r) {
  var i = m.useContext(Ys), o = i.activeKey, a = i.onActive, s = i.onInactive, l = {
    active: o === e
  };
  return t || (l.onMouseEnter = function(c) {
    n == null || n({
      key: e,
      domEvent: c
    }), a(e);
  }, l.onMouseLeave = function(c) {
    r == null || r({
      key: e,
      domEvent: c
    }), s(e);
  }), l;
}
function gV(e) {
  var t = m.useContext(Ys), n = t.mode, r = t.rtl, i = t.inlineIndent;
  if (n !== "inline")
    return null;
  var o = e;
  return r ? {
    paddingRight: o * i
  } : {
    paddingLeft: o * i
  };
}
function vV(e) {
  var t = e.icon, n = e.props, r = e.children, i;
  return t === null || t === !1 ? null : (typeof t == "function" ? i = /* @__PURE__ */ m.createElement(t, ye({}, n)) : typeof t != "boolean" && (i = t), i || r || null);
}
var bCe = ["item"];
function F1(e) {
  var t = e.item, n = _n(e, bCe);
  return Object.defineProperty(n, "item", {
    get: function() {
      return Sh(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), n;
}
var wCe = ["title", "attribute", "elementRef"], SCe = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], xCe = ["active"], CCe = /* @__PURE__ */ function(e) {
  cv(n, e);
  var t = uv(n);
  function n() {
    return Js(this, n), t.apply(this, arguments);
  }
  return Zs(n, [{
    key: "render",
    value: function() {
      var i = this.props, o = i.title, a = i.attribute, s = i.elementRef, l = _n(i, wCe), c = hV(l, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return Sh(!a, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ m.createElement(cc.Item, jt({}, a, {
        title: typeof o == "string" ? o : void 0
      }, c, {
        ref: s
      }));
    }
  }]), n;
}(m.Component), ECe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.style, r = e.className, i = e.eventKey;
  e.warnKey;
  var o = e.disabled, a = e.itemIcon, s = e.children, l = e.role, c = e.onMouseEnter, f = e.onMouseLeave, d = e.onClick, p = e.onKeyDown, g = e.onFocus, v = _n(e, SCe), y = oV(i), x = m.useContext(Ys), b = x.prefixCls, w = x.onItemClick, S = x.disabled, E = x.overflowDisabled, O = x.itemIcon, $ = x.selectedKeys, P = x.onActive, R = m.useContext(g2), L = R._internalRenderMenuItem, B = "".concat(b, "-item"), j = m.useRef(), A = m.useRef(), T = S || o, k = yCe(t, A), F = wv(i), W = function(me) {
    return {
      key: i,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: Rt(F).reverse(),
      item: j.current,
      domEvent: me
    };
  }, V = a || O, G = mV(i, T, c, f), X = G.active, D = _n(G, xCe), te = $.includes(i), ee = gV(F.length), U = function(me) {
    if (!T) {
      var Se = W(me);
      d == null || d(F1(Se)), w(Se);
    }
  }, he = function(me) {
    if (p == null || p(me), me.which === vt.ENTER) {
      var Se = W(me);
      d == null || d(F1(Se)), w(Se);
    }
  }, re = function(me) {
    P(i), g == null || g(me);
  }, de = {};
  e.role === "option" && (de["aria-selected"] = te);
  var we = /* @__PURE__ */ m.createElement(CCe, jt({
    ref: j,
    elementRef: k,
    role: l === null ? "none" : l || "menuitem",
    tabIndex: o ? null : -1,
    "data-menu-id": E && y ? null : y
  }, v, D, de, {
    component: "li",
    "aria-disabled": o,
    style: ye(ye({}, ee), n),
    className: ft(B, ce(ce(ce({}, "".concat(B, "-active"), X), "".concat(B, "-selected"), te), "".concat(B, "-disabled"), T), r),
    onClick: U,
    onKeyDown: he,
    onFocus: re
  }), s, /* @__PURE__ */ m.createElement(vV, {
    props: ye(ye({}, e), {}, {
      isSelected: te
    }),
    icon: V
  }));
  return L && (we = L(we, e, {
    selected: te
  })), we;
});
function $Ce(e, t) {
  var n = e.eventKey, r = tx(), i = wv(n);
  return m.useEffect(function() {
    if (r)
      return r.registerPath(n, i), function() {
        r.unregisterPath(n, i);
      };
  }, [i]), r ? null : /* @__PURE__ */ m.createElement(ECe, jt({}, e, {
    ref: t
  }));
}
const nx = /* @__PURE__ */ m.forwardRef($Ce);
var _Ce = ["className", "children"], OCe = function(t, n) {
  var r = t.className, i = t.children, o = _n(t, _Ce), a = m.useContext(Ys), s = a.prefixCls, l = a.mode, c = a.rtl;
  return /* @__PURE__ */ m.createElement("ul", jt({
    className: ft(s, c && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(l === "inline" ? "inline" : "vertical"), r),
    role: "menu"
  }, o, {
    "data-menu-list": !0,
    ref: n
  }), i);
}, w2 = /* @__PURE__ */ m.forwardRef(OCe);
w2.displayName = "SubMenuList";
function VT(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return oe.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(VT(r)) : yh.isFragment(r) && r.props ? n = n.concat(VT(r.props.children, t)) : n.push(r));
  }), n;
}
function S2(e, t) {
  return VT(e).map(function(n, r) {
    if (/* @__PURE__ */ m.isValidElement(n)) {
      var i, o, a = n.key, s = (i = (o = n.props) === null || o === void 0 ? void 0 : o.eventKey) !== null && i !== void 0 ? i : a, l = s == null;
      l && (s = "tmp_key-".concat([].concat(Rt(t), [r]).join("-")));
      var c = {
        key: s,
        eventKey: s
      };
      return /* @__PURE__ */ m.cloneElement(n, c);
    }
    return n;
  });
}
var lo = {
  adjustX: 1,
  adjustY: 1
}, PCe = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: lo
  },
  topRight: {
    points: ["br", "tr"],
    overflow: lo
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: lo
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: lo
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: lo
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: lo
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: lo
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: lo
  }
}, TCe = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: lo
  },
  topRight: {
    points: ["br", "tr"],
    overflow: lo
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: lo
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: lo
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: lo
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: lo
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: lo
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: lo
  }
};
function yV(e, t, n) {
  if (t)
    return t;
  if (n)
    return n[e] || n.other;
}
var ICe = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function ACe(e) {
  var t = e.prefixCls, n = e.visible, r = e.children, i = e.popup, o = e.popupStyle, a = e.popupClassName, s = e.popupOffset, l = e.disabled, c = e.mode, f = e.onVisibleChange, d = m.useContext(Ys), p = d.getPopupContainer, g = d.rtl, v = d.subMenuOpenDelay, y = d.subMenuCloseDelay, x = d.builtinPlacements, b = d.triggerSubMenuAction, w = d.forceSubMenuRender, S = d.rootClassName, E = d.motion, O = d.defaultMotions, $ = m.useState(!1), P = ke($, 2), R = P[0], L = P[1], B = ye(g ? ye({}, TCe) : ye({}, PCe), x), j = ICe[c], A = yV(c, E, O), T = m.useRef(A);
  c !== "inline" && (T.current = A);
  var k = ye(ye({}, T.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), F = m.useRef();
  return m.useEffect(function() {
    return F.current = $p(function() {
      L(n);
    }), function() {
      $p.cancel(F.current);
    };
  }, [n]), /* @__PURE__ */ m.createElement(q7, {
    prefixCls: t,
    popupClassName: ft("".concat(t, "-popup"), ce({}, "".concat(t, "-rtl"), g), a, S),
    stretch: c === "horizontal" ? "minWidth" : null,
    getPopupContainer: p,
    builtinPlacements: B,
    popupPlacement: j,
    popupVisible: R,
    popup: i,
    popupStyle: o,
    popupAlign: s && {
      offset: s
    },
    action: l ? [] : [b],
    mouseEnterDelay: v,
    mouseLeaveDelay: y,
    onPopupVisibleChange: f,
    forceRender: w,
    popupMotion: k,
    fresh: !0
  }, r);
}
function RCe(e) {
  var t = e.id, n = e.open, r = e.keyPath, i = e.children, o = "inline", a = m.useContext(Ys), s = a.prefixCls, l = a.forceSubMenuRender, c = a.motion, f = a.defaultMotions, d = a.mode, p = m.useRef(!1);
  p.current = d === o;
  var g = m.useState(!p.current), v = ke(g, 2), y = v[0], x = v[1], b = p.current ? n : !1;
  m.useEffect(function() {
    p.current && x(!1);
  }, [d]);
  var w = ye({}, yV(o, c, f));
  r.length > 1 && (w.motionAppear = !1);
  var S = w.onVisibleChanged;
  return w.onVisibleChanged = function(E) {
    return !p.current && !E && x(!0), S == null ? void 0 : S(E);
  }, y ? null : /* @__PURE__ */ m.createElement(zg, {
    mode: o,
    locked: !p.current
  }, /* @__PURE__ */ m.createElement(Cc, jt({
    visible: b
  }, w, {
    forceRender: l,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(E) {
    var O = E.className, $ = E.style;
    return /* @__PURE__ */ m.createElement(w2, {
      id: t,
      className: O,
      style: $
    }, i);
  }));
}
var MCe = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], NCe = ["active"], kCe = function(t) {
  var n = t.style, r = t.className, i = t.title, o = t.eventKey;
  t.warnKey;
  var a = t.disabled, s = t.internalPopupClose, l = t.children, c = t.itemIcon, f = t.expandIcon, d = t.popupClassName, p = t.popupOffset, g = t.popupStyle, v = t.onClick, y = t.onMouseEnter, x = t.onMouseLeave, b = t.onTitleClick, w = t.onTitleMouseEnter, S = t.onTitleMouseLeave, E = _n(t, MCe), O = oV(o), $ = m.useContext(Ys), P = $.prefixCls, R = $.mode, L = $.openKeys, B = $.disabled, j = $.overflowDisabled, A = $.activeKey, T = $.selectedKeys, k = $.itemIcon, F = $.expandIcon, W = $.onItemClick, V = $.onOpenChange, G = $.onActive, X = m.useContext(g2), D = X._internalRenderSubMenuItem, te = m.useContext(cV), ee = te.isSubPathKey, U = wv(), he = "".concat(P, "-submenu"), re = B || a, de = m.useRef(), we = m.useRef(), ue = c ?? k, me = f ?? F, Se = L.includes(o), _e = !j && Se, Ge = ee(T, o), Fe = mV(o, re, w, S), Ae = Fe.active, Me = _n(Fe, NCe), et = m.useState(!1), De = ke(et, 2), je = De[0], ie = De[1], fe = function(mt) {
    re || ie(mt);
  }, be = function(mt) {
    fe(!0), y == null || y({
      key: o,
      domEvent: mt
    });
  }, Te = function(mt) {
    fe(!1), x == null || x({
      key: o,
      domEvent: mt
    });
  }, Le = m.useMemo(function() {
    return Ae || (R !== "inline" ? je || ee([A], o) : !1);
  }, [R, Ae, A, je, o, ee]), ct = gV(U.length), Z = function(mt) {
    re || (b == null || b({
      key: o,
      domEvent: mt
    }), R === "inline" && V(o, !Se));
  }, se = Dm(function(Lt) {
    v == null || v(F1(Lt)), W(Lt);
  }), Ce = function(mt) {
    R !== "inline" && V(o, mt);
  }, Pe = function() {
    G(o);
  }, Ee = O && "".concat(O, "-popup"), We = /* @__PURE__ */ m.createElement("div", jt({
    role: "menuitem",
    style: ct,
    className: "".concat(he, "-title"),
    tabIndex: re ? null : -1,
    ref: de,
    title: typeof i == "string" ? i : null,
    "data-menu-id": j && O ? null : O,
    "aria-expanded": _e,
    "aria-haspopup": !0,
    "aria-controls": Ee,
    "aria-disabled": re,
    onClick: Z,
    onFocus: Pe
  }, Me), i, /* @__PURE__ */ m.createElement(vV, {
    icon: R !== "horizontal" ? me : void 0,
    props: ye(ye({}, t), {}, {
      isOpen: _e,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ m.createElement("i", {
    className: "".concat(he, "-arrow")
  }))), ze = m.useRef(R);
  if (R !== "inline" && U.length > 1 ? ze.current = "vertical" : ze.current = R, !j) {
    var Ye = ze.current;
    We = /* @__PURE__ */ m.createElement(ACe, {
      mode: Ye,
      prefixCls: he,
      visible: !s && _e && R !== "inline",
      popupClassName: d,
      popupOffset: p,
      popupStyle: g,
      popup: /* @__PURE__ */ m.createElement(
        zg,
        {
          mode: Ye === "horizontal" ? "vertical" : Ye
        },
        /* @__PURE__ */ m.createElement(w2, {
          id: Ee,
          ref: we
        }, l)
      ),
      disabled: re,
      onVisibleChange: Ce
    }, We);
  }
  var xt = /* @__PURE__ */ m.createElement(cc.Item, jt({
    role: "none"
  }, E, {
    component: "li",
    style: n,
    className: ft(he, "".concat(he, "-").concat(R), r, ce(ce(ce(ce({}, "".concat(he, "-open"), _e), "".concat(he, "-active"), Le), "".concat(he, "-selected"), Ge), "".concat(he, "-disabled"), re)),
    onMouseEnter: be,
    onMouseLeave: Te
  }), We, !j && /* @__PURE__ */ m.createElement(RCe, {
    id: Ee,
    open: _e,
    keyPath: U
  }, l));
  return D && (xt = D(xt, t, {
    selected: Ge,
    active: Le,
    open: _e,
    disabled: re
  })), /* @__PURE__ */ m.createElement(zg, {
    onItemClick: se,
    mode: R === "horizontal" ? "vertical" : R,
    itemIcon: ue,
    expandIcon: me
  }, xt);
};
function x2(e) {
  var t = e.eventKey, n = e.children, r = wv(t), i = S2(n, r), o = tx();
  m.useEffect(function() {
    if (o)
      return o.registerPath(t, r), function() {
        o.unregisterPath(t, r);
      };
  }, [r]);
  var a;
  return o ? a = i : a = /* @__PURE__ */ m.createElement(kCe, e, i), /* @__PURE__ */ m.createElement(lV.Provider, {
    value: r
  }, a);
}
var LCe = ["className", "title", "eventKey", "children"], DCe = ["children"], jCe = function(t) {
  var n = t.className, r = t.title;
  t.eventKey;
  var i = t.children, o = _n(t, LCe), a = m.useContext(Ys), s = a.prefixCls, l = "".concat(s, "-item-group");
  return /* @__PURE__ */ m.createElement("li", jt({
    role: "presentation"
  }, o, {
    onClick: function(f) {
      return f.stopPropagation();
    },
    className: ft(l, n)
  }), /* @__PURE__ */ m.createElement("div", {
    role: "presentation",
    className: "".concat(l, "-title"),
    title: typeof r == "string" ? r : void 0
  }, r), /* @__PURE__ */ m.createElement("ul", {
    role: "group",
    className: "".concat(l, "-list")
  }, i));
};
function bV(e) {
  var t = e.children, n = _n(e, DCe), r = wv(n.eventKey), i = S2(t, r), o = tx();
  return o ? i : /* @__PURE__ */ m.createElement(jCe, hV(n, ["warnKey"]), i);
}
function wV(e) {
  var t = e.className, n = e.style, r = m.useContext(Ys), i = r.prefixCls, o = tx();
  return o ? null : /* @__PURE__ */ m.createElement("li", {
    role: "separator",
    className: ft("".concat(i, "-item-divider"), t),
    style: n
  });
}
var FCe = ["label", "children", "key", "type"];
function GT(e) {
  return (e || []).map(function(t, n) {
    if (t && nn(t) === "object") {
      var r = t, i = r.label, o = r.children, a = r.key, s = r.type, l = _n(r, FCe), c = a ?? "tmp-".concat(n);
      return o || s === "group" ? s === "group" ? /* @__PURE__ */ m.createElement(bV, jt({
        key: c
      }, l, {
        title: i
      }), GT(o)) : /* @__PURE__ */ m.createElement(x2, jt({
        key: c
      }, l, {
        title: i
      }), GT(o)) : s === "divider" ? /* @__PURE__ */ m.createElement(wV, jt({
        key: c
      }, l)) : /* @__PURE__ */ m.createElement(nx, jt({
        key: c
      }, l), i);
    }
    return null;
  }).filter(function(t) {
    return t;
  });
}
function BCe(e, t, n) {
  var r = e;
  return t && (r = GT(t)), S2(r, n);
}
var zCe = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem"], Rd = [], UCe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n, r = e, i = r.prefixCls, o = i === void 0 ? "rc-menu" : i, a = r.rootClassName, s = r.style, l = r.className, c = r.tabIndex, f = c === void 0 ? 0 : c, d = r.items, p = r.children, g = r.direction, v = r.id, y = r.mode, x = y === void 0 ? "vertical" : y, b = r.inlineCollapsed, w = r.disabled, S = r.disabledOverflow, E = r.subMenuOpenDelay, O = E === void 0 ? 0.1 : E, $ = r.subMenuCloseDelay, P = $ === void 0 ? 0.1 : $, R = r.forceSubMenuRender, L = r.defaultOpenKeys, B = r.openKeys, j = r.activeKey, A = r.defaultActiveFirst, T = r.selectable, k = T === void 0 ? !0 : T, F = r.multiple, W = F === void 0 ? !1 : F, V = r.defaultSelectedKeys, G = r.selectedKeys, X = r.onSelect, D = r.onDeselect, te = r.inlineIndent, ee = te === void 0 ? 24 : te, U = r.motion, he = r.defaultMotions, re = r.triggerSubMenuAction, de = re === void 0 ? "hover" : re, we = r.builtinPlacements, ue = r.itemIcon, me = r.expandIcon, Se = r.overflowedIndicator, _e = Se === void 0 ? "..." : Se, Ge = r.overflowedIndicatorPopupClassName, Fe = r.getPopupContainer, Ae = r.onClick, Me = r.onOpenChange, et = r.onKeyDown;
  r.openAnimation, r.openTransitionName;
  var De = r._internalRenderMenuItem, je = r._internalRenderSubMenuItem, ie = _n(r, zCe), fe = m.useMemo(function() {
    return BCe(p, d, Rd);
  }, [p, d]), be = m.useState(!1), Te = ke(be, 2), Le = Te[0], ct = Te[1], Z = m.useRef(), se = mCe(v), Ce = g === "rtl", Pe = vb(L, {
    value: B,
    postState: function(wt) {
      return wt || Rd;
    }
  }), Ee = ke(Pe, 2), We = Ee[0], ze = Ee[1], Ye = function(wt) {
    var an = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function rr() {
      ze(wt), Me == null || Me(wt);
    }
    an ? js.flushSync(rr) : rr();
  }, xt = m.useState(We), Lt = ke(xt, 2), mt = Lt[0], St = Lt[1], Et = m.useRef(!1), Je = m.useMemo(function() {
    return (x === "inline" || x === "vertical") && b ? ["vertical", b] : [x, !1];
  }, [x, b]), Ze = ke(Je, 2), ut = Ze[0], cn = Ze[1], un = ut === "inline", bn = m.useState(ut), tt = ke(bn, 2), Qe = tt[0], rn = tt[1], Xe = m.useState(cn), it = ke(Xe, 2), _t = it[0], Yt = it[1];
  m.useEffect(function() {
    rn(ut), Yt(cn), Et.current && (un ? ze(mt) : Ye(Rd));
  }, [ut, cn]);
  var gn = m.useState(0), Zt = ke(gn, 2), dr = Zt[0], pr = Zt[1], Gn = dr >= fe.length - 1 || Qe !== "horizontal" || S;
  m.useEffect(function() {
    un && St(We);
  }, [We]), m.useEffect(function() {
    return Et.current = !0, function() {
      Et.current = !1;
    };
  }, []);
  var Mn = pCe(), Hr = Mn.registerPath, Nn = Mn.unregisterPath, bt = Mn.refreshOverflowKeys, ht = Mn.isSubPathKey, Ht = Mn.getKeyPath, Sn = Mn.getKeys, hr = Mn.getSubPathKeys, In = m.useMemo(function() {
    return {
      registerPath: Hr,
      unregisterPath: Nn
    };
  }, [Hr, Nn]), Kn = m.useMemo(function() {
    return {
      isSubPathKey: ht
    };
  }, [ht]);
  m.useEffect(function() {
    bt(Gn ? Rd : fe.slice(dr + 1).map(function(Kt) {
      return Kt.key;
    }));
  }, [dr, Gn]);
  var vi = vb(j || A && ((n = fe[0]) === null || n === void 0 ? void 0 : n.key), {
    value: j
  }), Vt = ke(vi, 2), Sr = Vt[0], Xr = Vt[1], Ri = Dm(function(Kt) {
    Xr(Kt);
  }), Dr = Dm(function() {
    Xr(void 0);
  });
  m.useImperativeHandle(t, function() {
    return {
      list: Z.current,
      focus: function(wt) {
        var an, rr = Sn(), kn = HT(rr, se), Fr = kn.elements, ai = kn.key2element, Ao = kn.element2key, si = y2(Z.current, Fr), yi = Sr ?? (si[0] ? Ao.get(si[0]) : (an = fe.find(function(Ni) {
          return !Ni.props.disabled;
        })) === null || an === void 0 ? void 0 : an.key), Mi = ai.get(yi);
        if (yi && Mi) {
          var Ji;
          Mi == null || (Ji = Mi.focus) === null || Ji === void 0 || Ji.call(Mi, wt);
        }
      }
    };
  });
  var Or = vb(V || [], {
    value: G,
    // Legacy convert key to array
    postState: function(wt) {
      return Array.isArray(wt) ? wt : wt == null ? Rd : [wt];
    }
  }), qi = ke(Or, 2), Yi = qi[0], jr = qi[1], Xi = function(wt) {
    if (k) {
      var an = wt.key, rr = Yi.includes(an), kn;
      W ? rr ? kn = Yi.filter(function(ai) {
        return ai !== an;
      }) : kn = [].concat(Rt(Yi), [an]) : kn = [an], jr(kn);
      var Fr = ye(ye({}, wt), {}, {
        selectedKeys: kn
      });
      rr ? D == null || D(Fr) : X == null || X(Fr);
    }
    !W && We.length && Qe !== "inline" && Ye(Rd);
  }, qn = Dm(function(Kt) {
    Ae == null || Ae(F1(Kt)), Xi(Kt);
  }), Qn = Dm(function(Kt, wt) {
    var an = We.filter(function(kn) {
      return kn !== Kt;
    });
    if (wt)
      an.push(Kt);
    else if (Qe !== "inline") {
      var rr = hr(Kt);
      an = an.filter(function(kn) {
        return !rr.has(kn);
      });
    }
    nV(We, an, !0) || Ye(an, !0);
  }), Jn = function(wt, an) {
    var rr = an ?? !We.includes(wt);
    Qn(wt, rr);
  }, Wr = uCe(Qe, Sr, Ce, se, Z, Sn, Ht, Xr, Jn, et);
  m.useEffect(function() {
    ct(!0);
  }, []);
  var oi = m.useMemo(function() {
    return {
      _internalRenderMenuItem: De,
      _internalRenderSubMenuItem: je
    };
  }, [De, je]), nr = Qe !== "horizontal" || S ? fe : (
    // Need wrap for overflow dropdown that do not response for open
    fe.map(function(Kt, wt) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ m.createElement(zg, {
          key: Kt.key,
          overflowDisabled: wt > dr
        }, Kt)
      );
    })
  ), Qi = /* @__PURE__ */ m.createElement(cc, jt({
    id: v,
    ref: Z,
    prefixCls: "".concat(o, "-overflow"),
    component: "ul",
    itemComponent: nx,
    className: ft(o, "".concat(o, "-root"), "".concat(o, "-").concat(Qe), l, ce(ce({}, "".concat(o, "-inline-collapsed"), _t), "".concat(o, "-rtl"), Ce), a),
    dir: g,
    style: s,
    role: "menu",
    tabIndex: f,
    data: nr,
    renderRawItem: function(wt) {
      return wt;
    },
    renderRawRest: function(wt) {
      var an = wt.length, rr = an ? fe.slice(-an) : null;
      return /* @__PURE__ */ m.createElement(x2, {
        eventKey: WT,
        title: _e,
        disabled: Gn,
        internalPopupClose: an === 0,
        popupClassName: Ge
      }, rr);
    },
    maxCount: Qe !== "horizontal" || S ? cc.INVALIDATE : cc.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(wt) {
      pr(wt);
    },
    onKeyDown: Wr
  }, ie));
  return /* @__PURE__ */ m.createElement(g2.Provider, {
    value: oi
  }, /* @__PURE__ */ m.createElement(rV.Provider, {
    value: se
  }, /* @__PURE__ */ m.createElement(zg, {
    prefixCls: o,
    rootClassName: a,
    mode: Qe,
    openKeys: We,
    rtl: Ce,
    disabled: w,
    motion: Le ? U : null,
    defaultMotions: Le ? he : null,
    activeKey: Sr,
    onActive: Ri,
    onInactive: Dr,
    selectedKeys: Yi,
    inlineIndent: ee,
    subMenuOpenDelay: O,
    subMenuCloseDelay: P,
    forceSubMenuRender: R,
    builtinPlacements: we,
    triggerSubMenuAction: de,
    getPopupContainer: Fe,
    itemIcon: ue,
    expandIcon: me,
    onItemClick: qn,
    onOpenChange: Qn
  }, /* @__PURE__ */ m.createElement(cV.Provider, {
    value: Kn
  }, Qi), /* @__PURE__ */ m.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ m.createElement(sV.Provider, {
    value: In
  }, fe)))));
}), Sv = UCe;
Sv.Item = nx;
Sv.SubMenu = x2;
Sv.ItemGroup = bV;
Sv.Divider = wV;
var gt = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= gt.F1 && n <= gt.F12)
      return !1;
    switch (n) {
      case gt.ALT:
      case gt.CAPS_LOCK:
      case gt.CONTEXT_MENU:
      case gt.CTRL:
      case gt.DOWN:
      case gt.END:
      case gt.ESC:
      case gt.HOME:
      case gt.INSERT:
      case gt.LEFT:
      case gt.MAC_FF_META:
      case gt.META:
      case gt.NUMLOCK:
      case gt.NUM_CENTER:
      case gt.PAGE_DOWN:
      case gt.PAGE_UP:
      case gt.PAUSE:
      case gt.PRINT_SCREEN:
      case gt.RIGHT:
      case gt.SHIFT:
      case gt.UP:
      case gt.WIN_KEY:
      case gt.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= gt.ZERO && t <= gt.NINE || t >= gt.NUM_ZERO && t <= gt.NUM_MULTIPLY || t >= gt.A && t <= gt.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case gt.SPACE:
      case gt.QUESTION_MARK:
      case gt.NUM_PLUS:
      case gt.NUM_MINUS:
      case gt.NUM_PERIOD:
      case gt.NUM_DIVISION:
      case gt.SEMICOLON:
      case gt.DASH:
      case gt.EQUALS:
      case gt.COMMA:
      case gt.PERIOD:
      case gt.SLASH:
      case gt.APOSTROPHE:
      case gt.SINGLE_QUOTE:
      case gt.OPEN_SQUARE_BRACKET:
      case gt.BACKSLASH:
      case gt.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, HCe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.id, i = e.tabs, o = e.locale, a = e.mobile, s = e.moreIcon, l = s === void 0 ? "More" : s, c = e.moreTransitionName, f = e.style, d = e.className, p = e.editable, g = e.tabBarGutter, v = e.rtl, y = e.removeAriaLabel, x = e.onTabClick, b = e.getPopupContainer, w = e.popupClassName, S = m.useState(!1), E = ke(S, 2), O = E[0], $ = E[1], P = m.useState(null), R = ke(P, 2), L = R[0], B = R[1], j = "".concat(r, "-more-popup"), A = "".concat(n, "-dropdown"), T = L !== null ? "".concat(j, "-").concat(L) : null, k = o == null ? void 0 : o.dropdownAriaLabel;
  function F(ee, U) {
    ee.preventDefault(), ee.stopPropagation(), p.onEdit("remove", {
      key: U,
      event: ee
    });
  }
  var W = /* @__PURE__ */ m.createElement(Sv, {
    onClick: function(U) {
      var he = U.key, re = U.domEvent;
      x(he, re), $(!1);
    },
    prefixCls: "".concat(A, "-menu"),
    id: j,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": T,
    selectedKeys: [L],
    "aria-label": k !== void 0 ? k : "expanded dropdown"
  }, i.map(function(ee) {
    var U = ee.closable, he = ee.disabled, re = ee.closeIcon, de = ee.key, we = ee.label, ue = B7(U, re, p, he);
    return /* @__PURE__ */ m.createElement(nx, {
      key: de,
      id: "".concat(j, "-").concat(de),
      role: "option",
      "aria-controls": r && "".concat(r, "-panel-").concat(de),
      disabled: he
    }, /* @__PURE__ */ m.createElement("span", null, we), ue && /* @__PURE__ */ m.createElement("button", {
      type: "button",
      "aria-label": y || "remove",
      tabIndex: 0,
      className: "".concat(A, "-menu-item-remove"),
      onClick: function(Se) {
        Se.stopPropagation(), F(Se, de);
      }
    }, re || p.removeIcon || "×"));
  }));
  function V(ee) {
    for (var U = i.filter(function(ue) {
      return !ue.disabled;
    }), he = U.findIndex(function(ue) {
      return ue.key === L;
    }) || 0, re = U.length, de = 0; de < re; de += 1) {
      he = (he + ee + re) % re;
      var we = U[he];
      if (!we.disabled) {
        B(we.key);
        return;
      }
    }
  }
  function G(ee) {
    var U = ee.which;
    if (!O) {
      [gt.DOWN, gt.SPACE, gt.ENTER].includes(U) && ($(!0), ee.preventDefault());
      return;
    }
    switch (U) {
      case gt.UP:
        V(-1), ee.preventDefault();
        break;
      case gt.DOWN:
        V(1), ee.preventDefault();
        break;
      case gt.ESC:
        $(!1);
        break;
      case gt.SPACE:
      case gt.ENTER:
        L !== null && x(L, ee);
        break;
    }
  }
  m.useEffect(function() {
    var ee = document.getElementById(T);
    ee && ee.scrollIntoView && ee.scrollIntoView(!1);
  }, [L]), m.useEffect(function() {
    O || B(null);
  }, [O]);
  var X = ce({}, v ? "marginRight" : "marginLeft", g);
  i.length || (X.visibility = "hidden", X.order = 1);
  var D = ft(ce({}, "".concat(A, "-rtl"), v)), te = a ? null : /* @__PURE__ */ m.createElement(Yxe, {
    prefixCls: A,
    overlay: W,
    trigger: ["hover"],
    visible: i.length ? O : !1,
    transitionName: c,
    onVisibleChange: $,
    overlayClassName: ft(D, w),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: b
  }, /* @__PURE__ */ m.createElement("button", {
    type: "button",
    className: "".concat(n, "-nav-more"),
    style: X,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": j,
    id: "".concat(r, "-more"),
    "aria-expanded": O,
    onKeyDown: G
  }, l));
  return /* @__PURE__ */ m.createElement("div", {
    className: ft("".concat(n, "-nav-operations"), d),
    style: f,
    ref: t
  }, te, /* @__PURE__ */ m.createElement(z7, {
    prefixCls: n,
    locale: o,
    editable: p
  }));
});
const WCe = /* @__PURE__ */ m.memo(HCe, function(e, t) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    t.tabMoving
  );
});
var VCe = function(t) {
  var n = t.prefixCls, r = t.id, i = t.active, o = t.tab, a = o.key, s = o.label, l = o.disabled, c = o.closeIcon, f = o.icon, d = t.closable, p = t.renderWrapper, g = t.removeAriaLabel, v = t.editable, y = t.onClick, x = t.onFocus, b = t.style, w = "".concat(n, "-tab"), S = B7(d, c, v, l);
  function E(R) {
    l || y(R);
  }
  function O(R) {
    R.preventDefault(), R.stopPropagation(), v.onEdit("remove", {
      key: a,
      event: R
    });
  }
  var $ = m.useMemo(function() {
    return f && typeof s == "string" ? /* @__PURE__ */ m.createElement("span", null, s) : s;
  }, [s, f]), P = /* @__PURE__ */ m.createElement("div", {
    key: a,
    "data-node-key": F7(a),
    className: ft(w, ce(ce(ce({}, "".concat(w, "-with-remove"), S), "".concat(w, "-active"), i), "".concat(w, "-disabled"), l)),
    style: b,
    onClick: E
  }, /* @__PURE__ */ m.createElement("div", {
    role: "tab",
    "aria-selected": i,
    id: r && "".concat(r, "-tab-").concat(a),
    className: "".concat(w, "-btn"),
    "aria-controls": r && "".concat(r, "-panel-").concat(a),
    "aria-disabled": l,
    tabIndex: l ? null : 0,
    onClick: function(L) {
      L.stopPropagation(), E(L);
    },
    onKeyDown: function(L) {
      [gt.SPACE, gt.ENTER].includes(L.which) && (L.preventDefault(), E(L));
    },
    onFocus: x
  }, f && /* @__PURE__ */ m.createElement("span", {
    className: "".concat(w, "-icon")
  }, f), s && $), S && /* @__PURE__ */ m.createElement("button", {
    type: "button",
    "aria-label": g || "remove",
    tabIndex: 0,
    className: "".concat(w, "-remove"),
    onClick: function(L) {
      L.stopPropagation(), O(L);
    }
  }, c || v.removeIcon || "×"));
  return p ? p(P) : P;
}, GCe = function(t, n) {
  var r = t.offsetWidth, i = t.offsetHeight, o = t.offsetTop, a = t.offsetLeft, s = t.getBoundingClientRect(), l = s.width, c = s.height, f = s.x, d = s.y;
  return Math.abs(l - r) < 1 ? [l, c, f - n.x, d - n.y] : [r, i, a, o];
}, Md = function(t) {
  var n = t.current || {}, r = n.offsetWidth, i = r === void 0 ? 0 : r, o = n.offsetHeight, a = o === void 0 ? 0 : o;
  if (t.current) {
    var s = t.current.getBoundingClientRect(), l = s.width, c = s.height;
    if (Math.abs(l - i) < 1)
      return [l, c];
  }
  return [i, a];
}, C0 = function(t, n) {
  return t[n ? 0 : 1];
}, Uj = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.className, r = e.style, i = e.id, o = e.animated, a = e.activeKey, s = e.rtl, l = e.extra, c = e.editable, f = e.locale, d = e.tabPosition, p = e.tabBarGutter, g = e.children, v = e.onTabClick, y = e.onTabScroll, x = e.indicator, b = m.useContext(WS), w = b.prefixCls, S = b.tabs, E = m.useRef(null), O = m.useRef(null), $ = m.useRef(null), P = m.useRef(null), R = m.useRef(null), L = m.useRef(null), B = m.useRef(null), j = d === "top" || d === "bottom", A = fj(0, function(bt, ht) {
    j && y && y({
      direction: bt > ht ? "left" : "right"
    });
  }), T = ke(A, 2), k = T[0], F = T[1], W = fj(0, function(bt, ht) {
    !j && y && y({
      direction: bt > ht ? "top" : "bottom"
    });
  }), V = ke(W, 2), G = V[0], X = V[1], D = m.useState([0, 0]), te = ke(D, 2), ee = te[0], U = te[1], he = m.useState([0, 0]), re = ke(he, 2), de = re[0], we = re[1], ue = m.useState([0, 0]), me = ke(ue, 2), Se = me[0], _e = me[1], Ge = m.useState([0, 0]), Fe = ke(Ge, 2), Ae = Fe[0], Me = Fe[1], et = KSe(/* @__PURE__ */ new Map()), De = ke(et, 2), je = De[0], ie = De[1], fe = WSe(S, je, de[0]), be = C0(ee, j), Te = C0(de, j), Le = C0(Se, j), ct = C0(Ae, j), Z = be < Te + Le, se = Z ? be - ct : be - Le, Ce = "".concat(w, "-nav-operations-hidden"), Pe = 0, Ee = 0;
  j && s ? (Pe = 0, Ee = Math.max(0, Te - se)) : (Pe = Math.min(0, se - Te), Ee = 0);
  function We(bt) {
    return bt < Pe ? Pe : bt > Ee ? Ee : bt;
  }
  var ze = m.useRef(null), Ye = m.useState(), xt = ke(Ye, 2), Lt = xt[0], mt = xt[1];
  function St() {
    mt(Date.now());
  }
  function Et() {
    ze.current && clearTimeout(ze.current);
  }
  GSe(P, function(bt, ht) {
    function Ht(Sn, hr) {
      Sn(function(In) {
        var Kn = We(In + hr);
        return Kn;
      });
    }
    return Z ? (j ? Ht(F, bt) : Ht(X, ht), Et(), St(), !0) : !1;
  }), m.useEffect(function() {
    return Et(), Lt && (ze.current = setTimeout(function() {
      mt(0);
    }, 100)), Et;
  }, [Lt]);
  var Je = qSe(
    fe,
    // Container
    se,
    // Transform
    j ? k : G,
    // Tabs
    Te,
    // Add
    Le,
    // Operation
    ct,
    ye(ye({}, e), {}, {
      tabs: S
    })
  ), Ze = ke(Je, 2), ut = Ze[0], cn = Ze[1], un = RT(function() {
    var bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a, ht = fe.get(bt) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (j) {
      var Ht = k;
      s ? ht.right < k ? Ht = ht.right : ht.right + ht.width > k + se && (Ht = ht.right + ht.width - se) : ht.left < -k ? Ht = -ht.left : ht.left + ht.width > -k + se && (Ht = -(ht.left + ht.width - se)), X(0), F(We(Ht));
    } else {
      var Sn = G;
      ht.top < -G ? Sn = -ht.top : ht.top + ht.height > -G + se && (Sn = -(ht.top + ht.height - se)), F(0), X(We(Sn));
    }
  }), bn = {};
  d === "top" || d === "bottom" ? bn[s ? "marginRight" : "marginLeft"] = p : bn.marginTop = p;
  var tt = S.map(function(bt, ht) {
    var Ht = bt.key;
    return /* @__PURE__ */ m.createElement(VCe, {
      id: i,
      prefixCls: w,
      key: Ht,
      tab: bt,
      style: ht === 0 ? void 0 : bn,
      closable: bt.closable,
      editable: c,
      active: Ht === a,
      renderWrapper: g,
      removeAriaLabel: f == null ? void 0 : f.removeAriaLabel,
      onClick: function(hr) {
        v(Ht, hr);
      },
      onFocus: function() {
        un(Ht), St(), P.current && (s || (P.current.scrollLeft = 0), P.current.scrollTop = 0);
      }
    });
  }), Qe = function() {
    return ie(function() {
      var ht, Ht = /* @__PURE__ */ new Map(), Sn = (ht = R.current) === null || ht === void 0 ? void 0 : ht.getBoundingClientRect();
      return S.forEach(function(hr) {
        var In, Kn = hr.key, vi = (In = R.current) === null || In === void 0 ? void 0 : In.querySelector('[data-node-key="'.concat(F7(Kn), '"]'));
        if (vi) {
          var Vt = GCe(vi, Sn), Sr = ke(Vt, 4), Xr = Sr[0], Ri = Sr[1], Dr = Sr[2], Or = Sr[3];
          Ht.set(Kn, {
            width: Xr,
            height: Ri,
            left: Dr,
            top: Or
          });
        }
      }), Ht;
    });
  };
  m.useEffect(function() {
    Qe();
  }, [S.map(function(bt) {
    return bt.key;
  }).join("_")]);
  var rn = j7(function() {
    var bt = Md(E), ht = Md(O), Ht = Md($);
    U([bt[0] - ht[0] - Ht[0], bt[1] - ht[1] - Ht[1]]);
    var Sn = Md(B);
    _e(Sn);
    var hr = Md(L);
    Me(hr);
    var In = Md(R);
    we([In[0] - Sn[0], In[1] - Sn[1]]), Qe();
  }), Xe = S.slice(0, ut), it = S.slice(cn + 1), _t = [].concat(Rt(Xe), Rt(it)), Yt = fe.get(a), gn = HSe({
    activeTabOffset: Yt,
    horizontal: j,
    indicator: x,
    rtl: s
  }), Zt = gn.style;
  m.useEffect(function() {
    un();
  }, [a, Pe, Ee, mj(Yt), mj(fe), j]), m.useEffect(function() {
    rn();
  }, [s]);
  var dr = !!_t.length, pr = "".concat(w, "-nav-wrap"), Gn, Mn, Hr, Nn;
  return j ? s ? (Mn = k > 0, Gn = k !== Ee) : (Gn = k < 0, Mn = k !== Pe) : (Hr = G < 0, Nn = G !== Pe), /* @__PURE__ */ m.createElement(Ws, {
    onResize: rn
  }, /* @__PURE__ */ m.createElement("div", {
    ref: USe(t, E),
    role: "tablist",
    className: ft("".concat(w, "-nav"), n),
    style: r,
    onKeyDown: function() {
      St();
    }
  }, /* @__PURE__ */ m.createElement(gj, {
    ref: O,
    position: "left",
    extra: l,
    prefixCls: w
  }), /* @__PURE__ */ m.createElement(Ws, {
    onResize: rn
  }, /* @__PURE__ */ m.createElement("div", {
    className: ft(pr, ce(ce(ce(ce({}, "".concat(pr, "-ping-left"), Gn), "".concat(pr, "-ping-right"), Mn), "".concat(pr, "-ping-top"), Hr), "".concat(pr, "-ping-bottom"), Nn)),
    ref: P
  }, /* @__PURE__ */ m.createElement(Ws, {
    onResize: rn
  }, /* @__PURE__ */ m.createElement("div", {
    ref: R,
    className: "".concat(w, "-nav-list"),
    style: {
      transform: "translate(".concat(k, "px, ").concat(G, "px)"),
      transition: Lt ? "none" : void 0
    }
  }, tt, /* @__PURE__ */ m.createElement(z7, {
    ref: B,
    prefixCls: w,
    locale: f,
    editable: c,
    style: ye(ye({}, tt.length === 0 ? void 0 : bn), {}, {
      visibility: dr ? "hidden" : null
    })
  }), /* @__PURE__ */ m.createElement("div", {
    className: ft("".concat(w, "-ink-bar"), ce({}, "".concat(w, "-ink-bar-animated"), o.inkBar)),
    style: Zt
  }))))), /* @__PURE__ */ m.createElement(WCe, jt({}, e, {
    removeAriaLabel: f == null ? void 0 : f.removeAriaLabel,
    ref: L,
    prefixCls: w,
    tabs: _t,
    className: !dr && Ce,
    tabMoving: !!Lt
  })), /* @__PURE__ */ m.createElement(gj, {
    ref: $,
    position: "right",
    extra: l,
    prefixCls: w
  })));
}), SV = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.className, i = e.style, o = e.id, a = e.active, s = e.tabKey, l = e.children;
  return /* @__PURE__ */ m.createElement("div", {
    id: o && "".concat(o, "-panel-").concat(s),
    role: "tabpanel",
    tabIndex: a ? 0 : -1,
    "aria-labelledby": o && "".concat(o, "-tab-").concat(s),
    "aria-hidden": !a,
    style: i,
    className: ft(n, a && "".concat(n, "-active"), r),
    ref: t
  }, l);
}), KCe = ["renderTabBar"], qCe = ["label", "key"], YCe = function(t) {
  var n = t.renderTabBar, r = _n(t, KCe), i = m.useContext(WS), o = i.tabs;
  if (n) {
    var a = ye(ye({}, r), {}, {
      // Legacy support. We do not use this actually
      panes: o.map(function(s) {
        var l = s.label, c = s.key, f = _n(s, qCe);
        return /* @__PURE__ */ m.createElement(SV, jt({
          tab: l,
          key: c,
          tabKey: c
        }, f));
      })
    });
    return n(a, Uj);
  }
  return /* @__PURE__ */ m.createElement(Uj, r);
}, XCe = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], QCe = function(t) {
  var n = t.id, r = t.activeKey, i = t.animated, o = t.tabPosition, a = t.destroyInactiveTabPane, s = m.useContext(WS), l = s.prefixCls, c = s.tabs, f = i.tabPane, d = "".concat(l, "-tabpane");
  return /* @__PURE__ */ m.createElement("div", {
    className: ft("".concat(l, "-content-holder"))
  }, /* @__PURE__ */ m.createElement("div", {
    className: ft("".concat(l, "-content"), "".concat(l, "-content-").concat(o), ce({}, "".concat(l, "-content-animated"), f))
  }, c.map(function(p) {
    var g = p.key, v = p.forceRender, y = p.style, x = p.className, b = p.destroyInactiveTabPane, w = _n(p, XCe), S = g === r;
    return /* @__PURE__ */ m.createElement(Cc, jt({
      key: g,
      visible: S,
      forceRender: v,
      removeOnLeave: !!(a || b),
      leavedClassName: "".concat(d, "-hidden")
    }, i.tabPaneMotion), function(E, O) {
      var $ = E.style, P = E.className;
      return /* @__PURE__ */ m.createElement(SV, jt({}, w, {
        prefixCls: d,
        id: n,
        tabKey: g,
        animated: f,
        active: S,
        style: ye(ye({}, y), $),
        className: ft(x, P),
        ref: O
      }));
    });
  })));
};
function JCe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, t;
  return e === !1 ? t = {
    inkBar: !1,
    tabPane: !1
  } : e === !0 ? t = {
    inkBar: !0,
    tabPane: !1
  } : t = ye({
    inkBar: !0
  }, nn(e) === "object" ? e : {}), t.tabPaneMotion && t.tabPane === void 0 && (t.tabPane = !0), !t.tabPaneMotion && t.tabPane && (t.tabPane = !1), t;
}
var ZCe = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "moreIcon", "moreTransitionName", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicator"], Hj = 0, eEe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.id, r = e.prefixCls, i = r === void 0 ? "rc-tabs" : r, o = e.className, a = e.items, s = e.direction, l = e.activeKey, c = e.defaultActiveKey, f = e.editable, d = e.animated, p = e.tabPosition, g = p === void 0 ? "top" : p, v = e.tabBarGutter, y = e.tabBarStyle, x = e.tabBarExtraContent, b = e.locale, w = e.moreIcon, S = e.moreTransitionName, E = e.destroyInactiveTabPane, O = e.renderTabBar, $ = e.onChange, P = e.onTabClick, R = e.onTabScroll, L = e.getPopupContainer, B = e.popupClassName, j = e.indicator, A = _n(e, ZCe), T = m.useMemo(function() {
    return (a || []).filter(function(Me) {
      return Me && nn(Me) === "object" && "key" in Me;
    });
  }, [a]), k = s === "rtl", F = JCe(d), W = m.useState(!1), V = ke(W, 2), G = V[0], X = V[1];
  m.useEffect(function() {
    X(jSe());
  }, []);
  var D = lj(function() {
    var Me;
    return (Me = T[0]) === null || Me === void 0 ? void 0 : Me.key;
  }, {
    value: l,
    defaultValue: c
  }), te = ke(D, 2), ee = te[0], U = te[1], he = m.useState(function() {
    return T.findIndex(function(Me) {
      return Me.key === ee;
    });
  }), re = ke(he, 2), de = re[0], we = re[1];
  m.useEffect(function() {
    var Me = T.findIndex(function(De) {
      return De.key === ee;
    });
    if (Me === -1) {
      var et;
      Me = Math.max(0, Math.min(de, T.length - 1)), U((et = T[Me]) === null || et === void 0 ? void 0 : et.key);
    }
    we(Me);
  }, [T.map(function(Me) {
    return Me.key;
  }).join("_"), ee, de]);
  var ue = lj(null, {
    value: n
  }), me = ke(ue, 2), Se = me[0], _e = me[1];
  m.useEffect(function() {
    n || (_e("rc-tabs-".concat(Hj)), Hj += 1);
  }, []);
  function Ge(Me, et) {
    P == null || P(Me, et);
    var De = Me !== ee;
    U(Me), De && ($ == null || $(Me));
  }
  var Fe = {
    id: Se,
    activeKey: ee,
    animated: F,
    tabPosition: g,
    rtl: k,
    mobile: G
  }, Ae = ye(ye({}, Fe), {}, {
    editable: f,
    locale: b,
    moreIcon: w,
    moreTransitionName: S,
    tabBarGutter: v,
    onTabClick: Ge,
    onTabScroll: R,
    extra: x,
    style: y,
    panes: null,
    getPopupContainer: L,
    popupClassName: B,
    indicator: j
  });
  return /* @__PURE__ */ m.createElement(WS.Provider, {
    value: {
      tabs: T,
      prefixCls: i
    }
  }, /* @__PURE__ */ m.createElement("div", jt({
    ref: t,
    id: n,
    className: ft(i, "".concat(i, "-").concat(g), ce(ce(ce({}, "".concat(i, "-mobile"), G), "".concat(i, "-editable"), f), "".concat(i, "-rtl"), k), o)
  }, A), /* @__PURE__ */ m.createElement(YCe, jt({}, Ae, {
    renderTabBar: O
  })), /* @__PURE__ */ m.createElement(QCe, jt({
    destroyInactiveTabPane: E
  }, Fe, {
    animated: F
  }))));
});
const tEe = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function nEe(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inkBar: !0,
    tabPane: !1
  }, n;
  return t === !1 ? n = {
    inkBar: !1,
    tabPane: !1
  } : t === !0 ? n = {
    inkBar: !0,
    tabPane: !0
  } : n = Object.assign({
    inkBar: !0
  }, typeof t == "object" ? t : {}), n.tabPane && (n.tabPaneMotion = Object.assign(Object.assign({}, tEe), {
    motionName: zf(e, "switch")
  })), n;
}
var rEe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function iEe(e) {
  return e.filter((t) => t);
}
function oEe(e, t) {
  if (e)
    return e;
  const n = vc(t).map((r) => {
    if (/* @__PURE__ */ m.isValidElement(r)) {
      const {
        key: i,
        props: o
      } = r, a = o || {}, {
        tab: s
      } = a, l = rEe(a, ["tab"]);
      return Object.assign(Object.assign({
        key: String(i)
      }, l), {
        label: s
      });
    }
    return null;
  });
  return iEe(n);
}
const aEe = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return [
    {
      [t]: {
        [`${t}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${n}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${n}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [MD(e, "slide-up"), MD(e, "slide-down")]
  ];
}, sEe = aEe, lEe = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: n,
    cardBg: r,
    cardGutter: i,
    colorBorderSecondary: o,
    itemSelectedColor: a
  } = e;
  return {
    [`${t}-card`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-tab`]: {
          margin: 0,
          padding: n,
          background: r,
          border: `${ge(e.lineWidth)} ${e.lineType} ${o}`,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`
        },
        [`${t}-tab-active`]: {
          color: a,
          background: e.colorBgContainer
        },
        [`${t}-ink-bar`]: {
          visibility: "hidden"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${t}-top, &${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: ge(i)
            }
          }
        }
      },
      [`&${t}-top`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)} 0 0`
          },
          [`${t}-tab-active`]: {
            borderBottomColor: e.colorBgContainer
          }
        }
      },
      [`&${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: `0 0 ${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)}`
          },
          [`${t}-tab-active`]: {
            borderTopColor: e.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${t}-left, &${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginTop: ge(i)
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${ge(e.borderRadiusLG)} 0 0 ${ge(e.borderRadiusLG)}`
            }
          },
          [`${t}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)} 0`
            }
          },
          [`${t}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: e.colorBgContainer
            }
          }
        }
      }
    }
  };
}, cEe = (e) => {
  const {
    componentCls: t,
    itemHoverColor: n,
    dropdownEdgeChildVerticalPadding: r
  } = e;
  return {
    [`${t}-dropdown`]: Object.assign(Object.assign({}, Vi(e)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: e.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${t}-dropdown-menu`]: {
        maxHeight: e.tabsDropdownHeight,
        margin: 0,
        padding: `${ge(r)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: e.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, IR), {
          display: "flex",
          alignItems: "center",
          minWidth: e.tabsDropdownWidth,
          margin: 0,
          padding: `${ge(e.paddingXXS)} ${ge(e.paddingSM)}`,
          color: e.colorText,
          fontWeight: "normal",
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          cursor: "pointer",
          transition: `all ${e.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: e.marginSM
            },
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: n
            }
          },
          "&:hover": {
            background: e.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: e.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, uEe = (e) => {
  const {
    componentCls: t,
    margin: n,
    colorBorderSecondary: r,
    horizontalMargin: i,
    verticalItemPadding: o,
    verticalItemMargin: a,
    calc: s
  } = e;
  return {
    // ========================== Top & Bottom ==========================
    [`${t}-top, ${t}-bottom`]: {
      flexDirection: "column",
      [`> ${t}-nav, > div > ${t}-nav`]: {
        margin: i,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${ge(e.lineWidth)} ${e.lineType} ${r}`,
          content: "''"
        },
        [`${t}-ink-bar`]: {
          height: e.lineWidthBold,
          "&-animated": {
            transition: `width ${e.motionDurationSlow}, left ${e.motionDurationSlow},
            right ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: e.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: e.boxShadowTabsOverflowRight
          },
          [`&${t}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${t}-top`]: {
      [`> ${t}-nav,
        > div > ${t}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${t}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${t}-bottom`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        marginTop: n,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${t}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${t}-left, ${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        flexDirection: "column",
        minWidth: s(e.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${t}-tab`]: {
          padding: o,
          textAlign: "center"
        },
        [`${t}-tab + ${t}-tab`]: {
          margin: a
        },
        // >>>>>>>>>>> Nav
        [`${t}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: e.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: e.boxShadowTabsOverflowBottom
          },
          [`&${t}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${t}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${t}-ink-bar`]: {
          width: e.lineWidthBold,
          "&-animated": {
            transition: `height ${e.motionDurationSlow}, top ${e.motionDurationSlow}`
          }
        },
        [`${t}-nav-list, ${t}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${t}-left`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: ge(s(e.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    },
    [`${t}-right`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        order: 1,
        [`${t}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${t}-content-holder, > div > ${t}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: s(e.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        [`> ${t}-content > ${t}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: e.paddingLG
          }
        }
      }
    }
  };
}, fEe = (e) => {
  const {
    componentCls: t,
    cardPaddingSM: n,
    cardPaddingLG: r,
    horizontalItemPaddingSM: i,
    horizontalItemPaddingLG: o
  } = e;
  return {
    [t]: {
      "&-small": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: i,
            fontSize: e.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: o,
            fontSize: e.titleFontSizeLG
          }
        }
      }
    },
    [`${t}-card`]: {
      [`&${t}-small`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: n
          }
        },
        [`&${t}-bottom`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `0 0 ${ge(e.borderRadius)} ${ge(e.borderRadius)}`
          }
        },
        [`&${t}-top`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: `${ge(e.borderRadius)} ${ge(e.borderRadius)} 0 0`
          }
        },
        [`&${t}-right`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${ge(e.borderRadius)} ${ge(e.borderRadius)} 0`
            }
          }
        },
        [`&${t}-left`]: {
          [`> ${t}-nav ${t}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${ge(e.borderRadius)} 0 0 ${ge(e.borderRadius)}`
            }
          }
        }
      },
      [`&${t}-large`]: {
        [`> ${t}-nav`]: {
          [`${t}-tab`]: {
            padding: r
          }
        }
      }
    }
  };
}, dEe = (e) => {
  const {
    componentCls: t,
    itemActiveColor: n,
    itemHoverColor: r,
    iconCls: i,
    tabsHorizontalItemMargin: o,
    horizontalItemPadding: a,
    itemSelectedColor: s,
    itemColor: l
  } = e, c = `${t}-tab`;
  return {
    [c]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: a,
      fontSize: e.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: l,
      "&-btn, &-remove": Object.assign({
        "&:focus:not(:focus-visible), &:active": {
          color: n
        }
      }, Jw(e)),
      "&-btn": {
        outline: "none",
        transition: "all 0.3s",
        [`${c}-icon:not(:last-child)`]: {
          marginInlineEnd: e.marginSM
        }
      },
      "&-remove": {
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: e.calc(e.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: e.marginXS
        },
        color: e.colorTextDescription,
        fontSize: e.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      "&:hover": {
        color: r
      },
      [`&${c}-active ${c}-btn`]: {
        color: s,
        textShadow: e.tabsActiveTextShadow
      },
      [`&${c}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${c}-disabled ${c}-btn, &${c}-disabled ${t}-remove`]: {
        "&:focus, &:active": {
          color: e.colorTextDisabled
        }
      },
      [`& ${c}-remove ${i}`]: {
        margin: 0
      },
      [`${i}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: e.marginSM
        }
      }
    },
    [`${c} + ${c}`]: {
      margin: {
        _skip_check_: !0,
        value: o
      }
    }
  };
}, pEe = (e) => {
  const {
    componentCls: t,
    tabsHorizontalItemMarginRTL: n,
    iconCls: r,
    cardGutter: i,
    calc: o
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl",
      [`${t}-nav`]: {
        [`${t}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: n
          },
          [`${t}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [r]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: ge(e.marginSM)
            }
          },
          [`${t}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: ge(e.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: ge(o(e.marginXXS).mul(-1).equal())
            },
            [r]: {
              margin: 0
            }
          }
        }
      },
      [`&${t}-left`]: {
        [`> ${t}-nav`]: {
          order: 1
        },
        [`> ${t}-content-holder`]: {
          order: 0
        }
      },
      [`&${t}-right`]: {
        [`> ${t}-nav`]: {
          order: 0
        },
        [`> ${t}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${t}-card${t}-top, &${t}-card${t}-bottom`]: {
        [`> ${t}-nav, > div > ${t}-nav`]: {
          [`${t}-tab + ${t}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: i
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${t}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${t}-menu-item`]: {
      [`${t}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, hEe = (e) => {
  const {
    componentCls: t,
    tabsCardPadding: n,
    cardHeight: r,
    cardGutter: i,
    itemHoverColor: o,
    itemActiveColor: a,
    colorBorderSecondary: s
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Vi(e)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${t}-nav, > div > ${t}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${t}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${e.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${t}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${e.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${t}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${t}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${t}-nav-more`]: {
          position: "relative",
          padding: n,
          background: "transparent",
          border: 0,
          color: e.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: e.calc(e.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${t}-nav-add`]: Object.assign({
          minWidth: r,
          minHeight: r,
          marginLeft: {
            _skip_check_: !0,
            value: i
          },
          padding: `0 ${ge(e.paddingXS)}`,
          background: "transparent",
          border: `${ge(e.lineWidth)} ${e.lineType} ${s}`,
          borderRadius: `${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: e.colorText,
          transition: `all ${e.motionDurationSlow} ${e.motionEaseInOut}`,
          "&:hover": {
            color: o
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: a
          }
        }, Jw(e))
      },
      [`${t}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${t}-ink-bar`]: {
        position: "absolute",
        background: e.inkBarColor,
        pointerEvents: "none"
      }
    }), dEe(e)), {
      // =========================== TabPanes ===========================
      [`${t}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${t}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${t}-tabpane`]: {
        outline: "none",
        "&-hidden": {
          display: "none"
        }
      }
    }),
    [`${t}-centered`]: {
      [`> ${t}-nav, > div > ${t}-nav`]: {
        [`${t}-nav-wrap`]: {
          [`&:not([class*='${t}-nav-wrap-ping'])`]: {
            justifyContent: "center"
          }
        }
      }
    }
  };
}, mEe = (e) => {
  const t = e.controlHeightLG;
  return {
    zIndexPopup: e.zIndexPopupBase + 50,
    cardBg: e.colorFillAlter,
    cardHeight: t,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(t - Math.round(e.fontSize * e.lineHeight)) / 2 - e.lineWidth}px ${e.padding}px`,
    cardPaddingSM: `${e.paddingXXS * 1.5}px ${e.padding}px`,
    cardPaddingLG: `${e.paddingXS}px ${e.padding}px ${e.paddingXXS * 1.5}px`,
    titleFontSize: e.fontSize,
    titleFontSizeLG: e.fontSizeLG,
    titleFontSizeSM: e.fontSize,
    inkBarColor: e.colorPrimary,
    horizontalMargin: `0 0 ${e.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${e.paddingSM}px 0`,
    horizontalItemPaddingSM: `${e.paddingXS}px 0`,
    horizontalItemPaddingLG: `${e.padding}px 0`,
    verticalItemPadding: `${e.paddingXS}px ${e.paddingLG}px`,
    verticalItemMargin: `${e.margin}px 0 0 0`,
    itemColor: e.colorText,
    itemSelectedColor: e.colorPrimary,
    itemHoverColor: e.colorPrimaryHover,
    itemActiveColor: e.colorPrimaryActive,
    cardGutter: e.marginXXS / 2
  };
}, gEe = Pi("Tabs", (e) => {
  const t = _r(e, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: e.cardPadding,
    dropdownEdgeChildVerticalPadding: e.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${ge(e.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${ge(e.horizontalItemGutter)}`
  });
  return [fEe(t), pEe(t), uEe(t), cEe(t), lEe(t), hEe(t), sEe(t)];
}, mEe), vEe = () => null, yEe = vEe;
var bEe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const xV = (e) => {
  var t, n, r, i, o, a, s, l;
  const {
    type: c,
    className: f,
    rootClassName: d,
    size: p,
    onEdit: g,
    hideAdd: v,
    centered: y,
    addIcon: x,
    removeIcon: b,
    moreIcon: w,
    popupClassName: S,
    children: E,
    items: O,
    animated: $,
    style: P,
    indicatorSize: R,
    indicator: L
  } = e, B = bEe(e, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "removeIcon", "moreIcon", "popupClassName", "children", "items", "animated", "style", "indicatorSize", "indicator"]), {
    prefixCls: j
  } = B, {
    direction: A,
    tabs: T,
    getPrefixCls: k,
    getPopupContainer: F
  } = m.useContext(Mt), W = k("tabs", j), V = xc(W), [G, X, D] = gEe(W, V);
  let te;
  c === "editable-card" && (te = {
    onEdit: (ue, me) => {
      let {
        key: Se,
        event: _e
      } = me;
      g == null || g(ue === "add" ? _e : Se, ue);
    },
    removeIcon: (t = b ?? (T == null ? void 0 : T.removeIcon)) !== null && t !== void 0 ? t : /* @__PURE__ */ m.createElement(lv, null),
    addIcon: (x ?? (T == null ? void 0 : T.addIcon)) || /* @__PURE__ */ m.createElement(kSe, null),
    showAdd: v !== !0
  });
  const ee = k(), U = Rl(p), he = oEe(O, E), re = nEe(W, $), de = Object.assign(Object.assign({}, T == null ? void 0 : T.style), P), we = {
    align: (n = L == null ? void 0 : L.align) !== null && n !== void 0 ? n : (r = T == null ? void 0 : T.indicator) === null || r === void 0 ? void 0 : r.align,
    size: (s = (o = (i = L == null ? void 0 : L.size) !== null && i !== void 0 ? i : R) !== null && o !== void 0 ? o : (a = T == null ? void 0 : T.indicator) === null || a === void 0 ? void 0 : a.size) !== null && s !== void 0 ? s : T == null ? void 0 : T.indicatorSize
  };
  return G(/* @__PURE__ */ m.createElement(eEe, Object.assign({
    direction: A,
    getPopupContainer: F,
    moreTransitionName: `${ee}-slide-up`
  }, B, {
    items: he,
    className: Ue({
      [`${W}-${U}`]: U,
      [`${W}-card`]: ["card", "editable-card"].includes(c),
      [`${W}-editable-card`]: c === "editable-card",
      [`${W}-centered`]: y
    }, T == null ? void 0 : T.className, f, d, X, D, V),
    popupClassName: Ue(S, X, D, V),
    style: de,
    editable: te,
    moreIcon: (l = w ?? (T == null ? void 0 : T.moreIcon)) !== null && l !== void 0 ? l : /* @__PURE__ */ m.createElement(ywe, null),
    prefixCls: W,
    animated: re,
    indicator: we
  })));
};
xV.TabPane = yEe;
const wEe = xV;
var SEe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const xEe = (e) => {
  var {
    prefixCls: t,
    className: n,
    hoverable: r = !0
  } = e, i = SEe(e, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls: o
  } = m.useContext(Mt), a = o("card", t), s = Ue(`${a}-grid`, n, {
    [`${a}-grid-hoverable`]: r
  });
  return /* @__PURE__ */ m.createElement("div", Object.assign({}, i, {
    className: s
  }));
}, CV = xEe, CEe = (e) => {
  const {
    antCls: t,
    componentCls: n,
    headerHeight: r,
    cardPaddingBase: i,
    tabsMarginBottom: o
  } = e;
  return Object.assign(Object.assign({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: r,
    marginBottom: -1,
    padding: `0 ${ge(i)}`,
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.headerFontSize,
    background: e.headerBg,
    borderBottom: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`,
    borderRadius: `${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)} 0 0`
  }, gh()), {
    "&-wrapper": {
      width: "100%",
      display: "flex",
      alignItems: "center"
    },
    "&-title": Object.assign(Object.assign({
      display: "inline-block",
      flex: 1
    }, IR), {
      [`
          > ${n}-typography,
          > ${n}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${t}-tabs-top`]: {
      clear: "both",
      marginBottom: o,
      color: e.colorText,
      fontWeight: "normal",
      fontSize: e.fontSize,
      "&-bar": {
        borderBottom: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorderSecondary}`
      }
    }
  });
}, EEe = (e) => {
  const {
    cardPaddingBase: t,
    colorBorderSecondary: n,
    cardShadow: r,
    lineWidth: i
  } = e;
  return {
    width: "33.33%",
    padding: t,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${ge(i)} 0 0 0 ${n},
      0 ${ge(i)} 0 0 ${n},
      ${ge(i)} ${ge(i)} 0 0 ${n},
      ${ge(i)} 0 0 0 ${n} inset,
      0 ${ge(i)} 0 0 ${n} inset;
    `,
    transition: `all ${e.motionDurationMid}`,
    "&-hoverable:hover": {
      position: "relative",
      zIndex: 1,
      boxShadow: r
    }
  };
}, $Ee = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    actionsLiMargin: r,
    cardActionsIconSize: i,
    colorBorderSecondary: o,
    actionsBg: a
  } = e;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: "none",
    background: a,
    borderTop: `${ge(e.lineWidth)} ${e.lineType} ${o}`,
    display: "flex",
    borderRadius: `0 0 ${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)}`
  }, gh()), {
    "& > li": {
      margin: r,
      color: e.colorTextDescription,
      textAlign: "center",
      "> span": {
        position: "relative",
        display: "block",
        minWidth: e.calc(e.cardActionsIconSize).mul(2).equal(),
        fontSize: e.fontSize,
        lineHeight: e.lineHeight,
        cursor: "pointer",
        "&:hover": {
          color: e.colorPrimary,
          transition: `color ${e.motionDurationMid}`
        },
        [`a:not(${t}-btn), > ${n}`]: {
          display: "inline-block",
          width: "100%",
          color: e.colorTextDescription,
          lineHeight: ge(e.fontHeight),
          transition: `color ${e.motionDurationMid}`,
          "&:hover": {
            color: e.colorPrimary
          }
        },
        [`> ${n}`]: {
          fontSize: i,
          lineHeight: ge(e.calc(i).mul(e.lineHeight).equal())
        }
      },
      "&:not(:last-child)": {
        borderInlineEnd: `${ge(e.lineWidth)} ${e.lineType} ${o}`
      }
    }
  });
}, _Ee = (e) => Object.assign(Object.assign({
  margin: `${ge(e.calc(e.marginXXS).mul(-1).equal())} 0`,
  display: "flex"
}, gh()), {
  "&-avatar": {
    paddingInlineEnd: e.padding
  },
  "&-detail": {
    overflow: "hidden",
    flex: 1,
    "> div:not(:last-child)": {
      marginBottom: e.marginXS
    }
  },
  "&-title": Object.assign({
    color: e.colorTextHeading,
    fontWeight: e.fontWeightStrong,
    fontSize: e.fontSizeLG
  }, IR),
  "&-description": {
    color: e.colorTextDescription
  }
}), OEe = (e) => {
  const {
    componentCls: t,
    cardPaddingBase: n,
    colorFillAlter: r
  } = e;
  return {
    [`${t}-head`]: {
      padding: `0 ${ge(n)}`,
      background: r,
      "&-title": {
        fontSize: e.fontSize
      }
    },
    [`${t}-body`]: {
      padding: `${ge(e.padding)} ${ge(n)}`
    }
  };
}, PEe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    overflow: "hidden",
    [`${t}-body`]: {
      userSelect: "none"
    }
  };
}, TEe = (e) => {
  const {
    antCls: t,
    componentCls: n,
    cardShadow: r,
    cardHeadPadding: i,
    colorBorderSecondary: o,
    boxShadowTertiary: a,
    cardPaddingBase: s,
    extraColor: l
  } = e;
  return {
    [n]: Object.assign(Object.assign({}, Vi(e)), {
      position: "relative",
      background: e.colorBgContainer,
      borderRadius: e.borderRadiusLG,
      [`&:not(${n}-bordered)`]: {
        boxShadow: a
      },
      [`${n}-head`]: CEe(e),
      [`${n}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: l,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`${n}-body`]: Object.assign({
        padding: s,
        borderRadius: ` 0 0 ${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)}`
      }, gh()),
      [`${n}-grid`]: EEe(e),
      [`${n}-cover`]: {
        "> *": {
          display: "block",
          width: "100%"
        },
        [`img, img + ${t}-image-mask`]: {
          borderRadius: `${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)} 0 0`
        }
      },
      [`${n}-actions`]: $Ee(e),
      [`${n}-meta`]: _Ee(e)
    }),
    [`${n}-bordered`]: {
      border: `${ge(e.lineWidth)} ${e.lineType} ${o}`,
      [`${n}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${n}-hoverable`]: {
      cursor: "pointer",
      transition: `box-shadow ${e.motionDurationMid}, border-color ${e.motionDurationMid}`,
      "&:hover": {
        borderColor: "transparent",
        boxShadow: r
      }
    },
    [`${n}-contain-grid`]: {
      borderRadius: `${ge(e.borderRadiusLG)} ${ge(e.borderRadiusLG)} 0 0 `,
      [`${n}-body`]: {
        display: "flex",
        flexWrap: "wrap"
      },
      [`&:not(${n}-loading) ${n}-body`]: {
        marginBlockStart: e.calc(e.lineWidth).mul(-1).equal(),
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${n}-contain-tabs`]: {
      [`> ${n}-head`]: {
        minHeight: 0,
        [`${n}-head-title, ${n}-extra`]: {
          paddingTop: i
        }
      }
    },
    [`${n}-type-inner`]: OEe(e),
    [`${n}-loading`]: PEe(e),
    [`${n}-rtl`]: {
      direction: "rtl"
    }
  };
}, IEe = (e) => {
  const {
    componentCls: t,
    cardPaddingSM: n,
    headerHeightSM: r,
    headerFontSizeSM: i
  } = e;
  return {
    [`${t}-small`]: {
      [`> ${t}-head`]: {
        minHeight: r,
        padding: `0 ${ge(n)}`,
        fontSize: i,
        [`> ${t}-head-wrapper`]: {
          [`> ${t}-extra`]: {
            fontSize: e.fontSize
          }
        }
      },
      [`> ${t}-body`]: {
        padding: n
      }
    },
    [`${t}-small${t}-contain-tabs`]: {
      [`> ${t}-head`]: {
        [`${t}-head-title, ${t}-extra`]: {
          paddingTop: 0,
          display: "flex",
          alignItems: "center"
        }
      }
    }
  };
}, AEe = (e) => ({
  headerBg: "transparent",
  headerFontSize: e.fontSizeLG,
  headerFontSizeSM: e.fontSize,
  headerHeight: e.fontSizeLG * e.lineHeightLG + e.padding * 2,
  headerHeightSM: e.fontSize * e.lineHeight + e.paddingXS * 2,
  actionsBg: e.colorBgContainer,
  actionsLiMargin: `${e.paddingSM}px 0`,
  tabsMarginBottom: -e.padding - e.lineWidth,
  extraColor: e.colorText
}), REe = Pi("Card", (e) => {
  const t = _r(e, {
    cardShadow: e.boxShadowCard,
    cardHeadPadding: e.padding,
    cardPaddingBase: e.paddingLG,
    cardActionsIconSize: e.fontSize,
    cardPaddingSM: 12
    // Fixed padding.
  });
  return [
    // Style
    TEe(t),
    // Size
    IEe(t)
  ];
}, AEe);
var Wj = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const MEe = (e) => {
  const {
    actionClasses: t,
    actions: n = [],
    actionStyle: r
  } = e;
  return /* @__PURE__ */ m.createElement("ul", {
    className: t,
    style: r
  }, n.map((i, o) => {
    const a = `action-${o}`;
    return /* @__PURE__ */ m.createElement("li", {
      style: {
        width: `${100 / n.length}%`
      },
      key: a
    }, /* @__PURE__ */ m.createElement("span", null, i));
  }));
}, NEe = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: r,
    rootClassName: i,
    style: o,
    extra: a,
    headStyle: s = {},
    bodyStyle: l = {},
    title: c,
    loading: f,
    bordered: d = !0,
    size: p,
    type: g,
    cover: v,
    actions: y,
    tabList: x,
    children: b,
    activeTabKey: w,
    defaultActiveTabKey: S,
    tabBarExtraContent: E,
    hoverable: O,
    tabProps: $ = {},
    classNames: P,
    styles: R
  } = e, L = Wj(e, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps", "classNames", "styles"]), {
    getPrefixCls: B,
    direction: j,
    card: A
  } = m.useContext(Mt), T = (je) => {
    var ie;
    (ie = e.onTabChange) === null || ie === void 0 || ie.call(e, je);
  }, k = (je) => {
    var ie;
    return Ue((ie = A == null ? void 0 : A.classNames) === null || ie === void 0 ? void 0 : ie[je], P == null ? void 0 : P[je]);
  }, F = (je) => {
    var ie;
    return Object.assign(Object.assign({}, (ie = A == null ? void 0 : A.styles) === null || ie === void 0 ? void 0 : ie[je]), R == null ? void 0 : R[je]);
  }, W = m.useMemo(() => {
    let je = !1;
    return m.Children.forEach(b, (ie) => {
      ie && ie.type && ie.type === CV && (je = !0);
    }), je;
  }, [b]), V = B("card", n), [G, X, D] = REe(V), te = /* @__PURE__ */ m.createElement(Bo, {
    loading: !0,
    active: !0,
    paragraph: {
      rows: 4
    },
    title: !1
  }, b), ee = w !== void 0, U = Object.assign(Object.assign({}, $), {
    [ee ? "activeKey" : "defaultActiveKey"]: ee ? w : S,
    tabBarExtraContent: E
  });
  let he;
  const re = Rl(p), de = !re || re === "default" ? "large" : re, we = x ? /* @__PURE__ */ m.createElement(wEe, Object.assign({
    size: de
  }, U, {
    className: `${V}-head-tabs`,
    onChange: T,
    items: x.map((je) => {
      var {
        tab: ie
      } = je, fe = Wj(je, ["tab"]);
      return Object.assign({
        label: ie
      }, fe);
    })
  })) : null;
  if (c || a || we) {
    const je = Ue(`${V}-head`, k("header")), ie = Ue(`${V}-head-title`, k("title")), fe = Ue(`${V}-extra`, k("extra")), be = Object.assign(Object.assign({}, s), F("header"));
    he = /* @__PURE__ */ m.createElement("div", {
      className: je,
      style: be
    }, /* @__PURE__ */ m.createElement("div", {
      className: `${V}-head-wrapper`
    }, c && /* @__PURE__ */ m.createElement("div", {
      className: ie,
      style: F("title")
    }, c), a && /* @__PURE__ */ m.createElement("div", {
      className: fe,
      style: F("extra")
    }, a)), we);
  }
  const ue = Ue(`${V}-cover`, k("cover")), me = v ? /* @__PURE__ */ m.createElement("div", {
    className: ue,
    style: F("cover")
  }, v) : null, Se = Ue(`${V}-body`, k("body")), _e = Object.assign(Object.assign({}, l), F("body")), Ge = /* @__PURE__ */ m.createElement("div", {
    className: Se,
    style: _e
  }, f ? te : b), Fe = Ue(`${V}-actions`, k("actions")), Ae = y && y.length ? /* @__PURE__ */ m.createElement(MEe, {
    actionClasses: Fe,
    actionStyle: F("actions"),
    actions: y
  }) : null, Me = os(L, ["onTabChange"]), et = Ue(V, A == null ? void 0 : A.className, {
    [`${V}-loading`]: f,
    [`${V}-bordered`]: d,
    [`${V}-hoverable`]: O,
    [`${V}-contain-grid`]: W,
    [`${V}-contain-tabs`]: x && x.length,
    [`${V}-${re}`]: re,
    [`${V}-type-${g}`]: !!g,
    [`${V}-rtl`]: j === "rtl"
  }, r, i, X, D), De = Object.assign(Object.assign({}, A == null ? void 0 : A.style), o);
  return G(/* @__PURE__ */ m.createElement("div", Object.assign({
    ref: t
  }, Me, {
    className: et,
    style: De
  }), he, me, Ge, Ae));
}), kEe = NEe;
var LEe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const DEe = (e) => {
  const {
    prefixCls: t,
    className: n,
    avatar: r,
    title: i,
    description: o
  } = e, a = LEe(e, ["prefixCls", "className", "avatar", "title", "description"]), {
    getPrefixCls: s
  } = m.useContext(Mt), l = s("card", t), c = Ue(`${l}-meta`, n), f = r ? /* @__PURE__ */ m.createElement("div", {
    className: `${l}-meta-avatar`
  }, r) : null, d = i ? /* @__PURE__ */ m.createElement("div", {
    className: `${l}-meta-title`
  }, i) : null, p = o ? /* @__PURE__ */ m.createElement("div", {
    className: `${l}-meta-description`
  }, o) : null, g = d || p ? /* @__PURE__ */ m.createElement("div", {
    className: `${l}-meta-detail`
  }, d, p) : null;
  return /* @__PURE__ */ m.createElement("div", Object.assign({}, a, {
    className: c
  }), f, g);
}, jEe = DEe, C2 = kEe;
C2.Grid = CV;
C2.Meta = jEe;
const FEe = C2;
function BEe(e, t, n) {
  var r = n || {}, i = r.noTrailing, o = i === void 0 ? !1 : i, a = r.noLeading, s = a === void 0 ? !1 : a, l = r.debounceMode, c = l === void 0 ? void 0 : l, f, d = !1, p = 0;
  function g() {
    f && clearTimeout(f);
  }
  function v(x) {
    var b = x || {}, w = b.upcomingOnly, S = w === void 0 ? !1 : w;
    g(), d = !S;
  }
  function y() {
    for (var x = arguments.length, b = new Array(x), w = 0; w < x; w++)
      b[w] = arguments[w];
    var S = this, E = Date.now() - p;
    if (d)
      return;
    function O() {
      p = Date.now(), t.apply(S, b);
    }
    function $() {
      f = void 0;
    }
    !s && c && !f && O(), g(), c === void 0 && E > e ? s ? (p = Date.now(), o || (f = setTimeout(c ? $ : O, e))) : O() : o !== !0 && (f = setTimeout(c ? $ : O, c === void 0 ? e - E : e));
  }
  return y.cancel = v, y;
}
function zEe(e, t, n) {
  var r = n || {}, i = r.atBegin, o = i === void 0 ? !1 : i;
  return BEe(e, t, {
    debounceMode: o !== !1
  });
}
function Hf() {
  return Hf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hf.apply(this, arguments);
}
function KT(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function UEe(e) {
  if (Array.isArray(e))
    return KT(e);
}
function HEe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function EV(e, t) {
  if (e) {
    if (typeof e == "string")
      return KT(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return KT(e, t);
  }
}
function WEe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VEe(e) {
  return UEe(e) || HEe(e) || EV(e) || WEe();
}
function GEe(e) {
  if (Array.isArray(e))
    return e;
}
function KEe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function qEe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ba(e, t) {
  return GEe(e) || KEe(e, t) || EV(e, t) || qEe();
}
function Xs(e) {
  "@babel/helpers - typeof";
  return Xs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xs(e);
}
var $V = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var l in o)
              t.call(o, l) && o[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})($V);
var YEe = $V.exports;
const Ug = /* @__PURE__ */ Oi(YEe);
function Vj(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function rx() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Gj = rx() ? m.useLayoutEffect : m.useEffect, Kj = function(t, n) {
  var r = m.useRef(!0);
  Gj(function() {
    if (!r.current)
      return t();
  }, n), Gj(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
};
function _p(e) {
  var t = m.useRef(!1), n = m.useState(e), r = ba(n, 2), i = r[0], o = r[1];
  m.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || o(s);
  }
  return [i, a];
}
function Z$(e) {
  return e !== void 0;
}
function XEe(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = _p(function() {
    return Z$(i) ? i : Z$(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = ba(s, 2), c = l[0], f = l[1], d = i !== void 0 ? i : c, p = a ? a(d) : d, g = Vj(o), v = _p([d]), y = ba(v, 2), x = y[0], b = y[1];
  Kj(function() {
    var S = x[0];
    c !== S && g(c, S);
  }, [x]), Kj(function() {
    Z$(i) || f(i);
  }, [i]);
  var w = Vj(function(S, E) {
    f(S, E), b([d], E);
  });
  return [p, w];
}
var qT = {}, QEe = function(t) {
};
function JEe(e, t) {
}
function ZEe(e, t) {
}
function e$e() {
  qT = {};
}
function _V(e, t, n) {
  !t && !qT[n] && (e(!1, n), qT[n] = !0);
}
function ix(e, t) {
  _V(JEe, e, t);
}
function t$e(e, t) {
  _V(ZEe, e, t);
}
ix.preMessage = QEe;
ix.resetWarned = e$e;
ix.noteOnce = t$e;
function n$e(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function B1(e, t) {
  if (e == null)
    return {};
  var n = n$e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var OV = { exports: {} }, Vn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ai = typeof Symbol == "function" && Symbol.for, E2 = Ai ? Symbol.for("react.element") : 60103, $2 = Ai ? Symbol.for("react.portal") : 60106, ox = Ai ? Symbol.for("react.fragment") : 60107, ax = Ai ? Symbol.for("react.strict_mode") : 60108, sx = Ai ? Symbol.for("react.profiler") : 60114, lx = Ai ? Symbol.for("react.provider") : 60109, cx = Ai ? Symbol.for("react.context") : 60110, _2 = Ai ? Symbol.for("react.async_mode") : 60111, ux = Ai ? Symbol.for("react.concurrent_mode") : 60111, fx = Ai ? Symbol.for("react.forward_ref") : 60112, dx = Ai ? Symbol.for("react.suspense") : 60113, r$e = Ai ? Symbol.for("react.suspense_list") : 60120, px = Ai ? Symbol.for("react.memo") : 60115, hx = Ai ? Symbol.for("react.lazy") : 60116, i$e = Ai ? Symbol.for("react.block") : 60121, o$e = Ai ? Symbol.for("react.fundamental") : 60117, a$e = Ai ? Symbol.for("react.responder") : 60118, s$e = Ai ? Symbol.for("react.scope") : 60119;
function Ra(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case E2:
        switch (e = e.type, e) {
          case _2:
          case ux:
          case ox:
          case sx:
          case ax:
          case dx:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case cx:
              case fx:
              case hx:
              case px:
              case lx:
                return e;
              default:
                return t;
            }
        }
      case $2:
        return t;
    }
  }
}
function PV(e) {
  return Ra(e) === ux;
}
Vn.AsyncMode = _2;
Vn.ConcurrentMode = ux;
Vn.ContextConsumer = cx;
Vn.ContextProvider = lx;
Vn.Element = E2;
Vn.ForwardRef = fx;
Vn.Fragment = ox;
Vn.Lazy = hx;
Vn.Memo = px;
Vn.Portal = $2;
Vn.Profiler = sx;
Vn.StrictMode = ax;
Vn.Suspense = dx;
Vn.isAsyncMode = function(e) {
  return PV(e) || Ra(e) === _2;
};
Vn.isConcurrentMode = PV;
Vn.isContextConsumer = function(e) {
  return Ra(e) === cx;
};
Vn.isContextProvider = function(e) {
  return Ra(e) === lx;
};
Vn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === E2;
};
Vn.isForwardRef = function(e) {
  return Ra(e) === fx;
};
Vn.isFragment = function(e) {
  return Ra(e) === ox;
};
Vn.isLazy = function(e) {
  return Ra(e) === hx;
};
Vn.isMemo = function(e) {
  return Ra(e) === px;
};
Vn.isPortal = function(e) {
  return Ra(e) === $2;
};
Vn.isProfiler = function(e) {
  return Ra(e) === sx;
};
Vn.isStrictMode = function(e) {
  return Ra(e) === ax;
};
Vn.isSuspense = function(e) {
  return Ra(e) === dx;
};
Vn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === ox || e === ux || e === sx || e === ax || e === dx || e === r$e || typeof e == "object" && e !== null && (e.$$typeof === hx || e.$$typeof === px || e.$$typeof === lx || e.$$typeof === cx || e.$$typeof === fx || e.$$typeof === o$e || e.$$typeof === a$e || e.$$typeof === s$e || e.$$typeof === i$e);
};
Vn.typeOf = Ra;
OV.exports = Vn;
var TV = OV.exports;
function YT(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return oe.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(YT(r)) : TV.isFragment(r) && r.props ? n = n.concat(YT(r.props.children, t)) : n.push(r));
  }), n;
}
function l$e(e, t) {
  if (Xs(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Xs(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function IV(e) {
  var t = l$e(e, "string");
  return Xs(t) === "symbol" ? t : String(t);
}
function Ir(e, t, n) {
  return t = IV(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function qj(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ar(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qj(Object(n), !0).forEach(function(r) {
      Ir(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qj(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function c$e(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function u$e(e) {
  return c$e(e) ? e : e instanceof oe.Component ? fh.findDOMNode(e) : null;
}
function f$e(e, t) {
  typeof e == "function" ? e(t) : Xs(e) === "object" && e && "current" in e && (e.current = t);
}
function d$e(e) {
  var t, n, r = TV.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
var p$e = /* @__PURE__ */ m.createContext({});
function AV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yj(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, IV(r.key), r);
  }
}
function RV(e, t, n) {
  return t && Yj(e.prototype, t), n && Yj(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function XT(e, t) {
  return XT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, XT(e, t);
}
function MV(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && XT(e, t);
}
function z1(e) {
  return z1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, z1(e);
}
function h$e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function QT(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function m$e(e, t) {
  if (t && (Xs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return QT(e);
}
function NV(e) {
  var t = h$e();
  return function() {
    var r = z1(e), i;
    if (t) {
      var o = z1(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return m$e(this, i);
  };
}
var g$e = /* @__PURE__ */ function(e) {
  MV(n, e);
  var t = NV(n);
  function n() {
    return AV(this, n), t.apply(this, arguments);
  }
  return RV(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(m.Component), af = "none", E0 = "appear", $0 = "enter", _0 = "leave", Xj = "none", Ls = "prepare", op = "start", ap = "active", O2 = "end", kV = "prepared";
function Qj(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function v$e(e, t) {
  var n = {
    animationend: Qj("Animation", "AnimationEnd"),
    transitionend: Qj("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var y$e = v$e(rx(), typeof window < "u" ? window : {}), LV = {};
if (rx()) {
  var b$e = document.createElement("div");
  LV = b$e.style;
}
var O0 = {};
function DV(e) {
  if (O0[e])
    return O0[e];
  var t = y$e[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(t, o) && o in LV)
        return O0[e] = t[o], O0[e];
    }
  return "";
}
var jV = DV("animationend"), FV = DV("transitionend"), BV = !!(jV && FV), Jj = jV || "animationend", Zj = FV || "transitionend";
function e6(e, t) {
  if (!e)
    return null;
  if (Xs(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const w$e = function(e) {
  var t = m.useRef(), n = m.useRef(e);
  n.current = e;
  var r = m.useCallback(function(a) {
    n.current(a);
  }, []);
  function i(a) {
    a && (a.removeEventListener(Zj, r), a.removeEventListener(Jj, r));
  }
  function o(a) {
    t.current && t.current !== a && i(t.current), a && a !== t.current && (a.addEventListener(Zj, r), a.addEventListener(Jj, r), t.current = a);
  }
  return m.useEffect(function() {
    return function() {
      i(t.current);
    };
  }, []), [o, i];
};
var zV = rx() ? m.useLayoutEffect : m.useEffect, UV = function(t) {
  return +setTimeout(t, 16);
}, HV = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (UV = function(t) {
  return window.requestAnimationFrame(t);
}, HV = function(t) {
  return window.cancelAnimationFrame(t);
});
var t6 = 0, P2 = /* @__PURE__ */ new Map();
function WV(e) {
  P2.delete(e);
}
var JT = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  t6 += 1;
  var r = t6;
  function i(o) {
    if (o === 0)
      WV(r), t();
    else {
      var a = UV(function() {
        i(o - 1);
      });
      P2.set(r, a);
    }
  }
  return i(n), r;
};
JT.cancel = function(e) {
  var t = P2.get(e);
  return WV(t), HV(t);
};
const S$e = function() {
  var e = m.useRef(null);
  function t() {
    JT.cancel(e.current);
  }
  function n(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var o = JT(function() {
      i <= 1 ? r({
        isCanceled: function() {
          return o !== e.current;
        }
      }) : n(r, i - 1);
    });
    e.current = o;
  }
  return m.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var x$e = [Ls, op, ap, O2], C$e = [Ls, kV], VV = !1, E$e = !0;
function GV(e) {
  return e === ap || e === O2;
}
const $$e = function(e, t, n) {
  var r = _p(Xj), i = ba(r, 2), o = i[0], a = i[1], s = S$e(), l = ba(s, 2), c = l[0], f = l[1];
  function d() {
    a(Ls, !0);
  }
  var p = t ? C$e : x$e;
  return zV(function() {
    if (o !== Xj && o !== O2) {
      var g = p.indexOf(o), v = p[g + 1], y = n(o);
      y === VV ? a(v, !0) : v && c(function(x) {
        function b() {
          x.isCanceled() || a(v, !0);
        }
        y === !0 ? b() : Promise.resolve(y).then(b);
      });
    }
  }, [e, o]), m.useEffect(function() {
    return function() {
      f();
    };
  }, []), [d, o];
};
function _$e(e, t, n, r) {
  var i = r.motionEnter, o = i === void 0 ? !0 : i, a = r.motionAppear, s = a === void 0 ? !0 : a, l = r.motionLeave, c = l === void 0 ? !0 : l, f = r.motionDeadline, d = r.motionLeaveImmediately, p = r.onAppearPrepare, g = r.onEnterPrepare, v = r.onLeavePrepare, y = r.onAppearStart, x = r.onEnterStart, b = r.onLeaveStart, w = r.onAppearActive, S = r.onEnterActive, E = r.onLeaveActive, O = r.onAppearEnd, $ = r.onEnterEnd, P = r.onLeaveEnd, R = r.onVisibleChanged, L = _p(), B = ba(L, 2), j = B[0], A = B[1], T = _p(af), k = ba(T, 2), F = k[0], W = k[1], V = _p(null), G = ba(V, 2), X = G[0], D = G[1], te = m.useRef(!1), ee = m.useRef(null);
  function U() {
    return n();
  }
  var he = m.useRef(!1);
  function re() {
    W(af, !0), D(null, !0);
  }
  function de(ie) {
    var fe = U();
    if (!(ie && !ie.deadline && ie.target !== fe)) {
      var be = he.current, Te;
      F === E0 && be ? Te = O == null ? void 0 : O(fe, ie) : F === $0 && be ? Te = $ == null ? void 0 : $(fe, ie) : F === _0 && be && (Te = P == null ? void 0 : P(fe, ie)), F !== af && be && Te !== !1 && re();
    }
  }
  var we = w$e(de), ue = ba(we, 1), me = ue[0], Se = function(fe) {
    var be, Te, Le;
    switch (fe) {
      case E0:
        return be = {}, Ir(be, Ls, p), Ir(be, op, y), Ir(be, ap, w), be;
      case $0:
        return Te = {}, Ir(Te, Ls, g), Ir(Te, op, x), Ir(Te, ap, S), Te;
      case _0:
        return Le = {}, Ir(Le, Ls, v), Ir(Le, op, b), Ir(Le, ap, E), Le;
      default:
        return {};
    }
  }, _e = m.useMemo(function() {
    return Se(F);
  }, [F]), Ge = $$e(F, !e, function(ie) {
    if (ie === Ls) {
      var fe = _e[Ls];
      return fe ? fe(U()) : VV;
    }
    if (Me in _e) {
      var be;
      D(((be = _e[Me]) === null || be === void 0 ? void 0 : be.call(_e, U(), null)) || null);
    }
    return Me === ap && (me(U()), f > 0 && (clearTimeout(ee.current), ee.current = setTimeout(function() {
      de({
        deadline: !0
      });
    }, f))), Me === kV && re(), E$e;
  }), Fe = ba(Ge, 2), Ae = Fe[0], Me = Fe[1], et = GV(Me);
  he.current = et, zV(function() {
    A(t);
    var ie = te.current;
    te.current = !0;
    var fe;
    !ie && t && s && (fe = E0), ie && t && o && (fe = $0), (ie && !t && c || !ie && d && !t && c) && (fe = _0);
    var be = Se(fe);
    fe && (e || be[Ls]) ? (W(fe), Ae()) : W(af);
  }, [t]), m.useEffect(function() {
    // Cancel appear
    (F === E0 && !s || // Cancel enter
    F === $0 && !o || // Cancel leave
    F === _0 && !c) && W(af);
  }, [s, o, c]), m.useEffect(function() {
    return function() {
      te.current = !1, clearTimeout(ee.current);
    };
  }, []);
  var De = m.useRef(!1);
  m.useEffect(function() {
    j && (De.current = !0), j !== void 0 && F === af && ((De.current || j) && (R == null || R(j)), De.current = !0);
  }, [j, F]);
  var je = X;
  return _e[Ls] && Me === op && (je = Ar({
    transition: "none"
  }, je)), [F, Me, je, j ?? t];
}
function O$e(e) {
  var t = e;
  Xs(e) === "object" && (t = e.transitionSupport);
  function n(i, o) {
    return !!(i.motionName && t && o !== !1);
  }
  var r = /* @__PURE__ */ m.forwardRef(function(i, o) {
    var a = i.visible, s = a === void 0 ? !0 : a, l = i.removeOnLeave, c = l === void 0 ? !0 : l, f = i.forceRender, d = i.children, p = i.motionName, g = i.leavedClassName, v = i.eventProps, y = m.useContext(p$e), x = y.motion, b = n(i, x), w = m.useRef(), S = m.useRef();
    function E() {
      try {
        return w.current instanceof HTMLElement ? w.current : u$e(S.current);
      } catch {
        return null;
      }
    }
    var O = _$e(b, s, E, i), $ = ba(O, 4), P = $[0], R = $[1], L = $[2], B = $[3], j = m.useRef(B);
    B && (j.current = !0);
    var A = m.useCallback(function(D) {
      w.current = D, f$e(o, D);
    }, [o]), T, k = Ar(Ar({}, v), {}, {
      visible: s
    });
    if (!d)
      T = null;
    else if (P === af)
      B ? T = d(Ar({}, k), A) : !c && j.current && g ? T = d(Ar(Ar({}, k), {}, {
        className: g
      }), A) : f || !c && !g ? T = d(Ar(Ar({}, k), {}, {
        style: {
          display: "none"
        }
      }), A) : T = null;
    else {
      var F, W;
      R === Ls ? W = "prepare" : GV(R) ? W = "active" : R === op && (W = "start");
      var V = e6(p, "".concat(P, "-").concat(W));
      T = d(Ar(Ar({}, k), {}, {
        className: Ug(e6(p, P), (F = {}, Ir(F, V, V && W), Ir(F, p, typeof p == "string"), F)),
        style: L
      }), A);
    }
    if (/* @__PURE__ */ m.isValidElement(T) && d$e(T)) {
      var G = T, X = G.ref;
      X || (T = /* @__PURE__ */ m.cloneElement(T, {
        ref: A
      }));
    }
    return /* @__PURE__ */ m.createElement(g$e, {
      ref: S
    }, T);
  });
  return r.displayName = "CSSMotion", r;
}
const KV = O$e(BV);
var ZT = "add", eI = "keep", tI = "remove", e_ = "removed";
function P$e(e) {
  var t;
  return e && Xs(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, Ar(Ar({}, t), {}, {
    key: String(t.key)
  });
}
function nI() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(P$e);
}
function T$e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, i = t.length, o = nI(e), a = nI(t);
  o.forEach(function(c) {
    for (var f = !1, d = r; d < i; d += 1) {
      var p = a[d];
      if (p.key === c.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(g) {
          return Ar(Ar({}, g), {}, {
            status: ZT
          });
        })), r = d), n.push(Ar(Ar({}, p), {}, {
          status: eI
        })), r += 1, f = !0;
        break;
      }
    }
    f || n.push(Ar(Ar({}, c), {}, {
      status: tI
    }));
  }), r < i && (n = n.concat(a.slice(r).map(function(c) {
    return Ar(Ar({}, c), {}, {
      status: ZT
    });
  })));
  var s = {};
  n.forEach(function(c) {
    var f = c.key;
    s[f] = (s[f] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(c) {
    return s[c] > 1;
  });
  return l.forEach(function(c) {
    n = n.filter(function(f) {
      var d = f.key, p = f.status;
      return d !== c || p !== tI;
    }), n.forEach(function(f) {
      f.key === c && (f.status = eI);
    });
  }), n;
}
var I$e = ["component", "children", "onVisibleChanged", "onAllRemoved"], A$e = ["status"], R$e = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function M$e(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : KV, n = /* @__PURE__ */ function(r) {
    MV(o, r);
    var i = NV(o);
    function o() {
      var a;
      AV(this, o);
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      return a = i.call.apply(i, [this].concat(l)), Ir(QT(a), "state", {
        keyEntities: []
      }), Ir(QT(a), "removeKey", function(f) {
        var d = a.state.keyEntities, p = d.map(function(g) {
          return g.key !== f ? g : Ar(Ar({}, g), {}, {
            status: e_
          });
        });
        return a.setState({
          keyEntities: p
        }), p.filter(function(g) {
          var v = g.status;
          return v !== e_;
        }).length;
      }), a;
    }
    return RV(o, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, c = this.props, f = c.component, d = c.children, p = c.onVisibleChanged, g = c.onAllRemoved, v = B1(c, I$e), y = f || m.Fragment, x = {};
        return R$e.forEach(function(b) {
          x[b] = v[b], delete v[b];
        }), delete v.keys, /* @__PURE__ */ m.createElement(y, v, l.map(function(b) {
          var w = b.status, S = B1(b, A$e), E = w === ZT || w === eI;
          return /* @__PURE__ */ m.createElement(t, Hf({}, x, {
            key: S.key,
            visible: E,
            eventProps: S,
            onVisibleChanged: function($) {
              if (p == null || p($, {
                key: S.key
              }), !$) {
                var P = s.removeKey(S.key);
                P === 0 && g && g();
              }
            }
          }), d);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var c = s.keys, f = l.keyEntities, d = nI(c), p = T$e(f, d);
        return {
          keyEntities: p.filter(function(g) {
            var v = f.find(function(y) {
              var x = y.key;
              return g.key === x;
            });
            return !(v && v.status === e_ && g.status === tI);
          })
        };
      }
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
    }]), o;
  }(m.Component);
  return Ir(n, "defaultProps", {
    component: "div"
  }), n;
}
M$e(BV);
var At = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= At.F1 && n <= At.F12)
      return !1;
    switch (n) {
      case At.ALT:
      case At.CAPS_LOCK:
      case At.CONTEXT_MENU:
      case At.CTRL:
      case At.DOWN:
      case At.END:
      case At.ESC:
      case At.HOME:
      case At.INSERT:
      case At.LEFT:
      case At.MAC_FF_META:
      case At.META:
      case At.NUMLOCK:
      case At.NUM_CENTER:
      case At.PAGE_DOWN:
      case At.PAGE_UP:
      case At.PAUSE:
      case At.PRINT_SCREEN:
      case At.RIGHT:
      case At.SHIFT:
      case At.UP:
      case At.WIN_KEY:
      case At.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= At.ZERO && t <= At.NINE || t >= At.NUM_ZERO && t <= At.NUM_MULTIPLY || t >= At.A && t <= At.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case At.SPACE:
      case At.QUESTION_MARK:
      case At.NUM_PLUS:
      case At.NUM_MINUS:
      case At.NUM_PERIOD:
      case At.NUM_DIVISION:
      case At.SEMICOLON:
      case At.DASH:
      case At.EQUALS:
      case At.COMMA:
      case At.PERIOD:
      case At.SLASH:
      case At.APOSTROPHE:
      case At.SINGLE_QUOTE:
      case At.OPEN_SQUARE_BRACKET:
      case At.BACKSLASH:
      case At.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, qV = /* @__PURE__ */ oe.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.forceRender, i = e.className, o = e.style, a = e.children, s = e.isActive, l = e.role, c = oe.useState(s || r), f = ba(c, 2), d = f[0], p = f[1];
  return oe.useEffect(function() {
    (r || s) && p(!0);
  }, [r, s]), d ? /* @__PURE__ */ oe.createElement("div", {
    ref: t,
    className: Ug("".concat(n, "-content"), Ir(Ir({}, "".concat(n, "-content-active"), s), "".concat(n, "-content-inactive"), !s), i),
    style: o,
    role: l
  }, /* @__PURE__ */ oe.createElement("div", {
    className: "".concat(n, "-content-box")
  }, a)) : null;
});
qV.displayName = "PanelContent";
var N$e = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"], YV = /* @__PURE__ */ oe.forwardRef(function(e, t) {
  var n = e.showArrow, r = n === void 0 ? !0 : n, i = e.headerClass, o = e.isActive, a = e.onItemClick, s = e.forceRender, l = e.className, c = e.prefixCls, f = e.collapsible, d = e.accordion, p = e.panelKey, g = e.extra, v = e.header, y = e.expandIcon, x = e.openMotion, b = e.destroyInactivePanel, w = e.children, S = B1(e, N$e), E = f === "disabled", O = f === "header", $ = f === "icon", P = g != null && typeof g != "boolean", R = function() {
    a == null || a(p);
  }, L = function(F) {
    (F.key === "Enter" || F.keyCode === At.ENTER || F.which === At.ENTER) && R();
  }, B = typeof y == "function" ? y(e) : /* @__PURE__ */ oe.createElement("i", {
    className: "arrow"
  });
  B && (B = /* @__PURE__ */ oe.createElement("div", {
    className: "".concat(c, "-expand-icon"),
    onClick: ["header", "icon"].includes(f) ? R : void 0
  }, B));
  var j = Ug(Ir(Ir(Ir({}, "".concat(c, "-item"), !0), "".concat(c, "-item-active"), o), "".concat(c, "-item-disabled"), E), l), A = Ug(i, Ir(Ir(Ir({}, "".concat(c, "-header"), !0), "".concat(c, "-header-collapsible-only"), O), "".concat(c, "-icon-collapsible-only"), $)), T = {
    className: A,
    "aria-expanded": o,
    "aria-disabled": E,
    onKeyDown: L
  };
  return !O && !$ && (T.onClick = R, T.role = d ? "tab" : "button", T.tabIndex = E ? -1 : 0), /* @__PURE__ */ oe.createElement("div", Hf({}, S, {
    ref: t,
    className: j
  }), /* @__PURE__ */ oe.createElement("div", T, r && B, /* @__PURE__ */ oe.createElement("span", {
    className: "".concat(c, "-header-text"),
    onClick: f === "header" ? R : void 0
  }, v), P && /* @__PURE__ */ oe.createElement("div", {
    className: "".concat(c, "-extra")
  }, g)), /* @__PURE__ */ oe.createElement(KV, Hf({
    visible: o,
    leavedClassName: "".concat(c, "-content-hidden")
  }, x, {
    forceRender: s,
    removeOnLeave: b
  }), function(k, F) {
    var W = k.className, V = k.style;
    return /* @__PURE__ */ oe.createElement(qV, {
      ref: F,
      prefixCls: c,
      className: W,
      style: V,
      isActive: o,
      forceRender: s,
      role: d ? "tabpanel" : void 0
    }, w);
  }));
}), k$e = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"], L$e = function(t, n) {
  var r = n.prefixCls, i = n.accordion, o = n.collapsible, a = n.destroyInactivePanel, s = n.onItemClick, l = n.activeKey, c = n.openMotion, f = n.expandIcon;
  return t.map(function(d, p) {
    var g = d.children, v = d.label, y = d.key, x = d.collapsible, b = d.onItemClick, w = d.destroyInactivePanel, S = B1(d, k$e), E = String(y ?? p), O = x ?? o, $ = w ?? a, P = function(B) {
      O !== "disabled" && (s(B), b == null || b(B));
    }, R = !1;
    return i ? R = l[0] === E : R = l.indexOf(E) > -1, /* @__PURE__ */ oe.createElement(YV, Hf({}, S, {
      prefixCls: r,
      key: E,
      panelKey: E,
      isActive: R,
      accordion: i,
      openMotion: c,
      expandIcon: f,
      header: v,
      collapsible: O,
      onItemClick: P,
      destroyInactivePanel: $
    }), g);
  });
}, D$e = function(t, n, r) {
  if (!t)
    return null;
  var i = r.prefixCls, o = r.accordion, a = r.collapsible, s = r.destroyInactivePanel, l = r.onItemClick, c = r.activeKey, f = r.openMotion, d = r.expandIcon, p = t.key || String(n), g = t.props, v = g.header, y = g.headerClass, x = g.destroyInactivePanel, b = g.collapsible, w = g.onItemClick, S = !1;
  o ? S = c[0] === p : S = c.indexOf(p) > -1;
  var E = b ?? a, O = function(R) {
    E !== "disabled" && (l(R), w == null || w(R));
  }, $ = {
    key: p,
    panelKey: p,
    header: v,
    headerClass: y,
    isActive: S,
    prefixCls: i,
    destroyInactivePanel: x ?? s,
    openMotion: f,
    accordion: o,
    children: t.props.children,
    onItemClick: O,
    expandIcon: d,
    collapsible: E
  };
  return typeof t.type == "string" ? t : (Object.keys($).forEach(function(P) {
    typeof $[P] > "u" && delete $[P];
  }), /* @__PURE__ */ oe.cloneElement(t, $));
};
function j$e(e, t, n) {
  return Array.isArray(e) ? L$e(e, n) : YT(t).map(function(r, i) {
    return D$e(r, i, n);
  });
}
var F$e = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, B$e = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, z$e = "".concat(F$e, " ").concat(B$e).split(/[\s\n]+/), U$e = "aria-", H$e = "data-";
function n6(e, t) {
  return e.indexOf(t) === 0;
}
function W$e(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = Ar({}, t);
  var r = {};
  return Object.keys(e).forEach(function(i) {
    // Aria
    (n.aria && (i === "role" || n6(i, U$e)) || // Data
    n.data && n6(i, H$e) || // Attr
    n.attr && z$e.includes(i)) && (r[i] = e[i]);
  }), r;
}
function V$e(e) {
  var t = e;
  if (!Array.isArray(t)) {
    var n = Xs(t);
    t = n === "number" || n === "string" ? [t] : [];
  }
  return t.map(function(r) {
    return String(r);
  });
}
var G$e = /* @__PURE__ */ oe.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-collapse" : n, i = e.destroyInactivePanel, o = i === void 0 ? !1 : i, a = e.style, s = e.accordion, l = e.className, c = e.children, f = e.collapsible, d = e.openMotion, p = e.expandIcon, g = e.activeKey, v = e.defaultActiveKey, y = e.onChange, x = e.items, b = Ug(r, l), w = XEe([], {
    value: g,
    onChange: function(L) {
      return y == null ? void 0 : y(L);
    },
    defaultValue: v,
    postState: V$e
  }), S = ba(w, 2), E = S[0], O = S[1], $ = function(L) {
    return O(function() {
      if (s)
        return E[0] === L ? [] : [L];
      var B = E.indexOf(L), j = B > -1;
      return j ? E.filter(function(A) {
        return A !== L;
      }) : [].concat(VEe(E), [L]);
    });
  };
  ix(!c, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
  var P = j$e(x, c, {
    prefixCls: r,
    accordion: s,
    openMotion: d,
    expandIcon: p,
    collapsible: f,
    destroyInactivePanel: o,
    onItemClick: $,
    activeKey: E
  });
  return /* @__PURE__ */ oe.createElement("div", Hf({
    ref: t,
    className: b,
    style: a,
    role: s ? "tablist" : void 0
  }, W$e(e, {
    aria: !0,
    data: !0
  })), P);
});
const T2 = Object.assign(G$e, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: YV
});
T2.Panel;
const K$e = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    getPrefixCls: n
  } = m.useContext(Mt), {
    prefixCls: r,
    className: i,
    showArrow: o = !0
  } = e, a = n("collapse", r), s = Ue({
    [`${a}-no-arrow`]: !o
  }, i);
  return /* @__PURE__ */ m.createElement(T2.Panel, Object.assign({
    ref: t
  }, e, {
    prefixCls: a,
    className: s
  }));
}), q$e = K$e, Y$e = (e) => {
  const {
    componentCls: t,
    contentBg: n,
    padding: r,
    headerBg: i,
    headerPadding: o,
    collapseHeaderPaddingSM: a,
    collapseHeaderPaddingLG: s,
    collapsePanelBorderRadius: l,
    lineWidth: c,
    lineType: f,
    colorBorder: d,
    colorText: p,
    colorTextHeading: g,
    colorTextDisabled: v,
    fontSizeLG: y,
    lineHeight: x,
    lineHeightLG: b,
    marginSM: w,
    paddingSM: S,
    paddingLG: E,
    paddingXS: O,
    motionDurationSlow: $,
    fontSizeIcon: P,
    contentPadding: R,
    fontHeight: L,
    fontHeightLG: B
  } = e, j = `${ge(c)} ${f} ${d}`;
  return {
    [t]: Object.assign(Object.assign({}, Vi(e)), {
      backgroundColor: i,
      border: j,
      borderBottom: 0,
      borderRadius: l,
      "&-rtl": {
        direction: "rtl"
      },
      [`& > ${t}-item`]: {
        borderBottom: j,
        "&:last-child": {
          [`
            &,
            & > ${t}-header`]: {
            borderRadius: `0 0 ${ge(l)} ${ge(l)}`
          }
        },
        [`> ${t}-header`]: {
          position: "relative",
          // Compatible with old version of antd, should remove in next version
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "flex-start",
          padding: o,
          color: g,
          lineHeight: x,
          cursor: "pointer",
          transition: `all ${$}, visibility 0s`,
          [`> ${t}-header-text`]: {
            flex: "auto"
          },
          "&:focus": {
            outline: "none"
          },
          // >>>>> Arrow
          [`${t}-expand-icon`]: {
            height: L,
            display: "flex",
            alignItems: "center",
            paddingInlineEnd: w
          },
          [`${t}-arrow`]: Object.assign(Object.assign({}, DH()), {
            fontSize: P,
            svg: {
              transition: `transform ${$}`
            }
          }),
          // >>>>> Text
          [`${t}-header-text`]: {
            marginInlineEnd: "auto"
          }
        },
        [`${t}-icon-collapsible-only`]: {
          cursor: "unset",
          [`${t}-expand-icon`]: {
            cursor: "pointer"
          }
        }
      },
      [`${t}-content`]: {
        color: p,
        backgroundColor: n,
        borderTop: j,
        [`& > ${t}-content-box`]: {
          padding: R
        },
        "&-hidden": {
          display: "none"
        }
      },
      "&-small": {
        [`> ${t}-item`]: {
          [`> ${t}-header`]: {
            padding: a,
            paddingInlineStart: O,
            [`> ${t}-expand-icon`]: {
              // Arrow offset
              marginInlineStart: e.calc(S).sub(O).equal()
            }
          },
          [`> ${t}-content > ${t}-content-box`]: {
            padding: S
          }
        }
      },
      "&-large": {
        [`> ${t}-item`]: {
          fontSize: y,
          lineHeight: b,
          [`> ${t}-header`]: {
            padding: s,
            paddingInlineStart: r,
            [`> ${t}-expand-icon`]: {
              height: B,
              // Arrow offset
              marginInlineStart: e.calc(E).sub(r).equal()
            }
          },
          [`> ${t}-content > ${t}-content-box`]: {
            padding: E
          }
        }
      },
      [`${t}-item:last-child`]: {
        [`> ${t}-content`]: {
          borderRadius: `0 0 ${ge(l)} ${ge(l)}`
        }
      },
      [`& ${t}-item-disabled > ${t}-header`]: {
        "\n          &,\n          & > .arrow\n        ": {
          color: v,
          cursor: "not-allowed"
        }
      },
      // ========================== Icon Position ==========================
      [`&${t}-icon-position-end`]: {
        [`& > ${t}-item`]: {
          [`> ${t}-header`]: {
            [`${t}-expand-icon`]: {
              order: 1,
              paddingInlineEnd: 0,
              paddingInlineStart: w
            }
          }
        }
      }
    })
  };
}, X$e = (e) => {
  const {
    componentCls: t
  } = e, n = `> ${t}-item > ${t}-header ${t}-arrow svg`;
  return {
    [`${t}-rtl`]: {
      [n]: {
        transform: "rotate(180deg)"
      }
    }
  };
}, Q$e = (e) => {
  const {
    componentCls: t,
    headerBg: n,
    paddingXXS: r,
    colorBorder: i
  } = e;
  return {
    [`${t}-borderless`]: {
      backgroundColor: n,
      border: 0,
      [`> ${t}-item`]: {
        borderBottom: `1px solid ${i}`
      },
      [`
        > ${t}-item:last-child,
        > ${t}-item:last-child ${t}-header
      `]: {
        borderRadius: 0
      },
      [`> ${t}-item:last-child`]: {
        borderBottom: 0
      },
      [`> ${t}-item > ${t}-content`]: {
        backgroundColor: "transparent",
        borderTop: 0
      },
      [`> ${t}-item > ${t}-content > ${t}-content-box`]: {
        paddingTop: r
      }
    }
  };
}, J$e = (e) => {
  const {
    componentCls: t,
    paddingSM: n
  } = e;
  return {
    [`${t}-ghost`]: {
      backgroundColor: "transparent",
      border: 0,
      [`> ${t}-item`]: {
        borderBottom: 0,
        [`> ${t}-content`]: {
          backgroundColor: "transparent",
          border: 0,
          [`> ${t}-content-box`]: {
            paddingBlock: n
          }
        }
      }
    }
  };
}, Z$e = (e) => ({
  headerPadding: `${e.paddingSM}px ${e.padding}px`,
  headerBg: e.colorFillAlter,
  contentPadding: `${e.padding}px 16px`,
  // Fixed Value
  contentBg: e.colorBgContainer
}), e_e = Pi("Collapse", (e) => {
  const t = _r(e, {
    collapseHeaderPaddingSM: `${ge(e.paddingXS)} ${ge(e.paddingSM)}`,
    collapseHeaderPaddingLG: `${ge(e.padding)} ${ge(e.paddingLG)}`,
    collapsePanelBorderRadius: e.borderRadiusLG
  });
  return [Y$e(t), Q$e(t), J$e(t), X$e(t), w0e(t)];
}, Z$e), t_e = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r,
    collapse: i
  } = m.useContext(Mt), {
    prefixCls: o,
    className: a,
    rootClassName: s,
    style: l,
    bordered: c = !0,
    ghost: f,
    size: d,
    expandIconPosition: p = "start",
    children: g,
    expandIcon: v
  } = e, y = Rl((j) => {
    var A;
    return (A = d ?? j) !== null && A !== void 0 ? A : "middle";
  }), x = n("collapse", o), b = n(), [w, S, E] = e_e(x), O = m.useMemo(() => p === "left" ? "start" : p === "right" ? "end" : p, [p]), $ = v ?? (i == null ? void 0 : i.expandIcon), P = m.useCallback(function() {
    let j = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const A = typeof $ == "function" ? $(j) : /* @__PURE__ */ m.createElement(pwe, {
      rotate: j.isActive ? 90 : void 0
    });
    return Oa(A, () => {
      var T;
      return {
        className: Ue((T = A == null ? void 0 : A.props) === null || T === void 0 ? void 0 : T.className, `${x}-arrow`)
      };
    });
  }, [$, x]), R = Ue(`${x}-icon-position-${O}`, {
    [`${x}-borderless`]: !c,
    [`${x}-rtl`]: r === "rtl",
    [`${x}-ghost`]: !!f,
    [`${x}-${y}`]: y !== "middle"
  }, i == null ? void 0 : i.className, a, s, S, E), L = Object.assign(Object.assign({}, qme(b)), {
    motionAppear: !1,
    leavedClassName: `${x}-content-hidden`
  }), B = m.useMemo(() => g ? vc(g).map((j, A) => {
    var T, k;
    if (!((T = j.props) === null || T === void 0) && T.disabled) {
      const F = (k = j.key) !== null && k !== void 0 ? k : String(A), {
        disabled: W,
        collapsible: V
      } = j.props, G = Object.assign(Object.assign({}, os(j.props, ["disabled"])), {
        key: F,
        collapsible: V ?? (W ? "disabled" : void 0)
      });
      return Oa(j, G);
    }
    return j;
  }) : null, [g]);
  return w(/* @__PURE__ */ m.createElement(T2, Object.assign({
    ref: t,
    openMotion: L
  }, os(e, ["rootClassName"]), {
    expandIcon: P,
    prefixCls: x,
    className: R,
    style: Object.assign(Object.assign({}, i == null ? void 0 : i.style), l)
  }), B));
}), XV = Object.assign(t_e, {
  Panel: q$e
});
function n_e(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function r_e(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function r6(e, t, n, r) {
  if (n) {
    var i = t;
    if (t.type === "click") {
      var o = e.cloneNode(!0);
      i = Object.create(t, {
        target: {
          value: o
        },
        currentTarget: {
          value: o
        }
      }), o.value = "", n(i);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      var a = e.cloneNode(!0);
      i = Object.create(t, {
        target: {
          value: a
        },
        currentTarget: {
          value: a
        }
      }), a.value = r, n(i);
      return;
    }
    n(i);
  }
}
var i_e = function(t) {
  var n, r, i = t.inputElement, o = t.children, a = t.prefixCls, s = t.prefix, l = t.suffix, c = t.addonBefore, f = t.addonAfter, d = t.className, p = t.style, g = t.disabled, v = t.readOnly, y = t.focused, x = t.triggerFocus, b = t.allowClear, w = t.value, S = t.handleReset, E = t.hidden, O = t.classes, $ = t.classNames, P = t.dataAttrs, R = t.styles, L = t.components, B = o ?? i, j = (L == null ? void 0 : L.affixWrapper) || "span", A = (L == null ? void 0 : L.groupWrapper) || "span", T = (L == null ? void 0 : L.wrapper) || "span", k = (L == null ? void 0 : L.groupAddon) || "span", F = m.useRef(null), W = function(Ae) {
    var Me;
    (Me = F.current) !== null && Me !== void 0 && Me.contains(Ae.target) && (x == null || x());
  }, V = r_e(t), G = /* @__PURE__ */ m.cloneElement(B, {
    value: w,
    className: ft(B.props.className, !V && ($ == null ? void 0 : $.variant)) || null
  });
  if (V) {
    var X, D = null;
    if (b) {
      var te, ee = !g && !v && w, U = "".concat(a, "-clear-icon"), he = nn(b) === "object" && b !== null && b !== void 0 && b.clearIcon ? b.clearIcon : "✖";
      D = /* @__PURE__ */ oe.createElement("span", {
        onClick: S,
        onMouseDown: function(Ae) {
          return Ae.preventDefault();
        },
        className: ft(U, (te = {}, ce(te, "".concat(U, "-hidden"), !ee), ce(te, "".concat(U, "-has-suffix"), !!l), te)),
        role: "button",
        tabIndex: -1
      }, he);
    }
    var re = "".concat(a, "-affix-wrapper"), de = ft(re, (X = {}, ce(X, "".concat(a, "-disabled"), g), ce(X, "".concat(re, "-disabled"), g), ce(X, "".concat(re, "-focused"), y), ce(X, "".concat(re, "-readonly"), v), ce(X, "".concat(re, "-input-with-clear-btn"), l && b && w), X), O == null ? void 0 : O.affixWrapper, $ == null ? void 0 : $.affixWrapper, $ == null ? void 0 : $.variant), we = (l || b) && /* @__PURE__ */ oe.createElement("span", {
      className: ft("".concat(a, "-suffix"), $ == null ? void 0 : $.suffix),
      style: R == null ? void 0 : R.suffix
    }, D, l);
    G = /* @__PURE__ */ oe.createElement(j, jt({
      className: de,
      style: R == null ? void 0 : R.affixWrapper,
      onClick: W
    }, P == null ? void 0 : P.affixWrapper, {
      ref: F
    }), s && /* @__PURE__ */ oe.createElement("span", {
      className: ft("".concat(a, "-prefix"), $ == null ? void 0 : $.prefix),
      style: R == null ? void 0 : R.prefix
    }, s), G, we);
  }
  if (n_e(t)) {
    var ue = "".concat(a, "-group"), me = "".concat(ue, "-addon"), Se = "".concat(ue, "-wrapper"), _e = ft("".concat(a, "-wrapper"), ue, O == null ? void 0 : O.wrapper, $ == null ? void 0 : $.wrapper), Ge = ft(Se, ce({}, "".concat(Se, "-disabled"), g), O == null ? void 0 : O.group, $ == null ? void 0 : $.groupWrapper);
    G = /* @__PURE__ */ oe.createElement(A, {
      className: Ge
    }, /* @__PURE__ */ oe.createElement(T, {
      className: _e
    }, c && /* @__PURE__ */ oe.createElement(k, {
      className: me
    }, c), G, f && /* @__PURE__ */ oe.createElement(k, {
      className: me
    }, f)));
  }
  return /* @__PURE__ */ oe.cloneElement(G, {
    className: ft((n = G.props) === null || n === void 0 ? void 0 : n.className, d) || null,
    style: ye(ye({}, (r = G.props) === null || r === void 0 ? void 0 : r.style), p),
    hidden: E
  });
}, o_e = ["show"];
function a_e(e, t) {
  return m.useMemo(function() {
    var n = {};
    t && (n.show = nn(t) === "object" && t.formatter ? t.formatter : !!t), n = ye(ye({}, n), e);
    var r = n, i = r.show, o = _n(r, o_e);
    return ye(ye({}, o), {}, {
      show: !!i,
      showFormatter: typeof i == "function" ? i : void 0,
      strategy: o.strategy || function(a) {
        return a.length;
      }
    });
  }, [e, t]);
}
const s_e = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = m.useContext(Mt), {
    prefixCls: r,
    className: i
  } = e, o = t("input-group", r), a = t("input"), [s, l] = f2(a), c = Ue(o, {
    [`${o}-lg`]: e.size === "large",
    [`${o}-sm`]: e.size === "small",
    [`${o}-compact`]: e.compact,
    [`${o}-rtl`]: n === "rtl"
  }, l, i), f = m.useContext(Uf), d = m.useMemo(() => Object.assign(Object.assign({}, f), {
    isFormItemInput: !1
  }), [f]);
  return s(/* @__PURE__ */ m.createElement("span", {
    className: c,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ m.createElement(Uf.Provider, {
    value: d
  }, e.children)));
}, l_e = s_e;
function Wf(e) {
  "@babel/helpers - typeof";
  return Wf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wf(e);
}
function c_e(e, t) {
  if (Wf(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Wf(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function u_e(e) {
  var t = c_e(e, "string");
  return Wf(t) === "symbol" ? t : String(t);
}
function Is(e, t, n) {
  return t = u_e(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function i6(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function su(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? i6(Object(n), !0).forEach(function(r) {
      Is(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i6(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Hg() {
  return Hg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hg.apply(this, arguments);
}
var QV = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var l in o)
              t.call(o, l) && o[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(QV);
var f_e = QV.exports;
const As = /* @__PURE__ */ Oi(f_e);
function d_e(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function p_e(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function o6(e, t, n) {
  var r = t.cloneNode(!0), i = Object.create(e, {
    target: {
      value: r
    },
    currentTarget: {
      value: r
    }
  });
  return r.value = n, typeof t.selectionStart == "number" && typeof t.selectionEnd == "number" && (r.selectionStart = t.selectionStart, r.selectionEnd = t.selectionEnd), i;
}
function a6(e, t, n, r) {
  if (n) {
    var i = t;
    if (t.type === "click") {
      i = o6(t, e, ""), n(i);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      i = o6(t, e, r), n(i);
      return;
    }
    n(i);
  }
}
function h_e(e, t) {
  if (e) {
    e.focus(t);
    var n = t || {}, r = n.cursor;
    if (r) {
      var i = e.value.length;
      switch (r) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(i, i);
          break;
        default:
          e.setSelectionRange(0, i);
      }
    }
  }
}
var m_e = function(t) {
  var n, r, i = t.inputElement, o = t.children, a = t.prefixCls, s = t.prefix, l = t.suffix, c = t.addonBefore, f = t.addonAfter, d = t.className, p = t.style, g = t.disabled, v = t.readOnly, y = t.focused, x = t.triggerFocus, b = t.allowClear, w = t.value, S = t.handleReset, E = t.hidden, O = t.classes, $ = t.classNames, P = t.dataAttrs, R = t.styles, L = t.components, B = o ?? i, j = (L == null ? void 0 : L.affixWrapper) || "span", A = (L == null ? void 0 : L.groupWrapper) || "span", T = (L == null ? void 0 : L.wrapper) || "span", k = (L == null ? void 0 : L.groupAddon) || "span", F = m.useRef(null), W = function(Ae) {
    var Me;
    (Me = F.current) !== null && Me !== void 0 && Me.contains(Ae.target) && (x == null || x());
  }, V = p_e(t), G = /* @__PURE__ */ m.cloneElement(B, {
    value: w,
    className: As(B.props.className, !V && ($ == null ? void 0 : $.variant)) || null
  });
  if (V) {
    var X, D = null;
    if (b) {
      var te, ee = !g && !v && w, U = "".concat(a, "-clear-icon"), he = Wf(b) === "object" && b !== null && b !== void 0 && b.clearIcon ? b.clearIcon : "✖";
      D = /* @__PURE__ */ oe.createElement("span", {
        onClick: S,
        onMouseDown: function(Ae) {
          return Ae.preventDefault();
        },
        className: As(U, (te = {}, Is(te, "".concat(U, "-hidden"), !ee), Is(te, "".concat(U, "-has-suffix"), !!l), te)),
        role: "button",
        tabIndex: -1
      }, he);
    }
    var re = "".concat(a, "-affix-wrapper"), de = As(re, (X = {}, Is(X, "".concat(a, "-disabled"), g), Is(X, "".concat(re, "-disabled"), g), Is(X, "".concat(re, "-focused"), y), Is(X, "".concat(re, "-readonly"), v), Is(X, "".concat(re, "-input-with-clear-btn"), l && b && w), X), O == null ? void 0 : O.affixWrapper, $ == null ? void 0 : $.affixWrapper, $ == null ? void 0 : $.variant), we = (l || b) && /* @__PURE__ */ oe.createElement("span", {
      className: As("".concat(a, "-suffix"), $ == null ? void 0 : $.suffix),
      style: R == null ? void 0 : R.suffix
    }, D, l);
    G = /* @__PURE__ */ oe.createElement(j, Hg({
      className: de,
      style: R == null ? void 0 : R.affixWrapper,
      onClick: W
    }, P == null ? void 0 : P.affixWrapper, {
      ref: F
    }), s && /* @__PURE__ */ oe.createElement("span", {
      className: As("".concat(a, "-prefix"), $ == null ? void 0 : $.prefix),
      style: R == null ? void 0 : R.prefix
    }, s), G, we);
  }
  if (d_e(t)) {
    var ue = "".concat(a, "-group"), me = "".concat(ue, "-addon"), Se = "".concat(ue, "-wrapper"), _e = As("".concat(a, "-wrapper"), ue, O == null ? void 0 : O.wrapper, $ == null ? void 0 : $.wrapper), Ge = As(Se, Is({}, "".concat(Se, "-disabled"), g), O == null ? void 0 : O.group, $ == null ? void 0 : $.groupWrapper);
    G = /* @__PURE__ */ oe.createElement(A, {
      className: Ge
    }, /* @__PURE__ */ oe.createElement(T, {
      className: _e
    }, c && /* @__PURE__ */ oe.createElement(k, {
      className: me
    }, c), G, f && /* @__PURE__ */ oe.createElement(k, {
      className: me
    }, f)));
  }
  return /* @__PURE__ */ oe.cloneElement(G, {
    className: As((n = G.props) === null || n === void 0 ? void 0 : n.className, d) || null,
    style: su(su({}, (r = G.props) === null || r === void 0 ? void 0 : r.style), p),
    hidden: E
  });
};
function rI(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function g_e(e) {
  if (Array.isArray(e))
    return rI(e);
}
function v_e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function JV(e, t) {
  if (e) {
    if (typeof e == "string")
      return rI(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return rI(e, t);
  }
}
function y_e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b_e(e) {
  return g_e(e) || v_e(e) || JV(e) || y_e();
}
function w_e(e) {
  if (Array.isArray(e))
    return e;
}
function S_e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function x_e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Op(e, t) {
  return w_e(e) || S_e(e, t) || JV(e, t) || x_e();
}
function C_e(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function ZV(e, t) {
  if (e == null)
    return {};
  var n = C_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function s6(e) {
  var t = m.useRef();
  t.current = e;
  var n = m.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function E_e() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var l6 = E_e() ? m.useLayoutEffect : m.useEffect, c6 = function(t, n) {
  var r = m.useRef(!0);
  l6(function() {
    if (!r.current)
      return t();
  }, n), l6(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
};
function u6(e) {
  var t = m.useRef(!1), n = m.useState(e), r = Op(n, 2), i = r[0], o = r[1];
  m.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || o(s);
  }
  return [i, a];
}
function t_(e) {
  return e !== void 0;
}
function $_e(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = u6(function() {
    return t_(i) ? i : t_(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = Op(s, 2), c = l[0], f = l[1], d = i !== void 0 ? i : c, p = a ? a(d) : d, g = s6(o), v = u6([d]), y = Op(v, 2), x = y[0], b = y[1];
  c6(function() {
    var S = x[0];
    c !== S && g(c, S);
  }, [x]), c6(function() {
    t_(i) || f(i);
  }, [i]);
  var w = s6(function(S, E) {
    f(S, E), b([d], E);
  });
  return [p, w];
}
function __e(e, t) {
  var n = su({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
var O_e = ["show"];
function P_e(e, t) {
  return m.useMemo(function() {
    var n = {};
    t && (n.show = Wf(t) === "object" && t.formatter ? t.formatter : !!t), n = su(su({}, n), e);
    var r = n, i = r.show, o = ZV(r, O_e);
    return su(su({}, o), {}, {
      show: !!i,
      showFormatter: typeof i == "function" ? i : void 0,
      strategy: o.strategy || function(a) {
        return a.length;
      }
    });
  }, [e, t]);
}
var T_e = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], I_e = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.autoComplete, r = e.onChange, i = e.onFocus, o = e.onBlur, a = e.onPressEnter, s = e.onKeyDown, l = e.prefixCls, c = l === void 0 ? "rc-input" : l, f = e.disabled, d = e.htmlSize, p = e.className, g = e.maxLength, v = e.suffix, y = e.showCount, x = e.count, b = e.type, w = b === void 0 ? "text" : b, S = e.classes, E = e.classNames, O = e.styles, $ = e.onCompositionStart, P = e.onCompositionEnd, R = ZV(e, T_e), L = m.useState(!1), B = Op(L, 2), j = B[0], A = B[1], T = m.useRef(!1), k = m.useRef(null), F = function(fe) {
    k.current && h_e(k.current, fe);
  }, W = $_e(e.defaultValue, {
    value: e.value
  }), V = Op(W, 2), G = V[0], X = V[1], D = G == null ? "" : String(G), te = m.useState(null), ee = Op(te, 2), U = ee[0], he = ee[1], re = P_e(x, y), de = re.max || g, we = re.strategy(D), ue = !!de && we > de;
  m.useImperativeHandle(t, function() {
    return {
      focus: F,
      blur: function() {
        var fe;
        (fe = k.current) === null || fe === void 0 || fe.blur();
      },
      setSelectionRange: function(fe, be, Te) {
        var Le;
        (Le = k.current) === null || Le === void 0 || Le.setSelectionRange(fe, be, Te);
      },
      select: function() {
        var fe;
        (fe = k.current) === null || fe === void 0 || fe.select();
      },
      input: k.current
    };
  }), m.useEffect(function() {
    A(function(ie) {
      return ie && f ? !1 : ie;
    });
  }, [f]);
  var me = function(fe, be, Te) {
    var Le = be;
    if (!T.current && re.exceedFormatter && re.max && re.strategy(be) > re.max) {
      if (Le = re.exceedFormatter(be, {
        max: re.max
      }), be !== Le) {
        var ct, Z;
        he([((ct = k.current) === null || ct === void 0 ? void 0 : ct.selectionStart) || 0, ((Z = k.current) === null || Z === void 0 ? void 0 : Z.selectionEnd) || 0]);
      }
    } else if (Te.source === "compositionEnd")
      return;
    X(Le), k.current && a6(k.current, fe, r, Le);
  };
  m.useEffect(function() {
    if (U) {
      var ie;
      (ie = k.current) === null || ie === void 0 || ie.setSelectionRange.apply(ie, b_e(U));
    }
  }, [U]);
  var Se = function(fe) {
    me(fe, fe.target.value, {
      source: "change"
    });
  }, _e = function(fe) {
    T.current = !1, me(fe, fe.currentTarget.value, {
      source: "compositionEnd"
    }), P == null || P(fe);
  }, Ge = function(fe) {
    a && fe.key === "Enter" && a(fe), s == null || s(fe);
  }, Fe = function(fe) {
    A(!0), i == null || i(fe);
  }, Ae = function(fe) {
    A(!1), o == null || o(fe);
  }, Me = function(fe) {
    X(""), F(), k.current && a6(k.current, fe, r);
  }, et = ue && "".concat(c, "-out-of-range"), De = function() {
    var fe = __e(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames"
    ]);
    return /* @__PURE__ */ oe.createElement("input", Hg({
      autoComplete: n
    }, fe, {
      onChange: Se,
      onFocus: Fe,
      onBlur: Ae,
      onKeyDown: Ge,
      className: As(c, Is({}, "".concat(c, "-disabled"), f), E == null ? void 0 : E.input),
      style: O == null ? void 0 : O.input,
      ref: k,
      size: d,
      type: w,
      onCompositionStart: function(Te) {
        T.current = !0, $ == null || $(Te);
      },
      onCompositionEnd: _e
    }));
  }, je = function() {
    var fe = Number(de) > 0;
    if (v || re.show) {
      var be = re.showFormatter ? re.showFormatter({
        value: D,
        count: we,
        maxLength: de
      }) : "".concat(we).concat(fe ? " / ".concat(de) : "");
      return /* @__PURE__ */ oe.createElement(oe.Fragment, null, re.show && /* @__PURE__ */ oe.createElement("span", {
        className: As("".concat(c, "-show-count-suffix"), Is({}, "".concat(c, "-show-count-has-suffix"), !!v), E == null ? void 0 : E.count),
        style: su({}, O == null ? void 0 : O.count)
      }, be), v);
    }
    return null;
  };
  return /* @__PURE__ */ oe.createElement(m_e, Hg({}, R, {
    prefixCls: c,
    className: As(p, et),
    handleReset: Me,
    value: D,
    focused: j,
    triggerFocus: F,
    suffix: je(),
    disabled: f,
    classes: S,
    classNames: E,
    styles: O
  }), De());
});
const A_e = (e) => {
  let t;
  return typeof e == "object" && (e != null && e.clearIcon) ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ oe.createElement(I9, null)
  }), t;
}, eG = A_e;
function tG(e, t) {
  const n = m.useRef([]), r = () => {
    n.current.push(setTimeout(() => {
      var i, o, a, s;
      !((i = e.current) === null || i === void 0) && i.input && ((o = e.current) === null || o === void 0 ? void 0 : o.input.getAttribute("type")) === "password" && (!((a = e.current) === null || a === void 0) && a.input.hasAttribute("value")) && ((s = e.current) === null || s === void 0 || s.input.removeAttribute("value"));
    }));
  };
  return m.useEffect(() => (t && r(), () => n.current.forEach((i) => {
    i && clearTimeout(i);
  })), []), r;
}
function R_e(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
var M_e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function N_e(e, t) {
  if (!e)
    return;
  e.focus(t);
  const {
    cursor: n
  } = t || {};
  if (n) {
    const r = e.value.length;
    switch (n) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(r, r);
        break;
      default:
        e.setSelectionRange(0, r);
        break;
    }
  }
}
const k_e = /* @__PURE__ */ m.forwardRef((e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: i = !0,
    status: o,
    size: a,
    disabled: s,
    onBlur: l,
    onFocus: c,
    suffix: f,
    allowClear: d,
    addonAfter: p,
    addonBefore: g,
    className: v,
    style: y,
    styles: x,
    rootClassName: b,
    onChange: w,
    classNames: S,
    variant: E
  } = e, O = M_e(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]), {
    getPrefixCls: $,
    direction: P,
    input: R
  } = oe.useContext(Mt), L = $("input", r), B = m.useRef(null), j = xc(L), [A, T, k] = f2(L, j), {
    compactSize: F,
    compactItemClassnames: W
  } = QR(L, P), V = Rl((Fe) => {
    var Ae;
    return (Ae = a ?? F) !== null && Ae !== void 0 ? Ae : Fe;
  }), G = oe.useContext(sv), X = s ?? G, {
    status: D,
    hasFeedback: te,
    feedbackIcon: ee
  } = m.useContext(Uf), U = n7(D, o), he = R_e(e) || !!te;
  m.useRef(he);
  const re = tG(B, !0), de = (Fe) => {
    re(), l == null || l(Fe);
  }, we = (Fe) => {
    re(), c == null || c(Fe);
  }, ue = (Fe) => {
    re(), w == null || w(Fe);
  }, me = (te || f) && /* @__PURE__ */ oe.createElement(oe.Fragment, null, f, te && ee), Se = eG(d ?? (R == null ? void 0 : R.allowClear)), [_e, Ge] = r7(E, i);
  return A(/* @__PURE__ */ oe.createElement(I_e, Object.assign({
    ref: Sc(t, B),
    prefixCls: L,
    autoComplete: R == null ? void 0 : R.autoComplete
  }, O, {
    disabled: X,
    onBlur: de,
    onFocus: we,
    style: Object.assign(Object.assign({}, R == null ? void 0 : R.style), y),
    styles: Object.assign(Object.assign({}, R == null ? void 0 : R.styles), x),
    suffix: me,
    allowClear: Se,
    className: Ue(v, b, k, j, W, R == null ? void 0 : R.className),
    onChange: ue,
    addonAfter: p && /* @__PURE__ */ oe.createElement(A1, null, /* @__PURE__ */ oe.createElement(ST, {
      override: !0,
      status: !0
    }, p)),
    addonBefore: g && /* @__PURE__ */ oe.createElement(A1, null, /* @__PURE__ */ oe.createElement(ST, {
      override: !0,
      status: !0
    }, g)),
    classNames: Object.assign(Object.assign(Object.assign({}, S), R == null ? void 0 : R.classNames), {
      input: Ue({
        [`${L}-sm`]: V === "small",
        [`${L}-lg`]: V === "large",
        [`${L}-rtl`]: P === "rtl"
      }, S == null ? void 0 : S.input, (n = R == null ? void 0 : R.classNames) === null || n === void 0 ? void 0 : n.input, T),
      variant: Ue({
        [`${L}-${_e}`]: Ge
      }, _T(L, U)),
      affixWrapper: Ue({
        [`${L}-affix-wrapper-sm`]: V === "small",
        [`${L}-affix-wrapper-lg`]: V === "large",
        [`${L}-affix-wrapper-rtl`]: P === "rtl"
      }, T),
      wrapper: Ue({
        [`${L}-group-rtl`]: P === "rtl"
      }, T),
      groupWrapper: Ue({
        [`${L}-group-wrapper-sm`]: V === "small",
        [`${L}-group-wrapper-lg`]: V === "large",
        [`${L}-group-wrapper-rtl`]: P === "rtl",
        [`${L}-group-wrapper-${_e}`]: Ge
      }, _T(`${L}-group-wrapper`, U, te), T)
    })
  })));
}), I2 = k_e;
var L_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const D_e = L_e;
var j_e = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: D_e
  }));
}, F_e = /* @__PURE__ */ m.forwardRef(j_e);
const B_e = F_e;
var z_e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const U_e = z_e;
var H_e = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: U_e
  }));
}, W_e = /* @__PURE__ */ m.forwardRef(H_e);
const V_e = W_e;
var G_e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const K_e = (e) => e ? /* @__PURE__ */ m.createElement(V_e, null) : /* @__PURE__ */ m.createElement(B_e, null), q_e = {
  click: "onClick",
  hover: "onMouseOver"
}, Y_e = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    visibilityToggle: n = !0
  } = e, r = typeof n == "object" && n.visible !== void 0, [i, o] = m.useState(() => r ? n.visible : !1), a = m.useRef(null);
  m.useEffect(() => {
    r && o(n.visible);
  }, [r, n]);
  const s = tG(a), l = () => {
    const {
      disabled: O
    } = e;
    O || (i && s(), o(($) => {
      var P;
      const R = !$;
      return typeof n == "object" && ((P = n.onVisibleChange) === null || P === void 0 || P.call(n, R)), R;
    }));
  }, c = (O) => {
    const {
      action: $ = "click",
      iconRender: P = K_e
    } = e, R = q_e[$] || "", L = P(i), B = {
      [R]: l,
      className: `${O}-icon`,
      key: "passwordIcon",
      onMouseDown: (j) => {
        j.preventDefault();
      },
      onMouseUp: (j) => {
        j.preventDefault();
      }
    };
    return /* @__PURE__ */ m.cloneElement(/* @__PURE__ */ m.isValidElement(L) ? L : /* @__PURE__ */ m.createElement("span", null, L), B);
  }, {
    className: f,
    prefixCls: d,
    inputPrefixCls: p,
    size: g
  } = e, v = G_e(e, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: y
  } = m.useContext(Mt), x = y("input", p), b = y("input-password", d), w = n && c(b), S = Ue(b, f, {
    [`${b}-${g}`]: !!g
  }), E = Object.assign(Object.assign({}, os(v, ["suffix", "iconRender", "visibilityToggle"])), {
    type: i ? "text" : "password",
    className: S,
    prefixCls: x,
    suffix: w
  });
  return g && (E.size = g), /* @__PURE__ */ m.createElement(I2, Object.assign({
    ref: Sc(t, a)
  }, E));
}), X_e = Y_e;
var Q_e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const J_e = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    prefixCls: n,
    inputPrefixCls: r,
    className: i,
    size: o,
    suffix: a,
    enterButton: s = !1,
    addonAfter: l,
    loading: c,
    disabled: f,
    onSearch: d,
    onChange: p,
    onCompositionStart: g,
    onCompositionEnd: v
  } = e, y = Q_e(e, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: x,
    direction: b
  } = m.useContext(Mt), w = m.useRef(!1), S = x("input-search", n), E = x("input", r), {
    compactSize: O
  } = QR(S, b), $ = Rl((D) => {
    var te;
    return (te = o ?? O) !== null && te !== void 0 ? te : D;
  }), P = m.useRef(null), R = (D) => {
    D && D.target && D.type === "click" && d && d(D.target.value, D, {
      source: "clear"
    }), p && p(D);
  }, L = (D) => {
    var te;
    document.activeElement === ((te = P.current) === null || te === void 0 ? void 0 : te.input) && D.preventDefault();
  }, B = (D) => {
    var te, ee;
    d && d((ee = (te = P.current) === null || te === void 0 ? void 0 : te.input) === null || ee === void 0 ? void 0 : ee.value, D, {
      source: "input"
    });
  }, j = (D) => {
    w.current || c || B(D);
  }, A = typeof s == "boolean" ? /* @__PURE__ */ m.createElement(ybe, null) : null, T = `${S}-button`;
  let k;
  const F = s || {}, W = F.type && F.type.__ANT_BUTTON === !0;
  W || F.type === "button" ? k = Oa(F, Object.assign({
    onMouseDown: L,
    onClick: (D) => {
      var te, ee;
      (ee = (te = F == null ? void 0 : F.props) === null || te === void 0 ? void 0 : te.onClick) === null || ee === void 0 || ee.call(te, D), B(D);
    },
    key: "enterButton"
  }, W ? {
    className: T,
    size: $
  } : {})) : k = /* @__PURE__ */ m.createElement(zi, {
    className: T,
    type: s ? "primary" : void 0,
    size: $,
    disabled: f,
    key: "enterButton",
    onMouseDown: L,
    onClick: B,
    loading: c,
    icon: A
  }, s), l && (k = [k, Oa(l, {
    key: "addonAfter"
  })]);
  const V = Ue(S, {
    [`${S}-rtl`]: b === "rtl",
    [`${S}-${$}`]: !!$,
    [`${S}-with-button`]: !!s
  }, i), G = (D) => {
    w.current = !0, g == null || g(D);
  }, X = (D) => {
    w.current = !1, v == null || v(D);
  };
  return /* @__PURE__ */ m.createElement(I2, Object.assign({
    ref: Sc(P, t),
    onPressEnter: j
  }, y, {
    size: $,
    onCompositionStart: G,
    onCompositionEnd: X,
    prefixCls: E,
    addonAfter: k,
    suffix: a,
    onChange: R,
    className: V,
    disabled: f
  }));
}), Z_e = J_e;
var eOe = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, tOe = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], n_ = {}, Wa;
function nOe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && n_[n])
    return n_[n];
  var r = window.getComputedStyle(e), i = r.getPropertyValue("box-sizing") || r.getPropertyValue("-moz-box-sizing") || r.getPropertyValue("-webkit-box-sizing"), o = parseFloat(r.getPropertyValue("padding-bottom")) + parseFloat(r.getPropertyValue("padding-top")), a = parseFloat(r.getPropertyValue("border-bottom-width")) + parseFloat(r.getPropertyValue("border-top-width")), s = tOe.map(function(c) {
    return "".concat(c, ":").concat(r.getPropertyValue(c));
  }).join(";"), l = {
    sizingStyle: s,
    paddingSize: o,
    borderSize: a,
    boxSizing: i
  };
  return t && n && (n_[n] = l), l;
}
function rOe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  Wa || (Wa = document.createElement("textarea"), Wa.setAttribute("tab-index", "-1"), Wa.setAttribute("aria-hidden", "true"), document.body.appendChild(Wa)), e.getAttribute("wrap") ? Wa.setAttribute("wrap", e.getAttribute("wrap")) : Wa.removeAttribute("wrap");
  var i = nOe(e, t), o = i.paddingSize, a = i.borderSize, s = i.boxSizing, l = i.sizingStyle;
  Wa.setAttribute("style", "".concat(l, ";").concat(eOe)), Wa.value = e.value || e.placeholder || "";
  var c = void 0, f = void 0, d, p = Wa.scrollHeight;
  if (s === "border-box" ? p += a : s === "content-box" && (p -= o), n !== null || r !== null) {
    Wa.value = " ";
    var g = Wa.scrollHeight - o;
    n !== null && (c = g * n, s === "border-box" && (c = c + o + a), p = Math.max(c, p)), r !== null && (f = g * r, s === "border-box" && (f = f + o + a), d = p > f ? "" : "hidden", p = Math.min(f, p));
  }
  var v = {
    height: p,
    overflowY: d,
    resize: "none"
  };
  return c && (v.minHeight = c), f && (v.maxHeight = f), v;
}
var iOe = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], r_ = 0, i_ = 1, o_ = 2, oOe = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e, r = n.prefixCls;
  n.onPressEnter;
  var i = n.defaultValue, o = n.value, a = n.autoSize, s = n.onResize, l = n.className, c = n.style, f = n.disabled, d = n.onChange;
  n.onInternalAutoSize;
  var p = _n(n, iOe), g = c2(i, {
    value: o,
    postState: function(he) {
      return he ?? "";
    }
  }), v = ke(g, 2), y = v[0], x = v[1], b = function(he) {
    x(he.target.value), d == null || d(he);
  }, w = m.useRef();
  m.useImperativeHandle(t, function() {
    return {
      textArea: w.current
    };
  });
  var S = m.useMemo(function() {
    return a && nn(a) === "object" ? [a.minRows, a.maxRows] : [];
  }, [a]), E = ke(S, 2), O = E[0], $ = E[1], P = !!a, R = function() {
    try {
      if (document.activeElement === w.current) {
        var he = w.current, re = he.selectionStart, de = he.selectionEnd, we = he.scrollTop;
        w.current.setSelectionRange(re, de), w.current.scrollTop = we;
      }
    } catch {
    }
  }, L = m.useState(o_), B = ke(L, 2), j = B[0], A = B[1], T = m.useState(), k = ke(T, 2), F = k[0], W = k[1], V = function() {
    A(r_);
  };
  Pu(function() {
    P && V();
  }, [o, O, $, P]), Pu(function() {
    if (j === r_)
      A(i_);
    else if (j === i_) {
      var U = rOe(w.current, !1, O, $);
      A(o_), W(U);
    } else
      R();
  }, [j]);
  var G = m.useRef(), X = function() {
    qp.cancel(G.current);
  }, D = function(he) {
    j === o_ && (s == null || s(he), a && (X(), G.current = qp(function() {
      V();
    })));
  };
  m.useEffect(function() {
    return X;
  }, []);
  var te = P ? F : null, ee = ye(ye({}, c), te);
  return (j === r_ || j === i_) && (ee.overflowY = "hidden", ee.overflowX = "hidden"), /* @__PURE__ */ m.createElement(Ws, {
    onResize: D,
    disabled: !(a || s)
  }, /* @__PURE__ */ m.createElement("textarea", jt({}, p, {
    ref: w,
    style: ee,
    className: ft(r, l, ce({}, "".concat(r, "-disabled"), f)),
    disabled: f,
    value: y,
    onChange: b
  })));
}), aOe = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize"], sOe = /* @__PURE__ */ oe.forwardRef(function(e, t) {
  var n, r, i = e.defaultValue, o = e.value, a = e.onFocus, s = e.onBlur, l = e.onChange, c = e.allowClear, f = e.maxLength, d = e.onCompositionStart, p = e.onCompositionEnd, g = e.suffix, v = e.prefixCls, y = v === void 0 ? "rc-textarea" : v, x = e.showCount, b = e.count, w = e.className, S = e.style, E = e.disabled, O = e.hidden, $ = e.classNames, P = e.styles, R = e.onResize, L = _n(e, aOe), B = c2(i, {
    value: o,
    defaultValue: i
  }), j = ke(B, 2), A = j[0], T = j[1], k = A == null ? "" : String(A), F = oe.useState(!1), W = ke(F, 2), V = W[0], G = W[1], X = oe.useRef(!1), D = oe.useState(null), te = ke(D, 2), ee = te[0], U = te[1], he = m.useRef(null), re = function() {
    var Ee;
    return (Ee = he.current) === null || Ee === void 0 ? void 0 : Ee.textArea;
  }, de = function() {
    re().focus();
  };
  m.useImperativeHandle(t, function() {
    return {
      resizableTextArea: he.current,
      focus: de,
      blur: function() {
        re().blur();
      }
    };
  }), m.useEffect(function() {
    G(function(Pe) {
      return !E && Pe;
    });
  }, [E]);
  var we = oe.useState(null), ue = ke(we, 2), me = ue[0], Se = ue[1];
  oe.useEffect(function() {
    if (me) {
      var Pe;
      (Pe = re()).setSelectionRange.apply(Pe, Rt(me));
    }
  }, [me]);
  var _e = a_e(b, x), Ge = (n = _e.max) !== null && n !== void 0 ? n : f, Fe = Number(Ge) > 0, Ae = _e.strategy(k), Me = !!Ge && Ae > Ge, et = function(Ee, We) {
    var ze = We;
    !X.current && _e.exceedFormatter && _e.max && _e.strategy(We) > _e.max && (ze = _e.exceedFormatter(We, {
      max: _e.max
    }), We !== ze && Se([re().selectionStart || 0, re().selectionEnd || 0])), T(ze), r6(Ee.currentTarget, Ee, l, ze);
  }, De = function(Ee) {
    X.current = !0, d == null || d(Ee);
  }, je = function(Ee) {
    X.current = !1, et(Ee, Ee.currentTarget.value), p == null || p(Ee);
  }, ie = function(Ee) {
    et(Ee, Ee.target.value);
  }, fe = function(Ee) {
    var We = L.onPressEnter, ze = L.onKeyDown;
    Ee.key === "Enter" && We && We(Ee), ze == null || ze(Ee);
  }, be = function(Ee) {
    G(!0), a == null || a(Ee);
  }, Te = function(Ee) {
    G(!1), s == null || s(Ee);
  }, Le = function(Ee) {
    T(""), de(), r6(re(), Ee, l);
  }, ct = g, Z;
  _e.show && (_e.showFormatter ? Z = _e.showFormatter({
    value: k,
    count: Ae,
    maxLength: Ge
  }) : Z = "".concat(Ae).concat(Fe ? " / ".concat(Ge) : ""), ct = /* @__PURE__ */ oe.createElement(oe.Fragment, null, ct, /* @__PURE__ */ oe.createElement("span", {
    className: ft("".concat(y, "-data-count"), $ == null ? void 0 : $.count),
    style: P == null ? void 0 : P.count
  }, Z)));
  var se = function(Ee) {
    var We;
    R == null || R(Ee), (We = re()) !== null && We !== void 0 && We.style.height && U(!0);
  }, Ce = !L.autoSize && !x && !c;
  return /* @__PURE__ */ oe.createElement(i_e, {
    value: k,
    allowClear: c,
    handleReset: Le,
    suffix: ct,
    prefixCls: y,
    classNames: ye(ye({}, $), {}, {
      affixWrapper: ft($ == null ? void 0 : $.affixWrapper, (r = {}, ce(r, "".concat(y, "-show-count"), x), ce(r, "".concat(y, "-textarea-allow-clear"), c), r))
    }),
    disabled: E,
    focused: V,
    className: ft(w, Me && "".concat(y, "-out-of-range")),
    style: ye(ye({}, S), ee && !Ce ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof Z == "string" ? Z : void 0
      }
    },
    hidden: O
  }, /* @__PURE__ */ oe.createElement(oOe, jt({}, L, {
    maxLength: f,
    onKeyDown: fe,
    onChange: ie,
    onFocus: be,
    onBlur: Te,
    onCompositionStart: De,
    onCompositionEnd: je,
    className: ft($ == null ? void 0 : $.textarea),
    style: ye(ye({}, P == null ? void 0 : P.textarea), {}, {
      resize: S == null ? void 0 : S.resize
    }),
    disabled: E,
    prefixCls: y,
    onResize: se,
    ref: he
  })));
}), lOe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const cOe = /* @__PURE__ */ m.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    bordered: o = !0,
    size: a,
    disabled: s,
    status: l,
    allowClear: c,
    classNames: f,
    rootClassName: d,
    className: p,
    style: g,
    styles: v,
    variant: y
  } = e, x = lOe(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]), {
    getPrefixCls: b,
    direction: w,
    textArea: S
  } = m.useContext(Mt), E = Rl(a), O = m.useContext(sv), $ = s ?? O, {
    status: P,
    hasFeedback: R,
    feedbackIcon: L
  } = m.useContext(Uf), B = n7(P, l), j = m.useRef(null);
  m.useImperativeHandle(t, () => {
    var D;
    return {
      resizableTextArea: (D = j.current) === null || D === void 0 ? void 0 : D.resizableTextArea,
      focus: (te) => {
        var ee, U;
        N_e((U = (ee = j.current) === null || ee === void 0 ? void 0 : ee.resizableTextArea) === null || U === void 0 ? void 0 : U.textArea, te);
      },
      blur: () => {
        var te;
        return (te = j.current) === null || te === void 0 ? void 0 : te.blur();
      }
    };
  });
  const A = b("input", i), T = xc(A), [k, F, W] = f2(A, T), [V, G] = r7(y, o), X = eG(c ?? (S == null ? void 0 : S.allowClear));
  return k(/* @__PURE__ */ m.createElement(sOe, Object.assign({
    autoComplete: S == null ? void 0 : S.autoComplete
  }, x, {
    style: Object.assign(Object.assign({}, S == null ? void 0 : S.style), g),
    styles: Object.assign(Object.assign({}, S == null ? void 0 : S.styles), v),
    disabled: $,
    allowClear: X,
    className: Ue(W, T, p, d, S == null ? void 0 : S.className),
    classNames: Object.assign(Object.assign(Object.assign({}, f), S == null ? void 0 : S.classNames), {
      textarea: Ue({
        [`${A}-sm`]: E === "small",
        [`${A}-lg`]: E === "large"
      }, F, f == null ? void 0 : f.textarea, (n = S == null ? void 0 : S.classNames) === null || n === void 0 ? void 0 : n.textarea),
      variant: Ue({
        [`${A}-${V}`]: G
      }, _T(A, B)),
      affixWrapper: Ue(`${A}-textarea-affix-wrapper`, {
        [`${A}-affix-wrapper-rtl`]: w === "rtl",
        [`${A}-affix-wrapper-sm`]: E === "small",
        [`${A}-affix-wrapper-lg`]: E === "large",
        [`${A}-textarea-show-count`]: e.showCount || ((r = e.count) === null || r === void 0 ? void 0 : r.show)
      }, F)
    }),
    prefixCls: A,
    suffix: R && /* @__PURE__ */ m.createElement("span", {
      className: `${A}-textarea-suffix`
    }, L),
    ref: j
  })));
}), nG = cOe, xv = I2;
xv.Group = l_e;
xv.Search = Z_e;
xv.TextArea = nG;
xv.Password = X_e;
const rG = xv;
function U1(e) {
  return ["small", "middle", "large"].includes(e);
}
function f6(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const iG = /* @__PURE__ */ oe.createContext({
  latestIndex: 0
}), uOe = iG.Provider, fOe = (e) => {
  let {
    className: t,
    index: n,
    children: r,
    split: i,
    style: o
  } = e;
  const {
    latestIndex: a
  } = m.useContext(iG);
  return r == null ? null : /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("div", {
    className: t,
    style: o
  }, r), n < a && i && /* @__PURE__ */ m.createElement("span", {
    className: `${t}-split`
  }, i));
}, dOe = fOe;
var pOe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const hOe = /* @__PURE__ */ m.forwardRef((e, t) => {
  var n, r;
  const {
    getPrefixCls: i,
    space: o,
    direction: a
  } = m.useContext(Mt), {
    size: s = (o == null ? void 0 : o.size) || "small",
    align: l,
    className: c,
    rootClassName: f,
    children: d,
    direction: p = "horizontal",
    prefixCls: g,
    split: v,
    style: y,
    wrap: x = !1,
    classNames: b,
    styles: w
  } = e, S = pOe(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [E, O] = Array.isArray(s) ? s : [s, s], $ = U1(O), P = U1(E), R = f6(O), L = f6(E), B = vc(d, {
    keepEmpty: !0
  }), j = l === void 0 && p === "horizontal" ? "center" : l, A = i("space", g), [T, k, F] = X9(A), W = Ue(A, o == null ? void 0 : o.className, k, `${A}-${p}`, {
    [`${A}-rtl`]: a === "rtl",
    [`${A}-align-${j}`]: j,
    [`${A}-gap-row-${O}`]: $,
    [`${A}-gap-col-${E}`]: P
  }, c, f, F), V = Ue(`${A}-item`, (n = b == null ? void 0 : b.item) !== null && n !== void 0 ? n : (r = o == null ? void 0 : o.classNames) === null || r === void 0 ? void 0 : r.item);
  let G = 0;
  const X = B.map((ee, U) => {
    var he, re;
    ee != null && (G = U);
    const de = ee && ee.key || `${V}-${U}`;
    return /* @__PURE__ */ m.createElement(dOe, {
      className: V,
      key: de,
      index: U,
      split: v,
      style: (he = w == null ? void 0 : w.item) !== null && he !== void 0 ? he : (re = o == null ? void 0 : o.styles) === null || re === void 0 ? void 0 : re.item
    }, ee);
  }), D = m.useMemo(() => ({
    latestIndex: G
  }), [G]);
  if (B.length === 0)
    return null;
  const te = {};
  return x && (te.flexWrap = "wrap"), !P && L && (te.columnGap = E), !$ && R && (te.rowGap = O), T(/* @__PURE__ */ m.createElement("div", Object.assign({
    ref: t,
    className: W,
    style: Object.assign(Object.assign(Object.assign({}, te), o == null ? void 0 : o.style), y)
  }, S), /* @__PURE__ */ m.createElement(uOe, {
    value: D
  }, X)));
}), oG = hOe;
oG.Compact = fge;
const mOe = oG, aG = ["wrap", "nowrap", "wrap-reverse"], sG = ["flex-start", "flex-end", "start", "end", "center", "space-between", "space-around", "space-evenly", "stretch", "normal", "left", "right"], lG = ["center", "start", "end", "flex-start", "flex-end", "self-start", "self-end", "baseline", "normal", "stretch"], gOe = (e, t) => {
  const n = {};
  return aG.forEach((r) => {
    n[`${e}-wrap-${r}`] = t.wrap === r;
  }), n;
}, vOe = (e, t) => {
  const n = {};
  return lG.forEach((r) => {
    n[`${e}-align-${r}`] = t.align === r;
  }), n[`${e}-align-stretch`] = !t.align && !!t.vertical, n;
}, yOe = (e, t) => {
  const n = {};
  return sG.forEach((r) => {
    n[`${e}-justify-${r}`] = t.justify === r;
  }), n;
};
function bOe(e, t) {
  return Ue(Object.assign(Object.assign(Object.assign({}, gOe(e, t)), vOe(e, t)), yOe(e, t)));
}
const wOe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "flex",
      "&-vertical": {
        flexDirection: "column"
      },
      "&-rtl": {
        direction: "rtl"
      },
      "&:empty": {
        display: "none"
      }
    }
  };
}, SOe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-small": {
        gap: e.flexGapSM
      },
      "&-gap-middle": {
        gap: e.flexGap
      },
      "&-gap-large": {
        gap: e.flexGapLG
      }
    }
  };
}, xOe = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return aG.forEach((r) => {
    n[`${t}-wrap-${r}`] = {
      flexWrap: r
    };
  }), n;
}, COe = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return lG.forEach((r) => {
    n[`${t}-align-${r}`] = {
      alignItems: r
    };
  }), n;
}, EOe = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return sG.forEach((r) => {
    n[`${t}-justify-${r}`] = {
      justifyContent: r
    };
  }), n;
}, $Oe = () => ({}), _Oe = Pi("Flex", (e) => {
  const {
    paddingXS: t,
    padding: n,
    paddingLG: r
  } = e, i = _r(e, {
    flexGapSM: t,
    flexGap: n,
    flexGapLG: r
  });
  return [wOe(i), SOe(i), xOe(i), COe(i), EOe(i)];
}, $Oe, {
  // Flex component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/46403
  resetStyle: !1
});
var OOe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const POe = /* @__PURE__ */ oe.forwardRef((e, t) => {
  const {
    prefixCls: n,
    rootClassName: r,
    className: i,
    style: o,
    flex: a,
    gap: s,
    children: l,
    vertical: c = !1,
    component: f = "div"
  } = e, d = OOe(e, ["prefixCls", "rootClassName", "className", "style", "flex", "gap", "children", "vertical", "component"]), {
    flex: p,
    direction: g,
    getPrefixCls: v
  } = oe.useContext(Mt), y = v("flex", n), [x, b, w] = _Oe(y), S = c ?? (p == null ? void 0 : p.vertical), E = Ue(i, r, p == null ? void 0 : p.className, y, b, w, bOe(y, e), {
    [`${y}-rtl`]: g === "rtl",
    [`${y}-gap-${s}`]: U1(s),
    [`${y}-vertical`]: S
  }), O = Object.assign(Object.assign({}, p == null ? void 0 : p.style), o);
  return a && (O.flex = a), s && !U1(s) && (O.gap = s), x(/* @__PURE__ */ oe.createElement(f, Object.assign({
    ref: t,
    className: E,
    style: O
  }, os(d, ["justify", "wrap", "align"])), l));
}), TOe = POe;
var IOe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
const AOe = IOe, ROe = new Tn("antSpinMove", {
  to: {
    opacity: 1
  }
}), MOe = new Tn("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), NOe = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({}, Vi(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "static",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: n(n(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [`${t}-dot ${t}-dot-item`]: {
          backgroundColor: e.colorWhite
        },
        [`${t}-text`]: {
          color: e.colorTextLightSolid
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: n(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: n(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          height: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          backgroundColor: e.colorPrimary,
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: ROe,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: MOe,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        fontSize: e.dotSizeSM,
        i: {
          width: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal(),
          height: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        fontSize: e.dotSizeLG,
        i: {
          width: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, kOe = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: n
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: n
  };
}, LOe = Pi("Spin", (e) => {
  const t = _r(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [NOe(t)];
}, kOe);
var DOe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
let wb = null;
function jOe(e, t) {
  const {
    indicator: n
  } = t, r = `${e}-dot`;
  return n === null ? null : /* @__PURE__ */ m.isValidElement(n) ? Oa(n, {
    className: Ue(n.props.className, r)
  }) : /* @__PURE__ */ m.isValidElement(wb) ? Oa(wb, {
    className: Ue(wb.props.className, r)
  }) : /* @__PURE__ */ m.createElement("span", {
    className: Ue(r, `${e}-dot-spin`)
  }, /* @__PURE__ */ m.createElement("i", {
    className: `${e}-dot-item`,
    key: 1
  }), /* @__PURE__ */ m.createElement("i", {
    className: `${e}-dot-item`,
    key: 2
  }), /* @__PURE__ */ m.createElement("i", {
    className: `${e}-dot-item`,
    key: 3
  }), /* @__PURE__ */ m.createElement("i", {
    className: `${e}-dot-item`,
    key: 4
  }));
}
function FOe(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const cG = (e) => {
  const {
    prefixCls: t,
    spinning: n = !0,
    delay: r = 0,
    className: i,
    rootClassName: o,
    size: a = "default",
    tip: s,
    wrapperClassName: l,
    style: c,
    children: f,
    fullscreen: d = !1
  } = e, p = DOe(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen"]), {
    getPrefixCls: g
  } = m.useContext(Mt), v = g("spin", t), [y, x, b] = LOe(v), [w, S] = m.useState(() => n && !FOe(n, r));
  m.useEffect(() => {
    if (n) {
      const A = zEe(r, () => {
        S(!0);
      });
      return A(), () => {
        var T;
        (T = A == null ? void 0 : A.cancel) === null || T === void 0 || T.call(A);
      };
    }
    S(!1);
  }, [r, n]);
  const E = m.useMemo(() => typeof f < "u" && !d, [f, d]), {
    direction: O,
    spin: $
  } = m.useContext(Mt), P = Ue(v, $ == null ? void 0 : $.className, {
    [`${v}-sm`]: a === "small",
    [`${v}-lg`]: a === "large",
    [`${v}-spinning`]: w,
    [`${v}-show-text`]: !!s,
    [`${v}-fullscreen`]: d,
    [`${v}-fullscreen-show`]: d && w,
    [`${v}-rtl`]: O === "rtl"
  }, i, o, x, b), R = Ue(`${v}-container`, {
    [`${v}-blur`]: w
  }), L = os(p, ["indicator"]), B = Object.assign(Object.assign({}, $ == null ? void 0 : $.style), c), j = /* @__PURE__ */ m.createElement("div", Object.assign({}, L, {
    style: B,
    className: P,
    "aria-live": "polite",
    "aria-busy": w
  }), jOe(v, e), s && (E || d) ? /* @__PURE__ */ m.createElement("div", {
    className: `${v}-text`
  }, s) : null);
  return y(E ? /* @__PURE__ */ m.createElement("div", Object.assign({}, L, {
    className: Ue(`${v}-nested-loading`, l, x, b)
  }), w && /* @__PURE__ */ m.createElement("div", {
    key: "loading"
  }, j), /* @__PURE__ */ m.createElement("div", {
    className: R,
    key: "container"
  }, f)) : j);
};
cG.setDefaultIndicator = (e) => {
  wb = e;
};
const BOe = cG;
var zOe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const UOe = (e) => {
  const {
    prefixCls: t,
    className: n,
    closeIcon: r,
    closable: i,
    type: o,
    title: a,
    children: s,
    footer: l
  } = e, c = zOe(e, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]), {
    getPrefixCls: f
  } = m.useContext(Mt), d = f(), p = t || f("modal"), g = xc(d), [v, y, x] = zW(p, g), b = `${p}-confirm`;
  let w = {};
  return o ? w = {
    closable: i ?? !1,
    title: "",
    footer: "",
    children: /* @__PURE__ */ m.createElement(HW, Object.assign({}, e, {
      prefixCls: p,
      confirmPrefixCls: b,
      rootPrefixCls: d,
      content: s
    }))
  } : w = {
    closable: i ?? !0,
    title: a,
    footer: l !== null && /* @__PURE__ */ m.createElement(jW, Object.assign({}, e)),
    children: s
  }, v(/* @__PURE__ */ m.createElement(EW, Object.assign({
    prefixCls: p,
    className: Ue(y, `${p}-pure-panel`, o && b, o && `${b}-${o}`, n, x, g)
  }, c, {
    closeIcon: DW(p, r),
    closable: i
  }, w)));
}, HOe = F0e(UOe);
function uG(e) {
  return vv(KW(e));
}
const el = UW;
el.useModal = j0e;
el.info = function(t) {
  return vv(qW(t));
};
el.success = function(t) {
  return vv(YW(t));
};
el.error = function(t) {
  return vv(XW(t));
};
el.warning = uG;
el.warn = uG;
el.confirm = function(t) {
  return vv(QW(t));
};
el.destroyAll = function() {
  for (; xf.length; ) {
    const t = xf.pop();
    t && t();
  }
};
el.config = M0e;
el._InternalPanelDoNotUseOrYouWillBeFired = HOe;
const WOe = el;
var Ct = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Ct.F1 && n <= Ct.F12)
      return !1;
    switch (n) {
      case Ct.ALT:
      case Ct.CAPS_LOCK:
      case Ct.CONTEXT_MENU:
      case Ct.CTRL:
      case Ct.DOWN:
      case Ct.END:
      case Ct.ESC:
      case Ct.HOME:
      case Ct.INSERT:
      case Ct.LEFT:
      case Ct.MAC_FF_META:
      case Ct.META:
      case Ct.NUMLOCK:
      case Ct.NUM_CENTER:
      case Ct.PAGE_DOWN:
      case Ct.PAGE_UP:
      case Ct.PAUSE:
      case Ct.PRINT_SCREEN:
      case Ct.RIGHT:
      case Ct.SHIFT:
      case Ct.UP:
      case Ct.WIN_KEY:
      case Ct.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Ct.ZERO && t <= Ct.NINE || t >= Ct.NUM_ZERO && t <= Ct.NUM_MULTIPLY || t >= Ct.A && t <= Ct.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Ct.SPACE:
      case Ct.QUESTION_MARK:
      case Ct.NUM_PLUS:
      case Ct.NUM_MINUS:
      case Ct.NUM_PERIOD:
      case Ct.NUM_DIVISION:
      case Ct.SEMICOLON:
      case Ct.DASH:
      case Ct.EQUALS:
      case Ct.COMMA:
      case Ct.PERIOD:
      case Ct.SLASH:
      case Ct.APOSTROPHE:
      case Ct.SINGLE_QUOTE:
      case Ct.OPEN_SQUARE_BRACKET:
      case Ct.BACKSLASH:
      case Ct.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
};
const VOe = (e) => {
  const {
    paddingXXS: t,
    lineWidth: n,
    tagPaddingHorizontal: r,
    componentCls: i,
    calc: o
  } = e, a = o(r).sub(n).equal(), s = o(t).sub(n).equal();
  return {
    // Result
    [i]: Object.assign(Object.assign({}, Vi(e)), {
      display: "inline-block",
      height: "auto",
      // https://github.com/ant-design/ant-design/pull/47504
      marginInlineEnd: e.marginXS,
      paddingInline: a,
      fontSize: e.tagFontSize,
      lineHeight: e.tagLineHeight,
      whiteSpace: "nowrap",
      background: e.defaultBg,
      border: `${ge(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
      borderRadius: e.borderRadiusSM,
      opacity: 1,
      transition: `all ${e.motionDurationMid}`,
      textAlign: "start",
      position: "relative",
      // RTL
      [`&${i}-rtl`]: {
        direction: "rtl"
      },
      "&, a, a:hover": {
        color: e.defaultColor
      },
      [`${i}-close-icon`]: {
        marginInlineStart: s,
        fontSize: e.tagIconSize,
        color: e.colorTextDescription,
        cursor: "pointer",
        transition: `all ${e.motionDurationMid}`,
        "&:hover": {
          color: e.colorTextHeading
        }
      },
      [`&${i}-has-color`]: {
        borderColor: "transparent",
        [`&, a, a:hover, ${e.iconCls}-close, ${e.iconCls}-close:hover`]: {
          color: e.colorTextLightSolid
        }
      },
      "&-checkable": {
        backgroundColor: "transparent",
        borderColor: "transparent",
        cursor: "pointer",
        [`&:not(${i}-checkable-checked):hover`]: {
          color: e.colorPrimary,
          backgroundColor: e.colorFillSecondary
        },
        "&:active, &-checked": {
          color: e.colorTextLightSolid
        },
        "&-checked": {
          backgroundColor: e.colorPrimary,
          "&:hover": {
            backgroundColor: e.colorPrimaryHover
          }
        },
        "&:active": {
          backgroundColor: e.colorPrimaryActive
        }
      },
      "&-hidden": {
        display: "none"
      },
      // To ensure that a space will be placed between character and `Icon`.
      [`> ${e.iconCls} + span, > span + ${e.iconCls}`]: {
        marginInlineStart: a
      }
    }),
    [`${i}-borderless`]: {
      borderColor: "transparent",
      background: e.tagBorderlessBg
    }
  };
}, A2 = (e) => {
  const {
    lineWidth: t,
    fontSizeIcon: n,
    calc: r
  } = e, i = e.fontSizeSM;
  return _r(e, {
    tagFontSize: i,
    tagLineHeight: ge(r(e.lineHeightSM).mul(i).equal()),
    tagIconSize: r(n).sub(r(t).mul(2)).equal(),
    // Tag icon is much smaller
    tagPaddingHorizontal: 8,
    // Fixed padding.
    tagBorderlessBg: e.defaultBg
  });
}, R2 = (e) => ({
  defaultBg: new Go(e.colorFillQuaternary).onBackground(e.colorBgContainer).toHexString(),
  defaultColor: e.colorText
}), fG = Pi("Tag", (e) => {
  const t = A2(e);
  return VOe(t);
}, R2);
var GOe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const KOe = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    prefixCls: n,
    style: r,
    className: i,
    checked: o,
    onChange: a,
    onClick: s
  } = e, l = GOe(e, ["prefixCls", "style", "className", "checked", "onChange", "onClick"]), {
    getPrefixCls: c,
    tag: f
  } = m.useContext(Mt), d = (b) => {
    a == null || a(!o), s == null || s(b);
  }, p = c("tag", n), [g, v, y] = fG(p), x = Ue(p, `${p}-checkable`, {
    [`${p}-checkable-checked`]: o
  }, f == null ? void 0 : f.className, i, v, y);
  return g(/* @__PURE__ */ m.createElement("span", Object.assign({}, l, {
    ref: t,
    style: Object.assign(Object.assign({}, r), f == null ? void 0 : f.style),
    className: x,
    onClick: d
  })));
}), qOe = KOe, YOe = (e) => eS(e, (t, n) => {
  let {
    textColor: r,
    lightBorderColor: i,
    lightColor: o,
    darkColor: a
  } = n;
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: r,
      background: o,
      borderColor: i,
      // Inverse color
      "&-inverse": {
        color: e.colorTextLightSolid,
        background: a,
        borderColor: a
      },
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}), XOe = Zw(["Tag", "preset"], (e) => {
  const t = A2(e);
  return YOe(t);
}, R2);
function QOe(e) {
  return typeof e != "string" ? e : e.charAt(0).toUpperCase() + e.slice(1);
}
const P0 = (e, t, n) => {
  const r = QOe(n);
  return {
    [`${e.componentCls}${e.componentCls}-${t}`]: {
      color: e[`color${n}`],
      background: e[`color${r}Bg`],
      borderColor: e[`color${r}Border`],
      [`&${e.componentCls}-borderless`]: {
        borderColor: "transparent"
      }
    }
  };
}, JOe = Zw(["Tag", "status"], (e) => {
  const t = A2(e);
  return [P0(t, "success", "Success"), P0(t, "processing", "Info"), P0(t, "error", "Error"), P0(t, "warning", "Warning")];
}, R2);
var ZOe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const ePe = (e, t) => {
  const {
    prefixCls: n,
    className: r,
    rootClassName: i,
    style: o,
    children: a,
    icon: s,
    color: l,
    onClose: c,
    closeIcon: f,
    closable: d,
    bordered: p = !0
  } = e, g = ZOe(e, ["prefixCls", "className", "rootClassName", "style", "children", "icon", "color", "onClose", "closeIcon", "closable", "bordered"]), {
    getPrefixCls: v,
    direction: y,
    tag: x
  } = m.useContext(Mt), [b, w] = m.useState(!0);
  m.useEffect(() => {
    "visible" in g && w(g.visible);
  }, [g.visible]);
  const S = FS(l), E = O1e(l), O = S || E, $ = Object.assign(Object.assign({
    backgroundColor: l && !O ? l : void 0
  }, x == null ? void 0 : x.style), o), P = v("tag", n), [R, L, B] = fG(P), j = Ue(P, x == null ? void 0 : x.className, {
    [`${P}-${l}`]: O,
    [`${P}-has-color`]: l && !O,
    [`${P}-hidden`]: !b,
    [`${P}-rtl`]: y === "rtl",
    [`${P}-borderless`]: !p
  }, r, i, L, B), A = (G) => {
    G.stopPropagation(), c == null || c(G), !G.defaultPrevented && w(!1);
  }, [, T] = OW({
    closable: d,
    closeIcon: f ?? (x == null ? void 0 : x.closeIcon),
    customCloseIconRender: (G) => G === null ? /* @__PURE__ */ m.createElement(lv, {
      className: `${P}-close-icon`,
      onClick: A
    }) : /* @__PURE__ */ m.createElement("span", {
      className: `${P}-close-icon`,
      onClick: A
    }, G),
    defaultCloseIcon: null,
    defaultClosable: !1
  }), k = typeof g.onClick == "function" || a && a.type === "a", F = s || null, W = F ? /* @__PURE__ */ m.createElement(m.Fragment, null, F, a && /* @__PURE__ */ m.createElement("span", null, a)) : a, V = /* @__PURE__ */ m.createElement("span", Object.assign({}, g, {
    ref: t,
    className: j,
    style: $
  }), W, T, S && /* @__PURE__ */ m.createElement(XOe, {
    key: "preset",
    prefixCls: P
  }), E && /* @__PURE__ */ m.createElement(JOe, {
    key: "status",
    prefixCls: P
  }));
  return R(k ? /* @__PURE__ */ m.createElement(XR, {
    component: "Tag"
  }, V) : V);
}, dG = /* @__PURE__ */ m.forwardRef(ePe);
dG.CheckableTag = qOe;
const pG = dG;
var tPe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const nPe = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
}, rPe = /* @__PURE__ */ m.forwardRef((e, t) => {
  const n = (c) => {
    const {
      keyCode: f
    } = c;
    f === Ct.ENTER && c.preventDefault();
  }, r = (c) => {
    const {
      keyCode: f
    } = c, {
      onClick: d
    } = e;
    f === Ct.ENTER && d && d();
  }, {
    style: i,
    noStyle: o,
    disabled: a
  } = e, s = tPe(e, ["style", "noStyle", "disabled"]);
  let l = {};
  return o || (l = Object.assign({}, nPe)), a && (l.pointerEvents = "none"), l = Object.assign(Object.assign({}, l), i), /* @__PURE__ */ m.createElement("div", Object.assign({
    role: "button",
    tabIndex: 0,
    ref: t
  }, s, {
    onKeyDown: n,
    onKeyUp: r,
    style: l
  }));
}), hG = rPe;
var iPe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
const oPe = iPe;
var aPe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: oPe
  }));
}, sPe = /* @__PURE__ */ m.forwardRef(aPe);
const lPe = sPe;
var cPe = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
    n.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(i) {
      e.addRange(i);
    }), t && t.focus();
  };
}, uPe = cPe, d6 = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, fPe = "Copy to clipboard: #{key}, Enter";
function dPe(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function pPe(e, t) {
  var n, r, i, o, a, s, l = !1;
  t || (t = {}), n = t.debug || !1;
  try {
    i = uPe(), o = document.createRange(), a = document.getSelection(), s = document.createElement("span"), s.textContent = e, s.ariaHidden = "true", s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function(f) {
      if (f.stopPropagation(), t.format)
        if (f.preventDefault(), typeof f.clipboardData > "u") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var d = d6[t.format] || d6.default;
          window.clipboardData.setData(d, e);
        } else
          f.clipboardData.clearData(), f.clipboardData.setData(t.format, e);
      t.onCopy && (f.preventDefault(), t.onCopy(f.clipboardData));
    }), document.body.appendChild(s), o.selectNodeContents(s), a.addRange(o);
    var c = document.execCommand("copy");
    if (!c)
      throw new Error("copy command was unsuccessful");
    l = !0;
  } catch (f) {
    n && console.error("unable to copy using execCommand: ", f), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), l = !0;
    } catch (d) {
      n && console.error("unable to copy using clipboardData: ", d), n && console.error("falling back to prompt"), r = dPe("message" in t ? t.message : fPe), window.prompt(r, e);
    }
  } finally {
    a && (typeof a.removeRange == "function" ? a.removeRange(o) : a.removeAllRanges()), s && document.body.removeChild(s), i();
  }
  return l;
}
var hPe = pPe;
const mPe = /* @__PURE__ */ Oi(hPe);
var gPe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" };
const vPe = gPe;
var yPe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: vPe
  }));
}, bPe = /* @__PURE__ */ m.forwardRef(yPe);
const wPe = bPe, SPe = (e, t, n, r) => {
  const {
    titleMarginBottom: i,
    fontWeightStrong: o
  } = r;
  return {
    marginBottom: i,
    color: n,
    fontWeight: o,
    fontSize: e,
    lineHeight: t
  };
}, xPe = (e) => {
  const t = [1, 2, 3, 4, 5], n = {};
  return t.forEach((r) => {
    n[`
      h${r}&,
      div&-h${r},
      div&-h${r} > textarea,
      h${r}
    `] = SPe(e[`fontSizeHeading${r}`], e[`lineHeightHeading${r}`], e.colorTextHeading, e);
  }), n;
}, CPe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    "a&, a": Object.assign(Object.assign({}, LH(e)), {
      textDecoration: e.linkDecoration,
      "&:active, &:hover": {
        textDecoration: e.linkHoverDecoration
      },
      [`&[disabled], &${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: e.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, EPe = (e) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: Qfe[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: e.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), $Pe = (e) => {
  const {
    componentCls: t,
    paddingSM: n
  } = e, r = n;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: e.calc(e.paddingSM).mul(-1).equal(),
        marginTop: e.calc(r).mul(-1).equal(),
        marginBottom: `calc(1em - ${ge(r)})`
      },
      [`${t}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: e.calc(e.marginXS).add(2).equal(),
        insetBlockEnd: e.marginXS,
        color: e.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: e.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, _Pe = (e) => ({
  [`${e.componentCls}-copy-success`]: {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: e.colorSuccess
    }
  },
  [`${e.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), OPe = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-single-line": {
    whiteSpace: "nowrap"
  },
  "&-ellipsis-single-line": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), PPe = (e) => {
  const {
    componentCls: t,
    titleMarginTop: n
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: e.colorText,
      wordBreak: "break-word",
      lineHeight: e.lineHeight,
      [`&${t}-secondary`]: {
        color: e.colorTextDescription
      },
      [`&${t}-success`]: {
        color: e.colorSuccess
      },
      [`&${t}-warning`]: {
        color: e.colorWarning
      },
      [`&${t}-danger`]: {
        color: e.colorError,
        "a&:active, a&:focus": {
          color: e.colorErrorActive
        },
        "a&:hover": {
          color: e.colorErrorHover
        }
      },
      [`&${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, xPe(e)), {
      [`
      & + h1${t},
      & + h2${t},
      & + h3${t},
      & + h4${t},
      & + h5${t}
      `]: {
        marginTop: n
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: n
        }
      }
    }), EPe(e)), CPe(e)), {
      // Operation
      [`
        ${t}-expand,
        ${t}-edit,
        ${t}-copy
      `]: Object.assign(Object.assign({}, LH(e)), {
        marginInlineStart: e.marginXXS
      })
    }), $Pe(e)), _Pe(e)), OPe()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, TPe = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), mG = Pi("Typography", (e) => [PPe(e)], TPe), IPe = (e) => {
  const {
    prefixCls: t,
    "aria-label": n,
    className: r,
    style: i,
    direction: o,
    maxLength: a,
    autoSize: s = !0,
    value: l,
    onSave: c,
    onCancel: f,
    onEnd: d,
    component: p,
    enterIcon: g = /* @__PURE__ */ m.createElement(wPe, null)
  } = e, v = m.useRef(null), y = m.useRef(!1), x = m.useRef(), [b, w] = m.useState(l);
  m.useEffect(() => {
    w(l);
  }, [l]), m.useEffect(() => {
    if (v.current && v.current.resizableTextArea) {
      const {
        textArea: F
      } = v.current.resizableTextArea;
      F.focus();
      const {
        length: W
      } = F.value;
      F.setSelectionRange(W, W);
    }
  }, []);
  const S = (F) => {
    let {
      target: W
    } = F;
    w(W.value.replace(/[\n\r]/g, ""));
  }, E = () => {
    y.current = !0;
  }, O = () => {
    y.current = !1;
  }, $ = (F) => {
    let {
      keyCode: W
    } = F;
    y.current || (x.current = W);
  }, P = () => {
    c(b.trim());
  }, R = (F) => {
    let {
      keyCode: W,
      ctrlKey: V,
      altKey: G,
      metaKey: X,
      shiftKey: D
    } = F;
    x.current === W && !y.current && !V && !G && !X && !D && (W === Ct.ENTER ? (P(), d == null || d()) : W === Ct.ESC && f());
  }, L = () => {
    P();
  }, B = p ? `${t}-${p}` : "", [j, A, T] = mG(t), k = Ue(t, `${t}-edit-content`, {
    [`${t}-rtl`]: o === "rtl"
  }, r, B, A, T);
  return j(/* @__PURE__ */ m.createElement("div", {
    className: k,
    style: i
  }, /* @__PURE__ */ m.createElement(nG, {
    ref: v,
    maxLength: a,
    value: b,
    onChange: S,
    onKeyDown: $,
    onKeyUp: R,
    onCompositionStart: E,
    onCompositionEnd: O,
    onBlur: L,
    "aria-label": n,
    rows: 1,
    autoSize: s
  }), g !== null ? Oa(g, {
    className: `${t}-edit-content-confirm`
  }) : null));
}, APe = IPe;
function a_(e, t) {
  return m.useMemo(() => {
    const n = !!e;
    return [n, Object.assign(Object.assign({}, t), n && typeof e == "object" ? e : null)];
  }, [e]);
}
const RPe = (e, t) => {
  const n = m.useRef(!1);
  m.useEffect(() => {
    n.current ? e() : n.current = !0;
  }, t);
}, MPe = RPe;
var NPe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const kPe = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    prefixCls: n,
    component: r = "article",
    className: i,
    rootClassName: o,
    setContentRef: a,
    children: s,
    direction: l,
    style: c
  } = e, f = NPe(e, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: d,
    direction: p,
    typography: g
  } = m.useContext(Mt), v = l ?? p;
  let y = t;
  a && (y = Sc(t, a));
  const x = d("typography", n), [b, w, S] = mG(x), E = Ue(x, g == null ? void 0 : g.className, {
    [`${x}-rtl`]: v === "rtl"
  }, i, o, w, S), O = Object.assign(Object.assign({}, g == null ? void 0 : g.style), c);
  return b(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ m.createElement(r, Object.assign({
      className: E,
      style: O,
      ref: y
    }, f), s)
  );
}), gG = kPe;
var LPe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
const DPe = LPe;
var jPe = function(t, n) {
  return /* @__PURE__ */ m.createElement(Gi, ri({}, t, {
    ref: n,
    icon: DPe
  }));
}, FPe = /* @__PURE__ */ m.forwardRef(jPe);
const BPe = FPe;
function p6(e) {
  return e === !1 ? [!1, !1] : Array.isArray(e) ? e : [e];
}
function T0(e, t, n) {
  return e === !0 || e === void 0 ? t : e || n && t;
}
function zPe(e) {
  const {
    prefixCls: t,
    copied: n,
    locale: r = {},
    onCopy: i,
    iconOnly: o,
    tooltips: a,
    icon: s
  } = e, l = p6(a), c = p6(s), {
    copied: f,
    copy: d
  } = r, p = n ? T0(l[1], f) : T0(l[0], d), v = typeof p == "string" ? p : n ? f : d;
  return /* @__PURE__ */ m.createElement(BS, {
    key: "copy",
    title: p
  }, /* @__PURE__ */ m.createElement(hG, {
    className: Ue(`${t}-copy`, {
      [`${t}-copy-success`]: n,
      [`${t}-copy-icon-only`]: o
    }),
    onClick: i,
    "aria-label": v
  }, n ? T0(c[1], /* @__PURE__ */ m.createElement(dbe, null), !0) : T0(c[0], /* @__PURE__ */ m.createElement(BPe, null), !0)));
}
const I0 = /* @__PURE__ */ m.forwardRef((e, t) => {
  let {
    style: n,
    children: r
  } = e;
  const i = m.useRef(null);
  return m.useImperativeHandle(t, () => ({
    isExceed: () => {
      const o = i.current;
      return o.scrollHeight > o.clientHeight;
    },
    getHeight: () => i.current.clientHeight
  })), /* @__PURE__ */ m.createElement("span", {
    "aria-hidden": !0,
    ref: i,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      // zIndex: -9999,
      // visibility: 'hidden',
      pointerEvents: "none",
      backgroundColor: "rgba(255, 0, 0, 0.65)"
    }, n)
  }, r);
});
function vG(e) {
  const t = typeof e;
  return t === "string" || t === "number";
}
function UPe(e) {
  let t = 0;
  return e.forEach((n) => {
    vG(n) ? t += String(n).length : t += 1;
  }), t;
}
function h6(e, t) {
  let n = 0;
  const r = [];
  for (let i = 0; i < e.length; i += 1) {
    if (n === t)
      return r;
    const o = e[i], s = vG(o) ? String(o).length : 1, l = n + s;
    if (l > t) {
      const c = t - n;
      return r.push(String(o).slice(0, c)), r;
    }
    r.push(o), n = l;
  }
  return e;
}
const s_ = 0, l_ = 1, c_ = 2, m6 = 3, A0 = {
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical"
};
function HPe(e) {
  const {
    enableMeasure: t,
    width: n,
    text: r,
    children: i,
    rows: o,
    miscDeps: a,
    onEllipsis: s
  } = e, l = m.useMemo(() => vc(r), [r]), c = m.useMemo(() => UPe(l), [r]), f = m.useMemo(() => i(l, !1, !1), [r]), [d, p] = m.useState(null), g = m.useRef(null), v = m.useRef(null), y = m.useRef(null), x = m.useRef(null), [b, w] = m.useState(s_), [S, E] = m.useState(0);
  Sp(() => {
    w(t && n && c ? l_ : s_);
  }, [n, r, o, t, l]), Sp(() => {
    var R, L, B, j;
    if (b === l_) {
      const A = !!(!((R = v.current) === null || R === void 0) && R.isExceed());
      w(A ? c_ : m6), p(A ? [0, c] : null);
      const T = ((L = v.current) === null || L === void 0 ? void 0 : L.getHeight()) || 0, k = o === 1 ? 0 : ((B = y.current) === null || B === void 0 ? void 0 : B.getHeight()) || 0, F = ((j = x.current) === null || j === void 0 ? void 0 : j.getHeight()) || 0, W = k + F, V = Math.max(T, W);
      E(V + 1), s(A);
    }
  }, [b]);
  const O = d ? Math.ceil((d[0] + d[1]) / 2) : 0;
  Sp(() => {
    var R;
    const [L, B] = d || [0, 0];
    if (L !== B) {
      const A = (((R = g.current) === null || R === void 0 ? void 0 : R.getHeight()) || 0) > S;
      let T = O;
      B - L === 1 && (T = A ? L : B), p(A ? [L, T] : [T, B]);
    }
  }, [d, O]);
  const $ = m.useMemo(() => {
    if (b !== c_ || !d || d[0] !== d[1]) {
      const R = i(l, !1, !1);
      return b !== m6 && b !== s_ ? /* @__PURE__ */ m.createElement("span", {
        style: Object.assign(Object.assign({}, A0), {
          WebkitLineClamp: o
        })
      }, R) : R;
    }
    return i(h6(l, d[0]), !0, !0);
  }, [b, d, l].concat(Qa(a))), P = {
    width: n,
    whiteSpace: "normal",
    margin: 0,
    padding: 0
  };
  return /* @__PURE__ */ m.createElement(m.Fragment, null, $, b === l_ && /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(I0, {
    style: Object.assign(Object.assign(Object.assign({}, P), A0), {
      WebkitLineClamp: o
    }),
    ref: v
  }, f), /* @__PURE__ */ m.createElement(I0, {
    style: Object.assign(Object.assign(Object.assign({}, P), A0), {
      WebkitLineClamp: o - 1
    }),
    ref: y
  }, f), /* @__PURE__ */ m.createElement(I0, {
    style: Object.assign(Object.assign(Object.assign({}, P), A0), {
      WebkitLineClamp: 1
    }),
    ref: x
  }, i([], !0, !0))), b === c_ && d && d[0] !== d[1] && /* @__PURE__ */ m.createElement(I0, {
    style: Object.assign(Object.assign({}, P), {
      top: 400
    }),
    ref: g
  }, i(h6(l, O), !0, !0)));
}
const WPe = (e) => {
  let {
    enableEllipsis: t,
    isEllipsis: n,
    children: r,
    tooltipProps: i
  } = e;
  return !(i != null && i.title) || !t ? r : /* @__PURE__ */ m.createElement(BS, Object.assign({
    open: n ? void 0 : !1
  }, i), r);
}, VPe = WPe;
var GPe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function KPe(e, t) {
  let {
    mark: n,
    code: r,
    underline: i,
    delete: o,
    strong: a,
    keyboard: s,
    italic: l
  } = e, c = t;
  function f(d, p) {
    p && (c = /* @__PURE__ */ m.createElement(d, {}, c));
  }
  return f("strong", a), f("u", i), f("del", o), f("code", r), f("mark", n), f("kbd", s), f("i", l), c;
}
const qPe = "...", YPe = /* @__PURE__ */ m.forwardRef((e, t) => {
  var n, r, i;
  const {
    prefixCls: o,
    className: a,
    style: s,
    type: l,
    disabled: c,
    children: f,
    ellipsis: d,
    editable: p,
    copyable: g,
    component: v,
    title: y
  } = e, x = GPe(e, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: b,
    direction: w
  } = m.useContext(Mt), [S] = Xw("Text"), E = m.useRef(null), O = m.useRef(null), $ = b("typography", o), P = os(x, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), [R, L] = a_(p), [B, j] = TR(!1, {
    value: L.editing
  }), {
    triggerType: A = ["icon"]
  } = L, T = (Je) => {
    var Ze;
    Je && ((Ze = L.onStart) === null || Ze === void 0 || Ze.call(L)), j(Je);
  };
  MPe(() => {
    var Je;
    B || (Je = O.current) === null || Je === void 0 || Je.focus();
  }, [B]);
  const k = (Je) => {
    Je == null || Je.preventDefault(), T(!0);
  }, F = (Je) => {
    var Ze;
    (Ze = L.onChange) === null || Ze === void 0 || Ze.call(L, Je), T(!1);
  }, W = () => {
    var Je;
    (Je = L.onCancel) === null || Je === void 0 || Je.call(L), T(!1);
  }, [V, G] = a_(g), [X, D] = m.useState(!1), te = m.useRef(null), ee = {};
  G.format && (ee.format = G.format);
  const U = () => {
    te.current && clearTimeout(te.current);
  }, he = (Je) => {
    var Ze;
    Je == null || Je.preventDefault(), Je == null || Je.stopPropagation(), mPe(G.text || String(f) || "", ee), D(!0), U(), te.current = setTimeout(() => {
      D(!1);
    }, 3e3), (Ze = G.onCopy) === null || Ze === void 0 || Ze.call(G, Je);
  };
  m.useEffect(() => U, []);
  const [re, de] = m.useState(!1), [we, ue] = m.useState(!1), [me, Se] = m.useState(!1), [_e, Ge] = m.useState(!1), [Fe, Ae] = m.useState(!1), [Me, et] = m.useState(!0), [De, je] = a_(d, {
    expandable: !1
  }), ie = De && !me, {
    rows: fe = 1
  } = je, be = m.useMemo(() => (
    // Disable ellipsis
    !ie || // Provide suffix
    je.suffix !== void 0 || je.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    je.expandable || R || V
  ), [ie, je, R, V]);
  Sp(() => {
    De && !be && (de(gD("webkitLineClamp")), ue(gD("textOverflow")));
  }, [be, De]);
  const Te = m.useMemo(() => be ? !1 : fe === 1 ? we : re, [be, we, re]), Le = ie && (Te ? Fe : _e), ct = ie && fe === 1 && Te, Z = ie && fe > 1 && Te, se = (Je) => {
    var Ze;
    Se(!0), (Ze = je.onExpand) === null || Ze === void 0 || Ze.call(je, Je);
  }, [Ce, Pe] = m.useState(0), Ee = (Je) => {
    let {
      offsetWidth: Ze
    } = Je;
    Pe(Ze);
  }, We = (Je) => {
    var Ze;
    Ge(Je), _e !== Je && ((Ze = je.onEllipsis) === null || Ze === void 0 || Ze.call(je, Je));
  };
  m.useEffect(() => {
    const Je = E.current;
    if (De && Te && Je) {
      const Ze = Z ? Je.offsetHeight < Je.scrollHeight : Je.offsetWidth < Je.scrollWidth;
      Fe !== Ze && Ae(Ze);
    }
  }, [De, Te, f, Z, Me, Ce]), m.useEffect(() => {
    const Je = E.current;
    if (typeof IntersectionObserver > "u" || !Je || !Te || !ie)
      return;
    const Ze = new IntersectionObserver(() => {
      et(!!Je.offsetParent);
    });
    return Ze.observe(Je), () => {
      Ze.disconnect();
    };
  }, [Te, ie]);
  let ze = {};
  je.tooltip === !0 ? ze = {
    title: (n = L.text) !== null && n !== void 0 ? n : f
  } : /* @__PURE__ */ m.isValidElement(je.tooltip) ? ze = {
    title: je.tooltip
  } : typeof je.tooltip == "object" ? ze = Object.assign({
    title: (r = L.text) !== null && r !== void 0 ? r : f
  }, je.tooltip) : ze = {
    title: je.tooltip
  };
  const Ye = m.useMemo(() => {
    const Je = (Ze) => ["string", "number"].includes(typeof Ze);
    if (!(!De || Te)) {
      if (Je(L.text))
        return L.text;
      if (Je(f))
        return f;
      if (Je(y))
        return y;
      if (Je(ze.title))
        return ze.title;
    }
  }, [De, Te, y, ze.title, Le]);
  if (B)
    return /* @__PURE__ */ m.createElement(APe, {
      value: (i = L.text) !== null && i !== void 0 ? i : typeof f == "string" ? f : "",
      onSave: F,
      onCancel: W,
      onEnd: L.onEnd,
      prefixCls: $,
      className: a,
      style: s,
      direction: w,
      component: v,
      maxLength: L.maxLength,
      autoSize: L.autoSize,
      enterIcon: L.enterIcon
    });
  const xt = () => {
    const {
      expandable: Je,
      symbol: Ze
    } = je;
    if (!Je)
      return null;
    let ut;
    return Ze ? ut = Ze : ut = S == null ? void 0 : S.expand, /* @__PURE__ */ m.createElement("a", {
      key: "expand",
      className: `${$}-expand`,
      onClick: se,
      "aria-label": S == null ? void 0 : S.expand
    }, ut);
  }, Lt = () => {
    if (!R)
      return;
    const {
      icon: Je,
      tooltip: Ze
    } = L, ut = vc(Ze)[0] || (S == null ? void 0 : S.edit), cn = typeof ut == "string" ? ut : "";
    return A.includes("icon") ? /* @__PURE__ */ m.createElement(BS, {
      key: "edit",
      title: Ze === !1 ? "" : ut
    }, /* @__PURE__ */ m.createElement(hG, {
      ref: O,
      className: `${$}-edit`,
      onClick: k,
      "aria-label": cn
    }, Je || /* @__PURE__ */ m.createElement(lPe, {
      role: "button"
    }))) : null;
  }, mt = () => V ? /* @__PURE__ */ m.createElement(zPe, Object.assign({
    key: "copy"
  }, G, {
    prefixCls: $,
    copied: X,
    locale: S,
    onCopy: he,
    iconOnly: f == null
  })) : null, St = (Je) => [Je && xt(), Lt(), mt()], Et = (Je) => [Je && /* @__PURE__ */ m.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, qPe), je.suffix, St(Je)];
  return /* @__PURE__ */ m.createElement(mR, {
    onResize: Ee,
    disabled: !ie
  }, (Je) => /* @__PURE__ */ m.createElement(VPe, {
    tooltipProps: ze,
    enableEllipsis: ie,
    isEllipsis: Le
  }, /* @__PURE__ */ m.createElement(gG, Object.assign({
    className: Ue({
      [`${$}-${l}`]: l,
      [`${$}-disabled`]: c,
      [`${$}-ellipsis`]: De,
      [`${$}-single-line`]: ie && fe === 1,
      [`${$}-ellipsis-single-line`]: ct,
      [`${$}-ellipsis-multiple-line`]: Z
    }, a),
    prefixCls: o,
    style: Object.assign(Object.assign({}, s), {
      WebkitLineClamp: Z ? fe : void 0
    }),
    component: v,
    ref: Sc(Je, E, t),
    direction: w,
    onClick: A.includes("text") ? k : void 0,
    "aria-label": Ye == null ? void 0 : Ye.toString(),
    title: y
  }, P), /* @__PURE__ */ m.createElement(HPe, {
    enableMeasure: ie && !Te,
    text: f,
    rows: fe,
    width: Ce,
    onEllipsis: We,
    miscDeps: [X, me]
  }, (Ze, ut) => {
    let cn = Ze;
    return Ze.length && ut && Ye && (cn = /* @__PURE__ */ m.createElement("span", {
      key: "show-content",
      "aria-hidden": !0
    }, cn)), KPe(e, /* @__PURE__ */ m.createElement(m.Fragment, null, cn, Et(ut)));
  }))));
}), mx = YPe;
var XPe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const QPe = /* @__PURE__ */ m.forwardRef((e, t) => {
  var {
    ellipsis: n,
    rel: r
  } = e, i = XPe(e, ["ellipsis", "rel"]);
  const o = Object.assign(Object.assign({}, i), {
    rel: r === void 0 && i.target === "_blank" ? "noopener noreferrer" : r
  });
  return delete o.navigate, /* @__PURE__ */ m.createElement(mx, Object.assign({}, o, {
    ref: t,
    ellipsis: !!n,
    component: "a"
  }));
}), JPe = QPe, ZPe = /* @__PURE__ */ m.forwardRef((e, t) => /* @__PURE__ */ m.createElement(mx, Object.assign({
  ref: t
}, e, {
  component: "div"
}))), eTe = ZPe;
var tTe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const nTe = (e, t) => {
  var {
    ellipsis: n
  } = e, r = tTe(e, ["ellipsis"]);
  const i = m.useMemo(() => n && typeof n == "object" ? os(n, ["expandable", "rows"]) : n, [n]);
  return /* @__PURE__ */ m.createElement(mx, Object.assign({
    ref: t
  }, r, {
    ellipsis: i,
    component: "span"
  }));
}, rTe = /* @__PURE__ */ m.forwardRef(nTe);
var iTe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const oTe = [1, 2, 3, 4, 5], aTe = /* @__PURE__ */ m.forwardRef((e, t) => {
  const {
    level: n = 1
  } = e, r = iTe(e, ["level"]);
  let i;
  return oTe.includes(n) ? i = `h${n}` : i = "h1", /* @__PURE__ */ m.createElement(mx, Object.assign({
    ref: t
  }, r, {
    component: i
  }));
}), sTe = aTe, Cv = gG;
Cv.Text = rTe;
Cv.Link = JPe;
Cv.Title = sTe;
Cv.Paragraph = eTe;
const xh = Cv;
var yG = { exports: {} }, bG = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qp = m;
function lTe(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var cTe = typeof Object.is == "function" ? Object.is : lTe, uTe = Qp.useState, fTe = Qp.useEffect, dTe = Qp.useLayoutEffect, pTe = Qp.useDebugValue;
function hTe(e, t) {
  var n = t(), r = uTe({ inst: { value: n, getSnapshot: t } }), i = r[0].inst, o = r[1];
  return dTe(function() {
    i.value = n, i.getSnapshot = t, u_(i) && o({ inst: i });
  }, [e, n, t]), fTe(function() {
    return u_(i) && o({ inst: i }), e(function() {
      u_(i) && o({ inst: i });
    });
  }, [e]), pTe(n), n;
}
function u_(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !cTe(e, n);
  } catch {
    return !0;
  }
}
function mTe(e, t) {
  return t();
}
var gTe = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? mTe : hTe;
bG.useSyncExternalStore = Qp.useSyncExternalStore !== void 0 ? Qp.useSyncExternalStore : gTe;
yG.exports = bG;
var vTe = yG.exports, wG = { exports: {} }, SG = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gx = m, yTe = vTe;
function bTe(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var wTe = typeof Object.is == "function" ? Object.is : bTe, STe = yTe.useSyncExternalStore, xTe = gx.useRef, CTe = gx.useEffect, ETe = gx.useMemo, $Te = gx.useDebugValue;
SG.useSyncExternalStoreWithSelector = function(e, t, n, r, i) {
  var o = xTe(null);
  if (o.current === null) {
    var a = { hasValue: !1, value: null };
    o.current = a;
  } else
    a = o.current;
  o = ETe(function() {
    function l(g) {
      if (!c) {
        if (c = !0, f = g, g = r(g), i !== void 0 && a.hasValue) {
          var v = a.value;
          if (i(v, g))
            return d = v;
        }
        return d = g;
      }
      if (v = d, wTe(f, g))
        return v;
      var y = r(g);
      return i !== void 0 && i(v, y) ? v : (f = g, d = y);
    }
    var c = !1, f, d, p = n === void 0 ? null : n;
    return [function() {
      return l(t());
    }, p === null ? void 0 : function() {
      return l(p());
    }];
  }, [t, n, r, i]);
  var s = STe(e, o[0], o[1]);
  return CTe(function() {
    a.hasValue = !0, a.value = s;
  }, [s]), $Te(s), s;
};
wG.exports = SG;
var _Te = wG.exports;
function OTe(e) {
  e();
}
let xG = OTe;
const PTe = (e) => xG = e, TTe = () => xG, g6 = Symbol.for("react-redux-context"), v6 = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function ITe() {
  var e;
  if (!m.createContext)
    return {};
  const t = (e = v6[g6]) != null ? e : v6[g6] = /* @__PURE__ */ new Map();
  let n = t.get(m.createContext);
  return n || (n = m.createContext(null), t.set(m.createContext, n)), n;
}
const Tu = /* @__PURE__ */ ITe();
function M2(e = Tu) {
  return function() {
    return m.useContext(e);
  };
}
const CG = /* @__PURE__ */ M2(), ATe = () => {
  throw new Error("uSES not initialized!");
};
let EG = ATe;
const RTe = (e) => {
  EG = e;
}, MTe = (e, t) => e === t;
function NTe(e = Tu) {
  const t = e === Tu ? CG : M2(e);
  return function(r, i = {}) {
    const {
      equalityFn: o = MTe,
      stabilityCheck: a = void 0,
      noopCheck: s = void 0
    } = typeof i == "function" ? {
      equalityFn: i
    } : i, {
      store: l,
      subscription: c,
      getServerState: f,
      stabilityCheck: d,
      noopCheck: p
    } = t();
    m.useRef(!0);
    const g = m.useCallback({
      [r.name](y) {
        return r(y);
      }
    }[r.name], [r, d, a]), v = EG(c.addNestedSub, l.getState, f || l.getState, g, o);
    return m.useDebugValue(v), v;
  };
}
const pe = /* @__PURE__ */ NTe();
var $G = yh, kTe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, LTe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, _G = {};
_G[$G.ForwardRef] = kTe;
_G[$G.Memo] = LTe;
var Xn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N2 = Symbol.for("react.element"), k2 = Symbol.for("react.portal"), vx = Symbol.for("react.fragment"), yx = Symbol.for("react.strict_mode"), bx = Symbol.for("react.profiler"), wx = Symbol.for("react.provider"), Sx = Symbol.for("react.context"), DTe = Symbol.for("react.server_context"), xx = Symbol.for("react.forward_ref"), Cx = Symbol.for("react.suspense"), Ex = Symbol.for("react.suspense_list"), $x = Symbol.for("react.memo"), _x = Symbol.for("react.lazy"), jTe = Symbol.for("react.offscreen"), OG;
OG = Symbol.for("react.module.reference");
function ps(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case N2:
        switch (e = e.type, e) {
          case vx:
          case bx:
          case yx:
          case Cx:
          case Ex:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case DTe:
              case Sx:
              case xx:
              case _x:
              case $x:
              case wx:
                return e;
              default:
                return t;
            }
        }
      case k2:
        return t;
    }
  }
}
Xn.ContextConsumer = Sx;
Xn.ContextProvider = wx;
Xn.Element = N2;
Xn.ForwardRef = xx;
Xn.Fragment = vx;
Xn.Lazy = _x;
Xn.Memo = $x;
Xn.Portal = k2;
Xn.Profiler = bx;
Xn.StrictMode = yx;
Xn.Suspense = Cx;
Xn.SuspenseList = Ex;
Xn.isAsyncMode = function() {
  return !1;
};
Xn.isConcurrentMode = function() {
  return !1;
};
Xn.isContextConsumer = function(e) {
  return ps(e) === Sx;
};
Xn.isContextProvider = function(e) {
  return ps(e) === wx;
};
Xn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === N2;
};
Xn.isForwardRef = function(e) {
  return ps(e) === xx;
};
Xn.isFragment = function(e) {
  return ps(e) === vx;
};
Xn.isLazy = function(e) {
  return ps(e) === _x;
};
Xn.isMemo = function(e) {
  return ps(e) === $x;
};
Xn.isPortal = function(e) {
  return ps(e) === k2;
};
Xn.isProfiler = function(e) {
  return ps(e) === bx;
};
Xn.isStrictMode = function(e) {
  return ps(e) === yx;
};
Xn.isSuspense = function(e) {
  return ps(e) === Cx;
};
Xn.isSuspenseList = function(e) {
  return ps(e) === Ex;
};
Xn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === vx || e === bx || e === yx || e === Cx || e === Ex || e === jTe || typeof e == "object" && e !== null && (e.$$typeof === _x || e.$$typeof === $x || e.$$typeof === wx || e.$$typeof === Sx || e.$$typeof === xx || e.$$typeof === OG || e.getModuleId !== void 0);
};
Xn.typeOf = ps;
function FTe() {
  const e = TTe();
  let t = null, n = null;
  return {
    clear() {
      t = null, n = null;
    },
    notify() {
      e(() => {
        let r = t;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      let r = [], i = t;
      for (; i; )
        r.push(i), i = i.next;
      return r;
    },
    subscribe(r) {
      let i = !0, o = n = {
        callback: r,
        next: null,
        prev: n
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : n = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
const y6 = {
  notify() {
  },
  get: () => []
};
function BTe(e, t) {
  let n, r = y6;
  function i(d) {
    return l(), r.subscribe(d);
  }
  function o() {
    r.notify();
  }
  function a() {
    f.onStateChange && f.onStateChange();
  }
  function s() {
    return !!n;
  }
  function l() {
    n || (n = t ? t.addNestedSub(a) : e.subscribe(a), r = FTe());
  }
  function c() {
    n && (n(), n = void 0, r.clear(), r = y6);
  }
  const f = {
    addNestedSub: i,
    notifyNestedSubs: o,
    handleChangeWrapper: a,
    isSubscribed: s,
    trySubscribe: l,
    tryUnsubscribe: c,
    getListeners: () => r
  };
  return f;
}
const zTe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", UTe = zTe ? m.useLayoutEffect : m.useEffect;
function L2({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: i = "once",
  noopCheck: o = "once"
}) {
  const a = m.useMemo(() => {
    const c = BTe(e);
    return {
      store: e,
      subscription: c,
      getServerState: r ? () => r : void 0,
      stabilityCheck: i,
      noopCheck: o
    };
  }, [e, r, i, o]), s = m.useMemo(() => e.getState(), [e]);
  UTe(() => {
    const {
      subscription: c
    } = a;
    return c.onStateChange = c.notifyNestedSubs, c.trySubscribe(), s !== e.getState() && c.notifyNestedSubs(), () => {
      c.tryUnsubscribe(), c.onStateChange = void 0;
    };
  }, [a, s]);
  const l = t || Tu;
  return /* @__PURE__ */ m.createElement(l.Provider, {
    value: a
  }, n);
}
function PG(e = Tu) {
  const t = (
    // @ts-ignore
    e === Tu ? CG : (
      // @ts-ignore
      M2(e)
    )
  );
  return function() {
    const {
      store: r
    } = t();
    return r;
  };
}
const HTe = /* @__PURE__ */ PG();
function WTe(e = Tu) {
  const t = (
    // @ts-ignore
    e === Tu ? HTe : PG(e)
  );
  return function() {
    return t().dispatch;
  };
}
const wr = /* @__PURE__ */ WTe();
RTe(_Te.useSyncExternalStoreWithSelector);
PTe(js.unstable_batchedUpdates);
const ku = "settings", D2 = Symbol("fetchingStatus");
var H1 = /* @__PURE__ */ ((e) => (e.POPUP = "popup", e.BADGE = "badge", e))(H1 || {});
const TG = {
  office_hours: {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: []
  },
  time_zone: "Asia/Taipei",
  new_messages_notification: "badge",
  auto_popup: {
    first: [],
    next: [],
    minimize: []
  },
  [D2]: !0,
  launcher_icon_url: null,
  display: null,
  start_questions: []
}, Ox = (e) => e[ku].start_questions, IG = (e) => e[ku].launcher_icon_url, Px = (e) => e[ku][D2], VTe = {
  width: "100%",
  height: "100%"
}, GTe = {
  background: "transparent",
  border: "0px",
  width: "100%",
  height: "100%"
}, b6 = {
  position: "relative",
  "z-index": 1
};
class KTe {
  constructor(t, n, r) {
    this.container = t, this.iframeContainer = n, this.embeddedWrapperSelectorId = r;
  }
  perform() {
    this.action();
  }
  action() {
    this.iframeContainer.setAttribute("data-embedded", "true"), Object.assign(this.container.style, VTe), Object.assign(this.iframeContainer.style, GTe);
    let t = document.getElementById(this.embeddedWrapperSelectorId);
    t ? (Object.assign(t.style, b6), t.appendChild(this.container)) : (t = document.createElement("div"), t.id = this.embeddedWrapperSelectorId, Object.assign(t.style, b6), document.body.appendChild(t), t.appendChild(this.container));
  }
}
class qTe {
  perform() {
    return this.action();
  }
  action() {
    const t = window.location.search, n = new URLSearchParams(t), r = (i) => {
      const o = n.get(i);
      return o === "1" || o === "true" ? !0 : o === "0" || o === "false" ? !1 : null;
    };
    return {
      independentLauncher: r("webchat_independent_launcher"),
      smallPopup: r("webchat_enable_popup_small_mode"),
      smallPopupStarterQuestions: r("webchat_small_popup_starter_questions"),
      autoPopup: r("webchat_auto_popup")
    };
  }
}
var Zl = /* @__PURE__ */ ((e) => (e.Positive = "positive", e.Negative = "negative", e))(Zl || {}), Bi = /* @__PURE__ */ ((e) => (e.Bubble = "bubble", e.Bar = "bar", e.SideBar = "side-bar", e.BubbleAndSideBar = "bubble-and-side-bar", e))(Bi || {}), Wg = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(Wg || {}), Vg = /* @__PURE__ */ ((e) => (e.IconOnly = "icon_only", e.FullImage = "full_image", e))(Vg || {});
const YTe = {
  positive: "positive",
  negative: "negative"
  /* Negative */
}, AG = {
  small: 60,
  medium: 80,
  large: 100
}, XTe = {
  small: 24,
  medium: 32,
  large: 40
};
class QTe {
  constructor(t, n, r, i) {
    this.isPlacement2Enabled = kG.isFeatureEnabled(), this.LAUNCHER_TOP_AND_BOTTOM = 36, this.SHADOW = 10, this.BAR_PLACEMENT_HEIGHT = 48, this.BAR_TOP_AND_BOTTOM = 16, this.instance = Nr.create(t), this.container = r, this.mobileBreakPoint = i;
  }
  perform(t) {
    this.action(t);
  }
  getBottom(t) {
    const { chatBubblePlacementStyle: n, chatBubblePlacementSize: r } = t, i = this.isPlacement2Enabled ? AG[r] : 60;
    return {
      [Bi.Bubble]: `${this.LAUNCHER_TOP_AND_BOTTOM + i - this.SHADOW}px`,
      [Bi.Bar]: `${this.BAR_TOP_AND_BOTTOM + this.BAR_PLACEMENT_HEIGHT - this.SHADOW}px`,
      [Bi.SideBar]: "14px",
      [Bi.BubbleAndSideBar]: `${this.LAUNCHER_TOP_AND_BOTTOM + i - this.SHADOW}px`
    }[n];
  }
  action(t) {
    const {
      isPopupShown: n,
      isPopupSmallMode: r,
      showSmallPopupStarterQuestions: i,
      welcomeMessageHeight: o,
      chatBubblePlacementStyle: a
    } = t;
    let s = this.instance.getContainer(xa.Container) ?? this.container, l;
    const c = a === Bi.Bar, f = 130 + (i ? 64 : 0), d = this.getBottom(t), p = c ? "10px" : "22px";
    switch (!0) {
      case (n && r):
        s.setAttribute("data-small-mode", "true"), Object.assign(s.style, {
          width: "100dvw",
          height: `${f + o + this.SHADOW * 2}px`,
          bottom: d,
          ...window.innerWidth >= this.mobileBreakPoint ? {
            right: p
          } : {
            right: "0px"
          }
        });
        break;
      case (n && !r):
        l = s.getAttribute("data-small-mode") === "true", s.setAttribute("data-small-mode", "false"), Object.assign(s.style, {
          width: "100dvw",
          transition: l ? "height 0.3s cubic-bezier(0.65, 0.05, 0.36, 1) 0s" : "none",
          ...window.innerWidth >= this.mobileBreakPoint ? {
            right: p,
            bottom: d,
            height: `calc(90dvh - ${d})`
          } : {
            right: "0px",
            bottom: "0px",
            height: "90dvh"
          }
        }), setTimeout(() => {
          Object.assign(s.style, {
            transition: "none"
          });
        }, 300);
        break;
      case !n:
        Object.assign(s.style, {
          width: "0px",
          height: "0px"
        });
        break;
    }
  }
}
class JTe {
  constructor(t, n, r, i) {
    this.container = t, this.iframeContainer = n, this.mobileBreakPoint = r ?? 441, this.isIndependentLauncherFeature = i;
  }
  perform() {
    this.action();
  }
  action() {
    const t = {
      border: "0px",
      "background-color": "transparent",
      "pointer-events": "none",
      "z-index": "999",
      position: "fixed",
      overflow: "hidden",
      opacity: "1",
      width: "0px",
      height: "0px",
      ...this.isIndependentLauncherFeature ? {
        "max-width": "441px",
        // TODO: 420px + 20px box shadow
        right: "22px",
        "max-height": "700px",
        ...window.innerWidth >= this.mobileBreakPoint ? {
          bottom: "86px"
        } : {
          bottom: 0
        }
      } : {
        "max-width": "442px",
        // TODO: 432px + 10px box shadow
        "max-height": "90dvh",
        bottom: "0px",
        right: "0px"
      }
    }, n = {
      "user-select": "none",
      "pointer-events": "all",
      background: "transparent",
      border: "0px",
      float: "none",
      position: "absolute",
      inset: "0px",
      width: "100%",
      height: "100%",
      margin: "0px",
      "min-height": "0px",
      ...!this.isIndependentLauncherFeature && { padding: "0px" }
    };
    Object.assign(this.container.style, t), Object.assign(this.iframeContainer.style, n), document.body.appendChild(this.container);
  }
}
class ZTe {
  constructor(t, n, r, i) {
    this.webChatId = t, this.configs = n, this.instance = Nr.create(t), this.container = r, this.webchatContainer = this.instance.getContainer(xa.Container) ?? this.container, this.mobileBreakPoint = i;
  }
  perform(t) {
    this.action(t);
  }
  action(t) {
    const { isPopupShown: n, isPopupSmallMode: r, isLauncherAlwaysShow: i, showSmallPopupStarterQuestions: o } = t, a = {
      SHADOW: 10,
      BOTTOM: 86,
      CONTAINER_WITHOUT_MESSAGE_HEIGHT: 130 + (o ? 64 : 0)
    };
    switch (!0) {
      case (n && i && r):
        this.setSmallPopupStyles(t, a);
        break;
      case (n && !i && r):
        this.setSmallPopupNoLauncherStyles(t, a);
        break;
      case (n && i && !r):
        this.setBigPopupStyles(t, a);
        break;
      case (n && !i && !r):
        this.setBigPopupNoLauncherStyles(t, a);
        break;
      case (!n && i):
        this.setHidePopupStyles(t, a);
        break;
      case (!n && !i):
        this.setHidePopupNoLauncherStyles(t, a);
        break;
    }
  }
  setSmallPopupStyles(t, n) {
    const { welcomeMessageHeight: r } = t, { SHADOW: i, BOTTOM: o, CONTAINER_WITHOUT_MESSAGE_HEIGHT: a } = n;
    this.webchatContainer.setAttribute("data-small-mode", "true"), Object.assign(this.webchatContainer.style, {
      width: "100dvw",
      height: `${a + o + i * 2 + r}px`,
      bottom: "0px"
    });
  }
  setSmallPopupNoLauncherStyles(t, n) {
    const { welcomeMessageHeight: r } = t, { SHADOW: i, BOTTOM: o, CONTAINER_WITHOUT_MESSAGE_HEIGHT: a } = n;
    this.webchatContainer.setAttribute("data-small-mode", "true"), Object.assign(this.webchatContainer.style, {
      width: "100dvw",
      height: `${a + i * 2 + r}px`,
      bottom: `${o}px`
    });
  }
  setBigPopupStyles(t, n) {
    const r = this.webchatContainer.getAttribute("data-small-mode") === "true";
    this.webchatContainer.setAttribute("data-small-mode", "false"), Object.assign(this.webchatContainer.style, {
      width: "100dvw",
      height: "100dvh",
      bottom: "0px",
      transition: r ? "height 0.3s cubic-bezier(0.65, 0.05, 0.36, 1) 0s" : "none"
    }), setTimeout(() => {
      Object.assign(this.webchatContainer.style, {
        transition: "none"
      });
    }, 300);
  }
  setBigPopupNoLauncherStyles(t, n) {
    const { BOTTOM: r } = n, i = this.webchatContainer.getAttribute("data-small-mode") === "true";
    this.webchatContainer.setAttribute("data-small-mode", "false"), Object.assign(this.webchatContainer.style, {
      width: "100dvw",
      height: "100dvh",
      transition: i ? "height 0.3s cubic-bezier(0.65, 0.05, 0.36, 1) 0s" : "none",
      ...window.innerWidth >= this.mobileBreakPoint ? {
        "max-height": "calc(90dvh - 86px)",
        // 96px - 10px bottom box-shadow
        bottom: `${r}px`
      } : {
        "max-height": "90dvh",
        bottom: "0px"
      }
    }), setTimeout(() => {
      Object.assign(this.webchatContainer.style, {
        transition: "none"
      });
    }, 300);
  }
  setHidePopupStyles(t, n) {
    const { chatBubblePlacementStyle: r } = t, i = r === Bi.Bar;
    Object.assign(this.webchatContainer.style, {
      width: i ? "300px" : "100px",
      height: "100px",
      bottom: "0px",
      transition: "none"
    });
  }
  setHidePopupNoLauncherStyles(t, n) {
    Object.assign(this.webchatContainer.style, {
      width: "0px",
      height: "0px",
      bottom: "0px",
      transition: "none"
    });
  }
}
class eIe {
  constructor(t) {
    this.featureFlagService = t;
  }
  perform(t) {
    if (this.featureFlagService.isFeatureEnabled())
      return this.action(t);
  }
  action(t) {
    throw new Error(`Should Replace ${t}`);
  }
}
class tIe extends eIe {
  action(t) {
    const { webchatId: n, type: r, url: i } = t;
    if (r !== Jo.SiteCompanion)
      return `webchat-${n}`;
    const o = window.location != window.parent.location ? document.referrer : document.location.href, a = new URL(i ?? o);
    a.search = "";
    const s = a.toString();
    return `${n}-${s}`;
  }
}
class nIe {
  constructor(t, n, r) {
    this.container = t, this.iframeContainer = n, this.mobileBreakPoint = r ?? 441;
  }
  perform() {
    this.action();
  }
  action() {
    const t = {
      height: 0,
      width: 0,
      opacity: 0,
      pointerEvents: "none"
    }, n = {
      height: "100%",
      width: "100%"
    };
    Object.assign(this.container.style, t), Object.assign(this.iframeContainer.style, n), document.body.appendChild(this.container);
  }
}
class rIe {
  constructor(t, n, r) {
    this.webChatId = t, this.configs = n, this.instance = Nr.create(t), this.mobileBreakPoint = r;
  }
  perform(t) {
    this.action(t);
  }
  action(t) {
    const { isPopupShown: n } = t, r = this.instance.getContainer(xa.Container), i = this.instance.getContainer(xa.Iframe);
    !r || !i || (n ? this.setFullScreenStyles(r, i) : this.setHiddenStyles(r, i));
  }
  setFullScreenStyles(t, n) {
    const r = {
      position: "fixed",
      inset: "0px",
      zIndex: 1e3,
      background: "rgba(0, 0, 0, 0.4)",
      transition: "background 0.3s ease-out",
      overflow: "hidden",
      ...window.innerWidth >= this.mobileBreakPoint ? {
        padding: window.innerWidth * 0.8 >= this.mobileBreakPoint ? "6% 10%" : "80px 20px"
      } : {
        padding: "10dvh 0px 0px"
      }
    }, i = {
      background: "transparent",
      border: "0px",
      height: "100%",
      width: "100%",
      ...window.innerWidth >= this.mobileBreakPoint && {
        width: "672px",
        // Note: we override the width to 100% in <BotDetailsPreview /> for bot setting page
        margin: "0 auto",
        display: "block"
      }
    };
    t.style.cssText = "", n.style.cssText = "", Object.assign(t.style, r), Object.assign(n.style, i);
  }
  setHiddenStyles(t, n) {
    const r = {
      height: 0,
      width: 0,
      opacity: 0,
      pointerEvents: "none"
    }, i = {
      height: "100%",
      width: "100%"
    };
    t.style.cssText = "", n.style.cssText = "", Object.assign(t.style, r), Object.assign(n.style, i);
  }
}
var W1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
W1.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, f = "__lodash_placeholder__", d = 1, p = 2, g = 4, v = 1, y = 2, x = 1, b = 2, w = 4, S = 8, E = 16, O = 32, $ = 64, P = 128, R = 256, L = 512, B = 30, j = "...", A = 800, T = 16, k = 1, F = 2, W = 3, V = 1 / 0, G = 9007199254740991, X = 17976931348623157e292, D = NaN, te = 4294967295, ee = te - 1, U = te >>> 1, he = [
      ["ary", P],
      ["bind", x],
      ["bindKey", b],
      ["curry", S],
      ["curryRight", E],
      ["flip", L],
      ["partial", O],
      ["partialRight", $],
      ["rearg", R]
    ], re = "[object Arguments]", de = "[object Array]", we = "[object AsyncFunction]", ue = "[object Boolean]", me = "[object Date]", Se = "[object DOMException]", _e = "[object Error]", Ge = "[object Function]", Fe = "[object GeneratorFunction]", Ae = "[object Map]", Me = "[object Number]", et = "[object Null]", De = "[object Object]", je = "[object Promise]", ie = "[object Proxy]", fe = "[object RegExp]", be = "[object Set]", Te = "[object String]", Le = "[object Symbol]", ct = "[object Undefined]", Z = "[object WeakMap]", se = "[object WeakSet]", Ce = "[object ArrayBuffer]", Pe = "[object DataView]", Ee = "[object Float32Array]", We = "[object Float64Array]", ze = "[object Int8Array]", Ye = "[object Int16Array]", xt = "[object Int32Array]", Lt = "[object Uint8Array]", mt = "[object Uint8ClampedArray]", St = "[object Uint16Array]", Et = "[object Uint32Array]", Je = /\b__p \+= '';/g, Ze = /\b(__p \+=) '' \+/g, ut = /(__e\(.*?\)|\b__t\)) \+\n'';/g, cn = /&(?:amp|lt|gt|quot|#39);/g, un = /[&<>"']/g, bn = RegExp(cn.source), tt = RegExp(un.source), Qe = /<%-([\s\S]+?)%>/g, rn = /<%([\s\S]+?)%>/g, Xe = /<%=([\s\S]+?)%>/g, it = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, _t = /^\w*$/, Yt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, gn = /[\\^$.*+?()[\]{}|]/g, Zt = RegExp(gn.source), dr = /^\s+/, pr = /\s/, Gn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Mn = /\{\n\/\* \[wrapped with (.+)\] \*/, Hr = /,? & /, Nn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, bt = /[()=,{}\[\]\/\s]/, ht = /\\(\\)?/g, Ht = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Sn = /\w*$/, hr = /^[-+]0x[0-9a-f]+$/i, In = /^0b[01]+$/i, Kn = /^\[object .+?Constructor\]$/, vi = /^0o[0-7]+$/i, Vt = /^(?:0|[1-9]\d*)$/, Sr = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Xr = /($^)/, Ri = /['\n\r\u2028\u2029\\]/g, Dr = "\\ud800-\\udfff", Or = "\\u0300-\\u036f", qi = "\\ufe20-\\ufe2f", Yi = "\\u20d0-\\u20ff", jr = Or + qi + Yi, Xi = "\\u2700-\\u27bf", qn = "a-z\\xdf-\\xf6\\xf8-\\xff", Qn = "\\xac\\xb1\\xd7\\xf7", Jn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Wr = "\\u2000-\\u206f", oi = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", nr = "A-Z\\xc0-\\xd6\\xd8-\\xde", Qi = "\\ufe0e\\ufe0f", Kt = Qn + Jn + Wr + oi, wt = "['’]", an = "[" + Dr + "]", rr = "[" + Kt + "]", kn = "[" + jr + "]", Fr = "\\d+", ai = "[" + Xi + "]", Ao = "[" + qn + "]", si = "[^" + Dr + Kt + Fr + Xi + qn + nr + "]", yi = "\\ud83c[\\udffb-\\udfff]", Mi = "(?:" + kn + "|" + yi + ")", Ji = "[^" + Dr + "]", Ni = "(?:\\ud83c[\\udde6-\\uddff]){2}", ta = "[\\ud800-\\udbff][\\udc00-\\udfff]", wn = "[" + nr + "]", Ro = "\\u200d", ir = "(?:" + Ao + "|" + si + ")", mr = "(?:" + wn + "|" + si + ")", bi = "(?:" + wt + "(?:d|ll|m|re|s|t|ve))?", wi = "(?:" + wt + "(?:D|LL|M|RE|S|T|VE))?", Zi = Mi + "?", eo = "[" + Qi + "]?", Mo = "(?:" + Ro + "(?:" + [Ji, Ni, ta].join("|") + ")" + eo + Zi + ")*", ys = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Na = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ka = eo + Zi + Mo, bs = "(?:" + [ai, Ni, ta].join("|") + ")" + ka, xe = "(?:" + [Ji + kn + "?", kn, Ni, ta, an].join("|") + ")", He = RegExp(wt, "g"), Nt = RegExp(kn, "g"), Wt = RegExp(yi + "(?=" + yi + ")|" + xe + ka, "g"), kt = RegExp([
      wn + "?" + Ao + "+" + bi + "(?=" + [rr, wn, "$"].join("|") + ")",
      mr + "+" + wi + "(?=" + [rr, wn + ir, "$"].join("|") + ")",
      wn + "?" + ir + "+" + bi,
      wn + "+" + wi,
      Na,
      ys,
      Fr,
      bs
    ].join("|"), "g"), na = RegExp("[" + Ro + Dr + jr + Qi + "]"), ws = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, il = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ra = -1, Zn = {};
    Zn[Ee] = Zn[We] = Zn[ze] = Zn[Ye] = Zn[xt] = Zn[Lt] = Zn[mt] = Zn[St] = Zn[Et] = !0, Zn[re] = Zn[de] = Zn[Ce] = Zn[ue] = Zn[Pe] = Zn[me] = Zn[_e] = Zn[Ge] = Zn[Ae] = Zn[Me] = Zn[De] = Zn[fe] = Zn[be] = Zn[Te] = Zn[Z] = !1;
    var ot = {};
    ot[re] = ot[de] = ot[Ce] = ot[Pe] = ot[ue] = ot[me] = ot[Ee] = ot[We] = ot[ze] = ot[Ye] = ot[xt] = ot[Ae] = ot[Me] = ot[De] = ot[fe] = ot[be] = ot[Te] = ot[Le] = ot[Lt] = ot[mt] = ot[St] = ot[Et] = !0, ot[_e] = ot[Ge] = ot[Z] = !1;
    var Dh = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, od = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, vC = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, yC = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, zv = parseFloat, bC = parseInt, Uv = typeof qa == "object" && qa && qa.Object === Object && qa, wC = typeof self == "object" && self && self.Object === Object && self, li = Uv || wC || Function("return this")(), jh = t && !t.nodeType && t, _c = jh && !0 && e && !e.nodeType && e, Hv = _c && _c.exports === jh, Fh = Hv && Uv.process, ia = function() {
      try {
        var ae = _c && _c.require && _c.require("util").types;
        return ae || Fh && Fh.binding && Fh.binding("util");
      } catch {
      }
    }(), Wv = ia && ia.isArrayBuffer, Vv = ia && ia.isDate, Gv = ia && ia.isMap, Kv = ia && ia.isRegExp, qv = ia && ia.isSet, Yv = ia && ia.isTypedArray;
    function yo(ae, Oe, ve) {
      switch (ve.length) {
        case 0:
          return ae.call(Oe);
        case 1:
          return ae.call(Oe, ve[0]);
        case 2:
          return ae.call(Oe, ve[0], ve[1]);
        case 3:
          return ae.call(Oe, ve[0], ve[1], ve[2]);
      }
      return ae.apply(Oe, ve);
    }
    function SC(ae, Oe, ve, at) {
      for (var Gt = -1, On = ae == null ? 0 : ae.length; ++Gt < On; ) {
        var ci = ae[Gt];
        Oe(at, ci, ve(ci), ae);
      }
      return at;
    }
    function No(ae, Oe) {
      for (var ve = -1, at = ae == null ? 0 : ae.length; ++ve < at && Oe(ae[ve], ve, ae) !== !1; )
        ;
      return ae;
    }
    function xC(ae, Oe) {
      for (var ve = ae == null ? 0 : ae.length; ve-- && Oe(ae[ve], ve, ae) !== !1; )
        ;
      return ae;
    }
    function Xv(ae, Oe) {
      for (var ve = -1, at = ae == null ? 0 : ae.length; ++ve < at; )
        if (!Oe(ae[ve], ve, ae))
          return !1;
      return !0;
    }
    function ol(ae, Oe) {
      for (var ve = -1, at = ae == null ? 0 : ae.length, Gt = 0, On = []; ++ve < at; ) {
        var ci = ae[ve];
        Oe(ci, ve, ae) && (On[Gt++] = ci);
      }
      return On;
    }
    function ad(ae, Oe) {
      var ve = ae == null ? 0 : ae.length;
      return !!ve && Ke(ae, Oe, 0) > -1;
    }
    function Bh(ae, Oe, ve) {
      for (var at = -1, Gt = ae == null ? 0 : ae.length; ++at < Gt; )
        if (ve(Oe, ae[at]))
          return !0;
      return !1;
    }
    function or(ae, Oe) {
      for (var ve = -1, at = ae == null ? 0 : ae.length, Gt = Array(at); ++ve < at; )
        Gt[ve] = Oe(ae[ve], ve, ae);
      return Gt;
    }
    function ar(ae, Oe) {
      for (var ve = -1, at = Oe.length, Gt = ae.length; ++ve < at; )
        ae[Gt + ve] = Oe[ve];
      return ae;
    }
    function Bu(ae, Oe, ve, at) {
      var Gt = -1, On = ae == null ? 0 : ae.length;
      for (at && On && (ve = ae[++Gt]); ++Gt < On; )
        ve = Oe(ve, ae[Gt], Gt, ae);
      return ve;
    }
    function CC(ae, Oe, ve, at) {
      var Gt = ae == null ? 0 : ae.length;
      for (at && Gt && (ve = ae[--Gt]); Gt--; )
        ve = Oe(ve, ae[Gt], Gt, ae);
      return ve;
    }
    function N(ae, Oe) {
      for (var ve = -1, at = ae == null ? 0 : ae.length; ++ve < at; )
        if (Oe(ae[ve], ve, ae))
          return !0;
      return !1;
    }
    var _ = xn("length");
    function M(ae) {
      return ae.split("");
    }
    function Y(ae) {
      return ae.match(Nn) || [];
    }
    function Q(ae, Oe, ve) {
      var at;
      return ve(ae, function(Gt, On, ci) {
        if (Oe(Gt, On, ci))
          return at = On, !1;
      }), at;
    }
    function $e(ae, Oe, ve, at) {
      for (var Gt = ae.length, On = ve + (at ? 1 : -1); at ? On-- : ++On < Gt; )
        if (Oe(ae[On], On, ae))
          return On;
      return -1;
    }
    function Ke(ae, Oe, ve) {
      return Oe === Oe ? qX(ae, Oe, ve) : $e(ae, Bt, ve);
    }
    function dt(ae, Oe, ve, at) {
      for (var Gt = ve - 1, On = ae.length; ++Gt < On; )
        if (at(ae[Gt], Oe))
          return Gt;
      return -1;
    }
    function Bt(ae) {
      return ae !== ae;
    }
    function vn(ae, Oe) {
      var ve = ae == null ? 0 : ae.length;
      return ve ? sd(ae, Oe) / ve : D;
    }
    function xn(ae) {
      return function(Oe) {
        return Oe == null ? n : Oe[ae];
      };
    }
    function xr(ae) {
      return function(Oe) {
        return ae == null ? n : ae[Oe];
      };
    }
    function zu(ae, Oe, ve, at, Gt) {
      return Gt(ae, function(On, ci, er) {
        ve = at ? (at = !1, On) : Oe(ve, On, ci, er);
      }), ve;
    }
    function EC(ae, Oe) {
      var ve = ae.length;
      for (ae.sort(Oe); ve--; )
        ae[ve] = ae[ve].value;
      return ae;
    }
    function sd(ae, Oe) {
      for (var ve, at = -1, Gt = ae.length; ++at < Gt; ) {
        var On = Oe(ae[at]);
        On !== n && (ve = ve === n ? On : ve + On);
      }
      return ve;
    }
    function zh(ae, Oe) {
      for (var ve = -1, at = Array(ae); ++ve < ae; )
        at[ve] = Oe(ve);
      return at;
    }
    function Qv(ae, Oe) {
      return or(Oe, function(ve) {
        return [ve, ae[ve]];
      });
    }
    function Jv(ae) {
      return ae && ae.slice(0, iN(ae) + 1).replace(dr, "");
    }
    function to(ae) {
      return function(Oe) {
        return ae(Oe);
      };
    }
    function Uh(ae, Oe) {
      return or(Oe, function(ve) {
        return ae[ve];
      });
    }
    function Uu(ae, Oe) {
      return ae.has(Oe);
    }
    function Hh(ae, Oe) {
      for (var ve = -1, at = ae.length; ++ve < at && Ke(Oe, ae[ve], 0) > -1; )
        ;
      return ve;
    }
    function Wh(ae, Oe) {
      for (var ve = ae.length; ve-- && Ke(Oe, ae[ve], 0) > -1; )
        ;
      return ve;
    }
    function Zv(ae, Oe) {
      for (var ve = ae.length, at = 0; ve--; )
        ae[ve] === Oe && ++at;
      return at;
    }
    var Vh = xr(Dh), Gh = xr(od);
    function ey(ae) {
      return "\\" + yC[ae];
    }
    function $C(ae, Oe) {
      return ae == null ? n : ae[Oe];
    }
    function Oc(ae) {
      return na.test(ae);
    }
    function _C(ae) {
      return ws.test(ae);
    }
    function OC(ae) {
      for (var Oe, ve = []; !(Oe = ae.next()).done; )
        ve.push(Oe.value);
      return ve;
    }
    function ld(ae) {
      var Oe = -1, ve = Array(ae.size);
      return ae.forEach(function(at, Gt) {
        ve[++Oe] = [Gt, at];
      }), ve;
    }
    function rN(ae, Oe) {
      return function(ve) {
        return ae(Oe(ve));
      };
    }
    function Pc(ae, Oe) {
      for (var ve = -1, at = ae.length, Gt = 0, On = []; ++ve < at; ) {
        var ci = ae[ve];
        (ci === Oe || ci === f) && (ae[ve] = f, On[Gt++] = ve);
      }
      return On;
    }
    function ty(ae) {
      var Oe = -1, ve = Array(ae.size);
      return ae.forEach(function(at) {
        ve[++Oe] = at;
      }), ve;
    }
    function KX(ae) {
      var Oe = -1, ve = Array(ae.size);
      return ae.forEach(function(at) {
        ve[++Oe] = [at, at];
      }), ve;
    }
    function qX(ae, Oe, ve) {
      for (var at = ve - 1, Gt = ae.length; ++at < Gt; )
        if (ae[at] === Oe)
          return at;
      return -1;
    }
    function YX(ae, Oe, ve) {
      for (var at = ve + 1; at--; )
        if (ae[at] === Oe)
          return at;
      return at;
    }
    function cd(ae) {
      return Oc(ae) ? QX(ae) : _(ae);
    }
    function Ss(ae) {
      return Oc(ae) ? JX(ae) : M(ae);
    }
    function iN(ae) {
      for (var Oe = ae.length; Oe-- && pr.test(ae.charAt(Oe)); )
        ;
      return Oe;
    }
    var XX = xr(vC);
    function QX(ae) {
      for (var Oe = Wt.lastIndex = 0; Wt.test(ae); )
        ++Oe;
      return Oe;
    }
    function JX(ae) {
      return ae.match(Wt) || [];
    }
    function ZX(ae) {
      return ae.match(kt) || [];
    }
    var eQ = function ae(Oe) {
      Oe = Oe == null ? li : ud.defaults(li.Object(), Oe, ud.pick(li, il));
      var ve = Oe.Array, at = Oe.Date, Gt = Oe.Error, On = Oe.Function, ci = Oe.Math, er = Oe.Object, PC = Oe.RegExp, tQ = Oe.String, La = Oe.TypeError, ny = ve.prototype, nQ = On.prototype, fd = er.prototype, ry = Oe["__core-js_shared__"], iy = nQ.toString, Ln = fd.hasOwnProperty, rQ = 0, oN = function() {
        var u = /[^.]+$/.exec(ry && ry.keys && ry.keys.IE_PROTO || "");
        return u ? "Symbol(src)_1." + u : "";
      }(), oy = fd.toString, iQ = iy.call(er), oQ = li._, aQ = PC(
        "^" + iy.call(Ln).replace(gn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), ay = Hv ? Oe.Buffer : n, Tc = Oe.Symbol, sy = Oe.Uint8Array, aN = ay ? ay.allocUnsafe : n, ly = rN(er.getPrototypeOf, er), sN = er.create, lN = fd.propertyIsEnumerable, cy = ny.splice, cN = Tc ? Tc.isConcatSpreadable : n, Kh = Tc ? Tc.iterator : n, Hu = Tc ? Tc.toStringTag : n, uy = function() {
        try {
          var u = qu(er, "defineProperty");
          return u({}, "", {}), u;
        } catch {
        }
      }(), sQ = Oe.clearTimeout !== li.clearTimeout && Oe.clearTimeout, lQ = at && at.now !== li.Date.now && at.now, cQ = Oe.setTimeout !== li.setTimeout && Oe.setTimeout, fy = ci.ceil, dy = ci.floor, TC = er.getOwnPropertySymbols, uQ = ay ? ay.isBuffer : n, uN = Oe.isFinite, fQ = ny.join, dQ = rN(er.keys, er), ui = ci.max, no = ci.min, pQ = at.now, hQ = Oe.parseInt, fN = ci.random, mQ = ny.reverse, IC = qu(Oe, "DataView"), qh = qu(Oe, "Map"), AC = qu(Oe, "Promise"), dd = qu(Oe, "Set"), Yh = qu(Oe, "WeakMap"), Xh = qu(er, "create"), py = Yh && new Yh(), pd = {}, gQ = Yu(IC), vQ = Yu(qh), yQ = Yu(AC), bQ = Yu(dd), wQ = Yu(Yh), hy = Tc ? Tc.prototype : n, Qh = hy ? hy.valueOf : n, dN = hy ? hy.toString : n;
      function K(u) {
        if (Br(u) && !qt(u) && !(u instanceof dn)) {
          if (u instanceof Da)
            return u;
          if (Ln.call(u, "__wrapped__"))
            return pk(u);
        }
        return new Da(u);
      }
      var hd = /* @__PURE__ */ function() {
        function u() {
        }
        return function(h) {
          if (!Pr(h))
            return {};
          if (sN)
            return sN(h);
          u.prototype = h;
          var C = new u();
          return u.prototype = n, C;
        };
      }();
      function my() {
      }
      function Da(u, h) {
        this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!h, this.__index__ = 0, this.__values__ = n;
      }
      K.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Qe,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: rn,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Xe,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: K
        }
      }, K.prototype = my.prototype, K.prototype.constructor = K, Da.prototype = hd(my.prototype), Da.prototype.constructor = Da;
      function dn(u) {
        this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = te, this.__views__ = [];
      }
      function SQ() {
        var u = new dn(this.__wrapped__);
        return u.__actions__ = ko(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = ko(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = ko(this.__views__), u;
      }
      function xQ() {
        if (this.__filtered__) {
          var u = new dn(this);
          u.__dir__ = -1, u.__filtered__ = !0;
        } else
          u = this.clone(), u.__dir__ *= -1;
        return u;
      }
      function CQ() {
        var u = this.__wrapped__.value(), h = this.__dir__, C = qt(u), I = h < 0, z = C ? u.length : 0, q = kJ(0, z, this.__views__), J = q.start, ne = q.end, le = ne - J, Re = I ? ne : J - 1, Ne = this.__iteratees__, Be = Ne.length, nt = 0, pt = no(le, this.__takeCount__);
        if (!C || !I && z == le && pt == le)
          return LN(u, this.__actions__);
        var Ot = [];
        e:
          for (; le-- && nt < pt; ) {
            Re += h;
            for (var en = -1, Pt = u[Re]; ++en < Be; ) {
              var fn = Ne[en], yn = fn.iteratee, sa = fn.type, So = yn(Pt);
              if (sa == F)
                Pt = So;
              else if (!So) {
                if (sa == k)
                  continue e;
                break e;
              }
            }
            Ot[nt++] = Pt;
          }
        return Ot;
      }
      dn.prototype = hd(my.prototype), dn.prototype.constructor = dn;
      function Wu(u) {
        var h = -1, C = u == null ? 0 : u.length;
        for (this.clear(); ++h < C; ) {
          var I = u[h];
          this.set(I[0], I[1]);
        }
      }
      function EQ() {
        this.__data__ = Xh ? Xh(null) : {}, this.size = 0;
      }
      function $Q(u) {
        var h = this.has(u) && delete this.__data__[u];
        return this.size -= h ? 1 : 0, h;
      }
      function _Q(u) {
        var h = this.__data__;
        if (Xh) {
          var C = h[u];
          return C === l ? n : C;
        }
        return Ln.call(h, u) ? h[u] : n;
      }
      function OQ(u) {
        var h = this.__data__;
        return Xh ? h[u] !== n : Ln.call(h, u);
      }
      function PQ(u, h) {
        var C = this.__data__;
        return this.size += this.has(u) ? 0 : 1, C[u] = Xh && h === n ? l : h, this;
      }
      Wu.prototype.clear = EQ, Wu.prototype.delete = $Q, Wu.prototype.get = _Q, Wu.prototype.has = OQ, Wu.prototype.set = PQ;
      function Fl(u) {
        var h = -1, C = u == null ? 0 : u.length;
        for (this.clear(); ++h < C; ) {
          var I = u[h];
          this.set(I[0], I[1]);
        }
      }
      function TQ() {
        this.__data__ = [], this.size = 0;
      }
      function IQ(u) {
        var h = this.__data__, C = gy(h, u);
        if (C < 0)
          return !1;
        var I = h.length - 1;
        return C == I ? h.pop() : cy.call(h, C, 1), --this.size, !0;
      }
      function AQ(u) {
        var h = this.__data__, C = gy(h, u);
        return C < 0 ? n : h[C][1];
      }
      function RQ(u) {
        return gy(this.__data__, u) > -1;
      }
      function MQ(u, h) {
        var C = this.__data__, I = gy(C, u);
        return I < 0 ? (++this.size, C.push([u, h])) : C[I][1] = h, this;
      }
      Fl.prototype.clear = TQ, Fl.prototype.delete = IQ, Fl.prototype.get = AQ, Fl.prototype.has = RQ, Fl.prototype.set = MQ;
      function Bl(u) {
        var h = -1, C = u == null ? 0 : u.length;
        for (this.clear(); ++h < C; ) {
          var I = u[h];
          this.set(I[0], I[1]);
        }
      }
      function NQ() {
        this.size = 0, this.__data__ = {
          hash: new Wu(),
          map: new (qh || Fl)(),
          string: new Wu()
        };
      }
      function kQ(u) {
        var h = Py(this, u).delete(u);
        return this.size -= h ? 1 : 0, h;
      }
      function LQ(u) {
        return Py(this, u).get(u);
      }
      function DQ(u) {
        return Py(this, u).has(u);
      }
      function jQ(u, h) {
        var C = Py(this, u), I = C.size;
        return C.set(u, h), this.size += C.size == I ? 0 : 1, this;
      }
      Bl.prototype.clear = NQ, Bl.prototype.delete = kQ, Bl.prototype.get = LQ, Bl.prototype.has = DQ, Bl.prototype.set = jQ;
      function Vu(u) {
        var h = -1, C = u == null ? 0 : u.length;
        for (this.__data__ = new Bl(); ++h < C; )
          this.add(u[h]);
      }
      function FQ(u) {
        return this.__data__.set(u, l), this;
      }
      function BQ(u) {
        return this.__data__.has(u);
      }
      Vu.prototype.add = Vu.prototype.push = FQ, Vu.prototype.has = BQ;
      function xs(u) {
        var h = this.__data__ = new Fl(u);
        this.size = h.size;
      }
      function zQ() {
        this.__data__ = new Fl(), this.size = 0;
      }
      function UQ(u) {
        var h = this.__data__, C = h.delete(u);
        return this.size = h.size, C;
      }
      function HQ(u) {
        return this.__data__.get(u);
      }
      function WQ(u) {
        return this.__data__.has(u);
      }
      function VQ(u, h) {
        var C = this.__data__;
        if (C instanceof Fl) {
          var I = C.__data__;
          if (!qh || I.length < i - 1)
            return I.push([u, h]), this.size = ++C.size, this;
          C = this.__data__ = new Bl(I);
        }
        return C.set(u, h), this.size = C.size, this;
      }
      xs.prototype.clear = zQ, xs.prototype.delete = UQ, xs.prototype.get = HQ, xs.prototype.has = WQ, xs.prototype.set = VQ;
      function pN(u, h) {
        var C = qt(u), I = !C && Xu(u), z = !C && !I && Nc(u), q = !C && !I && !z && yd(u), J = C || I || z || q, ne = J ? zh(u.length, tQ) : [], le = ne.length;
        for (var Re in u)
          (h || Ln.call(u, Re)) && !(J && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Re == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          z && (Re == "offset" || Re == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          q && (Re == "buffer" || Re == "byteLength" || Re == "byteOffset") || // Skip index properties.
          Wl(Re, le))) && ne.push(Re);
        return ne;
      }
      function hN(u) {
        var h = u.length;
        return h ? u[UC(0, h - 1)] : n;
      }
      function GQ(u, h) {
        return Ty(ko(u), Gu(h, 0, u.length));
      }
      function KQ(u) {
        return Ty(ko(u));
      }
      function RC(u, h, C) {
        (C !== n && !Cs(u[h], C) || C === n && !(h in u)) && zl(u, h, C);
      }
      function Jh(u, h, C) {
        var I = u[h];
        (!(Ln.call(u, h) && Cs(I, C)) || C === n && !(h in u)) && zl(u, h, C);
      }
      function gy(u, h) {
        for (var C = u.length; C--; )
          if (Cs(u[C][0], h))
            return C;
        return -1;
      }
      function qQ(u, h, C, I) {
        return Ic(u, function(z, q, J) {
          h(I, z, C(z), J);
        }), I;
      }
      function mN(u, h) {
        return u && sl(h, Si(h), u);
      }
      function YQ(u, h) {
        return u && sl(h, Do(h), u);
      }
      function zl(u, h, C) {
        h == "__proto__" && uy ? uy(u, h, {
          configurable: !0,
          enumerable: !0,
          value: C,
          writable: !0
        }) : u[h] = C;
      }
      function MC(u, h) {
        for (var C = -1, I = h.length, z = ve(I), q = u == null; ++C < I; )
          z[C] = q ? n : pE(u, h[C]);
        return z;
      }
      function Gu(u, h, C) {
        return u === u && (C !== n && (u = u <= C ? u : C), h !== n && (u = u >= h ? u : h)), u;
      }
      function ja(u, h, C, I, z, q) {
        var J, ne = h & d, le = h & p, Re = h & g;
        if (C && (J = z ? C(u, I, z, q) : C(u)), J !== n)
          return J;
        if (!Pr(u))
          return u;
        var Ne = qt(u);
        if (Ne) {
          if (J = DJ(u), !ne)
            return ko(u, J);
        } else {
          var Be = ro(u), nt = Be == Ge || Be == Fe;
          if (Nc(u))
            return FN(u, ne);
          if (Be == De || Be == re || nt && !z) {
            if (J = le || nt ? {} : ik(u), !ne)
              return le ? _J(u, YQ(J, u)) : $J(u, mN(J, u));
          } else {
            if (!ot[Be])
              return z ? u : {};
            J = jJ(u, Be, ne);
          }
        }
        q || (q = new xs());
        var pt = q.get(u);
        if (pt)
          return pt;
        q.set(u, J), Mk(u) ? u.forEach(function(Pt) {
          J.add(ja(Pt, h, C, Pt, u, q));
        }) : Ak(u) && u.forEach(function(Pt, fn) {
          J.set(fn, ja(Pt, h, C, fn, u, q));
        });
        var Ot = Re ? le ? ZC : JC : le ? Do : Si, en = Ne ? n : Ot(u);
        return No(en || u, function(Pt, fn) {
          en && (fn = Pt, Pt = u[fn]), Jh(J, fn, ja(Pt, h, C, fn, u, q));
        }), J;
      }
      function XQ(u) {
        var h = Si(u);
        return function(C) {
          return gN(C, u, h);
        };
      }
      function gN(u, h, C) {
        var I = C.length;
        if (u == null)
          return !I;
        for (u = er(u); I--; ) {
          var z = C[I], q = h[z], J = u[z];
          if (J === n && !(z in u) || !q(J))
            return !1;
        }
        return !0;
      }
      function vN(u, h, C) {
        if (typeof u != "function")
          throw new La(a);
        return om(function() {
          u.apply(n, C);
        }, h);
      }
      function Zh(u, h, C, I) {
        var z = -1, q = ad, J = !0, ne = u.length, le = [], Re = h.length;
        if (!ne)
          return le;
        C && (h = or(h, to(C))), I ? (q = Bh, J = !1) : h.length >= i && (q = Uu, J = !1, h = new Vu(h));
        e:
          for (; ++z < ne; ) {
            var Ne = u[z], Be = C == null ? Ne : C(Ne);
            if (Ne = I || Ne !== 0 ? Ne : 0, J && Be === Be) {
              for (var nt = Re; nt--; )
                if (h[nt] === Be)
                  continue e;
              le.push(Ne);
            } else
              q(h, Be, I) || le.push(Ne);
          }
        return le;
      }
      var Ic = WN(al), yN = WN(kC, !0);
      function QQ(u, h) {
        var C = !0;
        return Ic(u, function(I, z, q) {
          return C = !!h(I, z, q), C;
        }), C;
      }
      function vy(u, h, C) {
        for (var I = -1, z = u.length; ++I < z; ) {
          var q = u[I], J = h(q);
          if (J != null && (ne === n ? J === J && !aa(J) : C(J, ne)))
            var ne = J, le = q;
        }
        return le;
      }
      function JQ(u, h, C, I) {
        var z = u.length;
        for (C = Qt(C), C < 0 && (C = -C > z ? 0 : z + C), I = I === n || I > z ? z : Qt(I), I < 0 && (I += z), I = C > I ? 0 : kk(I); C < I; )
          u[C++] = h;
        return u;
      }
      function bN(u, h) {
        var C = [];
        return Ic(u, function(I, z, q) {
          h(I, z, q) && C.push(I);
        }), C;
      }
      function ki(u, h, C, I, z) {
        var q = -1, J = u.length;
        for (C || (C = BJ), z || (z = []); ++q < J; ) {
          var ne = u[q];
          h > 0 && C(ne) ? h > 1 ? ki(ne, h - 1, C, I, z) : ar(z, ne) : I || (z[z.length] = ne);
        }
        return z;
      }
      var NC = VN(), wN = VN(!0);
      function al(u, h) {
        return u && NC(u, h, Si);
      }
      function kC(u, h) {
        return u && wN(u, h, Si);
      }
      function yy(u, h) {
        return ol(h, function(C) {
          return Vl(u[C]);
        });
      }
      function Ku(u, h) {
        h = Rc(h, u);
        for (var C = 0, I = h.length; u != null && C < I; )
          u = u[ll(h[C++])];
        return C && C == I ? u : n;
      }
      function SN(u, h, C) {
        var I = h(u);
        return qt(u) ? I : ar(I, C(u));
      }
      function bo(u) {
        return u == null ? u === n ? ct : et : Hu && Hu in er(u) ? NJ(u) : KJ(u);
      }
      function LC(u, h) {
        return u > h;
      }
      function ZQ(u, h) {
        return u != null && Ln.call(u, h);
      }
      function eJ(u, h) {
        return u != null && h in er(u);
      }
      function tJ(u, h, C) {
        return u >= no(h, C) && u < ui(h, C);
      }
      function DC(u, h, C) {
        for (var I = C ? Bh : ad, z = u[0].length, q = u.length, J = q, ne = ve(q), le = 1 / 0, Re = []; J--; ) {
          var Ne = u[J];
          J && h && (Ne = or(Ne, to(h))), le = no(Ne.length, le), ne[J] = !C && (h || z >= 120 && Ne.length >= 120) ? new Vu(J && Ne) : n;
        }
        Ne = u[0];
        var Be = -1, nt = ne[0];
        e:
          for (; ++Be < z && Re.length < le; ) {
            var pt = Ne[Be], Ot = h ? h(pt) : pt;
            if (pt = C || pt !== 0 ? pt : 0, !(nt ? Uu(nt, Ot) : I(Re, Ot, C))) {
              for (J = q; --J; ) {
                var en = ne[J];
                if (!(en ? Uu(en, Ot) : I(u[J], Ot, C)))
                  continue e;
              }
              nt && nt.push(Ot), Re.push(pt);
            }
          }
        return Re;
      }
      function nJ(u, h, C, I) {
        return al(u, function(z, q, J) {
          h(I, C(z), q, J);
        }), I;
      }
      function em(u, h, C) {
        h = Rc(h, u), u = lk(u, h);
        var I = u == null ? u : u[ll(Ba(h))];
        return I == null ? n : yo(I, u, C);
      }
      function xN(u) {
        return Br(u) && bo(u) == re;
      }
      function rJ(u) {
        return Br(u) && bo(u) == Ce;
      }
      function iJ(u) {
        return Br(u) && bo(u) == me;
      }
      function tm(u, h, C, I, z) {
        return u === h ? !0 : u == null || h == null || !Br(u) && !Br(h) ? u !== u && h !== h : oJ(u, h, C, I, tm, z);
      }
      function oJ(u, h, C, I, z, q) {
        var J = qt(u), ne = qt(h), le = J ? de : ro(u), Re = ne ? de : ro(h);
        le = le == re ? De : le, Re = Re == re ? De : Re;
        var Ne = le == De, Be = Re == De, nt = le == Re;
        if (nt && Nc(u)) {
          if (!Nc(h))
            return !1;
          J = !0, Ne = !1;
        }
        if (nt && !Ne)
          return q || (q = new xs()), J || yd(u) ? tk(u, h, C, I, z, q) : RJ(u, h, le, C, I, z, q);
        if (!(C & v)) {
          var pt = Ne && Ln.call(u, "__wrapped__"), Ot = Be && Ln.call(h, "__wrapped__");
          if (pt || Ot) {
            var en = pt ? u.value() : u, Pt = Ot ? h.value() : h;
            return q || (q = new xs()), z(en, Pt, C, I, q);
          }
        }
        return nt ? (q || (q = new xs()), MJ(u, h, C, I, z, q)) : !1;
      }
      function aJ(u) {
        return Br(u) && ro(u) == Ae;
      }
      function jC(u, h, C, I) {
        var z = C.length, q = z, J = !I;
        if (u == null)
          return !q;
        for (u = er(u); z--; ) {
          var ne = C[z];
          if (J && ne[2] ? ne[1] !== u[ne[0]] : !(ne[0] in u))
            return !1;
        }
        for (; ++z < q; ) {
          ne = C[z];
          var le = ne[0], Re = u[le], Ne = ne[1];
          if (J && ne[2]) {
            if (Re === n && !(le in u))
              return !1;
          } else {
            var Be = new xs();
            if (I)
              var nt = I(Re, Ne, le, u, h, Be);
            if (!(nt === n ? tm(Ne, Re, v | y, I, Be) : nt))
              return !1;
          }
        }
        return !0;
      }
      function CN(u) {
        if (!Pr(u) || UJ(u))
          return !1;
        var h = Vl(u) ? aQ : Kn;
        return h.test(Yu(u));
      }
      function sJ(u) {
        return Br(u) && bo(u) == fe;
      }
      function lJ(u) {
        return Br(u) && ro(u) == be;
      }
      function cJ(u) {
        return Br(u) && ky(u.length) && !!Zn[bo(u)];
      }
      function EN(u) {
        return typeof u == "function" ? u : u == null ? jo : typeof u == "object" ? qt(u) ? ON(u[0], u[1]) : _N(u) : Gk(u);
      }
      function FC(u) {
        if (!im(u))
          return dQ(u);
        var h = [];
        for (var C in er(u))
          Ln.call(u, C) && C != "constructor" && h.push(C);
        return h;
      }
      function uJ(u) {
        if (!Pr(u))
          return GJ(u);
        var h = im(u), C = [];
        for (var I in u)
          I == "constructor" && (h || !Ln.call(u, I)) || C.push(I);
        return C;
      }
      function BC(u, h) {
        return u < h;
      }
      function $N(u, h) {
        var C = -1, I = Lo(u) ? ve(u.length) : [];
        return Ic(u, function(z, q, J) {
          I[++C] = h(z, q, J);
        }), I;
      }
      function _N(u) {
        var h = tE(u);
        return h.length == 1 && h[0][2] ? ak(h[0][0], h[0][1]) : function(C) {
          return C === u || jC(C, u, h);
        };
      }
      function ON(u, h) {
        return rE(u) && ok(h) ? ak(ll(u), h) : function(C) {
          var I = pE(C, u);
          return I === n && I === h ? hE(C, u) : tm(h, I, v | y);
        };
      }
      function by(u, h, C, I, z) {
        u !== h && NC(h, function(q, J) {
          if (z || (z = new xs()), Pr(q))
            fJ(u, h, J, C, by, I, z);
          else {
            var ne = I ? I(oE(u, J), q, J + "", u, h, z) : n;
            ne === n && (ne = q), RC(u, J, ne);
          }
        }, Do);
      }
      function fJ(u, h, C, I, z, q, J) {
        var ne = oE(u, C), le = oE(h, C), Re = J.get(le);
        if (Re) {
          RC(u, C, Re);
          return;
        }
        var Ne = q ? q(ne, le, C + "", u, h, J) : n, Be = Ne === n;
        if (Be) {
          var nt = qt(le), pt = !nt && Nc(le), Ot = !nt && !pt && yd(le);
          Ne = le, nt || pt || Ot ? qt(ne) ? Ne = ne : Vr(ne) ? Ne = ko(ne) : pt ? (Be = !1, Ne = FN(le, !0)) : Ot ? (Be = !1, Ne = BN(le, !0)) : Ne = [] : am(le) || Xu(le) ? (Ne = ne, Xu(ne) ? Ne = Lk(ne) : (!Pr(ne) || Vl(ne)) && (Ne = ik(le))) : Be = !1;
        }
        Be && (J.set(le, Ne), z(Ne, le, I, q, J), J.delete(le)), RC(u, C, Ne);
      }
      function PN(u, h) {
        var C = u.length;
        if (C)
          return h += h < 0 ? C : 0, Wl(h, C) ? u[h] : n;
      }
      function TN(u, h, C) {
        h.length ? h = or(h, function(q) {
          return qt(q) ? function(J) {
            return Ku(J, q.length === 1 ? q[0] : q);
          } : q;
        }) : h = [jo];
        var I = -1;
        h = or(h, to($t()));
        var z = $N(u, function(q, J, ne) {
          var le = or(h, function(Re) {
            return Re(q);
          });
          return { criteria: le, index: ++I, value: q };
        });
        return EC(z, function(q, J) {
          return EJ(q, J, C);
        });
      }
      function dJ(u, h) {
        return IN(u, h, function(C, I) {
          return hE(u, I);
        });
      }
      function IN(u, h, C) {
        for (var I = -1, z = h.length, q = {}; ++I < z; ) {
          var J = h[I], ne = Ku(u, J);
          C(ne, J) && nm(q, Rc(J, u), ne);
        }
        return q;
      }
      function pJ(u) {
        return function(h) {
          return Ku(h, u);
        };
      }
      function zC(u, h, C, I) {
        var z = I ? dt : Ke, q = -1, J = h.length, ne = u;
        for (u === h && (h = ko(h)), C && (ne = or(u, to(C))); ++q < J; )
          for (var le = 0, Re = h[q], Ne = C ? C(Re) : Re; (le = z(ne, Ne, le, I)) > -1; )
            ne !== u && cy.call(ne, le, 1), cy.call(u, le, 1);
        return u;
      }
      function AN(u, h) {
        for (var C = u ? h.length : 0, I = C - 1; C--; ) {
          var z = h[C];
          if (C == I || z !== q) {
            var q = z;
            Wl(z) ? cy.call(u, z, 1) : VC(u, z);
          }
        }
        return u;
      }
      function UC(u, h) {
        return u + dy(fN() * (h - u + 1));
      }
      function hJ(u, h, C, I) {
        for (var z = -1, q = ui(fy((h - u) / (C || 1)), 0), J = ve(q); q--; )
          J[I ? q : ++z] = u, u += C;
        return J;
      }
      function HC(u, h) {
        var C = "";
        if (!u || h < 1 || h > G)
          return C;
        do
          h % 2 && (C += u), h = dy(h / 2), h && (u += u);
        while (h);
        return C;
      }
      function on(u, h) {
        return aE(sk(u, h, jo), u + "");
      }
      function mJ(u) {
        return hN(bd(u));
      }
      function gJ(u, h) {
        var C = bd(u);
        return Ty(C, Gu(h, 0, C.length));
      }
      function nm(u, h, C, I) {
        if (!Pr(u))
          return u;
        h = Rc(h, u);
        for (var z = -1, q = h.length, J = q - 1, ne = u; ne != null && ++z < q; ) {
          var le = ll(h[z]), Re = C;
          if (le === "__proto__" || le === "constructor" || le === "prototype")
            return u;
          if (z != J) {
            var Ne = ne[le];
            Re = I ? I(Ne, le, ne) : n, Re === n && (Re = Pr(Ne) ? Ne : Wl(h[z + 1]) ? [] : {});
          }
          Jh(ne, le, Re), ne = ne[le];
        }
        return u;
      }
      var RN = py ? function(u, h) {
        return py.set(u, h), u;
      } : jo, vJ = uy ? function(u, h) {
        return uy(u, "toString", {
          configurable: !0,
          enumerable: !1,
          value: gE(h),
          writable: !0
        });
      } : jo;
      function yJ(u) {
        return Ty(bd(u));
      }
      function Fa(u, h, C) {
        var I = -1, z = u.length;
        h < 0 && (h = -h > z ? 0 : z + h), C = C > z ? z : C, C < 0 && (C += z), z = h > C ? 0 : C - h >>> 0, h >>>= 0;
        for (var q = ve(z); ++I < z; )
          q[I] = u[I + h];
        return q;
      }
      function bJ(u, h) {
        var C;
        return Ic(u, function(I, z, q) {
          return C = h(I, z, q), !C;
        }), !!C;
      }
      function wy(u, h, C) {
        var I = 0, z = u == null ? I : u.length;
        if (typeof h == "number" && h === h && z <= U) {
          for (; I < z; ) {
            var q = I + z >>> 1, J = u[q];
            J !== null && !aa(J) && (C ? J <= h : J < h) ? I = q + 1 : z = q;
          }
          return z;
        }
        return WC(u, h, jo, C);
      }
      function WC(u, h, C, I) {
        var z = 0, q = u == null ? 0 : u.length;
        if (q === 0)
          return 0;
        h = C(h);
        for (var J = h !== h, ne = h === null, le = aa(h), Re = h === n; z < q; ) {
          var Ne = dy((z + q) / 2), Be = C(u[Ne]), nt = Be !== n, pt = Be === null, Ot = Be === Be, en = aa(Be);
          if (J)
            var Pt = I || Ot;
          else
            Re ? Pt = Ot && (I || nt) : ne ? Pt = Ot && nt && (I || !pt) : le ? Pt = Ot && nt && !pt && (I || !en) : pt || en ? Pt = !1 : Pt = I ? Be <= h : Be < h;
          Pt ? z = Ne + 1 : q = Ne;
        }
        return no(q, ee);
      }
      function MN(u, h) {
        for (var C = -1, I = u.length, z = 0, q = []; ++C < I; ) {
          var J = u[C], ne = h ? h(J) : J;
          if (!C || !Cs(ne, le)) {
            var le = ne;
            q[z++] = J === 0 ? 0 : J;
          }
        }
        return q;
      }
      function NN(u) {
        return typeof u == "number" ? u : aa(u) ? D : +u;
      }
      function oa(u) {
        if (typeof u == "string")
          return u;
        if (qt(u))
          return or(u, oa) + "";
        if (aa(u))
          return dN ? dN.call(u) : "";
        var h = u + "";
        return h == "0" && 1 / u == -V ? "-0" : h;
      }
      function Ac(u, h, C) {
        var I = -1, z = ad, q = u.length, J = !0, ne = [], le = ne;
        if (C)
          J = !1, z = Bh;
        else if (q >= i) {
          var Re = h ? null : IJ(u);
          if (Re)
            return ty(Re);
          J = !1, z = Uu, le = new Vu();
        } else
          le = h ? [] : ne;
        e:
          for (; ++I < q; ) {
            var Ne = u[I], Be = h ? h(Ne) : Ne;
            if (Ne = C || Ne !== 0 ? Ne : 0, J && Be === Be) {
              for (var nt = le.length; nt--; )
                if (le[nt] === Be)
                  continue e;
              h && le.push(Be), ne.push(Ne);
            } else
              z(le, Be, C) || (le !== ne && le.push(Be), ne.push(Ne));
          }
        return ne;
      }
      function VC(u, h) {
        return h = Rc(h, u), u = lk(u, h), u == null || delete u[ll(Ba(h))];
      }
      function kN(u, h, C, I) {
        return nm(u, h, C(Ku(u, h)), I);
      }
      function Sy(u, h, C, I) {
        for (var z = u.length, q = I ? z : -1; (I ? q-- : ++q < z) && h(u[q], q, u); )
          ;
        return C ? Fa(u, I ? 0 : q, I ? q + 1 : z) : Fa(u, I ? q + 1 : 0, I ? z : q);
      }
      function LN(u, h) {
        var C = u;
        return C instanceof dn && (C = C.value()), Bu(h, function(I, z) {
          return z.func.apply(z.thisArg, ar([I], z.args));
        }, C);
      }
      function GC(u, h, C) {
        var I = u.length;
        if (I < 2)
          return I ? Ac(u[0]) : [];
        for (var z = -1, q = ve(I); ++z < I; )
          for (var J = u[z], ne = -1; ++ne < I; )
            ne != z && (q[z] = Zh(q[z] || J, u[ne], h, C));
        return Ac(ki(q, 1), h, C);
      }
      function DN(u, h, C) {
        for (var I = -1, z = u.length, q = h.length, J = {}; ++I < z; ) {
          var ne = I < q ? h[I] : n;
          C(J, u[I], ne);
        }
        return J;
      }
      function KC(u) {
        return Vr(u) ? u : [];
      }
      function qC(u) {
        return typeof u == "function" ? u : jo;
      }
      function Rc(u, h) {
        return qt(u) ? u : rE(u, h) ? [u] : dk(An(u));
      }
      var wJ = on;
      function Mc(u, h, C) {
        var I = u.length;
        return C = C === n ? I : C, !h && C >= I ? u : Fa(u, h, C);
      }
      var jN = sQ || function(u) {
        return li.clearTimeout(u);
      };
      function FN(u, h) {
        if (h)
          return u.slice();
        var C = u.length, I = aN ? aN(C) : new u.constructor(C);
        return u.copy(I), I;
      }
      function YC(u) {
        var h = new u.constructor(u.byteLength);
        return new sy(h).set(new sy(u)), h;
      }
      function SJ(u, h) {
        var C = h ? YC(u.buffer) : u.buffer;
        return new u.constructor(C, u.byteOffset, u.byteLength);
      }
      function xJ(u) {
        var h = new u.constructor(u.source, Sn.exec(u));
        return h.lastIndex = u.lastIndex, h;
      }
      function CJ(u) {
        return Qh ? er(Qh.call(u)) : {};
      }
      function BN(u, h) {
        var C = h ? YC(u.buffer) : u.buffer;
        return new u.constructor(C, u.byteOffset, u.length);
      }
      function zN(u, h) {
        if (u !== h) {
          var C = u !== n, I = u === null, z = u === u, q = aa(u), J = h !== n, ne = h === null, le = h === h, Re = aa(h);
          if (!ne && !Re && !q && u > h || q && J && le && !ne && !Re || I && J && le || !C && le || !z)
            return 1;
          if (!I && !q && !Re && u < h || Re && C && z && !I && !q || ne && C && z || !J && z || !le)
            return -1;
        }
        return 0;
      }
      function EJ(u, h, C) {
        for (var I = -1, z = u.criteria, q = h.criteria, J = z.length, ne = C.length; ++I < J; ) {
          var le = zN(z[I], q[I]);
          if (le) {
            if (I >= ne)
              return le;
            var Re = C[I];
            return le * (Re == "desc" ? -1 : 1);
          }
        }
        return u.index - h.index;
      }
      function UN(u, h, C, I) {
        for (var z = -1, q = u.length, J = C.length, ne = -1, le = h.length, Re = ui(q - J, 0), Ne = ve(le + Re), Be = !I; ++ne < le; )
          Ne[ne] = h[ne];
        for (; ++z < J; )
          (Be || z < q) && (Ne[C[z]] = u[z]);
        for (; Re--; )
          Ne[ne++] = u[z++];
        return Ne;
      }
      function HN(u, h, C, I) {
        for (var z = -1, q = u.length, J = -1, ne = C.length, le = -1, Re = h.length, Ne = ui(q - ne, 0), Be = ve(Ne + Re), nt = !I; ++z < Ne; )
          Be[z] = u[z];
        for (var pt = z; ++le < Re; )
          Be[pt + le] = h[le];
        for (; ++J < ne; )
          (nt || z < q) && (Be[pt + C[J]] = u[z++]);
        return Be;
      }
      function ko(u, h) {
        var C = -1, I = u.length;
        for (h || (h = ve(I)); ++C < I; )
          h[C] = u[C];
        return h;
      }
      function sl(u, h, C, I) {
        var z = !C;
        C || (C = {});
        for (var q = -1, J = h.length; ++q < J; ) {
          var ne = h[q], le = I ? I(C[ne], u[ne], ne, C, u) : n;
          le === n && (le = u[ne]), z ? zl(C, ne, le) : Jh(C, ne, le);
        }
        return C;
      }
      function $J(u, h) {
        return sl(u, nE(u), h);
      }
      function _J(u, h) {
        return sl(u, nk(u), h);
      }
      function xy(u, h) {
        return function(C, I) {
          var z = qt(C) ? SC : qQ, q = h ? h() : {};
          return z(C, u, $t(I, 2), q);
        };
      }
      function md(u) {
        return on(function(h, C) {
          var I = -1, z = C.length, q = z > 1 ? C[z - 1] : n, J = z > 2 ? C[2] : n;
          for (q = u.length > 3 && typeof q == "function" ? (z--, q) : n, J && wo(C[0], C[1], J) && (q = z < 3 ? n : q, z = 1), h = er(h); ++I < z; ) {
            var ne = C[I];
            ne && u(h, ne, I, q);
          }
          return h;
        });
      }
      function WN(u, h) {
        return function(C, I) {
          if (C == null)
            return C;
          if (!Lo(C))
            return u(C, I);
          for (var z = C.length, q = h ? z : -1, J = er(C); (h ? q-- : ++q < z) && I(J[q], q, J) !== !1; )
            ;
          return C;
        };
      }
      function VN(u) {
        return function(h, C, I) {
          for (var z = -1, q = er(h), J = I(h), ne = J.length; ne--; ) {
            var le = J[u ? ne : ++z];
            if (C(q[le], le, q) === !1)
              break;
          }
          return h;
        };
      }
      function OJ(u, h, C) {
        var I = h & x, z = rm(u);
        function q() {
          var J = this && this !== li && this instanceof q ? z : u;
          return J.apply(I ? C : this, arguments);
        }
        return q;
      }
      function GN(u) {
        return function(h) {
          h = An(h);
          var C = Oc(h) ? Ss(h) : n, I = C ? C[0] : h.charAt(0), z = C ? Mc(C, 1).join("") : h.slice(1);
          return I[u]() + z;
        };
      }
      function gd(u) {
        return function(h) {
          return Bu(Wk(Hk(h).replace(He, "")), u, "");
        };
      }
      function rm(u) {
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return new u();
            case 1:
              return new u(h[0]);
            case 2:
              return new u(h[0], h[1]);
            case 3:
              return new u(h[0], h[1], h[2]);
            case 4:
              return new u(h[0], h[1], h[2], h[3]);
            case 5:
              return new u(h[0], h[1], h[2], h[3], h[4]);
            case 6:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5]);
            case 7:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5], h[6]);
          }
          var C = hd(u.prototype), I = u.apply(C, h);
          return Pr(I) ? I : C;
        };
      }
      function PJ(u, h, C) {
        var I = rm(u);
        function z() {
          for (var q = arguments.length, J = ve(q), ne = q, le = vd(z); ne--; )
            J[ne] = arguments[ne];
          var Re = q < 3 && J[0] !== le && J[q - 1] !== le ? [] : Pc(J, le);
          if (q -= Re.length, q < C)
            return QN(
              u,
              h,
              Cy,
              z.placeholder,
              n,
              J,
              Re,
              n,
              n,
              C - q
            );
          var Ne = this && this !== li && this instanceof z ? I : u;
          return yo(Ne, this, J);
        }
        return z;
      }
      function KN(u) {
        return function(h, C, I) {
          var z = er(h);
          if (!Lo(h)) {
            var q = $t(C, 3);
            h = Si(h), C = function(ne) {
              return q(z[ne], ne, z);
            };
          }
          var J = u(h, C, I);
          return J > -1 ? z[q ? h[J] : J] : n;
        };
      }
      function qN(u) {
        return Hl(function(h) {
          var C = h.length, I = C, z = Da.prototype.thru;
          for (u && h.reverse(); I--; ) {
            var q = h[I];
            if (typeof q != "function")
              throw new La(a);
            if (z && !J && Oy(q) == "wrapper")
              var J = new Da([], !0);
          }
          for (I = J ? I : C; ++I < C; ) {
            q = h[I];
            var ne = Oy(q), le = ne == "wrapper" ? eE(q) : n;
            le && iE(le[0]) && le[1] == (P | S | O | R) && !le[4].length && le[9] == 1 ? J = J[Oy(le[0])].apply(J, le[3]) : J = q.length == 1 && iE(q) ? J[ne]() : J.thru(q);
          }
          return function() {
            var Re = arguments, Ne = Re[0];
            if (J && Re.length == 1 && qt(Ne))
              return J.plant(Ne).value();
            for (var Be = 0, nt = C ? h[Be].apply(this, Re) : Ne; ++Be < C; )
              nt = h[Be].call(this, nt);
            return nt;
          };
        });
      }
      function Cy(u, h, C, I, z, q, J, ne, le, Re) {
        var Ne = h & P, Be = h & x, nt = h & b, pt = h & (S | E), Ot = h & L, en = nt ? n : rm(u);
        function Pt() {
          for (var fn = arguments.length, yn = ve(fn), sa = fn; sa--; )
            yn[sa] = arguments[sa];
          if (pt)
            var So = vd(Pt), la = Zv(yn, So);
          if (I && (yn = UN(yn, I, z, pt)), q && (yn = HN(yn, q, J, pt)), fn -= la, pt && fn < Re) {
            var Gr = Pc(yn, So);
            return QN(
              u,
              h,
              Cy,
              Pt.placeholder,
              C,
              yn,
              Gr,
              ne,
              le,
              Re - fn
            );
          }
          var Es = Be ? C : this, Kl = nt ? Es[u] : u;
          return fn = yn.length, ne ? yn = qJ(yn, ne) : Ot && fn > 1 && yn.reverse(), Ne && le < fn && (yn.length = le), this && this !== li && this instanceof Pt && (Kl = en || rm(Kl)), Kl.apply(Es, yn);
        }
        return Pt;
      }
      function YN(u, h) {
        return function(C, I) {
          return nJ(C, u, h(I), {});
        };
      }
      function Ey(u, h) {
        return function(C, I) {
          var z;
          if (C === n && I === n)
            return h;
          if (C !== n && (z = C), I !== n) {
            if (z === n)
              return I;
            typeof C == "string" || typeof I == "string" ? (C = oa(C), I = oa(I)) : (C = NN(C), I = NN(I)), z = u(C, I);
          }
          return z;
        };
      }
      function XC(u) {
        return Hl(function(h) {
          return h = or(h, to($t())), on(function(C) {
            var I = this;
            return u(h, function(z) {
              return yo(z, I, C);
            });
          });
        });
      }
      function $y(u, h) {
        h = h === n ? " " : oa(h);
        var C = h.length;
        if (C < 2)
          return C ? HC(h, u) : h;
        var I = HC(h, fy(u / cd(h)));
        return Oc(h) ? Mc(Ss(I), 0, u).join("") : I.slice(0, u);
      }
      function TJ(u, h, C, I) {
        var z = h & x, q = rm(u);
        function J() {
          for (var ne = -1, le = arguments.length, Re = -1, Ne = I.length, Be = ve(Ne + le), nt = this && this !== li && this instanceof J ? q : u; ++Re < Ne; )
            Be[Re] = I[Re];
          for (; le--; )
            Be[Re++] = arguments[++ne];
          return yo(nt, z ? C : this, Be);
        }
        return J;
      }
      function XN(u) {
        return function(h, C, I) {
          return I && typeof I != "number" && wo(h, C, I) && (C = I = n), h = Gl(h), C === n ? (C = h, h = 0) : C = Gl(C), I = I === n ? h < C ? 1 : -1 : Gl(I), hJ(h, C, I, u);
        };
      }
      function _y(u) {
        return function(h, C) {
          return typeof h == "string" && typeof C == "string" || (h = za(h), C = za(C)), u(h, C);
        };
      }
      function QN(u, h, C, I, z, q, J, ne, le, Re) {
        var Ne = h & S, Be = Ne ? J : n, nt = Ne ? n : J, pt = Ne ? q : n, Ot = Ne ? n : q;
        h |= Ne ? O : $, h &= ~(Ne ? $ : O), h & w || (h &= ~(x | b));
        var en = [
          u,
          h,
          z,
          pt,
          Be,
          Ot,
          nt,
          ne,
          le,
          Re
        ], Pt = C.apply(n, en);
        return iE(u) && ck(Pt, en), Pt.placeholder = I, uk(Pt, u, h);
      }
      function QC(u) {
        var h = ci[u];
        return function(C, I) {
          if (C = za(C), I = I == null ? 0 : no(Qt(I), 292), I && uN(C)) {
            var z = (An(C) + "e").split("e"), q = h(z[0] + "e" + (+z[1] + I));
            return z = (An(q) + "e").split("e"), +(z[0] + "e" + (+z[1] - I));
          }
          return h(C);
        };
      }
      var IJ = dd && 1 / ty(new dd([, -0]))[1] == V ? function(u) {
        return new dd(u);
      } : bE;
      function JN(u) {
        return function(h) {
          var C = ro(h);
          return C == Ae ? ld(h) : C == be ? KX(h) : Qv(h, u(h));
        };
      }
      function Ul(u, h, C, I, z, q, J, ne) {
        var le = h & b;
        if (!le && typeof u != "function")
          throw new La(a);
        var Re = I ? I.length : 0;
        if (Re || (h &= ~(O | $), I = z = n), J = J === n ? J : ui(Qt(J), 0), ne = ne === n ? ne : Qt(ne), Re -= z ? z.length : 0, h & $) {
          var Ne = I, Be = z;
          I = z = n;
        }
        var nt = le ? n : eE(u), pt = [
          u,
          h,
          C,
          I,
          z,
          Ne,
          Be,
          q,
          J,
          ne
        ];
        if (nt && VJ(pt, nt), u = pt[0], h = pt[1], C = pt[2], I = pt[3], z = pt[4], ne = pt[9] = pt[9] === n ? le ? 0 : u.length : ui(pt[9] - Re, 0), !ne && h & (S | E) && (h &= ~(S | E)), !h || h == x)
          var Ot = OJ(u, h, C);
        else
          h == S || h == E ? Ot = PJ(u, h, ne) : (h == O || h == (x | O)) && !z.length ? Ot = TJ(u, h, C, I) : Ot = Cy.apply(n, pt);
        var en = nt ? RN : ck;
        return uk(en(Ot, pt), u, h);
      }
      function ZN(u, h, C, I) {
        return u === n || Cs(u, fd[C]) && !Ln.call(I, C) ? h : u;
      }
      function ek(u, h, C, I, z, q) {
        return Pr(u) && Pr(h) && (q.set(h, u), by(u, h, n, ek, q), q.delete(h)), u;
      }
      function AJ(u) {
        return am(u) ? n : u;
      }
      function tk(u, h, C, I, z, q) {
        var J = C & v, ne = u.length, le = h.length;
        if (ne != le && !(J && le > ne))
          return !1;
        var Re = q.get(u), Ne = q.get(h);
        if (Re && Ne)
          return Re == h && Ne == u;
        var Be = -1, nt = !0, pt = C & y ? new Vu() : n;
        for (q.set(u, h), q.set(h, u); ++Be < ne; ) {
          var Ot = u[Be], en = h[Be];
          if (I)
            var Pt = J ? I(en, Ot, Be, h, u, q) : I(Ot, en, Be, u, h, q);
          if (Pt !== n) {
            if (Pt)
              continue;
            nt = !1;
            break;
          }
          if (pt) {
            if (!N(h, function(fn, yn) {
              if (!Uu(pt, yn) && (Ot === fn || z(Ot, fn, C, I, q)))
                return pt.push(yn);
            })) {
              nt = !1;
              break;
            }
          } else if (!(Ot === en || z(Ot, en, C, I, q))) {
            nt = !1;
            break;
          }
        }
        return q.delete(u), q.delete(h), nt;
      }
      function RJ(u, h, C, I, z, q, J) {
        switch (C) {
          case Pe:
            if (u.byteLength != h.byteLength || u.byteOffset != h.byteOffset)
              return !1;
            u = u.buffer, h = h.buffer;
          case Ce:
            return !(u.byteLength != h.byteLength || !q(new sy(u), new sy(h)));
          case ue:
          case me:
          case Me:
            return Cs(+u, +h);
          case _e:
            return u.name == h.name && u.message == h.message;
          case fe:
          case Te:
            return u == h + "";
          case Ae:
            var ne = ld;
          case be:
            var le = I & v;
            if (ne || (ne = ty), u.size != h.size && !le)
              return !1;
            var Re = J.get(u);
            if (Re)
              return Re == h;
            I |= y, J.set(u, h);
            var Ne = tk(ne(u), ne(h), I, z, q, J);
            return J.delete(u), Ne;
          case Le:
            if (Qh)
              return Qh.call(u) == Qh.call(h);
        }
        return !1;
      }
      function MJ(u, h, C, I, z, q) {
        var J = C & v, ne = JC(u), le = ne.length, Re = JC(h), Ne = Re.length;
        if (le != Ne && !J)
          return !1;
        for (var Be = le; Be--; ) {
          var nt = ne[Be];
          if (!(J ? nt in h : Ln.call(h, nt)))
            return !1;
        }
        var pt = q.get(u), Ot = q.get(h);
        if (pt && Ot)
          return pt == h && Ot == u;
        var en = !0;
        q.set(u, h), q.set(h, u);
        for (var Pt = J; ++Be < le; ) {
          nt = ne[Be];
          var fn = u[nt], yn = h[nt];
          if (I)
            var sa = J ? I(yn, fn, nt, h, u, q) : I(fn, yn, nt, u, h, q);
          if (!(sa === n ? fn === yn || z(fn, yn, C, I, q) : sa)) {
            en = !1;
            break;
          }
          Pt || (Pt = nt == "constructor");
        }
        if (en && !Pt) {
          var So = u.constructor, la = h.constructor;
          So != la && "constructor" in u && "constructor" in h && !(typeof So == "function" && So instanceof So && typeof la == "function" && la instanceof la) && (en = !1);
        }
        return q.delete(u), q.delete(h), en;
      }
      function Hl(u) {
        return aE(sk(u, n, gk), u + "");
      }
      function JC(u) {
        return SN(u, Si, nE);
      }
      function ZC(u) {
        return SN(u, Do, nk);
      }
      var eE = py ? function(u) {
        return py.get(u);
      } : bE;
      function Oy(u) {
        for (var h = u.name + "", C = pd[h], I = Ln.call(pd, h) ? C.length : 0; I--; ) {
          var z = C[I], q = z.func;
          if (q == null || q == u)
            return z.name;
        }
        return h;
      }
      function vd(u) {
        var h = Ln.call(K, "placeholder") ? K : u;
        return h.placeholder;
      }
      function $t() {
        var u = K.iteratee || vE;
        return u = u === vE ? EN : u, arguments.length ? u(arguments[0], arguments[1]) : u;
      }
      function Py(u, h) {
        var C = u.__data__;
        return zJ(h) ? C[typeof h == "string" ? "string" : "hash"] : C.map;
      }
      function tE(u) {
        for (var h = Si(u), C = h.length; C--; ) {
          var I = h[C], z = u[I];
          h[C] = [I, z, ok(z)];
        }
        return h;
      }
      function qu(u, h) {
        var C = $C(u, h);
        return CN(C) ? C : n;
      }
      function NJ(u) {
        var h = Ln.call(u, Hu), C = u[Hu];
        try {
          u[Hu] = n;
          var I = !0;
        } catch {
        }
        var z = oy.call(u);
        return I && (h ? u[Hu] = C : delete u[Hu]), z;
      }
      var nE = TC ? function(u) {
        return u == null ? [] : (u = er(u), ol(TC(u), function(h) {
          return lN.call(u, h);
        }));
      } : wE, nk = TC ? function(u) {
        for (var h = []; u; )
          ar(h, nE(u)), u = ly(u);
        return h;
      } : wE, ro = bo;
      (IC && ro(new IC(new ArrayBuffer(1))) != Pe || qh && ro(new qh()) != Ae || AC && ro(AC.resolve()) != je || dd && ro(new dd()) != be || Yh && ro(new Yh()) != Z) && (ro = function(u) {
        var h = bo(u), C = h == De ? u.constructor : n, I = C ? Yu(C) : "";
        if (I)
          switch (I) {
            case gQ:
              return Pe;
            case vQ:
              return Ae;
            case yQ:
              return je;
            case bQ:
              return be;
            case wQ:
              return Z;
          }
        return h;
      });
      function kJ(u, h, C) {
        for (var I = -1, z = C.length; ++I < z; ) {
          var q = C[I], J = q.size;
          switch (q.type) {
            case "drop":
              u += J;
              break;
            case "dropRight":
              h -= J;
              break;
            case "take":
              h = no(h, u + J);
              break;
            case "takeRight":
              u = ui(u, h - J);
              break;
          }
        }
        return { start: u, end: h };
      }
      function LJ(u) {
        var h = u.match(Mn);
        return h ? h[1].split(Hr) : [];
      }
      function rk(u, h, C) {
        h = Rc(h, u);
        for (var I = -1, z = h.length, q = !1; ++I < z; ) {
          var J = ll(h[I]);
          if (!(q = u != null && C(u, J)))
            break;
          u = u[J];
        }
        return q || ++I != z ? q : (z = u == null ? 0 : u.length, !!z && ky(z) && Wl(J, z) && (qt(u) || Xu(u)));
      }
      function DJ(u) {
        var h = u.length, C = new u.constructor(h);
        return h && typeof u[0] == "string" && Ln.call(u, "index") && (C.index = u.index, C.input = u.input), C;
      }
      function ik(u) {
        return typeof u.constructor == "function" && !im(u) ? hd(ly(u)) : {};
      }
      function jJ(u, h, C) {
        var I = u.constructor;
        switch (h) {
          case Ce:
            return YC(u);
          case ue:
          case me:
            return new I(+u);
          case Pe:
            return SJ(u, C);
          case Ee:
          case We:
          case ze:
          case Ye:
          case xt:
          case Lt:
          case mt:
          case St:
          case Et:
            return BN(u, C);
          case Ae:
            return new I();
          case Me:
          case Te:
            return new I(u);
          case fe:
            return xJ(u);
          case be:
            return new I();
          case Le:
            return CJ(u);
        }
      }
      function FJ(u, h) {
        var C = h.length;
        if (!C)
          return u;
        var I = C - 1;
        return h[I] = (C > 1 ? "& " : "") + h[I], h = h.join(C > 2 ? ", " : " "), u.replace(Gn, `{
/* [wrapped with ` + h + `] */
`);
      }
      function BJ(u) {
        return qt(u) || Xu(u) || !!(cN && u && u[cN]);
      }
      function Wl(u, h) {
        var C = typeof u;
        return h = h ?? G, !!h && (C == "number" || C != "symbol" && Vt.test(u)) && u > -1 && u % 1 == 0 && u < h;
      }
      function wo(u, h, C) {
        if (!Pr(C))
          return !1;
        var I = typeof h;
        return (I == "number" ? Lo(C) && Wl(h, C.length) : I == "string" && h in C) ? Cs(C[h], u) : !1;
      }
      function rE(u, h) {
        if (qt(u))
          return !1;
        var C = typeof u;
        return C == "number" || C == "symbol" || C == "boolean" || u == null || aa(u) ? !0 : _t.test(u) || !it.test(u) || h != null && u in er(h);
      }
      function zJ(u) {
        var h = typeof u;
        return h == "string" || h == "number" || h == "symbol" || h == "boolean" ? u !== "__proto__" : u === null;
      }
      function iE(u) {
        var h = Oy(u), C = K[h];
        if (typeof C != "function" || !(h in dn.prototype))
          return !1;
        if (u === C)
          return !0;
        var I = eE(C);
        return !!I && u === I[0];
      }
      function UJ(u) {
        return !!oN && oN in u;
      }
      var HJ = ry ? Vl : SE;
      function im(u) {
        var h = u && u.constructor, C = typeof h == "function" && h.prototype || fd;
        return u === C;
      }
      function ok(u) {
        return u === u && !Pr(u);
      }
      function ak(u, h) {
        return function(C) {
          return C == null ? !1 : C[u] === h && (h !== n || u in er(C));
        };
      }
      function WJ(u) {
        var h = My(u, function(I) {
          return C.size === c && C.clear(), I;
        }), C = h.cache;
        return h;
      }
      function VJ(u, h) {
        var C = u[1], I = h[1], z = C | I, q = z < (x | b | P), J = I == P && C == S || I == P && C == R && u[7].length <= h[8] || I == (P | R) && h[7].length <= h[8] && C == S;
        if (!(q || J))
          return u;
        I & x && (u[2] = h[2], z |= C & x ? 0 : w);
        var ne = h[3];
        if (ne) {
          var le = u[3];
          u[3] = le ? UN(le, ne, h[4]) : ne, u[4] = le ? Pc(u[3], f) : h[4];
        }
        return ne = h[5], ne && (le = u[5], u[5] = le ? HN(le, ne, h[6]) : ne, u[6] = le ? Pc(u[5], f) : h[6]), ne = h[7], ne && (u[7] = ne), I & P && (u[8] = u[8] == null ? h[8] : no(u[8], h[8])), u[9] == null && (u[9] = h[9]), u[0] = h[0], u[1] = z, u;
      }
      function GJ(u) {
        var h = [];
        if (u != null)
          for (var C in er(u))
            h.push(C);
        return h;
      }
      function KJ(u) {
        return oy.call(u);
      }
      function sk(u, h, C) {
        return h = ui(h === n ? u.length - 1 : h, 0), function() {
          for (var I = arguments, z = -1, q = ui(I.length - h, 0), J = ve(q); ++z < q; )
            J[z] = I[h + z];
          z = -1;
          for (var ne = ve(h + 1); ++z < h; )
            ne[z] = I[z];
          return ne[h] = C(J), yo(u, this, ne);
        };
      }
      function lk(u, h) {
        return h.length < 2 ? u : Ku(u, Fa(h, 0, -1));
      }
      function qJ(u, h) {
        for (var C = u.length, I = no(h.length, C), z = ko(u); I--; ) {
          var q = h[I];
          u[I] = Wl(q, C) ? z[q] : n;
        }
        return u;
      }
      function oE(u, h) {
        if (!(h === "constructor" && typeof u[h] == "function") && h != "__proto__")
          return u[h];
      }
      var ck = fk(RN), om = cQ || function(u, h) {
        return li.setTimeout(u, h);
      }, aE = fk(vJ);
      function uk(u, h, C) {
        var I = h + "";
        return aE(u, FJ(I, YJ(LJ(I), C)));
      }
      function fk(u) {
        var h = 0, C = 0;
        return function() {
          var I = pQ(), z = T - (I - C);
          if (C = I, z > 0) {
            if (++h >= A)
              return arguments[0];
          } else
            h = 0;
          return u.apply(n, arguments);
        };
      }
      function Ty(u, h) {
        var C = -1, I = u.length, z = I - 1;
        for (h = h === n ? I : h; ++C < h; ) {
          var q = UC(C, z), J = u[q];
          u[q] = u[C], u[C] = J;
        }
        return u.length = h, u;
      }
      var dk = WJ(function(u) {
        var h = [];
        return u.charCodeAt(0) === 46 && h.push(""), u.replace(Yt, function(C, I, z, q) {
          h.push(z ? q.replace(ht, "$1") : I || C);
        }), h;
      });
      function ll(u) {
        if (typeof u == "string" || aa(u))
          return u;
        var h = u + "";
        return h == "0" && 1 / u == -V ? "-0" : h;
      }
      function Yu(u) {
        if (u != null) {
          try {
            return iy.call(u);
          } catch {
          }
          try {
            return u + "";
          } catch {
          }
        }
        return "";
      }
      function YJ(u, h) {
        return No(he, function(C) {
          var I = "_." + C[0];
          h & C[1] && !ad(u, I) && u.push(I);
        }), u.sort();
      }
      function pk(u) {
        if (u instanceof dn)
          return u.clone();
        var h = new Da(u.__wrapped__, u.__chain__);
        return h.__actions__ = ko(u.__actions__), h.__index__ = u.__index__, h.__values__ = u.__values__, h;
      }
      function XJ(u, h, C) {
        (C ? wo(u, h, C) : h === n) ? h = 1 : h = ui(Qt(h), 0);
        var I = u == null ? 0 : u.length;
        if (!I || h < 1)
          return [];
        for (var z = 0, q = 0, J = ve(fy(I / h)); z < I; )
          J[q++] = Fa(u, z, z += h);
        return J;
      }
      function QJ(u) {
        for (var h = -1, C = u == null ? 0 : u.length, I = 0, z = []; ++h < C; ) {
          var q = u[h];
          q && (z[I++] = q);
        }
        return z;
      }
      function JJ() {
        var u = arguments.length;
        if (!u)
          return [];
        for (var h = ve(u - 1), C = arguments[0], I = u; I--; )
          h[I - 1] = arguments[I];
        return ar(qt(C) ? ko(C) : [C], ki(h, 1));
      }
      var ZJ = on(function(u, h) {
        return Vr(u) ? Zh(u, ki(h, 1, Vr, !0)) : [];
      }), eZ = on(function(u, h) {
        var C = Ba(h);
        return Vr(C) && (C = n), Vr(u) ? Zh(u, ki(h, 1, Vr, !0), $t(C, 2)) : [];
      }), tZ = on(function(u, h) {
        var C = Ba(h);
        return Vr(C) && (C = n), Vr(u) ? Zh(u, ki(h, 1, Vr, !0), n, C) : [];
      });
      function nZ(u, h, C) {
        var I = u == null ? 0 : u.length;
        return I ? (h = C || h === n ? 1 : Qt(h), Fa(u, h < 0 ? 0 : h, I)) : [];
      }
      function rZ(u, h, C) {
        var I = u == null ? 0 : u.length;
        return I ? (h = C || h === n ? 1 : Qt(h), h = I - h, Fa(u, 0, h < 0 ? 0 : h)) : [];
      }
      function iZ(u, h) {
        return u && u.length ? Sy(u, $t(h, 3), !0, !0) : [];
      }
      function oZ(u, h) {
        return u && u.length ? Sy(u, $t(h, 3), !0) : [];
      }
      function aZ(u, h, C, I) {
        var z = u == null ? 0 : u.length;
        return z ? (C && typeof C != "number" && wo(u, h, C) && (C = 0, I = z), JQ(u, h, C, I)) : [];
      }
      function hk(u, h, C) {
        var I = u == null ? 0 : u.length;
        if (!I)
          return -1;
        var z = C == null ? 0 : Qt(C);
        return z < 0 && (z = ui(I + z, 0)), $e(u, $t(h, 3), z);
      }
      function mk(u, h, C) {
        var I = u == null ? 0 : u.length;
        if (!I)
          return -1;
        var z = I - 1;
        return C !== n && (z = Qt(C), z = C < 0 ? ui(I + z, 0) : no(z, I - 1)), $e(u, $t(h, 3), z, !0);
      }
      function gk(u) {
        var h = u == null ? 0 : u.length;
        return h ? ki(u, 1) : [];
      }
      function sZ(u) {
        var h = u == null ? 0 : u.length;
        return h ? ki(u, V) : [];
      }
      function lZ(u, h) {
        var C = u == null ? 0 : u.length;
        return C ? (h = h === n ? 1 : Qt(h), ki(u, h)) : [];
      }
      function cZ(u) {
        for (var h = -1, C = u == null ? 0 : u.length, I = {}; ++h < C; ) {
          var z = u[h];
          I[z[0]] = z[1];
        }
        return I;
      }
      function vk(u) {
        return u && u.length ? u[0] : n;
      }
      function uZ(u, h, C) {
        var I = u == null ? 0 : u.length;
        if (!I)
          return -1;
        var z = C == null ? 0 : Qt(C);
        return z < 0 && (z = ui(I + z, 0)), Ke(u, h, z);
      }
      function fZ(u) {
        var h = u == null ? 0 : u.length;
        return h ? Fa(u, 0, -1) : [];
      }
      var dZ = on(function(u) {
        var h = or(u, KC);
        return h.length && h[0] === u[0] ? DC(h) : [];
      }), pZ = on(function(u) {
        var h = Ba(u), C = or(u, KC);
        return h === Ba(C) ? h = n : C.pop(), C.length && C[0] === u[0] ? DC(C, $t(h, 2)) : [];
      }), hZ = on(function(u) {
        var h = Ba(u), C = or(u, KC);
        return h = typeof h == "function" ? h : n, h && C.pop(), C.length && C[0] === u[0] ? DC(C, n, h) : [];
      });
      function mZ(u, h) {
        return u == null ? "" : fQ.call(u, h);
      }
      function Ba(u) {
        var h = u == null ? 0 : u.length;
        return h ? u[h - 1] : n;
      }
      function gZ(u, h, C) {
        var I = u == null ? 0 : u.length;
        if (!I)
          return -1;
        var z = I;
        return C !== n && (z = Qt(C), z = z < 0 ? ui(I + z, 0) : no(z, I - 1)), h === h ? YX(u, h, z) : $e(u, Bt, z, !0);
      }
      function vZ(u, h) {
        return u && u.length ? PN(u, Qt(h)) : n;
      }
      var yZ = on(yk);
      function yk(u, h) {
        return u && u.length && h && h.length ? zC(u, h) : u;
      }
      function bZ(u, h, C) {
        return u && u.length && h && h.length ? zC(u, h, $t(C, 2)) : u;
      }
      function wZ(u, h, C) {
        return u && u.length && h && h.length ? zC(u, h, n, C) : u;
      }
      var SZ = Hl(function(u, h) {
        var C = u == null ? 0 : u.length, I = MC(u, h);
        return AN(u, or(h, function(z) {
          return Wl(z, C) ? +z : z;
        }).sort(zN)), I;
      });
      function xZ(u, h) {
        var C = [];
        if (!(u && u.length))
          return C;
        var I = -1, z = [], q = u.length;
        for (h = $t(h, 3); ++I < q; ) {
          var J = u[I];
          h(J, I, u) && (C.push(J), z.push(I));
        }
        return AN(u, z), C;
      }
      function sE(u) {
        return u == null ? u : mQ.call(u);
      }
      function CZ(u, h, C) {
        var I = u == null ? 0 : u.length;
        return I ? (C && typeof C != "number" && wo(u, h, C) ? (h = 0, C = I) : (h = h == null ? 0 : Qt(h), C = C === n ? I : Qt(C)), Fa(u, h, C)) : [];
      }
      function EZ(u, h) {
        return wy(u, h);
      }
      function $Z(u, h, C) {
        return WC(u, h, $t(C, 2));
      }
      function _Z(u, h) {
        var C = u == null ? 0 : u.length;
        if (C) {
          var I = wy(u, h);
          if (I < C && Cs(u[I], h))
            return I;
        }
        return -1;
      }
      function OZ(u, h) {
        return wy(u, h, !0);
      }
      function PZ(u, h, C) {
        return WC(u, h, $t(C, 2), !0);
      }
      function TZ(u, h) {
        var C = u == null ? 0 : u.length;
        if (C) {
          var I = wy(u, h, !0) - 1;
          if (Cs(u[I], h))
            return I;
        }
        return -1;
      }
      function IZ(u) {
        return u && u.length ? MN(u) : [];
      }
      function AZ(u, h) {
        return u && u.length ? MN(u, $t(h, 2)) : [];
      }
      function RZ(u) {
        var h = u == null ? 0 : u.length;
        return h ? Fa(u, 1, h) : [];
      }
      function MZ(u, h, C) {
        return u && u.length ? (h = C || h === n ? 1 : Qt(h), Fa(u, 0, h < 0 ? 0 : h)) : [];
      }
      function NZ(u, h, C) {
        var I = u == null ? 0 : u.length;
        return I ? (h = C || h === n ? 1 : Qt(h), h = I - h, Fa(u, h < 0 ? 0 : h, I)) : [];
      }
      function kZ(u, h) {
        return u && u.length ? Sy(u, $t(h, 3), !1, !0) : [];
      }
      function LZ(u, h) {
        return u && u.length ? Sy(u, $t(h, 3)) : [];
      }
      var DZ = on(function(u) {
        return Ac(ki(u, 1, Vr, !0));
      }), jZ = on(function(u) {
        var h = Ba(u);
        return Vr(h) && (h = n), Ac(ki(u, 1, Vr, !0), $t(h, 2));
      }), FZ = on(function(u) {
        var h = Ba(u);
        return h = typeof h == "function" ? h : n, Ac(ki(u, 1, Vr, !0), n, h);
      });
      function BZ(u) {
        return u && u.length ? Ac(u) : [];
      }
      function zZ(u, h) {
        return u && u.length ? Ac(u, $t(h, 2)) : [];
      }
      function UZ(u, h) {
        return h = typeof h == "function" ? h : n, u && u.length ? Ac(u, n, h) : [];
      }
      function lE(u) {
        if (!(u && u.length))
          return [];
        var h = 0;
        return u = ol(u, function(C) {
          if (Vr(C))
            return h = ui(C.length, h), !0;
        }), zh(h, function(C) {
          return or(u, xn(C));
        });
      }
      function bk(u, h) {
        if (!(u && u.length))
          return [];
        var C = lE(u);
        return h == null ? C : or(C, function(I) {
          return yo(h, n, I);
        });
      }
      var HZ = on(function(u, h) {
        return Vr(u) ? Zh(u, h) : [];
      }), WZ = on(function(u) {
        return GC(ol(u, Vr));
      }), VZ = on(function(u) {
        var h = Ba(u);
        return Vr(h) && (h = n), GC(ol(u, Vr), $t(h, 2));
      }), GZ = on(function(u) {
        var h = Ba(u);
        return h = typeof h == "function" ? h : n, GC(ol(u, Vr), n, h);
      }), KZ = on(lE);
      function qZ(u, h) {
        return DN(u || [], h || [], Jh);
      }
      function YZ(u, h) {
        return DN(u || [], h || [], nm);
      }
      var XZ = on(function(u) {
        var h = u.length, C = h > 1 ? u[h - 1] : n;
        return C = typeof C == "function" ? (u.pop(), C) : n, bk(u, C);
      });
      function wk(u) {
        var h = K(u);
        return h.__chain__ = !0, h;
      }
      function QZ(u, h) {
        return h(u), u;
      }
      function Iy(u, h) {
        return h(u);
      }
      var JZ = Hl(function(u) {
        var h = u.length, C = h ? u[0] : 0, I = this.__wrapped__, z = function(q) {
          return MC(q, u);
        };
        return h > 1 || this.__actions__.length || !(I instanceof dn) || !Wl(C) ? this.thru(z) : (I = I.slice(C, +C + (h ? 1 : 0)), I.__actions__.push({
          func: Iy,
          args: [z],
          thisArg: n
        }), new Da(I, this.__chain__).thru(function(q) {
          return h && !q.length && q.push(n), q;
        }));
      });
      function ZZ() {
        return wk(this);
      }
      function eee() {
        return new Da(this.value(), this.__chain__);
      }
      function tee() {
        this.__values__ === n && (this.__values__ = Nk(this.value()));
        var u = this.__index__ >= this.__values__.length, h = u ? n : this.__values__[this.__index__++];
        return { done: u, value: h };
      }
      function nee() {
        return this;
      }
      function ree(u) {
        for (var h, C = this; C instanceof my; ) {
          var I = pk(C);
          I.__index__ = 0, I.__values__ = n, h ? z.__wrapped__ = I : h = I;
          var z = I;
          C = C.__wrapped__;
        }
        return z.__wrapped__ = u, h;
      }
      function iee() {
        var u = this.__wrapped__;
        if (u instanceof dn) {
          var h = u;
          return this.__actions__.length && (h = new dn(this)), h = h.reverse(), h.__actions__.push({
            func: Iy,
            args: [sE],
            thisArg: n
          }), new Da(h, this.__chain__);
        }
        return this.thru(sE);
      }
      function oee() {
        return LN(this.__wrapped__, this.__actions__);
      }
      var aee = xy(function(u, h, C) {
        Ln.call(u, C) ? ++u[C] : zl(u, C, 1);
      });
      function see(u, h, C) {
        var I = qt(u) ? Xv : QQ;
        return C && wo(u, h, C) && (h = n), I(u, $t(h, 3));
      }
      function lee(u, h) {
        var C = qt(u) ? ol : bN;
        return C(u, $t(h, 3));
      }
      var cee = KN(hk), uee = KN(mk);
      function fee(u, h) {
        return ki(Ay(u, h), 1);
      }
      function dee(u, h) {
        return ki(Ay(u, h), V);
      }
      function pee(u, h, C) {
        return C = C === n ? 1 : Qt(C), ki(Ay(u, h), C);
      }
      function Sk(u, h) {
        var C = qt(u) ? No : Ic;
        return C(u, $t(h, 3));
      }
      function xk(u, h) {
        var C = qt(u) ? xC : yN;
        return C(u, $t(h, 3));
      }
      var hee = xy(function(u, h, C) {
        Ln.call(u, C) ? u[C].push(h) : zl(u, C, [h]);
      });
      function mee(u, h, C, I) {
        u = Lo(u) ? u : bd(u), C = C && !I ? Qt(C) : 0;
        var z = u.length;
        return C < 0 && (C = ui(z + C, 0)), Ly(u) ? C <= z && u.indexOf(h, C) > -1 : !!z && Ke(u, h, C) > -1;
      }
      var gee = on(function(u, h, C) {
        var I = -1, z = typeof h == "function", q = Lo(u) ? ve(u.length) : [];
        return Ic(u, function(J) {
          q[++I] = z ? yo(h, J, C) : em(J, h, C);
        }), q;
      }), vee = xy(function(u, h, C) {
        zl(u, C, h);
      });
      function Ay(u, h) {
        var C = qt(u) ? or : $N;
        return C(u, $t(h, 3));
      }
      function yee(u, h, C, I) {
        return u == null ? [] : (qt(h) || (h = h == null ? [] : [h]), C = I ? n : C, qt(C) || (C = C == null ? [] : [C]), TN(u, h, C));
      }
      var bee = xy(function(u, h, C) {
        u[C ? 0 : 1].push(h);
      }, function() {
        return [[], []];
      });
      function wee(u, h, C) {
        var I = qt(u) ? Bu : zu, z = arguments.length < 3;
        return I(u, $t(h, 4), C, z, Ic);
      }
      function See(u, h, C) {
        var I = qt(u) ? CC : zu, z = arguments.length < 3;
        return I(u, $t(h, 4), C, z, yN);
      }
      function xee(u, h) {
        var C = qt(u) ? ol : bN;
        return C(u, Ny($t(h, 3)));
      }
      function Cee(u) {
        var h = qt(u) ? hN : mJ;
        return h(u);
      }
      function Eee(u, h, C) {
        (C ? wo(u, h, C) : h === n) ? h = 1 : h = Qt(h);
        var I = qt(u) ? GQ : gJ;
        return I(u, h);
      }
      function $ee(u) {
        var h = qt(u) ? KQ : yJ;
        return h(u);
      }
      function _ee(u) {
        if (u == null)
          return 0;
        if (Lo(u))
          return Ly(u) ? cd(u) : u.length;
        var h = ro(u);
        return h == Ae || h == be ? u.size : FC(u).length;
      }
      function Oee(u, h, C) {
        var I = qt(u) ? N : bJ;
        return C && wo(u, h, C) && (h = n), I(u, $t(h, 3));
      }
      var Pee = on(function(u, h) {
        if (u == null)
          return [];
        var C = h.length;
        return C > 1 && wo(u, h[0], h[1]) ? h = [] : C > 2 && wo(h[0], h[1], h[2]) && (h = [h[0]]), TN(u, ki(h, 1), []);
      }), Ry = lQ || function() {
        return li.Date.now();
      };
      function Tee(u, h) {
        if (typeof h != "function")
          throw new La(a);
        return u = Qt(u), function() {
          if (--u < 1)
            return h.apply(this, arguments);
        };
      }
      function Ck(u, h, C) {
        return h = C ? n : h, h = u && h == null ? u.length : h, Ul(u, P, n, n, n, n, h);
      }
      function Ek(u, h) {
        var C;
        if (typeof h != "function")
          throw new La(a);
        return u = Qt(u), function() {
          return --u > 0 && (C = h.apply(this, arguments)), u <= 1 && (h = n), C;
        };
      }
      var cE = on(function(u, h, C) {
        var I = x;
        if (C.length) {
          var z = Pc(C, vd(cE));
          I |= O;
        }
        return Ul(u, I, h, C, z);
      }), $k = on(function(u, h, C) {
        var I = x | b;
        if (C.length) {
          var z = Pc(C, vd($k));
          I |= O;
        }
        return Ul(h, I, u, C, z);
      });
      function _k(u, h, C) {
        h = C ? n : h;
        var I = Ul(u, S, n, n, n, n, n, h);
        return I.placeholder = _k.placeholder, I;
      }
      function Ok(u, h, C) {
        h = C ? n : h;
        var I = Ul(u, E, n, n, n, n, n, h);
        return I.placeholder = Ok.placeholder, I;
      }
      function Pk(u, h, C) {
        var I, z, q, J, ne, le, Re = 0, Ne = !1, Be = !1, nt = !0;
        if (typeof u != "function")
          throw new La(a);
        h = za(h) || 0, Pr(C) && (Ne = !!C.leading, Be = "maxWait" in C, q = Be ? ui(za(C.maxWait) || 0, h) : q, nt = "trailing" in C ? !!C.trailing : nt);
        function pt(Gr) {
          var Es = I, Kl = z;
          return I = z = n, Re = Gr, J = u.apply(Kl, Es), J;
        }
        function Ot(Gr) {
          return Re = Gr, ne = om(fn, h), Ne ? pt(Gr) : J;
        }
        function en(Gr) {
          var Es = Gr - le, Kl = Gr - Re, Kk = h - Es;
          return Be ? no(Kk, q - Kl) : Kk;
        }
        function Pt(Gr) {
          var Es = Gr - le, Kl = Gr - Re;
          return le === n || Es >= h || Es < 0 || Be && Kl >= q;
        }
        function fn() {
          var Gr = Ry();
          if (Pt(Gr))
            return yn(Gr);
          ne = om(fn, en(Gr));
        }
        function yn(Gr) {
          return ne = n, nt && I ? pt(Gr) : (I = z = n, J);
        }
        function sa() {
          ne !== n && jN(ne), Re = 0, I = le = z = ne = n;
        }
        function So() {
          return ne === n ? J : yn(Ry());
        }
        function la() {
          var Gr = Ry(), Es = Pt(Gr);
          if (I = arguments, z = this, le = Gr, Es) {
            if (ne === n)
              return Ot(le);
            if (Be)
              return jN(ne), ne = om(fn, h), pt(le);
          }
          return ne === n && (ne = om(fn, h)), J;
        }
        return la.cancel = sa, la.flush = So, la;
      }
      var Iee = on(function(u, h) {
        return vN(u, 1, h);
      }), Aee = on(function(u, h, C) {
        return vN(u, za(h) || 0, C);
      });
      function Ree(u) {
        return Ul(u, L);
      }
      function My(u, h) {
        if (typeof u != "function" || h != null && typeof h != "function")
          throw new La(a);
        var C = function() {
          var I = arguments, z = h ? h.apply(this, I) : I[0], q = C.cache;
          if (q.has(z))
            return q.get(z);
          var J = u.apply(this, I);
          return C.cache = q.set(z, J) || q, J;
        };
        return C.cache = new (My.Cache || Bl)(), C;
      }
      My.Cache = Bl;
      function Ny(u) {
        if (typeof u != "function")
          throw new La(a);
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return !u.call(this);
            case 1:
              return !u.call(this, h[0]);
            case 2:
              return !u.call(this, h[0], h[1]);
            case 3:
              return !u.call(this, h[0], h[1], h[2]);
          }
          return !u.apply(this, h);
        };
      }
      function Mee(u) {
        return Ek(2, u);
      }
      var Nee = wJ(function(u, h) {
        h = h.length == 1 && qt(h[0]) ? or(h[0], to($t())) : or(ki(h, 1), to($t()));
        var C = h.length;
        return on(function(I) {
          for (var z = -1, q = no(I.length, C); ++z < q; )
            I[z] = h[z].call(this, I[z]);
          return yo(u, this, I);
        });
      }), uE = on(function(u, h) {
        var C = Pc(h, vd(uE));
        return Ul(u, O, n, h, C);
      }), Tk = on(function(u, h) {
        var C = Pc(h, vd(Tk));
        return Ul(u, $, n, h, C);
      }), kee = Hl(function(u, h) {
        return Ul(u, R, n, n, n, h);
      });
      function Lee(u, h) {
        if (typeof u != "function")
          throw new La(a);
        return h = h === n ? h : Qt(h), on(u, h);
      }
      function Dee(u, h) {
        if (typeof u != "function")
          throw new La(a);
        return h = h == null ? 0 : ui(Qt(h), 0), on(function(C) {
          var I = C[h], z = Mc(C, 0, h);
          return I && ar(z, I), yo(u, this, z);
        });
      }
      function jee(u, h, C) {
        var I = !0, z = !0;
        if (typeof u != "function")
          throw new La(a);
        return Pr(C) && (I = "leading" in C ? !!C.leading : I, z = "trailing" in C ? !!C.trailing : z), Pk(u, h, {
          leading: I,
          maxWait: h,
          trailing: z
        });
      }
      function Fee(u) {
        return Ck(u, 1);
      }
      function Bee(u, h) {
        return uE(qC(h), u);
      }
      function zee() {
        if (!arguments.length)
          return [];
        var u = arguments[0];
        return qt(u) ? u : [u];
      }
      function Uee(u) {
        return ja(u, g);
      }
      function Hee(u, h) {
        return h = typeof h == "function" ? h : n, ja(u, g, h);
      }
      function Wee(u) {
        return ja(u, d | g);
      }
      function Vee(u, h) {
        return h = typeof h == "function" ? h : n, ja(u, d | g, h);
      }
      function Gee(u, h) {
        return h == null || gN(u, h, Si(h));
      }
      function Cs(u, h) {
        return u === h || u !== u && h !== h;
      }
      var Kee = _y(LC), qee = _y(function(u, h) {
        return u >= h;
      }), Xu = xN(/* @__PURE__ */ function() {
        return arguments;
      }()) ? xN : function(u) {
        return Br(u) && Ln.call(u, "callee") && !lN.call(u, "callee");
      }, qt = ve.isArray, Yee = Wv ? to(Wv) : rJ;
      function Lo(u) {
        return u != null && ky(u.length) && !Vl(u);
      }
      function Vr(u) {
        return Br(u) && Lo(u);
      }
      function Xee(u) {
        return u === !0 || u === !1 || Br(u) && bo(u) == ue;
      }
      var Nc = uQ || SE, Qee = Vv ? to(Vv) : iJ;
      function Jee(u) {
        return Br(u) && u.nodeType === 1 && !am(u);
      }
      function Zee(u) {
        if (u == null)
          return !0;
        if (Lo(u) && (qt(u) || typeof u == "string" || typeof u.splice == "function" || Nc(u) || yd(u) || Xu(u)))
          return !u.length;
        var h = ro(u);
        if (h == Ae || h == be)
          return !u.size;
        if (im(u))
          return !FC(u).length;
        for (var C in u)
          if (Ln.call(u, C))
            return !1;
        return !0;
      }
      function ete(u, h) {
        return tm(u, h);
      }
      function tte(u, h, C) {
        C = typeof C == "function" ? C : n;
        var I = C ? C(u, h) : n;
        return I === n ? tm(u, h, n, C) : !!I;
      }
      function fE(u) {
        if (!Br(u))
          return !1;
        var h = bo(u);
        return h == _e || h == Se || typeof u.message == "string" && typeof u.name == "string" && !am(u);
      }
      function nte(u) {
        return typeof u == "number" && uN(u);
      }
      function Vl(u) {
        if (!Pr(u))
          return !1;
        var h = bo(u);
        return h == Ge || h == Fe || h == we || h == ie;
      }
      function Ik(u) {
        return typeof u == "number" && u == Qt(u);
      }
      function ky(u) {
        return typeof u == "number" && u > -1 && u % 1 == 0 && u <= G;
      }
      function Pr(u) {
        var h = typeof u;
        return u != null && (h == "object" || h == "function");
      }
      function Br(u) {
        return u != null && typeof u == "object";
      }
      var Ak = Gv ? to(Gv) : aJ;
      function rte(u, h) {
        return u === h || jC(u, h, tE(h));
      }
      function ite(u, h, C) {
        return C = typeof C == "function" ? C : n, jC(u, h, tE(h), C);
      }
      function ote(u) {
        return Rk(u) && u != +u;
      }
      function ate(u) {
        if (HJ(u))
          throw new Gt(o);
        return CN(u);
      }
      function ste(u) {
        return u === null;
      }
      function lte(u) {
        return u == null;
      }
      function Rk(u) {
        return typeof u == "number" || Br(u) && bo(u) == Me;
      }
      function am(u) {
        if (!Br(u) || bo(u) != De)
          return !1;
        var h = ly(u);
        if (h === null)
          return !0;
        var C = Ln.call(h, "constructor") && h.constructor;
        return typeof C == "function" && C instanceof C && iy.call(C) == iQ;
      }
      var dE = Kv ? to(Kv) : sJ;
      function cte(u) {
        return Ik(u) && u >= -G && u <= G;
      }
      var Mk = qv ? to(qv) : lJ;
      function Ly(u) {
        return typeof u == "string" || !qt(u) && Br(u) && bo(u) == Te;
      }
      function aa(u) {
        return typeof u == "symbol" || Br(u) && bo(u) == Le;
      }
      var yd = Yv ? to(Yv) : cJ;
      function ute(u) {
        return u === n;
      }
      function fte(u) {
        return Br(u) && ro(u) == Z;
      }
      function dte(u) {
        return Br(u) && bo(u) == se;
      }
      var pte = _y(BC), hte = _y(function(u, h) {
        return u <= h;
      });
      function Nk(u) {
        if (!u)
          return [];
        if (Lo(u))
          return Ly(u) ? Ss(u) : ko(u);
        if (Kh && u[Kh])
          return OC(u[Kh]());
        var h = ro(u), C = h == Ae ? ld : h == be ? ty : bd;
        return C(u);
      }
      function Gl(u) {
        if (!u)
          return u === 0 ? u : 0;
        if (u = za(u), u === V || u === -V) {
          var h = u < 0 ? -1 : 1;
          return h * X;
        }
        return u === u ? u : 0;
      }
      function Qt(u) {
        var h = Gl(u), C = h % 1;
        return h === h ? C ? h - C : h : 0;
      }
      function kk(u) {
        return u ? Gu(Qt(u), 0, te) : 0;
      }
      function za(u) {
        if (typeof u == "number")
          return u;
        if (aa(u))
          return D;
        if (Pr(u)) {
          var h = typeof u.valueOf == "function" ? u.valueOf() : u;
          u = Pr(h) ? h + "" : h;
        }
        if (typeof u != "string")
          return u === 0 ? u : +u;
        u = Jv(u);
        var C = In.test(u);
        return C || vi.test(u) ? bC(u.slice(2), C ? 2 : 8) : hr.test(u) ? D : +u;
      }
      function Lk(u) {
        return sl(u, Do(u));
      }
      function mte(u) {
        return u ? Gu(Qt(u), -G, G) : u === 0 ? u : 0;
      }
      function An(u) {
        return u == null ? "" : oa(u);
      }
      var gte = md(function(u, h) {
        if (im(h) || Lo(h)) {
          sl(h, Si(h), u);
          return;
        }
        for (var C in h)
          Ln.call(h, C) && Jh(u, C, h[C]);
      }), Dk = md(function(u, h) {
        sl(h, Do(h), u);
      }), Dy = md(function(u, h, C, I) {
        sl(h, Do(h), u, I);
      }), vte = md(function(u, h, C, I) {
        sl(h, Si(h), u, I);
      }), yte = Hl(MC);
      function bte(u, h) {
        var C = hd(u);
        return h == null ? C : mN(C, h);
      }
      var wte = on(function(u, h) {
        u = er(u);
        var C = -1, I = h.length, z = I > 2 ? h[2] : n;
        for (z && wo(h[0], h[1], z) && (I = 1); ++C < I; )
          for (var q = h[C], J = Do(q), ne = -1, le = J.length; ++ne < le; ) {
            var Re = J[ne], Ne = u[Re];
            (Ne === n || Cs(Ne, fd[Re]) && !Ln.call(u, Re)) && (u[Re] = q[Re]);
          }
        return u;
      }), Ste = on(function(u) {
        return u.push(n, ek), yo(jk, n, u);
      });
      function xte(u, h) {
        return Q(u, $t(h, 3), al);
      }
      function Cte(u, h) {
        return Q(u, $t(h, 3), kC);
      }
      function Ete(u, h) {
        return u == null ? u : NC(u, $t(h, 3), Do);
      }
      function $te(u, h) {
        return u == null ? u : wN(u, $t(h, 3), Do);
      }
      function _te(u, h) {
        return u && al(u, $t(h, 3));
      }
      function Ote(u, h) {
        return u && kC(u, $t(h, 3));
      }
      function Pte(u) {
        return u == null ? [] : yy(u, Si(u));
      }
      function Tte(u) {
        return u == null ? [] : yy(u, Do(u));
      }
      function pE(u, h, C) {
        var I = u == null ? n : Ku(u, h);
        return I === n ? C : I;
      }
      function Ite(u, h) {
        return u != null && rk(u, h, ZQ);
      }
      function hE(u, h) {
        return u != null && rk(u, h, eJ);
      }
      var Ate = YN(function(u, h, C) {
        h != null && typeof h.toString != "function" && (h = oy.call(h)), u[h] = C;
      }, gE(jo)), Rte = YN(function(u, h, C) {
        h != null && typeof h.toString != "function" && (h = oy.call(h)), Ln.call(u, h) ? u[h].push(C) : u[h] = [C];
      }, $t), Mte = on(em);
      function Si(u) {
        return Lo(u) ? pN(u) : FC(u);
      }
      function Do(u) {
        return Lo(u) ? pN(u, !0) : uJ(u);
      }
      function Nte(u, h) {
        var C = {};
        return h = $t(h, 3), al(u, function(I, z, q) {
          zl(C, h(I, z, q), I);
        }), C;
      }
      function kte(u, h) {
        var C = {};
        return h = $t(h, 3), al(u, function(I, z, q) {
          zl(C, z, h(I, z, q));
        }), C;
      }
      var Lte = md(function(u, h, C) {
        by(u, h, C);
      }), jk = md(function(u, h, C, I) {
        by(u, h, C, I);
      }), Dte = Hl(function(u, h) {
        var C = {};
        if (u == null)
          return C;
        var I = !1;
        h = or(h, function(q) {
          return q = Rc(q, u), I || (I = q.length > 1), q;
        }), sl(u, ZC(u), C), I && (C = ja(C, d | p | g, AJ));
        for (var z = h.length; z--; )
          VC(C, h[z]);
        return C;
      });
      function jte(u, h) {
        return Fk(u, Ny($t(h)));
      }
      var Fte = Hl(function(u, h) {
        return u == null ? {} : dJ(u, h);
      });
      function Fk(u, h) {
        if (u == null)
          return {};
        var C = or(ZC(u), function(I) {
          return [I];
        });
        return h = $t(h), IN(u, C, function(I, z) {
          return h(I, z[0]);
        });
      }
      function Bte(u, h, C) {
        h = Rc(h, u);
        var I = -1, z = h.length;
        for (z || (z = 1, u = n); ++I < z; ) {
          var q = u == null ? n : u[ll(h[I])];
          q === n && (I = z, q = C), u = Vl(q) ? q.call(u) : q;
        }
        return u;
      }
      function zte(u, h, C) {
        return u == null ? u : nm(u, h, C);
      }
      function Ute(u, h, C, I) {
        return I = typeof I == "function" ? I : n, u == null ? u : nm(u, h, C, I);
      }
      var Bk = JN(Si), zk = JN(Do);
      function Hte(u, h, C) {
        var I = qt(u), z = I || Nc(u) || yd(u);
        if (h = $t(h, 4), C == null) {
          var q = u && u.constructor;
          z ? C = I ? new q() : [] : Pr(u) ? C = Vl(q) ? hd(ly(u)) : {} : C = {};
        }
        return (z ? No : al)(u, function(J, ne, le) {
          return h(C, J, ne, le);
        }), C;
      }
      function Wte(u, h) {
        return u == null ? !0 : VC(u, h);
      }
      function Vte(u, h, C) {
        return u == null ? u : kN(u, h, qC(C));
      }
      function Gte(u, h, C, I) {
        return I = typeof I == "function" ? I : n, u == null ? u : kN(u, h, qC(C), I);
      }
      function bd(u) {
        return u == null ? [] : Uh(u, Si(u));
      }
      function Kte(u) {
        return u == null ? [] : Uh(u, Do(u));
      }
      function qte(u, h, C) {
        return C === n && (C = h, h = n), C !== n && (C = za(C), C = C === C ? C : 0), h !== n && (h = za(h), h = h === h ? h : 0), Gu(za(u), h, C);
      }
      function Yte(u, h, C) {
        return h = Gl(h), C === n ? (C = h, h = 0) : C = Gl(C), u = za(u), tJ(u, h, C);
      }
      function Xte(u, h, C) {
        if (C && typeof C != "boolean" && wo(u, h, C) && (h = C = n), C === n && (typeof h == "boolean" ? (C = h, h = n) : typeof u == "boolean" && (C = u, u = n)), u === n && h === n ? (u = 0, h = 1) : (u = Gl(u), h === n ? (h = u, u = 0) : h = Gl(h)), u > h) {
          var I = u;
          u = h, h = I;
        }
        if (C || u % 1 || h % 1) {
          var z = fN();
          return no(u + z * (h - u + zv("1e-" + ((z + "").length - 1))), h);
        }
        return UC(u, h);
      }
      var Qte = gd(function(u, h, C) {
        return h = h.toLowerCase(), u + (C ? Uk(h) : h);
      });
      function Uk(u) {
        return mE(An(u).toLowerCase());
      }
      function Hk(u) {
        return u = An(u), u && u.replace(Sr, Vh).replace(Nt, "");
      }
      function Jte(u, h, C) {
        u = An(u), h = oa(h);
        var I = u.length;
        C = C === n ? I : Gu(Qt(C), 0, I);
        var z = C;
        return C -= h.length, C >= 0 && u.slice(C, z) == h;
      }
      function Zte(u) {
        return u = An(u), u && tt.test(u) ? u.replace(un, Gh) : u;
      }
      function ene(u) {
        return u = An(u), u && Zt.test(u) ? u.replace(gn, "\\$&") : u;
      }
      var tne = gd(function(u, h, C) {
        return u + (C ? "-" : "") + h.toLowerCase();
      }), nne = gd(function(u, h, C) {
        return u + (C ? " " : "") + h.toLowerCase();
      }), rne = GN("toLowerCase");
      function ine(u, h, C) {
        u = An(u), h = Qt(h);
        var I = h ? cd(u) : 0;
        if (!h || I >= h)
          return u;
        var z = (h - I) / 2;
        return $y(dy(z), C) + u + $y(fy(z), C);
      }
      function one(u, h, C) {
        u = An(u), h = Qt(h);
        var I = h ? cd(u) : 0;
        return h && I < h ? u + $y(h - I, C) : u;
      }
      function ane(u, h, C) {
        u = An(u), h = Qt(h);
        var I = h ? cd(u) : 0;
        return h && I < h ? $y(h - I, C) + u : u;
      }
      function sne(u, h, C) {
        return C || h == null ? h = 0 : h && (h = +h), hQ(An(u).replace(dr, ""), h || 0);
      }
      function lne(u, h, C) {
        return (C ? wo(u, h, C) : h === n) ? h = 1 : h = Qt(h), HC(An(u), h);
      }
      function cne() {
        var u = arguments, h = An(u[0]);
        return u.length < 3 ? h : h.replace(u[1], u[2]);
      }
      var une = gd(function(u, h, C) {
        return u + (C ? "_" : "") + h.toLowerCase();
      });
      function fne(u, h, C) {
        return C && typeof C != "number" && wo(u, h, C) && (h = C = n), C = C === n ? te : C >>> 0, C ? (u = An(u), u && (typeof h == "string" || h != null && !dE(h)) && (h = oa(h), !h && Oc(u)) ? Mc(Ss(u), 0, C) : u.split(h, C)) : [];
      }
      var dne = gd(function(u, h, C) {
        return u + (C ? " " : "") + mE(h);
      });
      function pne(u, h, C) {
        return u = An(u), C = C == null ? 0 : Gu(Qt(C), 0, u.length), h = oa(h), u.slice(C, C + h.length) == h;
      }
      function hne(u, h, C) {
        var I = K.templateSettings;
        C && wo(u, h, C) && (h = n), u = An(u), h = Dy({}, h, I, ZN);
        var z = Dy({}, h.imports, I.imports, ZN), q = Si(z), J = Uh(z, q), ne, le, Re = 0, Ne = h.interpolate || Xr, Be = "__p += '", nt = PC(
          (h.escape || Xr).source + "|" + Ne.source + "|" + (Ne === Xe ? Ht : Xr).source + "|" + (h.evaluate || Xr).source + "|$",
          "g"
        ), pt = "//# sourceURL=" + (Ln.call(h, "sourceURL") ? (h.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ra + "]") + `
`;
        u.replace(nt, function(Pt, fn, yn, sa, So, la) {
          return yn || (yn = sa), Be += u.slice(Re, la).replace(Ri, ey), fn && (ne = !0, Be += `' +
__e(` + fn + `) +
'`), So && (le = !0, Be += `';
` + So + `;
__p += '`), yn && (Be += `' +
((__t = (` + yn + `)) == null ? '' : __t) +
'`), Re = la + Pt.length, Pt;
        }), Be += `';
`;
        var Ot = Ln.call(h, "variable") && h.variable;
        if (!Ot)
          Be = `with (obj) {
` + Be + `
}
`;
        else if (bt.test(Ot))
          throw new Gt(s);
        Be = (le ? Be.replace(Je, "") : Be).replace(Ze, "$1").replace(ut, "$1;"), Be = "function(" + (Ot || "obj") + `) {
` + (Ot ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ne ? ", __e = _.escape" : "") + (le ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Be + `return __p
}`;
        var en = Vk(function() {
          return On(q, pt + "return " + Be).apply(n, J);
        });
        if (en.source = Be, fE(en))
          throw en;
        return en;
      }
      function mne(u) {
        return An(u).toLowerCase();
      }
      function gne(u) {
        return An(u).toUpperCase();
      }
      function vne(u, h, C) {
        if (u = An(u), u && (C || h === n))
          return Jv(u);
        if (!u || !(h = oa(h)))
          return u;
        var I = Ss(u), z = Ss(h), q = Hh(I, z), J = Wh(I, z) + 1;
        return Mc(I, q, J).join("");
      }
      function yne(u, h, C) {
        if (u = An(u), u && (C || h === n))
          return u.slice(0, iN(u) + 1);
        if (!u || !(h = oa(h)))
          return u;
        var I = Ss(u), z = Wh(I, Ss(h)) + 1;
        return Mc(I, 0, z).join("");
      }
      function bne(u, h, C) {
        if (u = An(u), u && (C || h === n))
          return u.replace(dr, "");
        if (!u || !(h = oa(h)))
          return u;
        var I = Ss(u), z = Hh(I, Ss(h));
        return Mc(I, z).join("");
      }
      function wne(u, h) {
        var C = B, I = j;
        if (Pr(h)) {
          var z = "separator" in h ? h.separator : z;
          C = "length" in h ? Qt(h.length) : C, I = "omission" in h ? oa(h.omission) : I;
        }
        u = An(u);
        var q = u.length;
        if (Oc(u)) {
          var J = Ss(u);
          q = J.length;
        }
        if (C >= q)
          return u;
        var ne = C - cd(I);
        if (ne < 1)
          return I;
        var le = J ? Mc(J, 0, ne).join("") : u.slice(0, ne);
        if (z === n)
          return le + I;
        if (J && (ne += le.length - ne), dE(z)) {
          if (u.slice(ne).search(z)) {
            var Re, Ne = le;
            for (z.global || (z = PC(z.source, An(Sn.exec(z)) + "g")), z.lastIndex = 0; Re = z.exec(Ne); )
              var Be = Re.index;
            le = le.slice(0, Be === n ? ne : Be);
          }
        } else if (u.indexOf(oa(z), ne) != ne) {
          var nt = le.lastIndexOf(z);
          nt > -1 && (le = le.slice(0, nt));
        }
        return le + I;
      }
      function Sne(u) {
        return u = An(u), u && bn.test(u) ? u.replace(cn, XX) : u;
      }
      var xne = gd(function(u, h, C) {
        return u + (C ? " " : "") + h.toUpperCase();
      }), mE = GN("toUpperCase");
      function Wk(u, h, C) {
        return u = An(u), h = C ? n : h, h === n ? _C(u) ? ZX(u) : Y(u) : u.match(h) || [];
      }
      var Vk = on(function(u, h) {
        try {
          return yo(u, n, h);
        } catch (C) {
          return fE(C) ? C : new Gt(C);
        }
      }), Cne = Hl(function(u, h) {
        return No(h, function(C) {
          C = ll(C), zl(u, C, cE(u[C], u));
        }), u;
      });
      function Ene(u) {
        var h = u == null ? 0 : u.length, C = $t();
        return u = h ? or(u, function(I) {
          if (typeof I[1] != "function")
            throw new La(a);
          return [C(I[0]), I[1]];
        }) : [], on(function(I) {
          for (var z = -1; ++z < h; ) {
            var q = u[z];
            if (yo(q[0], this, I))
              return yo(q[1], this, I);
          }
        });
      }
      function $ne(u) {
        return XQ(ja(u, d));
      }
      function gE(u) {
        return function() {
          return u;
        };
      }
      function _ne(u, h) {
        return u == null || u !== u ? h : u;
      }
      var One = qN(), Pne = qN(!0);
      function jo(u) {
        return u;
      }
      function vE(u) {
        return EN(typeof u == "function" ? u : ja(u, d));
      }
      function Tne(u) {
        return _N(ja(u, d));
      }
      function Ine(u, h) {
        return ON(u, ja(h, d));
      }
      var Ane = on(function(u, h) {
        return function(C) {
          return em(C, u, h);
        };
      }), Rne = on(function(u, h) {
        return function(C) {
          return em(u, C, h);
        };
      });
      function yE(u, h, C) {
        var I = Si(h), z = yy(h, I);
        C == null && !(Pr(h) && (z.length || !I.length)) && (C = h, h = u, u = this, z = yy(h, Si(h)));
        var q = !(Pr(C) && "chain" in C) || !!C.chain, J = Vl(u);
        return No(z, function(ne) {
          var le = h[ne];
          u[ne] = le, J && (u.prototype[ne] = function() {
            var Re = this.__chain__;
            if (q || Re) {
              var Ne = u(this.__wrapped__), Be = Ne.__actions__ = ko(this.__actions__);
              return Be.push({ func: le, args: arguments, thisArg: u }), Ne.__chain__ = Re, Ne;
            }
            return le.apply(u, ar([this.value()], arguments));
          });
        }), u;
      }
      function Mne() {
        return li._ === this && (li._ = oQ), this;
      }
      function bE() {
      }
      function Nne(u) {
        return u = Qt(u), on(function(h) {
          return PN(h, u);
        });
      }
      var kne = XC(or), Lne = XC(Xv), Dne = XC(N);
      function Gk(u) {
        return rE(u) ? xn(ll(u)) : pJ(u);
      }
      function jne(u) {
        return function(h) {
          return u == null ? n : Ku(u, h);
        };
      }
      var Fne = XN(), Bne = XN(!0);
      function wE() {
        return [];
      }
      function SE() {
        return !1;
      }
      function zne() {
        return {};
      }
      function Une() {
        return "";
      }
      function Hne() {
        return !0;
      }
      function Wne(u, h) {
        if (u = Qt(u), u < 1 || u > G)
          return [];
        var C = te, I = no(u, te);
        h = $t(h), u -= te;
        for (var z = zh(I, h); ++C < u; )
          h(C);
        return z;
      }
      function Vne(u) {
        return qt(u) ? or(u, ll) : aa(u) ? [u] : ko(dk(An(u)));
      }
      function Gne(u) {
        var h = ++rQ;
        return An(u) + h;
      }
      var Kne = Ey(function(u, h) {
        return u + h;
      }, 0), qne = QC("ceil"), Yne = Ey(function(u, h) {
        return u / h;
      }, 1), Xne = QC("floor");
      function Qne(u) {
        return u && u.length ? vy(u, jo, LC) : n;
      }
      function Jne(u, h) {
        return u && u.length ? vy(u, $t(h, 2), LC) : n;
      }
      function Zne(u) {
        return vn(u, jo);
      }
      function ere(u, h) {
        return vn(u, $t(h, 2));
      }
      function tre(u) {
        return u && u.length ? vy(u, jo, BC) : n;
      }
      function nre(u, h) {
        return u && u.length ? vy(u, $t(h, 2), BC) : n;
      }
      var rre = Ey(function(u, h) {
        return u * h;
      }, 1), ire = QC("round"), ore = Ey(function(u, h) {
        return u - h;
      }, 0);
      function are(u) {
        return u && u.length ? sd(u, jo) : 0;
      }
      function sre(u, h) {
        return u && u.length ? sd(u, $t(h, 2)) : 0;
      }
      return K.after = Tee, K.ary = Ck, K.assign = gte, K.assignIn = Dk, K.assignInWith = Dy, K.assignWith = vte, K.at = yte, K.before = Ek, K.bind = cE, K.bindAll = Cne, K.bindKey = $k, K.castArray = zee, K.chain = wk, K.chunk = XJ, K.compact = QJ, K.concat = JJ, K.cond = Ene, K.conforms = $ne, K.constant = gE, K.countBy = aee, K.create = bte, K.curry = _k, K.curryRight = Ok, K.debounce = Pk, K.defaults = wte, K.defaultsDeep = Ste, K.defer = Iee, K.delay = Aee, K.difference = ZJ, K.differenceBy = eZ, K.differenceWith = tZ, K.drop = nZ, K.dropRight = rZ, K.dropRightWhile = iZ, K.dropWhile = oZ, K.fill = aZ, K.filter = lee, K.flatMap = fee, K.flatMapDeep = dee, K.flatMapDepth = pee, K.flatten = gk, K.flattenDeep = sZ, K.flattenDepth = lZ, K.flip = Ree, K.flow = One, K.flowRight = Pne, K.fromPairs = cZ, K.functions = Pte, K.functionsIn = Tte, K.groupBy = hee, K.initial = fZ, K.intersection = dZ, K.intersectionBy = pZ, K.intersectionWith = hZ, K.invert = Ate, K.invertBy = Rte, K.invokeMap = gee, K.iteratee = vE, K.keyBy = vee, K.keys = Si, K.keysIn = Do, K.map = Ay, K.mapKeys = Nte, K.mapValues = kte, K.matches = Tne, K.matchesProperty = Ine, K.memoize = My, K.merge = Lte, K.mergeWith = jk, K.method = Ane, K.methodOf = Rne, K.mixin = yE, K.negate = Ny, K.nthArg = Nne, K.omit = Dte, K.omitBy = jte, K.once = Mee, K.orderBy = yee, K.over = kne, K.overArgs = Nee, K.overEvery = Lne, K.overSome = Dne, K.partial = uE, K.partialRight = Tk, K.partition = bee, K.pick = Fte, K.pickBy = Fk, K.property = Gk, K.propertyOf = jne, K.pull = yZ, K.pullAll = yk, K.pullAllBy = bZ, K.pullAllWith = wZ, K.pullAt = SZ, K.range = Fne, K.rangeRight = Bne, K.rearg = kee, K.reject = xee, K.remove = xZ, K.rest = Lee, K.reverse = sE, K.sampleSize = Eee, K.set = zte, K.setWith = Ute, K.shuffle = $ee, K.slice = CZ, K.sortBy = Pee, K.sortedUniq = IZ, K.sortedUniqBy = AZ, K.split = fne, K.spread = Dee, K.tail = RZ, K.take = MZ, K.takeRight = NZ, K.takeRightWhile = kZ, K.takeWhile = LZ, K.tap = QZ, K.throttle = jee, K.thru = Iy, K.toArray = Nk, K.toPairs = Bk, K.toPairsIn = zk, K.toPath = Vne, K.toPlainObject = Lk, K.transform = Hte, K.unary = Fee, K.union = DZ, K.unionBy = jZ, K.unionWith = FZ, K.uniq = BZ, K.uniqBy = zZ, K.uniqWith = UZ, K.unset = Wte, K.unzip = lE, K.unzipWith = bk, K.update = Vte, K.updateWith = Gte, K.values = bd, K.valuesIn = Kte, K.without = HZ, K.words = Wk, K.wrap = Bee, K.xor = WZ, K.xorBy = VZ, K.xorWith = GZ, K.zip = KZ, K.zipObject = qZ, K.zipObjectDeep = YZ, K.zipWith = XZ, K.entries = Bk, K.entriesIn = zk, K.extend = Dk, K.extendWith = Dy, yE(K, K), K.add = Kne, K.attempt = Vk, K.camelCase = Qte, K.capitalize = Uk, K.ceil = qne, K.clamp = qte, K.clone = Uee, K.cloneDeep = Wee, K.cloneDeepWith = Vee, K.cloneWith = Hee, K.conformsTo = Gee, K.deburr = Hk, K.defaultTo = _ne, K.divide = Yne, K.endsWith = Jte, K.eq = Cs, K.escape = Zte, K.escapeRegExp = ene, K.every = see, K.find = cee, K.findIndex = hk, K.findKey = xte, K.findLast = uee, K.findLastIndex = mk, K.findLastKey = Cte, K.floor = Xne, K.forEach = Sk, K.forEachRight = xk, K.forIn = Ete, K.forInRight = $te, K.forOwn = _te, K.forOwnRight = Ote, K.get = pE, K.gt = Kee, K.gte = qee, K.has = Ite, K.hasIn = hE, K.head = vk, K.identity = jo, K.includes = mee, K.indexOf = uZ, K.inRange = Yte, K.invoke = Mte, K.isArguments = Xu, K.isArray = qt, K.isArrayBuffer = Yee, K.isArrayLike = Lo, K.isArrayLikeObject = Vr, K.isBoolean = Xee, K.isBuffer = Nc, K.isDate = Qee, K.isElement = Jee, K.isEmpty = Zee, K.isEqual = ete, K.isEqualWith = tte, K.isError = fE, K.isFinite = nte, K.isFunction = Vl, K.isInteger = Ik, K.isLength = ky, K.isMap = Ak, K.isMatch = rte, K.isMatchWith = ite, K.isNaN = ote, K.isNative = ate, K.isNil = lte, K.isNull = ste, K.isNumber = Rk, K.isObject = Pr, K.isObjectLike = Br, K.isPlainObject = am, K.isRegExp = dE, K.isSafeInteger = cte, K.isSet = Mk, K.isString = Ly, K.isSymbol = aa, K.isTypedArray = yd, K.isUndefined = ute, K.isWeakMap = fte, K.isWeakSet = dte, K.join = mZ, K.kebabCase = tne, K.last = Ba, K.lastIndexOf = gZ, K.lowerCase = nne, K.lowerFirst = rne, K.lt = pte, K.lte = hte, K.max = Qne, K.maxBy = Jne, K.mean = Zne, K.meanBy = ere, K.min = tre, K.minBy = nre, K.stubArray = wE, K.stubFalse = SE, K.stubObject = zne, K.stubString = Une, K.stubTrue = Hne, K.multiply = rre, K.nth = vZ, K.noConflict = Mne, K.noop = bE, K.now = Ry, K.pad = ine, K.padEnd = one, K.padStart = ane, K.parseInt = sne, K.random = Xte, K.reduce = wee, K.reduceRight = See, K.repeat = lne, K.replace = cne, K.result = Bte, K.round = ire, K.runInContext = ae, K.sample = Cee, K.size = _ee, K.snakeCase = une, K.some = Oee, K.sortedIndex = EZ, K.sortedIndexBy = $Z, K.sortedIndexOf = _Z, K.sortedLastIndex = OZ, K.sortedLastIndexBy = PZ, K.sortedLastIndexOf = TZ, K.startCase = dne, K.startsWith = pne, K.subtract = ore, K.sum = are, K.sumBy = sre, K.template = hne, K.times = Wne, K.toFinite = Gl, K.toInteger = Qt, K.toLength = kk, K.toLower = mne, K.toNumber = za, K.toSafeInteger = mte, K.toString = An, K.toUpper = gne, K.trim = vne, K.trimEnd = yne, K.trimStart = bne, K.truncate = wne, K.unescape = Sne, K.uniqueId = Gne, K.upperCase = xne, K.upperFirst = mE, K.each = Sk, K.eachRight = xk, K.first = vk, yE(K, function() {
        var u = {};
        return al(K, function(h, C) {
          Ln.call(K.prototype, C) || (u[C] = h);
        }), u;
      }(), { chain: !1 }), K.VERSION = r, No(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
        K[u].placeholder = K;
      }), No(["drop", "take"], function(u, h) {
        dn.prototype[u] = function(C) {
          C = C === n ? 1 : ui(Qt(C), 0);
          var I = this.__filtered__ && !h ? new dn(this) : this.clone();
          return I.__filtered__ ? I.__takeCount__ = no(C, I.__takeCount__) : I.__views__.push({
            size: no(C, te),
            type: u + (I.__dir__ < 0 ? "Right" : "")
          }), I;
        }, dn.prototype[u + "Right"] = function(C) {
          return this.reverse()[u](C).reverse();
        };
      }), No(["filter", "map", "takeWhile"], function(u, h) {
        var C = h + 1, I = C == k || C == W;
        dn.prototype[u] = function(z) {
          var q = this.clone();
          return q.__iteratees__.push({
            iteratee: $t(z, 3),
            type: C
          }), q.__filtered__ = q.__filtered__ || I, q;
        };
      }), No(["head", "last"], function(u, h) {
        var C = "take" + (h ? "Right" : "");
        dn.prototype[u] = function() {
          return this[C](1).value()[0];
        };
      }), No(["initial", "tail"], function(u, h) {
        var C = "drop" + (h ? "" : "Right");
        dn.prototype[u] = function() {
          return this.__filtered__ ? new dn(this) : this[C](1);
        };
      }), dn.prototype.compact = function() {
        return this.filter(jo);
      }, dn.prototype.find = function(u) {
        return this.filter(u).head();
      }, dn.prototype.findLast = function(u) {
        return this.reverse().find(u);
      }, dn.prototype.invokeMap = on(function(u, h) {
        return typeof u == "function" ? new dn(this) : this.map(function(C) {
          return em(C, u, h);
        });
      }), dn.prototype.reject = function(u) {
        return this.filter(Ny($t(u)));
      }, dn.prototype.slice = function(u, h) {
        u = Qt(u);
        var C = this;
        return C.__filtered__ && (u > 0 || h < 0) ? new dn(C) : (u < 0 ? C = C.takeRight(-u) : u && (C = C.drop(u)), h !== n && (h = Qt(h), C = h < 0 ? C.dropRight(-h) : C.take(h - u)), C);
      }, dn.prototype.takeRightWhile = function(u) {
        return this.reverse().takeWhile(u).reverse();
      }, dn.prototype.toArray = function() {
        return this.take(te);
      }, al(dn.prototype, function(u, h) {
        var C = /^(?:filter|find|map|reject)|While$/.test(h), I = /^(?:head|last)$/.test(h), z = K[I ? "take" + (h == "last" ? "Right" : "") : h], q = I || /^find/.test(h);
        z && (K.prototype[h] = function() {
          var J = this.__wrapped__, ne = I ? [1] : arguments, le = J instanceof dn, Re = ne[0], Ne = le || qt(J), Be = function(fn) {
            var yn = z.apply(K, ar([fn], ne));
            return I && nt ? yn[0] : yn;
          };
          Ne && C && typeof Re == "function" && Re.length != 1 && (le = Ne = !1);
          var nt = this.__chain__, pt = !!this.__actions__.length, Ot = q && !nt, en = le && !pt;
          if (!q && Ne) {
            J = en ? J : new dn(this);
            var Pt = u.apply(J, ne);
            return Pt.__actions__.push({ func: Iy, args: [Be], thisArg: n }), new Da(Pt, nt);
          }
          return Ot && en ? u.apply(this, ne) : (Pt = this.thru(Be), Ot ? I ? Pt.value()[0] : Pt.value() : Pt);
        });
      }), No(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
        var h = ny[u], C = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", I = /^(?:pop|shift)$/.test(u);
        K.prototype[u] = function() {
          var z = arguments;
          if (I && !this.__chain__) {
            var q = this.value();
            return h.apply(qt(q) ? q : [], z);
          }
          return this[C](function(J) {
            return h.apply(qt(J) ? J : [], z);
          });
        };
      }), al(dn.prototype, function(u, h) {
        var C = K[h];
        if (C) {
          var I = C.name + "";
          Ln.call(pd, I) || (pd[I] = []), pd[I].push({ name: h, func: C });
        }
      }), pd[Cy(n, b).name] = [{
        name: "wrapper",
        func: n
      }], dn.prototype.clone = SQ, dn.prototype.reverse = xQ, dn.prototype.value = CQ, K.prototype.at = JZ, K.prototype.chain = ZZ, K.prototype.commit = eee, K.prototype.next = tee, K.prototype.plant = ree, K.prototype.reverse = iee, K.prototype.toJSON = K.prototype.valueOf = K.prototype.value = oee, K.prototype.first = K.prototype.head, Kh && (K.prototype[Kh] = nee), K;
    }, ud = eQ();
    _c ? ((_c.exports = ud)._ = ud, jh._ = ud) : li._ = ud;
  }).call(qa);
})(W1, W1.exports);
var yt = W1.exports;
const iIe = async ({
  WebchatSettingOutput: e,
  sourceId: t,
  parentWindowUrl: n
}) => {
  try {
    return await e.getSettings({ sourceId: t, url: n });
  } catch (r) {
    throw Zo(r, "WebchatSettings", "getSettings");
  }
};
function oIe(e, t) {
  var n = cIe(t);
  return n.formatToParts ? sIe(n, e) : lIe(n, e);
}
var aIe = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function sIe(e, t) {
  try {
    for (var n = e.formatToParts(t), r = [], i = 0; i < n.length; i++) {
      var o = aIe[n[i].type];
      o >= 0 && (r[o] = parseInt(n[i].value, 10));
    }
    return r;
  } catch (a) {
    if (a instanceof RangeError)
      return [NaN];
    throw a;
  }
}
function lIe(e, t) {
  var n = e.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var f_ = {};
function cIe(e) {
  if (!f_[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    f_[e] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return f_[e];
}
function RG(e, t, n, r, i, o, a) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, n), s.setUTCHours(r, i, o, a), s;
}
var w6 = 36e5, uIe = 6e4, d_ = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function MG(e, t, n) {
  var r, i;
  if (!e || (r = d_.timezoneZ.exec(e), r))
    return 0;
  var o;
  if (r = d_.timezoneHH.exec(e), r)
    return o = parseInt(r[1], 10), S6(o) ? -(o * w6) : NaN;
  if (r = d_.timezoneHHMM.exec(e), r) {
    o = parseInt(r[1], 10);
    var a = parseInt(r[2], 10);
    return S6(o, a) ? (i = Math.abs(o) * w6 + a * uIe, o > 0 ? -i : i) : NaN;
  }
  if (pIe(e)) {
    t = new Date(t || Date.now());
    var s = n ? t : fIe(t), l = iI(s, e), c = n ? l : dIe(t, l, e);
    return -c;
  }
  return NaN;
}
function fIe(e) {
  return RG(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function iI(e, t) {
  var n = oIe(e, t), r = RG(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), i = e.getTime(), o = i % 1e3;
  return i -= o >= 0 ? o : 1e3 + o, r - i;
}
function dIe(e, t, n) {
  var r = e.getTime(), i = r - t, o = iI(new Date(i), n);
  if (t === o)
    return t;
  i -= o - t;
  var a = iI(new Date(i), n);
  return o === a ? o : Math.max(o, a);
}
function S6(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var x6 = {};
function pIe(e) {
  if (x6[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), x6[e] = !0, !0;
  } catch {
    return !1;
  }
}
var oI = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var i = Number(r);
    return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
  }
  e.exports = t.default;
})(oI, oI.exports);
var hIe = oI.exports;
const mIe = /* @__PURE__ */ Oi(hIe);
var aI = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    var i = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return i.setUTCFullYear(r.getFullYear()), r.getTime() - i.getTime();
  }
  e.exports = t.default;
})(aI, aI.exports);
var gIe = aI.exports;
const C6 = /* @__PURE__ */ Oi(gIe);
var vIe = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, p_ = 36e5, E6 = 6e4, yIe = 2, _o = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: vIe
};
function bIe(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t || {}, r = n.additionalDigits == null ? yIe : mIe(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var i = wIe(e), o = SIe(i.date, r), a = o.year, s = o.restDateString, l = xIe(s, a);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var c = l.getTime(), f = 0, d;
    if (i.time && (f = CIe(i.time), isNaN(f)))
      return /* @__PURE__ */ new Date(NaN);
    if (i.timeZone || n.timeZone) {
      if (d = MG(i.timeZone || n.timeZone, new Date(c + f)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = C6(new Date(c + f)), d = C6(new Date(c + f + d));
    return new Date(c + f + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function wIe(e) {
  var t = {}, n = _o.dateTimePattern.exec(e), r;
  if (n ? (t.date = n[1], r = n[3]) : (n = _o.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
    var i = _o.timeZone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
  }
  return t;
}
function SIe(e, t) {
  var n = _o.YYY[t], r = _o.YYYYY[t], i;
  if (i = _o.YYYY.exec(e) || r.exec(e), i) {
    var o = i[1];
    return {
      year: parseInt(o, 10),
      restDateString: e.slice(o.length)
    };
  }
  if (i = _o.YY.exec(e) || n.exec(e), i) {
    var a = i[1];
    return {
      year: parseInt(a, 10) * 100,
      restDateString: e.slice(a.length)
    };
  }
  return {
    year: null
  };
}
function xIe(e, t) {
  if (t === null)
    return null;
  var n, r, i, o;
  if (e.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  if (n = _o.MM.exec(e), n)
    return r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1, _6(t, i) ? (r.setUTCFullYear(t, i), r) : /* @__PURE__ */ new Date(NaN);
  if (n = _o.DDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0);
    var a = parseInt(n[1], 10);
    return _Ie(t, a) ? (r.setUTCFullYear(t, 0, a), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = _o.MMDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1;
    var s = parseInt(n[2], 10);
    return _6(t, i, s) ? (r.setUTCFullYear(t, i, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = _o.Www.exec(e), n)
    return o = parseInt(n[1], 10) - 1, O6(t, o) ? $6(t, o) : /* @__PURE__ */ new Date(NaN);
  if (n = _o.WwwD.exec(e), n) {
    o = parseInt(n[1], 10) - 1;
    var l = parseInt(n[2], 10) - 1;
    return O6(t, o, l) ? $6(t, o, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function CIe(e) {
  var t, n, r;
  if (t = _o.HH.exec(e), t)
    return n = parseFloat(t[1].replace(",", ".")), h_(n) ? n % 24 * p_ : NaN;
  if (t = _o.HHMM.exec(e), t)
    return n = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), h_(n, r) ? n % 24 * p_ + r * E6 : NaN;
  if (t = _o.HHMMSS.exec(e), t) {
    n = parseInt(t[1], 10), r = parseInt(t[2], 10);
    var i = parseFloat(t[3].replace(",", "."));
    return h_(n, r, i) ? n % 24 * p_ + r * E6 + i * 1e3 : NaN;
  }
  return null;
}
function $6(e, t, n) {
  t = t || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var i = r.getUTCDay() || 7, o = t * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
var EIe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $Ie = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function NG(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function _6(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = NG(e);
    if (r && n > $Ie[t] || !r && n > EIe[t])
      return !1;
  }
  return !0;
}
function _Ie(e, t) {
  if (t < 1)
    return !1;
  var n = NG(e);
  return !(n && t > 366 || !n && t > 365);
}
function O6(e, t, n) {
  return !(t < 0 || t > 52 || n != null && (n < 0 || n > 6));
}
function h_(e, t, n) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
function OIe(e, t, n) {
  var r = bIe(e, n), i = MG(t, r, !0), o = new Date(r.getTime() - i), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), a.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), a;
}
const PIe = (e, t) => {
  const n = t ? OIe(/* @__PURE__ */ new Date(), t) : /* @__PURE__ */ new Date(), r = n.getDay(), i = n.getHours() * 100 + n.getMinutes(), [o, a] = (e == null ? void 0 : e[r]) || [];
  return o !== void 0 && a != null ? o < i && i < a : !1;
};
class TIe {
  constructor(t) {
    this.id = t.id, this.source = t.source, this.sourceId = t.sourceId, this.display = t.display, this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, this.startQuestions = t.startQuestions, this.popup = t.popup, this.officeHours = this.popup.officeHours, this.newMessagesNotification = this.popup.NewMessagesNotificationSettings, this.autoPopup = this.popup.autoPopup, this.launcherIconUrl = this.popup.launcherIconUrl, this.isWithinOfficeHours = this.officeHours ? PIe(this.officeHours, this.timeZone) : !0, this.shouldPopupOnNewMessage = this.newMessagesNotification === H1.POPUP, this.answerRatingOptions = t.answerRatingOptions.map((n) => ({
      id: n.id,
      content: n.content,
      type: YTe[n.type]
    })), this.launcher = t.launcher, this.invitationModal = t.invitationModal;
  }
  // FIXME: should remove this
  get sliceData() {
    return {
      office_hours: this.popup.officeHours,
      time_zone: this.timeZone,
      new_messages_notification: this.popup.NewMessagesNotificationSettings,
      auto_popup: this.popup.autoPopup,
      launcher_icon_url: this.popup.launcherIconUrl,
      display: this.display,
      start_questions: this.startQuestions
    };
  }
}
var Yr = /* @__PURE__ */ ((e) => (e.LeadCreated = "SEND_LEAD_CREATED_EVENT_FEATURE", e.TrackingEventImpression = "EVENT_LOG_IMPRESSION", e.IndependentLauncher = "INDEPENDENT_LAUNCHER", e.ChatFusionMultipleBotStoreFeature = "MULTIPLE_BOT_STORE", e.CreateConversationWithSameUuid = "CREATE_CONVERSATION_WITH_SAME_UUID", e.ChatFusionConversationWithEachPage = "CONVERSATION_WITH_EACH_PAGE", e.AnswerRating = "ANSWER_RATING", e.StoreUserBehaviorData = "STORE_USER_BEHAVIOR_DATA", e.UserActionBox = "USER_ACTION_BOX", e.WebchatPureScript = "WEBCHAT_PURE_SCRIPT", e.SiteCompanionPlacement2 = "SITE_COMPANION_PLACEMENT_2", e.ChatBubbleNewPlacement = "CHAT_BUBBLE_NEW_PLACEMENT", e.ChatBubbleNewPlacement2 = "CHAT_BUBBLE_NEW_PLACEMENT_2", e.UseAPIClient = "USE_API_CLIENT", e.ChatBubbleSupportGif = "CHAT_BUBBLE_SUPPORT_GIF", e.InvitationModal = "INVITATION_MODAL", e.SiteCompanionLoadingAnimation = "SITE_COMPANION_LOADING_ANIMATION", e.RelatedQuestionApi = "RELATED_QUESTION_API", e.StreamingMessage = "STREAMING_MESSAGE", e.SiteCompanionLoadingAnimation2 = "SITE_COMPANION_LOADING_ANIMATION_2", e))(Yr || {});
const IIe = new ii(
  Yr.CreateConversationWithSameUuid
), AIe = new ii(Yr.AnswerRating), kG = new ii(
  Yr.ChatBubbleNewPlacement2
), RIe = new ii(
  Yr.ChatBubbleNewPlacement
), LG = new ii(
  Yr.ChatBubbleSupportGif
), j2 = new ii(
  Yr.ChatFusionConversationWithEachPage
), Ch = new ii(
  Yr.IndependentLauncher
), F2 = new ii(
  Yr.InvitationModal
), MIe = new ii(Yr.LeadCreated), Tx = new ii(
  Yr.ChatFusionMultipleBotStoreFeature
), DG = new ii(
  Yr.RelatedQuestionApi
), Vf = new ii(
  Yr.SiteCompanionLoadingAnimation
), NIe = new ii(
  Yr.SiteCompanionLoadingAnimation2
);
new ii(
  Yr.SiteCompanionPlacement2
);
const V1 = new ii(
  Yr.StoreUserBehaviorData
), Gf = new ii(
  Yr.StreamingMessage
), sp = new ii(
  Yr.TrackingEventImpression
), kIe = new ii(Yr.UseAPIClient), Ix = new ii(Yr.UserActionBox), Cl = new ii(Yr.WebchatPureScript), Ho = {
  /** @deprecated */
  UseAPICLient: kIe,
  ChatBubbleSupportGif: LG.isFeatureEnabled(),
  InvitationModal: F2.isFeatureEnabled(),
  SiteCompanionLoadingAnimation: Vf.isFeatureEnabled(),
  RelatedQuestionApi: DG.isFeatureEnabled(),
  StreamingMessage: Gf.isFeatureEnabled()
};
function jG(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: LIe } = Object.prototype, { getPrototypeOf: B2 } = Object, Ax = /* @__PURE__ */ ((e) => (t) => {
  const n = LIe.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ml = (e) => (e = e.toLowerCase(), (t) => Ax(t) === e), Rx = (e) => (t) => typeof t === e, { isArray: Eh } = Array, Gg = Rx("undefined");
function DIe(e) {
  return e !== null && !Gg(e) && e.constructor !== null && !Gg(e.constructor) && es(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const FG = Ml("ArrayBuffer");
function jIe(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && FG(e.buffer), t;
}
const FIe = Rx("string"), es = Rx("function"), BG = Rx("number"), Mx = (e) => e !== null && typeof e == "object", BIe = (e) => e === !0 || e === !1, Sb = (e) => {
  if (Ax(e) !== "object")
    return !1;
  const t = B2(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, zIe = Ml("Date"), UIe = Ml("File"), HIe = Ml("Blob"), WIe = Ml("FileList"), VIe = (e) => Mx(e) && es(e.pipe), GIe = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || es(e.append) && ((t = Ax(e)) === "formdata" || // detect form-data instance
  t === "object" && es(e.toString) && e.toString() === "[object FormData]"));
}, KIe = Ml("URLSearchParams"), qIe = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ev(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), Eh(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = o.length;
    let s;
    for (r = 0; r < a; r++)
      s = o[r], t.call(null, e[s], s, e);
  }
}
function zG(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const UG = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, HG = (e) => !Gg(e) && e !== UG;
function sI() {
  const { caseless: e } = HG(this) && this || {}, t = {}, n = (r, i) => {
    const o = e && zG(t, i) || i;
    Sb(t[o]) && Sb(r) ? t[o] = sI(t[o], r) : Sb(r) ? t[o] = sI({}, r) : Eh(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Ev(arguments[r], n);
  return t;
}
const YIe = (e, t, n, { allOwnKeys: r } = {}) => (Ev(t, (i, o) => {
  n && es(i) ? e[o] = jG(i, n) : e[o] = i;
}, { allOwnKeys: r }), e), XIe = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), QIe = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, JIe = (e, t, n, r) => {
  let i, o, a;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (i = Object.getOwnPropertyNames(e), o = i.length; o-- > 0; )
      a = i[o], (!r || r(a, e, t)) && !s[a] && (t[a] = e[a], s[a] = !0);
    e = n !== !1 && B2(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, ZIe = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, eAe = (e) => {
  if (!e)
    return null;
  if (Eh(e))
    return e;
  let t = e.length;
  if (!BG(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, tAe = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && B2(Uint8Array)), nAe = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const o = i.value;
    t.call(e, o[0], o[1]);
  }
}, rAe = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, iAe = Ml("HTMLFormElement"), oAe = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), P6 = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), aAe = Ml("RegExp"), WG = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Ev(n, (i, o) => {
    t(i, o, e) !== !1 && (r[o] = i);
  }), Object.defineProperties(e, r);
}, sAe = (e) => {
  WG(e, (t, n) => {
    if (es(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (es(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, lAe = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((o) => {
      n[o] = !0;
    });
  };
  return Eh(e) ? r(e) : r(String(e).split(t)), n;
}, cAe = () => {
}, uAe = (e, t) => (e = +e, Number.isFinite(e) ? e : t), m_ = "abcdefghijklmnopqrstuvwxyz", T6 = "0123456789", VG = {
  DIGIT: T6,
  ALPHA: m_,
  ALPHA_DIGIT: m_ + m_.toUpperCase() + T6
}, fAe = (e = 16, t = VG.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function dAe(e) {
  return !!(e && es(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const pAe = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (Mx(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[i] = r;
        const o = Eh(r) ? [] : {};
        return Ev(r, (a, s) => {
          const l = n(a, i + 1);
          !Gg(l) && (o[s] = l);
        }), t[i] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, hAe = Ml("AsyncFunction"), mAe = (e) => e && (Mx(e) || es(e)) && es(e.then) && es(e.catch), Ie = {
  isArray: Eh,
  isArrayBuffer: FG,
  isBuffer: DIe,
  isFormData: GIe,
  isArrayBufferView: jIe,
  isString: FIe,
  isNumber: BG,
  isBoolean: BIe,
  isObject: Mx,
  isPlainObject: Sb,
  isUndefined: Gg,
  isDate: zIe,
  isFile: UIe,
  isBlob: HIe,
  isRegExp: aAe,
  isFunction: es,
  isStream: VIe,
  isURLSearchParams: KIe,
  isTypedArray: tAe,
  isFileList: WIe,
  forEach: Ev,
  merge: sI,
  extend: YIe,
  trim: qIe,
  stripBOM: XIe,
  inherits: QIe,
  toFlatObject: JIe,
  kindOf: Ax,
  kindOfTest: Ml,
  endsWith: ZIe,
  toArray: eAe,
  forEachEntry: nAe,
  matchAll: rAe,
  isHTMLForm: iAe,
  hasOwnProperty: P6,
  hasOwnProp: P6,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: WG,
  freezeMethods: sAe,
  toObjectSet: lAe,
  toCamelCase: oAe,
  noop: cAe,
  toFiniteNumber: uAe,
  findKey: zG,
  global: UG,
  isContextDefined: HG,
  ALPHABET: VG,
  generateString: fAe,
  isSpecCompliantForm: dAe,
  toJSONObject: pAe,
  isAsyncFn: hAe,
  isThenable: mAe
};
function En(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
Ie.inherits(En, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Ie.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const GG = En.prototype, KG = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  KG[e] = { value: e };
});
Object.defineProperties(En, KG);
Object.defineProperty(GG, "isAxiosError", { value: !0 });
En.from = (e, t, n, r, i, o) => {
  const a = Object.create(GG);
  return Ie.toFlatObject(e, a, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), En.call(a, e.message, t, n, r, i), a.cause = e, a.name = e.name, o && Object.assign(a, o), a;
};
const gAe = null;
function lI(e) {
  return Ie.isPlainObject(e) || Ie.isArray(e);
}
function qG(e) {
  return Ie.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function I6(e, t, n) {
  return e ? e.concat(t).map(function(i, o) {
    return i = qG(i), !n && o ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function vAe(e) {
  return Ie.isArray(e) && !e.some(lI);
}
const yAe = Ie.toFlatObject(Ie, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Nx(e, t, n) {
  if (!Ie.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = Ie.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, x) {
    return !Ie.isUndefined(x[y]);
  });
  const r = n.metaTokens, i = n.visitor || f, o = n.dots, a = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && Ie.isSpecCompliantForm(t);
  if (!Ie.isFunction(i))
    throw new TypeError("visitor must be a function");
  function c(v) {
    if (v === null)
      return "";
    if (Ie.isDate(v))
      return v.toISOString();
    if (!l && Ie.isBlob(v))
      throw new En("Blob is not supported. Use a Buffer instead.");
    return Ie.isArrayBuffer(v) || Ie.isTypedArray(v) ? l && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function f(v, y, x) {
    let b = v;
    if (v && !x && typeof v == "object") {
      if (Ie.endsWith(y, "{}"))
        y = r ? y : y.slice(0, -2), v = JSON.stringify(v);
      else if (Ie.isArray(v) && vAe(v) || (Ie.isFileList(v) || Ie.endsWith(y, "[]")) && (b = Ie.toArray(v)))
        return y = qG(y), b.forEach(function(S, E) {
          !(Ie.isUndefined(S) || S === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? I6([y], E, o) : a === null ? y : y + "[]",
            c(S)
          );
        }), !1;
    }
    return lI(v) ? !0 : (t.append(I6(x, y, o), c(v)), !1);
  }
  const d = [], p = Object.assign(yAe, {
    defaultVisitor: f,
    convertValue: c,
    isVisitable: lI
  });
  function g(v, y) {
    if (!Ie.isUndefined(v)) {
      if (d.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      d.push(v), Ie.forEach(v, function(b, w) {
        (!(Ie.isUndefined(b) || b === null) && i.call(
          t,
          b,
          Ie.isString(w) ? w.trim() : w,
          y,
          p
        )) === !0 && g(b, y ? y.concat(w) : [w]);
      }), d.pop();
    }
  }
  if (!Ie.isObject(e))
    throw new TypeError("data must be an object");
  return g(e), t;
}
function A6(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function z2(e, t) {
  this._pairs = [], e && Nx(e, this, t);
}
const YG = z2.prototype;
YG.append = function(t, n) {
  this._pairs.push([t, n]);
};
YG.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, A6);
  } : A6;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function bAe(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function XG(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || bAe, i = n && n.serialize;
  let o;
  if (i ? o = i(t, n) : o = Ie.isURLSearchParams(t) ? t.toString() : new z2(t, n).toString(r), o) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class wAe {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    Ie.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const R6 = wAe, QG = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, SAe = typeof URLSearchParams < "u" ? URLSearchParams : z2, xAe = typeof FormData < "u" ? FormData : null, CAe = typeof Blob < "u" ? Blob : null, EAe = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), $Ae = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", El = {
  isBrowser: !0,
  classes: {
    URLSearchParams: SAe,
    FormData: xAe,
    Blob: CAe
  },
  isStandardBrowserEnv: EAe,
  isStandardBrowserWebWorkerEnv: $Ae,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function _Ae(e, t) {
  return Nx(e, new El.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, o) {
      return El.isNode && Ie.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function OAe(e) {
  return Ie.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function PAe(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let o;
  for (r = 0; r < i; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function JG(e) {
  function t(n, r, i, o) {
    let a = n[o++];
    const s = Number.isFinite(+a), l = o >= n.length;
    return a = !a && Ie.isArray(i) ? i.length : a, l ? (Ie.hasOwnProp(i, a) ? i[a] = [i[a], r] : i[a] = r, !s) : ((!i[a] || !Ie.isObject(i[a])) && (i[a] = []), t(n, r, i[a], o) && Ie.isArray(i[a]) && (i[a] = PAe(i[a])), !s);
  }
  if (Ie.isFormData(e) && Ie.isFunction(e.entries)) {
    const n = {};
    return Ie.forEachEntry(e, (r, i) => {
      t(OAe(r), i, n, 0);
    }), n;
  }
  return null;
}
const TAe = {
  "Content-Type": void 0
};
function IAe(e, t, n) {
  if (Ie.isString(e))
    try {
      return (t || JSON.parse)(e), Ie.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const kx = {
  transitional: QG,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, o = Ie.isObject(t);
    if (o && Ie.isHTMLForm(t) && (t = new FormData(t)), Ie.isFormData(t))
      return i && i ? JSON.stringify(JG(t)) : t;
    if (Ie.isArrayBuffer(t) || Ie.isBuffer(t) || Ie.isStream(t) || Ie.isFile(t) || Ie.isBlob(t))
      return t;
    if (Ie.isArrayBufferView(t))
      return t.buffer;
    if (Ie.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return _Ae(t, this.formSerializer).toString();
      if ((s = Ie.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Nx(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || i ? (n.setContentType("application/json", !1), IAe(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || kx.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (t && Ie.isString(t) && (r && !this.responseType || i)) {
      const a = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? En.from(s, En.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: El.classes.FormData,
    Blob: El.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
Ie.forEach(["delete", "get", "head"], function(t) {
  kx.headers[t] = {};
});
Ie.forEach(["post", "put", "patch"], function(t) {
  kx.headers[t] = Ie.merge(TAe);
});
const U2 = kx, AAe = Ie.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), RAe = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(a) {
    i = a.indexOf(":"), n = a.substring(0, i).trim().toLowerCase(), r = a.substring(i + 1).trim(), !(!n || t[n] && AAe[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, M6 = Symbol("internals");
function Em(e) {
  return e && String(e).trim().toLowerCase();
}
function xb(e) {
  return e === !1 || e == null ? e : Ie.isArray(e) ? e.map(xb) : String(e);
}
function MAe(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const NAe = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function g_(e, t, n, r, i) {
  if (Ie.isFunction(r))
    return r.call(this, t, n);
  if (i && (t = n), !!Ie.isString(t)) {
    if (Ie.isString(r))
      return t.indexOf(r) !== -1;
    if (Ie.isRegExp(r))
      return r.test(t);
  }
}
function kAe(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function LAe(e, t) {
  const n = Ie.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, o, a) {
        return this[r].call(this, t, i, o, a);
      },
      configurable: !0
    });
  });
}
class Lx {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function o(s, l, c) {
      const f = Em(l);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const d = Ie.findKey(i, f);
      (!d || i[d] === void 0 || c === !0 || c === void 0 && i[d] !== !1) && (i[d || l] = xb(s));
    }
    const a = (s, l) => Ie.forEach(s, (c, f) => o(c, f, l));
    return Ie.isPlainObject(t) || t instanceof this.constructor ? a(t, n) : Ie.isString(t) && (t = t.trim()) && !NAe(t) ? a(RAe(t), n) : t != null && o(n, t, r), this;
  }
  get(t, n) {
    if (t = Em(t), t) {
      const r = Ie.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return MAe(i);
        if (Ie.isFunction(n))
          return n.call(this, i, r);
        if (Ie.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Em(t), t) {
      const r = Ie.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || g_(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function o(a) {
      if (a = Em(a), a) {
        const s = Ie.findKey(r, a);
        s && (!n || g_(r, r[s], s, n)) && (delete r[s], i = !0);
      }
    }
    return Ie.isArray(t) ? t.forEach(o) : o(t), i;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || g_(this, this[o], o, t, !0)) && (delete this[o], i = !0);
    }
    return i;
  }
  normalize(t) {
    const n = this, r = {};
    return Ie.forEach(this, (i, o) => {
      const a = Ie.findKey(r, o);
      if (a) {
        n[a] = xb(i), delete n[o];
        return;
      }
      const s = t ? kAe(o) : String(o).trim();
      s !== o && delete n[o], n[s] = xb(i), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return Ie.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && Ie.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[M6] = this[M6] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function o(a) {
      const s = Em(a);
      r[s] || (LAe(i, a), r[s] = !0);
    }
    return Ie.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
Lx.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Ie.freezeMethods(Lx.prototype);
Ie.freezeMethods(Lx);
const uc = Lx;
function v_(e, t) {
  const n = this || U2, r = t || n, i = uc.from(r.headers);
  let o = r.data;
  return Ie.forEach(e, function(s) {
    o = s.call(n, o, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), o;
}
function ZG(e) {
  return !!(e && e.__CANCEL__);
}
function $v(e, t, n) {
  En.call(this, e ?? "canceled", En.ERR_CANCELED, t, n), this.name = "CanceledError";
}
Ie.inherits($v, En, {
  __CANCEL__: !0
});
function DAe(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new En(
    "Request failed with status code " + n.status,
    [En.ERR_BAD_REQUEST, En.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const jAe = El.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  /* @__PURE__ */ function() {
    return {
      write: function(n, r, i, o, a, s) {
        const l = [];
        l.push(n + "=" + encodeURIComponent(r)), Ie.isNumber(i) && l.push("expires=" + new Date(i).toGMTString()), Ie.isString(o) && l.push("path=" + o), Ie.isString(a) && l.push("domain=" + a), s === !0 && l.push("secure"), document.cookie = l.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function FAe(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function BAe(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function eK(e, t) {
  return e && !FAe(t) ? BAe(e, t) : t;
}
const zAe = El.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function i(o) {
      let a = o;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = i(window.location.href), function(a) {
      const s = Ie.isString(a) ? i(a) : a;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function UAe(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function HAe(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, o = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), f = r[o];
    a || (a = c), n[i] = l, r[i] = c;
    let d = o, p = 0;
    for (; d !== i; )
      p += n[d++], d = d % e;
    if (i = (i + 1) % e, i === o && (o = (o + 1) % e), c - a < t)
      return;
    const g = f && c - f;
    return g ? Math.round(p * 1e3 / g) : void 0;
  };
}
function N6(e, t) {
  let n = 0;
  const r = HAe(50, 250);
  return (i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, s = o - n, l = r(s), c = o <= a;
    n = o;
    const f = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: s,
      rate: l || void 0,
      estimated: l && a && c ? (a - o) / l : void 0,
      event: i
    };
    f[t ? "download" : "upload"] = !0, e(f);
  };
}
const WAe = typeof XMLHttpRequest < "u", VAe = WAe && function(e) {
  return new Promise(function(n, r) {
    let i = e.data;
    const o = uc.from(e.headers).normalize(), a = e.responseType;
    let s;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(s), e.signal && e.signal.removeEventListener("abort", s);
    }
    Ie.isFormData(i) && (El.isStandardBrowserEnv || El.isStandardBrowserWebWorkerEnv ? o.setContentType(!1) : o.setContentType("multipart/form-data;", !1));
    let c = new XMLHttpRequest();
    if (e.auth) {
      const g = e.auth.username || "", v = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(g + ":" + v));
    }
    const f = eK(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), XG(f, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function d() {
      if (!c)
        return;
      const g = uc.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), y = {
        data: !a || a === "text" || a === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: g,
        config: e,
        request: c
      };
      DAe(function(b) {
        n(b), l();
      }, function(b) {
        r(b), l();
      }, y), c = null;
    }
    if ("onloadend" in c ? c.onloadend = d : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, c.onabort = function() {
      c && (r(new En("Request aborted", En.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      r(new En("Network Error", En.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let v = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const y = e.transitional || QG;
      e.timeoutErrorMessage && (v = e.timeoutErrorMessage), r(new En(
        v,
        y.clarifyTimeoutError ? En.ETIMEDOUT : En.ECONNABORTED,
        e,
        c
      )), c = null;
    }, El.isStandardBrowserEnv) {
      const g = (e.withCredentials || zAe(f)) && e.xsrfCookieName && jAe.read(e.xsrfCookieName);
      g && o.set(e.xsrfHeaderName, g);
    }
    i === void 0 && o.setContentType(null), "setRequestHeader" in c && Ie.forEach(o.toJSON(), function(v, y) {
      c.setRequestHeader(y, v);
    }), Ie.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), a && a !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", N6(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", N6(e.onUploadProgress)), (e.cancelToken || e.signal) && (s = (g) => {
      c && (r(!g || g.type ? new $v(null, e, c) : g), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(s), e.signal && (e.signal.aborted ? s() : e.signal.addEventListener("abort", s)));
    const p = UAe(f);
    if (p && El.protocols.indexOf(p) === -1) {
      r(new En("Unsupported protocol " + p + ":", En.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(i || null);
  });
}, Cb = {
  http: gAe,
  xhr: VAe
};
Ie.forEach(Cb, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const GAe = {
  getAdapter: (e) => {
    e = Ie.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let i = 0; i < t && (n = e[i], !(r = Ie.isString(n) ? Cb[n.toLowerCase()] : n)); i++)
      ;
    if (!r)
      throw r === !1 ? new En(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        Ie.hasOwnProp(Cb, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!Ie.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: Cb
};
function y_(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $v(null, e);
}
function k6(e) {
  return y_(e), e.headers = uc.from(e.headers), e.data = v_.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), GAe.getAdapter(e.adapter || U2.adapter)(e).then(function(r) {
    return y_(e), r.data = v_.call(
      e,
      e.transformResponse,
      r
    ), r.headers = uc.from(r.headers), r;
  }, function(r) {
    return ZG(r) || (y_(e), r && r.response && (r.response.data = v_.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = uc.from(r.response.headers))), Promise.reject(r);
  });
}
const L6 = (e) => e instanceof uc ? e.toJSON() : e;
function Jp(e, t) {
  t = t || {};
  const n = {};
  function r(c, f, d) {
    return Ie.isPlainObject(c) && Ie.isPlainObject(f) ? Ie.merge.call({ caseless: d }, c, f) : Ie.isPlainObject(f) ? Ie.merge({}, f) : Ie.isArray(f) ? f.slice() : f;
  }
  function i(c, f, d) {
    if (Ie.isUndefined(f)) {
      if (!Ie.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, f, d);
  }
  function o(c, f) {
    if (!Ie.isUndefined(f))
      return r(void 0, f);
  }
  function a(c, f) {
    if (Ie.isUndefined(f)) {
      if (!Ie.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, f);
  }
  function s(c, f, d) {
    if (d in t)
      return r(c, f);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (c, f) => i(L6(c), L6(f), !0)
  };
  return Ie.forEach(Object.keys(Object.assign({}, e, t)), function(f) {
    const d = l[f] || i, p = d(e[f], t[f], f);
    Ie.isUndefined(p) && d !== s || (n[f] = p);
  }), n;
}
const tK = "1.4.0", H2 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  H2[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const D6 = {};
H2.transitional = function(t, n, r) {
  function i(o, a) {
    return "[Axios v" + tK + "] Transitional option '" + o + "'" + a + (r ? ". " + r : "");
  }
  return (o, a, s) => {
    if (t === !1)
      throw new En(
        i(a, " has been removed" + (n ? " in " + n : "")),
        En.ERR_DEPRECATED
      );
    return n && !D6[a] && (D6[a] = !0, console.warn(
      i(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, a, s) : !0;
  };
};
function KAe(e, t, n) {
  if (typeof e != "object")
    throw new En("options must be an object", En.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const o = r[i], a = t[o];
    if (a) {
      const s = e[o], l = s === void 0 || a(s, o, e);
      if (l !== !0)
        throw new En("option " + o + " must be " + l, En.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new En("Unknown option " + o, En.ERR_BAD_OPTION);
  }
}
const cI = {
  assertOptions: KAe,
  validators: H2
}, jc = cI.validators;
class G1 {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new R6(),
      response: new R6()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Jp(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: o } = n;
    r !== void 0 && cI.assertOptions(r, {
      silentJSONParsing: jc.transitional(jc.boolean),
      forcedJSONParsing: jc.transitional(jc.boolean),
      clarifyTimeoutError: jc.transitional(jc.boolean)
    }, !1), i != null && (Ie.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : cI.assertOptions(i, {
      encode: jc.function,
      serialize: jc.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a;
    a = o && Ie.merge(
      o.common,
      o[n.method]
    ), a && Ie.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete o[v];
      }
    ), n.headers = uc.concat(a, o);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(n) === !1 || (l = l && y.synchronous, s.unshift(y.fulfilled, y.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(y) {
      c.push(y.fulfilled, y.rejected);
    });
    let f, d = 0, p;
    if (!l) {
      const v = [k6.bind(this), void 0];
      for (v.unshift.apply(v, s), v.push.apply(v, c), p = v.length, f = Promise.resolve(n); d < p; )
        f = f.then(v[d++], v[d++]);
      return f;
    }
    p = s.length;
    let g = n;
    for (d = 0; d < p; ) {
      const v = s[d++], y = s[d++];
      try {
        g = v(g);
      } catch (x) {
        y.call(this, x);
        break;
      }
    }
    try {
      f = k6.call(this, g);
    } catch (v) {
      return Promise.reject(v);
    }
    for (d = 0, p = c.length; d < p; )
      f = f.then(c[d++], c[d++]);
    return f;
  }
  getUri(t) {
    t = Jp(this.defaults, t);
    const n = eK(t.baseURL, t.url);
    return XG(n, t.params, t.paramsSerializer);
  }
}
Ie.forEach(["delete", "get", "head", "options"], function(t) {
  G1.prototype[t] = function(n, r) {
    return this.request(Jp(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
Ie.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, a, s) {
      return this.request(Jp(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: a
      }));
    };
  }
  G1.prototype[t] = n(), G1.prototype[t + "Form"] = n(!0);
});
const Eb = G1;
class W2 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let o;
      const a = new Promise((s) => {
        r.subscribe(s), o = s;
      }).then(i);
      return a.cancel = function() {
        r.unsubscribe(o);
      }, a;
    }, t(function(o, a, s) {
      r.reason || (r.reason = new $v(o, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new W2(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
}
const qAe = W2;
function YAe(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function XAe(e) {
  return Ie.isObject(e) && e.isAxiosError === !0;
}
const uI = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(uI).forEach(([e, t]) => {
  uI[t] = e;
});
const QAe = uI;
function nK(e) {
  const t = new Eb(e), n = jG(Eb.prototype.request, t);
  return Ie.extend(n, Eb.prototype, t, { allOwnKeys: !0 }), Ie.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return nK(Jp(e, i));
  }, n;
}
const mi = nK(U2);
mi.Axios = Eb;
mi.CanceledError = $v;
mi.CancelToken = qAe;
mi.isCancel = ZG;
mi.VERSION = tK;
mi.toFormData = Nx;
mi.AxiosError = En;
mi.Cancel = mi.CanceledError;
mi.all = function(t) {
  return Promise.all(t);
};
mi.spread = YAe;
mi.isAxiosError = XAe;
mi.mergeConfig = Jp;
mi.AxiosHeaders = uc;
mi.formToJSON = (e) => JG(Ie.isHTMLForm(e) ? new FormData(e) : e);
mi.HttpStatusCode = QAe;
mi.default = mi;
const ng = mi;
class zo {
  constructor() {
    this.clientUrl = "https://api.chatfusion.contactloop.com/api";
    const t = ng.create({
      baseURL: this.clientUrl,
      headers: {
        "content-type": "application/json"
      }
    });
    this.client = lre.fromAxiosInstance(t);
  }
  static create() {
    return zo._instance || (zo._instance = new zo()), zo._instance;
  }
  static getInstance() {
    return zo._instance || (zo._instance = zo.create()), zo._instance;
  }
  getClient() {
    return this.client;
  }
}
var rK = /* @__PURE__ */ ((e) => (e.Webchat = "webchat", e.SiteCompanion = "site-companion", e))(rK || {});
class JAe {
  constructor() {
    this.clientUrl = "https://api.chatfusion.contactloop.com/api";
  }
  toDomainModel(t) {
    var a, s, l, c, f, d, p, g, v, y, x, b, w, S, E, O, $, P, R, L, B, j, A, T, k, F, W, V, G, X, D, te, ee;
    const n = {
      display: {
        theme: Jt.fusion,
        themeColor: "#635fe7",
        position: {
          horizon: Y1.right,
          vertical: Af.bottom
        },
        title: "My Bot",
        welcomeMsg: null,
        showProvider: !0,
        launcherAlwaysShow: !0
      },
      popup: {
        launcherIconUrl: "https://chatfusion.contactloop.com/static/images/message-white.svg",
        NewMessagesNotificationSettings: H1.BADGE,
        autoPopup: {
          first: [0],
          next: [],
          minimize: []
        },
        officeHours: {
          0: [0, 2359],
          1: [0, 2359],
          2: [0, 2359],
          3: [0, 2359],
          4: [0, 2359],
          5: [0, 2359],
          6: [0, 2359]
        }
      },
      launcher: {
        placementStyle: Bi.Bubble,
        placementSize: Wg.Small,
        placementDisplayType: Vg.IconOnly
      }
    };
    let r;
    if (t.display_setting) {
      const U = () => {
        var Se, _e, Ge, Fe;
        return (_e = (Se = t.display_setting) == null ? void 0 : Se.custom) != null && _e.showLogo ? !0 : yt.isNil((Fe = (Ge = t.display_setting) == null ? void 0 : Ge.custom) == null ? void 0 : Fe.showLogo);
      }, he = () => {
        var Se, _e, Ge, Fe;
        return (_e = (Se = t.display_setting) == null ? void 0 : Se.custom) != null && _e.showAvatar ? !0 : yt.isNil((Fe = (Ge = t.display_setting) == null ? void 0 : Ge.custom) == null ? void 0 : Fe.showAvatar);
      }, re = () => {
        var Ge;
        const Se = ["Hey there, how can I help you?"], _e = (Ge = t.greetings) == null ? void 0 : Ge.welcome_messages;
        return !_e || _e.length < 1 ? Se : _e;
      }, we = ((a = t.channel_settings[0]) == null ? void 0 : a.channel_type) === rK.SiteCompanion ? !0 : t.display_setting.defaultPopup === !1;
      let ue = (s = t.display_setting.popup) == null ? void 0 : s.launcherIconUrl;
      ue = ue != null && ue.startsWith("/static/images/") ? `https://chatfusion.contactloop.com${ue}` : ue;
      const me = {
        ...F2.isFeatureEnabled() ? {
          invitationModal: {
            show: ((c = (l = t.display_setting) == null ? void 0 : l.invitation_modal) == null ? void 0 : c.show) ?? !1,
            waitTime: ((d = (f = t.display_setting) == null ? void 0 : f.invitation_modal) == null ? void 0 : d.wait_time) ?? 18,
            invitationMessage: ((g = (p = t.display_setting) == null ? void 0 : p.invitation_modal) == null ? void 0 : g.invitation_message) ?? "Would you like to chat?",
            openWebchatButtonText: ((y = (v = t.display_setting) == null ? void 0 : v.invitation_modal) == null ? void 0 : y.open_webchat_button_text) ?? "Yes",
            dismissButtonText: ((b = (x = t.display_setting) == null ? void 0 : x.invitation_modal) == null ? void 0 : b.dismiss_button_text) ?? "No"
          }
        } : {}
      };
      r = {
        display: {
          theme: t.display_setting.theme ?? Jt.fusion,
          themeColor: t.display_setting.themeColor,
          position: {
            horizon: ((w = t.display_setting.position) == null ? void 0 : w.horizon) || Y1.right,
            vertical: Af.bottom
          },
          title: t.display_setting.title ?? "My Bot",
          welcomeMsg: re(),
          showProvider: t.display_setting.showProvider ?? !0,
          showBetaTag: !1,
          disclaimers: (S = t.display_setting.disclaimers) != null && S.show ? t.display_setting.disclaimers.content : "",
          disclaimerPosition: ((E = t.display_setting.disclaimers) == null ? void 0 : E.position) ?? Af.bottom,
          disclaimersAlwaysOn: ((O = t.display_setting.disclaimers) == null ? void 0 : O.alwaysOn) ?? !0,
          launcherAlwaysShow: t.display_setting.launcherAlwaysShow ?? !0,
          custom: {
            showLogo: U(),
            logo: (($ = t.display_setting.custom) == null ? void 0 : $.logo) ?? "https://chatfusion.onramplab.com/static/images/logo.svg",
            brandName: (P = t.display_setting.custom) == null ? void 0 : P.brandName,
            provider: "ChatFusion",
            showAvatar: he(),
            avatar: ((R = t.display_setting.custom) == null ? void 0 : R.avatar) ?? null,
            subHeader: ((L = t.display_setting.custom) == null ? void 0 : L.subHeader) ?? "Our bot answers instantly",
            msgPlacehold: ((B = t.display_setting.custom) == null ? void 0 : B.msgPlacehold) ?? null,
            brandLogo: ((j = t.display_setting.custom) == null ? void 0 : j.brandLogo) ?? "https://chatfusion.contactloop.com/static/images/logo_icon.svg",
            enablePopupSmallMode: ((A = t.display_setting.custom) == null ? void 0 : A.enablePopupSmallMode) ?? !1,
            showSmallPopupStarterQuestions: ((T = t.display_setting.custom) == null ? void 0 : T.showSmallPopupStarterQuestions) ?? !1
          },
          ...me
        },
        popup: {
          launcherIconUrl: ue ?? "https://chatfusion.contactloop.com/static/images/message-white.svg",
          // TODO: will default to badge to keep original behavior
          // NewMessagesNotificationSettings: infraSettings.display_setting.popup?.newMessagesNotification,
          NewMessagesNotificationSettings: H1.BADGE,
          autoPopup: {
            first: we ? [] : [0],
            next: [],
            minimize: []
          },
          officeHours: (k = t.display_setting.popup) == null ? void 0 : k.officeHours
        },
        answerRatingOptions: (((F = t == null ? void 0 : t.relationships) == null ? void 0 : F.answer_rating_options) || []).map(
          (Se) => ({
            id: Se.id,
            type: Se.type,
            content: Se.content
          })
        ),
        launcher: {
          placementStyle: ((V = (W = t.display_setting) == null ? void 0 : W.launcher) == null ? void 0 : V.placement_style) ?? Bi.Bubble,
          placementSize: ((X = (G = t.display_setting) == null ? void 0 : G.launcher) == null ? void 0 : X.placement_size) ?? Wg.Small,
          placementDisplayType: ((D = t.display_setting.launcher) == null ? void 0 : D.placement_display_type) ?? Vg.IconOnly,
          placementFullImageUrl: (te = t.display_setting.launcher) == null ? void 0 : te.placement_full_image_url
        }
      };
    }
    const i = (((ee = t.greetings) == null ? void 0 : ee.starter_questions) || []).map(
      (U) => typeof U == "string" ? {
        question: U ?? "",
        answer: ""
      } : typeof U == "object" && U !== null && "question" in U ? { question: U.question ?? "", answer: U.answer ?? "" } : { question: U ?? "", answer: "" }
    );
    return {
      id: t.id,
      source: "Chat Fusion",
      sourceId: t.id,
      display: (r == null ? void 0 : r.display) ?? n.display,
      popup: (r == null ? void 0 : r.popup) ?? n.popup,
      startQuestions: i,
      answerRatingOptions: (r == null ? void 0 : r.answerRatingOptions) || [],
      launcher: (r == null ? void 0 : r.launcher) ?? n.launcher
    };
  }
  async getSettings({
    sourceId: t,
    url: n
  }) {
    if (!t)
      throw new Error("lost source id");
    const r = t;
    let i;
    Ho.UseAPICLient ? i = (await zo.create().getClient().open.getBot(r, n)).data : i = await Mr.get(
      `/chat/bots/${r}`,
      {
        url: this.validateUrlOrDefault(n)
      },
      {
        baseURL: this.clientUrl
      }
    );
    const o = this.toDomainModel(i.data);
    return Promise.resolve(o);
  }
  validateUrlOrDefault(t) {
    return !t || t.trim() === "" ? `${document.location.origin}${document.location.pathname}` : /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(t) ? t : document.location.href;
  }
}
const ZAe = new JAe(), iK = () => ({
  get: async (t, n) => {
    try {
      const r = await iIe({
        WebchatSettingOutput: ZAe,
        sourceId: t,
        parentWindowUrl: n
      });
      return new TIe(r);
    } catch (r) {
      throw new Error(r);
    }
  }
}), { get: eRe } = iK(), _v = Nu(
  `${ku}/fetchRemoteSettings`,
  async (e) => {
    try {
      const { webchatId: t, parentWindowUrl: n, remoteSettingsProps: r } = e, i = new qTe().perform();
      let o;
      return r ? o = r : o = await eRe(t, n), { webChatConfigs: e, webchatSettings: o, webChatUrlConfig: i };
    } catch (t) {
      throw Zo(t, "WebchatSettings", "getSettings");
    }
  }
), oK = Iw({
  name: ku,
  initialState: TG,
  reducers: {},
  extraReducers: (e) => {
    e.addCase(_v.fulfilled, (t, n) => {
      const { webchatSettings: r, webChatUrlConfig: i } = n.payload, o = r.sliceData, a = i.autoPopup ?? yt.isEqual(r.autoPopup.first, [0]);
      t.auto_popup = {
        ...o.auto_popup,
        first: a ? [0] : []
      }, t.office_hours = o.office_hours, t.time_zone = o.time_zone, t.new_messages_notification = o.new_messages_notification, t[D2] = !1, t.launcher_icon_url = o.launcher_icon_url, t.display = o.display, t.start_questions = o.start_questions;
    });
  }
}), V2 = (e) => {
  const t = wr();
  m.useEffect(() => {
    t(_v(e));
  }, []);
};
var lt = {}, fI = { exports: {} };
(function(e, t) {
  (function(n, r) {
    var i = "1.0.37", o = "", a = "?", s = "function", l = "undefined", c = "object", f = "string", d = "major", p = "model", g = "name", v = "type", y = "vendor", x = "version", b = "architecture", w = "console", S = "mobile", E = "tablet", O = "smarttv", $ = "wearable", P = "embedded", R = 500, L = "Amazon", B = "Apple", j = "ASUS", A = "BlackBerry", T = "Browser", k = "Chrome", F = "Edge", W = "Firefox", V = "Google", G = "Huawei", X = "LG", D = "Microsoft", te = "Motorola", ee = "Opera", U = "Samsung", he = "Sharp", re = "Sony", de = "Xiaomi", we = "Zebra", ue = "Facebook", me = "Chromium OS", Se = "Mac OS", _e = function(Z, se) {
      var Ce = {};
      for (var Pe in Z)
        se[Pe] && se[Pe].length % 2 === 0 ? Ce[Pe] = se[Pe].concat(Z[Pe]) : Ce[Pe] = Z[Pe];
      return Ce;
    }, Ge = function(Z) {
      for (var se = {}, Ce = 0; Ce < Z.length; Ce++)
        se[Z[Ce].toUpperCase()] = Z[Ce];
      return se;
    }, Fe = function(Z, se) {
      return typeof Z === f ? Ae(se).indexOf(Ae(Z)) !== -1 : !1;
    }, Ae = function(Z) {
      return Z.toLowerCase();
    }, Me = function(Z) {
      return typeof Z === f ? Z.replace(/[^\d\.]/g, o).split(".")[0] : r;
    }, et = function(Z, se) {
      if (typeof Z === f)
        return Z = Z.replace(/^\s\s*/, o), typeof se === l ? Z : Z.substring(0, R);
    }, De = function(Z, se) {
      for (var Ce = 0, Pe, Ee, We, ze, Ye, xt; Ce < se.length && !Ye; ) {
        var Lt = se[Ce], mt = se[Ce + 1];
        for (Pe = Ee = 0; Pe < Lt.length && !Ye && Lt[Pe]; )
          if (Ye = Lt[Pe++].exec(Z), Ye)
            for (We = 0; We < mt.length; We++)
              xt = Ye[++Ee], ze = mt[We], typeof ze === c && ze.length > 0 ? ze.length === 2 ? typeof ze[1] == s ? this[ze[0]] = ze[1].call(this, xt) : this[ze[0]] = ze[1] : ze.length === 3 ? typeof ze[1] === s && !(ze[1].exec && ze[1].test) ? this[ze[0]] = xt ? ze[1].call(this, xt, ze[2]) : r : this[ze[0]] = xt ? xt.replace(ze[1], ze[2]) : r : ze.length === 4 && (this[ze[0]] = xt ? ze[3].call(this, xt.replace(ze[1], ze[2])) : r) : this[ze] = xt || r;
        Ce += 2;
      }
    }, je = function(Z, se) {
      for (var Ce in se)
        if (typeof se[Ce] === c && se[Ce].length > 0) {
          for (var Pe = 0; Pe < se[Ce].length; Pe++)
            if (Fe(se[Ce][Pe], Z))
              return Ce === a ? r : Ce;
        } else if (Fe(se[Ce], Z))
          return Ce === a ? r : Ce;
      return Z;
    }, ie = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, fe = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, be = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [x, [g, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [x, [g, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [g, x], [/opios[\/ ]+([\w\.]+)/i], [x, [g, ee + " Mini"]], [/\bopr\/([\w\.]+)/i], [x, [g, ee]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [x, [g, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [g, x], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [x, [g, "UC" + T]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [x, [g, "WeChat"]], [/konqueror\/([\w\.]+)/i], [x, [g, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [x, [g, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [x, [g, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [x, [g, "Smart Lenovo " + T]], [/(avast|avg)\/([\w\.]+)/i], [[g, /(.+)/, "$1 Secure " + T], x], [/\bfocus\/([\w\.]+)/i], [x, [g, W + " Focus"]], [/\bopt\/([\w\.]+)/i], [x, [g, ee + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [x, [g, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [x, [g, "Dolphin"]], [/coast\/([\w\.]+)/i], [x, [g, ee + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [x, [g, "MIUI " + T]], [/fxios\/([-\w\.]+)/i], [x, [g, W]], [/\bqihu|(qi?ho?o?|360)browser/i], [[g, "360 " + T]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[g, /(.+)/, "$1 " + T], x], [/samsungbrowser\/([\w\.]+)/i], [x, [g, U + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[g, /_/g, " "], x], [/metasr[\/ ]?([\d\.]+)/i], [x, [g, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[g, "Sogou Mobile"], x], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [g, x], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [g], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[g, ue], x], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [g, x], [/\bgsa\/([\w\.]+) .*safari\//i], [x, [g, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [x, [g, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [x, [g, k + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[g, k + " WebView"], x], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [x, [g, "Android " + T]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [g, x], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [x, [g, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [x, g], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [g, [x, je, ie]], [/(webkit|khtml)\/([\w\.]+)/i], [g, x], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[g, "Netscape"], x], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [x, [g, W + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [g, x], [/(cobalt)\/([\w\.]+)/i], [g, [x, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[b, "amd64"]], [/(ia32(?=;))/i], [[b, Ae]], [/((?:i[346]|x)86)[;\)]/i], [[b, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[b, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[b, "armhf"]], [/windows (ce|mobile); ppc;/i], [[b, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[b, /ower/, o, Ae]], [/(sun4\w)[;\)]/i], [[b, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[b, Ae]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [p, [y, U], [v, E]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [p, [y, U], [v, S]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [p, [y, B], [v, S]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [p, [y, B], [v, E]], [/(macintosh);/i], [p, [y, B]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [p, [y, he], [v, S]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [p, [y, G], [v, E]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [p, [y, G], [v, S]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[p, /_/g, " "], [y, de], [v, S]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[p, /_/g, " "], [y, de], [v, E]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [p, [y, "OPPO"], [v, S]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [p, [y, "Vivo"], [v, S]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [p, [y, "Realme"], [v, S]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [p, [y, te], [v, S]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [p, [y, te], [v, E]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [p, [y, X], [v, E]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [p, [y, X], [v, S]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [p, [y, "Lenovo"], [v, E]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[p, /_/g, " "], [y, "Nokia"], [v, S]], [/(pixel c)\b/i], [p, [y, V], [v, E]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [p, [y, V], [v, S]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [p, [y, re], [v, S]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[p, "Xperia Tablet"], [y, re], [v, E]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [p, [y, "OnePlus"], [v, S]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [p, [y, L], [v, E]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[p, /(.+)/g, "Fire Phone $1"], [y, L], [v, S]], [/(playbook);[-\w\),; ]+(rim)/i], [p, y, [v, E]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [p, [y, A], [v, S]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [p, [y, j], [v, E]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [p, [y, j], [v, S]], [/(nexus 9)/i], [p, [y, "HTC"], [v, E]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [y, [p, /_/g, " "], [v, S]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [p, [y, "Acer"], [v, E]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [p, [y, "Meizu"], [v, S]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [p, [y, "Ulefone"], [v, S]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [y, p, [v, S]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [y, p, [v, E]], [/(surface duo)/i], [p, [y, D], [v, E]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [p, [y, "Fairphone"], [v, S]], [/(u304aa)/i], [p, [y, "AT&T"], [v, S]], [/\bsie-(\w*)/i], [p, [y, "Siemens"], [v, S]], [/\b(rct\w+) b/i], [p, [y, "RCA"], [v, E]], [/\b(venue[\d ]{2,7}) b/i], [p, [y, "Dell"], [v, E]], [/\b(q(?:mv|ta)\w+) b/i], [p, [y, "Verizon"], [v, E]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [p, [y, "Barnes & Noble"], [v, E]], [/\b(tm\d{3}\w+) b/i], [p, [y, "NuVision"], [v, E]], [/\b(k88) b/i], [p, [y, "ZTE"], [v, E]], [/\b(nx\d{3}j) b/i], [p, [y, "ZTE"], [v, S]], [/\b(gen\d{3}) b.+49h/i], [p, [y, "Swiss"], [v, S]], [/\b(zur\d{3}) b/i], [p, [y, "Swiss"], [v, E]], [/\b((zeki)?tb.*\b) b/i], [p, [y, "Zeki"], [v, E]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[y, "Dragon Touch"], p, [v, E]], [/\b(ns-?\w{0,9}) b/i], [p, [y, "Insignia"], [v, E]], [/\b((nxa|next)-?\w{0,9}) b/i], [p, [y, "NextBook"], [v, E]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[y, "Voice"], p, [v, S]], [/\b(lvtel\-)?(v1[12]) b/i], [[y, "LvTel"], p, [v, S]], [/\b(ph-1) /i], [p, [y, "Essential"], [v, S]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [p, [y, "Envizen"], [v, E]], [/\b(trio[-\w\. ]+) b/i], [p, [y, "MachSpeed"], [v, E]], [/\btu_(1491) b/i], [p, [y, "Rotor"], [v, E]], [/(shield[\w ]+) b/i], [p, [y, "Nvidia"], [v, E]], [/(sprint) (\w+)/i], [y, p, [v, S]], [/(kin\.[onetw]{3})/i], [[p, /\./g, " "], [y, D], [v, S]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [p, [y, we], [v, E]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [p, [y, we], [v, S]], [/smart-tv.+(samsung)/i], [y, [v, O]], [/hbbtv.+maple;(\d+)/i], [[p, /^/, "SmartTV"], [y, U], [v, O]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[y, X], [v, O]], [/(apple) ?tv/i], [y, [p, B + " TV"], [v, O]], [/crkey/i], [[p, k + "cast"], [y, V], [v, O]], [/droid.+aft(\w+)( bui|\))/i], [p, [y, L], [v, O]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [p, [y, he], [v, O]], [/(bravia[\w ]+)( bui|\))/i], [p, [y, re], [v, O]], [/(mitv-\w{5}) bui/i], [p, [y, de], [v, O]], [/Hbbtv.*(technisat) (.*);/i], [y, p, [v, O]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[y, et], [p, et], [v, O]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[v, O]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [y, p, [v, w]], [/droid.+; (shield) bui/i], [p, [y, "Nvidia"], [v, w]], [/(playstation [345portablevi]+)/i], [p, [y, re], [v, w]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [p, [y, D], [v, w]], [/((pebble))app/i], [y, p, [v, $]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [p, [y, B], [v, $]], [/droid.+; (glass) \d/i], [p, [y, V], [v, $]], [/droid.+; (wt63?0{2,3})\)/i], [p, [y, we], [v, $]], [/(quest( 2| pro)?)/i], [p, [y, ue], [v, $]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [y, [v, P]], [/(aeobc)\b/i], [p, [y, L], [v, P]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [p, [v, S]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [p, [v, E]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[v, E]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[v, S]], [/(android[-\w\. ]{0,9});.+buil/i], [p, [y, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [x, [g, F + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [x, [g, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [g, x], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [x, g]], os: [[/microsoft (windows) (vista|xp)/i], [g, x], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [g, [x, je, fe]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[x, je, fe], [g, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[x, /_/g, "."], [g, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[g, Se], [x, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [x, g], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [g, x], [/\(bb(10);/i], [x, [g, A]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [x, [g, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [x, [g, W + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [x, [g, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [x, [g, "watchOS"]], [/crkey\/([\d\.]+)/i], [x, [g, k + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[g, me], x], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [g, x], [/(sunos) ?([\w\.\d]*)/i], [[g, "Solaris"], x], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [g, x]] }, Te = function(Z, se) {
      if (typeof Z === c && (se = Z, Z = r), !(this instanceof Te))
        return new Te(Z, se).getResult();
      var Ce = typeof n !== l && n.navigator ? n.navigator : r, Pe = Z || (Ce && Ce.userAgent ? Ce.userAgent : o), Ee = Ce && Ce.userAgentData ? Ce.userAgentData : r, We = se ? _e(be, se) : be, ze = Ce && Ce.userAgent == Pe;
      return this.getBrowser = function() {
        var Ye = {};
        return Ye[g] = r, Ye[x] = r, De.call(Ye, Pe, We.browser), Ye[d] = Me(Ye[x]), ze && Ce && Ce.brave && typeof Ce.brave.isBrave == s && (Ye[g] = "Brave"), Ye;
      }, this.getCPU = function() {
        var Ye = {};
        return Ye[b] = r, De.call(Ye, Pe, We.cpu), Ye;
      }, this.getDevice = function() {
        var Ye = {};
        return Ye[y] = r, Ye[p] = r, Ye[v] = r, De.call(Ye, Pe, We.device), ze && !Ye[v] && Ee && Ee.mobile && (Ye[v] = S), ze && Ye[p] == "Macintosh" && Ce && typeof Ce.standalone !== l && Ce.maxTouchPoints && Ce.maxTouchPoints > 2 && (Ye[p] = "iPad", Ye[v] = E), Ye;
      }, this.getEngine = function() {
        var Ye = {};
        return Ye[g] = r, Ye[x] = r, De.call(Ye, Pe, We.engine), Ye;
      }, this.getOS = function() {
        var Ye = {};
        return Ye[g] = r, Ye[x] = r, De.call(Ye, Pe, We.os), ze && !Ye[g] && Ee && Ee.platform != "Unknown" && (Ye[g] = Ee.platform.replace(/chrome os/i, me).replace(/macos/i, Se)), Ye;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return Pe;
      }, this.setUA = function(Ye) {
        return Pe = typeof Ye === f && Ye.length > R ? et(Ye, R) : Ye, this;
      }, this.setUA(Pe), this;
    };
    Te.VERSION = i, Te.BROWSER = Ge([g, x, d]), Te.CPU = Ge([b]), Te.DEVICE = Ge([p, y, v, w, S, O, E, $, P]), Te.ENGINE = Te.OS = Ge([g, x]), e.exports && (t = e.exports = Te), t.UAParser = Te;
    var Le = typeof n !== l && (n.jQuery || n.Zepto);
    if (Le && !Le.ua) {
      var ct = new Te();
      Le.ua = ct.getResult(), Le.ua.get = function() {
        return ct.getUA();
      }, Le.ua.set = function(Z) {
        ct.setUA(Z);
        var se = ct.getResult();
        for (var Ce in se)
          Le.ua[Ce] = se[Ce];
      };
    }
  })(typeof window == "object" ? window : qa);
})(fI, fI.exports);
var tRe = fI.exports;
Object.defineProperty(lt, "__esModule", { value: !0 });
function nRe(e) {
  return e && typeof e == "object" && "default" in e ? e.default : e;
}
var po = m, fr = nRe(po), aK = tRe, Lu = new aK(), go = Lu.getBrowser(), rRe = Lu.getCPU(), Ma = Lu.getDevice(), G2 = Lu.getEngine(), Du = Lu.getOS(), Ov = Lu.getUA(), sK = function(t) {
  return Lu.setUA(t);
}, Pv = function(t) {
  if (!t) {
    console.error("No userAgent string was provided");
    return;
  }
  var n = new aK(t);
  return {
    UA: n,
    browser: n.getBrowser(),
    cpu: n.getCPU(),
    device: n.getDevice(),
    engine: n.getEngine(),
    os: n.getOS(),
    ua: n.getUA(),
    setUserAgent: function(i) {
      return n.setUA(i);
    }
  };
}, lK = /* @__PURE__ */ Object.freeze({
  ClientUAInstance: Lu,
  browser: go,
  cpu: rRe,
  device: Ma,
  engine: G2,
  os: Du,
  ua: Ov,
  setUa: sK,
  parseUserAgent: Pv
});
function j6(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function iRe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j6(Object(n), !0).forEach(function(r) {
      sRe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : j6(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function rg(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rg = function(t) {
    return typeof t;
  } : rg = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rg(e);
}
function oRe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function F6(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function aRe(e, t, n) {
  return t && F6(e.prototype, t), n && F6(e, n), e;
}
function sRe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function dI() {
  return dI = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dI.apply(this, arguments);
}
function lRe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && hI(e, t);
}
function pI(e) {
  return pI = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, pI(e);
}
function hI(e, t) {
  return hI = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, hI(e, t);
}
function cRe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function hs(e, t) {
  if (e == null)
    return {};
  var n = cRe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $b(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function uRe(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $b(e);
}
function fRe(e, t) {
  return dRe(e) || pRe(e, t) || hRe(e, t) || mRe();
}
function dRe(e) {
  if (Array.isArray(e))
    return e;
}
function pRe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o)
          throw s;
      }
    }
    return r;
  }
}
function hRe(e, t) {
  if (e) {
    if (typeof e == "string")
      return B6(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return B6(e, t);
  }
}
function B6(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function mRe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var co = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, Qo = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, $h = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, gRe = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, vRe = function(t) {
  switch (t) {
    case co.Mobile:
      return {
        isMobile: !0
      };
    case co.Tablet:
      return {
        isTablet: !0
      };
    case co.SmartTv:
      return {
        isSmartTV: !0
      };
    case co.Console:
      return {
        isConsole: !0
      };
    case co.Wearable:
      return {
        isWearable: !0
      };
    case co.Browser:
      return {
        isBrowser: !0
      };
    case co.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return gRe;
  }
}, yRe = function(t) {
  return sK(t);
}, zt = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return t || n;
}, K2 = function() {
  return typeof window < "u" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, q2 = function(t) {
  var n = K2();
  return n && n.platform && (n.platform.indexOf(t) !== -1 || n.platform === "MacIntel" && n.maxTouchPoints > 1 && !window.MSStream);
}, bRe = function(t, n, r, i, o) {
  return {
    isBrowser: t,
    browserMajorVersion: zt(n.major),
    browserFullVersion: zt(n.version),
    browserName: zt(n.name),
    engineName: zt(r.name),
    engineVersion: zt(r.version),
    osName: zt(i.name),
    osVersion: zt(i.version),
    userAgent: zt(o)
  };
}, z6 = function(t, n, r, i) {
  return iRe({}, t, {
    vendor: zt(n.vendor),
    model: zt(n.model),
    os: zt(r.name),
    osVersion: zt(r.version),
    ua: zt(i)
  });
}, wRe = function(t, n, r, i) {
  return {
    isSmartTV: t,
    engineName: zt(n.name),
    engineVersion: zt(n.version),
    osName: zt(r.name),
    osVersion: zt(r.version),
    userAgent: zt(i)
  };
}, SRe = function(t, n, r, i) {
  return {
    isConsole: t,
    engineName: zt(n.name),
    engineVersion: zt(n.version),
    osName: zt(r.name),
    osVersion: zt(r.version),
    userAgent: zt(i)
  };
}, xRe = function(t, n, r, i) {
  return {
    isWearable: t,
    engineName: zt(n.name),
    engineVersion: zt(n.version),
    osName: zt(r.name),
    osVersion: zt(r.version),
    userAgent: zt(i)
  };
}, CRe = function(t, n, r, i, o) {
  return {
    isEmbedded: t,
    vendor: zt(n.vendor),
    model: zt(n.model),
    engineName: zt(r.name),
    engineVersion: zt(r.version),
    osName: zt(i.name),
    osVersion: zt(i.version),
    userAgent: zt(o)
  };
};
function ERe(e) {
  var t = e ? Pv(e) : lK, n = t.device, r = t.browser, i = t.engine, o = t.os, a = t.ua, s = vRe(n.type), l = s.isBrowser, c = s.isMobile, f = s.isTablet, d = s.isSmartTV, p = s.isConsole, g = s.isWearable, v = s.isEmbedded;
  if (l)
    return bRe(l, r, i, o, a);
  if (d)
    return wRe(d, i, o, a);
  if (p)
    return SRe(p, i, o, a);
  if (c || f)
    return z6(s, n, o, a);
  if (g)
    return xRe(g, i, o, a);
  if (v)
    return CRe(v, n, i, o, a);
}
var cK = function(t) {
  var n = t.type;
  return n === co.Mobile;
}, uK = function(t) {
  var n = t.type;
  return n === co.Tablet;
}, fK = function(t) {
  var n = t.type;
  return n === co.Mobile || n === co.Tablet;
}, dK = function(t) {
  var n = t.type;
  return n === co.SmartTv;
}, K1 = function(t) {
  var n = t.type;
  return n === co.Browser;
}, pK = function(t) {
  var n = t.type;
  return n === co.Wearable;
}, hK = function(t) {
  var n = t.type;
  return n === co.Console;
}, mK = function(t) {
  var n = t.type;
  return n === co.Embedded;
}, gK = function(t) {
  var n = t.vendor;
  return zt(n);
}, vK = function(t) {
  var n = t.model;
  return zt(n);
}, yK = function(t) {
  var n = t.type;
  return zt(n, "browser");
}, bK = function(t) {
  var n = t.name;
  return n === $h.Android;
}, wK = function(t) {
  var n = t.name;
  return n === $h.Windows;
}, SK = function(t) {
  var n = t.name;
  return n === $h.MAC_OS;
}, xK = function(t) {
  var n = t.name;
  return n === $h.WindowsPhone;
}, CK = function(t) {
  var n = t.name;
  return n === $h.IOS;
}, EK = function(t) {
  var n = t.version;
  return zt(n);
}, $K = function(t) {
  var n = t.name;
  return zt(n);
}, _K = function(t) {
  var n = t.name;
  return n === Qo.Chrome;
}, OK = function(t) {
  var n = t.name;
  return n === Qo.Firefox;
}, PK = function(t) {
  var n = t.name;
  return n === Qo.Chromium;
}, q1 = function(t) {
  var n = t.name;
  return n === Qo.Edge;
}, TK = function(t) {
  var n = t.name;
  return n === Qo.Yandex;
}, IK = function(t) {
  var n = t.name;
  return n === Qo.Safari || n === Qo.MobileSafari;
}, AK = function(t) {
  var n = t.name;
  return n === Qo.MobileSafari;
}, RK = function(t) {
  var n = t.name;
  return n === Qo.Opera;
}, MK = function(t) {
  var n = t.name;
  return n === Qo.InternetExplorer || n === Qo.Ie;
}, NK = function(t) {
  var n = t.name;
  return n === Qo.MIUI;
}, kK = function(t) {
  var n = t.name;
  return n === Qo.SamsungBrowser;
}, LK = function(t) {
  var n = t.version;
  return zt(n);
}, DK = function(t) {
  var n = t.major;
  return zt(n);
}, jK = function(t) {
  var n = t.name;
  return zt(n);
}, FK = function(t) {
  var n = t.name;
  return zt(n);
}, BK = function(t) {
  var n = t.version;
  return zt(n);
}, zK = function() {
  var t = K2(), n = t && t.userAgent && t.userAgent.toLowerCase();
  return typeof n == "string" ? /electron/.test(n) : !1;
}, Pp = function(t) {
  return typeof t == "string" && t.indexOf("Edg/") !== -1;
}, UK = function() {
  var t = K2();
  return t && (/iPad|iPhone|iPod/.test(t.platform) || t.platform === "MacIntel" && t.maxTouchPoints > 1) && !window.MSStream;
}, wl = function() {
  return q2("iPad");
}, HK = function() {
  return q2("iPhone");
}, WK = function() {
  return q2("iPod");
}, VK = function(t) {
  return zt(t);
};
function GK(e) {
  var t = e || lK, n = t.device, r = t.browser, i = t.os, o = t.engine, a = t.ua;
  return {
    isSmartTV: dK(n),
    isConsole: hK(n),
    isWearable: pK(n),
    isEmbedded: mK(n),
    isMobileSafari: AK(r) || wl(),
    isChromium: PK(r),
    isMobile: fK(n) || wl(),
    isMobileOnly: cK(n),
    isTablet: uK(n) || wl(),
    isBrowser: K1(n),
    isDesktop: K1(n),
    isAndroid: bK(i),
    isWinPhone: xK(i),
    isIOS: CK(i) || wl(),
    isChrome: _K(r),
    isFirefox: OK(r),
    isSafari: IK(r),
    isOpera: RK(r),
    isIE: MK(r),
    osVersion: EK(i),
    osName: $K(i),
    fullBrowserVersion: LK(r),
    browserVersion: DK(r),
    browserName: jK(r),
    mobileVendor: gK(n),
    mobileModel: vK(n),
    engineName: FK(o),
    engineVersion: BK(o),
    getUA: VK(a),
    isEdge: q1(r) || Pp(a),
    isYandex: TK(r),
    deviceType: yK(n),
    isIOS13: UK(),
    isIPad13: wl(),
    isIPhone13: HK(),
    isIPod13: WK(),
    isElectron: zK(),
    isEdgeChromium: Pp(a),
    isLegacyEdge: q1(r) && !Pp(a),
    isWindows: wK(i),
    isMacOs: SK(i),
    isMIUI: NK(r),
    isSamsungBrowser: kK(r)
  };
}
var KK = dK(Ma), qK = hK(Ma), YK = pK(Ma), $Re = mK(Ma), _Re = AK(go) || wl(), ORe = PK(go), Dx = fK(Ma) || wl(), XK = cK(Ma), QK = uK(Ma) || wl(), JK = K1(Ma), PRe = K1(Ma), ZK = bK(Du), eq = xK(Du), tq = CK(Du) || wl(), TRe = _K(go), IRe = OK(go), ARe = IK(go), RRe = RK(go), nq = MK(go), MRe = EK(Du), NRe = $K(Du), kRe = LK(go), LRe = DK(go), DRe = jK(go), jRe = gK(Ma), FRe = vK(Ma), BRe = FK(G2), zRe = BK(G2), URe = VK(Ov), HRe = q1(go) || Pp(Ov), WRe = TK(go), VRe = yK(Ma), GRe = UK(), KRe = wl(), qRe = HK(), YRe = WK(), XRe = zK(), QRe = Pp(Ov), JRe = q1(go) && !Pp(Ov), ZRe = wK(Du), e2e = SK(Du), t2e = NK(go), n2e = kK(go), r2e = function(t) {
  if (!t || typeof t != "string") {
    console.error("No valid user agent string was provided");
    return;
  }
  var n = Pv(t), r = n.device, i = n.browser, o = n.os, a = n.engine, s = n.ua;
  return GK({
    device: r,
    browser: i,
    os: o,
    engine: a,
    ua: s
  });
}, i2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return ZK ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, o2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return JK ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, a2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return nq ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, s2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return tq ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, l2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return Dx ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, c2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return QK ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, u2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return eq ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, f2e = function(t) {
  var n = t.renderWithFragment, r = t.children;
  t.viewClassName, t.style;
  var i = hs(t, ["renderWithFragment", "children", "viewClassName", "style"]);
  return XK ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, d2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return KK ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, p2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return qK ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, h2e = function(t) {
  var n = t.renderWithFragment, r = t.children, i = hs(t, ["renderWithFragment", "children"]);
  return YK ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", i, r) : null;
}, m2e = function(t) {
  var n = t.renderWithFragment, r = t.children;
  t.viewClassName, t.style;
  var i = t.condition, o = hs(t, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return i ? n ? fr.createElement(po.Fragment, null, r) : fr.createElement("div", o, r) : null;
};
function g2e(e) {
  return /* @__PURE__ */ function(t) {
    lRe(n, t);
    function n(r) {
      var i;
      return oRe(this, n), i = uRe(this, pI(n).call(this, r)), i.isEventListenerAdded = !1, i.handleOrientationChange = i.handleOrientationChange.bind($b(i)), i.onOrientationChange = i.onOrientationChange.bind($b(i)), i.onPageLoad = i.onPageLoad.bind($b(i)), i.state = {
        isLandscape: !1,
        isPortrait: !1
      }, i;
    }
    return aRe(n, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var i = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: i === 0,
          isLandscape: i === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window > "u" ? "undefined" : rg(window)) !== void 0 && Dx && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return fr.createElement(e, dI({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), n;
  }(fr.Component);
}
function v2e() {
  var e = po.useState(function() {
    var o = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: o === 0,
      isLandscape: o === 90,
      orientation: o === 0 ? "portrait" : "landscape"
    };
  }), t = fRe(e, 2), n = t[0], r = t[1], i = po.useCallback(function() {
    var o = window.innerWidth > window.innerHeight ? 90 : 0, a = {
      isPortrait: o === 0,
      isLandscape: o === 90,
      orientation: o === 0 ? "portrait" : "landscape"
    };
    n.orientation !== a.orientation && r(a);
  }, [n.orientation]);
  return po.useEffect(function() {
    return (typeof window > "u" ? "undefined" : rg(window)) !== void 0 && Dx && (i(), window.addEventListener("load", i, !1), window.addEventListener("resize", i, !1)), function() {
      window.removeEventListener("resize", i, !1), window.removeEventListener("load", i, !1);
    };
  }, [i]), n;
}
function rq(e) {
  var t = e || window.navigator.userAgent;
  return Pv(t);
}
function y2e(e) {
  var t = e || window.navigator.userAgent, n = rq(t), r = GK(n);
  return [r, n];
}
lt.AndroidView = i2e;
lt.BrowserTypes = Qo;
lt.BrowserView = o2e;
lt.ConsoleView = p2e;
lt.CustomView = m2e;
lt.IEView = a2e;
lt.IOSView = s2e;
lt.MobileOnlyView = f2e;
lt.MobileView = l2e;
lt.OsTypes = $h;
lt.SmartTVView = d2e;
lt.TabletView = c2e;
lt.WearableView = h2e;
lt.WinPhoneView = u2e;
lt.browserName = DRe;
lt.browserVersion = LRe;
lt.deviceDetect = ERe;
lt.deviceType = VRe;
lt.engineName = BRe;
lt.engineVersion = zRe;
lt.fullBrowserVersion = kRe;
lt.getSelectorsByUserAgent = r2e;
lt.getUA = URe;
lt.isAndroid = ZK;
lt.isBrowser = JK;
lt.isChrome = TRe;
lt.isChromium = ORe;
lt.isConsole = qK;
lt.isDesktop = PRe;
lt.isEdge = HRe;
lt.isEdgeChromium = QRe;
lt.isElectron = XRe;
lt.isEmbedded = $Re;
lt.isFirefox = IRe;
lt.isIE = nq;
lt.isIOS = tq;
lt.isIOS13 = GRe;
lt.isIPad13 = KRe;
lt.isIPhone13 = qRe;
lt.isIPod13 = YRe;
lt.isLegacyEdge = JRe;
lt.isMIUI = t2e;
lt.isMacOs = e2e;
var Ec = lt.isMobile = Dx;
lt.isMobileOnly = XK;
lt.isMobileSafari = _Re;
lt.isOpera = RRe;
lt.isSafari = ARe;
lt.isSamsungBrowser = n2e;
lt.isSmartTV = KK;
lt.isTablet = QK;
lt.isWearable = YK;
lt.isWinPhone = eq;
lt.isWindows = ZRe;
lt.isYandex = WRe;
lt.mobileModel = FRe;
lt.mobileVendor = jRe;
lt.osName = NRe;
lt.osVersion = MRe;
lt.parseUserAgent = Pv;
lt.setUserAgent = yRe;
lt.useDeviceData = rq;
lt.useDeviceSelectors = y2e;
lt.useMobileOrientation = v2e;
lt.withOrientationChange = g2e;
const Ur = "core", U6 = {
  isLauncherShown: !1,
  isPopupShown: !1,
  isPopupSmallMode: !1,
  isPopupHovered: !1,
  isPopupFocused: !1,
  isBadgeShown: !0,
  badgeCount: 0,
  shouldPopupOnNewMessage: !1,
  lastInteractionTime: void 0,
  enableSmallPopup: !1,
  showSmallPopupStarterQuestions: !1,
  isSimulateMobile: !1,
  isUserCloseActionBox: !1
};
var Y2 = /* @__PURE__ */ ((e) => (e.Mobile = "mobile", e.Desktop = "desktop", e))(Y2 || {});
const tl = Iw({
  name: Ur,
  initialState: U6,
  reducers: {
    setIsPopupSmallMode: (e, t) => {
      e.isPopupSmallMode = t.payload;
    },
    popupToggled: (e, t) => {
      e.isPopupShown = t.payload !== void 0 ? t.payload : !e.isPopupShown, dU(e).isPopupShown && (e.badgeCount = 0), e.lastInteractionTime = Date.now();
    },
    popupHovered: (e, t) => {
      e.isPopupHovered = t.payload, e.lastInteractionTime = Date.now();
    },
    popupFocused: (e, t) => {
      e.isPopupFocused = t.payload, e.lastInteractionTime = Date.now(), t.payload && (e.badgeCount = 0);
    },
    initBadgeCount: (e) => {
      e.badgeCount = 0;
    },
    updateBadgeCount: (e, t) => {
      e.badgeCount = t.payload;
    },
    updateSimulateMobile: (e, t) => {
      e.isSimulateMobile = t.payload;
    },
    initIsUserCloseActionBox: (e) => {
      e.isUserCloseActionBox = U6.isUserCloseActionBox;
    },
    updateUserCloseActionBox: (e, t) => {
      e.isUserCloseActionBox = t.payload;
    }
  },
  extraReducers: (e) => {
    e.addCase(_v.fulfilled, (t, n) => {
      var w, S;
      const { webChatConfigs: r, webchatSettings: i, webChatUrlConfig: o } = n.payload, { display: a, isWithinOfficeHours: s, shouldPopupOnNewMessage: l, startQuestions: c } = i, d = ((a == null ? void 0 : a.launcherAlwaysShow) ?? !0) && s, p = r.theme === Jt.fusion, g = r.theme === Jt.siteCompanionPopup, v = o.autoPopup ?? yt.isEqual(i.autoPopup.first, [0]), y = t.isSimulateMobile || Ec, x = o.smallPopupStarterQuestions ?? ((w = a == null ? void 0 : a.custom) == null ? void 0 : w.showSmallPopupStarterQuestions) ?? !1, b = o.smallPopup ?? ((S = a == null ? void 0 : a.custom) == null ? void 0 : S.enablePopupSmallMode) ?? !1;
      t.shouldPopupOnNewMessage = l, t.isLauncherShown = d, t.isSimulateMobile = r.isSimulateMobile ?? !1, t.showSmallPopupStarterQuestions = x && !!(c != null && c.length), t.enableSmallPopup = b, t.isPopupSmallMode = p && v && (y || b), g && (t.isPopupShown = !1, t.shouldPopupOnNewMessage = !1);
    }), e.addCase(Aw, (t) => {
      t.isPopupShown = t.isPopupShown || t.shouldPopupOnNewMessage, t.badgeCount = t.isPopupShown ? 0 : t.badgeCount + 1;
    });
  }
}), Vs = tl.actions.popupToggled, H6 = tl.actions.popupHovered, W6 = tl.actions.popupFocused, iq = tl.actions.initBadgeCount, Kg = tl.actions.setIsPopupSmallMode, b2e = tl.actions.updateBadgeCount, w2e = tl.actions.updateSimulateMobile, V6 = tl.actions.updateUserCloseActionBox, S2e = tl.actions.initIsUserCloseActionBox, X2 = (e) => e[Ur].isLauncherShown, Nl = (e) => e[Ur].isPopupShown, kl = (e) => e[Ur].isPopupSmallMode, x2e = (e) => e[Ur].isBadgeShown, oq = (e) => e[Ur].badgeCount, C2e = (e) => e[Ur].enableSmallPopup, jx = (e) => e[Ur].showSmallPopupStarterQuestions, $c = (e) => e[Ur].isSimulateMobile, aq = (e) => {
  const { children: t, ...n } = e, r = pe(x2e), i = pe(oq), o = {
    offset: [-4, 4],
    ...n
  };
  return r ? /* @__PURE__ */ H.jsx(_7, { ...o, count: i, children: t }) : /* @__PURE__ */ H.jsx(H.Fragment, { children: t });
}, Q2 = "WebChat.Change", mI = "Webchat.resize", b_ = {
  s: 1e3,
  m: 60 * 1e3,
  H: 60 * 60 * 1e3,
  d: 24 * 60 * 60 * 1e3
}, Fi = {
  POPUP_SHOW: "WEBCHAT.POPUP.SHOW",
  POPUP_HIDE: "WEBCHAT.POPUP.HIDE",
  POPUP_UPDATE: "WEBCHAT.POPUP.UPDATE",
  CONVERSATION_RESTART: "CONVERSATION.RESTART",
  DEVICE_CHANGE: "DEVICE_CHANGE",
  MESSAGE_SEND: "WEBCHAT.MESSAGE.SEND",
  POPUP_SMALL_MODE_CHANGED: "WEBCHAT.POPUP.SMALL_MODE_CHANGED"
}, E2e = {
  TOGGLE_POPUP: "TOGGLE_POPUP"
}, sn = {
  WEBCHAT_LOADED: "webchat.loaded",
  WEBCHAT_UPDATE: "webchat.update",
  WEBCHAT_POPUP_SHOW: "webchat.popup.show",
  WEBCHAT_POPUP_HIDE: "webchat.popup.hide",
  IFRAME_LOADED: "webchat.iframe.loaded",
  IFRAME_LOADING: "webchat.iframe.loading",
  IFRAME_EMBEDDED: "webchat.iframe.embedded",
  IFRAME_REMOVED: "webchat.iframe.removed",
  CONVERSATION_CREATED: "webchat.conversation.created",
  DEVICE_CHANGE: "DEVICE_CHANGE",
  BADGE_COUNT_CHANGE: "webchat.count.change",
  WEBCHAT_RESIZE: "webchat.resize",
  WEBCHAT_LAUNCHER_CLICKED: "webchat.launcher.clicked"
  // Note: sibling event between WebchatPlacement and InvitationModal
};
var zc = /* @__PURE__ */ ((e) => (e.InContent = "in-content", e.MediumRectangle = "medium-rectangle", e.HalfPageRectangle = "half-page-rectangle", e.LargeLeaderboardPanel = "large-leaderboard-panel", e.HeaderSearchBar = "header-search-bar", e.BannerSearchBar = "banner-search-bar", e.LargeLeaderboardSearchBar = "large-leaderboard-search-bar", e))(zc || {});
class $2e {
  constructor(t, n) {
    this.event = t, this.payload = n, this.externalEvent = Q2, this.createAt = /* @__PURE__ */ new Date(), this.sendAt = null;
  }
  sent() {
    const t = {
      detail: {
        name: this.event,
        event: this.event,
        payload: { ...this.payload }
      }
    };
    Nr.create().dispatchWindowEvent(this.externalEvent, void 0, t), Nr.create().postEventToParent(this.externalEvent, void 0, t), this.sendAt = /* @__PURE__ */ new Date();
  }
}
class J2 {
  constructor(t, n) {
    this.name = t, this.config = n, this.name = t, this.config = n;
  }
}
const Z2 = (e) => {
  const { isLauncherShown: t, isPopupShown: n, isPopupHovered: r, isPopupFocused: i, lastInteractionTime: o } = e[Ur], { auto_popup: a } = e[ku];
  return {
    // static settings to override remote settings
    autoPopup: a,
    isLauncherShown: t,
    isPopupShown: n,
    isPopupHovered: r,
    isPopupFocused: i,
    lastInteractionTime: o
  };
}, sq = (e) => {
  const { isUserCloseActionBox: t } = e[Ur], { isUserSignUpIntentDetected: n, userActionBox: r } = e[tr], i = !t && n && !!r.value;
  return {
    isUserSignUpIntentDetected: n,
    isUserCloseActionBox: t,
    userActionBoxInfo: r,
    isShownUserActionBox: i
  };
};
function vo(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ls(e) {
  vo(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || nn(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function _2e(e, t) {
  return vo(2, arguments), ls(e).getTime() - ls(t).getTime();
}
class df {
  constructor() {
    this.enable = !1, this.uuid = null, this.botId = null, this.leadId = null, this.trackingId = this.generateUUID();
  }
  static getInstance() {
    return df._instance || (df._instance = new df()), df._instance;
  }
  startTest() {
    this.enable = !0;
  }
  closeTest() {
    this.enable = !1;
  }
  setLeadId(t) {
    this.leadId = t;
  }
  setWebChatInfo({
    botId: t,
    uuid: n
  }) {
    this.uuid = n, this.botId = t;
  }
  debug(t, n = {}) {
    this.log("debug", t, n);
  }
  info(t, n = {}) {
    this.log("info", t, n);
  }
  error(t, n = {}) {
    this.log("error", t, n);
  }
  warn(t, n = {}) {
    this.log("warn", t, n);
  }
  log(t = "info", n, r) {
    if (this.enable) {
      const i = {
        uuid: this.uuid,
        bot_id: this.botId,
        lead_id: this.leadId,
        tracking_id: this.trackingId,
        timestamp: (/* @__PURE__ */ new Date()).getTime()
      };
      console[t](`[WebChat] ${n}`, { meta: r, ...i });
    }
  }
  generateUUID() {
    let t = (/* @__PURE__ */ new Date()).getTime(), n = typeof performance < "u" && performance.now && performance.now() * 1e3 || 0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(i) {
      let o = Math.random() * 16;
      return t > 0 ? (o = (t + o) % 16 | 0, t = Math.floor(t / 16)) : (o = (n + o) % 16 | 0, n = Math.floor(n / 16)), (i === "x" ? o : o & 3 | 8).toString(16);
    });
  }
}
const rt = df.getInstance(), w_ = (e) => e.length === 0, R0 = (e) => e.length === 1 && e[0] === 0, fl = (e, t) => {
  rt.debug(`[Autopopup/${e}] ${t}`);
}, O2e = () => {
  const e = wr(), {
    autoPopup: t,
    isLauncherShown: n,
    isPopupShown: r,
    isPopupHovered: i,
    isPopupFocused: o,
    lastInteractionTime: a
  } = pe(Z2), { first: s, next: l, minimize: c } = t, f = (d) => {
    e(Vs(d));
  };
  m.useEffect(() => {
    if (!(w_(s) || a))
      if (R0(s)) {
        fl("first", "popuping"), f(!0);
        return;
      } else {
        const [d, p] = s, g = setTimeout(() => {
          fl("first", "popuping"), f(!0);
        }, d * b_[p]);
        return fl("first", "timeout set"), () => {
          fl("first", "timeout cleared"), clearTimeout(g);
        };
      }
  }, [s, a, n]), m.useEffect(() => {
    R0(l) && (fl("next", "popuping"), f(!0));
  }, [n, l]), m.useEffect(() => {
    if (!n || !a || w_(l) || R0(l) || r)
      return;
    const d = _2e(/* @__PURE__ */ new Date(), new Date(a)), [p, g] = l, v = p * b_[g], y = setTimeout(
      () => {
        fl("next", "popuping"), f(!0);
      },
      d >= v ? 0 : v - d
    );
    return fl("next", "timeout set"), () => {
      rt.debug("next", { reason: "timeout cleared" }), clearTimeout(y);
    };
  }, [l, a, r, n]), m.useEffect(() => {
    if (!(!n || i || o || w_(c) || R0(c)) && r) {
      const [d, p] = c, g = setTimeout(() => {
        fl("minimize", "minimized"), f(!1);
      }, d * b_[p]);
      return fl("minimize", "timeout set"), () => {
        fl("minimize", "timeout cleared"), clearTimeout(g);
      };
    }
  }, [
    c,
    a,
    i,
    o,
    r,
    n
  ]);
}, lq = (e) => e[ln].campaignId, Tv = (e) => e[ln].webchatId, eM = (e) => e[ln].testingMod, cq = (e) => e[ln].welcomeMsg, P2e = (e) => e[ln].showProvider, T2e = (e) => e[ln].showBetaTag, I2e = (e) => e[ln].title, Ll = (e) => e[ln].theme, nl = (e) => e[ln].themeConfig, A2e = (e) => e[ln].position, Zf = (e) => e[ln].custom, ed = (e) => e[ln].themeColor, td = (e) => e[ln].themeTextColor, tM = (e) => e[ln].connected, nM = (e) => e[ln].disclaimers, R2e = (e) => e[ln].disclaimerPosition, M2e = (e) => e[ln].disclaimersAlwaysOn, N2e = (e) => e[ln].launcherAlwaysShow, rM = (e) => e[ln].type, k2e = (e) => e[ln].parentWindowUrl, L2e = (e) => e[ln].answer_rating_options, Fx = (e) => e[ln].chatBubblePlacementStyle, uq = (e) => e[ln].chatBubblePlacementSize, D2e = (e) => e[ln].placementDisplayType, j2e = (e) => e[ln].placementFullImageUrl, F2e = (e) => {
  var t;
  return (t = e[ln]) == null ? void 0 : t.invitationModalSettings;
}, B2e = ({ themeStyle: e }) => {
  const t = pe(nl);
  return {
    conversationContainerDivStyles: {
      ...{
        backgroundColor: e.conversation.background
      },
      ...(() => {
        const o = t == null ? void 0 : t.conversation, a = {
          backgroundColor: o == null ? void 0 : o.background
        };
        return yt.omitBy(a, yt.isNil);
      })()
    }
  };
}, z2e = () => {
  const e = pe(nl), t = pe(ed), n = pe(kl), r = pe(jx) && n, i = {
    height: "50px",
    textAreaHeight: "42px",
    textAreaPadding: "10px 30px 10px 16px",
    sendBtnRight: "6px",
    sentBtnColor: "#635FE7",
    isSendBtnCircle: !1,
    padding: "4px 10px",
    overflowY: "auto"
  }, o = () => {
    const f = t ? {
      sentBtnColor: t
    } : {};
    return yt.omitBy(f, yt.isNil);
  }, a = () => {
    const f = n ? {
      height: "62px",
      padding: "6px 16px 16px",
      overflowY: "hidden"
    } : {};
    return yt.omitBy(f, yt.isNil);
  }, s = () => {
    const f = r ? {
      height: "56px",
      padding: "0px 16px 16px"
    } : {};
    return yt.omitBy(f, yt.isNil);
  }, l = () => {
    var g, v;
    const f = e == null ? void 0 : e.visualHeight, d = e == null ? void 0 : e.conversation, p = {
      height: f == null ? void 0 : f.sendMsgBox,
      textAreaPadding: (g = d == null ? void 0 : d.textArea) == null ? void 0 : g.padding,
      padding: d == null ? void 0 : d.sendMsgBox.padding,
      textAreaHeight: (v = d == null ? void 0 : d.textArea) == null ? void 0 : v.height,
      sendBtnRight: d == null ? void 0 : d.sendMsgBox.btnRight,
      isSendBtnCircle: d == null ? void 0 : d.sendMsgBox.isBtnCircle
    };
    return yt.omitBy(p, yt.isNil);
  };
  return {
    footerStyles: {
      ...i,
      ...o(),
      ...a(),
      ...s(),
      ...l()
    }
  };
}, U2e = ({ themeStyle: e }) => {
  const { conversationContainerDivStyles: t } = B2e({ themeStyle: e }), { footerStyles: n } = z2e();
  return {
    conversationContainerDivStyles: t,
    footerStyles: n
  };
};
function ya(e, t, n, r) {
  const i = m.useRef((o) => {
  });
  m.useEffect(() => {
    i.current = t;
  }, [t]), m.useEffect(() => {
    if (!n)
      return;
    const o = (a) => {
      var s;
      ((s = a.detail) == null ? void 0 : s.webchatId) === r && i.current(a);
    };
    return n.addEventListener(e, o), () => {
      n.removeEventListener(e, o);
    };
  }, [e, n]);
}
const H2e = () => {
  const e = pe(nl), t = pe(ed), n = pe(td), r = {
    themeColor: "#635FE7",
    themeTextColor: "#ffffff",
    headerBackground: "#635FE7",
    headerColor: "#ffffff",
    titleColor: "#ffffff",
    closeColor: "#ffffff",
    headerHeight: void 0,
    headerMinHeight: void 0,
    headerPadding: void 0,
    bodyHeight: void 0,
    bodyBorder: void 0
  }, i = () => {
    const s = {
      themeColor: t,
      headerBackground: t,
      titleColor: n,
      themeTextColor: n,
      headerColor: n,
      closeColor: n
    };
    return yt.omitBy(s, yt.isNil);
  }, o = () => {
    var d;
    const s = e == null ? void 0 : e.header, l = e == null ? void 0 : e.body, c = e == null ? void 0 : e.visualHeight, f = {
      titleColor: (d = e == null ? void 0 : e.title) == null ? void 0 : d.color,
      headerBackground: s == null ? void 0 : s.background,
      headerColor: s == null ? void 0 : s.color,
      headerPadding: s == null ? void 0 : s.padding,
      bodyBorder: l == null ? void 0 : l.border,
      headerHeight: c == null ? void 0 : c.header,
      headerMinHeight: c == null ? void 0 : c.header,
      bodyHeight: c == null ? void 0 : c.body
    };
    return yt.omitBy(f, yt.isNil);
  };
  return {
    divStyles: {
      ...r,
      ...i(),
      ...o()
    }
  };
};
var lu = /* @__PURE__ */ ((e) => (e.fusion = "fusion", e.simple = "simple", e.siteCompanion = "site-companion", e.siteCompanionPopup = "site-companion-popup", e))(lu || {});
const G6 = new J2(lu.simple, {
  popup: {
    custom: {
      padding: "0px"
    }
  },
  popupWrapper: {},
  title: {
    display: !1
  },
  disclaimers: {
    display: !1,
    height: 0
  },
  avatar: {
    display: !1
  },
  conversation: {
    background: "#fff",
    color: "#635fe7",
    sentBtnColor: "#fff",
    custom: {
      borderBottom: "1px solid #ebe7e4"
    },
    message: {
      color: "#635fe7",
      background: "#fefefe"
    },
    sendMsgBox: {
      height: 92,
      showSentBtn: !1,
      padding: "0px"
    },
    textArea: {
      padding: "10px 20px",
      custom: {
        background: "#fff"
      }
    }
  },
  header: {
    background: "#fff",
    height: 52,
    padding: "0",
    color: "#000",
    extraButtons: !0
  },
  footer: {
    height: 0,
    display: !1,
    background: "#fff"
  },
  cover: {
    display: !1
  }
}), gI = {
  width: "100%",
  height: "64px",
  fontWeight: Vf.isFeatureEnabled() ? "normal" : 500,
  fontSize: "14px",
  lineHeight: "20px",
  padding: "12px 40px 12px 12px",
  marginTop: "0px",
  borderRadius: "10px",
  color: Vf.isFeatureEnabled() ? "#666666" : "#333333",
  maxWidth: "none",
  overflow: "hidden",
  whiteSpace: "normal",
  textOverflow: "ellipsis",
  transition: `color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1),
      border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)`,
  textAlign: "left"
}, ga = {
  popup: {},
  popupWrapper: {},
  disclaimers: {
    display: !1,
    height: 0
  },
  conversation: {
    background: "#fff",
    padding: "0 24px",
    message: {
      display: !1
    },
    messageDate: {
      display: !0
    },
    dateDivider: {
      display: !0
    },
    sendMsgBox: {
      height: 56,
      padding: "4px 24px",
      isBtnCircle: !0,
      btnRight: "8px"
    },
    textArea: {
      height: "48px",
      padding: "10px 48px 10px 16px",
      custom: {
        borderRadius: "50px",
        border: "1px solid #DBDBDB",
        background: "#ffffff",
        boxShadow: "0px 4px 14px 0px #C2C2C240"
      }
    },
    starterQuestions: {
      display: !0,
      custom: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "8px 12px"
      },
      title: {
        display: !1
      },
      button: {
        rows: 2,
        showArrow: !0,
        custom: gI
      }
    },
    relatedQuestions: {
      button: {
        rows: 2,
        showArrow: !0,
        custom: gI
      }
    }
  },
  header: {
    extraButtons: !1,
    background: "#fff",
    color: "#000",
    logo: {
      display: !1
    },
    height: 76,
    padding: "0px 24px 4px"
  },
  body: {
    border: "none"
  },
  footer: {
    height: 61,
    custom: {
      fontSize: 12
    }
  },
  title: {
    color: "#000",
    content: "Ask Me Anything",
    custom: {
      fontFamily: "Nunito",
      fontWeight: "bold",
      fontSize: 24,
      lineHeight: "32px",
      height: "32px"
    }
  },
  cover: {
    display: !1
  },
  caption: {
    display: !1
  },
  userActionBox: {
    display: !1,
    height: 140
    // Note: 116px + margin top & bottom 24px
  }
};
var PB, TB, IB, AB, RB;
const fq = {
  ...ga,
  header: {
    ...ga.header,
    padding: "10px 20px 0"
  },
  title: {
    ...ga.title,
    preTitle: {
      ...(PB = ga.title) == null ? void 0 : PB.preTitle,
      custom: {
        ...(IB = (TB = ga.title) == null ? void 0 : TB.preTitle) == null ? void 0 : IB.custom,
        marginBottom: 8
      }
    }
  },
  conversation: {
    ...ga.conversation,
    padding: "14px 20px 12px",
    sendMsgBox: {
      ...ga.conversation.sendMsgBox,
      padding: "4px 20px"
    },
    starterQuestions: {
      ...ga.conversation.starterQuestions,
      custom: {
        ...(AB = ga.conversation.starterQuestions) == null ? void 0 : AB.custom,
        gridTemplateColumns: "1fr"
      }
    },
    relatedQuestions: {
      ...ga.conversation.relatedQuestions,
      custom: {
        ...(RB = ga.conversation.relatedQuestions) == null ? void 0 : RB.custom,
        gridTemplateColumns: "1fr"
      }
    }
  }
}, K6 = new J2(lu.siteCompanion, {
  ...ga,
  mobileTheme: fq
}), W2e = ga, V2e = fq, vI = {
  popup: {
    custom: {
      maxWidth: "100%",
      height: "100%",
      top: 0,
      right: 0
    }
  },
  disclaimers: {
    display: !0,
    height: 40
  },
  conversation: {
    background: "#fff",
    sendMsgBox: {
      height: 50
    },
    relatedQuestions: W2e.conversation.relatedQuestions
  },
  header: {
    height: 96,
    extraButtons: !0
  },
  footer: {
    height: 26
  },
  userActionBox: {
    display: !0,
    height: 140
    // Note: 116px + margin top & bottom 24px
  }
}, G2e = {
  ...vI,
  conversation: {
    ...vI.conversation,
    relatedQuestions: V2e.conversation.relatedQuestions
  }
}, q6 = new J2(lu.siteCompanionPopup, {
  ...vI,
  mobileTheme: G2e
});
class Xc {
  constructor() {
    this.themes = {
      [G6.name]: G6,
      [K6.name]: K6,
      [q6.name]: q6
    };
  }
  static getInstance() {
    return Xc._instance || (Xc._instance = new Xc()), Xc._instance;
  }
  getTheme(t) {
    return this.themes[t] ?? null;
  }
}
Xc.getInstance();
const dq = (e) => {
  const t = Ix.isFeatureEnabled(), n = wr(), r = pe($c), i = pe(Ll), o = !!pe(nM), { isShownUserActionBox: a } = pe(sq), s = new tce(new Xc()), l = new nce(), c = async (f) => {
    try {
      const d = r || Ec, p = new PU({
        name: f
      }), g = await s.perform(p), v = d && (g != null && g.mobileTheme) ? g == null ? void 0 : g.mobileTheme : g;
      if (v) {
        const y = new Jf(v, {
          hasDisclaimers: !!o,
          isShownUserActionBox: t && a
        }), x = await l.perform(y) ?? null;
        n(ib({ ...v, visualHeight: x }));
      } else
        n(ib(null));
    } catch (d) {
      rt.error("[Webchat Theme]", d.message);
    }
  };
  m.useEffect(() => {
    i && (n(ib(null)), c(i));
  }, [i, o, r, a]), m.useEffect(() => {
    n(Bx(e));
  }, []);
}, ln = "app";
var Y1 = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e))(Y1 || {}), Af = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(Af || {}), Jt = ((e) => (e[e.fusion = lu.fusion] = "fusion", e[e.simple = lu.simple] = "simple", e.basic = "basic", e[e.siteCompanion = lu.siteCompanion] = "siteCompanion", e[e.siteCompanionPopup = lu.siteCompanionPopup] = "siteCompanionPopup", e))(Jt || {}), Jo = /* @__PURE__ */ ((e) => (e.Default = "default", e.SiteCompanion = "site-companion", e))(Jo || {});
const Qr = {
  webchatId: -1,
  campaignId: -1,
  title: "ChatFusion",
  parentWindowUrl: "",
  settings: TG,
  position: {
    horizon: "right",
    vertical: "bottom"
    /* bottom */
  },
  theme: Jt.fusion,
  themeConfig: null,
  themeColor: "#635fe7",
  themeTextColor: "#fff",
  custom: {},
  testingMod: !1,
  welcomeMsg: null,
  showProvider: !0,
  showBetaTag: !1,
  connected: !1,
  disclaimers: "",
  disclaimerPosition: "bottom",
  disclaimersAlwaysOn: !0,
  launcherAlwaysShow: !0,
  type: "default",
  answer_rating_options: [],
  chatBubblePlacementStyle: Bi.Bubble,
  chatBubblePlacementSize: Wg.Small,
  placementDisplayType: Vg.IconOnly,
  invitationModalSettings: {
    show: !1,
    waitTime: 18,
    invitationMessage: "Do you want to chat with our agent?",
    openWebchatButtonText: "Yes",
    dismissButtonText: "No"
  }
}, Y6 = (e) => {
  if (e.startsWith("#")) {
    const t = parseInt(e.slice(1, 3), 16), n = parseInt(e.slice(3, 5), 16), r = parseInt(e.slice(5, 7), 16);
    return 0.299 * t + 0.587 * n + 0.114 * r;
  } else if (e.startsWith("rgb")) {
    const t = /(\d+), (\d+), (\d+)/.exec(e);
    if (t) {
      const n = parseInt(t[1]), r = parseInt(t[2]), i = parseInt(t[3]);
      return 0.299 * n + 0.587 * r + 0.114 * i;
    }
  }
  return 0;
}, Dl = Iw({
  name: ln,
  initialState: Qr,
  reducers: {
    enableTestingMod: (e, t) => {
      e.testingMod = t.payload.testingMod;
    },
    updateCompanyName: (e, t) => {
      e.title = t.payload;
    },
    updateTheme: (e, t) => {
      e.theme = t.payload, e.themeConfig = null;
    },
    updateThemeColor: (e, t) => {
      e.themeColor = t.payload, Y6(e.themeColor) > 180 ? e.themeTextColor = "#000" : e.themeTextColor = "#fff";
    },
    updatePosition: (e, t) => {
      e.position = t.payload;
    },
    updateCustom: (e, t) => {
      e.custom = t.payload;
    },
    updateDisplay: (e, t) => {
      e.theme = t.payload.theme ?? e.theme, e.position = t.payload.position ?? e.position, e.custom = t.payload.custom ?? e.custom, e.themeColor = t.payload.themeColor ?? e.themeColor, e.themeTextColor = t.payload.themeTextColor ?? e.themeTextColor, e.title = t.payload.title ?? e.title;
    },
    hideDisclaimers: (e) => {
      e.disclaimers = null;
    }
  },
  extraReducers: (e) => {
    e.addCase(_v.fulfilled, (t, n) => {
      var s, l, c, f, d;
      const { webchatSettings: r, webChatConfigs: i } = n.payload, { display: o } = r, a = i.theme === Jt.siteCompanionPopup;
      t.theme = i.theme ?? o.theme ?? Qr.theme, t.position = o.position ?? Qr.position, t.custom = o.custom ?? Qr.custom, t.themeColor = o.themeColor ?? Qr.themeColor, t.title = o.title ?? Qr.title, t.welcomeMsg = o.welcomeMsg ?? Qr.welcomeMsg, t.showProvider = o.showProvider ?? Qr.showProvider, t.disclaimers = o.disclaimers ?? Qr.disclaimers, t.disclaimerPosition = o.disclaimerPosition ?? Qr.disclaimerPosition, t.disclaimersAlwaysOn = o.disclaimersAlwaysOn ?? Qr.disclaimersAlwaysOn, t.launcherAlwaysShow = o.launcherAlwaysShow ?? Qr.launcherAlwaysShow, t.answer_rating_options = r.answerRatingOptions, t.chatBubblePlacementStyle = ((s = r == null ? void 0 : r.launcher) == null ? void 0 : s.placementStyle) ?? Qr.chatBubblePlacementStyle, t.chatBubblePlacementSize = ((l = r == null ? void 0 : r.launcher) == null ? void 0 : l.placementSize) ?? Qr.chatBubblePlacementSize, t.placementDisplayType = ((c = r == null ? void 0 : r.launcher) == null ? void 0 : c.placementDisplayType) ?? Qr.placementDisplayType, t.placementFullImageUrl = (f = r == null ? void 0 : r.launcher) == null ? void 0 : f.placementFullImageUrl, t.showBetaTag = o.showBetaTag ?? t.showBetaTag, o.themeColor && (Y6(o.themeColor) > 180 ? t.themeTextColor = "#000" : t.themeTextColor = "#fff"), a && (t.launcherAlwaysShow = !1), F2.isFeatureEnabled() && (t.invitationModalSettings = ((d = r.display) == null ? void 0 : d.invitationModal) ?? Qr.invitationModalSettings);
    }), e.addCase(ib, (t, n) => {
      t.themeConfig = n.payload;
    }), e.addCase(ep, (t, n) => {
      t.connected = n.payload.status;
    });
  }
}), K2e = Dl.actions.updateCompanyName, Bx = Dl.actions.updateTheme, q2e = Dl.actions.updatePosition;
Dl.actions.updateCustom;
const pq = Dl.actions.updateThemeColor, Y2e = Dl.actions.updateDisplay, X2e = Dl.actions.enableTestingMod, Q2e = Dl.actions.hideDisclaimers, hq = (e) => {
  const t = {
    [Jt.fusion]: {
      caption: {
        color: "#fff"
      },
      title: {
        color: "#fff"
      },
      cover: "https://chatfusion.onramplab.com/static/images/logo.svg"
    },
    [Jt.basic]: {
      caption: {
        color: "lightslategrey"
      },
      title: {
        color: "#d5d3d3"
      },
      cover: ""
    }
  };
  return t[e] ?? t.basic;
}, J2e = {
  baseURL: "https://api.chatfusion.contactloop.com",
  validateStatus: (e) => e >= 200 && e <= 302
}, Z2e = ng.create(J2e), Nd = {}, Mr = {
  instance: Z2e,
  setInstance: (e) => {
    Mr.instance = ng.create({
      baseURL: e,
      validateStatus: (t) => t >= 200 && t <= 302
    });
  },
  request: async ({
    method: e,
    url: t,
    params: n = {},
    data: r = {},
    headers: i = {},
    ...o
  }) => {
    var a;
    if (!t)
      throw new Error("url cannot be empty");
    e === "GET" && (Nd[t] && Nd[t].cancel("Operation canceled"), Nd[t] = ng.CancelToken.source());
    try {
      const s = await Mr.instance({
        url: t,
        method: e,
        headers: i,
        params: n,
        data: r,
        cancelToken: (a = Nd[t]) == null ? void 0 : a.token,
        ...o
      });
      return delete Nd[t], s.data;
    } catch (s) {
      throw ng.isCancel(s) || delete Nd[t], s;
    }
  },
  get: async (e, t = {}, n = {}) => Mr.request({ method: "GET", url: e, params: t, ...n }),
  post: async (e, t = {}, n = {}) => Mr.request({ method: "POST", url: e, data: t, ...n }),
  patch: async (e, t = {}, n = {}) => Mr.request({ method: "PATCH", url: e, data: t, ...n }),
  put: async (e, t = {}, n = {}) => Mr.request({ method: "PUT", url: e, data: t, ...n }),
  delete: async (e, t = {}) => Mr.request({ method: "DELETE", url: e, ...t })
}, Zo = (e, t, n) => (rt.error(`[${t}] ${n}:`, { e }), e), eMe = async ({
  conversationOutput: e,
  sourceId: t,
  payload: n
}) => {
  try {
    return await e.sendMessage({ sourceId: t, payload: n });
  } catch (r) {
    throw Zo(r, "Conversation", "sendMessage");
  }
}, tMe = async ({
  conversationOutput: e,
  sourceId: t,
  payload: n
}) => {
  try {
    await e.sendMessageV2({ sourceId: t, payload: n });
  } catch (r) {
    throw Zo(r, "Conversation", "sendMessageV2");
  }
}, nMe = async ({
  conversationOutput: e,
  sourceId: t,
  payload: n
}) => {
  try {
    return await e.createConversation({ sourceId: t, payload: n });
  } catch (r) {
    throw Zo(r, "Conversation", "createConversation");
  }
}, rMe = async ({
  conversationOutput: e
}) => {
  try {
    return await e.reset();
  } catch (t) {
    throw Zo(t, "Conversation", "resetConversation");
  }
}, iMe = ({
  conversationOutput: e
}) => {
  try {
    e.clear();
  } catch (t) {
    throw Zo(t, "Conversation", "clearConversation");
  }
}, oMe = async ({
  conversationOutput: e,
  sourceId: t,
  conversationId: n,
  uuid: r
}) => {
  try {
    return await e.getConversation({ sourceId: t, conversationId: n, uuid: r });
  } catch (i) {
    throw Zo(i, "Conversation", "getConversation");
  }
}, X6 = ({
  conversationOutput: e
}) => {
  try {
    return e.getConnector();
  } catch (t) {
    throw Zo(t, "Conversation", "getConnector");
  }
}, aMe = ({
  conversationOutput: e
}) => {
  try {
    return e.getChannel();
  } catch (t) {
    throw Zo(t, "Conversation", "getChannel");
  }
}, sMe = ({
  conversationOutput: e,
  message: t
}) => {
  try {
    return e.receivedMessage(t);
  } catch (n) {
    throw Zo(n, "Conversation", "receivedMessage");
  }
}, lMe = ({
  conversationOutput: e,
  active: t
}) => {
  try {
    return e.setTestingMod(t);
  } catch (n) {
    throw Zo(n, "Conversation", "setTestingMod");
  }
}, cMe = async ({
  conversationOutput: e,
  botId: t,
  conversationId: n,
  payload: r
}) => {
  try {
    await e.updateAnswerRating({ botId: t, conversationId: n, payload: r });
  } catch (i) {
    throw Zo(i, "Conversation", "updateAnswerRating");
  }
}, uMe = async ({
  conversationOutput: e,
  conversationId: t
}) => {
  try {
    return await e.getUserActionBoxInfo({ conversationId: t });
  } catch (n) {
    throw Zo(n, "Conversation", "getUserActionBoxInfo");
  }
};
class M0 {
  constructor(t) {
    var n;
    Object.assign(this, t), this.id = t.id, this.uuid = t.uuid, this.source = t.source, this.sourceId = t.sourceId, this.messages = t.messages || [], this.status = t.status, this.createdAt = t.createdAt, this.updatedAt = t.updatedAt, this.userActionBox = {
      isDisplay: ((n = t == null ? void 0 : t.userActionBox) == null ? void 0 : n.isDisplay) || !1
    }, this.meta = {};
  }
  storeToSlice() {
    var r;
    const t = this.messages.map((i) => ({
      id: String(i.id),
      conversation_id: String(i.conversationId),
      content: i.content,
      type: i.type,
      created_at: i.createdAt,
      updated_at: i.updatedAt,
      content_meta: i.contentMeta,
      sources: i.sources,
      related_questions: i.relatedQuestions,
      is_capturing_lead: i.isCapturingLead
    }));
    return {
      id: String(this.id),
      assignee_id: ((r = this.meta) == null ? void 0 : r.assignee_id) || 0,
      campaign_id: this.sourceId,
      journey_id: 0,
      lead_id: this.meta.lead_id || 0,
      messages: t,
      status: this.status,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
      source: this.source,
      source_id: this.sourceId,
      trace_id: this.uuid,
      user_action_box: {
        is_display: this.userActionBox.isDisplay
      }
    };
  }
}
class fMe {
  constructor(t) {
    this.content = t.content, this.buttonText = t.buttonText, this.value = t.value;
  }
}
const dMe = "Chat Fusion Start";
class pf {
  constructor() {
    this.storeKeyPrefix = "CHATFUSHION_CONVERSATION", this.entryUrl = null, this.getUuidByStorage(), this.status = wu.ONGOING, this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, this.clientUrl = "https://api.chatfusion.contactloop.com/api", this.sandBoxMod = !1, this.botId = null, this.entryUrl = null, this.connector = {
      config: {
        pusherKey: "48674eac95b91f0b474b",
        PusherCluster: "us3"
      },
      eventName: "message.replied"
    };
  }
  static getInstance() {
    return pf._instance || (pf._instance = new pf()), pf._instance;
  }
  initializeByConfigs(t) {
    const { parentWindowUrl: n } = t;
    this.entryUrl = n;
  }
  setEntryUrl(t) {
    this.entryUrl = t;
  }
  start(t) {
    this.botId = t, this.initVisitor(t);
  }
  // FIXME: should change to Conversation['messages']
  get messages() {
    const t = localStorage.getItem(`${this.storeKeyPrefix}_HISTORY`);
    return t ? JSON.parse(t) : [];
  }
  get conversation() {
    const t = localStorage.getItem(`${this.storeKeyPrefix}_CONVERSATION`);
    return t ? JSON.parse(t) : null;
  }
  get uuid() {
    return localStorage.getItem(`${this.storeKeyPrefix}_TRACKER_ID`) ?? null;
  }
  getEntryUrl() {
    return this.entryUrl;
  }
  getUuidByStorage() {
    return this.uuid;
  }
  renewUuid() {
    const t = this.generateUUID();
    return localStorage.setItem(`${this.storeKeyPrefix}_TRACKER_ID`, t), t;
  }
  getCurrent() {
    return this.conversation;
  }
  getLocalMessages() {
    return this.messages;
  }
  async createConversation({
    sourceId: t,
    payload: n = {}
  }) {
    const r = t;
    if (!t)
      throw new Error("bot id not found");
    let i;
    const o = {
      data: {
        sandbox: this.sandBoxMod
      },
      meta: {
        uuid: this.uuid,
        timezone: this.timeZone,
        ...n
      }
    };
    Ho.UseAPICLient ? i = (await this._getClient().open.createConversation(r, o)).data : i = await Mr.post(`/chat/bots/${r}/conversations`, o, {
      baseURL: this.clientUrl
    }), rt.setWebChatInfo({ uuid: this.uuid, botId: this.botId });
    const a = this.toDomainConversation(i.data);
    return rt.info("[conversation] create conversation", {
      cf_conversation_id: i.data.id,
      cf_guest_id: i.data.guest_id,
      cf_bot_id: i.data.bot_id
    }), this.setConversation(a), Promise.resolve(a);
  }
  initVisitor(t, n) {
    this.uuid || (this.botId = t, rt.info("[conversation] renew uuid by create bot", {
      renew_bot_id: t
    }), this.renewUuid(), this.uuid && this.saveImpressionEventLog(n));
  }
  // call api save impression event log
  saveImpressionEventLog(t) {
    let n = window.location != window.parent.location ? document.referrer : document.location.href;
    const r = sp.isFeatureEnabled();
    Mr.post(
      "/event_log",
      {
        event_name: "impression",
        ...r && {
          sandbox: this.sandBoxMod
        },
        data: {
          uuid: this.uuid,
          bot_id: this.botId,
          url: n,
          ...r && t && {
            conversation_id: t
          }
        }
      },
      {
        baseURL: this.clientUrl
      }
    );
  }
  setConversation(t) {
    localStorage.setItem(`${this.storeKeyPrefix}_CONVERSATION`, JSON.stringify(t));
  }
  async getConversation({
    sourceId: t
  }) {
    try {
      if (!t)
        throw new Error("get conversation with null bot id");
      if (this.botId = t, !this.conversation || !this.uuid)
        throw new Error("[conversation] Please create a conversation");
      let n;
      Ho.UseAPICLient ? n = (await this._getClient().open.getUniversalConversation(this.uuid)).data : n = await Mr.get(
        `/chat/universal_conversations/${this.uuid}/messages`,
        {},
        {
          baseURL: this.clientUrl
        }
      );
      const r = yt.reverse(this.mapToDomainMessages(n.data)), i = [...this.messages, r];
      return rt.info("[conversation] get conversation", {
        request_uuid: this.uuid,
        messages: n.data,
        request_botId: this.botId
      }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify(i)), Promise.resolve({
        ...this.conversation,
        messages: r
      });
    } catch (n) {
      throw rt.error("[conversation] get conversation error", {
        error: n.message,
        request_uuid: this.uuid
      }), n;
    }
  }
  mapToDomainMessages(t) {
    return t.map((n) => {
      var r;
      return {
        id: n.id,
        conversationId: parseInt(`${(r = this.conversation) == null ? void 0 : r.id}`),
        content: n.content,
        type: n.sender === "bot" ? fi.SENT : fi.RECEIVED,
        createdAt: n.created_at,
        updatedAt: n.updated_at,
        contentMeta: null,
        sources: n.sources,
        relatedQuestions: n.related_questions,
        isCapturingLead: n.is_capturing_lead
      };
    });
  }
  /** @deprecated */
  addMessage(t) {
    if (!this.botId || !this.uuid)
      throw new Error("bot not found");
  }
  setStatus(t) {
    this.status = t;
  }
  toDomainModel(t, n) {
    if (!this.uuid)
      throw new Error("lost guest id");
    return {
      id: t.conversation_id,
      uuid: this.uuid,
      source: "chat fusion",
      sourceId: n,
      messages: yt.last(this.messages) ?? [],
      status: this.status,
      createdAt: t.created_at,
      updatedAt: t.updated_at,
      connector: this.connector
    };
  }
  toDomainConversation(t) {
    return {
      id: t.id,
      uuid: t.guest_id,
      source: "chat fusion",
      sourceId: t.bot_id,
      messages: yt.last(this.messages) ?? [],
      status: this.status,
      createdAt: t.created_at,
      updatedAt: t.updated_at,
      connector: this.connector
    };
  }
  async sendMessage({
    sourceId: t,
    payload: n
  }) {
    var a;
    if (!t || !this.uuid || !((a = this.conversation) != null && a.id))
      throw new Error("Please create a conversation");
    this.botId = t;
    let r;
    const i = {
      data: {
        content: n.message,
        url: this.entryUrl
      }
    };
    Ho.UseAPICLient ? r = (await this._getClient().open.sendMessage(this.conversation.id, i)).data : r = await Mr.post(
      `/chat/conversations/${this.conversation.id}/messages`,
      i,
      {
        baseURL: this.clientUrl
      }
    ), n.message !== dMe && n.message && (this.addMessage(r.data), this.status = wu.REPLYING);
    const o = this.toDomainModel(r.data, t);
    return Promise.resolve(o);
  }
  async sendMessageV2({
    sourceId: t,
    payload: n
  }) {
    var i;
    if (!t || !this.uuid || !((i = this.conversation) != null && i.id))
      throw new Error("Please create a conversation");
    this.botId = t;
    const r = {
      data: {
        content: n.content,
        url: `${this.entryUrl}`,
        stream: n.stream
      }
    };
    await this._getClient().open.sendMessageV2(this.conversation.id, r);
  }
  getConnector() {
    return this.connector;
  }
  getChannel() {
    var t;
    if (!((t = this.conversation) != null && t.id) || !this.uuid)
      throw new Error("Please create a conversation");
    return this.uuid;
  }
  setTestingMod(t) {
    this.sandBoxMod = t, this.sandBoxMod ? rt.startTest() : rt.closeTest();
  }
  /** @deprecated */
  receivedMessage(t) {
    this.addMessage(t), this.status = wu.ONGOING;
  }
  async reset() {
    if (rt.info("start reset", {
      reset_bot_id: this.botId,
      reset_uuid: this.uuid
    }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify([])), localStorage.setItem(`${this.storeKeyPrefix}_TRACKER_ID`, ""), rt.info("[conversation] reset empty uuid and botId", {
      should_empty_uuid: this.uuid,
      reset_bot_id: this.botId
    }), !this.botId)
      return null;
    this.initVisitor(this.botId);
    const t = await this.createConversation({
      sourceId: this.botId,
      payload: {
        new_conversation: !0
      }
    });
    return Promise.resolve(t);
  }
  clear() {
    if (!this.botId)
      throw new Error("clear with null bot id");
    rt.info("[conversation] start clearing conversation", {
      reset_bot_id: this.botId,
      reset_uuid: this.uuid
    }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify([])), localStorage.setItem(`${this.storeKeyPrefix}_TRACKER_ID`, ""), localStorage.setItem(`${this.storeKeyPrefix}_CONVERSATION`, "{}"), rt.info("[conversation] clear uuid and botId", {
      should_empty_uuid: this.uuid,
      reset_bot_id: this.botId
    }), this.initVisitor(this.botId);
  }
  postLeadToAAC(t) {
    Mr.post(
      "/aac/lead-created",
      {
        data: {
          lead: { ...t }
        }
      },
      {
        baseURL: this.clientUrl
      }
    );
  }
  generateUUID() {
    let t = (/* @__PURE__ */ new Date()).getTime(), n = typeof performance < "u" && performance.now && performance.now() * 1e3 || 0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(i) {
      let o = Math.random() * 16;
      return t > 0 ? (o = (t + o) % 16 | 0, t = Math.floor(t / 16)) : (o = (n + o) % 16 | 0, n = Math.floor(n / 16)), (i === "x" ? o : o & 3 | 8).toString(16);
    });
  }
  getUuid() {
    return this.uuid;
  }
  _getClient() {
    return zo.getInstance().getClient();
  }
}
const Q6 = "Chat Fusion Start";
class Qc extends pf {
  constructor() {
    super();
  }
  static getInstance() {
    return Qc._instance || (Qc._instance = new Qc()), Qc._instance;
  }
  get uuid() {
    return localStorage.getItem(`${this.storeKeyPrefix}_${this.botId}_TRACKER_ID`) ?? null;
  }
  renewUuid() {
    const t = this.generateUUID();
    return localStorage.setItem(`${this.storeKeyPrefix}_${this.botId}_TRACKER_ID`, t), console.log("renew uuid", t), t;
  }
  get conversation() {
    const t = localStorage.getItem(
      `${this.storeKeyPrefix}_${this.botId}_CONVERSATION`
    );
    return t ? JSON.parse(t) : null;
  }
  setConversation(t) {
    localStorage.setItem(
      `${this.storeKeyPrefix}_${this.botId}_CONVERSATION`,
      JSON.stringify(t)
    );
  }
  async getConversation({
    sourceId: t
  }) {
    try {
      if (!t)
        throw new Error("get conversation with null bot id");
      if (this.botId = t, !this.conversation || !this.uuid)
        throw new Error("[conversation with same uuid] Please create a conversation");
      const n = this.checkIsSiteCompanion() ? `/chat/guests/${this.uuid}/site-companion/conversations/${this.conversation.id}/messages` : `/chat/guests/${this.uuid}/conversations/${this.conversation.id}/messages`;
      let r;
      Ho.UseAPICLient ? this.checkIsSiteCompanion() ? r = (await this._getClient().open.getSiteCompanionConversation(
        this.uuid,
        this.conversation.id
      )).data : r = (await this._getClient().open.getWebChatConversation(this.uuid, this.conversation.id)).data : r = await Mr.get(
        n,
        {},
        {
          baseURL: this.clientUrl
        }
      );
      const i = yt.reverse(this.mapToDomainMessages(r.data)), o = [...this.messages, i];
      return rt.info("[conversation with same uuid] get conversation", {
        request_uuid: this.uuid,
        messages: r.data,
        request_botId: this.botId
      }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify(o)), Promise.resolve({
        ...this.conversation,
        messages: i
      });
    } catch (n) {
      throw rt.error("[conversation with same uuid] get conversation error", {
        error: n.message,
        request_uuid: this.uuid
      }), n;
    }
  }
  // TODO: should remove this after CREATE_CONVERSATION_WITH_SAME_UUID feature released
  async createConversation({
    sourceId: t,
    payload: n = {}
  }) {
    var l;
    const r = t;
    if (!t)
      throw new Error("bot id not found");
    const i = this.uuid ?? this.renewUuid();
    if ((l = this.conversation) != null && l.id)
      return this.conversation;
    let o;
    const a = {
      data: {
        sandbox: this.sandBoxMod
      },
      meta: {
        uuid: i,
        timezone: this.timeZone,
        ...n
      }
    };
    if (Ho.UseAPICLient)
      this.checkIsSiteCompanion() ? o = (await this._getClient().open.createSiteCompanionConversation(r, a)).data : o = (await this._getClient().open.createConversation(r, a)).data;
    else {
      const c = this.checkIsSiteCompanion() ? `/chat/bots/${r}/site-companion/conversations` : `/chat/bots/${r}/conversations`;
      o = await Mr.post(c, a, {
        baseURL: this.clientUrl
      });
    }
    rt.setWebChatInfo({ uuid: this.uuid, botId: this.botId });
    const s = this.toDomainConversation(o.data);
    return rt.info("[conversation] create conversation", {
      cf_conversation_id: o.data.id,
      cf_guest_id: o.data.guest_id,
      cf_bot_id: o.data.bot_id
    }), this.setConversation(s), Promise.resolve(s);
  }
  // TODO: should remove this after CREATE_CONVERSATION_WITH_SAME_UUID feature released
  async sendMessage({
    sourceId: t,
    payload: n
  }) {
    var l;
    if (!t || !this.uuid || !((l = this.conversation) != null && l.id))
      throw new Error("Please create a conversation");
    if (this.checkIsSiteCompanion())
      return this.sendSiteCompanionMessage({ sourceId: t, payload: n });
    const r = V1.isFeatureEnabled();
    this.botId = t;
    const i = {
      content: n.message,
      url: this.validateUrlOrDefault(this.entryUrl),
      ...r && { content_type: n.contentType }
    };
    let o;
    const a = {
      data: i
    };
    Ho.UseAPICLient ? o = (await this._getClient().open.sendMessage(this.conversation.id, a)).data : o = await Mr.post(
      `/chat/conversations/${this.conversation.id}/messages`,
      a,
      {
        baseURL: this.clientUrl
      }
    ), n.message !== Q6 && n.message && (this.addMessage(o.data), this.status = wu.REPLYING);
    const s = this.toDomainModel(o.data, t);
    return Promise.resolve(s);
  }
  // TODO: should remove this after CREATE_CONVERSATION_WITH_SAME_UUID feature released
  async sendSiteCompanionMessage({
    sourceId: t,
    payload: n
  }) {
    var l;
    if (!t || !this.uuid || !((l = this.conversation) != null && l.id))
      throw new Error("Please create a conversation");
    const r = V1.isFeatureEnabled();
    this.botId = t;
    const i = {
      content: n.message,
      url: this.validateUrlOrDefault(this.entryUrl),
      ...r && { content_type: n.contentType }
    };
    let o;
    const a = {
      data: i
    };
    Ho.UseAPICLient ? o = (await this._getClient().open.sendSiteCompanionMessage(this.conversation.id, a)).data : o = await Mr.post(
      `/chat/site-companion/conversations/${this.conversation.id}/messages`,
      a,
      {
        baseURL: this.clientUrl
      }
    ), n.message !== Q6 && n.message && (this.addMessage(o.data), this.status = wu.REPLYING);
    const s = this.toDomainModel(o.data, t);
    return Promise.resolve(s);
  }
  // TODO: should remove this after CREATE_CONVERSATION_WITH_SAME_UUID feature released
  checkIsSiteCompanion() {
    return j2.isFeatureEnabled() && this.type === Jo.SiteCompanion;
  }
  // TODO: should remove this after CREATE_CONVERSATION_WITH_SAME_UUID feature released
  get type() {
    const t = document.location.href;
    return new URLSearchParams(t).get("type") ?? Jo.Default;
  }
  /** @deprecated should use clear conversation instead */
  async reset() {
    if (!this.botId)
      throw new Error("reset with null bot id");
    rt.info("start reset", {
      reset_bot_id: this.botId,
      reset_uuid: this.uuid
    }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify([])), localStorage.setItem(`${this.storeKeyPrefix}_${this.botId}_TRACKER_ID`, ""), rt.info("[conversation] reset empty uuid and botId", {
      should_empty_uuid: this.uuid,
      reset_bot_id: this.botId
    }), this.initVisitor(this.botId);
    const t = await this.createConversation({
      sourceId: this.botId,
      payload: {
        new_conversation: !0
      }
    });
    return Promise.resolve(t);
  }
  clear() {
    if (!this.botId)
      throw new Error("clear with null bot id");
    rt.info("[conversation] start clearing conversation", {
      reset_bot_id: this.botId,
      reset_uuid: this.uuid
    }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify([])), localStorage.setItem(`${this.storeKeyPrefix}_${this.botId}_TRACKER_ID`, ""), localStorage.setItem(`${this.storeKeyPrefix}_${this.botId}_CONVERSATION`, "{}"), rt.info("[conversation] clear uuid and botId", {
      should_empty_uuid: this.uuid,
      reset_bot_id: this.botId
    }), this.initVisitor(this.botId);
  }
  validateUrlOrDefault(t) {
    return !t || t.trim() === "" ? `${document.location.origin}${document.location.pathname}` : /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(t) ? t : document.location.href;
  }
  _getClient() {
    return zo.getInstance().getClient();
  }
  async updateAnswerRating(t) {
    throw new Error("Method not implemented");
  }
  async getUserActionBoxInfo(t) {
    throw new Error("Method not implemented");
  }
  async createRelatedQuestions(t) {
    throw new Error("Method not implemented");
  }
}
const J6 = "Chat Fusion Start";
class hf extends Qc {
  constructor() {
    super(), this.projectId = null;
  }
  get conversationKey() {
    return this.isDemoPage && Cl.isFeatureEnabled() ? `${this.storeKeyPrefix}_DEMO_${this.botId}_CONVERSATION` : this.isAdminPage && Cl.isFeatureEnabled() ? `${this.storeKeyPrefix}_ADMIN_${this.botId}_CONVERSATION` : this.checkIsSiteCompanion() ? `${this.entryUrl}_${this.botId}_CONVERSATION` : `${this.storeKeyPrefix}_${this.botId}_CONVERSATION`;
  }
  get trackerIdKey() {
    const t = this.projectId ? `PROJECT_${this.projectId}_TRACKER_ID` : "TRACKER_ID";
    return this.isDemoPage && Cl.isFeatureEnabled() ? `${this.storeKeyPrefix}_DEMO_${t}` : this.isAdminPage && Cl.isFeatureEnabled() ? `${this.storeKeyPrefix}_ADMIN_${t}` : `${this.storeKeyPrefix}_${t}`;
  }
  get conversation() {
    const t = localStorage.getItem(this.conversationKey);
    return t ? JSON.parse(t) : null;
  }
  setConversation(t) {
    localStorage.setItem(this.conversationKey, JSON.stringify(t));
  }
  checkIsSiteCompanion() {
    return j2.isFeatureEnabled() && this.type === Jo.SiteCompanion;
  }
  start(t, n) {
    this.botId = t, n && (this.projectId = n), sp.isFeatureEnabled() || this.initVisitor(this.botId);
  }
  static getInstance() {
    return hf._instance || (hf._instance = new hf()), hf._instance;
  }
  get type() {
    const t = document.location.href;
    return new URLSearchParams(t).get("type") ?? Jo.Default;
  }
  get isDemoPage() {
    const t = document.location.href, r = new URLSearchParams(t).get("parentWindowUrl");
    return !!(r != null && r.startsWith("https://chatfusion.contactloop.com/demo/"));
  }
  get isAdminPage() {
    const t = document.location.href, r = new URLSearchParams(t).get("parentWindowUrl");
    return !!(r != null && r.startsWith("https://chatfusion.contactloop.com/admin/"));
  }
  get uuid() {
    return localStorage.getItem(this.trackerIdKey) ?? null;
  }
  renewUuid() {
    const t = this.generateUUID();
    return localStorage.setItem(this.trackerIdKey, t), rt.info("renew uuid", t), t;
  }
  toAnswerRatingInfraPayload(t) {
    return {
      url: t.url,
      type: t.type,
      guest_id: t.guestId,
      content: t.content ?? null,
      bot_message_id: t.botMessageId
    };
  }
  toUserActionBoxDomain(t) {
    return {
      content: t.content,
      buttonText: t.button_text,
      value: t.value
    };
  }
  async getConversation({
    sourceId: t
  }) {
    var n;
    try {
      if (!t)
        throw new Error("get conversation with null bot id");
      if (this.botId = t, !this.conversation || !this.uuid)
        throw new Error("[conversation with same uuid] Please create a conversation");
      const r = this.checkIsSiteCompanion() ? `/chat/guests/${this.uuid}/site-companion/conversations/${this.conversation.id}/messages` : `/chat/guests/${this.uuid}/conversations/${this.conversation.id}/messages`;
      let i;
      Ho.UseAPICLient ? this.checkIsSiteCompanion() ? i = (await this._getClient().open.getSiteCompanionConversation(
        this.uuid,
        this.conversation.id
      )).data : i = (await this._getClient().open.getWebChatConversation(this.uuid, this.conversation.id)).data : i = await Mr.get(
        r,
        {},
        {
          baseURL: this.clientUrl
        }
      );
      const o = yt.reverse(this.mapToDomainMessages(i.data)), a = [...this.messages, o];
      return rt.info("[conversation with same uuid] get conversation", {
        request_uuid: this.uuid,
        messages: i.data,
        request_botId: this.botId
      }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify(a)), Promise.resolve({
        ...this.conversation,
        messages: o,
        ...Ix.isFeatureEnabled() ? {
          userActionBox: {
            isDisplay: ((n = i == null ? void 0 : i.user_action_box) == null ? void 0 : n.is_display) || !1
          }
        } : {}
      });
    } catch (r) {
      throw rt.error("[conversation with same uuid] get conversation error", {
        error: r.message,
        request_uuid: this.uuid
      }), r;
    }
  }
  async createConversation({
    sourceId: t,
    payload: n
  }) {
    var c;
    const r = t;
    if (!t)
      throw new Error("bot id not found");
    const i = this.uuid ?? this.renewUuid();
    if ((c = this.conversation) != null && c.id)
      return this.conversation;
    let o;
    const a = {
      data: {
        sandbox: this.sandBoxMod,
        url: this.entryUrl
      },
      meta: {
        uuid: i,
        timezone: this.timeZone,
        ...n
      }
    };
    if (Ho.UseAPICLient)
      this.checkIsSiteCompanion() ? o = (await this._getClient().open.createSiteCompanionConversation(r, a)).data : o = (await this._getClient().open.createConversation(r, a)).data;
    else {
      const f = this.checkIsSiteCompanion() ? `/chat/bots/${r}/site-companion/conversations` : `/chat/bots/${r}/conversations`;
      o = await Mr.post(f, a, {
        baseURL: this.clientUrl
      });
    }
    rt.setWebChatInfo({ uuid: this.uuid, botId: this.botId });
    const s = this.toDomainConversation(o.data);
    return rt.info("[conversation] create conversation", {
      cf_conversation_id: o.data.id,
      cf_guest_id: o.data.guest_id,
      cf_bot_id: o.data.bot_id
    }), this.setConversation(s), sp.isFeatureEnabled() && this.initVisitor(r, s.id), Promise.resolve(s);
  }
  async sendMessage({
    sourceId: t,
    payload: n
  }) {
    var l;
    if (!t || !this.uuid || !((l = this.conversation) != null && l.id))
      throw new Error("Please create a conversation");
    if (this.checkIsSiteCompanion())
      return this.sendSiteCompanionMessage({ sourceId: t, payload: n });
    const r = V1.isFeatureEnabled();
    this.botId = t;
    const i = {
      content: n.message,
      url: this.validateUrlOrDefault(this.entryUrl),
      ...r && { content_type: n.contentType }
    };
    let o;
    const a = {
      data: i
    };
    Ho.UseAPICLient ? o = (await this._getClient().open.sendMessage(this.conversation.id, a)).data : o = await Mr.post(
      `/chat/conversations/${this.conversation.id}/messages`,
      a,
      {
        baseURL: this.clientUrl
      }
    ), n.message !== J6 && n.message && (this.addMessage(o.data), this.status = wu.REPLYING);
    const s = this.toDomainModel(o.data, t);
    return Promise.resolve(s);
  }
  async sendSiteCompanionMessage({
    sourceId: t,
    payload: n
  }) {
    var l;
    if (!t || !this.uuid || !((l = this.conversation) != null && l.id))
      throw new Error("Please create a conversation");
    const r = V1.isFeatureEnabled();
    this.botId = t;
    const i = {
      content: n.message,
      url: this.validateUrlOrDefault(this.entryUrl),
      ...r && { content_type: n.contentType }
    };
    let o;
    const a = {
      data: i
    };
    Ho.UseAPICLient ? o = (await this._getClient().open.sendSiteCompanionMessage(this.conversation.id, a)).data : o = await Mr.post(
      `/chat/site-companion/conversations/${this.conversation.id}/messages`,
      a,
      {
        baseURL: this.clientUrl
      }
    ), n.message !== J6 && n.message && (this.addMessage(o.data), this.status = wu.REPLYING);
    const s = this.toDomainModel(o.data, t);
    return Promise.resolve(s);
  }
  async updateAnswerRating({
    botId: t,
    conversationId: n,
    payload: r
  }) {
    try {
      const i = this.toAnswerRatingInfraPayload(r), o = {
        data: i
      };
      Ho.UseAPICLient ? await this._getClient().open.updateAnswerRating(t, n, o) : await Mr.post(
        `/chat/bots/${t}/conversations/${n}/answer-rating`,
        {
          data: i
        },
        {
          baseURL: this.clientUrl
        }
      );
    } catch (i) {
      throw rt.error("[conversation] get conversation error", {
        error: i.message,
        request_uuid: this.uuid
      }), i;
    }
  }
  async getUserActionBoxInfo({
    conversationId: t
  }) {
    try {
      let n;
      if (Ho.UseAPICLient) {
        if (!this.uuid)
          throw new Error("UUID should not be empty");
        n = (await this._getClient().open.getUserActionBoxInfo(this.uuid, t)).data;
      } else
        n = await Mr.get(
          `/chat/guests/${this.uuid}/site-companion/conversations/${t}/call-to-action`,
          {},
          {
            baseURL: this.clientUrl
          }
        );
      const r = this.toUserActionBoxDomain(n.data);
      return Promise.resolve(r);
    } catch (n) {
      throw rt.info("[conversation] getUserActionBoxInfo", {
        error: n.message,
        request_uuid: this.uuid,
        conversation_id: t
      }), Error("[conversation] getUserActionBoxInfo");
    }
  }
  clear() {
    if (!this.botId)
      throw new Error("clear with null bot id");
    rt.info("[conversation] start clearing conversation", {
      reset_bot_id: this.botId,
      reset_uuid: this.uuid
    }), localStorage.setItem(`${this.storeKeyPrefix}_HISTORY`, JSON.stringify([])), localStorage.setItem(this.conversationKey, "{}"), rt.info("[conversation] clear uuid and botId", {
      should_empty_uuid: this.uuid,
      reset_bot_id: this.botId
    }), sp.isFeatureEnabled() || this.initVisitor(this.botId);
  }
  getChannel() {
    var t;
    if (!((t = this.conversation) != null && t.id) || !this.uuid)
      throw new Error("Please create a conversation");
    return `${this.uuid}_${this.conversation.id}`;
  }
  validateUrlOrDefault(t) {
    return !t || t.trim() === "" ? `${document.location.origin}${document.location.pathname}` : /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(t) ? t : document.location.href;
  }
  initVisitor(t, n) {
    sp.isFeatureEnabled() && (this.botId = t, this.uuid && this.saveImpressionEventLog(n));
  }
  async createRelatedQuestions(t) {
    var r;
    if (!this.uuid || !((r = this.conversation) != null && r.id))
      throw new Error("Please create a conversation");
    return (await this._getClient().open.createRelatedQuestions(
      this.uuid,
      this.conversation.id,
      t
    )).data.data.content;
  }
}
const ms = () => {
  const e = IIe.isFeatureEnabled() ? hf.getInstance() : Qc.getInstance();
  return {
    initializeByConfigs: (E) => {
      e.initializeByConfigs(E);
    },
    create: async (E, O) => {
      try {
        const $ = await nMe({
          conversationOutput: e,
          sourceId: E,
          payload: O
        });
        return new M0($);
      } catch ($) {
        throw new Error($);
      }
    },
    get: async (E, O, $) => {
      try {
        const P = await oMe({
          conversationOutput: e,
          conversationId: O,
          sourceId: E,
          uuid: $
        });
        return new M0(P);
      } catch (P) {
        throw new Error(P);
      }
    },
    send: async (E, O) => {
      try {
        const $ = await eMe({
          conversationOutput: e,
          payload: O,
          sourceId: E
        });
        return new M0($);
      } catch ($) {
        throw new Error($);
      }
    },
    sendV2: async (E, O) => {
      try {
        await tMe({
          conversationOutput: e,
          sourceId: E,
          payload: O
        });
      } catch ($) {
        throw new Error($);
      }
    },
    updateRating: async ({
      botId: E,
      conversationId: O,
      payload: $
    }) => {
      try {
        await cMe({
          conversationOutput: e,
          botId: E,
          conversationId: O,
          payload: $
        });
      } catch {
      }
    },
    getUserActionBoxInfo: async ({ conversationId: E }) => {
      try {
        const O = await uMe({ conversationOutput: e, conversationId: E });
        return new fMe(O);
      } catch (O) {
        throw new Error(O);
      }
    },
    connector: () => {
      try {
        return X6({ conversationOutput: e });
      } catch (E) {
        throw new Error(E);
      }
    },
    channel: () => {
      try {
        return aMe({ conversationOutput: e });
      } catch (E) {
        throw new Error(E);
      }
    },
    eventName: () => {
      try {
        return X6({ conversationOutput: e }).eventName;
      } catch (E) {
        throw new Error(E);
      }
    },
    received: (E) => {
      try {
        sMe({ conversationOutput: e, message: E });
      } catch (O) {
        throw new Error(O);
      }
    },
    activeTestingMod: (E) => {
      try {
        lMe({ conversationOutput: e, active: E });
      } catch (O) {
        throw new Error(O);
      }
    },
    reset: async () => {
      try {
        const E = await rMe({
          conversationOutput: e
        });
        return E ? new M0(E) : void 0;
      } catch (E) {
        throw new Error(E);
      }
    },
    clear: () => {
      try {
        iMe({
          conversationOutput: e
        });
      } catch (E) {
        throw new Error(E);
      }
    },
    current: () => e.getCurrent(),
    start: (E, O) => {
      e.start(E, O);
    },
    getEntryUrl: () => e.getEntryUrl(),
    getUuid: () => e.getUuid(),
    createRelatedQuestions: async (E) => {
      try {
        return await e.createRelatedQuestions(E);
      } catch (O) {
        throw new Error(O);
      }
    },
    adapter: e
  };
}, pMe = () => {
  const e = pe(lq), t = pe(dM), n = pe(Nl), r = pe(tM), i = pe(rl), { current: o } = ms(), a = o(), s = wr();
  m.useEffect(() => {
    var c;
    ((c = yt.last(i)) == null ? void 0 : c.type) === fi.SENT && n && a != null && a.uuid && r && s(
      oh({
        campaignId: e,
        conversationId: a.uuid,
        traceId: t.trace_id
      })
    );
  }, [n, r]), m.useEffect(() => {
    t != null && t.id && localStorage.setItem(
      "contactloop-messenger",
      JSON.stringify({
        conversation: {
          id: t.id,
          lead_id: t.lead_id
        }
      })
    );
  }, [t == null ? void 0 : t.id]);
};
var xa = /* @__PURE__ */ ((e) => (e.Container = "container", e.Iframe = "iframeContainer", e.IndependentLauncher = "independentLauncher", e))(xa || {});
const S_ = {
  container: "onrWebchat",
  iframeContainer: "onrWebchatIframe",
  independentLauncher: "independentOnrWebchatLauncher"
};
class Nr {
  constructor(t) {
    this.id = t;
  }
  static create(t) {
    return new Nr(t);
  }
  getContainerId(t) {
    const n = S_[t];
    return this.id ? `${n}-${this.id}` : n;
  }
  getContainer(t) {
    const n = S_[t], r = this.id ? `${n}-${this.id}` : n;
    return document.getElementById(r) ?? document.getElementById(n);
  }
  postEventTo(t, n) {
    var r;
    try {
      const i = S_[t];
      if (!this.id)
        document.querySelectorAll(
          `[data-container-name="${i}"]:not([data-embedded="true"])`
        ).forEach((a) => {
          var l;
          const s = a;
          (l = s == null ? void 0 : s.contentWindow) == null || l.postMessage(
            { name: n.name, detail: n.detail },
            "*"
          );
        });
      else {
        const o = document.getElementById(
          `${i}-${this.id}`
        );
        (r = o == null ? void 0 : o.contentWindow) == null || r.postMessage({ name: n.name, detail: n.detail }, "*");
      }
      rt.info("post event", { webchatId: this.id, target: t, eventData: n });
    } catch (i) {
      rt.error("post event error", { target: t, eventData: n, error: i });
    }
  }
  postEventToParent(t, n, r) {
    var i, o;
    try {
      !n && !r ? ((i = window == null ? void 0 : window.parent) == null || i.postMessage(t), rt.info(`post event to parent: ${t}`)) : ((o = window == null ? void 0 : window.parent) == null || o.postMessage(
        {
          name: t,
          webchatId: n,
          ...r
        },
        "*"
      ), rt.info(`post event to parent: ${t}`, { ...r, webchatId: n }));
    } catch (a) {
      rt.error(`post event to parent: ${t} error`, {
        error: a,
        detail: { ...r == null ? void 0 : r.detail, webchatId: n }
      });
    }
  }
  dispatchWindowEvent(t, n, r) {
    try {
      const i = new CustomEvent(t, { detail: { ...r == null ? void 0 : r.detail, webchatId: n } });
      window.dispatchEvent(i), console.log(`[WebChat] send event: ${t}`, { detail: { ...r == null ? void 0 : r.detail, webchatId: n } });
    } catch (i) {
      console.error(`[WebChat] send event: ${t} error`, {
        error: i,
        detail: { ...r == null ? void 0 : r.detail, webchatId: n }
      });
    }
  }
}
const hMe = (e) => {
  const t = wr(), n = () => {
    t(Vs(!0));
  }, r = () => {
    t(Vs(!1));
  }, i = () => {
    t(Vs());
  }, o = (p) => {
    var y;
    const v = ((y = p.detail) == null ? void 0 : y.device) === Y2.Mobile;
    t(w2e(v));
  }, a = (p) => {
    const { message: g, messageType: v, webchatId: y = e } = p.detail;
    t(
      p8e({
        content: g,
        contentType: v,
        webchatId: y
      })
    );
  }, s = (p) => {
    rt.info("[ui] update popup behavior", { ...p.detail });
    const g = p.detail;
    g.theme && t(Bx(g.theme)), g.position && t(q2e(g.position)), g.themeColor && t(pq(g.themeColor)), g.companyName && t(K2e(g.companyName)), g.startQuestion && (t(m8e(g.startQuestion)), t(Qs(!0)));
  }, l = () => {
    t(rw()), t(iw()), rt.info("[ui] restart conversation by conversation_restart event");
  }, c = (p) => {
    const { isPopupSmallMode: g } = p.detail;
    t(Kg(g));
  }, f = {
    [Fi.POPUP_HIDE]: r,
    [Fi.POPUP_SHOW]: n,
    [Fi.POPUP_UPDATE]: s,
    [Fi.CONVERSATION_RESTART]: l,
    [Fi.DEVICE_CHANGE]: o,
    [Fi.MESSAGE_SEND]: a,
    [Fi.POPUP_SMALL_MODE_CHANGED]: c,
    /** deprecated, after independent launcher removed, remove this */
    [E2e.TOGGLE_POPUP]: i
  }, d = (p) => {
    var v;
    const g = f[p.data.name];
    g && (Tx.isFeatureEnabled() && ((v = p.data.detail) != null && v.webchatId) ? p.data.detail.webchatId === e && g(p.data) : g(p.data));
  };
  m.useEffect(() => {
    if (window != null && window.webchat)
      return window == null || window.addEventListener("message", d), Nr.create().postEventToParent(Q2), () => {
        window == null || window.removeEventListener("message", d);
      };
  }, []);
}, mq = (e) => {
  [v8e, S2e, w8e].forEach((t) => {
    e(t());
  });
}, mMe = () => {
  const e = m.useRef(), t = m.useRef(0), n = m.useRef(0), r = pe(kl), i = (c, f) => {
    try {
      const d = document.getElementsByClassName("message-container")[0], p = document.getElementById(
        "small-popup-starter-questions"
      ), g = !!(d != null && d.contains(c.target)), v = !!(p != null && p.contains(
        c.target
      )), y = g && f && d && d.scrollHeight > d.clientHeight && !r, x = v && !f && p && p.scrollWidth > p.clientWidth;
      !y && !x && c.preventDefault();
    } catch {
    }
  }, o = (c) => {
    const f = c;
    t.current = f.touches[0].clientX, n.current = f.touches[0].clientY;
  }, a = (c) => {
    const f = c, d = Math.abs(f.touches[0].clientX - t.current), g = Math.abs(f.touches[0].clientY - n.current) > d;
    i(c, g);
  }, s = (c) => {
    const d = c.deltaY !== 0;
    i(c, d);
  };
  return {
    initializeContainerEvents: () => {
      const c = new MutationObserver(() => {
        e.current = document.getElementsByClassName("conversation-container")[0], e.current && (c.disconnect(), e.current.addEventListener("touchstart", o), e.current.addEventListener("touchmove", a), e.current.addEventListener("wheel", s));
      });
      c.observe(document.body, {
        childList: !0,
        subtree: !0
      }), setTimeout(() => {
        c.disconnect();
      }, 1e4);
    }
  };
}, gMe = 41, vMe = (e) => {
  const { title: t, themeColor: n, position: r, theme: i, custom: o, testingMod: a, reset: s, webchatId: l } = e, { current: c, getUuid: f, activeTestingMod: d } = ms(), p = wr(), g = pe(Nl), v = pe(N2e), y = pe(Px), x = pe($c), b = pe(kl), w = pe(jx) && b, S = pe(rl), E = pe(oq), { updateSmallPopupStatus: O } = BX(e), [$, P] = m.useState(), { autoPopup: R } = pe(Z2), L = pe(Fx), B = pe(uq), { initializeContainerEvents: j } = mMe(), A = m.useCallback(() => {
    const W = {
      name: mI,
      isPopupShown: g,
      /* @deprecated, could be remove after INDEPENDENT_LAUNCHER flag removed */
      isLauncherAlwaysShow: v,
      isPopupSmallMode: b,
      showSmallPopupStarterQuestions: w,
      welcomeMessageHeight: $ ?? gMe,
      isSimulateMobile: x,
      webchatId: l,
      chatBubblePlacementStyle: L ?? Bi.Bubble,
      chatBubblePlacementSize: B ?? Wg.Small
    };
    Nr.create().postEventToParent(mI, l, W), rt.debug("resize", W);
  }, [
    l,
    g,
    v,
    b,
    $,
    x,
    w,
    L,
    B
  ]), T = () => {
    var G;
    const W = (G = c()) == null ? void 0 : G.uuid, V = f();
    W && V && W !== V && (p(rw()), p(iw()), rt.info("[Init] restart conversation by new uuid"));
  }, k = () => {
    let W = 0;
    const V = setInterval(() => {
      try {
        (document.querySelector(".conversation-container") || W++ > 100) && (clearInterval(V), Nr.create().postEventToParent(sn.IFRAME_LOADED, l));
      } catch (G) {
        console.error("[Webchat Demo] iframe failed to get data", G), clearInterval(V), setTimeout(() => {
          Nr.create().postEventToParent(sn.IFRAME_LOADED, l);
        }, 5e3);
      }
    }, 500);
  }, F = () => {
    const W = setInterval(() => {
      try {
        const V = document.querySelector(".message-wrapper.sent:not(.loading)");
        if (!V)
          return;
        clearInterval(W), setTimeout(() => {
          P(V.clientHeight);
        }, 200);
      } catch {
        clearInterval(W);
      }
    }, 100);
    setTimeout(() => {
      clearInterval(W);
    }, 1e5);
  };
  m.useEffect(() => {
    p(
      Y2e({
        title: t,
        themeColor: n,
        position: r,
        theme: i,
        custom: o
      })
    ), p(X2e({ testingMod: a ?? !1 })), d(a ?? !1);
  }, [t, n, r, i, o, a]), m.useEffect(() => {
    y || A();
  }, [A, y]), m.useEffect(() => {
    O();
  }, [x, i, R]), m.useEffect(() => {
    b && O();
  }, [S]), m.useEffect(() => {
    !g || S.length > 1 || F();
  }, [g, x, S]), m.useEffect(() => {
    s && (p(rw()), p(iw()), rt.info("[Init] restart conversation by reset config"));
  }, [s]), m.useEffect(() => {
    Nr.create().postEventToParent(sn.BADGE_COUNT_CHANGE, l, {
      badgeCount: E
    });
  }, [E]), m.useEffect(() => {
    Nr.create().postEventToParent(
      g ? sn.WEBCHAT_POPUP_SHOW : sn.WEBCHAT_POPUP_HIDE,
      l
    );
  }, [g]), m.useEffect(() => {
    T(), j(), mq(p), Cl.isFeatureEnabled() && k(), localStorage.setItem("FEATURE_FLAGS", "SEND_LEAD_CREATED_EVENT_FEATURE,EVENT_LOG_IMPRESSION,INDEPENDENT_LAUNCHER,MULTIPLE_BOT_STORE,CREATE_CONVERSATION_WITH_SAME_UUID,CONVERSATION_WITH_EACH_PAGE,ANSWER_RATING,STORE_USER_BEHAVIOR_DATA,USER_ACTION_BOX,WEBCHAT_PURE_SCRIPT,CHAT_BUBBLE_NEW_PLACEMENT,CHAT_BUBBLE_NEW_PLACEMENT_2,USE_API_CLIENT,INVITATION_MODAL,CHAT_BUBBLE_SUPPORT_GIF,SITE_COMPANION_LOADING_ANIMATION,STREAMING_MESSAGE,RELATED_QUESTION_API,SITE_COMPANION_LOADING_ANIMATION_2");
  }, []);
}, zx = (e) => {
  const [t, n] = m.useState(), [r, i] = m.useState(!1), [o, a] = m.useState(!1), s = m.useRef(!1), l = (y, x) => {
    var b, w;
    (b = window.webchat) == null || b.sendMessage(y, x, e), (w = window.webchat) == null || w.show(e);
  }, c = () => {
    try {
      const y = yt.trim(t);
      if (!y)
        return;
      if (!s.current) {
        a(!0), setTimeout(() => {
          c();
        }, 500);
        return;
      }
      l(y, $u.Message), n(""), a(!1);
    } catch {
      a(!1);
    }
  }, f = (y) => {
    try {
      if (!s.current) {
        a(!0), setTimeout(() => {
          f(y);
        }, 500);
        return;
      }
      l(y, $u.StarterQuestion), a(!1);
    } catch {
      a(!1);
    }
  }, d = (y) => {
    n(y);
  }, p = (y) => {
    var w;
    const b = ((w = y.detail) == null ? void 0 : w.device) === Y2.Mobile;
    i(b);
  }, g = () => {
    setTimeout(() => {
      s.current = !0;
    }, 5e3);
  }, v = () => {
    s.current = !0;
  };
  return ya(sn.DEVICE_CHANGE, p, window, e), ya(sn.IFRAME_LOADED, g, window, e), ya(
    sn.CONVERSATION_CREATED,
    v,
    window,
    e
  ), {
    loading: o,
    value: t,
    isSimulateMobile: r,
    updateValue: d,
    sendMessage: l,
    handleSendInputMessage: c,
    handleStarterQuestionClick: f
  };
}, x_ = {
  [Jt.fusion]: {
    chatBtn: {
      background: "#635fe7",
      color: "#fff"
    },
    caption: {
      color: "rgb(246 246 246 / 47%)"
    },
    title: {
      color: "#fff"
    },
    footer: {
      background: "#635fe7"
    },
    header: {
      background: "#635fe7"
    },
    conversation: {
      background: "#fff",
      height: "calc(100% - 75px)",
      divider: "1px solid #f9f9f9",
      color: "#635fe7",
      sentBtnColor: "#fff"
    },
    cover: "https://chatfusion.onramplab.com/static/images/logo.svg"
  },
  [Jt.basic]: {
    chatBtn: {
      background: "#1890ff",
      color: "#fff"
    },
    caption: {
      color: "lightslategrey"
    },
    title: {
      color: "#d5d3d3"
    },
    footer: {
      background: "#fff"
    },
    header: {
      background: "#fff"
    },
    conversation: {
      background: "#f9f9f9",
      height: "calc(100% - 40px)",
      divider: "0px",
      color: "#000",
      sentBtnColor: "#1890ff"
    },
    cover: ""
  },
  [Jt.simple]: void 0,
  [Jt.siteCompanion]: void 0
}, Kf = () => {
  const [e, t] = m.useState(x_.basic), n = pe(ed) || "#fff", r = pe(Ll) || Jt.basic, i = () => {
    if (!r)
      return;
    const o = x_[r] || x_.basic, a = {
      chatBtn: {
        background: n,
        color: "#fff"
      },
      footer: {
        background: n
      },
      header: {
        background: n
      },
      conversation: {
        sentBtnColor: n
      }
    }, s = {
      chatBtn: { ...o.chatBtn, ...a.chatBtn },
      caption: o.caption,
      title: o.title,
      footer: { ...o.footer, ...a.footer },
      header: { ...o.header, ...a.header },
      conversation: { ...o.conversation, ...a.conversation },
      cover: o.cover
    };
    t(s);
  };
  return m.useEffect(() => {
    i();
  }, [r]), {
    themeStyle: e,
    theme: r,
    themeColor: n
  };
};
var fo = function() {
  return fo = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, fo.apply(this, arguments);
};
function Zp(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var vr = "-ms-", ig = "-moz-", Rn = "-webkit-", gq = "comm", Ux = "rule", iM = "decl", yMe = "@import", vq = "@keyframes", bMe = "@layer", wMe = Math.abs, oM = String.fromCharCode, yI = Object.assign;
function SMe(e, t) {
  return $i(e, 0) ^ 45 ? (((t << 2 ^ $i(e, 0)) << 2 ^ $i(e, 1)) << 2 ^ $i(e, 2)) << 2 ^ $i(e, 3) : 0;
}
function yq(e) {
  return e.trim();
}
function tc(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function tn(e, t, n) {
  return e.replace(t, n);
}
function _b(e, t) {
  return e.indexOf(t);
}
function $i(e, t) {
  return e.charCodeAt(t) | 0;
}
function eh(e, t, n) {
  return e.slice(t, n);
}
function yl(e) {
  return e.length;
}
function bq(e) {
  return e.length;
}
function jm(e, t) {
  return t.push(e), e;
}
function xMe(e, t) {
  return e.map(t).join("");
}
function Z6(e, t) {
  return e.filter(function(n) {
    return !tc(n, t);
  });
}
var Hx = 1, th = 1, wq = 0, cs = 0, ti = 0, _h = "";
function Wx(e, t, n, r, i, o, a, s) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: Hx, column: th, length: a, return: "", siblings: s };
}
function Uc(e, t) {
  return yI(Wx("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function kd(e) {
  for (; e.root; )
    e = Uc(e.root, { children: [e] });
  jm(e, e.siblings);
}
function CMe() {
  return ti;
}
function EMe() {
  return ti = cs > 0 ? $i(_h, --cs) : 0, th--, ti === 10 && (th = 1, Hx--), ti;
}
function Gs() {
  return ti = cs < wq ? $i(_h, cs++) : 0, th++, ti === 10 && (th = 1, Hx++), ti;
}
function Rf() {
  return $i(_h, cs);
}
function Ob() {
  return cs;
}
function Vx(e, t) {
  return eh(_h, e, t);
}
function bI(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function $Me(e) {
  return Hx = th = 1, wq = yl(_h = e), cs = 0, [];
}
function _Me(e) {
  return _h = "", e;
}
function C_(e) {
  return yq(Vx(cs - 1, wI(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function OMe(e) {
  for (; (ti = Rf()) && ti < 33; )
    Gs();
  return bI(e) > 2 || bI(ti) > 3 ? "" : " ";
}
function PMe(e, t) {
  for (; --t && Gs() && !(ti < 48 || ti > 102 || ti > 57 && ti < 65 || ti > 70 && ti < 97); )
    ;
  return Vx(e, Ob() + (t < 6 && Rf() == 32 && Gs() == 32));
}
function wI(e) {
  for (; Gs(); )
    switch (ti) {
      case e:
        return cs;
      case 34:
      case 39:
        e !== 34 && e !== 39 && wI(ti);
        break;
      case 40:
        e === 41 && wI(e);
        break;
      case 92:
        Gs();
        break;
    }
  return cs;
}
function TMe(e, t) {
  for (; Gs() && e + ti !== 57; )
    if (e + ti === 84 && Rf() === 47)
      break;
  return "/*" + Vx(t, cs - 1) + "*" + oM(e === 47 ? e : Gs());
}
function IMe(e) {
  for (; !bI(Rf()); )
    Gs();
  return Vx(e, cs);
}
function AMe(e) {
  return _Me(Pb("", null, null, null, [""], e = $Me(e), 0, [0], e));
}
function Pb(e, t, n, r, i, o, a, s, l) {
  for (var c = 0, f = 0, d = a, p = 0, g = 0, v = 0, y = 1, x = 1, b = 1, w = 0, S = "", E = i, O = o, $ = r, P = S; x; )
    switch (v = w, w = Gs()) {
      case 40:
        if (v != 108 && $i(P, d - 1) == 58) {
          _b(P += tn(C_(w), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += C_(w);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += OMe(v);
        break;
      case 92:
        P += PMe(Ob() - 1, 7);
        continue;
      case 47:
        switch (Rf()) {
          case 42:
          case 47:
            jm(RMe(TMe(Gs(), Ob()), t, n, l), l);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * y:
        s[c++] = yl(P) * b;
      case 125 * y:
      case 59:
      case 0:
        switch (w) {
          case 0:
          case 125:
            x = 0;
          case 59 + f:
            b == -1 && (P = tn(P, /\f/g, "")), g > 0 && yl(P) - d && jm(g > 32 ? t5(P + ";", r, n, d - 1, l) : t5(tn(P, " ", "") + ";", r, n, d - 2, l), l);
            break;
          case 59:
            P += ";";
          default:
            if (jm($ = e5(P, t, n, c, f, i, s, S, E = [], O = [], d, o), o), w === 123)
              if (f === 0)
                Pb(P, t, $, $, E, o, d, s, O);
              else
                switch (p === 99 && $i(P, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Pb(e, $, $, r && jm(e5(e, $, $, 0, 0, i, s, S, i, E = [], d, O), O), i, O, d, s, r ? E : O);
                    break;
                  default:
                    Pb(P, $, $, $, [""], O, 0, s, O);
                }
        }
        c = f = g = 0, y = b = 1, S = P = "", d = a;
        break;
      case 58:
        d = 1 + yl(P), g = v;
      default:
        if (y < 1) {
          if (w == 123)
            --y;
          else if (w == 125 && y++ == 0 && EMe() == 125)
            continue;
        }
        switch (P += oM(w), w * y) {
          case 38:
            b = f > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            s[c++] = (yl(P) - 1) * b, b = 1;
            break;
          case 64:
            Rf() === 45 && (P += C_(Gs())), p = Rf(), f = d = yl(S = P += IMe(Ob())), w++;
            break;
          case 45:
            v === 45 && yl(P) == 2 && (y = 0);
        }
    }
  return o;
}
function e5(e, t, n, r, i, o, a, s, l, c, f, d) {
  for (var p = i - 1, g = i === 0 ? o : [""], v = bq(g), y = 0, x = 0, b = 0; y < r; ++y)
    for (var w = 0, S = eh(e, p + 1, p = wMe(x = a[y])), E = e; w < v; ++w)
      (E = yq(x > 0 ? g[w] + " " + S : tn(S, /&\f/g, g[w]))) && (l[b++] = E);
  return Wx(e, t, n, i === 0 ? Ux : s, l, c, f, d);
}
function RMe(e, t, n, r) {
  return Wx(e, t, n, gq, oM(CMe()), eh(e, 2, -2), 0, r);
}
function t5(e, t, n, r, i) {
  return Wx(e, t, n, iM, eh(e, 0, r), eh(e, r + 1, -1), r, i);
}
function Sq(e, t, n) {
  switch (SMe(e, t)) {
    case 5103:
      return Rn + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Rn + e + e;
    case 4789:
      return ig + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Rn + e + ig + e + vr + e + e;
    case 5936:
      switch ($i(e, t + 11)) {
        case 114:
          return Rn + e + vr + tn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Rn + e + vr + tn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Rn + e + vr + tn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return Rn + e + vr + e + e;
    case 6165:
      return Rn + e + vr + "flex-" + e + e;
    case 5187:
      return Rn + e + tn(e, /(\w+).+(:[^]+)/, Rn + "box-$1$2" + vr + "flex-$1$2") + e;
    case 5443:
      return Rn + e + vr + "flex-item-" + tn(e, /flex-|-self/g, "") + (tc(e, /flex-|baseline/) ? "" : vr + "grid-row-" + tn(e, /flex-|-self/g, "")) + e;
    case 4675:
      return Rn + e + vr + "flex-line-pack" + tn(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return Rn + e + vr + tn(e, "shrink", "negative") + e;
    case 5292:
      return Rn + e + vr + tn(e, "basis", "preferred-size") + e;
    case 6060:
      return Rn + "box-" + tn(e, "-grow", "") + Rn + e + vr + tn(e, "grow", "positive") + e;
    case 4554:
      return Rn + tn(e, /([^-])(transform)/g, "$1" + Rn + "$2") + e;
    case 6187:
      return tn(tn(tn(e, /(zoom-|grab)/, Rn + "$1"), /(image-set)/, Rn + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return tn(e, /(image-set\([^]*)/, Rn + "$1$`$1");
    case 4968:
      return tn(tn(e, /(.+:)(flex-)?(.*)/, Rn + "box-pack:$3" + vr + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Rn + e + e;
    case 4200:
      if (!tc(e, /flex-|baseline/))
        return vr + "grid-column-align" + eh(e, t) + e;
      break;
    case 2592:
    case 3360:
      return vr + tn(e, "template-", "") + e;
    case 4384:
    case 3616:
      return n && n.some(function(r, i) {
        return t = i, tc(r.props, /grid-\w+-end/);
      }) ? ~_b(e + (n = n[t].value), "span") ? e : vr + tn(e, "-start", "") + e + vr + "grid-row-span:" + (~_b(n, "span") ? tc(n, /\d+/) : +tc(n, /\d+/) - +tc(e, /\d+/)) + ";" : vr + tn(e, "-start", "") + e;
    case 4896:
    case 4128:
      return n && n.some(function(r) {
        return tc(r.props, /grid-\w+-start/);
      }) ? e : vr + tn(tn(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return tn(e, /(.+)-inline(.+)/, Rn + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (yl(e) - 1 - t > 6)
        switch ($i(e, t + 1)) {
          case 109:
            if ($i(e, t + 4) !== 45)
              break;
          case 102:
            return tn(e, /(.+:)(.+)-([^]+)/, "$1" + Rn + "$2-$3$1" + ig + ($i(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~_b(e, "stretch") ? Sq(tn(e, "stretch", "fill-available"), t, n) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return tn(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, i, o, a, s, l, c) {
        return vr + i + ":" + o + c + (a ? vr + i + "-span:" + (s ? l : +l - +o) + c : "") + e;
      });
    case 4949:
      if ($i(e, t + 6) === 121)
        return tn(e, ":", ":" + Rn) + e;
      break;
    case 6444:
      switch ($i(e, $i(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return tn(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Rn + ($i(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Rn + "$2$3$1" + vr + "$2box$3") + e;
        case 100:
          return tn(e, ":", ":" + vr) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return tn(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function X1(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function MMe(e, t, n, r) {
  switch (e.type) {
    case bMe:
      if (e.children.length)
        break;
    case yMe:
    case iM:
      return e.return = e.return || e.value;
    case gq:
      return "";
    case vq:
      return e.return = e.value + "{" + X1(e.children, r) + "}";
    case Ux:
      if (!yl(e.value = e.props.join(",")))
        return "";
  }
  return yl(n = X1(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function NMe(e) {
  var t = bq(e);
  return function(n, r, i, o) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, r, i, o) || "";
    return a;
  };
}
function kMe(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function LMe(e, t, n, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case iM:
        e.return = Sq(e.value, e.length, n);
        return;
      case vq:
        return X1([Uc(e, { value: tn(e.value, "@", "@" + Rn) })], r);
      case Ux:
        if (e.length)
          return xMe(n = e.props, function(i) {
            switch (tc(i, r = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                kd(Uc(e, { props: [tn(i, /:(read-\w+)/, ":" + ig + "$1")] })), kd(Uc(e, { props: [i] })), yI(e, { props: Z6(n, r) });
                break;
              case "::placeholder":
                kd(Uc(e, { props: [tn(i, /:(plac\w+)/, ":" + Rn + "input-$1")] })), kd(Uc(e, { props: [tn(i, /:(plac\w+)/, ":" + ig + "$1")] })), kd(Uc(e, { props: [tn(i, /:(plac\w+)/, vr + "input-$1")] })), kd(Uc(e, { props: [i] })), yI(e, { props: Z6(n, r) });
                break;
            }
            return "";
          });
    }
}
var DMe = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, nh = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", aM = typeof window < "u" && "HTMLElement" in window, jMe = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" && process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY), FMe = {}, Gx = Object.freeze([]), rh = Object.freeze({});
function xq(e, t, n) {
  return n === void 0 && (n = rh), e.theme !== n.theme && e.theme || t || n.theme;
}
var Cq = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), BMe = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, zMe = /(^-|-$)/g;
function n5(e) {
  return e.replace(BMe, "-").replace(zMe, "");
}
var UMe = /(a)(d)/gi, r5 = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function SI(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0)
    n = r5(t % 52) + n;
  return (r5(t % 52) + n).replace(UMe, "$1-$2");
}
var E_, lp = function(e, t) {
  for (var n = t.length; n; )
    e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, Eq = function(e) {
  return lp(5381, e);
};
function sM(e) {
  return SI(Eq(e) >>> 0);
}
function HMe(e) {
  return e.displayName || e.name || "Component";
}
function $_(e) {
  return typeof e == "string" && !0;
}
var $q = typeof Symbol == "function" && Symbol.for, _q = $q ? Symbol.for("react.memo") : 60115, WMe = $q ? Symbol.for("react.forward_ref") : 60112, VMe = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, GMe = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Oq = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, KMe = ((E_ = {})[WMe] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, E_[_q] = Oq, E_);
function i5(e) {
  return ("type" in (t = e) && t.type.$$typeof) === _q ? Oq : "$$typeof" in e ? KMe[e.$$typeof] : VMe;
  var t;
}
var qMe = Object.defineProperty, YMe = Object.getOwnPropertyNames, o5 = Object.getOwnPropertySymbols, XMe = Object.getOwnPropertyDescriptor, QMe = Object.getPrototypeOf, a5 = Object.prototype;
function Pq(e, t, n) {
  if (typeof t != "string") {
    if (a5) {
      var r = QMe(t);
      r && r !== a5 && Pq(e, r, n);
    }
    var i = YMe(t);
    o5 && (i = i.concat(o5(t)));
    for (var o = i5(e), a = i5(t), s = 0; s < i.length; ++s) {
      var l = i[s];
      if (!(l in GMe || n && n[l] || a && l in a || o && l in o)) {
        var c = XMe(t, l);
        try {
          qMe(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
function ih(e) {
  return typeof e == "function";
}
function lM(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function Cf(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function Q1(e, t) {
  if (e.length === 0)
    return "";
  for (var n = e[0], r = 1; r < e.length; r++)
    n += t ? t + e[r] : e[r];
  return n;
}
function qg(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function xI(e, t, n) {
  if (n === void 0 && (n = !1), !n && !qg(e) && !Array.isArray(e))
    return t;
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      e[r] = xI(e[r], t[r]);
  else if (qg(t))
    for (var r in t)
      e[r] = xI(e[r], t[r]);
  return e;
}
function cM(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
function Iv(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : ""));
}
var JMe = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  return e.prototype.indexOfGroup = function(t) {
    for (var n = 0, r = 0; r < t; r++)
      n += this.groupSizes[r];
    return n;
  }, e.prototype.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var r = this.groupSizes, i = r.length, o = i; t >= o; )
        if ((o <<= 1) < 0)
          throw Iv(16, "".concat(t));
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(r), this.length = o;
      for (var a = i; a < o; a++)
        this.groupSizes[a] = 0;
    }
    for (var s = this.indexOfGroup(t + 1), l = (a = 0, n.length); a < l; a++)
      this.tag.insertRule(s, n[a]) && (this.groupSizes[t]++, s++);
  }, e.prototype.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], r = this.indexOfGroup(t), i = r + n;
      this.groupSizes[t] = 0;
      for (var o = r; o < i; o++)
        this.tag.deleteRule(r);
    }
  }, e.prototype.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return n;
    for (var r = this.groupSizes[t], i = this.indexOfGroup(t), o = i + r, a = i; a < o; a++)
      n += "".concat(this.tag.getRule(a)).concat(`/*!sc*/
`);
    return n;
  }, e;
}(), Tb = /* @__PURE__ */ new Map(), J1 = /* @__PURE__ */ new Map(), __ = 1, N0 = function(e) {
  if (Tb.has(e))
    return Tb.get(e);
  for (; J1.has(__); )
    __++;
  var t = __++;
  return Tb.set(e, t), J1.set(t, e), t;
}, ZMe = function(e, t) {
  Tb.set(e, t), J1.set(t, e);
}, eNe = "style[".concat(nh, "][").concat("data-styled-version", '="').concat("6.0.7", '"]'), tNe = new RegExp("^".concat(nh, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), nNe = function(e, t, n) {
  for (var r, i = n.split(","), o = 0, a = i.length; o < a; o++)
    (r = i[o]) && e.registerName(t, r);
}, rNe = function(e, t) {
  for (var n, r = ((n = t.textContent) !== null && n !== void 0 ? n : "").split(`/*!sc*/
`), i = [], o = 0, a = r.length; o < a; o++) {
    var s = r[o].trim();
    if (s) {
      var l = s.match(tNe);
      if (l) {
        var c = 0 | parseInt(l[1], 10), f = l[2];
        c !== 0 && (ZMe(f, c), nNe(e, f, l[3]), e.getTag().insertRules(c, i)), i.length = 0;
      } else
        i.push(s);
    }
  }
};
function iNe() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var Tq = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), i = function(s) {
    var l = Array.from(s.querySelectorAll("style[".concat(nh, "]")));
    return l[l.length - 1];
  }(n), o = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(nh, "active"), r.setAttribute("data-styled-version", "6.0.7");
  var a = iNe();
  return a && r.setAttribute("nonce", a), n.insertBefore(r, o), r;
}, oNe = function() {
  function e(t) {
    this.element = Tq(t), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet)
        return n.sheet;
      for (var r = document.styleSheets, i = 0, o = r.length; i < o; i++) {
        var a = r[i];
        if (a.ownerNode === n)
          return a;
      }
      throw Iv(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.prototype.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n && n.cssText ? n.cssText : "";
  }, e;
}(), aNe = function() {
  function e(t) {
    this.element = Tq(t), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var r = document.createTextNode(n);
      return this.element.insertBefore(r, this.nodes[t] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), sNe = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, e.prototype.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), s5 = aM, lNe = { isServer: !aM, useCSSOMInjection: !jMe }, Z1 = function() {
  function e(t, n, r) {
    t === void 0 && (t = rh), n === void 0 && (n = {});
    var i = this;
    this.options = fo(fo({}, lNe), t), this.gs = n, this.names = new Map(r), this.server = !!t.isServer, !this.server && aM && s5 && (s5 = !1, function(o) {
      for (var a = document.querySelectorAll(eNe), s = 0, l = a.length; s < l; s++) {
        var c = a[s];
        c && c.getAttribute(nh) !== "active" && (rNe(o, c), c.parentNode && c.parentNode.removeChild(c));
      }
    }(this)), cM(this, function() {
      return function(o) {
        for (var a = o.getTag(), s = a.length, l = "", c = function(d) {
          var p = function(b) {
            return J1.get(b);
          }(d);
          if (p === void 0)
            return "continue";
          var g = o.names.get(p), v = a.getGroup(d);
          if (g === void 0 || v.length === 0)
            return "continue";
          var y = "".concat(nh, ".g").concat(d, '[id="').concat(p, '"]'), x = "";
          g !== void 0 && g.forEach(function(b) {
            b.length > 0 && (x += "".concat(b, ","));
          }), l += "".concat(v).concat(y, '{content:"').concat(x, '"}').concat(`/*!sc*/
`);
        }, f = 0; f < s; f++)
          c(f);
        return l;
      }(i);
    });
  }
  return e.registerId = function(t) {
    return N0(t);
  }, e.prototype.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(fo(fo({}, this.options), t), this.gs, n && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (t = function(n) {
      var r = n.useCSSOMInjection, i = n.target;
      return n.isServer ? new sNe(i) : r ? new oNe(i) : new aNe(i);
    }(this.options), new JMe(t)));
    var t;
  }, e.prototype.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, e.prototype.registerName = function(t, n) {
    if (N0(t), this.names.has(t))
      this.names.get(t).add(n);
    else {
      var r = /* @__PURE__ */ new Set();
      r.add(n), this.names.set(t, r);
    }
  }, e.prototype.insertRules = function(t, n, r) {
    this.registerName(t, n), this.getTag().insertRules(N0(t), r);
  }, e.prototype.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.prototype.clearRules = function(t) {
    this.getTag().clearGroup(N0(t)), this.clearNames(t);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), cNe = /&/g, uNe = /^\s*\/\/.*$/gm;
function Iq(e, t) {
  return e.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(t, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(t, " ")), n.props = n.props.map(function(r) {
      return "".concat(t, " ").concat(r);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = Iq(n.children, t)), n;
  });
}
function fNe(e) {
  var t, n, r, i = e === void 0 ? rh : e, o = i.options, a = o === void 0 ? rh : o, s = i.plugins, l = s === void 0 ? Gx : s, c = function(p, g, v) {
    return v === n || v.startsWith(n) && v.endsWith(n) && v.replaceAll(n, "").length > 0 ? ".".concat(t) : p;
  }, f = l.slice();
  f.push(function(p) {
    p.type === Ux && p.value.includes("&") && (p.props[0] = p.props[0].replace(cNe, n).replace(r, c));
  }), a.prefix && f.push(LMe), f.push(MMe);
  var d = function(p, g, v, y) {
    g === void 0 && (g = ""), v === void 0 && (v = ""), y === void 0 && (y = "&"), t = y, n = g, r = new RegExp("\\".concat(n, "\\b"), "g");
    var x = p.replace(uNe, ""), b = AMe(v || g ? "".concat(v, " ").concat(g, " { ").concat(x, " }") : x);
    a.namespace && (b = Iq(b, a.namespace));
    var w = [];
    return X1(b, NMe(f.concat(kMe(function(S) {
      return w.push(S);
    })))), w;
  };
  return d.hash = l.length ? l.reduce(function(p, g) {
    return g.name || Iv(15), lp(p, g.name);
  }, 5381).toString() : "", d;
}
var dNe = new Z1(), CI = fNe(), Aq = oe.createContext({ shouldForwardProp: void 0, styleSheet: dNe, stylis: CI });
Aq.Consumer;
oe.createContext(void 0);
function EI() {
  return m.useContext(Aq);
}
var Rq = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(i, o) {
      o === void 0 && (o = CI);
      var a = r.name + o.hash;
      i.hasNameForId(r.id, a) || i.insertRules(r.id, a, o(r.rules, a, "@keyframes"));
    }, this.name = t, this.id = "sc-keyframes-".concat(t), this.rules = n, cM(this, function() {
      throw Iv(12, String(r.name));
    });
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = CI), this.name + t.hash;
  }, e;
}(), pNe = function(e) {
  return e >= "A" && e <= "Z";
};
function l5(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var r = e[n];
    if (n === 1 && r === "-" && e[0] === "-")
      return e;
    pNe(r) ? t += "-" + r.toLowerCase() : t += r;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var Mq = function(e) {
  return e == null || e === !1 || e === "";
}, Nq = function(e) {
  var t, n, r = [];
  for (var i in e) {
    var o = e[i];
    e.hasOwnProperty(i) && !Mq(o) && (Array.isArray(o) && o.isCss || ih(o) ? r.push("".concat(l5(i), ":"), o, ";") : qg(o) ? r.push.apply(r, Zp(Zp(["".concat(i, " {")], Nq(o), !1), ["}"], !1)) : r.push("".concat(l5(i), ": ").concat((t = i, (n = o) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || t in DMe || t.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return r;
};
function xu(e, t, n, r) {
  if (Mq(e))
    return [];
  if (lM(e))
    return [".".concat(e.styledComponentId)];
  if (ih(e)) {
    if (!ih(o = e) || o.prototype && o.prototype.isReactComponent || !t)
      return [e];
    var i = e(t);
    return xu(i, t, n, r);
  }
  var o;
  return e instanceof Rq ? n ? (e.inject(n, r), [e.getName(r)]) : [e] : qg(e) ? Nq(e) : Array.isArray(e) ? Array.prototype.concat.apply(Gx, e.map(function(a) {
    return xu(a, t, n, r);
  })) : [e.toString()];
}
function kq(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (ih(n) && !lM(n))
      return !1;
  }
  return !0;
}
var hNe = Eq("6.0.7"), mNe = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = (r === void 0 || r.isStatic) && kq(t), this.componentId = n, this.baseHash = lp(hNe, n), this.baseStyle = r, Z1.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var i = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, n, r) : "";
    if (this.isStatic && !r.hash)
      if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId))
        i = Cf(i, this.staticRulesId);
      else {
        var o = Q1(xu(this.rules, t, n, r)), a = SI(lp(this.baseHash, o) >>> 0);
        if (!n.hasNameForId(this.componentId, a)) {
          var s = r(o, ".".concat(a), void 0, this.componentId);
          n.insertRules(this.componentId, a, s);
        }
        i = Cf(i, a), this.staticRulesId = a;
      }
    else {
      for (var l = lp(this.baseHash, r.hash), c = "", f = 0; f < this.rules.length; f++) {
        var d = this.rules[f];
        if (typeof d == "string")
          c += d;
        else if (d) {
          var p = Q1(xu(d, t, n, r));
          l = lp(l, p), c += p;
        }
      }
      if (c) {
        var g = SI(l >>> 0);
        n.hasNameForId(this.componentId, g) || n.insertRules(this.componentId, g, r(c, ".".concat(g), void 0, this.componentId)), i = Cf(i, g);
      }
    }
    return i;
  }, e;
}(), uM = oe.createContext(void 0);
uM.Consumer;
var O_ = {};
function gNe(e, t, n) {
  var r = lM(e), i = e, o = !$_(e), a = t.attrs, s = a === void 0 ? Gx : a, l = t.componentId, c = l === void 0 ? function(S, E) {
    var O = typeof S != "string" ? "sc" : n5(S);
    O_[O] = (O_[O] || 0) + 1;
    var $ = "".concat(O, "-").concat(sM("6.0.7" + O + O_[O]));
    return E ? "".concat(E, "-").concat($) : $;
  }(t.displayName, t.parentComponentId) : l, f = t.displayName;
  f === void 0 && function(S) {
    return $_(S) ? "styled.".concat(S) : "Styled(".concat(HMe(S), ")");
  }(e);
  var d = t.displayName && t.componentId ? "".concat(n5(t.displayName), "-").concat(t.componentId) : t.componentId || c, p = r && i.attrs ? i.attrs.concat(s).filter(Boolean) : s, g = t.shouldForwardProp;
  if (r && i.shouldForwardProp) {
    var v = i.shouldForwardProp;
    if (t.shouldForwardProp) {
      var y = t.shouldForwardProp;
      g = function(S, E) {
        return v(S, E) && y(S, E);
      };
    } else
      g = v;
  }
  var x = new mNe(n, d, r ? i.componentStyle : void 0);
  function b(S, E) {
    return function(O, $, P) {
      var R = O.attrs, L = O.componentStyle, B = O.defaultProps, j = O.foldedComponentIds, A = O.styledComponentId, T = O.target, k = oe.useContext(uM), F = EI(), W = O.shouldForwardProp || F.shouldForwardProp, V = function(U, he, re) {
        for (var de, we = fo(fo({}, he), { className: void 0, theme: re }), ue = 0; ue < U.length; ue += 1) {
          var me = ih(de = U[ue]) ? de(we) : de;
          for (var Se in me)
            we[Se] = Se === "className" ? Cf(we[Se], me[Se]) : Se === "style" ? fo(fo({}, we[Se]), me[Se]) : me[Se];
        }
        return he.className && (we.className = Cf(we.className, he.className)), we;
      }(R, $, xq($, k, B) || rh), G = V.as || T, X = {};
      for (var D in V)
        V[D] === void 0 || D[0] === "$" || D === "as" || D === "theme" || (D === "forwardedAs" ? X.as = V.forwardedAs : W && !W(D, G) || (X[D] = V[D]));
      var te = function(U, he) {
        var re = EI(), de = U.generateAndInjectStyles(he, re.styleSheet, re.stylis);
        return de;
      }(L, V), ee = Cf(j, A);
      return te && (ee += " " + te), V.className && (ee += " " + V.className), X[$_(G) && !Cq.has(G) ? "class" : "className"] = ee, X.ref = P, m.createElement(G, X);
    }(w, S, E);
  }
  var w = oe.forwardRef(b);
  return w.attrs = p, w.componentStyle = x, w.shouldForwardProp = g, w.foldedComponentIds = r ? Cf(i.foldedComponentIds, i.styledComponentId) : "", w.styledComponentId = d, w.target = r ? i.target : e, Object.defineProperty(w, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(S) {
    this._foldedDefaultProps = r ? function(E) {
      for (var O = [], $ = 1; $ < arguments.length; $++)
        O[$ - 1] = arguments[$];
      for (var P = 0, R = O; P < R.length; P++)
        xI(E, R[P], !0);
      return E;
    }({}, i.defaultProps, S) : S;
  } }), cM(w, function() {
    return ".".concat(w.styledComponentId);
  }), o && Pq(w, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), w;
}
function c5(e, t) {
  for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}
var u5 = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function fM(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  if (ih(e) || qg(e)) {
    var r = e;
    return u5(xu(c5(Gx, Zp([r], t, !0))));
  }
  var i = e;
  return t.length === 0 && i.length === 1 && typeof i[0] == "string" ? xu(i) : u5(xu(c5(i, t)));
}
function $I(e, t, n) {
  if (n === void 0 && (n = rh), !t)
    throw Iv(1, t);
  var r = function(i) {
    for (var o = [], a = 1; a < arguments.length; a++)
      o[a - 1] = arguments[a];
    return e(t, n, fM.apply(void 0, Zp([i], o, !1)));
  };
  return r.attrs = function(i) {
    return $I(e, t, fo(fo({}, n), { attrs: Array.prototype.concat(n.attrs, i).filter(Boolean) }));
  }, r.withConfig = function(i) {
    return $I(e, t, fo(fo({}, n), i));
  }, r;
}
var Lq = function(e) {
  return $I(gNe, e);
}, Ut = Lq;
Cq.forEach(function(e) {
  Ut[e] = Lq(e);
});
var vNe = function() {
  function e(t, n) {
    this.rules = t, this.componentId = n, this.isStatic = kq(t), Z1.registerId(this.componentId + 1);
  }
  return e.prototype.createStyles = function(t, n, r, i) {
    var o = i(Q1(xu(this.rules, n, r, i)), ""), a = this.componentId + t;
    r.insertRules(a, a, o);
  }, e.prototype.removeStyles = function(t, n) {
    n.clearRules(this.componentId + t);
  }, e.prototype.renderStyles = function(t, n, r, i) {
    t > 2 && Z1.registerId(this.componentId + t), this.removeStyles(t, r), this.createStyles(t, n, r, i);
  }, e;
}();
function Dq(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  var r = fM.apply(void 0, Zp([e], t, !1)), i = "sc-global-".concat(sM(JSON.stringify(r))), o = new vNe(r, i), a = function(l) {
    var c = EI(), f = oe.useContext(uM), d = oe.useRef(c.styleSheet.allocateGSInstance(i)).current;
    return c.styleSheet.server && s(d, l, c.styleSheet, f, c.stylis), oe.useLayoutEffect(function() {
      if (!c.styleSheet.server)
        return s(d, l, c.styleSheet, f, c.stylis), function() {
          return o.removeStyles(d, c.styleSheet);
        };
    }, [d, l, c.styleSheet, f, c.stylis]), null;
  };
  function s(l, c, f, d, p) {
    if (o.isStatic)
      o.renderStyles(l, FMe, f, p);
    else {
      var g = fo(fo({}, c), { theme: xq(c, d, a.defaultProps) });
      o.renderStyles(l, g, f, p);
    }
  }
  return oe.memo(a);
}
function jq(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  var r = Q1(fM.apply(void 0, Zp([e], t, !1))), i = sM(r);
  return new Rq(i, r);
}
var Ef = /* @__PURE__ */ ((e) => (e.Ongoing = "ongoing", e.Done = "done", e))(Ef || {});
const tr = "conversation", P_ = {
  conversation: {},
  messages: [],
  showAgentReplyingDots: !1,
  fetchingConversationStatus: !1,
  isUserSignUpIntentDetected: !1,
  isExpandingLastMessage: !1,
  welcomeMessages: [],
  userActionBox: {
    buttonText: "",
    value: "",
    content: ""
  },
  pendingMessages: [],
  currentStreamingMessage: void 0,
  doneStreamingMessageReplyIds: []
}, yNe = ["received", "sent"], T_ = 105, Ld = 20, sf = 8, I_ = 100, bNe = 264, Fq = 60, _I = 60;
var oc = /* @__PURE__ */ ((e) => (e.RECEIVED = "received", e.SENT = "sent", e))(oc || {});
const dM = (e) => e[tr].conversation, wNe = (e) => e[tr].conversation.id, rl = (e) => e[tr].messages, SNe = (e) => e[tr].showAgentReplyingDots, xNe = (e) => e[tr].fetchingConversationStatus, CNe = (e) => e[tr].isExpandingLastMessage, ENe = (e = {}) => {
  const t = Cl.isFeatureEnabled();
  return {
    GlobalStyles: Dq`
  ${t ? `
/* NOTE: Do not move body styles to webchat styles.less, to avoid global styles affect user's page */      
body {
  margin: 0;
  height: 100vh;
  overflow: hidden;
  font-family:
    'Helvetica Neue',
    'Open Sans',
    Roboto,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Arial,
    'Noto Sans',
    sans-serif,
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji';
}
/* Font face */
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueRoman.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueMedium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueBold.woff') format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueBold.woff') format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueHeavy.woff') format('woff');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}
  ` : ""}`
  };
}, $Ne = {
  "textgray-1": "#BDBDBD",
  "textgray-3": "#999999",
  "textgray-5": "#666666",
  "textgray-8": "#333333",
  "bordergray-1": "#F5F5F5",
  "bordergray-5": "#E8E8E8",
  "bordergray-8": "#DBDBDB"
}, _Ne = (e = {}) => {
  const { theme: t = $Ne } = e;
  return {
    components: {
      Button: {
        defaultColor: t["textgray-5"],
        defaultBorderColor: t["bordergray-8"]
      }
    }
  };
}, Kx = ({ webchatId: e, webChatType: t }) => {
  const r = "".split(",").map((o) => parseInt(o)), i = t === Jo.SiteCompanion;
  return Gf.isFeatureEnabled() && !!e && !0 && i;
};
function ONe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Bq = ONe;
function PNe() {
  this.__data__ = [], this.size = 0;
}
var TNe = PNe;
function INe(e, t) {
  return e === t || e !== e && t !== t;
}
var zq = INe, ANe = zq;
function RNe(e, t) {
  for (var n = e.length; n--; )
    if (ANe(e[n][0], t))
      return n;
  return -1;
}
var qx = RNe, MNe = qx, NNe = Array.prototype, kNe = NNe.splice;
function LNe(e) {
  var t = this.__data__, n = MNe(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : kNe.call(t, n, 1), --this.size, !0;
}
var DNe = LNe, jNe = qx;
function FNe(e) {
  var t = this.__data__, n = jNe(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var BNe = FNe, zNe = qx;
function UNe(e) {
  return zNe(this.__data__, e) > -1;
}
var HNe = UNe, WNe = qx;
function VNe(e, t) {
  var n = this.__data__, r = WNe(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var GNe = VNe, KNe = TNe, qNe = DNe, YNe = BNe, XNe = HNe, QNe = GNe;
function Oh(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Oh.prototype.clear = KNe;
Oh.prototype.delete = qNe;
Oh.prototype.get = YNe;
Oh.prototype.has = XNe;
Oh.prototype.set = QNe;
var Yx = Oh, JNe = Yx;
function ZNe() {
  this.__data__ = new JNe(), this.size = 0;
}
var eke = ZNe;
function tke(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var nke = tke;
function rke(e) {
  return this.__data__.get(e);
}
var ike = rke;
function oke(e) {
  return this.__data__.has(e);
}
var ake = oke, ske = typeof qa == "object" && qa && qa.Object === Object && qa, Uq = ske, lke = Uq, cke = typeof self == "object" && self && self.Object === Object && self, uke = lke || cke || Function("return this")(), jl = uke, fke = jl, dke = fke.Symbol, Av = dke, f5 = Av, Hq = Object.prototype, pke = Hq.hasOwnProperty, hke = Hq.toString, $m = f5 ? f5.toStringTag : void 0;
function mke(e) {
  var t = pke.call(e, $m), n = e[$m];
  try {
    e[$m] = void 0;
    var r = !0;
  } catch {
  }
  var i = hke.call(e);
  return r && (t ? e[$m] = n : delete e[$m]), i;
}
var gke = mke, vke = Object.prototype, yke = vke.toString;
function bke(e) {
  return yke.call(e);
}
var wke = bke, d5 = Av, Ske = gke, xke = wke, Cke = "[object Null]", Eke = "[object Undefined]", p5 = d5 ? d5.toStringTag : void 0;
function $ke(e) {
  return e == null ? e === void 0 ? Eke : Cke : p5 && p5 in Object(e) ? Ske(e) : xke(e);
}
var Ph = $ke;
function _ke(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Rv = _ke, Oke = Ph, Pke = Rv, Tke = "[object AsyncFunction]", Ike = "[object Function]", Ake = "[object GeneratorFunction]", Rke = "[object Proxy]";
function Mke(e) {
  if (!Pke(e))
    return !1;
  var t = Oke(e);
  return t == Ike || t == Ake || t == Tke || t == Rke;
}
var Wq = Mke, Nke = jl, kke = Nke["__core-js_shared__"], Lke = kke, A_ = Lke, h5 = function() {
  var e = /[^.]+$/.exec(A_ && A_.keys && A_.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Dke(e) {
  return !!h5 && h5 in e;
}
var jke = Dke, Fke = Function.prototype, Bke = Fke.toString;
function zke(e) {
  if (e != null) {
    try {
      return Bke.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Vq = zke, Uke = Wq, Hke = jke, Wke = Rv, Vke = Vq, Gke = /[\\^$.*+?()[\]{}|]/g, Kke = /^\[object .+?Constructor\]$/, qke = Function.prototype, Yke = Object.prototype, Xke = qke.toString, Qke = Yke.hasOwnProperty, Jke = RegExp(
  "^" + Xke.call(Qke).replace(Gke, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Zke(e) {
  if (!Wke(e) || Hke(e))
    return !1;
  var t = Uke(e) ? Jke : Kke;
  return t.test(Vke(e));
}
var eLe = Zke;
function tLe(e, t) {
  return e == null ? void 0 : e[t];
}
var nLe = tLe, rLe = eLe, iLe = nLe;
function oLe(e, t) {
  var n = iLe(e, t);
  return rLe(n) ? n : void 0;
}
var nd = oLe, aLe = nd, sLe = jl, lLe = aLe(sLe, "Map"), pM = lLe, cLe = nd, uLe = cLe(Object, "create"), Xx = uLe, m5 = Xx;
function fLe() {
  this.__data__ = m5 ? m5(null) : {}, this.size = 0;
}
var dLe = fLe;
function pLe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var hLe = pLe, mLe = Xx, gLe = "__lodash_hash_undefined__", vLe = Object.prototype, yLe = vLe.hasOwnProperty;
function bLe(e) {
  var t = this.__data__;
  if (mLe) {
    var n = t[e];
    return n === gLe ? void 0 : n;
  }
  return yLe.call(t, e) ? t[e] : void 0;
}
var wLe = bLe, SLe = Xx, xLe = Object.prototype, CLe = xLe.hasOwnProperty;
function ELe(e) {
  var t = this.__data__;
  return SLe ? t[e] !== void 0 : CLe.call(t, e);
}
var $Le = ELe, _Le = Xx, OLe = "__lodash_hash_undefined__";
function PLe(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = _Le && t === void 0 ? OLe : t, this;
}
var TLe = PLe, ILe = dLe, ALe = hLe, RLe = wLe, MLe = $Le, NLe = TLe;
function Th(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Th.prototype.clear = ILe;
Th.prototype.delete = ALe;
Th.prototype.get = RLe;
Th.prototype.has = MLe;
Th.prototype.set = NLe;
var kLe = Th, g5 = kLe, LLe = Yx, DLe = pM;
function jLe() {
  this.size = 0, this.__data__ = {
    hash: new g5(),
    map: new (DLe || LLe)(),
    string: new g5()
  };
}
var FLe = jLe;
function BLe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var zLe = BLe, ULe = zLe;
function HLe(e, t) {
  var n = e.__data__;
  return ULe(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Qx = HLe, WLe = Qx;
function VLe(e) {
  var t = WLe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var GLe = VLe, KLe = Qx;
function qLe(e) {
  return KLe(this, e).get(e);
}
var YLe = qLe, XLe = Qx;
function QLe(e) {
  return XLe(this, e).has(e);
}
var JLe = QLe, ZLe = Qx;
function e3e(e, t) {
  var n = ZLe(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var t3e = e3e, n3e = FLe, r3e = GLe, i3e = YLe, o3e = JLe, a3e = t3e;
function Ih(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ih.prototype.clear = n3e;
Ih.prototype.delete = r3e;
Ih.prototype.get = i3e;
Ih.prototype.has = o3e;
Ih.prototype.set = a3e;
var Gq = Ih, s3e = Yx, l3e = pM, c3e = Gq, u3e = 200;
function f3e(e, t) {
  var n = this.__data__;
  if (n instanceof s3e) {
    var r = n.__data__;
    if (!l3e || r.length < u3e - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new c3e(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var d3e = f3e, p3e = Yx, h3e = eke, m3e = nke, g3e = ike, v3e = ake, y3e = d3e;
function Ah(e) {
  var t = this.__data__ = new p3e(e);
  this.size = t.size;
}
Ah.prototype.clear = h3e;
Ah.prototype.delete = m3e;
Ah.prototype.get = g3e;
Ah.prototype.has = v3e;
Ah.prototype.set = y3e;
var b3e = Ah;
function w3e(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var S3e = w3e, x3e = nd, C3e = function() {
  try {
    var e = x3e(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Kq = C3e, v5 = Kq;
function E3e(e, t, n) {
  t == "__proto__" && v5 ? v5(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var qq = E3e, $3e = qq, _3e = zq, O3e = Object.prototype, P3e = O3e.hasOwnProperty;
function T3e(e, t, n) {
  var r = e[t];
  (!(P3e.call(e, t) && _3e(r, n)) || n === void 0 && !(t in e)) && $3e(e, t, n);
}
var Yq = T3e, I3e = Yq, A3e = qq;
function R3e(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], l = r ? r(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), i ? A3e(n, s, l) : I3e(n, s, l);
  }
  return n;
}
var Mv = R3e;
function M3e(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var N3e = M3e;
function k3e(e) {
  return e != null && typeof e == "object";
}
var rd = k3e, L3e = Ph, D3e = rd, j3e = "[object Arguments]";
function F3e(e) {
  return D3e(e) && L3e(e) == j3e;
}
var B3e = F3e, y5 = B3e, z3e = rd, Xq = Object.prototype, U3e = Xq.hasOwnProperty, H3e = Xq.propertyIsEnumerable, W3e = y5(/* @__PURE__ */ function() {
  return arguments;
}()) ? y5 : function(e) {
  return z3e(e) && U3e.call(e, "callee") && !H3e.call(e, "callee");
}, Qq = W3e, V3e = Array.isArray, ju = V3e;
const b5 = /* @__PURE__ */ Oi(ju);
var ew = { exports: {} };
function G3e() {
  return !1;
}
var K3e = G3e;
ew.exports;
(function(e, t) {
  var n = jl, r = K3e, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  e.exports = c;
})(ew, ew.exports);
var Jq = ew.exports, q3e = 9007199254740991, Y3e = /^(?:0|[1-9]\d*)$/;
function X3e(e, t) {
  var n = typeof e;
  return t = t ?? q3e, !!t && (n == "number" || n != "symbol" && Y3e.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Q3e = X3e, J3e = 9007199254740991;
function Z3e(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= J3e;
}
var Zq = Z3e, e4e = Ph, t4e = Zq, n4e = rd, r4e = "[object Arguments]", i4e = "[object Array]", o4e = "[object Boolean]", a4e = "[object Date]", s4e = "[object Error]", l4e = "[object Function]", c4e = "[object Map]", u4e = "[object Number]", f4e = "[object Object]", d4e = "[object RegExp]", p4e = "[object Set]", h4e = "[object String]", m4e = "[object WeakMap]", g4e = "[object ArrayBuffer]", v4e = "[object DataView]", y4e = "[object Float32Array]", b4e = "[object Float64Array]", w4e = "[object Int8Array]", S4e = "[object Int16Array]", x4e = "[object Int32Array]", C4e = "[object Uint8Array]", E4e = "[object Uint8ClampedArray]", $4e = "[object Uint16Array]", _4e = "[object Uint32Array]", yr = {};
yr[y4e] = yr[b4e] = yr[w4e] = yr[S4e] = yr[x4e] = yr[C4e] = yr[E4e] = yr[$4e] = yr[_4e] = !0;
yr[r4e] = yr[i4e] = yr[g4e] = yr[o4e] = yr[v4e] = yr[a4e] = yr[s4e] = yr[l4e] = yr[c4e] = yr[u4e] = yr[f4e] = yr[d4e] = yr[p4e] = yr[h4e] = yr[m4e] = !1;
function O4e(e) {
  return n4e(e) && t4e(e.length) && !!yr[e4e(e)];
}
var P4e = O4e;
function T4e(e) {
  return function(t) {
    return e(t);
  };
}
var hM = T4e, tw = { exports: {} };
tw.exports;
(function(e, t) {
  var n = Uq, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(tw, tw.exports);
var mM = tw.exports, I4e = P4e, A4e = hM, w5 = mM, S5 = w5 && w5.isTypedArray, R4e = S5 ? A4e(S5) : I4e, M4e = R4e, N4e = N3e, k4e = Qq, L4e = ju, D4e = Jq, j4e = Q3e, F4e = M4e, B4e = Object.prototype, z4e = B4e.hasOwnProperty;
function U4e(e, t) {
  var n = L4e(e), r = !n && k4e(e), i = !n && !r && D4e(e), o = !n && !r && !i && F4e(e), a = n || r || i || o, s = a ? N4e(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || z4e.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    j4e(c, l))) && s.push(c);
  return s;
}
var eY = U4e, H4e = Object.prototype;
function W4e(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || H4e;
  return e === n;
}
var gM = W4e;
function V4e(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var tY = V4e, G4e = tY, K4e = G4e(Object.keys, Object), q4e = K4e, Y4e = gM, X4e = q4e, Q4e = Object.prototype, J4e = Q4e.hasOwnProperty;
function Z4e(e) {
  if (!Y4e(e))
    return X4e(e);
  var t = [];
  for (var n in Object(e))
    J4e.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var eDe = Z4e, tDe = Wq, nDe = Zq;
function rDe(e) {
  return e != null && nDe(e.length) && !tDe(e);
}
var nY = rDe, iDe = eY, oDe = eDe, aDe = nY;
function sDe(e) {
  return aDe(e) ? iDe(e) : oDe(e);
}
var vM = sDe, lDe = Mv, cDe = vM;
function uDe(e, t) {
  return e && lDe(t, cDe(t), e);
}
var fDe = uDe;
function dDe(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var pDe = dDe, hDe = Rv, mDe = gM, gDe = pDe, vDe = Object.prototype, yDe = vDe.hasOwnProperty;
function bDe(e) {
  if (!hDe(e))
    return gDe(e);
  var t = mDe(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !yDe.call(e, r)) || n.push(r);
  return n;
}
var wDe = bDe, SDe = eY, xDe = wDe, CDe = nY;
function EDe(e) {
  return CDe(e) ? SDe(e, !0) : xDe(e);
}
var yM = EDe, $De = Mv, _De = yM;
function ODe(e, t) {
  return e && $De(t, _De(t), e);
}
var PDe = ODe, nw = { exports: {} };
nw.exports;
(function(e, t) {
  var n = jl, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function l(c, f) {
    if (f)
      return c.slice();
    var d = c.length, p = s ? s(d) : new c.constructor(d);
    return c.copy(p), p;
  }
  e.exports = l;
})(nw, nw.exports);
var TDe = nw.exports;
function IDe(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var ADe = IDe;
function RDe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
var MDe = RDe;
function NDe() {
  return [];
}
var rY = NDe, kDe = MDe, LDe = rY, DDe = Object.prototype, jDe = DDe.propertyIsEnumerable, x5 = Object.getOwnPropertySymbols, FDe = x5 ? function(e) {
  return e == null ? [] : (e = Object(e), kDe(x5(e), function(t) {
    return jDe.call(e, t);
  }));
} : LDe, bM = FDe, BDe = Mv, zDe = bM;
function UDe(e, t) {
  return BDe(e, zDe(e), t);
}
var HDe = UDe;
function WDe(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var wM = WDe, VDe = tY, GDe = VDe(Object.getPrototypeOf, Object), SM = GDe, KDe = wM, qDe = SM, YDe = bM, XDe = rY, QDe = Object.getOwnPropertySymbols, JDe = QDe ? function(e) {
  for (var t = []; e; )
    KDe(t, YDe(e)), e = qDe(e);
  return t;
} : XDe, iY = JDe, ZDe = Mv, eje = iY;
function tje(e, t) {
  return ZDe(e, eje(e), t);
}
var nje = tje, rje = wM, ije = ju;
function oje(e, t, n) {
  var r = t(e);
  return ije(e) ? r : rje(r, n(e));
}
var oY = oje, aje = oY, sje = bM, lje = vM;
function cje(e) {
  return aje(e, lje, sje);
}
var uje = cje, fje = oY, dje = iY, pje = yM;
function hje(e) {
  return fje(e, pje, dje);
}
var aY = hje, mje = nd, gje = jl, vje = mje(gje, "DataView"), yje = vje, bje = nd, wje = jl, Sje = bje(wje, "Promise"), xje = Sje, Cje = nd, Eje = jl, $je = Cje(Eje, "Set"), _je = $je, Oje = nd, Pje = jl, Tje = Oje(Pje, "WeakMap"), Ije = Tje, OI = yje, PI = pM, TI = xje, II = _je, AI = Ije, sY = Ph, Rh = Vq, C5 = "[object Map]", Aje = "[object Object]", E5 = "[object Promise]", $5 = "[object Set]", _5 = "[object WeakMap]", O5 = "[object DataView]", Rje = Rh(OI), Mje = Rh(PI), Nje = Rh(TI), kje = Rh(II), Lje = Rh(AI), lf = sY;
(OI && lf(new OI(new ArrayBuffer(1))) != O5 || PI && lf(new PI()) != C5 || TI && lf(TI.resolve()) != E5 || II && lf(new II()) != $5 || AI && lf(new AI()) != _5) && (lf = function(e) {
  var t = sY(e), n = t == Aje ? e.constructor : void 0, r = n ? Rh(n) : "";
  if (r)
    switch (r) {
      case Rje:
        return O5;
      case Mje:
        return C5;
      case Nje:
        return E5;
      case kje:
        return $5;
      case Lje:
        return _5;
    }
  return t;
});
var xM = lf, Dje = Object.prototype, jje = Dje.hasOwnProperty;
function Fje(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && jje.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Bje = Fje, zje = jl, Uje = zje.Uint8Array, Hje = Uje, P5 = Hje;
function Wje(e) {
  var t = new e.constructor(e.byteLength);
  return new P5(t).set(new P5(e)), t;
}
var CM = Wje, Vje = CM;
function Gje(e, t) {
  var n = t ? Vje(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Kje = Gje, qje = /\w*$/;
function Yje(e) {
  var t = new e.constructor(e.source, qje.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Xje = Yje, T5 = Av, I5 = T5 ? T5.prototype : void 0, A5 = I5 ? I5.valueOf : void 0;
function Qje(e) {
  return A5 ? Object(A5.call(e)) : {};
}
var Jje = Qje, Zje = CM;
function e6e(e, t) {
  var n = t ? Zje(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var t6e = e6e, n6e = CM, r6e = Kje, i6e = Xje, o6e = Jje, a6e = t6e, s6e = "[object Boolean]", l6e = "[object Date]", c6e = "[object Map]", u6e = "[object Number]", f6e = "[object RegExp]", d6e = "[object Set]", p6e = "[object String]", h6e = "[object Symbol]", m6e = "[object ArrayBuffer]", g6e = "[object DataView]", v6e = "[object Float32Array]", y6e = "[object Float64Array]", b6e = "[object Int8Array]", w6e = "[object Int16Array]", S6e = "[object Int32Array]", x6e = "[object Uint8Array]", C6e = "[object Uint8ClampedArray]", E6e = "[object Uint16Array]", $6e = "[object Uint32Array]";
function _6e(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case m6e:
      return n6e(e);
    case s6e:
    case l6e:
      return new r(+e);
    case g6e:
      return r6e(e, n);
    case v6e:
    case y6e:
    case b6e:
    case w6e:
    case S6e:
    case x6e:
    case C6e:
    case E6e:
    case $6e:
      return a6e(e, n);
    case c6e:
      return new r();
    case u6e:
    case p6e:
      return new r(e);
    case f6e:
      return i6e(e);
    case d6e:
      return new r();
    case h6e:
      return o6e(e);
  }
}
var O6e = _6e, P6e = Rv, R5 = Object.create, T6e = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!P6e(t))
      return {};
    if (R5)
      return R5(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), I6e = T6e, A6e = I6e, R6e = SM, M6e = gM;
function N6e(e) {
  return typeof e.constructor == "function" && !M6e(e) ? A6e(R6e(e)) : {};
}
var k6e = N6e, L6e = xM, D6e = rd, j6e = "[object Map]";
function F6e(e) {
  return D6e(e) && L6e(e) == j6e;
}
var B6e = F6e, z6e = B6e, U6e = hM, M5 = mM, N5 = M5 && M5.isMap, H6e = N5 ? U6e(N5) : z6e, W6e = H6e, V6e = xM, G6e = rd, K6e = "[object Set]";
function q6e(e) {
  return G6e(e) && V6e(e) == K6e;
}
var Y6e = q6e, X6e = Y6e, Q6e = hM, k5 = mM, L5 = k5 && k5.isSet, J6e = L5 ? Q6e(L5) : X6e, Z6e = J6e, e5e = b3e, t5e = S3e, n5e = Yq, r5e = fDe, i5e = PDe, o5e = TDe, a5e = ADe, s5e = HDe, l5e = nje, c5e = uje, u5e = aY, f5e = xM, d5e = Bje, p5e = O6e, h5e = k6e, m5e = ju, g5e = Jq, v5e = W6e, y5e = Rv, b5e = Z6e, w5e = vM, S5e = yM, x5e = 1, C5e = 2, E5e = 4, lY = "[object Arguments]", $5e = "[object Array]", _5e = "[object Boolean]", O5e = "[object Date]", P5e = "[object Error]", cY = "[object Function]", T5e = "[object GeneratorFunction]", I5e = "[object Map]", A5e = "[object Number]", uY = "[object Object]", R5e = "[object RegExp]", M5e = "[object Set]", N5e = "[object String]", k5e = "[object Symbol]", L5e = "[object WeakMap]", D5e = "[object ArrayBuffer]", j5e = "[object DataView]", F5e = "[object Float32Array]", B5e = "[object Float64Array]", z5e = "[object Int8Array]", U5e = "[object Int16Array]", H5e = "[object Int32Array]", W5e = "[object Uint8Array]", V5e = "[object Uint8ClampedArray]", G5e = "[object Uint16Array]", K5e = "[object Uint32Array]", sr = {};
sr[lY] = sr[$5e] = sr[D5e] = sr[j5e] = sr[_5e] = sr[O5e] = sr[F5e] = sr[B5e] = sr[z5e] = sr[U5e] = sr[H5e] = sr[I5e] = sr[A5e] = sr[uY] = sr[R5e] = sr[M5e] = sr[N5e] = sr[k5e] = sr[W5e] = sr[V5e] = sr[G5e] = sr[K5e] = !0;
sr[P5e] = sr[cY] = sr[L5e] = !1;
function Ib(e, t, n, r, i, o) {
  var a, s = t & x5e, l = t & C5e, c = t & E5e;
  if (n && (a = i ? n(e, r, i, o) : n(e)), a !== void 0)
    return a;
  if (!y5e(e))
    return e;
  var f = m5e(e);
  if (f) {
    if (a = d5e(e), !s)
      return a5e(e, a);
  } else {
    var d = f5e(e), p = d == cY || d == T5e;
    if (g5e(e))
      return o5e(e, s);
    if (d == uY || d == lY || p && !i) {
      if (a = l || p ? {} : h5e(e), !s)
        return l ? l5e(e, i5e(a, e)) : s5e(e, r5e(a, e));
    } else {
      if (!sr[d])
        return i ? e : {};
      a = p5e(e, d, s);
    }
  }
  o || (o = new e5e());
  var g = o.get(e);
  if (g)
    return g;
  o.set(e, a), b5e(e) ? e.forEach(function(x) {
    a.add(Ib(x, t, n, x, e, o));
  }) : v5e(e) && e.forEach(function(x, b) {
    a.set(b, Ib(x, t, n, b, e, o));
  });
  var v = c ? l ? u5e : c5e : l ? S5e : w5e, y = f ? void 0 : v(e);
  return t5e(y || e, function(x, b) {
    y && (b = x, x = e[b]), n5e(a, b, Ib(x, t, n, b, e, o));
  }), a;
}
var q5e = Ib, Y5e = Ph, X5e = rd, Q5e = "[object Symbol]";
function J5e(e) {
  return typeof e == "symbol" || X5e(e) && Y5e(e) == Q5e;
}
var EM = J5e, Z5e = ju, eFe = EM, tFe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, nFe = /^\w*$/;
function rFe(e, t) {
  if (Z5e(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || eFe(e) ? !0 : nFe.test(e) || !tFe.test(e) || t != null && e in Object(t);
}
var iFe = rFe, fY = Gq, oFe = "Expected a function";
function $M(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(oFe);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new ($M.Cache || fY)(), n;
}
$M.Cache = fY;
var aFe = $M, sFe = aFe, lFe = 500;
function cFe(e) {
  var t = sFe(e, function(r) {
    return n.size === lFe && n.clear(), r;
  }), n = t.cache;
  return t;
}
var uFe = cFe, fFe = uFe, dFe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, pFe = /\\(\\)?/g, hFe = fFe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(dFe, function(n, r, i, o) {
    t.push(i ? o.replace(pFe, "$1") : r || n);
  }), t;
}), mFe = hFe, D5 = Av, gFe = Bq, vFe = ju, yFe = EM, bFe = 1 / 0, j5 = D5 ? D5.prototype : void 0, F5 = j5 ? j5.toString : void 0;
function dY(e) {
  if (typeof e == "string")
    return e;
  if (vFe(e))
    return gFe(e, dY) + "";
  if (yFe(e))
    return F5 ? F5.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -bFe ? "-0" : t;
}
var wFe = dY, SFe = wFe;
function xFe(e) {
  return e == null ? "" : SFe(e);
}
var CFe = xFe, EFe = ju, $Fe = iFe, _Fe = mFe, OFe = CFe;
function PFe(e, t) {
  return EFe(e) ? e : $Fe(e, t) ? [e] : _Fe(OFe(e));
}
var _M = PFe;
function TFe(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var IFe = TFe, AFe = EM, RFe = 1 / 0;
function MFe(e) {
  if (typeof e == "string" || AFe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -RFe ? "-0" : t;
}
var pY = MFe, NFe = _M, kFe = pY;
function LFe(e, t) {
  t = NFe(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[kFe(t[n++])];
  return n && n == r ? e : void 0;
}
var DFe = LFe;
function jFe(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var FFe = jFe, BFe = DFe, zFe = FFe;
function UFe(e, t) {
  return t.length < 2 ? e : BFe(e, zFe(t, 0, -1));
}
var HFe = UFe, WFe = _M, VFe = IFe, GFe = HFe, KFe = pY;
function qFe(e, t) {
  return t = WFe(t, e), e = GFe(e, t), e == null || delete e[KFe(VFe(t))];
}
var YFe = qFe, XFe = Ph, QFe = SM, JFe = rd, ZFe = "[object Object]", eBe = Function.prototype, tBe = Object.prototype, hY = eBe.toString, nBe = tBe.hasOwnProperty, rBe = hY.call(Object);
function iBe(e) {
  if (!JFe(e) || XFe(e) != ZFe)
    return !1;
  var t = QFe(e);
  if (t === null)
    return !0;
  var n = nBe.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && hY.call(n) == rBe;
}
var oBe = iBe, aBe = oBe;
function sBe(e) {
  return aBe(e) ? void 0 : e;
}
var lBe = sBe, B5 = Av, cBe = Qq, uBe = ju, z5 = B5 ? B5.isConcatSpreadable : void 0;
function fBe(e) {
  return uBe(e) || cBe(e) || !!(z5 && e && e[z5]);
}
var dBe = fBe, pBe = wM, hBe = dBe;
function mY(e, t, n, r, i) {
  var o = -1, a = e.length;
  for (n || (n = hBe), i || (i = []); ++o < a; ) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? mY(s, t - 1, n, r, i) : pBe(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var mBe = mY, gBe = mBe;
function vBe(e) {
  var t = e == null ? 0 : e.length;
  return t ? gBe(e, 1) : [];
}
var yBe = vBe;
function bBe(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var wBe = bBe, SBe = wBe, U5 = Math.max;
function xBe(e, t, n) {
  return t = U5(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = U5(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), SBe(e, this, s);
  };
}
var CBe = xBe;
function EBe(e) {
  return function() {
    return e;
  };
}
var $Be = EBe;
function _Be(e) {
  return e;
}
var OBe = _Be, PBe = $Be, H5 = Kq, TBe = OBe, IBe = H5 ? function(e, t) {
  return H5(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: PBe(t),
    writable: !0
  });
} : TBe, ABe = IBe, RBe = 800, MBe = 16, NBe = Date.now;
function kBe(e) {
  var t = 0, n = 0;
  return function() {
    var r = NBe(), i = MBe - (r - n);
    if (n = r, i > 0) {
      if (++t >= RBe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var LBe = kBe, DBe = ABe, jBe = LBe, FBe = jBe(DBe), BBe = FBe, zBe = yBe, UBe = CBe, HBe = BBe;
function WBe(e) {
  return HBe(UBe(e, void 0, zBe), e + "");
}
var VBe = WBe, GBe = Bq, KBe = q5e, qBe = YFe, YBe = _M, XBe = Mv, QBe = lBe, JBe = VBe, ZBe = aY, e8e = 1, t8e = 2, n8e = 4, r8e = JBe(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = GBe(t, function(o) {
    return o = YBe(o, e), r || (r = o.length > 1), o;
  }), XBe(e, ZBe(e), n), r && (n = KBe(n, e8e | t8e | n8e, QBe));
  for (var i = t.length; i--; )
    qBe(n, t[i]);
  return n;
}), i8e = r8e;
const R_ = /* @__PURE__ */ Oi(i8e), { create: o8e, get: gY, send: a8e, sendV2: s8e, reset: l8e, clear: c8e, getUserActionBoxInfo: u8e } = ms(), f8e = Nu(`${tr}/resetConversation`, async () => {
  try {
    const e = await l8e();
    return e ? e.storeToSlice() : null;
  } catch (e) {
    rt.error("[Webchat info]", e.message);
  }
}), vY = Nu(
  `${tr}/createConversation`,
  async ({ webchatId: e }) => (await o8e(e, {})).storeToSlice()
), oh = Nu(
  `${tr}/getConversation`,
  async ({
    campaignId: e,
    conversationId: t,
    traceId: n
  }, { dispatch: r, getState: i }) => {
    try {
      const o = i(), { pendingMessages: a } = o[tr], { type: s } = o[ln], c = (await gY(e, t, n)).storeToSlice();
      return a.length > 0 && (setTimeout(() => {
        const f = a[0];
        r(y8e(a.slice(1))), r(Mh(f));
      }), setTimeout(() => {
        r(Qs(!0));
      }, 2e3)), { ...c, _webChatType: s };
    } catch (o) {
      rt.error("[Webchat info]", o.message);
    }
  }
), d8e = Nu(
  `${tr}/receivedMessage`,
  async ({
    campaignId: e,
    conversationId: t,
    traceId: n
  }) => {
    try {
      return (await gY(e, t, n)).storeToSlice();
    } catch (r) {
      rt.error("[Webchat info]", r.message);
    }
  }
), Mh = Nu(
  `${tr}/sendMessage`,
  async (e, t) => {
    try {
      const { webchatId: n, content: r, contentType: i } = e, o = t.getState(), { type: a } = o[ln], s = {
        message: r,
        contentType: i,
        meta: {}
      }, l = {
        content: r,
        stream: !0
      };
      if (Kx({
        webchatId: n,
        webChatType: a
      }))
        await s8e(n, l);
      else
        return (await a8e(n, s)).storeToSlice();
    } catch (n) {
      rt.error("[Webchat info]", n.message);
    }
  }
), p8e = Nu(
  `${tr}/sendPendingMessage`,
  async (e, { dispatch: t, getState: n }) => {
    var r;
    try {
      const o = n()[tr], { messages: a } = o;
      ((r = yt.last(a)) == null ? void 0 : r.type) === fi.SENT ? (t(Mh(e)), setTimeout(() => {
        t(Qs(!0));
      })) : t(b8e(e));
    } catch (i) {
      rt.error("[Webchat info]", i.message);
    }
  }
), yY = Nu(
  `${tr}/getUserActionBoxInfo`,
  async ({ conversationId: e }) => {
    try {
      return await u8e({ conversationId: e });
    } catch (t) {
      rt.error("[Webchat getUserActionBox]", t.message);
    }
  }
), Qs = Po(
  `${tr}/showAgentReplyingDots`
), gs = Iw({
  name: tr,
  initialState: P_,
  reducers: {
    clearMessage: (e) => {
      e.messages = [];
    },
    clearConversation: (e) => {
      c8e(), e.conversation = {}, e.messages = [];
    },
    clearUserActionBox: (e) => {
      const t = P_.userActionBox;
      e.userActionBox = {
        ...t
      };
    },
    appendUserMessage: (e, t) => {
      e.messages = [
        ...e.messages,
        {
          content: t.payload.content,
          content_meta: null,
          id: `${Date.now()}`,
          conversation_id: e.conversation.id,
          type: fi.RECEIVED,
          created_at: (/* @__PURE__ */ new Date()).toJSON(),
          updated_at: (/* @__PURE__ */ new Date()).toJSON()
        }
      ];
    },
    addWelcomeMsg: (e, t) => {
      e.messages = [
        {
          content: t.payload.content,
          content_meta: null,
          id: `${Date.now()}`,
          conversation_id: t.payload.conversationId,
          type: fi.SENT,
          created_at: (/* @__PURE__ */ new Date()).toJSON(),
          updated_at: (/* @__PURE__ */ new Date()).toJSON()
        }
      ];
    },
    addStartQuestionMsg: (e, t) => {
      e.messages = [
        ...e.messages,
        {
          content: t.payload.content,
          content_meta: null,
          id: `${Date.now()}`,
          conversation_id: e.conversation.trace_id,
          type: fi.RECEIVED,
          created_at: (/* @__PURE__ */ new Date()).toJSON(),
          updated_at: (/* @__PURE__ */ new Date()).toJSON()
        }
      ];
    },
    updatePendingMessages: (e, t) => {
      e.pendingMessages = t.payload;
    },
    addPendingMessages: (e, t) => {
      e.pendingMessages = [...e.pendingMessages, t.payload], e.messages = [
        ...e.messages,
        {
          content: t.payload.content,
          content_meta: null,
          id: `${Date.now()}`,
          conversation_id: e.conversation.trace_id,
          type: fi.RECEIVED,
          created_at: (/* @__PURE__ */ new Date()).toJSON(),
          updated_at: (/* @__PURE__ */ new Date()).toJSON()
        }
      ];
    },
    initIsUserSignUpIntentDetected: (e) => {
      e.isUserSignUpIntentDetected = P_.isUserSignUpIntentDetected;
    },
    updateExpandingLastMessage: (e, t) => {
      e.isExpandingLastMessage = t.payload;
    }
  },
  extraReducers: (e) => {
    e.addCase(_v.fulfilled, (t, n) => {
      const { webchatSettings: r } = n.payload;
      t.welcomeMessages = r.display.welcomeMsg ?? [];
    }), e.addCase(f8e.fulfilled, (t, n) => {
      t.conversation = R_(n.payload, "messages"), t.messages = [];
    }), e.addCase(vY.fulfilled, (t, n) => {
      t.conversation = R_(n.payload, "messages"), t.messages = [];
    }), e.addCase(oh.pending, (t, n) => {
      t.fetchingConversationStatus = !0, t.messages.length === 1 && (t.messages = [
        {
          content: t.welcomeMessages[0] ?? "",
          content_meta: null,
          id: `${Date.now()}`,
          conversation_id: `${n.meta.arg.conversationId}`,
          type: fi.SENT,
          created_at: (/* @__PURE__ */ new Date()).toJSON(),
          updated_at: (/* @__PURE__ */ new Date()).toJSON()
        }
      ]);
    }), e.addCase(oh.fulfilled, (t, n) => {
      var l;
      const r = n.payload, i = (r == null ? void 0 : r.messages) ?? [], o = i[0], a = Kx({
        webchatId: r == null ? void 0 : r.source_id,
        webChatType: r == null ? void 0 : r._webChatType
      });
      t.fetchingConversationStatus = !1, t.conversation = R_(r, "messages"), t.currentStreamingMessage = void 0, Ix.isFeatureEnabled() && (t.isUserSignUpIntentDetected = ((l = r == null ? void 0 : r.user_action_box) == null ? void 0 : l.is_display) || !1), a && (t.isUserSignUpIntentDetected = i.length > 1);
      const s = {
        content: t.welcomeMessages[0] ?? "",
        content_meta: null,
        id: `${Date.now()}`,
        conversation_id: `${n.meta.arg.conversationId}`,
        type: fi.SENT,
        created_at: (/* @__PURE__ */ new Date()).toJSON(),
        updated_at: (/* @__PURE__ */ new Date()).toJSON()
      };
      (o == null ? void 0 : o.type) === fi.SENT ? t.messages = [...i] : t.messages = [s, ...i];
    }), e.addCase(d8e.fulfilled, (t, n) => {
      var i;
      const r = yt.last((i = n.payload) == null ? void 0 : i.messages);
      (r == null ? void 0 : r.type) === fi.SENT && (t.messages = [
        ...t.messages,
        {
          ...r,
          // append newest message when received message from API
          id: `${Date.now()}`,
          content_meta: null,
          conversation_id: String(r == null ? void 0 : r.conversation_id),
          type: r.type,
          created_at: (/* @__PURE__ */ new Date()).toJSON(),
          updated_at: (/* @__PURE__ */ new Date()).toJSON()
        }
      ]);
    }), e.addCase(yY.fulfilled, (t, n) => {
      var r, i, o;
      t.userActionBox = {
        buttonText: ((r = n.payload) == null ? void 0 : r.buttonText) || "",
        value: ((i = n.payload) == null ? void 0 : i.value) || "",
        content: ((o = n.payload) == null ? void 0 : o.content) || ""
      };
    }), e.addCase(Mh.pending, (t, n) => {
      const r = n.meta.arg, { content: i, conversationId: o } = r;
      t.currentStreamingMessage = void 0, t.messages = [
        ...t.messages,
        {
          content: i,
          content_meta: null,
          id: `${Date.now()}`,
          conversation_id: String(o),
          type: fi.RECEIVED,
          created_at: (/* @__PURE__ */ new Date()).toJSON(),
          updated_at: (/* @__PURE__ */ new Date()).toJSON()
        }
      ];
    }), e.addCase(Qs, (t, n) => {
      t.showAgentReplyingDots = n.payload;
    }), e.addCase(ep, (t, n) => {
      n.payload.status || (t.showAgentReplyingDots = !1);
    }), e.addCase(CU, (t, n) => {
      const r = n.payload;
      t.doneStreamingMessageReplyIds = t.doneStreamingMessageReplyIds.concat(
        r.reply_id
      ), t.currentStreamingMessage = void 0;
      const i = yt.last(t.messages);
      (i == null ? void 0 : i.streaming_message_status) === Ef.Ongoing && (t.messages = [
        ...t.messages.slice(0, -1),
        {
          ...i,
          streaming_message_status: Ef.Done
        }
      ]);
    }), e.addCase(Aw, (t) => {
      t.currentStreamingMessage = {
        ...t.currentStreamingMessage,
        replied: !0
      };
    }), e.addCase(dR, (t, n) => {
      const r = n.payload;
      t.currentStreamingMessage = {
        ...t.currentStreamingMessage,
        done: !0,
        replyId: r.reply_id,
        channelName: r.channel_name
      };
    }), e.addCase(xU, (t, n) => {
      var o;
      const r = yt.last(t.messages), i = n.payload;
      if (!t.doneStreamingMessageReplyIds.includes(i.reply_id)) {
        if ((r == null ? void 0 : r.streaming_message_status) === Ef.Ongoing && r.reply_id === i.reply_id) {
          const a = (((o = t.currentStreamingMessage) == null ? void 0 : o.unsortedStreamingMessages) ?? []).concat(i), s = a.sort((l, c) => l.index - c.index).map((l) => l.char).join("");
          t.currentStreamingMessage = {
            ...t.currentStreamingMessage,
            unsortedStreamingMessages: a
          }, t.messages = [
            ...t.messages.slice(0, -1),
            {
              ...r,
              content: s
            }
          ];
          return;
        }
        (r == null ? void 0 : r.type) !== fi.SENT && (t.currentStreamingMessage = {
          ...t.currentStreamingMessage,
          unsortedStreamingMessages: [i]
        }, t.messages = [
          ...t.messages,
          {
            // append newest message when received message from API
            id: `${Date.now()}`,
            content: i.char,
            content_meta: null,
            conversation_id: `${t.conversation.id}`,
            type: fi.SENT,
            created_at: (/* @__PURE__ */ new Date()).toJSON(),
            updated_at: (/* @__PURE__ */ new Date()).toJSON(),
            streaming_message_status: Ef.Ongoing,
            reply_id: i.reply_id
          }
        ]);
      }
    });
  }
}), rw = gs.actions.clearMessage, h8e = gs.actions.addWelcomeMsg, iw = gs.actions.clearConversation, m8e = gs.actions.addStartQuestionMsg, g8e = gs.actions.appendUserMessage, v8e = gs.actions.clearUserActionBox, y8e = gs.actions.updatePendingMessages, b8e = gs.actions.addPendingMessages, W5 = gs.actions.updateExpandingLastMessage, w8e = gs.actions.initIsUserSignUpIntentDetected;
function qf(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function S8e(e, t) {
  vo(2, arguments);
  var n = ls(e).getTime(), r = qf(t);
  return new Date(n + r);
}
var x8e = {};
function Jx() {
  return x8e;
}
function C8e(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function E8e(e) {
  return vo(1, arguments), e instanceof Date || nn(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function $8e(e) {
  if (vo(1, arguments), !E8e(e) && typeof e != "number")
    return !1;
  var t = ls(e);
  return !isNaN(Number(t));
}
function _8e(e, t) {
  vo(2, arguments);
  var n = qf(t);
  return S8e(e, -n);
}
var O8e = 864e5;
function P8e(e) {
  vo(1, arguments);
  var t = ls(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), i = n - r;
  return Math.floor(i / O8e) + 1;
}
function ow(e) {
  vo(1, arguments);
  var t = 1, n = ls(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function bY(e) {
  vo(1, arguments);
  var t = ls(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = ow(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var a = ow(o);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function T8e(e) {
  vo(1, arguments);
  var t = bY(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = ow(n);
  return r;
}
var I8e = 6048e5;
function A8e(e) {
  vo(1, arguments);
  var t = ls(e), n = ow(t).getTime() - T8e(t).getTime();
  return Math.round(n / I8e) + 1;
}
function aw(e, t) {
  var n, r, i, o, a, s, l, c;
  vo(1, arguments);
  var f = Jx(), d = qf((n = (r = (i = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = ls(e), g = p.getUTCDay(), v = (g < d ? 7 : 0) + g - d;
  return p.setUTCDate(p.getUTCDate() - v), p.setUTCHours(0, 0, 0, 0), p;
}
function wY(e, t) {
  var n, r, i, o, a, s, l, c;
  vo(1, arguments);
  var f = ls(e), d = f.getUTCFullYear(), p = Jx(), g = qf((n = (r = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = p.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(d + 1, 0, g), v.setUTCHours(0, 0, 0, 0);
  var y = aw(v, t), x = /* @__PURE__ */ new Date(0);
  x.setUTCFullYear(d, 0, g), x.setUTCHours(0, 0, 0, 0);
  var b = aw(x, t);
  return f.getTime() >= y.getTime() ? d + 1 : f.getTime() >= b.getTime() ? d : d - 1;
}
function R8e(e, t) {
  var n, r, i, o, a, s, l, c;
  vo(1, arguments);
  var f = Jx(), d = qf((n = (r = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = wY(e, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(p, 0, d), g.setUTCHours(0, 0, 0, 0);
  var v = aw(g, t);
  return v;
}
var M8e = 6048e5;
function N8e(e, t) {
  vo(1, arguments);
  var n = ls(e), r = aw(n, t).getTime() - R8e(n, t).getTime();
  return Math.round(r / M8e) + 1;
}
function Dn(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var k8e = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return Dn(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : Dn(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return Dn(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return Dn(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return Dn(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return Dn(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return Dn(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, i = t.getUTCMilliseconds(), o = Math.floor(i * Math.pow(10, r - 3));
    return Dn(o, n.length);
  }
};
const Fc = k8e;
var Dd = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, L8e = {
  // Era
  G: function(t, n, r) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var i = t.getUTCFullYear(), o = i > 0 ? i : 1 - i;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return Fc.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, i) {
    var o = wY(t, i), a = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var s = a % 100;
      return Dn(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : Dn(a, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = bY(t);
    return Dn(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return Dn(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return Dn(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return Dn(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Fc.M(t, n);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return Dn(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, i) {
    var o = N8e(t, i);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : Dn(o, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var i = A8e(t);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : Dn(i, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Fc.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var i = P8e(t);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : Dn(i, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var i = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, i) {
    var o = t.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return Dn(a, 2);
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, i) {
    var o = t.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return Dn(a, n.length);
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var i = t.getUTCDay(), o = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return Dn(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var i = t.getUTCHours(), o = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var i = t.getUTCHours(), o;
    switch (i === 12 ? o = Dd.noon : i === 0 ? o = Dd.midnight : o = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var i = t.getUTCHours(), o;
    switch (i >= 17 ? o = Dd.evening : i >= 12 ? o = Dd.afternoon : i >= 4 ? o = Dd.morning : o = Dd.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Fc.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Fc.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var i = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : Dn(i, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : Dn(i, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Fc.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Fc.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Fc.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return G5(a);
      case "XXXX":
      case "XX":
        return cf(a);
      case "XXXXX":
      case "XXX":
      default:
        return cf(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return G5(a);
      case "xxxx":
      case "xx":
        return cf(a);
      case "xxxxx":
      case "xxx":
      default:
        return cf(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + V5(a, ":");
      case "OOOO":
      default:
        return "GMT" + cf(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + V5(a, ":");
      case "zzzz":
      default:
        return "GMT" + cf(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, i) {
    var o = i._originalDate || t, a = Math.floor(o.getTime() / 1e3);
    return Dn(a, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTime();
    return Dn(a, n.length);
  }
};
function V5(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(i);
  var a = t || "";
  return n + String(i) + a + Dn(o, 2);
}
function G5(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Dn(Math.abs(e) / 60, 2);
  }
  return cf(e, t);
}
function cf(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), o = Dn(Math.floor(i / 60), 2), a = Dn(i % 60, 2);
  return r + o + n + a;
}
const D8e = L8e;
var K5 = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, SY = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, j8e = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], i = r[1], o = r[2];
  if (!o)
    return K5(t, n);
  var a;
  switch (i) {
    case "P":
      a = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = n.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", K5(i, n)).replace("{{time}}", SY(o, n));
}, F8e = {
  p: SY,
  P: j8e
};
const B8e = F8e;
var z8e = ["D", "DD"], U8e = ["YY", "YYYY"];
function H8e(e) {
  return z8e.indexOf(e) !== -1;
}
function W8e(e) {
  return U8e.indexOf(e) !== -1;
}
function q5(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var V8e = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, G8e = function(t, n, r) {
  var i, o = V8e[t];
  return typeof o == "string" ? i = o : n === 1 ? i = o.one : i = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
const K8e = G8e;
function M_(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var q8e = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Y8e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, X8e = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Q8e = {
  date: M_({
    formats: q8e,
    defaultWidth: "full"
  }),
  time: M_({
    formats: Y8e,
    defaultWidth: "full"
  }),
  dateTime: M_({
    formats: X8e,
    defaultWidth: "full"
  })
};
const J8e = Q8e;
var Z8e = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, eze = function(t, n, r, i) {
  return Z8e[t];
};
const tze = eze;
function _m(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : o;
      i = e.formattingValues[a] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[l] || e.values[s];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[c];
  };
}
var nze = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, rze = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ize = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, oze = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, aze = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, sze = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, lze = function(t, n) {
  var r = Number(t), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, cze = {
  ordinalNumber: lze,
  era: _m({
    values: nze,
    defaultWidth: "wide"
  }),
  quarter: _m({
    values: rze,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: _m({
    values: ize,
    defaultWidth: "wide"
  }),
  day: _m({
    values: oze,
    defaultWidth: "wide"
  }),
  dayPeriod: _m({
    values: aze,
    defaultWidth: "wide",
    formattingValues: sze,
    defaultFormattingWidth: "wide"
  })
};
const uze = cze;
function Om(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    var a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? dze(s, function(d) {
      return d.test(a);
    }) : fze(s, function(d) {
      return d.test(a);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var f = t.slice(a.length);
    return {
      value: c,
      rest: f
    };
  };
}
function fze(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function dze(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function pze(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var i = r[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = t.slice(i.length);
    return {
      value: a,
      rest: s
    };
  };
}
var hze = /^(\d+)(th|st|nd|rd)?/i, mze = /\d+/i, gze = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, vze = {
  any: [/^b/i, /^(a|c)/i]
}, yze = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bze = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wze = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Sze = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, xze = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Cze = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Eze = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $ze = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, _ze = {
  ordinalNumber: pze({
    matchPattern: hze,
    parsePattern: mze,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Om({
    matchPatterns: gze,
    defaultMatchWidth: "wide",
    parsePatterns: vze,
    defaultParseWidth: "any"
  }),
  quarter: Om({
    matchPatterns: yze,
    defaultMatchWidth: "wide",
    parsePatterns: bze,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Om({
    matchPatterns: wze,
    defaultMatchWidth: "wide",
    parsePatterns: Sze,
    defaultParseWidth: "any"
  }),
  day: Om({
    matchPatterns: xze,
    defaultMatchWidth: "wide",
    parsePatterns: Cze,
    defaultParseWidth: "any"
  }),
  dayPeriod: Om({
    matchPatterns: Eze,
    defaultMatchWidth: "any",
    parsePatterns: $ze,
    defaultParseWidth: "any"
  })
};
const Oze = _ze;
var Pze = {
  code: "en-US",
  formatDistance: K8e,
  formatLong: J8e,
  formatRelative: tze,
  localize: uze,
  match: Oze,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Tze = Pze;
var Ize = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Aze = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Rze = /^'([^]*?)'?$/, Mze = /''/g, Nze = /[a-zA-Z]/;
function Zx(e, t, n) {
  var r, i, o, a, s, l, c, f, d, p, g, v, y, x, b, w, S, E;
  vo(2, arguments);
  var O = String(t), $ = Jx(), P = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : $.locale) !== null && r !== void 0 ? r : Tze, R = qf((o = (a = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && s !== void 0 ? s : $.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = $.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(R >= 1 && R <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var L = qf((g = (v = (y = (x = n == null ? void 0 : n.weekStartsOn) !== null && x !== void 0 ? x : n == null || (b = n.locale) === null || b === void 0 || (w = b.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && y !== void 0 ? y : $.weekStartsOn) !== null && v !== void 0 ? v : (S = $.locale) === null || S === void 0 || (E = S.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(L >= 0 && L <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!P.localize)
    throw new RangeError("locale must contain localize property");
  if (!P.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var B = ls(e);
  if (!$8e(B))
    throw new RangeError("Invalid time value");
  var j = C8e(B), A = _8e(B, j), T = {
    firstWeekContainsDate: R,
    weekStartsOn: L,
    locale: P,
    _originalDate: B
  }, k = O.match(Aze).map(function(F) {
    var W = F[0];
    if (W === "p" || W === "P") {
      var V = B8e[W];
      return V(F, P.formatLong);
    }
    return F;
  }).join("").match(Ize).map(function(F) {
    if (F === "''")
      return "'";
    var W = F[0];
    if (W === "'")
      return kze(F);
    var V = D8e[W];
    if (V)
      return !(n != null && n.useAdditionalWeekYearTokens) && W8e(F) && q5(F, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && H8e(F) && q5(F, t, String(e)), V(A, F, P.localize, T);
    if (W.match(Nze))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + W + "`");
    return F;
  }).join("");
  return k;
}
function kze(e) {
  var t = e.match(Rze);
  return t ? t[1].replace(Mze, "'") : e;
}
const Lze = (e) => {
  const { groupedMessages: t, messageContainerRef: n, webchatId: r } = e, i = pe(rl), { themeStyle: o } = Kf(), { isSameDay: a } = Fv({ themeStyle: o });
  return t.map((s, l) => /* @__PURE__ */ H.jsxs("div", { children: [
    i.length > 7 && a(s.date, /* @__PURE__ */ new Date()) && /* @__PURE__ */ H.jsx("div", { className: "date-divider", children: /* @__PURE__ */ H.jsxs("label", { children: [
      "Today",
      /* @__PURE__ */ H.jsx("div", { className: "mask" })
    ] }) }),
    !a(s.date, /* @__PURE__ */ new Date()) && /* @__PURE__ */ H.jsx("div", { className: "date-divider", children: /* @__PURE__ */ H.jsxs("label", { children: [
      Zx(new Date(s.date), "EEE', ' MMM d "),
      /* @__PURE__ */ H.jsx("div", { className: "mask" })
    ] }) }),
    s.messages.map((c, f) => {
      const d = l === t.length - 1 && f === s.messages.length - 1, p = i.findIndex((g) => g.id === c.id);
      return /* @__PURE__ */ H.jsx(
        Mqe,
        {
          webchatId: r,
          isFirstMessage: l === 0 && f === 0,
          isLastMessage: d,
          messageContainerRef: d ? n : void 0,
          prevMessageData: i.length > 0 ? i[p - 1] : void 0,
          ...c
        },
        c.id
      );
    })
  ] }, `${s.date}`));
}, Y5 = Ut(mOe)`
  overflow-x: hidden;

  .ant-skeleton-element {
    width: 100%;
  }

  .ant-space-item {
    flex-grow: 1;
  }
`, Dze = () => {
  const e = pe($c), t = Ec || e, n = t ? bNe : "unset";
  return /* @__PURE__ */ H.jsx(
    "div",
    {
      style: {
        width: "100%",
        border: "1px solid #DBDBDB",
        borderRadius: "4px 16px 16px 16px",
        background: "#FFFFFF",
        padding: "16px",
        overflowX: "hidden",
        minHeight: "calc(100dvh - 195px)"
      },
      children: /* @__PURE__ */ H.jsxs(TOe, { gap: "middle", vertical: !0, children: [
        /* @__PURE__ */ H.jsx(Bo.Input, { active: !0, style: { width: T_, borderRadius: Ld } }),
        /* @__PURE__ */ H.jsxs(Y5, { size: "middle", children: [
          /* @__PURE__ */ H.jsx(
            Bo.Input,
            {
              active: !0,
              style: {
                minWidth: n,
                width: "100%",
                height: I_,
                borderRadius: sf
              }
            }
          ),
          /* @__PURE__ */ H.jsx(
            Bo.Input,
            {
              active: !0,
              style: {
                minWidth: n,
                width: "100%",
                height: I_,
                borderRadius: sf
              }
            }
          ),
          /* @__PURE__ */ H.jsx(
            Bo.Input,
            {
              active: !0,
              style: {
                minWidth: n,
                width: "100%",
                height: I_,
                borderRadius: sf
              }
            }
          )
        ] }),
        /* @__PURE__ */ H.jsx(Bo.Input, { active: !0, style: { minWidth: T_, borderRadius: Ld } }),
        /* @__PURE__ */ H.jsx(Bo.Input, { active: !0, block: !0, style: { borderRadius: Ld } }),
        /* @__PURE__ */ H.jsx(Bo.Input, { active: !0, block: !0, style: { borderRadius: Ld } }),
        /* @__PURE__ */ H.jsx(Bo.Input, { active: !0, block: !0, style: { borderRadius: Ld } }),
        /* @__PURE__ */ H.jsx(Bo.Input, { active: !0, style: { minWidth: T_, borderRadius: Ld } }),
        t ? /* @__PURE__ */ H.jsx(oe.Fragment, { children: Array(6).fill(null).map((r, i) => /* @__PURE__ */ H.jsx(
          Bo.Input,
          {
            active: !0,
            block: !0,
            style: {
              borderRadius: sf,
              width: "100%",
              height: Fq
            }
          },
          i
        )) }) : /* @__PURE__ */ H.jsx(oe.Fragment, { children: Array(3).fill(null).map((r, i) => /* @__PURE__ */ H.jsxs(Y5, { size: "middle", children: [
          /* @__PURE__ */ H.jsx(
            Bo.Input,
            {
              active: !0,
              style: {
                width: "100%",
                height: _I,
                borderRadius: sf
              }
            }
          ),
          /* @__PURE__ */ H.jsx(
            Bo.Input,
            {
              active: !0,
              style: {
                width: "100%",
                height: _I,
                borderRadius: sf
              }
            }
          )
        ] }, i)) })
      ] })
    }
  );
}, jze = Ut.div`
  position: sticky;
  bottom: 0;

  .loader {
    width: 40px;
    margin: 6px 0px;
    aspect-ratio: 4;
    background: radial-gradient(circle closest-side, ${(e) => e.$styles.dotsColor} 90%, #0000)
      0 / calc(100% / 3) 100% space;
    clip-path: inset(0 100% 0 0);
    animation: l1 1s steps(4) infinite;
  }

  .message-wrapper {
    min-height: 41px;

    .message-body {
      min-width: initial;
    }
  }

  @keyframes l1 {
    to {
      clip-path: inset(0 -34% 0 0);
    }
  }
`, Fze = Ut.div`
  background: ${(e) => e.$styles.background} !important;
  color: ${(e) => e.$styles.color};
  padding: ${(e) => e.$styles.padding} !important;
  ${(e) => e.$styles.border ? `border: ${e.$styles.border};` : ""};
`, Bze = (e) => {
  const { showDotByRandomTime: t, overMaxResponseTime: n } = e, r = pe(Zf), i = oc.SENT, { bodyStyles: o, loadingStyles: a, showAvatar: s } = lC({ type: i });
  return /* @__PURE__ */ H.jsx(jze, { $styles: a, children: /* @__PURE__ */ H.jsxs("div", { className: `message-wrapper ${i} loading`, children: [
    s && /* @__PURE__ */ H.jsx(
      "div",
      {
        style: {
          display: "inline-block",
          verticalAlign: "top",
          width: "45px",
          paddingRight: "15px"
        },
        children: /* @__PURE__ */ H.jsx(
          "img",
          {
            className: "ant-avatar",
            src: `${r.avatar}`,
            alt: "icon",
            style: { width: "30px", height: "30px", objectFit: "cover" }
          }
        )
      }
    ),
    /* @__PURE__ */ H.jsx(
      "div",
      {
        style: {
          display: "inline-block",
          verticalAlign: "top",
          width: r.avatar ? "calc(100% - 45px)" : "100%"
        },
        children: t && !n && /* @__PURE__ */ H.jsx(Fze, { className: "shadow-sm message-body", $styles: o, children: /* @__PURE__ */ H.jsx(
          "p",
          {
            style: {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "pre-wrap"
            },
            children: /* @__PURE__ */ H.jsx("div", { className: "loader" })
          }
        ) })
      }
    )
  ] }) });
}, zze = Ut.div`
  background: linear-gradient(90deg, #2bc055, #74cef4, #5e81ff, #74cef4, #2bc055);
  background-size: 200% 100%;
  background-position: 0% 0%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; /* for Firefox */
  color: transparent;
  animation: rainbow-move 2s linear infinite;
  min-height: calc(100dvh - 195px);

  @keyframes rainbow-move {
    from {
      background-position: 0% 0%;
    }
    to {
      background-position: -200% 0%;
    }
  }
`, Uze = () => {
  const e = [
    "Searching across knowledge sources...",
    "Fetching the latest data for you...",
    "Looking into our database...",
    "Gathering relevant insights...",
    "Analyzing your request..."
  ], [t, n] = m.useState(e[0]), r = (o) => {
    if (n(e[o]), o + 1 < e.length) {
      const a = 2500 + Math.random() * 1e3;
      setTimeout(() => {
        r(o + 1);
      }, a);
    }
  }, i = () => {
    r(0);
  };
  return m.useEffect(() => {
    i();
  }, []), /* @__PURE__ */ H.jsx(zze, { children: t });
}, Hze = (e) => {
  const {
    showMessages: t,
    isShowJumpingDots: n,
    isSiteCompanionWebChat: r,
    showDotByRandomTime: i,
    overMaxResponseTime: o
  } = e, a = Vf.isFeatureEnabled(), s = NIe.isFeatureEnabled();
  return t && n && r && s ? /* @__PURE__ */ H.jsx(Uze, {}) : t && n && r && a && !s ? /* @__PURE__ */ H.jsx(Dze, {}) : t && n ? /* @__PURE__ */ H.jsx(
    Bze,
    {
      showDotByRandomTime: i,
      overMaxResponseTime: o
    }
  ) : null;
};
class X5 {
  constructor(t) {
    this.name = t.name, this.avatar = t.avatar;
  }
}
class Wze {
  constructor(t) {
    this.type = t.type, this.title = t.title, this.url = t.url, this.sourceName = t.source_name, this.avatar = t.source_icon, this.writers = (t.writers ?? []).map((n) => new X5(n)), this.experts = (t.experts ?? []).map((n) => new X5(n));
  }
}
const Vze = () => {
  var f;
  const e = wr(), t = pe(lq), n = pe(dM), r = pe(rl), i = ((f = yt.last(r)) == null ? void 0 : f.type) === fi.SENT, o = pe(SNe) && !i, [a, s] = m.useState(!1), [l, c] = m.useState(!1);
  return m.useEffect(() => {
    let d;
    return o ? (setTimeout(() => {
      s(!0);
    }, 1e3), rt.debug("[sync timer] auto sync timer start"), c(!1), d = setTimeout(() => {
      rt.debug("[sync timer] auto sync"), e(
        oh({
          campaignId: t,
          conversationId: n.id,
          traceId: n.trace_id
        })
      );
    }, 18e3)) : s(!1), () => {
      d && (rt.debug("[sync timer] auto sync end"), clearTimeout(d), d = null), s(!1);
    };
  }, [o]), m.useEffect(() => {
    let d;
    return !l && !d && (o ? (rt.debug("[limit timer] response limit timer start"), d = setTimeout(() => {
      rt.debug("[limit timer] over limit response time"), c(!0);
    }, 9e4)) : c(!1)), () => {
      (d || l) && (rt.debug("[limit timer] clear response limit timer"), clearTimeout(d), d = null);
    };
  }, [l]), {
    showDotByRandomTime: a,
    isShowJumpingDots: o,
    overMaxResponseTime: l
  };
}, Gze = () => {
  var E, O;
  const { current: e } = ms(), t = wr(), n = pe(rl), r = pe(Tv), i = pe(nl), {
    userActionBoxInfo: o,
    isUserCloseActionBox: a,
    isUserSignUpIntentDetected: s,
    isShownUserActionBox: l
  } = pe(sq), [c, f] = m.useState(""), d = e(), p = d == null ? void 0 : d.id, g = d == null ? void 0 : d.uuid, v = ((E = yt.last(n)) == null ? void 0 : E.type) === fi.SENT, y = ((O = i == null ? void 0 : i.userActionBox) == null ? void 0 : O.display) ?? !1, x = l && y, b = ($) => {
    g && (v ? w($) : (f($), t(
      g8e({
        content: $,
        conversationId: g
      })
    )));
  }, w = ($) => {
    const P = {
      domain: window.location.hostname,
      incoming_message_url: window.location.href
    };
    t(Qs(!0)), t(
      Mh({
        webchatId: r,
        content: $,
        publisher: P,
        contentType: $u.CallToAction
        // TODO: API not yet ready
      })
    ), f("");
  }, S = () => {
    p && t(yY({ conversationId: p }));
  };
  return m.useEffect(() => {
    v && c && w(c);
  }, [v, c]), {
    showUserActionBox: x,
    userActionBoxInfo: o,
    isUserCloseActionBox: a,
    isUserSignUpIntentDetected: s,
    getUserActionBoxInfo: S,
    sendUserActionBoxMessage: b
  };
}, Kze = (e) => {
  const { containerRef: t, messageContainerRef: n, messages: r, loading: i } = e, o = wr(), a = pe(Nl), { scrollToLastMessage: s, wasBottom: l } = cU(t, n);
  return m.useEffect(() => {
    l && o(iq());
  }, [l, o]), m.useEffect(() => {
    a && setTimeout(() => {
      s({ behavior: "instant" });
    });
  }, [a, s]), m.useEffect(() => {
    !i || !Gf.isFeatureEnabled() || setTimeout(() => {
      s();
    });
  }, [i, r.length, s]), m.useEffect(() => {
    if (i || !Gf.isFeatureEnabled()) {
      o(W5(!1));
      return;
    }
    setTimeout(() => {
      o(W5(!0));
    }), setTimeout(() => {
      s();
    }, 200);
  }, [i, s, o]), null;
};
var RI = { exports: {} }, MI = { exports: {} }, xY = { exports: {} }, qze = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Yze = qze, Xze = Yze;
function CY() {
}
function EY() {
}
EY.resetWarningCache = CY;
var Qze = function() {
  function e(r, i, o, a, s, l) {
    if (l !== Xze) {
      var c = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw c.name = "Invariant Violation", c;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: EY,
    resetWarningCache: CY
  };
  return n.PropTypes = n, n;
};
xY.exports = Qze();
var $Y = xY.exports;
const cu = /* @__PURE__ */ Oi($Y);
/*!
 * perfect-scrollbar v1.5.6
 * Copyright 2024 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
function $l(e) {
  return getComputedStyle(e);
}
function Wo(e, t) {
  for (var n in t) {
    var r = t[n];
    typeof r == "number" && (r = r + "px"), e.style[n] = r;
  }
  return e;
}
function k0(e) {
  var t = document.createElement("div");
  return t.className = e, t;
}
var Q5 = typeof Element < "u" && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function uu(e, t) {
  if (!Q5)
    throw new Error("No element matching method supported");
  return Q5.call(e, t);
}
function cp(e) {
  e.remove ? e.remove() : e.parentNode && e.parentNode.removeChild(e);
}
function J5(e, t) {
  return Array.prototype.filter.call(
    e.children,
    function(n) {
      return uu(n, t);
    }
  );
}
var Zr = {
  main: "ps",
  rtl: "ps__rtl",
  element: {
    thumb: function(e) {
      return "ps__thumb-" + e;
    },
    rail: function(e) {
      return "ps__rail-" + e;
    },
    consuming: "ps__child--consume"
  },
  state: {
    focus: "ps--focus",
    clicking: "ps--clicking",
    active: function(e) {
      return "ps--active-" + e;
    },
    scrolling: function(e) {
      return "ps--scrolling-" + e;
    }
  }
}, _Y = { x: null, y: null };
function OY(e, t) {
  var n = e.element.classList, r = Zr.state.scrolling(t);
  n.contains(r) ? clearTimeout(_Y[t]) : n.add(r);
}
function PY(e, t) {
  _Y[t] = setTimeout(
    function() {
      return e.isAlive && e.element.classList.remove(Zr.state.scrolling(t));
    },
    e.settings.scrollingThreshold
  );
}
function Jze(e, t) {
  OY(e, t), PY(e, t);
}
var Nv = function(t) {
  this.element = t, this.handlers = {};
}, TY = { isEmpty: { configurable: !0 } };
Nv.prototype.bind = function(t, n) {
  typeof this.handlers[t] > "u" && (this.handlers[t] = []), this.handlers[t].push(n), this.element.addEventListener(t, n, !1);
};
Nv.prototype.unbind = function(t, n) {
  var r = this;
  this.handlers[t] = this.handlers[t].filter(function(i) {
    return n && i !== n ? !0 : (r.element.removeEventListener(t, i, !1), !1);
  });
};
Nv.prototype.unbindAll = function() {
  for (var t in this.handlers)
    this.unbind(t);
};
TY.isEmpty.get = function() {
  var e = this;
  return Object.keys(this.handlers).every(
    function(t) {
      return e.handlers[t].length === 0;
    }
  );
};
Object.defineProperties(Nv.prototype, TY);
var Nh = function() {
  this.eventElements = [];
};
Nh.prototype.eventElement = function(t) {
  var n = this.eventElements.filter(function(r) {
    return r.element === t;
  })[0];
  return n || (n = new Nv(t), this.eventElements.push(n)), n;
};
Nh.prototype.bind = function(t, n, r) {
  this.eventElement(t).bind(n, r);
};
Nh.prototype.unbind = function(t, n, r) {
  var i = this.eventElement(t);
  i.unbind(n, r), i.isEmpty && this.eventElements.splice(this.eventElements.indexOf(i), 1);
};
Nh.prototype.unbindAll = function() {
  this.eventElements.forEach(function(t) {
    return t.unbindAll();
  }), this.eventElements = [];
};
Nh.prototype.once = function(t, n, r) {
  var i = this.eventElement(t), o = function(a) {
    i.unbind(n, o), r(a);
  };
  i.bind(n, o);
};
function L0(e) {
  if (typeof window.CustomEvent == "function")
    return new CustomEvent(e);
  var t = document.createEvent("CustomEvent");
  return t.initCustomEvent(e, !1, !1, void 0), t;
}
function sw(e, t, n, r, i) {
  r === void 0 && (r = !0), i === void 0 && (i = !1);
  var o;
  if (t === "top")
    o = ["contentHeight", "containerHeight", "scrollTop", "y", "up", "down"];
  else if (t === "left")
    o = ["contentWidth", "containerWidth", "scrollLeft", "x", "left", "right"];
  else
    throw new Error("A proper axis should be provided");
  Zze(e, n, o, r, i);
}
function Zze(e, t, n, r, i) {
  var o = n[0], a = n[1], s = n[2], l = n[3], c = n[4], f = n[5];
  r === void 0 && (r = !0), i === void 0 && (i = !1);
  var d = e.element;
  e.reach[l] = null, d[s] < 1 && (e.reach[l] = "start"), d[s] > e[o] - e[a] - 1 && (e.reach[l] = "end"), t && (d.dispatchEvent(L0("ps-scroll-" + l)), t < 0 ? d.dispatchEvent(L0("ps-scroll-" + c)) : t > 0 && d.dispatchEvent(L0("ps-scroll-" + f)), r && Jze(e, l)), e.reach[l] && (t || i) && d.dispatchEvent(L0("ps-" + l + "-reach-" + e.reach[l]));
}
function Tr(e) {
  return parseInt(e, 10) || 0;
}
function eUe(e) {
  return uu(e, "input,[contenteditable]") || uu(e, "select,[contenteditable]") || uu(e, "textarea,[contenteditable]") || uu(e, "button,[contenteditable]");
}
function tUe(e) {
  var t = $l(e);
  return Tr(t.width) + Tr(t.paddingLeft) + Tr(t.paddingRight) + Tr(t.borderLeftWidth) + Tr(t.borderRightWidth);
}
var zd = {
  isWebKit: typeof document < "u" && "WebkitAppearance" in document.documentElement.style,
  supportsTouch: typeof window < "u" && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof navigator < "u" && navigator.msMaxTouchPoints,
  isChrome: typeof navigator < "u" && /Chrome/i.test(navigator && navigator.userAgent)
};
function bc(e) {
  var t = e.element, n = Math.floor(t.scrollTop), r = t.getBoundingClientRect();
  e.containerWidth = Math.floor(r.width), e.containerHeight = Math.floor(r.height), e.contentWidth = t.scrollWidth, e.contentHeight = t.scrollHeight, t.contains(e.scrollbarXRail) || (J5(t, Zr.element.rail("x")).forEach(function(i) {
    return cp(i);
  }), t.appendChild(e.scrollbarXRail)), t.contains(e.scrollbarYRail) || (J5(t, Zr.element.rail("y")).forEach(function(i) {
    return cp(i);
  }), t.appendChild(e.scrollbarYRail)), !e.settings.suppressScrollX && e.containerWidth + e.settings.scrollXMarginOffset < e.contentWidth ? (e.scrollbarXActive = !0, e.railXWidth = e.containerWidth - e.railXMarginWidth, e.railXRatio = e.containerWidth / e.railXWidth, e.scrollbarXWidth = Z5(e, Tr(e.railXWidth * e.containerWidth / e.contentWidth)), e.scrollbarXLeft = Tr(
    (e.negativeScrollAdjustment + t.scrollLeft) * (e.railXWidth - e.scrollbarXWidth) / (e.contentWidth - e.containerWidth)
  )) : e.scrollbarXActive = !1, !e.settings.suppressScrollY && e.containerHeight + e.settings.scrollYMarginOffset < e.contentHeight ? (e.scrollbarYActive = !0, e.railYHeight = e.containerHeight - e.railYMarginHeight, e.railYRatio = e.containerHeight / e.railYHeight, e.scrollbarYHeight = Z5(
    e,
    Tr(e.railYHeight * e.containerHeight / e.contentHeight)
  ), e.scrollbarYTop = Tr(
    n * (e.railYHeight - e.scrollbarYHeight) / (e.contentHeight - e.containerHeight)
  )) : e.scrollbarYActive = !1, e.scrollbarXLeft >= e.railXWidth - e.scrollbarXWidth && (e.scrollbarXLeft = e.railXWidth - e.scrollbarXWidth), e.scrollbarYTop >= e.railYHeight - e.scrollbarYHeight && (e.scrollbarYTop = e.railYHeight - e.scrollbarYHeight), nUe(t, e), e.scrollbarXActive ? t.classList.add(Zr.state.active("x")) : (t.classList.remove(Zr.state.active("x")), e.scrollbarXWidth = 0, e.scrollbarXLeft = 0, t.scrollLeft = e.isRtl === !0 ? e.contentWidth : 0), e.scrollbarYActive ? t.classList.add(Zr.state.active("y")) : (t.classList.remove(Zr.state.active("y")), e.scrollbarYHeight = 0, e.scrollbarYTop = 0, t.scrollTop = 0);
}
function Z5(e, t) {
  return e.settings.minScrollbarLength && (t = Math.max(t, e.settings.minScrollbarLength)), e.settings.maxScrollbarLength && (t = Math.min(t, e.settings.maxScrollbarLength)), t;
}
function nUe(e, t) {
  var n = { width: t.railXWidth }, r = Math.floor(e.scrollTop);
  t.isRtl ? n.left = t.negativeScrollAdjustment + e.scrollLeft + t.containerWidth - t.contentWidth : n.left = e.scrollLeft, t.isScrollbarXUsingBottom ? n.bottom = t.scrollbarXBottom - r : n.top = t.scrollbarXTop + r, Wo(t.scrollbarXRail, n);
  var i = { top: r, height: t.railYHeight };
  t.isScrollbarYUsingRight ? t.isRtl ? i.right = t.contentWidth - (t.negativeScrollAdjustment + e.scrollLeft) - t.scrollbarYRight - t.scrollbarYOuterWidth - 9 : i.right = t.scrollbarYRight - e.scrollLeft : t.isRtl ? i.left = t.negativeScrollAdjustment + e.scrollLeft + t.containerWidth * 2 - t.contentWidth - t.scrollbarYLeft - t.scrollbarYOuterWidth : i.left = t.scrollbarYLeft + e.scrollLeft, Wo(t.scrollbarYRail, i), Wo(t.scrollbarX, {
    left: t.scrollbarXLeft,
    width: t.scrollbarXWidth - t.railBorderXWidth
  }), Wo(t.scrollbarY, {
    top: t.scrollbarYTop,
    height: t.scrollbarYHeight - t.railBorderYWidth
  });
}
function rUe(e) {
  e.event.bind(e.scrollbarY, "mousedown", function(t) {
    return t.stopPropagation();
  }), e.event.bind(e.scrollbarYRail, "mousedown", function(t) {
    var n = t.pageY - window.pageYOffset - e.scrollbarYRail.getBoundingClientRect().top, r = n > e.scrollbarYTop ? 1 : -1;
    e.element.scrollTop += r * e.containerHeight, bc(e), t.stopPropagation();
  }), e.event.bind(e.scrollbarX, "mousedown", function(t) {
    return t.stopPropagation();
  }), e.event.bind(e.scrollbarXRail, "mousedown", function(t) {
    var n = t.pageX - window.pageXOffset - e.scrollbarXRail.getBoundingClientRect().left, r = n > e.scrollbarXLeft ? 1 : -1;
    e.element.scrollLeft += r * e.containerWidth, bc(e), t.stopPropagation();
  });
}
var D0 = null;
function iUe(e) {
  eF(e, [
    "containerHeight",
    "contentHeight",
    "pageY",
    "railYHeight",
    "scrollbarY",
    "scrollbarYHeight",
    "scrollTop",
    "y",
    "scrollbarYRail"
  ]), eF(e, [
    "containerWidth",
    "contentWidth",
    "pageX",
    "railXWidth",
    "scrollbarX",
    "scrollbarXWidth",
    "scrollLeft",
    "x",
    "scrollbarXRail"
  ]);
}
function eF(e, t) {
  var n = t[0], r = t[1], i = t[2], o = t[3], a = t[4], s = t[5], l = t[6], c = t[7], f = t[8], d = e.element, p = null, g = null, v = null;
  function y(w) {
    w.touches && w.touches[0] && (w[i] = w.touches[0]["page" + c.toUpperCase()]), D0 === a && (d[l] = p + v * (w[i] - g), OY(e, c), bc(e), w.stopPropagation(), w.preventDefault());
  }
  function x() {
    PY(e, c), e[f].classList.remove(Zr.state.clicking), document.removeEventListener("mousemove", y), document.removeEventListener("mouseup", x), document.removeEventListener("touchmove", y), document.removeEventListener("touchend", x), D0 = null;
  }
  function b(w) {
    D0 === null && (D0 = a, p = d[l], w.touches && (w[i] = w.touches[0]["page" + c.toUpperCase()]), g = w[i], v = (e[r] - e[n]) / (e[o] - e[s]), w.touches ? (document.addEventListener("touchmove", y, { passive: !1 }), document.addEventListener("touchend", x)) : (document.addEventListener("mousemove", y), document.addEventListener("mouseup", x)), e[f].classList.add(Zr.state.clicking)), w.stopPropagation(), w.cancelable && w.preventDefault();
  }
  e[a].addEventListener("mousedown", b), e[a].addEventListener("touchstart", b);
}
function oUe(e) {
  var t = e.element, n = function() {
    return uu(t, ":hover");
  }, r = function() {
    return uu(e.scrollbarX, ":focus") || uu(e.scrollbarY, ":focus");
  };
  function i(o, a) {
    var s = Math.floor(t.scrollTop);
    if (o === 0) {
      if (!e.scrollbarYActive)
        return !1;
      if (s === 0 && a > 0 || s >= e.contentHeight - e.containerHeight && a < 0)
        return !e.settings.wheelPropagation;
    }
    var l = t.scrollLeft;
    if (a === 0) {
      if (!e.scrollbarXActive)
        return !1;
      if (l === 0 && o < 0 || l >= e.contentWidth - e.containerWidth && o > 0)
        return !e.settings.wheelPropagation;
    }
    return !0;
  }
  e.event.bind(e.ownerDocument, "keydown", function(o) {
    if (!(o.isDefaultPrevented && o.isDefaultPrevented() || o.defaultPrevented) && !(!n() && !r())) {
      var a = document.activeElement ? document.activeElement : e.ownerDocument.activeElement;
      if (a) {
        if (a.tagName === "IFRAME")
          a = a.contentDocument.activeElement;
        else
          for (; a.shadowRoot; )
            a = a.shadowRoot.activeElement;
        if (eUe(a))
          return;
      }
      var s = 0, l = 0;
      switch (o.which) {
        case 37:
          o.metaKey ? s = -e.contentWidth : o.altKey ? s = -e.containerWidth : s = -30;
          break;
        case 38:
          o.metaKey ? l = e.contentHeight : o.altKey ? l = e.containerHeight : l = 30;
          break;
        case 39:
          o.metaKey ? s = e.contentWidth : o.altKey ? s = e.containerWidth : s = 30;
          break;
        case 40:
          o.metaKey ? l = -e.contentHeight : o.altKey ? l = -e.containerHeight : l = -30;
          break;
        case 32:
          o.shiftKey ? l = e.containerHeight : l = -e.containerHeight;
          break;
        case 33:
          l = e.containerHeight;
          break;
        case 34:
          l = -e.containerHeight;
          break;
        case 36:
          l = e.contentHeight;
          break;
        case 35:
          l = -e.contentHeight;
          break;
        default:
          return;
      }
      e.settings.suppressScrollX && s !== 0 || e.settings.suppressScrollY && l !== 0 || (t.scrollTop -= l, t.scrollLeft += s, bc(e), i(s, l) && o.preventDefault());
    }
  });
}
function aUe(e) {
  var t = e.element;
  function n(a, s) {
    var l = Math.floor(t.scrollTop), c = t.scrollTop === 0, f = l + t.offsetHeight === t.scrollHeight, d = t.scrollLeft === 0, p = t.scrollLeft + t.offsetWidth === t.scrollWidth, g;
    return Math.abs(s) > Math.abs(a) ? g = c || f : g = d || p, g ? !e.settings.wheelPropagation : !0;
  }
  function r(a) {
    var s = a.deltaX, l = -1 * a.deltaY;
    return (typeof s > "u" || typeof l > "u") && (s = -1 * a.wheelDeltaX / 6, l = a.wheelDeltaY / 6), a.deltaMode && a.deltaMode === 1 && (s *= 10, l *= 10), s !== s && l !== l && (s = 0, l = a.wheelDelta), a.shiftKey ? [-l, -s] : [s, l];
  }
  function i(a, s, l) {
    if (!zd.isWebKit && t.querySelector("select:focus"))
      return !0;
    if (!t.contains(a))
      return !1;
    for (var c = a; c && c !== t; ) {
      if (c.classList.contains(Zr.element.consuming))
        return !0;
      var f = $l(c);
      if (l && f.overflowY.match(/(scroll|auto)/)) {
        var d = c.scrollHeight - c.clientHeight;
        if (d > 0 && (c.scrollTop > 0 && l < 0 || c.scrollTop < d && l > 0))
          return !0;
      }
      if (s && f.overflowX.match(/(scroll|auto)/)) {
        var p = c.scrollWidth - c.clientWidth;
        if (p > 0 && (c.scrollLeft > 0 && s < 0 || c.scrollLeft < p && s > 0))
          return !0;
      }
      c = c.parentNode;
    }
    return !1;
  }
  function o(a) {
    var s = r(a), l = s[0], c = s[1];
    if (!i(a.target, l, c)) {
      var f = !1;
      e.settings.useBothWheelAxes ? e.scrollbarYActive && !e.scrollbarXActive ? (c ? t.scrollTop -= c * e.settings.wheelSpeed : t.scrollTop += l * e.settings.wheelSpeed, f = !0) : e.scrollbarXActive && !e.scrollbarYActive && (l ? t.scrollLeft += l * e.settings.wheelSpeed : t.scrollLeft -= c * e.settings.wheelSpeed, f = !0) : (t.scrollTop -= c * e.settings.wheelSpeed, t.scrollLeft += l * e.settings.wheelSpeed), bc(e), f = f || n(l, c), f && !a.ctrlKey && (a.stopPropagation(), a.preventDefault());
    }
  }
  typeof window.onwheel < "u" ? e.event.bind(t, "wheel", o) : typeof window.onmousewheel < "u" && e.event.bind(t, "mousewheel", o);
}
function sUe(e) {
  if (!zd.supportsTouch && !zd.supportsIePointer)
    return;
  var t = e.element, n = {
    startOffset: {},
    startTime: 0,
    speed: {},
    easingLoop: null
  };
  function r(d, p) {
    var g = Math.floor(t.scrollTop), v = t.scrollLeft, y = Math.abs(d), x = Math.abs(p);
    if (x > y) {
      if (p < 0 && g === e.contentHeight - e.containerHeight || p > 0 && g === 0)
        return window.scrollY === 0 && p > 0 && zd.isChrome;
    } else if (y > x && (d < 0 && v === e.contentWidth - e.containerWidth || d > 0 && v === 0))
      return !0;
    return !0;
  }
  function i(d, p) {
    t.scrollTop -= p, t.scrollLeft -= d, bc(e);
  }
  function o(d) {
    return d.targetTouches ? d.targetTouches[0] : d;
  }
  function a(d) {
    return d.target === e.scrollbarX || d.target === e.scrollbarY || d.pointerType && d.pointerType === "pen" && d.buttons === 0 ? !1 : !!(d.targetTouches && d.targetTouches.length === 1 || d.pointerType && d.pointerType !== "mouse" && d.pointerType !== d.MSPOINTER_TYPE_MOUSE);
  }
  function s(d) {
    if (a(d)) {
      var p = o(d);
      n.startOffset.pageX = p.pageX, n.startOffset.pageY = p.pageY, n.startTime = (/* @__PURE__ */ new Date()).getTime(), n.easingLoop !== null && clearInterval(n.easingLoop);
    }
  }
  function l(d, p, g) {
    if (!t.contains(d))
      return !1;
    for (var v = d; v && v !== t; ) {
      if (v.classList.contains(Zr.element.consuming))
        return !0;
      var y = $l(v);
      if (g && y.overflowY.match(/(scroll|auto)/)) {
        var x = v.scrollHeight - v.clientHeight;
        if (x > 0 && (v.scrollTop > 0 && g < 0 || v.scrollTop < x && g > 0))
          return !0;
      }
      if (p && y.overflowX.match(/(scroll|auto)/)) {
        var b = v.scrollWidth - v.clientWidth;
        if (b > 0 && (v.scrollLeft > 0 && p < 0 || v.scrollLeft < b && p > 0))
          return !0;
      }
      v = v.parentNode;
    }
    return !1;
  }
  function c(d) {
    if (a(d)) {
      var p = o(d), g = { pageX: p.pageX, pageY: p.pageY }, v = g.pageX - n.startOffset.pageX, y = g.pageY - n.startOffset.pageY;
      if (l(d.target, v, y))
        return;
      i(v, y), n.startOffset = g;
      var x = (/* @__PURE__ */ new Date()).getTime(), b = x - n.startTime;
      b > 0 && (n.speed.x = v / b, n.speed.y = y / b, n.startTime = x), r(v, y) && d.cancelable && d.preventDefault();
    }
  }
  function f() {
    e.settings.swipeEasing && (clearInterval(n.easingLoop), n.easingLoop = setInterval(function() {
      if (e.isInitialized) {
        clearInterval(n.easingLoop);
        return;
      }
      if (!n.speed.x && !n.speed.y) {
        clearInterval(n.easingLoop);
        return;
      }
      if (Math.abs(n.speed.x) < 0.01 && Math.abs(n.speed.y) < 0.01) {
        clearInterval(n.easingLoop);
        return;
      }
      i(n.speed.x * 30, n.speed.y * 30), n.speed.x *= 0.8, n.speed.y *= 0.8;
    }, 10));
  }
  zd.supportsTouch ? (e.event.bind(t, "touchstart", s), e.event.bind(t, "touchmove", c), e.event.bind(t, "touchend", f)) : zd.supportsIePointer && (window.PointerEvent ? (e.event.bind(t, "pointerdown", s), e.event.bind(t, "pointermove", c), e.event.bind(t, "pointerup", f)) : window.MSPointerEvent && (e.event.bind(t, "MSPointerDown", s), e.event.bind(t, "MSPointerMove", c), e.event.bind(t, "MSPointerUp", f)));
}
var lUe = function() {
  return {
    handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollingThreshold: 1e3,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: !1,
    suppressScrollY: !1,
    swipeEasing: !0,
    useBothWheelAxes: !1,
    wheelPropagation: !0,
    wheelSpeed: 1
  };
}, cUe = {
  "click-rail": rUe,
  "drag-thumb": iUe,
  keyboard: oUe,
  wheel: aUe,
  touch: sUe
}, kv = function(t, n) {
  var r = this;
  if (n === void 0 && (n = {}), typeof t == "string" && (t = document.querySelector(t)), !t || !t.nodeName)
    throw new Error("no element is specified to initialize PerfectScrollbar");
  this.element = t, t.classList.add(Zr.main), this.settings = lUe();
  for (var i in n)
    this.settings[i] = n[i];
  this.containerWidth = null, this.containerHeight = null, this.contentWidth = null, this.contentHeight = null;
  var o = function() {
    return t.classList.add(Zr.state.focus);
  }, a = function() {
    return t.classList.remove(Zr.state.focus);
  };
  this.isRtl = $l(t).direction === "rtl", this.isRtl === !0 && t.classList.add(Zr.rtl), this.isNegativeScroll = function() {
    var c = t.scrollLeft, f = null;
    return t.scrollLeft = -1, f = t.scrollLeft < 0, t.scrollLeft = c, f;
  }(), this.negativeScrollAdjustment = this.isNegativeScroll ? t.scrollWidth - t.clientWidth : 0, this.event = new Nh(), this.ownerDocument = t.ownerDocument || document, this.scrollbarXRail = k0(Zr.element.rail("x")), t.appendChild(this.scrollbarXRail), this.scrollbarX = k0(Zr.element.thumb("x")), this.scrollbarXRail.appendChild(this.scrollbarX), this.scrollbarX.setAttribute("tabindex", 0), this.event.bind(this.scrollbarX, "focus", o), this.event.bind(this.scrollbarX, "blur", a), this.scrollbarXActive = null, this.scrollbarXWidth = null, this.scrollbarXLeft = null;
  var s = $l(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(s.bottom, 10), isNaN(this.scrollbarXBottom) ? (this.isScrollbarXUsingBottom = !1, this.scrollbarXTop = Tr(s.top)) : this.isScrollbarXUsingBottom = !0, this.railBorderXWidth = Tr(s.borderLeftWidth) + Tr(s.borderRightWidth), Wo(this.scrollbarXRail, { display: "block" }), this.railXMarginWidth = Tr(s.marginLeft) + Tr(s.marginRight), Wo(this.scrollbarXRail, { display: "" }), this.railXWidth = null, this.railXRatio = null, this.scrollbarYRail = k0(Zr.element.rail("y")), t.appendChild(this.scrollbarYRail), this.scrollbarY = k0(Zr.element.thumb("y")), this.scrollbarYRail.appendChild(this.scrollbarY), this.scrollbarY.setAttribute("tabindex", 0), this.event.bind(this.scrollbarY, "focus", o), this.event.bind(this.scrollbarY, "blur", a), this.scrollbarYActive = null, this.scrollbarYHeight = null, this.scrollbarYTop = null;
  var l = $l(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(l.right, 10), isNaN(this.scrollbarYRight) ? (this.isScrollbarYUsingRight = !1, this.scrollbarYLeft = Tr(l.left)) : this.isScrollbarYUsingRight = !0, this.scrollbarYOuterWidth = this.isRtl ? tUe(this.scrollbarY) : null, this.railBorderYWidth = Tr(l.borderTopWidth) + Tr(l.borderBottomWidth), Wo(this.scrollbarYRail, { display: "block" }), this.railYMarginHeight = Tr(l.marginTop) + Tr(l.marginBottom), Wo(this.scrollbarYRail, { display: "" }), this.railYHeight = null, this.railYRatio = null, this.reach = {
    x: t.scrollLeft <= 0 ? "start" : t.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
    y: t.scrollTop <= 0 ? "start" : t.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
  }, this.isAlive = !0, this.settings.handlers.forEach(function(c) {
    return cUe[c](r);
  }), this.lastScrollTop = Math.floor(t.scrollTop), this.lastScrollLeft = t.scrollLeft, this.event.bind(this.element, "scroll", function(c) {
    return r.onScroll(c);
  }), bc(this);
};
kv.prototype.update = function() {
  this.isAlive && (this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0, Wo(this.scrollbarXRail, { display: "block" }), Wo(this.scrollbarYRail, { display: "block" }), this.railXMarginWidth = Tr($l(this.scrollbarXRail).marginLeft) + Tr($l(this.scrollbarXRail).marginRight), this.railYMarginHeight = Tr($l(this.scrollbarYRail).marginTop) + Tr($l(this.scrollbarYRail).marginBottom), Wo(this.scrollbarXRail, { display: "none" }), Wo(this.scrollbarYRail, { display: "none" }), bc(this), sw(this, "top", 0, !1, !0), sw(this, "left", 0, !1, !0), Wo(this.scrollbarXRail, { display: "" }), Wo(this.scrollbarYRail, { display: "" }));
};
kv.prototype.onScroll = function(t) {
  this.isAlive && (bc(this), sw(this, "top", this.element.scrollTop - this.lastScrollTop), sw(this, "left", this.element.scrollLeft - this.lastScrollLeft), this.lastScrollTop = Math.floor(this.element.scrollTop), this.lastScrollLeft = this.element.scrollLeft);
};
kv.prototype.destroy = function() {
  this.isAlive && (this.event.unbindAll(), cp(this.scrollbarX), cp(this.scrollbarY), cp(this.scrollbarXRail), cp(this.scrollbarYRail), this.removePsClasses(), this.element = null, this.scrollbarX = null, this.scrollbarY = null, this.scrollbarXRail = null, this.scrollbarYRail = null, this.isAlive = !1);
};
kv.prototype.removePsClasses = function() {
  this.element.className = this.element.className.split(" ").filter(function(t) {
    return !t.match(/^ps([-_].+|)$/);
  }).join(" ");
};
const uUe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kv
}, Symbol.toStringTag, { value: "Module" })), fUe = /* @__PURE__ */ NB(uUe);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(x) {
    for (var b = 1; b < arguments.length; b++) {
      var w = arguments[b];
      for (var S in w)
        Object.prototype.hasOwnProperty.call(w, S) && (x[S] = w[S]);
    }
    return x;
  }, r = /* @__PURE__ */ function() {
    function x(b, w) {
      for (var S = 0; S < w.length; S++) {
        var E = w[S];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(b, E.key, E);
      }
    }
    return function(b, w, S) {
      return w && x(b.prototype, w), S && x(b, S), b;
    };
  }(), i = m, o = c(i), a = $Y, s = fUe, l = c(s);
  function c(x) {
    return x && x.__esModule ? x : { default: x };
  }
  function f(x, b) {
    var w = {};
    for (var S in x)
      b.indexOf(S) >= 0 || Object.prototype.hasOwnProperty.call(x, S) && (w[S] = x[S]);
    return w;
  }
  function d(x, b) {
    if (!(x instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(x, b) {
    if (!x)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return b && (typeof b == "object" || typeof b == "function") ? b : x;
  }
  function g(x, b) {
    if (typeof b != "function" && b !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof b);
    x.prototype = Object.create(b && b.prototype, { constructor: { value: x, enumerable: !1, writable: !0, configurable: !0 } }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(x, b) : x.__proto__ = b);
  }
  var v = {
    "ps-scroll-y": "onScrollY",
    "ps-scroll-x": "onScrollX",
    "ps-scroll-up": "onScrollUp",
    "ps-scroll-down": "onScrollDown",
    "ps-scroll-left": "onScrollLeft",
    "ps-scroll-right": "onScrollRight",
    "ps-y-reach-start": "onYReachStart",
    "ps-y-reach-end": "onYReachEnd",
    "ps-x-reach-start": "onXReachStart",
    "ps-x-reach-end": "onXReachEnd"
  };
  Object.freeze(v);
  var y = function(x) {
    g(b, x);
    function b(w) {
      d(this, b);
      var S = p(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this, w));
      return S.handleRef = S.handleRef.bind(S), S._handlerByEvent = {}, S;
    }
    return r(b, [{
      key: "componentDidMount",
      value: function() {
        this.props.option && console.warn('react-perfect-scrollbar: the "option" prop has been deprecated in favor of "options"'), this._ps = new l.default(this._container, this.props.options || this.props.option), this._updateEventHook(), this._updateClassName();
      }
    }, {
      key: "componentDidUpdate",
      value: function(S) {
        this._updateEventHook(S), this.updateScroll(), S.className !== this.props.className && this._updateClassName();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        var S = this;
        Object.keys(this._handlerByEvent).forEach(function(E) {
          var O = S._handlerByEvent[E];
          O && S._container.removeEventListener(E, O, !1);
        }), this._handlerByEvent = {}, this._ps.destroy(), this._ps = null;
      }
    }, {
      key: "_updateEventHook",
      value: function() {
        var S = this, E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        Object.keys(v).forEach(function(O) {
          var $ = S.props[v[O]], P = E[v[O]];
          if ($ !== P) {
            if (P) {
              var R = S._handlerByEvent[O];
              S._container.removeEventListener(O, R, !1), S._handlerByEvent[O] = null;
            }
            if ($) {
              var L = function() {
                return $(S._container);
              };
              S._container.addEventListener(O, L, !1), S._handlerByEvent[O] = L;
            }
          }
        });
      }
    }, {
      key: "_updateClassName",
      value: function() {
        var S = this.props.className, E = this._container.className.split(" ").filter(function(O) {
          return O.match(/^ps([-_].+|)$/);
        }).join(" ");
        this._container && (this._container.className = "scrollbar-container" + (S ? " " + S : "") + (E ? " " + E : ""));
      }
    }, {
      key: "updateScroll",
      value: function() {
        this.props.onSync(this._ps);
      }
    }, {
      key: "handleRef",
      value: function(S) {
        this._container = S, this.props.containerRef(S);
      }
    }, {
      key: "render",
      value: function() {
        var S = this.props;
        S.className;
        var E = S.style;
        S.option, S.options, S.containerRef, S.onScrollY, S.onScrollX, S.onScrollUp, S.onScrollDown, S.onScrollLeft, S.onScrollRight, S.onYReachStart, S.onYReachEnd, S.onXReachStart, S.onXReachEnd;
        var O = S.component;
        S.onSync;
        var $ = S.children, P = f(S, ["className", "style", "option", "options", "containerRef", "onScrollY", "onScrollX", "onScrollUp", "onScrollDown", "onScrollLeft", "onScrollRight", "onYReachStart", "onYReachEnd", "onXReachStart", "onXReachEnd", "component", "onSync", "children"]), R = O;
        return o.default.createElement(
          R,
          n({ style: E, ref: this.handleRef }, P),
          $
        );
      }
    }]), b;
  }(i.Component);
  t.default = y, y.defaultProps = {
    className: "",
    style: void 0,
    option: void 0,
    options: void 0,
    containerRef: function() {
    },
    onScrollY: void 0,
    onScrollX: void 0,
    onScrollUp: void 0,
    onScrollDown: void 0,
    onScrollLeft: void 0,
    onScrollRight: void 0,
    onYReachStart: void 0,
    onYReachEnd: void 0,
    onXReachStart: void 0,
    onXReachEnd: void 0,
    onSync: function(b) {
      return b.update();
    },
    component: "div"
  }, y.propTypes = {
    children: a.PropTypes.node.isRequired,
    className: a.PropTypes.string,
    style: a.PropTypes.object,
    option: a.PropTypes.object,
    options: a.PropTypes.object,
    containerRef: a.PropTypes.func,
    onScrollY: a.PropTypes.func,
    onScrollX: a.PropTypes.func,
    onScrollUp: a.PropTypes.func,
    onScrollDown: a.PropTypes.func,
    onScrollLeft: a.PropTypes.func,
    onScrollRight: a.PropTypes.func,
    onYReachStart: a.PropTypes.func,
    onYReachEnd: a.PropTypes.func,
    onXReachStart: a.PropTypes.func,
    onXReachEnd: a.PropTypes.func,
    onSync: a.PropTypes.func,
    component: a.PropTypes.string
  }, e.exports = t.default;
})(MI, MI.exports);
var dUe = MI.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = dUe, r = i(n);
  function i(o) {
    return o && o.__esModule ? o : { default: o };
  }
  t.default = r.default, e.exports = t.default;
})(RI, RI.exports);
var pUe = RI.exports;
const hUe = /* @__PURE__ */ Oi(pUe);
var mUe = /* @__PURE__ */ m.createContext({});
const OM = mUe;
function gi() {
  return gi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gi.apply(null, arguments);
}
function gUe(e) {
  if (Array.isArray(e))
    return e;
}
function vUe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function tF(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function yUe(e, t) {
  if (e) {
    if (typeof e == "string")
      return tF(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? tF(e, t) : void 0;
  }
}
function bUe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IY(e, t) {
  return gUe(e) || vUe(e, t) || yUe(e, t) || bUe();
}
function Yf(e) {
  "@babel/helpers - typeof";
  return Yf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yf(e);
}
function wUe(e, t) {
  if (Yf(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Yf(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function SUe(e) {
  var t = wUe(e, "string");
  return Yf(t) == "symbol" ? t : t + "";
}
function Yg(e, t, n) {
  return (t = SUe(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function xUe(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.includes(r))
        continue;
      n[r] = e[r];
    }
  return n;
}
function PM(e, t) {
  if (e == null)
    return {};
  var n, r, i = xUe(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++)
      n = o[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function ts(e, t) {
  CUe(e) && (e = "100%");
  var n = EUe(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function CUe(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function EUe(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function $Ue(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function j0(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function N_(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function _Ue(e, t, n) {
  return {
    r: ts(e, 255) * 255,
    g: ts(t, 255) * 255,
    b: ts(n, 255) * 255
  };
}
function k_(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function OUe(e, t, n) {
  var r, i, o;
  if (e = ts(e, 360), t = ts(t, 100), n = ts(n, 100), t === 0)
    i = n, o = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - a;
    r = k_(s, a, e + 1 / 3), i = k_(s, a, e), o = k_(s, a, e - 1 / 3);
  }
  return { r: r * 255, g: i * 255, b: o * 255 };
}
function PUe(e, t, n) {
  e = ts(e, 255), t = ts(t, 255), n = ts(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = r, s = r - i, l = r === 0 ? 0 : s / r;
  if (r === i)
    o = 0;
  else {
    switch (r) {
      case e:
        o = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / s + 2;
        break;
      case n:
        o = (e - t) / s + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: l, v: a };
}
function TUe(e, t, n) {
  e = ts(e, 360) * 6, t = ts(t, 100), n = ts(n, 100);
  var r = Math.floor(e), i = e - r, o = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), l = r % 6, c = [n, a, o, o, s, n][l], f = [s, n, n, a, o, o][l], d = [o, o, s, n, n, a][l];
  return { r: c * 255, g: f * 255, b: d * 255 };
}
function IUe(e, t, n, r) {
  var i = [
    N_(Math.round(e).toString(16)),
    N_(Math.round(t).toString(16)),
    N_(Math.round(n).toString(16))
  ];
  return r && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function nF(e) {
  return pa(e) / 255;
}
function pa(e) {
  return parseInt(e, 16);
}
var rF = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Pm(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof e == "string" && (e = MUe(e)), typeof e == "object" && (Ql(e.r) && Ql(e.g) && Ql(e.b) ? (t = _Ue(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ql(e.h) && Ql(e.s) && Ql(e.v) ? (r = j0(e.s), i = j0(e.v), t = TUe(e.h, r, i), a = !0, s = "hsv") : Ql(e.h) && Ql(e.s) && Ql(e.l) && (r = j0(e.s), o = j0(e.l), t = OUe(e.h, r, o), a = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = $Ue(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var AUe = "[-\\+]?\\d+%?", RUe = "[-\\+]?\\d*\\.\\d+%?", fu = "(?:".concat(RUe, ")|(?:").concat(AUe, ")"), L_ = "[\\s|\\(]+(".concat(fu, ")[,|\\s]+(").concat(fu, ")[,|\\s]+(").concat(fu, ")\\s*\\)?"), D_ = "[\\s|\\(]+(".concat(fu, ")[,|\\s]+(").concat(fu, ")[,|\\s]+(").concat(fu, ")[,|\\s]+(").concat(fu, ")\\s*\\)?"), Ps = {
  CSS_UNIT: new RegExp(fu),
  rgb: new RegExp("rgb" + L_),
  rgba: new RegExp("rgba" + D_),
  hsl: new RegExp("hsl" + L_),
  hsla: new RegExp("hsla" + D_),
  hsv: new RegExp("hsv" + L_),
  hsva: new RegExp("hsva" + D_),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function MUe(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (rF[e])
    e = rF[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = Ps.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = Ps.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = Ps.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = Ps.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = Ps.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = Ps.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = Ps.hex8.exec(e), n ? {
    r: pa(n[1]),
    g: pa(n[2]),
    b: pa(n[3]),
    a: nF(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Ps.hex6.exec(e), n ? {
    r: pa(n[1]),
    g: pa(n[2]),
    b: pa(n[3]),
    format: t ? "name" : "hex"
  } : (n = Ps.hex4.exec(e), n ? {
    r: pa(n[1] + n[1]),
    g: pa(n[2] + n[2]),
    b: pa(n[3] + n[3]),
    a: nF(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Ps.hex3.exec(e), n ? {
    r: pa(n[1] + n[1]),
    g: pa(n[2] + n[2]),
    b: pa(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Ql(e) {
  return !!Ps.CSS_UNIT.exec(String(e));
}
var F0 = 2, iF = 0.16, NUe = 0.05, kUe = 0.05, LUe = 0.15, AY = 5, RY = 4, DUe = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function oF(e) {
  var t = e.r, n = e.g, r = e.b, i = PUe(t, n, r);
  return {
    h: i.h * 360,
    s: i.s,
    v: i.v
  };
}
function B0(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(IUe(t, n, r, !1));
}
function jUe(e, t, n) {
  var r = n / 100, i = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return i;
}
function aF(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - F0 * t : Math.round(e.h) + F0 * t : r = n ? Math.round(e.h) + F0 * t : Math.round(e.h) - F0 * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function sF(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - iF * t : t === RY ? r = e.s + iF : r = e.s + NUe * t, r > 1 && (r = 1), n && t === AY && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function lF(e, t, n) {
  var r;
  return n ? r = e.v + kUe * t : r = e.v - LUe * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function NI(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = Pm(e), i = AY; i > 0; i -= 1) {
    var o = oF(r), a = B0(Pm({
      h: aF(o, i, !0),
      s: sF(o, i, !0),
      v: lF(o, i, !0)
    }));
    n.push(a);
  }
  n.push(B0(r));
  for (var s = 1; s <= RY; s += 1) {
    var l = oF(r), c = B0(Pm({
      h: aF(l, s),
      s: sF(l, s),
      v: lF(l, s)
    }));
    n.push(c);
  }
  return t.theme === "dark" ? DUe.map(function(f) {
    var d = f.index, p = f.opacity, g = B0(jUe(Pm(t.backgroundColor || "#141414"), Pm(n[d]), p * 100));
    return g;
  }) : n;
}
var j_ = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Ab = {}, F_ = {};
Object.keys(j_).forEach(function(e) {
  Ab[e] = NI(j_[e]), Ab[e].primary = Ab[e][5], F_[e] = NI(j_[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), F_[e].primary = F_[e][5];
});
var FUe = Ab.blue;
function cF(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _l(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cF(Object(n), !0).forEach(function(r) {
      Yg(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cF(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function BUe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function zUe(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var uF = "data-rc-order", UUe = "rc-util-key", kI = /* @__PURE__ */ new Map();
function MY() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : UUe;
}
function TM(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function HUe(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function NY(e) {
  return Array.from((kI.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function kY(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!BUe())
    return null;
  var n = t.csp, r = t.prepend, i = document.createElement("style");
  i.setAttribute(uF, HUe(r)), n != null && n.nonce && (i.nonce = n == null ? void 0 : n.nonce), i.innerHTML = e;
  var o = TM(t), a = o.firstChild;
  if (r) {
    if (r === "queue") {
      var s = NY(o).filter(function(l) {
        return ["prepend", "prependQueue"].includes(l.getAttribute(uF));
      });
      if (s.length)
        return o.insertBefore(i, s[s.length - 1].nextSibling), i;
    }
    o.insertBefore(i, a);
  } else
    o.appendChild(i);
  return i;
}
function WUe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = TM(t);
  return NY(n).find(function(r) {
    return r.getAttribute(MY(t)) === e;
  });
}
function VUe(e, t) {
  var n = kI.get(e);
  if (!n || !zUe(document, n)) {
    var r = kY("", t), i = r.parentNode;
    kI.set(e, i), e.removeChild(r);
  }
}
function GUe(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = TM(n);
  VUe(r, n);
  var i = WUe(t, n);
  if (i) {
    var o, a;
    if ((o = n.csp) !== null && o !== void 0 && o.nonce && i.nonce !== ((a = n.csp) === null || a === void 0 ? void 0 : a.nonce)) {
      var s;
      i.nonce = (s = n.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return i.innerHTML !== e && (i.innerHTML = e), i;
  }
  var l = kY(e, n);
  return l.setAttribute(MY(n), t), l;
}
function LY(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function KUe(e) {
  return LY(e) !== (e == null ? void 0 : e.ownerDocument);
}
function qUe(e) {
  return KUe(e) ? LY(e) : null;
}
var LI = {}, YUe = function(t) {
};
function XUe(e, t) {
}
function QUe(e, t) {
}
function JUe() {
  LI = {};
}
function DY(e, t, n) {
  !t && !LI[n] && (e(!1, n), LI[n] = !0);
}
function eC(e, t) {
  DY(XUe, e, t);
}
function ZUe(e, t) {
  DY(QUe, e, t);
}
eC.preMessage = YUe;
eC.resetWarned = JUe;
eC.noteOnce = ZUe;
function eHe(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function DI(e, t) {
  eC(e, "[@ant-design/icons] ".concat(t));
}
function fF(e) {
  return Yf(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Yf(e.icon) === "object" || typeof e.icon == "function");
}
function dF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[eHe(n)] = r;
    }
    return t;
  }, {});
}
function jI(e, t, n) {
  return n ? /* @__PURE__ */ oe.createElement(e.tag, _l(_l({
    key: t
  }, dF(e.attrs)), n), (e.children || []).map(function(r, i) {
    return jI(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ oe.createElement(e.tag, _l({
    key: t
  }, dF(e.attrs)), (e.children || []).map(function(r, i) {
    return jI(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  }));
}
function jY(e) {
  return NI(e)[0];
}
function FY(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var tHe = {
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
}, nHe = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, BY = function(t) {
  var n = m.useContext(OM), r = n.csp, i = n.prefixCls, o = nHe;
  i && (o = o.replace(/anticon/g, i)), m.useEffect(function() {
    var a = t.current, s = qUe(a);
    GUe(o, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: s
    });
  }, []);
}, rHe = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], og = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function iHe(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  og.primaryColor = t, og.secondaryColor = n || jY(t), og.calculated = !!n;
}
function oHe() {
  return _l({}, og);
}
var tC = function(t) {
  var n = t.icon, r = t.className, i = t.onClick, o = t.style, a = t.primaryColor, s = t.secondaryColor, l = PM(t, rHe), c = m.useRef(), f = og;
  if (a && (f = {
    primaryColor: a,
    secondaryColor: s || jY(a)
  }), BY(c), DI(fF(n), "icon should be icon definiton, but got ".concat(n)), !fF(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = _l(_l({}, d), {}, {
    icon: d.icon(f.primaryColor, f.secondaryColor)
  })), jI(d.icon, "svg-".concat(d.name), _l(_l({
    className: r,
    onClick: i,
    style: o,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: c
  }));
};
tC.displayName = "IconReact";
tC.getTwoToneColors = oHe;
tC.setTwoToneColors = iHe;
const IM = tC;
function zY(e) {
  var t = FY(e), n = IY(t, 2), r = n[0], i = n[1];
  return IM.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function aHe() {
  var e = IM.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var sHe = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
zY(FUe.primary);
var nC = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, i = e.spin, o = e.rotate, a = e.tabIndex, s = e.onClick, l = e.twoToneColor, c = PM(e, sHe), f = m.useContext(OM), d = f.prefixCls, p = d === void 0 ? "anticon" : d, g = f.rootClassName, v = ft(g, p, Yg(Yg({}, "".concat(p, "-").concat(r.name), !!r.name), "".concat(p, "-spin"), !!i || r.name === "loading"), n), y = a;
  y === void 0 && s && (y = -1);
  var x = o ? {
    msTransform: "rotate(".concat(o, "deg)"),
    transform: "rotate(".concat(o, "deg)")
  } : void 0, b = FY(l), w = IY(b, 2), S = w[0], E = w[1];
  return /* @__PURE__ */ m.createElement("span", gi({
    role: "img",
    "aria-label": r.name
  }, c, {
    ref: t,
    tabIndex: y,
    onClick: s,
    className: v
  }), /* @__PURE__ */ m.createElement(IM, {
    icon: r,
    primaryColor: S,
    secondaryColor: E,
    style: x
  }));
});
nC.displayName = "AntdIcon";
nC.getTwoToneColor = aHe;
nC.setTwoToneColor = zY;
const ea = nC;
var lHe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, name: "arrow-right", theme: "outlined" };
const cHe = lHe;
var uHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: cHe
  }));
}, fHe = /* @__PURE__ */ m.forwardRef(uHe);
const Xg = fHe;
var dHe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z" } }] }, name: "bulb", theme: "outlined" };
const pHe = dHe;
var hHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: pHe
  }));
}, mHe = /* @__PURE__ */ m.forwardRef(hHe);
const gHe = mHe;
var vHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: A9
  }));
}, yHe = /* @__PURE__ */ m.forwardRef(vHe);
const AM = yHe;
var bHe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z" } }] }, name: "dislike", theme: "filled" };
const wHe = bHe;
var SHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: wHe
  }));
}, xHe = /* @__PURE__ */ m.forwardRef(SHe);
const CHe = xHe;
var EHe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z" } }] }, name: "dislike", theme: "outlined" };
const $He = EHe;
var _He = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: $He
  }));
}, OHe = /* @__PURE__ */ m.forwardRef(_He);
const PHe = OHe;
var THe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: hbe
  }));
}, IHe = /* @__PURE__ */ m.forwardRef(THe);
const RM = IHe;
var AHe = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM770.87 199.13l-52.2-52.2a8.01 8.01 0 014.7-13.6l179.4-21c5.1-.6 9.5 3.7 8.9 8.9l-21 179.4c-.8 6.6-8.9 9.4-13.6 4.7l-52.4-52.4-256.2 256.2a8.03 8.03 0 01-11.3 0l-42.4-42.4a8.03 8.03 0 010-11.3l256.1-256.3z" } }] }, name: "export", theme: "outlined" };
const RHe = AHe;
var MHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: RHe
  }));
}, NHe = /* @__PURE__ */ m.forwardRef(MHe);
const kHe = NHe;
var LHe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z" } }] }, name: "like", theme: "filled" };
const DHe = LHe;
var jHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: DHe
  }));
}, FHe = /* @__PURE__ */ m.forwardRef(jHe);
const BHe = FHe;
var zHe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0142.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z" } }] }, name: "like", theme: "outlined" };
const UHe = zHe;
var HHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: UHe
  }));
}, WHe = /* @__PURE__ */ m.forwardRef(HHe);
const VHe = WHe;
var GHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: H9
  }));
}, KHe = /* @__PURE__ */ m.forwardRef(GHe);
const qHe = KHe;
var YHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: AOe
  }));
}, XHe = /* @__PURE__ */ m.forwardRef(YHe);
const pF = XHe;
var QHe = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: i7
  }));
}, JHe = /* @__PURE__ */ m.forwardRef(QHe);
const UY = JHe;
var ZHe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z" } }] }, name: "send", theme: "outlined" };
const e9e = ZHe;
var t9e = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: e9e
  }));
}, n9e = /* @__PURE__ */ m.forwardRef(t9e);
const rC = n9e;
var r9e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M881.7 187.4l-45.1-45.1a8.03 8.03 0 00-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L447.9 585a7.9 7.9 0 00-8.9-8.9z" } }] }, name: "shrink", theme: "outlined" };
const i9e = r9e;
var o9e = function(t, n) {
  return /* @__PURE__ */ m.createElement(ea, gi({}, t, {
    ref: n,
    icon: i9e
  }));
}, a9e = /* @__PURE__ */ m.forwardRef(o9e);
const s9e = a9e;
function FI(e) {
  "@babel/helpers - typeof";
  return FI = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, FI(e);
}
function l9e(e, t, n) {
  var r = m.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function c9e(e, t) {
  typeof e == "function" ? e(t) : FI(e) === "object" && e && "current" in e && (e.current = t);
}
function u9e() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    t.forEach(function(o) {
      c9e(o, i);
    });
  };
}
function f9e() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return l9e(function() {
    return u9e.apply(void 0, t);
  }, t, function(r, i) {
    return r.length === i.length && r.every(function(o, a) {
      return o === i[a];
    });
  });
}
var d9e = ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"], HY = /* @__PURE__ */ m.forwardRef(function(e, t) {
  var n = e.className, r = e.component, i = e.viewBox, o = e.spin, a = e.rotate, s = e.tabIndex, l = e.onClick, c = e.children, f = PM(e, d9e), d = m.useRef(), p = f9e(d, t);
  DI(!!(r || c), "Should have `component` prop or `children`."), BY(d);
  var g = m.useContext(OM), v = g.prefixCls, y = v === void 0 ? "anticon" : v, x = g.rootClassName, b = ft(x, y, Yg({}, "".concat(y, "-spin"), !!o && !!r), n), w = ft(Yg({}, "".concat(y, "-spin"), !!o)), S = a ? {
    msTransform: "rotate(".concat(a, "deg)"),
    transform: "rotate(".concat(a, "deg)")
  } : void 0, E = _l(_l({}, tHe), {}, {
    className: w,
    style: S,
    viewBox: i
  });
  i || delete E.viewBox;
  var O = function() {
    return r ? /* @__PURE__ */ m.createElement(r, E, c) : c ? (DI(!!i || m.Children.count(c) === 1 && /* @__PURE__ */ m.isValidElement(c) && m.Children.only(c).type === "use", "Make sure that you provide correct `viewBox` prop (default `0 0 1024 1024`) to the icon."), /* @__PURE__ */ m.createElement("svg", gi({}, E, {
      viewBox: i
    }), c)) : null;
  }, $ = s;
  return $ === void 0 && l && ($ = -1), /* @__PURE__ */ m.createElement("span", gi({
    role: "img"
  }, f, {
    ref: p,
    tabIndex: $,
    onClick: l,
    className: b
  }), O());
});
HY.displayName = "AntdIcon";
const WY = HY, { Paragraph: p9e } = xh, h9e = Ut(zi)`
  background: white !important;
  ${(e) => e.$styles.opacity ? `opacity: ${e.$styles.opacity};` : ""}
  ${(e) => e.$showSmallPopupStarterQuestions ? `
  vertical-align: top;
  height: 56px;
  max-width: 75%;
  white-space: normal;
  margin-right: 8px !important;
  text-align: left;
  ` : ""}
  ${(e) => e.$showBigPopupStarterQuestions ? `
  &.ant-btn {
    overflow: hidden;
    display: block;
    margin-left: auto;
    text-overflow: ellipsis;
    margin-top: 5px;
    transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1),
      border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    height: auto;
    white-space: normal;
    text-align: left;
    max-width: 80%;

    span {
      display: inline;
    }
  }
    ` : ""}
  ${Ec ? `
  &:hover {
    border-color: #DBDBDB !important;
    color: var(--textgray-5) !important;
  }
  ` : ""}
`, VY = (e) => {
  const {
    question: t,
    isShowJumpingDots: n,
    styles: r,
    customStyles: i,
    questionsRows: o,
    questionsShowArrow: a,
    contentType: s = $u.StarterQuestion
  } = e, l = wr(), c = pe(Tv), { themeStyle: f } = Kf(), {
    isSiteCompanionWebChat: d,
    starterQuestionsRows: p,
    starterQuestionButtonStyles: g,
    customStarterQuestionButtonStyles: v,
    showBigPopupStarterQuestions: y,
    showStarterQuestionArrow: x,
    showSmallPopupStarterQuestions: b
  } = Fv({ themeStyle: f, isShowJumpingDots: n }), w = r ?? g, S = i ?? v, E = o ?? p, O = a ?? x, $ = () => {
    const P = {
      domain: window.location.hostname,
      incoming_message_url: window.location.href
    };
    l(
      Mh({
        webchatId: c,
        content: t,
        publisher: P,
        contentType: s
      })
    ), l(Qs(!0));
  };
  return /* @__PURE__ */ H.jsxs(
    h9e,
    {
      $showSmallPopupStarterQuestions: b,
      $showBigPopupStarterQuestions: y,
      $styles: w,
      className: "starter-question",
      type: "default",
      onClick: () => $(),
      style: S,
      disabled: n,
      children: [
        E ? /* @__PURE__ */ H.jsx(
          p9e,
          {
            ellipsis: { rows: E },
            style: {
              color: "inherit",
              marginBottom: 0
            },
            children: t
          }
        ) : /* @__PURE__ */ H.jsx("div", { style: { overflowWrap: "break-word" }, children: t }),
        O && /* @__PURE__ */ H.jsx(
          Xg,
          {
            style: {
              position: "absolute",
              right: "14px",
              top: "50%",
              marginTop: "-6px",
              fontSize: "13px"
            }
          }
        )
      ]
    }
  );
}, m9e = Ut.div``, g9e = (e) => {
  const { showSmallPopupStarterQuestions: t, ...n } = e;
  return Ec || !t ? /* @__PURE__ */ H.jsx(m9e, { ...n }) : /* @__PURE__ */ H.jsx(hUe, { ...n, options: { suppressScrollY: !0 } });
}, v9e = (e) => {
  const { isShowJumpingDots: t } = e, n = pe(Ox), { themeStyle: r } = Kf(), { theme: i } = Kf(), {
    showBigPopupStarterQuestions: o,
    showSmallPopupStarterQuestions: a,
    starterQuestionsTitle: s,
    customStarterQuestionsTitleStyles: l,
    customStarterQuestionsContainerStyles: c
  } = Fv({ themeStyle: r }), d = i === Jt.siteCompanionPopup ? n : n == null ? void 0 : n.slice(0, 4);
  return /* @__PURE__ */ H.jsxs("div", { children: [
    s && /* @__PURE__ */ H.jsx("div", { style: l, children: s }),
    /* @__PURE__ */ H.jsx(
      g9e,
      {
        id: a ? "small-popup-starter-questions" : void 0,
        className: `
						${o ? "startQuestionsContainer" : ""}
					`,
        style: c,
        showSmallPopupStarterQuestions: a,
        children: d == null ? void 0 : d.map((p) => /* @__PURE__ */ H.jsx(
          VY,
          {
            question: p.question,
            isShowJumpingDots: t
          },
          p.question
        ))
      }
    )
  ] });
}, y9e = (e) => {
  const { containerRef: t, messageContainerRef: n, messages: r, isShowJumpingDotsCalculated: i } = e, o = wr(), { scrollToBottom: a, scrollToLastMessage: s, wasBottom: l } = cU(
    t,
    n
  );
  return m.useEffect(() => {
    l && o(iq());
  }, [l, o]), m.useEffect(() => {
    i && setTimeout(() => {
      a();
    });
  }, [i, a]), m.useEffect(() => {
    setTimeout(() => {
      s();
    });
  }, [r, s]), null;
}, b9e = Ut.div`
  height: ${(e) => e.$styles.height};
  background-color: ${(e) => e.$styles.backgroundColor};
  padding: ${(e) => e.$styles.padding};
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  overscroll-behavior: contain;

  &.show-big-popup-starter-questions {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .date-divider {
    ${(e) => e.$styles.showDateDivider ? "" : "display: none !important;"}
  }

  .message-datetime {
    ${(e) => e.$styles.showMessageDate ? "" : "display: none !important;"}
  }

  .startQuestionsContainer {
    text-align: right;
    overflow: hidden;
  }

  #small-popup-starter-questions {
    overflow: ${Ec ? "auto hidden" : "hidden"};
    white-space: nowrap;
    padding-top: 16px;
    padding-bottom: 8px;
    text-align: right;
  }
`, hF = (e) => {
  const { className: t, showDotByRandomTime: n, isShowJumpingDots: r, overMaxResponseTime: i, webchatId: o } = e, a = m.useRef(null), s = pe(rl), l = pe(CNe), { themeStyle: c, theme: f } = Kf(), {
    groupedMessages: d,
    messageContainerStyles: p,
    showBigPopupStarterQuestions: g,
    showScrollToBottomEffectComponent: v,
    showSmallPopupStarterQuestions: y,
    showMessages: x,
    customContainerStyles: b
  } = Fv({ themeStyle: c }), w = m.useRef(null), S = f === Jt.siteCompanionPopup;
  return /* @__PURE__ */ H.jsxs(
    b9e,
    {
      ref: a,
      className: `
        ${t ?? ""}
        ${g ? "show-big-popup-starter-questions" : ""}
        message-container
        ${l ? "expand-last-message" : ""}
      `,
      $styles: p,
      style: b,
      children: [
        x && v && (S ? /* @__PURE__ */ H.jsx(
          Kze,
          {
            containerRef: a,
            messageContainerRef: w,
            messages: s,
            loading: r
          }
        ) : /* @__PURE__ */ H.jsx(
          y9e,
          {
            containerRef: a,
            messageContainerRef: w,
            messages: s,
            isShowJumpingDotsCalculated: r && n && !i
          }
        )),
        x && /* @__PURE__ */ H.jsx(
          Lze,
          {
            webchatId: o,
            groupedMessages: d,
            isShowJumpingDots: r,
            messageContainerRef: w
          }
        ),
        /* @__PURE__ */ H.jsx(
          Hze,
          {
            showMessages: x,
            isShowJumpingDots: r,
            isSiteCompanionWebChat: S,
            showDotByRandomTime: n,
            overMaxResponseTime: i
          }
        ),
        (g || y) && /* @__PURE__ */ H.jsx(v9e, { isShowJumpingDots: r })
      ]
    }
  );
};
var w9e = (e) => typeof e != "string" ? {} : e.split(/ ?; ?/).reduce((t, n) => {
  const [r, i] = n.split(/ ?: ?/).map((o, a) => a === 0 ? o.replace(/\s+/g, "") : o.trim());
  if (r && i) {
    const o = r.replace(/(\w)-(\w)/g, (s, l, c) => `${l}${c.toUpperCase()}`);
    let a = i.trim();
    Number.isNaN(Number(i)) || (a = Number(i)), t[r.startsWith("-") ? r : o] = a;
  }
  return t;
}, {});
function S9e(e = 6) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let r = e; r > 0; --r)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var x9e = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], mF = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};
function C9e(e, t) {
  var o;
  const { key: n, level: r, ...i } = t;
  switch (e.nodeType) {
    case 1:
      return m.createElement(
        $9e(e.nodeName),
        E9e(e, n),
        gF(e.childNodes, r, i)
      );
    case 3: {
      const a = ((o = e.nodeValue) == null ? void 0 : o.toString()) ?? "";
      if (!i.allowWhiteSpaces && /^\s+$/.test(a) && !/[\u00A0\u202F]/.test(a))
        return null;
      if (!e.parentNode)
        return a;
      const s = e.parentNode.nodeName.toLowerCase();
      return x9e.includes(s) ? (/\S/.test(a) && console.warn(
        `A textNode is not allowed inside '${s}'. Your text "${a}" will be ignored`
      ), null) : a;
    }
    case 8:
      return null;
    case 11:
      return gF(e.childNodes, r, t);
    default:
      return null;
  }
}
function E9e(e, t) {
  const n = {
    key: t
  };
  if (e instanceof Element) {
    const r = e.getAttribute("class");
    r && (n.className = r), [...e.attributes].forEach((i) => {
      switch (i.name) {
        case "class":
          break;
        case "style":
          n[i.name] = w9e(i.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[mF[i.name] || i.name] = !0;
          break;
        default:
          n[mF[i.name] || i.name] = i.value;
      }
    });
  }
  return n;
}
function gF(e, t, n) {
  const r = [...e].map(
    (i, o) => lw(i, {
      ...n,
      index: o,
      level: t + 1
    })
  ).filter(Boolean);
  return r.length ? r : null;
}
function $9e(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function lw(e, t = {}) {
  if (!e || !(e instanceof Node))
    return null;
  const { actions: n = [], index: r = 0, level: i = 0, randomKey: o } = t;
  let a = e, s = `${i}-${r}`;
  const l = [];
  return o && i === 0 && (s = `${S9e()}-${s}`), Array.isArray(n) && n.forEach((c) => {
    c.condition(a, s, i) && (typeof c.pre == "function" && (a = c.pre(a, s, i), a instanceof Node || (a = e)), typeof c.post == "function" && l.push(c.post(a, s, i)));
  }), l.length ? l : C9e(a, { key: s, level: i, ...t });
}
function _9e(e, t = {}) {
  if (!e || typeof e != "string")
    return null;
  const {
    includeAllNodes: n = !1,
    nodeOnly: r = !1,
    selector: i = "body > *",
    type: o = "text/html"
  } = t;
  try {
    const s = new DOMParser().parseFromString(e, o);
    if (n) {
      const { childNodes: c } = s.body;
      return r ? c : [...c].map((f) => lw(f, t));
    }
    const l = s.querySelector(i) || s.body.childNodes[0];
    if (!(l instanceof Node))
      throw new TypeError("Error parsing input");
    return r ? l : lw(l, t);
  } catch {
  }
  return null;
}
function GY(e, t = {}) {
  return typeof e == "string" ? _9e(e, t) : e instanceof Node ? lw(e, t) : null;
}
var O9e = Object.defineProperty, P9e = (e, t, n) => t in e ? O9e(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, z0 = (e, t, n) => (P9e(e, typeof t != "symbol" ? t + "" : t, n), n), vF = "react-inlinesvg", yF = 10, jn = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function Rb() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function T9e() {
  return A9e() && typeof window < "u" && window !== null;
}
async function KY(e, t) {
  const n = await fetch(e, t), r = n.headers.get("content-type"), [i] = (r ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((o) => i.includes(o)))
    throw new Error(`Content type isn't valid: ${i}`);
  return n.text();
}
function I9e(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function A9e() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
function R9e(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function M9e(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", n = "1234567890", r = `${t}${t.toUpperCase()}${n}`;
  let i = "";
  for (let o = 0; o < e; o++)
    i += R9e(r);
  return i;
}
function N9e(e, ...t) {
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && (t.includes(r) || (n[r] = e[r]));
  return n;
}
var k9e = class {
  constructor() {
    z0(this, "cacheApi"), z0(this, "cacheStore"), z0(this, "subscribers", []), z0(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = vF, t = !1;
    Rb() && (e = window.REACT_INLINESVG_CACHE_NAME ?? vF, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n, this.isReady = !0, this.subscribers.forEach((r) => r());
    }).catch((n) => {
      this.isReady = !0, console.error(`Failed to open cache: ${n.message}`);
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === jn.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === jn.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: jn.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: jn.LOADING });
      try {
        const r = await KY(e, t);
        this.cacheStore.set(e, { content: r, status: jn.LOADED });
      } catch (r) {
        throw this.cacheStore.set(e, { content: "", status: jn.FAILED }), r;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var i, o, a;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === jn.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === jn.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: jn.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: jn.LOADING });
    const r = await ((i = this.cacheApi) == null ? void 0 : i.match(e));
    if (r) {
      const s = await r.text();
      this.cacheStore.set(e, { content: s, status: jn.LOADED });
      return;
    }
    try {
      await ((o = this.cacheApi) == null ? void 0 : o.add(new Request(e, t)));
      const s = await ((a = this.cacheApi) == null ? void 0 : a.match(e)), l = await (s == null ? void 0 : s.text()) ?? "";
      this.cacheStore.set(e, { content: l, status: jn.LOADED });
    } catch (s) {
      throw this.cacheStore.set(e, { content: "", status: jn.FAILED }), s;
    }
  }
  async handleLoading(e, t) {
    var r;
    let n = 0;
    for (; ((r = this.cacheStore.get(e)) == null ? void 0 : r.status) === jn.LOADING && n < yF; )
      await I9e(0.1), n += 1;
    n >= yF && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function bF(e) {
  const t = m.useRef();
  return m.useEffect(() => {
    t.current = e;
  }), t.current;
}
function L9e(e) {
  const {
    baseURL: t,
    content: n,
    description: r,
    handleError: i,
    hash: o,
    preProcessor: a,
    title: s,
    uniquifyIDs: l = !1
  } = e;
  try {
    const c = D9e(n, a), f = GY(c, { nodeOnly: !0 });
    if (!f || !(f instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const d = qY(f, { baseURL: t, hash: o, uniquifyIDs: l });
    if (r) {
      const p = d.querySelector("desc");
      p != null && p.parentNode && p.parentNode.removeChild(p);
      const g = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      g.innerHTML = r, d.prepend(g);
    }
    if (typeof s < "u") {
      const p = d.querySelector("title");
      if (p != null && p.parentNode && p.parentNode.removeChild(p), s) {
        const g = document.createElementNS("http://www.w3.org/2000/svg", "title");
        g.innerHTML = s, d.prepend(g);
      }
    }
    return d;
  } catch (c) {
    return i(c);
  }
}
function D9e(e, t) {
  return t ? t(e) : e;
}
function qY(e, t) {
  const { baseURL: n = "", hash: r, uniquifyIDs: i } = t, o = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], a = ["href", "xlink:href"], s = (l, c) => a.includes(l) && (c ? !c.includes("#") : !1);
  return i && [...e.children].forEach((l) => {
    var c;
    if ((c = l.attributes) != null && c.length) {
      const f = Object.values(l.attributes).map((d) => {
        const p = d, g = /url\((.*?)\)/.exec(d.value);
        return g != null && g[1] && (p.value = d.value.replace(g[0], `url(${n}${g[1]}__${r})`)), p;
      });
      o.forEach((d) => {
        const p = f.find((g) => g.name === d);
        p && !s(d, p.value) && (p.value = `${p.value}__${r}`);
      });
    }
    return l.children.length ? qY(l, t) : l;
  }), e;
}
var up;
function j9e(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: r,
    fetchOptions: i,
    innerRef: o,
    loader: a = null,
    onError: s,
    onLoad: l,
    src: c,
    title: f,
    uniqueHash: d
  } = e, [p, g] = m.useReducer(
    (k, F) => ({
      ...k,
      ...F
    }),
    {
      content: "",
      element: null,
      isCached: t && up.isCached(e.src),
      status: jn.IDLE
    }
  ), { content: v, element: y, isCached: x, status: b } = p, w = bF(e), S = bF(p), E = m.useRef(d ?? M9e(8)), O = m.useRef(!1), $ = m.useRef(!1), P = m.useCallback(
    (k) => {
      O.current && (g({
        status: k.message === "Browser does not support SVG" ? jn.UNSUPPORTED : jn.FAILED
      }), s == null || s(k));
    },
    [s]
  ), R = m.useCallback((k, F = !1) => {
    O.current && g({
      content: k,
      isCached: F,
      status: jn.LOADED
    });
  }, []), L = m.useCallback(async () => {
    const k = await KY(c, i);
    R(k);
  }, [i, R, c]), B = m.useCallback(() => {
    try {
      const k = L9e({ ...e, handleError: P, hash: E.current, content: v }), F = GY(k);
      if (!F || !m.isValidElement(F))
        throw new Error("Could not convert the src to a React element");
      g({
        element: F,
        status: jn.READY
      });
    } catch (k) {
      P(new Error(k.message));
    }
  }, [v, P, e]), j = m.useCallback(async () => {
    const k = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(c);
    let F;
    if (k ? F = k[1] ? window.atob(k[2]) : decodeURIComponent(k[2]) : c.includes("<svg") && (F = c), F) {
      R(F);
      return;
    }
    try {
      if (t) {
        const W = await up.get(c, i);
        R(W, !0);
      } else
        await L();
    } catch (W) {
      P(W);
    }
  }, [t, L, i, P, R, c]), A = m.useCallback(async () => {
    O.current && g({
      content: "",
      element: null,
      isCached: !1,
      status: jn.LOADING
    });
  }, []);
  m.useEffect(
    () => {
      if (O.current = !0, !Rb() || $.current)
        return () => {
        };
      try {
        if (b === jn.IDLE) {
          if (!T9e())
            throw new Error("Browser does not support SVG");
          if (!c)
            throw new Error("Missing src");
          A();
        }
      } catch (k) {
        P(k);
      }
      return $.current = !0, () => {
        O.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), m.useEffect(() => {
    if (Rb() && w)
      if (w.src !== c) {
        if (!c) {
          P(new Error("Missing src"));
          return;
        }
        A();
      } else
        (w.title !== f || w.description !== r) && B();
  }, [r, B, P, A, w, c, f]), m.useEffect(() => {
    S && (S.status !== jn.LOADING && b === jn.LOADING && j(), S.status !== jn.LOADED && b === jn.LOADED && B(), S.status !== jn.READY && b === jn.READY && (l == null || l(c, x)));
  }, [j, B, x, l, S, c, b]);
  const T = N9e(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return Rb() ? y ? m.cloneElement(y, { ref: o, ...T }) : [jn.UNSUPPORTED, jn.FAILED].includes(b) ? n : a : a;
}
function YY(e) {
  up || (up = new k9e());
  const { loader: t } = e, n = m.useRef(!1), [r, i] = m.useState(up.isReady);
  return m.useEffect(() => {
    n.current || (up.onReady(() => {
      i(!0);
    }), n.current = !0);
  }, []), r ? /* @__PURE__ */ H.jsx(j9e, { ...e }) : t;
}
const F9e = "Type something....", B9e = /* @__PURE__ */ H.jsx(WY, { component: () => /* @__PURE__ */ H.jsx(YY, { src: "/static/images/send.svg" }) }), z9e = (e) => {
  var j, A;
  const { webchatId: t, className: n, overMaxResponseTime: r, isShowJumpingDots: i } = e, o = m.useRef(null), a = wr(), s = pe(Ll), l = pe(nl), c = pe(rM), { msgPlacehold: f } = pe(Zf), d = pe(eM), p = pe(Nl), g = pe(kl), v = m.useRef(null), [y, x] = m.useState(""), [b, w] = m.useState(!1), S = i && !r || b, E = l != null && l.conversation.sendMsgBox.isBtnCircle ? "circle" : void 0, O = l != null && l.conversation.sendMsgBox.isBtnCircle ? /* @__PURE__ */ H.jsx(rC, {}) : B9e, $ = (j = l == null ? void 0 : l.conversation.sendMsgBox) == null ? void 0 : j.custom, P = (A = l == null ? void 0 : l.conversation.textArea) == null ? void 0 : A.custom, R = c === Jo.SiteCompanion && [Jt.siteCompanion, Jt.siteCompanionPopup].includes(s), L = () => {
    try {
      if (!y || !y.trim())
        return;
      const T = {
        domain: window.location.hostname,
        incoming_message_url: window.location.href
      };
      w(!0), a(
        Mh({
          webchatId: t,
          content: y.trim(),
          publisher: T,
          contentType: $u.Message
        })
      ), x(""), setTimeout(() => {
        a(Qs(!0)), w(!1);
      }, R ? 0 : 2e3);
    } catch {
      w(!1);
    }
  }, B = (T) => {
    S || T.key !== "Enter" || (T.preventDefault(), L());
  };
  return m.useEffect(() => {
    d || g || !p || s === Jt.siteCompanion || setTimeout(() => {
      var T;
      (T = v.current) == null || T.focus();
    }, 300);
  }, [d, g, p]), /* @__PURE__ */ H.jsx("div", { ref: o, className: `${n}`, style: $, children: /* @__PURE__ */ H.jsxs("div", { className: "styled-inner", children: [
    /* @__PURE__ */ H.jsx(
      rG,
      {
        className: "styled-text-area",
        ref: v,
        style: P,
        placeholder: f ?? F9e,
        onKeyDown: B,
        value: y,
        maxLength: 500,
        onChange: (T) => x(T.target.value),
        onClick: (T) => {
          g && (a(Kg(!1)), setTimeout(() => {
            T.target.focus();
          }, 310));
        }
      }
    ),
    ((l == null ? void 0 : l.conversation.sendMsgBox.showSentBtn) ?? !0) && /* @__PURE__ */ H.jsx(
      zi,
      {
        className: "styled-button",
        type: "link",
        size: "middle",
        shape: E,
        icon: O,
        onClick: L,
        disabled: S,
        style: S ? { opacity: 0.4 } : {}
      }
    )
  ] }) });
}, U9e = m.memo(z9e), H9e = Ut.div`
  .webchat-disclaimer-wrapper {
    position: sticky;
    width: 100%;
    left: 0px;
    z-index: 9999;
    display: block;
    background: #fff3cf;
    top: 0px;
    text-align: center;
    color: #4d4d4d;
    padding-left: 10px;
    height: 40px;
  }
  .webchat-disclaimer-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }
  .webchat-disclaimer-text {
    font-size: 0.8rem;
    line-height: 0.9rem;
    max-height: 40px;
    text-align: left;
    padding: 0;
    margin: 0;
    width: 368px;
  }
`, { Paragraph: W9e } = xh, wF = () => {
  const e = pe(nM), t = pe(M2e), n = wr(), r = pe(nl), i = () => {
    t || n(Q2e());
  };
  return !e || (r == null ? void 0 : r.disclaimers.display) === !1 ? /* @__PURE__ */ H.jsx(H.Fragment, {}) : /* @__PURE__ */ H.jsx(H9e, { children: /* @__PURE__ */ H.jsx("div", { className: "webchat-disclaimer-wrapper", children: /* @__PURE__ */ H.jsxs("div", { className: "webchat-disclaimer-content", children: [
    /* @__PURE__ */ H.jsx(W9e, { ellipsis: { rows: 2, expandable: !1 }, className: "webchat-disclaimer-text", children: /* @__PURE__ */ H.jsx("div", { dangerouslySetInnerHTML: { __html: e } }) }),
    !t && /* @__PURE__ */ H.jsx(
      AM,
      {
        style: { cursor: "pointer", padding: "13px" },
        onClick: i
      }
    )
  ] }) }) });
}, V9e = jq`
  from {
    transform: scaleY(0);
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
`, G9e = jq`
  from {
    transform: scaleY(1);
    opacity: 1;
  }
  to {
    transform: scaleY(0);
    opacity: 0;
  }
`, K9e = Ut.div`
  display: flex;
  justify-content: center;

  .user-action-box {
    display: flex;
    flex-direction: column;
    background: #f5f5f5;
    width: 384px;
    padding: 12px 20px;
    margin: 12px 20px;
    border-radius: 8px;
    height: 116px;
    overflow: hidden;
    transform-origin: bottom;

    animation: ${({ $isShownUserActionBox: e }) => e ? V9e : G9e}
      0.3s ease-in-out;
    transform: ${({ $isShownUserActionBox: e }) => e ? "scaleY(1)" : "scaleY(0)"};
    opacity: ${({ $isShownUserActionBox: e }) => e ? "1" : "0"};

    .user-action-content-container {
      display: flex;
      flex-grow: 1;
    }

    .user-action-content {
      color: #333333;
      flex-grow: 1;
      word-break: break-all;
      max-height: 48px;
      overflow-y: hidden;
      padding-right: 8px;
    }

    .close-icon {
      color: #d1d5db;
    }

    .action-button {
      margin-top: 12px;
      border-radius: 8px;
    }
  }
`, q9e = (e) => {
  const t = wr(), n = pe(ed), r = pe(td), {
    showUserActionBox: i,
    userActionBoxInfo: o,
    isUserCloseActionBox: a,
    isUserSignUpIntentDetected: s,
    sendUserActionBoxMessage: l,
    getUserActionBoxInfo: c
  } = Gze(), f = () => {
    t(V6(!0));
  }, d = (p) => {
    p && (l(p), t(V6(!0)));
  };
  return m.useEffect(() => {
    !a && s && c();
  }, [a, s]), i ? /* @__PURE__ */ H.jsx(K9e, { $isShownUserActionBox: i, children: /* @__PURE__ */ H.jsxs("div", { className: "user-action-box", children: [
    /* @__PURE__ */ H.jsxs("div", { className: "user-action-content-container", children: [
      /* @__PURE__ */ H.jsx("div", { className: "user-action-content", children: o.content }),
      /* @__PURE__ */ H.jsx("div", { children: /* @__PURE__ */ H.jsx(AM, { className: "close-icon", onClick: f }) })
    ] }),
    /* @__PURE__ */ H.jsx(
      zi,
      {
        style: { background: n, color: r },
        className: "action-button",
        onClick: () => d(o.value),
        children: o.buttonText
      }
    )
  ] }) }) : /* @__PURE__ */ H.jsx(H.Fragment, {});
}, SF = Ut.div`
  background-color: ${(e) => e.$styles.backgroundColor};
  height: 100%;

  .network-status {
    position: sticky;
    width: 100%;
    padding: 5px;
    height: 30px;
    left: 0px;
    z-index: 9999;
    display: block;
    background: #f9f8f8fa;
    top: 0px;
    text-align: center;
    opacity: 0.5;
  }
`, xF = Ut(U9e)`
  height: ${(e) => e.$styles.height};
  overflow: visible;
  z-index: 1;
  position: relative;
  padding: ${(e) => e.$styles.padding};

  .ant-btn-link {
    color: ${(e) => e.$styles.sentBtnColor};
    padding-top: 0;
    padding-bottom: 0;
  }

  #sendIcon {
    fill: ${(e) => e.$styles.sentBtnColor};
  }

  .ant-btn-icon {
    ${(e) => e.$styles.isSendBtnCircle ? `
    vertical-align: middle;
    margin-right: -1px;
    ` : ""}
  }

  .ant-btn.ant-btn-icon-only .anticon {
    font-size: ${(e) => e.$styles.isSendBtnCircle ? "14px" : "18px"};
  }

  .styled-inner {
    position: relative;
  }

  .ant-btn-icon {
    vertical-align: middle;
  }

  .styled-text-area {
    padding: ${(e) => e.$styles.textAreaPadding};
    position: relative;
    background: #f5f5f5;
    width: 100%;
    margin: 0 auto;
    height: ${(e) => e.$styles.textAreaHeight};
    border: none;
    border-radius: 8px;
    font-size: 16px; /* to prevent safari focus zoom in problem */

    &:focus {
      box-shadow: none;
      outline: none;
      font-size: 16px; /* to prevent safari focus zoom in problem */
    }
  }

  .styled-button {
    position: absolute;
    right: ${(e) => e.$styles.sendBtnRight};
    top: 50%;
    margin-top: -16px;
    ${(e) => e.$styles.isSendBtnCircle ? `
    color: white;
    background-color: ${e.$styles.sentBtnColor};
    border-color: ${e.$styles.sentBtnColor};

    &:hover {
      color: white !important;
      background-color: ${e.$styles.sentBtnColor} !important;
      border-color: ${e.$styles.sentBtnColor} !important;
    }
    ` : `
    color: ${e.$styles.sentBtnColor};

    &:hover {
      color: ${e.$styles.sentBtnColor} !important;
    }
    `}
  }
`, CF = (e) => {
  const { theme: t, showDotByRandomTime: n, isShowJumpingDots: r, overMaxResponseTime: i } = e, o = wr(), a = pe(Tv), s = pe(cq), l = pe(rl), c = pe(tM), f = pe(R2e), d = pe(Nl), p = pe(kl), { current: g } = ms(), v = g(), y = v == null ? void 0 : v.uuid, { themeStyle: x } = Kf(), { footerStyles: b, conversationContainerDivStyles: w } = U2e({ themeStyle: x }), S = m.useRef(!1), E = m.useRef(!1), O = t === Jt.siteCompanionPopup, $ = sp.isFeatureEnabled(), P = Ix.isFeatureEnabled(), R = () => {
    o(Qs(!0)), O || (S.current = !0, setTimeout(() => {
      S.current = !1;
    }, 2e3 + Math.random() * 1e3));
    try {
      const j = {
        publisher: {
          domain: window.location.hostname,
          conversation_created_url: window.location.href
        }
      };
      o(vY({ webchatId: a, payload: j })), rt.info("[ui] conversation container ready");
    } catch (B) {
      rt.error("[ui] conversation container failed", B.message);
    }
  }, L = (B, j) => {
    if (S.current) {
      setTimeout(() => {
        L(B, j);
      }, 500);
      return;
    }
    o(Qs(!1));
    const A = Math.floor(Math.random() * j.length);
    o(
      h8e({
        content: j[A],
        conversationId: B
      })
    );
  };
  return m.useEffect(() => {
    $ || !d || y || R();
  }, [y, d]), m.useEffect(() => {
    $ && (y || R());
  }, [y]), m.useEffect(() => {
    !y || !(s != null && s.length) || l.length || !d && !O || L(y, s);
  }, [y, s, l, d]), m.useEffect(() => {
    if (E.current || !l.length || !y)
      return;
    E.current = !0;
    let B = 0;
    Nr.create().postEventToParent(sn.CONVERSATION_CREATED, a);
    const j = setInterval(() => {
      B++ > 4 && clearInterval(j), Nr.create().postEventToParent(sn.CONVERSATION_CREATED, a);
    }, 1e3);
  }, [y, l]), p ? /* @__PURE__ */ H.jsxs(SF, { $styles: w, children: [
    /* @__PURE__ */ H.jsx(
      hF,
      {
        webchatId: a,
        showDotByRandomTime: n,
        isShowJumpingDots: r,
        overMaxResponseTime: i
      }
    ),
    /* @__PURE__ */ H.jsx(
      xF,
      {
        webchatId: a,
        $styles: b,
        overMaxResponseTime: i,
        isShowJumpingDots: r
      }
    )
  ] }) : /* @__PURE__ */ H.jsxs(SF, { $styles: w, children: [
    !c && /* @__PURE__ */ H.jsx("div", { className: "network-status", children: " Network Unstable " }),
    f === Af.top && /* @__PURE__ */ H.jsx(wF, {}),
    /* @__PURE__ */ H.jsx(
      hF,
      {
        webchatId: a,
        showDotByRandomTime: n,
        isShowJumpingDots: r,
        overMaxResponseTime: i
      }
    ),
    P && /* @__PURE__ */ H.jsx(q9e, { theme: t }),
    /* @__PURE__ */ H.jsx(
      xF,
      {
        webchatId: a,
        $styles: b,
        overMaxResponseTime: i,
        isShowJumpingDots: r
      }
    ),
    f === Af.bottom && /* @__PURE__ */ H.jsx(wF, {})
  ] });
};
var XY = { exports: {} };
/*!
 * Pusher JavaScript Library v8.3.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */
(function(e, t) {
  (function(r, i) {
    e.exports = i();
  })(window, function() {
    return (
      /******/
      function(n) {
        var r = {};
        function i(o) {
          if (r[o])
            return r[o].exports;
          var a = r[o] = {
            /******/
            i: o,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return n[o].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
        }
        return i.m = n, i.c = r, i.d = function(o, a, s) {
          i.o(o, a) || Object.defineProperty(o, a, { enumerable: !0, get: s });
        }, i.r = function(o) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
        }, i.t = function(o, a) {
          if (a & 1 && (o = i(o)), a & 8 || a & 4 && typeof o == "object" && o && o.__esModule)
            return o;
          var s = /* @__PURE__ */ Object.create(null);
          if (i.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: o }), a & 2 && typeof o != "string")
            for (var l in o)
              i.d(s, l, (function(c) {
                return o[c];
              }).bind(null, l));
          return s;
        }, i.n = function(o) {
          var a = o && o.__esModule ? (
            /******/
            function() {
              return o.default;
            }
          ) : (
            /******/
            function() {
              return o;
            }
          );
          return i.d(a, "a", a), a;
        }, i.o = function(o, a) {
          return Object.prototype.hasOwnProperty.call(o, a);
        }, i.p = "", i(i.s = 2);
      }([
        /* 0 */
        /***/
        function(n, r, i) {
          var o = this && this.__extends || /* @__PURE__ */ function() {
            var y = function(x, b) {
              return y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, S) {
                w.__proto__ = S;
              } || function(w, S) {
                for (var E in S)
                  S.hasOwnProperty(E) && (w[E] = S[E]);
              }, y(x, b);
            };
            return function(x, b) {
              y(x, b);
              function w() {
                this.constructor = x;
              }
              x.prototype = b === null ? Object.create(b) : (w.prototype = b.prototype, new w());
            };
          }();
          Object.defineProperty(r, "__esModule", { value: !0 });
          var a = 256, s = (
            /** @class */
            function() {
              function y(x) {
                x === void 0 && (x = "="), this._paddingCharacter = x;
              }
              return y.prototype.encodedLength = function(x) {
                return this._paddingCharacter ? (x + 2) / 3 * 4 | 0 : (x * 8 + 5) / 6 | 0;
              }, y.prototype.encode = function(x) {
                for (var b = "", w = 0; w < x.length - 2; w += 3) {
                  var S = x[w] << 16 | x[w + 1] << 8 | x[w + 2];
                  b += this._encodeByte(S >>> 3 * 6 & 63), b += this._encodeByte(S >>> 2 * 6 & 63), b += this._encodeByte(S >>> 1 * 6 & 63), b += this._encodeByte(S >>> 0 * 6 & 63);
                }
                var E = x.length - w;
                if (E > 0) {
                  var S = x[w] << 16 | (E === 2 ? x[w + 1] << 8 : 0);
                  b += this._encodeByte(S >>> 3 * 6 & 63), b += this._encodeByte(S >>> 2 * 6 & 63), E === 2 ? b += this._encodeByte(S >>> 1 * 6 & 63) : b += this._paddingCharacter || "", b += this._paddingCharacter || "";
                }
                return b;
              }, y.prototype.maxDecodedLength = function(x) {
                return this._paddingCharacter ? x / 4 * 3 | 0 : (x * 6 + 7) / 8 | 0;
              }, y.prototype.decodedLength = function(x) {
                return this.maxDecodedLength(x.length - this._getPaddingLength(x));
              }, y.prototype.decode = function(x) {
                if (x.length === 0)
                  return new Uint8Array(0);
                for (var b = this._getPaddingLength(x), w = x.length - b, S = new Uint8Array(this.maxDecodedLength(w)), E = 0, O = 0, $ = 0, P = 0, R = 0, L = 0, B = 0; O < w - 4; O += 4)
                  P = this._decodeChar(x.charCodeAt(O + 0)), R = this._decodeChar(x.charCodeAt(O + 1)), L = this._decodeChar(x.charCodeAt(O + 2)), B = this._decodeChar(x.charCodeAt(O + 3)), S[E++] = P << 2 | R >>> 4, S[E++] = R << 4 | L >>> 2, S[E++] = L << 6 | B, $ |= P & a, $ |= R & a, $ |= L & a, $ |= B & a;
                if (O < w - 1 && (P = this._decodeChar(x.charCodeAt(O)), R = this._decodeChar(x.charCodeAt(O + 1)), S[E++] = P << 2 | R >>> 4, $ |= P & a, $ |= R & a), O < w - 2 && (L = this._decodeChar(x.charCodeAt(O + 2)), S[E++] = R << 4 | L >>> 2, $ |= L & a), O < w - 3 && (B = this._decodeChar(x.charCodeAt(O + 3)), S[E++] = L << 6 | B, $ |= B & a), $ !== 0)
                  throw new Error("Base64Coder: incorrect characters for decoding");
                return S;
              }, y.prototype._encodeByte = function(x) {
                var b = x;
                return b += 65, b += 25 - x >>> 8 & 6, b += 51 - x >>> 8 & -75, b += 61 - x >>> 8 & -15, b += 62 - x >>> 8 & 3, String.fromCharCode(b);
              }, y.prototype._decodeChar = function(x) {
                var b = a;
                return b += (42 - x & x - 44) >>> 8 & -a + x - 43 + 62, b += (46 - x & x - 48) >>> 8 & -a + x - 47 + 63, b += (47 - x & x - 58) >>> 8 & -a + x - 48 + 52, b += (64 - x & x - 91) >>> 8 & -a + x - 65 + 0, b += (96 - x & x - 123) >>> 8 & -a + x - 97 + 26, b;
              }, y.prototype._getPaddingLength = function(x) {
                var b = 0;
                if (this._paddingCharacter) {
                  for (var w = x.length - 1; w >= 0 && x[w] === this._paddingCharacter; w--)
                    b++;
                  if (x.length < 4 || b > 2)
                    throw new Error("Base64Coder: incorrect padding");
                }
                return b;
              }, y;
            }()
          );
          r.Coder = s;
          var l = new s();
          function c(y) {
            return l.encode(y);
          }
          r.encode = c;
          function f(y) {
            return l.decode(y);
          }
          r.decode = f;
          var d = (
            /** @class */
            function(y) {
              o(x, y);
              function x() {
                return y !== null && y.apply(this, arguments) || this;
              }
              return x.prototype._encodeByte = function(b) {
                var w = b;
                return w += 65, w += 25 - b >>> 8 & 6, w += 51 - b >>> 8 & -75, w += 61 - b >>> 8 & -13, w += 62 - b >>> 8 & 49, String.fromCharCode(w);
              }, x.prototype._decodeChar = function(b) {
                var w = a;
                return w += (44 - b & b - 46) >>> 8 & -a + b - 45 + 62, w += (94 - b & b - 96) >>> 8 & -a + b - 95 + 63, w += (47 - b & b - 58) >>> 8 & -a + b - 48 + 52, w += (64 - b & b - 91) >>> 8 & -a + b - 65 + 0, w += (96 - b & b - 123) >>> 8 & -a + b - 97 + 26, w;
              }, x;
            }(s)
          );
          r.URLSafeCoder = d;
          var p = new d();
          function g(y) {
            return p.encode(y);
          }
          r.encodeURLSafe = g;
          function v(y) {
            return p.decode(y);
          }
          r.decodeURLSafe = v, r.encodedLength = function(y) {
            return l.encodedLength(y);
          }, r.maxDecodedLength = function(y) {
            return l.maxDecodedLength(y);
          }, r.decodedLength = function(y) {
            return l.decodedLength(y);
          };
        },
        /* 1 */
        /***/
        function(n, r, i) {
          Object.defineProperty(r, "__esModule", { value: !0 });
          var o = "utf8: invalid string", a = "utf8: invalid source encoding";
          function s(f) {
            for (var d = new Uint8Array(l(f)), p = 0, g = 0; g < f.length; g++) {
              var v = f.charCodeAt(g);
              v < 128 ? d[p++] = v : v < 2048 ? (d[p++] = 192 | v >> 6, d[p++] = 128 | v & 63) : v < 55296 ? (d[p++] = 224 | v >> 12, d[p++] = 128 | v >> 6 & 63, d[p++] = 128 | v & 63) : (g++, v = (v & 1023) << 10, v |= f.charCodeAt(g) & 1023, v += 65536, d[p++] = 240 | v >> 18, d[p++] = 128 | v >> 12 & 63, d[p++] = 128 | v >> 6 & 63, d[p++] = 128 | v & 63);
            }
            return d;
          }
          r.encode = s;
          function l(f) {
            for (var d = 0, p = 0; p < f.length; p++) {
              var g = f.charCodeAt(p);
              if (g < 128)
                d += 1;
              else if (g < 2048)
                d += 2;
              else if (g < 55296)
                d += 3;
              else if (g <= 57343) {
                if (p >= f.length - 1)
                  throw new Error(o);
                p++, d += 4;
              } else
                throw new Error(o);
            }
            return d;
          }
          r.encodedLength = l;
          function c(f) {
            for (var d = [], p = 0; p < f.length; p++) {
              var g = f[p];
              if (g & 128) {
                var v = void 0;
                if (g < 224) {
                  if (p >= f.length)
                    throw new Error(a);
                  var y = f[++p];
                  if ((y & 192) !== 128)
                    throw new Error(a);
                  g = (g & 31) << 6 | y & 63, v = 128;
                } else if (g < 240) {
                  if (p >= f.length - 1)
                    throw new Error(a);
                  var y = f[++p], x = f[++p];
                  if ((y & 192) !== 128 || (x & 192) !== 128)
                    throw new Error(a);
                  g = (g & 15) << 12 | (y & 63) << 6 | x & 63, v = 2048;
                } else if (g < 248) {
                  if (p >= f.length - 2)
                    throw new Error(a);
                  var y = f[++p], x = f[++p], b = f[++p];
                  if ((y & 192) !== 128 || (x & 192) !== 128 || (b & 192) !== 128)
                    throw new Error(a);
                  g = (g & 15) << 18 | (y & 63) << 12 | (x & 63) << 6 | b & 63, v = 65536;
                } else
                  throw new Error(a);
                if (g < v || g >= 55296 && g <= 57343)
                  throw new Error(a);
                if (g >= 65536) {
                  if (g > 1114111)
                    throw new Error(a);
                  g -= 65536, d.push(String.fromCharCode(55296 | g >> 10)), g = 56320 | g & 1023;
                }
              }
              d.push(String.fromCharCode(g));
            }
            return d.join("");
          }
          r.decode = c;
        },
        /* 2 */
        /***/
        function(n, r, i) {
          n.exports = i(3).default;
        },
        /* 3 */
        /***/
        function(n, r, i) {
          i.r(r);
          class o {
            constructor(_, M) {
              this.lastId = 0, this.prefix = _, this.name = M;
            }
            create(_) {
              this.lastId++;
              var M = this.lastId, Y = this.prefix + M, Q = this.name + "[" + M + "]", $e = !1, Ke = function() {
                $e || (_.apply(null, arguments), $e = !0);
              };
              return this[M] = Ke, { number: M, id: Y, name: Q, callback: Ke };
            }
            remove(_) {
              delete this[_.number];
            }
          }
          var a = new o("_pusher_script_", "Pusher.ScriptReceivers"), s = {
            VERSION: "8.3.0",
            PROTOCOL: 7,
            wsPort: 80,
            wssPort: 443,
            wsPath: "",
            httpHost: "sockjs.pusher.com",
            httpPort: 80,
            httpsPort: 443,
            httpPath: "/pusher",
            stats_host: "stats.pusher.com",
            authEndpoint: "/pusher/auth",
            authTransport: "ajax",
            activityTimeout: 12e4,
            pongTimeout: 3e4,
            unavailableTimeout: 1e4,
            userAuthentication: {
              endpoint: "/pusher/user-auth",
              transport: "ajax"
            },
            channelAuthorization: {
              endpoint: "/pusher/auth",
              transport: "ajax"
            },
            cdn_http: "http://js.pusher.com",
            cdn_https: "https://js.pusher.com",
            dependency_suffix: ""
          }, l = s;
          class c {
            constructor(_) {
              this.options = _, this.receivers = _.receivers || a, this.loading = {};
            }
            load(_, M, Y) {
              var Q = this;
              if (Q.loading[_] && Q.loading[_].length > 0)
                Q.loading[_].push(Y);
              else {
                Q.loading[_] = [Y];
                var $e = ot.createScriptRequest(Q.getPath(_, M)), Ke = Q.receivers.create(function(dt) {
                  if (Q.receivers.remove(Ke), Q.loading[_]) {
                    var Bt = Q.loading[_];
                    delete Q.loading[_];
                    for (var vn = function(xr) {
                      xr || $e.cleanup();
                    }, xn = 0; xn < Bt.length; xn++)
                      Bt[xn](dt, vn);
                  }
                });
                $e.send(Ke);
              }
            }
            getRoot(_) {
              var M, Y = ot.getDocument().location.protocol;
              return _ && _.useTLS || Y === "https:" ? M = this.options.cdn_https : M = this.options.cdn_http, M.replace(/\/*$/, "") + "/" + this.options.version;
            }
            getPath(_, M) {
              return this.getRoot(M) + "/" + _ + this.options.suffix + ".js";
            }
          }
          var f = new o("_pusher_dependencies", "Pusher.DependenciesReceivers"), d = new c({
            cdn_http: l.cdn_http,
            cdn_https: l.cdn_https,
            version: l.VERSION,
            suffix: l.dependency_suffix,
            receivers: f
          });
          const p = {
            baseUrl: "https://pusher.com",
            urls: {
              authenticationEndpoint: {
                path: "/docs/channels/server_api/authenticating_users"
              },
              authorizationEndpoint: {
                path: "/docs/channels/server_api/authorizing-users/"
              },
              javascriptQuickStart: {
                path: "/docs/javascript_quick_start"
              },
              triggeringClientEvents: {
                path: "/docs/client_api_guide/client_events#trigger-events"
              },
              encryptedChannelSupport: {
                fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
              }
            }
          };
          var v = { buildLogSuffix: function(N) {
            const _ = "See:", M = p.urls[N];
            if (!M)
              return "";
            let Y;
            return M.fullUrl ? Y = M.fullUrl : M.path && (Y = p.baseUrl + M.path), Y ? `${_} ${Y}` : "";
          } }, y;
          (function(N) {
            N.UserAuthentication = "user-authentication", N.ChannelAuthorization = "channel-authorization";
          })(y || (y = {}));
          class x extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class b extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class w extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class S extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class E extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class O extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class $ extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class P extends Error {
            constructor(_) {
              super(_), Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          class R extends Error {
            constructor(_, M) {
              super(M), this.status = _, Object.setPrototypeOf(this, new.target.prototype);
            }
          }
          var B = function(N, _, M, Y, Q) {
            const $e = ot.createXHR();
            $e.open("POST", M.endpoint, !0), $e.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            for (var Ke in M.headers)
              $e.setRequestHeader(Ke, M.headers[Ke]);
            if (M.headersProvider != null) {
              let dt = M.headersProvider();
              for (var Ke in dt)
                $e.setRequestHeader(Ke, dt[Ke]);
            }
            return $e.onreadystatechange = function() {
              if ($e.readyState === 4)
                if ($e.status === 200) {
                  let dt, Bt = !1;
                  try {
                    dt = JSON.parse($e.responseText), Bt = !0;
                  } catch {
                    Q(new R(200, `JSON returned from ${Y.toString()} endpoint was invalid, yet status code was 200. Data was: ${$e.responseText}`), null);
                  }
                  Bt && Q(null, dt);
                } else {
                  let dt = "";
                  switch (Y) {
                    case y.UserAuthentication:
                      dt = v.buildLogSuffix("authenticationEndpoint");
                      break;
                    case y.ChannelAuthorization:
                      dt = `Clients must be authorized to join private or presence channels. ${v.buildLogSuffix("authorizationEndpoint")}`;
                      break;
                  }
                  Q(new R($e.status, `Unable to retrieve auth string from ${Y.toString()} endpoint - received status: ${$e.status} from ${M.endpoint}. ${dt}`), null);
                }
            }, $e.send(_), $e;
          };
          function j(N) {
            return V(F(N));
          }
          var A = String.fromCharCode, T = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", k = function(N) {
            var _ = N.charCodeAt(0);
            return _ < 128 ? N : _ < 2048 ? A(192 | _ >>> 6) + A(128 | _ & 63) : A(224 | _ >>> 12 & 15) + A(128 | _ >>> 6 & 63) + A(128 | _ & 63);
          }, F = function(N) {
            return N.replace(/[^\x00-\x7F]/g, k);
          }, W = function(N) {
            var _ = [0, 2, 1][N.length % 3], M = N.charCodeAt(0) << 16 | (N.length > 1 ? N.charCodeAt(1) : 0) << 8 | (N.length > 2 ? N.charCodeAt(2) : 0), Y = [
              T.charAt(M >>> 18),
              T.charAt(M >>> 12 & 63),
              _ >= 2 ? "=" : T.charAt(M >>> 6 & 63),
              _ >= 1 ? "=" : T.charAt(M & 63)
            ];
            return Y.join("");
          }, V = window.btoa || function(N) {
            return N.replace(/[\s\S]{1,3}/g, W);
          };
          class G {
            constructor(_, M, Y, Q) {
              this.clear = M, this.timer = _(() => {
                this.timer && (this.timer = Q(this.timer));
              }, Y);
            }
            isRunning() {
              return this.timer !== null;
            }
            ensureAborted() {
              this.timer && (this.clear(this.timer), this.timer = null);
            }
          }
          var X = G;
          function D(N) {
            window.clearTimeout(N);
          }
          function te(N) {
            window.clearInterval(N);
          }
          class ee extends X {
            constructor(_, M) {
              super(setTimeout, D, _, function(Y) {
                return M(), null;
              });
            }
          }
          class U extends X {
            constructor(_, M) {
              super(setInterval, te, _, function(Y) {
                return M(), Y;
              });
            }
          }
          var he = {
            now() {
              return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).valueOf();
            },
            defer(N) {
              return new ee(0, N);
            },
            method(N, ..._) {
              var M = Array.prototype.slice.call(arguments, 1);
              return function(Y) {
                return Y[N].apply(Y, M.concat(arguments));
              };
            }
          }, re = he;
          function de(N, ..._) {
            for (var M = 0; M < _.length; M++) {
              var Y = _[M];
              for (var Q in Y)
                Y[Q] && Y[Q].constructor && Y[Q].constructor === Object ? N[Q] = de(N[Q] || {}, Y[Q]) : N[Q] = Y[Q];
            }
            return N;
          }
          function we() {
            for (var N = ["Pusher"], _ = 0; _ < arguments.length; _++)
              typeof arguments[_] == "string" ? N.push(arguments[_]) : N.push(Le(arguments[_]));
            return N.join(" : ");
          }
          function ue(N, _) {
            var M = Array.prototype.indexOf;
            if (N === null)
              return -1;
            if (M && N.indexOf === M)
              return N.indexOf(_);
            for (var Y = 0, Q = N.length; Y < Q; Y++)
              if (N[Y] === _)
                return Y;
            return -1;
          }
          function me(N, _) {
            for (var M in N)
              Object.prototype.hasOwnProperty.call(N, M) && _(N[M], M, N);
          }
          function Se(N) {
            var _ = [];
            return me(N, function(M, Y) {
              _.push(Y);
            }), _;
          }
          function _e(N) {
            var _ = [];
            return me(N, function(M) {
              _.push(M);
            }), _;
          }
          function Ge(N, _, M) {
            for (var Y = 0; Y < N.length; Y++)
              _.call(M || window, N[Y], Y, N);
          }
          function Fe(N, _) {
            for (var M = [], Y = 0; Y < N.length; Y++)
              M.push(_(N[Y], Y, N, M));
            return M;
          }
          function Ae(N, _) {
            var M = {};
            return me(N, function(Y, Q) {
              M[Q] = _(Y);
            }), M;
          }
          function Me(N, _) {
            _ = _ || function(Q) {
              return !!Q;
            };
            for (var M = [], Y = 0; Y < N.length; Y++)
              _(N[Y], Y, N, M) && M.push(N[Y]);
            return M;
          }
          function et(N, _) {
            var M = {};
            return me(N, function(Y, Q) {
              (_ && _(Y, Q, N, M) || Y) && (M[Q] = Y);
            }), M;
          }
          function De(N) {
            var _ = [];
            return me(N, function(M, Y) {
              _.push([Y, M]);
            }), _;
          }
          function je(N, _) {
            for (var M = 0; M < N.length; M++)
              if (_(N[M], M, N))
                return !0;
            return !1;
          }
          function ie(N, _) {
            for (var M = 0; M < N.length; M++)
              if (!_(N[M], M, N))
                return !1;
            return !0;
          }
          function fe(N) {
            return Ae(N, function(_) {
              return typeof _ == "object" && (_ = Le(_)), encodeURIComponent(j(_.toString()));
            });
          }
          function be(N) {
            var _ = et(N, function(Y) {
              return Y !== void 0;
            }), M = Fe(De(fe(_)), re.method("join", "=")).join("&");
            return M;
          }
          function Te(N) {
            var _ = [], M = [];
            return function Y(Q, $e) {
              var Ke, dt, Bt;
              switch (typeof Q) {
                case "object":
                  if (!Q)
                    return null;
                  for (Ke = 0; Ke < _.length; Ke += 1)
                    if (_[Ke] === Q)
                      return { $ref: M[Ke] };
                  if (_.push(Q), M.push($e), Object.prototype.toString.apply(Q) === "[object Array]")
                    for (Bt = [], Ke = 0; Ke < Q.length; Ke += 1)
                      Bt[Ke] = Y(Q[Ke], $e + "[" + Ke + "]");
                  else {
                    Bt = {};
                    for (dt in Q)
                      Object.prototype.hasOwnProperty.call(Q, dt) && (Bt[dt] = Y(Q[dt], $e + "[" + JSON.stringify(dt) + "]"));
                  }
                  return Bt;
                case "number":
                case "string":
                case "boolean":
                  return Q;
              }
            }(N, "$");
          }
          function Le(N) {
            try {
              return JSON.stringify(N);
            } catch {
              return JSON.stringify(Te(N));
            }
          }
          class ct {
            constructor() {
              this.globalLog = (_) => {
                window.console && window.console.log && window.console.log(_);
              };
            }
            debug(..._) {
              this.log(this.globalLog, _);
            }
            warn(..._) {
              this.log(this.globalLogWarn, _);
            }
            error(..._) {
              this.log(this.globalLogError, _);
            }
            globalLogWarn(_) {
              window.console && window.console.warn ? window.console.warn(_) : this.globalLog(_);
            }
            globalLogError(_) {
              window.console && window.console.error ? window.console.error(_) : this.globalLogWarn(_);
            }
            log(_, ...M) {
              var Y = we.apply(this, arguments);
              Bu.log ? Bu.log(Y) : Bu.logToConsole && _.bind(this)(Y);
            }
          }
          var Z = new ct(), se = function(N, _, M, Y, Q) {
            (M.headers !== void 0 || M.headersProvider != null) && Z.warn(`To send headers with the ${Y.toString()} request, you must use AJAX, rather than JSONP.`);
            var $e = N.nextAuthCallbackID.toString();
            N.nextAuthCallbackID++;
            var Ke = N.getDocument(), dt = Ke.createElement("script");
            N.auth_callbacks[$e] = function(xn) {
              Q(null, xn);
            };
            var Bt = "Pusher.auth_callbacks['" + $e + "']";
            dt.src = M.endpoint + "?callback=" + encodeURIComponent(Bt) + "&" + _;
            var vn = Ke.getElementsByTagName("head")[0] || Ke.documentElement;
            vn.insertBefore(dt, vn.firstChild);
          }, Ce = se;
          class Pe {
            constructor(_) {
              this.src = _;
            }
            send(_) {
              var M = this, Y = "Error loading " + M.src;
              M.script = document.createElement("script"), M.script.id = _.id, M.script.src = M.src, M.script.type = "text/javascript", M.script.charset = "UTF-8", M.script.addEventListener ? (M.script.onerror = function() {
                _.callback(Y);
              }, M.script.onload = function() {
                _.callback(null);
              }) : M.script.onreadystatechange = function() {
                (M.script.readyState === "loaded" || M.script.readyState === "complete") && _.callback(null);
              }, M.script.async === void 0 && document.attachEvent && /opera/i.test(navigator.userAgent) ? (M.errorScript = document.createElement("script"), M.errorScript.id = _.id + "_error", M.errorScript.text = _.name + "('" + Y + "');", M.script.async = M.errorScript.async = !1) : M.script.async = !0;
              var Q = document.getElementsByTagName("head")[0];
              Q.insertBefore(M.script, Q.firstChild), M.errorScript && Q.insertBefore(M.errorScript, M.script.nextSibling);
            }
            cleanup() {
              this.script && (this.script.onload = this.script.onerror = null, this.script.onreadystatechange = null), this.script && this.script.parentNode && this.script.parentNode.removeChild(this.script), this.errorScript && this.errorScript.parentNode && this.errorScript.parentNode.removeChild(this.errorScript), this.script = null, this.errorScript = null;
            }
          }
          class Ee {
            constructor(_, M) {
              this.url = _, this.data = M;
            }
            send(_) {
              if (!this.request) {
                var M = be(this.data), Y = this.url + "/" + _.number + "?" + M;
                this.request = ot.createScriptRequest(Y), this.request.send(_);
              }
            }
            cleanup() {
              this.request && this.request.cleanup();
            }
          }
          var We = function(N, _) {
            return function(M, Y) {
              var Q = "http" + (_ ? "s" : "") + "://", $e = Q + (N.host || N.options.host) + N.options.path, Ke = ot.createJSONPRequest($e, M), dt = ot.ScriptReceivers.create(function(Bt, vn) {
                a.remove(dt), Ke.cleanup(), vn && vn.host && (N.host = vn.host), Y && Y(Bt, vn);
              });
              Ke.send(dt);
            };
          }, ze = {
            name: "jsonp",
            getAgent: We
          }, Ye = ze;
          function xt(N, _, M) {
            var Y = N + (_.useTLS ? "s" : ""), Q = _.useTLS ? _.hostTLS : _.hostNonTLS;
            return Y + "://" + Q + M;
          }
          function Lt(N, _) {
            var M = "/app/" + N, Y = "?protocol=" + l.PROTOCOL + "&client=js&version=" + l.VERSION + (_ ? "&" + _ : "");
            return M + Y;
          }
          var mt = {
            getInitial: function(N, _) {
              var M = (_.httpPath || "") + Lt(N, "flash=false");
              return xt("ws", _, M);
            }
          }, St = {
            getInitial: function(N, _) {
              var M = (_.httpPath || "/pusher") + Lt(N);
              return xt("http", _, M);
            }
          }, Et = {
            getInitial: function(N, _) {
              return xt("http", _, _.httpPath || "/pusher");
            },
            getPath: function(N, _) {
              return Lt(N);
            }
          };
          class Je {
            constructor() {
              this._callbacks = {};
            }
            get(_) {
              return this._callbacks[Ze(_)];
            }
            add(_, M, Y) {
              var Q = Ze(_);
              this._callbacks[Q] = this._callbacks[Q] || [], this._callbacks[Q].push({
                fn: M,
                context: Y
              });
            }
            remove(_, M, Y) {
              if (!_ && !M && !Y) {
                this._callbacks = {};
                return;
              }
              var Q = _ ? [Ze(_)] : Se(this._callbacks);
              M || Y ? this.removeCallback(Q, M, Y) : this.removeAllCallbacks(Q);
            }
            removeCallback(_, M, Y) {
              Ge(_, function(Q) {
                this._callbacks[Q] = Me(this._callbacks[Q] || [], function($e) {
                  return M && M !== $e.fn || Y && Y !== $e.context;
                }), this._callbacks[Q].length === 0 && delete this._callbacks[Q];
              }, this);
            }
            removeAllCallbacks(_) {
              Ge(_, function(M) {
                delete this._callbacks[M];
              }, this);
            }
          }
          function Ze(N) {
            return "_" + N;
          }
          class ut {
            constructor(_) {
              this.callbacks = new Je(), this.global_callbacks = [], this.failThrough = _;
            }
            bind(_, M, Y) {
              return this.callbacks.add(_, M, Y), this;
            }
            bind_global(_) {
              return this.global_callbacks.push(_), this;
            }
            unbind(_, M, Y) {
              return this.callbacks.remove(_, M, Y), this;
            }
            unbind_global(_) {
              return _ ? (this.global_callbacks = Me(this.global_callbacks || [], (M) => M !== _), this) : (this.global_callbacks = [], this);
            }
            unbind_all() {
              return this.unbind(), this.unbind_global(), this;
            }
            emit(_, M, Y) {
              for (var Q = 0; Q < this.global_callbacks.length; Q++)
                this.global_callbacks[Q](_, M);
              var $e = this.callbacks.get(_), Ke = [];
              if (Y ? Ke.push(M, Y) : M && Ke.push(M), $e && $e.length > 0)
                for (var Q = 0; Q < $e.length; Q++)
                  $e[Q].fn.apply($e[Q].context || window, Ke);
              else
                this.failThrough && this.failThrough(_, M);
              return this;
            }
          }
          class cn extends ut {
            constructor(_, M, Y, Q, $e) {
              super(), this.initialize = ot.transportConnectionInitializer, this.hooks = _, this.name = M, this.priority = Y, this.key = Q, this.options = $e, this.state = "new", this.timeline = $e.timeline, this.activityTimeout = $e.activityTimeout, this.id = this.timeline.generateUniqueID();
            }
            handlesActivityChecks() {
              return !!this.hooks.handlesActivityChecks;
            }
            supportsPing() {
              return !!this.hooks.supportsPing;
            }
            connect() {
              if (this.socket || this.state !== "initialized")
                return !1;
              var _ = this.hooks.urls.getInitial(this.key, this.options);
              try {
                this.socket = this.hooks.getSocket(_, this.options);
              } catch (M) {
                return re.defer(() => {
                  this.onError(M), this.changeState("closed");
                }), !1;
              }
              return this.bindListeners(), Z.debug("Connecting", { transport: this.name, url: _ }), this.changeState("connecting"), !0;
            }
            close() {
              return this.socket ? (this.socket.close(), !0) : !1;
            }
            send(_) {
              return this.state === "open" ? (re.defer(() => {
                this.socket && this.socket.send(_);
              }), !0) : !1;
            }
            ping() {
              this.state === "open" && this.supportsPing() && this.socket.ping();
            }
            onOpen() {
              this.hooks.beforeOpen && this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options)), this.changeState("open"), this.socket.onopen = void 0;
            }
            onError(_) {
              this.emit("error", { type: "WebSocketError", error: _ }), this.timeline.error(this.buildTimelineMessage({ error: _.toString() }));
            }
            onClose(_) {
              _ ? this.changeState("closed", {
                code: _.code,
                reason: _.reason,
                wasClean: _.wasClean
              }) : this.changeState("closed"), this.unbindListeners(), this.socket = void 0;
            }
            onMessage(_) {
              this.emit("message", _);
            }
            onActivity() {
              this.emit("activity");
            }
            bindListeners() {
              this.socket.onopen = () => {
                this.onOpen();
              }, this.socket.onerror = (_) => {
                this.onError(_);
              }, this.socket.onclose = (_) => {
                this.onClose(_);
              }, this.socket.onmessage = (_) => {
                this.onMessage(_);
              }, this.supportsPing() && (this.socket.onactivity = () => {
                this.onActivity();
              });
            }
            unbindListeners() {
              this.socket && (this.socket.onopen = void 0, this.socket.onerror = void 0, this.socket.onclose = void 0, this.socket.onmessage = void 0, this.supportsPing() && (this.socket.onactivity = void 0));
            }
            changeState(_, M) {
              this.state = _, this.timeline.info(this.buildTimelineMessage({
                state: _,
                params: M
              })), this.emit(_, M);
            }
            buildTimelineMessage(_) {
              return de({ cid: this.id }, _);
            }
          }
          class un {
            constructor(_) {
              this.hooks = _;
            }
            isSupported(_) {
              return this.hooks.isSupported(_);
            }
            createConnection(_, M, Y, Q) {
              return new cn(this.hooks, _, M, Y, Q);
            }
          }
          var bn = new un({
            urls: mt,
            handlesActivityChecks: !1,
            supportsPing: !1,
            isInitialized: function() {
              return !!ot.getWebSocketAPI();
            },
            isSupported: function() {
              return !!ot.getWebSocketAPI();
            },
            getSocket: function(N) {
              return ot.createWebSocket(N);
            }
          }), tt = {
            urls: St,
            handlesActivityChecks: !1,
            supportsPing: !0,
            isInitialized: function() {
              return !0;
            }
          }, Qe = de({
            getSocket: function(N) {
              return ot.HTTPFactory.createStreamingSocket(N);
            }
          }, tt), rn = de({
            getSocket: function(N) {
              return ot.HTTPFactory.createPollingSocket(N);
            }
          }, tt), Xe = {
            isSupported: function() {
              return ot.isXHRSupported();
            }
          }, it = new un(de({}, Qe, Xe)), _t = new un(de({}, rn, Xe)), Yt = {
            ws: bn,
            xhr_streaming: it,
            xhr_polling: _t
          }, gn = Yt, Zt = new un({
            file: "sockjs",
            urls: Et,
            handlesActivityChecks: !0,
            supportsPing: !1,
            isSupported: function() {
              return !0;
            },
            isInitialized: function() {
              return window.SockJS !== void 0;
            },
            getSocket: function(N, _) {
              return new window.SockJS(N, null, {
                js_path: d.getPath("sockjs", {
                  useTLS: _.useTLS
                }),
                ignore_null_origin: _.ignoreNullOrigin
              });
            },
            beforeOpen: function(N, _) {
              N.send(JSON.stringify({
                path: _
              }));
            }
          }), dr = {
            isSupported: function(N) {
              var _ = ot.isXDRSupported(N.useTLS);
              return _;
            }
          }, pr = new un(de({}, Qe, dr)), Gn = new un(de({}, rn, dr));
          gn.xdr_streaming = pr, gn.xdr_polling = Gn, gn.sockjs = Zt;
          var Mn = gn;
          class Hr extends ut {
            constructor() {
              super();
              var _ = this;
              window.addEventListener !== void 0 && (window.addEventListener("online", function() {
                _.emit("online");
              }, !1), window.addEventListener("offline", function() {
                _.emit("offline");
              }, !1));
            }
            isOnline() {
              return window.navigator.onLine === void 0 ? !0 : window.navigator.onLine;
            }
          }
          var Nn = new Hr();
          class bt {
            constructor(_, M, Y) {
              this.manager = _, this.transport = M, this.minPingDelay = Y.minPingDelay, this.maxPingDelay = Y.maxPingDelay, this.pingDelay = void 0;
            }
            createConnection(_, M, Y, Q) {
              Q = de({}, Q, {
                activityTimeout: this.pingDelay
              });
              var $e = this.transport.createConnection(_, M, Y, Q), Ke = null, dt = function() {
                $e.unbind("open", dt), $e.bind("closed", Bt), Ke = re.now();
              }, Bt = (vn) => {
                if ($e.unbind("closed", Bt), vn.code === 1002 || vn.code === 1003)
                  this.manager.reportDeath();
                else if (!vn.wasClean && Ke) {
                  var xn = re.now() - Ke;
                  xn < 2 * this.maxPingDelay && (this.manager.reportDeath(), this.pingDelay = Math.max(xn / 2, this.minPingDelay));
                }
              };
              return $e.bind("open", dt), $e;
            }
            isSupported(_) {
              return this.manager.isAlive() && this.transport.isSupported(_);
            }
          }
          const ht = {
            decodeMessage: function(N) {
              try {
                var _ = JSON.parse(N.data), M = _.data;
                if (typeof M == "string")
                  try {
                    M = JSON.parse(_.data);
                  } catch {
                  }
                var Y = {
                  event: _.event,
                  channel: _.channel,
                  data: M
                };
                return _.user_id && (Y.user_id = _.user_id), Y;
              } catch (Q) {
                throw { type: "MessageParseError", error: Q, data: N.data };
              }
            },
            encodeMessage: function(N) {
              return JSON.stringify(N);
            },
            processHandshake: function(N) {
              var _ = ht.decodeMessage(N);
              if (_.event === "pusher:connection_established") {
                if (!_.data.activity_timeout)
                  throw "No activity timeout specified in handshake";
                return {
                  action: "connected",
                  id: _.data.socket_id,
                  activityTimeout: _.data.activity_timeout * 1e3
                };
              } else {
                if (_.event === "pusher:error")
                  return {
                    action: this.getCloseAction(_.data),
                    error: this.getCloseError(_.data)
                  };
                throw "Invalid handshake";
              }
            },
            getCloseAction: function(N) {
              return N.code < 4e3 ? N.code >= 1002 && N.code <= 1004 ? "backoff" : null : N.code === 4e3 ? "tls_only" : N.code < 4100 ? "refused" : N.code < 4200 ? "backoff" : N.code < 4300 ? "retry" : "refused";
            },
            getCloseError: function(N) {
              return N.code !== 1e3 && N.code !== 1001 ? {
                type: "PusherError",
                data: {
                  code: N.code,
                  message: N.reason || N.message
                }
              } : null;
            }
          };
          var Ht = ht;
          class Sn extends ut {
            constructor(_, M) {
              super(), this.id = _, this.transport = M, this.activityTimeout = M.activityTimeout, this.bindListeners();
            }
            handlesActivityChecks() {
              return this.transport.handlesActivityChecks();
            }
            send(_) {
              return this.transport.send(_);
            }
            send_event(_, M, Y) {
              var Q = { event: _, data: M };
              return Y && (Q.channel = Y), Z.debug("Event sent", Q), this.send(Ht.encodeMessage(Q));
            }
            ping() {
              this.transport.supportsPing() ? this.transport.ping() : this.send_event("pusher:ping", {});
            }
            close() {
              this.transport.close();
            }
            bindListeners() {
              var _ = {
                message: (Y) => {
                  var Q;
                  try {
                    Q = Ht.decodeMessage(Y);
                  } catch ($e) {
                    this.emit("error", {
                      type: "MessageParseError",
                      error: $e,
                      data: Y.data
                    });
                  }
                  if (Q !== void 0) {
                    switch (Z.debug("Event recd", Q), Q.event) {
                      case "pusher:error":
                        this.emit("error", {
                          type: "PusherError",
                          data: Q.data
                        });
                        break;
                      case "pusher:ping":
                        this.emit("ping");
                        break;
                      case "pusher:pong":
                        this.emit("pong");
                        break;
                    }
                    this.emit("message", Q);
                  }
                },
                activity: () => {
                  this.emit("activity");
                },
                error: (Y) => {
                  this.emit("error", Y);
                },
                closed: (Y) => {
                  M(), Y && Y.code && this.handleCloseEvent(Y), this.transport = null, this.emit("closed");
                }
              }, M = () => {
                me(_, (Y, Q) => {
                  this.transport.unbind(Q, Y);
                });
              };
              me(_, (Y, Q) => {
                this.transport.bind(Q, Y);
              });
            }
            handleCloseEvent(_) {
              var M = Ht.getCloseAction(_), Y = Ht.getCloseError(_);
              Y && this.emit("error", Y), M && this.emit(M, { action: M, error: Y });
            }
          }
          class hr {
            constructor(_, M) {
              this.transport = _, this.callback = M, this.bindListeners();
            }
            close() {
              this.unbindListeners(), this.transport.close();
            }
            bindListeners() {
              this.onMessage = (_) => {
                this.unbindListeners();
                var M;
                try {
                  M = Ht.processHandshake(_);
                } catch (Y) {
                  this.finish("error", { error: Y }), this.transport.close();
                  return;
                }
                M.action === "connected" ? this.finish("connected", {
                  connection: new Sn(M.id, this.transport),
                  activityTimeout: M.activityTimeout
                }) : (this.finish(M.action, { error: M.error }), this.transport.close());
              }, this.onClosed = (_) => {
                this.unbindListeners();
                var M = Ht.getCloseAction(_) || "backoff", Y = Ht.getCloseError(_);
                this.finish(M, { error: Y });
              }, this.transport.bind("message", this.onMessage), this.transport.bind("closed", this.onClosed);
            }
            unbindListeners() {
              this.transport.unbind("message", this.onMessage), this.transport.unbind("closed", this.onClosed);
            }
            finish(_, M) {
              this.callback(de({ transport: this.transport, action: _ }, M));
            }
          }
          class In {
            constructor(_, M) {
              this.timeline = _, this.options = M || {};
            }
            send(_, M) {
              this.timeline.isEmpty() || this.timeline.send(ot.TimelineTransport.getAgent(this, _), M);
            }
          }
          class Kn extends ut {
            constructor(_, M) {
              super(function(Y, Q) {
                Z.debug("No callbacks on " + _ + " for " + Y);
              }), this.name = _, this.pusher = M, this.subscribed = !1, this.subscriptionPending = !1, this.subscriptionCancelled = !1;
            }
            authorize(_, M) {
              return M(null, { auth: "" });
            }
            trigger(_, M) {
              if (_.indexOf("client-") !== 0)
                throw new x("Event '" + _ + "' does not start with 'client-'");
              if (!this.subscribed) {
                var Y = v.buildLogSuffix("triggeringClientEvents");
                Z.warn(`Client event triggered before channel 'subscription_succeeded' event . ${Y}`);
              }
              return this.pusher.send_event(_, M, this.name);
            }
            disconnect() {
              this.subscribed = !1, this.subscriptionPending = !1;
            }
            handleEvent(_) {
              var M = _.event, Y = _.data;
              if (M === "pusher_internal:subscription_succeeded")
                this.handleSubscriptionSucceededEvent(_);
              else if (M === "pusher_internal:subscription_count")
                this.handleSubscriptionCountEvent(_);
              else if (M.indexOf("pusher_internal:") !== 0) {
                var Q = {};
                this.emit(M, Y, Q);
              }
            }
            handleSubscriptionSucceededEvent(_) {
              this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : this.emit("pusher:subscription_succeeded", _.data);
            }
            handleSubscriptionCountEvent(_) {
              _.data.subscription_count && (this.subscriptionCount = _.data.subscription_count), this.emit("pusher:subscription_count", _.data);
            }
            subscribe() {
              this.subscribed || (this.subscriptionPending = !0, this.subscriptionCancelled = !1, this.authorize(this.pusher.connection.socket_id, (_, M) => {
                _ ? (this.subscriptionPending = !1, Z.error(_.toString()), this.emit("pusher:subscription_error", Object.assign({}, {
                  type: "AuthError",
                  error: _.message
                }, _ instanceof R ? { status: _.status } : {}))) : this.pusher.send_event("pusher:subscribe", {
                  auth: M.auth,
                  channel_data: M.channel_data,
                  channel: this.name
                });
              }));
            }
            unsubscribe() {
              this.subscribed = !1, this.pusher.send_event("pusher:unsubscribe", {
                channel: this.name
              });
            }
            cancelSubscription() {
              this.subscriptionCancelled = !0;
            }
            reinstateSubscription() {
              this.subscriptionCancelled = !1;
            }
          }
          class vi extends Kn {
            authorize(_, M) {
              return this.pusher.config.channelAuthorizer({
                channelName: this.name,
                socketId: _
              }, M);
            }
          }
          class Vt {
            constructor() {
              this.reset();
            }
            get(_) {
              return Object.prototype.hasOwnProperty.call(this.members, _) ? {
                id: _,
                info: this.members[_]
              } : null;
            }
            each(_) {
              me(this.members, (M, Y) => {
                _(this.get(Y));
              });
            }
            setMyID(_) {
              this.myID = _;
            }
            onSubscription(_) {
              this.members = _.presence.hash, this.count = _.presence.count, this.me = this.get(this.myID);
            }
            addMember(_) {
              return this.get(_.user_id) === null && this.count++, this.members[_.user_id] = _.user_info, this.get(_.user_id);
            }
            removeMember(_) {
              var M = this.get(_.user_id);
              return M && (delete this.members[_.user_id], this.count--), M;
            }
            reset() {
              this.members = {}, this.count = 0, this.myID = null, this.me = null;
            }
          }
          var Sr = function(N, _, M, Y) {
            function Q($e) {
              return $e instanceof M ? $e : new M(function(Ke) {
                Ke($e);
              });
            }
            return new (M || (M = Promise))(function($e, Ke) {
              function dt(xn) {
                try {
                  vn(Y.next(xn));
                } catch (xr) {
                  Ke(xr);
                }
              }
              function Bt(xn) {
                try {
                  vn(Y.throw(xn));
                } catch (xr) {
                  Ke(xr);
                }
              }
              function vn(xn) {
                xn.done ? $e(xn.value) : Q(xn.value).then(dt, Bt);
              }
              vn((Y = Y.apply(N, _ || [])).next());
            });
          };
          class Xr extends vi {
            constructor(_, M) {
              super(_, M), this.members = new Vt();
            }
            authorize(_, M) {
              super.authorize(_, (Y, Q) => Sr(this, void 0, void 0, function* () {
                if (!Y)
                  if (Q = Q, Q.channel_data != null) {
                    var $e = JSON.parse(Q.channel_data);
                    this.members.setMyID($e.user_id);
                  } else if (yield this.pusher.user.signinDonePromise, this.pusher.user.user_data != null)
                    this.members.setMyID(this.pusher.user.user_data.id);
                  else {
                    let Ke = v.buildLogSuffix("authorizationEndpoint");
                    Z.error(`Invalid auth response for channel '${this.name}', expected 'channel_data' field. ${Ke}, or the user should be signed in.`), M("Invalid auth response");
                    return;
                  }
                M(Y, Q);
              }));
            }
            handleEvent(_) {
              var M = _.event;
              if (M.indexOf("pusher_internal:") === 0)
                this.handleInternalEvent(_);
              else {
                var Y = _.data, Q = {};
                _.user_id && (Q.user_id = _.user_id), this.emit(M, Y, Q);
              }
            }
            handleInternalEvent(_) {
              var M = _.event, Y = _.data;
              switch (M) {
                case "pusher_internal:subscription_succeeded":
                  this.handleSubscriptionSucceededEvent(_);
                  break;
                case "pusher_internal:subscription_count":
                  this.handleSubscriptionCountEvent(_);
                  break;
                case "pusher_internal:member_added":
                  var Q = this.members.addMember(Y);
                  this.emit("pusher:member_added", Q);
                  break;
                case "pusher_internal:member_removed":
                  var $e = this.members.removeMember(Y);
                  $e && this.emit("pusher:member_removed", $e);
                  break;
              }
            }
            handleSubscriptionSucceededEvent(_) {
              this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : (this.members.onSubscription(_.data), this.emit("pusher:subscription_succeeded", this.members));
            }
            disconnect() {
              this.members.reset(), super.disconnect();
            }
          }
          var Ri = i(1), Dr = i(0);
          class Or extends vi {
            constructor(_, M, Y) {
              super(_, M), this.key = null, this.nacl = Y;
            }
            authorize(_, M) {
              super.authorize(_, (Y, Q) => {
                if (Y) {
                  M(Y, Q);
                  return;
                }
                let $e = Q.shared_secret;
                if (!$e) {
                  M(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                  return;
                }
                this.key = Object(Dr.decode)($e), delete Q.shared_secret, M(null, Q);
              });
            }
            trigger(_, M) {
              throw new O("Client events are not currently supported for encrypted channels");
            }
            handleEvent(_) {
              var M = _.event, Y = _.data;
              if (M.indexOf("pusher_internal:") === 0 || M.indexOf("pusher:") === 0) {
                super.handleEvent(_);
                return;
              }
              this.handleEncryptedEvent(M, Y);
            }
            handleEncryptedEvent(_, M) {
              if (!this.key) {
                Z.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                return;
              }
              if (!M.ciphertext || !M.nonce) {
                Z.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + M);
                return;
              }
              let Y = Object(Dr.decode)(M.ciphertext);
              if (Y.length < this.nacl.secretbox.overheadLength) {
                Z.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${Y.length}`);
                return;
              }
              let Q = Object(Dr.decode)(M.nonce);
              if (Q.length < this.nacl.secretbox.nonceLength) {
                Z.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${Q.length}`);
                return;
              }
              let $e = this.nacl.secretbox.open(Y, Q, this.key);
              if ($e === null) {
                Z.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint..."), this.authorize(this.pusher.connection.socket_id, (Ke, dt) => {
                  if (Ke) {
                    Z.error(`Failed to make a request to the authEndpoint: ${dt}. Unable to fetch new key, so dropping encrypted event`);
                    return;
                  }
                  if ($e = this.nacl.secretbox.open(Y, Q, this.key), $e === null) {
                    Z.error("Failed to decrypt event with new key. Dropping encrypted event");
                    return;
                  }
                  this.emit(_, this.getDataToEmit($e));
                });
                return;
              }
              this.emit(_, this.getDataToEmit($e));
            }
            getDataToEmit(_) {
              let M = Object(Ri.decode)(_);
              try {
                return JSON.parse(M);
              } catch {
                return M;
              }
            }
          }
          class qi extends ut {
            constructor(_, M) {
              super(), this.state = "initialized", this.connection = null, this.key = _, this.options = M, this.timeline = this.options.timeline, this.usingTLS = this.options.useTLS, this.errorCallbacks = this.buildErrorCallbacks(), this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks), this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
              var Y = ot.getNetwork();
              Y.bind("online", () => {
                this.timeline.info({ netinfo: "online" }), (this.state === "connecting" || this.state === "unavailable") && this.retryIn(0);
              }), Y.bind("offline", () => {
                this.timeline.info({ netinfo: "offline" }), this.connection && this.sendActivityCheck();
              }), this.updateStrategy();
            }
            connect() {
              if (!(this.connection || this.runner)) {
                if (!this.strategy.isSupported()) {
                  this.updateState("failed");
                  return;
                }
                this.updateState("connecting"), this.startConnecting(), this.setUnavailableTimer();
              }
            }
            send(_) {
              return this.connection ? this.connection.send(_) : !1;
            }
            send_event(_, M, Y) {
              return this.connection ? this.connection.send_event(_, M, Y) : !1;
            }
            disconnect() {
              this.disconnectInternally(), this.updateState("disconnected");
            }
            isUsingTLS() {
              return this.usingTLS;
            }
            startConnecting() {
              var _ = (M, Y) => {
                M ? this.runner = this.strategy.connect(0, _) : Y.action === "error" ? (this.emit("error", {
                  type: "HandshakeError",
                  error: Y.error
                }), this.timeline.error({ handshakeError: Y.error })) : (this.abortConnecting(), this.handshakeCallbacks[Y.action](Y));
              };
              this.runner = this.strategy.connect(0, _);
            }
            abortConnecting() {
              this.runner && (this.runner.abort(), this.runner = null);
            }
            disconnectInternally() {
              if (this.abortConnecting(), this.clearRetryTimer(), this.clearUnavailableTimer(), this.connection) {
                var _ = this.abandonConnection();
                _.close();
              }
            }
            updateStrategy() {
              this.strategy = this.options.getStrategy({
                key: this.key,
                timeline: this.timeline,
                useTLS: this.usingTLS
              });
            }
            retryIn(_) {
              this.timeline.info({ action: "retry", delay: _ }), _ > 0 && this.emit("connecting_in", Math.round(_ / 1e3)), this.retryTimer = new ee(_ || 0, () => {
                this.disconnectInternally(), this.connect();
              });
            }
            clearRetryTimer() {
              this.retryTimer && (this.retryTimer.ensureAborted(), this.retryTimer = null);
            }
            setUnavailableTimer() {
              this.unavailableTimer = new ee(this.options.unavailableTimeout, () => {
                this.updateState("unavailable");
              });
            }
            clearUnavailableTimer() {
              this.unavailableTimer && this.unavailableTimer.ensureAborted();
            }
            sendActivityCheck() {
              this.stopActivityCheck(), this.connection.ping(), this.activityTimer = new ee(this.options.pongTimeout, () => {
                this.timeline.error({ pong_timed_out: this.options.pongTimeout }), this.retryIn(0);
              });
            }
            resetActivityCheck() {
              this.stopActivityCheck(), this.connection && !this.connection.handlesActivityChecks() && (this.activityTimer = new ee(this.activityTimeout, () => {
                this.sendActivityCheck();
              }));
            }
            stopActivityCheck() {
              this.activityTimer && this.activityTimer.ensureAborted();
            }
            buildConnectionCallbacks(_) {
              return de({}, _, {
                message: (M) => {
                  this.resetActivityCheck(), this.emit("message", M);
                },
                ping: () => {
                  this.send_event("pusher:pong", {});
                },
                activity: () => {
                  this.resetActivityCheck();
                },
                error: (M) => {
                  this.emit("error", M);
                },
                closed: () => {
                  this.abandonConnection(), this.shouldRetry() && this.retryIn(1e3);
                }
              });
            }
            buildHandshakeCallbacks(_) {
              return de({}, _, {
                connected: (M) => {
                  this.activityTimeout = Math.min(this.options.activityTimeout, M.activityTimeout, M.connection.activityTimeout || 1 / 0), this.clearUnavailableTimer(), this.setConnection(M.connection), this.socket_id = this.connection.id, this.updateState("connected", { socket_id: this.socket_id });
                }
              });
            }
            buildErrorCallbacks() {
              let _ = (M) => (Y) => {
                Y.error && this.emit("error", { type: "WebSocketError", error: Y.error }), M(Y);
              };
              return {
                tls_only: _(() => {
                  this.usingTLS = !0, this.updateStrategy(), this.retryIn(0);
                }),
                refused: _(() => {
                  this.disconnect();
                }),
                backoff: _(() => {
                  this.retryIn(1e3);
                }),
                retry: _(() => {
                  this.retryIn(0);
                })
              };
            }
            setConnection(_) {
              this.connection = _;
              for (var M in this.connectionCallbacks)
                this.connection.bind(M, this.connectionCallbacks[M]);
              this.resetActivityCheck();
            }
            abandonConnection() {
              if (this.connection) {
                this.stopActivityCheck();
                for (var _ in this.connectionCallbacks)
                  this.connection.unbind(_, this.connectionCallbacks[_]);
                var M = this.connection;
                return this.connection = null, M;
              }
            }
            updateState(_, M) {
              var Y = this.state;
              if (this.state = _, Y !== _) {
                var Q = _;
                Q === "connected" && (Q += " with new socket ID " + M.socket_id), Z.debug("State changed", Y + " -> " + Q), this.timeline.info({ state: _, params: M }), this.emit("state_change", { previous: Y, current: _ }), this.emit(_, M);
              }
            }
            shouldRetry() {
              return this.state === "connecting" || this.state === "connected";
            }
          }
          class Yi {
            constructor() {
              this.channels = {};
            }
            add(_, M) {
              return this.channels[_] || (this.channels[_] = jr(_, M)), this.channels[_];
            }
            all() {
              return _e(this.channels);
            }
            find(_) {
              return this.channels[_];
            }
            remove(_) {
              var M = this.channels[_];
              return delete this.channels[_], M;
            }
            disconnect() {
              me(this.channels, function(_) {
                _.disconnect();
              });
            }
          }
          function jr(N, _) {
            if (N.indexOf("private-encrypted-") === 0) {
              if (_.config.nacl)
                return qn.createEncryptedChannel(N, _, _.config.nacl);
              let M = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available", Y = v.buildLogSuffix("encryptedChannelSupport");
              throw new O(`${M}. ${Y}`);
            } else {
              if (N.indexOf("private-") === 0)
                return qn.createPrivateChannel(N, _);
              if (N.indexOf("presence-") === 0)
                return qn.createPresenceChannel(N, _);
              if (N.indexOf("#") === 0)
                throw new b('Cannot create a channel with name "' + N + '".');
              return qn.createChannel(N, _);
            }
          }
          var Xi = {
            createChannels() {
              return new Yi();
            },
            createConnectionManager(N, _) {
              return new qi(N, _);
            },
            createChannel(N, _) {
              return new Kn(N, _);
            },
            createPrivateChannel(N, _) {
              return new vi(N, _);
            },
            createPresenceChannel(N, _) {
              return new Xr(N, _);
            },
            createEncryptedChannel(N, _, M) {
              return new Or(N, _, M);
            },
            createTimelineSender(N, _) {
              return new In(N, _);
            },
            createHandshake(N, _) {
              return new hr(N, _);
            },
            createAssistantToTheTransportManager(N, _, M) {
              return new bt(N, _, M);
            }
          }, qn = Xi;
          class Qn {
            constructor(_) {
              this.options = _ || {}, this.livesLeft = this.options.lives || 1 / 0;
            }
            getAssistant(_) {
              return qn.createAssistantToTheTransportManager(this, _, {
                minPingDelay: this.options.minPingDelay,
                maxPingDelay: this.options.maxPingDelay
              });
            }
            isAlive() {
              return this.livesLeft > 0;
            }
            reportDeath() {
              this.livesLeft -= 1;
            }
          }
          class Jn {
            constructor(_, M) {
              this.strategies = _, this.loop = !!M.loop, this.failFast = !!M.failFast, this.timeout = M.timeout, this.timeoutLimit = M.timeoutLimit;
            }
            isSupported() {
              return je(this.strategies, re.method("isSupported"));
            }
            connect(_, M) {
              var Y = this.strategies, Q = 0, $e = this.timeout, Ke = null, dt = (Bt, vn) => {
                vn ? M(null, vn) : (Q = Q + 1, this.loop && (Q = Q % Y.length), Q < Y.length ? ($e && ($e = $e * 2, this.timeoutLimit && ($e = Math.min($e, this.timeoutLimit))), Ke = this.tryStrategy(Y[Q], _, { timeout: $e, failFast: this.failFast }, dt)) : M(!0));
              };
              return Ke = this.tryStrategy(Y[Q], _, { timeout: $e, failFast: this.failFast }, dt), {
                abort: function() {
                  Ke.abort();
                },
                forceMinPriority: function(Bt) {
                  _ = Bt, Ke && Ke.forceMinPriority(Bt);
                }
              };
            }
            tryStrategy(_, M, Y, Q) {
              var $e = null, Ke = null;
              return Y.timeout > 0 && ($e = new ee(Y.timeout, function() {
                Ke.abort(), Q(!0);
              })), Ke = _.connect(M, function(dt, Bt) {
                dt && $e && $e.isRunning() && !Y.failFast || ($e && $e.ensureAborted(), Q(dt, Bt));
              }), {
                abort: function() {
                  $e && $e.ensureAborted(), Ke.abort();
                },
                forceMinPriority: function(dt) {
                  Ke.forceMinPriority(dt);
                }
              };
            }
          }
          class Wr {
            constructor(_) {
              this.strategies = _;
            }
            isSupported() {
              return je(this.strategies, re.method("isSupported"));
            }
            connect(_, M) {
              return oi(this.strategies, _, function(Y, Q) {
                return function($e, Ke) {
                  if (Q[Y].error = $e, $e) {
                    nr(Q) && M(!0);
                    return;
                  }
                  Ge(Q, function(dt) {
                    dt.forceMinPriority(Ke.transport.priority);
                  }), M(null, Ke);
                };
              });
            }
          }
          function oi(N, _, M) {
            var Y = Fe(N, function(Q, $e, Ke, dt) {
              return Q.connect(_, M($e, dt));
            });
            return {
              abort: function() {
                Ge(Y, Qi);
              },
              forceMinPriority: function(Q) {
                Ge(Y, function($e) {
                  $e.forceMinPriority(Q);
                });
              }
            };
          }
          function nr(N) {
            return ie(N, function(_) {
              return !!_.error;
            });
          }
          function Qi(N) {
            !N.error && !N.aborted && (N.abort(), N.aborted = !0);
          }
          class Kt {
            constructor(_, M, Y) {
              this.strategy = _, this.transports = M, this.ttl = Y.ttl || 1800 * 1e3, this.usingTLS = Y.useTLS, this.timeline = Y.timeline;
            }
            isSupported() {
              return this.strategy.isSupported();
            }
            connect(_, M) {
              var Y = this.usingTLS, Q = an(Y), $e = Q && Q.cacheSkipCount ? Q.cacheSkipCount : 0, Ke = [this.strategy];
              if (Q && Q.timestamp + this.ttl >= re.now()) {
                var dt = this.transports[Q.transport];
                dt && (["ws", "wss"].includes(Q.transport) || $e > 3 ? (this.timeline.info({
                  cached: !0,
                  transport: Q.transport,
                  latency: Q.latency
                }), Ke.push(new Jn([dt], {
                  timeout: Q.latency * 2 + 1e3,
                  failFast: !0
                }))) : $e++);
              }
              var Bt = re.now(), vn = Ke.pop().connect(_, function xn(xr, zu) {
                xr ? (kn(Y), Ke.length > 0 ? (Bt = re.now(), vn = Ke.pop().connect(_, xn)) : M(xr)) : (rr(Y, zu.transport.name, re.now() - Bt, $e), M(null, zu));
              });
              return {
                abort: function() {
                  vn.abort();
                },
                forceMinPriority: function(xn) {
                  _ = xn, vn && vn.forceMinPriority(xn);
                }
              };
            }
          }
          function wt(N) {
            return "pusherTransport" + (N ? "TLS" : "NonTLS");
          }
          function an(N) {
            var _ = ot.getLocalStorage();
            if (_)
              try {
                var M = _[wt(N)];
                if (M)
                  return JSON.parse(M);
              } catch {
                kn(N);
              }
            return null;
          }
          function rr(N, _, M, Y) {
            var Q = ot.getLocalStorage();
            if (Q)
              try {
                Q[wt(N)] = Le({
                  timestamp: re.now(),
                  transport: _,
                  latency: M,
                  cacheSkipCount: Y
                });
              } catch {
              }
          }
          function kn(N) {
            var _ = ot.getLocalStorage();
            if (_)
              try {
                delete _[wt(N)];
              } catch {
              }
          }
          class Fr {
            constructor(_, { delay: M }) {
              this.strategy = _, this.options = { delay: M };
            }
            isSupported() {
              return this.strategy.isSupported();
            }
            connect(_, M) {
              var Y = this.strategy, Q, $e = new ee(this.options.delay, function() {
                Q = Y.connect(_, M);
              });
              return {
                abort: function() {
                  $e.ensureAborted(), Q && Q.abort();
                },
                forceMinPriority: function(Ke) {
                  _ = Ke, Q && Q.forceMinPriority(Ke);
                }
              };
            }
          }
          class ai {
            constructor(_, M, Y) {
              this.test = _, this.trueBranch = M, this.falseBranch = Y;
            }
            isSupported() {
              var _ = this.test() ? this.trueBranch : this.falseBranch;
              return _.isSupported();
            }
            connect(_, M) {
              var Y = this.test() ? this.trueBranch : this.falseBranch;
              return Y.connect(_, M);
            }
          }
          class Ao {
            constructor(_) {
              this.strategy = _;
            }
            isSupported() {
              return this.strategy.isSupported();
            }
            connect(_, M) {
              var Y = this.strategy.connect(_, function(Q, $e) {
                $e && Y.abort(), M(Q, $e);
              });
              return Y;
            }
          }
          function si(N) {
            return function() {
              return N.isSupported();
            };
          }
          var yi = function(N, _, M) {
            var Y = {};
            function Q(ey, $C, Oc, _C, OC) {
              var ld = M(N, ey, $C, Oc, _C, OC);
              return Y[ey] = ld, ld;
            }
            var $e = Object.assign({}, _, {
              hostNonTLS: N.wsHost + ":" + N.wsPort,
              hostTLS: N.wsHost + ":" + N.wssPort,
              httpPath: N.wsPath
            }), Ke = Object.assign({}, $e, {
              useTLS: !0
            }), dt = Object.assign({}, _, {
              hostNonTLS: N.httpHost + ":" + N.httpPort,
              hostTLS: N.httpHost + ":" + N.httpsPort,
              httpPath: N.httpPath
            }), Bt = {
              loop: !0,
              timeout: 15e3,
              timeoutLimit: 6e4
            }, vn = new Qn({
              minPingDelay: 1e4,
              maxPingDelay: N.activityTimeout
            }), xn = new Qn({
              lives: 2,
              minPingDelay: 1e4,
              maxPingDelay: N.activityTimeout
            }), xr = Q("ws", "ws", 3, $e, vn), zu = Q("wss", "ws", 3, Ke, vn), EC = Q("sockjs", "sockjs", 1, dt), sd = Q("xhr_streaming", "xhr_streaming", 1, dt, xn), zh = Q("xdr_streaming", "xdr_streaming", 1, dt, xn), Qv = Q("xhr_polling", "xhr_polling", 1, dt), Jv = Q("xdr_polling", "xdr_polling", 1, dt), to = new Jn([xr], Bt), Uh = new Jn([zu], Bt), Uu = new Jn([EC], Bt), Hh = new Jn([
              new ai(si(sd), sd, zh)
            ], Bt), Wh = new Jn([
              new ai(si(Qv), Qv, Jv)
            ], Bt), Zv = new Jn([
              new ai(si(Hh), new Wr([
                Hh,
                new Fr(Wh, { delay: 4e3 })
              ]), Wh)
            ], Bt), Vh = new ai(si(Zv), Zv, Uu), Gh;
            return _.useTLS ? Gh = new Wr([
              to,
              new Fr(Vh, { delay: 2e3 })
            ]) : Gh = new Wr([
              to,
              new Fr(Uh, { delay: 2e3 }),
              new Fr(Vh, { delay: 5e3 })
            ]), new Kt(new Ao(new ai(si(xr), Gh, Vh)), Y, {
              ttl: 18e5,
              timeline: _.timeline,
              useTLS: _.useTLS
            });
          }, Mi = yi, Ji = function() {
            var N = this;
            N.timeline.info(N.buildTimelineMessage({
              transport: N.name + (N.options.useTLS ? "s" : "")
            })), N.hooks.isInitialized() ? N.changeState("initialized") : N.hooks.file ? (N.changeState("initializing"), d.load(N.hooks.file, { useTLS: N.options.useTLS }, function(_, M) {
              N.hooks.isInitialized() ? (N.changeState("initialized"), M(!0)) : (_ && N.onError(_), N.onClose(), M(!1));
            })) : N.onClose();
          }, Ni = {
            getRequest: function(N) {
              var _ = new window.XDomainRequest();
              return _.ontimeout = function() {
                N.emit("error", new w()), N.close();
              }, _.onerror = function(M) {
                N.emit("error", M), N.close();
              }, _.onprogress = function() {
                _.responseText && _.responseText.length > 0 && N.onChunk(200, _.responseText);
              }, _.onload = function() {
                _.responseText && _.responseText.length > 0 && N.onChunk(200, _.responseText), N.emit("finished", 200), N.close();
              }, _;
            },
            abortRequest: function(N) {
              N.ontimeout = N.onerror = N.onprogress = N.onload = null, N.abort();
            }
          }, ta = Ni;
          const wn = 256 * 1024;
          class Ro extends ut {
            constructor(_, M, Y) {
              super(), this.hooks = _, this.method = M, this.url = Y;
            }
            start(_) {
              this.position = 0, this.xhr = this.hooks.getRequest(this), this.unloader = () => {
                this.close();
              }, ot.addUnloadListener(this.unloader), this.xhr.open(this.method, this.url, !0), this.xhr.setRequestHeader && this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.send(_);
            }
            close() {
              this.unloader && (ot.removeUnloadListener(this.unloader), this.unloader = null), this.xhr && (this.hooks.abortRequest(this.xhr), this.xhr = null);
            }
            onChunk(_, M) {
              for (; ; ) {
                var Y = this.advanceBuffer(M);
                if (Y)
                  this.emit("chunk", { status: _, data: Y });
                else
                  break;
              }
              this.isBufferTooLong(M) && this.emit("buffer_too_long");
            }
            advanceBuffer(_) {
              var M = _.slice(this.position), Y = M.indexOf(`
`);
              return Y !== -1 ? (this.position += Y + 1, M.slice(0, Y)) : null;
            }
            isBufferTooLong(_) {
              return this.position === _.length && _.length > wn;
            }
          }
          var ir;
          (function(N) {
            N[N.CONNECTING = 0] = "CONNECTING", N[N.OPEN = 1] = "OPEN", N[N.CLOSED = 3] = "CLOSED";
          })(ir || (ir = {}));
          var mr = ir, bi = 1;
          class wi {
            constructor(_, M) {
              this.hooks = _, this.session = Na(1e3) + "/" + ka(8), this.location = Zi(M), this.readyState = mr.CONNECTING, this.openStream();
            }
            send(_) {
              return this.sendRaw(JSON.stringify([_]));
            }
            ping() {
              this.hooks.sendHeartbeat(this);
            }
            close(_, M) {
              this.onClose(_, M, !0);
            }
            sendRaw(_) {
              if (this.readyState === mr.OPEN)
                try {
                  return ot.createSocketRequest("POST", Mo(eo(this.location, this.session))).start(_), !0;
                } catch {
                  return !1;
                }
              else
                return !1;
            }
            reconnect() {
              this.closeStream(), this.openStream();
            }
            onClose(_, M, Y) {
              this.closeStream(), this.readyState = mr.CLOSED, this.onclose && this.onclose({
                code: _,
                reason: M,
                wasClean: Y
              });
            }
            onChunk(_) {
              if (_.status === 200) {
                this.readyState === mr.OPEN && this.onActivity();
                var M, Y = _.data.slice(0, 1);
                switch (Y) {
                  case "o":
                    M = JSON.parse(_.data.slice(1) || "{}"), this.onOpen(M);
                    break;
                  case "a":
                    M = JSON.parse(_.data.slice(1) || "[]");
                    for (var Q = 0; Q < M.length; Q++)
                      this.onEvent(M[Q]);
                    break;
                  case "m":
                    M = JSON.parse(_.data.slice(1) || "null"), this.onEvent(M);
                    break;
                  case "h":
                    this.hooks.onHeartbeat(this);
                    break;
                  case "c":
                    M = JSON.parse(_.data.slice(1) || "[]"), this.onClose(M[0], M[1], !0);
                    break;
                }
              }
            }
            onOpen(_) {
              this.readyState === mr.CONNECTING ? (_ && _.hostname && (this.location.base = ys(this.location.base, _.hostname)), this.readyState = mr.OPEN, this.onopen && this.onopen()) : this.onClose(1006, "Server lost session", !0);
            }
            onEvent(_) {
              this.readyState === mr.OPEN && this.onmessage && this.onmessage({ data: _ });
            }
            onActivity() {
              this.onactivity && this.onactivity();
            }
            onError(_) {
              this.onerror && this.onerror(_);
            }
            openStream() {
              this.stream = ot.createSocketRequest("POST", Mo(this.hooks.getReceiveURL(this.location, this.session))), this.stream.bind("chunk", (_) => {
                this.onChunk(_);
              }), this.stream.bind("finished", (_) => {
                this.hooks.onFinished(this, _);
              }), this.stream.bind("buffer_too_long", () => {
                this.reconnect();
              });
              try {
                this.stream.start();
              } catch (_) {
                re.defer(() => {
                  this.onError(_), this.onClose(1006, "Could not start streaming", !1);
                });
              }
            }
            closeStream() {
              this.stream && (this.stream.unbind_all(), this.stream.close(), this.stream = null);
            }
          }
          function Zi(N) {
            var _ = /([^\?]*)\/*(\??.*)/.exec(N);
            return {
              base: _[1],
              queryString: _[2]
            };
          }
          function eo(N, _) {
            return N.base + "/" + _ + "/xhr_send";
          }
          function Mo(N) {
            var _ = N.indexOf("?") === -1 ? "?" : "&";
            return N + _ + "t=" + +/* @__PURE__ */ new Date() + "&n=" + bi++;
          }
          function ys(N, _) {
            var M = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(N);
            return M[1] + _ + M[3];
          }
          function Na(N) {
            return ot.randomInt(N);
          }
          function ka(N) {
            for (var _ = [], M = 0; M < N; M++)
              _.push(Na(32).toString(32));
            return _.join("");
          }
          var bs = wi, xe = {
            getReceiveURL: function(N, _) {
              return N.base + "/" + _ + "/xhr_streaming" + N.queryString;
            },
            onHeartbeat: function(N) {
              N.sendRaw("[]");
            },
            sendHeartbeat: function(N) {
              N.sendRaw("[]");
            },
            onFinished: function(N, _) {
              N.onClose(1006, "Connection interrupted (" + _ + ")", !1);
            }
          }, He = xe, Nt = {
            getReceiveURL: function(N, _) {
              return N.base + "/" + _ + "/xhr" + N.queryString;
            },
            onHeartbeat: function() {
            },
            sendHeartbeat: function(N) {
              N.sendRaw("[]");
            },
            onFinished: function(N, _) {
              _ === 200 ? N.reconnect() : N.onClose(1006, "Connection interrupted (" + _ + ")", !1);
            }
          }, Wt = Nt, kt = {
            getRequest: function(N) {
              var _ = ot.getXHRAPI(), M = new _();
              return M.onreadystatechange = M.onprogress = function() {
                switch (M.readyState) {
                  case 3:
                    M.responseText && M.responseText.length > 0 && N.onChunk(M.status, M.responseText);
                    break;
                  case 4:
                    M.responseText && M.responseText.length > 0 && N.onChunk(M.status, M.responseText), N.emit("finished", M.status), N.close();
                    break;
                }
              }, M;
            },
            abortRequest: function(N) {
              N.onreadystatechange = null, N.abort();
            }
          }, na = kt, ws = {
            createStreamingSocket(N) {
              return this.createSocket(He, N);
            },
            createPollingSocket(N) {
              return this.createSocket(Wt, N);
            },
            createSocket(N, _) {
              return new bs(N, _);
            },
            createXHR(N, _) {
              return this.createRequest(na, N, _);
            },
            createRequest(N, _, M) {
              return new Ro(N, _, M);
            }
          }, il = ws;
          il.createXDR = function(N, _) {
            return this.createRequest(ta, N, _);
          };
          var ra = il, Zn = {
            nextAuthCallbackID: 1,
            auth_callbacks: {},
            ScriptReceivers: a,
            DependenciesReceivers: f,
            getDefaultStrategy: Mi,
            Transports: Mn,
            transportConnectionInitializer: Ji,
            HTTPFactory: ra,
            TimelineTransport: Ye,
            getXHRAPI() {
              return window.XMLHttpRequest;
            },
            getWebSocketAPI() {
              return window.WebSocket || window.MozWebSocket;
            },
            setup(N) {
              window.Pusher = N;
              var _ = () => {
                this.onDocumentBody(N.ready);
              };
              window.JSON ? _() : d.load("json2", {}, _);
            },
            getDocument() {
              return document;
            },
            getProtocol() {
              return this.getDocument().location.protocol;
            },
            getAuthorizers() {
              return { ajax: B, jsonp: Ce };
            },
            onDocumentBody(N) {
              document.body ? N() : setTimeout(() => {
                this.onDocumentBody(N);
              }, 0);
            },
            createJSONPRequest(N, _) {
              return new Ee(N, _);
            },
            createScriptRequest(N) {
              return new Pe(N);
            },
            getLocalStorage() {
              try {
                return window.localStorage;
              } catch {
                return;
              }
            },
            createXHR() {
              return this.getXHRAPI() ? this.createXMLHttpRequest() : this.createMicrosoftXHR();
            },
            createXMLHttpRequest() {
              var N = this.getXHRAPI();
              return new N();
            },
            createMicrosoftXHR() {
              return new ActiveXObject("Microsoft.XMLHTTP");
            },
            getNetwork() {
              return Nn;
            },
            createWebSocket(N) {
              var _ = this.getWebSocketAPI();
              return new _(N);
            },
            createSocketRequest(N, _) {
              if (this.isXHRSupported())
                return this.HTTPFactory.createXHR(N, _);
              if (this.isXDRSupported(_.indexOf("https:") === 0))
                return this.HTTPFactory.createXDR(N, _);
              throw "Cross-origin HTTP requests are not supported";
            },
            isXHRSupported() {
              var N = this.getXHRAPI();
              return !!N && new N().withCredentials !== void 0;
            },
            isXDRSupported(N) {
              var _ = N ? "https:" : "http:", M = this.getProtocol();
              return !!window.XDomainRequest && M === _;
            },
            addUnloadListener(N) {
              window.addEventListener !== void 0 ? window.addEventListener("unload", N, !1) : window.attachEvent !== void 0 && window.attachEvent("onunload", N);
            },
            removeUnloadListener(N) {
              window.addEventListener !== void 0 ? window.removeEventListener("unload", N, !1) : window.detachEvent !== void 0 && window.detachEvent("onunload", N);
            },
            randomInt(N) {
              return Math.floor(function() {
                return (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32);
              }() * N);
            }
          }, ot = Zn, Dh;
          (function(N) {
            N[N.ERROR = 3] = "ERROR", N[N.INFO = 6] = "INFO", N[N.DEBUG = 7] = "DEBUG";
          })(Dh || (Dh = {}));
          var od = Dh;
          class vC {
            constructor(_, M, Y) {
              this.key = _, this.session = M, this.events = [], this.options = Y || {}, this.sent = 0, this.uniqueID = 0;
            }
            log(_, M) {
              _ <= this.options.level && (this.events.push(de({}, M, { timestamp: re.now() })), this.options.limit && this.events.length > this.options.limit && this.events.shift());
            }
            error(_) {
              this.log(od.ERROR, _);
            }
            info(_) {
              this.log(od.INFO, _);
            }
            debug(_) {
              this.log(od.DEBUG, _);
            }
            isEmpty() {
              return this.events.length === 0;
            }
            send(_, M) {
              var Y = de({
                session: this.session,
                bundle: this.sent + 1,
                key: this.key,
                lib: "js",
                version: this.options.version,
                cluster: this.options.cluster,
                features: this.options.features,
                timeline: this.events
              }, this.options.params);
              return this.events = [], _(Y, (Q, $e) => {
                Q || this.sent++, M && M(Q, $e);
              }), !0;
            }
            generateUniqueID() {
              return this.uniqueID++, this.uniqueID;
            }
          }
          class yC {
            constructor(_, M, Y, Q) {
              this.name = _, this.priority = M, this.transport = Y, this.options = Q || {};
            }
            isSupported() {
              return this.transport.isSupported({
                useTLS: this.options.useTLS
              });
            }
            connect(_, M) {
              if (this.isSupported()) {
                if (this.priority < _)
                  return zv(new S(), M);
              } else
                return zv(new P(), M);
              var Y = !1, Q = this.transport.createConnection(this.name, this.priority, this.options.key, this.options), $e = null, Ke = function() {
                Q.unbind("initialized", Ke), Q.connect();
              }, dt = function() {
                $e = qn.createHandshake(Q, function(xr) {
                  Y = !0, xn(), M(null, xr);
                });
              }, Bt = function(xr) {
                xn(), M(xr);
              }, vn = function() {
                xn();
                var xr;
                xr = Le(Q), M(new E(xr));
              }, xn = function() {
                Q.unbind("initialized", Ke), Q.unbind("open", dt), Q.unbind("error", Bt), Q.unbind("closed", vn);
              };
              return Q.bind("initialized", Ke), Q.bind("open", dt), Q.bind("error", Bt), Q.bind("closed", vn), Q.initialize(), {
                abort: () => {
                  Y || (xn(), $e ? $e.close() : Q.close());
                },
                forceMinPriority: (xr) => {
                  Y || this.priority < xr && ($e ? $e.close() : Q.close());
                }
              };
            }
          }
          function zv(N, _) {
            return re.defer(function() {
              _(N);
            }), {
              abort: function() {
              },
              forceMinPriority: function() {
              }
            };
          }
          const { Transports: bC } = ot;
          var Uv = function(N, _, M, Y, Q, $e) {
            var Ke = bC[M];
            if (!Ke)
              throw new $(M);
            var dt = (!N.enabledTransports || ue(N.enabledTransports, _) !== -1) && (!N.disabledTransports || ue(N.disabledTransports, _) === -1), Bt;
            return dt ? (Q = Object.assign({ ignoreNullOrigin: N.ignoreNullOrigin }, Q), Bt = new yC(_, Y, $e ? $e.getAssistant(Ke) : Ke, Q)) : Bt = wC, Bt;
          }, wC = {
            isSupported: function() {
              return !1;
            },
            connect: function(N, _) {
              var M = re.defer(function() {
                _(new P());
              });
              return {
                abort: function() {
                  M.ensureAborted();
                },
                forceMinPriority: function() {
                }
              };
            }
          };
          function li(N) {
            if (N == null)
              throw "You must pass an options object";
            if (N.cluster == null)
              throw "Options object must provide a cluster";
            "disableStats" in N && Z.warn("The disableStats option is deprecated in favor of enableStats");
          }
          const jh = (N, _) => {
            var M = "socket_id=" + encodeURIComponent(N.socketId);
            for (var Y in _.params)
              M += "&" + encodeURIComponent(Y) + "=" + encodeURIComponent(_.params[Y]);
            if (_.paramsProvider != null) {
              let Q = _.paramsProvider();
              for (var Y in Q)
                M += "&" + encodeURIComponent(Y) + "=" + encodeURIComponent(Q[Y]);
            }
            return M;
          };
          var Hv = (N) => {
            if (typeof ot.getAuthorizers()[N.transport] > "u")
              throw `'${N.transport}' is not a recognized auth transport`;
            return (_, M) => {
              const Y = jh(_, N);
              ot.getAuthorizers()[N.transport](ot, Y, N, y.UserAuthentication, M);
            };
          };
          const Fh = (N, _) => {
            var M = "socket_id=" + encodeURIComponent(N.socketId);
            M += "&channel_name=" + encodeURIComponent(N.channelName);
            for (var Y in _.params)
              M += "&" + encodeURIComponent(Y) + "=" + encodeURIComponent(_.params[Y]);
            if (_.paramsProvider != null) {
              let Q = _.paramsProvider();
              for (var Y in Q)
                M += "&" + encodeURIComponent(Y) + "=" + encodeURIComponent(Q[Y]);
            }
            return M;
          };
          var Wv = (N) => {
            if (typeof ot.getAuthorizers()[N.transport] > "u")
              throw `'${N.transport}' is not a recognized auth transport`;
            return (_, M) => {
              const Y = Fh(_, N);
              ot.getAuthorizers()[N.transport](ot, Y, N, y.ChannelAuthorization, M);
            };
          };
          const Vv = (N, _, M) => {
            const Y = {
              authTransport: _.transport,
              authEndpoint: _.endpoint,
              auth: {
                params: _.params,
                headers: _.headers
              }
            };
            return (Q, $e) => {
              const Ke = N.channel(Q.channelName);
              M(Ke, Y).authorize(Q.socketId, $e);
            };
          };
          function Gv(N, _) {
            let M = {
              activityTimeout: N.activityTimeout || l.activityTimeout,
              cluster: N.cluster,
              httpPath: N.httpPath || l.httpPath,
              httpPort: N.httpPort || l.httpPort,
              httpsPort: N.httpsPort || l.httpsPort,
              pongTimeout: N.pongTimeout || l.pongTimeout,
              statsHost: N.statsHost || l.stats_host,
              unavailableTimeout: N.unavailableTimeout || l.unavailableTimeout,
              wsPath: N.wsPath || l.wsPath,
              wsPort: N.wsPort || l.wsPort,
              wssPort: N.wssPort || l.wssPort,
              enableStats: SC(N),
              httpHost: Kv(N),
              useTLS: yo(N),
              wsHost: qv(N),
              userAuthenticator: No(N),
              channelAuthorizer: Xv(N, _)
            };
            return "disabledTransports" in N && (M.disabledTransports = N.disabledTransports), "enabledTransports" in N && (M.enabledTransports = N.enabledTransports), "ignoreNullOrigin" in N && (M.ignoreNullOrigin = N.ignoreNullOrigin), "timelineParams" in N && (M.timelineParams = N.timelineParams), "nacl" in N && (M.nacl = N.nacl), M;
          }
          function Kv(N) {
            return N.httpHost ? N.httpHost : N.cluster ? `sockjs-${N.cluster}.pusher.com` : l.httpHost;
          }
          function qv(N) {
            return N.wsHost ? N.wsHost : Yv(N.cluster);
          }
          function Yv(N) {
            return `ws-${N}.pusher.com`;
          }
          function yo(N) {
            return ot.getProtocol() === "https:" ? !0 : N.forceTLS !== !1;
          }
          function SC(N) {
            return "enableStats" in N ? N.enableStats : "disableStats" in N ? !N.disableStats : !1;
          }
          function No(N) {
            const _ = Object.assign(Object.assign({}, l.userAuthentication), N.userAuthentication);
            return "customHandler" in _ && _.customHandler != null ? _.customHandler : Hv(_);
          }
          function xC(N, _) {
            let M;
            return "channelAuthorization" in N ? M = Object.assign(Object.assign({}, l.channelAuthorization), N.channelAuthorization) : (M = {
              transport: N.authTransport || l.authTransport,
              endpoint: N.authEndpoint || l.authEndpoint
            }, "auth" in N && ("params" in N.auth && (M.params = N.auth.params), "headers" in N.auth && (M.headers = N.auth.headers)), "authorizer" in N && (M.customHandler = Vv(_, M, N.authorizer))), M;
          }
          function Xv(N, _) {
            const M = xC(N, _);
            return "customHandler" in M && M.customHandler != null ? M.customHandler : Wv(M);
          }
          class ol extends ut {
            constructor(_) {
              super(function(M, Y) {
                Z.debug(`No callbacks on watchlist events for ${M}`);
              }), this.pusher = _, this.bindWatchlistInternalEvent();
            }
            handleEvent(_) {
              _.data.events.forEach((M) => {
                this.emit(M.name, M);
              });
            }
            bindWatchlistInternalEvent() {
              this.pusher.connection.bind("message", (_) => {
                var M = _.event;
                M === "pusher_internal:watchlist_events" && this.handleEvent(_);
              });
            }
          }
          function ad() {
            let N, _;
            return { promise: new Promise((Y, Q) => {
              N = Y, _ = Q;
            }), resolve: N, reject: _ };
          }
          var Bh = ad;
          class or extends ut {
            constructor(_) {
              super(function(M, Y) {
                Z.debug("No callbacks on user for " + M);
              }), this.signin_requested = !1, this.user_data = null, this.serverToUserChannel = null, this.signinDonePromise = null, this._signinDoneResolve = null, this._onAuthorize = (M, Y) => {
                if (M) {
                  Z.warn(`Error during signin: ${M}`), this._cleanup();
                  return;
                }
                this.pusher.send_event("pusher:signin", {
                  auth: Y.auth,
                  user_data: Y.user_data
                });
              }, this.pusher = _, this.pusher.connection.bind("state_change", ({ previous: M, current: Y }) => {
                M !== "connected" && Y === "connected" && this._signin(), M === "connected" && Y !== "connected" && (this._cleanup(), this._newSigninPromiseIfNeeded());
              }), this.watchlist = new ol(_), this.pusher.connection.bind("message", (M) => {
                var Y = M.event;
                Y === "pusher:signin_success" && this._onSigninSuccess(M.data), this.serverToUserChannel && this.serverToUserChannel.name === M.channel && this.serverToUserChannel.handleEvent(M);
              });
            }
            signin() {
              this.signin_requested || (this.signin_requested = !0, this._signin());
            }
            _signin() {
              this.signin_requested && (this._newSigninPromiseIfNeeded(), this.pusher.connection.state === "connected" && this.pusher.config.userAuthenticator({
                socketId: this.pusher.connection.socket_id
              }, this._onAuthorize));
            }
            _onSigninSuccess(_) {
              try {
                this.user_data = JSON.parse(_.user_data);
              } catch {
                Z.error(`Failed parsing user data after signin: ${_.user_data}`), this._cleanup();
                return;
              }
              if (typeof this.user_data.id != "string" || this.user_data.id === "") {
                Z.error(`user_data doesn't contain an id. user_data: ${this.user_data}`), this._cleanup();
                return;
              }
              this._signinDoneResolve(), this._subscribeChannels();
            }
            _subscribeChannels() {
              const _ = (M) => {
                M.subscriptionPending && M.subscriptionCancelled ? M.reinstateSubscription() : !M.subscriptionPending && this.pusher.connection.state === "connected" && M.subscribe();
              };
              this.serverToUserChannel = new Kn(`#server-to-user-${this.user_data.id}`, this.pusher), this.serverToUserChannel.bind_global((M, Y) => {
                M.indexOf("pusher_internal:") === 0 || M.indexOf("pusher:") === 0 || this.emit(M, Y);
              }), _(this.serverToUserChannel);
            }
            _cleanup() {
              this.user_data = null, this.serverToUserChannel && (this.serverToUserChannel.unbind_all(), this.serverToUserChannel.disconnect(), this.serverToUserChannel = null), this.signin_requested && this._signinDoneResolve();
            }
            _newSigninPromiseIfNeeded() {
              if (!this.signin_requested || this.signinDonePromise && !this.signinDonePromise.done)
                return;
              const { promise: _, resolve: M, reject: Y } = Bh();
              _.done = !1;
              const Q = () => {
                _.done = !0;
              };
              _.then(Q).catch(Q), this.signinDonePromise = _, this._signinDoneResolve = M;
            }
          }
          class ar {
            static ready() {
              ar.isReady = !0;
              for (var _ = 0, M = ar.instances.length; _ < M; _++)
                ar.instances[_].connect();
            }
            static getClientFeatures() {
              return Se(et({ ws: ot.Transports.ws }, function(_) {
                return _.isSupported({});
              }));
            }
            constructor(_, M) {
              CC(_), li(M), this.key = _, this.config = Gv(M, this), this.channels = qn.createChannels(), this.global_emitter = new ut(), this.sessionID = ot.randomInt(1e9), this.timeline = new vC(this.key, this.sessionID, {
                cluster: this.config.cluster,
                features: ar.getClientFeatures(),
                params: this.config.timelineParams || {},
                limit: 50,
                level: od.INFO,
                version: l.VERSION
              }), this.config.enableStats && (this.timelineSender = qn.createTimelineSender(this.timeline, {
                host: this.config.statsHost,
                path: "/timeline/v2/" + ot.TimelineTransport.name
              }));
              var Y = (Q) => ot.getDefaultStrategy(this.config, Q, Uv);
              this.connection = qn.createConnectionManager(this.key, {
                getStrategy: Y,
                timeline: this.timeline,
                activityTimeout: this.config.activityTimeout,
                pongTimeout: this.config.pongTimeout,
                unavailableTimeout: this.config.unavailableTimeout,
                useTLS: !!this.config.useTLS
              }), this.connection.bind("connected", () => {
                this.subscribeAll(), this.timelineSender && this.timelineSender.send(this.connection.isUsingTLS());
              }), this.connection.bind("message", (Q) => {
                var $e = Q.event, Ke = $e.indexOf("pusher_internal:") === 0;
                if (Q.channel) {
                  var dt = this.channel(Q.channel);
                  dt && dt.handleEvent(Q);
                }
                Ke || this.global_emitter.emit(Q.event, Q.data);
              }), this.connection.bind("connecting", () => {
                this.channels.disconnect();
              }), this.connection.bind("disconnected", () => {
                this.channels.disconnect();
              }), this.connection.bind("error", (Q) => {
                Z.warn(Q);
              }), ar.instances.push(this), this.timeline.info({ instances: ar.instances.length }), this.user = new or(this), ar.isReady && this.connect();
            }
            channel(_) {
              return this.channels.find(_);
            }
            allChannels() {
              return this.channels.all();
            }
            connect() {
              if (this.connection.connect(), this.timelineSender && !this.timelineSenderTimer) {
                var _ = this.connection.isUsingTLS(), M = this.timelineSender;
                this.timelineSenderTimer = new U(6e4, function() {
                  M.send(_);
                });
              }
            }
            disconnect() {
              this.connection.disconnect(), this.timelineSenderTimer && (this.timelineSenderTimer.ensureAborted(), this.timelineSenderTimer = null);
            }
            bind(_, M, Y) {
              return this.global_emitter.bind(_, M, Y), this;
            }
            unbind(_, M, Y) {
              return this.global_emitter.unbind(_, M, Y), this;
            }
            bind_global(_) {
              return this.global_emitter.bind_global(_), this;
            }
            unbind_global(_) {
              return this.global_emitter.unbind_global(_), this;
            }
            unbind_all(_) {
              return this.global_emitter.unbind_all(), this;
            }
            subscribeAll() {
              var _;
              for (_ in this.channels.channels)
                this.channels.channels.hasOwnProperty(_) && this.subscribe(_);
            }
            subscribe(_) {
              var M = this.channels.add(_, this);
              return M.subscriptionPending && M.subscriptionCancelled ? M.reinstateSubscription() : !M.subscriptionPending && this.connection.state === "connected" && M.subscribe(), M;
            }
            unsubscribe(_) {
              var M = this.channels.find(_);
              M && M.subscriptionPending ? M.cancelSubscription() : (M = this.channels.remove(_), M && M.subscribed && M.unsubscribe());
            }
            send_event(_, M, Y) {
              return this.connection.send_event(_, M, Y);
            }
            shouldUseTLS() {
              return this.config.useTLS;
            }
            signin() {
              this.user.signin();
            }
          }
          ar.instances = [], ar.isReady = !1, ar.logToConsole = !1, ar.Runtime = ot, ar.ScriptReceivers = ot.ScriptReceivers, ar.DependenciesReceivers = ot.DependenciesReceivers, ar.auth_callbacks = ot.auth_callbacks;
          var Bu = r.default = ar;
          function CC(N) {
            if (N == null)
              throw "You must pass your app key when you instantiate Pusher.";
          }
          ot.setup(ar);
        }
        /******/
      ])
    );
  });
})(XY);
var Y9e = XY.exports;
const X9e = /* @__PURE__ */ Oi(Y9e), QY = m.createContext(null), Q9e = () => m.useContext(QY), JY = (e = "48674eac95b91f0b474b", t = "us3") => {
  if (!e || !t)
    throw new Error(
      "You should either pass PUSHER_KEY and PUSHER_CLUSTER or include them in .env!"
    );
  const n = Q9e(), r = m.useRef(null), i = n || r;
  return {
    pusherRef: i,
    useConnection: () => {
      const l = wr();
      m.useEffect(() => {
        var c, f;
        return i === r && (i.current = new X9e(e, {
          cluster: t,
          activityTimeout: 8e3,
          pongTimeout: 5e3
        }), (c = i.current) == null || c.connection.bind("state_change", (d) => {
          if (rt.debug("[pusher]: state changed", { state: d, date: /* @__PURE__ */ new Date() }), d.current === "connected") {
            rt.debug("[pusher]: Connection to Pusher establed."), l(
              ep({
                status: !0
              })
            );
            return;
          }
          if (d.current === "connecting" && d.previous === "connected") {
            l(
              ep({
                status: !1
              })
            );
            return;
          }
          if (d.current === "disconnected" || d.current === "failed" || d.current === "unavailable") {
            l(
              ep({
                status: !1
              })
            );
            return;
          }
          rt.debug("[pusher]: Connection to Pusher is lost");
        }), (f = i.current) == null || f.connection.bind("error", (d) => {
          rt.debug(`[pusher] connection error: ${d}`);
        })), () => {
          var d;
          i === r && (rt.debug("[pusher]: disconnecting"), l(
            ep({
              status: !1
            })
          ), (d = i.current) == null || d.disconnect());
        };
      }, []);
    },
    useSubscribe: (l, c) => {
      const f = b5(l) ? l : [l];
      m.useEffect(() => (setTimeout(() => {
        f.forEach((d) => {
          var p;
          rt.debug("[pusher]: subscribe ", d), (p = i.current) == null || p.subscribe(d);
        });
      }), () => {
        f.forEach((d) => {
          var p;
          rt.debug("[pusher]: unsubscribe ", d), (p = i.current) == null || p.unsubscribe(d);
        });
      }), c);
    },
    useEvents: (l, c) => {
      const f = b5(l) ? l : [l];
      m.useEffect(() => (setTimeout(() => {
        f.forEach(({ channel: d, event: p, handler: g }) => {
          var v, y, x, b;
          rt.debug(
            `[pusher]: listenting to channel ${d} event ${p}`,
            {
              current: (v = i.current) == null ? void 0 : v.channel(d),
              all_channels: (y = i.current) == null ? void 0 : y.allChannels()
            }
          ), (x = i.current) != null && x.channel(d) && ((b = i.current) == null || b.channel(d).bind(p, g));
        });
      }), () => {
        f.forEach(({ channel: d, event: p, handler: g }) => {
          var v, y, x, b;
          rt.debug(
            `[pusher]: leaving channel ${d} event ${p}`,
            {
              current: (v = i.current) == null ? void 0 : v.channel(d),
              all_channels: (y = i.current) == null ? void 0 : y.allChannels()
            }
          ), (x = i.current) != null && x.channel(d) && ((b = i.current) == null || b.channel(d).unbind(p, g));
        });
      }), c);
    }
  };
}, J9e = ({ channels: e, events: t, channelsDeps: n = [], eventsDeps: r = [] }) => {
  const { useConnection: i, useSubscribe: o, useEvents: a } = JY();
  return i(), o(e, n), a(t, r), null;
}, ZY = ({ children: e }) => {
  const { pusherRef: t, useConnection: n } = JY();
  return n(), /* @__PURE__ */ H.jsx(QY.Provider, { value: t, children: e });
}, pw = class pw extends $2e {
  static create(t) {
    return new pw(this.EventName, t);
  }
};
pw.EventName = "lead.created";
let cw = pw;
class MM {
  constructor(t, n, r, i, o, a, s, l, c, f, d, p, g, v, y, x, b) {
    this.id = t, this.name = n, this.first_name = r, this.last_name = i, this.EntryUrl = o, this.PageUrl = a, this.email = s, this.phone = l, this.createdAt = c, this.webchatId = f, this.project_id = d, this.bot_id = p, this.created_at = g, this.updated_at = v, this.city = y, this.zip_code = x, this.state = b;
  }
  static create(t) {
    return new MM(
      t.id || null,
      t.name || null,
      t.first_name || null,
      t.last_name || null,
      t.EntryUrl || null,
      t.PageUrl || null,
      t.email || null,
      t.phone || null,
      t.createdAt || null,
      t.webchatId || null,
      t.project_id || null,
      t.bot_id || null,
      t.created_at || null,
      t.updated_at || null,
      t.city || null,
      t.zip_code || null,
      t.state || null
    );
  }
}
class Z9e {
  constructor() {
    this.featureFlagService = MIe;
  }
  perform(t) {
    if (this.featureFlagService.isFeatureEnabled())
      return this.action(t);
  }
  action(t) {
    const n = cw.create(t), { adapter: r } = ms();
    return n.sent(), r.postLeadToAAC(t), Promise.resolve(t);
  }
}
const eWe = () => {
  const e = new Z9e(), { getEntryUrl: t } = ms(), n = pe(Tv);
  return {
    handler: (i) => {
      try {
        rt.info("[webchat] get lead created data", i);
        const { lead: o } = i, a = window.location != window.parent.location ? document.referrer : window.location.href, s = t(), l = MM.create({
          ...o,
          id: o == null ? void 0 : o.id,
          name: `${[o == null ? void 0 : o.first_name, o == null ? void 0 : o.last_name].join(", ")}`,
          first_name: (o == null ? void 0 : o.first_name) ?? "",
          last_name: (o == null ? void 0 : o.last_name) ?? "",
          EntryUrl: s,
          PageUrl: a,
          email: (o == null ? void 0 : o.email) ?? "",
          phone: (o == null ? void 0 : o.phone) ?? "",
          createdAt: o == null ? void 0 : o.created_at,
          webchatId: n
        });
        e.perform(l);
      } catch (o) {
        rt.error("[ui] Lead Create error", o.message);
      }
    },
    leadCreatedEvent: cw.EventName
  };
}, tWe = "message.chunk", nWe = "message.done", EF = () => {
  const e = wr(), { handler: t, leadCreatedEvent: n } = eWe(), r = pe(dM), i = pe(rl), o = pe(rM), { channel: a, eventName: s, received: l } = ms(), c = a(), f = s(), d = [c], p = [r.id], g = async () => e(Qs(!1)), v = async () => {
    try {
      e(
        oh({
          campaignId: r.campaign_id,
          conversationId: r.id,
          traceId: r.trace_id
        })
      );
    } catch (b) {
      rt.error("[ui] received message error", b.message);
    }
  }, y = [
    {
      channel: c,
      event: f,
      handler: async (b) => {
        var w;
        try {
          e(
            Aw({
              campaignId: r.campaign_id,
              conversationId: r.id,
              sourceId: r.source_id,
              traceId: r.trace_id
            })
          ), l(b.message), Kx({
            webchatId: r.source_id,
            webChatType: o
          }) || (await v(), i.length && ((w = yt.last(i)) == null ? void 0 : w.type) === fi.SENT && await g());
        } catch (S) {
          rt.debug("ui received replied message with wrong format", S.message);
        }
      }
    },
    {
      channel: c,
      event: n,
      handler: async (b) => {
        t(b);
      }
    },
    {
      channel: c,
      event: nWe,
      handler: async (b) => {
        try {
          e(dR(b));
        } catch (w) {
          rt.debug("ui received done message with wrong format", w.message);
        }
      }
    },
    {
      channel: c,
      event: tWe,
      handler: async (b) => {
        e(xU(b));
      }
    }
  ], x = [r.id, r.journey_id];
  return /* @__PURE__ */ H.jsx(H.Fragment, { children: r.id && /* @__PURE__ */ H.jsx(
    J9e,
    {
      channels: d,
      channelsDeps: p,
      events: y,
      eventsDeps: x
    }
  ) });
};
class rWe {
  perform(t) {
    const {
      type: n,
      is_capturing_lead: r,
      sources: i = [],
      related_questions: o = [],
      theme: a,
      starter_questions: s = [],
      isFirstMessage: l
    } = t;
    if (![
      Jt.siteCompanion,
      Jt.siteCompanionPopup
    ].includes(a) || n !== oc.SENT || l)
      return !1;
    const f = o.length + s.length > 0, d = i.length > 0;
    return !r && (f || d);
  }
}
function BI() {
  return BI = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, BI.apply(this, arguments);
}
function iWe(e, t) {
  if (e == null)
    return {};
  var n = oWe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function oWe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var NM = m.forwardRef(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = e.size, o = i === void 0 ? 24 : i, a = iWe(e, ["color", "size"]);
  return /* @__PURE__ */ oe.createElement("svg", BI({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: r,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, a), /* @__PURE__ */ oe.createElement("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  }), /* @__PURE__ */ oe.createElement("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  }));
});
NM.propTypes = {
  color: cu.string,
  size: cu.oneOfType([cu.string, cu.number])
};
NM.displayName = "Link";
const aWe = NM;
function zI() {
  return zI = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zI.apply(this, arguments);
}
function sWe(e, t) {
  if (e == null)
    return {};
  var n = lWe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function lWe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var kM = m.forwardRef(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = e.size, o = i === void 0 ? 24 : i, a = sWe(e, ["color", "size"]);
  return /* @__PURE__ */ oe.createElement("svg", zI({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: r,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, a), /* @__PURE__ */ oe.createElement("polyline", {
    points: "1 4 1 10 7 10"
  }), /* @__PURE__ */ oe.createElement("polyline", {
    points: "23 20 23 14 17 14"
  }), /* @__PURE__ */ oe.createElement("path", {
    d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
  }));
});
kM.propTypes = {
  color: cu.string,
  size: cu.oneOfType([cu.string, cu.number])
};
kM.displayName = "RefreshCcw";
const cWe = kM;
function uWe(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const fWe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, dWe = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, pWe = {};
function $F(e, t) {
  return ((t || pWe).jsx ? dWe : fWe).test(e);
}
const hWe = /[ \t\n\f\r]/g;
function mWe(e) {
  return typeof e == "object" ? e.type === "text" ? _F(e.value) : !1 : _F(e);
}
function _F(e) {
  return e.replace(hWe, "") === "";
}
class Lv {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Lv.prototype.property = {};
Lv.prototype.normal = {};
Lv.prototype.space = null;
function eX(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new Lv(n, r, t);
}
function UI(e) {
  return e.toLowerCase();
}
class vs {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
vs.prototype.space = null;
vs.prototype.boolean = !1;
vs.prototype.booleanish = !1;
vs.prototype.overloadedBoolean = !1;
vs.prototype.number = !1;
vs.prototype.commaSeparated = !1;
vs.prototype.spaceSeparated = !1;
vs.prototype.commaOrSpaceSeparated = !1;
vs.prototype.mustUseProperty = !1;
vs.prototype.defined = !1;
let gWe = 0;
const Xt = id(), Jr = id(), tX = id(), qe = id(), lr = id(), Tp = id(), ha = id();
function id() {
  return 2 ** ++gWe;
}
const HI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Xt,
  booleanish: Jr,
  commaOrSpaceSeparated: ha,
  commaSeparated: Tp,
  number: qe,
  overloadedBoolean: tX,
  spaceSeparated: lr
}, Symbol.toStringTag, { value: "Module" })), B_ = Object.keys(HI);
class LM extends vs {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), OF(this, "space", i), typeof r == "number")
      for (; ++o < B_.length; ) {
        const a = B_[o];
        OF(this, B_[o], (r & HI[a]) === HI[a]);
      }
  }
}
LM.prototype.defined = !0;
function OF(e, t, n) {
  n && (e[t] = n);
}
const vWe = {}.hasOwnProperty;
function kh(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (vWe.call(e.properties, r)) {
      const i = e.properties[r], o = new LM(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[UI(r)] = r, n[UI(o.attribute)] = r;
    }
  return new Lv(t, n, e.space);
}
const nX = kh({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), rX = kh({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function iX(e, t) {
  return t in e ? e[t] : t;
}
function oX(e, t) {
  return iX(e, t.toLowerCase());
}
const aX = kh({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: oX,
  properties: { xmlns: null, xmlnsXLink: null }
}), sX = kh({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Jr,
    ariaAutoComplete: null,
    ariaBusy: Jr,
    ariaChecked: Jr,
    ariaColCount: qe,
    ariaColIndex: qe,
    ariaColSpan: qe,
    ariaControls: lr,
    ariaCurrent: null,
    ariaDescribedBy: lr,
    ariaDetails: null,
    ariaDisabled: Jr,
    ariaDropEffect: lr,
    ariaErrorMessage: null,
    ariaExpanded: Jr,
    ariaFlowTo: lr,
    ariaGrabbed: Jr,
    ariaHasPopup: null,
    ariaHidden: Jr,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: lr,
    ariaLevel: qe,
    ariaLive: null,
    ariaModal: Jr,
    ariaMultiLine: Jr,
    ariaMultiSelectable: Jr,
    ariaOrientation: null,
    ariaOwns: lr,
    ariaPlaceholder: null,
    ariaPosInSet: qe,
    ariaPressed: Jr,
    ariaReadOnly: Jr,
    ariaRelevant: null,
    ariaRequired: Jr,
    ariaRoleDescription: lr,
    ariaRowCount: qe,
    ariaRowIndex: qe,
    ariaRowSpan: qe,
    ariaSelected: Jr,
    ariaSetSize: qe,
    ariaSort: null,
    ariaValueMax: qe,
    ariaValueMin: qe,
    ariaValueNow: qe,
    ariaValueText: null,
    role: null
  }
}), yWe = kh({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: oX,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Tp,
    acceptCharset: lr,
    accessKey: lr,
    action: null,
    allow: null,
    allowFullScreen: Xt,
    allowPaymentRequest: Xt,
    allowUserMedia: Xt,
    alt: null,
    as: null,
    async: Xt,
    autoCapitalize: null,
    autoComplete: lr,
    autoFocus: Xt,
    autoPlay: Xt,
    blocking: lr,
    capture: Xt,
    charSet: null,
    checked: Xt,
    cite: null,
    className: lr,
    cols: qe,
    colSpan: null,
    content: null,
    contentEditable: Jr,
    controls: Xt,
    controlsList: lr,
    coords: qe | Tp,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Xt,
    defer: Xt,
    dir: null,
    dirName: null,
    disabled: Xt,
    download: tX,
    draggable: Jr,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Xt,
    formTarget: null,
    headers: lr,
    height: qe,
    hidden: Xt,
    high: qe,
    href: null,
    hrefLang: null,
    htmlFor: lr,
    httpEquiv: lr,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Xt,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Xt,
    itemId: null,
    itemProp: lr,
    itemRef: lr,
    itemScope: Xt,
    itemType: lr,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Xt,
    low: qe,
    manifest: null,
    max: null,
    maxLength: qe,
    media: null,
    method: null,
    min: null,
    minLength: qe,
    multiple: Xt,
    muted: Xt,
    name: null,
    nonce: null,
    noModule: Xt,
    noValidate: Xt,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Xt,
    optimum: qe,
    pattern: null,
    ping: lr,
    placeholder: null,
    playsInline: Xt,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Xt,
    referrerPolicy: null,
    rel: lr,
    required: Xt,
    reversed: Xt,
    rows: qe,
    rowSpan: qe,
    sandbox: lr,
    scope: null,
    scoped: Xt,
    seamless: Xt,
    selected: Xt,
    shadowRootDelegatesFocus: Xt,
    shadowRootMode: null,
    shape: null,
    size: qe,
    sizes: null,
    slot: null,
    span: qe,
    spellCheck: Jr,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: qe,
    step: null,
    style: null,
    tabIndex: qe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Xt,
    useMap: null,
    value: Jr,
    width: qe,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: lr,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: qe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: qe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Xt,
    // Lists. Use CSS to reduce space between items instead
    declare: Xt,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: qe,
    // `<img>` and `<object>`
    leftMargin: qe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: qe,
    // `<body>`
    marginWidth: qe,
    // `<body>`
    noResize: Xt,
    // `<frame>`
    noHref: Xt,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Xt,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Xt,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: qe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Jr,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: qe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: qe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Xt,
    disableRemotePlayback: Xt,
    prefix: null,
    property: null,
    results: qe,
    security: null,
    unselectable: null
  }
}), bWe = kh({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: iX,
  properties: {
    about: ha,
    accentHeight: qe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: qe,
    amplitude: qe,
    arabicForm: null,
    ascent: qe,
    attributeName: null,
    attributeType: null,
    azimuth: qe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: qe,
    by: null,
    calcMode: null,
    capHeight: qe,
    className: lr,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: qe,
    diffuseConstant: qe,
    direction: null,
    display: null,
    dur: null,
    divisor: qe,
    dominantBaseline: null,
    download: Xt,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: qe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: qe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: qe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Tp,
    g2: Tp,
    glyphName: Tp,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: qe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: qe,
    horizOriginX: qe,
    horizOriginY: qe,
    id: null,
    ideographic: qe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: qe,
    k: qe,
    k1: qe,
    k2: qe,
    k3: qe,
    k4: qe,
    kernelMatrix: ha,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: qe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: qe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: qe,
    overlineThickness: qe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: qe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: lr,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: qe,
    pointsAtY: qe,
    pointsAtZ: qe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ha,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ha,
    rev: ha,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ha,
    requiredFeatures: ha,
    requiredFonts: ha,
    requiredFormats: ha,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: qe,
    specularExponent: qe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: qe,
    strikethroughThickness: qe,
    string: null,
    stroke: null,
    strokeDashArray: ha,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: qe,
    strokeOpacity: qe,
    strokeWidth: null,
    style: null,
    surfaceScale: qe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ha,
    tabIndex: qe,
    tableValues: null,
    target: null,
    targetX: qe,
    targetY: qe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ha,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: qe,
    underlineThickness: qe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: qe,
    values: null,
    vAlphabetic: qe,
    vMathematical: qe,
    vectorEffect: null,
    vHanging: qe,
    vIdeographic: qe,
    version: null,
    vertAdvY: qe,
    vertOriginX: qe,
    vertOriginY: qe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: qe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), wWe = /^data[-\w.:]+$/i, PF = /-[a-z]/g, SWe = /[A-Z]/g;
function xWe(e, t) {
  const n = UI(t);
  let r = t, i = vs;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && wWe.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(PF, EWe);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!PF.test(o)) {
        let a = o.replace(SWe, CWe);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    i = LM;
  }
  return new i(r, t);
}
function CWe(e) {
  return "-" + e.toLowerCase();
}
function EWe(e) {
  return e.charAt(1).toUpperCase();
}
const $We = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, _We = eX([rX, nX, aX, sX, yWe], "html"), DM = eX([rX, nX, aX, sX, bWe], "svg");
function OWe(e) {
  return e.join(" ").trim();
}
var lX = {}, TF = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, PWe = /\n/g, TWe = /^\s*/, IWe = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, AWe = /^:\s*/, RWe = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, MWe = /^[;\s]*/, NWe = /^\s+|\s+$/g, kWe = `
`, IF = "/", AF = "*", mf = "", LWe = "comment", DWe = "declaration", jWe = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function i(v) {
    var y = v.match(PWe);
    y && (n += y.length);
    var x = v.lastIndexOf(kWe);
    r = ~x ? v.length - x : r + v.length;
  }
  function o() {
    var v = { line: n, column: r };
    return function(y) {
      return y.position = new a(v), c(), y;
    };
  }
  function a(v) {
    this.start = v, this.end = { line: n, column: r }, this.source = t.source;
  }
  a.prototype.content = e;
  function s(v) {
    var y = new Error(
      t.source + ":" + n + ":" + r + ": " + v
    );
    if (y.reason = v, y.filename = t.source, y.line = n, y.column = r, y.source = e, !t.silent)
      throw y;
  }
  function l(v) {
    var y = v.exec(e);
    if (y) {
      var x = y[0];
      return i(x), e = e.slice(x.length), y;
    }
  }
  function c() {
    l(TWe);
  }
  function f(v) {
    var y;
    for (v = v || []; y = d(); )
      y !== !1 && v.push(y);
    return v;
  }
  function d() {
    var v = o();
    if (!(IF != e.charAt(0) || AF != e.charAt(1))) {
      for (var y = 2; mf != e.charAt(y) && (AF != e.charAt(y) || IF != e.charAt(y + 1)); )
        ++y;
      if (y += 2, mf === e.charAt(y - 1))
        return s("End of comment missing");
      var x = e.slice(2, y - 2);
      return r += 2, i(x), e = e.slice(y), r += 2, v({
        type: LWe,
        comment: x
      });
    }
  }
  function p() {
    var v = o(), y = l(IWe);
    if (y) {
      if (d(), !l(AWe))
        return s("property missing ':'");
      var x = l(RWe), b = v({
        type: DWe,
        property: RF(y[0].replace(TF, mf)),
        value: x ? RF(x[0].replace(TF, mf)) : mf
      });
      return l(MWe), b;
    }
  }
  function g() {
    var v = [];
    f(v);
    for (var y; y = p(); )
      y !== !1 && (v.push(y), f(v));
    return v;
  }
  return c(), g();
};
function RF(e) {
  return e ? e.replace(NWe, mf) : mf;
}
var FWe = qa && qa.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(lX, "__esModule", { value: !0 });
var BWe = FWe(jWe);
function zWe(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, BWe.default)(e), i = typeof t == "function";
  return r.forEach(function(o) {
    if (o.type === "declaration") {
      var a = o.property, s = o.value;
      i ? t(a, s, o) : s && (n = n || {}, n[a] = s);
    }
  }), n;
}
var MF = lX.default = zWe;
const UWe = MF.default || MF, HWe = WWe("start");
function WWe(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function ag(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? NF(e.position) : "start" in e || "end" in e ? NF(e) : "line" in e || "column" in e ? WI(e) : "";
}
function WI(e) {
  return kF(e && e.line) + ":" + kF(e && e.column);
}
function NF(e) {
  return WI(e && e.start) + "-" + WI(e && e.end);
}
function kF(e) {
  return e && typeof e == "number" ? e : 1;
}
class Ki extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", o = {}, a = !1;
    if (n && ("line" in n && "column" in n ? o = { place: n } : "start" in n && "end" in n ? o = { place: n } : "type" in n ? o = {
      ancestors: [n],
      place: n.position
    } : o = { ...n }), typeof t == "string" ? i = t : !o.cause && t && (a = !0, i = t.message, o.cause = t), !o.ruleId && !o.source && typeof r == "string") {
      const l = r.indexOf(":");
      l === -1 ? o.ruleId = r : (o.source = r.slice(0, l), o.ruleId = r.slice(l + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const l = o.ancestors[o.ancestors.length - 1];
      l && (o.place = l.position);
    }
    const s = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = s ? s.line : void 0, this.name = ag(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = a && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Ki.prototype.file = "";
Ki.prototype.name = "";
Ki.prototype.reason = "";
Ki.prototype.message = "";
Ki.prototype.stack = "";
Ki.prototype.column = void 0;
Ki.prototype.line = void 0;
Ki.prototype.ancestors = void 0;
Ki.prototype.cause = void 0;
Ki.prototype.fatal = void 0;
Ki.prototype.place = void 0;
Ki.prototype.ruleId = void 0;
Ki.prototype.source = void 0;
const jM = {}.hasOwnProperty, VWe = /* @__PURE__ */ new Map(), GWe = /[A-Z]/g, KWe = /-([a-z])/g, qWe = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), YWe = /* @__PURE__ */ new Set(["td", "th"]), cX = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function XWe(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = i7e(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = r7e(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? DM : _We,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, o = uX(i, e, void 0);
  return o && typeof o != "string" ? o : i.create(
    e,
    i.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function uX(e, t, n) {
  if (t.type === "element")
    return QWe(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return JWe(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return e7e(e, t, n);
  if (t.type === "mdxjsEsm")
    return ZWe(e, t);
  if (t.type === "root")
    return t7e(e, t, n);
  if (t.type === "text")
    return n7e(e, t);
}
function QWe(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = DM, e.schema = i), e.ancestors.push(t);
  const o = dX(e, t.tagName, !1), a = o7e(e, t);
  let s = BM(e, t);
  return qWe.has(t.tagName) && (s = s.filter(function(l) {
    return typeof l == "string" ? !mWe(l) : !0;
  })), fX(e, a, o, t), FM(a, s), e.ancestors.pop(), e.schema = r, e.create(t, o, a, n);
}
function JWe(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  Qg(e, t.position);
}
function ZWe(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  Qg(e, t.position);
}
function e7e(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = DM, e.schema = i), e.ancestors.push(t);
  const o = t.name === null ? e.Fragment : dX(e, t.name, !0), a = a7e(e, t), s = BM(e, t);
  return fX(e, a, o, t), FM(a, s), e.ancestors.pop(), e.schema = r, e.create(t, o, a, n);
}
function t7e(e, t, n) {
  const r = {};
  return FM(r, BM(e, t)), e.create(t, e.Fragment, r, n);
}
function n7e(e, t) {
  return t.value;
}
function fX(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function FM(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function r7e(e, t, n) {
  return r;
  function r(i, o, a, s) {
    const c = Array.isArray(a.children) ? n : t;
    return s ? c(o, a, s) : c(o, a);
  }
}
function i7e(e, t) {
  return n;
  function n(r, i, o, a) {
    const s = Array.isArray(o.children), l = HWe(r);
    return t(
      i,
      o,
      a,
      s,
      {
        columnNumber: l ? l.column - 1 : void 0,
        fileName: e,
        lineNumber: l ? l.line : void 0
      },
      void 0
    );
  }
}
function o7e(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && jM.call(t.properties, i)) {
      const o = s7e(e, i, t.properties[i]);
      if (o) {
        const [a, s] = o;
        e.tableCellAlignToStyle && a === "align" && typeof s == "string" && YWe.has(t.tagName) ? r = s : n[a] = s;
      }
    }
  if (r) {
    const o = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function a7e(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const o = r.data.estree.body[0];
        o.type;
        const a = o.expression;
        a.type;
        const s = a.properties[0];
        s.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(s.argument)
        );
      } else
        Qg(e, t.position);
    else {
      const i = r.name;
      let o;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const s = r.value.data.estree.body[0];
          s.type, o = e.evaluater.evaluateExpression(s.expression);
        } else
          Qg(e, t.position);
      else
        o = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      o;
    }
  return n;
}
function BM(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : VWe;
  for (; ++r < t.children.length; ) {
    const o = t.children[r];
    let a;
    if (e.passKeys) {
      const l = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (l) {
        const c = i.get(l) || 0;
        a = l + "-" + c, i.set(l, c + 1);
      }
    }
    const s = uX(e, o, a);
    s !== void 0 && n.push(s);
  }
  return n;
}
function s7e(e, t, n) {
  const r = xWe(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? uWe(n) : OWe(n)), r.property === "style") {
      let i = typeof n == "object" ? n : l7e(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = c7e(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? $We[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function l7e(e, t) {
  const n = {};
  try {
    UWe(t, r);
  } catch (i) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        i
      ), a = new Ki("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw a.file = e.filePath || void 0, a.url = cX + "#cannot-parse-style-attribute", a;
    }
  }
  return n;
  function r(i, o) {
    let a = i;
    a.slice(0, 2) !== "--" && (a.slice(0, 4) === "-ms-" && (a = "ms-" + a.slice(4)), a = a.replace(KWe, f7e)), n[a] = o;
  }
}
function dX(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let o = -1, a;
    for (; ++o < i.length; ) {
      const s = $F(i[o]) ? { type: "Identifier", name: i[o] } : { type: "Literal", value: i[o] };
      a = a ? {
        type: "MemberExpression",
        object: a,
        property: s,
        computed: !!(o && s.type === "Literal"),
        optional: !1
      } : s;
    }
    r = a;
  } else
    r = $F(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return jM.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  Qg(e);
}
function Qg(e, t) {
  const n = new Ki(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = cX + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function c7e(e) {
  const t = {};
  let n;
  for (n in e)
    jM.call(e, n) && (t[u7e(n)] = e[n]);
  return t;
}
function u7e(e) {
  let t = e.replace(GWe, d7e);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function f7e(e, t) {
  return t.toUpperCase();
}
function d7e(e) {
  return "-" + e.toLowerCase();
}
const z_ = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, p7e = {};
function h7e(e, t) {
  const n = t || p7e, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return pX(e, r, i);
}
function pX(e, t, n) {
  if (m7e(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return LF(e.children, t, n);
  }
  return Array.isArray(e) ? LF(e, t, n) : "";
}
function LF(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = pX(e[i], t, n);
  return r.join("");
}
function m7e(e) {
  return !!(e && typeof e == "object");
}
const DF = document.createElement("i");
function zM(e) {
  const t = "&" + e + ";";
  DF.innerHTML = t;
  const n = DF.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Al(e, t, n, r) {
  const i = e.length;
  let o = 0, a;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); o < r.length; )
      a = r.slice(o, o + 1e4), a.unshift(t, 0), e.splice(...a), o += 1e4, t += 1e4;
}
function Ka(e, t) {
  return e.length > 0 ? (Al(e, e.length, 0, t), e) : t;
}
const jF = {}.hasOwnProperty;
function g7e(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    v7e(t, e[n]);
  return t;
}
function v7e(e, t) {
  let n;
  for (n in t) {
    const i = (jF.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let a;
    if (o)
      for (a in o) {
        jF.call(i, a) || (i[a] = []);
        const s = o[a];
        y7e(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function y7e(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Al(e, 0, 0, r);
}
function hX(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function Ip(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const b7e = Fu(new RegExp("\\p{P}", "u")), Sl = Fu(/[A-Za-z]/), Ca = Fu(/[\dA-Za-z]/), w7e = Fu(/[#-'*+\--9=?A-Z^-~]/);
function VI(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const GI = Fu(/\d/), S7e = Fu(/[\dA-Fa-f]/), mX = Fu(/[!-/:-@[-`{-~]/);
function Ft(e) {
  return e !== null && e < -2;
}
function Xo(e) {
  return e !== null && (e < 0 || e === 32);
}
function Pn(e) {
  return e === -2 || e === -1 || e === 32;
}
function x7e(e) {
  return mX(e) || b7e(e);
}
const C7e = Fu(/\s/);
function Fu(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Lh(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let a = "";
    if (o === 37 && Ca(e.charCodeAt(n + 1)) && Ca(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (a = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const s = e.charCodeAt(n + 1);
      o < 56320 && s > 56319 && s < 57344 ? (a = String.fromCharCode(o, s), i = 1) : a = "�";
    } else
      a = String.fromCharCode(o);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + i + 1, a = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function ur(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(l) {
    return Pn(l) ? (e.enter(n), s(l)) : t(l);
  }
  function s(l) {
    return Pn(l) && o++ < i ? (e.consume(l), s) : (e.exit(n), t(l));
  }
}
const E7e = {
  tokenize: $7e
};
function $7e(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ur(e, t, "linePrefix");
  }
  function i(s) {
    return e.enter("paragraph"), o(s);
  }
  function o(s) {
    const l = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = l), n = l, a(s);
  }
  function a(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return Ft(s) ? (e.consume(s), e.exit("chunkText"), o) : (e.consume(s), a);
  }
}
const _7e = {
  tokenize: O7e
}, FF = {
  tokenize: P7e
};
function O7e(e) {
  const t = this, n = [];
  let r = 0, i, o, a;
  return s;
  function s(S) {
    if (r < n.length) {
      const E = n[r];
      return t.containerState = E[1], e.attempt(
        E[0].continuation,
        l,
        c
      )(S);
    }
    return c(S);
  }
  function l(S) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && w();
      const E = t.events.length;
      let O = E, $;
      for (; O--; )
        if (t.events[O][0] === "exit" && t.events[O][1].type === "chunkFlow") {
          $ = t.events[O][1].end;
          break;
        }
      b(r);
      let P = E;
      for (; P < t.events.length; )
        t.events[P][1].end = Object.assign({}, $), P++;
      return Al(
        t.events,
        O + 1,
        0,
        t.events.slice(E)
      ), t.events.length = P, c(S);
    }
    return s(S);
  }
  function c(S) {
    if (r === n.length) {
      if (!i)
        return p(S);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return v(S);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      FF,
      f,
      d
    )(S);
  }
  function f(S) {
    return i && w(), b(r), p(S);
  }
  function d(S) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, v(S);
  }
  function p(S) {
    return t.containerState = {}, e.attempt(
      FF,
      g,
      v
    )(S);
  }
  function g(S) {
    return r++, n.push([t.currentConstruct, t.containerState]), p(S);
  }
  function v(S) {
    if (S === null) {
      i && w(), b(0), e.consume(S);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), y(S);
  }
  function y(S) {
    if (S === null) {
      x(e.exit("chunkFlow"), !0), b(0), e.consume(S);
      return;
    }
    return Ft(S) ? (e.consume(S), x(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(S), y);
  }
  function x(S, E) {
    const O = t.sliceStream(S);
    if (E && O.push(null), S.previous = o, o && (o.next = S), o = S, i.defineSkip(S.start), i.write(O), t.parser.lazy[S.start.line]) {
      let $ = i.events.length;
      for (; $--; )
        if (
          // The token starts before the line ending…
          i.events[$][1].start.offset < a && // …and either is not ended yet…
          (!i.events[$][1].end || // …or ends after it.
          i.events[$][1].end.offset > a)
        )
          return;
      const P = t.events.length;
      let R = P, L, B;
      for (; R--; )
        if (t.events[R][0] === "exit" && t.events[R][1].type === "chunkFlow") {
          if (L) {
            B = t.events[R][1].end;
            break;
          }
          L = !0;
        }
      for (b(r), $ = P; $ < t.events.length; )
        t.events[$][1].end = Object.assign({}, B), $++;
      Al(
        t.events,
        R + 1,
        0,
        t.events.slice(P)
      ), t.events.length = $;
    }
  }
  function b(S) {
    let E = n.length;
    for (; E-- > S; ) {
      const O = n[E];
      t.containerState = O[1], O[0].exit.call(t, e);
    }
    n.length = S;
  }
  function w() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function P7e(e, t, n) {
  return ur(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function BF(e) {
  if (e === null || Xo(e) || C7e(e))
    return 1;
  if (x7e(e))
    return 2;
}
function UM(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const KI = {
  name: "attention",
  tokenize: I7e,
  resolveAll: T7e
};
function T7e(e, t) {
  let n = -1, r, i, o, a, s, l, c, f;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, e[r][1].end), p = Object.assign({}, e[n][1].start);
          zF(d, -l), zF(p, l), a = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, e[r][1].end)
          }, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: p
          }, o = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: l > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, s.end)
          }, e[r][1].end = Object.assign({}, a.start), e[n][1].start = Object.assign({}, s.end), c = [], e[r][1].end.offset - e[r][1].start.offset && (c = Ka(c, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), c = Ka(c, [
            ["enter", i, t],
            ["enter", a, t],
            ["exit", a, t],
            ["enter", o, t]
          ]), c = Ka(
            c,
            UM(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), c = Ka(c, [
            ["exit", o, t],
            ["enter", s, t],
            ["exit", s, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (f = 2, c = Ka(c, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : f = 0, Al(e, r - 1, n - r + 3, c), n = r + c.length - f - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function I7e(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = BF(r);
  let o;
  return a;
  function a(l) {
    return o = l, e.enter("attentionSequence"), s(l);
  }
  function s(l) {
    if (l === o)
      return e.consume(l), s;
    const c = e.exit("attentionSequence"), f = BF(l), d = !f || f === 2 && i || n.includes(l), p = !i || i === 2 && f || n.includes(r);
    return c._open = !!(o === 42 ? d : d && (i || !p)), c._close = !!(o === 42 ? p : p && (f || !d)), t(l);
  }
}
function zF(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const A7e = {
  name: "autolink",
  tokenize: R7e
};
function R7e(e, t, n) {
  let r = 0;
  return i;
  function i(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(g) {
    return Sl(g) ? (e.consume(g), a) : c(g);
  }
  function a(g) {
    return g === 43 || g === 45 || g === 46 || Ca(g) ? (r = 1, s(g)) : c(g);
  }
  function s(g) {
    return g === 58 ? (e.consume(g), r = 0, l) : (g === 43 || g === 45 || g === 46 || Ca(g)) && r++ < 32 ? (e.consume(g), s) : (r = 0, c(g));
  }
  function l(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), t) : g === null || g === 32 || g === 60 || VI(g) ? n(g) : (e.consume(g), l);
  }
  function c(g) {
    return g === 64 ? (e.consume(g), f) : w7e(g) ? (e.consume(g), c) : n(g);
  }
  function f(g) {
    return Ca(g) ? d(g) : n(g);
  }
  function d(g) {
    return g === 46 ? (e.consume(g), r = 0, f) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), t) : p(g);
  }
  function p(g) {
    if ((g === 45 || Ca(g)) && r++ < 63) {
      const v = g === 45 ? p : d;
      return e.consume(g), v;
    }
    return n(g);
  }
}
const iC = {
  tokenize: M7e,
  partial: !0
};
function M7e(e, t, n) {
  return r;
  function r(o) {
    return Pn(o) ? ur(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || Ft(o) ? t(o) : n(o);
  }
}
const gX = {
  name: "blockQuote",
  tokenize: N7e,
  continuation: {
    tokenize: k7e
  },
  exit: L7e
};
function N7e(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    if (a === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), o;
    }
    return n(a);
  }
  function o(a) {
    return Pn(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function k7e(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return Pn(a) ? ur(
      e,
      o,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a) : o(a);
  }
  function o(a) {
    return e.attempt(gX, t, n)(a);
  }
}
function L7e(e) {
  e.exit("blockQuote");
}
const vX = {
  name: "characterEscape",
  tokenize: D7e
};
function D7e(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return mX(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const yX = {
  name: "characterReference",
  tokenize: j7e
};
function j7e(e, t, n) {
  const r = this;
  let i = 0, o, a;
  return s;
  function s(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), l;
  }
  function l(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), o = 31, a = Ca, f(d));
  }
  function c(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, a = S7e, f) : (e.enter("characterReferenceValue"), o = 7, a = GI, f(d));
  }
  function f(d) {
    if (d === 59 && i) {
      const p = e.exit("characterReferenceValue");
      return a === Ca && !zM(r.sliceSerialize(p)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(d) && i++ < o ? (e.consume(d), f) : n(d);
  }
}
const UF = {
  tokenize: B7e,
  partial: !0
}, HF = {
  name: "codeFenced",
  tokenize: F7e,
  concrete: !0
};
function F7e(e, t, n) {
  const r = this, i = {
    tokenize: O,
    partial: !0
  };
  let o = 0, a = 0, s;
  return l;
  function l($) {
    return c($);
  }
  function c($) {
    const P = r.events[r.events.length - 1];
    return o = P && P[1].type === "linePrefix" ? P[2].sliceSerialize(P[1], !0).length : 0, s = $, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), f($);
  }
  function f($) {
    return $ === s ? (a++, e.consume($), f) : a < 3 ? n($) : (e.exit("codeFencedFenceSequence"), Pn($) ? ur(e, d, "whitespace")($) : d($));
  }
  function d($) {
    return $ === null || Ft($) ? (e.exit("codeFencedFence"), r.interrupt ? t($) : e.check(UF, y, E)($)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), p($));
  }
  function p($) {
    return $ === null || Ft($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d($)) : Pn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ur(e, g, "whitespace")($)) : $ === 96 && $ === s ? n($) : (e.consume($), p);
  }
  function g($) {
    return $ === null || Ft($) ? d($) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), v($));
  }
  function v($) {
    return $ === null || Ft($) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d($)) : $ === 96 && $ === s ? n($) : (e.consume($), v);
  }
  function y($) {
    return e.attempt(i, E, x)($);
  }
  function x($) {
    return e.enter("lineEnding"), e.consume($), e.exit("lineEnding"), b;
  }
  function b($) {
    return o > 0 && Pn($) ? ur(
      e,
      w,
      "linePrefix",
      o + 1
    )($) : w($);
  }
  function w($) {
    return $ === null || Ft($) ? e.check(UF, y, E)($) : (e.enter("codeFlowValue"), S($));
  }
  function S($) {
    return $ === null || Ft($) ? (e.exit("codeFlowValue"), w($)) : (e.consume($), S);
  }
  function E($) {
    return e.exit("codeFenced"), t($);
  }
  function O($, P, R) {
    let L = 0;
    return B;
    function B(F) {
      return $.enter("lineEnding"), $.consume(F), $.exit("lineEnding"), j;
    }
    function j(F) {
      return $.enter("codeFencedFence"), Pn(F) ? ur(
        $,
        A,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(F) : A(F);
    }
    function A(F) {
      return F === s ? ($.enter("codeFencedFenceSequence"), T(F)) : R(F);
    }
    function T(F) {
      return F === s ? (L++, $.consume(F), T) : L >= a ? ($.exit("codeFencedFenceSequence"), Pn(F) ? ur($, k, "whitespace")(F) : k(F)) : R(F);
    }
    function k(F) {
      return F === null || Ft(F) ? ($.exit("codeFencedFence"), P(F)) : R(F);
    }
  }
}
function B7e(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a === null ? n(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const U_ = {
  name: "codeIndented",
  tokenize: U7e
}, z7e = {
  tokenize: H7e,
  partial: !0
};
function U7e(e, t, n) {
  const r = this;
  return i;
  function i(c) {
    return e.enter("codeIndented"), ur(e, o, "linePrefix", 5)(c);
  }
  function o(c) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? a(c) : n(c);
  }
  function a(c) {
    return c === null ? l(c) : Ft(c) ? e.attempt(z7e, a, l)(c) : (e.enter("codeFlowValue"), s(c));
  }
  function s(c) {
    return c === null || Ft(c) ? (e.exit("codeFlowValue"), a(c)) : (e.consume(c), s);
  }
  function l(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function H7e(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : Ft(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : ur(e, o, "linePrefix", 5)(a);
  }
  function o(a) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(a) : Ft(a) ? i(a) : n(a);
  }
}
const W7e = {
  name: "codeText",
  tokenize: K7e,
  resolve: V7e,
  previous: G7e
};
function V7e(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function G7e(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function K7e(e, t, n) {
  let r = 0, i, o;
  return a;
  function a(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(d);
  }
  function s(d) {
    return d === 96 ? (e.consume(d), r++, s) : (e.exit("codeTextSequence"), l(d));
  }
  function l(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), l) : d === 96 ? (o = e.enter("codeTextSequence"), i = 0, f(d)) : Ft(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), l) : (e.enter("codeTextData"), c(d));
  }
  function c(d) {
    return d === null || d === 32 || d === 96 || Ft(d) ? (e.exit("codeTextData"), l(d)) : (e.consume(d), c);
  }
  function f(d) {
    return d === 96 ? (e.consume(d), i++, f) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (o.type = "codeTextData", c(d));
  }
}
function bX(e) {
  const t = {};
  let n = -1, r, i, o, a, s, l, c;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, o = 0, o < l.length && l[o][1].type === "lineEndingBlank" && (o += 2), o < l.length && l[o][1].type === "content"))
      for (; ++o < l.length && l[o][1].type !== "content"; )
        l[o][1].type === "chunkText" && (l[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, q7e(e, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (a = e[o], a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, e[i][1].start), s = e.slice(i, n), s.unshift(r), Al(e, i, n - i + 1, s));
    }
  }
  return !c;
}
function q7e(e, t) {
  const n = e[t][1], r = e[t][2];
  let i = t - 1;
  const o = [], a = n._tokenizer || r.parser[n.contentType](n.start), s = a.events, l = [], c = {};
  let f, d, p = -1, g = n, v = 0, y = 0;
  const x = [y];
  for (; g; ) {
    for (; e[++i][1] !== g; )
      ;
    o.push(i), g._tokenizer || (f = r.sliceStream(g), g.next || f.push(null), d && a.defineSkip(g.start), g._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(f), g._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), d = g, g = g.next;
  }
  for (g = n; ++p < s.length; )
    // Find a void token that includes a break.
    s[p][0] === "exit" && s[p - 1][0] === "enter" && s[p][1].type === s[p - 1][1].type && s[p][1].start.line !== s[p][1].end.line && (y = p + 1, x.push(y), g._tokenizer = void 0, g.previous = void 0, g = g.next);
  for (a.events = [], g ? (g._tokenizer = void 0, g.previous = void 0) : x.pop(), p = x.length; p--; ) {
    const b = s.slice(x[p], x[p + 1]), w = o.pop();
    l.unshift([w, w + b.length - 1]), Al(e, w, 2, b);
  }
  for (p = -1; ++p < l.length; )
    c[v + l[p][0]] = v + l[p][1], v += l[p][1] - l[p][0] - 1;
  return c;
}
const Y7e = {
  tokenize: J7e,
  resolve: Q7e
}, X7e = {
  tokenize: Z7e,
  partial: !0
};
function Q7e(e) {
  return bX(e), e;
}
function J7e(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? o(s) : Ft(s) ? e.check(
      X7e,
      a,
      o
    )(s) : (e.consume(s), i);
  }
  function o(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function a(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function Z7e(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), ur(e, o, "linePrefix");
  }
  function o(a) {
    if (a === null || Ft(a))
      return n(a);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function wX(e, t, n, r, i, o, a, s, l) {
  const c = l || Number.POSITIVE_INFINITY;
  let f = 0;
  return d;
  function d(b) {
    return b === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(b), e.exit(o), p) : b === null || b === 32 || b === 41 || VI(b) ? n(b) : (e.enter(r), e.enter(a), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), y(b));
  }
  function p(b) {
    return b === 62 ? (e.enter(o), e.consume(b), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), g(b));
  }
  function g(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(s), p(b)) : b === null || b === 60 || Ft(b) ? n(b) : (e.consume(b), b === 92 ? v : g);
  }
  function v(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), g) : g(b);
  }
  function y(b) {
    return !f && (b === null || b === 41 || Xo(b)) ? (e.exit("chunkString"), e.exit(s), e.exit(a), e.exit(r), t(b)) : f < c && b === 40 ? (e.consume(b), f++, y) : b === 41 ? (e.consume(b), f--, y) : b === null || b === 32 || b === 40 || VI(b) ? n(b) : (e.consume(b), b === 92 ? x : y);
  }
  function x(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), y) : y(b);
  }
}
function SX(e, t, n, r, i, o) {
  const a = this;
  let s = 0, l;
  return c;
  function c(g) {
    return e.enter(r), e.enter(i), e.consume(g), e.exit(i), e.enter(o), f;
  }
  function f(g) {
    return s > 999 || g === null || g === 91 || g === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    g === 94 && !s && "_hiddenFootnoteSupport" in a.parser.constructs ? n(g) : g === 93 ? (e.exit(o), e.enter(i), e.consume(g), e.exit(i), e.exit(r), t) : Ft(g) ? (e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), f) : (e.enter("chunkString", {
      contentType: "string"
    }), d(g));
  }
  function d(g) {
    return g === null || g === 91 || g === 93 || Ft(g) || s++ > 999 ? (e.exit("chunkString"), f(g)) : (e.consume(g), l || (l = !Pn(g)), g === 92 ? p : d);
  }
  function p(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), s++, d) : d(g);
  }
}
function xX(e, t, n, r, i, o) {
  let a;
  return s;
  function s(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(r), e.enter(i), e.consume(p), e.exit(i), a = p === 40 ? 41 : p, l) : n(p);
  }
  function l(p) {
    return p === a ? (e.enter(i), e.consume(p), e.exit(i), e.exit(r), t) : (e.enter(o), c(p));
  }
  function c(p) {
    return p === a ? (e.exit(o), l(a)) : p === null ? n(p) : Ft(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), ur(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === a || p === null || Ft(p) ? (e.exit("chunkString"), c(p)) : (e.consume(p), p === 92 ? d : f);
  }
  function d(p) {
    return p === a || p === 92 ? (e.consume(p), f) : f(p);
  }
}
function sg(e, t) {
  let n;
  return r;
  function r(i) {
    return Ft(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : Pn(i) ? ur(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
const eVe = {
  name: "definition",
  tokenize: nVe
}, tVe = {
  tokenize: rVe,
  partial: !0
};
function nVe(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(g) {
    return e.enter("definition"), a(g);
  }
  function a(g) {
    return SX.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(g);
  }
  function s(g) {
    return i = Ip(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), l) : n(g);
  }
  function l(g) {
    return Xo(g) ? sg(e, c)(g) : c(g);
  }
  function c(g) {
    return wX(
      e,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(g);
  }
  function f(g) {
    return e.attempt(tVe, d, d)(g);
  }
  function d(g) {
    return Pn(g) ? ur(e, p, "whitespace")(g) : p(g);
  }
  function p(g) {
    return g === null || Ft(g) ? (e.exit("definition"), r.parser.defined.push(i), t(g)) : n(g);
  }
}
function rVe(e, t, n) {
  return r;
  function r(s) {
    return Xo(s) ? sg(e, i)(s) : n(s);
  }
  function i(s) {
    return xX(
      e,
      o,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s);
  }
  function o(s) {
    return Pn(s) ? ur(e, a, "whitespace")(s) : a(s);
  }
  function a(s) {
    return s === null || Ft(s) ? t(s) : n(s);
  }
}
const iVe = {
  name: "hardBreakEscape",
  tokenize: oVe
};
function oVe(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return Ft(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const aVe = {
  name: "headingAtx",
  tokenize: lVe,
  resolve: sVe
};
function sVe(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Al(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", i, t]
  ])), e;
}
function lVe(e, t, n) {
  let r = 0;
  return i;
  function i(f) {
    return e.enter("atxHeading"), o(f);
  }
  function o(f) {
    return e.enter("atxHeadingSequence"), a(f);
  }
  function a(f) {
    return f === 35 && r++ < 6 ? (e.consume(f), a) : f === null || Xo(f) ? (e.exit("atxHeadingSequence"), s(f)) : n(f);
  }
  function s(f) {
    return f === 35 ? (e.enter("atxHeadingSequence"), l(f)) : f === null || Ft(f) ? (e.exit("atxHeading"), t(f)) : Pn(f) ? ur(e, s, "whitespace")(f) : (e.enter("atxHeadingText"), c(f));
  }
  function l(f) {
    return f === 35 ? (e.consume(f), l) : (e.exit("atxHeadingSequence"), s(f));
  }
  function c(f) {
    return f === null || f === 35 || Xo(f) ? (e.exit("atxHeadingText"), s(f)) : (e.consume(f), c);
  }
}
const cVe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], WF = ["pre", "script", "style", "textarea"], uVe = {
  name: "htmlFlow",
  tokenize: hVe,
  resolveTo: pVe,
  concrete: !0
}, fVe = {
  tokenize: gVe,
  partial: !0
}, dVe = {
  tokenize: mVe,
  partial: !0
};
function pVe(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function hVe(e, t, n) {
  const r = this;
  let i, o, a, s, l;
  return c;
  function c(U) {
    return f(U);
  }
  function f(U) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(U), d;
  }
  function d(U) {
    return U === 33 ? (e.consume(U), p) : U === 47 ? (e.consume(U), o = !0, y) : U === 63 ? (e.consume(U), i = 3, r.interrupt ? t : D) : Sl(U) ? (e.consume(U), a = String.fromCharCode(U), x) : n(U);
  }
  function p(U) {
    return U === 45 ? (e.consume(U), i = 2, g) : U === 91 ? (e.consume(U), i = 5, s = 0, v) : Sl(U) ? (e.consume(U), i = 4, r.interrupt ? t : D) : n(U);
  }
  function g(U) {
    return U === 45 ? (e.consume(U), r.interrupt ? t : D) : n(U);
  }
  function v(U) {
    const he = "CDATA[";
    return U === he.charCodeAt(s++) ? (e.consume(U), s === he.length ? r.interrupt ? t : A : v) : n(U);
  }
  function y(U) {
    return Sl(U) ? (e.consume(U), a = String.fromCharCode(U), x) : n(U);
  }
  function x(U) {
    if (U === null || U === 47 || U === 62 || Xo(U)) {
      const he = U === 47, re = a.toLowerCase();
      return !he && !o && WF.includes(re) ? (i = 1, r.interrupt ? t(U) : A(U)) : cVe.includes(a.toLowerCase()) ? (i = 6, he ? (e.consume(U), b) : r.interrupt ? t(U) : A(U)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(U) : o ? w(U) : S(U));
    }
    return U === 45 || Ca(U) ? (e.consume(U), a += String.fromCharCode(U), x) : n(U);
  }
  function b(U) {
    return U === 62 ? (e.consume(U), r.interrupt ? t : A) : n(U);
  }
  function w(U) {
    return Pn(U) ? (e.consume(U), w) : B(U);
  }
  function S(U) {
    return U === 47 ? (e.consume(U), B) : U === 58 || U === 95 || Sl(U) ? (e.consume(U), E) : Pn(U) ? (e.consume(U), S) : B(U);
  }
  function E(U) {
    return U === 45 || U === 46 || U === 58 || U === 95 || Ca(U) ? (e.consume(U), E) : O(U);
  }
  function O(U) {
    return U === 61 ? (e.consume(U), $) : Pn(U) ? (e.consume(U), O) : S(U);
  }
  function $(U) {
    return U === null || U === 60 || U === 61 || U === 62 || U === 96 ? n(U) : U === 34 || U === 39 ? (e.consume(U), l = U, P) : Pn(U) ? (e.consume(U), $) : R(U);
  }
  function P(U) {
    return U === l ? (e.consume(U), l = null, L) : U === null || Ft(U) ? n(U) : (e.consume(U), P);
  }
  function R(U) {
    return U === null || U === 34 || U === 39 || U === 47 || U === 60 || U === 61 || U === 62 || U === 96 || Xo(U) ? O(U) : (e.consume(U), R);
  }
  function L(U) {
    return U === 47 || U === 62 || Pn(U) ? S(U) : n(U);
  }
  function B(U) {
    return U === 62 ? (e.consume(U), j) : n(U);
  }
  function j(U) {
    return U === null || Ft(U) ? A(U) : Pn(U) ? (e.consume(U), j) : n(U);
  }
  function A(U) {
    return U === 45 && i === 2 ? (e.consume(U), W) : U === 60 && i === 1 ? (e.consume(U), V) : U === 62 && i === 4 ? (e.consume(U), te) : U === 63 && i === 3 ? (e.consume(U), D) : U === 93 && i === 5 ? (e.consume(U), X) : Ft(U) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      fVe,
      ee,
      T
    )(U)) : U === null || Ft(U) ? (e.exit("htmlFlowData"), T(U)) : (e.consume(U), A);
  }
  function T(U) {
    return e.check(
      dVe,
      k,
      ee
    )(U);
  }
  function k(U) {
    return e.enter("lineEnding"), e.consume(U), e.exit("lineEnding"), F;
  }
  function F(U) {
    return U === null || Ft(U) ? T(U) : (e.enter("htmlFlowData"), A(U));
  }
  function W(U) {
    return U === 45 ? (e.consume(U), D) : A(U);
  }
  function V(U) {
    return U === 47 ? (e.consume(U), a = "", G) : A(U);
  }
  function G(U) {
    if (U === 62) {
      const he = a.toLowerCase();
      return WF.includes(he) ? (e.consume(U), te) : A(U);
    }
    return Sl(U) && a.length < 8 ? (e.consume(U), a += String.fromCharCode(U), G) : A(U);
  }
  function X(U) {
    return U === 93 ? (e.consume(U), D) : A(U);
  }
  function D(U) {
    return U === 62 ? (e.consume(U), te) : U === 45 && i === 2 ? (e.consume(U), D) : A(U);
  }
  function te(U) {
    return U === null || Ft(U) ? (e.exit("htmlFlowData"), ee(U)) : (e.consume(U), te);
  }
  function ee(U) {
    return e.exit("htmlFlow"), t(U);
  }
}
function mVe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return Ft(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o) : n(a);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function gVe(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(iC, t, n);
  }
}
const vVe = {
  name: "htmlText",
  tokenize: yVe
};
function yVe(e, t, n) {
  const r = this;
  let i, o, a;
  return s;
  function s(D) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(D), l;
  }
  function l(D) {
    return D === 33 ? (e.consume(D), c) : D === 47 ? (e.consume(D), O) : D === 63 ? (e.consume(D), S) : Sl(D) ? (e.consume(D), R) : n(D);
  }
  function c(D) {
    return D === 45 ? (e.consume(D), f) : D === 91 ? (e.consume(D), o = 0, v) : Sl(D) ? (e.consume(D), w) : n(D);
  }
  function f(D) {
    return D === 45 ? (e.consume(D), g) : n(D);
  }
  function d(D) {
    return D === null ? n(D) : D === 45 ? (e.consume(D), p) : Ft(D) ? (a = d, V(D)) : (e.consume(D), d);
  }
  function p(D) {
    return D === 45 ? (e.consume(D), g) : d(D);
  }
  function g(D) {
    return D === 62 ? W(D) : D === 45 ? p(D) : d(D);
  }
  function v(D) {
    const te = "CDATA[";
    return D === te.charCodeAt(o++) ? (e.consume(D), o === te.length ? y : v) : n(D);
  }
  function y(D) {
    return D === null ? n(D) : D === 93 ? (e.consume(D), x) : Ft(D) ? (a = y, V(D)) : (e.consume(D), y);
  }
  function x(D) {
    return D === 93 ? (e.consume(D), b) : y(D);
  }
  function b(D) {
    return D === 62 ? W(D) : D === 93 ? (e.consume(D), b) : y(D);
  }
  function w(D) {
    return D === null || D === 62 ? W(D) : Ft(D) ? (a = w, V(D)) : (e.consume(D), w);
  }
  function S(D) {
    return D === null ? n(D) : D === 63 ? (e.consume(D), E) : Ft(D) ? (a = S, V(D)) : (e.consume(D), S);
  }
  function E(D) {
    return D === 62 ? W(D) : S(D);
  }
  function O(D) {
    return Sl(D) ? (e.consume(D), $) : n(D);
  }
  function $(D) {
    return D === 45 || Ca(D) ? (e.consume(D), $) : P(D);
  }
  function P(D) {
    return Ft(D) ? (a = P, V(D)) : Pn(D) ? (e.consume(D), P) : W(D);
  }
  function R(D) {
    return D === 45 || Ca(D) ? (e.consume(D), R) : D === 47 || D === 62 || Xo(D) ? L(D) : n(D);
  }
  function L(D) {
    return D === 47 ? (e.consume(D), W) : D === 58 || D === 95 || Sl(D) ? (e.consume(D), B) : Ft(D) ? (a = L, V(D)) : Pn(D) ? (e.consume(D), L) : W(D);
  }
  function B(D) {
    return D === 45 || D === 46 || D === 58 || D === 95 || Ca(D) ? (e.consume(D), B) : j(D);
  }
  function j(D) {
    return D === 61 ? (e.consume(D), A) : Ft(D) ? (a = j, V(D)) : Pn(D) ? (e.consume(D), j) : L(D);
  }
  function A(D) {
    return D === null || D === 60 || D === 61 || D === 62 || D === 96 ? n(D) : D === 34 || D === 39 ? (e.consume(D), i = D, T) : Ft(D) ? (a = A, V(D)) : Pn(D) ? (e.consume(D), A) : (e.consume(D), k);
  }
  function T(D) {
    return D === i ? (e.consume(D), i = void 0, F) : D === null ? n(D) : Ft(D) ? (a = T, V(D)) : (e.consume(D), T);
  }
  function k(D) {
    return D === null || D === 34 || D === 39 || D === 60 || D === 61 || D === 96 ? n(D) : D === 47 || D === 62 || Xo(D) ? L(D) : (e.consume(D), k);
  }
  function F(D) {
    return D === 47 || D === 62 || Xo(D) ? L(D) : n(D);
  }
  function W(D) {
    return D === 62 ? (e.consume(D), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(D);
  }
  function V(D) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), G;
  }
  function G(D) {
    return Pn(D) ? ur(
      e,
      X,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(D) : X(D);
  }
  function X(D) {
    return e.enter("htmlTextData"), a(D);
  }
}
const HM = {
  name: "labelEnd",
  tokenize: EVe,
  resolveTo: CVe,
  resolveAll: xVe
}, bVe = {
  tokenize: $Ve
}, wVe = {
  tokenize: _Ve
}, SVe = {
  tokenize: OVe
};
function xVe(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function CVe(e, t) {
  let n = e.length, r = 0, i, o, a, s;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = n);
  const l = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, c = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[a][1].end)
  }, f = {
    type: "labelText",
    start: Object.assign({}, e[o + r + 2][1].end),
    end: Object.assign({}, e[a - 2][1].start)
  };
  return s = [
    ["enter", l, t],
    ["enter", c, t]
  ], s = Ka(s, e.slice(o + 1, o + r + 3)), s = Ka(s, [["enter", f, t]]), s = Ka(
    s,
    UM(
      t.parser.constructs.insideSpan.null,
      e.slice(o + r + 4, a - 3),
      t
    )
  ), s = Ka(s, [
    ["exit", f, t],
    e[a - 2],
    e[a - 1],
    ["exit", c, t]
  ]), s = Ka(s, e.slice(a + 1)), s = Ka(s, [["exit", l, t]]), Al(e, o, e.length, s), e;
}
function EVe(e, t, n) {
  const r = this;
  let i = r.events.length, o, a;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return s;
  function s(p) {
    return o ? o._inactive ? d(p) : (a = r.parser.defined.includes(
      Ip(
        r.sliceSerialize({
          start: o.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(p);
  }
  function l(p) {
    return p === 40 ? e.attempt(
      bVe,
      f,
      a ? f : d
    )(p) : p === 91 ? e.attempt(
      wVe,
      f,
      a ? c : d
    )(p) : a ? f(p) : d(p);
  }
  function c(p) {
    return e.attempt(
      SVe,
      f,
      d
    )(p);
  }
  function f(p) {
    return t(p);
  }
  function d(p) {
    return o._balanced = !0, n(p);
  }
}
function $Ve(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return Xo(d) ? sg(e, o)(d) : o(d);
  }
  function o(d) {
    return d === 41 ? f(d) : wX(
      e,
      a,
      s,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(d);
  }
  function a(d) {
    return Xo(d) ? sg(e, l)(d) : f(d);
  }
  function s(d) {
    return n(d);
  }
  function l(d) {
    return d === 34 || d === 39 || d === 40 ? xX(
      e,
      c,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(d) : f(d);
  }
  function c(d) {
    return Xo(d) ? sg(e, f)(d) : f(d);
  }
  function f(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function _Ve(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return SX.call(
      r,
      e,
      o,
      a,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function o(s) {
    return r.parser.defined.includes(
      Ip(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(s) : n(s);
  }
  function a(s) {
    return n(s);
  }
}
function OVe(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const PVe = {
  name: "labelStartImage",
  tokenize: TVe,
  resolveAll: HM.resolveAll
};
function TVe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), o;
  }
  function o(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), a) : n(s);
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const IVe = {
  name: "labelStartLink",
  tokenize: AVe,
  resolveAll: HM.resolveAll
};
function AVe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const H_ = {
  name: "lineEnding",
  tokenize: RVe
};
function RVe(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), ur(e, t, "linePrefix");
  }
}
const Mb = {
  name: "thematicBreak",
  tokenize: MVe
};
function MVe(e, t, n) {
  let r = 0, i;
  return o;
  function o(c) {
    return e.enter("thematicBreak"), a(c);
  }
  function a(c) {
    return i = c, s(c);
  }
  function s(c) {
    return c === i ? (e.enter("thematicBreakSequence"), l(c)) : r >= 3 && (c === null || Ft(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function l(c) {
    return c === i ? (e.consume(c), r++, l) : (e.exit("thematicBreakSequence"), Pn(c) ? ur(e, s, "whitespace")(c) : s(c));
  }
}
const Fo = {
  name: "list",
  tokenize: LVe,
  continuation: {
    tokenize: DVe
  },
  exit: FVe
}, NVe = {
  tokenize: BVe,
  partial: !0
}, kVe = {
  tokenize: jVe,
  partial: !0
};
function LVe(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return s;
  function s(g) {
    const v = r.containerState.type || (g === 42 || g === 43 || g === 45 ? "listUnordered" : "listOrdered");
    if (v === "listUnordered" ? !r.containerState.marker || g === r.containerState.marker : GI(g)) {
      if (r.containerState.type || (r.containerState.type = v, e.enter(v, {
        _container: !0
      })), v === "listUnordered")
        return e.enter("listItemPrefix"), g === 42 || g === 45 ? e.check(Mb, n, c)(g) : c(g);
      if (!r.interrupt || g === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(g);
    }
    return n(g);
  }
  function l(g) {
    return GI(g) && ++a < 10 ? (e.consume(g), l) : (!r.interrupt || a < 2) && (r.containerState.marker ? g === r.containerState.marker : g === 41 || g === 46) ? (e.exit("listItemValue"), c(g)) : n(g);
  }
  function c(g) {
    return e.enter("listItemMarker"), e.consume(g), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || g, e.check(
      iC,
      // Can’t be empty when interrupting.
      r.interrupt ? n : f,
      e.attempt(
        NVe,
        p,
        d
      )
    );
  }
  function f(g) {
    return r.containerState.initialBlankLine = !0, o++, p(g);
  }
  function d(g) {
    return Pn(g) ? (e.enter("listItemPrefixWhitespace"), e.consume(g), e.exit("listItemPrefixWhitespace"), p) : n(g);
  }
  function p(g) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(g);
  }
}
function DVe(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(iC, i, o);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, ur(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(s);
  }
  function o(s) {
    return r.containerState.furtherBlankLines || !Pn(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(kVe, t, a)(s));
  }
  function a(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, ur(
      e,
      e.attempt(Fo, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function jVe(e, t, n) {
  const r = this;
  return ur(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function FVe(e) {
  e.exit(this.containerState.type);
}
function BVe(e, t, n) {
  const r = this;
  return ur(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return !Pn(o) && a && a[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const VF = {
  name: "setextUnderline",
  tokenize: UVe,
  resolveTo: zVe
};
function zVe(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", a, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[o][1].end)) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function UVe(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(c) {
    let f = r.events.length, d;
    for (; f--; )
      if (r.events[f][1].type !== "lineEnding" && r.events[f][1].type !== "linePrefix" && r.events[f][1].type !== "content") {
        d = r.events[f][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = c, a(c)) : n(c);
  }
  function a(c) {
    return e.enter("setextHeadingLineSequence"), s(c);
  }
  function s(c) {
    return c === i ? (e.consume(c), s) : (e.exit("setextHeadingLineSequence"), Pn(c) ? ur(e, l, "lineSuffix")(c) : l(c));
  }
  function l(c) {
    return c === null || Ft(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const HVe = {
  tokenize: WVe
};
function WVe(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    iC,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      ur(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(Y7e, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const VVe = {
  resolveAll: EX()
}, GVe = CX("string"), KVe = CX("text");
function CX(e) {
  return {
    tokenize: t,
    resolveAll: EX(
      e === "text" ? qVe : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, a, s);
    return a;
    function a(f) {
      return c(f) ? o(f) : s(f);
    }
    function s(f) {
      if (f === null) {
        n.consume(f);
        return;
      }
      return n.enter("data"), n.consume(f), l;
    }
    function l(f) {
      return c(f) ? (n.exit("data"), o(f)) : (n.consume(f), l);
    }
    function c(f) {
      if (f === null)
        return !0;
      const d = i[f];
      let p = -1;
      if (d)
        for (; ++p < d.length; ) {
          const g = d[p];
          if (!g.previous || g.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function EX(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function qVe(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, a = -1, s = 0, l;
      for (; o--; ) {
        const c = i[o];
        if (typeof c == "string") {
          for (a = c.length; c.charCodeAt(a - 1) === 32; )
            s++, a--;
          if (a)
            break;
          a = -1;
        } else if (c === -2)
          l = !0, s++;
        else if (c !== -1) {
          o++;
          break;
        }
      }
      if (s) {
        const c = {
          type: n === e.length || l || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + o,
            _bufferIndex: o ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, c.start), r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(
          n,
          0,
          ["enter", c, t],
          ["exit", c, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function YVe(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let a = [], s = [];
  const l = {
    consume: w,
    enter: S,
    exit: E,
    attempt: P(O),
    check: P($),
    interrupt: P($, {
      interrupt: !0
    })
  }, c = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: g,
    sliceSerialize: p,
    now: v,
    defineSkip: y,
    write: d
  };
  let f = t.tokenize.call(c, l);
  return t.resolveAll && o.push(t), c;
  function d(j) {
    return a = Ka(a, j), x(), a[a.length - 1] !== null ? [] : (R(t, 0), c.events = UM(o, c.events, c), c.events);
  }
  function p(j, A) {
    return QVe(g(j), A);
  }
  function g(j) {
    return XVe(a, j);
  }
  function v() {
    const { line: j, column: A, offset: T, _index: k, _bufferIndex: F } = r;
    return {
      line: j,
      column: A,
      offset: T,
      _index: k,
      _bufferIndex: F
    };
  }
  function y(j) {
    i[j.line] = j.column, B();
  }
  function x() {
    let j;
    for (; r._index < a.length; ) {
      const A = a[r._index];
      if (typeof A == "string")
        for (j = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === j && r._bufferIndex < A.length; )
          b(A.charCodeAt(r._bufferIndex));
      else
        b(A);
    }
  }
  function b(j) {
    f = f(j);
  }
  function w(j) {
    Ft(j) ? (r.line++, r.column = 1, r.offset += j === -3 ? 2 : 1, B()) : j !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = j;
  }
  function S(j, A) {
    const T = A || {};
    return T.type = j, T.start = v(), c.events.push(["enter", T, c]), s.push(T), T;
  }
  function E(j) {
    const A = s.pop();
    return A.end = v(), c.events.push(["exit", A, c]), A;
  }
  function O(j, A) {
    R(j, A.from);
  }
  function $(j, A) {
    A.restore();
  }
  function P(j, A) {
    return T;
    function T(k, F, W) {
      let V, G, X, D;
      return Array.isArray(k) ? ee(k) : "tokenize" in k ? (
        // @ts-expect-error Looks like a construct.
        ee([k])
      ) : te(k);
      function te(de) {
        return we;
        function we(ue) {
          const me = ue !== null && de[ue], Se = ue !== null && de.null, _e = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(me) ? me : me ? [me] : [],
            ...Array.isArray(Se) ? Se : Se ? [Se] : []
          ];
          return ee(_e)(ue);
        }
      }
      function ee(de) {
        return V = de, G = 0, de.length === 0 ? W : U(de[G]);
      }
      function U(de) {
        return we;
        function we(ue) {
          return D = L(), X = de, de.partial || (c.currentConstruct = de), de.name && c.parser.constructs.disable.null.includes(de.name) ? re() : de.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            A ? Object.assign(Object.create(c), A) : c,
            l,
            he,
            re
          )(ue);
        }
      }
      function he(de) {
        return j(X, D), F;
      }
      function re(de) {
        return D.restore(), ++G < V.length ? U(V[G]) : W;
      }
    }
  }
  function R(j, A) {
    j.resolveAll && !o.includes(j) && o.push(j), j.resolve && Al(
      c.events,
      A,
      c.events.length - A,
      j.resolve(c.events.slice(A), c)
    ), j.resolveTo && (c.events = j.resolveTo(c.events, c));
  }
  function L() {
    const j = v(), A = c.previous, T = c.currentConstruct, k = c.events.length, F = Array.from(s);
    return {
      restore: W,
      from: k
    };
    function W() {
      r = j, c.previous = A, c.currentConstruct = T, c.events.length = k, s = F, B();
    }
  }
  function B() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function XVe(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let a;
  if (n === i)
    a = [e[n].slice(r, o)];
  else {
    if (a = e.slice(n, i), r > -1) {
      const s = a[0];
      typeof s == "string" ? a[0] = s.slice(r) : a.shift();
    }
    o > 0 && a.push(e[i].slice(0, o));
  }
  return a;
}
function QVe(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, r.push(a);
  }
  return r.join("");
}
const JVe = {
  42: Fo,
  43: Fo,
  45: Fo,
  48: Fo,
  49: Fo,
  50: Fo,
  51: Fo,
  52: Fo,
  53: Fo,
  54: Fo,
  55: Fo,
  56: Fo,
  57: Fo,
  62: gX
}, ZVe = {
  91: eVe
}, eGe = {
  [-2]: U_,
  [-1]: U_,
  32: U_
}, tGe = {
  35: aVe,
  42: Mb,
  45: [VF, Mb],
  60: uVe,
  61: VF,
  95: Mb,
  96: HF,
  126: HF
}, nGe = {
  38: yX,
  92: vX
}, rGe = {
  [-5]: H_,
  [-4]: H_,
  [-3]: H_,
  33: PVe,
  38: yX,
  42: KI,
  60: [A7e, vVe],
  91: IVe,
  92: [iVe, vX],
  93: HM,
  95: KI,
  96: W7e
}, iGe = {
  null: [KI, VVe]
}, oGe = {
  null: [42, 95]
}, aGe = {
  null: []
}, sGe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: oGe,
  contentInitial: ZVe,
  disable: aGe,
  document: JVe,
  flow: tGe,
  flowInitial: eGe,
  insideSpan: iGe,
  string: nGe,
  text: rGe
}, Symbol.toStringTag, { value: "Module" }));
function lGe(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    g7e([sGe, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(E7e),
    document: i(_7e),
    flow: i(HVe),
    string: i(GVe),
    text: i(KVe)
  };
  return r;
  function i(o) {
    return a;
    function a(s) {
      return YVe(r, o, s);
    }
  }
}
function cGe(e) {
  for (; !bX(e); )
    ;
  return e;
}
const GF = /[\0\t\n\r]/g;
function uGe() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, a, s) {
    const l = [];
    let c, f, d, p, g;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(a || void 0).decode(o)), d = 0, t = "", n && (o.charCodeAt(0) === 65279 && d++, n = void 0); d < o.length; ) {
      if (GF.lastIndex = d, c = GF.exec(o), p = c && c.index !== void 0 ? c.index : o.length, g = o.charCodeAt(p), !c) {
        t = o.slice(d);
        break;
      }
      if (g === 10 && d === p && r)
        l.push(-3), r = void 0;
      else
        switch (r && (l.push(-5), r = void 0), d < p && (l.push(o.slice(d, p)), e += p - d), g) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (f = Math.ceil(e / 4) * 4, l.push(-2); e++ < f; )
              l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = p + 1;
    }
    return s && (r && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
const fGe = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function dGe(e) {
  return e.replace(fGe, pGe);
}
function pGe(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return hX(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return zM(n) || e;
}
const $X = {}.hasOwnProperty;
function hGe(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), mGe(n)(
    cGe(
      lGe(n).document().write(uGe()(e, t, !0))
    )
  );
}
function mGe(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(je),
      autolinkProtocol: L,
      autolinkEmail: L,
      atxHeading: o(Ae),
      blockQuote: o(me),
      characterEscape: L,
      characterReference: L,
      codeFenced: o(Se),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: o(Se, a),
      codeText: o(_e, a),
      codeTextData: L,
      data: L,
      codeFlowValue: L,
      definition: o(Ge),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: o(Fe),
      hardBreakEscape: o(Me),
      hardBreakTrailing: o(Me),
      htmlFlow: o(et, a),
      htmlFlowData: L,
      htmlText: o(et, a),
      htmlTextData: L,
      image: o(De),
      label: a,
      link: o(je),
      listItem: o(fe),
      listItemValue: p,
      listOrdered: o(ie, d),
      listUnordered: o(ie),
      paragraph: o(be),
      reference: U,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: o(Ae),
      strong: o(Te),
      thematicBreak: o(ct)
    },
    exit: {
      atxHeading: l(),
      atxHeadingSequence: O,
      autolink: l(),
      autolinkEmail: ue,
      autolinkProtocol: we,
      blockQuote: l(),
      characterEscapeValue: B,
      characterReferenceMarkerHexadecimal: re,
      characterReferenceMarkerNumeric: re,
      characterReferenceValue: de,
      codeFenced: l(x),
      codeFencedFence: y,
      codeFencedFenceInfo: g,
      codeFencedFenceMeta: v,
      codeFlowValue: B,
      codeIndented: l(b),
      codeText: l(F),
      codeTextData: B,
      data: B,
      definition: l(),
      definitionDestinationString: E,
      definitionLabelString: w,
      definitionTitleString: S,
      emphasis: l(),
      hardBreakEscape: l(A),
      hardBreakTrailing: l(A),
      htmlFlow: l(T),
      htmlFlowData: B,
      htmlText: l(k),
      htmlTextData: B,
      image: l(V),
      label: X,
      labelText: G,
      lineEnding: j,
      link: l(W),
      listItem: l(),
      listOrdered: l(),
      listUnordered: l(),
      paragraph: l(),
      referenceString: he,
      resourceDestinationString: D,
      resourceTitleString: te,
      resource: ee,
      setextHeading: l(R),
      setextHeadingLineSequence: P,
      setextHeadingText: $,
      strong: l(),
      thematicBreak: l()
    }
  };
  _X(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(Z) {
    let se = {
      type: "root",
      children: []
    };
    const Ce = {
      stack: [se],
      tokenStack: [],
      config: t,
      enter: s,
      exit: c,
      buffer: a,
      resume: f,
      data: n
    }, Pe = [];
    let Ee = -1;
    for (; ++Ee < Z.length; )
      if (Z[Ee][1].type === "listOrdered" || Z[Ee][1].type === "listUnordered")
        if (Z[Ee][0] === "enter")
          Pe.push(Ee);
        else {
          const We = Pe.pop();
          Ee = i(Z, We, Ee);
        }
    for (Ee = -1; ++Ee < Z.length; ) {
      const We = t[Z[Ee][0]];
      $X.call(We, Z[Ee][1].type) && We[Z[Ee][1].type].call(
        Object.assign(
          {
            sliceSerialize: Z[Ee][2].sliceSerialize
          },
          Ce
        ),
        Z[Ee][1]
      );
    }
    if (Ce.tokenStack.length > 0) {
      const We = Ce.tokenStack[Ce.tokenStack.length - 1];
      (We[1] || KF).call(Ce, void 0, We[0]);
    }
    for (se.position = {
      start: Bc(
        Z.length > 0 ? Z[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Bc(
        Z.length > 0 ? Z[Z.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, Ee = -1; ++Ee < t.transforms.length; )
      se = t.transforms[Ee](se) || se;
    return se;
  }
  function i(Z, se, Ce) {
    let Pe = se - 1, Ee = -1, We = !1, ze, Ye, xt, Lt;
    for (; ++Pe <= Ce; ) {
      const mt = Z[Pe];
      switch (mt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          mt[0] === "enter" ? Ee++ : Ee--, Lt = void 0;
          break;
        }
        case "lineEndingBlank": {
          mt[0] === "enter" && (ze && !Lt && !Ee && !xt && (xt = Pe), Lt = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Lt = void 0;
      }
      if (!Ee && mt[0] === "enter" && mt[1].type === "listItemPrefix" || Ee === -1 && mt[0] === "exit" && (mt[1].type === "listUnordered" || mt[1].type === "listOrdered")) {
        if (ze) {
          let St = Pe;
          for (Ye = void 0; St--; ) {
            const Et = Z[St];
            if (Et[1].type === "lineEnding" || Et[1].type === "lineEndingBlank") {
              if (Et[0] === "exit")
                continue;
              Ye && (Z[Ye][1].type = "lineEndingBlank", We = !0), Et[1].type = "lineEnding", Ye = St;
            } else if (!(Et[1].type === "linePrefix" || Et[1].type === "blockQuotePrefix" || Et[1].type === "blockQuotePrefixWhitespace" || Et[1].type === "blockQuoteMarker" || Et[1].type === "listItemIndent"))
              break;
          }
          xt && (!Ye || xt < Ye) && (ze._spread = !0), ze.end = Object.assign(
            {},
            Ye ? Z[Ye][1].start : mt[1].end
          ), Z.splice(Ye || Pe, 0, ["exit", ze, mt[2]]), Pe++, Ce++;
        }
        if (mt[1].type === "listItemPrefix") {
          const St = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, mt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          ze = St, Z.splice(Pe, 0, ["enter", St, mt[2]]), Pe++, Ce++, xt = void 0, Lt = !0;
        }
      }
    }
    return Z[se][1]._spread = We, Ce;
  }
  function o(Z, se) {
    return Ce;
    function Ce(Pe) {
      s.call(this, Z(Pe), Pe), se && se.call(this, Pe);
    }
  }
  function a() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(Z, se, Ce) {
    this.stack[this.stack.length - 1].children.push(Z), this.stack.push(Z), this.tokenStack.push([se, Ce]), Z.position = {
      start: Bc(se.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function l(Z) {
    return se;
    function se(Ce) {
      Z && Z.call(this, Ce), c.call(this, Ce);
    }
  }
  function c(Z, se) {
    const Ce = this.stack.pop(), Pe = this.tokenStack.pop();
    if (Pe)
      Pe[0].type !== Z.type && (se ? se.call(this, Z, Pe[0]) : (Pe[1] || KF).call(this, Z, Pe[0]));
    else
      throw new Error(
        "Cannot close `" + Z.type + "` (" + ag({
          start: Z.start,
          end: Z.end
        }) + "): it’s not open"
      );
    Ce.position.end = Bc(Z.end);
  }
  function f() {
    return h7e(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function p(Z) {
    if (this.data.expectingFirstListItemValue) {
      const se = this.stack[this.stack.length - 2];
      se.start = Number.parseInt(this.sliceSerialize(Z), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function g() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.lang = Z;
  }
  function v() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.meta = Z;
  }
  function y() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function x() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.value = Z.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function b() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.value = Z.replace(/(\r?\n|\r)$/g, "");
  }
  function w(Z) {
    const se = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.label = se, Ce.identifier = Ip(
      this.sliceSerialize(Z)
    ).toLowerCase();
  }
  function S() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.title = Z;
  }
  function E() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.url = Z;
  }
  function O(Z) {
    const se = this.stack[this.stack.length - 1];
    if (!se.depth) {
      const Ce = this.sliceSerialize(Z).length;
      se.depth = Ce;
    }
  }
  function $() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function P(Z) {
    const se = this.stack[this.stack.length - 1];
    se.depth = this.sliceSerialize(Z).codePointAt(0) === 61 ? 1 : 2;
  }
  function R() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function L(Z) {
    const Ce = this.stack[this.stack.length - 1].children;
    let Pe = Ce[Ce.length - 1];
    (!Pe || Pe.type !== "text") && (Pe = Le(), Pe.position = {
      start: Bc(Z.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Ce.push(Pe)), this.stack.push(Pe);
  }
  function B(Z) {
    const se = this.stack.pop();
    se.value += this.sliceSerialize(Z), se.position.end = Bc(Z.end);
  }
  function j(Z) {
    const se = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Ce = se.children[se.children.length - 1];
      Ce.position.end = Bc(Z.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(se.type) && (L.call(this, Z), B.call(this, Z));
  }
  function A() {
    this.data.atHardBreak = !0;
  }
  function T() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.value = Z;
  }
  function k() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.value = Z;
  }
  function F() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.value = Z;
  }
  function W() {
    const Z = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const se = this.data.referenceType || "shortcut";
      Z.type += "Reference", Z.referenceType = se, delete Z.url, delete Z.title;
    } else
      delete Z.identifier, delete Z.label;
    this.data.referenceType = void 0;
  }
  function V() {
    const Z = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const se = this.data.referenceType || "shortcut";
      Z.type += "Reference", Z.referenceType = se, delete Z.url, delete Z.title;
    } else
      delete Z.identifier, delete Z.label;
    this.data.referenceType = void 0;
  }
  function G(Z) {
    const se = this.sliceSerialize(Z), Ce = this.stack[this.stack.length - 2];
    Ce.label = dGe(se), Ce.identifier = Ip(se).toLowerCase();
  }
  function X() {
    const Z = this.stack[this.stack.length - 1], se = this.resume(), Ce = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Ce.type === "link") {
      const Pe = Z.children;
      Ce.children = Pe;
    } else
      Ce.alt = se;
  }
  function D() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.url = Z;
  }
  function te() {
    const Z = this.resume(), se = this.stack[this.stack.length - 1];
    se.title = Z;
  }
  function ee() {
    this.data.inReference = void 0;
  }
  function U() {
    this.data.referenceType = "collapsed";
  }
  function he(Z) {
    const se = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.label = se, Ce.identifier = Ip(
      this.sliceSerialize(Z)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function re(Z) {
    this.data.characterReferenceType = Z.type;
  }
  function de(Z) {
    const se = this.sliceSerialize(Z), Ce = this.data.characterReferenceType;
    let Pe;
    Ce ? (Pe = hX(
      se,
      Ce === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : Pe = zM(se);
    const Ee = this.stack.pop();
    Ee.value += Pe, Ee.position.end = Bc(Z.end);
  }
  function we(Z) {
    B.call(this, Z);
    const se = this.stack[this.stack.length - 1];
    se.url = this.sliceSerialize(Z);
  }
  function ue(Z) {
    B.call(this, Z);
    const se = this.stack[this.stack.length - 1];
    se.url = "mailto:" + this.sliceSerialize(Z);
  }
  function me() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Se() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function _e() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ge() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Fe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Ae() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Me() {
    return {
      type: "break"
    };
  }
  function et() {
    return {
      type: "html",
      value: ""
    };
  }
  function De() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function je() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ie(Z) {
    return {
      type: "list",
      ordered: Z.type === "listOrdered",
      start: null,
      spread: Z._spread,
      children: []
    };
  }
  function fe(Z) {
    return {
      type: "listItem",
      spread: Z._spread,
      checked: null,
      children: []
    };
  }
  function be() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Te() {
    return {
      type: "strong",
      children: []
    };
  }
  function Le() {
    return {
      type: "text",
      value: ""
    };
  }
  function ct() {
    return {
      type: "thematicBreak"
    };
  }
}
function Bc(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function _X(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? _X(e, r) : gGe(e, r);
  }
}
function gGe(e, t) {
  let n;
  for (n in t)
    if ($X.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function KF(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + ag({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + ag({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + ag({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function vGe(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return hGe(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function yGe(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function bGe(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function wGe(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function SGe(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function xGe(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function CGe(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Lh(r.toLowerCase()), o = e.footnoteOrder.indexOf(r);
  let a, s = e.footnoteCounts.get(r);
  s === void 0 ? (s = 0, e.footnoteOrder.push(r), a = e.footnoteOrder.length) : a = o + 1, s += 1, e.footnoteCounts.set(r, s);
  const l = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(a) }]
  };
  e.patch(t, l);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function EGe(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function $Ge(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function OX(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const a = i[i.length - 1];
  return a && a.type === "text" ? a.value += r : i.push({ type: "text", value: r }), i;
}
function _Ge(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return OX(e, t);
  const i = { src: Lh(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, o), e.applyData(t, o);
}
function OGe(e, t) {
  const n = { src: Lh(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function PGe(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function TGe(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return OX(e, t);
  const i = { href: Lh(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function IGe(e, t) {
  const n = { href: Lh(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function AGe(e, t, n) {
  const r = e.all(t), i = n ? RGe(n) : PX(t), o = {}, a = [];
  if (typeof t.checked == "boolean") {
    const f = r[0];
    let d;
    f && f.type === "element" && f.tagName === "p" ? d = f : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const f = r[s];
    (i || s !== 0 || f.type !== "element" || f.tagName !== "p") && a.push({ type: "text", value: `
` }), f.type === "element" && f.tagName === "p" && !i ? a.push(...f.children) : a.push(f);
  }
  const l = r[r.length - 1];
  l && (i || l.type !== "element" || l.tagName !== "p") && a.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: o, children: a };
  return e.patch(t, c), e.applyData(t, c);
}
function RGe(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = PX(n[r]);
  }
  return t;
}
function PX(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function MGe(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const a = r[i];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function NGe(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function kGe(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function LGe(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const TX = AX("end"), IX = AX("start");
function AX(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function DGe(e) {
  const t = IX(e), n = TX(e);
  if (t && n)
    return { start: t, end: n };
}
function jGe(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), i.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = IX(t.children[1]), l = TX(t.children[t.children.length - 1]);
    s && l && (a.position = { start: s, end: l }), i.push(a);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function FGe(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, s = a ? a.length : t.children.length;
  let l = -1;
  const c = [];
  for (; ++l < s; ) {
    const d = t.children[l], p = {}, g = a ? a[l] : void 0;
    g && (p.align = g);
    let v = { type: "element", tagName: o, properties: p, children: [] };
    d && (v.children = e.all(d), e.patch(d, v), v = e.applyData(d, v)), c.push(v);
  }
  const f = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, f), e.applyData(t, f);
}
function BGe(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const qF = 9, YF = 32;
function zGe(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      XF(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(XF(t.slice(i), i > 0, !1)), o.join("");
}
function XF(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === qF || o === YF; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === qF || o === YF; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function UGe(e, t) {
  const n = { type: "text", value: zGe(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function HGe(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const WGe = {
  blockquote: yGe,
  break: bGe,
  code: wGe,
  delete: SGe,
  emphasis: xGe,
  footnoteReference: CGe,
  heading: EGe,
  html: $Ge,
  imageReference: _Ge,
  image: OGe,
  inlineCode: PGe,
  linkReference: TGe,
  link: IGe,
  listItem: AGe,
  list: MGe,
  paragraph: NGe,
  // @ts-expect-error: root is different, but hard to type.
  root: kGe,
  strong: LGe,
  table: jGe,
  tableCell: BGe,
  tableRow: FGe,
  text: UGe,
  thematicBreak: HGe,
  toml: U0,
  yaml: U0,
  definition: U0,
  footnoteDefinition: U0
};
function U0() {
}
const RX = -1, oC = 0, uw = 1, fw = 2, WM = 3, VM = 4, GM = 5, KM = 6, MX = 7, NX = 8, QF = typeof self == "object" ? self : globalThis, VGe = (e, t) => {
  const n = (i, o) => (e.set(o, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [o, a] = t[i];
    switch (o) {
      case oC:
      case RX:
        return n(a, i);
      case uw: {
        const s = n([], i);
        for (const l of a)
          s.push(r(l));
        return s;
      }
      case fw: {
        const s = n({}, i);
        for (const [l, c] of a)
          s[r(l)] = r(c);
        return s;
      }
      case WM:
        return n(new Date(a), i);
      case VM: {
        const { source: s, flags: l } = a;
        return n(new RegExp(s, l), i);
      }
      case GM: {
        const s = n(/* @__PURE__ */ new Map(), i);
        for (const [l, c] of a)
          s.set(r(l), r(c));
        return s;
      }
      case KM: {
        const s = n(/* @__PURE__ */ new Set(), i);
        for (const l of a)
          s.add(r(l));
        return s;
      }
      case MX: {
        const { name: s, message: l } = a;
        return n(new QF[s](l), i);
      }
      case NX:
        return n(BigInt(a), i);
      case "BigInt":
        return n(Object(BigInt(a)), i);
    }
    return n(new QF[o](a), i);
  };
  return r;
}, JF = (e) => VGe(/* @__PURE__ */ new Map(), e)(0), jd = "", { toString: GGe } = {}, { keys: KGe } = Object, Tm = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [oC, t];
  const n = GGe.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [uw, jd];
    case "Object":
      return [fw, jd];
    case "Date":
      return [WM, jd];
    case "RegExp":
      return [VM, jd];
    case "Map":
      return [GM, jd];
    case "Set":
      return [KM, jd];
  }
  return n.includes("Array") ? [uw, n] : n.includes("Error") ? [MX, n] : [fw, n];
}, H0 = ([e, t]) => e === oC && (t === "function" || t === "symbol"), qGe = (e, t, n, r) => {
  const i = (a, s) => {
    const l = r.push(a) - 1;
    return n.set(s, l), l;
  }, o = (a) => {
    if (n.has(a))
      return n.get(a);
    let [s, l] = Tm(a);
    switch (s) {
      case oC: {
        let f = a;
        switch (l) {
          case "bigint":
            s = NX, f = a.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + l);
            f = null;
            break;
          case "undefined":
            return i([RX], a);
        }
        return i([s, f], a);
      }
      case uw: {
        if (l)
          return i([l, [...a]], a);
        const f = [], d = i([s, f], a);
        for (const p of a)
          f.push(o(p));
        return d;
      }
      case fw: {
        if (l)
          switch (l) {
            case "BigInt":
              return i([l, a.toString()], a);
            case "Boolean":
            case "Number":
            case "String":
              return i([l, a.valueOf()], a);
          }
        if (t && "toJSON" in a)
          return o(a.toJSON());
        const f = [], d = i([s, f], a);
        for (const p of KGe(a))
          (e || !H0(Tm(a[p]))) && f.push([o(p), o(a[p])]);
        return d;
      }
      case WM:
        return i([s, a.toISOString()], a);
      case VM: {
        const { source: f, flags: d } = a;
        return i([s, { source: f, flags: d }], a);
      }
      case GM: {
        const f = [], d = i([s, f], a);
        for (const [p, g] of a)
          (e || !(H0(Tm(p)) || H0(Tm(g)))) && f.push([o(p), o(g)]);
        return d;
      }
      case KM: {
        const f = [], d = i([s, f], a);
        for (const p of a)
          (e || !H0(Tm(p))) && f.push(o(p));
        return d;
      }
    }
    const { message: c } = a;
    return i([s, { name: l, message: c }], a);
  };
  return o;
}, ZF = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return qGe(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, dw = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? JF(ZF(e, t)) : structuredClone(e)
) : (e, t) => JF(ZF(e, t));
function YGe(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function XGe(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function QGe(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || YGe, r = e.options.footnoteBackLabel || XGe, i = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", a = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let l = -1;
  for (; ++l < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(e.footnoteOrder[l]);
    if (!c)
      continue;
    const f = e.all(c), d = String(c.identifier).toUpperCase(), p = Lh(d.toLowerCase());
    let g = 0;
    const v = [], y = e.footnoteCounts.get(d);
    for (; y !== void 0 && ++g <= y; ) {
      v.length > 0 && v.push({ type: "text", value: " " });
      let w = typeof n == "string" ? n : n(l, g);
      typeof w == "string" && (w = { type: "text", value: w }), v.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + p + (g > 1 ? "-" + g : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(l, g),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(w) ? w : [w]
      });
    }
    const x = f[f.length - 1];
    if (x && x.type === "element" && x.tagName === "p") {
      const w = x.children[x.children.length - 1];
      w && w.type === "text" ? w.value += " " : x.children.push({ type: "text", value: " " }), x.children.push(...v);
    } else
      f.push(...v);
    const b = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + p },
      children: e.wrap(f, !0)
    };
    e.patch(c, b), s.push(b);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...dw(a),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const kX = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return tKe;
    if (typeof e == "function")
      return aC(e);
    if (typeof e == "object")
      return Array.isArray(e) ? JGe(e) : ZGe(e);
    if (typeof e == "string")
      return eKe(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function JGe(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = kX(e[n]);
  return aC(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, i))
        return !0;
    return !1;
  }
}
function ZGe(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return aC(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in e)
      if (i[o] !== t[o])
        return !1;
    return !0;
  }
}
function eKe(e) {
  return aC(t);
  function t(n) {
    return n && n.type === e;
  }
}
function aC(e) {
  return t;
  function t(n, r, i) {
    return !!(nKe(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function tKe() {
  return !0;
}
function nKe(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const LX = [], rKe = !0, eB = !1, iKe = "skip";
function oKe(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const o = kX(i), a = r ? -1 : 1;
  s(e, void 0, [])();
  function s(l, c, f) {
    const d = (
      /** @type {Record<string, unknown>} */
      l && typeof l == "object" ? l : {}
    );
    if (typeof d.type == "string") {
      const g = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(p, "name", {
        value: "node (" + (l.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return p;
    function p() {
      let g = LX, v, y, x;
      if ((!t || o(l, c, f[f.length - 1] || void 0)) && (g = aKe(n(l, f)), g[0] === eB))
        return g;
      if ("children" in l && l.children) {
        const b = (
          /** @type {UnistParent} */
          l
        );
        if (b.children && g[0] !== iKe)
          for (y = (r ? b.children.length : -1) + a, x = f.concat(b); y > -1 && y < b.children.length; ) {
            const w = b.children[y];
            if (v = s(w, y, x)(), v[0] === eB)
              return v;
            y = typeof v[1] == "number" ? v[1] : y + a;
          }
      }
      return g;
    }
  }
}
function aKe(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [rKe, e] : e == null ? LX : [e];
}
function sKe(e, t, n, r) {
  let i, o, a;
  typeof t == "function" && typeof n != "function" ? (o = void 0, a = t, i = n) : (o = t, a = n, i = r), oKe(e, o, s, i);
  function s(l, c) {
    const f = c[c.length - 1], d = f ? f.children.indexOf(l) : void 0;
    return a(l, d, f);
  }
}
const qI = {}.hasOwnProperty, lKe = {};
function cKe(e, t) {
  const n = t || lKe, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = { ...WGe, ...n.handlers }, s = {
    all: c,
    applyData: fKe,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: a,
    one: l,
    options: n,
    patch: uKe,
    wrap: pKe
  };
  return sKe(e, function(f) {
    if (f.type === "definition" || f.type === "footnoteDefinition") {
      const d = f.type === "definition" ? r : i, p = String(f.identifier).toUpperCase();
      d.has(p) || d.set(p, f);
    }
  }), s;
  function l(f, d) {
    const p = f.type, g = s.handlers[p];
    if (qI.call(s.handlers, p) && g)
      return g(s, f, d);
    if (s.options.passThrough && s.options.passThrough.includes(p)) {
      if ("children" in f) {
        const { children: y, ...x } = f, b = dw(x);
        return b.children = s.all(f), b;
      }
      return dw(f);
    }
    return (s.options.unknownHandler || dKe)(s, f, d);
  }
  function c(f) {
    const d = [];
    if ("children" in f) {
      const p = f.children;
      let g = -1;
      for (; ++g < p.length; ) {
        const v = s.one(p[g], f);
        if (v) {
          if (g && p[g - 1].type === "break" && (!Array.isArray(v) && v.type === "text" && (v.value = tB(v.value)), !Array.isArray(v) && v.type === "element")) {
            const y = v.children[0];
            y && y.type === "text" && (y.value = tB(y.value));
          }
          Array.isArray(v) ? d.push(...v) : d.push(v);
        }
      }
    }
    return d;
  }
}
function uKe(e, t) {
  e.position && (t.position = DGe(e));
}
function fKe(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const a = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: a };
      }
    n.type === "element" && o && Object.assign(n.properties, dw(o)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function dKe(e, t) {
  const n = t.data || {}, r = "value" in t && !(qI.call(n, "hProperties") || qI.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function pKe(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function tB(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function nB(e, t) {
  const n = cKe(e, t), r = n.one(e, void 0), i = QGe(n), o = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && o.children.push({ type: "text", value: `
` }, i), o;
}
function hKe(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      nB(n, t)
    );
    await e.run(i, r);
  } : function(n) {
    return (
      /** @type {HastRoot} */
      nB(n, t || e)
    );
  };
}
function rB(e) {
  if (e)
    throw e;
}
var Nb = Object.prototype.hasOwnProperty, DX = Object.prototype.toString, iB = Object.defineProperty, oB = Object.getOwnPropertyDescriptor, aB = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : DX.call(t) === "[object Array]";
}, sB = function(t) {
  if (!t || DX.call(t) !== "[object Object]")
    return !1;
  var n = Nb.call(t, "constructor"), r = t.constructor && t.constructor.prototype && Nb.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || Nb.call(t, i);
}, lB = function(t, n) {
  iB && n.name === "__proto__" ? iB(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, cB = function(t, n) {
  if (n === "__proto__")
    if (Nb.call(t, n)) {
      if (oB)
        return oB(t, n).value;
    } else
      return;
  return t[n];
}, mKe = function e() {
  var t, n, r, i, o, a, s = arguments[0], l = 1, c = arguments.length, f = !1;
  for (typeof s == "boolean" && (f = s, s = arguments[1] || {}, l = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); l < c; ++l)
    if (t = arguments[l], t != null)
      for (n in t)
        r = cB(s, n), i = cB(t, n), s !== i && (f && i && (sB(i) || (o = aB(i))) ? (o ? (o = !1, a = r && aB(r) ? r : []) : a = r && sB(r) ? r : {}, lB(s, { name: n, newValue: e(f, a, i) })) : typeof i < "u" && lB(s, { name: n, newValue: i }));
  return s;
};
const W_ = /* @__PURE__ */ Oi(mKe);
function YI(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function gKe() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...i);
    function s(l, ...c) {
      const f = e[++o];
      let d = -1;
      if (l) {
        a(l);
        return;
      }
      for (; ++d < i.length; )
        (c[d] === null || c[d] === void 0) && (c[d] = i[d]);
      i = c, f ? vKe(f, s)(...c) : a(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function vKe(e, t) {
  let n;
  return r;
  function r(...a) {
    const s = e.length > a.length;
    let l;
    s && a.push(i);
    try {
      l = e.apply(this, a);
    } catch (c) {
      const f = (
        /** @type {Error} */
        c
      );
      if (s && n)
        throw f;
      return i(f);
    }
    s || (l instanceof Promise ? l.then(o, i) : l instanceof Error ? i(l) : o(l));
  }
  function i(a, ...s) {
    n || (n = !0, t(a, ...s));
  }
  function o(a) {
    i(null, a);
  }
}
const pl = { basename: yKe, dirname: bKe, extname: wKe, join: SKe, sep: "/" };
function yKe(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Dv(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (o = !0, a = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function bKe(e) {
  if (Dv(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function wKe(e) {
  Dv(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, a;
  for (; t--; ) {
    const s = e.codePointAt(t);
    if (s === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function SKe(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Dv(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : xKe(n);
}
function xKe(e) {
  Dv(e);
  const t = e.codePointAt(0) === 47;
  let n = CKe(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function CKe(e, t) {
  let n = "", r = 0, i = -1, o = 0, a = -1, s, l;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.codePointAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || o === 1))
        if (i !== a - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = a, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = a, o = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), r = a - i - 1;
      i = a, o = 0;
    } else
      s === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function Dv(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const EKe = { cwd: $Ke };
function $Ke() {
  return "/";
}
function XI(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function _Ke(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!XI(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return OKe(e);
}
function OKe(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const V_ = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
let PKe = class {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? XI(t) ? n = { path: t } : typeof t == "string" || TKe(t) ? n = { value: t } : n = t : n = {}, this.cwd = EKe.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < V_.length; ) {
      const o = V_[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      V_.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? pl.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    K_(t, "basename"), G_(t, "basename"), this.path = pl.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? pl.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    uB(this.basename, "dirname"), this.path = pl.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? pl.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (G_(t, "extname"), uB(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = pl.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    XI(t) && (t = _Ke(t)), K_(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? pl.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    K_(t, "stem"), G_(t, "stem"), this.path = pl.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Ki(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
};
function G_(e, t) {
  if (e && e.includes(pl.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + pl.sep + "`"
    );
}
function K_(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function uB(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function TKe(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const IKe = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], o = function() {
      return i.apply(o, arguments);
    };
    Object.setPrototypeOf(o, r);
    const a = Object.getOwnPropertyNames(i);
    for (const s of a) {
      const l = Object.getOwnPropertyDescriptor(i, s);
      l && Object.defineProperty(o, s, l);
    }
    return o;
  }
), AKe = {}.hasOwnProperty;
class qM extends IKe {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = gKe();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new qM()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(W_(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (X_("data", this.frozen), this.namespace[t] = n, this) : AKe.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (X_("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = W0(t), r = this.parser || this.Parser;
    return q_("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), q_("process", this.parser || this.Parser), Y_("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(o, a) {
      const s = W0(t), l = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(s)
      );
      r.run(l, s, function(f, d, p) {
        if (f || !d || !p)
          return c(f);
        const g = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), v = r.stringify(g, p);
        NKe(v) ? p.value = v : p.result = v, c(
          f,
          /** @type {VFileWithOutput<CompileResult>} */
          p
        );
      });
      function c(f, d) {
        f || !d ? a(f) : o ? o(d) : n(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), q_("processSync", this.parser || this.Parser), Y_("processSync", this.compiler || this.Compiler), this.process(t, i), dB("processSync", "process", n), r;
    function i(o, a) {
      n = !0, rB(o), r = a;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    fB(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? o(void 0, r) : new Promise(o);
    function o(a, s) {
      const l = W0(n);
      i.run(t, l, c);
      function c(f, d, p) {
        const g = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        f ? s(f) : a ? a(g) : r(void 0, g, p);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, o), dB("runSync", "run", r), i;
    function o(a, s) {
      rB(a), i = s, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = W0(n), i = this.compiler || this.Compiler;
    return Y_("stringify", i), fB(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (X_("use", this.frozen), t != null)
      if (typeof t == "function")
        l(t, n);
      else if (typeof t == "object")
        Array.isArray(t) ? s(t) : a(t);
      else
        throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function o(c) {
      if (typeof c == "function")
        l(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [f, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          l(f, d);
        } else
          a(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function a(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(c.plugins), c.settings && (i.settings = W_(!0, i.settings, c.settings));
    }
    function s(c) {
      let f = -1;
      if (c != null)
        if (Array.isArray(c))
          for (; ++f < c.length; ) {
            const d = c[f];
            o(d);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function l(c, f) {
      let d = -1, p = -1;
      for (; ++d < r.length; )
        if (r[d][0] === c) {
          p = d;
          break;
        }
      if (p === -1)
        r.push([c, ...f]);
      else if (f.length > 0) {
        let [g, ...v] = f;
        const y = r[p][1];
        YI(y) && YI(g) && (g = W_(!0, y, g)), r[p] = [c, g, ...v];
      }
    }
  }
}
const RKe = new qM().freeze();
function q_(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Y_(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function X_(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function fB(e) {
  if (!YI(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function dB(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function W0(e) {
  return MKe(e) ? e : new PKe(e);
}
function MKe(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function NKe(e) {
  return typeof e == "string" || kKe(e);
}
function kKe(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const jX = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return FKe;
    if (typeof e == "function")
      return sC(e);
    if (typeof e == "object")
      return Array.isArray(e) ? LKe(e) : DKe(e);
    if (typeof e == "string")
      return jKe(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function LKe(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = jX(e[n]);
  return sC(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, i))
        return !0;
    return !1;
  }
}
function DKe(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return sC(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in e)
      if (i[o] !== t[o])
        return !1;
    return !0;
  }
}
function jKe(e) {
  return sC(t);
  function t(n) {
    return n && n.type === e;
  }
}
function sC(e) {
  return t;
  function t(n, r, i) {
    return !!(BKe(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function FKe() {
  return !0;
}
function BKe(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const FX = [], zKe = !0, pB = !1, UKe = "skip";
function HKe(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const o = jX(i), a = r ? -1 : 1;
  s(e, void 0, [])();
  function s(l, c, f) {
    const d = (
      /** @type {Record<string, unknown>} */
      l && typeof l == "object" ? l : {}
    );
    if (typeof d.type == "string") {
      const g = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(p, "name", {
        value: "node (" + (l.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return p;
    function p() {
      let g = FX, v, y, x;
      if ((!t || o(l, c, f[f.length - 1] || void 0)) && (g = WKe(n(l, f)), g[0] === pB))
        return g;
      if ("children" in l && l.children) {
        const b = (
          /** @type {UnistParent} */
          l
        );
        if (b.children && g[0] !== UKe)
          for (y = (r ? b.children.length : -1) + a, x = f.concat(b); y > -1 && y < b.children.length; ) {
            const w = b.children[y];
            if (v = s(w, y, x)(), v[0] === pB)
              return v;
            y = typeof v[1] == "number" ? v[1] : y + a;
          }
      }
      return g;
    }
  }
}
function WKe(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [zKe, e] : e == null ? FX : [e];
}
function VKe(e, t, n, r) {
  let i, o, a;
  typeof t == "function" && typeof n != "function" ? (o = void 0, a = t, i = n) : (o = t, a = n, i = r), HKe(e, o, s, i);
  function s(l, c) {
    const f = c[c.length - 1], d = f ? f.children.indexOf(l) : void 0;
    return a(l, d, f);
  }
}
const hl = { basename: GKe, dirname: KKe, extname: qKe, join: YKe, sep: "/" };
function GKe(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  jv(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (o = !0, a = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function KKe(e) {
  if (jv(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function qKe(e) {
  jv(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, a;
  for (; t--; ) {
    const s = e.codePointAt(t);
    if (s === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function YKe(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    jv(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : XKe(n);
}
function XKe(e) {
  jv(e);
  const t = e.codePointAt(0) === 47;
  let n = QKe(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function QKe(e, t) {
  let n = "", r = 0, i = -1, o = 0, a = -1, s, l;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.codePointAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || o === 1))
        if (i !== a - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = a, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = a, o = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), r = a - i - 1;
      i = a, o = 0;
    } else
      s === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function jv(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const JKe = { cwd: ZKe };
function ZKe() {
  return "/";
}
function QI(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function eqe(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!QI(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return tqe(e);
}
function tqe(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const Q_ = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class nqe {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? QI(t) ? n = { path: t } : typeof t == "string" || rqe(t) ? n = { value: t } : n = t : n = {}, this.cwd = JKe.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < Q_.length; ) {
      const o = Q_[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      Q_.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? hl.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Z_(t, "basename"), J_(t, "basename"), this.path = hl.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? hl.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    hB(this.basename, "dirname"), this.path = hl.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? hl.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (J_(t, "extname"), hB(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = hl.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    QI(t) && (t = eqe(t)), Z_(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? hl.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Z_(t, "stem"), J_(t, "stem"), this.path = hl.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Ki(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function J_(e, t) {
  if (e && e.includes(hl.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + hl.sep + "`"
    );
}
function Z_(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function hB(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function rqe(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const iqe = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", mB = [], gB = { allowDangerousHtml: !0 }, oqe = /^(https?|ircs?|mailto|xmpp)$/i, aqe = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function sqe(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, o = e.components, a = e.disallowedElements, s = e.rehypePlugins || mB, l = e.remarkPlugins || mB, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...gB } : gB, f = e.skipHtml, d = e.unwrapDisallowed, p = e.urlTransform || lqe, g = RKe().use(vGe).use(l).use(hKe, c).use(s), v = new nqe();
  typeof r == "string" && (v.value = r);
  for (const w of aqe)
    Object.hasOwn(e, w.from) && ("" + w.from + (w.to ? "use `" + w.to + "` instead" : "remove it") + iqe + w.id, void 0);
  const y = g.parse(v);
  let x = g.runSync(y, v);
  return i && (x = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      x.type === "root" ? x.children : [x]
    )
  }), VKe(x, b), XWe(x, {
    Fragment: H.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: H.jsx,
    jsxs: H.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function b(w, S, E) {
    if (w.type === "raw" && E && typeof S == "number")
      return f ? E.children.splice(S, 1) : E.children[S] = { type: "text", value: w.value }, S;
    if (w.type === "element") {
      let O;
      for (O in z_)
        if (Object.hasOwn(z_, O) && Object.hasOwn(w.properties, O)) {
          const $ = w.properties[O], P = z_[O];
          (P === null || P.includes(w.tagName)) && (w.properties[O] = p(String($ || ""), O, w));
        }
    }
    if (w.type === "element") {
      let O = t ? !t.includes(w.tagName) : a ? a.includes(w.tagName) : !1;
      if (!O && n && typeof S == "number" && (O = !n(w, S, E)), O && E && typeof S == "number")
        return d && w.children ? E.children.splice(S, 1, ...w.children) : E.children.splice(S, 1), S;
    }
  }
}
function lqe(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    oqe.test(e.slice(0, t)) ? e : ""
  );
}
const vB = (e, t) => e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear(), cqe = (e) => {
  const t = e ? {
    height: "calc(100% - 105px)"
  } : {};
  return yt.omitBy(t, yt.isNil);
}, uqe = (e) => {
  const t = e ? {
    height: "calc(100% - 115px)"
  } : {};
  return yt.omitBy(t, yt.isNil);
}, fqe = (e) => {
  const t = e ? {
    height: "calc(100% - 62px)",
    padding: "16px 15px 10px"
  } : {};
  return yt.omitBy(t, yt.isNil);
}, dqe = (e) => {
  const t = e ? {
    height: "calc(100% - 56px)",
    padding: "16px 15px 0px"
  } : {};
  return yt.omitBy(t, yt.isNil);
}, pqe = (e) => {
  var r, i, o;
  const t = e == null ? void 0 : e.conversation, n = {
    height: (r = e == null ? void 0 : e.visualHeight) == null ? void 0 : r.conversation,
    padding: t == null ? void 0 : t.padding,
    backgroundColor: t == null ? void 0 : t.background,
    showDateDivider: (i = t == null ? void 0 : t.dateDivider) == null ? void 0 : i.display,
    showMessageDate: (o = t == null ? void 0 : t.messageDate) == null ? void 0 : o.display
  };
  return yt.omitBy(n, yt.isNil);
}, Fv = ({
  themeStyle: e,
  isShowJumpingDots: t
}) => {
  var re, de, we, ue, me, Se, _e, Ge, Fe, Ae, Me, et, De, je, ie, fe, be, Te, Le, ct, Z, se;
  const n = pe(rM), r = pe(Ll), i = pe(nl), o = pe(cq), a = pe(Ox), s = pe(jx), l = pe(tM), c = pe(nM), f = pe(rl), d = pe(kl), p = ((re = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : re.display) ?? !1, g = (o == null ? void 0 : o.length) && f.length < 2, v = !(o != null && o.length) && !f.length, y = !!(a != null && a.length), x = p || y && (g || v), b = s && d && x, w = !d, S = x && !d, E = b ? 2 : void 0, O = ((we = (de = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : de.button) == null ? void 0 : we.rows) ?? E, $ = ((me = (ue = i == null ? void 0 : i.conversation.relatedQuestions) == null ? void 0 : ue.button) == null ? void 0 : me.rows) ?? void 0, P = (_e = (Se = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : Se.button) == null ? void 0 : _e.showArrow, R = (Fe = (Ge = i == null ? void 0 : i.conversation.relatedQuestions) == null ? void 0 : Ge.button) == null ? void 0 : Fe.showArrow, L = ((Ae = i == null ? void 0 : i.conversation.message) == null ? void 0 : Ae.display) ?? !0, B = n === Jo.SiteCompanion && [Jt.siteCompanion, Jt.siteCompanionPopup].includes(r), j = (et = (Me = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : Me.title) != null && et.display ? (je = (De = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : De.title) == null ? void 0 : je.content : void 0, A = i == null ? void 0 : i.conversation.custom, T = (ie = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : ie.custom, k = (be = (fe = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : fe.title) == null ? void 0 : be.custom, F = (Le = (Te = i == null ? void 0 : i.conversation.starterQuestions) == null ? void 0 : Te.button) == null ? void 0 : Le.custom, W = (Z = (ct = i == null ? void 0 : i.conversation.relatedQuestions) == null ? void 0 : ct.button) == null ? void 0 : Z.custom, V = (se = i == null ? void 0 : i.conversation.relatedQuestions) == null ? void 0 : se.custom, G = {
    height: e.conversation.height,
    backgroundColor: e.conversation.background,
    showDateDivider: !d,
    showMessageDate: !d,
    padding: "10px 15px"
  }, X = {
    opacity: t ? "0.4 !important" : void 0
  }, D = {
    opacity: t ? "0.4 !important" : void 0
  }, te = m.useMemo(() => f.reduce((Ce, Pe) => {
    if (yNe.includes(Pe.type)) {
      const Ee = new Date(Pe.created_at), We = Ce[Ce.length - 1];
      !We || !vB(We.date, Ee) ? Ce.push({ date: Ee, messages: [Pe] }) : We.messages.push(Pe);
    }
    return Ce;
  }, []), [f]), ee = {
    ...G,
    ...cqe(!l),
    ...uqe(!!c),
    ...fqe(d),
    ...dqe(b),
    ...pqe(i)
  }, U = {
    ...X
  }, he = {
    ...D
  };
  return {
    isSameDay: vB,
    isPopupSmallMode: d,
    isSiteCompanionWebChat: B,
    groupedMessages: te,
    starterQuestionsRows: O,
    relatedQuestionsRows: $,
    showScrollToBottomEffectComponent: w,
    showBigPopupStarterQuestions: S,
    showStartQuestions: x,
    showSmallPopupStarterQuestions: b,
    showStarterQuestionArrow: P,
    showRelatedQuestionArrow: R,
    showMessages: L,
    messageContainerStyles: ee,
    starterQuestionButtonStyles: U,
    relatedQuestionButtonStyles: he,
    starterQuestionsTitle: j,
    customContainerStyles: A,
    customStarterQuestionsContainerStyles: T,
    customStarterQuestionButtonStyles: F,
    customRelatedQuestionButtonStyles: W,
    customStarterQuestionsTitleStyles: k,
    customRelatedQuestionContainerStyles: V
  };
}, lC = (e = {}) => {
  var P;
  const { type: t = oc.SENT } = e, n = pe(Zf), r = pe(Ll), i = pe(nl), o = pe(ed), a = pe(td), s = pe($c), c = (((P = i == null ? void 0 : i.avatar) == null ? void 0 : P.display) ?? !0) && n.showAvatar && n.avatar, f = {
    background: "#F5F5F5",
    color: "#333333",
    padding: ".6rem 1.2rem",
    border: void 0
  }, d = {
    dotsColor: "#d9d9d9"
  }, p = {
    color: "#333333",
    mobileBreakPoint: 441
  }, g = () => {
    const R = {
      padding: "8.5px 18px",
      border: "1px solid #F5F5F5"
    };
    return yt.omitBy(R, yt.isNil);
  }, v = () => {
    const R = t === oc.RECEIVED ? {
      background: o,
      color: a,
      border: `1px solid ${o}`
    } : {};
    return yt.omitBy(R, yt.isNil);
  }, y = () => {
    const R = r === Jt.siteCompanionPopup && t === oc.SENT ? {
      border: "1px solid #DBDBDB",
      background: "white"
    } : {};
    return yt.omitBy(R, yt.isNil);
  }, x = () => {
    const R = r === Jt.siteCompanionPopup && t === oc.SENT ? {
      dotsColor: "#999999"
    } : {};
    return yt.omitBy(R, yt.isNil);
  }, b = () => {
    const R = r === Jt.siteCompanionPopup && t === oc.SENT ? {
      color: "#666666"
    } : {};
    return yt.omitBy(R, yt.isNil);
  }, w = () => {
    const R = Ch.isFeatureEnabled() ? {
      mobileBreakPoint: 441
    } : {};
    return yt.omitBy(R, yt.isNil);
  }, S = () => {
    const R = s ? {
      simulateMobileOverFlow: "hidden"
    } : {};
    return yt.omitBy(R, yt.isNil);
  }, E = {
    ...f,
    ...g(),
    ...v(),
    ...y()
  }, O = {
    ...d,
    ...x()
  }, $ = {
    ...p,
    ...b(),
    ...w(),
    ...S()
  };
  return {
    bodyStyles: E,
    loadingStyles: O,
    sourceListStyles: $,
    showAvatar: c,
    isSimulateMobile: s
  };
}, BX = (e) => {
  const { theme: t } = e, n = wr(), r = pe(rl), i = pe(C2e), o = pe($c), { autoPopup: a } = pe(Z2);
  return {
    updateSmallPopupStatus: (l = {}) => {
      const { restart: c = !1 } = l, f = r.length <= 1 || c, d = t === Jt.fusion, p = o || Ec, g = yt.isEqual(a.first, [0]);
      n(Kg(!!(f && d && g && (p || i))));
    }
  };
};
function hqe(e, t = 50, n = 1) {
  const [r, i] = m.useState(""), o = m.useRef(0);
  return m.useEffect(() => {
    let a;
    const s = () => {
      o.current < e.length ? (i(e.slice(0, o.current + n)), o.current = o.current + n, a = setTimeout(s, t)) : i(e);
    };
    return s(), () => clearTimeout(a);
  }, [e, t, n]), r;
}
const mqe = (e) => /* @__PURE__ */ H.jsx("a", { href: e.href, target: "_blank", rel: "noreferrer", children: e.children }), gqe = Ut.div`
  .blinking-cursor {
    display: inline-block;
    width: 1px;
    animation: blink 1s step-start infinite;
    margin-left: 2px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ol,
  ul,
  dl,
  div {
    &:last-child {
      margin-bottom: 0;
    }

    ${(e) => e.$showStreamingAnimation ? `
    &:nth-last-child(2) {
      margin-bottom: 0;
      display: inline-block;
    }
    ` : ""}
  }

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`, zX = ({
  content: e,
  contentMeta: t,
  showStreamingAnimation: n
}) => {
  const r = hqe(e, 25, 3), i = (a) => {
    const { type: s, data: l } = a, { text: c } = l;
    switch (s) {
      case "link":
      case "upload_link":
      case "download_file":
        return /* @__PURE__ */ H.jsxs("a", { href: c, target: "_blank", rel: "noreferrer", className: "text-blue-500 underline", children: [
          /* @__PURE__ */ H.jsx(aWe, { size: 14, color: "rgba(75, 85, 99)", style: { marginRight: "0.5em" } }),
          c.slice(0, 30),
          "..."
        ] });
      default:
        return c;
    }
  }, o = (a, s) => {
    const l = [];
    let c = "", f = !1;
    for (let d = 0; d < a.length; d++) {
      const p = a[d];
      if (p === "{") {
        !f && c && l.push(c), f = !0, c = "";
        continue;
      }
      if (p === "}") {
        f && s[c] && l.push(i(s[c])), f = !1, c = "";
        continue;
      }
      c += p;
    }
    return l.push(c), l;
  };
  if (t) {
    const { template: a, payload: s } = t;
    return /* @__PURE__ */ H.jsx(H.Fragment, { children: o(a, s) });
  } else
    return /* @__PURE__ */ H.jsxs(gqe, { $showStreamingAnimation: n, children: [
      /* @__PURE__ */ H.jsx(
        sqe,
        {
          components: {
            p: "div",
            a: mqe
          },
          children: n ? r : e
        }
      ),
      n && /* @__PURE__ */ H.jsx("span", { className: "blinking-cursor", children: "|" })
    ] });
}, vqe = {
  rating: void 0,
  feedbackDetail: void 0
}, yqe = Ut.div`
  .rating-icon-wrapper {
    display: flex;
  }

  .margin-right-8 {
    margin-right: 8px;
  }

  .margin-bottom-8 {
    margin-bottom: 8px;
  }

  .rating-icon-container {
    display: flex;
  }

  .like-icon {
    color: #999999;
  }

  .text-gray-3 {
    color: #999999;
  }

  .submit-button {
    width: 100%;
    color: ${(e) => e.$styles.color};
    background: ${(e) => e.$styles.background};
  }

  .radio-wrapper {
    width: 100%;
    &:hover .ant-radio-inner {
      border-color: ${(e) => e.$styles.background};
    }

    .ant-radio-inner::after {
      background: ${(e) => e.$styles.background};
    }

    .ant-radio-checked .ant-radio-inner {
      border-color: ${(e) => e.$styles.background};
    }

    span.ant-radio + span {
      display: block;
      width: calc(100% - 16px);
      overflow-wrap: break-word;
    }
  }
`, bqe = (e) => {
  var P, R;
  const { id: t, created_at: n } = e, r = pe(Tv), i = pe(k2e), o = pe(L2e), [a, s] = m.useState(vqe), [l, c] = m.useState(
    "initialize"
    /* Initialize */
  ), { bodyStyles: f } = lC({ type: oc.RECEIVED }), { current: d, updateRating: p } = ms(), g = (P = d()) == null ? void 0 : P.uuid, v = (R = d()) == null ? void 0 : R.id, y = (L) => (o || []).filter((B) => B.type === L), x = y(Zl.Positive), b = y(Zl.Negative), w = l !== "initialize", S = a.rating === Zl.Positive ? x : b, E = async (L) => {
    try {
      if (!v || !i || !g || w)
        return;
      s((j) => ({
        ...j,
        rating: L
      }));
      const B = {
        url: i,
        type: L,
        guestId: g,
        botMessageId: parseInt(t)
      };
      await p({ botId: r, conversationId: v, payload: B });
    } catch {
    } finally {
      (L === Zl.Positive ? x : b).length <= 0 ? c(
        "submitted"
        /* Submitted */
      ) : c(
        "hasRated"
        /* HasRated */
      );
    }
  }, O = (L) => {
    var A;
    const B = L.target.value, j = (A = S.find((T) => T.id === B)) == null ? void 0 : A.content;
    s((T) => ({
      ...T,
      feedbackDetail: j
    }));
  }, $ = async () => {
    try {
      if (!v || !i || !g || !a.rating)
        return;
      const L = {
        url: i,
        type: a.rating,
        guestId: g,
        content: a.feedbackDetail,
        botMessageId: parseInt(t)
      };
      await p({ botId: r, conversationId: v, payload: L });
    } catch {
    } finally {
      c(
        "submitted"
        /* Submitted */
      );
    }
  };
  return /* @__PURE__ */ H.jsxs(yqe, { $styles: f, children: [
    /* @__PURE__ */ H.jsxs("div", { className: "rating-icon-wrapper", children: [
      /* @__PURE__ */ H.jsx("p", { className: "message-datetime margin-right-8", children: Zx(new Date(n), "h:mm a") }),
      l !== "submitted" && /* @__PURE__ */ H.jsxs("div", { className: "rating-icon-container", children: [
        a.rating === Zl.Positive ? /* @__PURE__ */ H.jsx(
          BHe,
          {
            className: "text-gray-3 margin-right-8",
            disabled: w
          }
        ) : /* @__PURE__ */ H.jsx(
          VHe,
          {
            className: "text-gray-3 margin-right-8",
            style: {
              cursor: w ? "auto" : "pointer"
            },
            disabled: w,
            onClick: () => E(Zl.Positive)
          }
        ),
        a.rating === Zl.Negative ? /* @__PURE__ */ H.jsx(CHe, { className: "text-gray-3", disabled: w }) : /* @__PURE__ */ H.jsx(
          PHe,
          {
            className: "margin-right-8 text-gray-3",
            style: {
              cursor: w ? "auto" : "pointer"
            },
            disabled: w,
            onClick: () => E(Zl.Negative)
          }
        )
      ] })
    ] }),
    l === "hasRated" && !!a.rating && /* @__PURE__ */ H.jsxs("div", { children: [
      /* @__PURE__ */ H.jsx("div", { className: "text-gray-3 margin-bottom-8", children: "Thanks for your feedback! Please tell us more:" }),
      /* @__PURE__ */ H.jsx(ej.Group, { onChange: O, style: { width: "100%" }, children: S.map((L) => /* @__PURE__ */ H.jsx(
        ej,
        {
          className: "margin-bottom-8 radio-wrapper",
          style: {
            border: "1px solid #DBDBDB",
            borderRadius: "4px",
            padding: "9px 12px",
            marginRight: 0
          },
          value: L.id,
          children: L.content
        },
        L.id
      )) }),
      /* @__PURE__ */ H.jsx(zi, { className: "submit-button", onClick: () => $(), children: "Submit" })
    ] }),
    l === "submitted" && /* @__PURE__ */ H.jsx("div", { className: "text-gray-3 margin-bottom-8", children: "Thanks! Your feedback will help us continue to improve this experience." })
  ] });
}, wqe = Ut.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`, Sqe = (e) => {
  const { relatedQuestions: t, isShowJumpingDots: n = !1 } = e, { themeStyle: r } = Kf(), {
    relatedQuestionsRows: i,
    showRelatedQuestionArrow: o,
    customRelatedQuestionContainerStyles: a,
    relatedQuestionButtonStyles: s,
    customRelatedQuestionButtonStyles: l
  } = Fv({
    themeStyle: r,
    isShowJumpingDots: n
  });
  return /* @__PURE__ */ H.jsx(wqe, { style: a, children: t.map((c, f) => /* @__PURE__ */ H.jsx(
    VY,
    {
      styles: s,
      customStyles: l,
      questionsRows: i,
      questionsShowArrow: o,
      question: c,
      isShowJumpingDots: n,
      contentType: $u.RelatedQuestion
    },
    f
  )) });
}, { Paragraph: xqe } = xh, Cqe = Ut.div`
  color: ${(e) => e.$styles.color};

  .site-flex-grow {
    flex-grow: 1;
  }

  .site-info {
    height: 16px;
    margin-bottom: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .site-info-icon {
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    font-size: 14px;
    margin-right: 4px;
    margin-top: -1px;
    object-fit: contain;
  }

  .site-info-url {
    display: inline-block;
    vertical-align: middle;
    color: #666666;
    cursor: pointer;
    font-size: 12px;
    line-height: 16px;
  }

  .source-list {
    overflow: auto hidden;
    white-space: nowrap;
    display: flex;
    gap: 12px;
  }

  .source-item {
    cursor: pointer;
    white-space: normal;
    background: #f5f5f5;
    border-radius: 8px;
    padding: 8px 12px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px;

    .site-info {
      margin-bottom: 0;
    }

    .site-info-icon {
      border-radius: 50%;
    }
  }

  .source-item-title {
    display: flex;
    align-items: flex-start;
    color: #333333;
    font-size: 14px;
    height: 60px;
    font-weight: 500;
  }

  .meta-list {
    display: flex;
    align-items: center;
  }

  .meta-item {
    position: relative;
    flex: 1;
    overflow: hidden;

    &:not(:first-child) {
      padding-left: 32px;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 16px;
        height: 20px;
        border-left: 1px solid rgb(219, 219, 219);
        margin-top: -10px;
      }
    }
  }

  .meta-item-title {
    color: #999999;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .meta-item-content {
    margin-top: 4px;
  }

  .meta-avatar {
    display: inline-block;
    vertical-align: middle;
    width: 24px;
    height: 24px;
    margin-right: 4px;
    border-radius: 50%;
    object-fit: cover;
  }

  .meta-description {
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    font-weight: 500;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  @media (min-width: ${(e) => e.$styles.mobileBreakPoint + 1}px) {
    .source-item {
      flex: 1;
      width: 33%;
      max-width: 33%;
    }
  }

  @media (max-width: ${(e) => e.$styles.mobileBreakPoint}px) {
    .source-list {
      ${(e) => e.$styles.simulateMobileOverFlow ? `overflow: ${e.$styles.simulateMobileOverFlow};` : ""}
    }

    .source-item {
      max-width: 80%;
      min-width: 80%;
    }
  }
`, Eqe = (e) => {
  const { sources: t } = e, n = t.slice(0, 3).map((a) => new Wze(a)), r = m.useRef(null), { sourceListStyles: i } = lC(), o = (a) => {
    window.open(a, "_blank");
  };
  return /* @__PURE__ */ H.jsx(Cqe, { $styles: i, children: /* @__PURE__ */ H.jsx("div", { className: "source-list", ref: r, children: n.map((a, s) => {
    const { url: l, title: c, sourceName: f, avatar: d } = a;
    return /* @__PURE__ */ H.jsxs("div", { className: "source-item", onClick: () => o(l), children: [
      /* @__PURE__ */ H.jsx("div", { className: "source-item-title", children: /* @__PURE__ */ H.jsx(
        xqe,
        {
          ellipsis: { rows: 3 },
          style: {
            color: "inherit",
            marginBottom: 0
          },
          children: c
        }
      ) }),
      f && /* @__PURE__ */ H.jsxs("div", { className: "site-info", children: [
        d && /* @__PURE__ */ H.jsx("img", { className: "site-info-icon", src: d }),
        /* @__PURE__ */ H.jsx("div", { className: "site-info-url", children: f })
      ] })
    ] }, s);
  }) }) });
}, $qe = Ut.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding: 16px;
  border-radius: 4px 16px 16px 16px;
  border: 1px solid #dbdbdb;
  ${Vf.isFeatureEnabled() ? `
  color: #666666;
  ` : ""}

  .ant-collapse-header {
    &[aria-expanded='true'] .ant-collapse-arrow svg {
      transform: rotate(-90deg) !important;
    }

    &[aria-expanded='false'] .ant-collapse-arrow svg {
      transform: rotate(90deg) !important;
    }
  }

  .ant-collapse-header {
    padding-inline-start: 0px !important;
    padding-bottom: 8px !important;
  }

  .meta-message-header {
    color: #333333;
    ${(e) => e.$showBigHeader ? `
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: bold;
    line-height: 32px;
    ` : `
    margin-bottom: 8px;
    `}
  }

  .ant-collapse-content-box {
    padding: 0px !important;
  }

  .meta-message-title {
    display: inline-block;
    vertical-align: center;
    color: #333333;
    line-height: 1;
    font-size: ${Vf.isFeatureEnabled() ? "16px" : "14px"};
    font-weight: 500;
  }

  .meta-message-title-icon {
    display: inline-block;
    vertical-align: center;
    font-size: 14px;
    margin-right: 5px;
  }
`, eO = Ut(XV)`
  &.ant-collapse-borderless {
    background: none;
  }
`, _qe = (e) => {
  const {
    id: t,
    content: n,
    content_meta: r = null,
    created_at: i,
    sources: o,
    related_questions: a = [],
    isShowJumpingDots: s,
    isLastMessage: l,
    messageContainerRef: c,
    streaming_message_status: f,
    webchatId: d,
    prevMessageData: p
  } = e, g = AIe.isFeatureEnabled(), v = Kx({
    webchatId: d,
    webChatType: Jo.SiteCompanion
  }), y = DG.isFeatureEnabled() && v, x = Gf.isFeatureEnabled(), b = Vf.isFeatureEnabled(), w = x && f === Ef.Ongoing, S = x && !!f, E = pe($c), O = pe(Ox), $ = pe(Nl), P = a.length > 0 ? a.slice(0, 6) : O.map((F) => F.question), [R, L] = m.useState(!1), [B, j] = m.useState(
    y ? [] : P
  ), { createRelatedQuestions: A } = ms(), T = Ec || E, k = m.useCallback(async () => {
    try {
      L(!0);
      const F = await A(t), W = F.length > 0 ? F.slice(0, 6) : O.map((V) => V.question);
      j(W);
    } catch {
    } finally {
      L(!1);
    }
  }, [O]);
  return m.useEffect(() => {
    !l || !y || S || !$ || k();
  }, [
    l,
    y,
    S,
    $,
    k
  ]), /* @__PURE__ */ H.jsxs("div", { ref: c, children: [
    /* @__PURE__ */ H.jsxs($qe, { $showBigHeader: b && !!p, children: [
      /* @__PURE__ */ H.jsxs("div", { children: [
        /* @__PURE__ */ H.jsx("div", { className: "meta-message-header", children: b && p ? /* @__PURE__ */ H.jsx(H.Fragment, { children: p.content }) : /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
          /* @__PURE__ */ H.jsx(gHe, { className: "meta-message-title-icon" }),
          /* @__PURE__ */ H.jsx("div", { className: "meta-message-title", children: "Answer" })
        ] }) }),
        /* @__PURE__ */ H.jsx(
          zX,
          {
            content: n,
            contentMeta: r,
            showStreamingAnimation: w
          }
        )
      ] }),
      o && (o == null ? void 0 : o.length) > 0 && /* @__PURE__ */ H.jsx(
        eO,
        {
          size: "small",
          expandIconPosition: "end",
          bordered: !1,
          items: [
            {
              key: "1",
              label: /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
                /* @__PURE__ */ H.jsx(kHe, { className: "meta-message-title-icon" }),
                /* @__PURE__ */ H.jsx("div", { className: "meta-message-title", children: "Source(s)" })
              ] }),
              children: /* @__PURE__ */ H.jsx(Eqe, { sources: o })
            }
          ]
        }
      ),
      R && l && y && /* @__PURE__ */ H.jsx(
        eO,
        {
          size: "small",
          defaultActiveKey: "1",
          expandIconPosition: "end",
          bordered: !1,
          items: [
            {
              key: "1",
              label: /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
                /* @__PURE__ */ H.jsx(pF, { className: "meta-message-title-icon" }),
                /* @__PURE__ */ H.jsx("div", { className: "meta-message-title", children: "Related Questions" })
              ] }),
              children: /* @__PURE__ */ H.jsx(
                "div",
                {
                  style: {
                    display: "grid",
                    gap: 16,
                    ...T ? {} : { gridTemplateColumns: "repeat(2, 1fr)" }
                  },
                  children: Array(6).fill(null).map((F, W) => /* @__PURE__ */ H.jsx(
                    Bo.Input,
                    {
                      active: !0,
                      style: {
                        width: "100%",
                        height: T ? Fq : _I,
                        borderRadius: sf
                      }
                    },
                    W
                  ))
                }
              )
            }
          ]
        }
      ),
      !R && l && B && (B == null ? void 0 : B.length) > 0 && /* @__PURE__ */ H.jsx(
        eO,
        {
          size: "small",
          defaultActiveKey: "1",
          expandIconPosition: "end",
          bordered: !1,
          items: [
            {
              key: "1",
              label: /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
                /* @__PURE__ */ H.jsx(pF, { className: "meta-message-title-icon" }),
                /* @__PURE__ */ H.jsx("div", { className: "meta-message-title", children: "Related Questions" })
              ] }),
              children: /* @__PURE__ */ H.jsx(
                Sqe,
                {
                  isShowJumpingDots: s,
                  relatedQuestions: B
                }
              )
            }
          ]
        }
      )
    ] }),
    g ? /* @__PURE__ */ H.jsx(bqe, { ...e }) : /* @__PURE__ */ H.jsx("p", { className: "message-datetime", children: Zx(new Date(i), "h:mm a") })
  ] });
}, Oqe = Ut.div`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`, Pqe = Ut(pG)`
  vertical-align: top;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: 0;
  margin-bottom: 0px !important;
  white-space: nowrap;
`, Tqe = Ut(pG)`
  vertical-align: top;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  margin-left: 0;
  margin-bottom: 0px !important;
  white-space: nowrap;
  min-width: 100px;
  max-width: 65%;
`, Iqe = ({ sources: e }) => /* @__PURE__ */ H.jsx("div", { children: e.map((t, n) => /* @__PURE__ */ H.jsxs(Oqe, { children: [
  /* @__PURE__ */ H.jsx(Pqe, { children: /* @__PURE__ */ H.jsx(
    "p",
    {
      style: {
        display: "inline-block",
        verticalAlign: "middle"
      },
      children: n + 1
    }
  ) }),
  /* @__PURE__ */ H.jsx(Tqe, { children: t.url ? /* @__PURE__ */ H.jsx("a", { href: t.url, target: "_blank", rel: "noreferrer", className: "source-title", children: t.title }) : /* @__PURE__ */ H.jsx("p", { className: "source-title", children: t.title }) })
] }, n + 1)) }), Aqe = Ut.div`
  background: ${(e) => e.$styles.background} !important;
  color: ${(e) => e.$styles.color};
  padding: ${(e) => e.$styles.padding} !important;
  ${(e) => e.$styles.border ? `border: ${e.$styles.border};` : ""};
`, Rqe = Ut(XV)`
  color: ${(e) => e.$styles.color};
  margin-top: 10px;
  background-color: #fff;

  .ant-collapse-content-box {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
`, Mqe = (e) => {
  const {
    isFirstMessage: t,
    isLastMessage: n,
    type: r,
    content: i,
    content_meta: o = null,
    created_at: a,
    sources: s,
    messageContainerRef: l,
    streaming_message_status: c
  } = e, f = pe(Ll), d = pe(Zf), { bodyStyles: p, sourceListStyles: g, showAvatar: v } = lC({ type: r }), x = Gf.isFeatureEnabled() && c === Ef.Ongoing, b = pe(Ox), S = new rWe().perform({
    ...e,
    theme: f,
    starter_questions: b,
    isFirstMessage: t
  });
  return /* @__PURE__ */ H.jsxs("div", { className: `message-wrapper ${r} ${n ? "is-last-message" : ""}`, children: [
    v && /* @__PURE__ */ H.jsx(
      "div",
      {
        style: {
          display: "inline-block",
          verticalAlign: "top",
          width: "45px",
          paddingRight: "15px"
        },
        children: /* @__PURE__ */ H.jsx(
          "img",
          {
            className: "ant-avatar",
            src: `${d.avatar}`,
            alt: "icon",
            style: { width: "30px", height: "30px", objectFit: "cover" }
          }
        )
      }
    ),
    /* @__PURE__ */ H.jsx(
      "div",
      {
        style: {
          display: "inline-block",
          verticalAlign: "top",
          width: v ? "calc(100% - 45px)" : "100%"
        },
        children: S ? /* @__PURE__ */ H.jsx(_qe, { ...e }) : /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
          /* @__PURE__ */ H.jsx(
            Aqe,
            {
              className: "shadow-sm message-body",
              $styles: p,
              ref: l,
              children: /* @__PURE__ */ H.jsx(
                "p",
                {
                  style: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "pre-wrap"
                  },
                  children: /* @__PURE__ */ H.jsx(
                    zX,
                    {
                      content: i,
                      contentMeta: o,
                      showStreamingAnimation: x
                    }
                  )
                }
              )
            }
          ),
          s && (s == null ? void 0 : s.length) > 0 && /* @__PURE__ */ H.jsx(
            Rqe,
            {
              size: "small",
              defaultActiveKey: "1",
              bordered: !1,
              items: [
                {
                  key: "1",
                  label: "Learn More",
                  children: /* @__PURE__ */ H.jsx(Iqe, { sources: s })
                }
              ],
              $styles: g
            }
          ),
          /* @__PURE__ */ H.jsx("p", { className: "message-datetime", children: Zx(new Date(a), "h:mm a") })
        ] })
      }
    )
  ] });
}, Nqe = (e) => {
  const { configs: t, isEmbedded: n, isShowJumpingDots: r } = e, i = pe(td), o = pe(eM), a = pe(rl), s = pe($c), l = pe(Ll), c = pe(kl), f = wr(), { updateSmallPopupStatus: d } = BX(t), p = o && !c, g = !o && n, v = !c && l !== Jt.siteCompanion && o && (s || l === Jt.siteCompanionPopup), y = () => {
    f(rw()), f(iw()), mq(f), d({ restart: !0 }), rt.info("[ui] restart conversation by click restart button");
  }, x = () => {
    f(Vs(!1));
  };
  return g ? /* @__PURE__ */ H.jsx(H.Fragment, {}) : p ? /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
    v && /* @__PURE__ */ H.jsx(
      zi,
      {
        className: "close-left",
        type: "link",
        onClick: x,
        style: { color: i },
        children: /* @__PURE__ */ H.jsx(RM, {})
      }
    ),
    /* @__PURE__ */ H.jsx(
      zi,
      {
        className: "betaBtn",
        shape: "round",
        onClick: () => y(),
        icon: /* @__PURE__ */ H.jsx(cWe, { size: 10 }),
        disabled: !a.length || r,
        children: "Restart"
      }
    )
  ] }) : l === Jt.siteCompanionPopup ? /* @__PURE__ */ H.jsx(
    zi,
    {
      type: "link",
      className: "close",
      onClick: x,
      style: {
        top: "50%",
        fontSize: "24px",
        lineHeight: 1,
        padding: "16px",
        marginTop: "-28px"
      },
      children: /* @__PURE__ */ H.jsx(s9e, {})
    }
  ) : /* @__PURE__ */ H.jsx(zi, { type: "link", className: "close", onClick: x, children: /* @__PURE__ */ H.jsx(AM, {}) });
}, kqe = () => {
  var i;
  const e = pe(P2e), t = pe(Zf), n = pe(T2e), r = pe(nl);
  return /* @__PURE__ */ H.jsxs(
    "div",
    {
      className: "cf-footer",
      style: { ...r == null ? void 0 : r.footer.custom, height: (i = r == null ? void 0 : r.visualHeight) == null ? void 0 : i.footer },
      children: [
        e && ((t == null ? void 0 : t.brandLogo) ?? (t == null ? void 0 : t.provider)) && /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
          "Powered By",
          t.brandLogo && /* @__PURE__ */ H.jsx("img", { src: t.brandLogo }),
          t.provider ?? "ChatFusion"
        ] }),
        n && /* @__PURE__ */ H.jsx("label", { className: "betaTag", children: "BETA" })
      ]
    }
  );
}, Lqe = "typically reply in minutes", Dqe = oe.memo(() => /* @__PURE__ */ H.jsx(WY, { style: { marginRight: "8px" }, component: () => /* @__PURE__ */ H.jsx(YY, { src: "/static/images/shiny.svg" }) })), jqe = () => {
  var v, y, x, b, w, S, E, O, $, P, R;
  const e = pe(Ll), t = pe(td), n = hq(e), r = pe(I2e), i = pe(Zf), o = pe(eM), a = pe(nl), s = pe($c), l = pe(kl), c = ((v = a == null ? void 0 : a.header.logo) == null ? void 0 : v.display) ?? i.showLogo, f = ((y = a == null ? void 0 : a.caption) == null ? void 0 : y.display) ?? !0, d = ((b = (x = a == null ? void 0 : a.title) == null ? void 0 : x.preTitle) == null ? void 0 : b.display) ?? !1, p = e === Jt.siteCompanion, g = !l && e !== Jt.siteCompanion && o && (s || e === Jt.siteCompanionPopup);
  return l ? /* @__PURE__ */ H.jsxs("div", { className: "popupHeader", children: [
    c && /* @__PURE__ */ H.jsx("div", { style: { width: 25, height: 25, marginRight: "8px" }, children: /* @__PURE__ */ H.jsx(
      JD,
      {
        src: i.logo ?? n.cover,
        size: 25,
        style: { border: "none" }
      }
    ) }),
    /* @__PURE__ */ H.jsx("div", { className: "cf-title", dangerouslySetInnerHTML: { __html: r } })
  ] }) : /* @__PURE__ */ H.jsxs(
    "div",
    {
      className: "popupHeader",
      style: {
        ...(w = a == null ? void 0 : a.title) == null ? void 0 : w.custom,
        ...g ? {
          marginLeft: "30px"
        } : {}
      },
      children: [
        c && /* @__PURE__ */ H.jsx(
          _7,
          {
            dot: !0,
            className: "status-badge",
            status: "success",
            offset: [0, 45],
            style: { marginRight: "20px", width: "10px", height: "10px" },
            children: /* @__PURE__ */ H.jsx(JD, { src: i.logo ?? n.cover, className: "cf-logo", size: "large" })
          }
        ),
        p && /* @__PURE__ */ H.jsx(Dqe, {}),
        /* @__PURE__ */ H.jsxs("div", { style: { overflow: "hidden" }, children: [
          d && /* @__PURE__ */ H.jsx("div", { style: (E = (S = a == null ? void 0 : a.title) == null ? void 0 : S.preTitle) == null ? void 0 : E.custom, children: ($ = (O = a == null ? void 0 : a.title) == null ? void 0 : O.preTitle) == null ? void 0 : $.content }),
          /* @__PURE__ */ H.jsx(
            "div",
            {
              className: "cf-title",
              style: (P = a == null ? void 0 : a.title) == null ? void 0 : P.custom,
              dangerouslySetInnerHTML: {
                __html: ((R = a == null ? void 0 : a.title) == null ? void 0 : R.content) ?? r
              }
            }
          ),
          f && /* @__PURE__ */ H.jsx(
            "div",
            {
              className: "caption",
              style: {
                fontSize: "0.9rem",
                color: t ?? n.caption.color,
                fontWeight: 400
              },
              children: /* @__PURE__ */ H.jsx("div", { dangerouslySetInnerHTML: { __html: i.subHeader || Lqe } })
            }
          )
        ] })
      ]
    }
  );
}, Fqe = Dq`
body * {
	cursor: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" stroke="rgba(0, 0, 0, 0.4)" fill="rgba(0, 0, 0, 0.4)" width="20px" height="20px" viewBox="0 0 10.04 10.04"><circle cx="5.02" cy="5.02" r="4.52"/></svg>') 10 10, auto !important;
}
`, Bqe = Ut.div`
  height: 100%;

  .conversation-container & .ant-card-head {
    position: relative;
    background-color: ${(e) => e.$styles.headerBackground} !important;
    color: ${(e) => e.$styles.headerColor};
    ${(e) => e.$styles.headerHeight ? `height: ${e.$styles.headerHeight};` : ""}
    ${(e) => e.$styles.headerPadding ? `padding: ${e.$styles.headerPadding};` : ""}
  }

  .ant-card-body {
    ${(e) => e.$styles.bodyHeight ? `height: ${e.$styles.bodyHeight};` : ""}
    ${(e) => e.$styles.bodyBorder ? `border: ${e.$styles.bodyBorder};` : ""}
  }

  .ant-card-cover {
    background-color: ${(e) => e.$styles.themeColor} !important;
    color: ${(e) => e.$styles.themeTextColor} !important;
  }

  .cf-title {
    color: ${(e) => e.$styles.titleColor};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .betaBtn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #ffffff75;
    box-shadow: none;
  }

  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    color: ${(e) => e.$styles.closeColor};
    padding: 8px 15px;
    height: auto;

    &:hover {
      color: ${(e) => e.$styles.closeColor} !important;
      opacity: 0.8;
    }
  }

  .close-left {
    position: absolute;
    left: 5px;
    top: 50%;
    margin-top: -25px;
    padding: 10px;
    font-size: 20px;
    height: auto;
  }

  .betaTag {
    background: #22b573;
    color: rgb(255, 255, 255);
    padding: 1px 0.5rem;
    border-radius: 1rem;
    font-weight: bolder;
    font-size: 0.6rem;
    margin-bottom: 0;
  }
`, zqe = () => {
  const e = pe(Ll), t = hq(e), n = pe(Zf);
  return n.showLogo && (n != null && n.logo) ? /* @__PURE__ */ H.jsx("img", { src: n.logo }) : /* @__PURE__ */ H.jsx("img", { src: t.cover });
}, Uqe = /* @__PURE__ */ H.jsx(qHe, { style: { fontSize: 50, color: "#ddd" }, spin: !0 }), yB = (e) => {
  var P, R;
  const { configs: t, children: n, isShowJumpingDots: r } = e, { embeddedWrapperSelectorId: i } = t, o = pe(Nl), a = pe(X2), s = pe(wNe), l = pe(xNe), c = pe(Ll), f = pe($c), d = Ec || f, p = pe(kl), g = Ch.isFeatureEnabled(), y = pe(Fx) === Bi.Bar, x = pe(jx), b = wr(), w = pe(nl), { divStyles: S } = H2e(), E = !s && !p && l, O = ((w == null ? void 0 : w.footer.display) ?? !0) && !p, $ = !!i && c !== Jt.siteCompanionPopup;
  return /* @__PURE__ */ H.jsxs(
    "div",
    {
      className: `
        conversation-container
        fade-in-up
        ${c}
        ${$ ? "is-embedded" : "is-fixed"}
        ${a ? "" : "is-launcher-hidden"}
        ${p && c !== "simple" ? "is-popup-small-mode" : ""}
        ${g ? "is-independent-launcher" : "none-independent-launcher"}
        ${x ? "show-small-popup-start-questions" : ""}
      `,
      onFocus: () => b(W6(!0)),
      onBlur: () => b(W6(!1)),
      onMouseEnter: () => b(H6(!0)),
      onMouseLeave: () => b(H6(!1)),
      style: {
        ...o ? w == null ? void 0 : w.popup.custom : { display: "none" },
        ...y && a && !d && !g && { bottom: "72px" }
        // Note: override the setting from style.less(.is-fixed), plan to solve it in usecase with independent launcher feature
      },
      children: [
        f && /* @__PURE__ */ H.jsx(Fqe, {}),
        /* @__PURE__ */ H.jsx(Bqe, { $styles: S, children: /* @__PURE__ */ H.jsxs(
          FEe,
          {
            hoverable: !0,
            title: (((P = w == null ? void 0 : w.title) == null ? void 0 : P.display) ?? !0) && /* @__PURE__ */ H.jsx(jqe, {}),
            cover: (((R = w == null ? void 0 : w.cover) == null ? void 0 : R.display) ?? !0) && /* @__PURE__ */ H.jsx(zqe, {}),
            extra: ((w == null ? void 0 : w.header.extraButtons) ?? !$) && /* @__PURE__ */ H.jsx(
              Nqe,
              {
                configs: t,
                isEmbedded: $,
                isShowJumpingDots: r
              }
            ),
            style: w == null ? void 0 : w.popupWrapper,
            children: [
              /* @__PURE__ */ H.jsx(BOe, { spinning: E, indicator: Uqe }),
              n,
              O && /* @__PURE__ */ H.jsx(kqe, {})
            ]
          }
        ) })
      ]
    }
  );
};
function kb(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? kb = function(n) {
    return typeof n;
  } : kb = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, kb(e);
}
function Hqe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function bB(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Wqe(e, t, n) {
  return t && bB(e.prototype, t), n && bB(e, n), e;
}
function Vqe(e, t) {
  return t && (kb(t) === "object" || typeof t == "function") ? t : Lb(e);
}
function JI(e) {
  return JI = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, JI(e);
}
function Lb(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Gqe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ZI(e, t);
}
function ZI(e, t) {
  return ZI = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, ZI(e, t);
}
function Db(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var cC = /* @__PURE__ */ function(e) {
  Gqe(t, e);
  function t() {
    var n, r;
    Hqe(this, t);
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = Vqe(this, (n = JI(t)).call.apply(n, [this].concat(o))), Db(Lb(r), "state", {
      bootstrapped: !1
    }), Db(Lb(r), "_unsubscribe", void 0), Db(Lb(r), "handlePersistorState", function() {
      var s = r.props.persistor, l = s.getState(), c = l.bootstrapped;
      c && (r.props.onBeforeLift ? Promise.resolve(r.props.onBeforeLift()).finally(function() {
        return r.setState({
          bootstrapped: !0
        });
      }) : r.setState({
        bootstrapped: !0
      }), r._unsubscribe && r._unsubscribe());
    }), r;
  }
  return Wqe(t, [{
    key: "componentDidMount",
    value: function() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState), this.handlePersistorState();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: "render",
    value: function() {
      return typeof this.props.children == "function" ? this.props.children(this.state.bootstrapped) : this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]), t;
}(m.PureComponent);
Db(cC, "defaultProps", {
  children: null,
  loading: null
});
const Kqe = Ut(rG)`
  background: white;
  color: rgba(0, 0, 0, 0.88);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  outline: none;
  box-shadow: none !important;
  pointer-events: ${(e) => e.loading ? "none" : "auto"};
  opacity: ${(e) => e.loading ? "0.8" : "1"};
  cursor: text !important;
  background-color: white !important;
`, uC = (e) => {
  const { loading: t, updateValue: n } = e;
  return /* @__PURE__ */ H.jsx(
    Kqe,
    {
      onChange: (r) => n(r.target.value),
      maxLength: 500,
      disabled: t,
      ...e
    }
  );
}, YM = Ut(zi)`
  width: 100%;
  font-weight: 500;
  border-radius: 10px;
  color: #333333;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  transition: color 0.2scubic-bezier(0.645, 0.045, 0.355, 1),
    border-color 0.2scubic-bezier(0.645, 0.045, 0.355, 1);
  text-align: left;
  background: white !important;
`, XM = Ut(zi)`
  position: absolute;
  top: 50%;
  color: white !important;
  background-color: ${(e) => e.$color} !important;
  border-color: ${(e) => e.$color} !important;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.8 !important;
  }

  &.ant-btn.ant-btn-icon-only .anticon {
    font-size: ${(e) => e.$iconSize ?? "14px"};
  }
`, fC = Ut.div`
  font-family: 'Helvetica Neue', 'Open Sans', Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Arial, 'Noto Sans', sans-serif;

  * {
    font-family: 'Helvetica Neue', 'Open Sans', Roboto, -apple-system, BlinkMacSystemFont,
      'Segoe UI', Arial, 'Noto Sans', sans-serif;
    box-sizing: border-box;
  }
`, { Paragraph: tO } = xh, qqe = "Ask our AI anything...", Yqe = Ut(fC)`
  box-shadow: 0 0 14px #8b8b8b40;
  border-radius: 10px;
  background-color: white;
  width: 300px;
  padding: 12px;
`, UX = Ut(YM)`
  border-radius: 6px;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 34px 8px 12px;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  margin-bottom: 8px;
  height: 48px;
`, Xqe = Ut(UX)`
  height: 100%;
  padding-right: 12px;

  &:hover {
    li {
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      color: #4096ff;
    }
  }

  li {
    list-style-type: disc;
    color: #666666;
    font-size: 10px;
    margin-inline: 12px 0;
    margin-bottom: 4px;

    div {
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`, Qqe = Ut(XM)`
  right: 8px;
  margin-top: -16px;
`, Jqe = Ut.div`
  margin-top: 16px;
`, Zqe = (e) => {
  var d, p, g, v, y, x, b, w;
  const { webchatId: t, isSimulateMobile: n = !1, settings: r } = e, { loading: i, value: o, updateValue: a, handleSendInputMessage: s, handleStarterQuestionClick: l } = zx(t), c = r.startQuestions || [], f = ((d = r == null ? void 0 : r.display.custom) == null ? void 0 : d.brandLogo) ?? "";
  return /* @__PURE__ */ H.jsxs(Yqe, { "data-id": "onrSiteCompanionPlacementWrapper", $isMobileMode: n, children: [
    /* @__PURE__ */ H.jsxs(
      "div",
      {
        style: {
          marginBottom: "16px",
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        children: [
          /* @__PURE__ */ H.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
            /* @__PURE__ */ H.jsx("div", { style: { width: 32, height: 32, marginRight: 9 }, children: /* @__PURE__ */ H.jsx("img", { style: { width: "100%", height: "100%" }, src: f }) }),
            /* @__PURE__ */ H.jsx("div", { style: { fontWeight: 500, color: "#333333" }, children: (p = r == null ? void 0 : r.display) == null ? void 0 : p.title })
          ] }),
          /* @__PURE__ */ H.jsx("div", { style: { width: 32, height: 32 }, children: /* @__PURE__ */ H.jsx(UY, { style: { color: (g = r == null ? void 0 : r.display) == null ? void 0 : g.themeColor, fontSize: 32 } }) })
        ]
      }
    ),
    /* @__PURE__ */ H.jsxs("div", { style: { height: 32, display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ H.jsx(
        "img",
        {
          src: "https://chatfusion.contactloop.com/static/images/shiny.svg",
          style: { marginRight: "8px" }
        }
      ),
      /* @__PURE__ */ H.jsx(
        "div",
        {
          style: {
            fontFamily: "Nunito",
            fontWeight: "bold",
            color: "#000000"
          },
          children: "Others May Ask..."
        }
      )
    ] }),
    /* @__PURE__ */ H.jsx(
      Jqe,
      {
        $isMobileMode: n,
        $onlyOneQuestion: c.length === 1,
        children: c.slice(0, 6).map((S, E) => E === 0 ? /* @__PURE__ */ H.jsxs(
          Xqe,
          {
            "data-id": "starter-question",
            type: "default",
            onClick: () => l(S.question),
            disabled: i,
            children: [
              /* @__PURE__ */ H.jsx(
                tO,
                {
                  style: {
                    color: "inherit",
                    marginBottom: 0,
                    fontSize: "12px"
                  },
                  children: S.question
                }
              ),
              S.answer && /* @__PURE__ */ H.jsx(
                tO,
                {
                  style: {
                    color: "inherit",
                    marginBottom: 0,
                    marginTop: "8px",
                    fontSize: "12px",
                    fontWeight: 400
                  },
                  children: /* @__PURE__ */ H.jsx("ul", { children: /* @__PURE__ */ H.jsx("li", { children: /* @__PURE__ */ H.jsx("div", { children: S.answer }) }) })
                }
              ),
              /* @__PURE__ */ H.jsxs(
                "div",
                {
                  style: {
                    float: "right",
                    paddingRight: "2px",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center"
                  },
                  children: [
                    /* @__PURE__ */ H.jsx("div", { style: { marginRight: "4px", color: "#1890FF", fontSize: "10px" }, children: "...See more" }),
                    /* @__PURE__ */ H.jsx(Xg, { style: { color: "#1890FF" } })
                  ]
                }
              )
            ]
          },
          E
        ) : /* @__PURE__ */ H.jsxs(
          UX,
          {
            "data-id": "starter-question",
            type: "default",
            onClick: () => l(S.question),
            disabled: i,
            children: [
              /* @__PURE__ */ H.jsx(
                tO,
                {
                  ellipsis: { rows: 2 },
                  style: {
                    color: "inherit",
                    marginBottom: 0,
                    fontSize: "12px",
                    lineHeight: "16px"
                  },
                  children: S.question
                }
              ),
              /* @__PURE__ */ H.jsx(
                Xg,
                {
                  style: {
                    position: "absolute",
                    right: "14px",
                    top: "50%",
                    marginTop: "-6px",
                    fontSize: "13px"
                  }
                }
              )
            ]
          },
          E
        ))
      }
    ),
    /* @__PURE__ */ H.jsxs(
      "div",
      {
        style: {
          position: "relative",
          overflow: "visible",
          marginTop: 16
        },
        children: [
          /* @__PURE__ */ H.jsx(
            uC,
            {
              value: o,
              updateValue: a,
              onPressEnter: s,
              placeholder: ((y = (v = r == null ? void 0 : r.display) == null ? void 0 : v.custom) == null ? void 0 : y.msgPlacehold) ?? qqe,
              style: {
                height: "48px",
                lineHeight: "48px",
                paddingLeft: "16px",
                paddingRight: "48px",
                boxShadow: "0px 4px 14px 0px #c2c2c240",
                borderRadius: "50px",
                border: "1px solid #dbdbdb",
                fontSize: 16
              },
              loading: i
            }
          ),
          ((x = r == null ? void 0 : r.display) == null ? void 0 : x.themeColor) && /* @__PURE__ */ H.jsx(
            Qqe,
            {
              type: "link",
              shape: "circle",
              icon: /* @__PURE__ */ H.jsx(rC, {}),
              onClick: s,
              disabled: i,
              loading: i,
              $color: (b = r == null ? void 0 : r.display) == null ? void 0 : b.themeColor
            }
          )
        ]
      }
    ),
    ((w = r == null ? void 0 : r.display) == null ? void 0 : w.showProvider) && /* @__PURE__ */ H.jsxs(
      "div",
      {
        style: {
          marginTop: 16,
          fontSize: 12,
          color: "#999999",
          lineHeight: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
          letterSpacing: "0.01em"
        },
        children: [
          "Powered By",
          /* @__PURE__ */ H.jsx("img", { src: "https://chatfusion.contactloop.com/static/images/logo_icon.svg" }),
          "ChatFusion"
        ]
      }
    )
  ] });
}, eYe = "Search anything...", tYe = Ut(fC)`
  width: 246px;

  &:after {
    content: '';
    display: block;
    clear: both;
  }

  @media (max-width: 440px) {
    width: 120px;
  }
`, nYe = Ut.div`
  position: relative;
  height: 36px;
  display: flex;
  align-items: center;
  box-shadow: 0 0 14px #8b8b8b40;
  border-radius: 8px;
  background-color: white;
  padding-right: 36px;
  float: right;

  img {
    margin-left: 8px;
    width: 20px;
  }

  input {
    height: 36px;
    line-height: 40px;
    padding: 0 8px;
    border: none;
    font-size: 14px;
  }

  @media (max-width: 440px) {
    height: 32px;
    padding-right: 32px;

    input {
      font-size: 12px;
      height: 32px;
      line-height: 34px;

      &:focus {
        width: 182px;
      }
    }

    img {
      width: 16px;
    }
  }
`, rYe = Ut(zi)`
  position: absolute;
  right: 0;
  color: ${(e) => e.color} !important;
  height: 21px;
  border-left: 1px solid #dbdbdb;
  padding: 0 8px;
  border-radius: 0;
  width: 36px !important;
  opacity: ${(e) => e.loading ? 0.8 : 1};

  &:hover {
    opacity: 0.8 !important;
  }

  @media (max-width: 440px) {
    height: 16px;
    width: 32px !important;
  }
}
`, iYe = (e) => {
  var s, l, c, f;
  const { webchatId: t, settings: n } = e, { value: r, loading: i, updateValue: o, handleSendInputMessage: a } = zx(t);
  return /* @__PURE__ */ H.jsx(tYe, { "data-id": "onrSiteCompanionPlacementWrapper", children: /* @__PURE__ */ H.jsxs(nYe, { children: [
    /* @__PURE__ */ H.jsx("img", { src: "https://chatfusion.contactloop.com/static/images/shiny.svg" }),
    /* @__PURE__ */ H.jsx(
      uC,
      {
        value: r,
        updateValue: o,
        onPressEnter: a,
        placeholder: ((l = (s = n == null ? void 0 : n.display) == null ? void 0 : s.custom) == null ? void 0 : l.msgPlacehold) ?? eYe,
        loading: i
      }
    ),
    ((c = n == null ? void 0 : n.display) == null ? void 0 : c.themeColor) && /* @__PURE__ */ H.jsx(
      rYe,
      {
        type: "link",
        icon: /* @__PURE__ */ H.jsx(UY, {}),
        onClick: a,
        color: (f = n == null ? void 0 : n.display) == null ? void 0 : f.themeColor,
        loading: i,
        disabled: i
      }
    )
  ] }) });
}, { Paragraph: oYe } = xh, aYe = "Search anything...", sYe = Ut(fC)`
  box-shadow: 0 0 14px #8b8b8b40;
  border-radius: 10px;
  background-color: white;
  width: 300px;
  padding: 12px 12px 18px;
`, lYe = Ut(YM)`
  height: 52px;
  line-height: 12px;
  padding: 8px 34px 8px 12px;
`, cYe = Ut(XM)`
  right: 4px;
  width: 24px !important;
  height: 24px !important;
  min-width: initial !important;
  margin-top: -12px;
`, uYe = (e) => {
  var c, f, d, p, g;
  const { webchatId: t, settings: n } = e, { value: r, loading: i, updateValue: o, handleSendInputMessage: a, handleStarterQuestionClick: s } = zx(t), l = n.startQuestions || [];
  return /* @__PURE__ */ H.jsxs(sYe, { "data-id": "onrSiteCompanionPlacementWrapper", children: [
    /* @__PURE__ */ H.jsxs("div", { style: { height: 22, display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ H.jsx(
        "img",
        {
          src: "https://chatfusion.contactloop.com/static/images/shiny.svg",
          style: { marginRight: "4px", width: "20px" }
        }
      ),
      /* @__PURE__ */ H.jsx(
        "div",
        {
          style: {
            fontFamily: "Nunito",
            fontWeight: "bold",
            fontSize: 16,
            lineHeight: "22px",
            color: "#333333"
          },
          children: "Others May Ask..."
        }
      )
    ] }),
    /* @__PURE__ */ H.jsx(
      "div",
      {
        style: {
          display: "grid",
          gap: "8px",
          gridTemplateColumns: "1fr",
          marginTop: 16
        },
        children: l.slice(0, 2).map((v, y) => /* @__PURE__ */ H.jsxs(
          lYe,
          {
            type: "default",
            onClick: () => s(v.question),
            disabled: i,
            children: [
              /* @__PURE__ */ H.jsx(
                oYe,
                {
                  ellipsis: { rows: 2 },
                  style: {
                    color: "inherit",
                    marginBottom: 0,
                    fontSize: "12px",
                    lineHeight: 1.5
                  },
                  children: v.question
                }
              ),
              /* @__PURE__ */ H.jsx(
                Xg,
                {
                  style: {
                    position: "absolute",
                    right: "11px",
                    top: "50%",
                    marginTop: "-6px",
                    fontSize: "13px"
                  }
                }
              )
            ]
          },
          y
        ))
      }
    ),
    /* @__PURE__ */ H.jsxs(
      "div",
      {
        style: {
          position: "relative",
          overflow: "visible",
          marginTop: 12
        },
        children: [
          /* @__PURE__ */ H.jsx(
            uC,
            {
              value: r,
              updateValue: o,
              onPressEnter: a,
              placeholder: ((f = (c = n == null ? void 0 : n.display) == null ? void 0 : c.custom) == null ? void 0 : f.msgPlacehold) ?? aYe,
              style: {
                height: "32px",
                lineHeight: "32px",
                paddingLeft: "12px",
                paddingRight: "36px",
                boxShadow: "0px 4px 14px 0px #c2c2c240",
                borderRadius: "50px",
                border: "1px solid #dbdbdb",
                fontSize: 12
              },
              loading: i
            }
          ),
          ((d = n == null ? void 0 : n.display) == null ? void 0 : d.themeColor) && /* @__PURE__ */ H.jsx(
            cYe,
            {
              type: "link",
              shape: "circle",
              icon: /* @__PURE__ */ H.jsx(rC, {}),
              onClick: a,
              loading: i,
              disabled: i,
              $color: (p = n == null ? void 0 : n.display) == null ? void 0 : p.themeColor,
              $iconSize: "12px"
            }
          )
        ]
      }
    ),
    ((g = n == null ? void 0 : n.display) == null ? void 0 : g.showProvider) && /* @__PURE__ */ H.jsxs(
      "div",
      {
        style: {
          marginTop: 16,
          fontSize: 8,
          color: "#999999",
          lineHeight: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "2px",
          letterSpacing: "0.01em"
        },
        children: [
          "Powered By",
          /* @__PURE__ */ H.jsx("img", { src: "https://chatfusion.contactloop.com/static/images/logo_icon.svg", width: 11 }),
          "ChatFusion"
        ]
      }
    )
  ] });
}, { Paragraph: fYe } = xh, dYe = "Ask our AI anything...", pYe = Ut(fC)`
  box-shadow: 0 0 14px #8b8b8b40;
  border-radius: 30px;
  background-color: white;
  ${(e) => e.$isMobileMode ? `
  width: 345px;
  padding: 20px;
  ` : `
  width: 640px;
  padding: 20px 24px;
  `}

  @media (max-width: 440px) {
    width: 345px;
    padding: 20px;
  }
`;
Ut(YM)`
  height: 64px;
  line-height: 20px;
  padding: 12px 40px 12px 12px;
  font-size: 14px;
`;
const hYe = Ut(XM)`
  right: 8px;
  margin-top: -16px;
`, mYe = Ut.div`
  display: grid;
  gap: 8px 12px;
  grid-template-columns: ${(e) => e.$isMobileMode || e.$onlyOneQuestion ? "1fr" : "1fr 1fr"};
  margin-top: 24px;

  @media (max-width: 440px) {
    grid-template-columns: 1fr;
  }
`, gYe = (e) => {
  var f, d, p, g, v;
  const { webchatId: t, settings: n } = e, {
    isSimulateMobile: r,
    loading: i,
    value: o,
    updateValue: a,
    handleSendInputMessage: s,
    handleStarterQuestionClick: l
  } = zx(t), c = n.startQuestions || [];
  return /* @__PURE__ */ H.jsxs(pYe, { "data-id": "onrSiteCompanionPlacementWrapper", $isMobileMode: r, children: [
    /* @__PURE__ */ H.jsxs("div", { style: { height: 32, display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ H.jsx(
        "img",
        {
          src: "https://chatfusion.contactloop.com/static/images/shiny.svg",
          style: { marginRight: "8px" }
        }
      ),
      /* @__PURE__ */ H.jsx(
        "div",
        {
          style: {
            fontFamily: "Nunito",
            fontWeight: "bold",
            fontSize: 24,
            lineHeight: "32px",
            color: "#333333"
          },
          children: "Ask AI"
        }
      )
    ] }),
    /* @__PURE__ */ H.jsx(
      mYe,
      {
        $isMobileMode: r,
        $onlyOneQuestion: c.length === 1,
        children: c.slice(0, 4).map((y, x) => /* @__PURE__ */ H.jsxs(
          zi,
          {
            "data-id": "starter-question",
            type: "default",
            onClick: () => l(y.question),
            disabled: i,
            style: gI,
            children: [
              /* @__PURE__ */ H.jsx(
                fYe,
                {
                  ellipsis: { rows: 2 },
                  style: {
                    color: "inherit",
                    marginBottom: 0
                  },
                  children: y.question
                }
              ),
              /* @__PURE__ */ H.jsx(
                Xg,
                {
                  style: {
                    position: "absolute",
                    right: "14px",
                    top: "50%",
                    marginTop: "-6px",
                    fontSize: "13px"
                  }
                }
              )
            ]
          },
          x
        ))
      }
    ),
    /* @__PURE__ */ H.jsxs(
      "div",
      {
        style: {
          position: "relative",
          overflow: "visible",
          marginTop: 16
        },
        children: [
          /* @__PURE__ */ H.jsx(
            uC,
            {
              value: o,
              updateValue: a,
              onPressEnter: s,
              placeholder: ((d = (f = n == null ? void 0 : n.display) == null ? void 0 : f.custom) == null ? void 0 : d.msgPlacehold) ?? dYe,
              style: {
                height: "48px",
                lineHeight: "48px",
                paddingLeft: "16px",
                paddingRight: "48px",
                boxShadow: "0px 4px 14px 0px #c2c2c240",
                borderRadius: "50px",
                border: "1px solid #dbdbdb",
                fontSize: 16
              },
              loading: i
            }
          ),
          ((p = n == null ? void 0 : n.display) == null ? void 0 : p.themeColor) && /* @__PURE__ */ H.jsx(
            hYe,
            {
              type: "link",
              shape: "circle",
              icon: /* @__PURE__ */ H.jsx(rC, {}),
              onClick: s,
              loading: i,
              disabled: i,
              $color: (g = n == null ? void 0 : n.display) == null ? void 0 : g.themeColor
            }
          )
        ]
      }
    ),
    ((v = n == null ? void 0 : n.display) == null ? void 0 : v.showProvider) && /* @__PURE__ */ H.jsxs(
      "div",
      {
        style: {
          marginTop: 24,
          fontSize: 12,
          color: "#999999",
          lineHeight: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
          letterSpacing: "0.01em"
        },
        children: [
          "Powered By",
          /* @__PURE__ */ H.jsx("img", { src: "https://chatfusion.contactloop.com/static/images/logo_icon.svg" }),
          "ChatFusion"
        ]
      }
    )
  ] });
}, vYe = (e) => {
  const { type: t } = e, n = {
    [zc.InContent]: /* @__PURE__ */ H.jsx(gYe, { ...e }),
    [zc.MediumRectangle]: /* @__PURE__ */ H.jsx(uYe, { ...e }),
    [zc.HalfPageRectangle]: /* @__PURE__ */ H.jsx(Zqe, { ...e }),
    [zc.LargeLeaderboardPanel]: /* @__PURE__ */ H.jsx(H.Fragment, {}),
    [zc.HeaderSearchBar]: /* @__PURE__ */ H.jsx(iYe, { ...e }),
    [zc.BannerSearchBar]: /* @__PURE__ */ H.jsx(H.Fragment, {}),
    [zc.LargeLeaderboardSearchBar]: /* @__PURE__ */ H.jsx(H.Fragment, {})
  };
  return /* @__PURE__ */ H.jsx(H.Fragment, { children: n[t] });
}, yYe = () => /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
  /* @__PURE__ */ H.jsx("link", { href: "https://fonts.googleapis.com/css?family=Nunito:700", rel: "stylesheet" }),
  /* @__PURE__ */ H.jsx("style", { children: `
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueRoman.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueMedium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Helvetica Neue';
  src: url('https://d1tpc6dloxrm5e.cloudfront.net/fonts/HelveticaNeueBold.woff') format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
      ` })
] }), bYe = Ut.div`
  position: fixed;
  bottom: 0px;
  right: 20px;
  z-index: 998;
  cursor: pointer;

  .ant-badge {
    vertical-align: bottom;
  }
`, wYe = Ut.div`
  width: 264px;
  height: 48px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0px 0px;
  cursor: pointer;
  padding: 0 16px;
  box-sizing: border-box;
`, QM = (e) => {
  const { postToggleEvent: t, wrapperStyle: n } = e, r = wr(), i = pe(X2), o = pe(Nl), a = pe(ed), s = pe(td), l = pe(IG), c = Ch.isFeatureEnabled(), f = () => {
    r(Vs()), c && (t == null || t(!o));
  };
  return i ? /* @__PURE__ */ H.jsx(bYe, { style: n, children: /* @__PURE__ */ H.jsx(aq, { offset: [-2, 0], children: /* @__PURE__ */ H.jsxs(wYe, { style: { background: a, color: s }, onClick: f, children: [
    /* @__PURE__ */ H.jsx("div", { style: { position: "absolute", left: "16px" }, children: "Chat With Us" }),
    /* @__PURE__ */ H.jsx("div", { style: { position: "absolute", right: "16px" }, children: o ? /* @__PURE__ */ H.jsx(RM, { style: { fontSize: "20px", color: s } }) : /* @__PURE__ */ H.jsx("img", { style: { width: 20, height: 20 }, src: l, alt: "launcher icon" }) })
  ] }) }) }) : null;
}, SYe = Ut.div`
  position: fixed;
  bottom: 18px;
  right: 20px;
  z-index: 998;
  user-select: none;

  .full-icon,
  .launcher-icon {
    width: ${(e) => e.$size ?? "60"}px !important;
    height: ${(e) => e.$size ?? "60"}px !important;
    cursor: pointer;
    border-radius: 100%;
    overflow: hidden;
  }

  .launcher-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    & > img {
      width: ${(e) => e.$iconSize ?? "24"}px;
      height: ${(e) => e.$iconSize ?? "24"}px;
      border-radius: 100%;
      object-fit: cover;
    }
  }

  .full-icon {
    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`, eA = (e) => {
  const { className: t, postToggleEvent: n } = e, r = wr(), i = pe(X2), o = pe(ed), a = pe(td), s = pe(IG), l = pe(Nl), c = pe(uq), f = pe(D2e), d = pe(j2e), p = c ? AG[c] : void 0, g = c ? XTe[c] : void 0, v = f === Vg.FullImage && d && LG.isFeatureEnabled(), y = !v, x = Ch.isFeatureEnabled(), b = kG.isFeatureEnabled(), w = () => {
    r(Vs()), x && (n == null || n(!l));
  };
  return i ? /* @__PURE__ */ H.jsx(
    SYe,
    {
      className: t,
      $size: b ? p : 60,
      $iconSize: b ? g : 28,
      children: /* @__PURE__ */ H.jsx(aq, { children: /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
        !l && v && /* @__PURE__ */ H.jsx("div", { className: "full-icon", onClick: w, children: /* @__PURE__ */ H.jsx("img", { src: d, alt: "launcher icon" }) }),
        !l && y && /* @__PURE__ */ H.jsx("div", { className: "launcher-icon", style: { background: o }, onClick: w, children: /* @__PURE__ */ H.jsx("img", { src: s, alt: "launcher icon" }) }),
        l && /* @__PURE__ */ H.jsx(
          zi,
          {
            size: "large",
            type: "primary",
            shape: "circle",
            className: "launcher-icon",
            style: {
              background: o,
              borderColor: o,
              boxShadow: "none"
            },
            icon: /* @__PURE__ */ H.jsx(
              RM,
              {
                style: {
                  fontSize: b ? g : "20px",
                  color: a
                }
              }
            ),
            onClick: w
          }
        )
      ] }) })
    }
  ) : null;
};
var JM = "persist:", dC = "persist/FLUSH", Bv = "persist/REHYDRATE", pC = "persist/PAUSE", hC = "persist/PERSIST", mC = "persist/PURGE", gC = "persist/REGISTER", xYe = -1;
function jb(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? jb = function(n) {
    return typeof n;
  } : jb = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, jb(e);
}
function wB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function CYe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wB(n, !0).forEach(function(r) {
      EYe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wB(n).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function EYe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $Ye(e, t, n, r) {
  r.debug;
  var i = CYe({}, n);
  return e && jb(e) === "object" && Object.keys(e).forEach(function(o) {
    o !== "_persist" && t[o] === n[o] && (i[o] = e[o]);
  }), i;
}
function _Ye(e) {
  var t = e.blacklist || null, n = e.whitelist || null, r = e.transforms || [], i = e.throttle || 0, o = "".concat(e.keyPrefix !== void 0 ? e.keyPrefix : JM).concat(e.key), a = e.storage, s;
  e.serialize === !1 ? s = function(O) {
    return O;
  } : typeof e.serialize == "function" ? s = e.serialize : s = OYe;
  var l = e.writeFailHandler || null, c = {}, f = {}, d = [], p = null, g = null, v = function(O) {
    Object.keys(O).forEach(function($) {
      b($) && c[$] !== O[$] && d.indexOf($) === -1 && d.push($);
    }), Object.keys(c).forEach(function($) {
      O[$] === void 0 && b($) && d.indexOf($) === -1 && c[$] !== void 0 && d.push($);
    }), p === null && (p = setInterval(y, i)), c = O;
  };
  function y() {
    if (d.length === 0) {
      p && clearInterval(p), p = null;
      return;
    }
    var E = d.shift(), O = r.reduce(function($, P) {
      return P.in($, E, c);
    }, c[E]);
    if (O !== void 0)
      try {
        f[E] = s(O);
      } catch ($) {
        console.error("redux-persist/createPersistoid: error serializing state", $);
      }
    else
      delete f[E];
    d.length === 0 && x();
  }
  function x() {
    Object.keys(f).forEach(function(E) {
      c[E] === void 0 && delete f[E];
    }), g = a.setItem(o, s(f)).catch(w);
  }
  function b(E) {
    return !(n && n.indexOf(E) === -1 && E !== "_persist" || t && t.indexOf(E) !== -1);
  }
  function w(E) {
    l && l(E);
  }
  var S = function() {
    for (; d.length !== 0; )
      y();
    return g || Promise.resolve();
  };
  return {
    update: v,
    flush: S
  };
}
function OYe(e) {
  return JSON.stringify(e);
}
function PYe(e) {
  var t = e.transforms || [], n = "".concat(e.keyPrefix !== void 0 ? e.keyPrefix : JM).concat(e.key), r = e.storage;
  e.debug;
  var i;
  return e.deserialize === !1 ? i = function(a) {
    return a;
  } : typeof e.deserialize == "function" ? i = e.deserialize : i = TYe, r.getItem(n).then(function(o) {
    if (o)
      try {
        var a = {}, s = i(o);
        return Object.keys(s).forEach(function(l) {
          a[l] = t.reduceRight(function(c, f) {
            return f.out(c, l, s);
          }, i(s[l]));
        }), a;
      } catch (l) {
        throw l;
      }
    else
      return;
  });
}
function TYe(e) {
  return JSON.parse(e);
}
function IYe(e) {
  var t = e.storage, n = "".concat(e.keyPrefix !== void 0 ? e.keyPrefix : JM).concat(e.key);
  return t.removeItem(n, AYe);
}
function AYe(e) {
}
function SB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? SB(n, !0).forEach(function(r) {
      RYe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : SB(n).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function RYe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function MYe(e, t) {
  if (e == null)
    return {};
  var n = NYe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function NYe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var kYe = 5e3;
function HX(e, t) {
  var n = e.version !== void 0 ? e.version : xYe;
  e.debug;
  var r = e.stateReconciler === void 0 ? $Ye : e.stateReconciler, i = e.getStoredState || PYe, o = e.timeout !== void 0 ? e.timeout : kYe, a = null, s = !1, l = !0, c = function(d) {
    return d._persist.rehydrated && a && !l && a.update(d), d;
  };
  return function(f, d) {
    var p = f || {}, g = p._persist, v = MYe(p, ["_persist"]), y = v;
    if (d.type === hC) {
      var x = !1, b = function(R, L) {
        x || (d.rehydrate(e.key, R, L), x = !0);
      };
      if (o && setTimeout(function() {
        !x && b(void 0, new Error('redux-persist: persist timed out for persist key "'.concat(e.key, '"')));
      }, o), l = !1, a || (a = _Ye(e)), g)
        return Jl({}, t(y, d), {
          _persist: g
        });
      if (typeof d.rehydrate != "function" || typeof d.register != "function")
        throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
      return d.register(e.key), i(e).then(function(P) {
        var R = e.migrate || function(L, B) {
          return Promise.resolve(L);
        };
        R(P, n).then(function(L) {
          b(L);
        }, function(L) {
          b(void 0, L);
        });
      }, function(P) {
        b(void 0, P);
      }), Jl({}, t(y, d), {
        _persist: {
          version: n,
          rehydrated: !1
        }
      });
    } else {
      if (d.type === mC)
        return s = !0, d.result(IYe(e)), Jl({}, t(y, d), {
          _persist: g
        });
      if (d.type === dC)
        return d.result(a && a.flush()), Jl({}, t(y, d), {
          _persist: g
        });
      if (d.type === pC)
        l = !0;
      else if (d.type === Bv) {
        if (s)
          return Jl({}, y, {
            _persist: Jl({}, g, {
              rehydrated: !0
            })
            // @NOTE if key does not match, will continue to default else below
          });
        if (d.key === e.key) {
          var w = t(y, d), S = d.payload, E = r !== !1 && S !== void 0 ? r(S, f, w, e) : w, O = Jl({}, E, {
            _persist: Jl({}, g, {
              rehydrated: !0
            })
          });
          return c(O);
        }
      }
    }
    if (!g)
      return t(f, d);
    var $ = t(y, d);
    return $ === y ? f : c(Jl({}, $, {
      _persist: g
    }));
  };
}
function xB(e) {
  return jYe(e) || DYe(e) || LYe();
}
function LYe() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function DYe(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]")
    return Array.from(e);
}
function jYe(e) {
  if (Array.isArray(e)) {
    for (var t = 0, n = new Array(e.length); t < e.length; t++)
      n[t] = e[t];
    return n;
  }
}
function CB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? CB(n, !0).forEach(function(r) {
      FYe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : CB(n).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function FYe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var WX = {
  registry: [],
  bootstrapped: !1
}, BYe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : WX, n = arguments.length > 1 ? arguments[1] : void 0;
  switch (n.type) {
    case gC:
      return tA({}, t, {
        registry: [].concat(xB(t.registry), [n.key])
      });
    case Bv:
      var r = t.registry.indexOf(n.key), i = xB(t.registry);
      return i.splice(r, 1), tA({}, t, {
        registry: i,
        bootstrapped: i.length === 0
      });
    default:
      return t;
  }
};
function VX(e, t, n) {
  var r = n || !1, i = cR(BYe, WX, t && t.enhancer ? t.enhancer : void 0), o = function(c) {
    i.dispatch({
      type: gC,
      key: c
    });
  }, a = function(c, f, d) {
    var p = {
      type: Bv,
      payload: f,
      err: d,
      key: c
      // dispatch to `store` to rehydrate and `persistor` to track result
    };
    e.dispatch(p), i.dispatch(p), r && s.getState().bootstrapped && (r(), r = !1);
  }, s = tA({}, i, {
    purge: function() {
      var c = [];
      return e.dispatch({
        type: mC,
        result: function(d) {
          c.push(d);
        }
      }), Promise.all(c);
    },
    flush: function() {
      var c = [];
      return e.dispatch({
        type: dC,
        result: function(d) {
          c.push(d);
        }
      }), Promise.all(c);
    },
    pause: function() {
      e.dispatch({
        type: pC
      });
    },
    persist: function() {
      e.dispatch({
        type: hC,
        register: o,
        rehydrate: a
      });
    }
  });
  return t && t.manualPersist || s.persist(), s;
}
var GX = UYe;
function lg(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? lg = function(n) {
    return typeof n;
  } : lg = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, lg(e);
}
function EB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $B(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? EB(n, !0).forEach(function(r) {
      zYe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : EB(n).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zYe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function UYe(e, t, n, r) {
  r.debug;
  var i = $B({}, n);
  return e && lg(e) === "object" && Object.keys(e).forEach(function(o) {
    if (o !== "_persist" && t[o] === n[o]) {
      if (HYe(n[o])) {
        i[o] = $B({}, i[o], {}, e[o]);
        return;
      }
      i[o] = e[o];
    }
  }), i;
}
function HYe(e) {
  return e !== null && !Array.isArray(e) && lg(e) === "object";
}
var ZM = {}, eN = {};
eN.__esModule = !0;
eN.default = GYe;
function Fb(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Fb = function(n) {
    return typeof n;
  } : Fb = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Fb(e);
}
function nO() {
}
var WYe = {
  getItem: nO,
  setItem: nO,
  removeItem: nO
};
function VYe(e) {
  if ((typeof self > "u" ? "undefined" : Fb(self)) !== "object" || !(e in self))
    return !1;
  try {
    var t = self[e], n = "redux-persist ".concat(e, " test");
    t.setItem(n, "test"), t.getItem(n), t.removeItem(n);
  } catch {
    return !1;
  }
  return !0;
}
function GYe(e) {
  var t = "".concat(e, "Storage");
  return VYe(t) ? self[t] : WYe;
}
ZM.__esModule = !0;
ZM.default = YYe;
var KYe = qYe(eN);
function qYe(e) {
  return e && e.__esModule ? e : { default: e };
}
function YYe(e) {
  var t = (0, KYe.default)(e);
  return {
    getItem: function(r) {
      return new Promise(function(i, o) {
        i(t.getItem(r));
      });
    },
    setItem: function(r, i) {
      return new Promise(function(o, a) {
        o(t.setItem(r, i));
      });
    },
    removeItem: function(r) {
      return new Promise(function(i, o) {
        i(t.removeItem(r));
      });
    }
  };
}
var tN = void 0, XYe = QYe(ZM);
function QYe(e) {
  return e && e.__esModule ? e : { default: e };
}
var JYe = (0, XYe.default)("local");
tN = JYe;
const ZYe = (e) => (t) => (n) => {
  const r = t(n), o = e.getState()[tr], { currentStreamingMessage: a, conversation: s } = o;
  return (n.type === Aw.type || n.type === dR.type) && a && a.replied && a.done && a.replyId && a.channelName && Gf.isFeatureEnabled() && (e.dispatch(
    oh({
      conversationId: s.id,
      campaignId: s.campaign_id,
      traceId: s.trace_id
    })
  ), e.dispatch(Qs(!1)), e.dispatch(
    CU({
      reply_id: a.replyId,
      channel_name: a.channelName
    })
  )), r;
}, eXe = {
  key: "root",
  version: 1,
  storage: tN,
  stateReconciler: function(e, t, n, r) {
    if (t[ln].webchatId !== e[ln].webchatId)
      return t;
    const i = {
      ...e,
      [Ur]: {
        ...e[Ur],
        isPopupSmallMode: t[Ur].isPopupSmallMode,
        isSimulateMobile: t[Ur].isSimulateMobile,
        isUserCloseActionBox: t[Ur].isUserCloseActionBox
      },
      [tr]: {
        ...e[tr],
        isUserSignUpIntentDetected: t[tr].isUserSignUpIntentDetected,
        pendingMessages: t[tr].pendingMessages,
        doneStreamingMessageReplyIds: t[tr].doneStreamingMessageReplyIds,
        currentStreamingMessage: t[tr].currentStreamingMessage
      }
    };
    return GX(i, t, n, r);
  }
}, tXe = (e, t, n, r) => {
  const i = nXe(e, n, r), o = {
    ...eXe,
    key: i
  }, a = HX(
    o,
    uR({
      [ln]: Dl.reducer,
      [Ur]: tl.reducer,
      [ku]: oK.reducer,
      [tr]: gs.reducer
    })
  );
  return wU({
    reducer: a,
    middleware: (s) => s({
      serializableCheck: {
        ignoredActions: [dC, Bv, pC, hC, mC, gC]
      }
    }).concat(ZYe),
    ...t
  });
}, nXe = (e, t, n) => t ? new tIe(
  j2
).perform({ webchatId: e, type: t, url: n }) ?? `webchat-${e}` : `webchat-${e}`, rXe = (e, t, n, r) => {
  const i = tXe(t, e, n, r);
  return {
    store: i,
    persistor: VX(i)
  };
}, iXe = {
  key: "root",
  version: 1,
  storage: tN,
  stateReconciler: function(e, t, n, r) {
    if (t[ln].webchatId !== e[ln].webchatId)
      return t;
    const i = {
      ...e,
      [Ur]: {
        ...e[Ur],
        isPopupSmallMode: t[Ur].isPopupSmallMode,
        isSimulateMobile: t[Ur].isSimulateMobile
      }
    };
    return GX(i, t, n, r);
  }
}, oXe = HX(
  iXe,
  uR({
    [ln]: Dl.reducer,
    [Ur]: tl.reducer,
    [ku]: oK.reducer,
    [tr]: gs.reducer
  })
), nN = (e, t, n, r) => Tx.isFeatureEnabled() && t ? rXe(e, t, n, r) : aXe(e), aXe = (e) => {
  const t = wU({
    reducer: oXe,
    middleware: (n) => n({
      serializableCheck: {
        ignoredActions: [dC, Bv, pC, hC, mC, gC]
      }
    }),
    ...e
  });
  return {
    store: t,
    persistor: VX(t)
  };
}, _B = (e) => /* @__PURE__ */ H.jsx(
  QM,
  {
    ...e,
    wrapperStyle: {
      top: "calc(50% - 48px)",
      left: "0px",
      bottom: "unset",
      right: "unset",
      marginTop: "-132px",
      transform: "rotate(90deg)",
      transformOrigin: "left bottom"
    }
  }
), sXe = (e) => {
  const { remoteSettingsProps: t, ...n } = e, { theme: r, testingMod: i, webchatId: o } = n, [a, s] = m.useState(!1), l = pe(Px), c = pe(Fx), f = wr();
  V2({ ...n, remoteSettingsProps: t }), dq(r);
  const d = (S) => {
    Nr.create().dispatchWindowEvent(
      sn.WEBCHAT_LAUNCHER_CLICKED,
      o
    ), S ? Nr.create(o).postEventTo(xa.Iframe, {
      name: Fi.POPUP_SHOW
    }) : Nr.create(o).postEventTo(xa.Iframe, {
      name: Fi.POPUP_HIDE
    });
  }, p = () => {
    let S = 0;
    const E = setInterval(() => {
      var O;
      try {
        const $ = Tx.isFeatureEnabled() ? `onrWebchatIframe-${o}` : "onrWebchatIframe", P = document.getElementById($), R = ((O = P == null ? void 0 : P.contentWindow) == null ? void 0 : O.document) || (P == null ? void 0 : P.contentDocument);
        ((R == null ? void 0 : R.querySelector(".conversation-container")) || S++ >= 20) && (s(!0), clearInterval(E));
      } catch {
        clearInterval(E), s(!0);
      }
    }, 500);
  }, g = () => {
    Cl.isFeatureEnabled() && s(!0);
  }, v = () => {
    Cl.isFeatureEnabled() && setTimeout(() => {
      s(!0);
    }, 5e3);
  }, y = () => {
    f(Vs(!0));
  }, x = () => {
    f(Vs(!1));
  }, b = (S) => {
    const E = S.detail;
    f(b2e(E.badgeCount));
  }, w = (S) => {
    const E = S.detail;
    E.themeColor && f(pq(E.themeColor));
  };
  if (ya(sn.IFRAME_EMBEDDED, v, window, o), ya(sn.IFRAME_LOADED, g, window, o), ya(sn.WEBCHAT_POPUP_SHOW, y, window, o), ya(sn.WEBCHAT_POPUP_HIDE, x, window, o), ya(sn.BADGE_COUNT_CHANGE, b, window, o), ya(sn.WEBCHAT_UPDATE, w, window, o), m.useEffect(() => {
    r && f(Bx(r));
  }, [r]), m.useEffect(() => {
    i && rt.startTest();
  }, [i]), m.useEffect(() => {
    Cl.isFeatureEnabled() || p();
  }, []), l || !a)
    return null;
  switch (c) {
    case Bi.Bar:
      return /* @__PURE__ */ H.jsx(QM, { postToggleEvent: d });
    case Bi.SideBar:
      return /* @__PURE__ */ H.jsx(_B, { postToggleEvent: d });
    case Bi.BubbleAndSideBar:
      return /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
        /* @__PURE__ */ H.jsx(_B, { postToggleEvent: d }),
        /* @__PURE__ */ H.jsx(
          eA,
          {
            className: "conversation-launcher",
            postToggleEvent: d
          }
        )
      ] });
    default:
      return /* @__PURE__ */ H.jsx(
        eA,
        {
          className: "conversation-launcher",
          postToggleEvent: d
        }
      );
  }
}, lXe = (e) => {
  const { webchatId: t, type: n, parentWindowUrl: r, remoteSettingsProps: i, ...o } = e, a = { ...Qr, ...o }, { store: s, persistor: l } = nN(
    { preloadedState: { [ln]: a } },
    t,
    n ?? Jo.Default,
    r
  );
  return /* @__PURE__ */ H.jsx(L2, { store: s, children: /* @__PURE__ */ H.jsx(cC, { loading: null, persistor: l, children: /* @__PURE__ */ H.jsx(ZY, { children: /* @__PURE__ */ H.jsx(sXe, { ...e }) }) }) });
}, OB = () => (pMe(), O2e(), null), cXe = (e) => {
  const { embeddedWrapperSelectorId: t, theme: n, reset: r, webchatId: i } = e, o = !!t, a = Ch.isFeatureEnabled(), s = RIe.isFeatureEnabled(), l = pe(Px), c = pe(A2e), f = pe(Fx), d = !a && n !== Jt.siteCompanionPopup, { overMaxResponseTime: p, showDotByRandomTime: g, isShowJumpingDots: v } = Vze(), { current: y } = ms(), x = y(), b = wr();
  return V2(e), hMe(i), vMe(e), dq(n), m.useEffect(() => {
    o && b(Vs(!0));
  }, [o]), m.useEffect(() => {
    n && b(Bx(n));
  }, [n]), l ? /* @__PURE__ */ H.jsx(H.Fragment, {}) : o ? /* @__PURE__ */ H.jsxs(H.Fragment, { children: [
    /* @__PURE__ */ H.jsx(OB, {}),
    /* @__PURE__ */ H.jsx(yB, { configs: e, isShowJumpingDots: v, children: /* @__PURE__ */ H.jsx(
      CF,
      {
        theme: n,
        reset: r,
        showDotByRandomTime: g,
        isShowJumpingDots: v,
        overMaxResponseTime: p
      }
    ) }),
    (x == null ? void 0 : x.uuid) && /* @__PURE__ */ H.jsx(EF, {})
  ] }) : /* @__PURE__ */ H.jsxs("div", { className: `-${c == null ? void 0 : c.horizon}`, children: [
    /* @__PURE__ */ H.jsx(OB, {}),
    d && (!s || f === Bi.Bubble) && /* @__PURE__ */ H.jsx(eA, { className: "conversation-launcher" }),
    d && s && f === Bi.Bar && /* @__PURE__ */ H.jsx(QM, {}),
    /* @__PURE__ */ H.jsx(yB, { configs: e, isShowJumpingDots: v, children: /* @__PURE__ */ H.jsx(
      CF,
      {
        theme: n,
        reset: r,
        showDotByRandomTime: g,
        isShowJumpingDots: v,
        overMaxResponseTime: p
      }
    ) }),
    (x == null ? void 0 : x.uuid) && /* @__PURE__ */ H.jsx(EF, {})
  ] });
}, uXe = (e) => {
  const { webchatId: t, projectId: n, type: r, parentWindowUrl: i } = e, o = { ...Qr, ...e }, { GlobalStyles: a } = ENe({ configs: e }), { store: s, persistor: l } = nN(
    { preloadedState: { [ln]: o } },
    t,
    r ?? Jo.Default,
    i
  ), { start: c, initializeByConfigs: f } = ms(), d = () => {
    f(e), t && c(t, n);
  };
  m.useEffect(() => {
    d();
  }, []);
  const p = _Ne();
  return /* @__PURE__ */ H.jsx(L2, { store: s, children: /* @__PURE__ */ H.jsx(cC, { loading: null, persistor: l, children: /* @__PURE__ */ H.jsxs(dS, { theme: p, children: [
    /* @__PURE__ */ H.jsx("link", { href: "https://fonts.googleapis.com/css?family=Nunito:700", rel: "stylesheet" }),
    /* @__PURE__ */ H.jsx(a, {}),
    /* @__PURE__ */ H.jsx(ZY, { children: t && /* @__PURE__ */ H.jsx(cXe, { ...e }) })
  ] }) }) });
}, fXe = (e) => {
  const { remoteSettingsProps: t, ...n } = e, { webchatId: r } = n, i = Qr.invitationModalSettings, o = wr(), a = pe(kl), s = pe(Nl), l = pe(F2e), c = pe(Px), [f, d] = m.useState(!1), [p, g] = m.useState(!1), [v, y] = m.useState(!1), x = m.useRef(), b = (l == null ? void 0 : l.show) ?? !1, w = ((l == null ? void 0 : l.waitTime) ?? i.waitTime) * 1e3, S = (l == null ? void 0 : l.invitationMessage) ?? i.invitationMessage, E = (l == null ? void 0 : l.openWebchatButtonText) ?? i.openWebchatButtonText, O = (l == null ? void 0 : l.dismissButtonText) ?? i.dismissButtonText, $ = () => {
    d(!1);
  }, P = () => {
    Nr.create(r).postEventTo(xa.Iframe, {
      name: Fi.POPUP_SHOW
    }), Nr.create(r).postEventTo(xa.Iframe, {
      name: Fi.POPUP_SMALL_MODE_CHANGED,
      detail: { isPopupSmallMode: !1 }
    }), d(!1);
  };
  return ya(
    sn.IFRAME_LOADED,
    () => {
      g(!0);
    },
    window,
    r
  ), V2({ ...n, remoteSettingsProps: t }), m.useEffect(() => {
    if (b)
      return p && (x.current = setTimeout(() => {
        (a || !s) && d(!0);
      }, w)), () => {
        x.current && clearTimeout(x.current);
      };
  }, [b, p, s, a]), m.useEffect(() => {
    clearTimeout(x.current);
  }, [v, s, a]), ya(
    sn.WEBCHAT_LAUNCHER_CLICKED,
    () => {
      y(!0);
    },
    window,
    r
  ), ya(
    sn.WEBCHAT_POPUP_SHOW,
    () => {
      o(Vs(!0));
    },
    window,
    r
  ), ya(
    sn.WEBCHAT_RESIZE,
    (R) => {
      const { isPopupSmallMode: L } = R.detail;
      o(Kg(L));
    },
    window,
    r
  ), c || !p ? null : /* @__PURE__ */ H.jsx(
    WOe,
    {
      okText: E,
      cancelText: O,
      open: f,
      closable: !1,
      onOk: P,
      onCancel: $,
      style: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      },
      children: S
    }
  );
}, dXe = (e) => {
  const { webchatId: t, type: n, parentWindowUrl: r, ...i } = e, o = { ...Qr, ...i }, { store: a, persistor: s } = nN(
    { preloadedState: { [ln]: o } },
    t,
    n ?? Jo.Default,
    r
  );
  return /* @__PURE__ */ H.jsx(L2, { store: a, children: /* @__PURE__ */ H.jsx(cC, { loading: null, persistor: s, children: /* @__PURE__ */ H.jsx(fXe, { ...e }) }) });
}, Dt = {
  containerId: "onrWebchat",
  iframeContainerId: "onrWebchatIframe",
  independentLauncherId: "independentOnrWebchatLauncher",
  loadingAnimationContainerId: "onrWebchatLoadingAnimation",
  invitationModalContainerId: "invitation-modal-container",
  _getSettingToggleQueryParams: () => {
    const t = window.location.search.split("?")[1];
    return mL.parse(t ?? "");
  },
  _isFeatureEnabledOnUrl: ({
    urlFeatureName: e,
    featureFlagEnabled: t
  }) => {
    if (!t)
      return !1;
    const n = Dt._getSettingToggleQueryParams();
    return n[e] === "1" || n[e] === "true";
  },
  _getWebChatConfigs: (e, t) => {
    if (e <= 0)
      return;
    const n = (w) => /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(w) ? w : document.location.href, {
      title: r = "My Bot",
      settings: i,
      embeddedWrapperSelectorId: o,
      theme: a = Jt.fusion,
      position: s = {
        horizon: Y1.right,
        vertical: Af.bottom
      },
      custom: l = {
        brandName: "ChatFusion"
      },
      testingMod: c = !1,
      reset: f,
      isSimulateMobile: d,
      type: p,
      parentWindowUrl: g = n(`${window.location.origin}${window.location.pathname}`),
      projectId: v
    } = t;
    let y = a, x = o;
    if (a === Jt.siteCompanion && o) {
      y = Jt.siteCompanionPopup, x = void 0;
      const w = document.getElementById(o);
      w && (w.setAttribute("data-id", "onrSiteCompanionPlacement"), w.setAttribute("data-type", "in-content"), w.setAttribute("data-webchat-id", `${e}`));
    }
    return {
      campaignId: e,
      webchatId: e,
      title: r,
      settings: i,
      embeddedWrapperSelectorId: x,
      theme: y,
      position: s,
      custom: l,
      testingMod: c,
      reset: f,
      isSimulateMobile: d,
      type: p,
      projectId: v,
      parentWindowUrl: g
    };
  },
  _getChatBotSettings: async (e, t) => {
    const { get: n } = iK();
    return await n(e, t);
  },
  _postEventToIframe: (e = null, t) => {
    Nr.create(e).postEventTo(xa.Iframe, t);
  },
  _renderWebChatPlacement: async (e, t) => {
    const n = Dt._getWebChatConfigs(e, t);
    if (!n)
      return;
    const r = await Dt._getChatBotSettings(e, t.parentWindowUrl), i = {
      ...n,
      remoteSettingsProps: r
    }, o = document.createElement("div");
    o.id = Dt.independentLauncherId, document.body.appendChild(o);
    const a = document.createElement("div");
    a.id = `${Dt.invitationModalContainerId}-${e}`, window.parent.document.body.appendChild(a), setTimeout(() => {
      js.render(/* @__PURE__ */ H.jsx(lXe, { ...i }), o);
    }), setTimeout(() => {
      js.render(/* @__PURE__ */ H.jsx(dXe, { ...i }), a);
    }, 500);
  },
  _removeExistElements: (e, t) => {
    t.forEach((n) => {
      const r = document.getElementById(n);
      r && r.remove(), n === Dt.iframeContainerId && Dt._sent(sn.IFRAME_REMOVED, e);
    });
  },
  _setMultipleBotContainerId: (e) => {
    const t = Nr.create(e);
    Dt.containerId = t.getContainerId(xa.Container), Dt.iframeContainerId = t.getContainerId(xa.Iframe), Dt.independentLauncherId = t.getContainerId(xa.IndependentLauncher);
  },
  // TODO: should we remove useEventListener and use message post listener instead?
  _sent: (e, t, n) => {
    Nr.create().dispatchWindowEvent(e, t, { detail: n });
  },
  _renderSiteCompanionPlacement: async (e, t) => {
    const n = await Dt._getChatBotSettings(e, t), r = document.createElement("div");
    r.style.display = "none", document.body.appendChild(r), js.render(/* @__PURE__ */ H.jsx(yYe, {}), r), document.querySelectorAll(
      `[data-id="onrSiteCompanionPlacement"][data-webchat-id="${e}"]`
    ).forEach((i) => {
      const { type: o, webchatId: a } = i.dataset;
      js.render(
        /* @__PURE__ */ H.jsx(
          vYe,
          {
            settings: n,
            type: o,
            webchatId: Number(a)
          }
        ),
        i
      );
    });
  },
  _removeInvitationModal: async (e) => {
    const t = window.parent.document.getElementById(
      `${Dt.invitationModalContainerId}-${e}`
    );
    t && (fh.unmountComponentAtNode(t), t.remove());
  },
  clear: (e) => {
    Dt._removeExistElements(e, [
      Dt.containerId,
      Dt.iframeContainerId,
      Dt.independentLauncherId,
      Dt.loadingAnimationContainerId
    ]);
  },
  subscribed: (e) => {
    window.addEventListener("message", (t) => {
      t.data.name === Q2 && e(t.data.detail);
    });
  },
  update: (e, t) => {
    Dt._postEventToIframe(t, {
      name: Fi.POPUP_UPDATE,
      detail: { ...e, webchatId: t }
    }), Dt._sent(sn.WEBCHAT_UPDATE, t, e);
  },
  show: (e) => {
    Dt._postEventToIframe(e, {
      name: Fi.POPUP_SHOW,
      detail: { webchatId: e }
    });
  },
  restart: (e) => {
    Dt._postEventToIframe(e, {
      name: Fi.CONVERSATION_RESTART,
      detail: { webchatId: e }
    });
  },
  changeDevice: (e, t) => {
    Dt._postEventToIframe(t, {
      name: Fi.DEVICE_CHANGE,
      detail: { device: e }
    }), Dt._sent(sn.DEVICE_CHANGE, t, { device: e });
  },
  hide: (e) => {
    Dt._postEventToIframe(e, {
      name: Fi.POPUP_HIDE,
      detail: { webchatId: e }
    });
  },
  build: (e, t) => {
    const n = Dt._getWebChatConfigs(e, t);
    if (!n)
      return;
    const { embeddedWrapperSelectorId: r, theme: i } = n, o = document.createElement("div");
    o.id = Dt.containerId, o.className = "contact-loop-web-chat", r && (o.className = `contact-loop-web-chat is-embedded ${i}`), Dt.clear(e), document.body.appendChild(o), setTimeout(() => {
      js.render(/* @__PURE__ */ H.jsx(uXe, { ...n }), o);
    });
  },
  init: async (e, t) => {
    const n = Dt._getWebChatConfigs(e, t);
    if (!n)
      return;
    const r = Ch.isFeatureEnabled(), i = Tx.isFeatureEnabled(), o = Cl.isFeatureEnabled(), a = Dt._getSettingToggleQueryParams(), s = {
      ...n,
      ...a
    }, { reset: l, embeddedWrapperSelectorId: c, type: f, theme: d, parentWindowUrl: p } = s, g = 441, v = document.createElement("div"), y = o ? "https://api.chatfusion.contactloop.com" : "https://chatfusion.contactloop.com", x = document.createElement("iframe"), b = mL.stringify(s), w = f === Jo.SiteCompanion && [Jt.siteCompanion, Jt.siteCompanionPopup].includes(d);
    i && Dt._setMultipleBotContainerId(e), Dt.clear(e), Dt._removeInvitationModal(e), l && Dt.restart(), i && x.setAttribute("data-container-name", "onrWebchatIframe"), x.id = Dt.iframeContainerId, o ? x.src = `${y}/bots/${e}/snippet?${b}` : x.src = `${y}/webchat/${e}?${b}`, v.id = Dt.containerId, v.appendChild(x), Dt._sent(sn.IFRAME_EMBEDDED, e);
    const S = new rIe(
      e,
      n,
      g
    ), E = new QTe(
      e,
      n,
      v,
      g
    ), O = new ZTe(
      e,
      n,
      v,
      g
    );
    window.addEventListener("message", ($) => {
      const P = $.data, { name: R, webchatId: L } = P;
      if (L === e)
        switch (R) {
          case sn.IFRAME_LOADED:
            o && Dt._sent(sn.IFRAME_LOADED, e, P);
            break;
          case sn.CONVERSATION_CREATED:
            Dt._sent(sn.CONVERSATION_CREATED, e);
            break;
          case sn.WEBCHAT_POPUP_SHOW:
            o && Dt._sent(sn.WEBCHAT_POPUP_SHOW, e);
            break;
          case sn.WEBCHAT_POPUP_HIDE:
            o && Dt._sent(sn.WEBCHAT_POPUP_HIDE, e);
            break;
          case sn.BADGE_COUNT_CHANGE:
            o && Dt._sent(sn.BADGE_COUNT_CHANGE, e, P);
            break;
          case mI:
          case sn.WEBCHAT_RESIZE:
            Dt._sent(sn.WEBCHAT_RESIZE, e, P);
            const B = P;
            w ? S.perform(B) : !c && r ? E.perform(B) : !c && !r && O.perform(B);
            break;
        }
    }), c ? new KTe(
      v,
      x,
      c
    ).perform() : w ? (new nIe(
      v,
      x,
      g
    ).perform(), Dt._renderSiteCompanionPlacement(e, p)) : (new JTe(
      v,
      x,
      g,
      r
    ).perform(), r && Dt._renderWebChatPlacement(e, t));
  },
  // TODO: should rename to sendPendingMessage
  sendMessage: (e, t = $u.Message, n) => {
    Dt._postEventToIframe(n, {
      name: Fi.MESSAGE_SEND,
      detail: { message: e, messageType: t, webchatId: n }
    });
  },
  onWebchatLoad: () => {
    Dt._sent(sn.WEBCHAT_LOADED);
  }
}, {
  containerId: mXe,
  clear: gXe,
  update: vXe,
  show: yXe,
  restart: bXe,
  hide: wXe,
  init: SXe,
  build: xXe,
  subscribed: CXe,
  changeDevice: EXe,
  sendMessage: $Xe
} = Dt;
(function() {
  Dt.onWebchatLoad();
})();
export {
  xXe as build,
  EXe as changeDevice,
  gXe as clear,
  mXe as containerId,
  wXe as hide,
  SXe as init,
  bXe as restart,
  $Xe as sendMessage,
  yXe as show,
  CXe as subscribed,
  vXe as update
};
